(function () {
    'use strict';

    angular
        .module('app.expenseSettlement.settlement',
            [
            ])
        .config(config);


    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {
        // State
        $stateProvider
            .state('app.expenseSettlement.settlement', {
                abstract: true,
                url: '/expenseSettlement'
            })
            .state('app.expenseSettlement.settlement.settlement', {
                url: '/settlements/:pettyCashId',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/expenseSettlements/settlements/settlement/settlement.html',
                        controller: 'settlementController as vm'
                    }
                },
                bodyClass: 'e-commerce'
            })
            .state('app.expenseSettlement.settlement.entering', {
                url: '/1',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/expenseSettlements/settlements/settlement/settlement.html',
                        controller: 'settlementController as vm'
                    }
                },
                params: {
                    status: 'Ingresando'
                },
                bodyClass: 'e-commerce'
            })
            .state('app.expenseSettlement.settlement.pendingAuthorize', {
                url: '/2',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/expenseSettlements/settlements/settlement/settlement.html',
                        controller: 'settlementController as vm'
                    }
                },
                params: {
                    status: 'Pendiente de Autorizar'
                },
                bodyClass: 'e-commerce'
            })
            .state('app.expenseSettlement.settlement.preProvisioned', {
                url: '/3',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/expenseSettlements/settlements/settlement/settlement.html',
                        controller: 'settlementController as vm'
                    }
                },
                params: {
                    status: 'Pre-Provisionada'
                },
                bodyClass: 'e-commerce'
            })
            .state('app.expenseSettlement.settlement.provisionedx', {
                url: '/4',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/expenseSettlements/settlements/settlement/settlement.html',
                        controller: 'settlementController as vm'
                    }
                },
                params: {
                    status: 'Provisionada'
                },
                bodyClass: 'e-commerce'
            })
            .state('app.expenseSettlement.settlement.details', {
                url: '/details',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/expenseSettlements/settlements/details/details.html',
                        controller: 'SettlementDetailsController as vm'
                    }
                },
                bodyClass: 'e-commerce'
            })
            .state('app.expenseSettlement.settlement.settlementEdit', {
                url: '/edit/:settlementId',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/expenseSettlements/settlements/settlement/settlementEditor/settlementEditor.html',
                        controller: 'settlementEditorController as vm'
                    }
                },
                resolve: {
                    Settlement: function (apiResolver, $stateParams) {
                        if ($stateParams.settlementId) {
                            return apiResolver.resolve('ComprasWS.Settlement.Settlement@get', { 'id': $stateParams.settlementId });
                        } else {
                            return null;
                        }
                    },
                    PreviousState: function ($state) {
                        return angular.copy($state.current);

                    }
                },
                bodyClass: 'e-commerce'
            })
            .state('app.expenseSettlement.settlement.settlementView', {
                url: '/view/:settlementId',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/expenseSettlements/settlements/settlement/settlementEditor/settlement_view.html',
                        controller: 'settlementEditorController as vm'
                    }
                },
                resolve: {
                    Settlement: function (apiResolver, $stateParams) {
                        if ($stateParams.settlementId) {
                            return apiResolver.resolve('ComprasWS.Settlement.Settlement@get', { 'id': $stateParams.settlementId });
                        } else {
                            return null;
                        }
                    },
                    PreviousState: function ($state) {
                        return angular.copy($state.current);
                    }
                },
                params: {
                    backTo: null,
                    filter: null
                },
                bodyClass: 'e-commerce'
            })
            .state('app.expenseSettlement.settlement.settlementEdit.documentVerify', {
                url: 'edit/invoices',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/documentVerify/invoice.html',
                        controller: 'PurchaseDocumentController as vm'
                    }
                },
                params: {
                    backState: {},
                    docArray: [],
                    mainDoc: {},
                    canEdit: true
                },
                bodyClass: 'e-commerce'
            })
            .state('app.expenseSettlement.settlement.invoiceEdit', {
                url: '/invoiceEdit/:settlement/:invoiceId/:type/:settlementDetailId',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/expenseSettlements/settlements/details/invoiceEditor/invoiceEditor.html',
                        controller: 'SettlementInvoiceEditorController as vm'
                    }
                },
                resolve: {
                    InvoicePurchase: function (apiResolver, $stateParams) {
                        if ($stateParams.invoiceId) {
                            return apiResolver.resolve('ComprasWS.InvoicePurchase@get', { 'id': $stateParams.invoiceId });
                        } else {
                            return null;
                        }
                    },
                    PreviousState: function ($state) {
                        return angular.copy($state.current);
                    }
                },
                params:{
                  budgeted: null
                },
                bodyClass: 'e-commerce'
            })
            .state('app.expenseSettlement.settlement.invoiceView', {
                url: '/invoiceView/:settlement/:detail/:invoiceId/',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/expenseSettlements/settlements/details/invoiceEditor/invoice_view.html',
                        controller: 'SettlementInvoiceEditorController as vm'
                    }
                },
                resolve: {
                    InvoicePurchase: function (apiResolver, $stateParams) {
                        if ($stateParams.invoiceId) {
                            return apiResolver.resolve('ComprasWS.InvoicePurchase@get', { 'id': $stateParams.invoiceId });
                        } else {
                            return null;
                        }
                    },
                    PreviousState: function ($state) {
                        return angular.copy($state.current);
                    }
                },
                bodyClass: 'e-commerce'
            })

            .state('app.expenseSettlement.settlement.receiptEdit', {
                url: '/receiptEdit/:settlement/:receipt/:settlementDetailId',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/expenseSettlements/settlements/details/receiptEditor/receiptEditor.html',
                        controller: 'SettlementReceiptEditorController as vm'
                    }
                },
                resolve: {
                    PaymentReceipt: function (apiResolver, $stateParams) {
                        if ($stateParams.receipt) {
                            return apiResolver.resolve('ComprasWS.PaymentReceipt@get', { 'id': $stateParams.receipt });
                        } else {
                            return null;
                        }
                    },
                    PreviousState: function ($state) {
                        return angular.copy($state.current);
                    }
                },
                bodyClass: 'e-commerce'
            })

            .state('app.expenseSettlement.settlement.receiptView', {
                url: '/receiptView/:settlement/:detail/:receipt/',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/expenseSettlements/settlements/details/receiptEditor/receipt_view.html',
                        controller: 'SettlementReceiptEditorController as vm'
                    }
                },
                resolve: {
                    PaymentReceipt: function (apiResolver, $stateParams) {
                        if ($stateParams.receipt) {
                            return apiResolver.resolve('ComprasWS.PaymentReceipt@get', { 'id': $stateParams.receipt });
                        } else {
                            return null;
                        }
                    },
                    PreviousState: function ($state) {
                        return angular.copy($state.current);
                    }
                },
                bodyClass: 'e-commerce'
            })

            .state('app.expenseSettlement.settlement.receiptVerifier', {
                url: '/receiptVerifier/:settlement/:settlementDetailId/:receipt/',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/expenseSettlements/settlements/details/receiptEditor/receiptVerifier/receiptVerifier.html',
                        controller: 'SettlementReceiptverifierController as vm'
                    }
                },
                resolve: {
                    PaymentReceipt: function (apiResolver, $stateParams) {
                        if ($stateParams.receipt) {
                            return apiResolver.resolve('ComprasWS.PaymentReceipt@get', { 'id': $stateParams.receipt });
                        } else {
                            return null;
                        }
                    },
                    PreviousState: function ($state) {
                        return angular.copy($state.current);
                    }
                },
                bodyClass: 'e-commerce'
            });
        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/expenseSettlements/settlements');

    }
})();


(function () {
    'use strict';
    angular
        .module('app.expenseSettlement.settlement')
        .controller('ComposeDialogProductRequiredController', ComposeDialogProductRequiredController);
    /** @ngInject */
    function ComposeDialogProductRequiredController($mdDialog, products, showButtons) {
        var vm = this;
        vm.showButtons = showButtons;
        vm.products = products;
        // Methods
        vm.closeDialog = closeDialog;
        vm.ok = ok;
        //////////

        init();
        /**
         * Initialize
         */
        function init() {
        }


        function ok() {
            $mdDialog.hide();
        }

        function closeDialog() {
            $mdDialog.cancel();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.expenseSettlement.settlement')
        .controller('paySettlementController', paySettlementController);

    /** @ngInject */
    function paySettlementController($mdDialog, api, $log, $rootScope, Data, $timeout) {
        var vm = this;
        vm.paymentSetllement = [];
        vm.settlement = angular.copy(Data);
        vm.wireTransfer = {
            wireTransferType: {},
            amount: vm.settlement.settledAmount
        };

        vm.closeDialog = closeDialog;
        vm.paySetlement = paySetlement;

        //////////
        vm.clearSearchBankAccount = function () {
            vm.searchBankAccountType = "";
        };

        $timeout(function () {
            var keyEvent = function (event) {
                event.stopPropagation();
            };
            var searchBankAccountInput = document.querySelector("#bankAccount");
            if (searchBankAccountInput) {
                searchBankAccountInput.addEventListener("keydown", keyEvent);
            }
        }, 500);


        init();
        function init() {
            api.ComprasWS.BankAccount.query({ company: vm.settlement.pettyCash.company.id }).$promise.then(function (response) {
                vm.bankAccounts = response;
            }, function (error) {
                $log.error(error.data);
            });
        }

        function paySetlement() {
            var wireTransfer = {
                wireTransferType: vm.wireTransfer.wireTransferType,
                bankAccount: {
                    id: vm.wireTransfer.bankAccount.id
                },
                amount: vm.wireTransfer.amount,
                number: vm.wireTransfer.number,
                documentDate: vm.wireTransfer.documentDate,
                referenceNumber: vm.settlement.id,
                recipient: {
                    id: vm.settlement.pettyCash.holder.id
                }
            };
            api.ComprasWS.WireTransfer.save({ circle: $rootScope.bsCircle.id }, wireTransfer).$promise.then(function (response) {
                vm.wireTransfer = response;
                $mdDialog.hide(vm.wireTransfer);
            }, function (error) {
                $log.error(error.data);
            });
        }

        function closeDialog() {
            $mdDialog.cancel();
        }

    }
})();

(function () {
    'use strict';
    angular
        .module('app.expenseSettlement.settlement')
        .controller('DetailSettlementInvoiceEditorController', DetailSettlementInvoiceEditorController);
    /** @ngInject */
    function DetailSettlementInvoiceEditorController($mdDialog, edited, InvoicePurchase, SettlementDetailId, api, $log, $timeout,
        Details, $rootScope, Settlement, $mdToast, $filter, $scope) {
        var vm = this;

        //Data
        vm.isNew = edited ? false : true;
        vm.foreignCurrency = $rootScope.bsCircle.company.foreignCurrency;
        vm.differentCurrency = false;
        vm.useInputSubTotalAfterTax = false;
        vm.useInputPriceAfterTax = false;
        vm.creatingProduct = false;
        vm.invoicePurchaseDetailTaxList = [];
        vm.detailsTax = [];
        vm.settlement = {};
        vm.pettyCashGeneralSets = {};


        vm.dtOptions = {
            dom: 'rt<"top"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            columnDefs: [{ targets: 0 }],
            bInfo: false,
            paging: false,
            responsive: true
        };

        //Methods
        vm.changeInputQuantityDetail = changeInputQuantityDetail;
        vm.calculateSubTotalAfterTax = calculateSubTotalAfterTax;
        vm.calculatePriceAfterTax = calculatePriceAfterTax;
        vm.invoicePurchase = InvoicePurchase;
        vm.invoicePurchaseDetails = Details ? Details : [];
        vm.getAmountAvailable = getAmountAvailable;
        vm.closeDialog = closeDialog;
        vm.sendForm = sendForm;
        vm.validateMaxAmount = validateMaxAmount;
        vm.selectProduct = selectProduct;
        vm.activeSearch = activeSearch;
        vm.getProducts = getProducts;
        vm.changeFilter = changeFilter;
        vm.backSearch = backSearch;
        vm.settlement = Settlement;
        vm.page = 1;
        vm.pageSize = 20;
        vm.selectedTab = 0;

        //////////

        init();
        function init() {
            api.ComprasWS.pettyCash.get({ id: vm.settlement.pettyCash.id, circle: $rootScope.bsCircle.id }).$promise.then(function (response) {
                vm.pettyCash = response;
                api.ComprasWS.pettyCashGeneralSets.getByPettyCashType(
                    { id: 'byPettyCashType', pettyCashTypeId: response.pettyCashType.id, idCircle: $rootScope.bsCircle.id }).$promise.then(function (response) {
                        vm.pettyCashGeneralSets = response;
                    }, function (error) {
                        $log.error(error.data);
                    });
            }, function (error) {
                $log.error(error.data);
            });
            if (vm.settlement.pettyCash.currency.id !== vm.invoicePurchase.currency.id) {
                vm.differentCurrency = true;
            }
            vm.getAmountAvailable();
        }

        if (vm.isNew === false) {
            vm.useInputSubTotalAfterTax = true;
            vm.useInputPriceAfterTax = true;
            vm.selectedTab = 1;
            $log.debug(edited);
            vm.invoicePurchaseDetail = angular.copy(edited);
            $rootScope.loadingProgress = true;
            api.ComprasWS.InvoicePurchaseDetailTax.InvoicePurchaseDetailTax.byInvoicePurchaseDetail(
                { id: 'byInvoicePurchaseDetail', invoicePurchaseDetailId: edited.id }).$promise.then(function (response) {
                    vm.detailsTax = response;
                    $rootScope.loadingProgress = false;
                }, function (error) {
                    $log.error(error.data);
                    $rootScope.loadingProgress = false;
                });
        } else {
            vm.invoicePurchaseDetail = {};
        }

        function getAmountAvailable() {
            if (vm.settlement.pettyCash.amount > 0) {
                api.ComprasWS.Settlement.getAmountAvailable.getTotal({ id: vm.settlement.pettyCash.id }).$promise.then(function (response) {
                    vm.amountAvailable = parseFloat(response.$data);
                    $log.debug("vm.amountAvailable");
                    $log.debug(vm.amountAvailable);
                }, function (error) {
                    $log.error(error.data);
                });
            }
        }

        function getProducts(page) {
            vm.page = page;
            vm.loading = true;
            api.ComprasWS.allSettlementProduct.get(
                {
                    settlementId: vm.settlement.id, companyId: $rootScope.bsCircle.company.id,
                    page: page - 1, size: vm.pageSize, filter: vm.filterProduct, invoicePurchaseId: vm.invoicePurchase.id
                }, function (data) {
                    vm.productos = data;
                    $log.debug("vm.productos:");
                    $log.debug(vm.productos);
                    vm.loading = false;
                    if (vm.productos.content.length === 1) {
                        vm.productSelect = vm.productos.content[0];
                        vm.selectProduct(vm.productSelect);
                    }

                }, function (data) {
                    vm.loading = false;
                    $log.error(data.data);
                });
        }

        $scope.$watch('vm.filterProduct', function (newVal) {
            getProducts(1);
        });

        function activeSearch() {
            vm.searchMode = true;
            $timeout(function () {
                $('#searchField').focus();
            });
        }

        function changeFilter() {
            if (!vm.filterProduct || vm.filterProduct === '') {
                getProducts(1);
            }
            $timeout(function () {
                $('#amount').focus();
            });
        }

        function backSearch() {
            vm.searchMode = !vm.searchMode;
            vm.filterProduct = '';
            getProducts(1);
        }


        function selectProduct(product) {
            vm.searchMode = false;
            var change = vm.isNew ? vm.isNew : vm.detail.product.id !== product.id;
            vm.invoicePurchaseDetail.product = {
                id: product.id,
                productCode: product.productCode,
                name: product.name
            };
            vm.selectedTab = 1;
            if (vm.isNew || change) {
                $timeout(function () {
                    vm.detailForm.$setDirty();
                });
            }
            $timeout(function () {
                $("#description").focus();
            });
        }

        function modelToCreate(price) {
            vm.newInvoicePurchaseDetail = {
                id: 0,
                invoicePurchase: {
                    id: vm.invoicePurchase.id
                },
                product: {
                    id: vm.invoicePurchaseDetail.product.id
                },
                description: vm.invoicePurchaseDetail.description,
                quantity: vm.invoicePurchaseDetail.quantity.toFixed(2),
                priceBeforeTax: price,
                priceAfterTax: price,
                documentSubTotalBeforeTax: price * vm.invoicePurchaseDetail.quantity,
                documentSubTotalAfterTax: price * vm.invoicePurchaseDetail.quantity
            };
        }

        function validateMaxAmount() {
            if (vm.pettyCashGeneralSets) {
                var totalAfterTax;
                if (vm.isNew === true) {
                    totalAfterTax = vm.invoicePurchase.totalAfterTax + vm.invoicePurchaseDetail.subTotalAfterTax;
                } else {
                    var newTotal = vm.invoicePurchase.totalAfterTax - edited.subTotalAfterTax;
                    totalAfterTax = vm.invoicePurchaseDetail.subTotalAfterTax + newTotal;
                }
                if (vm.pettyCashGeneralSets.maxAmountByDocument > 0 && totalAfterTax > vm.pettyCashGeneralSets.maxAmountByDocument) {
                    showErrorMessage($filter('translate')('SETTLEMENT.INVOICE.MAX_AMOUNT_BY_PETTY_TYPE') + vm.pettyCash.currency.symbol +
                        toFixedNumber(vm.pettyCashGeneralSets.maxAmountByDocument, 2) + $filter('translate')('SETTLEMENT.INVOICE.MAX_AMOUNT_BY_PETTY_TYPE2'));
                } else {
                    sendForm();
                }
            }
        }

        function setAsOverSpend(settlementDetailId) {
            //marca si se sobre pasa el limite
            vm.loading = true;
            api.ComprasWS.SettlementDetails.OverSpend.setIsOverSpend({ id: settlementDetailId }).$promise.then(function (response) {
                vm.loading = false;
            }, function (error) {
                $log.debug(error);
                vm.loading = false;
            });
        }

        function sendForm() {
            vm.loading = true;
            $rootScope.loadingProgress = true;
            $log.debug("vm.pettyCash.pettyCashType.allowOverSpend:");
            $log.debug(vm.pettyCash);
            if (vm.isNew === true) {
                if (!vm.pettyCash.pettyCashType.allowOverSpend
                    && vm.pettyCash.amount > 0
                    && (vm.invoicePurchaseDetail.subTotalAfterTax > vm.amountAvailable)) {
                    showErrorMessage($filter('translate')('SETTLEMENT.TOTAL_SETTLEMENTS_EXCEEDS_CREATING') + vm.pettyCash.currency.symbol
                        + toFixedNumber(vm.pettyCash.amount, 2) + $filter('translate')('SETTLEMENT.TOTAL_SETTLEMENTS_EXCEEDS_CREATING2'));
                    $rootScope.loadingProgress = false;
                    vm.loading = false;
                } else {
                    vm.loading = true;
                    api.ComprasWS.InvoicePurchaseDetail.save(
                        { id: '', idCircle: $rootScope.bsCircle.id }, vm.newInvoicePurchaseDetail).$promise.then(function (response) {
                            vm.newInvoicePurchaseDetail = angular.copy(response);
                            vm.newInvoicePurchaseDetail.priceAfterTax = vm.invoicePurchaseDetail.priceAfterTax;
                            vm.newInvoicePurchaseDetail.subTotalAfterTax = vm.invoicePurchaseDetail.subTotalAfterTax;
                            vm.newInvoicePurchaseDetail.documentSubTotalAfterTax = vm.invoicePurchaseDetail.documentSubTotalAfterTax;
                            vm.invoicePurchaseDetail = vm.newInvoicePurchaseDetail;
                            vm.isNew = false;
                            vm.invoicePurchaseDetails.push(response);
                            showMessage($filter('translate')('SETTLEMENT.INVOICE.DETAIL.DETAIL_ADDED'));

                            //si se sobrepasa limite
                            if (vm.pettyCash.pettyCashType.allowOverSpend && vm.invoicePurchaseDetail.subTotalAfterTax > vm.amountAvailable) {
                                setAsOverSpend(SettlementDetailId);
                            }
                            $mdDialog.hide(vm.invoicePurchaseDetails);
                        }, function (error) {
                            vm.loading = false;
                            $log.error(error);
                            if (error.data === 'ERROR_CALCULATE_TAXES') {
                                showErrorMessage($filter('translate')('SETTLEMENT.INVOICE.ERROR_CALCULATE_TAXES'));
                            } else {
                                showErrorMessage($filter('translate')('SETTLEMENT.INVOICE.DETAIL.DETAIL_ADDED_ERROR'));
                            }
                        });
                }
            } else {
                vm.loading = true;
                vm.amountAvailable = vm.amountAvailable + edited.subTotalAfterTax;
                if (!vm.pettyCash.pettyCashType.allowOverSpend
                    && vm.pettyCash.amount > 0
                    && (vm.invoicePurchaseDetail.subTotalAfterTax > vm.amountAvailable)) {
                    showErrorMessage($filter('translate')('SETTLEMENT.TOTAL_SETTLEMENTS_EXCEEDS_UPDATING') + vm.pettyCash.currency.symbol
                        + toFixedNumber(vm.pettyCash.amount, 2) + $filter('translate')('SETTLEMENT.TOTAL_SETTLEMENTS_EXCEEDS_UPDATING2'));
                    $rootScope.loadingProgress = false;
                    vm.loading = false;
                    getAmountAvailable();
                } else {
                    vm.loading = true;
                    api.ComprasWS.InvoicePurchaseDetail.update(
                        { id: vm.invoicePurchaseDetail.id, idCircle: $rootScope.bsCircle.id }, vm.invoicePurchaseDetail).$promise.then(function (response) {
                            //si se sobregira
                            if (vm.pettyCash.pettyCashType.allowOverSpend && vm.invoicePurchaseDetail.subTotalAfterTax > vm.amountAvailable) {
                                setAsOverSpend(SettlementDetailId);
                            }
                            showMessage($filter('translate')('SETTLEMENT.INVOICE.DETAIL.DETAIL_UPDATED'));
                            $mdDialog.hide(response);
                            vm.loading = false;
                        }, function (error) {
                            $log.error(error);
                            if (error.data === 'ERROR_CALCULATE_TAXES') {
                                showErrorMessage($filter('translate')('SETTLEMENT.INVOICE.ERROR_CALCULATE_TAXES'));
                            } else {
                                showErrorMessage($filter('translate')('SETTLEMENT.INVOICE.DETAIL.DETAIL_UPDATED_ERROR'));
                            }
                            vm.loading = false;
                        });
                }
            }
            $rootScope.loadingProgress = false;
        }

        function changeInputQuantityDetail() {

            if (vm.useInputPriceAfterTax === true && vm.useInputSubTotalAfterTax === true) {
                if (vm.invoicePurchaseDetail.priceAfterTax && vm.invoicePurchaseDetail.subTotalAfterTax && vm.invoicePurchaseDetail.quantity) {
                    //CON IMPUESTOS
                    vm.invoicePurchaseDetail.priceAfterTax = validateNumberDecimal(vm.invoicePurchaseDetail.priceAfterTax, 6);
                    //Total con moneda de documento
                    vm.invoicePurchaseDetail.documentSubTotalAfterTax = toFixedNumber(vm.invoicePurchaseDetail.priceAfterTax * vm.invoicePurchaseDetail.quantity, 2);
                    //Total con moneda local
                    vm.invoicePurchaseDetail.subTotalAfterTax = toFixedNumber(vm.invoicePurchaseDetail.documentSubTotalAfterTax * vm.invoicePurchase.exchangeRate, 2);
                }

            } else if (vm.invoicePurchaseDetail.quantity) {
                if (vm.useInputPriceAfterTax === false && vm.useInputSubTotalAfterTax === false) {
                    if (vm.invoicePurchaseDetail.priceAfterTax) {
                        calculateSubTotalAfterTax();
                        vm.useInputPriceAfterTax = true;
                    } else if (vm.invoicePurchaseDetail.documentSubTotalAfterTax) {
                        calculatePriceAfterTax();
                        vm.useInputSubTotalAfterTax = true;
                    } else {
                        vm.useInputSubTotalAfterTax = true;
                        vm.useInputPriceAfterTax = true;
                    }
                } else if (vm.useInputPriceAfterTax === false || vm.useInputSubTotalAfterTax === false) {
                    if (vm.useInputPriceAfterTax === true) {
                        calculateSubTotalAfterTax();
                    } else if (vm.useInputSubTotalAfterTax === true) {
                        calculatePriceAfterTax();
                    }
                }
            } else if (vm.useInputPriceAfterTax === false || vm.useInputSubTotalAfterTax === false) {
                if (vm.useInputPriceAfterTax === true) {
                    vm.invoicePurchaseDetail.documentSubTotalAfterTax = null;
                    vm.invoicePurchaseDetail.subTotalAfterTax = null;
                    vm.useInputPriceAfterTax = false;
                } else if (vm.useInputSubTotalAfterTax === true) {
                    vm.invoicePurchaseDetail.priceAfterTax = null;
                    vm.useInputSubTotalAfterTax = false;
                }
            }
        }

        function calculatePriceAfterTax() { //Calcular precio unitario cuando se ingresa total
            if (vm.invoicePurchaseDetail.documentSubTotalAfterTax) {
                vm.invoicePurchaseDetail.documentSubTotalAfterTax = validateNumberDecimal(vm.invoicePurchaseDetail.documentSubTotalAfterTax, 2);
                vm.invoicePurchaseDetail.subTotalAfterTax = validateNumberDecimal(vm.invoicePurchaseDetail.documentSubTotalAfterTax * vm.invoicePurchase.exchangeRate, 2);
                vm.useInputPriceAfterTax = false;
                //Calcula y redondea precio sin impuesto
                vm.invoicePurchaseDetail.priceAfterTax = vm.invoicePurchaseDetail.documentSubTotalAfterTax / vm.invoicePurchaseDetail.quantity;
                var priceToFixed = vm.invoicePurchaseDetail.priceAfterTax.toFixed(6);
                vm.invoicePurchaseDetail.priceAfterTax = parseFloat(priceToFixed);
                modelToCreate(vm.invoicePurchaseDetail.priceAfterTax);
            } else {
                vm.invoicePurchaseDetail.priceAfterTax = null;
                vm.useInputPriceAfterTax = true;
            }
        }

        function calculateSubTotalAfterTax() { //Calcular total cuando se ingresa precio unitario
            if (vm.invoicePurchaseDetail.priceAfterTax) {
                vm.invoicePurchaseDetail.priceAfterTax = validateNumberDecimal(vm.invoicePurchaseDetail.priceAfterTax, 6);
                vm.useInputSubTotalAfterTax = false;
                vm.invoicePurchaseDetail.documentSubTotalAfterTax = vm.invoicePurchaseDetail.priceAfterTax * vm.invoicePurchaseDetail.quantity;
                vm.invoicePurchaseDetail.documentSubTotalAfterTax = toFixedNumber(vm.invoicePurchaseDetail.documentSubTotalAfterTax, 2);
                vm.invoicePurchaseDetail.subTotalAfterTax = vm.invoicePurchaseDetail.documentSubTotalAfterTax * vm.invoicePurchase.exchangeRate;
                vm.invoicePurchaseDetail.subTotalAfterTax = toFixedNumber((vm.invoicePurchaseDetail.subTotalAfterTax), 2);
                modelToCreate(vm.invoicePurchaseDetail.priceAfterTax);
            } else {
                vm.invoicePurchaseDetail.documentSubTotalAfterTax = null;
                vm.invoicePurchaseDetail.subTotalAfterTax = null;
                vm.useInputSubTotalAfterTax = true;
            }
        }

        function toFixedNumber(value, numberDecimals) {
            if (value) {
                var toFixed = value.toFixed(numberDecimals);
                return parseFloat(toFixed);
            } else {
                return value;
            }
        }

        function validateNumberDecimal(origin, quantityDecimals) {
            var numbers;
            var isPoint = true;
            numbers = origin.toString().split(".");
            if (numbers.length === 1) {
                numbers = origin.toString().split(",");
                if (numbers.length > 1) {
                    isPoint = false;
                }
            }
            if (numbers.length === 2) {
                $log.debug(numbers[1].toString().length);
                if (numbers[1].toString().length > quantityDecimals) {
                    numbers[1] = numbers[1].substring(0, quantityDecimals);
                    if (isPoint) {
                        origin = parseFloat(numbers.join("."));
                    } else {
                        origin = parseFloat(numbers.join(","));
                    }
                }
            }
            return origin;
        }

        function closeDialog() {
            $mdDialog.cancel();
        }

        function showMessage(message) {
            $rootScope.loadingProgress = false;
            $mdToast.show({
                template: '<md-toast layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
                hideDelay: 3000,
                position: 'top right'
            });
        }

        function showErrorMessage(message) {
            $rootScope.loadingProgress = false;
            $mdToast.show({
                template: '<md-toast layout="column" layout-align="center start"><div class="md-toast-content" style="background-color: red">'
                    + message + '</div></md-toast>',
                hideDelay: 5000,
                position: 'top right'
            });
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('app.expenseSettlement.settlement')
        .controller('createBasicCompanyController', createBasicCompanyController);

    /** @ngInject */
    function createBasicCompanyController($mdDialog, data, api, companyBuyer, $log, company, settlementId, titleFiscal, $rootScope, $mdToast, $filter) {
        var vm = this;
        var isNew = false;
        // Data
        vm.document = [];

        vm.showNrc = companyBuyer.country.name  === 'El Salvador';
        vm.titleFiscal = titleFiscal ? titleFiscal : 'SETTLEMENT.COMPANY.NIT';

        if (data) {
            vm.document.number = data;
            isNew = true;
        } else {
            vm.companyProvider = angular.copy(company);
            vm.showNrc = vm.companyProvider.country.name  === 'El Salvador';
            getDocumentByCompanyProvider(vm.companyProvider);
            getDocumentNrc(vm.companyProvider.id);
        }

        function init() {
            if (vm.companyProvider) {
                vm.loading = true;
                $rootScope.loadingProgress = true;
                api.GeneralWS.CompanyWithholding.getAgentWithholding.get({ 'company': vm.companyProvider.id }, function (response) { // Success
                    if (response.id) {
                        vm.isWithholding = true;
                    }
                    vm.loading = false;
                    $rootScope.loadingProgress = false;
                }, function (errResponse) {
                    vm.loading = false;
                    $rootScope.loadingProgress = false;
                });
            }

        }

        init();

        function getDocumentByCompanyProvider(companyProvider) {
            vm.loading = true;
            $rootScope.loadingProgress = true;
            api.GeneralWS.DocumentByCompany.getByCompany({ companyId: companyProvider.id }).$promise.then(function (response) {
                vm.document = response;
                vm.loading = false;
                $rootScope.loadingProgress = false;
            }, function (error) {
                $log.error(error.data);
                vm.loading = false;
                $rootScope.loadingProgress = false;
            });
        }

      /**
       * Obtiene el documento de tipo NRC en el caso de que sea el pais el salvador
       * @param companyProvider id de la empresa
       */
      function getDocumentNrc(companyProvider) {
        if (!vm.showNrc) {
          return;
        }
        api.GeneralWS.CompanyDocumentActive.getAll({id: companyProvider}).$promise.then(function (response) {
          for (var i = 0; i < response.length; i++) {
            if (response[i].document.documentType.name === 'NRC') {
              vm.documentNRC = response[i].document;
              break;
            }
          }
        });
      }


        // Methods
        vm.closeDialog = closeDialog;
        vm.sendForm = sendForm;

        //////////

        function closeDialog() {
            $mdDialog.cancel();
        }

        function sendForm() {
            vm.loading = true;
            $rootScope.loadingProgress = true;
            var description = '[created by settlement, id = ' + settlementId + ']';
            var numberNRC = vm.documentNRC ? vm.documentNRC.number : null;
            if (isNew) {
                var newCompany = {
                    id: 0,
                    name: vm.companyProvider.businessName,
                    businessName: vm.companyProvider.businessName,
                    country: companyBuyer.country,

                    documentNRC: numberNRC,

                    description: description
                };
                $log.debug("newCompany");
                $log.debug(newCompany);
                api.GeneralWS.BasicCompany.createBasicCompany.create(
                    {
                        document: vm.document.number, companyBuyer: companyBuyer.id,
                       'documentNRC': numberNRC,
                    }, newCompany).$promise.then(function (response) {
                        showMessage($filter('translate')('SETTLEMENT.COMPANY.COMPANY_CREATE'));
                        $mdDialog.hide(response);
                    }, function (error) {
                        $log.error(error);
                        $log.error(error.data);
                        var mensaje;
                        if (error.data === 'Company is already created') {
                            mensaje = 'SETTLEMENT.COMPANY.COMPANY_ALREADY_EXISTS';
                        } else {
                            mensaje = 'SETTLEMENT.COMPANY.COMPANY_CREATE_ERROR';
                        }
                        showErrorMessage($filter('translate')(mensaje));
                        vm.loading = false;
                    });
            } else {
                $log.debug("editCompany");
                $log.debug(vm.companyProvider);
                $rootScope.isWithholding = vm.isWithholding;
              api.GeneralWS.BasicCompany.updateBasicCompany.update(
                    {
                        id: vm.companyProvider.id, companyBuyer: companyBuyer.id,
                        'documentNRC': numberNRC,
                        'isWithholding': vm.isWithholding
                    }, vm.companyProvider).$promise.then(function (response) {
                        showMessage($filter('translate')('SETTLEMENT.COMPANY.COMPANY_UPDATE'));
                        $mdDialog.hide(response);
                    }, function (error) {
                        $log.error(error.data);
                        var mensaje;
                        if (error.data === 'Company already exists') {
                            mensaje = 'SETTLEMENT.COMPANY.COMPANY_ALREADY_EXISTS';
                        } else {
                            mensaje = 'SETTLEMENT.COMPANY.COMPANY_UPDATE_ERROR';
                        }
                        showErrorMessage($filter('translate')(mensaje));
                        vm.loading = false;
                    });
            }
        }

        function showMessage(message) {
            $rootScope.loadingProgress = false;
            $mdToast.show({
                template: '<md-toast layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
                hideDelay: 3000,
                position: 'top right'
            });
        }

        function showErrorMessage(message) {
            $rootScope.loadingProgress = false;
            $mdToast.show({
                template: '<md-toast layout="column" layout-align="center start"><div class="md-toast-content" style="background-color: red">'
                    + message + '</div></md-toast>',
                hideDelay: 5000,
                position: 'top right'
            });
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.expenseSettlement.settlement')
        .controller('changeStatusController', changeStatusController);

    /** @ngInject */
    function changeStatusController($mdDialog, api, $log, $filter, settlementId, $timeout) {
        var vm = this;

        vm.closeDialog = closeDialog;

        //////////
        vm.masterGridOptions = {
            enableSorting: true,
            debug: false,
            enableFilter: true,
            enableColResize: true,
            angularCompileRows: true,
            angularCompileHeaders: true,
            groupSuppressBlankHeader: true,
            toolPanelSuppressGroups: true,
            groupHeaders: false,
            fullWidthCellRenderer: true,
            rowData: [],
            pinnedBottomRowData: [],
            rowHeight: 45,
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            },
            columnDefs: [
                {
                    headerName: "SETTLEMENT.CHANGE_STATUS.DATE",
                    field: "date",
                    width: 150,
                    headerCellRenderer: getHeader,
                    valueFormatter: function (params) {
                        if (params.value === undefined || params.value === null) {
                            return '';
                        } else {
                            return $filter('date')(params.value, 'dd/MM/yyyy HH:mm:ss');
                        }
                    },
                    enableRowGroup: true,
                    enablePivot: true
                },
                {
                    headerName: "SETTLEMENT.CHANGE_STATUS.PREVIOUS_STATUS_NAME",
                    field: "previousStatus.name",
                    width: 150,
                    headerCellRenderer: getHeader,
                    enableRowGroup: true,
                    enablePivot: true
                },
                {
                    headerName: "SETTLEMENT.CHANGE_STATUS.STATUS_NAME",
                    field: "status.name",
                    width: 150,
                    headerCellRenderer: getHeader,
                    enableRowGroup: true,
                    enablePivot: true
                },
                {
                    headerName: "SETTLEMENT.CHANGE_STATUS.ROLE",
                    field: "role.description",
                    width: 230,
                    headerCellRenderer: getHeader,
                    enableRowGroup: true,
                    enablePivot: true
                },
                {
                    headerName: "SETTLEMENT.CHANGE_STATUS.USER",
                    field: "user.name",
                    width: 250,
                    headerCellRenderer: getHeader,
                    enableRowGroup: true,
                    enablePivot: true
                }
            ]
        };

        function init() {
            var element = $("#changeStatusDetailMasterGridOptions");

            if (element) {
                var dialogHeight = element[0].parentElement.offsetHeight;
                dialogHeight -= 40;

                element.css('height', dialogHeight + 'px');

            }
            vm.loading = true;
            api.ComprasWS.Settlement.getSettlementChangeStatus.page({ settlementId: settlementId, pageNumber: 0, pageSize: 20 }, function (response) {
                vm.changeStatus = response;
                vm.masterGridOptions.api.setRowData(new jinqJs()
                    .from(vm.changeStatus.content)
                    .select());
                vm.loading = false;
            }, function (error) {
                vm.loading = false;
                $log.debug(error);
                $log.debug(error.data);
            });

        }

        $timeout(init, 1000);

        function closeDialog() {
            $mdDialog.cancel();
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('app.expenseSettlement.settlement')
        .controller('rejectionReasonController', rejectionReasonController);

    /** @ngInject */
    function rejectionReasonController($mdDialog, api, $log, $state, $rootScope, $mdToast, $filter, Data, detailId, MessageService) {
        var vm = this;
        vm.detail = angular.copy(Data);
        var settlementDetailId = detailId > 0 ? detailId : vm.detail.id;
        vm.detail.rejectionReason = {};
        vm.detail.rejectionReasonDescription = '';
        vm.confirmIsDefinitive = false;
        vm.canSaveRejection = false;

        vm.closeDialog = closeDialog;
        vm.sendForm = sendForm;
        vm.changeReason = changeReason;

        //////////

        init();
        function init() {
          api.ComprasWS.RejectionReason.getAll({circleId: $rootScope.bsCircle.id}, function (response) {
            vm.reasons = response;
            if (vm.reasons.length > 0) {
              vm.detail.rejectionReason = vm.reasons[0];
            }
          }, function (error) {
            $log.debug(error.data);
          });
          api.ComprasWS.SettlementDetail.query({id: settlementDetailId})
            .$promise.then(function (response) {
            vm.detail = response;
            if (vm.detail.invoicePurchase) {
              api.ComprasWS.InvoicePurchaseDetail.byInvoice(
                {
                  id: 'byInvoicePurchase',
                  invoiceId: vm.detail.invoicePurchase.id,
                  idCircle: $rootScope.bsCircle.id
                }, function (response) {
                  vm.detailsSettlement = response;
                }, function () {
                });
            }
            api.ComprasWS.pettyCashGeneralSets.getByPettyCashType(
              {
                id: 'byPettyCashType',
                pettyCashTypeId: vm.detail.settlement.pettyCash.pettyCashType.id, idCircle: $rootScope.bsCircle.id
              }).$promise.then(function (response) {
              if (response.id) {
                vm.pettyCashGeneralSets = response;
                if (vm.pettyCashGeneralSets.askForBudget) {
                  validateHasBudgetApplication($rootScope.bsCircle.company.id);
                }
              }
            }, function () {
            });
          }, function () {
          });
        }

        function changeReason() {
            vm.checkRequired = false;
        }
        function sendForm() {
            vm.checkRequired = false;
            $log.debug("vm.detail 1:");
            if (vm.detail.rejectionReason.isDefinitive === true && vm.confirmIsDefinitive === true) {
                vm.canSaveRejection = true;
            } else if (vm.detail.rejectionReason.isDefinitive === false) {
                vm.canSaveRejection = true;
            }
            if (vm.canSaveRejection === true) {
              if(vm.hasBudgetApplication){
                revertBudgetedProducts();
              } else {
                setReason();
              }
            } else {
                vm.checkRequired = true;
                showErrorMessage($filter('translate')('SETTLEMENT.SETTLEMENT_DETAIL.PLEASE_SELECT_CHECK'));
            }
        }

        function setReason(){
          api.ComprasWS.setRejectionReason.setReason(
            { id: settlementDetailId, circleId: $rootScope.bsCircle.id }, vm.detail).$promise.then(function (response) {
            showMessage($filter('translate')('SETTLEMENT.SETTLEMENT_DETAIL.DETAIL_REJECTED'));

            $log.debug('response on Reject:');
            $log.debug(response);

            var settlementDetail = response;
            var settlement = settlementDetail.settlement;

            //si es importacion y trae estado pre-provisionado llamaria al de provisionar
            if (settlement.pettyCash.pettyCashType && settlement.pettyCash.pettyCashType.name === 'IMPORT'
              && settlementDetail.settlementDetailStatus.name === 'Pre-Provisionado') {

              $rootScope.loadingProgress = true;
              api.ComprasWS.Settlement.provisionSettlement.Provision({ settlementId: settlement.id }, function (responseS) {
                $rootScope.loadingProgress = false;
                $mdDialog.hide(settlementDetail);
                var settlement = responseS;
                showMessage($filter('translate')('SETTLEMENT.SETTLEMENT_VERIFIED'));
                showPDF(settlement);
              }, function (error) {
                $rootScope.loadingProgress = false;
                if (error.data === 'Settlement details not found') {
                  showErrorMessage($filter('translate')('SETTLEMENT.CAN_NOT_VALIDATE_SETTLEMENT'));
                } else {
                  showErrorMessage($filter('translate')('SETTLEMENT.SETTLEMENT_VERIFIED_ERROR'));
                }
                $log.error(error.data);
              });
            } else {
              $mdDialog.hide(settlementDetail);
            }

            $log.debug("vm.detail 2:");
            $log.debug(vm.detail);
            $mdDialog.hide(vm.detail);
          }, function (error) {
            showErrorMessage($filter('translate')('SETTLEMENT.SETTLEMENT_DETAIL.ERROR_DETAIL_REJECTED'));
            $log.error(error.data);
          });
        }


        function showPDF(settlement) {

            var urlRpt = $rootScope.getParameterValue('JASPER_URL_SETTLEMENT_INVOICE_RECEIPT').replace('[ID]', settlement.id);

            $mdDialog.show({
                controller: 'ReportShowPDFController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/reports/dialogs/show-pdf/show-pdf.html',
                parent: angular.element("#main"),
                locals: {
                    Url: urlRpt
                },
                clickOutsideToClose: false,
                fullscreen: true
            }).then(function (answer) {
                $state.go('app.expenseSettlement.verificationSettlements');
            }, function () {
            });
        }

        function closeDialog() {
            $mdDialog.cancel();
        }

        function showMessage(message) {
            $rootScope.loadingProgress = false;
            $mdToast.show({
                template: '<md-toast layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
                hideDelay: 3000,
                position: 'top right'
            });
        }

        function showErrorMessage(message) {
            $rootScope.loadingProgress = false;
            $mdToast.show({
                template: '<md-toast layout="column" layout-align="center start"><div class="md-toast-content" style="background-color: red">'
                    + message + '</div></md-toast>',
                hideDelay: 5000,
                position: 'top right'
            });
        }

      function validateHasBudgetApplication(companyId) {
        api.GeneralWS.CompanyApplication.byAppName.get({ 'company': companyId, 'app': 'Presupuestos' }).$promise.then(function (responseParameter) {
          if (responseParameter.$status === 200) {
            if (responseParameter.$data && responseParameter.$data !== '') {
              vm.hasBudgetApplication = responseParameter.$data.active;
            }
          }
        }, function (response) {
          $log.error(response);
        });
      }

    function revertBudgetedProducts(){
      var confirm2 = $mdDialog.confirm()
        .title($filter('translate')('CONTRACT.CANCELAR'))
        .textContent($filter('translate')('CONTRACT.MSG.CONFIRMACION_CANCELAll'))
        .ok($filter('translate')('CONTRACT.MSG.SI_ALL'))
        .multiple(true)
        .cancel($filter('translate')('CONTRACT.MSG.NO_ALL'));
      $mdDialog.show(confirm2).then(function () {
        $rootScope.loadingProgress = true;
        if (vm.hasBudgetApplication) {
          var productsToValidate = [];
          if (vm.detail.paymentReceipt) {
            productsToValidate = [{
              id: vm.detail.paymentReceipt.id,
              product: vm.detail.paymentReceipt.product,
              amount: (vm.detail.paymentReceipt.amount),
              unitPrice: vm.detail.paymentReceipt.amount,
              currency: vm.detail.paymentReceipt.currency,
              exchangeRate: vm.detail.paymentReceipt.exchangeRate,
              requestAmpliation: false,
              references: null
            }];
          } else {
            vm.detailsSettlement.forEach(function (data) {
              var productToValidate = {
                id: data.id,
                product: data.product,
                amount: data.subTotalAfterTax,
                unitPrice: data.priceAfterTax,
                currency: data.invoicePurchase.currency,
                exchangeRate: data.invoicePurchase.exchangeRate,
                requestAmpliation: false,
                references: null
              };
              productsToValidate.push(productToValidate);
            });
          }

          if (productsToValidate.length <= 0) {
            MessageService.show("INVOICE.NO_BUDGET_FOR_THIS_PRODUCT");
            return null;
          }

          $rootScope.loadingProgress = true;
          api.PresupuestosWS.Budget.revertBudgetedProducts
            .revertBudgeted(
              {
                idc: $rootScope.bsCircle.id,
                originType: '30'
              },
              productsToValidate
            )
            .$promise.then(
            function(response) {
              $rootScope.loadingProgress = false;
              setReason();
            },
            function(response) {
              $rootScope.loadingProgress = false;
              $log.error(response);
            }
          );

        } else {
          setReason();
        }

      }, function (){});
    }
  }

})();

(function () {

    'use strict';

    angular
        .module('app.quotation', ['app.quotation.create'])
        .config(config);

    /**@ngInject**/
    function config($stateProvider, $translatePartialLoaderProvider) {

        $translatePartialLoaderProvider.addPart('app/main/apps/quotation/');

        $stateProvider
            .state('app.quotation', {
                url: '/quotation',
                abstract: true
            })
            .state('app.quotation.Autorizado', {
                url: '/pending-approval',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/quotation/quotations.html',
                        controller: 'QuotationsController as vm'
                    }
                },
                params: {
                    status: 'Autorizado',
                    isClient: false,
                    optionsTrue: true,
                    backTo: null,
                    filter: null
                },
                bodyClass: 'e-commerce'
            })
            .state('app.quotation.Autorizado.detail', {
                url: '/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/quotation/quotation/quotation_view.html',
                        controller: 'QuotationController as vm'
                    }
                },
                params: {
                    productId: 0
                },
                bodyClass: 'e-commerce'
            })
            .state('app.quotation.Ingresada', {
                url: '/pending-authorize',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/quotation/pending-authorize/pending-authorize.html',
                        controller: 'QuotationPendingAuthorizeController as vm'
                    }
                },
                params: {
                    status: 'Ingresada',
                    isClient: true,
                    optionsTrue: true
                }
            })
            .state('app.quotation.Ingresada.detail', {
                url: '/detail',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/quotation/pending-authorize/detail/detail.html',
                        controller: 'QuotationPendingAuthorizeDetailController as vm'
                    }
                },
                params: {
                    requisitionArray: null
                }
            })
            .state('app.quotation.detail', {
                url: '/0/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/quotation/quotation/quotation_view.html',
                        controller: 'QuotationController as vm'
                    }
                },
                params: {
                    backTo: null,
                    filter: null,
                    isClient: null,
                    isReport: null
                }
            })
            .state('app.quotation.Aprobado_sin_caracteristicas', {
                url: '/features-pending',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/quotation/quotations.html',
                        controller: 'QuotationsController as vm'
                    }
                },
                params: {
                    status: 'Aprobado sin caracteristicas',
                    isClient: false,
                    optionsTrue: true
                },
                bodyClass: 'e-commerce'
            })
            .state('app.quotation.Aprobado_sin_caracteristicas.detail', {
                url: '/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/quotation/quotation/quotation_view.html',
                        controller: 'QuotationController as vm'
                    }
                },
                bodyClass: 'e-commerce'
            })
            .state('app.quotation.IngresadaTicket', {
                url: '/pending-authorizeTicket',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/quotation/pending-authorize-ticket/pending-authorize-ticket.html',
                        controller: 'QuotationPendingAuthorizeTicketController as vm'
                    }
                },
                params: {
                    status: 'Ingresada',
                    isClient: true,
                    optionsTrue: true
                }
            })
            .state('app.quotation.IngresadaTicket.detail', {
                url: '/detail',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/quotation/pending-authorize-ticket/detail/detail.html',
                        controller: 'QuotationPendingAuthorizeTicketDetailController as vm'
                    }
                },
                params: {
                    requisitionArray: null
                }
            })
            .state('app.quotation.quotationReport', {
                url: '/quotation-report',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/quotation/quotation-report/quotation-report.html',
                        controller: 'QuotationReportController as vm'
                    }
                },
                bodyClass: 'dashboard-project'
            })
            .state('app.quotation.reportDetailPendingApprove.list', {
                url: '/pending-approval/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/quotation/quotations.html',
                        controller: 'QuotationsController as vm'
                    }
                },
                params: {
                    status: 'Autorizado',
                    isClient: false,
                    optionsTrue: true,
                    filter: null,
                    backTo: null
                },
                bodyClass: 'e-commerce'
            })
            .state('app.quotation.reportDetailPendingApprove.detail', {
                url: '/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/quotation/quotation/quotation_view.html',
                        controller: 'QuotationController as vm'
                    }
                },
                params: {
                    productId: 0
                },
                bodyClass: 'e-commerce'
            });
    }

})();


(function () {

    'use strict';

    angular
        .module('app.quotation')
        .controller('QuotationHistoryProductController', QuotationHistoryProductController);

    function QuotationHistoryProductController(api, $mdDialog, $filter, $timeout, $log, quotationDetail, departmentId, costCenterId) {

        var vm = this;
        vm.product = quotationDetail.requisitionDetail.product;

        vm.byCorporate = false;

        vm.gridOptions = {
            columnDefs: [
                {
                    headerName: $filter('translate')('authorize_quotations.requisition_number'),
                    field: "requisitionId",
                    width: 130,
                    hide: true,
                    rowGroupIndex: 0
                },
                {
                    headerName: $filter('translate')('authorize_quotations.date'),
                    field: "requisitionCreatedAt",
                    width: 100,
                    valueFormatter: function (params) {
                        if (!params.node.group) {
                            return $filter('apiDate')(params.value, 'dd/MM/yyyy');
                        } else {
                            return "";
                        }
                    }
                },
                {
                    headerName: $filter('translate')('authorize_quotations.quantity'),
                    field: "quantity",
                    width: 110,
                    cellStyle: { 'text-align': 'right' },
                    aggFunc: 'sum'
                },
                {
                    headerName: $filter('translate')('authorize_quotations.price'),
                    field: "price",
                    width: 110,
                    valueFormatter: function (params) {
                        return $filter('number')(params.value, 2);
                    },
                    cellStyle: { 'text-align': 'right' }
                },
                {
                    headerName: $filter('translate')('authorize_quotations.total'),
                    field: "total",
                    width: 110,
                    valueFormatter: function (params) {
                        return $filter('number')(params.value, 2);
                    },
                    cellStyle: { 'text-align': 'right' },
                    aggFunc: 'sum'
                }
            ],
            suppressContextMenu: true,
            groupHeaders: true,
            groupDefaultExpanded: 1,
            groupSelectsChildren: true,
            autoGroupColumnDef: {
                headerName: $filter('translate')('authorize_quotations.requisition_number'),
                field: "requisitionId",
                width: 120,
                cellRenderer: 'group',
                hide: true,
                cellRendererParams: {
                }
            },
            angularCompileRows: true,
            angularCompileHeaders: true,
            enableColResize: true,
            rowData: [],
            rowHeight: 30,
            pinnedBottomRowData: []
        };

        vm.closeDialog = closeDialog;
        vm.init = init;

        function closeDialog() {
            $mdDialog.cancel();
        }

        function init() {
            vm.loading = true;
            api.ComprasWS.Requisitions.historyProduct.query(
                {
                    'productId': quotationDetail.requisitionDetail.product.id,
                    'departmentId': departmentId, 'costCenterId': costCenterId,
                    'byCorporate': vm.byCorporate
                }).$promise.then(function (response) {
                    vm.gridOptions.api.setRowData(response);
                    vm.loading = false;
                }, function (response) {
                    vm.loading = false;
                    $log.error(response);
                });

        }

        $timeout(init, 1000);

    }

})();

(function () {
    'use strict';

    angular
        .module('app.order',
            [
                'flow'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {
        // State
        $stateProvider
            .state('app.order', {
                url: '/order',
                abstract: true
            })
            .state('app.order.P', {
                url: '/P',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/order/orders.html',
                        controller: 'OrdersController as vm'
                    }
                },
                params: {
                    type: 'P'
                },
                bodyClass: 'e-commerce'
            })
            .state('app.order.C', {
                url: '/C',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/order/orders.html',
                        controller: 'OrdersController as vm'
                    }
                },
                params: {
                    type: 'C'
                },
                bodyClass: 'e-commerce'
            })
            .state('app.order.PR', {
                url: '/PR',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/order/orders.html',
                        controller: 'OrdersController as vm'
                    }
                },
                params: {
                    type: 'PR'
                },
                bodyClass: 'e-commerce'
            })
            .state('app.order.P.detail', {
                url: '/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/order/order/order_view.html',
                        controller: 'OrderController as vm'
                    }
                },
                params: {
                    backTo: null,
                    filter: null
                },
                bodyClass: 'e-commerce'
            })
            .state('app.order.PR.detail', {
                url: '/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/order/order/order.html',
                        controller: 'OrderController as vm'
                    }
                },
                bodyClass: 'e-commerce'
            })
            .state('app.order.C.detail', {
                url: '/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/order/order/order.html',
                        controller: 'OrderController as vm'
                    }
                },
                bodyClass: 'e-commerce'
            })
            .state('app.order.detail', {
                url: '/0/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/order/order/order_view.html',
                        controller: 'OrderController as vm'
                    }
                },
                params: {
                    backTo: null,
                    filter: null,
                    isClient: null
                },
                bodyClass: 'e-commerce'
            })
            .state('app.order.detailProvider', {
                url: '/1/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/order/order-provider/order-provider.html',
                        controller: 'OrderProviderController as vm'
                    }
                },
                params: {
                    backTo: null,
                    filter: null,
                    isClient: null
                },
                bodyClass: 'e-commerce'
            })
            .state('app.order.PIC', {
                url: '/PIC',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/order/orders.html',
                        controller: 'OrdersController as vm'
                    }
                },
                params: {
                    type: 'PIC'
                },
                bodyClass: 'e-commerce'
            })
            .state('app.order.PIC.detail', {
                url: '/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/order/order/order_view.html',
                        controller: 'OrderController as vm'
                    }
                },
                params: {
                    backTo: null,
                    filter: null
                },
                bodyClass: 'e-commerce'
            }).state('app.order.purchaseOrderReport', {
                url: '/purchaseOrder-report',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/order/order-report/order-report.html',
                        controller: 'PurchaseOrderReportController as vm'
                    }
                },
                bodyClass: 'dashboard-project'
            })
            .state('app.order.cancelPurchaseOrder', {
                url: '/purchaseOrder-reportCancel',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/order/order-report/order-report.html',
                        controller: 'PurchaseOrderReportController as vm'
                    }
                },
                params: {
                    cancelPurchase: true
                },
                bodyClass: 'dashboard-project'
            })
          .state('app.order.detailsPendingDelivery', {
            url: '/detail-pending-delivery',
            views: {
              'content@app': {
                templateUrl: 'app/main/apps/order/details-pending-delivery/details-pending-delivery.html',
                controller: 'DetailsPendingDelivery as vm'
              }
            },
            bodyClass: 'e-commerce'
          });
        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/order');

    }

})();

(function () {
    'use strict';
    angular
        .module('app.order')
        .controller('MerchandiseEntryDialogController', MerchandiseEntryDialogController);

    /** @ngInject */
    function MerchandiseEntryDialogController($mdDialog, api, $log, $filter, $rootScope, merchandiseHeader, MessageService) {

        var vm = this;
        vm.merchandiseHeader = merchandiseHeader;
        vm.close = close;
        vm.details = [];
        vm.URLPHOTOS = api.baseUrlPhotos;
        vm.editDetail = editDetail;
        vm.deleteDetail = deleteDetail;
        vm.updateMerchandiseHeader = updateMerchandiseHeader;
        vm.viewIMG = viewIMG;
        vm.showButtons = false;

        vm.masterColumnDefsD = [
            {
                headerName: 'INVOICE_MERCHANDISE_ENTRY.DETAIL.QUANTITY',
                name: "quantity",
                headerCellRenderer: getHeader,
                width: 200,
                enableRowGroup: true,
                enablePivot: true,
                cellRenderer: rendererQuantity,
                cellStyle: { 'text-align': 'center' }
            },
            {
                headerName: 'INVOICE_MERCHANDISE_ENTRY.DETAIL.PRODUCT',
                field: "purchaseOrderDetail.product.name",
                headerCellRenderer: getHeader,
                width: 250,
                enableRowGroup: true,
                enablePivot: true
            }, {
                headerName: 'REQUISITION.ACTIONS',
                name: "actions",
                headerCellRenderer: getHeader,
                suppressSorting: true,
                suppressMenu: true,
                width: 150,
                cellRenderer: renderer,
                cellStyle: { 'padding': '0px' }
            }
        ];


        vm.masterGridOptionsD = {
            columnDefs: vm.masterColumnDefsD,
            enableSorting: true,
            debug: false,
            enableFilter: true,
            enableColResize: true,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowData: null,
            groupHeaders: true,
            headerHeight: 64,
            rowHeight: 45,
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            doesDataFlower: function (dataItem) {
                return true;
            },
            isExternalFilterPresent: isExternalFilterPresent,
            doesExternalFilterPass: doesExternalFilterPass
        };

        // Data
        var filter = 'everyone';

        function isExternalFilterPresent() {
            // if ageType is not everyone, then we are filtering
            return filter !== '';
        }

        function doesExternalFilterPass(node) {
            if (filter && filter !== 'everyone') {
                var arrdt = node.data.filter.split(filter);
                return arrdt.length > 1;
            }
            return true;
        }

        function close() {
            $mdDialog.hide(vm.merchandiseHeader);
        }

        init();

        function init() {
            api.ComprasWS.MerchandiseEntry.getHeader(
                { id: 'byMerchandiseHeader', idCircle: $rootScope.bsCircle.id, merchandiseHeaderId: vm.merchandiseHeader.id }).$promise.then(function (response) {
                    vm.details = response;
                    vm.masterGridOptionsD.api.setColumnDefs(vm.masterColumnDefsD);
                    vm.masterGridOptionsD.api.setRowData(vm.details);
                }, function (errResponse) {
                    $log.debug(errResponse);
                    vm.masterGridOptionsD.api.setColumnDefs(vm.masterColumnDefsD);
                    vm.masterGridOptionsD.api.setRowData([]);
                });
        }

        function renderer(param) {
            if (param.data.merchandiseHeader.purchaseOrder.quotation && (param.data.merchandiseHeader.purchaseOrder.quotation.requisition.receivedDouble)) {
                api.ComprasWS.ByPurchaseOrderAndType.query(
                    {
                        idCircle: $rootScope.bsCircle.id,
                        'purchaseOrderId': param.data.merchandiseHeader.purchaseOrder.id,
                        'merchandiseEntryType': param.data.merchandiseHeader.merchandiseEntryType
                    }).$promise.then(function (response) {
                        if (response.length === 0) {
                            vm.showButtons = true;
                        } else {
                            vm.showButtons = false;
                        }
                    }, function (errResponse) {
                        $log.debug(errResponse);

                    });
            }
            return '<div ng-if="!data.invoiced && (data.merchandiseHeader.purchaseOrder.quotation '
                + ' && ((data.merchandiseHeader.purchaseOrder.quotation.requisition.receivedDouble '
                + ' && ((data.merchandiseHeader.merchandiseEntryType===\'INVOICE\' && data.merchandiseHeader.purchaseOrder.purchaseStatus.description===\'Primera Recepcion\') '
                + '|| (data.merchandiseHeader.merchandiseEntryType===\'NOT_INVOICE\' && data.merchandiseHeader.purchaseOrder.purchaseStatus.description===\'Recibido\'))) '
                + ' || !data.merchandiseHeader.purchaseOrder.quotation.requisition.receivedDouble) || vm.showButtons)">'
                + ' <md-button ng-if="data.quantity>0" class="edit-button md-icon-button"'
                + ' ng-click="vm.editDetail($event, data, $index)"'
                + ' aria-label="Product details"'
                + '   translate translate-attr-aria-label="REQUISITION.PRODUCT_DETAILS">'
                + ' <md-icon md-font-icon="icon-pencil" ng-if="!data.editDetail" class="s16">'
                + '  <md-tooltip md-direction="bottom">'
                + ' {{"general.edit"| translate}}'
                + ' </md-tooltip>'
                + ' </md-icon>'
                + '              <md-icon md-font-icon="icon-content-save" ng-if="data.editDetail" class="s16">'
                + '  <md-tooltip md-direction="bottom">'
                + ' {{"general.save"| translate}}'
                + ' </md-tooltip>'
                + ' </md-icon>'
                + '          </md-button>'
                + ' <md-button class="edit-button md-icon-button"'
                + '                                                ng-click="vm.deleteDetail($event, data, $index)"'
                + '                                aria-label="Product details"'
                + '                                translate translate-attr-aria-label="REQUISITION.DELETE">'
                + '                         <md-icon md-font-icon="icon-delete" class="s16 md-warn">'
                + '  <md-tooltip md-direction="bottom">'
                + '                                             {{"CONTRACT.DELETE"| translate}}'
                + ' </md-tooltip>'
                + ' </md-icon>'
                + '          </md-button>'
                + ' </div>';
        }

        function rendererQuantity(dataItem) {
            return '<div>'
                + ' <input ng-if="data.editDetail" min="0" type="number" ng-model="data.quantity"/>'
                + ' <span ng-if="!data.editDetail">{{data.quantity}}</span>'
                + ' </div>';
        }

        function editDetail(ev, data, index) {
            data.editDetail = !data.editDetail;
            if (!data.editDetail) {

                vm.updateMerchandiseEntry = {
                    id: data.id,
                    quantity: data.quantity,
                    purchaseOrderDetail: data.purchaseOrderDetail,
                    merchandiseHeader: data.merchandiseHeader,
                    invoiced: false,
                    purchaseStatus: data.purchaseStatus
                };
                api.ComprasWS.MerchandiseEntry.update({ id: data.id }, vm.updateMerchandiseEntry).$promise.then(function (response) {
                    data = response;
                    MessageService.show('INVOICE_MERCHANDISE_ENTRY.UPDATE_SUCCESSFULLY');
                }, function (errResponse) {
                    $log.debug(errResponse);
                    MessageService.showErrorMessage("REQUISITION.MSG." + errResponse.data.mensaje);
                });

            }
        }

        function updateMerchandiseHeader() {
            if (vm.filesToUpload.length > 0) {
                var files = [];

                vm.filesToUpload.forEach(function (r) {
                    files.push(r.file.file);
                });

                $rootScope.loadingProgress = true;
                api.GeneralWS.Common.FileStorage.filesUpload.add({ 'companyId': $rootScope.bsCircle.company.id }, files).then(function (response) {
                    $rootScope.loadingProgress = false;
                    vm.merchandiseHeader.filesMerchandiseEntry = response.data;
                    MessageService.show('INVOICE_MERCHANDISE_ENTRY.UPDATE_SUCCESSFULLY');
                    save();
                }, function (errResponse) {
                    $log.error(errResponse);
                    MessageService.showErrorMessage("REQUISITION.MSG." + errResponse.data.mensaje);
                    $rootScope.loadingProgress = false;
                });

            }
        }

        function save() {
            api.ComprasWS.MerchandiseHeader.updateFiles(
                { idCircle: $rootScope.bsCircle.id, id: 'updateFiles' }, vm.merchandiseHeader).$promise.then(function (response) {
                    vm.merchandiseHeader = response;
                    $mdDialog.hide(vm.merchandiseHeader);
                    MessageService.show('INVOICE_MERCHANDISE_ENTRY.UPDATE_SUCCESSFULLY');
                }, function (errResponse) {
                    MessageService.showErrorMessage("REQUISITION.MSG." + errResponse.data.mensaje);
                    $log.debug(errResponse);
                });
        }

        function viewIMG(file) {
            $mdDialog.show({
                controller: 'DialogPhotoController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/files/dialogPhoto/dialogPhoto.html',
                parent: angular.element("#main"),
                name: file.originalName,
                url: vm.URLPHOTOS + file.parentPath + file.name + file.extension,
                clickOutsideToClose: false
            }).then(function (answer) {
                //go to Quotations
                answer === true ? goToInvoicePurchases() : null;
            });
        }

        function deleteDetail(ev, data, index) {
            api.ComprasWS.MerchandiseEntry.delete({ id: data.id }).$promise.then(function (response) {
                vm.details.splice(index, 1);
                MessageService.show('INVOICE_MERCHANDISE_ENTRY.DELETE_SUCCESSFULLY');
                $mdDialog.hide(vm.merchandiseHeader);
            }, function (errResponse) {
                MessageService.showErrorMessage("REQUISITION.MSG." + errResponse.data.mensaje);
                $log.debug(errResponse);
            });
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('app.expenseSettlement.settlement')
        .controller('SettlementReceiptEditorController', SettlementReceiptEditorController);

    /** @ngInject */
    function SettlementReceiptEditorController($rootScope, $state, api, $log, $mdDialog, $filter, $mdToast,
        $stateParams, PreviousState, PaymentReceipt, $timeout) {
        var vm = this;

        document.addEventListener("mousewheel", function (event) {
            if (document.activeElement.type === "number") {
                document.activeElement.blur();
            }
        });

        //Data
        vm.company = $rootScope.bsCircle.company;
        vm.URLPHOTOS = api.baseUrlPhotos;
        vm.receipt = {};
        var SettlementDetailId = $stateParams.detail;
        vm.receipt.receiptDate = ('dd-MM-yyyy');
        vm.filesToUpload = [];
        vm.detailsExtraAuthorization = [];
        vm.canEditExchangeRate = true;
        vm.isExtraAuthorizer = $rootScope.bsCircle.name === 'ROLE_EXTRA_AUTORIZADOR_LIQUIDACIONES' ? true : false;

        //Methods
        vm.saveReceipt = saveReceipt;
        vm.closeThread = closeThread;
        vm.viewIMG = viewIMG;
        vm.updateReceipt = updateReceipt;
        vm.notAuthorizated = notAuthorizated;
        vm.authorizeDetail = authorizeDetail;
        vm.changeCurrencyOrDate = changeCurrencyOrDate;
        vm.calculateAmounts = calculateAmounts;

        function addDay(date, day) {
            date.setDate(date.getDate() + day);
            return date;
        }

        var currentDate = new Date();
        vm.today = new Date();
        vm.lastYear = new Date(currentDate.setYear(currentDate.getFullYear() - 1));

        init();
        function init() {
            api.ComprasWS.Settlement.Settlement.get({ id: $stateParams.settlement }).$promise.then(function (response) {
                vm.settlement = response;
                api.ComprasWS.pettyCash.get({ id: vm.settlement.pettyCash.id, circle: $rootScope.bsCircle.id }).$promise.then(function (response) {
                    vm.pettyCash = response;
                    api.ComprasWS.pettyCashGeneralSets.getByPettyCashType(
                        {
                            id: 'byPettyCashType',
                            pettyCashTypeId: response.pettyCashType.id, idCircle: $rootScope.bsCircle.id
                        }).$promise.then(function (response) {
                            vm.pettyCashGeneralSets = response;
                        }, function (error) {
                            $log.error(error.data);
                        });
                    getRequiredProducts(response.pettyCashType.id);
                    getAllCurrencies();
                    getAmountAvailable();
                    if (PaymentReceipt && vm.receipt.currency.id === vm.pettyCash.currency.id) {
                        vm.canEditExchangeRate = false;
                    }
                }, function (error) {
                    $log.error(error.data);
                });
            }, function (error) {
                $log.error(error.data);
            });
        }

        if (PaymentReceipt) {
            vm.receipt = angular.copy(PaymentReceipt);
            vm.receipt.receiptDate = addDay(new Date(vm.receipt.receiptDate), 1);
            vm.receipt.dateReceiptAccounting = addDay(new Date(vm.receipt.dateReceiptAccounting), 1);
            $log.debug("vm.receipt");
            $log.debug(vm.receipt);
            loadFiles(vm.receipt);
            getDetailsExtraAuthorization();
        }

        function getDetailsExtraAuthorization() {
            if (vm.isExtraAuthorizer) {
                api.ComprasWS.SettlementDetails.getDetailsExtraAuthorization.getDetails(
                    {
                        settlementDetailId: SettlementDetailId,
                        circleId: $rootScope.bsCircle.id
                    }).$promise.then(function (response) {
                        vm.detailsExtraAuthorization = response;
                    }, function (error) {
                        $log.error(error.data);
                    });
            }
        }

        function changeCurrencyOrDate(currencyId, dateReceipt) {
            if (currencyId && dateReceipt) {
                if (typeof (dateReceipt) === "number") {
                    dateReceipt = new Date(dateReceipt);
                }
                if (currencyId === vm.pettyCash.currency.id) {
                    vm.canEditExchangeRate = false;
                    vm.receipt.exchangeRate = 1;
                    calculateAmounts();
                } else {
                    var exchange = {
                        sourceCurrency: {
                            id: currencyId
                        },
                        targetCurrency: {
                            id: vm.pettyCash.currency.id
                        },
                        rateDate: dateReceipt.getTime(),
                        rate: 0,
                        id: 0
                    };
                    api.GeneralWS.ExchangeRate.getDayExchangeRate({ idCircle: $rootScope.bsCircle.id }, exchange).$promise.then(function (response) {
                        vm.canEditExchangeRate = true;
                        vm.receipt.exchangeRate = response.rate;
                        calculateAmounts();
                    }, function (error) {
                        vm.canEditExchangeRate = true;
                        vm.receipt.exchangeRate = null;
                        vm.receipt.amount = null;
                        $log.debug(error.data);
                    });
                }
            }
        }

        vm.clearSearchCurrency = function () {
            vm.searchCurrency = "";
        };

        vm.clearSearchProduct = function () {
            vm.searchProduct = "";
        };

        $timeout(function () {
            var keyEvent = function (event) {
                event.stopPropagation();
            };
            var searchCurrencyInput = document.querySelector("#currency");
            var searchProductInput = document.querySelector("#product");

            if (searchCurrencyInput) {
                searchCurrencyInput.addEventListener("keydown", keyEvent);
            }
            if (searchProductInput) {
                searchProductInput.addEventListener("keydown", keyEvent);
            }
        }, 500);


        function getAllCurrencies() {
            api.GeneralWS.Currency.query().$promise.then(function (response) {
                vm.currencies = response;
                if (vm.currencies.length > 0 && !PaymentReceipt) {
                    vm.receipt.currency = vm.settlement.pettyCash.currency;
                }
            }, function (errResponse) {
                $log.error(errResponse);
            });
        }

        function getRequiredProducts(pettyCashTypeId) {
            api.ComprasWS.getSettlementProduct.getAll(
                {
                    pettyCashTypeId: pettyCashTypeId,
                    idCircle: $rootScope.bsCircle.id, settlementProductTypeName: 'PREDETERMINED'
                }).$promise.then(function (response) {
                    vm.defaultProducts = response;
                    if (vm.defaultProducts.length === 0) {
                        showErrorMessage($filter('translate')('SETTLEMENT.RECEIPT.DEFAULT_PRODUCTS_NOT_FOUND') + vm.pettyCash.pettyCashType.description);
                    } else if (vm.defaultProducts.length === 1 && !PaymentReceipt) {
                        vm.receipt.product = vm.defaultProducts[0];
                    }
                }, function (error) {
                    showErrorMessage($filter('translate')('SETTLEMENT.RECEIPT.DEFAULT_PRODUCTS_NOT_FOUND') + vm.pettyCash.pettyCashType.description);
                    $log.error(error);
                    $log.error(error.data);
                });
        }


        function loadFiles(receipt) {
            api.ComprasWS.PaymentReceiptFiles.get({ id: receipt.id }, function (response) {// Success
                vm.receipt.files = response;
                vm.filesReceipt = response;
            }, function (response) {// Error
                $log.error(response);
                vm.loading = false;
                $rootScope.loadingProgress = false;
            });
        }

        function viewIMG(file) {
            $mdDialog.show({
                controller: 'DialogPhotoController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/files/dialogPhoto/dialogPhoto.html',
                parent: angular.element("#main"),
                name: file.originalName,
                url: vm.URLPHOTOS + file.parentPath + file.name + file.extension,
                clickOutsideToClose: false
            }).then(function (answer) {
            });
        }

        function getAmountAvailable() {
            if (vm.pettyCash.amount > 0) {
                api.ComprasWS.Settlement.getAmountAvailable.getTotal({ id: vm.pettyCash.id }).$promise.then(function (response) {
                    vm.amountAvailable = parseFloat(response.$data);
                    $log.debug("vm.amountAvailable");
                    $log.debug(vm.amountAvailable);
                }, function (error) {
                    $log.error(error.data);
                });
            }
        }

        function setAsOverSpend(settlementDetailId) {
            //marca si se sobre pasa el limite
            vm.loading = true;
            api.ComprasWS.SettlementDetails.OverSpend.setIsOverSpend({ id: settlementDetailId }).$promise.then(function (response) {
                vm.loading = false;
            }, function (error) {
                $log.error(error);
                vm.loading = false;
            });
        }

        function calculateAmounts() {
            if (vm.receipt.documentAmount) {
                vm.receipt.amount = toFixedNumber(vm.receipt.documentAmount * vm.receipt.exchangeRate, 2);
            }
        }

        function validateMaxAmount() {
            if (vm.pettyCashGeneralSets) {
                var amount = angular.copy(vm.receipt.amount);
                if (vm.pettyCashGeneralSets.maxAmountByDocument > 0 && amount > vm.pettyCashGeneralSets.maxAmountByDocument) {
                    showErrorMessage($filter('translate')('SETTLEMENT.RECEIPT.MAX_AMOUNT_BY_PETTY_TYPE') + vm.pettyCash.currency.symbol +
                        toFixedNumber(vm.pettyCashGeneralSets.maxAmountByDocument, 2) + $filter('translate')('SETTLEMENT.RECEIPT.MAX_AMOUNT_BY_PETTY_TYPE2'));
                    return false;
                }
            }
            return true;
        }

        //save new
        function saveReceipt() {
            if (validateMaxAmount()) {
                vm.newReceipt = {
                    companyBuyer: {
                        id: vm.company.id
                    },
                    serie: vm.receipt.serie,
                    correlative: vm.receipt.correlative,
                    product: { id: vm.receipt.product.id },
                    description: vm.receipt.description,
                    amount: vm.receipt.amount,
                    documentAmount: vm.receipt.documentAmount,
                    foreignAmount: vm.receipt.foreignAmount,
                    recipientName: vm.receipt.recipientName,
                    receiptDate: vm.receipt.receiptDate.getTime(),
                    dateReceiptAccounting: vm.receipt.receiptDate.getTime(),
                    currency: { id: vm.receipt.currency.id },
                    exchangeRate: vm.receipt.exchangeRate,
                    companyCurrency: vm.pettyCash.currency,
                    foreignExchangeRate: vm.receipt.foreignExchangeRate,
                    purchaseStatus: {
                        description: 'Ingresando'
                    }
                };
                vm.exchangeRate = angular.copy(vm.receipt.foreignExchangeRate);
                if (!vm.pettyCash.pettyCashType.allowOverSpend
                    && vm.pettyCash.amount > 0
                    && (vm.receipt.amount > vm.amountAvailable)
                ) {
                    showErrorMessage($filter('translate')('SETTLEMENT.TOTAL_SETTLEMENTS_EXCEEDS_CREATING') + vm.pettyCash.currency.symbol
                        + toFixedNumber(vm.pettyCash.amount, 2) + $filter('translate')('SETTLEMENT.TOTAL_SETTLEMENTS_EXCEEDS_CREATING2'));
                } else {
                    if (vm.filesToUpload.length > 0) {
                        var files = [];
                        vm.filesToUpload.forEach(function (r) {
                            files.push(r.file.file);
                        });
                        $rootScope.loadingProgress = true;
                        api.GeneralWS.Common.FileStorage.filesUpload.add({ 'companyId': $rootScope.bsCircle.company.id }, files).then(function (response) {
                            $rootScope.loadingProgress = false;
                            vm.receipt.files = response.data;
                            vm.newReceipt.files = response.data;
                            vm.filesPurchase = response.data;
                            save();
                        }, function (errResponse) {
                            $log.error(errResponse);
                            $rootScope.loadingProgress = false;
                        });
                    } else {
                        save();
                    }
                }
            }
        }

        function save() {
            api.ComprasWS.PaymentReceipt.save({ idCircle: $rootScope.bsCircle.id }, vm.newReceipt).$promise.then(function (response) {
                vm.receipt.id = response.id;
                vm.receipt.dateReceipt = addDay(new Date(vm.receipt.dateReceipt), 1);
                vm.receipt.dateReceiptAccounting = addDay(new Date(vm.receipt.dateReceiptAccounting), 1);
                vm.filesToUpload = [];
                createSettlementDetail(response);
                showMessage($filter('translate')('SETTLEMENT.RECEIPT.RECEIPT_CREATED'));
            }, function (error) {
                showErrorMessage($filter('translate')('SETTLEMENT.RECEIPT.ERROR_RECEIPT_CREATED'));
                $log.error(error.data);
            });
        }

        function createSettlementDetail(receipt) {
            if (receipt) {
                var newDetail = {
                    id: 0,
                    paymentReceipt: {
                        id: receipt.id
                    },
                    settlement: {
                        id: vm.settlement.id
                    }
                };
                api.ComprasWS.SettlementDetail.create({ id: '' }, newDetail).$promise.then(function (response) {
                    $log.debug("Detalle de liquidación creado");
                    $log.debug(response);

                    //si se sobrepasa limite
                    SettlementDetailId = response.id;
                    if (vm.pettyCash.pettyCashType.allowOverSpend && vm.receipt.amount > vm.amountAvailable) {
                        setAsOverSpend(SettlementDetailId);
                    }

                    closeThread();
                }, function (error) {
                    $log.error(error.data);
                });
            }
        }

        //update existing
        function updateReceipt() {
            if (validateMaxAmount()) {
                $rootScope.loadingProgress = true;
                vm.amountAvailable = vm.amountAvailable + PaymentReceipt.amount;

                if (!vm.pettyCash.pettyCashType.allowOverSpend
                    && vm.pettyCash.amount > 0
                    && (vm.receipt.amount > vm.amountAvailable)
                ) {
                    showErrorMessage($filter('translate')('SETTLEMENT.TOTAL_SETTLEMENTS_EXCEEDS_UPDATING') + vm.pettyCash.currency.symbol
                        + toFixedNumber(vm.pettyCash.amount, 2) + $filter('translate')('SETTLEMENT.TOTAL_SETTLEMENTS_EXCEEDS_UPDATING2'));
                    getAmountAvailable();
                } else {
                    if (vm.filesToUpload.length > 0) {
                        var files = [];
                        vm.filesToUpload.forEach(function (r) {
                            files.push(r.file.file);
                        });
                        api.GeneralWS.Common.FileStorage.filesUpload.add({ 'companyId': $rootScope.bsCircle.company.id }, files).then(function (response) {
                            $rootScope.loadingProgress = false;
                            vm.receipt.files = response.data;
                            vm.filesToUpload = [];
                            update();
                        }, function (errResponse) {
                            $log.error(errResponse);
                            $rootScope.loadingProgress = false;
                        });

                    } else {
                        update();
                    }
                }
            }
        }

        function update() {
            vm.receipt.companyCurrency = { id: vm.pettyCash.currency.id };

            api.ComprasWS.PaymentReceipt.update({ id: vm.receipt.id, idCircle: $rootScope.bsCircle.id }, vm.receipt).$promise.then(function (response) {
                vm.receipt.id = response.id;
                vm.receipt.dateReceipt = addDay(new Date(vm.receipt.dateReceipt), 1);
                vm.receipt.dateReceiptAccounting = addDay(new Date(vm.receipt.dateReceiptAccounting), 1);
                updateTotalSettlement();

                //si se sobrepasa limite
                if (vm.pettyCash.pettyCashType.allowOverSpend && vm.receipt.amount > vm.amountAvailable) {
                    setAsOverSpend(SettlementDetailId);
                }

                showMessage($filter('translate')('SETTLEMENT.RECEIPT.RECEIPT_UPDATED'));
                $rootScope.loadingProgress = false;

            }, function (errResponse) {
                showErrorMessage($filter('translate')('SETTLEMENT.RECEIPT.ERROR_RECEIPT_UPDATED'));
                $log.error(errResponse);
            });

        }

        function updateTotalSettlement() {
            api.ComprasWS.Settlement.setTotalSettlement.update({ id: vm.settlement.id }).$promise.then(function (response) {
                vm.settlement.settledAmount = response.settledAmount;
                $rootScope.loadingProgress = false;
            }, function (error) {
                $rootScope.loadingProgress = false;
                $log.error(error.data);
            });
        }

        function authorizeDetail(event) {
            if (event) {
                event.stopPropagation();
            }
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('SETTLEMENT.SETTLEMENT_DETAIL.AUTHORIZE_DETAIL'))
                .htmlContent('<strong>' + $filter('translate')('SETTLEMENT.SETTLEMENT_DETAIL.MSG_DETAIL_AUTHORIZED') + '</strong>' + '<br>' +
                    $filter('translate')('SETTLEMENT.SETTLEMENT_DETAIL.MSG_DETAIL_AUTHORIZED2'))
                .ariaLabel('Authorize Detail')
                .ok($filter('translate')('SETTLEMENT.OK'))
                .cancel($filter('translate')('SETTLEMENT.CANCEL'));
            $mdDialog.show(confirm).then(function () {
                $rootScope.loadingProgress = true;
                api.ComprasWS.SettlementDetails.AuthorizeDetail.authorize(
                    { id: $stateParams.detail, circleId: $rootScope.bsCircle.id }).$promise.then(function (response) {
                        showMessage($filter('translate')('SETTLEMENT.SETTLEMENT_DETAIL.DETAIL_AUTHORIZED'));
                        closeThread();
                    }, function (error) {
                        showErrorMessage($filter('translate')('SETTLEMENT.SETTLEMENT_DETAIL.DETAIL_AUTHORIZED_ERROR'));
                        $log.error(error.data);
                    });
            }, function () {
                // Cancel Action
            });
        }

        function notAuthorizated(ev, d) {
            $mdDialog.show({
                controller: 'rejectionReasonController',
                controllerAs: 'vm',
                locals: {
                    Data: d,
                    detailId: $stateParams.detail
                },
                templateUrl: 'app/main/apps/expenseSettlements/settlements/settlement/settlementEditor/rejectionReason/rejectionReason.html',
                parent: angular.element("#main"),
                targetEvent: ev,
                clickOutsideToClose: false
            }).then(function (answer) {
                closeThread();
            }, function () {
            });
        }

        function toFixedNumber(origin, numberDecimals) {
            var toFixed = origin.toFixed(numberDecimals);
            return parseFloat(toFixed);
        }

        function closeThread() {
            $rootScope.snThread = false;
            if (PreviousState.name !== "") {
                switch (PreviousState.name) {
                    case 'app.expenseSettlement.settlement.settlementEdit':
                        $state.go('app.expenseSettlement.settlement.settlementEdit', { settlementId: vm.settlement.id });
                        break;
                    case 'app.expenseSettlement.settlement.settlementView':
                        $state.go('app.expenseSettlement.settlement.settlementView', { settlementId: vm.settlement.id });
                        break;
                    case 'app.expenseSettlement.consultSettlement':
                        $state.go('app.expenseSettlement.consultSettlement', { id: vm.settlement.id });
                        break;
                    default:
                        $state.go(PreviousState.name, PreviousState.params);
                        break;
                }
            } else {
                $state.go('app.dashboards_project');
            }
        }

        function showMessage(message) {
            $rootScope.loadingProgress = false;
            $mdToast.show({
                template: '<md-toast layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
                hideDelay: 3000,
                position: 'top right'
            });
        }


        function showErrorMessage(message) {
            $rootScope.loadingProgress = false;
            $mdToast.show({
                template: '<md-toast layout="column" layout-align="center start"><div class="md-toast-content" style="background-color: red">'
                    + message + '</div></md-toast>',
                hideDelay: 5000,
                position: 'top right'
            });
        }

    }
})();

(function () {
    'use strict';
    angular
        .module('app.expenseSettlement.settlement')
        .controller('SettlementInvoiceEditorController', SettlementInvoiceEditorController);
    /** @ngInject */
    function SettlementInvoiceEditorController($rootScope, $state, api, $mdToast, $mdDialog, InvoicePurchase, $filter,
        $log, PreviousState, $stateParams, $timeout, STATUS_CODES, $sce, $templateRequest, REGEX_UUID, MessageService) {

        var vm = this;

        document.addEventListener("mousewheel", function (event) {
            if (document.activeElement.type === "number") {
                document.activeElement.blur();
            }
        });
        vm.regexUUID = REGEX_UUID;

        //Data
        vm.userInfo = angular.copy($rootScope.account);
        vm.company = $rootScope.bsCircle.company;
        vm.fiscalNumberTitle = vm.company.country.name === "Honduras" ? "RTN" : "NIT";
        vm.showNrcInput = vm.company.country.name === 'El Salvador';
        $log.debug('vm.company:');
        $log.debug(vm.company);
        vm.invoicePurchaseType = $stateParams.type;
        vm.URLPHOTOS = api.baseUrlPhotos;
        $rootScope.loadingProgress = false;
        vm.invoicePurchaseDetails = [];
        vm.invoicePurchase = {};
        vm.invoicePurchaseDetail = {};
        vm.settlementDetailId = $stateParams.detail;
        vm.invoicePurchase.dateInvoicePurchase = new Date();
        vm.sendInvoice = false;
        vm.autoriceInvoice = false;
        vm.seeColumn = true;
        vm.showMore = true;
        vm.filesToUpload = [];
        vm.filesPurchase = [];
        vm.pettyCashGeneralSets = {};
        vm.detailsExtraAuthorization = [];
        vm.regime = {};
        vm.document = { documentType: {} };
        vm.invoiceSeriesDocumentType = null;
        vm.invoiceSerieDocumentType = null;
        vm.isExtraAuthorizer = $rootScope.bsCircle.name === 'ROLE_EXTRA_AUTORIZADOR_LIQUIDACIONES' ? true : false;
        vm.today = new Date();
        vm.validateRegime = validateRegime;
        vm.validateNrc = validateNrc;
        vm.viewUuid = false;
        vm.viewNrc = false;
        vm.nrc = {};
        vm.showFelSV = false;
        vm.electronicSignatureTitle = 'INVOICE.INVOICE_PURCHASE.ELECTRONIC_SIGNATURE';
        vm.uuidTitle = 'INVOICE.INVOICE_PURCHASE.UUID';
        vm.uuidErrorTitle = 'INVOICE.ERROR.FIELD_REQUIRED_PATTERN';

        vm.details = [];
        vm.productBudget = {};
        var budgetsTemplate = null;

        vm.three_hundred = 300;

        vm.detailToAuthorize = [];
        vm.gridOptions = {
          columnDefs: [],
          suppressContextMenu: true,
          rowSelection: 'multiple',
          suppressRowClickSelection: true,
          angularCompileRows: true,
          angularCompileHeaders: true,
          enableColResize: true,
          rowData: [],
          rowHeight: 50,
          pinnedBottomRowData: []
        };
      vm.reserveBudgetBySettlement = reserveBudgetBySettlement;
        vm.dtOptions = {
            dom: 'rt<"top"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            columnDefs: [
                // Target the id column
                { targets: 0 },
                // Target the actions column
                { targets: 4, responsivePriority: 1, filterable: false, sortable: false }
            ], bInfo: false, paging: false, responsive: true
        };

        //Methods
        vm.findDocument = findDocument;
        vm.createBasicCompany = createBasicCompany;
        vm.saveInvoicePurchase = saveInvoicePurchase;
        vm.updateInvoicePurchase = updateInvoicePurchase;
        vm.editDetail = editDetail;
        vm.deleteDetail = deleteDetail;
        vm.updateTotalSettlement = updateTotalSettlement;
        vm.closeThread = closeThread;
        vm.viewIMG = viewIMG;
        vm.querySearch = querySearch;
        vm.addSerieToCompany = addSerieToCompany;
        vm.changeInvoice = changeInvoice;
        vm.canEditExchangeRate = true;
        vm.changeExchangeRate = changeExchangeRate;
        vm.addRegimeToCompany = addRegimeToCompany;
        vm.updateCompanyIsExternalProvider = updateCompanyIsExternalProvider;
        vm.useExternalProviders = false;

        vm.dimensionCompanyDetail3 = null;
        vm.dimensionCompanyDetail4 = null;
        vm.dimensionCompanyDetail5 = null;
        const EIGTH_HUNDRED_TIME_OUT = 800;
        vm.validateByExternalProvider = false;

        function addDay(date, day) {
            date.setDate(date.getDate() + day);
            return date;
        }

        init();
        function init() {
            api.ComprasWS.Settlement.Settlement.get({ id: $stateParams.settlement }).$promise.then(function (response) {
                vm.settlement = response;
                getDimensionCompany();
                if (vm.settlement.settlementStatus.name !== 'Ingresando') {
                    vm.dtOptions.columnDefs[1].targets = vm.dtOptions.columnDefs[1].targets - 1;
                }
                api.ComprasWS.pettyCash.get({ id: vm.settlement.pettyCash.id, circle: $rootScope.bsCircle.id }).$promise.then(function (response) {
                    vm.pettyCash = response;
                  if ($stateParams.settlementDetailId) {
                    api.ComprasWS.SettlementDetail.query({id: $stateParams.settlementDetailId}).$promise.then(function (response) {
                      vm.settlementDetail = response;
                    }, function () {
                    });
                  }
                    api.ComprasWS.pettyCashGeneralSets.getByPettyCashType(
                        {
                            id: 'byPettyCashType',
                            pettyCashTypeId: vm.pettyCash.pettyCashType.id, idCircle: $rootScope.bsCircle.id
                        }).$promise.then(function (response) {
                            if (response.id) {
                                vm.pettyCashGeneralSets = response;
                                vm.useExternalProviders = vm.pettyCashGeneralSets.useExternalProviders && vm.invoicePurchaseType === 'INV';
                              if (vm.pettyCashGeneralSets.askForBudget) {
                                validateHasBudgetApplication(vm.pettyCashGeneralSets.company.id);
                              }else{
                                $timeout(function (){
                                  getInvoice();
                                },300);
                              }
                            } else {
                              $timeout(function (){
                                getInvoice();
                              },300);
                            }
                        }, function (error) {
                            $log.error(error.data);
                        });
                }, function (error) {
                    $log.error(error.data);
                });

                vm.today = new Date(vm.settlement.pettyCash.dueDate);

                getAmountAvailable();

                if (InvoicePurchase && vm.invoicePurchase.currency.id === vm.settlement.pettyCash.currency.id) {
                    vm.canEditExchangeRate = false;
                }
                $rootScope.loadingProgress = false;
            }, function (error) {
                $log.error(error.data);
                $rootScope.loadingProgress = false;
            });
            getDocumentTypes();
        }

        function changeInvoice() {
            if (vm.invoicePurchase.id) {
                vm.invoicePurchase = {
                    id: vm.invoicePurchase.id,
                    dateInvoicePurchase: vm.invoicePurchase.dateInvoicePurchase,
                    dateInvoiceAccounting: vm.invoicePurchase.dateInvoicePurchase,
                    documentTotalAfterTax: 0,
                    documentTotalBeforeTax: 0,
                    totalAfterTax: 0,
                    totalBeforeTax: 0,
                    companyBuyer: { id: vm.invoicePurchase.companyBuyer.id },
                    files: vm.invoicePurchase.files,
                    purchaseStatus: { description: 'Ingresando' },
                    currency: vm.invoicePurchase.currency,
                    exchangeRate: vm.invoicePurchase.exchangeRate,
                    invoiceSerie: null
                };
            } else {
                vm.invoicePurchase = {};
            }
            vm.showMore = false;
        }

        function formatInvoiceSerie(countryProvider) {

            if (countryProvider.name === "Honduras") {
                if (vm.pettyCash && vm.pettyCash.pettyCashType.name !== "IMPORT") {
                    countryProvider.taxRegex =
                        /^[a-zA-Z\d]{6}[-][a-zA-Z\d]{6}[-][a-zA-Z\d]{6}[-][a-zA-Z\d]{6}[-][a-zA-Z\d]{6}[-][a-zA-Z\d]{2}[-][0-9]{3}[-][0-9]{3}[-][0-9]{2}[-]$/g;
                } else {
                    //DIFEL01-001
                    countryProvider.taxRegex =
                        /^[a-zA-Z\d]{6}[-][a-zA-Z\d]{6}[-][a-zA-Z\d]{6}[-][a-zA-Z\d]{6}[-][a-zA-Z\d]{6}[-][a-zA-Z\d]{2}[-][0-9]{3}[-][0-9]{3}[-][0-9]{2}[-]|[a-zA-Z\-\d]{1,20}$/g;
                }
                countryProvider.taxRegexSample = "7EDDAD-FD2FD8-D94697-8944DC-720AF5-04-000-007-01-";
                countryProvider.fiscalNumberTitle = "RTN";
            } else {
                countryProvider.taxRegex = /^[a-zA-Z\-\d]{1,25}$/g;
                countryProvider.taxRegexSample = "A u 11 ó FACE-63-JMFC1-1";
                countryProvider.fiscalNumberTitle = "NIT";
            }
        }

        function nitIsValid(nit) {
            if (!nit) {
                return true;
            }

            var nitRegExp = new RegExp('^[0-9]+(-?[0-9kK])?$');

            if (!nitRegExp.test(nit)) {
                return false;
            }

            nit = nit.replace(/-/, '');
            var lastChar = nit.length - 1;
            var number = nit.substring(0, lastChar);
            var expectedCheker = nit.substring(lastChar, lastChar + 1).toLowerCase();

            var factor = number.length + 1;
            var total = 0;

            for (var i = 0; i < number.length; i++) {
                var character = number.substring(i, i + 1);
                var digit = parseInt(character, 10);

                total += (digit * factor);
                factor = factor - 1;
            }

            var modulus = (11 - (total % 11)) % 11;
            var computedChecker = (modulus === 10 ? "k" : modulus.toString());

            return expectedCheker === computedChecker;
        }

        function getDocumentTypes() {
            api.GeneralWS.DocumentType.getAll({ id: vm.company.country.id, category: 'COMPANY' }).$promise.then(function (response) {
                for (var i = 0; i < response.length; i++) {
                    if (vm.fiscalNumberTitle === response[i].name) {
                        vm.document.documentType = response[i];
                        break;
                    }
                }
            }, function (errResponse) {
                $log.error(errResponse.data);
            });
        }
        ///

        function findDocument(document) {
            if (vm.document.documentType.documentTypeFormat !== null) {
                var documentFormat;
                if (vm.pettyCash && vm.pettyCash.pettyCashType.name === "IMPORT" && vm.company.country.name === "Guatemala") {
                    documentFormat = /^(\d+\-[\dk]|[\d]{3})$/g;
                } else {
                    documentFormat = new RegExp(vm.document.documentType.documentTypeFormat, 'g');
                }
                if (documentFormat.test(document)) {
                    if (vm.company.country.name === "Guatemala" && document.indexOf('-') !== -1) {
                        if (nitIsValid(document)) {
                            findDocumentValid(document);
                        } else {
                            invalidDocumentMsg('SETTLEMENT.INVOICE.COMPANY_DOCUMENT_INVALID');
                        }
                    } else {
                        findDocumentValid(document);
                    }
                } else {
                    invalidDocumentMsg('SETTLEMENT.INVOICE.COMPANY_DOCUMENT_INCORRECT_FORMAT');
                }
            } else {
                findDocumentValid(document);
            }
        }

        function invalidDocumentMsg(translate) {
            var example = '';
            if (vm.fiscalNumberTitle === 'NIT') {
                if (vm.pettyCash && vm.pettyCash.pettyCashType.name === "IMPORT") {
                    example = '7896169-6, 3069715-k ó 031';
                } else {
                    example = '7896169-6 ó 3069715-k';
                }
            }
            showErrorMessage($filter('translate')(translate) + example);
        }

        function findDocumentValid(document) {
            vm.regime = {};
            api.GeneralWS.CompanyDocumentSettlementByDocument.get({ id: vm.company.id, number: document }).$promise.then(function (response) {
                vm.document = response.document;
                api.GeneralWS.CompanyByDocument.getByDocument({ documentId: vm.document.id }).$promise.then(function (response) {
                    getNrc(response.id);
                    getRegimeProvider(response.id);
                    vm.invoicePurchase.companyProvider = response;
                    vm.validateByExternalProvider = true;
                    $log.debug("vm.invoicePurchase.companyProvider:");
                    $log.debug(vm.invoicePurchase.companyProvider);
                    vm.countryProvider = angular.copy(vm.invoicePurchase.companyProvider.country);
                    formatInvoiceSerie(vm.countryProvider);
                    vm.showMore = true;
                    getSeries();
                    getAllRegimes();
                }, function (error) {
                    $rootScope.loadingProgress = false;
                    $log.error(error.data);
                });
            }, function (error) {
                $rootScope.loadingProgress = false;
                if (error.data === "Document not found") {
                    var confirm = $mdDialog.confirm()
                        .title($filter('translate')('SETTLEMENT.COMPANY.DOCUMENT.DOCUMENT_NOT_EXIST'))
                        .htmlContent(document + $filter('translate')('SETTLEMENT.COMPANY.DOCUMENT.DOCUMENT_NOT_ASSOCIATED'))
                        .ariaLabel("Document not found")
                        .ok($filter('translate')('SETTLEMENT.OK'))
                        .cancel($filter('translate')('SETTLEMENT.CANCEL'));
                    $mdDialog.show(confirm).then(function () {
                        createBasicCompany(document);
                    });
                }
            });
        }

      /**
       * Obtiene el documento de tipo NRC en el caso de que sea el pais el salvador
       * @param companyId id de la empresa
       */
      function getNrc(companyId) {
        if (!vm.showNrcInput) {
          return;
        }

        api.GeneralWS.CompanyDocumentActive.getAll({id: companyId}).$promise.then(function (response) {
          for (var i = 0; i < response.length; i++) {
            if (response[i].document.documentType.name === 'NRC') {
              vm.documentNRC = response[i].document;
              break;
            }
          }
        });
      }

        function createBasicCompany(data) {
            var detail = angular.copy(data);
            $mdDialog.show({
                controller: 'createBasicCompanyController',
                controllerAs: 'vm',
                locals: {
                    data: detail,
                    company: '',
                    settlementId: vm.settlement.id,
                    companyBuyer: vm.company,
                    titleFiscal: vm.fiscalNumberTitle
                },
                templateUrl: 'app/main/apps/expenseSettlements/settlements/details/invoiceEditor/companyEditor/companyEditor.html',
                parent: angular.element("#main"),
                clickOutsideToClose: false
            }).then(function (answer) {
                $rootScope.loadingProgress = false;
                vm.invoicePurchase.companyProvider = answer;
                vm.countryProvider = angular.copy(vm.invoicePurchase.companyProvider.country);
                formatInvoiceSerie(vm.countryProvider);
                getDocumentByCompanyProvider(vm.invoicePurchase.companyProvider);
                getSeries();
                getAllRegimes();
                getNrc(answer.id);
                vm.showMore = true;
            }, function () {
                $rootScope.loadingProgress = false;
            });
        }

        function getDocumentTypeSeries() {
            var invoiceSerieTypeCode;
            switch (vm.invoicePurchaseType) {
                case 'CFISCAL':
                    invoiceSerieTypeCode = 'INVOICE_CREDIT_FISCAL';
                    break;
                case 'TCK':
                    invoiceSerieTypeCode = 'INVOICE_TICKET';
                    break;
                default:
                    invoiceSerieTypeCode = 'INVOICE';
                    break;
            }
            api.GeneralWS.InvoiceSeriesDocumentType.query({ companyId: vm.invoicePurchase.companyProvider.id }).$promise.then(function (response) {
                var resp = response
                    .filter(function (rp) { return rp.code === invoiceSerieTypeCode });
                if (resp.length > 0) {
                    vm.invoiceSerieDocumentType = resp[0];
                }
                vm.invoiceSeriesDocumentType = response;
                loadSeries();
            }, function (errResponse) {
              $rootScope.loadingProgress = false;
            });
        }

        function addSerieToCompany(event, serie, company) {
            $log.debug("serie: " + serie);
            //valida formato serie
            $log.debug("vm.countryProvider.taxRegex: ");
            $log.debug(vm.countryProvider.taxRegex);
            $log.debug(vm.countryProvider.taxRegexSample);
            var re = new RegExp(vm.countryProvider.taxRegex);

            if (re.test(serie)) {

                if (event) {
                    event.stopPropagation();
                }
                var confirm = $mdDialog.confirm()
                    .title($filter('translate')("SETTLEMENT.COMPANY.ASSOCIATE_SERIE"))
                    .content($filter('translate')('SETTLEMENT.COMPANY.MSG_SURE_ASSOCIATE_SERIE'))
                    .ariaLabel('Add serie')
                    .ok($filter('translate')('SETTLEMENT.OK'))
                    .cancel($filter('translate')('SETTLEMENT.CANCEL'));
                $mdDialog.show(confirm).then(function () {
                  goToAddSerieToCompany(serie, company);
                }, function () {
                    // Cancel Action
                });
            } else {
                showErrorMessage($filter('translate')("SETTLEMENT.COMPANY.ERROR_INVALID_FORMAT_SERIE") + vm.countryProvider.taxRegexSample);
            }
        }

        function goToAddSerieToCompany(serie, company) {
          $rootScope.loadingProgress = true;
          var invoiceSerie = {
              id: 0,
              company: {
                  id: company.id
              },
              invoiceSerieDocumentType: vm.invoiceSerieDocumentType.id,
              serie: serie
          };
          api.GeneralWS.CreateBasicSerieNotBlocked.create({ idCircle: $rootScope.bsCircle.company.id }, invoiceSerie, function (data) {
              vm.invoicePurchase.invoiceSerie = data;
              vm.exist = true;
              showMessage($filter('translate')('SETTLEMENT.COMPANY.ASSOCIATED_SERIE'));
              $rootScope.loadingProgress = false;
          }, function (errResponse) {
              var message;
              if (errResponse.data === 'sierieBloqueda') {

                  message = 'SETTLEMENT.COMPANY.SERIE_BLOQUEADA';
              } else {
                  message = 'SETTLEMENT.COMPANY.ERROR_ASSOCIATED_SERIE';

              }
              showErrorMessage($filter('translate')(message));
              $log.error(errResponse.data);
              $rootScope.loadingProgress = false;
          });
        }

        function addRegimeToCompany(event, regimeId, company) {
            if (event) {
                event.stopPropagation();
            }
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('SETTLEMENT.COMPANY.MSG_SURE_ASSOCIATE_REGIME'))
                .content($filter('translate')('SETTLEMENT.COMPANY.REGIME_WILL_ASSOCIATED'))
                .ariaLabel('Add regime')
                .ok($filter('translate')('SETTLEMENT.OK'))
                .cancel($filter('translate')('SETTLEMENT.CANCEL'));
            $mdDialog.show(confirm).then(function () {
                $rootScope.loadingProgress = true;
                company.regimes = [];
                var regime = _.find(vm.regimes, function (regime) {
                    return regime.id === regimeId;
                });
                company.regimes.push(regime);
                api.GeneralWS.CompanyRegime.addRegime({ id: company.id }, company, function (response) {
                    vm.regime = response.regimes[0];
                    vm.invoicePurchase.regime = vm.regime;
                    getTaxes();
                    showMessage($filter('translate')('SETTLEMENT.COMPANY.ASSOCIATED_REGIME'));
                }, function (error) {
                    $log.error(error.data);
                    $rootScope.loadingProgress = false;
                    vm.company.regimes.splice(vm.company.regimes.length - 1);
                    showErrorMessage($filter('translate')('SETTLEMENT.COMPANY.ERROR_ASSOCIATED_REGIME'));
                });
            }, function () {
                $rootScope.loadingProgress = false;
            });
        }

        vm.clearSearchRegime = function () {
            vm.searchRegime = "";
        };


        $timeout(function () {
            var keyEvent = function (event) {
                event.stopPropagation();
            };
            var searchRegimeInput = document.querySelector("#searchRegime");

            if (searchRegimeInput) {
                searchRegimeInput.addEventListener("keydown", keyEvent);
            }

        }, 500);

        var currentDate = new Date();

        vm.lastYear = new Date(currentDate.setYear(currentDate.getFullYear() - 1));

        if (InvoicePurchase) {
            vm.showMore = true;
            vm.exist = true;
            vm.invoicePurchase = InvoicePurchase;
            vm.invoicePurchaseType = vm.invoicePurchase.invoicePurchaseType;
            vm.invoicePurchase.dateInvoicePurchase = addDay(new Date(vm.invoicePurchase.dateInvoicePurchase), 1);
            vm.invoicePurchase.dateInvoiceAccounting = addDay(new Date(vm.invoicePurchase.dateInvoiceAccounting), 1);
            vm.countryProvider = angular.copy(vm.invoicePurchase.companyProvider.country);
            formatInvoiceSerie(vm.countryProvider);
            vm.currentRegime = angular.copy(vm.invoicePurchase.regime);
            vm.currentCurrency = angular.copy(vm.invoicePurchase.currency);
            vm.currentExchangeRate = angular.copy(vm.invoicePurchase.exchangeRate);
            vm.invoiceCopy = angular.copy(vm.invoicePurchase);
            getDetailsExtraAuthorization();
            getDocumentByCompanyProvider(vm.invoicePurchase.companyProvider);
            loadFiles(vm.invoicePurchase);
            getTaxes();
            getSeries();
        } else {
            vm.showMore = false;
        }

        function getDetailsExtraAuthorization() {
            if (vm.isExtraAuthorizer) {
                api.ComprasWS.SettlementDetails.getDetailsExtraAuthorization.getDetails(
                    { settlementDetailId: vm.settlementDetailId, circleId: $rootScope.bsCircle.id }).$promise.then(function (response) {
                        vm.detailsExtraAuthorization = response;
                    }, function (error) {
                        $log.error(error.data);
                    });
            }
        }

        getAllRegimes();
        function getAllRegimes() {
            api.GeneralWS.Regime.getAllWithTaxByCountry.get({ id: vm.company.country.id }).$promise.then(function (data) {
                vm.regimes = data;
                if (vm.regimes.length === 1 && !vm.invoicePurchase.id && !vm.regime) {
                    vm.invoicePurchase.regime = vm.regimes[0];
                    vm.taxes = vm.regimes[0].countryTaxes;
                } else if (vm.invoicePurchase.id) {
                    getTaxes();
                }
                getAllCurrencies();
                $timeout(function () {
                    validateRegime();
                }, 300);
            }, function (errResponse) {
                $rootScope.loadingProgress = false;
                $log.error(errResponse);
            });
        }

        function getRegimeProvider(companyId) {
            api.GeneralWS.Regime.getByCompany.get({ id: 'Company', companyId: companyId }).$promise.then(function (response) {
                if (response.length > 0 && !vm.invoicePurchase.id) {
                    vm.regime = response[0];
                    vm.invoicePurchase.regime = vm.regime;
                    vm.taxes = vm.regime.countryTaxes;
                } else if (response.length > 0 && InvoicePurchase && (vm.invoicePurchase.companyProvider.id !== InvoicePurchase.companyProvider.id)) {
                    if (response.length === 1) {
                        vm.regime = response[0];
                        vm.invoicePurchase.regime = vm.regime;
                        vm.taxes = vm.regime.countryTaxes;
                    }

                }
            }, function (error) {
                $log.error(error.data);
            });
        }

        function getAllCurrencies() {
            api.GeneralWS.Currency.query().$promise.then(function (response) {
                $rootScope.loadingProgress = true;
                vm.currencies = response;
                if (vm.currencies.length > 0 && !InvoicePurchase && vm.settlement) {
                    vm.invoicePurchase.currency = vm.settlement.pettyCash.currency;
                } else if (vm.currencies.length > 0 && InvoicePurchase && (InvoicePurchase.companyProvider.id !== vm.invoicePurchase.companyProvider.id)) {
                    vm.invoicePurchase.currency = vm.settlement.pettyCash.currency;
                }
                $rootScope.loadingProgress = false;
            }, function (errResponse) {
                $rootScope.loadingProgress = false;
                $log.error(errResponse);
            });
        }

        function getTaxes() {
            if (vm.invoicePurchase.companyProvider) {
                if (vm.invoicePurchase.regime && vm.invoicePurchase.regime.id) {
                    var regime = _.find(vm.regimes, function (regime) {
                        return regime.id === vm.invoicePurchase.regime.id;
                    });
                    vm.taxes = regime ? regime.countryTaxes : [];
                }
            }
        }

        function getSeries() {
            if (vm.invoiceSeriesDocumentType) {
                loadSeries();
            } else {
                getDocumentTypeSeries();
            }
        }

        function filterSeries(series) {
            var seriesChanged = series
                .map(function(mp){
                    if (mp.invoiceSerieDocumentType >= 0) {
                        return mp;
                    }
                    mp.invoiceSerieDocumentType = 0;
                    return mp;
                })
                .filter(function (sr) { return sr.invoiceSerieDocumentType === vm.invoiceSerieDocumentType.id });
            return seriesChanged;
        }

        function loadSeries() {
            if (vm.invoicePurchase.companyProvider) {
                $rootScope.loadingProgress = true;
                api.GeneralWS.InvoiceSeries.getByCompany({ companyId: vm.invoicePurchase.companyProvider.id }).$promise.then(function (response) {
                    vm.series = filterSeries(response);
                    if (!InvoicePurchase) {
                        if (vm.series.length === 1) {
                            vm.invoicePurchase.invoiceSerie = vm.series[0];
                        }
                    } else if (InvoicePurchase.companyProvider.id !== vm.invoicePurchase.companyProvider.id) {
                        if (vm.series.length === 1) {
                            vm.invoicePurchase.invoiceSerie = vm.series[0];
                        } else {
                            vm.invoicePurchase.invoiceSerie = {};
                        }
                    }
                    if (vm.validateByExternalProvider) {
                      processToCompanyIsExternalProvider();
                    }
                    $rootScope.loadingProgress = false;
                }, function (error) {
                    $rootScope.loadingProgress = false;
                    $log.error(error.data);
                });
            }
        }

        function loadFiles(invoice) {
            api.ComprasWS.InvoicePurchaseFiles.get({ id: invoice.id }, function (response) {// Success
                vm.invoicePurchase.files = response;
                vm.filesPurchase = response;
            }, function (response) {// Error
                $log.error(response);
                vm.loading = false;
                $rootScope.loadingProgress = false;
            });
        }

        function viewIMG(file) {
            $mdDialog.show({
                controller: 'DialogPhotoController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/files/dialogPhoto/dialogPhoto.html',
                parent: angular.element("#main"),
                name: file.originalName,
                url: vm.URLPHOTOS + file.parentPath + file.name + file.extension,
                clickOutsideToClose: false
            }).then(function (answer) {
            });
        }

        function loadDetails(invoice) {
            api.ComprasWS.InvoicePurchaseDetail.byInvoice(
                { id: 'byInvoicePurchase', invoiceId: invoice.id, idCircle: $rootScope.bsCircle.id }, function (response) {
                    vm.details = response;
                    loadDetailsDto(invoice);
                    $log.debug("vm.details");
                    $log.debug(vm.details);
                vm.showButton = false;
                  setColumnsToGrid();
                  if (vm.details.length > 0) {
                    $timeout(function (){
                      vm.gridOptions.api.setRowData(vm.details);
                    },400);
                  }
                }, function (error) {
                    $log.error(error.data);
                });
        }

        function loadDetailsDto(invoice) {
            api.ComprasWS.InvoicePurchaseDetail.getDtoByInvoice(
                { id: 'getInvoiceDetailsWithTaxes', invoiceId: invoice.id, idCircle: $rootScope.bsCircle.id }).$promise.then(function (response) {
                    vm.detailsDto = response;
                    $log.debug("vm.detailsDto");
                    $log.debug(vm.detailsDto);
                }, function (error) {
                    $log.error(error.data);
                });
        }

        function getDocumentByCompanyProvider(companyProvider) {
            api.GeneralWS.DocumentByCompany.getByCompany({ companyId: companyProvider.id }).$promise.then(function (response) {
                vm.document = response;
            }, function (error) {
                $log.error(error.data);
            });
        }

        function saveInvoicePurchase() {
            $rootScope.loadingProgress = true;
            if (vm.invoicePurchase.uuid) {
              vm.invoicePurchase.uuid = vm.invoicePurchase.uuid.toUpperCase();
            }
            vm.newInvoicePurchase = {
                correlative: vm.invoicePurchase.correlative,
                dateInvoicePurchase: vm.invoicePurchase.dateInvoicePurchase.getTime(),
                dateInvoiceAccounting: vm.invoicePurchase.dateInvoicePurchase.getTime(),
                documentTotalAfterTax: 0,
                documentTotalBeforeTax: 0,
                totalAfterTax: 0,
                totalBeforeTax: 0,
                companyCurrency: vm.settlement.pettyCash.currency,
                exchangeRate: vm.invoicePurchase.exchangeRate,
                companyBuyer: {
                    id: vm.company.id
                },
                companyProvider: {
                    id: vm.invoicePurchase.companyProvider.id
                },
                regime: {
                    id: vm.invoicePurchase.regime.id
                },
                currency: {
                    id: vm.invoicePurchase.currency.id
                },
                purchaseStatus: {
                    description: STATUS_CODES.InvoicePurchase.Ingresando
                },
                invoicePurchaseType: vm.invoicePurchaseType,
                invoiceSerie: vm.invoicePurchase.invoiceSerie ? {
                    id: vm.invoicePurchase.invoiceSerie.id
                } : null,
                originType: {
                    originTypeCode: 11
                },
                electronicSignature: vm.invoicePurchase.electronicSignature,
                controlNumber: vm.invoicePurchase.controlNumber,
                uuid:vm.invoicePurchase.uuid
            };
            if (vm.filesToUpload.length > 0) {
                var files = [];
                vm.filesToUpload.forEach(function (r) {
                    files.push(r.file.file);
                });
                $rootScope.loadingProgress = true;
                api.GeneralWS.Common.FileStorage.filesUpload.add({ 'companyId': $rootScope.bsCircle.company.id }, files).then(function (response) {
                    $rootScope.loadingProgress = false;
                    vm.invoicePurchase.files = response.data;
                    vm.newInvoicePurchase.files = response.data;
                    vm.filesPurchase = response.data;
                    save();
                }, function (errResponse) {
                    $log.error(errResponse);
                    $rootScope.loadingProgress = false;
                });
            } else {
                save();
            }
        }

        function save() {
            $rootScope.loadingProgress = true;
            $log.debug("vm.invoicePurchase before save:");
            $log.debug(vm.invoicePurchase);

            //obtiene deducible para seguir con la grabacion
            $rootScope.loadingProgress = true;
            var accountingDate = new Date(vm.newInvoicePurchase.dateInvoiceAccounting);
            accountingDate = accountingDate.getFullYear() + '-' + (accountingDate.getMonth() + 1) + '-' + accountingDate.getDate();
            api.ComprasWS.SettlementDetails.Deductible.getDeductible(
                { circleId: $rootScope.bsCircle.id, accountingDate: accountingDate }).$promise.then(function (response) {
                    $rootScope.loadingProgress = false;
                    var deductible = response;
                    $log.debug("Deducibles obtenidos");
                    $log.debug(deductible);

                    api.ComprasWS.InvoicePurchase.save({ idCircle: $rootScope.bsCircle.id }, vm.newInvoicePurchase).$promise.then(function (invoicePurchase) {
                        $rootScope.loadingProgress = false;
                        vm.invoicePurchase.id = invoicePurchase.id;
                        vm.invoicePurchase.companyBuyer = invoicePurchase.companyBuyer;
                        vm.currentRegime = invoicePurchase.regime;
                        vm.currentCurrency = invoicePurchase.currency;
                        vm.currentExchangeRate = invoicePurchase.exchangeRate;
                        vm.invoiceCopy = invoicePurchase;

                        $log.debug("vm.invoicePurchase after save:");
                        $log.debug(vm.invoicePurchase);
                        if (vm.invoicePurchaseType === 'INV') {
                            showMessage($filter('translate')('SETTLEMENT.TYPE_' + vm.invoicePurchaseType)
                                + " " + $filter('translate')('SETTLEMENT.CREATE_SUCCESSFULLY'));
                        } else {
                            showMessage($filter('translate')('SETTLEMENT.TYPE_' + vm.invoicePurchaseType)
                                + " " + $filter('translate')('SETTLEMENT.CREATE_SUCCESSFULLY2'));
                        }
                        vm.filesToUpload = [];
                        //Asociar a liquidación
                        createSettlementDetail(vm.invoicePurchase, deductible);
                    }, function (errResponse) {
                        $rootScope.loadingProgress = false;
                        if (errResponse.data === 'INVOICE.MSG.EXIST_INVOICE') {
                            showErrorMessage($filter('translate')("SETTLEMENT.INVOICE.EXISTING_INVOICE"));
                        } else {
                            if (vm.invoicePurchaseType === 'INV') {
                                showMessage($filter('translate')('SETTLEMENT.ERROR_CREATED')
                                    + " " + $filter('translate')('SETTLEMENT.TYPE_' + vm.invoicePurchaseType));
                            } else {
                                showMessage($filter('translate')('SETTLEMENT.ERROR_CREATED2')
                                    + " " + $filter('translate')('SETTLEMENT.TYPE_' + vm.invoicePurchaseType));
                            }
                        }
                        $log.error(errResponse.data);
                    });
                }, function (error) {
                    $rootScope.loadingProgress = false;
                    if (error.data === "CURRENT_FISCAL_PERIOD_NOTFOUND") {
                        showErrorMessage($filter('translate')("SETTLEMENT.CURRENT_FISCAL_PERIOD_NOTFOUND"));
                    } else if (error.data === "DOCUMENT_FISCAL_PERIOD_NOTFOUND") {
                        showErrorMessage($filter('translate')("SETTLEMENT.DOCUMENT_FISCAL_PERIOD_NOTFOUND"));
                    } else {
                        $log.error(error);
                    }
                });
        }

        function createSettlementDetail(invoice, deductible) {
            if (invoice) {
                var newDetail = {
                    id: 0,
                    invoicePurchase: {
                        id: invoice.id
                    },
                    settlement: {
                        id: vm.settlement.id
                    }
                };
                if (deductible) {
                    newDetail.expenseDeductible = deductible.expenseDeductible;
                    newDetail.taxDeductible = deductible.taxDeductible;
                } else {
                    newDetail.expenseDeductible = false;
                    newDetail.taxDeductible = false;
                }
                $rootScope.loadingProgress = true;
                api.ComprasWS.SettlementDetail.create({ id: '' }, newDetail).$promise.then(function (response) {
                    $rootScope.loadingProgress = false;
                    getTaxes();
                    vm.settlementDetailId = response.id;
                    $log.debug("Detalle de liquidación creado");
                    $log.debug(response);
                }, function (error) {
                    $rootScope.loadingProgress = false;
                    $log.error(error.data);
                });
            }
        }

        function updateInvoicePurchase() {
            $rootScope.loadingProgress = true;
            if (vm.filesToUpload.length > 0) {
                var files = [];
                vm.filesToUpload.forEach(function (r) {
                    files.push(r.file.file);
                });
                api.GeneralWS.Common.FileStorage.filesUpload.add({ 'companyId': $rootScope.bsCircle.company.id }, files).then(function (response) {
                    $rootScope.loadingProgress = false;
                    vm.invoicePurchase.files = response.data;
                    update();
                }, function (errResponse) {
                    $log.error(errResponse);
                    $rootScope.loadingProgress = false;
                });

            } else {
                update();
            }
        }

      function verifyStatusAndUUID() {
        if (!vm.invoicePurchase.purchaseStatus) {
          vm.invoicePurchase.purchaseStatus = { description: STATUS_CODES.InvoicePurchase.Ingresando };
        }
        if (vm.invoicePurchase.uuid) {
          vm.invoicePurchase.uuid = vm.invoicePurchase.uuid.toUpperCase();
        }
        return vm.invoicePurchase;
      }

      function update() {
            vm.invoicePurchase.invoiceSerie = vm.invoicePurchase.invoiceSerie ? { id: vm.invoicePurchase.invoiceSerie.id } : null;
            vm.invoicePurchase.companyCurrency = { id: vm.settlement.pettyCash.currency.id };
            $log.debug("vm.invoicePurchase before save:");
            $log.debug(vm.invoicePurchase);
            vm.invoicePurchase=verifyStatusAndUUID();
            api.ComprasWS.InvoicePurchase.update(
                { id: vm.invoicePurchase.id, idCircle: $rootScope.bsCircle.id }, vm.invoicePurchase).$promise.then(function (invoicePurchase) {
                    vm.invoicePurchase.id = invoicePurchase.id;
                    vm.invoicePurchase.companyBuyer = invoicePurchase.companyBuyer;
                    vm.invoicePurchase.invoiceSerie = invoicePurchase.invoiceSerie;
                    if (vm.invoicePurchaseType === 'INV') {
                        showMessage($filter('translate')('SETTLEMENT.TYPE_' + vm.invoicePurchaseType)
                            + " " + $filter('translate')('SETTLEMENT.UPDATE_SUCCESSFULLY'));
                    } else {
                        showMessage($filter('translate')('SETTLEMENT.TYPE_' + vm.invoicePurchaseType)
                            + " " + $filter('translate')('SETTLEMENT.UPDATE_SUCCESSFULLY2'));
                    }
                    if (vm.currentRegime.id !== vm.invoicePurchase.regime.id || //Régimen diferente
                        vm.currentCurrency.id !== vm.invoicePurchase.currency.id || //Moneda diferente
                        vm.invoiceCopy.dateInvoicePurchase !== vm.invoicePurchase.dateInvoicePurchase || //Fecha diferente
                        vm.currentExchangeRate !== vm.invoicePurchase.exchangeRate) { //tasa diferente

                        if (vm.details && vm.details.length > 0) {
                            api.ComprasWS.InvoicePurchaseChange.changeDetails(
                                { id: vm.invoicePurchase.id, idCircle: $rootScope.bsCircle.id }).$promise.then(function (response) {
                                    vm.invoiceCopy = response;
                                    vm.invoicePurchase.totalAfterTax = response.totalAfterTax;
                                    updateTotalSettlement();
                                    showMessage($filter('translate')('SETTLEMENT.INVOICE.CALCULATE_TAXES'));
                                }, function (error) {
                                    showErrorMessage($filter('translate')('SETTLEMENT.INVOICE.ERROR_CALCULATE_TAXES'));
                                    $log.error(error);
                                });
                        }
                    }
                    vm.currentRegime = invoicePurchase.regime;
                    vm.currentCurrency = invoicePurchase.currency;
                    vm.currentExchangeRate = invoicePurchase.exchangeRate;
                    $log.debug("vm.invoicePurchase after save:");
                    $log.debug(vm.invoicePurchase);
                    getInvoice();
                    getTaxes();
                    vm.filesToUpload = [];
                    $rootScope.loadingProgress = false;

                }, function (errResponse) {
                    getSeries();
                    if (vm.invoicePurchaseType === 'INV') {
                        showMessage($filter('translate')('SETTLEMENT.ERROR_UPDATED') + " " + $filter('translate')('SETTLEMENT.TYPE_' + vm.invoicePurchaseType));
                    } else {
                        showMessage($filter('translate')('SETTLEMENT.ERROR_UPDATED2') + " " + $filter('translate')('SETTLEMENT.TYPE_' + vm.invoicePurchaseType));
                    }
                    $log.error(errResponse);
                });
        }

        vm.changeCurrencyOrDate = function (currency, dateInvoice) {
            if (currency && dateInvoice) {
                if (typeof (dateInvoice) === "number") {
                    dateInvoice = new Date(dateInvoice);
                }
                if (currency.id === vm.pettyCash.currency.id) {
                    vm.canEditExchangeRate = false;
                    vm.invoicePurchase.exchangeRate = 1;
                } else {

                    $log.debug("vm.invoicePurchase:");
                    $log.debug(vm.invoicePurchase);

                    var exchange = {
                        sourceCurrency: {
                            id: currency.id
                        },
                        targetCurrency: {
                            id: vm.settlement.pettyCash.currency.id
                        },
                        rateDate: dateInvoice.getTime(),
                        rate: 0,
                        id: 0
                    };
                    api.GeneralWS.ExchangeRate.getDayExchangeRate({ idCircle: $rootScope.bsCircle.id }, exchange).$promise.then(function (response) {
                        vm.canEditExchangeRate = true;
                        vm.invoicePurchase.exchangeRate = response.rate;
                        if (vm.invoicePurchase.id && (vm.detailsDto && vm.detailsDto.length > 0)) {
                            var total = vm.invoiceCopy.documentTotalAfterTax * vm.invoicePurchase.exchangeRate;
                            if (total > vm.pettyCashGeneralSets.maxAmountByDocument) {
                                showErrorMessage($filter('translate')('SETTLEMENT.INVOICE.MAX_AMOUNT_BY_PETTY_TYPE') + vm.settlement.pettyCash.currency.symbol +
                                    toFixedNumber(vm.pettyCashGeneralSets.maxAmountByDocument, 2)
                                    + $filter('translate')('SETTLEMENT.INVOICE.MAX_AMOUNT_BY_PETTY_TYPE2'));
                                vm.invoicePurchase.currency = vm.currentCurrency;
                                vm.invoicePurchase.dateInvoicePurchase = vm.invoiceCopy.dateInvoicePurchase;
                                getAmountAvailable();
                            } else {
                                vm.amountAvailable = vm.amountAvailable + vm.invoicePurchase.totalAfterTax;
                                if (!vm.pettyCash.pettyCashType.allowOverSpend
                                    && vm.settlement.pettyCash.amount > 0 && (total > vm.amountAvailable)) {
                                    showErrorMessage($filter('translate')('SETTLEMENT.TOTAL_SETTLEMENTS_EXCEEDS_UPDATING_INVOICE')
                                        + vm.settlement.pettyCash.currency.symbol
                                        + toFixedNumber(vm.settlement.pettyCash.amount, 2)
                                        + $filter('translate')('SETTLEMENT.TOTAL_SETTLEMENTS_EXCEEDS_UPDATING_INVOICE2'));
                                    vm.invoicePurchase.currency = vm.currentCurrency;
                                    vm.invoicePurchase.dateInvoicePurchase = vm.invoiceCopy.dateInvoicePurchase;
                                    getAmountAvailable();
                                }
                            }
                        }
                    }, function (error) {
                        vm.canEditExchangeRate = true;
                        vm.invoicePurchase.exchangeRate = null;
                        vm.invoicePurchase.totalAfterTax = null;
                        vm.invoicePurchase.totalBeforeTax = null;
                        $log.debug(error.data);
                    });
                }
            }
        };

        function changeExchangeRate(exchangeRate) {
            if (exchangeRate) {
                if (vm.invoicePurchase.id && (vm.detailsDto && vm.detailsDto.length > 0)) {
                    if (vm.currentExchangeRate !== exchangeRate) {
                        var total = vm.invoiceCopy.documentTotalAfterTax * exchangeRate;
                        if (total > vm.pettyCashGeneralSets.maxAmountByDocument) {
                            showErrorMessage($filter('translate')('SETTLEMENT.INVOICE.MAX_AMOUNT_BY_PETTY_TYPE') + vm.settlement.pettyCash.currency.symbol +
                                toFixedNumber(vm.pettyCashGeneralSets.maxAmountByDocument, 2)
                                + $filter('translate')('SETTLEMENT.INVOICE.MAX_AMOUNT_BY_PETTY_TYPE2'));
                            vm.invoicePurchase.regime = vm.currentRegime;
                            getAmountAvailable();
                        } else {
                            vm.amountAvailable = vm.amountAvailable + vm.invoicePurchase.totalAfterTax;
                            if (!vm.pettyCash.pettyCashType.allowOverSpend
                                && vm.pettyCash.amount > 0 && (total > vm.amountAvailable)) {
                                showErrorMessage($filter('translate')('SETTLEMENT.TOTAL_SETTLEMENTS_EXCEEDS_UPDATING_INVOICE')
                                    + vm.settlement.pettyCash.currency.symbol
                                    + toFixedNumber(vm.settlement.pettyCash.amount, 2)
                                    + $filter('translate')('SETTLEMENT.TOTAL_SETTLEMENTS_EXCEEDS_UPDATING_INVOICE2'));
                                vm.invoicePurchase.regime = vm.currentRegime;
                                getAmountAvailable();
                            }
                        }
                    }
                }
            }
        }

        function getAmountAvailable() {
            if (vm.settlement.pettyCash.amount > 0) {
                api.ComprasWS.Settlement.getAmountAvailable.getTotal({ id: vm.settlement.pettyCash.id }).$promise.then(function (response) {
                    vm.amountAvailable = parseFloat(response.$data);
                }, function (error) {
                    $log.error(error.data);
                });
            }
        }

        function toFixedNumber(origin, numberDecimals) {
            var toFixed = origin.toFixed(numberDecimals);
            return parseFloat(toFixed);
        }

        function updateTotalInvoicePurchase() {
            $rootScope.loadingProgress = true;
            api.ComprasWS.setTotalInvoice.setTotal({ id: vm.invoicePurchase.id, idCircle: $rootScope.bsCircle.id }).$promise.then(function (invoicePurchase) {
                vm.invoicePurchase.documentTotalAfterTax = toFixedNumber(invoicePurchase.documentTotalAfterTax, 2);
                vm.invoicePurchase.documentTotalBeforeTax = toFixedNumber(invoicePurchase.documentTotalBeforeTax, 2);
                vm.invoicePurchase.totalAfterTax = toFixedNumber(invoicePurchase.totalAfterTax, 2);
                vm.invoicePurchase.totalBeforeTax = toFixedNumber(invoicePurchase.totalBeforeTax, 2);
                updateTotalSettlement();
                $rootScope.loadingProgress = false;
            }, function (errResponse) {
                $rootScope.loadingProgress = false;
                $log.error(errResponse);
            });
        }

        function updateTotalSettlement() {
            api.ComprasWS.Settlement.setTotalSettlement.update({ id: vm.settlement.id }).$promise.then(function (response) {
                vm.settlement.settledAmount = response.settledAmount;
                $rootScope.loadingProgress = false;
            }, function (error) {
                $rootScope.loadingProgress = false;
                $log.error(error.data);
            });
        }

        function deleteDetail(event, data) {
            if (event) {
                event.stopPropagation();
            }
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('SETTLEMENT.INVOICE.DETAIL.DELETE_DETAIL.MSG_SURE_DELETE_DETAIL'))
                .content($filter('translate')('SETTLEMENT.INVOICE.DETAIL.DELETE_DETAIL.DELETE_DETAIL'))
                .ariaLabel('Delete Detail')
                .ok($filter('translate')('SETTLEMENT.DELETE'))
                .cancel($filter('translate')('SETTLEMENT.CANCEL'));
            $mdDialog.show(confirm).then(function () {
                $rootScope.loadingProgress = true;
                api.ComprasWS.InvoicePurchaseDetail.delete({ id: data.id, idCircle: $rootScope.bsCircle.id }, function (data) {
                    showMessage($filter('translate')('SETTLEMENT.INVOICE.DETAIL.DELETE_DETAIL.DETAIL_DELETED'));
                    updateTotalInvoicePurchase();
                    getInvoice();
                }, function (errResponse) {
                    showErrorMessage("Error al eliminar el detalle de la factura");
                    $log.error(errResponse.data);
                });
            }, function () {
                // Cancel Action
            });
        }


        function editDetail(index, ev, data) {

            var detail = angular.copy(data);
            if (detail) {
                detail = {
                    active: true,
                    description: data.description,
                    id: data.id,
                    invoicePurchase: data.invoicePurchase,
                    priceAfterTax: data.priceAfterTax,
                    priceBeforeTax: data.priceBeforeTax,
                    product: data.product,
                    quantity: data.quantity,
                    documentSubTotalAfterTax: data.documentSubTotalAfterTax,
                    documentSubTotalBeforeTax: data.documentSubTotalBeforeTax,
                    subTotalAfterTax: data.subTotalAfterTax,
                    subTotalBeforeTax: data.subTotalBeforeTax,
                    isExento: data.isExento
                };
            }
            $mdDialog.show({
                controller: 'DetailSettlementInvoiceEditorController',
                controllerAs: 'vm',
                locals: {
                    edited: detail,
                    InvoicePurchase: vm.invoicePurchase,
                    SettlementDetailId: vm.settlementDetailId,
                    Details: vm.details,
                    Settlement: vm.settlement,
                    Taxes: vm.taxes
                },
                templateUrl: 'app/main/apps/expenseSettlements/settlements/details/invoiceEditor/detailEditor/detailEditor.html',
                parent: angular.element("#main"),
                targetEvent: ev,
                clickOutsideToClose: false
            }).then(function (answer) {
              if (!vm.details || vm.details.length === 1) {
                updateTotalSettlement();
                init();
              } else {
                getInvoice();
                updateTotalSettlement();
              }
            }, function () {
            });
        }

        function getInvoice() {
          if(vm.invoicePurchase.id){
            api.ComprasWS.InvoicePurchase.get({ id: vm.invoicePurchase.id }).$promise.then(function (response) {
              vm.invoicePurchase.totalAfterTax = response.totalAfterTax;
              vm.invoicePurchase.totalBeforeTax = response.totalBeforeTax;
              vm.invoicePurchase.documentTotalAfterTax = response.documentTotalAfterTax;
              vm.invoicePurchase.documentTotalBeforeTax = response.documentTotalBeforeTax;
              vm.invoicePurchase.companyBuyer = response.companyBuyer;
              loadDetails(vm.invoicePurchase);
            }, function (error) {
              $log.error(error);
            });
          }
        }
        function querySearch(numberSelect, query) {
            var results = [];
            if (numberSelect && vm.currencies !== undefined) {
                if (numberSelect === 1) {
                    results = query ? vm.currencies.filter(createFilterFor(1, query)) : vm.currencies;
                } else if (numberSelect === 3) {
                    results = query ? vm.series.filter(createFilterFor(3, query)) : vm.series;
                    if (results) {
                        var serie = _.find(results, function (serie) {
                            return serie.serie === query;
                        });
                        if (serie) {
                            vm.invoicePurchase.invoiceSerie = serie;
                            vm.exist = true;
                        }
                    }
                }

            }
            return results;
        }
        function createFilterFor(fieldFilter, query) {
            var lowercaseQuery = angular.lowercase(query);
            return function filterFn(model) {
                var lowercaseName;
                if (fieldFilter === 1) {
                    lowercaseName = angular.lowercase(model.description);
                } else if (fieldFilter === 3) {
                    lowercaseName = angular.lowercase(model.serie);
                } else {
                    lowercaseName = '';
                }
                return (lowercaseName.indexOf(lowercaseQuery) === 0 || lowercaseName.indexOf(lowercaseQuery) >= 1);
            };
        }


      function validateNrc() {
        vm.documentNRC.forEach(function (row) {
          if (vm.nrc.document && row.id === vm.nrc.documentNRC.id) {
            if (row.code === 'NRC') {
              vm.nrc.dateNrc = null;
            } else {
              vm.viewNrc = false;
            }
          }
        });
      }


      function closeThread() {
            $rootScope.snThread = false;
            if (PreviousState.name !== "") {
                switch (PreviousState.name) {
                    case 'app.expenseSettlement.settlement.settlementEdit':
                        $state.go('app.expenseSettlement.settlement.settlementEdit', { settlementId: vm.settlement.id });
                        break;
                    case 'app.expenseSettlement.settlement.settlementView':
                        $state.go('app.expenseSettlement.settlement.settlementView', { settlementId: vm.settlement.id });
                        break;
                    case 'app.expenseSettlement.consultSettlement':
                        $state.go('app.expenseSettlement.consultSettlement', {id: vm.settlement.id});
                        break;
                    default:
                        $state.go(PreviousState.name, PreviousState.params);
                        break;
                }
            } else {
                $state.go('app.dashboards_project');

            }
        }

        function showMessage(message) {
            $rootScope.loadingProgress = false;
            $mdToast.show({
                template: '<md-toast layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
                hideDelay: 3000,
                position: 'top right'
            });
        }

        function showErrorMessage(message) {
            $rootScope.loadingProgress = false;
            $mdToast.show({
                template: '<md-toast layout="column" layout-align="center start"><div class="md-toast-content" style="background-color: red">'
                    + message + '</div></md-toast>',
                hideDelay: 5000,
                position: 'top right'
            });
        }

        function validateRegime() {
            if ($state.current.name === 'app.expenseSettlement.settlement.invoiceView') {
              return;
            }
            vm.regimes.forEach(function (row) {
                if (vm.invoicePurchase.regime && row.id === vm.invoicePurchase.regime.id) {
                    if (row.code === 'FEL') {
                        vm.invoicePurchase.invoiceSerie = null;
                        vm.invoicePurchase.correlative = null;
                        vm.viewUuid = true;
                        validateElectronicInvoice();
                    } else {
                        vm.viewUuid = false;
                        vm.showFelSV = false;
                        vm.invoicePurchase.uuid = null;
                        vm.invoicePurchase.electronicSignature = null;
                    }
                }
            });

        }

        function validateElectronicInvoice() {
          api.GeneralWS.Company.me.get({id: vm.invoicePurchase.companyProvider.id}).$promise.then(function (companyProvider) {
            if (companyProvider.country.name === 'El Salvador') {
              vm.showFelSV = true;
              vm.electronicSignatureTitle = 'INVOICE.INVOICE_PURCHASE.RECEIPT_STAMP';
              vm.uuidTitle = 'INVOICE.INVOICE_PURCHASE.GENERATION_CODE';
              vm.uuidErrorTitle = 'INVOICE.ERROR.FIELD_GENERATION_CODE_PATTERN';
            }
          });
        }

      function validateHasBudgetApplication(companyId) {
        api.GeneralWS.CompanyApplication.byAppName.get({ 'company': companyId, 'app': 'Presupuestos' }).$promise.then(function (responseParameter) {
          if (responseParameter.$status === 200) {
            if (responseParameter.$data && responseParameter.$data !== "") {
              vm.hasBudgetApplication = responseParameter.$data.active;
              getBudgets();
            } else {
              $timeout(function (){
                setColumnsToGrid();
                if (vm.details.length > 0) {
                  vm.gridOptions.api.setRowData(vm.details);
                }
              },200);
            }
            $timeout(function (){
              getInvoice();
            },vm.three_hundred);
          }
        }, function (response) {
          $log.error(response);
        });
      }

      function getBudgets(){
        vm.isShowLoaderBudgets = true;
        api.PresupuestosWS.Budget.findApprovedOfBeforeAndCurrentAndAfterMonth.query(
          {
            'idc': $rootScope.bsCircle.id,
            'costCenterId': vm.settlement.pettyCash.costCenter.id,
            'departmentId': vm.settlement.pettyCash.department.id,
            'dimensionCompanyDetail3Id': getDimensionCompanyDetailBudget(vm.settlement.pettyCash.dimensionCompanyDetail3),
            'dimensionCompanyDetail4Id': getDimensionCompanyDetailBudget(vm.settlement.pettyCash.dimensionCompanyDetail4),
            'dimensionCompanyDetail5Id': getDimensionCompanyDetailBudget(vm.settlement.pettyCash.dimensionCompanyDetail5)
          }).$promise.then(function (response) {
          vm.isShowLoaderBudgets = false;
          vm.budgets= response;
          if (vm.budgets && vm.budgets.length>0) {
            vm.showButton = false;
          }
        }, function (response) {
          vm.isShowLoaderBudgets = false;
          $log.error(response);
        });
      }

      function getDimensionCompanyDetailBudget(dimensionCompanyDetail) {
        if (dimensionCompanyDetail) {
          return dimensionCompanyDetail.id;
        }
        return 0;
      }

      function setColumnsToGrid() {
        var columns = [];
        if ($state.current.name === 'app.expenseSettlement.settlement.invoiceView') {
          columns = [
            {
              headerName: $filter('translate')('SETTLEMENT.INVOICE.PRODUCT'),
              field: "product.name",
              width: 450
            },
            {
              headerName: $filter('translate')('SETTLEMENT.INVOICE.DETAIL.QUANTITY'),
              field: "quantity",
              width: 180,
              cellRenderer: function (params) {
                return $filter('number')(params.value, 2);
              }
            },
            {
              headerName: $filter('translate')('SETTLEMENT.INVOICE.DETAIL.UNIT_PRICE'),
              field: "priceAfterTax",
              width: 180,
              cellRenderer: function (params) {
                var detail = params.data;
                return detail.invoicePurchase.currency.symbol + ' ' + $filter('number')(detail.priceAfterTax, 2);
              }
            },
            {
              headerName: $filter('translate')('SETTLEMENT.INVOICE.DETAIL.TOTAL_PRICE'),
              field: "id",
              width: 180,
              cellRenderer: function (params) {
                var detail = params.data;
                return detail.invoicePurchase.currency.symbol + ' ' + $filter('number')(detail.documentSubTotalAfterTax, 2)
                  + '<br>' + vm.pettyCash.currency.symbol + ' ' + $filter('number')(detail.subTotalAfterTax, 2);
              },
              cellStyle: {'text-align': 'left'}
            }
          ];
        } else {
          columns = [
            {
              headerName: $filter('translate')('SETTLEMENT.INVOICE.PRODUCT'),
              field: "product.name",
              width: 450
            },
            {
              headerName: $filter('translate')('SETTLEMENT.INVOICE.DETAIL.QUANTITY'),
              field: "quantity",
              width: 180,
              cellRenderer: function (params) {
                return $filter('number')(params.value, 2);
              }
            },
            {
              headerName: $filter('translate')('SETTLEMENT.INVOICE.DETAIL.UNIT_PRICE'),
              field: "priceAfterTax",
              width: 180,
              cellRenderer: function (params) {
                var detail = params.data;
                return detail.invoicePurchase.currency.symbol + ' ' + $filter('number')(detail.priceAfterTax, 2);
              }
            },
            {
              headerName: $filter('translate')('SETTLEMENT.INVOICE.DETAIL.TOTAL_PRICE'),
              field: "id",
              width: 180,
              cellRenderer: function (params) {
                var detail = params.data;
                return detail.invoicePurchase.currency.symbol + ' ' + $filter('number')(detail.documentSubTotalAfterTax, 2)
                  + '<br>' + vm.pettyCash.currency.symbol + ' ' + $filter('number')(detail.subTotalAfterTax, 2);
              },
              cellStyle: {'text-align': 'left'}
            }
          ];

          if ((vm.hasBudgetApplication && !vm.settlementDetail) || (vm.hasBudgetApplication && vm.settlementDetail && !vm.settlementDetail.budgeted)) {
            columns.push({
              suppressMenu: true,
              suppressSorting: true,
              headerName: $filter('translate')('authorize_quotations.select_budgets'),
              field: "budgetSelect",
              width: 400,
              cellRenderer: function (params) {
                if (!params.node.group && !params.data.budgeted) {
                  var products = getBudgetsByProduct(params.data.product.id);
                  vm.productBudget[params.data.product.id] = getBudgetsByProduct(params.data.product.id);

                  params.$scope.isSelected = isSelected;
                  params.$scope.toggleSelectBudget = toggleSelectBudget;
                  params.$scope.validateRequestAmpliation = validateRequestAmpliation;
                  params.data.needExtension = false;

                  if (!params.data.totalCovered) {
                    params.data.totalCovered = 0;
                  }

                  params.data.requestAmpliation = false;


                  if (products.length === 1) {

                    $timeout(function () {
                      if (products[0].available >= params.data.subTotalAfterTax) {
                        params.$scope.toggleSelectBudget(products[0], null, true);
                      }
                    }, 2000);
                  }

                  return budgetsTemplate;
                } else {
                  return "";
                }
              }
            });
          }
          columns.push({
            suppressMenu: true,
            suppressSorting: true,
            headerName: $filter('translate')('SETTLEMENT.OPTIONS'),
            field: "id",
            width: 110,
            cellRenderer: function (params) {
              if (!params.node.group) {
                return '<md-button class="edit-button md-icon-button" ng-click="vm.editDetail($index, $event, data)" aria-label="Product details"\n' +
                  '                                                translate translate-attr-aria-label="SETTLEMENT.EDIT">\n' +
                  '                                                <md-icon md-font-icon="icon-pencil" class="s16"></md-icon>\n' +
                  '                                                <md-tooltip>\n' +
                  '                                                    <span translate="SETTLEMENT.EDIT">COMPOSE</span>\n' +
                  '                                                </md-tooltip>\n' +
                  '                                            </md-button>\n' +
                  '                                            <md-button class="md-icon-button" ng-click="vm.deleteDetail($event, data)" aria-label="Delete" translate translate-attr-aria-label="SETTLEMENT.DELETE">\n' +
                  '                                                <md-icon md-font-icon="icon-delete" class="s16"></md-icon>\n' +
                  '                                                <md-tooltip>\n' +
                  '                                                    <span translate="SETTLEMENT.DELETE">COMPOSE</span>\n' +
                  '                                                </md-tooltip>\n' +
                  '                                            </md-button>';
              }
            },
            pinned: 'right'
          });
        }
        $timeout(function () {
          if (vm.details.length > 0) {
            vm.gridOptions.api.setColumnDefs(columns);
          }
        }, 200);
      }

      function getBudgetsByProduct(productId) {
        if (vm.productBudget[productId] !== undefined && vm.productBudget[productId] !== null) {
          return vm.productBudget[productId];
        }

        var result = [];

        if (vm.budgets) {
          vm.budgets.forEach(function (row) {

            if (row.product.id === productId) {
              row.available = (row.amountOfficial - (row.amountExecuted ? row.amountExecuted : 0) - (row.amountReserved ? row.amountReserved : 0) - (row.amountNotExecuted ? row.amountNotExecuted : 0)).toFixed(2);
              result.push(row);
            }

          });
        }
        return result;
      }

      function isSelected(budgetDetail) {

        var scopeParent = this.$parent.$parent;

        if (scopeParent.data.references === undefined || scopeParent.data.references === null) {
          scopeParent.data.references = [];
        }

        for (var i = 0; i < scopeParent.data.references.length; i++) {
          if (scopeParent.data.references[i].budgetDetailId === budgetDetail.id) {
            return true;
          }
        }

        return false;
      }

      function toggleSelectBudget(budgetDetail, event, fromParent) {

        var scopeParent;


        if (fromParent) {
          scopeParent = this;
        } else {
          scopeParent = this.$parent;
        }


        scopeParent.data.needExtension = false;
        vm.currentDetail = scopeParent.data;

        if (scopeParent.data.references === undefined || scopeParent.data.references === null || fromParent) {
          scopeParent.data.references = [];
        }

        if (event) {
          event.stopPropagation();
        }

        var selected = false;

        for (var i = 0; i < scopeParent.data.references.length; i++) {
          if (scopeParent.data.references[i].budgetDetailId === budgetDetail.id) {
            scopeParent.data.totalCovered -= scopeParent.data.references[i].amountToUse;
            calculateAvailable(scopeParent.data.references[i].budgetDetailId,
              scopeParent.data.references[i].amountToUse, vm.productBudget[scopeParent.data.product.id]);
            scopeParent.data.references.splice(i, 1);
            selected = true;
            break;
          }
        }

        if (!selected) {
          scopeParent.data.needExtension = scopeParent.data.subTotalAfterTax > budgetDetail.available;

          var reference = {
            referenceId: budgetDetail.id,
            budgetId: budgetDetail.budget.id,
            budgetDetailId: budgetDetail.id,
            amountToUse: parseFloat(scopeParent.data.subTotalAfterTax) > parseFloat(budgetDetail.available) ?
              parseFloat(budgetDetail.available) :
              parseFloat(scopeParent.data.subTotalAfterTax),
            budgetStartDate: budgetDetail.budget.startDate,
            budgetEndDate: budgetDetail.budget.endDate,
            currencyCode: budgetDetail.currencyOfficial.code,
            budgetType: budgetDetail.budget.budgetType.description,
            budgetExchangeRateOfficial: budgetDetail.exchangeRateOfficial
          };

          scopeParent.data.references.push(reference);
          scopeParent.data.totalCovered += reference.amountToUse;
          calculateAvailable(budgetDetail.id, reference.amountToUse * -1, vm.productBudget[scopeParent.data.product.id]);
          var exist = false;
          vm.detailToAuthorize.forEach(function (data) {
            if (data.id === scopeParent.data.id) {
              exist = true;
            }
          });
          if (vm.detailToAuthorize.length === 0 && scopeParent.data.references.length > 0) {
            exist = true;
            vm.detailToAuthorize.push(scopeParent.data);
          }
          if (!exist && scopeParent.data.references.length > 0) {
            vm.detailToAuthorize.push(scopeParent.data);
          }
        }

        $timeout(function(){
          verifiActiveButtonAuthorize();
        },200);

      }

      function validateRequestAmpliation(event, scope) {
        $timeout(function(){
          verifiActiveButtonAuthorize();
        },200);
      }

      function calculateAvailable(budgetDetailId, amountToAdd, budgetDetailArray) {

        budgetDetailArray.forEach(function (budgetDetail) {
          if (budgetDetailId === budgetDetail.id) {
            budgetDetail.available = parseFloat(budgetDetail.available) + parseFloat(amountToAdd);
          }
        });

      }

      function verifiActiveButtonAuthorize() {
        var verifyAllItems = true;
        for (var r = 0; r < vm.details.length; r++) {
          if (!vm.details[r].references
            || vm.details[r].references.length === 0) {
            verifyAllItems = false;
            break;
          }else if(vm.details[r].references.length>0){
            for(var j=0; j<vm.details[r].references.length; j++){
              if(vm.details[r].references[j].amountToUse <
                (vm.details[r].subTotalAfterTax)
                && !vm.details[r].requestAmpliation){
                verifyAllItems = false;
              }
            }
          }
        }
        vm.showButton = verifyAllItems;
      }

      function reserveBudgetBySettlement(){
        vm.detailsSettlement=vm.details.map(function (r){
          r['total']= r.subTotalAfterTax;
          return r;
        });
        vm.productsToValidate = [];
        vm.detailsSettlement.forEach(function (data){
          var productToValidate = {
            id: data.id,
            product: data.product,
            amount: data.requestAmpliation ?
              (((data.total) - data.totalCovered) / data.references[data.references.length - 1].budgetExchangeRateOfficial) :
              (data.total),
            referenceAmpliationId: data.references[data.references.length - 1].referenceId,
            unitPrice: 0,
            currency: data.invoicePurchase.currency,
            exchangeRate: data.invoicePurchase.exchangeRate,
            requestAmpliation: data.requestAmpliation,
            references: data.references,
            referenceHeaderId: $stateParams.settlement
          };
          vm.productsToValidate.push(productToValidate);
        });
        $rootScope.loadingProgress = true;
        vm.requestAmpliation=false;
        for (var i = 0; i < vm.productsToValidate.length; i++) {
          if (vm.productsToValidate[i].requestAmpliation) {
            vm.requestAmpliation = true;
            break;
          }
        }
        if (vm.requestAmpliation) {
          var productAmpliation = new jinqJs()
            .from(vm.productsToValidate)
            .where(function (r) {
              return r.requestAmpliation;
            })
            .select();
          vm.productsToValidate = productAmpliation;
        }
        if (vm.productsToValidate.length > 0) {
          api.PresupuestosWS.Budget.validatesBudgetedProducts.validate(
            { 'idc': $rootScope.bsCircle.id, originType: '30' }, { quotations: vm.productsToValidate }).$promise.then(function (response) {
            $rootScope.loadingProgress = false;
            vm.productsToValidate = response;
            vm.requestAmpliation = false;
            for (var i = 0; i < vm.productsToValidate.length; i++) {
              if (vm.productsToValidate[i].requestAmpliation) {
                vm.requestAmpliation = true;
                break;
              }
            }
            if (!vm.requestAmpliation) {
              $rootScope.loadingProgress = false;
              vm.showButton = false;
              $rootScope.loadingProgress = true;
              api.ComprasWS.SettlementDetailReference.createReferences.create(
                {
                  'id': vm.invoicePurchase.id,
                  'idCircle': $rootScope.bsCircle.id,
                  'isInvoice': true
                }, {'quotations': vm.productsToValidate}).$promise.then(function (responseUp) {
                vm.contractPurchase = responseUp;
                closeThread();
              }, function (responseErr) {
                $rootScope.loadingProgress = false;
                var msg = 'ERROR';
                if (responseErr.data === 'No Detail') {
                  msg = 'DETAIL';
                }

                MessageService.showErrorMessage('REQUISITION.MSG.' + msg);
              });
            } else {
              MessageService.show('CONTRACT.REQUEST_AMPLIATION');
              $state.go('app.invoice.' + $stateParams.status);
              $rootScope.loadingProgress = false;
            }

          }, function (response) {
            vm.showButton = true;
            $rootScope.loadingProgress = false;
            $log.error(response);
          });
        }
      }

      function getBudgetsTemplate() {
        var resource = $sce.getTrustedResourceUrl('app/main/apps/expenseSettlements/settlements/details/invoiceEditor/budgetsTemplate.html');

        $templateRequest(resource).then(function (template) {
          budgetsTemplate = template;
        }, function () {
          $log.error("Ocurrio un error al leer el template");
        });
      }

      getBudgetsTemplate();

      vm.validateUUID = function () {
        if (vm.invoicePurchase.uuid) {
          vm.invoicePurchase.uuid = vm.invoicePurchase.uuid.toUpperCase();
        } else {
          if(vm.showFelSV) {
            MessageService.showErrorMessage('INVOICE.MSG.ERROR_TO_GENERATION_CODE');
          } else {
            MessageService.showErrorMessage('INVOICE.MSG.ERROR_TO_UUID');
          }
        }
      };

      function getDimensionCompany() {
        const NUMBER_DIMENSION_THREE = 3;
        const NUMBER_DIMENSION_FOUR = 4;
        const NUMBER_DIMENSION_FIVE = 5;
        api.GeneralWS.DimensionCompany.byCompany.getList(
            { 'company': $rootScope.bsCircle.company.id }
        ).$promise.then(function (responseDimension) {
            for (let i = 0; i < responseDimension.length; i++) {
                if (responseDimension[i].dimensionNumber === NUMBER_DIMENSION_THREE) {
                    vm.dimensionCompanyDetail3 = responseDimension[i];
                } else if (responseDimension[i].dimensionNumber === NUMBER_DIMENSION_FOUR) {
                    vm.dimensionCompanyDetail4 = responseDimension[i];
                } else if (responseDimension[i].dimensionNumber === NUMBER_DIMENSION_FIVE) {
                    vm.dimensionCompanyDetail5 = responseDimension[i];
                } else {
                    vm.dimensionCompanyDetail1 = responseDimension[i];
                }
            }
            $timeout(function () {
                vm.gridOptions.api.setColumnDefs(vm.masterColumnDefs);
            }, EIGTH_HUNDRED_TIME_OUT);
        });
      }

      function updateCompanyIsExternalProvider() {
        $rootScope.loadingProgress = true;
        api.GeneralWS.Company.updateExternalProvider
        .update({ id: vm.invoicePurchase.companyProvider.id, isExternalProvider:  vm.invoicePurchase.companyProvider.isExternalProvider})
        .$promise.then(
          function() {
            $rootScope.loadingProgress = false;
            MessageService.show('INVOICE.MSG.UPDATE_COMPANY_IS_EXTERNAL_PROVIDER');
            processToCompanyIsExternalProvider();
          },
          function() {
            vm.invoicePurchase.companyProvider.isExternalProvider = !vm.invoicePurchase.companyProvider.isExternalProvider;
            $rootScope.loadingProgress = false;
            MessageService.showErrorMessage('INVOICE.MSG.ERROR_TO_UPDATE_COMPANY_IS_EXTERNAL_PROVIDER');
          }
        );
      }

      function processToCompanyIsExternalProvider() {
        vm.validateByExternalProvider = false;
        if (!vm.useExternalProviders) {
          return;
        }
        if (!vm.invoicePurchase.companyProvider.isExternalProvider) {
          vm.invoicePurchase.regime = null;
          vm.invoicePurchase.invoiceSerie = undefined;
          return;
        }
        vm.invoicePurchase.regime = _.find(vm.regimes, function (regime) {
          return regime.name.toUpperCase() === 'SIN RÉGIMEN' || regime.name.toUpperCase() === 'SIN REGIMEN';
        });

        vm.validateRegime();

        const serie = _.find(vm.series, function (serieData) {
          return serieData.serie === 'INVOICE';
        });

        vm.invoicePurchase.invoiceSerie = {};
        if (serie) {
          vm.invoicePurchase.invoiceSerie = serie;
          return;
        }

        if (vm.invoiceSerieDocumentType && vm.invoiceSerieDocumentType.id !== undefined
          && vm.invoiceSerieDocumentType.id !== null) {
          goToAddSerieToCompany('INVOICE', vm.invoicePurchase.companyProvider);
        }

      }

    }
})();

(function() {
  "use strict";

  angular
    .module("app.expenseSettlement.settlement")
    .controller("settlementEditorController", settlementEditorController);

  /** @ngInject */
  function settlementEditorController(
    $rootScope,
    $state,
    api,
    Settlement,
    $filter,
    $log,
    msUtils,
    $mdDialog,
    $mdToast,
    $scope,
    $stateParams,
    $timeout,
    $sce,
    $templateRequest
  ) {
    var vm = this;

    // Data
    vm.company = $rootScope.bsCircle.company;
    vm.settlement = Settlement;
    vm.pettyCash = vm.settlement.pettyCash;
    vm.countrySettlement = vm.pettyCash.company.country;

    vm.isValidated =
      vm.settlement.settlementStatus.name === "Provisionada" ||
      vm.settlement.settlementStatus.name === "No Validada"
        ? true
        : false;
    vm.isAuthorizer = false;
    vm.isVerifier = false;
    vm.isPayment = false;
    vm.requirePolicyAndContainer = false;
    vm.canAddDetail = true;
    vm.canNotAuthorizedDetail = false;
    vm.canGoToInvoice = false;
    vm.canAuthorizeSettlement = false;
    vm.canValidateSettlement = false;
    vm.selectedDetails = [];
    vm.finalSettlement = false;
    vm.productBudget = {};
    var budgetsTemplate = null;
    vm.showButton = false;
    vm.showButtonSV = false;

    vm.detailToAuthorize = [];
    vm.gridOptions = {
      columnDefs: [],
      suppressContextMenu: true,
      rowSelection: 'multiple',
      suppressRowClickSelection: true,
      angularCompileRows: true,
      angularCompileHeaders: true,
      enableColResize: true,
      rowData: [],
      rowHeight: 50,
      pinnedBottomRowData: [],
      getRowStyle: rowStyleFunction
    };

    vm.dtOptions = {
      dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      columnDefs: [
        { targets: 0, className: "control" },
        //Target the select column
        { targets: 1, filterable: false, sortable: false },
        // Target the id column
        { targets: 2 },
        // Target the actions column
        {
          targets: 9,
          responsivePriority: 1,
          filterable: false,
          sortable: false
        }
      ],
      bInfo: false,
      paging: false,
      responsive: { details: { type: "column" } }
    };

    // Methods
    vm.closeThread = closeThread;
    vm.updateSettlement = updateSettlement;
    vm.addDetail = addDetail;
    vm.editDetail = editDetail;
    vm.deleteDetail = deleteDetail;
    vm.loadDetails = loadDetails();
    vm.toggleSelectDetail = toggleSelectDetail;
    vm.deselectDetails = deselectDetails;
    vm.selectAllDetails = selectAllDetails;
    vm.toggleInArray = msUtils.toggleInArray;
    vm.exists = msUtils.exists;
    vm.updateTotalSettlementEditing = updateTotalSettlementEditing;
    vm.showDialog = showDialog;
    vm.sendSettlement = sendSettlement;
    vm.notAuthorizated = notAuthorizated;
    vm.authorizeSettlement = authorizeSettlement;
    vm.provisionSettlement = provisionSettlement;
    vm.paySettlement = paySettlement;
    vm.goToInvoicePurchaseEdit = goToInvoicePurchaseEdit;
    vm.getAmountAvailable = getAmountAvailable();
    vm.viewDetail = viewDetail;
    vm.activeVerifyButton = activeVerifyButton;
    vm.closeDialog = closeDialog;
    vm.sendInvoiceForSettlement = sendInvoiceForSettlement;
    vm.detailsProductRequired = detailsProductRequired;
    vm.viewChangeStatus = viewChangeStatus;

    vm.dimensionCompanyDetail3 = null;
    vm.dimensionCompanyDetail4 = null;
    vm.dimensionCompanyDetail5 = null;

    vm.NUMBER_THREE = 3;
    vm.NUMBER_FOUR = 4;
    vm.NUMBER_FIVE = 5;
    //////////

    function init() {
      api.ComprasWS.pettyCashGeneralSets.getByPettyCashType(
        {
          id: 'byPettyCashType',
          pettyCashTypeId: vm.pettyCash.pettyCashType.id, idCircle: $rootScope.bsCircle.id
        }).$promise.then(function (response) {
        if (response.id) {
          vm.pettyCashGeneralSets = response;
          if (vm.pettyCashGeneralSets.askForBudget) {
            vm.showButton = false;
            validateHasBudgetApplication(vm.pettyCashGeneralSets.company.id);
            getDimensionCompany();
          }else{
            setColumnsToGrid();
            if (vm.gridOptions && vm.gridOptions.api) {
              vm.gridOptions.api.setRowData(vm.details);
            }
            getDimensionCompany();
            vm.showButton = true;
          }
        } else {
          setColumnsToGrid();
          if (vm.gridOptions && vm.gridOptions.api) {
            vm.gridOptions.api.setRowData(vm.details);
          }
          vm.showButton = true;
        }
      }, function (error) {
        vm.showButton = false;
        $log.error(error.data);
      });
    }

    if (vm.pettyCash.pettyCashType.name === "IMPORT") {
      vm.requirePolicyAndContainer = true;
      if (vm.settlement.policy === null || vm.settlement.container === null) {
        vm.canAddDetail = false;
      }
    }

    function activeVerifyButton(detail) {
      return false; //para que no desactive, este siempre visible
    }

    function loadDetails() {
      if (Settlement) {
        vm.snDetails = true;
        vm.showButtonSV = vm.countrySettlement.countryCode === 'SV';
        vm.loadingInDetail = true;
        api.ComprasWS.SettlementDetails.getAllDetailsBySettlement
          .getAll({
            settlementId: Settlement.id,
            circleId: $rootScope.bsCircle.id
          })
          .$promise.then(
            function(data) {
              vm.details = data;
              init();
              switch ($rootScope.bsCircle.name) {
                case "ADMIN":
                  vm.isAuthorizer = true;
                  vm.isPayment = true;
                  vm.canAuthorizeSettlement = true;
                  vm.canNotAuthorizedDetail = true;
                  break;
                case "ROLE_AUTORIZADOR_LIQUIDACIONES":
                  switch (vm.settlement.settlementStatus.name) {
                    case "Pendiente de Autorizar":
                    case "Pre-Provisionada":
                      vm.isAuthorizer = true;
                      vm.canAuthorizeSettlement = true;
                      vm.canNotAuthorizedDetail = true;
                      break;
                    case "Autorizada":
                      vm.isAuthorizer = true;
                      vm.canAuthorizeSettlement = false;
                      vm.canNotAuthorizedDetail = false;
                      break;
                  }
                  break;
                case "ROLE_VERIFICADOR_LIQUIDACIONES":
                case "ROLE_PAGOS_AUTORIZADOR":
                  vm.isVerifier = true;
                  vm.canValidateSettlement = true;
                  vm.canGoToInvoice = true;
                  break;
                case "ROLE_LIQUIDADOR_LIQUIDACIONES":
                  vm.isPayment = true;
                  break;
                default:
                  break;
              }

              vm.details.forEach(function(detail) {
                if (
                  detail.settlementDetailStatus.name === "Autorización Extra"
                ) {
                  vm.canAuthorizeSettlement = false;
                }
                if (
                  detail.settlementDetailStatus.name !== 'Pre-Provisionado' &&
                  detail.settlementDetailStatus.name !== 'No Validado'
                ) {
                  vm.isValidated = true;
                }

                if (
                  $rootScope.bsCircle.name ===
                    "ROLE_VERIFICADOR_LIQUIDACIONES" ||
                  $rootScope.bsCircle.name === "ROLE_PAGOS_AUTORIZADOR"
                ) {
                  if (detail.settlementDetailStatus.name === "Autorizado") {
                    vm.canValidateSettlement = false;
                  }
                }
              });
              $log.debug("vm.details");

              vm.loadingInDetail = false;
            },
            function(error) {
              $log.error(error.data);
              vm.loadingInDetail = false;
            }
          );
      }
    }

    function getAmountAvailable() {
      if (vm.pettyCash.amount > 0) {
        api.ComprasWS.Settlement.getAmountAvailable
          .getTotal({ id: vm.settlement.pettyCash.id })
          .$promise.then(
            function(response) {
              vm.amountAvailable = parseFloat(response.$data);
              $log.debug("vm.amountAvailable");
              $log.debug(vm.amountAvailable);
            },
            function(error) {
              $log.error(error.data);
            }
          );
      }
    }

    $scope.set_color = function(requireRevision) {
      if (requireRevision !== false) {
        return { background: "#E0E0E0" };
      }
    };

    function updateSettlement() {
      api.ComprasWS.Settlement.Settlement.update(
        { id: vm.settlement.id },
        vm.settlement
      ).$promise.then(
        function(response) {
          vm.settlement = response;
          vm.canAddDetail = true;
        },
        function(error) {
          $log.error(error.data);
        }
      );
    }

    //INGRESANDO
    function addDetail(settlementId, type) {
      if (type === undefined) {
        $state.go("app.expenseSettlement.settlement.receiptEdit", {
          settlement: settlementId
        });
      } else {
        $state.go("app.expenseSettlement.settlement.invoiceEdit", {
          settlement: settlementId,
          type: type
        });
      }
    }

    function editDetail(detail) {
      if (detail.invoicePurchase === null) {
        $state.go("app.expenseSettlement.settlement.receiptEdit", {
          settlement: vm.settlement.id,
          receipt: detail.paymentReceipt.id,
          settlementDetailId: detail.id,
          budgeted: detail.budgeted
        });
      } else {
        $state.go("app.expenseSettlement.settlement.invoiceEdit", {
          settlement: vm.settlement.id,
          invoiceId: detail.invoicePurchase.id,
          settlementDetailId: detail.id,
          budgeted: detail.budgeted
        });
      }
    }

    function viewDetail(detail) {
      if (!detail.invoicePurchase) {
        $state.go("app.expenseSettlement.settlement.receiptView", {
          settlement: vm.settlement.id,
          detail: detail.id,
          receipt: detail.paymentReceipt.id
        });
      } else {
        $state.go("app.expenseSettlement.settlement.invoiceView", {
          settlement: vm.settlement.id,
          detail: detail.id,
          invoiceId: detail.invoicePurchase.id
        });
      }
    }

    function goToInvoicePurchaseEdit(detail, index) {
      var docArray = [];
      vm.details.forEach(function(detail) {
        if (detail.invoicePurchase) {
          //invoice
          docArray.push({
            docType: "invoice", //invoice=facturas, receipt=recibos
            docObj: detail.invoicePurchase, //objeto invoicePurchase
            detailId: detail.id
          });
        }
        if (detail.paymentReceipt) {
          //receipt
          docArray.push({
            docType: "receipt",
            docObj: detail.paymentReceipt,
            detailId: detail.id
          });
        }
      });
      $state.go(
        "app.expenseSettlement.settlement.settlementEdit.documentVerify",
        {
          docArray: docArray, //el array de los documentos ej. invoicePurchase
          backState: {
            stateToBack: "app.expenseSettlement.settlement.settlementView", //state a donde debe regresar
            paramsToBack: $state.params
          },
          mainDoc: {
            type: $filter("translate")("SETTLEMENT.EXPENSE_SETTLEMENT"), //descripcion del typo
            typeCode: "SETTLEMENT", //PURCHASE_ORDER= para compras, SETTLEMENT para liquidaciones
            number: vm.settlement.id, //el id del Doc principal, en compras puede ser la orden de compra.
            description: vm.settlement.settlementStatus.name, //Una descripcion a mostrar
            detailIndex: index //indice del docArray que debe abrir primero, si es unico enivar 0
          }
        }
      );
    }

    function deleteDetail(index, event, data) {
      if (event) {
        event.stopPropagation();
      }
      var confirm = $mdDialog
        .confirm()
        .title(
          $filter("translate")(
            "SETTLEMENT.INVOICE.DETAIL.DELETE_DETAIL.MSG_SURE_DELETE_DETAIL"
          )
        )
        .content(
          $filter("translate")(
            "SETTLEMENT.INVOICE.DETAIL.DELETE_DETAIL.DELETE_DETAIL"
          )
        )
        .ariaLabel("Delete Detail")
        .ok($filter("translate")("SETTLEMENT.DELETE"))
        .cancel($filter("translate")("SETTLEMENT.CANCEL"));
      $mdDialog.show(confirm).then(
        function() {
          $rootScope.loadingProgress = true;
          api.ComprasWS.SettlementDetail.delete({ id: data.id }).$promise.then(
            function(response) {
              loadDetails();
              updateTotalSettlementEditing(vm.settlement.id);
              showMessage(
                $filter("translate")(
                  "SETTLEMENT.INVOICE.DETAIL.DELETE_DETAIL.DETAIL_DELETED"
                )
              );
              if (vm.settlement.isExtra === true && vm.details.length === 0) {
                closeThread();
              }
            },
            function(error) {
              $log.error(error.data);
            }
          );
        },
        function() {
          // Cancel Action
        }
      );
    }

    function updateTotalSettlementEditing(settlementId) {
      api.ComprasWS.Settlement.setTotalSettlement
        .update({ id: settlementId })
        .$promise.then(
          function(response) {
            vm.settlement.settledAmount = response.settledAmount;
            getAmountAvailable();
            $rootScope.loadingProgress = false;
          },
          function(error) {
            $rootScope.loadingProgress = false;
            $log.error(error.data);
          }
        );
    }

    function showDialog(ev) {
      $mdDialog
        .show({
          contentElement: "#myStaticDialog",
          parent: angular.element(document.body),
          targetEvent: ev,
          clickOutsideToClose: true,
          fullscreen: false
        })
        .then(function() {}, function() {});
    }

    function detailsProductRequired(data, index, ev) {
      $mdDialog
        .show({
          controller: "ComposeDialogProductRequiredController",
          controllerAs: "vm",
          templateUrl:
            "app/main/apps/expenseSettlements/settlements/details/invoiceEditor/productsRequired/productsRequired.html",
          targetEvent: ev,
          locals: {
            products: data,
            showButtons: true
          },
          clickOutsideToClose: false
        })
        .then(function(answer) {
          sendInvoiceForSettlement();
        });
    }

    function viewChangeStatus(settlementId, ev) {
      $mdDialog
        .show({
          controller: "changeStatusController",
          controllerAs: "vm",
          templateUrl:
            "app/main/apps/expenseSettlements/settlements/settlement/settlementEditor/changeStatus/changeStatus.html",
          targetEvent: ev,
          locals: {
            settlementId: settlementId
          },
          clickOutsideToClose: false
        })
        .then(function(answer) {});
    }

    function sendSettlement() {
      $rootScope.loadingProgress = false;
      api.ComprasWS.productRequired.query(
        {
          settlementId: vm.settlement.id,
          companyId: $rootScope.bsCircle.company.id
        },
        function (response) {
          vm.products = response;
          if (vm.products.length !== 0) {
            vm.detailsProductRequired(vm.products);
          } else {
            sendInvoiceForSettlement();
          }
        },
        function (error) {
          $rootScope.loadingProgress = false;
          $log.error(error.data);
        }
      );
    }

    function changeStatus(){
      api.ComprasWS.Settlement.sendSettlement.send(
        {
          settlementId: vm.settlement.id,
          isFinal: vm.finalSettlement,
          idCircle: $rootScope.bsCircle.id
        },
        function(response) {
          vm.settlement = response;
          showMessage($filter("translate")("SETTLEMENT.SETTLEMENT_SEND"));
          $state.go("app.expenseSettlement.settlement.entering", {
            status: "Ingresando"
          });
          $rootScope.loadingProgress = false;
        },
        function(error) {
          $rootScope.loadingProgress = false;
          if (error.data.mensaje.startsWith("Invoice not details")) {
            showErrorMessage(
              $filter("translate")("SETTLEMENT.SETTLEMENT_SEND_ERROR")
            );
          } else if (error.data === "productRequired ") {
            showErrorMessage(
              $filter("translate")("SETTLEMENT.PRODUCTREQUIRED")
            );
          } else {
            if (error.status === 406) {
              var sd = error.data;
              var msg =
                $filter("translate")(
                  "SETTLEMENT.SETTLEMENT_SEND_ERROR_MAXI_INVOICE_BY_PROVIDER1"
                ) +
                sd.invoicePurchase.companyProvider.name +
                $filter("translate")(
                  "SETTLEMENT.SETTLEMENT_SEND_ERROR_MAXI_INVOICE_BY_PROVIDER2"
                ) +
                sd.settlement.pettyCash.pettyCashType.description +
                $filter("translate")(
                  "SETTLEMENT.SETTLEMENT_SEND_ERROR_MAXI_INVOICE_BY_PROVIDER3"
                ) +
                sd.invoicePurchase.correlative;

              showErrorMessage(msg);
              closeDialog();
            } else {
              $log.error(error);
            }
          }
        }
      );
    }

    function sendInvoiceForSettlement(ev) {
      var confirm = $mdDialog
        .confirm()
        .title($filter("translate")("SETTLEMENT.SEND_CONFIRMATION"))
        .content($filter("translate")("SETTLEMENT.SEND_CONFIRMATION_MSG"))
        .ariaLabel("Delete Detail")
        .ok($filter("translate")("SETTLEMENT.OK"))
        .cancel($filter("translate")("SETTLEMENT.CANCEL"));
      $mdDialog.show(confirm).then(
        function() {
          $rootScope.loadingProgress = true;
          if (vm.hasBudgetApplication && verifyExistPaymentReceipt()) {
            reserveBudgetBySettlement();
          } else {
            changeStatus();
          }
        },
        function() {
          // Cancel Action
          $rootScope.loadingProgress = false;
        }
      );
    }

    //AUTORIZAR, NO AUTORIZAR
    function notAuthorizated(i, ev, d) {
      $rootScope.loadingProgress = true;
      $mdDialog
        .show({
          controller: "rejectionReasonController",
          controllerAs: "vm",
          locals: {
            Data: d,
            detailId: 0
          },
          templateUrl:
            "app/main/apps/expenseSettlements/settlements/settlement/settlementEditor/rejectionReason/rejectionReason.html",
          parent: angular.element("#main"),
          targetEvent: ev,
          clickOutsideToClose: false
        })
        .then(
          function(answer) {
            if (answer) {
              loadDetails();
            }
            api.ComprasWS.Settlement.Settlement.get({
              id: vm.settlement.id
            }).$promise.then(
              function(response) {
                vm.settlement = response;
                if (vm.settlement.settlementStatus.name === "No Autorizada") {
                  $state.go(
                    "app.expenseSettlement.settlement.pendingAuthorize",
                    { status: "Pendiente de Autorizar" }
                  );
                }
                $rootScope.loadingProgress = false;
              },
              function(error) {
                $log.error(error.data);
                $rootScope.loadingProgress = false;
              }
            );
          },
          function() {
            $rootScope.loadingProgress = false;
          }
        );
    }

    function authorizeSettlement() {
      $rootScope.loadingProgress = true;
      api.ComprasWS.Settlement.authorizeSettlement.authorize(
        { settlementId: vm.settlement.id, idCircle: $rootScope.bsCircle.id },
        function(response) {
          vm.settlement = response;
          showMessage($filter("translate")("SETTLEMENT.SETTLEMENT_AUTHORIZED"));
          $rootScope.loadingProgress = false;
          $state.go("app.expenseSettlement.settlement.pendingAuthorize", {
            status: "Pendiente de Autorizar"
          });
        },
        function(error) {
          $rootScope.loadingProgress = false;
          if (error.data === "Settlement details not found") {
            showErrorMessage(
              $filter("translate")("SETTLEMENT.CAN_NOT_AUTHORIZE_SETTLEMENT")
            );
            $state.go("app.expenseSettlement.settlement.pendingAuthorize", {
              status: "Pendiente de Autorizar"
            });
          } else {
            showErrorMessage(
              $filter("translate")("SETTLEMENT.SETTLEMENT_AUTHORIZED_ERROR")
            );
          }
          $log.error(error.data);
        }
      );
    }

    function provisionSettlement(ev) {
      $mdDialog
        .show({
          controller: "VerificationInvoiceComposeController",
          controllerAs: "vm",
          templateUrl:
            "app/main/apps/documentVerify/settlement/compose/compose-dialog.html",
          parent: angular.element("#main"),
          targetEvent: ev,
          locals: {
            detail: vm.details,
            settlement: vm.settlement
          },
          clickOutsideToClose: false
        })
        .then(function(answer) {
          var settlement = answer;
          $log.debug("settlement:");
          $log.debug(settlement);
          vm.settlement = settlement;
        }, function(err){
          if (err) {
            vm.isValidated = true;
          }
      });
    }

    function paySettlement(ev, settlement) {
      $rootScope.loadingProgress = true;
      $mdDialog
        .show({
          controller: "paySettlementController",
          controllerAs: "vm",
          locals: {
            Data: settlement
          },
          templateUrl:
            "app/main/apps/expenseSettlements/settlements/settlement/settlementEditor/paySettlement/paySettlement.html",
          parent: angular.element("#main"),
          targetEvent: ev,
          clickOutsideToClose: false
        })
        .then(
          function(answer) {
            //Cambiar estado de liquidación
            if (answer) {
              api.ComprasWS.Settlement.paySettlement.pay(
                {
                  settlementId: vm.settlement.id,
                  wireTransferReference: answer.id,
                  idCircle: $rootScope.bsCircle.id
                },
                function(response) {
                  vm.settlement = response;
                  $state.go("app.expenseSettlement.paymentSettlements");
                  showMessage(
                    $filter("translate")("SETTLEMENT.SETTLEMENT_PAID")
                  );
                },
                function(error) {
                  $log.error(error.data);
                  if (error.data === "ERP reference null") {
                    showErrorMessage(
                      $filter("translate")("SETTLEMENT.ERP_REFERENCE_NULL")
                    );
                  } else {
                    showErrorMessage(
                      $filter("translate")("SETTLEMENT.SETTLEMENT_PAID_ERROR")
                    );
                  }
                }
              );
            }
          },
          function() {
            $rootScope.loadingProgress = false;
          }
        );
    }

    function toggleSelectDetail(detail, event) {
      if (event) {
        event.stopPropagation();
      }

      if (vm.selectedDetails.indexOf(detail) > -1) {
        vm.selectedDetails.splice(vm.selectedDetails.indexOf(detail), 1);
      } else {
        vm.selectedDetails.push(detail);
      }
    }

    function deselectDetails() {
      vm.selectedDetails = [];
    }

    function selectAllDetails() {
      vm.selectedDetails = vm.details;
    }

    function closeDialog() {
      $mdDialog.cancel();
    }

    function closeThread() {
      $rootScope.snThread = false;

      if ($stateParams.backTo && $stateParams.filter && $stateParams.backTo !== null) {
        $state.go($stateParams.backTo, {
          id: $stateParams.filter.id,
          filter: $stateParams.filter
        });
      } else if ($rootScope.bsCircle) {
        switch ($rootScope.bsCircle.name) {
          case "ROLE_OPERADOR_LIQUIDACIONES":
            switch (vm.settlement.settlementStatus.name) {
              case "Ingresando":
                $state.go("app.expenseSettlement.settlement.entering", {
                  status: "Ingresando"
                });
                break;
              case "Autorizada":
                $state.go("app.expenseSettlement.settlement.preProvisioned", {
                  status: "Pre-Provisionada"
                });
                break;
              case "Pre-Provisionada":
                $state.go("app.expenseSettlement.settlement.preProvisioned", {
                  status: "Pre-Provisionada"
                });
                break;
            }
            break;
          case "ROLE_AUTORIZADOR_LIQUIDACIONES":
            switch (vm.settlement.settlementStatus.name) {
              case "Pendiente de Autorizar":
                $state.go("app.expenseSettlement.settlement.pendingAuthorize", {
                  status: "Pendiente de Autorizar"
                });
                break;
              case "Autorizada":
                $state.go("app.expenseSettlement.settlement.preProvisioned", {
                  status: "Pre-Provisionada"
                });
                break;
              case "Pre-Provisionada":
                $state.go("app.expenseSettlement.settlement.preProvisioned", {
                  status: "Pre-Provisionada"
                });
                break;
              case "Provisionada":
                $state.go("app.expenseSettlement.settlement.provisioned", {
                  status: "Provisionada"
                });
                break;
            }
            break;
          case "ROLE_VERIFICADOR_LIQUIDACIONES":
          case "ROLE_PAGOS_AUTORIZADOR":
            switch (vm.settlement.settlementStatus.name) {
              case "Autorizada":
                $state.go("app.expenseSettlement.verificationSettlements");
                break;
              case "No Validada":
                $state.go("app.expenseSettlement.verificationSettlements");
                break;
              case "Pre-Provisionada":
                $state.go("app.expenseSettlement.verificationSettlements");
                break;
              case "Provisionada":
                $state.go("app.expenseSettlement.provisioned");
                break;
            }
            break;
          case "ROLE_LIQUIDADOR_LIQUIDACIONES":
            switch (vm.settlement.settlementStatus.name) {
              case "Provisionada":
                $state.go("app.expenseSettlement.paymentSettlements");
                break;
              case "Pagada":
                $state.go("app.expenseSettlement.paidSettlements");
                break;
            }
            break;
          default:
            $state.go("app.dashboards_project");
            break;
        }
      }
    }

    function showMessage(message) {
      $rootScope.loadingProgress = false;
      $mdToast.show({
        template:
          '<md-toast layout="column" layout-align="center start"><div class="md-toast-content">' +
          message +
          "</div></md-toast>",
        hideDelay: 3000,
        position: "top right"
      });
    }

    function showErrorMessage(message) {
      $rootScope.loadingProgress = false;
      $mdToast.show({
        template:
          '<md-toast layout="column" layout-align="center start"><div class="md-toast-content" style="background-color: red">' +
          message +
          "</div></md-toast>",
        hideDelay: 10000,
        position: "top right"
      });
    }

    function validateHasBudgetApplication(companyId) {
      api.GeneralWS.CompanyApplication.byAppName.get({ 'company': companyId, 'app': 'Presupuestos' }).$promise.then(function (responseParameter) {
        if (responseParameter.$status === 200) {
          if (responseParameter.$data && responseParameter.$data !== "") {
            vm.hasBudgetApplication = responseParameter.$data.active;
            getBudgets();
          }else{
            $timeout(function (){
              setColumnsToGrid();
              vm.gridOptions.api.setRowData(vm.details);
              vm.showButton = true;
            },200);
          }
        }
      }, function (response) {
        $log.error(response);
        $timeout(function (){
          setColumnsToGrid();
        },200);
      });
    }

    function getBudgets(){
      vm.isShowLoaderBudgets = true;
      api.PresupuestosWS.Budget.findApprovedOfBeforeAndCurrentAndAfterMonth.query(
        {
          'idc': $rootScope.bsCircle.id,
          'costCenterId': vm.settlement.pettyCash.costCenter.id,
          'departmentId': vm.settlement.pettyCash.department.id,
          'dimensionCompanyDetail3Id': getDimensionCompanyDetailBudget(vm.settlement.pettyCash.dimensionCompanyDetail3),
          'dimensionCompanyDetail4Id': getDimensionCompanyDetailBudget(vm.settlement.pettyCash.dimensionCompanyDetail4),
          'dimensionCompanyDetail5Id': getDimensionCompanyDetailBudget(vm.settlement.pettyCash.dimensionCompanyDetail5)
        }).$promise.then(function (response) {
        vm.isShowLoaderBudgets = false;
        vm.budgets= response;
        if (vm.budgets && vm.budgets.length>0) {
          vm.showButton = false;
        }
        $timeout(function () {
          setColumnsToGrid();
          vm.showButton = true;
          for (var i = 0; i < vm.details.length; i++) {
            if (!vm.details[i].budgeted) {
              vm.showButton = false;
              break;
            }
          }
          vm.gridOptions.api.setRowData(vm.details);
        }, 100);
      }, function (response) {
        vm.isShowLoaderBudgets = false;
        $log.error(response);
      });
    }

    function getDimensionCompanyDetailBudget(dimensionCompanyDetail) {
      if (dimensionCompanyDetail) {
        return dimensionCompanyDetail.id;
      }
      return 0;
    }

    function getSettlementDetailNumberColumnValue(settlementDetail) {
      if (settlementDetail.invoicePurchase && settlementDetail.invoicePurchase.id > 0) {
        return getSettlementDetailNumberColumnValueByInvoicePurchase(settlementDetail);
      }

      var numberValue = '';
      if (settlementDetail.paymentReceipt.serie) {
        numberValue = settlementDetail.paymentReceipt.serie + '-';
      }
      numberValue = numberValue + settlementDetail.paymentReceipt.correlative;
      return numberValue;
    }

    function getSettlementDetailNumberColumnValueByInvoicePurchase(settlementDetail) {
      if (vm.countrySettlement.countryCode === 'SV' && settlementDetail.invoicePurchase.uuid) {
        return settlementDetail.invoicePurchase.uuid;
      }

      if (settlementDetail.invoicePurchase.invoiceSerie && settlementDetail.invoicePurchase.invoiceSerie.serie) {
        return settlementDetail.invoicePurchase.invoiceSerie.serie + '-' + settlementDetail.invoicePurchase.correlative;
      }

      var numberValue = '';
      if (settlementDetail.invoicePurchase.uuid) {
        const maxCharIndex = 8;
        numberValue = settlementDetail.invoicePurchase.uuid.substring(0, maxCharIndex) + '-';
      }
      numberValue = numberValue + settlementDetail.invoicePurchase.correlative;
      return numberValue;
    }


    function setColumnsToGrid(){
      var columns = [];
      if ($state.current.name === 'app.expenseSettlement.settlement.settlementView') {
        columns=[
          {
            headerName: $filter('translate')('SETTLEMENT.TYPE'),
            field: "id",
            width: 150,
            cellRenderer: function (params){
              return $filter('translate')((params.data.invoicePurchase && params.data.invoicePurchase.id > 0) ? 'SETTLEMENT.TYPE_' + params.data.invoicePurchase.invoicePurchaseType : 'SETTLEMENT.RECEIPT.RECEIPT');
            }
          },{
            headerName: $filter('translate')('SETTLEMENT.NUMBER'),
            field: "id",
            width: 150,
            cellRenderer: function (params){
              return getSettlementDetailNumberColumnValue(params.data);
            }
          },{
            headerName: $filter('translate')('SETTLEMENT.PROVIDER'),
            field: "id",
            width: 350,
            cellStyle: {'text-align': 'right'},
            cellRenderer: function (params){
              return params.data.invoicePurchase && params.data.invoicePurchase.id > 0 ? params.data.invoicePurchase.companyProvider.businessName
                : params.data.paymentReceipt.recipientName;
            }
          },{
            headerName: $filter('translate')('SETTLEMENT.TOTAL'),
            field: "id",
            width: 150,
            cellRenderer: function (params){
              return '<div>\n' +
                '                                                <span ng-class="data.isOverSpend ? \'over-spend\' : \'\'">\n' +
                '                                                    {{vm.pettyCash.currency.symbol}} {{data.invoicePurchase.id > 0 ? data.invoicePurchase.totalAfterTax : data.paymentReceipt.amount|\n' +
                '                                                    number: 2}}\n' +
                '                                                </span>\n' +
                '                                                <md-tooltip ng-if="detail.isOverSpend" md-direction="top" md-visible="tooltipVisible">{{\'SETTLEMENT.OVER_SPEND\'|\n' +
                '                                                    translate}}\n' +
                '                                                </md-tooltip>\n' +
                '                                            </div>';
            }
          },{
            headerName: $filter('translate')('SETTLEMENT.DEDUCTIBLE'),
            field: "id",
            width: 350,
            cellRenderer: function (params){
              return '<span ng-show="data.expenseDeductible">\n' +
                '                                                Gasto Deducible,\n' +
                '                                            </span>\n' +
                '                                            <span ng-show="data.taxDeductible">\n' +
                '                                                Impuesto Deducible\n' +
                '                                            </span>';
            }
          },{
            headerName: $filter('translate')('SETTLEMENT.STATUS'),
            field: "id",
            width: 200,
            cellRenderer: function (params){
              return '<div class="actions" layout="row" layout-align="start center">\n' +
                '                                                <div class="label ng-binding ng-scope md-green-300-bg" role="button" ng-if="data.settlementDetailStatus.name === \'Ingresando\'"\n' +
                '                                                    translate="SETTLEMENT.SETTLEMENT_DETAIL.STATUS_ENTERING">\n' +
                '                                                    Ingresando\n' +
                '                                                </div>\n' +
                '                                                <div class="label ng-binding ng-scope md-lime-A700-bg" role="button" ng-if="data.settlementDetailStatus.name === \'Autorización Extra\'"\n' +
                '                                                    translate="SETTLEMENT.SETTLEMENT_DETAIL.EXTRA_AUTHORIZATION">\n' +
                '                                                    Autorización Extra\n' +
                '                                                </div>\n' +
                '                                                <div class="label ng-binding ng-scope md-orange-900-bg" role="button" ng-if="data.settlementDetailStatus.name === \'Pendiente de Autorizar\'"\n' +
                '                                                    translate="SETTLEMENT.SETTLEMENT_DETAIL.STATUS_PENDING_AUTHORIZATION">\n' +
                '                                                    Enviado\n' +
                '                                                </div>\n' +
                '                                                <div class="label ng-binding ng-scope md-blue-900-bg" role="button" ng-if="data.settlementDetailStatus.name === \'Autorizado\'"\n' +
                '                                                    translate="SETTLEMENT.SETTLEMENT_DETAIL.STATUS_AUTHORIZED">\n' +
                '                                                    Autorizado\n' +
                '                                                </div>\n' +
                '                                                <div class="label ng-binding ng-scope md-amber-300-bg" role="button" ng-if="data.settlementDetailStatus.name === \'No Autorizado\'"\n' +
                '                                                    translate="SETTLEMENT.SETTLEMENT_DETAIL.STATUS_NO_AUTHORIZED">\n' +
                '                                                    No Autorizado\n' +
                '                                                    <p ng-if=""></p>\n' +
                '                                                </div>\n' +
                '                                                <div class="label ng-binding ng-scope md-cyan-200-bg" role="button" ng-if="data.settlementDetailStatus.name === \'Validado\'"\n' +
                '                                                    translate="SETTLEMENT.SETTLEMENT_DETAIL.STATUS_VALIDATED">\n' +
                '                                                    Validado\n' +
                '                                                </div>\n' +
                '                                                <div class="label ng-binding ng-scope md-red-900-bg" role="button" ng-if="data.settlementDetailStatus.name === \'No Validado\'"\n' +
                '                                                    translate="SETTLEMENT.SETTLEMENT_DETAIL.STATUS_NO_VALIDATED">\n' +
                '                                                    No Validado\n' +
                '                                                </div>\n' +
                '                                                <div class="label ng-binding ng-scope md-indigo-700-bg" role="button" ng-if="data.settlementDetailStatus.name === \'Pre-Provisionado\'"\n' +
                '                                                    translate="SETTLEMENT.SETTLEMENT_DETAIL.STATUS_PRE_PROVISIONED">\n' +
                '                                                    Pre-provisionado\n' +
                '                                                </div>\n' +
                '                                                <div class="label ng-binding ng-scope md-orange-700-bg" role="button" ng-if="data.settlementDetailStatus.name === \'Provisionado\'"\n' +
                '                                                    translate="SETTLEMENT.SETTLEMENT_DETAIL.STATUS_PROVISIONED">\n' +
                '                                                    Provisionado\n' +
                '                                                </div>\n' +
                '                                            </div>';
            }
          },{
            headerName: $filter('translate')('SETTLEMENT.REJECTION_REASON'),
            field: "id",
            width: 200,
            cellRenderer: function (params){
              return '<div ng-if="data.rejectionReason">\n' +
              '                                                {{data.rejectionReason.name}} ({{\'SETTLEMENT.IS_DEFINITIVE_\' + data.rejectionReason.isDefinitive| translate}})\n' +
              '                                                <md-tooltip>\n' +
              '                                                    <span>{{data.rejectionReasonDescription}}</span>\n' +
              '                                                </md-tooltip>\n' +
              '                                            </div>';
            }
          },{
            headerName: $filter('translate')('SETTLEMENT.OPTIONS'),
            field: "id",
            width: 200,
            pinned: 'right',
            cellRenderer: function (params) {
              return '<div>\n' +
                '                                                <md-button class="edit-button md-icon-button" ng-click="vm.viewDetail(data)" aria-label="Product details" ng-if=\'!vm.isVerifier\'\n' +
                '                                                    translate translate-attr-aria-label="SETTLEMENT.VIEW_DETAIL">\n' +
                '                                                    <md-icon md-font-icon="icon-eye" class="s16"></md-icon>\n' +
                '                                                    <md-tooltip>\n' +
                '                                                        <span translate="SETTLEMENT.VIEW_DETAIL">VIEW DETAIL</span>\n' +
                '                                                    </md-tooltip>\n' +
                '                                                </md-button>\n' +
                '                                                <md-button class="edit-button md-icon-button" ng-click="vm.goToInvoicePurchaseEdit(data, $index)" ng-if="vm.canGoToInvoice"\n' +
                '                                                    ng-disabled="vm.activeVerifyButton(data)" translate translate-attr-aria-label="INVOICE.COMPARACION">\n' +
                '                                                    <md-icon md-font-icon="icon-eye" class="s16"></md-icon>\n' +
                '                                                </md-button>\n' +
                '                                                <md-button class="md-icon-button" ng-click="vm.notAuthorizated($index, $event, data)" ng-if="vm.canNotAuthorizedDetail || !data.settlementDetailStatus.name === \'Validado\'"\n' +
                '                                                    aria-label="Delete" translate translate-attr-aria-label="INVOICE.NO_AUTHORIZE"\n' +
                '                                                    ng-disabled="data.settlementDetailStatus.name === \'No Autorizado\' || data.settlementDetailStatus.name === \'Autorización Extra\'">\n' +
                '                                                    <md-icon md-font-icon="icon-thumb-down" class="s16"></md-icon>\n' +
                '                                                    <md-tooltip>\n' +
                '                                                        <span translate="SETTLEMENT.NO_AUTHORIZE">NO_AUTHORIZE</span>\n' +
                '                                                    </md-tooltip>\n' +
                '                                                </md-button>\n' +
                '                                            </div>';
            }
          }
        ];
      } else {
        columns = [
          {
            headerName: $filter('translate')('ID'),
            field: "id",
            width: 100
          },
          {
            headerName: $filter('translate')('SETTLEMENT.TYPE'),
            field: "id",
            width: 190,
            cellRenderer: function (params) {
              var detail = params.data;
              return $filter('translate')(detail.invoicePurchase && detail.invoicePurchase.id > 0 ? 'SETTLEMENT.TYPE_' + detail.invoicePurchase.invoicePurchaseType : 'SETTLEMENT.RECEIPT.RECEIPT');
            }
          },
          {
            headerName: $filter('translate')('SETTLEMENT.NUMBER'),
            field: "id",
            width: 150,
            cellRenderer: function (params) {
              var detail = params.data;
              return detail.invoicePurchase && detail.invoicePurchase.id > 0 ? (detail.invoicePurchase.invoiceSerie ? detail.invoicePurchase.invoiceSerie.serie + '-' :  (detail.invoicePurchase.uuid?(detail.invoicePurchase.uuid.substring(0,8) + '-'):'')) + detail.invoicePurchase.correlative :
                (detail.paymentReceipt.serie ? (detail.paymentReceipt.serie + '-') : '') + detail.paymentReceipt.correlative;
            }
          },
          {
            headerName: $filter('translate')('SETTLEMENT.PROVIDER'),
            field: "id",
            width: 310,
            cellRenderer: function (params) {
              var detail = params.data;
              return detail.invoicePurchase && detail.invoicePurchase.id > 0 ? detail.invoicePurchase.companyProvider.businessName : detail.paymentReceipt.recipientName;
            },
            cellStyle: {'text-align': 'left'}
          },
          {
            headerName: $filter('translate')('SETTLEMENT.TOTAL'),
            field: "id",
            width: 110,
            cellRenderer: function (params) {
              var detail = params.data;
              return '<span ng-class="data.isOverSpend ? \'over-spend\' : \'\'">' +
                vm.pettyCash.currency.symbol + " " + $filter('number')(detail.invoicePurchase && detail.invoicePurchase.id > 0 ? detail.invoicePurchase.totalAfterTax : detail.paymentReceipt.amount) +
                '</span>' +
                '<md-tooltip ng-if="data.isOverSpend" md-direction="top" md-visible="tooltipVisible">{{\'SETTLEMENT.OVER_SPEND\'| translate}}' +
                '</md-tooltip>';
            },
            cellStyle: {'text-align': 'right'}
          },
          {
            headerName: $filter('translate')('SETTLEMENT.DEDUCTIBLE'),
            field: "id",
            width: 220,
            cellStyle: {'text-align': 'right'},
            cellRenderer: function (params) {
              return '<span ng-show="data.expenseDeductible">\n' +
                '                                                Gasto Deducible,\n' +
                '                                            </span>\n' +
                '                                            <span ng-show="data.taxDeductible">\n' +
                '                                                Impuesto Deducible\n' +
                '                                            </span>';
            }
          },
          {
            headerName: $filter('translate')('SETTLEMENT.STATUS'),
            field: "id",
            width: 150,
            cellRenderer: function (params) {
              return '<div class="actions" layout="row" layout-align="start center">\n' +
                '                                                <div class="label ng-binding ng-scope md-green-300-bg" role="button" ng-if="data.settlementDetailStatus.name === \'Ingresando\'"\n' +
                '                                                    translate="SETTLEMENT.SETTLEMENT_DETAIL.STATUS_ENTERING">\n' +
                '                                                    Ingresando\n' +
                '                                                </div>\n' +
                '                                                <div class="label ng-binding ng-scope md-lime-A700-bg" role="button" ng-if="data.settlementDetailStatus.name === \'Autorización Extra\'"\n' +
                '                                                    translate="SETTLEMENT.SETTLEMENT_DETAIL.EXTRA_AUTHORIZATION">\n' +
                '                                                    Autorización Extra\n' +
                '                                                </div>\n' +
                '                                                <div class="label ng-binding ng-scope md-orange-900-bg" role="button" ng-if="data.settlementDetailStatus.name === \'Pendiente de Autorizar\'"\n' +
                '                                                    translate="SETTLEMENT.SETTLEMENT_DETAIL.STATUS_PENDING_AUTHORIZATION">\n' +
                '                                                    Enviada\n' +
                '                                                </div>\n' +
                '                                                <div class="label ng-binding ng-scope md-blue-900-bg" role="button" ng-if="data.settlementDetailStatus.name === \'Autorizado\'"\n' +
                '                                                    translate="SETTLEMENT.SETTLEMENT_DETAIL.STATUS_AUTHORIZED">\n' +
                '                                                    Autorizada\n' +
                '                                                </div>\n' +
                '                                                <div class="label ng-binding ng-scope md-amber-300-bg" role="button" ng-if="data.settlementDetailStatus.name === \'No Autorizado\'"\n' +
                '                                                    translate="SETTLEMENT.SETTLEMENT_DETAIL.STATUS_NO_AUTHORIZED">\n' +
                '                                                    No Autorizada\n' +
                '                                                    <p ng-if=""></p>\n' +
                '                                                </div>\n' +
                '                                                <div class="label ng-binding ng-scope md-cyan-200-bg" role="button" ng-if="data.settlementDetailStatus.name === \'Validado\'"\n' +
                '                                                    translate="SETTLEMENT.SETTLEMENT_DETAIL.STATUS_VALIDATED">\n' +
                '                                                    Validada\n' +
                '                                                </div>\n' +
                '                                                <div class="label ng-binding ng-scope md-red-900-bg" role="button" ng-if="data.settlementDetailStatus.name === \'No Validado\'"\n' +
                '                                                    translate="SETTLEMENT.SETTLEMENT_DETAIL.STATUS_NO_VALIDATED">\n' +
                '                                                    No Validada\n' +
                '                                                </div>\n' +
                '                                            </div>';
            },
            cellStyle: {'text-align': 'center'}
          },
          {
            headerName: $filter('translate')('SETTLEMENT.REJECTION_REASON'),
            field: "id",
            width: 250,
            cellRenderer: function (params) {
              var detail = params.data;
              if (detail.rejectionReason) {
                return '<div ng-if="data.rejectionReason">' +
                  detail.rejectionReason.name + ' ' +
                  $filter('translate')('SETTLEMENT.IS_DEFINITIVE_' + detail.rejectionReason.isDefinitive) +
                  '                                                <md-tooltip>\n' +
                  '                                                    <span>' + detail.rejectionReasonDescription + '</span>\n' +
                  '                                                </md-tooltip>\n' +
                  '                                            </div>';
              } else {
                return '';
              }
            }
          }
        ];
        if (vm.hasBudgetApplication) {
          columns.push({
            suppressMenu: true,
            suppressSorting: true,
            field: "budgeted",
            headerName: $filter('translate')('SETTLEMENT.BUDGETED'),
            width: 250,
            cellRenderer: function (params) {
              if (params.data.invoicePurchase) {
                return '<md-icon md-font-icon="{{data.budgeted ? \'icon-check\' : \'icon-close\'}}"></md-icon>';
              } else {
                if (!params.node.group && !params.data.budgeted) {
                  var products = getBudgetsByProduct(params.data.paymentReceipt.product.id);
                  vm.productBudget[params.data.paymentReceipt.product.id] = getBudgetsByProduct(params.data.paymentReceipt.product.id);

                  params.$scope.isSelected = isSelected;
                  params.$scope.toggleSelectBudget = toggleSelectBudget;
                  params.$scope.validateRequestAmpliation = validateRequestAmpliation;
                  params.data.needExtension = false;

                  if (!params.data.totalCovered) {
                    params.data.totalCovered = 0;
                  }

                  params.data.requestAmpliation = false;


                  if (products.length === 1) {

                    $timeout(function () {
                      if (products[0].available >= params.data.paymentReceipt.documentAmount) {
                        params.$scope.toggleSelectBudget(products[0], null, true);
                      }
                    }, 2000);
                  }

                  return budgetsTemplate;
                } else {
                  return "";
                }
              }
            }
          });
        }
        columns.push({
          suppressMenu: true,
          suppressSorting: true,
          headerName: $filter('translate')('SETTLEMENT.OPTIONS'),
          field: "id",
          width: 110,
          cellRenderer: function (params) {
            if (!params.node.group) {
              return '<md-button class="edit-button md-icon-button" ng-click="vm.editDetail(data)" aria-label="Product details" translate translate-attr-aria-label="SETTLEMENT.EDIT">\n' +
                '                                                    <md-icon md-font-icon="icon-pencil" class="s16"></md-icon>\n' +
                '                                                    <md-tooltip>\n' +
                '                                                        <span translate="SETTLEMENT.EDIT">EDIT DETAIL</span>\n' +
                '                                                    </md-tooltip>\n' +
                '                                                </md-button>\n' +
                '                                                <md-button class="md-icon-button" ng-click="vm.deleteDetail($index, $event, data)" aria-label="Delete" translate translate-attr-aria-label="INVOICE.DELETE">\n' +
                '                                                    <md-icon md-font-icon="icon-delete" class="s16"></md-icon>\n' +
                '                                                    <md-tooltip>\n' +
                '                                                        <span translate="SETTLEMENT.DELETE">DELETE DETAIL</span>\n' +
                '                                                    </md-tooltip>\n' +
                '                                                </md-button>';
            }
          },
          pinned: 'right'
        });
      }
      $timeout(function () {
        if (vm.details.length > 0) {
          vm.gridOptions.api.setColumnDefs(columns);
        }
      }, 200);
    }

    function getBudgetsByProduct(productId) {
      if (vm.productBudget[productId] !== undefined && vm.productBudget[productId] !== null) {
        return vm.productBudget[productId];
      }

      var result = [];

      if (vm.budgets) {
        vm.budgets.forEach(function (row) {

          if (row.product.id === productId) {
            row.available = (row.amountOfficial - (row.amountExecuted ? row.amountExecuted : 0) - (row.amountReserved ? row.amountReserved : 0) - (row.amountNotExecuted ? row.amountNotExecuted : 0)).toFixed(2);
            result.push(row);
          }

        });
      }
      return result;
    }

    function isSelected(budgetDetail) {

      var scopeParent = this.$parent.$parent;

      if (scopeParent.data.references === undefined || scopeParent.data.references === null) {
        scopeParent.data.references = [];
      }

      for (var i = 0; i < scopeParent.data.references.length; i++) {
        if (scopeParent.data.references[i].budgetDetailId === budgetDetail.id) {
          return true;
        }
      }

      return false;
    }

    function toggleSelectBudget(budgetDetail, event, fromParent) {

      var scopeParent;


      if (fromParent) {
        scopeParent = this;
      } else {
        scopeParent = this.$parent;
      }


      scopeParent.data.needExtension = false;
      vm.currentDetail = scopeParent.data;

      if (scopeParent.data.references === undefined || scopeParent.data.references === null || fromParent) {
        scopeParent.data.references = [];
      }

      if (event) {
        event.stopPropagation();
      }

      var selected = false;

      for (var i = 0; i < scopeParent.data.references.length; i++) {
        if (scopeParent.data.references[i].budgetDetailId === budgetDetail.id) {
          scopeParent.data.totalCovered -= scopeParent.data.references[i].amountToUse;
          calculateAvailable(scopeParent.data.references[i].budgetDetailId,
            scopeParent.data.references[i].amountToUse, vm.productBudget[scopeParent.data.paymentReceipt.product.id]);
          scopeParent.data.references.splice(i, 1);
          selected = true;
          break;
        }
      }

      if (!selected) {
        scopeParent.data.needExtension = scopeParent.data.paymentReceipt.amount > budgetDetail.available;

        var reference = {
          referenceId: budgetDetail.id,
          budgetId: budgetDetail.budget.id,
          budgetDetailId: budgetDetail.id,
          amountToUse: parseFloat(scopeParent.data.paymentReceipt.amount) > parseFloat(budgetDetail.available) ?
            parseFloat(budgetDetail.available) :
            parseFloat(scopeParent.data.paymentReceipt.amount),
          budgetStartDate: budgetDetail.budget.startDate,
          budgetEndDate: budgetDetail.budget.endDate,
          currencyCode: budgetDetail.currencyOfficial.code,
          budgetType: budgetDetail.budget.budgetType.description,
          budgetExchangeRateOfficial: budgetDetail.exchangeRateOfficial
        };

        scopeParent.data.references.push(reference);
        scopeParent.data.totalCovered += reference.amountToUse;
        calculateAvailable(budgetDetail.id, reference.amountToUse * -1, vm.productBudget[scopeParent.data.paymentReceipt.product.id]);
        var exist = false;
        vm.detailToAuthorize.forEach(function (data) {
          if (data.id === scopeParent.data.id) {
            exist = true;
          }
        });
        if (vm.detailToAuthorize.length === 0 && scopeParent.data.references.length > 0) {
          exist = true;
          vm.detailToAuthorize.push(scopeParent.data);
        }
        if (!exist && scopeParent.data.references.length > 0) {
          vm.detailToAuthorize.push(scopeParent.data);
        }
      }

      $timeout(function(){
        verifiActiveButtonAuthorize();
      },200);

    }

    function validateRequestAmpliation(event, scope) {
      $timeout(function(){
        verifiActiveButtonAuthorize();
      },200);
    }

    function calculateAvailable(budgetDetailId, amountToAdd, budgetDetailArray) {

      budgetDetailArray.forEach(function (budgetDetail) {
        if (budgetDetailId === budgetDetail.id) {
          budgetDetail.available = parseFloat(budgetDetail.available) + parseFloat(amountToAdd);
        }
      });

    }

    function verifiActiveButtonAuthorize() {
      var verifyAllItems = true;
      vm.detailsPaymentReceipt= new jinqJs()
        .from(vm.details)
        .where(function (r) {
          return r.paymentReceipt && r.paymentReceipt.id > 0;
        })
        .select();
      for (var r = 0; r < vm.detailsPaymentReceipt.length; r++) {
        if (!vm.detailsPaymentReceipt[r].references
          || vm.detailsPaymentReceipt[r].references.length === 0) {
          verifyAllItems = false;
          break;
        }else if(vm.detailsPaymentReceipt[r].references.length>0){
          for(var j=0; j<vm.detailsPaymentReceipt[r].references.length; j++){
            if(vm.detailsPaymentReceipt[r].references[j].amountToUse <
              (vm.detailsPaymentReceipt[r].paymentReceipt.amount)
              && !vm.detailsPaymentReceipt[r].requestAmpliation){
              verifyAllItems = false;
            }
          }
        }
      }
      for (var i = 0; i < vm.details.length; i++) {
        if (vm.details[i].invoicePurchase && !vm.details[i].budgeted) {
          verifyAllItems = false;
          break;
        }
      }
      vm.showButton = verifyAllItems;
    }

    function reserveBudgetBySettlement() {
      vm.detailsSettlement=new jinqJs()
        .from(vm.details)
        .where(function (r) {
          return r.paymentReceipt && r.paymentReceipt.id > 0;
        })
        .select( function (r){
          r['total'] = r.paymentReceipt.amount;
          return r;
        });

      vm.productsToValidate = [];
      vm.detailsSettlement.forEach(function (data){
        var productToValidate = {
          id: data.paymentReceipt.id,
          product: data.paymentReceipt.product,
          amount: data.requestAmpliation ?
            (((data.total) - data.totalCovered) / data.references[data.references.length - 1].budgetExchangeRateOfficial) :
            (data.total),
          referenceAmpliationId: data.references[data.references.length - 1].referenceId,
          unitPrice: 0,
          currency: data.paymentReceipt.currency,
          exchangeRate: data.paymentReceipt.exchangeRate,
          requestAmpliation: data.requestAmpliation,
          references: data.references,
          referenceHeaderId: vm.settlement.id
        };
        vm.productsToValidate.push(productToValidate);
      });
      $rootScope.loadingProgress = true;
      vm.requestAmpliation=false;
      for (var i = 0; i < vm.productsToValidate.length; i++) {
        if (vm.productsToValidate[i].requestAmpliation) {
          vm.requestAmpliation = true;
          break;
        }
      }
      if (vm.requestAmpliation) {
        var productAmpliation = new jinqJs()
          .from(vm.productsToValidate)
          .where(function (r) {
            return r.requestAmpliation;
          })
          .select();
        vm.productsToValidate = productAmpliation;
      }
      if (vm.productsToValidate.length > 0) {
        api.PresupuestosWS.Budget.validatesBudgetedProducts.validate(
          { 'idc': $rootScope.bsCircle.id, originType: '30' }, { quotations: vm.productsToValidate }).$promise.then(function (response) {
          $rootScope.loadingProgress = false;
          vm.productsToValidate = response;
          vm.requestAmpliation = false;
          for (var i = 0; i < vm.productsToValidate.length; i++) {
            if (vm.productsToValidate[i].requestAmpliation) {
              vm.requestAmpliation = true;
              break;
            }
          }
          if (!vm.requestAmpliation) {
            $rootScope.loadingProgress = false;
            vm.showButton = false;
            $rootScope.loadingProgress = true;
            api.ComprasWS.SettlementDetailReference.createReferences.create(
              {
                'id': 0,
                'idCircle': $rootScope.bsCircle.id,
                'isInvoice': false
              }, {'quotations': vm.productsToValidate}).$promise.then(function (responseUp) {
              vm.contractPurchase = responseUp;
              changeStatus();
            }, function (responseErr) {
              $rootScope.loadingProgress = false;
              var msg = 'ERROR';
              if (responseErr.data === 'No Detail') {
                msg = 'DETAIL';
              }

              MessageService.showErrorMessage('REQUISITION.MSG.' + msg);
            });
          } else {
            MessageService.show('CONTRACT.REQUEST_AMPLIATION');
            $state.go('app.invoice.' + $stateParams.status);
            $rootScope.loadingProgress = false;
          }

        }, function (response) {
          vm.showButton = true;
          $rootScope.loadingProgress = false;
          $log.error(response);
        });
      }
    }

    function rowStyleFunction(params) {
      if (params.data.settlementDetailStatus.name === 'No Autorizado') {
        return {background: "#E0E0E0"};
      }
    }

    function verifyExistPaymentReceipt (){
      var exist = false;
      for (var i = 0; i < vm.details.length; i++) {
        if (vm.details[i].paymentReceipt && vm.details[i].paymentReceipt.id > 0) {
          exist = true;
        }
      }
      return exist;
    }

    function getBudgetsTemplate() {
      var resource = $sce.getTrustedResourceUrl('app/main/apps/expenseSettlements/settlements/settlement/settlementEditor/budgetsTemplate.html');

      $templateRequest(resource).then(function (template) {
        budgetsTemplate = template;
      }, function () {
        $log.error("Ocurrio un error al leer el template");
      });
    }

    function getDimensionCompany() {
      vm.dimensionCompanyDetail3 = null;
      vm.dimensionCompanyDetail4 = null;
      vm.dimensionCompanyDetail5 = null;
      api.GeneralWS.DimensionCompany.byCompany.getList(
        { 'company': $rootScope.bsCircle.company.id }
      ).$promise.then(function (responseDimension) {
        for (let i = 0; i < responseDimension.length; i++) {
          if (responseDimension[i].dimensionNumber === vm.NUMBER_THREE) {
            vm.dimensionCompanyDetail3 = responseDimension[i];
          } else if (responseDimension[i].dimensionNumber === vm.NUMBER_FOUR) {
            vm.dimensionCompanyDetail4 = responseDimension[i];
          } else if (responseDimension[i].dimensionNumber === vm.NUMBER_FIVE) {
            vm.dimensionCompanyDetail5 = responseDimension[i];
          } else {
            vm.dimensionCompanyDetail1 = responseDimension[i];
          }
        }
      });
    }

    getBudgetsTemplate();

  }
})();

(function () {
    'use strict';

    angular
        .module('app.expenseSettlement.settlement')
        .controller('createBankDepositeController', createBankDepositeController);

    /** @ngInject */
    function createBankDepositeController($mdDialog, $timeout, $mdToast, $rootScope, pettyCash, api, $log) {
        var vm = this;

        // Data
        vm.pettyCash = pettyCash;

        $log.debug("vm.pettyCash:");
        $log.debug(vm.pettyCash);

        vm.wireTransfer = {
            recipient: vm.pettyCash.holder,
            amount: vm.pettyCash.amountAvailable
        };
        $log.debug("vm.wireTransfer:");
        $log.debug(vm.wireTransfer);

        // Methods
        vm.closeDialog = closeDialog;
        vm.sendForm = sendForm;

        //////////

        function closeDialog() {
            $mdDialog.cancel();
        }

        $timeout(function () {
            var keyEvent = function (event) {
                event.stopPropagation();
            };
            var searchBankAccountInput = document.querySelector("#bankAccount");
            if (searchBankAccountInput) {
                searchBankAccountInput.addEventListener("keydown", keyEvent);
            }
        }, 500);

        init();
        function init() {
            api.ComprasWS.BankAccount.query({ company: $rootScope.bsCircle.company.id }).$promise.then(function (response) {
                vm.bankAccounts = response;
            }, function (error) {
                $log.error(error.data);
            });
        }

        vm.clearSearchBankAccount = function () {
            vm.searchBankAccountType = "";
        };

        function sendForm() {
            vm.loading = true;
            var wireTransfer = {
                wireTransferType: 'DEPOSIT',
                bankAccount: {
                    id: vm.wireTransfer.bankAccount.id
                },
                amount: vm.wireTransfer.amount,
                number: vm.wireTransfer.number,
                documentDate: vm.wireTransfer.documentDate,
                referenceNumber: vm.pettyCash.id,
                recipient: {
                    id: vm.wireTransfer.recipient.id
                }
            };
            $log.debug("wireTransfer");
            $log.debug(wireTransfer);
            api.ComprasWS.WireTransfer.save({ circle: $rootScope.bsCircle.id }, wireTransfer).$promise.then(function (response) {
                vm.wireTransfer = response;
                $mdDialog.hide(vm.wireTransfer);
                showMessage('Se ha generado el pago de devolución para la liquidación');
                vm.loading = false;
            }, function (error) {
                $log.error(error.data);
                vm.loading = false;
            });
        }

        function showMessage(message) {
            $rootScope.loadingProgress = false;
            $mdToast.show({
                template: '<md-toast layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
                hideDelay: 3000,
                position: 'top right'
            });
        }



    }
})();

(function () {
    'use strict';

    angular
        .module('app.reports', ['flow'])
        .config(config)
        .directive('expandGrid', expandGrid);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider) {

        $stateProvider
            .state('app.report', {
                url: '/report',
                abstract: true
            })
            .state('app.report.requisition', {
                url: '/requisition',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/reports/horizontalFilterReport.html',
                        controller: 'ReportsController as vm'
                    }
                },
                resolve: {
                    Report: function (msApi) {
                        return msApi.resolve('report.requisition@get');
                    }
                },
                params: {
                    filter: null
                },
                bodyClass: 'file-manager'
            })
            .state('app.report.requisitionTickets', {
                url: '/requisitionTK',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/reports/horizontalFilterReport.html',
                        controller: 'ReportsController as vm'
                    }
                },
                resolve: {
                    Report: function (msApi) {
                        return msApi.resolve('report.requisitionTickets@get');
                    }
                },
                params: {
                    filter: null,
                    isTicket: true
                },
                bodyClass: 'file-manager'
            })
            .state('app.report.requisitionAll', {
                url: '/requisitionAll',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/reports/horizontalFilterReport.html',
                        controller: 'ReportsController as vm'
                    }
                },
                resolve: {
                    Report: function (msApi) {
                        return msApi.resolve('report.requisitionAll@get');
                    }
                },
                params: {
                    filter: null
                },
                bodyClass: 'file-manager'
            })
            .state('app.report.reportUserQuote', {
                url: '/reportUserQuote',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/reports/horizontalFilterReport.html',
                        controller: 'ReportsController as vm'
                    }
                },
                resolve: {
                    Report: function (msApi) {
                        return msApi.resolve('report.reportUserQuote@get');
                    }
                },
                params: {
                    filter: null
                },
                bodyClass: 'file-manager'
            })
            .state('app.report.orderP', {
                url: '/porder',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/reports/horizontalFilterReport.html',
                        controller: 'ReportsController as vm'
                    }
                },
                resolve: {
                    Report: function (msApi) {
                        return msApi.resolve('report.order.provider@get');
                    }
                },
                params: {
                    filter: null,
                    provider: true
                },
                bodyClass: 'file-manager'
            })
            .state('app.report.orderC', {
                url: '/corder',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/reports/horizontalFilterReport.html',
                        controller: 'ReportsController as vm'
                    }
                },
                resolve: {
                    Report: function (msApi) {
                        return msApi.resolve('report.order.client@get');
                    }
                },
                params: {
                    filter: null
                },
                bodyClass: 'file-manager'
            })
            .state('app.report.orderAll', {
                url: '/order-all',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/reports/horizontalFilterReport.html',
                        controller: 'ReportsController as vm'
                    }
                },
                resolve: {
                    Report: function (msApi) {
                        return msApi.resolve('report.order.client.all@get');
                    }
                },
                params: {
                    filter: null
                },
                bodyClass: 'file-manager'
            })
            .state('app.report.quotationP', {
                url: '/pquotation',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/reports/horizontalFilterReport.html',
                        controller: 'ReportsController as vm'
                    }
                },
                params: {
                    filter: null
                },
                resolve: {
                    Report: function (msApi) {
                        return msApi.resolve('report.quotation.provider@get');
                    }
                },
                bodyClass: 'file-manager'
            })
            .state('app.report.quotationAll', {
                url: '/quotationAll',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/reports/horizontalFilterReport.html',
                        controller: 'ReportsController as vm'
                    }
                },
                params: {
                    filter: null
                },
                resolve: {
                    Report: function (msApi) {
                        return msApi.resolve('report.quotation.client.all@get');
                    }
                },
                bodyClass: 'file-manager'
            })
            .state('app.report.quotationC', {
                url: '/cquotation?{id:int}',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/reports/horizontalFilterReport.html',
                        controller: 'ReportsController as vm'
                    }
                },
                params: {
                    filter: null
                },
                resolve: {
                    Report: function (msApi) {
                        return msApi.resolve('report.quotation.client@get');
                    }
                },
                bodyClass: 'file-manager'
            })
            .state('app.report.invoiceP', {
                url: '/pinvoice',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/reports/horizontalFilterReport.html',
                        controller: 'ReportsController as vm'
                    }
                },
                params: {
                    filter: null
                },
                resolve: {
                    Report: function (msApi) {
                        return msApi.resolve('report.invoice.provider@get');
                    }
                },
                bodyClass: 'file-manager'
            })
            .state('app.report.invoiceP.detail', {
                url: '/detail/:id?{cl}',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/invoice/purchases/invoice.html',
                        controller: 'PurchaseInvoiceController as vm'
                    }
                },
                params: {
                    cl: null,
                    filter: null,
                    backTo: null
                }
            })
            .state('app.report.invoiceC', {
                url: '/cinvoice',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/reports/horizontalFilterReport.html',
                        controller: 'ReportsController as vm'
                    }
                },
                params: {
                    filter: null
                },
                resolve: {
                    Report: function (msApi) {
                        return msApi.resolve('report.invoice.client@get');
                    }
                },
                bodyClass: 'file-manager'
            })
            .state('app.report.invoiceAll', {
                url: '/invoiceAll',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/reports/horizontalFilterReport.html',
                        controller: 'ReportsController as vm'
                    }
                },
                params: {
                    filter: null
                },
                resolve: {
                    Report: function (msApi) {
                        return msApi.resolve('report.invoice.client.all@get');
                    }
                },
                bodyClass: 'file-manager'
            })

            .state('app.report.erpPendingsend', {
                url: '/erp-pending-send',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/reports/horizontalFilterReport.html',
                        controller: 'ReportsController as vm'
                    }
                },
                params: {
                    filter: null
                },
                resolve: {
                    Report: function (msApi) {
                        return msApi.resolve('report.invoice.erp.psend@get');
                    }
                },
                bodyClass: 'file-manager'
            })
            .state('app.report.erpPendingconfirm', {
                url: '/erp-pending-confirm',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/reports/horizontalFilterReport.html',
                        controller: 'ReportsController as vm'
                    }
                },
                params: {
                    filter: null
                },
                resolve: {
                    Report: function (msApi) {
                        return msApi.resolve('report.invoice.erp.pconfirm@get');
                    }
                },
                bodyClass: 'file-manager'
            })
            .state('app.report.erpPendingcancel', {
                url: '/erp-pending-cancel',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/reports/horizontalFilterReport.html',
                        controller: 'ReportsController as vm'
                    }
                },
                params: {
                    filter: null
                },
                resolve: {
                    Report: function (msApi) {
                        return msApi.resolve('report.invoice.erp.pcancel@get');
                    }
                },
                bodyClass: 'file-manager'
            })

            .state('app.report.invoiceC.detail', {
                url: '/detail/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/invoice/purchases/invoice.html',
                        controller: 'PurchaseInvoiceController as vm'
                    }
                },
                params: {
                    filter: null,
                    backTo: null
                }
            })
            .state('app.contract.report', {
                url: '/contract',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/reports/horizontalFilterReport.html',
                        controller: 'ReportsController as vm'
                    }
                },
                resolve: {
                    Report: function (msApi) {
                        return msApi.resolve('report.contract.client@get');
                    }
                },
                params: {
                    filter: null,
                    backTo: null
                },
                bodyClass: 'file-manager'
            })
            .state('app.contract.reportAll', {
                url: '/contractAll',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/reports/horizontalFilterReport.html',
                        controller: 'ReportsController as vm'
                    }
                },
                resolve: {
                    Report: function (msApi) {
                        return msApi.resolve('report.contract.client.all@get');
                    }
                },
                params: {
                    filter: null,
                    backTo: null
                },
                bodyClass: 'file-manager'
            })
            .state('app.contract.reportP', {
                url: '/contractP',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/reports/horizontalFilterReport.html',
                        controller: 'ReportsController as vm'
                    }
                },
                resolve: {
                    Report: function (msApi) {
                        return msApi.resolve('report.contract.provider@get');
                    }
                },
                params: {
                    filter: null,
                    backTo: null
                },
                bodyClass: 'file-manager'
            })
            .state('app.merchandiseEntry.merchandiseEntry', {
                url: '/merchandiseEntry',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/reports/horizontalFilterReport.html',
                        controller: 'ReportsController as vm'
                    }
                },
                resolve: {
                    Report: function (msApi) {
                        return msApi.resolve('report.merchandise.client@get');
                    }
                },
                params: {
                    filter: null,
                    backTo: null
                },
                bodyClass: 'file-manager'
            })
            .state('app.report.Settlement', {
                url: '/settlement',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/reports/horizontalFilterReport.html',
                        controller: 'ReportsController as vm'
                    }
                },
                resolve: {
                    Report: function (msApi) {
                        return msApi.resolve('report.Settlement.client@get');
                    }
                },
                params: {
                    filter: null,
                    backTo: null
                },
                bodyClass: 'file-manager'
            })
            .state('app.quotation.reportPendingAuthorize', {
                url: '/quotationP',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/reports/horizontalFilterReport.html',
                        controller: 'ReportsController as vm'
                    }
                },
                resolve: {
                    Report: function (msApi) {
                        return msApi.resolve('report.quotation.reportPendingAuthorize@get');
                    }
                },
                params: {
                    filter: null,
                    backTo: null
                },
                bodyClass: 'file-manager'
            })
            .state('app.quotation.reportPendingApprove', {
                url: '/quotationPA',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/reports/horizontalFilterReport.html',
                        controller: 'ReportsController as vm'
                    }
                },
                resolve: {
                    Report: function (msApi) {
                        return msApi.resolve('report.quotation.reportPendingApprove@get');
                    }
                },
                params: {
                    filter: null,
                    backTo: null
                },
                bodyClass: 'file-manager'
            })
            .state('app.quotation.reportDetailPendingApprove', {
                url: '/detailQuotationPA',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/reports/horizontalFilterReport.html',
                        controller: 'ReportsController as vm'
                    }
                },
                resolve: {
                    Report: function (msApi) {
                        return msApi.resolve('report.quotation.reportDetailPendingApprove@get');
                    }
                },
                params: {
                    filter: null,
                    backTo: null
                },
                bodyClass: 'file-manager'
            })
            .state('app.order.reportPendingDelivery', {
                url: '/order',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/reports/horizontalFilterReport.html',
                        controller: 'ReportsController as vm'
                    }
                },
                resolve: {
                    Report: function (msApi) {
                        return msApi.resolve('report.order.reportPendingDelivery@get');
                    }
                },
                params: {
                    filter: null,
                    backTo: null
                },
                bodyClass: 'file-manager'
            })
            .state('app.report.canceledAutomatically', {
                url: '/invoiceReport',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/reports/horizontalFilterReport.html',
                        controller: 'ReportsController as vm'
                    }
                },
                resolve: {
                    Report: function (msApi) {
                        return msApi.resolve('report.invoice.reportCanceledAutomatically@get');
                    }
                },
                params: {
                    filter: null,
                    backTo: null
                },
                bodyClass: 'file-manager'
            })
            .state('app.expenseSettlement.pettyCash.reportPettyCash', {
                url: '/pettyCashReport',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/reports/horizontalFilterReport.html',
                        controller: 'ReportsController as vm'
                    }
                },
                resolve: {
                    Report: function (msApi) {
                        return msApi.resolve('report.settlement.pettyCash@get');
                    }
                },
                params: {
                    filter: null,
                    backTo: null
                },
                bodyClass: 'file-manager'
            })
            .state('app.expenseSettlement.settlement.provisioned', {
                url: '/settlementProvisioned',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/reports/horizontalFilterReport.html',
                        controller: 'ReportsController as vm'
                    }
                },
                resolve: {
                    Report: function (msApi) {
                        return msApi.resolve('report.settlement.settlementProvisioned@get');
                    }
                },
                params: {
                    filter: null,
                    backTo: null,
                    status: 'Provisionada',
                    otherOptions: true
                },
                bodyClass: 'file-manager'
            })
            .state('app.expenseSettlement.provisioned', {
                url: '/settlementProvisionedVerify',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/reports/horizontalFilterReport.html',
                        controller: 'ReportsController as vm'
                    }
                },
                resolve: {
                    Report: function (msApi) {
                        return msApi.resolve('report.settlement.settlementProvisionedRoleVerify@get');
                    }
                },
                params: {
                    filter: null,
                    backTo: null,
                    status: 'Provisionada',
                    roleVerify: true
                },
                bodyClass: 'file-manager'
            })
            .state('app.expenseSettlement.paidSettlements', {
                url: '/paidSettlements',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/reports/horizontalFilterReport.html',
                        controller: 'ReportsController as vm'
                    }
                },
                resolve: {
                    Report: function (msApi) {
                        return msApi.resolve('report.settlement.settlementProvisioned@get');
                    }
                },
                params: {
                    filter: null,
                    backTo: null,
                    status: 'Pagada',
                    showButtonCancelPayment: true
                },
                bodyClass: 'file-manager'
            })
            .state('app.physicalDocumentDelivery.consult', {
                url: '/physicalDocumentDelivery',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/reports/horizontalFilterReport.html',
                        controller: 'ReportsController as vm'
                    }
                },
                resolve: {
                    Report: function (msApi) {
                        return msApi.resolve('report.physicalDocumentDelivery.physicalDocumentDelivery@get');
                    }
                },
                params: {
                    filter: null,
                    backTo: null,
                },
                bodyClass: 'file-manager'
            })
            .state('app.reports.reportWithholding', {
                url: '/reportWithholding',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/reports/horizontalFilterReport.html',
                        controller: 'ReportsController as vm'
                    }
                },
                resolve: {
                    Report: function (msApi) {
                        return msApi.resolve('report.invoicePurchaseWithholding.invoicePurchaseWithholding@get');
                    }
                },
                params: {
                    filter: null,
                    backTo: null
                },
                bodyClass: 'file-manager'
            })
            .state('app.reports.reportWithholding.detail', {
                url: '/detail/:id?{cl}',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/invoice/purchases/invoice.html',
                        controller: 'PurchaseInvoiceController as vm'
                    }
                },
                params: {
                    cl: null,
                    filter: null,
                    backTo: null
                }
            })
            .state('app.shippingOrder.consult', {
                url: '/consult',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/reports/horizontalFilterReport.html',
                        controller: 'ReportsController as vm'
                    }
                },
                resolve: {
                    Report: function (msApi) {
                        return msApi.resolve('report.shippingOrder.consultShippingOrder@get');
                    }
                },
                params: {
                    filter: null,
                    backTo: null
                },
                bodyClass: 'file-manager'
            })
            .state('app.reports.detailRequisitionAndPurchase', {
                url: '/detailRequisitionAndPurchase',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/reports/horizontalFilterReport.html',
                        controller: 'ReportsController as vm'
                    }
                },
                resolve: {
                    Report: function (msApi) {
                        return msApi.resolve('report.detailRequisitionAndPurchase@get');
                    }
                },
                params: {
                    filter: null,
                    backTo: null
                },
                bodyClass: 'file-manager'
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/reports');

        // Api
        msApiProvider.register('report.requisition', ['app/main/apps/reports/data/requisition.json']);
        msApiProvider.register('report.requisitionTickets', ['app/main/apps/reports/data/requisitionTickets.json']);
        msApiProvider.register('report.requisitionAll', ['app/main/apps/reports/data/requisitionAll.json']);
        msApiProvider.register('report.reportUserQuote', ['app/main/apps/reports/data/reportUserQuote.json']);
        msApiProvider.register('report.order.provider', ['app/main/apps/reports/data/order.provider.json']);
        msApiProvider.register('report.order.client', ['app/main/apps/reports/data/order.client.json']);
        msApiProvider.register('report.order.client.all', ['app/main/apps/reports/data/order.client.all.json']);
        msApiProvider.register('report.quotation.provider', ['app/main/apps/reports/data/quotation.provider.json']);
        msApiProvider.register('report.quotation.client', ['app/main/apps/reports/data/quotation.client.json']);
        msApiProvider.register('report.quotation.client.all', ['app/main/apps/reports/data/quotation.client.all.json']);
        msApiProvider.register('report.invoice.provider', ['app/main/apps/reports/data/invoice.provider.json']);
        msApiProvider.register('report.invoice.client', ['app/main/apps/reports/data/invoice.client.json']);
        msApiProvider.register('report.invoice.client.all', ['app/main/apps/reports/data/invoice.client.all.json']);
        msApiProvider.register('report.invoice.erp.psend', ['app/main/apps/reports/data/invoice.erp.psend.json']);
        msApiProvider.register('report.invoice.erp.pconfirm', ['app/main/apps/reports/data/invoice.erp.pconfirm.json']);
        msApiProvider.register('report.invoice.erp.pcancel', ['app/main/apps/reports/data/invoice.erp.pcancel.json']);
        msApiProvider.register('report.contract.client', ['app/main/apps/reports/data/contract.client.json']);
        msApiProvider.register('report.contract.provider', ['app/main/apps/reports/data/contract.provider.json']);
        msApiProvider.register('report.contract.client.all', ['app/main/apps/reports/data/contract.client.all.json']);
        msApiProvider.register('report.merchandise.client', ['app/main/apps/reports/data/merchandise.client.json']);
        msApiProvider.register('report.Settlement.client', ['app/main/apps/reports/data/settlement.json']);
        msApiProvider.register('report.quotation.reportPendingAuthorize', ['app/main/apps/reports/data/quotationPendingAuthorize.json']);
        msApiProvider.register('report.quotation.reportPendingApprove', ['app/main/apps/reports/data/quotationPendingApprove.json']);
        msApiProvider.register('report.quotation.reportDetailPendingApprove', ['app/main/apps/reports/data/reportDetailPendingApprove.json']);
        msApiProvider.register('report.order.reportPendingDelivery', ['app/main/apps/reports/data/orderPendingDelivery.json']);
        msApiProvider.register('report.invoice.reportCanceledAutomatically', ['app/main/apps/reports/data/invoiceCanceledAutomatically.json']);
        msApiProvider.register('report.settlement.pettyCash', ['app/main/apps/reports/data/pettyCash.json']);
        msApiProvider.register('report.settlement.settlementProvisioned', ['app/main/apps/reports/data/settlementProvisioned.json']);
        msApiProvider.register('report.settlement.settlementProvisionedRoleVerify', ['app/main/apps/reports/data/settlementProvisionedRoleVerify.json']);
        msApiProvider.register('report.physicalDocumentDelivery.physicalDocumentDelivery', ['app/main/apps/reports/data/physicalDocumentDelivery.json']);
        msApiProvider.register('report.invoicePurchaseWithholding.invoicePurchaseWithholding', ['app/main/apps/reports/data/invoicePurchaseWithholding.json']);
        msApiProvider.register('report.shippingOrder.consultShippingOrder', ['app/main/apps/reports/data/shippingOrder.json']);
        msApiProvider.register('report.detailRequisitionAndPurchase', ['app/main/apps/reports/data/detailRequisitionAndPurchase.json']);
    }

    function expandGrid() {
        var directive = {
            link: link, // The function attaching the behavior
            restrict: 'A' // Restrict directive to be used only as attribute
        };
        return directive;


        function link(scope, element, attrs) {

            var gridElement = $(element);
            var idGrid = attrs.id;
            var min = attrs.min ? parseInt(attrs.min) : 250;
            var other = attrs.other ? parseInt(attrs.other) : 0;
            resizeGridM("#" + idGrid, other, min);
            // Attach an eventHandler to the resize event of the
            // window to resize the data area of the grid accordingly
            scope.$watch(
                function () {
                    return gridElement.parent().height();
                },
                function (height) {
                    resizeGridM("#" + idGrid, other, min);
                });
        }
    }
    function resizeGridM(gridName, other, min) {
        //Define Elements Needed
        var grid = $(gridName);

        other = other ? other : 0;
        //Other variables
        var minimumAcceptableGridHeight = min ? min : 250; //This is roughly 5 rows

        //Get Window Height
        var windowHeight = $(window).innerHeight();

        //Padding you want to apply below your page
        var bottomPadding = 60;

        //Check if Calculated height is below threshold
        var calculatedHeight = windowHeight - bottomPadding - other - 150;
        var finalHeight = calculatedHeight < minimumAcceptableGridHeight ? minimumAcceptableGridHeight : calculatedHeight;

        //Apply the height for the content area
        grid.css('height', finalHeight + 'px');
    }

})();

(function () {
    'use strict';
    angular
        .module('app.reports')
        .controller('ReportShowPDFController', ReportShowPDFController);
    /** @ngInject */
    function ReportShowPDFController($mdDialog, Url, $sce, envService) {
        var vm = this;

        vm.report = $sce.trustAsResourceUrl(envService.read('baseUrlJReportsWSPdf') + '?rpt=' + Url);

        vm.cancel = function () {
            $mdDialog.cancel();
        };

    }
})();

(function () {

    'use strict';

    angular
        .module('app.reports')
        .controller('AuditLogController', AuditLogController);

    function AuditLogController($mdDialog, api, $filter, $timeout, id, type) {

        var vm = this;

        vm.masterGridOptions = {
            enableSorting: true,
            debug: false,
            enableFilter: true,
            enableColResize: true,
            angularCompileRows: true,
            angularCompileHeaders: true,
            groupSuppressBlankHeader: true,
            toolPanelSuppressGroups: true,
            groupHeaders: false,
            fullWidthCellRenderer: true,
            rowData: [],
            pinnedBottomRowData: [],
            rowHeight: 45,
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            },
            columnDefs: [
                {
                    suppressMenu: true,
                    suppressSorting: false,
                    headerName: "REPORT.LOGS.USER",
                    headerCellRenderer: getHeader,
                    field: "user",
                    width: 200,
                    enableRowGroup: false,
                    enablePivot: false
                },
                {
                    headerName: "REPORT.LOGS.DATE",
                    field: "modificationDate",
                    headerCellRenderer: getHeader,
                    valueFormatter: function (params) {
                        if (params.value === undefined || params.value === null) {
                            return '';
                        } else {
                            return $filter('date')(new Date(params.value), 'dd/MM/yyyy HH:mm:ss');
                        }
                    },
                    enableRowGroup: true,
                    enablePivot: true
                },
                {
                    suppressMenu: true,
                    suppressSorting: false,
                    headerName: "REPORT.LOGS.STATUS",
                    headerCellRenderer: getHeader,
                    field: "statusName",
                    width: 200,
                    enableRowGroup: false,
                    enablePivot: false
                }
            ]
        };

        //methods
        vm.closeDialog = closeDialog;

        function closeDialog() {
            $mdDialog.cancel();
        }

        function init() {
            var element = $("#transactionDetailMasterGridOptions");

            if (element && element.length) {
                var dialogHeight = element[0].parentElement.offsetHeight;
                dialogHeight -= 40;

                element.css('height', dialogHeight + 'px');
            }

            vm.loading = true;

            if (type === 1) {
                api.ComprasWS.Requisitions.Audit.get({ id: id }, function (data) {
                    vm.masterGridOptions.api.setRowData(data);
                    vm.showGrid = true;
                    vm.loading = false;
                });
            }

            if (type === 2) {
                api.ComprasWS.Quotation.Audit.get({ companyId: 0, id: id }, function (data) {
                    vm.masterGridOptions.api.setRowData(data);
                    vm.showGrid = true;
                    vm.loading = false;
                });
            }

            if (type === 3) {
                api.ComprasWS.PurchaseOrders.Audit.get({ id: id }, function (data) {
                    vm.masterGridOptions.api.setRowData(data);
                    vm.showGrid = true;
                    vm.loading = false;
                });
            }

            if (type === 4) {
                api.ComprasWS.InvoicePurchaseAudit.Audit.get({ id: id }, function (data) {
                    vm.masterGridOptions.api.setRowData(data);
                    vm.showGrid = true;
                    vm.loading = false;
                });
            }
        }

        $timeout(init, 1000);

    }

})();

(function () {

    'use strict';

    angular
        .module('app.reports')
        .controller('InvoiceReportDetailController', InvoiceReportDetailController);

    function InvoiceReportDetailController($rootScope, api, $mdDialog, detail, invoiceId, $log) {

        var vm = this;
        //methods
        vm.closeDialog = closeDialog;
        vm.detailsSettlement = detail;
        vm.loadFiles = loadFiles;
        vm.URLPHOTOS = api.baseUrlPhotos;
        vm.viewIMG = viewIMG;
        vm.dimensionCompanyDetail3 = null;
        vm.dimensionCompanyDetail4 = null;
        vm.dimensionCompanyDetail5 = null;


        function closeDialog() {
            $mdDialog.cancel();
        }

        init();
        function init() {
            if (vm.detailsSettlement.invoicePurchaseType === 'RECEIPT') {
                api.ComprasWS.PaymentReceipt.get({ id: invoiceId }, function (response) {
                    vm.receipt = response;
                    vm.filesReceipt = vm.receipt.files;
                    $log.debug(vm.details);
                }, function (error) {
                    $log.error(error.data);

                });
            } else {
                api.ComprasWS.InvoicePurchaseDetail.byInvoice(
                    { id: 'byInvoicePurchase', invoiceId: invoiceId, idCircle: $rootScope.bsCircle.id }, function (response) {
                        vm.details = response;
                        loadFiles();
                    }, function (error) {
                        $log.error(error.data);
                    });
            }
            getDimensionCompany();

        }

        function loadFiles() {
            api.ComprasWS.InvoicePurchaseFiles.get({ id: invoiceId }, function (response) {
                vm.filesPurchase = response;
            }, function (response) {// Error
                $log.error(response);
                vm.loading = false;
                $rootScope.loadingProgress = false;
            });


        }

        function viewIMG(file) {
            $mdDialog.show({
                controller: 'DialogPhotoController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/files/dialogPhoto/dialogPhoto.html',
                parent: angular.element("#main"),
                name: file.originalName,
                url: vm.URLPHOTOS + file.parentPath + file.name + file.extension,
                clickOutsideToClose: false
            }).then(function (answer) {
            });
        }

        function getDimensionCompany() {
            const NUMBER_DIMENSION_THREE = 3;
            const NUMBER_DIMENSION_FOUR = 4;
            const NUMBER_DIMENSION_FIVE = 5;
            api.GeneralWS.DimensionCompany.byCompany.getList(
                { 'company': $rootScope.bsCircle.company.id }
            ).$promise.then(function (responseDimension) {
                for (let i = 0; i < responseDimension.length; i++) {
                    if (responseDimension[i].dimensionNumber === NUMBER_DIMENSION_THREE) {
                        vm.dimensionCompanyDetail3 = responseDimension[i];
                    } else if (responseDimension[i].dimensionNumber === NUMBER_DIMENSION_FOUR) {
                        vm.dimensionCompanyDetail4 = responseDimension[i];
                    } else if (responseDimension[i].dimensionNumber === NUMBER_DIMENSION_FIVE) {
                        vm.dimensionCompanyDetail5 = responseDimension[i];
                    } else {
                        vm.dimensionCompanyDetail1 = responseDimension[i];
                    }
                }
            });
        }
    }

})();

(function () {

    'use strict';

    angular
        .module('app.reports')
        .controller('GeneralInterfazReportDetailController', generalInterfazReportDetailController);

    function generalInterfazReportDetailController($mdDialog, api, $filter, $timeout, entity, id, companyId) {

        var vm = this;

        vm.masterGridOptions = {
            enableSorting: true,
            debug: false,
            enableFilter: true,
            enableColResize: true,
            angularCompileRows: true,
            angularCompileHeaders: true,
            groupSuppressBlankHeader: true,
            toolPanelSuppressGroups: true,
            groupHeaders: false,
            fullWidthCellRenderer: true,
            rowData: [],
            pinnedBottomRowData: [],
            rowHeight: 45,
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            },
            columnDefs: [
                {
                    headerName: "REPORT.date",
                    field: "createdAt",
                    headerCellRenderer: getHeader,
                    valueFormatter: function (params) {
                        if (params.value === undefined || params.value === null) {
                            return '';
                        } else {
                            return $filter('apiDate')(params.value, 'dd/MM/yyyy HH:mm:ss');
                        }
                    },
                    enableRowGroup: true,
                    enablePivot: true
                },
                {
                    suppressMenu: true,
                    suppressSorting: false,
                    headerName: "REPORT.message",
                    headerCellRenderer: getHeader,
                    field: "messageDetail",
                    width: 500,
                    enableRowGroup: false,
                    enablePivot: false
                }
            ]
        };

        //methods
        vm.closeDialog = closeDialog;

        function closeDialog() {
            $mdDialog.cancel();
        }

        function init() {
            var element = $("#transactionDetailMasterGridOptions");

            if (element && element.length) {
                var dialogHeight = element[0].parentElement.offsetHeight;
                dialogHeight -= 40;

                element.css('height', dialogHeight + 'px');
            }

            var parameters = {
                companyId: companyId,
                pageNumber: 0,
                pageSize: 20
            };

            vm.filter = {
                entityCatalogIdList: [entity.id],
                theId: id
            };

            vm.loading = true;
            api.InterfazWS.InterfazTransaction.findByFilter.page(parameters, vm.filter).$promise.then(function (response) {

                var info = [];
                if (response.content) {
                    for (var i = 0; i < response.content.length; i++) {
                        for (var j = 0; j < response.content[i].details.length; j++) {
                            info.push(response.content[i].details[j]);
                        }
                    }
                }

                vm.masterGridOptions.api.setRowData(info);
                vm.showGrid = true;
                vm.loading = false;
            }, function (response) {
                vm.loading = false;
            });
        }

        $timeout(init, 1000);

    }

})();

(function () {

    'use strict';

    angular
        .module('app.notifications', [])
        .config(config);

    function config($stateProvider) {

        $stateProvider
            .state('app.notifications', {
                url: '/notifications',
                abstract: true
            })
            .state('app.notifications.MyNotifications', {
                url: '/my-notifications',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/general/notifications/my-notifications/my-notifications.html',
                        controller: 'MyNotifications as vm'
                    }
                }
            })
            .state('app.notifications.Configuration', {
                url: '/configuration',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/general/notifications/configuration/configuration.html',
                        controller: 'NotificationConfigurationController as vm'
                    }
                }
            });

    }

})();

(function () {

    'use strict';

    angular
        .module('app.notifications')
        .controller('MyNotificationsFilterController', MyNotificationsFilterController);

    function MyNotificationsFilterController(api, $scope, $timeout, $log) {

        var vm = $scope.vm;
        var filterCtrl = this;

        filterCtrl.search = search;
        filterCtrl.changeStartDate = changeStartDate;
        filterCtrl.clearSearchCompany = clearSearchCompany;
        filterCtrl.clearSearchApplication = clearSearchApplication;
        filterCtrl.clearFilters = clearFilters;


        function clearFilters() {
            vm.filter = {
                filterByDates: false,
                startDate: new Date(),
                endDate: new Date(),
                applications: [],
                companies: []
            };

            search();
        }

        function changeStartDate(isStart) {
            if (isStart) {
                if (vm.filter.startDate > vm.filter.endDate) {
                    vm.filter.endDate = vm.filter.startDate;
                }
            }
            vm.filter.startDate = setDateType(vm.filter.startDate, false);
            vm.filter.endDate = setDateType(vm.filter.endDate, true);
        }

        function setDateType(date, end) {
            if (end) {
                date.setHours(23);
                date.setMinutes(59);
                date.setSeconds(59);
            } else {
                date.setHours(0);
                date.setMinutes(0);
                date.setSeconds(0);
            }
            return date;
        }

        function getCompanies() {
            api.GeneralWS.CompanyUser.query({}).$promise.then(function (response) {
                filterCtrl.companyArray = response;
            }, function (response) {
                $log.error(response);
            });
        }

        function search(event) {
            vm.showAdvancedFilter = false;
            vm.getMyNotifications();
        }

        function clearSearchCompany() {
            filterCtrl.searchCompany = "";
        }

        function clearSearchApplication() {
            filterCtrl.searchApplication = "";
        }

        function init() {

            getCompanies();

            var keyEvent = function (event) {
                event.stopPropagation();
            };

            var searchCompanyInput = document.querySelector("#searchCompanyInput");
            var searchApplicationInput = document.querySelector("#searchApplicationInput");

            if (searchCompanyInput) {
                searchCompanyInput.addEventListener("keydown", keyEvent);
            }

            if (searchApplicationInput) {
                searchApplicationInput.addEventListener("keydown", keyEvent);
            }

        }

        $timeout(init, 1000);

    }

})();

(function () {
    'use strict';

    angular.module('app.auth.checkPassword', [])
        .directive('pwCheck', [function () {
            return {
                require: 'ngModel',
                link: function (scope, elem, attrs, ctrl) {
                    var firstPassword = '#' + attrs.pwCheck;
                    elem.add(firstPassword).on('keyup', function () {
                        scope.$apply(function () {
                            var v = elem.val() === $(firstPassword).val();
                            ctrl.$setValidity('pwmatch', v);
                        });
                    });
                }
            };
        }]);
})();

(function () {
    'use strict';

    angular.module('app.auth.strengthPassword', [])
        .directive('myPasswordStrength', ['passwordStrengthService',
            function (service) {

                function updateValues(password, scope) {
                    password = password || '';
                    scope.lengthLevel = service.getLengthLevel(password);
                    scope.strengthLevel = service.getStrengthLevel(password);
                    scope.strengthLabel = service.getLabel(scope.strengthLevel);
                }

                function link(scope) {
                    scope.$watch('password', function (password) {
                        updateValues(password, scope);
                    });
                }

                return {
                    restrict: 'EA',
                    replace: true,
                    scope: { password: '=' },
                    templateUrl: 'app/main/general/auth/directives/strengthPassword/strengthPassword.tpl.html',
                    link: link
                };
            }])

        .factory('passwordStrengthService', ['passwordStrengthConstants',
            function (constant) {
                var _matchPatterns = constant.patterns;
                var _maxLengthLevel = constant.maxLengthLevel;

                function _getStrengthLevel(password) {
                    for (var level in _matchPatterns) {
                        if (_matchPatterns[level].test(password)) {
                            return level;
                        }
                    }
                }

                function _getLengthLevel(password) {
                    var level = password.length / _maxLengthLevel * 100;
                    return level < 100 ? level : 100;
                }

                function _getLabel(level) {
                    return constant.labels[level];
                }

                return {
                    getStrengthLevel: _getStrengthLevel,
                    getLengthLevel: _getLengthLevel,
                    getLabel: _getLabel
                };
            }])

        .constant('passwordStrengthConstants', {
            patterns: {
                empty: /^$/i, // not looping if empty
                strong: /^.*(?=.{8,})(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*\W).*$/, // 8+ sym, small+capital, digits, alpha
                medium: /^.*(?=.{6,})(?=.*[a-z])(?=.*[\d\W]).*$/i, // 6+ sym letters, digits
                weak: /^.*(?=.{6,})(?=.*[a-z\d]).*$/i, // 6+ letters or digits
                useless: /^.*$/i                                                  // anything other
            },
            labels: {
                empty: 'pwdCheck.pwdIsRequired',
                strong: 'pwdCheck.strong',
                medium: 'pwdCheck.medium',
                weak: 'pwdCheck.weak',
                useless: 'pwdCheck.useless'
            },
            maxLengthLevel: 20
        });



})();

(function () {

    'use strict';

    angular
        .module('app.quotation')
        .controller('QuotationPendingAuthorizeTicketDetailController', QuotationPendingAuthorizeTicketDetailController);

    function QuotationPendingAuthorizeTicketDetailController($mdDialog, $templateRequest, $sce, $rootScope, $timeout,
        $filter, $log, api, MessageService, $stateParams, $state) {

        if ($stateParams.requisitionArray === null || $stateParams.requisitionArray === undefined) {
            $state.go('app.quotation.Ingresada', {});
            return null;
        }

        var vm = this;
        var budgetsTemplate = null;
        var editQuantityTemplate = null;
        vm.dimensionCompanyDetail3 = null;
        vm.dimensionCompanyDetail4 = null;
        vm.dimensionCompanyDetail5 = null;

        vm.productBudget = {};
        vm.indexView = 0;
        vm.requisitionArray = $stateParams.requisitionArray;
        vm.gridOptions = {
            columnDefs: [],
            suppressContextMenu: true,
            groupHeaders: true,
            groupDefaultExpanded: 1,
            groupSelectsChildren: true,
            rowSelection: 'multiple',
            suppressRowClickSelection: true,
            autoGroupColumnDef: {
                headerName: $filter('translate')('authorize_quotations.quotation_number'),
                field: "quotation.id",
                width: 100,
                cellRenderer: 'group',
                hide: true,
                cellRendererParams: {
                    checkbox: true
                }
            },
            angularCompileRows: true,
            angularCompileHeaders: true,
            enableColResize: true,
            rowData: null,
            rowHeight: 50,
            pinnedBottomRowData: []
        };
        vm.buttonDescription = 'authorize_quotations.authorize';

        //metodos
        vm.selectRequisition = selectRequisition;
        vm.backToQuotations = backToQuotations;
        vm.authorizeQuotation = authorizeQuotation;
        vm.replaceOriginTypedata = replaceOriginTypedata;
        vm.cancelRequisition = cancelRequisition;
        vm.onEditQuantity = onEditQuantity;
        vm.updateQuantity = updateQuantity;
        vm.showHistory = showHistory;
        vm.reCotizeQuotation = reCotizeQuotation;

        function setColumnsToGrid() {

            var columns = [
                {
                    headerName: $filter('translate')('authorize_quotations.quotation_number'),
                    field: "quotation.id",
                    width: 120,
                    hide: true,
                    rowGroupIndex: 0
                },
                {
                    headerName: $filter('translate')('authorize_quotations.product'),
                    field: "requisitionDetail.product.name",
                    width: 150,
                    cellRenderer: function (params) {
                        if (!params.node.group) {

                            if (params.data.requisitionDetail.product.brand && params.data.requisitionDetail.product.measurementUnit) {
                                return params.value + ", " + $filter('translate')('authorize_quotations.measurement_unit')
                                    + ": " + params.data.requisitionDetail.product.measurementUnit.name + ", "
                                    + $filter('translate')('authorize_quotations.brand') + ": " + params.data.requisitionDetail.product.brand.name;
                            } else {
                                return params.value;
                            }

                        } else {
                            return params.value;
                        }
                    }
                },
                {
                    headerName: $filter('translate')('authorize_quotations.quantity'),
                    field: "requisitionDetail.quantity",
                    width: 110,
                    cellStyle: { 'text-align': 'right' },
                    aggFunc: 'sum',
                    cellRenderer: function (params) {
                        if (params.node.group) {
                            return params.value;
                        } else {
                            params.data.editMode = false;
                            return editQuantityTemplate;
                        }
                    }
                },
                {
                    headerName: $filter('translate')('authorize_quotations.price'),
                    field: "price",
                    width: 110,
                    valueFormatter: function (params) {
                        return $filter('number')(params.value, 2);
                    },
                    cellStyle: { 'text-align': 'right' }
                },
                {
                    headerName: $filter('translate')('authorize_quotations.total'),
                    field: "subTotal",
                    width: 110,
                    valueFormatter: function (params) {
                        return $filter('number')(params.value, 2);
                    },
                    cellStyle: { 'text-align': 'right' },
                    aggFunc: 'sum'
                },
                {
                    headerName: $filter('translate')('authorize_quotations.observations'),
                    field: "requisitionDetail.observations",
                    width: 150
                }
            ];

            if (vm.hasBudgetApplication) {
                columns.push({
                    suppressMenu: true,
                    suppressSorting: true,
                    headerName: $filter('translate')('authorize_quotations.select_budgets'),
                    field: "budgetSelect",
                    width: 400,
                    cellRenderer: function (params) {
                        if (!params.node.group) {
                            var products = getBudgetsByProduct(params.data.requisitionDetail.product.id);
                            vm.productBudget[params.data.requisitionDetail.product.id] = getBudgetsByProduct(params.data.requisitionDetail.product.id);

                            params.$scope.isSelected = isSelected;
                            params.$scope.toggleSelectBudget = toggleSelectBudget;
                            params.$scope.validateRequestAmpliation = validateRequestAmpliation;
                            params.data.needExtension = false;
                            params.data.totalCovered = 0;
                            params.data.requestAmpliation = false;

                            if (products.length === 1) {

                                $timeout(function () {
                                    if (products[0].available >= params.data.subTotal) {
                                        params.$scope.toggleSelectBudget(products[0], null, true);
                                    }
                                }, 2000);
                            }

                            return budgetsTemplate;
                        } else {
                            return "";
                        }
                    }
                });
            }

            columns.push({
                suppressMenu: true,
                suppressSorting: true,
                headerName: $filter('translate')('authorize_quotations.show_history'),
                field: "btnShowHistory",
                width: 110,
                cellRenderer: function (params) {
                    if (!params.node.group) {
                        return "<div layout='row' layout-align='center center'>" +
                            " <md-button ng-click='vm.showHistory(data)' class='md-icon-button'" +
                            " title='Ver historial de este producto'> " +
                            "<md-icon md-font-icon='icon-menu'></md-icon> </md-button> </div>";
                    }
                }
            });

            vm.gridOptions.api.setColumnDefs(columns);

        }

        function showHistory(data) {

            $mdDialog.show({
                controller: 'QuotationHistoryProductController',
                controllerAs: 'vm',
                locals: {
                    'quotationDetail': data,
                    'departmentId': vm.currentRequisition.departmentId,
                    'costCenterId': vm.currentRequisition.costCenterId
                },
                templateUrl: 'app/main/apps/quotation/pending-authorize/detail/show-history-product/history-product.html',
                parent: angular.element("#main"),
                targetEvent: null,
                clickOutsideToClose: false
            }).then(function (response) {
            }, function () {
            });

        }

        function updateQuantity(data, rowNode) {

            if (data.requisitionDetail.quantity === undefined || data.requisitionDetail.quantity === null
                || data.requisitionDetail.quantity === "" || parseInt(data.requisitionDetail.quantity) <= 0) {
                MessageService.showErrorMessage($filter('translate')('authorize_quotations.invalid_quantity'));
                return null;
            }

            var confirm = $mdDialog.confirm()
                .targetEvent(null)
                .title($filter('translate')('authorize_quotations.update_quantity'))
                .textContent($filter('translate')('authorize_quotations.confirm_that_you_want_to_update_the_quantity_of_this_item'))
                .ok($filter('translate')('general.si'))
                .cancel($filter('translate')('general.no'));

            $mdDialog.show(confirm).then(function () {
                $rootScope.loadingProgress = true;
                api.ComprasWS.QuotationDetail.updateQuantity.update(
                    {
                        'companyId': $rootScope.bsCircle.company.id,
                        'quotationId': data.quotation.id,
                        'quotationDetailId': data.id, 'quantity': parseInt(data.requisitionDetail.quantity)
                    }).$promise.then(function (response) {
                        $rootScope.loadingProgress = false;

                        data.editMode = false;
                        data.subTotal = parseInt(data.requisitionDetail.quantity) * data.price;

                        //actualiza los totales
                        var sumCantidad = 0;
                        var sumSubTotal = 0;

                        rowNode.parent.allLeafChildren.forEach(function (node) {
                            sumCantidad += node.data.requisitionDetail.quantity;
                            sumSubTotal += node.data.subTotal;
                        });

                        rowNode.parent.aggData["requisitionDetail.quantity"] = sumCantidad;
                        rowNode.parent.aggData["subTotal"] = sumSubTotal;

                        vm.gridOptions.api.refreshCells();

                        MessageService.show($filter('translate')('authorize_quotations.amount_updated_correctly'));

                    }, function (data) {
                          var msg = '';
                          switch (data.status) {
                            case 409:
                              msg = 'ORDER.MSG.PRODUCT';
                              break;
                            case 406:
                              var message = data.data.mensaje.split('|');
                              var max = message[0];
                              var available = message[1];
                              msg = $filter('translate')('ORDER.MSG.CANNOT_EXCEED_MAXIMUM') + '(' + max + ').'
                                + $filter('translate')('ORDER.MSG.AVAILABLE_TO_ORDER') + available;
                              break;
                            default:
                              msg = 'ORDER.MSG.ERROR';
                              break;
                          }

                          MessageService.showErrorMessage(msg);
                          vm.loading = false;
                          $rootScope.loadingProgress = false;
                          $log.error(data);
                    });
            }, function () {
            });

        }

        function onEditQuantity(scope, data, rowNode) {

            if (!data.editMode) {

                data.oldQuantityValue = data.requisitionDetail.quantity;

                data.editMode = true;

                $timeout(function () {
                    $("#input" + data.id).focus();
                }, 1000);

            } else {

                data.requisitionDetail.quantity = data.oldQuantityValue;
                data.editMode = false;

            }

        }

        function validateRequestAmpliation(event, scope) {

            var requestAmpliations = false;
            var authorizeQuotations = false;

            vm.gridOptions.api.getSelectedNodes().forEach(function (node) {

                if (!node.group && node.data) {

                    if (node.data.requestAmpliation) {
                        requestAmpliations = true;
                    }

                    if (node.data.totalCovered === node.data.subTotal) {
                        authorizeQuotations = true;
                    }

                }

            });

            if (requestAmpliations && authorizeQuotations) {
                vm.buttonDescription = 'authorize_quotations.authorize_and_request_ampliations';
            } else if (requestAmpliations) {
                vm.buttonDescription = 'authorize_quotations.request_ampliation';
            } else {
                vm.buttonDescription = 'authorize_quotations.authorize';
            }

        }

        function getBudgetsByProduct(productId) {

            if (vm.productBudget[productId] !== undefined && vm.productBudget[productId] !== null) {
                return vm.productBudget[productId];
            }

            var result = [];

            vm.budgets.forEach(function (row) {

                if (row.product.id === productId) {
                    row.available = row.amountOfficial -
                        (row.amountExecuted ? row.amountExecuted : 0) -
                        (row.amountReserved ? row.amountReserved : 0) -
                        (row.amountNotExecuted ? row.amountNotExecuted : 0);
                    result.push(row);
                }

            });

            return result;

        }

        function selectRequisition(event, requisition) {

            if (vm.currentRequisition !== null && vm.currentRequisition !== undefined && vm.currentRequisition.requisitionId === requisition.requisitionId) {
                return null;
            }

            vm.circleQuotation = {};
            vm.currentRequisition = requisition;
            validateHasBudgetApplication(vm.currentRequisition.companyId);
            getDimensionCompany();

            for (var i = 0; i < $rootScope.circles.length; i++) {
                if ($rootScope.circles[i].company.id === vm.currentRequisition.companyId) {
                    vm.circleQuotation = $rootScope.circles[i];
                    break;
                }
            }

            var quotationIdArray = [];

            vm.currentRequisition.quotations.forEach(function (row) {
                quotationIdArray.push(row.id);
            });

            vm.showGrid = false;
            $rootScope.loadingProgress = true;
            api.ComprasWS.QuotationDetail.findDetailByQuotations.query(
                {
                    'companyId': 0, 'quotationId': 0, 'circleId': $rootScope.bsCircle.id,
                    'quotations': quotationIdArray.join(',')
                }).$promise.then(function (response) {
                    $rootScope.loadingProgress = false;
                    vm.gridOptions.api.setRowData(response);

                    vm.gridOptions.api.forEachNode(function (node) {

                        node.setSelected(true);

                    });

                    vm.showGrid = true;

                }, function (response) {
                    $log.error(response);
                });

            api.ComprasWS.ProcessFlow.get({ id: vm.currentRequisition.requisitionId, type: 1 }, function (data) {
                vm.infoProcessFlow = data;
            });

        }

        function validateHasBudgetApplication(companyId) {
            api.GeneralWS.CompanyApplication.byAppName.get({ 'company': companyId, 'app': 'Presupuestos' }).$promise.then(function (responseParameter) {
                if (responseParameter.$status === 200) {
                    if (responseParameter.$data && responseParameter.$data !== "") {
                        vm.hasBudgetApplication = responseParameter.$data.active;
                        if (vm.hasBudgetApplication) {
                            getBudgets();
                        } else {
                            setColumnsToGrid();
                        }
                    } else {
                        setColumnsToGrid();
                    }
                }
            }, function (response) {
                $log.error(response);
            });
        }

        function getBudgets() {
            vm.isShowLoaderBudgets = true;
            api.PresupuestosWS.Budget.findApprovedOfBeforeAndCurrentAndAfterMonth.query(
                {
                    'idc': vm.circleQuotation.id, 'costCenterId': vm.currentRequisition.costCenterId,
                    'departmentId': vm.currentRequisition.departmentId,
                  'dimensionCompanyDetail3Id': getDimensionCompanyDetailBudget(vm.currentRequisition.dimensionCompanyDetail3),
                  'dimensionCompanyDetail4Id': getDimensionCompanyDetailBudget(vm.currentRequisition.dimensionCompanyDetail4),
                  'dimensionCompanyDetail5Id': getDimensionCompanyDetailBudget(vm.currentRequisition.dimensionCompanyDetail5)
                }).$promise.then(function (response) {
                    vm.isShowLoaderBudgets = false;
                    vm.budgets = response;
                    setColumnsToGrid();
                }, function (response) {
                    vm.isShowLoaderBudgets = false;
                    $log.error(response);
                });
        }

      function getDimensionCompanyDetailBudget(dimensionCompanyDetail) {
        if (dimensionCompanyDetail) {
          return dimensionCompanyDetail.id;
        }
        return 0;
      }

        function backToQuotations() {
            $state.go('app.quotation.IngresadaTicket');
        }

        function init() {
            vm.selectRequisition(null, vm.requisitionArray[0]);
        }

        function getBudgetsTemplate() {
            var resource = $sce.getTrustedResourceUrl('app/main/apps/quotation/pending-authorize/detail/budgetsTemplate.html');

            var resource2 = $sce.getTrustedResourceUrl('app/main/apps/quotation/pending-authorize/detail/editQuantityTemplate.html');

            $templateRequest(resource).then(function (template) {
                budgetsTemplate = template;
            }, function () {
                $log.error("Ocurrio un error al leer el template");
            });

            $templateRequest(resource2).then(function (template) {
                editQuantityTemplate = template;
            }, function () {
                $log.error("Ocurrio un error al leer el template");
            });
        }

        function isSelected(budgetDetail) {

            var scopeParent = this.$parent.$parent;

            if (scopeParent.data.references === undefined || scopeParent.data.references === null) {
                scopeParent.data.references = [];
            }

            for (var i = 0; i < scopeParent.data.references.length; i++) {
                if (scopeParent.data.references[i].budgetDetailId === budgetDetail.id) {
                    return true;
                }
            }

            return false;
        }

        function toggleSelectBudget(budgetDetail, event, fromParent) {

            var scopeParent;


            if (fromParent) {
                scopeParent = this;
            } else {
                scopeParent = this.$parent;
            }

            scopeParent.data.needExtension = false;

            if (scopeParent.data.references === undefined || scopeParent.data.references === null) {
                scopeParent.data.references = [];
            }

            if (event) {
                event.stopPropagation();
            }

            var selected = false;

            for (var i = 0; i < scopeParent.data.references.length; i++) {
                if (scopeParent.data.references[i].budgetDetailId === budgetDetail.id) {
                    scopeParent.data.totalCovered -= scopeParent.data.references[i].amountToUse;
                    calculateAvailable(scopeParent.data.references[i].budgetDetailId,
                        scopeParent.data.references[i].amountToUse,
                        vm.productBudget[scopeParent.data.requisitionDetail.product.id]);
                    scopeParent.data.references.splice(i, 1);
                    selected = true;
                    break;
                }
            }

            if (!selected) {

                scopeParent.data.needExtension = scopeParent.data.subTotal > budgetDetail.available;

                var reference = {
                    referenceId: budgetDetail.id,
                    budgetId: budgetDetail.budget.id,
                    budgetDetailId: budgetDetail.id,
                    amountToUse: scopeParent.data.subTotal > budgetDetail.available ? budgetDetail.available : scopeParent.data.subTotal,
                    budgetStartDate: budgetDetail.budget.startDate,
                    budgetEndDate: budgetDetail.budget.endDate,
                    currencyCode: budgetDetail.currencyOfficial.code,
                    budgetType: budgetDetail.budget.budgetType.description,
                    budgetExchangeRateOfficial: budgetDetail.exchangeRateOfficial
                };

                scopeParent.data.references.push(reference);
                scopeParent.data.totalCovered += reference.amountToUse;
                calculateAvailable(budgetDetail.id, reference.amountToUse * -1, vm.productBudget[scopeParent.data.requisitionDetail.product.id]);

            }

        }

        function calculateAvailable(budgetDetailId, amountToAdd, budgetDetailArray) {

            budgetDetailArray.forEach(function (budgetDetail) {
                if (budgetDetailId === budgetDetail.id) {
                    budgetDetail.available = parseFloat(budgetDetail.available) + parseFloat(amountToAdd);
                }
            });

        }

        function authorizeQuotation(event) {

            if (!vm.hasBudgetApplication) {

                var message, countQuotations, quotationDetailToAuthorize;

                countQuotations = 0;
                quotationDetailToAuthorize = [];

                vm.gridOptions.api.getSelectedNodes().forEach(function (node) {

                    if (!node.group) {

                        quotationDetailToAuthorize.push({
                            id: node.data.id,
                            product: node.data.requisitionDetail.product,
                            amount: 0,
                            referenceAmpliationId: 0,
                            unitPrice: 0,
                            currency: node.data.currencyCompanyBuyer,
                            exchangeRate: node.data.exchangeRateCompanyBuyer,
                            requestAmpliation: false,
                            references: [],
                            referenceHeaderId: node.data.quotation.id
                        });

                        countQuotations++;
                    }

                });

                if (countQuotations > 1) {
                    message = $filter('translate')('authorize_quotations.confirm_that_you_want_to_authorize') + " " + countQuotations + " items?";
                } else if (countQuotations === 1) {
                    message = $filter('translate')('authorize_quotations.confirm_that_you_want_to_authorize_the_selected_item');
                } else {
                    MessageService.show($filter('translate')('authorize_quotations.no_quotations_to_authorize'));
                    return null;
                }

                var confirm = $mdDialog.confirm()
                    .targetEvent(event)
                    .title($filter('translate')('authorize_quotations.authorize_quotations'))
                    .textContent(message)
                    .ok($filter('translate')('general.si'))
                    .cancel($filter('translate')('general.no'));

                $mdDialog.show(confirm).then(function () {
                    authorizeQuotationDetail(quotationDetailToAuthorize, 0);
                }, function () {
                });

            } else {

                var countRequestAmpliations, countAuthorizeQuotations;

                countRequestAmpliations = 0;
                countAuthorizeQuotations = 0;

                vm.gridOptions.api.getSelectedNodes().forEach(function (node) {
                    if (!node.group) {

                        if (node.data && node.data.requestAmpliation) {
                            countRequestAmpliations++;
                        }

                        if (node.data && node.data.totalCovered >= node.data.subTotal) {
                            countAuthorizeQuotations++;
                        }

                    }
                });

                if (countRequestAmpliations > 0 && countAuthorizeQuotations > 0) {
                    message = $filter('translate')('authorize_quotations.confirm_that_you_want_to_request')
                        + " " + getMessageRequestAmpliations(countRequestAmpliations) + " "
                        + $filter('translate')('authorize_quotations.and_authorize') + " "
                        + getMessageAuthorizeQuotations(countAuthorizeQuotations) + "?";
                } else if (countRequestAmpliations > 0) {
                    message = $filter('translate')('authorize_quotations.confirm_that_you_want_to_request')
                        + " " + getMessageRequestAmpliations(countRequestAmpliations) + "?";
                } else if (countAuthorizeQuotations > 0) {
                    message = $filter('translate')('authorize_quotations.confirm_that_you_want_to_authorize')
                        + getMessageAuthorizeQuotations(countAuthorizeQuotations) + "?";
                } else {

                    MessageService.show($filter('translate')('authorize_quotations.no_quotations_to_authorize'));

                    return null;
                }

                var confirm = $mdDialog.confirm()
                    .targetEvent(event)
                    .title($filter('translate')('authorize_quotations.authorize_quotations'))
                    .textContent(message)
                    .ok($filter('translate')('general.si'))
                    .cancel($filter('translate')('general.no'));

                $mdDialog.show(confirm).then(function () {
                    validateBudgetProducts();
                }, function () {
                });

            }

        }

        function getMessageRequestAmpliations(countRequestAmpliations) {
            if (countRequestAmpliations === 1) {
                return countRequestAmpliations + " " + $filter('translate')('authorize_quotations.ampliation');
            } else {
                return countRequestAmpliations + " " + $filter('translate')('authorize_quotations.ampliations');
            }
        }

        function getMessageAuthorizeQuotations(countAuthorizeQuotations) {
            if (countAuthorizeQuotations === 1) {
                return countAuthorizeQuotations + " item";
            } else {
                return countAuthorizeQuotations + " items";
            }
        }

        function validateBudgetProducts() {
            var productsToValidate = [];

            vm.gridOptions.api.getSelectedNodes().forEach(function (node) {

                if (!node.group && node.data && node.data.references
                    && node.data.references.length > 0 && (!(node.data.totalCovered < node.data.subTotal) || node.data.requestAmpliation)) {

                    var productToValidate = {
                        id: node.data.id,
                        product: node.data.requisitionDetail.product,
                        amount: node.data.requestAmpliation ?
                            ((node.data.subTotalCompanyBuyer - node.data.totalCovered) / node.data.references[node.data.references.length - 1].budgetExchangeRateOfficial) :
                            node.data.subTotalCompanyBuyer,
                        referenceAmpliationId: node.data.references[node.data.references.length - 1].referenceId,
                        unitPrice: 0,
                        currency: node.data.currencyCompanyBuyer,
                        exchangeRate: node.data.exchangeRateCompanyBuyer,
                        requestAmpliation: node.data.requestAmpliation,
                        references: node.data.references,
                        referenceHeaderId: node.data.quotation.id
                    };

                    productsToValidate.push(productToValidate);

                }

            });

            $rootScope.loadingProgress = true;
            api.PresupuestosWS.Budget.validatesBudgetedProducts.validate(
                { 'idc': vm.circleQuotation.id }, { quotations: productsToValidate }).$promise.then(function (response) {
                    $rootScope.loadingProgress = false;
                    vm.productsToValidate = response;

                    var quotationDetailToAuthorize = new jinqJs()
                        .from(response)
                        .where(function (r) {
                            return r.lessOrEqualAmount;
                        })
                        .select();

                    var requestAmpliation = new jinqJs()
                        .from(response)
                        .where(function (r) {
                            return !r.lessOrEqualAmount && r.requestAmpliation;
                        })
                        .select();

                    authorizeQuotationDetail(quotationDetailToAuthorize, requestAmpliation.length);

                }, function (response) {
                    $rootScope.loadingProgress = false;
                    $log.error(response);
                });
        }

        function authorizeQuotationDetail(quotationDetailToAuthorize, countRequestAmpliations) {

            if (countRequestAmpliations > 0 && quotationDetailToAuthorize.length === 0) {
                MessageService.show($filter('translate')('authorize_quotations.it_was_requested') + " " + getMessageRequestAmpliations(countRequestAmpliations));
                backToQuotations();
                return null;
            }

            var quotationArray = new jinqJs()
                .from(quotationDetailToAuthorize)
                .distinct('referenceHeaderId')
                .select();

            quotationArray.forEach(function (quotation) {

                quotation.quotationId = quotation.referenceHeaderId;
                quotation.detail = [];

                quotationDetailToAuthorize.forEach(function (quotationDetail) {
                    if (quotationDetail.referenceHeaderId === quotation.quotationId) {
                        quotation.detail.push(quotationDetail);
                    }
                });

            });

            $rootScope.loadingProgress = true;
            api.ComprasWS.Quotation.authorize.update(
                {
                    'companyId': $rootScope.bsCircle.company.id,
                    'idCircle': $rootScope.bsCircle.id,
                    'quotationId': 0
                }, quotationArray).$promise.then(function (response) {
                    $rootScope.loadingProgress = true;

                    var message;

                    if (countRequestAmpliations > 0 && response.length > 0) {
                        message = $filter('translate')('authorize_quotations.it_was_requested')
                            + " " + getMessageRequestAmpliations(countRequestAmpliations) + " "
                            + $filter('translate')('authorize_quotations.and_was_authorized')
                            + getMessageAuthorizeQuotations(quotationDetailToAuthorize.length) + ".";
                    } else if (countRequestAmpliations > 0) {
                        message = $filter('translate')('authorize_quotations.it_was_requested')
                            + " " + getMessageRequestAmpliations(countRequestAmpliations) + ".";
                    } else if (response.length > 0) {
                        message = $filter('translate')('authorize_quotations.was_authorized')
                            + " " + getMessageAuthorizeQuotations(quotationDetailToAuthorize.length) + ".";
                    }

                    MessageService.show(message);

                    backToQuotations();
                }, function (response) {
                    $log.error(response);
                    $rootScope.loadingProgress = true;
                });
        }

        function cancelRequisition(event) {

            var quotationIdArray = [];

            vm.gridOptions.api.forEachNode(function (node) {
                if (!node.group) {
                    quotationIdArray.push(node.data.quotation.id);
                }
            });

            if (quotationIdArray.length === 0) {
                return null;
            }

            var message;

            if (quotationIdArray.length > 1) {
                message = $filter('translate')('authorize_quotations.confirm_that_you_want_to_cancel')
                    + " " + quotationIdArray.length + " " + $filter('translate')('authorize_quotations.quotations') + "?";
            } else {
                message = $filter('translate')('authorize_quotations.confirm_that_you_want_to_cancel_the_quotation') + " " + quotationIdArray[0] + "?";
            }

            var confirm = $mdDialog.confirm()
                .targetEvent(event)
                .title($filter('translate')('authorize_quotations.cancel_quotations'))
                .textContent(message)
                .ok($filter('translate')('general.si'))
                .cancel($filter('translate')('general.no'));

            $mdDialog.show(confirm).then(function () {

                $rootScope.loadingProgress = true;
                api.ComprasWS.Quotation.cancelQuotations.update(
                    {
                        'companyId': $rootScope.bsCircle.company.id,
                        'circleId': $rootScope.bsCircle.id
                    }, quotationIdArray).$promise.then(function (response) {
                        $rootScope.loadingProgress = false;

                        if (quotationIdArray.length > 1) {
                            MessageService.show($filter('translate')('authorize_quotations.quotation_successfully_canceled'));
                        } else {
                            MessageService.show($filter('translate')('authorize_quotations.quotations_successfully_canceled'));
                        }

                        vm.backToQuotations();

                    }, function (response) {
                        $rootScope.loadingProgress = false;
                        $log.error(response);
                    });

            }, function () {

            });

        }

        function reCotizeQuotation(ev) {
            var quotationIdArray = [];

            vm.gridOptions.api.forEachNode(function (node) {
                if (!node.group) {
                    quotationIdArray.push(node.data.quotation.id);
                }
            });

            if (quotationIdArray.length === 0) {
                return null;
            }

            var message;

            if (quotationIdArray.length > 1) {
                message = $filter('translate')('authorize_quotations.confirm_that_you_want_to_reCotize')
                    + " " + quotationIdArray.length + " " + $filter('translate')('authorize_quotations.quotations') + "?";
            } else {
                message = $filter('translate')('authorize_quotations.confirm_that_you_want_to_reCotize_the_quotation') + " " + quotationIdArray[0] + "?";
            }

            var confirm = $mdDialog.confirm()
                .targetEvent(ev)
                .title($filter('translate')('authorize_quotations.reCotize_quotations'))
                .textContent(message)
                .ok($filter('translate')('general.si'))
                .cancel($filter('translate')('general.no'));

            $mdDialog.show(confirm).then(function () {

                $rootScope.loadingProgress = true;
                api.ComprasWS.Quotation.reCotizeQuotations.update(
                    {
                        'companyId': $rootScope.bsCircle.company.id,
                        'circleId': $rootScope.bsCircle.id
                    }, quotationIdArray).$promise.then(function (response) {
                        $rootScope.loadingProgress = false;

                        if (quotationIdArray.length > 1) {
                            MessageService.show($filter('translate')('authorize_quotations.quotation_successfully_reCotized'));
                        } else {
                            MessageService.show($filter('translate')('authorize_quotations.quotations_successfully_reCotized'));
                        }

                        vm.backToQuotations();

                    }, function (response) {
                        $rootScope.loadingProgress = false;
                        $log.error(response);
                    });

            }, function () {

            });
        }

        function getDimensionCompany() {
            const NUMBER_DIMENSION_THREE = 3;
            const NUMBER_DIMENSION_FOUR = 4;
            const NUMBER_DIMENSION_FIVE = 5;
            api.GeneralWS.DimensionCompany.byCompany.getList(
              { 'company': vm.currentRequisition.companyId }
            ).$promise.then(function (responseDimension) {
              for (let i = 0; i < responseDimension.length; i++) {
                if (responseDimension[i].dimensionNumber === NUMBER_DIMENSION_THREE) {
                  vm.dimensionCompanyDetail3 = responseDimension[i];
                } else if (responseDimension[i].dimensionNumber === NUMBER_DIMENSION_FOUR) {
                  vm.dimensionCompanyDetail4 = responseDimension[i];
                } else if (responseDimension[i].dimensionNumber === NUMBER_DIMENSION_FIVE) {
                  vm.dimensionCompanyDetail5 = responseDimension[i];
                } else {
                  vm.dimensionCompanyDetail1 = responseDimension[i];
                }
              }
            });
          }

        getBudgetsTemplate();
        $timeout(init, 500);


    }

})();

(function () {
    'use strict';

    angular
        .module('app.requisition', ['flow'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {
        // State
        $stateProvider
            .state('app.requisition', {
                url: '/requisition',
                abstract: true
            })
            .state('app.requisition.Creando', {
                url: '/1?:companyCart',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/requisition/requisitions.html',
                        controller: 'RequisitionsController as vm'
                    }
                },
                params: {
                    status: 'Creando',
                    companyCart: null,
                    backTo: null
                },
                resolve: {
                    configuration: function () {
                        return {
                            viewId: 1,
                            getTemplates: true
                        };
                    }
                },
                bodyClass: 'e-commerce'
            })
            .state('app.requisition.CreandoTickets', {
                url: '/5?:companyCart',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/requisition/requisitions.html',
                        controller: 'RequisitionsController as vm'
                    }
                },
                params: {
                    status: 'Creando',
                    tickets: true,
                    companyCart: null,
                    backTo: null
                },
                resolve: {
                    configuration: function () {
                        return {
                            viewId: 5,
                            getTemplates: false
                        };
                    }
                },
                bodyClass: 'e-commerce'
            })
            .state('app.requisition.Ingresado', {
                url: '/2',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/requisition/requisition-autorize/requisitions-autorize.html',
                        controller: 'RequisitionsAutorizeController as vm'
                    }
                },
                params: {
                    status: 'Ingresado'
                },
                resolve: {
                    configuration: function () {
                        return {
                            viewId: 2,
                            getTemplates: false
                        };
                    }
                },
                bodyClass: 'e-commerce'
            })
            .state('app.requisition.Autorizado', {
                url: '/3',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/requisition/requisition-cotize/requisitions-cotize.html',
                        controller: 'RequisitionsCotizeController as vm'
                    }
                },
                params: {
                    status: 'Autorizado'
                },
                resolve: {
                    configuration: function () {
                        return {
                            viewId: 3,
                            getTemplates: false
                        };
                    }
                },
                bodyClass: 'e-commerce'
            })
            .state('app.requisition.AutorizadoTickets', {
                url: '/cotize',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/requisition/requisition-cotize/requisitions-cotize.html',
                        controller: 'RequisitionsCotizeController as vm'
                    }
                },
                params: {
                    status: 'Autorizado',
                    tickets: true
                },
                resolve: {
                    configuration: function () {
                        return {
                            viewId: 0,
                            getTemplates: false
                        };
                    }
                },
                bodyClass: 'e-commerce'
            })
            .state('app.requisition.MisAutorizados', {
                url: '/myQuote',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/requisition/requisition-cotize/requisitions-cotize.html',
                        controller: 'RequisitionsCotizeController as vm'
                    }
                },
                params: {
                    status: 'Autorizado',
                    userToQuote: true,
                    isBuyer: true
                },
                resolve: {
                    configuration: function () {
                        return {
                            viewId: 3,
                            getTemplates: false
                        };
                    }
                },
                bodyClass: 'e-commerce'
            })
            .state('app.requisition.Creando.detail', {
                url: '/:id?{referenceId:int}&originTypeCode&{costCenterId:int}&{departmentId:int}&{companyId:int}&{companyUserId:int}&circleName&{createdInDepartmentId:int}' +
                  '&{dimensionCompanyDetail3Id:int}' +
                  '&{dimensionCompanyDetail4Id:int}' +
                  '&{dimensionCompanyDetail5Id:int}',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/requisition/requisition/requisition.html',
                        controller: 'RequisitionController as vm'
                    }
                },
                params: {
                    status: 'Creando'
                },
                resolve: {
                    PreviousState: function ($state) {
                        return angular.copy($state.current);
                    },
                    configuration: function () {
                        return {
                            viewId: 0,
                            getTemplates: true
                        };
                    }
                },
                bodyClass: 'e-commerce'
            })
            .state('app.requisition.CreandoTickets.detail', {
                url: '/:id?{referenceId:int}&originTypeCode&{costCenterId:int}&{departmentId:int}&{companyId:int}&{companyUserId:int}&circleName&{createdInDepartmentId:int}' +
                  '&{dimensionCompanyDetail3Id:int}'+
                  '&{dimensionCompanyDetail4Id:int}'+
                  '&{dimensionCompanyDetail5Id:int}',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/requisition/requisition/requisition.html',
                        controller: 'RequisitionController as vm'
                    }
                },
                resolve: {
                    PreviousState: function ($state) {
                        return angular.copy($state.current);
                    },
                    configuration: function () {
                        return {
                            viewId: 0,
                            getTemplates: false
                        };
                    }
                },
                bodyClass: 'e-commerce'
            })
            .state('app.requisition.Ingresado.detail', {
                url: '/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/requisition/requisition/requisition.html',
                        controller: 'RequisitionController as vm'
                    }
                },
                resolve: {
                    PreviousState: function ($state) {
                        return angular.copy($state.current);
                    },
                    configuration: function () {
                        return {
                            viewId: 0,
                            getTemplates: false
                        };
                    }
                },
                bodyClass: 'e-commerce'
            })
            .state('app.requisition.Autorizado.detail', {
                url: '/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/requisition/requisition/requisition_view.html',
                        controller: 'RequisitionController as vm'
                    }
                },
                resolve: {
                    PreviousState: function ($state) {
                        return angular.copy($state.current);
                    },
                    configuration: function () {
                        return {
                            viewId: 0,
                            getTemplates: false
                        };
                    }
                },
                bodyClass: 'e-commerce'
            })
            .state('app.requisition.MisAutorizados.detail', {
                url: '/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/requisition/requisition/requisition_view.html',
                        controller: 'RequisitionController as vm'
                    }
                },
                resolve: {
                    PreviousState: function ($state) {
                        return angular.copy($state.current);
                    },
                    configuration: function () {
                        return {
                            viewId: 0,
                            getTemplates: false
                        };
                    }
                },
                bodyClass: 'e-commerce'
            })
            .state('app.requisition.AutorizadoTickets.detail', {
                url: '/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/requisition/requisition/requisition_view.html',
                        controller: 'RequisitionController as vm'
                    }
                },
                resolve: {
                    PreviousState: function ($state) {
                        return angular.copy($state.current);
                    },
                    configuration: function () {
                        return {
                            viewId: 0,
                            getTemplates: false
                        };
                    }
                },
                bodyClass: 'e-commerce'
            })
            .state('app.requisition.detail', {
                url: '/4/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/requisition/requisition/requisition_view.html',
                        controller: 'RequisitionController as vm'
                    }
                },
                params: {
                    backTo: null,
                    filter: null
                },
                resolve: {
                    PreviousState: function ($state) {
                        return angular.copy($state.current);
                    },
                    configuration: function () {
                        return {
                            viewId: 0,
                            getTemplates: false
                        };
                    }
                },
                bodyClass: 'e-commerce'
            })
            .state('app.requisition.compare', {
                url: '/compare/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/requisition/requisition-compare/requisition-compare.html',
                        controller: 'requisitionCompareController as vm',
                    },
                },
                params: {
                    backTo: null,
                    filter: null,
                },
                bodyClass: 'e-commerce',
            })
            .state('app.requisition.template', {
                url: '/requisition-template',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/requisition/requisition-template/requisition-templates.html',
                        controller: 'RequisitionTemplatesController as vm'
                    }
                },
                bodyClass: 'dashboard-project'
            })
            .state('app.requisition.template.detail', {
                url: '/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/requisition/requisition-template/editor/requisition-template.html',
                        controller: 'RequisitionTemplateController as vm'
                    }
                },
                params: {
                    shareMe: null
                }
            })
            .state('app.requisition.template.detailShares', {
                url: '/share/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/requisition/requisition-template/editor/requisition-template-shares.html',
                        controller: 'RequisitionTemplateSharesController as vm'
                    }
                }
            })
            .state('app.requisition.requisitionReport', {
                url: '/requisition-report/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/requisition/requisition-report/requisition-report.html',
                        controller: 'RequisitionReportController as vm'
                    }
                },
                bodyClass: 'dashboard-project'
            })
            .state('app.requisition.PendienteCotizar', {
                url: '/4',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/requisition/requisitions.html',
                        controller: 'RequisitionsController as vm'
                    }
                },
                params: {
                    status: 'Autorizado',
                    isBuyer: true
                },
                resolve: {
                    configuration: function () {
                        return {
                            viewId: 3,
                            getTemplates: false
                        };
                    }
                },
                bodyClass: 'e-commerce'
            })
            .state('app.requisition.PendienteCotizar.detail', {
                url: '/PendingCotize/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/requisition/requisition/requisition_view.html',
                        controller: 'RequisitionController as vm'
                    }
                },
                resolve: {
                    PreviousState: function ($state) {
                        return angular.copy($state.current);
                    },
                    configuration: function () {
                        return {
                            viewId: 0,
                            getTemplates: false
                        };
                    }
                },
                bodyClass: 'e-commerce',
                params: {
                    isBuyer: true,
                    backTo: null,
                    filter: null
                }
            })
            .state('app.requisition.requisitionType', {
                url: '/requisitionType',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/requisition/requisitionType/requisitionType.html',
                        controller: 'requisitionTypeController as vm'
                    }
                },
                bodyClass: 'mail'
            });


        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/requisition');

    }

})();

(function () {
    'use strict';
    angular
        .module('app.requisition')
        .controller('FeaturesDialogController', FeaturesDialogController);

    /** @ngInject */
    function FeaturesDialogController($mdDialog, api, $log, $timeout, $rootScope, quotationDetail, quotationId, MessageService) {

        var vm = this;
        vm.quotationDetail = quotationDetail;
        vm.fixedAsset = {
            fixedAssetGroup: { id: vm.quotationDetail.fixedAssetGroupId },
            product: { id: vm.quotationDetail.requisitionDetail.product.id },
            quotationDetailId: vm.quotationDetail.id,
            quotationId: quotationId,
            originType: {
                originTypeCode: "03"
            }
        };
        vm.completedFeatures = false;

        /**
         * methods
         */

        vm.cancel = cancel;
        vm.onEdit = onEdit;
        vm.flipping = flipping;
        vm.toggleBooleanFeatureValue = toggleBooleanFeatureValue;
        vm.isCheckedBooleanFeatureValue = isCheckedBooleanFeatureValue;
        vm.save = save;
        vm.searchFeature = searchFeature;

        vm.newContact = true;
        vm.flip;
        function flipping(funct) {
            vm.flip = funct;
            if (vm.newContact) {
                funct();
            }
        }
        init();
        function init() {
            getFeaturesByGroup();
            getFixedAssets();
        }

        function onEdit() {
            !vm.fixedAssetToUpdate ? vm.fixedAssetToUpdate = vm.fixedAssets[0] : null;
            if (vm.flip) {
                vm.flip();
            }
            $timeout(function () {
                document.getElementById("searchFilter").focus();
            }, 600);
        }

        function cancel() {
            $mdDialog.cancel();
        }
        function getFeaturesByGroup() {
            api.ActivosFijosWS.FixedAssetGroupFeature.active.query(
                {
                    'companyId': vm.quotationDetail.requisitionDetail.requisition.department.company.id,
                    'fixedAssetGroupId': vm.quotationDetail.fixedAssetGroupId, isProvider: true
                }).$promise.then(function (response) {
                    vm.fixedAssetGroupFeatures = response;
                    cleanFeatures();
                }, function (response) {
                    $log.error(response);
                });
        }
        function orderFeaturesById(featureArray) {
            return featureArray.sort(function (a, b) {
                return a.fixedAssetGroupFeature.orderOfEntry - b.fixedAssetGroupFeature.orderOfEntry;
            });
        }
        function toggleBooleanFeatureValue(event, feature) {
            event.stopPropagation();
            if (feature.featureValue === null || feature.featureValue === undefined) {
                feature.featureValue = "0";
            }

            if (feature.featureValue === "0") {
                feature.featureValue = "1";
            } else {
                feature.featureValue = "0";
            }
        }

        function isCheckedBooleanFeatureValue(feature) {
            return feature.featureValue === "1";
        }

        function getFixedAssets() {
            api.ActivosFijosWS.FixedAsset.me.query(
                {
                    'fixedAssetId': 'byQuotatonDetail',
                    'companyId': vm.quotationDetail.requisitionDetail.requisition.department.company.id,
                    'quotationDetailId': vm.quotationDetail.id
                }).$promise.then(function (fixedAssets) {
                    vm.fixedAssets = fixedAssets.sort(function (a, b) {
                        return a.id - b.id;
                    });
                    vm.fixedAssetsToUpdate = fixedAssets;
                    vm.completedFeatures = !(vm.quotationDetail.requisitionDetail.quantity > vm.fixedAssets.length);
                    vm.completedFeatures === true ? onEdit() : null;
                }, function (response) {
                    $log.error(response);
                });
        }

        function save(isNew) {
            $rootScope.loadingProgress = true;

            var promise;
            if (isNew === false) {
                promise = api.ActivosFijosWS.FixedAsset.me.update(
                    {
                        'companyId': vm.quotationDetail.requisitionDetail.requisition.department.company.id,
                        'fixedAssetId': vm.fixedAssetToUpdate.id
                    }, vm.fixedAssetToUpdate).$promise;
            } else {
                promise = api.ActivosFijosWS.FixedAsset.me.create(
                    { 'companyId': vm.quotationDetail.requisitionDetail.requisition.department.company.id }, vm.fixedAsset).$promise;
            }
            promise.then(function (response) {
                $rootScope.loadingProgress = false;
                if (isNew === false) {
                    MessageService.show("QUOTATION.DETAIL.FEATURES.UPDATED");
                } else {
                    MessageService.show("QUOTATION.DETAIL.FEATURES.ADDED");
                    vm.fixedAssets.push(response);
                    vm.completedFeatures = !(vm.quotationDetail.requisitionDetail.quantity > vm.fixedAssets.length);
                    vm.completedFeatures === true ? completedFeatures(true) : cleanFeatures();
                }

            }, function (response) {
                $rootScope.loadingProgress = false;
                $log.error(response);
            });

        }

        function cleanFeatures() {
            vm.fixedAsset.features = [];
            var features = [];
            vm.fixedAssetGroupFeatures.forEach(function (row) {
                var fixedAssetGroupFeature = angular.copy(row);
                delete fixedAssetGroupFeature.sales;
                var item = {
                    fixedAssetGroupFeature: fixedAssetGroupFeature,
                    featureValue: null
                };
                features.push(item);
            });
            vm.fixedAsset.features = vm.fixedAsset.features.concat(orderFeaturesById(features));
        }

        function completedFeatures(completed) {
            vm.quotationDetail.completedFeatures = completed;
            api.ComprasWS.QuotationDetail.me.update(
                {
                    'id': 'setCompletedFeatures', 'companyId': 0,
                    'quotationId': 0, 'idCircle': $rootScope.bsCircle.id
                }, vm.quotationDetail).$promise.then(function (quotationDetail) {
                    MessageService.show("QUOTATION.COMPLETED");
                    $mdDialog.hide(vm.quotationDetail);
                }, function (response) {
                    $log.error(response);
                });
        }

        function searchFeature() {
            if (!vm.filter) {
                vm.fixedAssetsToUpdate = vm.fixedAssets;
            } else {
                vm.fixedAssetsToUpdate = vm.fixedAssets.filter(function (fixedAsset) {
                    return _.find(fixedAsset.features, function (feature) {
                        var lowercaseQuery = angular.lowercase(vm.filter);
                        var lowercaseName = angular.lowercase(feature.featureValue);
                        return (lowercaseName.indexOf(lowercaseQuery) === 0 || lowercaseName.indexOf(lowercaseQuery) > 0);
                    });
                });
            }
            vm.fixedAssetToUpdate = vm.fixedAssetsToUpdate[0];
            vm.page = 1;
        }

    }

})();

(function () {
    'use strict';
    angular
        .module('app.requisition')
        .controller('ComposeDialogController', ComposeDialogController);

    /** @ngInject */
    function ComposeDialogController($mdDialog, $log, api, $rootScope, quotation, quotationDetails, id, MessageService, status) {
        var vm = this;

        // Data
        vm.purchaseOrder = { dateDelivery: null };
        vm.minDate = new Date();

        // Methods
        vm.closeDialog = closeDialog;
        vm.createPurchaseOrder = createPurchaseOrder;

        $log.debug(quotation);
        vm.disabledButton = false;
        vm.closeTicketOnReceivePurchase = false;
        vm.originType = { originTypeName: null };
        vm.NUMBER_THREE = 3;
        vm.NUMBER_FOUR = 4;
        vm.NUMBER_FIVE = 5;

        //////////

        init();
        /**
         * Initialize
         */
        function init() {
            if (!quotation) {
                $rootScope.loadingProgress = true;
                api.ComprasWS.Quotation.Quotation.get({ companyId: $rootScope.bsCircle.company.id, id: id }, function (data) {
                    vm.statusToChange = data.quotationStatus.description;
                    quotation = data;
                    $rootScope.loadingProgress = false;
                    getDetails();
                }, function (data) {
                    $log.debug(data);
                    $rootScope.loadingProgress = false;
                });
            } else if (!quotationDetails) {
                vm.statusToChange = quotation.quotationStatus.description;
                getDetails();
            } else {
                vm.statusToChange = quotation.quotationStatus.description;
            }
        }

        function getDetails() {
            $rootScope.loadingProgress = true;
            api.ComprasWS.QuotationDetail.me.query(
                { companyId: $rootScope.bsCircle.company.id, circleId: $rootScope.bsCircle.id, quotationId: quotation.id }, function (data) {
                    quotationDetails = data.filter(function (item) {
                        return !item.bought;
                    });
                    $rootScope.loadingProgress = false;
                }, function (data) {
                    $log.debug(data);
                    $rootScope.loadingProgress = false;
                });
        }

        function closeDialog() {
            $mdDialog.cancel();
        }

        function createPurchaseOrder(theDate) {
            $rootScope.loadingProgress = true;
            vm.disabledButton = true;

            if (!theDate && !vm.dateDelivery) {
                return null;
            }

            if (!theDate) {
                theDate = vm.dateDelivery;
            }

            $rootScope.loadingProgress = true;
            vm.purchaseOrderDetails = [];
            var total = 0;

            quotationDetails.forEach(function (detail) {
                var price = detail.price;
                var subTotal = price * detail.requisitionDetail.quantity;
                vm.purchaseOrderDetails.push({
                    purchaseOrder: {},
                    product: { id: detail.requisitionDetail.product.id },
                    quantity: detail.requisitionDetail.quantity,
                    price: detail.price,
                    subTotal: subTotal.toFixed(2),
                    quotationDetail: { id: detail.id }
                });
                total += parseFloat(subTotal);
            });

            vm.purchaseOrder = {
                companyProvider: { id: quotation.provider.id },
                company: { id: quotation.requisition.department.company.id },
                department: { id: quotation.requisition.department.id },
                costCenter: { id: quotation.requisition.costCenter.id },
                currency: { id: quotation.currency.id },
                dateDelivery: theDate,
                total: total,
                purchaseStatus: { description: status },
                quotation: { id: quotation.id },
                dimensionCompanyDetail3: getDimensionCompanyDetail(vm.NUMBER_THREE),
                dimensionCompanyDetail4: getDimensionCompanyDetail(vm.NUMBER_FOUR),
                dimensionCompanyDetail5: getDimensionCompanyDetail(vm.NUMBER_FIVE)
            };
            vm.purchaseOrderDetails.forEach(function(d){
                d.purchaseOrder = vm.purchaseOrder
            });

             var promise = api.ComprasWS.PurchaseOrderDetail.create(
                { idPurchaseOrder: 0, idCircle: $rootScope.bsCircle.id }, vm.purchaseOrderDetails).$promise;
            promise.then(function (data) {
                vm.purchaseOrder = data[0].purchaseOrder;
                vm.disabledButton = true;
                promise = api.ComprasWS.PurchaseOrderDetail.create(
                    { idPurchaseOrder: vm.purchaseOrder.id, idCircle: $rootScope.bsCircle.id }, vm.purchaseOrderDetails).$promise;
                promise.then(function () {
                    MessageService.show('QUOTATION.MSG.SUCCESSFULLY_APPROVED');
                    $mdDialog.hide(true);
                    $rootScope.loadingProgress = false;
                    vm.disabledButton = false;
                }, function (data) {
                    $log.debug(data);
                    $rootScope.loadingProgress = false;
                    vm.disabledButton = false;
                });
            }, function (data) {
                var message = 'QUOTATION.CREATE.ERROR';
                if (data.status == 409) {
                    message = 'QUOTATION.ERROR.' + data.data.mensaje;
                    $mdDialog.hide(false);
                }
                MessageService.showErrorMessage(message);
                $log.debug(data);
                $rootScope.loadingProgress = false;
                vm.disabledButton = false;
            });
        }

        function getDimensionCompanyDetail(number) {
            if (quotation.requisition['dimensionCompanyDetail' + number]) {
                return { id: quotation.requisition['dimensionCompanyDetail' + number].id };
            } else {
                return null;
            }
        }

    }
})();

(function () {

    'use strict';

    angular
        .module('app.quotation')
        .controller('QuotationPendingAuthorizeDetailController', QuotationPendingAuthorizeDetailController);

    function QuotationPendingAuthorizeDetailController($mdDialog, $templateRequest, $sce, $rootScope, $timeout, $filter,
        $log, api, MessageService, $stateParams, $state) {

        if ($stateParams.requisitionArray === null || $stateParams.requisitionArray === undefined) {
            $state.go('app.quotation.Ingresada', {});
            return null;
        }

        var vm = this;
        var budgetsTemplate = null;
        var editQuantityTemplate = null;
        vm.dimensionCompanyDetail3 = null;
        vm.dimensionCompanyDetail4 = null;
        vm.dimensionCompanyDetail5 = null;

        vm.productBudget = {};
        vm.indexView = 0;
        vm.requisitionArray = $stateParams.requisitionArray;
        vm.detailToAuthorize = [];
        vm.gridOptions = {
            columnDefs: [],
            suppressContextMenu: true,
            groupHeaders: true,
            groupDefaultExpanded: 2,
            groupSelectsChildren: true,
            rowSelection: 'multiple',
            suppressRowClickSelection: true,
            autoGroupColumnDef: {
                headerName: $filter('translate')('authorize_quotations.quotation_number'),
                field: "quotation.id",
                width: 100,
                cellRenderer: 'group',
                hide: true,
                cellRendererParams: {
                    checkbox: true
                }
            },
            angularCompileRows: true,
            angularCompileHeaders: true,
            enableColResize: true,
            rowData: null,
            rowHeight: 50,
            pinnedBottomRowData: [],
            onSelectionChanged: selectionChangedFunc,
        };
        vm.buttonDescription = 'authorize_quotations.authorize';

        //metodos
        vm.selectRequisition = selectRequisition;
        vm.backToQuotations = backToQuotations;
        vm.authorizeQuotation = authorizeQuotation;
        vm.replaceOriginTypedata = replaceOriginTypedata;
        vm.cancelRequisition = cancelRequisition;
        vm.onEditQuantity = onEditQuantity;
        vm.updateQuantity = updateQuantity;
        vm.showHistory = showHistory;
        vm.reCotizeQuotation = reCotizeQuotation;
        vm.currentDetail = {};

        function selectionChangedFunc(data) {
            data.api.rowModel.rowsToDisplay.forEach(function (param) {
                if (!param.group && !param.selected) {
                    param.data.references = [];
                    vm.detailToAuthorize.forEach(function (inf, index) {
                        if (param.data.id === inf.id) {
                            vm.detailToAuthorize.splice(index, 1);
                        }
                    });
                }
            });
            vm.merchandiseEntrysSend = [];
            if (vm.gridOptions.api.getSelectedNodes().length === 0) {
                vm.detailToAuthorize.forEach(function (inf, index) {
                    if (vm.currentDetail.id === inf.id) {
                        vm.detailToAuthorize.splice(index, 1);
                    }
                });
            }
            $timeout(function () {
                vm.merchandiseEntrysSend = angular.copy(vm.merchandiseEntrysSend);
            }, 100);
        }

        function setColumnsToGrid() {

            var columns = [
                {
                    headerName: $filter('translate')('authorize_quotations.quotation_number'),
                    field: "requisitionDetail.requisition.id",
                    width: 120,
                    hide: true,
                    rowGroupIndex: 0
                },
                {
                    headerName: $filter('translate')('authorize_quotations.quotation_number'),
                    field: "quotation.id",
                    width: 120,
                    hide: true,
                    rowGroupIndex: 0
                },
                {
                    headerName: $filter('translate')('authorize_quotations.product'),
                    field: "requisitionDetail.product.name",
                    width: 150,
                    cellRenderer: function (params) {
                        if (!params.node.group) {

                            if (params.data.requisitionDetail.product.brand && params.data.requisitionDetail.product.measurementUnit) {
                                return params.value + ", " + $filter('translate')('authorize_quotations.measurement_unit')
                                    + ": " + params.data.requisitionDetail.product.measurementUnit.name
                                    + ", " + $filter('translate')('authorize_quotations.brand') + ": " + params.data.requisitionDetail.product.brand.name;
                            } else {
                                return params.value;
                            }

                        } else {
                            return params.value;
                        }
                    }
                },
                {
                    headerName: $filter('translate')('authorize_quotations.quantity'),
                    field: "requisitionDetail.quantity",
                    width: 110,
                    cellStyle: { 'text-align': 'right' },
                    aggFunc: 'sum',
                    cellRenderer: function (params) {
                        if (params.node.group) {
                            return params.value;
                        } else {
                            params.data.editMode = false;
                            return editQuantityTemplate;
                        }
                    }
                },
                {
                    headerName: $filter('translate')('authorize_quotations.price'),
                    field: "price",
                    width: 110,
                    valueFormatter: function (params) {
                        return $filter('number')(params.value, 6);
                    },
                    cellStyle: { 'text-align': 'right' }
                },
                {
                    headerName: $filter('translate')('authorize_quotations.total'),
                    field: "subTotal",
                    width: 110,
                    valueFormatter: function (params) {
                        return $filter('number')(params.value, 2);
                    },
                    cellStyle: { 'text-align': 'right' },
                    aggFunc: 'sum'
                },
                {
                    headerName: $filter('translate')('authorize_quotations.observations'),
                    field: "requisitionDetail.observations",
                    width: 150
                }
            ];

            if (vm.hasBudgetApplication) {
                columns.push({
                    suppressMenu: true,
                    suppressSorting: true,
                    headerName: $filter('translate')('authorize_quotations.select_budgets'),
                    field: "budgetSelect",
                    width: 400,
                    cellRenderer: function (params) {
                        if (!params.node.group) {
                            var products = getBudgetsByProduct(params.data.requisitionDetail.product.id);
                            vm.productBudget[params.data.requisitionDetail.product.id] = getBudgetsByProduct(params.data.requisitionDetail.product.id);

                            params.$scope.isSelected = isSelected;
                            params.$scope.toggleSelectBudget = toggleSelectBudget;
                            params.$scope.validateRequestAmpliation = validateRequestAmpliation;
                            params.data.needExtension = false;

                            if (!params.data.totalCovered) {
                                params.data.totalCovered = 0;
                            }

                            params.data.requestAmpliation = false;


                            if (products.length === 1) {

                                $timeout(function () {
                                    if (products[0].available >= params.data.subTotal) {
                                        params.$scope.toggleSelectBudget(products[0], null, true);
                                    }
                                }, 2000);
                            }

                            return budgetsTemplate;

                        } else {
                            return "";
                        }
                    }
                });
            }

            columns.push({
                suppressMenu: true,
                suppressSorting: true,
                headerName: $filter('translate')('authorize_quotations.show_history'),
                field: "btnShowHistory",
                width: 110,
                cellRenderer: function (params) {
                    if (!params.node.group) {
                        return "<div layout='row' layout-align='center center'> " +
                            "<md-button ng-click='vm.showHistory(data)' class='md-icon-button' " +
                            "title='Ver historial de este producto'> " +
                            "<md-icon md-font-icon='icon-menu'></md-icon> </md-button> </div>";
                    }
                }
            });

            vm.gridOptions.api.setColumnDefs(columns);

        }

        function showHistory(data) {

            $mdDialog.show({
                controller: 'QuotationHistoryProductController',
                controllerAs: 'vm',
                locals: {
                    'quotationDetail': data,
                    'departmentId': vm.currentRequisition.departmentId,
                    'costCenterId': vm.currentRequisition.costCenterId
                },
                templateUrl: 'app/main/apps/quotation/pending-authorize/detail/show-history-product/history-product.html',
                parent: angular.element("#main"),
                targetEvent: null,
                clickOutsideToClose: false
            }).then(function (response) {
            }, function () {
            });
        }

        function updateQuantity(data, rowNode) {

            if (data.requisitionDetail.quantity === undefined
                || data.requisitionDetail.quantity === null
                || data.requisitionDetail.quantity === "" || parseInt(data.requisitionDetail.quantity) <= 0) {
                MessageService.showErrorMessage($filter('translate')('authorize_quotations.invalid_quantity'));
                return null;
            }

            var confirm = $mdDialog.confirm()
                .targetEvent(null)
                .title($filter('translate')('authorize_quotations.update_quantity'))
                .textContent($filter('translate')('authorize_quotations.confirm_that_you_want_to_update_the_quantity_of_this_item'))
                .ok($filter('translate')('general.si'))
                .cancel($filter('translate')('general.no'));

            $mdDialog.show(confirm).then(function () {
                $rootScope.loadingProgress = true;
                api.ComprasWS.QuotationDetail.updateQuantity.update(
                    {
                        'companyId': $rootScope.bsCircle.company.id,
                        'quotationId': data.quotation.id, 'quotationDetailId': data.id,
                        'quantity': parseInt(data.requisitionDetail.quantity)
                    }).$promise.then(function (response) {
                        $rootScope.loadingProgress = false;

                        data.editMode = false;
                        data.subTotal = parseInt(data.requisitionDetail.quantity) * data.price;
                        data.subTotalCompanyBuyer = parseInt(response.requisitionDetail.quantity) * data.price;

                        //actualiza los totales
                        var sumCantidad = 0;
                        var sumSubTotal = 0;

                        rowNode.parent.allLeafChildren.forEach(function (node) {
                            sumCantidad += node.data.requisitionDetail.quantity;
                            sumSubTotal += node.data.subTotal;
                        });

                        rowNode.parent.aggData["requisitionDetail.quantity"] = sumCantidad;
                        rowNode.parent.aggData["subTotal"] = sumSubTotal;

                        vm.gridOptions.api.refreshCells();

                        MessageService.show($filter('translate')('authorize_quotations.amount_updated_correctly'));

                    }, function (data) {
                        var msg = '';
                        switch (data.status) {
                          case 409:
                            msg = 'ORDER.MSG.PRODUCT';
                            break;
                          case 406:
                            var message = data.data.mensaje.split('|');
                            var max = message[0];
                            var available = message[1];
                            msg = $filter('translate')('ORDER.MSG.CANNOT_EXCEED_MAXIMUM') + '(' + max + ').'
                              + $filter('translate')('ORDER.MSG.AVAILABLE_TO_ORDER') + available;
                            break;
                          default:
                            msg = 'ORDER.MSG.ERROR';
                            break;
                        }

                        MessageService.showErrorMessage(msg);
                        vm.loading = false;
                        $rootScope.loadingProgress = false;
                        $log.error(data);
                    });
            }, function () {
            });

        }

        function onEditQuantity(scope, data, rowNode) {

            if (!data.editMode) {

                data.oldQuantityValue = data.requisitionDetail.quantity;

                data.editMode = true;

                $timeout(function () {
                    $("#input" + data.id).focus();
                }, 1000);

            } else {

                data.requisitionDetail.quantity = data.oldQuantityValue;
                data.editMode = false;

            }

        }

        function validateRequestAmpliation(event, scope) {

            var requestAmpliations = false;
            var authorizeQuotations = false;

            vm.gridOptions.api.getSelectedNodes().forEach(function (node) {

                if (!node.group && node.data) {

                    if (node.data.requestAmpliation) {
                        requestAmpliations = true;
                    }

                    if (node.data.totalCovered === node.data.subTotal) {
                        authorizeQuotations = true;
                    }

                }

            });

            if (requestAmpliations && authorizeQuotations) {
                vm.buttonDescription = 'authorize_quotations.authorize_and_request_ampliations';
            } else if (requestAmpliations) {
                vm.buttonDescription = 'authorize_quotations.request_ampliation';
            } else {
                vm.buttonDescription = 'authorize_quotations.authorize';
            }

        }

        function getBudgetsByProduct(productId) {

            if (vm.productBudget[productId] !== undefined && vm.productBudget[productId] !== null) {
                return vm.productBudget[productId];
            }

            var result = [];

            if (vm.budgets) {
                vm.budgets.forEach(function (row) {

                    if (row.product.id === productId) {
                        row.available = (row.amountOfficial - (row.amountExecuted ? row.amountExecuted : 0) - (row.amountReserved ? row.amountReserved : 0) - (row.amountNotExecuted ? row.amountNotExecuted : 0)).toFixed(2);
                        result.push(row);
                    }

                });
            }

            return result;

        }

        function selectRequisition(event, requisition) {

            if (vm.currentRequisition !== null && vm.currentRequisition !== undefined && vm.currentRequisition.requisitionId === requisition.requisitionId) {
                return null;
            }

            vm.circleQuotation = {};
            vm.currentRequisition = requisition;
            validateHasBudgetApplication(vm.currentRequisition.companyId);
            getDimensionCompany();

            for (var i = 0; i < $rootScope.circles.length; i++) {
                if ($rootScope.circles[i].company.id === vm.currentRequisition.companyId) {
                    vm.circleQuotation = $rootScope.circles[i];
                    break;
                }
            }

            var quotationIdArray = [];

            vm.currentRequisition.quotations.forEach(function (row) {
                quotationIdArray.push(row.id);
            });

            vm.showGrid = false;
            $rootScope.loadingProgress = true;
            api.ComprasWS.QuotationDetail.findDetailByQuotations.query(
                {
                    'companyId': 0, 'quotationId': 0, 'circleId': $rootScope.bsCircle.id,
                    'quotations': quotationIdArray.join(',')
                }).$promise.then(function (response) {
                    $rootScope.loadingProgress = false;
                    vm.gridOptions.api.setRowData(response);
                    vm.quotationDetails = response;

                    vm.gridOptions.api.forEachNode(function (node) {

                        node.setSelected(true);

                    });

                    vm.showGrid = true;

                }, function (response) {
                    $log.error(response);
                });

            api.ComprasWS.ProcessFlow.get({ id: vm.currentRequisition.requisitionId, type: 1 }, function (data) {
                vm.infoProcessFlow = data;
            });

        }

        function validateHasBudgetApplication(companyId) {
            api.GeneralWS.CompanyApplication.byAppName.get({ 'company': companyId, 'app': 'Presupuestos' }).$promise.then(function (responseParameter) {
                if (responseParameter.$status === 200) {
                    if (responseParameter.$data && responseParameter.$data !== "") {
                        vm.hasBudgetApplication = responseParameter.$data.active;
                        if (vm.hasBudgetApplication) {
                            getBudgets();
                        } else {
                            setColumnsToGrid();
                        }
                    } else {
                        setColumnsToGrid();
                    }
                }
            }, function (response) {
                $log.error(response);
            });
        }

        function getBudgets() {
            vm.isShowLoaderBudgets = true;
            api.PresupuestosWS.Budget.findApprovedOfBeforeAndCurrentAndAfterMonth.query(
                {
                    'idc': vm.circleQuotation.id, 'costCenterId': vm.currentRequisition.costCenterId,
                    'departmentId': vm.currentRequisition.departmentId,
                  'dimensionCompanyDetail3Id': vm.currentRequisition.dimensionCompanyDetail3Id,
                  'dimensionCompanyDetail4Id': vm.currentRequisition.dimensionCompanyDetail4Id,
                  'dimensionCompanyDetail5Id': vm.currentRequisition.dimensionCompanyDetail5Id
                }).$promise.then(function (response) {
                    vm.isShowLoaderBudgets = false;
                    vm.budgets = response;
                    setColumnsToGrid();
                }, function (response) {
                    vm.isShowLoaderBudgets = false;
                    $log.error(response);
                });
        }

        function backToQuotations() {
            $state.go('app.quotation.Ingresada');
        }

        function init() {
            vm.selectRequisition(null, vm.requisitionArray[0]);
        }

        function getBudgetsTemplate() {
            var resource = $sce.getTrustedResourceUrl('app/main/apps/quotation/pending-authorize/detail/budgetsTemplate.html');

            var resource2 = $sce.getTrustedResourceUrl('app/main/apps/quotation/pending-authorize/detail/editQuantityTemplate.html');

            $templateRequest(resource).then(function (template) {
                budgetsTemplate = template;
            }, function () {
                $log.error("Ocurrio un error al leer el template");
            });

            $templateRequest(resource2).then(function (template) {
                editQuantityTemplate = template;
            }, function () {
                $log.error("Ocurrio un error al leer el template");
            });
        }

        function isSelected(budgetDetail) {

            var scopeParent = this.$parent.$parent;

            if (scopeParent.data.references === undefined || scopeParent.data.references === null) {
                scopeParent.data.references = [];
            }

            for (var i = 0; i < scopeParent.data.references.length; i++) {
                if (scopeParent.data.references[i].budgetDetailId === budgetDetail.id) {
                    return true;
                }
            }

            return false;
        }

        function toggleSelectBudget(budgetDetail, event, fromParent) {

            var scopeParent;


            if (fromParent) {
                scopeParent = this;
            } else {
                scopeParent = this.$parent;
            }


            scopeParent.data.needExtension = false;
            vm.currentDetail = scopeParent.data;

            if (scopeParent.data.references === undefined || scopeParent.data.references === null || fromParent) {
                scopeParent.data.references = [];
            }

            if (event) {
                event.stopPropagation();
            }

            var selected = false;

            for (var i = 0; i < scopeParent.data.references.length; i++) {
                if (scopeParent.data.references[i].budgetDetailId === budgetDetail.id) {
                    scopeParent.data.totalCovered -= scopeParent.data.references[i].amountToUse;
                    calculateAvailable(scopeParent.data.references[i].budgetDetailId,
                        scopeParent.data.references[i].amountToUse, vm.productBudget[scopeParent.data.requisitionDetail.product.id]);
                    scopeParent.data.references.splice(i, 1);
                    selected = true;
                    break;
                }
            }

            if (!selected) {
                scopeParent.data.needExtension = scopeParent.data.subTotal > budgetDetail.available;

                var reference = {
                    referenceId: budgetDetail.id,
                    budgetId: budgetDetail.budget.id,
                    budgetDetailId: budgetDetail.id,
                    amountToUse: parseFloat(scopeParent.data.subTotal) > parseFloat(budgetDetail.available) ?
                        parseFloat(budgetDetail.available) :
                        parseFloat(scopeParent.data.subTotal),
                    budgetStartDate: budgetDetail.budget.startDate,
                    budgetEndDate: budgetDetail.budget.endDate,
                    currencyCode: budgetDetail.currencyOfficial.code,
                    budgetType: budgetDetail.budget.budgetType.description,
                    budgetExchangeRateOfficial: budgetDetail.exchangeRateOfficial
                };

                scopeParent.data.references.push(reference);
                scopeParent.data.totalCovered += reference.amountToUse;
                calculateAvailable(budgetDetail.id, reference.amountToUse * -1, vm.productBudget[scopeParent.data.requisitionDetail.product.id]);
                var exist = false;
                vm.detailToAuthorize.forEach(function (data) {
                    if (data.id === scopeParent.data.id) {
                        exist = true;
                    }
                });
                if (vm.detailToAuthorize.length === 0 && scopeParent.data.references.length > 0) {
                    exist = true;
                    vm.detailToAuthorize.push(scopeParent.data);
                }
                if (!exist && scopeParent.data.references.length > 0) {
                    vm.detailToAuthorize.push(scopeParent.data);
                }
            }

        }

        function calculateAvailable(budgetDetailId, amountToAdd, budgetDetailArray) {

            budgetDetailArray.forEach(function (budgetDetail) {
                if (budgetDetailId === budgetDetail.id) {
                    budgetDetail.available = parseFloat(budgetDetail.available) + parseFloat(amountToAdd);
                }
            });

        }

        function authorizeQuotation(event) {

            if (!vm.hasBudgetApplication) {

                var message, countQuotations, quotationDetailToAuthorize;

                countQuotations = 0;
                quotationDetailToAuthorize = [];

                vm.gridOptions.api.getSelectedNodes().forEach(function (node) {

                    if (!node.group) {

                        quotationDetailToAuthorize.push({
                            id: node.data.id,
                            product: node.data.requisitionDetail.product,
                            amount: 0,
                            referenceAmpliationId: 0,
                            unitPrice: 0,
                            currency: node.data.currencyCompanyBuyer,
                            exchangeRate: node.data.exchangeRateCompanyBuyer,
                            requestAmpliation: false,
                            references: [],
                            referenceHeaderId: node.data.quotation.id
                        });

                        countQuotations++;
                    }

                });

                if (countQuotations > 1) {
                    message = $filter('translate')('authorize_quotations.confirm_that_you_want_to_authorize') + " " + countQuotations + " items?";
                } else if (countQuotations === 1) {
                    message = $filter('translate')('authorize_quotations.confirm_that_you_want_to_authorize_the_selected_item');
                } else {
                    MessageService.show($filter('translate')('authorize_quotations.no_quotations_to_authorize'));
                    return null;
                }

                var confirm = $mdDialog.confirm()
                    .targetEvent(event)
                    .title($filter('translate')('authorize_quotations.authorize_quotations'))
                    .textContent(message)
                    .ok($filter('translate')('general.si'))
                    .cancel($filter('translate')('general.no'));

                $mdDialog.show(confirm).then(function () {
                    authorizeQuotationDetail(quotationDetailToAuthorize, 0);
                }, function () {
                });

            } else {

                var countRequestAmpliations;
                var countAuthorizeQuotations;

                countRequestAmpliations = 0;
                countAuthorizeQuotations = 0;

                if (vm.detailToAuthorize.length > 0) {
                    vm.detailToAuthorize.forEach(function (inf) {

                        if (inf.requestAmpliation) {
                            countRequestAmpliations++;
                        }
                        if (inf.totalCovered >= inf.subTotal) {
                            countAuthorizeQuotations++;
                        }

                    });
                } else {
                    vm.gridOptions.api.getSelectedNodes().forEach(function (node) {
                        if (!node.group) {

                            if (node.data && node.data.requestAmpliation) {
                                countRequestAmpliations++;
                            }

                            if (node.data && node.data.totalCovered >= node.data.subTotal) {
                                countAuthorizeQuotations++;
                            }

                        }
                    });
                }


                if (countRequestAmpliations > 0 && countAuthorizeQuotations > 0) {
                    message = $filter('translate')('authorize_quotations.confirm_that_you_want_to_request')
                        + " " + getMessageRequestAmpliations(countRequestAmpliations) + " "
                        + $filter('translate')('authorize_quotations.and_authorize') + " " + getMessageAuthorizeQuotations(countAuthorizeQuotations) + "?";
                } else if (countRequestAmpliations > 0) {
                    message = $filter('translate')('authorize_quotations.confirm_that_you_want_to_request')
                        + " " + getMessageRequestAmpliations(countRequestAmpliations) + "?";
                } else if (countAuthorizeQuotations > 0) {
                    message = $filter('translate')('authorize_quotations.confirm_that_you_want_to_authorize')
                        + getMessageAuthorizeQuotations(countAuthorizeQuotations) + "?";
                } else {

                    MessageService.show($filter('translate')('authorize_quotations.no_quotations_to_authorize'));

                    return null;
                }

                var confirm = $mdDialog.confirm()
                    .targetEvent(event)
                    .title($filter('translate')('authorize_quotations.authorize_quotations'))
                    .textContent(message)
                    .ok($filter('translate')('general.si'))
                    .cancel($filter('translate')('general.no'));

                $mdDialog.show(confirm).then(function () {
                    validateBudgetProducts();
                }, function () {
                });

            }

        }

        function getMessageRequestAmpliations(countRequestAmpliations) {
            if (countRequestAmpliations === 1) {
                return countRequestAmpliations + " " + $filter('translate')('authorize_quotations.ampliation');
            } else {
                return countRequestAmpliations + " " + $filter('translate')('authorize_quotations.ampliations');
            }
        }

        function getMessageAuthorizeQuotations(countAuthorizeQuotations) {
            if (countAuthorizeQuotations === 1) {
                return countAuthorizeQuotations + " item";
            } else {
                return countAuthorizeQuotations + " items";
            }
        }

        function validateBudgetProducts() {
            var productsToValidate = [];

            //vm.gridOptions.api.forEachNode(function (node) {
            if (vm.detailToAuthorize.length > 0) {
                vm.detailToAuthorize.forEach(function (inf) {
                    if (inf.references && inf.references.length > 0 && (!(inf.totalCovered < inf.subTotal) || inf.requestAmpliation)) {
                        var productToValidate = {
                            id: inf.id,
                            product: inf.requisitionDetail.product,
                            amount: inf.requestAmpliation ?
                                ((inf.subTotalCompanyBuyer - inf.totalCovered) / inf.references[inf.references.length - 1].budgetExchangeRateOfficial) :
                                inf.subTotalCompanyBuyer,
                            referenceAmpliationId: inf.references[inf.references.length - 1].referenceId,
                            unitPrice: 0,
                            currency: inf.currencyCompanyBuyer,
                            exchangeRate: inf.exchangeRateCompanyBuyer,
                            requestAmpliation: inf.requestAmpliation,
                            references: inf.references,
                            referenceHeaderId: inf.quotation.id
                        };

                        productsToValidate.push(productToValidate);
                    }
                });
            } else {
                vm.gridOptions.api.getSelectedNodes().forEach(function (node) {

                    if (!node.group && node.data && node.data.references && node.data.references.length > 0
                        && (!(node.data.totalCovered < node.data.subTotal) || node.data.requestAmpliation)) {

                        var productToValidate = {
                            id: node.data.id,
                            product: node.data.requisitionDetail.product,
                            amount: node.data.requestAmpliation ?
                                ((node.data.subTotalCompanyBuyer - node.data.totalCovered) / node.data.references[node.data.references.length - 1].budgetExchangeRateOfficial) :
                                node.data.subTotalCompanyBuyer,
                            referenceAmpliationId: node.data.references[node.data.references.length - 1].referenceId,
                            unitPrice: 0,
                            currency: node.data.currencyCompanyBuyer,
                            exchangeRate: node.data.exchangeRateCompanyBuyer,
                            requestAmpliation: node.data.requestAmpliation,
                            references: node.data.references,
                            referenceHeaderId: node.data.quotation.id
                        };

                        productsToValidate.push(productToValidate);

                    }

                });
            }





            $rootScope.loadingProgress = true;
            api.PresupuestosWS.Budget.validatesBudgetedProducts.validate(
                { 'idc': vm.circleQuotation.id }, { quotations: productsToValidate }).$promise.then(function (response) {
                    $rootScope.loadingProgress = false;
                    vm.productsToValidate = response;

                    var quotationDetailToAuthorize = new jinqJs()
                        .from(response)
                        .where(function (r) {
                            return r.lessOrEqualAmount;
                        })
                        .select();

                    var requestAmpliation = new jinqJs()
                        .from(response)
                        .where(function (r) {
                            return !r.lessOrEqualAmount && r.requestAmpliation;
                        })
                        .select();

                    authorizeQuotationDetail(quotationDetailToAuthorize, requestAmpliation.length);

                }, function (response) {
                    $rootScope.loadingProgress = false;
                    $log.error(response);
                });
        }

        function authorizeQuotationDetail(quotationDetailToAuthorize, countRequestAmpliations) {

            if (countRequestAmpliations > 0 && quotationDetailToAuthorize.length === 0) {
                MessageService.show($filter('translate')('authorize_quotations.it_was_requested') + " " + getMessageRequestAmpliations(countRequestAmpliations));
                backToQuotations();
                return null;
            }

            var quotationArray = new jinqJs()
                .from(quotationDetailToAuthorize)
                .distinct('referenceHeaderId')
                .select();

            quotationArray.forEach(function (quotation) {

                quotation.quotationId = quotation.referenceHeaderId;
                quotation.detail = [];

                quotationDetailToAuthorize.forEach(function (quotationDetail) {
                    if (quotationDetail.referenceHeaderId === quotation.quotationId) {
                        quotation.detail.push(quotationDetail);
                    }
                });

            });

            $rootScope.loadingProgress = true;
            api.ComprasWS.Quotation.authorize.update(
                {
                    'companyId': $rootScope.bsCircle.company.id,
                    'idCircle': $rootScope.bsCircle.id, 'quotationId': 0
                }, quotationArray).$promise.then(function (response) {
                    $rootScope.loadingProgress = true;

                    var message;

                    if (countRequestAmpliations > 0 && response.length > 0) {
                        message = $filter('translate')('authorize_quotations.it_was_requested')
                            + " " + getMessageRequestAmpliations(countRequestAmpliations) + " "
                            + $filter('translate')('authorize_quotations.and_was_authorized')
                            + getMessageAuthorizeQuotations(quotationDetailToAuthorize.length) + ".";
                    } else if (countRequestAmpliations > 0) {
                        message = $filter('translate')('authorize_quotations.it_was_requested')
                            + " " + getMessageRequestAmpliations(countRequestAmpliations) + ".";
                    } else if (response.length > 0) {
                        message = $filter('translate')('authorize_quotations.was_authorized')
                            + " " + getMessageAuthorizeQuotations(quotationDetailToAuthorize.length) + ".";
                    }

                    MessageService.show(message);

                    backToQuotations();
                }, function (response) {
                    $log.error(response);
                    $rootScope.loadingProgress = true;
                });
        }

        function cancelRequisition(event) {

            var quotationIdArray = [];
            vm.detailToCancel = [];


            vm.gridOptions.api.rowModel.rowsToDisplay.forEach(function (param) {
                if (!param.group && param.selected) {
                    vm.detailToCancel.push(param.data.id);
                }
            });
            var message;

            if (vm.detailToCancel.length > 0) {
                if (vm.detailToCancel.length > 1) {
                    message = $filter('translate')('authorize_quotations.confirm_that_you_want_to_cancel')
                        + " " + vm.detailToCancel.length + " " + $filter('translate')('authorize_quotations.quotations') + "?";
                } else {
                    message = $filter('translate')('authorize_quotations.confirm_that_you_want_to_cancel_the_quotation')
                        + " " + vm.detailToCancel[0] + "?";
                }

                var confirm = $mdDialog.confirm()
                    .targetEvent(event)
                    .title($filter('translate')('authorize_quotations.cancel_quotations'))
                    .textContent(message)
                    .ok($filter('translate')('general.si'))
                    .cancel($filter('translate')('general.no'));

                $mdDialog.show(confirm).then(function () {
                    $rootScope.loadingProgress = true;
                    api.ComprasWS.QuotationDetail.deleteDetail.cancel(
                        {
                            'companyId': $rootScope.bsCircle.company.id,
                            'circleId': $rootScope.bsCircle.id, 'quotationId': 0, 'quotationDetailIds': vm.detailToCancel
                        }).$promise.then(function (response) {
                            $rootScope.loadingProgress = false;

                            if (vm.detailToCancel.length > 1) {
                                MessageService.show($filter('translate')('authorize_quotations.quotation_successfully_canceled'));
                            } else {
                                MessageService.show($filter('translate')('authorize_quotations.quotations_successfully_canceled'));
                            }

                            vm.backToQuotations();

                        }, function (response) {
                            $rootScope.loadingProgress = false;
                            $log.error(response);
                        });

                }, function () { });
            } else {
                vm.gridOptions.api.forEachNode(function (node) {
                    if (!node.group) {
                        quotationIdArray.push(node.data.quotation.id);
                    }
                });

                if (quotationIdArray.length === 0) {
                    return null;
                }

                if (quotationIdArray.length > 1) {
                    message = $filter('translate')('authorize_quotations.confirm_that_you_want_to_cancel')
                        + " " + quotationIdArray.length + " " + $filter('translate')('authorize_quotations.quotations') + "?";
                } else {
                    message = $filter('translate')('authorize_quotations.confirm_that_you_want_to_cancel_the_quotation')
                        + " " + quotationIdArray[0] + "?";
                }

                var confirm = $mdDialog.confirm()
                    .targetEvent(event)
                    .title($filter('translate')('authorize_quotations.cancel_quotations'))
                    .textContent(message)
                    .ok($filter('translate')('general.si'))
                    .cancel($filter('translate')('general.no'));

                $mdDialog.show(confirm).then(function () {

                    $rootScope.loadingProgress = true;
                    api.ComprasWS.Quotation.cancelQuotations.update(
                        {
                            'companyId': $rootScope.bsCircle.company.id,
                            'circleId': $rootScope.bsCircle.id
                        }, quotationIdArray).$promise.then(function (response) {
                            $rootScope.loadingProgress = false;

                            if (quotationIdArray.length > 1) {
                                MessageService.show($filter('translate')('authorize_quotations.quotation_successfully_canceled'));
                            } else {
                                MessageService.show($filter('translate')('authorize_quotations.quotations_successfully_canceled'));
                            }

                            vm.backToQuotations();

                        }, function (response) {
                            $rootScope.loadingProgress = false;
                            $log.error(response);
                        });

                }, function () {

                });
            }


        }

        function reCotizeQuotation(ev) {
            var quotationIdArray = [];

            vm.gridOptions.api.getSelectedNodes().forEach(function (node) {
                if (!node.group) {
                    quotationIdArray.push(node.data.id);
                }
            });

            if (quotationIdArray.length === 0) {
                return null;
            }

            var message;

            if (quotationIdArray.length > 1) {
                message = $filter('translate')('authorize_quotations.confirm_that_you_want_to_reCotize') + " "
                    + quotationIdArray.length + " " + $filter('translate')('authorize_quotations.quotations') + "?";
            } else {
                message = $filter('translate')('authorize_quotations.confirm_that_you_want_to_reCotize_the_quotation')
                    + " " + quotationIdArray[0] + "?";
            }

            var confirm = $mdDialog.confirm()
                .targetEvent(ev)
                .title($filter('translate')('authorize_quotations.reCotize_quotations'))
                .textContent(message)
                .ok($filter('translate')('general.si'))
                .cancel($filter('translate')('general.no'));

            $mdDialog.show(confirm).then(function () {

                $rootScope.loadingProgress = true;
                api.ComprasWS.Quotation.reCotizeQuotations.update(
                    {
                        'companyId': $rootScope.bsCircle.company.id,
                        'circleId': $rootScope.bsCircle.id
                    }, quotationIdArray).$promise.then(function (response) {
                        $rootScope.loadingProgress = false;

                        if (quotationIdArray.length > 1) {
                            MessageService.show($filter('translate')('authorize_quotations.quotation_successfully_reCotized'));
                        } else {
                            MessageService.show($filter('translate')('authorize_quotations.quotations_successfully_reCotized'));
                        }

                        vm.backToQuotations();

                    }, function (response) {
                        $rootScope.loadingProgress = false;
                        if(response.data && response.data.mensaje) {
                            MessageService.showErrorMessage(response.data.mensaje.replace('CANNOT_REQUOTED', $filter('translate')('authorize_quotations.CANNOT_REQUOTED')));
                        }
                        $log.error(response);
                    });

            }, function () {

            });
        }

        function getDimensionCompany() {
            const NUMBER_DIMENSION_THREE = 3;
            const NUMBER_DIMENSION_FOUR = 4;
            const NUMBER_DIMENSION_FIVE = 5;
            api.GeneralWS.DimensionCompany.byCompany.getList(
              { 'company': vm.currentRequisition.companyId }
            ).$promise.then(function (responseDimension) {
              for (let i = 0; i < responseDimension.length; i++) {
                if (responseDimension[i].dimensionNumber === NUMBER_DIMENSION_THREE) {
                  vm.dimensionCompanyDetail3 = responseDimension[i];
                } else if (responseDimension[i].dimensionNumber === NUMBER_DIMENSION_FOUR) {
                  vm.dimensionCompanyDetail4 = responseDimension[i];
                } else if (responseDimension[i].dimensionNumber === NUMBER_DIMENSION_FIVE) {
                  vm.dimensionCompanyDetail5 = responseDimension[i];
                } else {
                  vm.dimensionCompanyDetail1 = responseDimension[i];
                }
              }
            });
          }

        getBudgetsTemplate();
        $timeout(init, 500);


    }

})();

(function () {
    'use strict';
    angular
        .module('app.quotation')
        .controller('QuotationDetailBudgetDialogController', QuotationDetailBudgetDialogController);

    /** @ngInject */
    function QuotationDetailBudgetDialogController($mdDialog, $filter, $timeout, quotationDetail, $scope) {

        var vm = this;

        vm.completedFeatures = false;

        vm.details = quotationDetail;

        vm.goToRef = goToRef;
        vm.cancel = cancel;


        vm.masterColumnDefs = [
            {
                headerName: 'QUOTATION.DETAIL.PRODUCT',
                field: "quotationDetail.requisitionDetail.product.name",
                headerCellRenderer: getHeader,
                width: 250,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'QUOTATION.BUDGET',
                name: "link",
                width: 350,
                headerCellRenderer: getHeader,
                cellRenderer: renderer,
                enablePivot: true
            }
        ];

        vm.masterGridOptions = {
            columnDefs: vm.masterColumnDefs,
            enableSorting: true,
            debug: false,
            enableFilter: true,
            enableColResize: true,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowData: null,
            groupHeaders: true,
            headerHeight: 64,
            rowHeight: 45,
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            doesDataFlower: function (dataItem) {
                return true;
            },
            isExternalFilterPresent: isExternalFilterPresent,
            doesExternalFilterPass: doesExternalFilterPass
        };

        // Data
        var filter = 'everyone';

        function isExternalFilterPresent() {
            // if ageType is not everyone, then we are filtering
            return filter !== '';
        }

        function doesExternalFilterPass(node) {
            if (filter && filter !== 'everyone') {
                var arrdt = node.data.filter.split(filter);
                return arrdt.length > 1;
            }
            return true;
        }

        $scope.$watch('vm.search',
            function (newValue) {
                filter = newValue ? newValue.toLowerCase() : 'everyone';
                vm.masterGridOptions.api.onFilterChanged();
            }
        );

        $timeout(function () {
            vm.masterGridOptions.api.setColumnDefs(vm.masterColumnDefs);
            vm.masterGridOptions.api.setRowData(vm.details);
        }, 1000);

        function renderer(params) {
            return '<div>Presupuesto # {{data.budgetId}} <a href="" ng-click="vm.goToRef(data)" target="_blank">(Ver Presupuesto)</a></div>';
        }

        function goToRef(data) {
            window.open(data.originType.queryUrl + data.budgetId, '_blank');
        }

        function cancel() {
            $mdDialog.cancel();
        }


    }

})();

(function () {
    'use strict';

    angular
        .module('app.requisition')
        .controller('requisitionTypeEditController', requisitionTypeEditController);

    /** @ngInject */
    function requisitionTypeEditController($mdDialog, requisitionType, api, $rootScope, MessageService) {
        var vm = this;


        var isNew = requisitionType ? false : true;

        if (!isNew) {
            vm.requisitionType = requisitionType;
        } else {
            vm.requisitionType = {
                company: { id: $rootScope.bsCircle.company.id }
            };
        }
        vm.productos = [];

        // Methods
        vm.closeDialog = closeDialog;
        vm.sendDetail = sendDetail;

        //////////

        function closeDialog() {
            $mdDialog.cancel();
        }



        function sendDetail() {
            if (vm.detailForm.$valid) {
                if (vm.detailForm.$dirty) {
                    vm.loading = true;

                    vm.promise;
                    if (isNew) {
                        vm.promise = api.ComprasWS.RequisitionType.RequisitionTypeCompany.create(
                            { company: $rootScope.bsCircle.company.id, idCircle: $rootScope.bsCircle.id },
                            vm.requisitionType).$promise;
                    } else {
                        vm.promise = api.ComprasWS.RequisitionType.RequisitionTypeCompany.update(
                            { company: $rootScope.bsCircle.company.id, id: vm.requisitionType.id, idCircle: $rootScope.bsCircle.id },
                            vm.requisitionType).$promise;
                    }

                    vm.promise.then(
                        function (data) {
                            $mdDialog.hide(data);
                            vm.loading = false;
                        },
                        function (data) {
                            var msg = 'ERROR';
                            if (data.status === 409) {
                                msg = data.data;
                                if (msg === 'Product is exist') {
                                    msg = 'PRODUCT';
                                }
                            }
                            MessageService.show('ORDER.MSG.' + msg);
                            vm.loading = false;
                        }
                    );
                } else {
                    $mdDialog.cancel();
                }
            }
        }

    }

})();

(function () {

    'use strict';

    angular
        .module('app.requisition')
        .controller('RequisitionEditDataBussinesController', RequisitionEditDataBussinesController);

    function RequisitionEditDataBussinesController($mdDialog, $timeout, api, requisition, $rootScope, MessageService) {

        var vm = this;

        vm.closeDialog = closeDialog;
        vm.requisition = requisition;
        vm.loading = false;
        vm.sendDataCompany = sendDataCompany;
        vm.loadDepartments = loadDepartments;
        vm.loadByCostCentersCompany = loadByCostCentersCompany;
        var params = { idc: vm.requisition.department.company.id };
        loadDepartments();
        loadByCostCentersCompany();


        function closeDialog() {
            $mdDialog.cancel();
        }

        function loadDepartments() {
            vm.loadingDepartments = true;
            api.GeneralWS.getAllDepartment.query(params, function (data) {
                if (data.length === 1) {
                    vm.departments = [data[0].id.toString()];
                }
                vm.departments = data;
                vm.loadingDepartments = false;
                vm.requisitionForm.$setPristine();
            });
        }


        function loadByCostCentersCompany() {
            vm.loadingCostCenter = true;
            api.GeneralWS.getAllCost.query(params, function (data) {
                vm.costCenters = data;
                vm.loadingCostCenter = false;
                vm.requisitionForm.$setPristine();
            });
        }

        function sendDataCompany() {
            vm.loading = true;
            $rootScope.loadingProgress = true;
            var promise = api.ComprasWS.RequisitionUpdateCompany.change({
                'idCircle': $rootScope.bsCircle.id,
                'id': vm.requisition.id,
                'departmentId': vm.requisition.department.id,
                'costCenterId': vm.requisition.costCenter.id
            }, null).$promise;
            promise.then(function (response) {
                if (response) {
                    MessageService.show("REQUISITION.MSG.UPDATESUCCESSFULLY");
                    $mdDialog.hide(response);
                }
                vm.loading = true;
                $rootScope.loadingProgress = false;
            }, function (response) {
                MessageService.showErrorMessage("REQUISITION.MSG.STATUSRECIBED");
                vm.loading = true;
                $rootScope.loadingProgress = false;
            });
        }

        vm.clearSearchDepartment = function () {
            vm.searchDepartment = "";
        };
        vm.clearSearchCostCenter = function () {
            vm.searchCostCenter = "";
        };
        $timeout(function () {

            var keyEvent = function (event) {
                event.stopPropagation();
            };

            var searchDepartmentInput = document.querySelector("#searchDepartment");
            var searchCostCenterInput = document.querySelector("#searchCostCenter");

            if (searchDepartmentInput) {
                searchDepartmentInput.addEventListener("keydown", keyEvent);
            }
            if (searchCostCenterInput) {
                searchCostCenterInput.addEventListener("keydown", keyEvent);
            }
        }, 100);

    }

})();

(function () {
    'use strict';
    angular
        .module('app.requisition')
        .controller('RequisitionTemplateController', RequisitionTemplateController);
    /** @ngInject */
    function RequisitionTemplateController($state, api, $scope, $log, $rootScope, $mdDialog, $timeout, $filter, $stateParams, MessageService) {
        var vm = this;

        // Data
        var isNew = true;
        vm.productTemplate = {
            monthStart: 1,
            yearStart: new Date().getFullYear(),
            frecuency: 1,
            repititions: 1
        };

        vm.months = getMonths(-1);
        vm.minYear = new Date().getFullYear();
        vm.shareMe = $stateParams.shareMe;

        vm.loadingDepartments = true;
        vm.loadingCostCenter = true;
        vm.loadingRequisitionType = true;

        // Methods
        vm.gotoTemplates = gotoTemplates;
        vm.openDialog = openDialog;
        vm.saveHeader = saveHeader;
        vm.deleteDetail = deleteDetail;
        vm.typesDates = getTypesDates();
        //////////
      vm.dimensionCompanyDetail3 = null;
      vm.dimensionCompanyDetail4 = null;
      vm.dimensionCompanyDetail5 = null;

      vm.searchDimensionCompanyDetail3 = '';
      vm.searchDimensionCompanyDetail4 = '';
      vm.searchDimensionCompanyDetail5 = '';

      vm.loadingdimensionCompanyDetail3List = false;
      vm.loadingdimensionCompanyDetail4List = false;
      vm.loadingdimensionCompanyDetail5List = false;

      vm.NUMBER_THREE = 3;
      vm.NUMBER_FOUR = 4;
      vm.NUMBER_FIVE = 5;

      vm.dimensionCompanyDetail3List = [];
      vm.dimensionCompanyDetail4List = [];
      vm.dimensionCompanyDetail5List = [];
      vm.two_hundred = 200;

      vm.masterColumnDefsDetail = [
            {
                headerName: 'Cantidad',
                field: "quantity",
                headerCellRenderer: getHeader,
                width: 200,
                enableRowGroup: true,
                enablePivot: true,
                cellStyle: { 'text-align': 'center' }
            },
            {
                headerName: 'Producto',
                field: "product.name",
                width: 300,
                headerCellRenderer: getHeader,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'TEMPLATE.ACTIONS',
                name: "actions",
                headerCellRenderer: getHeader,
                suppressSorting: true,
                suppressMenu: true,
                width: 250,
                cellRenderer: function (params) {
                    return '<div ng-if="!vm.shareMe" style="width: 100%;">'
                        + '            <md-button class="edit-button md-icon-button" ng-show="data.active" ng-click="vm.openDialog(data)" '
                        + ' aria-label="Order details"'
                        + '                        translate translate-attr-aria-label="TEMPLATE.PT.PRODUCT_DETAILS">'
                        + '                 <md-tooltip md-direction="bottom">'
                        + '                     {{"TEMPLATE.EDIT"| translate}}'
                        + '                 </md-tooltip>'
                        + '                 <md-icon md-font-icon="icon-border-color" class="s16"></md-icon> '
                        + '             </md-button>'
                        + '                                     <md-button class="edit-button md-icon-button" ng-show="data.active" '
                        + ' ng-click="vm.deleteDetail(data)" aria-label="Compare"'
                        + '                        translate translate-attr-aria-label="TEMPLATE.PT.COMPARE">'
                        + '                 <md-tooltip md-direction="bottom">'
                        + '                     {{"general.delete"| translate}}'
                        + '                 </md-tooltip>'
                        + '                 <md-icon md-font-icon="icon-delete" class="s16 md-warn"></md-icon> '
                        + '             </md-button>'
                        + '         </div>';
                },
                cellStyle: { 'padding': '0px' }
            }
        ];

        vm.masterGridOptionsDetail = {
            columnDefs: vm.masterColumnDefsDetail,
            enableSorting: true,
            debug: false,
            enableFilter: true,
            enableColResize: true,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowData: null,
            groupHeaders: true,
            headerHeight: 50,
            rowHeight: 40,
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            },
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            doesDataFlower: function (dataItem) {
                return true;
            }
        };


        vm.masterColumnDefsFrecuency = [
            {
                headerName: 'TEMPLATE.PT.MONTHS',
                field: "months",
                headerCellRenderer: getHeader,
                width: 300,
                enableRowGroup: true,
                enablePivot: true,
                cellRenderer: function (params) {
                    return '<div style="width: 100%;">'
                        + '          <span> {{"TEMPLATE.PT.MONTH." + data.months| translate}} </span>'
                        + '         </div>';
                }
            },
            {
                headerName: 'TEMPLATE.PT.YEAR',
                field: "years",
                width: 250,
                headerCellRenderer: getHeader,
                enableRowGroup: true,
                enablePivot: true,
                cellRenderer: function (params) {
                    return '<div style="width: 100%;">'
                        + ' <span> {{(data.years ? data.years : "TEMPLATE.PT.INDEFINIDE")| translate}}</span>'
                        + ' </div>';
                }
            }
        ];

        vm.masterGridOptionsFrecuency = {
            enableSorting: true,
            debug: false,
            enableFilter: true,
            enableColResize: true,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowData: null,
            groupHeaders: true,
            headerHeight: 50,
            rowHeight: 40,
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            },
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            doesDataFlower: function (dataItem) {
                return true;
            }
        };

        function init(id, ot) {
          getDimensionCompany($rootScope.bsCircle.company.id);
            var params = { idc: $rootScope.bsCircle.company.id, idPath: 'me' };
            api.GeneralWS.Department.query(params, vm.productTemplate, function (data) {
                if (data.length === 1) {
                    vm.productTemplate.department = {
                        id: data[0].id.toString()
                    };
                }
                vm.departments = data;
                vm.loadingDepartments = false;
            });

            api.GeneralWS.CostCenter.query(params, vm.productTemplate, function (data) {
                if (data.length === 1) {
                    vm.productTemplate.costCenter = {
                        id: data[0].id.toString()
                    };
                }
                vm.costCenters = data;
                vm.loadingCostCenter = false;
            });

            api.ComprasWS.RequisitionType.RequisitionTypeCompany.query({ 'company': $rootScope.bsCircle.company.id }, {}, function (data) {
                if (data.length === 1) {
                    vm.productTemplate.requisitionType = {
                        id: data[0].id.toString()
                    };
                }
                vm.requisitionTypes = data;
                vm.loadingRequisitionType = false;
            });

            id = id ? id : $stateParams.id;

            if (id) {
                $rootScope.loadingProgress = true;

                vm.masterGridOptionsDetail.api.setColumnDefs(vm.masterColumnDefsDetail);
                vm.masterGridOptionsDetail.api.setRowData([]);

                vm.masterGridOptionsFrecuency.api.setColumnDefs(vm.masterColumnDefsFrecuency);
                vm.masterGridOptionsFrecuency.api.setRowData([]);

                api.ComprasWS.RequisitionTemplate.get({ 'company': $rootScope.bsCircle.company.id, 'id': id }, function (data) {
                    vm.productTemplate = data;

                    vm.details = data.requisitionTemplateDetail;
                    vm.masterGridOptionsDetail.api.setRowData(vm.details);
                    vm.masterGridOptionsFrecuency.api.setRowData(data.requisitionTemplateDates);

                    vm.minYear = data.yearStart;

                    if (!vm.departments) {
                        vm.departments = [];
                        vm.departments.push(vm.productTemplate.department);
                    } else {
                        var exist = false;
                        vm.departments.forEach(function (depto) {
                            if (depto.id === vm.productTemplate.department.id) {
                                exist = true;
                            }
                        });
                        if (!exist) {
                            vm.departments.push(vm.productTemplate.department);
                        }
                    }

                    if (!vm.costCenters) {
                        vm.costCenters = [];
                        vm.costCenters.push(vm.productTemplate.costCenter);
                    } else {
                        var exist = false;
                        vm.costCenters.forEach(function (ccost) {
                            if (ccost.id === vm.productTemplate.costCenter.id) {
                                exist = true;
                            }
                        });
                        if (!exist) {
                            vm.costCenters.push(vm.productTemplate.costCenter);
                        }
                    }

                    $rootScope.loadingProgress = false;
                    vm.currentTab = 0;
                    if (ot) {
                        vm.currentTab = 1;
                    }

                    isNew = false;

                    $timeout(function () {
                        vm.productTemplateForm.$setPristine();
                        setDimensionCompanyDetailForm();
                    });
                });
            }
        }

        $scope.$watch('vm.isIndefinide', function (newVal) {
            vm.productTemplate.repititions = newVal ? 0 : (newVal === false ? 1 : vm.productTemplate.repititions);
        });

        $scope.$watch('vm.currentTab', function (newVal) {
            if (newVal === 1) {
                saveHeader();
            }
        });

        function getTypesDates() {
            var resp = [];
            resp.push({ id: 1, name: 'TEMPLATE.PT.DATETYPES.1' });
            resp.push({ id: 2, name: 'TEMPLATE.PT.DATETYPES.2' });
            resp.push({ id: 3, name: 'TEMPLATE.PT.DATETYPES.3' });
            resp.push({ id: 6, name: 'TEMPLATE.PT.DATETYPES.6' });
            resp.push({ id: 12, name: 'TEMPLATE.PT.DATETYPES.12' });
            return resp;
        }

        function saveHeader() {
            vm.showChangeStatusButton = false;

            if (vm.productTemplateForm.$valid && vm.productTemplateForm.$dirty) {

                $rootScope.loadingProgress = true;
                var promise;
                if (isNew) {
                    promise = api.ComprasWS.RequisitionTemplate.create({ company: $rootScope.bsCircle.company.id }, vm.productTemplate).$promise;
                } else {
                    promise = api.ComprasWS.RequisitionTemplate.update(
                        { company: $rootScope.bsCircle.company.id, id: $state.params.id }, vm.productTemplate).$promise;
                }

                promise.then(
                    function (data) {
                        $rootScope.loadingProgress = false;
                        vm.productTemplate = data;
                        vm.productTemplateForm.$setPristine();
                        if (isNew) {
                            $state.go($state.current.name, { id: data.id }, { notify: false });
                            $timeout(function () {
                                init(data.id, true);
                            }, 500);
                            isNew = false;
                        }
                    },
                    function (data) {
                        var message;
                        if (data.status === 409) {
                            message = 'BUDGETEXIST';
                        } else {
                            message = 'ERROR';
                        }
                        MessageService.show('REQUISITION.MSG.' + message);
                        $rootScope.loadingProgress = false;
                    }
                );
            }
        }

        function deleteDetail(detail, e, i, other) {
            var id = detail.id;
            var msg = other ? 'PASS' : 'DELETE';

            var confirm = $mdDialog.confirm()
                .title($filter('translate')('REQUISITION.MSG.SURE_' + msg))
                .ariaLabel('Delete modal')
                .targetEvent(e)
                .ok($filter('translate')('REQUISITION.' + msg))
                .cancel($filter('translate')('REQUISITION.CANCELAR'));

            $mdDialog.show(confirm).then(function () {

                $rootScope.loadingProgress = true;
                api.ComprasWS.RequisitionTemplateDetail.delete(
                    { company: $rootScope.bsCircle.company.id, id: id, idTemplate: vm.productTemplate.id }, function (response) {
                        vm.details.splice(i, 1);
                        $rootScope.loadingProgress = false;
                        vm.masterGridOptionsDetail.api.setRowData(vm.details);

                        MessageService.show('TEMPLATE.MSG.DELETED');
                    }, function (response) {// Error
                        $log.debug(response);
                    });

            }, function () {
                $rootScope.loadingProgress = false;
            });
        }

        function gotoTemplates() {
            $state.go('app.requisition.template');
        }

        function openDialog(ev, det, i) {
            composeDialog(ev, det, i);
        }

        function composeDialog(ev, det, i) {
            var detail = angular.copy(det);

            $mdDialog.show({
                controller: 'CreateDetailTemplatesController',
                controllerAs: 'vm',
                locals: {
                    template: vm.productTemplate,
                    templateDetail: detail
                },
                templateUrl: 'app/main/apps/requisition/requisition-template/detail/template-detail-dialog.html',
                parent: angular.element("#main"),
                targetEvent: ev,
                clickOutsideToClose: false
            }).then(function (answer) {
                if (!vm.details) {
                    vm.details = [];
                }
                if (det) {
                    vm.details[i] = answer;
                } else {
                    vm.details.push(answer);
                }
                vm.masterGridOptionsDetail.api.setRowData(vm.details);
            });
        }

        vm.clearSearchDepartment = function () {
            vm.searchDepartment = "";
        };

        vm.clearSearchCostCenter = function () {
            vm.searchCostCenter = "";
        };

        vm.clearSearchRequisitionType = function () {
            vm.searchRequisitionType = "";
        };

        $timeout(function () {

            var keyEvent = function (event) {
                event.stopPropagation();
            };

            var searchDepartmentInput = document.querySelector("#searchDepartment");
            var searchCostCenterInput = document.querySelector("#searchCostCenter");
            var searchRequisitionTypeInput = document.querySelector("#searchRequisitionType");

            if (searchDepartmentInput) {
                searchDepartmentInput.addEventListener("keydown", keyEvent);
            }

            if (searchCostCenterInput) {
                searchCostCenterInput.addEventListener("keydown", keyEvent);
            }

            if (searchRequisitionTypeInput) {
                searchRequisitionTypeInput.addEventListener("keydown", keyEvent);
            }

            init();
        }, 500);

      function getDimensionCompanyDetail(id, number) {
        api.GeneralWS.DimensionCompanyDetail.byDimensionCompany.getList(
          {'dimensionCompanyId': id}
        ).$promise.then(function (responseDimension) {
          const arrIds = vm.userDimensionCompanyDetails.map(function (row) {
            return row.dimensionCompanyDetailId;
          });
          if (number === vm.NUMBER_THREE) {
            vm.dimensionCompanyDetail3List = getArrayDimensionCompanyDetail(responseDimension, arrIds);
            vm.loadingdimensionCompanyDetail3List = false;
          }
          if (number === vm.NUMBER_FOUR) {
            vm.dimensionCompanyDetail4List = getArrayDimensionCompanyDetail(responseDimension, arrIds);
            vm.loadingdimensionCompanyDetail4List = false;
          }
          if (number === vm.NUMBER_FIVE) {
            vm.dimensionCompanyDetail5List = getArrayDimensionCompanyDetail(responseDimension, arrIds);
            vm.loadingdimensionCompanyDetail5List = false;
          }
        }, function () {
          vm.loadingdimensionCompanyDetail3List = false;
          vm.loadingdimensionCompanyDetail4List = false;
          vm.loadingdimensionCompanyDetail5List = false;
        });
      }

      function getDimensionCompany(companyId) {
        $rootScope.loadingProgress = true;
        clearDimensionObjectAndList();
        api.GeneralWS.Usr.User.basicUserInformation.get().$promise.then(function (user) {
          api.UserWS.UserDimension.ByUser.get({'userId': user.userId}).$promise.then(function (userList) {
            vm.userDimensionCompanyDetails = userList;

            vm.loadingdimensionCompanyDetail3List = true;
            vm.loadingdimensionCompanyDetail4List = true;
            vm.loadingdimensionCompanyDetail5List = true;
            api.GeneralWS.DimensionCompany.byCompany.getList(
              {'company': companyId}
            ).$promise.then(function (responseDimension) {
              for (let i = 0; i < responseDimension.length; i++) {
                if (responseDimension[i].dimensionNumber === vm.NUMBER_THREE) {
                  vm.dimensionCompanyDetail3 = responseDimension[i];
                  getDimensionCompanyDetail(responseDimension[i].id, responseDimension[i].dimensionNumber);
                } else if (responseDimension[i].dimensionNumber === vm.NUMBER_FOUR) {
                  vm.dimensionCompanyDetail4 = responseDimension[i];
                  getDimensionCompanyDetail(responseDimension[i].id, responseDimension[i].dimensionNumber);
                } else if (responseDimension[i].dimensionNumber === vm.NUMBER_FIVE) {
                  vm.dimensionCompanyDetail5 = responseDimension[i];
                  getDimensionCompanyDetail(responseDimension[i].id, responseDimension[i].dimensionNumber);
                } else {
                  vm.dimensionCompanyDetail1 = responseDimension[i];
                }
              }
              if (responseDimension.length === 0) {
                vm.productTemplate.dimensionCompanyDetail3 = null;
                vm.productTemplate.dimensionCompanyDetail4 = null;
                vm.productTemplate.dimensionCompanyDetail5 = null;
              }
              $timeout(function () {
                $rootScope.loadingProgresss = false;
              }, vm.two_hundred);
            }, function (err) {
              if (err) {
                vm.loadingdimensionCompanyDetail3List = false;
                vm.loadingdimensionCompanyDetail4List = false;
                vm.loadingdimensionCompanyDetail5List = false;
              }
            });
          }, function (errorUser) {
            $log.debug(errorUser);
          });
        }, function (err) {
          $log.debug(err);
        });
      }

      function getArrayDimensionCompanyDetail(responseDimension, arrIds) {
        return responseDimension.filter(function (item) {
          return arrIds.includes(item.id);
        });
      }

      function clearDimensionObjectAndList(){
        vm.dimensionCompanyDetail3 = null;
        vm.dimensionCompanyDetail4 = null;
        vm.dimensionCompanyDetail5 = null;
        vm.dimensionCompanyDetail3List = [];
        vm.dimensionCompanyDetail4List = [];
        vm.dimensionCompanyDetail5List = [];
      }

      function setDimensionCompanyDetailForm(){
        if (vm.productTemplate && vm.productTemplate.dimensionCompanyDetail3) {
          vm.productTemplate.dimensionCompanyDetail3 = {id: vm.productTemplate.dimensionCompanyDetail3.id.toString()};
        }
        if (vm.productTemplate && vm.productTemplate.dimensionCompanyDetail4) {
          vm.productTemplate.dimensionCompanyDetail4 = {id: vm.productTemplate.dimensionCompanyDetail4.id.toString()};
        }
        if (vm.productTemplate && vm.productTemplate.dimensionCompanyDetail5) {
          vm.productTemplate.dimensionCompanyDetail5 = {id: vm.productTemplate.dimensionCompanyDetail5.id.toString()};
        }
      }

    }
})();

(function () {
    'use strict';
    angular
        .module('app.requisition')
        .controller('RequisitionTemplateSharesController', RequisitionTemplateSharesController);
    /** @ngInject */
    function RequisitionTemplateSharesController($state, api, $scope, $log, $rootScope, $mdDialog, $filter, $stateParams, MessageService) {
        var vm = this;

        vm.masterColumnDefs = [
            {
                headerName: 'TEMPLATE.USER',
                field: "userShares.account",
                headerCellRenderer: getHeader,
                width: 600,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'TEMPLATE.ACTIONS',
                name: "actions",
                headerCellRenderer: getHeader,
                suppressSorting: true,
                suppressMenu: true,
                width: 250,
                cellRenderer: function (params) {
                    return '<div style="width: 100%;">' +
                        '<md-button class="edit-button md-icon-button"' +
                        'ng-click="vm.deleteUser($event, data.id,' + params.rowIndex + ')" aria-label="Compare"' +
                        'translate translate-attr-aria-label="TEMPLATE.PT.COMPARE">' +
                        '<md-tooltip md-direction="bottom">' +
                        '{{"TEMPLATE.DELETE"| translate}}' +
                        '</md-tooltip>' +
                        '<md-icon md-font-icon="icon-minus-circle" class="s16 md-warn"></md-icon> ' +
                        '</md-button>' +
                        '</div>';
                },
                cellStyle: { 'padding': '0px' },
                pinned: "right"
            }
        ];

        vm.masterGridOptionsU = {
            enableSorting: true,
            debug: false,
            enableFilter: true,
            enableColResize: true,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowData: null,
            groupHeaders: true,
            headerHeight: 50,
            rowHeight: 40,
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            },
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            doesDataFlower: function (dataItem) {
                return true;
            },
            isExternalFilterPresent: isExternalFilterPresent,
            doesExternalFilterPass: doesExternalFilterPass
        };

        var filter = 'everyone';

        function isExternalFilterPresent() {
            return filter !== '';
        }

        function doesExternalFilterPass(node) {
            if (filter && filter !== 'everyone') {
                var arrdt = node.data.filter.split(filter);
                return arrdt.length > 1;
            }
            return true;
        }

        $scope.$watch('vm.search',
            function (newValue) {
                filter = newValue ? newValue.toLowerCase() : 'everyone';
                vm.masterGridOptionsU.api.onFilterChanged();
            }
        );

        init();

        function init() {
            api.ComprasWS.RequisitionTemplate.get({ 'company': $rootScope.bsCircle.company.id, 'id': $stateParams.id }, function (data) {
                vm.productTemplate = data;

                vm.requisitionTemplateUser = {
                    requisitionTemplate: data,
                    user: {
                        account: vm.email
                    }
                };
                getUsers();
                vm.details = data.requisitionTemplateDetail;
            }, function (errResponse) {
                $log.debug(errResponse);
            });
        }

        function getUsers() {
            $rootScope.loadingProgress = true;
            api.ComprasWS.RequisitionTemplateUserShares.get({ 'idCircle': $rootScope.bsCircle.id, 'templateId': $stateParams.id }, function (data) {
                vm.masterGridOptionsU.api.setColumnDefs(vm.masterColumnDefs);
                vm.masterGridOptionsU.api.setRowData(data);
                $rootScope.loadingProgress = false;
            }, function (errResponse) {
                $rootScope.loadingProgress = false;
            });
        }

        vm.deleteUser = function (e, id, i) {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('TEMPLATE.CANCELAR'))
                .textContent($filter('translate')('TEMPLATE.MSG.CONFIRMACION_CANCEL'))
                .ok($filter('translate')('TEMPLATE.MSG.SI'))
                .cancel($filter('translate')('TEMPLATE.MSG.NO'));

            $mdDialog.show(confirm).then(function () {
                $rootScope.loadingProgress = true;
                api.ComprasWS.RequisitionTemplateUserShares.delete({ 'idCircle': $rootScope.bsCircle.id, 'id': id }, function (response) {
                    $rootScope.loadingProgress = false;
                    getUsers();
                    MessageService.show('TEMPLATE.MSG.DELETED');
                }, function (response) {// Error
                    $log.debug(response);
                });

            }, function () {
            });
        };

        vm.addUser = function () {
            $rootScope.loadingProgress = true;
            api.ComprasWS.RequisitionTemplateUserShares.create({ 'idCircle': $rootScope.bsCircle.id }, vm.requisitionTemplateUser, function (data) {
                getUsers();
                vm.requisitionTemplateUser.user.account = '';
                $rootScope.loadingProgress = false;
            }, function (errResponse) {
                if (errResponse.data && errResponse.data.mensaje === 'Exist') {
                    MessageService.showErrorMessage($filter('translate')('TEMPLATE.' + errResponse.data.mensaje));
                } else {
                    MessageService.showErrorMessage(errResponse.data.mensaje);
                }
                $rootScope.loadingProgress = false;
            });
        };

        vm.gotoTemplates = function () {
            $state.go('app.requisition.template');
        };

    }
})();

(function () {
    'use strict';

    angular
        .module('app.requisition')
        .controller('CreateDetailTemplatesController', CreateDetailTemplatesController);

    /** @ngInject */
    function CreateDetailTemplatesController($mdDialog, template, api, templateDetail, $timeout, $mdToast, $rootScope, $scope) {
        var vm = this;

        // Data

        vm.page = 1;
        vm.pageSize = 20;
        var isNew = templateDetail ? false : true;
        vm.selectedTab = 0;
        if (!isNew) {
            vm.detail = templateDetail;
            vm.selectedTab = 1;
        } else {
            vm.detail = {
                quantity: 1
            };
        }
        vm.loading = true;

        vm.hiddenCC = true;
        vm.hiddenBCC = true;
        getProducts(vm.page);

        // Methods
        vm.closeDialog = closeDialog;
        vm.selectProduct = selectProduct;
        vm.sendDetail = sendDetail;
        vm.getProducts = getProducts;
        vm.changeFilter = changeFilter;
        vm.activeSearch = activeSearch;

        //////////

        function closeDialog() {
            $mdDialog.cancel();
        }

        $scope.$watch('vm.filterProduct', function (newVal) {
            getProducts(1);
        });

        $scope.$watch('vm.detail.quantity', function (newVal) {
            if (vm.detail && newVal) {
                vm.detail.amount = newVal * (vm.detail.unitPrice ? vm.detail.unitPrice : 0);
            }
        });

        function changeFilter() {
            if (!vm.filterProduct || vm.filterProduct === '') {
                getProducts(1);
            }
        }

        function activeSearch() {
            vm.searchMode = true;
            $timeout(function () {
                $('#searchField').focus();
            });
        }

        function selectProduct(product) {
            vm.searchMode = false;
            var change = isNew ? isNew : vm.detail.product.id !== product.id;

            vm.detail.product = {
                id: product.id,
                productCode: product.productCode,
                name: product.name
            };
            if (product.salePrice) {
                vm.detail.unitPrice = product.buyPrice ? product.buyPrice : product.salePrice;
                vm.detail.currency = product.buyPrice ? product.currencyBuy : product.currencySale;
            }
            vm.selectedTab = 1;
            if (isNew || change) {
                $timeout(function () {
                    vm.detailForm.$setDirty();
                });
            }
            $timeout(function () {
                $('#amount').focus();
            });
        }

        function getProducts(page) {
            vm.page = page;
            vm.loading = true;
            api.GeneralWS.ProductAll.get({ circle: $rootScope.bsCircle.id, page: page - 1, size: vm.pageSize, filter: vm.filterProduct },
                function (data) {
                    vm.productos = data;
                    vm.loading = false;
                },
                function (data) {
                    vm.loading = false;
                }
            );
        }

        function sendDetail() {
            if (vm.detailForm.$valid) {
                if (vm.detailForm.$dirty) {
                    vm.loading = true;
                    vm.promise;
                    if (isNew) {
                        vm.promise = api.ComprasWS.RequisitionTemplateDetail.create(
                            { idTemplate: template.id, company: $rootScope.bsCircle.company.id }, vm.detail).$promise;
                    } else {
                        delete vm.detail.product.modifiedAt;
                        vm.promise = api.ComprasWS.RequisitionTemplateDetail.update(
                            { idTemplate: template.id, id: vm.detail.id, company: $rootScope.bsCircle.company.id }, vm.detail).$promise;
                    }

                    vm.promise.then(
                        function (data) {
                            $mdDialog.hide(data);
                            vm.loading = false;
                        },
                        function (data) {
                            var msg = 'ERROR';
                            if (data.status === 406) {
                                msg = data.data;
                                if (msg === 'Product is exist') {
                                    msg = 'PRODUCT';
                                }
                            }
                            $mdToast.show({
                                template: '<md-toast layout="column" layout-align="center start"><div class="md-toast-content" translate="TEMPLATE.MSG.'
                                    + msg + '"></div></md-toast>',
                                hideDelay: 3000,
                                position: 'top right'
                            });
                            vm.loading = false;
                        }
                    );
                } else {
                    $mdDialog.cancel();
                }
            }
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('app.requisition')
        .controller('AddRequisitionToQuoteController', addRequisitionToQuoteController);

    /** @ngInject */
    function addRequisitionToQuoteController($mdDialog, api, requisition, $rootScope, MessageService, $filter) {
        const vm = this;

        vm.closeDialog = closeDialog;
        vm.requisition = requisition;
        vm.roleComprasOperador = {};
        vm.searchUserInput = '';
        vm.isShowLoaderUsers = false;
        vm.toggleUser = toggleUser;
        vm.asociateUser = asociateUser;
        $rootScope.loadingProgress = false;
        vm.loadingAssociation = false;
        vm.paginationUsers = {
            pageNumber: 1,
            pageSize: 20,
            totalElements: 0,
            totalPages: 0,
            numberOfElements: 0,
            nextPage: getNextPage(),
            beforePage: getBeforePage(),
            firstPage: getFirstPage(),
            lastPage: getLastPage(),
            getPage: getPageByNumber()
        };

        init();

        function closeDialog() {
            $mdDialog.cancel();
        }

        function init() {
            getUsersToQuote();
        }

        function getUsersToQuote() {
            vm.isShowLoaderUsers = true;
            api.GeneralWS.RoleApplication.getRoles(
                {
                    applicationId: $rootScope.bsCircle.role.aplication.id,
                    nameLike: 'ROLE_COMPRAS_OPERADOR'
                }
            ).$promise.then(function (response) {
                vm.roleComprasOperador = response[0];
                searchUser();
            });
        }

        function searchUser() {
            vm.isShowLoaderUsers = true;
            api.GeneralWS.UsersCompany.get({
                'company': vm.requisition.department.company.id,
                'roleId': vm.roleComprasOperador.id,
                'pageNumber': vm.paginationUsers.pageNumber,
                'pageSize': vm.paginationUsers.pageSize,
                'search': vm.searchUserInput
            }).$promise.then(function (response) {
                vm.userArray = response.content;
                vm.paginationUsers.totalElements = response.totalElements;
                vm.paginationUsers.totalPages = response.totalPages;
                vm.paginationUsers.numberOfElements = response.numberOfElements;
                vm.isShowLoaderUsers = false;
            });
        }

        function toggleUser(user) {
            vm.requisition.userToQuote = user;
        }

        function asociateUser() {
            $rootScope.loadingProgress = true;
            vm.loadingAssociation = true;
            api.ComprasWS.asociateUserToQuote.asociate(
                {
                    'requisitionId': vm.requisition.id,
                    'userId': vm.requisition.userToQuote.id
                }
            ).$promise.then(function (resp) {
                MessageService.show($filter('translate')('USER_ASIGNMENT.USER_ASOCIATED_SUCCESSFULLY'));
                $rootScope.loadingProgress = false;
                vm.loadingAssociation = false;
                $mdDialog.hide(resp);
            });
        }

        function getNextPage() {
            return function () {
                this.pageNumber++;
            }
        }

        function getBeforePage() {
            return function () {
                this.pageNumber--;
            }
        }

        function getFirstPage() {
            return function () {
                this.pageNumber = 1;
            }
        }

        function getLastPage() {
            return function () {
                this.pageNumber = this.totalPages;
            }
        }

        function getPageByNumber() {
            return function (pageNumber) {
                this.pageNumber = pageNumber;
                searchUser();
            }
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.requisition')
        .controller('requisitionCompareDialogController', requisitionCompareDialogController);

    /** @ngInject */
    function requisitionCompareDialogController($mdDialog, $rootScope, $timeout, api, $log, MessageService, requisitionId) {
        const vm = this;
        // Methods
        vm.closeDialog = closeDialog;
        vm.compare = compare;
        vm.changeStartDate = changeStartDate;
        vm.clearSearchDepartment = clearSearchDepartment;
        vm.clearSearchCostCenter = clearSearchCostCenter;
        vm.clearRequisitionType = clearRequisitionType;
        vm.search = search;
        vm.selectAllRequisition = selectAllRequisition;
        vm.toggle = toggle;
        vm.isSelected = isSelected;
        vm.lastHour = 23;
        vm.lastMinuteAndSecond = 59;
        vm.timeout1000 = 1000;

        //Variables
        vm.isShowFilter = true;
        vm.minDate = new Date();
        vm.filter = {
            startDate: new Date(vm.minDate.getTime()),
            endDate: new Date(vm.minDate.getTime()),
        };
        vm.snFilter = {
            department: true,
            costCenter: true,
            filterByDates: true,
            requisitionTypes: true,
            requisitionNo: true,
        };
        vm.requisitions = [];

        vm.load = false;
        vm.pagination = {
            pageNumber: 1,
            pageSize: 20,
            totalElements: 0,
            totalPages: 0,
        };
        vm.pagination.nextPage = function () {
            this.pageNumber++;
        };
        vm.pagination.beforePage = function () {
            this.pageNumber--;
        };
        vm.pagination.firstPage = function () {
            this.pageNumber = 1;
        };
        vm.pagination.lastPage = function () {
            this.pageNumber = this.totalPages;
        };
        vm.pagination.getPage = function (pageNumber) {
            this.pageNumber = pageNumber;
            getRequisition();
        };

        vm.countRequisitionSelected = 0;
        vm.selectedArray = [];
        //////////

        function changeStartDate(isStart) {
            if (isStart) {
                if (vm.filter.startDate > vm.filter.endDate) {
                    vm.filter.endDate = vm.filter.startDate;
                }
            } else {
                if (vm.filter.endDate < vm.filter.startDate) {
                    vm.filter.startDate = vm.filter.endDate;
                }
            }
            vm.filter.startDate = setDateType(vm.filter.startDate, false);
            vm.filter.endDate = setDateType(vm.filter.endDate, true);
        }

        function setDateType(date, end) {
            if (end) {
                date.setHours(vm.lastHour);
                date.setMinutes(vm.lastMinuteAndSecond);
                date.setSeconds(vm.lastMinuteAndSecond);
            } else {
                date.setHours(0);
                date.setMinutes(0);
                date.setSeconds(0);
            }
            return date;
        }

        function closeDialog() {
            $mdDialog.cancel();
        }

        function compare() {
            $mdDialog.hide(vm.selectedArray);
        }

        function search() {

            if (!vm.filter.startDate) {
                vm.filter.startDate = new Date();
            }
            if (!vm.filter.endDate) {
                vm.filter.endDate = new Date();
            }
            vm.filter.startDate.setHours(0);
            vm.filter.startDate.setMinutes(0);
            vm.filter.startDate.setSeconds(0);

            vm.filter.endDate.setHours(vm.lastHour);
            vm.filter.endDate.setMinutes(vm.lastMinuteAndSecond);
            vm.filter.endDate.setSeconds(vm.lastMinuteAndSecond);

            setFilterListData('departments');
            setFilterListData('costCenters');
            setFilterListData('requisitionTypes');

            vm.isShowFilter = false;

            getRequisition();
        }

        function setFilterListData(propertyName) {
            if (!vm.filter[propertyName] || vm.filter[propertyName].length <= 0) {
                vm.filter[propertyName] = [];

                if (vm[propertyName]) {
                    vm[propertyName].forEach(function (row) {
                        vm.filter[propertyName].push(row.id);
                    });
                } else {
                    vm.filter[propertyName].push(0);
                }
            }
        }

        function loadCostCenter() {
            vm.loadingCostCenter = true;
            api.GeneralWS.CostCenter.query({ idc: $rootScope.bsCircle.company.id }, function (data) {
                if (data.length === 1) {
                    vm.filter.costCenters = [data[0].id.toString()];
                }
                vm.costCenters = data;
                vm.loadingCostCenter = false;
            });
        }

        function loadDepartments() {
            vm.loadingDepartments = true;
            api.GeneralWS.Department.query({ idc: $rootScope.bsCircle.company.id }, function (data) {
                if (data.length === 1) {
                    vm.filter.departments = [data[0].id.toString()];
                }
                vm.departments = data;
                vm.loadingDepartments = false;
            });
        }

        function loadRequisitionTypes() {
            vm.loadingRequisitionTypes = true;
            api.ComprasWS.RequisitionType.RequisitionTypeCompany
                .query({ 'company': $rootScope.bsCircle.company.id }, function (data) {
                    vm.requisitionTypes = data;
                    vm.loadingRequisitionTypes = false;
                });
        }

        function clearSearchDepartment() {
            vm.searchDepartment = '';
        }

        function clearSearchCostCenter() {
            vm.searchCostCenter = '';
        }

        function clearRequisitionType() {
            vm.searchRequisitionType = '';
        }

        function getRequisition() {
            vm.isShowProgressLinear = true;
            vm.load = true;
            api.ComprasWS.Requisitions.filterToCompare.page({
                'circleId': $rootScope.bsCircle.id,
                'reqId': requisitionId,
                'page': vm.pagination.pageNumber - 1,
                'pageSize': vm.pagination.pageSize,
            }, vm.filter).$promise.then(function (response) {
                vm.isShowProgressLinear = false;
                vm.load = false;

                vm.pagination.totalElements = response.totalElements;
                vm.pagination.totalPages = response.totalPages;
                vm.requisitions = response.content;
                vm.isCheckAllRequisition = false;

            }, function (response) {
                $log.error(response);
                vm.isShowProgressLinear = false;
                vm.load = false;
                vm.isCheckAllRequisition = false;
                vm.requisitions = [];
                MessageService.showErrorMessage('REQUISITION.MSG.ERROR');
            });
        }

        function selectAllRequisition() {
            if (vm.isCheckAllRequisition) {
                let countSelected = 0;
                vm.requisitions.forEach(function (row) {
                    row.isCheck = true;

                    const present = vm.selectedArray.find(function (element) {
                        return element.id === row.id;
                    });
                    if (!present) {
                        vm.selectedArray.push(row);
                        countSelected = countSelected + 1;
                    }

                });

                vm.countRequisitionSelected = vm.countRequisitionSelected + countSelected;

            } else {
                let countDeselected = 0;
                vm.requisitions.forEach(function (row) {
                    row.isCheck = false;

                    const present = vm.selectedArray.find(function (element) {
                        return element.id === row.id;
                    });
                    if (present) {
                        vm.selectedArray.splice(vm.selectedArray.indexOf(present), 1);
                        countDeselected = countDeselected + 1;
                    }

                });

                vm.countRequisitionSelected = vm.countRequisitionSelected - countDeselected;
            }
        }

        function toggle(data, event) {
            if (event) {
                event.stopPropagation();
            }
            if (vm.selectedArray.indexOf(data) > -1) {
                vm.selectedArray.splice(vm.selectedArray.indexOf(data), 1);
            } else {
                vm.selectedArray.push(data);
            }
        }

        function isSelected(data) {
            const present = vm.selectedArray.find(function (element) {
                return element.id === data.id;
            });
            return present && present.id > 0;
        }

        $timeout(function () {
            const keyEvent = function (event) {
                event.stopPropagation();
            };

            const searchDepartmentInput = document.querySelector('#searchDepartment');
            const searchCostCenterInput = document.querySelector('#searchCostCenter');
            const searchRequisitionTypeInput = document.querySelector('#searchRequisitionType');

            if (searchDepartmentInput) {
                searchDepartmentInput.addEventListener('keydown', keyEvent);
            }
            if (searchCostCenterInput) {
                searchCostCenterInput.addEventListener('keydown', keyEvent);
            }
            if (searchRequisitionTypeInput) {
                searchRequisitionTypeInput.addEventListener('keydown', keyEvent);
            }

            const dialog = $('.requisition-compare-dialog');
            let dialogHeight = parseInt(dialog.innerHeight());

            const toolbar = $('#dialog-toolbar');
            const toolbarHeight = parseInt(toolbar.innerHeight());

            const filterHeight = 53;
            const paginationHeight = 77;
            const selectAllHeight = 35;

            dialogHeight = dialogHeight - toolbarHeight - filterHeight - paginationHeight - selectAllHeight;

            vm.dinamicHeight = {
                'height': dialogHeight + 'px',
            };
        }, vm.timeout1000);

        init();

        function init() {
            loadDepartments();
            loadCostCenter();
            loadRequisitionTypes();
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('app.requisition')
        .controller('SelectTemplatesController', SelectTemplatesController);

    /** @ngInject */
    function SelectTemplatesController($mdDialog, templates, $filter, $timeout, $mdToast, api,
        idRequisition, $rootScope, requisitionTypes, requisitionType) {
        var vm = this;
        vm.templates = fixData();

        vm.getTemplate = getTemplate;
        vm.selectAllTemplates = selectAllTemplates;
        vm.templatessSend = [];
        vm.sendTemplates = sendTemplates;
        vm.selectAll = false;
        vm.closeDialog = closeDialog;
        vm.selectItem = selectItem;
        vm.selectCompany = selectCompany;
        vm.requisitionTypes = requisitionTypes;
        vm.requisitionType = requisitionType;
        vm.getDataTemplate = getDataTemplate;

        var selprod = {};

        var addFilterAll = false
        vm.requisitionTypes.forEach(function (data) {
            if (data.id === 0) {
                addFilterAll = true
            }
        });

        if (!addFilterAll) {
            vm.requisitionTypes.splice(0, 0, { id: 0, description: 'Filtrar Todos' });
        }

        // Data
        vm.masterColumnDefs = [
            {
                headerName: '',
                field: "idProduct",
                width: 100,
                cellRenderer: function (params) {
                    if (params.data) {
                        return '<div>'
                            + '<input type="checkbox" ng-model="data.selected" ng-click="vm.selectItem(data)"/> '
                            + '</div>';
                    }
                    return '';
                },
                hide: true
            },
            {
                headerName: 'REQUISITION.DETAIL.PRODUCT',
                field: "product",
                headerCellRenderer: getHeader,
                width: 180
            },
            {
                headerName: 'REQUISITION.DETAIL.QUANTITY',
                field: "quantity",
                width: 100,
                headerCellRenderer: getHeader,
                cellStyle: { 'text-align': 'center' }
            },
            {
                headerName: 'REQUISITION.DESCRIPTION',
                field: "description",
                headerCellRenderer: getHeader,
                width: 150,
                rowGroupIndex: 0,
                headerCheckboxSelection: true,
                hide: true
            }
        ];

        vm.masterGridOptions = {
            columnDefs: vm.masterColumnDefs,
            groupHeaders: true,
            groupDefaultExpanded: 1,
            groupSelectsChildren: true,
            rowSelection: 'multiple',
            enableColResize: true,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowData: null,
            headerHeight: 50,
            rowHeight: 45,
            suppressRowClickSelection: true,
            autoGroupColumnDef: {
                headerName: $filter('translate')('REQUISITION.DESCRIPTION'),
                field: "idProduct",
                width: 150,
                cellRenderer: 'group',
                hide: true,
                cellRendererParams: {
                    checkbox: true
                },
                pinned: "left"
            },
            doesDataFlower: function (dataItem) {
            },
            isExternalFilterPresent: isExternalFilterPresent,
            doesExternalFilterPass: doesExternalFilterPass,
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            },
            onSelectionChanged: selectionChangedFunc
        };

        function selectionChangedFunc(params, other) {

            vm.templatessSend = [];

            for (var i = 0; i < vm.masterGridOptions.api.getSelectedNodes().length; i++) {
                vm.masterGridOptions.api.getSelectedNodes()[i].data.selected = true;
                selectItem(vm.masterGridOptions.api.getSelectedNodes()[i].data);
            }
            $timeout(function () {
                vm.templatessSend = angular.copy(vm.templatessSend);
            }, 100);
        }

        var filter = 'everyone';

        function isExternalFilterPresent() {
            return filter !== '';
        }

        function selectItem(data) {
            if (data.selected) {
                selprod[data.idProduct.toString()] = true;
                vm.templatessSend ? vm.templatessSend : [];
                vm.templatessSend.push(data);
            }
        }

        function fixData() {
            var templat = [];
            templates.forEach(function (d) {
                templat.push({
                    description: d.templateDescription,
                    product: d.productName,
                    idProduct: d.productId,
                    quantity: d.quantity
                });
            });
            return templat;
        }

        function doesExternalFilterPass(node) {
            if (filter && filter !== 'everyone') {
                var arrdt = node.data.filter.split(filter.toLowerCase());
                return arrdt.length > 1;
            }
            return true;
        }

        function getTemplate() {
            vm.masterGridOptions.api.setColumnDefs(vm.masterColumnDefs);
            vm.masterGridOptions.api.setRowData(vm.templates);
        }

        function selectAllTemplates() {
            vm.templatessSend = [];

            vm.masterGridOptions.api.forEachNode(function (param) {
                if (!vm.selectAll && param.data) {
                    vm.masterGridOptions.api.selectAll();
                    param.data.selected = true;
                    selectItem(param.data);
                } else {
                    vm.masterGridOptions.api.deselectAll();
                }
            });

        }

        function sendTemplates() {

            var resp = new jinqJs()
                .from(vm.templatessSend)
                .select(function (r) {
                    return {
                        product: { id: r.idProduct },
                        quantity: r.quantity,
                        observations: ''
                    };
                });

            api.ComprasWS.Requisition.updateBatch(
                {
                    id: idRequisition, tipo: 'batch',
                    companyId: $rootScope.bsCircle.company.id, loadFromTemplate: true, idCircle: $rootScope.bsCircle.id
                }, resp, function (data) {
                    $mdDialog.hide(data);
                }, function (data) {
                    var msg = 'ERROR';
                    if (data.status === 409) {
                        msg = data.data;
                    }
                    $mdToast.show({
                        template: '<md-toast layout="column" layout-align="center start"><div class="md-toast-content" translate="ORDER.MSG.'
                            + msg + '"></div></md-toast>',
                        hideDelay: 3000,
                        position: 'top right'
                    });
                });
        }

        //////////

        function closeDialog() {
            $mdDialog.cancel();
        }

        function selectCompany() {
            $mdDialog.hide(vm.company);
        }


        function init() {
            getTemplate();
        }

        $timeout(init, 300);

        function getDataTemplate() {
            vm.templatessSend = [];
            api.ComprasWS.RequisitionTemplateBudget.query(
                { company: $rootScope.bsCircle.company.id, idRequisition: idRequisition, requisitionTypeId: vm.requisitionType.id },
                function (data) {
                    templates = data;
                    vm.templates = fixData();
                    getTemplate();
                },
                function (err) {
                });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.requisition')
        .controller('SelectCompanyController', SelectCompanyController);

    /** @ngInject */
    function SelectCompanyController($mdDialog, $rootScope, $timeout) {
        var vm = this;

        // Data
        vm.companies = $rootScope.circles;

        // Methods
        vm.closeDialog = closeDialog;
        vm.selectCompany = selectCompany;

        //////////

        function closeDialog() {
            $mdDialog.cancel();
        }

        function selectCompany() {
            $mdDialog.hide(vm.company);
        }

        vm.clearSearchRole = function () {
            vm.searchRole = "";
        };

        $timeout(function () {
            var keyEvent = function (event) {
                event.stopPropagation();
            };

            var searchRoleInput = document.querySelector("#searchRole");
            if (searchRoleInput) {
                searchRoleInput.addEventListener("keydown", keyEvent);
            }
        }, 500);
    }
})();

(function () {
    'use strict';

    angular
        .module('app.requisition')
        .controller('ProductsByBudgetController', productsByBudgetController);

    /** @ngInject */
    function productsByBudgetController($mdDialog, $filter, $timeout, api, idRequisition, $rootScope, MessageService) {
        var vm = this;

        vm.closeDialog = closeDialog;
        vm.getTemplate = getTemplate;
        vm.selectItem = selectItem;
        vm.sendData = sendData;
        vm.selectAllItems = selectAllItems;
        vm.itemSelected = [];

        api.ComprasWS.Requisition.get({ idCircle: $rootScope.bsCircle.id, id: idRequisition }, function (data) {
            vm.requisition = data;
        }, function (errResponse) {

        });


        // Data
        vm.masterColumnDefs = [
            {
                headerName: '',
                field: "product.id",
                width: 100,
                cellRenderer: function (params) {
                    if (params.data) {
                        return '<div>' +
                            '<input type="checkbox" ng-model="data.selected" ng-click="vm.selectItem(data)"/> ' +
                            '</div>';
                    }
                    return '';
                }
            },
            {
                headerName: 'REQUISITION.DETAIL.PRODUCT',
                field: "product.name",
                headerCellRenderer: getHeader,
                width: 180
            },
            {
                headerName: 'REQUISITION.DETAIL.QUANTITY',
                field: "quantity",
                width: 100,
                headerCellRenderer: getHeader,
                cellStyle: { 'text-align': 'center' }
            },
            {
                headerName: 'REQUISITION.DETAIL.PRICE',
                field: "unitPrice",
                width: 150,
                headerCellRenderer: getHeader,
                cellStyle: { 'text-align': 'right' },
                cellRenderer: function (params) {
                    if (!params.node.group) {
                        if (params.data && params.data.currency && params.data.unitPrice) {
                            return params.data.currency.symbol + ". " + $filter('number')(params.data.unitPrice, 2);
                        } else {
                            return params.value;
                        }
                    } else {
                        return params.value;
                    }
                }
            }
        ];

        vm.masterGridOptions = {
            columnDefs: vm.masterColumnDefs,
            enableSorting: true,
            debug: false,
            enableFilter: true,
            enableColResize: true,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowData: null,
            headerHeight: 50,
            rowHeight: 45,
            groupUseEntireRow: true,
            animateRows: true,
            groupDefaultExpanded: 1,
            doesDataFlower: function (dataItem) {
            },
            isExternalFilterPresent: isExternalFilterPresent,
            doesExternalFilterPass: doesExternalFilterPass,
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            }
        };

        var filter = 'everyone';

        function isExternalFilterPresent() {
            return filter !== '';
        }

        function doesExternalFilterPass(node) {
            if (filter && filter !== 'everyone') {
                var arrdt = node.data.filter.split(filter.toLowerCase());
                return arrdt.length > 1;
            }
            return true;
        }

        function getTemplate() {
            vm.masterGridOptions.api.setColumnDefs(vm.masterColumnDefs);
            if (vm.filter && vm.filter.startDate && vm.filter.endDate) {
                vm.filter.departments = "" + vm.requisition.department.id + "";
                vm.filter.costCenters = "" + vm.requisition.costCenter.id + "";
                vm.filter.dimensionCompanyDetail3 = [];
                vm.filter.dimensionCompanyDetail3.push(vm.requisition.dimensionCompanyDetail3.id);
                vm.filter.filterBy = "startDate";
                api.PresupuestosWS.Budget.executedByDateRange.query({ 'idc': $rootScope.bsCircle.id }, vm.filter).$promise.then(function (data) {
                    vm.templates = data;
                    vm.masterGridOptions.api.setRowData(vm.templates);
                }, function (errResponse) {

                });
            }
        }


        function selectItem(data) {
            if (data.selected) {
                var exist = false;
                for (var i = 0; i < vm.itemSelected.length; i++) {
                    if (vm.itemSelected[i].id === data.id) {
                        exist = true;
                    }
                }
                if (!exist) {
                    vm.itemSelected.push(data);
                }
            } else {
                var j = vm.itemSelected.indexOf(data);
                vm.itemSelected.splice(j, 1);
            }
        }

        //////////

        function closeDialog() {
            $mdDialog.cancel();
        }

        function init() {

            getTemplate();
        }

        function sendData() {
            vm.loading = true;
            $rootScope.loadingProgress = true;
            var resp = new jinqJs()
                .from(vm.itemSelected)
                .select(function (r) {
                    var detail = {
                        product: { id: r.product.id },
                        quantity: r.quantity,
                        consignment: false,
                        observations: ''
                    };
                    return detail;
                });

            api.ComprasWS.RequisitionDetail.createList(
                { idCircle: $rootScope.bsCircle.id, idRequisition: vm.requisition.id }, resp).$promise.then(
                    function (data) {
                        vm.loading = false;
                        if (data.length > 0) {
                            $rootScope.loadingProgress = false;
                            $mdDialog.hide(resp);
                            MessageService.show('REQUISITION.DETAIL_ADDED');
                        }
                    },
                    function (data) {
                        var msg = 'ERROR';
                        if (data.status === 409) {
                            msg = data.data;
                            if (msg === 'Product is exist') {
                                msg = 'PRODUCT';
                            }
                        }
                        MessageService.show('ORDER.MSG.' + msg);
                        vm.loading = false;

                    }
                );
        }

        function selectAllItems() {
            vm.templates.forEach(function (t) {
                t.selected = !vm.selectAll;
                if (t.selected) {
                    vm.itemSelected.push(t);
                } else {
                    var i = vm.itemSelected.indexOf(t);
                    vm.itemSelected.splice(i, 1);
                }
            });
        }

        $timeout(init, 300);
    }
})();

(function () {
    'use strict';
    angular
        .module('app.requisition')
        .controller('DialogDetailZeroController', DialogDetailZeroController);

    /** @ngInject */
    function DialogDetailZeroController($mdDialog, api, requisition, requisitionDetail, $rootScope, $log) {
        var vm = this;
        vm.ignoreDetailZero = false;
        vm.requisition = requisition;
        vm.details = requisitionDetail;

        vm.okDetail = function () {
            $rootScope.loadingProgress = true;
            if (vm.ignoreDetailZero) {
                vm.details.forEach(function (data) {
                    if (data.quantity <= 0) {
                        api.ComprasWS.RequisitionDetail.delete(
                            { idRequisition: vm.requisition.id, id: data.id, idCircle: $rootScope.bsCircle.id }, function (data) {

                                $rootScope.loadingProgress = false;

                            }, function (data) {
                                $log.debug(data);
                                $rootScope.loadingProgress = false;
                            });
                    }
                });
                $mdDialog.hide(true);
            }
        };

        vm.closeDialog = function () {
            $mdDialog.close();
        };
    }

})();

(function () {
    'use strict';
    angular
        .module('app.requisition')
        .controller('DetailRequisitionController', DetailRequisitionController)
        .controller('ProductCreateController', ProductCreateController);

    /** @ngInject */
    function DetailRequisitionController($mdDialog, requisition, api, requisitionDetail, $timeout, MessageService, $rootScope, $scope, $filter) {
        var vm = this;

        vm.page = 1;
        vm.pageSize = 20;

        var isNew = requisitionDetail ? false : true;
        vm.selectedTab = 0;
        vm.requisition = requisition;
        vm.keySelected = '';
        vm.departmentsUser = [];

        api.ComprasWS.Requisition.get({ idCircle: $rootScope.bsCircle.id, id: requisition.id }, function (data) {
            vm.requisition = data;
        });

        if (!isNew) {
            vm.detail = requisitionDetail;
            vm.selectedTab = 1;
        } else {
            vm.detail = {
                quantity: 1
            };
        }
        vm.loading = true;
        vm.productos = [];

        // Methods
        vm.closeDialog = closeDialog;
        vm.selectProduct = selectProduct;
        vm.sendDetail = sendDetail;
        vm.getProducts = getProducts;
        vm.isDefaultClass = isDefaultClass;
        vm.selectedProduct = selectedProduct;
        vm.changeFilter = changeFilter;
        vm.activeSearch = activeSearch;

        getProducts(vm.page);

        //////////

        function closeDialog() {
            $mdDialog.cancel();
        }

        $scope.$watch('vm.filterProduct', function (newVal) {
            if (newVal && newVal.length > -1) {
                getProducts(1);
            }
        });

        function changeFilter() {
            if (!vm.filterProduct || vm.filterProduct === '') {
                getProducts(1);
            }
        }

        function activeSearch() {
            vm.searchMode = true;
            $timeout(function () {
                $('#searchField').focus();
            });
        }

        function selectProduct(product) {
            vm.searchMode = false;
            var change = isNew ? isNew : vm.detail.product.id !== product.id;
            vm.keySelected = '' + product.id + product.company + product.defaultCC + product.buyPrice;
            vm.detail.product = {
                id: product.id,
                productCode: product.productCode,
                name: product.name,
                brand: product.brand,
                measurementUnit: product.measurementUnit
            };
            vm.detail.consignment = false;
            vm.detail.productCompanyBuyId = product.productCompanyBuyId;

            if (product.currencySale) {
                vm.detail.currentCurrency = product.currencySale;
            }

            if (product.salePrice) {
                vm.detail.currentPrice = product.salePrice;
            }

            if (product.addons) {
                if (product.addons.isConsignment !== null && product.addons.isConsignment === true) {
                    vm.detail.consignment = true;
                }
            }
            vm.selectedTab = 1;
            if (isNew || change) {
                $timeout(function () {
                    vm.detailForm.$setDirty();
                });
            }
            $timeout(function () {
                $("#quantity").focus();
            });
        }

        function selectedProduct(p) {
            var key = '' + p.id + p.company + p.defaultCC + p.buyPrice;
            return key === vm.keySelected;
        }

        function isDefaultClass(prod) {
            if (prod.defaultCC) {
              return 'accent-300';
            }
            if (prod.default) {
              return 'green-300';
            }
            return '';
        }

        function getProducts(page) {
            vm.page = page;
            vm.loading = true;
            var costCenterId = vm.requisition ? vm.requisition.costCenter.id : null;
            if (vm.requisition.originType && vm.requisition.originType.originTypeCode === '01') {
                searchDepartments(page, costCenterId);
            } else {
                api.GeneralWS.ProductAll.get({ circle: $rootScope.bsCircle.id, page: page - 1, size: vm.pageSize, filter: vm.filterProduct,
                    validateToPurchaseRequisition: true, costCenterId: costCenterId.toString() },
                    function (data) {
                        vm.productos = data;
                        vm.loading = false;
                    },
                    function (data) {
                        vm.loading = false;
                    }
                );
            }
        }

        function searchDepartments(page, costCenterId) {
            var params = { companyid: null, id: 'departments' };
            if(vm.departmentsUser.length <= 0) {
                api.GeneralWS.User.query(params, function (data) {
                    for (var i = 0; i < data.length; i++) {
                        vm.departmentsUser.push(data[i].department.id);
                    }
                    searchProductDepartment(page, costCenterId);
    
                    vm.loadingDepartments = false;
                });
            } else {
                searchProductDepartment(page, costCenterId);
            }
        }

        function searchProductDepartment(page, costCenterId) {
            api.GeneralWS.DepartmentProduct.getAll(
                {
                    id: 'departments',
                    companyId: vm.requisition.department.company.id,
                    circleId: $rootScope.bsCircle.id,
                    departments: vm.departmentsUser.toString(),
                    pageNumber: page - 1, pageSize: vm.pageSize,
                    search: vm.filterProduct,
                    validateToPurchaseRequisition: true,
                    costCenterId: costCenterId.toString()
                },
                function (response) {
                    vm.productos = response;
                    vm.loading = false;
                },
                function (data) {
                    vm.loading = false;
                }
            );
        }

        function sendDetail() {
            if (vm.detailForm.$valid) {
                if (vm.detailForm.$dirty) {
                    vm.loading = true;
                    vm.promise;
                    if (isNew) {
                        vm.promise = api.ComprasWS.RequisitionDetail.create(
                            { idCircle: $rootScope.bsCircle.id, idRequisition: vm.requisition.id }, vm.detail).$promise;
                    } else {
                        vm.promise = api.ComprasWS.RequisitionDetail.update(
                            { idCircle: $rootScope.bsCircle.id, id: vm.detail.id, idRequisition: vm.requisition.id }, vm.detail).$promise;
                    }

                    vm.promise.then(
                        function (data) {
                            $mdDialog.hide(data);
                            vm.loading = false;
                        },
                        function (data) {
                            var msg = '';
                            switch (data.status) {
                                case 409:
                                    msg = 'ORDER.MSG.PRODUCT';
                                    break;
                                case 406:
                                        var message = data.data.mensaje.split('|');
                                        var max = message[0];
                                        var available = message[1];
                                        msg = $filter('translate')('ORDER.MSG.CANNOT_EXCEED_MAXIMUM') + '(' + max + ').'
                                            + $filter('translate')('ORDER.MSG.AVAILABLE_TO_ORDER') + available;
                                    break;
                                default:
                                    msg = 'ORDER.MSG.ERROR';
                                    break;
                            }

                            MessageService.showErrorMessage(msg);
                            vm.loading = false;
                        }
                    );
                } else {
                    $mdDialog.cancel();
                }
            }
        }
    }

    function ProductCreateController(api, MessageService, $timeout, $scope, $rootScope) {
        var pro = this;
        var vm = $scope.vm;
        pro.noExistBrand = false;

        pro.changeBrand = changeBrand;
        pro.saveContain = saveContain;

        if (vm.searchTextProduct) {
            pro.product = { name: vm.searchTextProduct };
        }

        pro.loadingBrands = true;
        api.GeneralWS.BrandProduct.query({},
            function (data) {
                pro.brands = data;
                pro.loadingBrands = false;
            },
            function (err) {
                pro.loadingBrands = false;
            }
        );
        pro.loadingMeasures = true;
        api.GeneralWS.MeasurementUnit.query({},
            function (data) {
                pro.measures = data;
                pro.loadingMeasures = false;
            },
            function (err) {
                pro.loadingMeasures = false;
            }
        );

        function changeBrand() {
            if (pro.noExistBrand) {
                pro.noExistBrand = false;
            } else {
                pro.noExistBrand = true;
                $timeout(function () {
                    $("#ipBrand").focus();
                }, 200);
            }
        }

        function saveContain() {
            vm.loading = true;
            api.GeneralWS.Product.create({ idCircle: $rootScope.bsCircle.id }, pro.product,
                function (response) {
                    MessageService.show('REQUISITION.MSG.PRODUCT_CREATED');
                    vm.loading = false;
                    pro.product = null;
                    vm.creatingProduct = false;
                    vm.selectProduct(response);
                },
                function (erro) {
                    MessageService.show('REQUISITION.MSG.ERROR');
                    vm.loading = false;
                }
            );
        }

        ////////////////////

        pro.clearSearchBrand = function () {
            pro.searchBrand = "";
        };

        pro.clearSearchMeasure = function () {
            pro.searchMeasures = "";
        };

        $timeout(function () {

            var keyEvent = function (event) {
                event.stopPropagation();
            };

            var searchMeasuresInput = document.querySelector("#searchMeasureses");
            var searchBrandInput = document.querySelector("#searchBrand");

            if (searchMeasuresInput) {
                searchMeasuresInput.addEventListener("keydown", keyEvent);
            }

            if (searchBrandInput) {
                searchBrandInput.addEventListener("keydown", keyEvent);
            }
        }, 500);
    }
})();

(function () {
    'use strict';
    angular
        .module('app.reports')
        .controller('ReportShowPDFController', ReportShowPDFController);
    /** @ngInject */
    function ReportShowPDFController($mdDialog, Url, $sce, envService) {
        var vm = this;

        vm.report = $sce.trustAsResourceUrl(envService.read('baseUrlJReportsWSPdf') + '?rpt=' + Url);

        vm.cancel = function () {
            $mdDialog.cancel();
        };

    }
})();

(function () {

    'use strict';

    angular
        .module('app.reports')
        .controller('InvoiceReportDetailController', InvoiceReportDetailController);

    function InvoiceReportDetailController($rootScope, api, $mdDialog, detail, invoiceId, $log) {

        var vm = this;
        //methods
        vm.closeDialog = closeDialog;
        vm.detailsSettlement = detail;
        vm.loadFiles = loadFiles;
        vm.URLPHOTOS = api.baseUrlPhotos;
        vm.viewIMG = viewIMG;
        vm.dimensionCompanyDetail3 = null;
        vm.dimensionCompanyDetail4 = null;
        vm.dimensionCompanyDetail5 = null;


        function closeDialog() {
            $mdDialog.cancel();
        }

        init();
        function init() {
            if (vm.detailsSettlement.invoicePurchaseType === 'RECEIPT') {
                api.ComprasWS.PaymentReceipt.get({ id: invoiceId }, function (response) {
                    vm.receipt = response;
                    vm.filesReceipt = vm.receipt.files;
                    $log.debug(vm.details);
                }, function (error) {
                    $log.error(error.data);

                });
            } else {
                api.ComprasWS.InvoicePurchaseDetail.byInvoice(
                    { id: 'byInvoicePurchase', invoiceId: invoiceId, idCircle: $rootScope.bsCircle.id }, function (response) {
                        vm.details = response;
                        loadFiles();
                    }, function (error) {
                        $log.error(error.data);
                    });
            }
            getDimensionCompany();

        }

        function loadFiles() {
            api.ComprasWS.InvoicePurchaseFiles.get({ id: invoiceId }, function (response) {
                vm.filesPurchase = response;
            }, function (response) {// Error
                $log.error(response);
                vm.loading = false;
                $rootScope.loadingProgress = false;
            });


        }

        function viewIMG(file) {
            $mdDialog.show({
                controller: 'DialogPhotoController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/files/dialogPhoto/dialogPhoto.html',
                parent: angular.element("#main"),
                name: file.originalName,
                url: vm.URLPHOTOS + file.parentPath + file.name + file.extension,
                clickOutsideToClose: false
            }).then(function (answer) {
            });
        }

        function getDimensionCompany() {
            const NUMBER_DIMENSION_THREE = 3;
            const NUMBER_DIMENSION_FOUR = 4;
            const NUMBER_DIMENSION_FIVE = 5;
            api.GeneralWS.DimensionCompany.byCompany.getList(
                { 'company': $rootScope.bsCircle.company.id }
            ).$promise.then(function (responseDimension) {
                for (let i = 0; i < responseDimension.length; i++) {
                    if (responseDimension[i].dimensionNumber === NUMBER_DIMENSION_THREE) {
                        vm.dimensionCompanyDetail3 = responseDimension[i];
                    } else if (responseDimension[i].dimensionNumber === NUMBER_DIMENSION_FOUR) {
                        vm.dimensionCompanyDetail4 = responseDimension[i];
                    } else if (responseDimension[i].dimensionNumber === NUMBER_DIMENSION_FIVE) {
                        vm.dimensionCompanyDetail5 = responseDimension[i];
                    } else {
                        vm.dimensionCompanyDetail1 = responseDimension[i];
                    }
                }
            });
        }
    }

})();

(function () {

    'use strict';

    angular
        .module('app.reports')
        .controller('InterfazReportDetailController', InterfazReportDetailController);

    function InterfazReportDetailController($mdDialog, api, $filter, $timeout, entity, id, companyId, invoicePurchase) {

        var vm = this;

        vm.masterGridOptions = {
            enableSorting: true,
            debug: false,
            enableFilter: true,
            enableColResize: true,
            angularCompileRows: true,
            angularCompileHeaders: true,
            groupSuppressBlankHeader: true,
            toolPanelSuppressGroups: true,
            groupHeaders: false,
            fullWidthCellRenderer: true,
            rowData: [],
            pinnedBottomRowData: [],
            rowHeight: 45,
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            },
            columnDefs: [
                {
                    headerName: "REPORT.date",
                    field: "createdAt",
                    headerCellRenderer: getHeader,
                    valueFormatter: function (params) {
                        if (params.value === undefined || params.value === null) {
                            return '';
                        } else {
                            return $filter('apiDate')(params.value, 'dd/MM/yyyy HH:mm:ss');
                        }
                    },
                    enableRowGroup: true,
                    enablePivot: true
                },
                {
                    suppressMenu: true,
                    suppressSorting: false,
                    headerName: "REPORT.message",
                    headerCellRenderer: getHeader,
                    field: "messageDetail",
                    width: 500,
                    enableRowGroup: false,
                    enablePivot: false
                }
            ]
        };

        //methods
        vm.closeDialog = closeDialog;

        function closeDialog() {
            $mdDialog.cancel();
        }

        function init() {
            var element = $("#transactionDetailMasterGridOptions");

            if (element) {
                var dialogHeight = element[0].parentElement.offsetHeight;
                dialogHeight -= 40;

                element.css('height', dialogHeight + 'px');
            }

            vm.loading = true;
            const info = [{'createdAt': invoicePurchase.modifiedAt, 'messageDetail': invoicePurchase.erpError}];
            info.push(info);

            vm.masterGridOptions.api.setRowData(info);
            vm.showGrid = true;
            vm.loading = false;

        }

        $timeout(init, 1000);

    }

})();

(function () {

    'use strict';

    angular
        .module('app.reports')
        .controller('AuditLogController', AuditLogController);

    function AuditLogController($mdDialog, api, $filter, $timeout, id, type) {

        var vm = this;

        vm.masterGridOptions = {
            enableSorting: true,
            debug: false,
            enableFilter: true,
            enableColResize: true,
            angularCompileRows: true,
            angularCompileHeaders: true,
            groupSuppressBlankHeader: true,
            toolPanelSuppressGroups: true,
            groupHeaders: false,
            fullWidthCellRenderer: true,
            rowData: [],
            pinnedBottomRowData: [],
            rowHeight: 45,
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            },
            columnDefs: [
                {
                    suppressMenu: true,
                    suppressSorting: false,
                    headerName: "REPORT.LOGS.USER",
                    headerCellRenderer: getHeader,
                    field: "user",
                    width: 200,
                    enableRowGroup: false,
                    enablePivot: false
                },
                {
                    headerName: "REPORT.LOGS.DATE",
                    field: "modificationDate",
                    headerCellRenderer: getHeader,
                    valueFormatter: function (params) {
                        if (params.value === undefined || params.value === null) {
                            return '';
                        } else {
                            return $filter('date')(new Date(params.value), 'dd/MM/yyyy HH:mm:ss');
                        }
                    },
                    enableRowGroup: true,
                    enablePivot: true
                },
                {
                    suppressMenu: true,
                    suppressSorting: false,
                    headerName: "REPORT.LOGS.STATUS",
                    headerCellRenderer: getHeader,
                    field: "statusName",
                    width: 200,
                    enableRowGroup: false,
                    enablePivot: false
                }
            ]
        };

        //methods
        vm.closeDialog = closeDialog;

        function closeDialog() {
            $mdDialog.cancel();
        }

        function init() {
            var element = $("#transactionDetailMasterGridOptions");

            if (element) {
                var dialogHeight = element[0].parentElement.offsetHeight;
                dialogHeight -= 40;

                element.css('height', dialogHeight + 'px');
            }

            vm.loading = true;

            if (type === 1) {
                api.ComprasWS.Requisitions.Audit.get({ id: id }, function (data) {
                    vm.masterGridOptions.api.setRowData(data);
                    vm.showGrid = true;
                    vm.loading = false;
                });
            }

            if (type === 2) {
                api.ComprasWS.Quotation.Audit.get({ companyId: 0, id: id }, function (data) {
                    vm.masterGridOptions.api.setRowData(data);
                    vm.showGrid = true;
                    vm.loading = false;
                });
            }

            if (type === 3) {
                api.ComprasWS.PurchaseOrders.Audit.get({ id: id }, function (data) {
                    vm.masterGridOptions.api.setRowData(data);
                    vm.showGrid = true;
                    vm.loading = false;
                });
            }

            if (type === 4) {
                api.ComprasWS.InvoicePurchaseAudit.Audit.get({ id: id }, function (data) {
                    vm.masterGridOptions.api.setRowData(data);
                    vm.showGrid = true;
                    vm.loading = false;
                });
            }
        }

        $timeout(init, 1000);

    }

})();

(function () {
    'use strict';
    angular
        .module('app.reports')
        .controller('DialogProductsController', dialogProductsController);

    function dialogProductsController($rootScope, api, $mdDialog, productsIds, originTypeCode) {

        const vm = this;
        //methods
        vm.closeDialog = closeDialog;
        vm.URLPHOTOS = api.baseUrlPhotos;
        vm.searchProductInput = '';
        vm.disableFilter = false;
        vm.selectProduct = selectProduct;
        vm.save = save;
        vm.arraySelected = [];
        vm.getAllProducts = getAllProducts;
        vm.paginationProducts = {
            pageNumber: 1,
            pageSize: 100,
            totalElements: 0,
            totalPages: 0,
            numberOfElements: 0,
            nextPage: getNextPage(),
            beforePage: getBeforePage(),
            firstPage: getFirstPage(),
            lastPage: getLastPage(),
            getPage: getPageByNumber()
        };


        function closeDialog() {
            $mdDialog.cancel();
        }

        init();
        function init() {
            vm.departmentsUser = [];
            const params = { companyid: null, id: 'departments' };
            if (originTypeCode && originTypeCode === '01') {
                vm.disableFilter = true;
                api.GeneralWS.User.query(params, function (data) {
                    for (let i = 0; i < data.length; i++) {
                        vm.departmentsUser.push(data[i].department.id);
                    }
                    vm.disableFilter = false;
                    getAllProducts();
                });
            } else {
                getAllProducts();
            }
            
        }

        function getAllProducts() {
            vm.isShowLoaderProducts = true;
            if (originTypeCode && originTypeCode === '01') {
                api.GeneralWS.DepartmentProduct.getAll(
                    {
                        id: 'departments',
                        companyId: $rootScope.bsCircle.company.id,
                        circleId: $rootScope.bsCircle.id,
                        departments: vm.departmentsUser.toString(),
                        pageNumber: vm.paginationProducts.pageNumber,
                        pageSize: vm.paginationProducts.pageSize,
                        search: vm.searchProductInput,
                        validateToPurchaseRequisition: false
                    },
                    function (response) {
                        setPaginationAndData(response);
                    }
                );
            } else {
                api.GeneralWS.ProductAll.get({
                    circle: $rootScope.bsCircle.id,
                    page: vm.paginationProducts.pageNumber - 1,
                    size: vm.paginationProducts.pageSize,
                    filter: vm.searchProductInput,
                    validateToPurchaseRequisition: false,
                    excludeDepartmentProducts: false,
                    hideInBudget: false
                },
                    function (response) {
                        setPaginationAndData(response);
                    }
                );
            }
        }

        function selectProduct(product) {
            product.selected = !product.selected;
            if (product.selected) {
                let exist = false;
                vm.arraySelected.forEach(function (dat) {
                    if (dat.id === product.id) {
                        exist = true;
                    }
                });
                if (!exist) {
                    vm.arraySelected.push(product);
                } else {
                    product.selected = !product.selected;
                    deleteProductList(product);
                }
            } else {
                deleteProductList(product);
            }
        }

        function deleteProductList(product) {
            vm.arraySelected.splice(vm.arraySelected.indexOf(product), 1);
        }

        function save() {
            $mdDialog.hide(vm.arraySelected);
        }

        function getNextPage() {
            return function () {
                this.pageNumber++;
            };
        }

        function getBeforePage() {
            return function () {
                this.pageNumber--;
            };
        }

        function getFirstPage() {
            return function () {
                this.pageNumber = 1;
            };
        }

        function getLastPage() {
            return function () {
                this.pageNumber = this.totalPages;
            };
        }

        function getPageByNumber() {
            return function (pageNumber) {
                this.pageNumber = pageNumber;
                getAllProducts();
            };
        }

        function selectedProductsLoad() {
            if (productsIds) {
                productsIds.forEach(function (product) {
                    vm.products.forEach(function (prod) {
                        if (product === prod.id) {
                            selectProduct(prod);
                        }
                    });
                });
            }

            if (vm.arraySelected) {
                vm.arraySelected.forEach(function (data) {
                    vm.products.forEach(function (product) {
                        if (data.id === product.id) {
                            product.selected = true;
                        }
                    });
                });
            }
        }

        function setPaginationAndData(response) {
            vm.products = response.content;
            vm.paginationProducts.totalElements = response.totalElements;
            vm.paginationProducts.totalPages = response.totalPages;
            vm.paginationProducts.numberOfElements = response.numberOfElements;
            selectedProductsLoad();
            vm.isShowLoaderProducts = false;
        }

    }

})();

(function () {

    'use strict';

    angular
        .module('app.reports')
        .controller('DialogCompaniesController', dialogCompaniesController);

    function dialogCompaniesController($rootScope, api, $mdDialog, companiesIds, $log, type) {

        const TEXT_PROVIDERS = 'providers';
        const vm = this;
        //methods
        vm.closeDialog = closeDialog;
        vm.URLPHOTOS = api.baseUrlPhotos;
        vm.selectCompany = selectCompany;
        vm.arraySelected = [];
        vm.type = type;
        vm.save = save;
        vm.searchCompanyInput = '';
        vm.getAllCompanies = getAllCompanies;
        vm.paginationCompanies = {
            pageNumber: 1,
            pageSize: 100,
            totalElements: 0,
            totalPages: 0,
            numberOfElements: 0,
            nextPage: getNextPage(),
            beforePage: getBeforePage(),
            firstPage: getFirstPage(),
            lastPage: getLastPage(),
            getPage: getPageByNumber()
        };


        function closeDialog() {
            $mdDialog.cancel();
        }

        init();
        function init() {
            getAllCompanies(null);
        }

        function getAllCompanies(ev) {
            vm.isShowLoaderCompanies = true;
            let promise;
            if (type === TEXT_PROVIDERS) {
                promise = api.GeneralWS.getAllCompaniesProviders.page(
                    {
                        'pageNumber': vm.paginationCompanies.pageNumber,
                        'pageSize': vm.paginationCompanies.pageSize, 'search': vm.searchCompanyInput,
                        'companyId': $rootScope.bsCircle.company.id, 'includeMe': false
                    }).$promise;
            } else if (!ev) {
                promise = api.GeneralWS.Usr.User.Company.CompanyRolUser.page(
                    { 'idCircle': $rootScope.bsCircle.id }
                ).$promise;
            } else {
                vm.isShowLoaderCompanies = false;
            }
            if (promise) {
                promise.then(function (response) {
                    vm.isShowLoaderCompanies = false;
                    setPaginationAndData(response);
                    selectedCompaniesLoad();
                }, function (response) {
                    vm.isShowLoaderCompanies = false;
                    $log.error(response);
                });
            } else {
                vm.isShowLoaderCompanies = false;
            }
        }

        function selectCompany(company) {
            company.selected = !company.selected;
            if (company.selected) {
                let exist = false;
                vm.arraySelected.forEach(function (comp) {
                    if (comp.id === company.id) {
                        exist = true;
                    }
                });
                if (!exist) {
                    vm.arraySelected.push(company);
                }
            } else {
                deleteCompanyList(company);
            }
        }

        function deleteCompanyList(company) {
            const index = vm.arraySelected.findIndex(function (selectedCompany) {
                return selectedCompany.id === company.id;
            });
            if (index > -1) {
                vm.arraySelected.splice(index, 1);
            }
        }

        function save() {
            $mdDialog.hide(vm.arraySelected);
        }

        function getNextPage() {
            return function () {
                this.pageNumber++;
            };
        }

        function getBeforePage() {
            return function () {
                this.pageNumber--;
            };
        }

        function getFirstPage() {
            return function () {
                this.pageNumber = 1;
            };
        }

        function getLastPage() {
            return function () {
                this.pageNumber = this.totalPages;
            };
        }

        function getPageByNumber() {
            return function (pageNumber) {
                this.pageNumber = pageNumber;
                getAllCompanies();
            };
        }

        function selectedCompaniesLoad() {
            if (companiesIds) {
                companiesIds.forEach(function (id) {
                    vm.companyArray.forEach(function (company) {
                        if (id === company.id) {
                            selectCompany(company);
                        }
                    });
                });
            }

            if (vm.arraySelected) {
                vm.arraySelected.forEach(function (comp) {
                    vm.companyArray.forEach(function (company) {
                        if (comp.id === company.id) {
                            company.selected = true;
                        }
                    });
                });
            }
        }

        function setPaginationAndData(response) {
            if (type === TEXT_PROVIDERS) {
                vm.companyArray = response.content;
                vm.paginationCompanies.totalElements = response.totalElements;
                vm.paginationCompanies.totalPages = response.totalPages;
                vm.paginationCompanies.numberOfElements = response.numberOfElements;
            } else {
                vm.companyArray = response;
                vm.paginationCompanies.totalElements = response.length;
                vm.paginationCompanies.totalPages = 1;
                vm.paginationCompanies.numberOfElements = response.length;
                vm.paginationCompanies.pageSize = response.length;
            }
        }

    }

})();


(function () {
    'use strict';
    angular
        .module('app.order')
        .controller('ShippingOrderViewController', ShippingOrderViewController);

    function ShippingOrderViewController(id, api, $rootScope, $mdDialog, $filter, MessageService) {
        var vm = this;
        vm.loading = true;

        vm.cancel = cancel;
        vm.editShippingDetail = editShippingDetail;
        vm.deleteShippingDetail = deleteShippingDetail;

        vm.masterColumnDefs = [
            {
                headerName: '#',
                field: "id",
                width: 70,
                cellStyle: { 'text-align': 'center' }
            },
            {
                headerName: 'ORDER.DETAIL.DATE',
                headerCellRenderer: getHeader,
                width: 230,
                cellRenderer: rendererDate,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'ORDER.DETAIL.QUANTITY',
                field: "quantity",
                headerCellRenderer: getHeader,
                width: 130,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'ORDER.SHIPPING_ORDER.USER',
                field: "shippingOrder.user.name",
                headerCellRenderer: getHeader,
                width: 230,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'ORDER.SHIPPING_ORDER.STATUS',
                field: "shippingOrder.shippingStatus.description",
                headerCellRenderer: getHeader,
                width: 230,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'ORDER.SHIPPING_ORDER.OPTIONS',
                field: "id",
                headerCellRenderer: getHeader,
                width: 100,
                cellRenderer: renderer,
                enableRowGroup: true,
                enablePivot: true,
                pinned: 'right'
            }
        ];


        vm.masterGridOptionsSO = {
            columnDefs: vm.masterColumnDefs,
            enableSorting: true,
            debug: false,
            enableFilter: true,
            enableColResize: true,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowData: null,
            groupHeaders: true,
            headerHeight: 64,
            rowHeight: 45,
            groupDefaultExpanded: 1,
            groupUseEntireRow: true,
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            },
            doesDataFlower: function (dataItem) {
                dataItem.merchandiseEntryType = dataItem.merchandiseEntryType === "NOT_INVOICE" ? "Segunda Recepcion" : "Primera Recepcion";
                return false;
            }
        };

        function init() {
            api.ComprasWS.ShippingOrderDetailByPurchaseorderDetail.getAll({ purchaseOrderDetailId: id, idCircle: $rootScope.bsCircle.id },
                function (data) {
                    vm.merchandises = new jinqJs()
                        .from(data)
                        .orderBy([{ field: 'id', sort: 'asc' }])
                        .select(function (r) {
                            return r;
                        });
                    vm.masterGridOptionsSO.api.setColumnDefs(vm.masterColumnDefs);
                    vm.masterGridOptionsSO.api.setRowData(vm.merchandises);
                    vm.loading = false;
                },
                function (err) {
                    vm.masterGridOptionsSO.api.setColumnDefs(vm.masterColumnDefs);
                    vm.masterGridOptionsSO.api.setRowData([]);
                    vm.loading = false;
                }
            );
        }

        init();


        function cancel() {
            $mdDialog.cancel();
        }

        function renderer(params) {
            if (params.data) {
                if (params.data) {
                    return '<md-button class="edit-button md-icon-button" ng-if="data.shippingOrder.shippingStatus.orderColumn<2"' +
                        '                ng-click="vm.editShippingDetail($eventev,data)"' +
                        '        aria-label="Product details"' +
                        '        translate translate-attr-aria-label="REQUISITION.PRODUCT_DETAILS">' +
                        ' <md-icon md-font-icon="icon-pencil" class="s16"></md-icon> ' +
                        '                             <md-tooltip md-direction="left">{{"ORDER.SHIPPING_ORDER.EDIT_SHIPPING"| translate}}</md-tooltip>' +
                        ' </md-button>' +
                        '<md-button class="edit-button md-icon-button" ng-if="data.shippingOrder.shippingStatus.orderColumn<2"' +
                        '                ng-click="vm.deleteShippingDetail($eventev,data)"' +
                        '        aria-label="Product details"' +
                        '        translate translate-attr-aria-label="REQUISITION.PRODUCT_DETAILS">' +
                        ' <md-icon md-font-icon="icon-trash" class="s16 md-warn"></md-icon> ' +
                        '                             <md-tooltip md-direction="left">{{"ORDER.SHIPPING_ORDER.DELETE_SHIPPING"| translate}}</md-tooltip>' +
                        ' </md-button>';
                } else {
                    return '';
                }
            } else {
                return '';
            }
        }

        function rendererDate(params) {
            if (params.data) {
                return '<div>' + params.data.createdAt.dayOfMonth + '/' + params.data.createdAt.monthValue + '/' + params.data.createdAt.year + '</div>';
            } else {
                return '';
            }

        }

        function editShippingDetail(ev, data) {
            var confirm = $mdDialog.prompt()
                .title($filter("translate")('ORDER.SHIPPING_ORDER.UPDATE_QUANTITY'))
                .textContent($filter("translate")('ORDER.SHIPPING_ORDER.ADD_QUANTITY'))
                .placeholder($filter("translate")('ORDER.SHIPPING_ORDER.ADD_QUANTITY'))
                .ariaLabel('quantity')
                .initialValue(data.quantity)
                .multiple(true)
                .ok($filter('translate')('general.accept'))
                .cancel($filter('translate')('general.cancel'));

            $mdDialog.show(confirm).then(function (result) {
                if (result && result > 0 && result !== data.quantity && result <= (data.purchaseOrderDetail.quantity - verifyTotalReceived(data.id))) {
                    api.ComprasWS.ShippingOrderDetail.update({ id: data.id, 'quantity': result }, null,
                        function (data) {
                            init();
                        }, function (err) {
                        });
                } else {
                    MessageService.showErrorMessage($filter("translate")("ORDER.SHIPPING_ORDER.QUANTITY_NO_ACCEPTED"));
                }
            });
        }

        function deleteShippingDetail(ev, data) {
            var confirm = $mdDialog.confirm()
                .title($filter("translate")('ORDER.SHIPPING_ORDER.DELETE_SHIPPING'))
                .ariaLabel('delete')
                .multiple(true)
                .ok($filter('translate')('general.accept'))
                .cancel($filter('translate')('general.cancel'));

            $mdDialog.show(confirm).then(function (result) {
                if (result) {
                    api.ComprasWS.ShippingOrderDetail.del({ id: data.id },
                        function (data) {
                            init();
                            MessageService.show($filter("translate")("ORDER.SHIPPING_ORDER.DELETED_SUCCESSFULLY"))
                        }, function () {
                        });
                }
            });
        }

        function verifyTotalReceived(id) {
            var total = 0;
            for (var i = 0; i < vm.merchandises.length; i++) {
                if (vm.merchandises[i].id !== id) {
                    total = total + vm.merchandises[i].quantity;
                }
            }
            return total;
        }
    }
}
)();

(function () {
    'use strict';
    angular
        .module('app.order')
        .controller('receiveMerchandiseEntryController', receiveMerchandiseEntryController);

    /** @ngInject */
    function receiveMerchandiseEntryController($mdDialog, api, $log, $rootScope, details, order) {

        var vm = this;
        vm.page = 1;
        vm.pageSize = 20;
        vm.quotationDetail = {};
        vm.details = details;
        vm.productType = 'S';
        vm.selectedTab = 0;
        vm.requisitionDetail = {
            requisition: { id: details[0].requisitionId }
        };
        vm.closeDialog = closeDialog;
        vm.saveMerchandiseHeader = saveMerchandiseHeader;
        vm.uploadFiles = true;

        init();

        function init() {
            for (var i = 0; i < vm.details.length; i++) {
                vm.uploadFiles = vm.details[i].addProduct;
            }
        }

        function saveMerchandiseHeader() {
            vm.merchandiseHeader = {
                purchaseOrder: order,
                filesMerchandiseEntry: null
            };

            if (vm.filesToUpload.length > 0) {
                var files = [];

                vm.filesToUpload.forEach(function (r) {
                    files.push(r.file.file);
                });

                $rootScope.loadingProgress = true;
                api.GeneralWS.Common.FileStorage.filesUpload.add({ 'companyId': $rootScope.bsCircle.company.id }, files).then(function (response) {
                    $rootScope.loadingProgress = false;
                    vm.merchandiseHeader.filesMerchandiseEntry = response.data;
                    save();
                }, function (errResponse) {
                    $log.error(errResponse);
                    $rootScope.loadingProgress = false;
                });

            } else {
                vm.merchandiseHeader.filesMerchandiseEntry = [];
                save();
            }
        }


        function closeDialog() {
            $mdDialog.cancel();
        }

        function save() {
            $mdDialog.hide(vm.merchandiseHeader.filesMerchandiseEntry);
        }

    }

})();

(function () {
    'use strict';
    angular
        .module('app.order')
        .controller('OrderDetailMerchandiseController', OrderDetailMerchandiseController);

    function OrderDetailMerchandiseController(detail, api, $rootScope, $mdDialog, $filter, MessageService, $log) {
        var vm = this;
        vm.loading = true;

        vm.cancel = cancel;
        vm.deleteDetail = deleteDetail;

        vm.masterColumnDefs = [
            {
                headerName: 'EstadoRecibido',
                field: "merchandiseEntryType",
                width: 100,
                rowGroupIndex: 0,
                hide: true
            },
            {
                headerName: '#',
                field: "id",
                width: 70,
                cellStyle: { 'text-align': 'center' }
            },
            {
                headerName: 'ORDER.DETAIL.DATE',
                headerCellRenderer: getHeader,
                width: 130,
                cellRenderer: rendererDate,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'ORDER.DETAIL.QUANTITY',
                field: "quantity",
                headerCellRenderer: getHeader,
                width: 130,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'ORDER.DETAIL.INVOICED',
                headerCellRenderer: getHeader,
                width: 100,
                cellRenderer: renderer,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'ORDER.ACTIONS',
                headerCellRenderer: getHeader,
                width: 100,
                cellRenderer: rendererOptions,
                enableRowGroup: true,
                enablePivot: true
            }
        ];


        vm.masterGridOptionsME = {
            columnDefs: vm.masterColumnDefs,
            enableSorting: true,
            debug: false,
            enableFilter: true,
            enableColResize: true,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowData: null,
            groupHeaders: true,
            headerHeight: 64,
            rowHeight: 45,
            groupDefaultExpanded: 1,
            groupUseEntireRow: true,
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            },
            doesDataFlower: function (dataItem) {
                dataItem.merchandiseEntryType = dataItem.merchandiseEntryType === "NOT_INVOICE" ? "Segunda Recepcion" : "Primera Recepcion";
                return false;
            },
            isExternalFilterPresent: isExternalFilterPresent,
            doesExternalFilterPass: doesExternalFilterPass
        };

        var filter = 'everyone';

        function isExternalFilterPresent() {
            return filter !== '';
        }

        function doesExternalFilterPass(node) {
            if (filter && filter !== 'everyone') {
                var arrdt = node.data.filter.split(filter);
                return arrdt.length > 1;
            }
            return true;
        }


        api.ComprasWS.MerchandiseEntryOrderDetail.query({ id: detail.id, idCircle: $rootScope.bsCircle.id },
            function (data) {
                vm.merchandises = data;
                vm.masterGridOptionsME.api.setColumnDefs(vm.masterColumnDefs);
                vm.masterGridOptionsME.api.setRowData(vm.merchandises);
                vm.loading = false;
            },
            function (err) {
                vm.masterGridOptionsME.api.setColumnDefs(vm.masterColumnDefs);
                vm.masterGridOptionsME.api.setRowData([]);
                vm.loading = false;
            }
        );

        function cancel() {
            $mdDialog.cancel();
        }

        function renderer(params) {
            if (params.data) {
                if (params.data.invoiced) {
                    return '<div style="text-align: center"> <i class="icon-checkbox-marked-circle green-500-fg"></i> </div>';
                } else {
                    return '<div style="text-align: center"> <i class="icon-cancel red-500-fg"></i> </div>';
                }
            } else {
                return '';
            }
        }

        function rendererDate(params) {
            if (params.data) {
                return '<div>' + params.data.createdAt.dayOfMonth + '/' + params.data.createdAt.monthValue + '/' + params.data.createdAt.year + '</div>';
            } else {
                return '';
            }
        }

        function rendererOptions(params) {
            if (params.data && detail.providerCanInvoiceBeforeReceive) {
                return '<div>' +
                    '<md-button class="edit-button md-icon-button" ng-if="!data.invoiced"' +
                    '                                                            ng-click="vm.deleteDetail($event, data)"' +
                    '                                                            aria-label="Product details"' +
                    '                                                            translate translate-attr-aria-label="REQUISITION.PRODUCT_DETAILS">' +
                    '                                                     <md-icon md-font-icon="icon-trash" class="s16 md-warn"></md-icon>' +
                    '                                                     <md-tooltip md-direction="bottom">' +
                    '                                                         {{"ORDER.DETAIL.DELETE"| translate}}' +
                    "                                                     </md-tooltip>" +
                    "                                                 </md-button>"+
                '</div>';
            } else {
                return '';
            }

        }

        function deleteDetail(ev, data) {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('MERCHANDISE_ENTRY.MSG_CONFIRM.DELETE'))
                .ariaLabel('Delete modal')
                .targetEvent(ev)
                .multiple(true)
                .ok($filter('translate')('REQUISITION.MSG.SI'))
                .cancel($filter('translate')('REQUISITION.MSG.NO'));
            $mdDialog.show(confirm).then(function () {
                api.ComprasWS.MerchandiseEntry.delete({ id: data.id }).$promise.then(function (response) {
                    MessageService.show('INVOICE_MERCHANDISE_ENTRY.DELETE_SUCCESSFULLY');
                    $mdDialog.hide(response);
                }, function (errResponse) {
                    MessageService.showErrorMessage("REQUISITION.MSG." + errResponse.data.mensaje);
                    $log.debug(errResponse);
                });
            });
        }
    }
}
)();

(function () {
    'use strict';
    angular
        .module('app.requisition')
        .controller('FeaturesDialogController', FeaturesDialogController);

    /** @ngInject */
    function FeaturesDialogController($mdDialog, api, $log, $timeout, $rootScope, detail, orderId, MessageService) {

        var vm = this;
        vm.detail = detail;
        vm.fixedAsset = {
            fixedAssetGroup: { id: vm.detail.fixedAssetGroupId },
            product: { id: vm.detail.product.id },
            quotationDetailId: vm.detail.id,
            quotationId: orderId,
            originType: {
                originTypeCode: "19"
            }
        };
        vm.completedFeatures = false;

        /**
         * methods
         */

        vm.cancel = cancel;
        vm.onEdit = onEdit;
        vm.flipping = flipping;
        vm.toggleBooleanFeatureValue = toggleBooleanFeatureValue;
        vm.isCheckedBooleanFeatureValue = isCheckedBooleanFeatureValue;
        vm.save = save;
        vm.searchFeature = searchFeature;
        vm.saveAll = saveAll;
        vm.updateAll = updateAll;

        vm.newContact = true;
        vm.flip;
        function flipping(funct) {
            vm.flip = funct;
            if (vm.newContact) {
                funct();
            }
        }
        init();
        function init() {
            getFeaturesByGroup();
            getFixedAssets();
        }

        function onEdit() {
            !vm.fixedAssetToUpdate ? vm.fixedAssetToUpdate = vm.fixedAssets[0] : null;
            if (vm.flip) {
                vm.flip();
            }
            $timeout(function () {
                document.getElementById("searchFilter").focus();
            }, 600);
        }

        function cancel() {
            $mdDialog.cancel();
        }
        function getFeaturesByGroup() {
            api.ActivosFijosWS.FixedAssetGroupFeature.active.query(
                {
                    'companyId': vm.detail.quotationDetail.requisitionDetail.requisition.department.company.id,
                    'fixedAssetGroupId': vm.detail.fixedAssetGroupId, isProvider: true
                }).$promise.then(function (response) {
                    vm.fixedAssetGroupFeatures = response;
                    cleanFeatures();
                }, function (response) {
                    $log.error(response);
                });
        }
        function orderFeaturesById(featureArray) {
            return featureArray.sort(function (a, b) {
                return a.fixedAssetGroupFeature.orderOfEntry - b.fixedAssetGroupFeature.orderOfEntry;
            });
        }
        function toggleBooleanFeatureValue(event, feature) {
            event.stopPropagation();
            if (feature.featureValue === null || feature.featureValue === undefined) {
                feature.featureValue = "0";
            }

            if (feature.featureValue === "0") {
                feature.featureValue = "1";
            } else {
                feature.featureValue = "0";
            }
        }

        function isCheckedBooleanFeatureValue(feature) {
            return feature.featureValue === "1";
        }

        function getFixedAssets() {
            api.ActivosFijosWS.FixedAsset.me.query(
                {
                    'fixedAssetId': 'byQuotatonDetail',
                    'companyId': vm.detail.quotationDetail.requisitionDetail.requisition.department.company.id,
                    'quotationDetailId': vm.detail.id
                }).$promise.then(function (fixedAssets) {
                    vm.fixedAssets = fixedAssets.sort(function (a, b) {
                        return a.id - b.id;
                    });
                    vm.fixedAssetsToUpdate = fixedAssets;
                    vm.completedFeatures = !(vm.detail.quotationDetail.requisitionDetail.quantity > vm.fixedAssets.length);
                    vm.completedFeatures === true ? onEdit() : null;
                }, function (response) {
                    $log.error(response);
                });
        }

        function save(isNew, all) {
            $rootScope.loadingProgress = true;

            var promise;
            if (isNew === false) {
                promise = api.ActivosFijosWS.FixedAsset.me.update(
                    {
                        'companyId': vm.detail.quotationDetail.requisitionDetail.requisition.department.company.id,
                        'fixedAssetId': vm.fixedAssetToUpdate.id
                    }, vm.fixedAssetToUpdate).$promise;
            } else {
                promise = api.ActivosFijosWS.FixedAsset.me.create(
                    { 'companyId': vm.detail.quotationDetail.requisitionDetail.requisition.department.company.id }, vm.fixedAsset).$promise;
            }
            promise.then(function (response) {
                $rootScope.loadingProgress = false;
                if (isNew === false) {
                    MessageService.show("QUOTATION.DETAIL.FEATURES.UPDATED");
                } else if (!all) {
                    MessageService.show("QUOTATION.DETAIL.FEATURES.ADDED");
                    vm.fixedAssets.push(response);
                    vm.completedFeatures = !(vm.detail.quotationDetail.requisitionDetail.quantity > vm.fixedAssets.length);
                    vm.completedFeatures === true ? completedFeatures(true) : cleanFeatures();
                } else {
                    vm.fixedAssets.push(response);
                    vm.completedFeatures = !(vm.detail.quotationDetail.requisitionDetail.quantity > vm.fixedAssets.length);
                    vm.completedFeatures === true ? completedFeatures(true) : cleanFeatures();
                }

            }, function (response) {
                $rootScope.loadingProgress = false;
                $log.error(response);
            });

        }

        function cleanFeatures() {
            vm.fixedAsset.features = [];
            var features = [];
            vm.fixedAssetGroupFeatures.forEach(function (row) {
                var fixedAssetGroupFeature = angular.copy(row);
                delete fixedAssetGroupFeature.sales;
                var item = {
                    fixedAssetGroupFeature: fixedAssetGroupFeature,
                    featureValue: null
                };
                features.push(item);
            });
            vm.fixedAsset.features = vm.fixedAsset.features.concat(orderFeaturesById(features));
        }

        function completedFeatures(completed) {
            vm.detail.completedFeatures = completed;
            api.ComprasWS.PurchaseOrderDetail.update(
                {
                    'id': 'setCompletedFeatures', 'companyId': 0,
                    'idPurchaseOrder': orderId, 'idCircle': $rootScope.bsCircle.id
                }, vm.detail).$promise.then(function (quotationDetail) {
                    MessageService.show("QUOTATION.COMPLETED");
                    $mdDialog.hide(vm.detail);
                }, function (response) {
                    $log.error(response);
                });
        }

        function searchFeature() {
            if (!vm.filter) {
                vm.fixedAssetsToUpdate = vm.fixedAssets;
            } else {
                vm.fixedAssetsToUpdate = vm.fixedAssets.filter(function (fixedAsset) {
                    return _.find(fixedAsset.features, function (feature) {
                        var lowercaseQuery = angular.lowercase(vm.filter);
                        var lowercaseName = angular.lowercase(feature.featureValue);
                        return (lowercaseName.indexOf(lowercaseQuery) === 0 || lowercaseName.indexOf(lowercaseQuery) > 0);
                    });
                });
            }
            vm.fixedAssetToUpdate = vm.fixedAssetsToUpdate[0];
            vm.page = 1;
        }

        function saveAll() {
            var count = vm.detail.quotationDetail.requisitionDetail.quantity - vm.fixedAssets.length;
            for (var i = 0; i < count; i++) {
                save(true, true);
            }
        }

        function updateAll() {
            var count = vm.fixedAssets.length;
            for (var i = 0; i < count; i++) {
                vm.fixedAssetToUpdate = vm.fixedAssets[i];
                for (var j = 0; j < vm.fixedAssets[0].features.length; j++) {
                    for (var k = 0; k < vm.fixedAssetToUpdate.features.length; k++) {
                        if (vm.fixedAssets[0].features[j].fixedAssetGroupFeature.id === vm.fixedAssetToUpdate.features[k].fixedAssetGroupFeature.id) {
                            vm.fixedAssetToUpdate.features[k].featureValue = vm.fixedAssets[0].features[j].featureValue;
                        }
                    }
                }
                vm.fixedAssetToUpdate.originType = {
                    originTypeCode: "19"
                };
                api.ActivosFijosWS.FixedAsset.me.update(
                    {
                        'companyId': vm.detail.quotationDetail.requisitionDetail.requisition.department.company.id,
                        'fixedAssetId': vm.fixedAssetToUpdate.id
                    }, vm.fixedAssetToUpdate).$promise.then(function (response) {
                        $rootScope.loadingProgress = false;
                        vm.fixedAssets.push(response);
                        vm.completedFeatures = !(vm.detail.quotationDetail.requisitionDetail.quantity > vm.fixedAssets.length);
                        vm.completedFeatures === true ? completedFeatures(true) : cleanFeatures();
                    }, function (response) {
                        $rootScope.loadingProgress = false;
                        $log.error(response);
                    });
            }
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('app.merchandiseEntry', [
            'app.merchandiseEntry.invoiceMerchandiseEntry',
            'app.merchandiseEntry.merchandiseEntryR'
        ]).config(config);


    /** @ngInject **/
    function config($stateProvider) {
        $stateProvider
            .state('app.merchandiseEntry', {
                url: '/merchandiseEntry',
                abstract: true
            })
            .state('app.merchandiseEntry.view', {
                url: '/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/merchandiseEntry/invoiceMerchandiseEntry/view/view.html',
                        controller: 'ViewInvoiceMerchandiseEntryController as vm'
                    }
                },
                params: {
                    backTo: null,
                    filter: null
                },
                bodyClass: 'e-commerce'
            });
    }

})();

(function () {
    'use strict';
    angular
        .module('app.merchandiseEntry')
        .controller('ViewInvoiceMerchandiseEntryController', ViewInvoiceMerchandiseEntryController);

    /** @ngInject */
    function ViewInvoiceMerchandiseEntryController($state, api,
        $log, $rootScope, $mdDialog, $stateParams, $mdToast, $filter, MessageService) {
        var vm = this;
        // Data

        vm.petition = 0;
        vm.minDate = new Date();
        vm.details = [];
        vm.dateDelivery = new Date();
        vm.statusToChange = 'Creando';
        vm.merchandises = [];
        vm.saleProducts = saleProducts;
        vm.masterColumnDefs = [
            {
                headerName: 'INVOICE_MERCHANDISE_ENTRY.REQUISITION',
                field: "requisition.id",
                headerCellRenderer: getHeader,
                width: 250,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'REQUISITION.DETAIL.QUANTITY',
                field: "quantity",
                headerCellRenderer: getHeader,
                width: 200,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'REQUISITION.DETAIL.PRODUCT',
                field: "product.name",
                headerCellRenderer: getHeader,
                width: 200,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'REQUISITION.DETAIL.OBSERVATIONS',
                field: "observations",
                headerCellRenderer: getHeader,
                width: 200,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'REQUISITION.ACTIONS',
                name: "actions",
                headerCellRenderer: getHeader,
                suppressSorting: true,
                suppressMenu: true,
                width: 250,
                cellRenderer: renderer,
                cellStyle: { 'padding': '0px' }
            }
        ];


        vm.masterGridOptions = {
            columnDefs: vm.masterColumnDefs,
            enableSorting: true,
            debug: false,
            enableFilter: true,
            enableColResize: true,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowData: null,
            groupHeaders: true,
            headerHeight: 64,
            rowHeight: 45,
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            doesDataFlower: function (dataItem) {
                return true;
            },
            isExternalFilterPresent: isExternalFilterPresent,
            doesExternalFilterPass: doesExternalFilterPass
        };

        // Data
        var filter = 'everyone';

        function isExternalFilterPresent() {
            // if ageType is not everyone, then we are filtering
            return filter !== '';
        }

        function doesExternalFilterPass(node) {
            if (filter && filter !== 'everyone') {
                var arrdt = node.data.filter.split(filter);
                return arrdt.length > 1;
            }
            return true;
        }

        if ($stateParams.id === '') {
            $state.go('app.dashboards_project');
        }
        // Methods
        vm.gotoMerchandises = gotoMerchandises;
        vm.merchandiseEntryDialog = merchandiseEntryDialog;
        vm.getDetailRequisition = getDetailRequisition;
        vm.composeDialog = composeDialog;
        vm.deleteDetail = deleteDetail;
        vm.presentRequisition = presentRequisition;
        vm.addProducts = false;
        vm.viewMerchandisesDetail = viewMerchandisesDetail;

        vm.masterColumnDefsME = [
            {
                headerName: '#',
                field: "id",
                width: 50,
                cellStyle: { 'text-align': 'center' }
            },
            {
                headerName: 'MERCHANDISE_ENTRY.DETAIL.PRODUCT',
                field: "purchaseOrderDetail.product.name",
                headerCellRenderer: getHeader,
                width: 280,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'MERCHANDISE_ENTRY.DETAIL.QUANTITY',
                field: "quantity",
                headerCellRenderer: getHeader,
                width: 150,
                enableRowGroup: true,
                enablePivot: true,
                cellStyle: { 'text-align': 'center' }
            },
            {
                headerName: 'MERCHANDISE_ENTRY.ENTRYDATEPURCHASE',
                field: "dateDelivery",
                headerCellRenderer: getHeader,
                width: 150,
                valueFormatter: function (params) {
                    return $filter('date')(params.value, 'dd/MM/yyyy');
                },
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'MERCHANDISE_ENTRY.INVOICED',
                name: "invoiced",
                headerCellRenderer: getHeader,
                cellRenderer: rendererInvoiced,
                enableRowGroup: true,
                enablePivot: true,
                cellStyle: { 'text-align': 'center' }
            }
        ];


        vm.masterGridOptionsME = {
            columnDefs: vm.masterColumnDefs,
            enableSorting: true,
            debug: false,
            enableFilter: true,
            enableColResize: true,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowData: null,
            groupHeaders: true,
            headerHeight: 50,
            rowHeight: 45,
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            },
            doesDataFlower: function (dataItem) {
                return true;
            },
            isExternalFilterPresent: isExternalFilterPresent,
            doesExternalFilterPass: doesExternalFilterPass
        };

        //////////

        init();
        /**
         * Initialize
         */
        function init() {
            $rootScope.loadingProgress = true;
            vm.loading = true;
            api.ComprasWS.MerchandiseEntry.getHeader(
                { idCircle: $rootScope.bsCircle.id, id: 'byMerchandiseHeader', merchandiseHeaderId: $stateParams.id }, function (response) {// Success
                    vm.merchandiseHeader = response[0].merchandiseHeader;
                    vm.merchandises = new jinqJs()
                        .from(response)
                        .orderBy([{ field: 'id', sort: 'asc' }])
                        .select(function (r) {
                            r.dateDelivery = getDateFormat(r);
                            return r;
                        });

                    $rootScope.loadingProgress = false;
                    vm.masterGridOptionsME.api.setColumnDefs(vm.masterColumnDefsME);
                    vm.masterGridOptionsME.api.setRowData(vm.merchandises);

                    vm.merchandiseEntry = vm.merchandises[0];
                    if (vm.merchandiseEntry.purchaseOrderDetail.product.type === 'S'
                        && vm.merchandiseEntry.purchaseOrderDetail.purchaseOrder.quotation
                        && vm.statusToChange === 'Creando') {
                        for (var i = 0; i < $rootScope.bsCircle.role.roleSpecialActions.length; i++) {
                            if ($rootScope.bsCircle.role.roleSpecialActions[i].specialAction.actionName === 'Agregar Productos Adicionales a Entrada de Mercancia') {
                                vm.addProducts = true;
                                break;
                            }
                        }

                    }

                    api.ComprasWS.ProcessFlow.get({ id: vm.merchandiseHeader.id, type: 4 }, function (data) {
                        vm.infoProcessFlow = data;
                    });

                    vm.loading = false;
                    vm.dateDelivery = getDateFormat(vm.merchandiseEntry);
                    if (vm.merchandiseEntry.purchaseOrderDetail && vm.merchandiseEntry.purchaseOrderDetail.purchaseOrder.quotation) {
                        vm.otherRequisition = vm.merchandiseEntry.purchaseOrderDetail.purchaseOrder.quotation.requisition;
                        $rootScope.loadingProgress = false;
                        api.ComprasWS.Requisitions.byReference.get(
                            { referenceId: vm.merchandiseEntry.merchandiseHeader.id, originTypeCode: '04' }, function (data) {
                                vm.requisition = data[0];
                                if (vm.requisition && vm.requisition.id) {
                                    getDetailRequisition();
                                    vm.statusToChange = vm.requisition.purchaseStatus.description;
                                } else if (vm.addProducts) {
                                    api.ComprasWS.Requisition.changeStatus(
                                        {
                                            'id': 'requisitionByOrigin',
                                            requisitionId: vm.otherRequisition.id,
                                            referenceId: vm.merchandiseEntry.merchandiseHeader.id, originTypeCode: '04',
                                            idCircle: $rootScope.bsCircle.id
                                        }, null).$promise.then(function (response) {
                                            vm.requisition = response;
                                            getDetailRequisition();
                                        }, function (errResponse) {
                                            $log.debug(errResponse);
                                            vm.loading = false;
                                            $rootScope.loadingProgress = false;
                                        });
                                }
                            }, function (errResponseRQ) {
                                $log.debug(errResponseRQ);
                                vm.loading = false;
                                $rootScope.loadingProgress = false;
                            });
                    } else {
                        getDetailRequisition();
                    }
                }, function (response) {// Error
                    $log.debug(response);
                    vm.loading = false;
                    $rootScope.loadingProgress = false;
                });
        }

        /**
         * Go to Orders page
         */
        function gotoMerchandises() {
            if ($stateParams.backTo) {
                $state.go($stateParams.backTo, { 'filter': $stateParams.filter });
            } else {
                $state.go("app.order.C");
            }
        }

        function merchandiseEntryDialog(ev, det) {
            var detail = angular.copy(det);

            $mdDialog.show({
                controller: 'OrderDetailMerchandiseController',
                controllerAs: 'vm',
                locals: {
                    detail: detail
                },
                templateUrl: 'app/main/apps/order/order/merchandiseEntry/merchandiseEntry.html',
                parent: angular.element("#main"),
                targetEvent: ev,
                clickOutsideToClose: false
            });
        }

        function getDetailRequisition() {
            if (vm.requisition) {
                api.ComprasWS.RequisitionDetail.query({ idCircle: $rootScope.bsCircle.id, idRequisition: vm.requisition.id }, function (data) {

                    vm.details = new jinqJs()
                        .from(data)
                        .orderBy([{ field: 'id', sort: 'asc' }])
                        .select();

                    $rootScope.loadingProgress = false;
                    vm.masterGridOptions.api.setColumnDefs(vm.masterColumnDefs);
                    vm.masterGridOptions.api.setRowData(vm.details);
                }, function (data) {
                    $log.debug(data);
                    $rootScope.loadingProgress = false;
                    vm.masterGridOptions.api.setColumnDefs(vm.masterColumnDefs);
                    vm.masterGridOptions.api.setRowData([]);
                });
            } else {
                vm.masterGridOptions.api.setColumnDefs(vm.masterColumnDefs);
                vm.masterGridOptions.api.setRowData([]);
            }
        }

        function composeDialog(ev, det) {

            var detail = angular.copy(det);

            $mdDialog.show({
                controller: 'DetailRequisitionController',
                controllerAs: 'vm',
                locals: {
                    requisition: vm.requisition,
                    requisitionDetail: detail
                },
                templateUrl: 'app/main/apps/requisition/requisition/compose/compose-dialog.html',
                parent: angular.element("#main"),
                targetEvent: ev,
                clickOutsideToClose: false
            }).then(function (answer) {
                getDetailRequisition();
            });
        }

        function renderer(data) {
            if (vm.statusToChange === 'Creando') {
                return '<div>'
                    + ' <md-button class="edit-button md-icon-button"'
                    + '                            ng-click="vm.composeDialog($event, data, $index)"'
                    + '                            aria-label="Product details"'
                    + '                            translate translate-attr-aria-label="REQUISITION.PRODUCT_DETAILS">'
                    + '                     <md-icon md-font-icon="icon-pencil" class="s16"></md-icon>'
                    + '                 </md-button>'
                    + ' <md-button class="edit-button md-icon-button"'
                    + '                            ng-click="vm.deleteDetail(data, $event, $index)"'
                    + '                            aria-label="Product details"'
                    + '                            translate translate-attr-aria-label="REQUISITION.DELETE">'
                    + '                     <md-icon md-font-icon="icon-delete" class="s16 md-warn"></md-icon>'
                    + '                 </md-button>'
                    + '                 </div>';
            } else {
                return '';
            }

        }

        function deleteDetail(detail, event, index, del) {
            var msg = 'DELETE';
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('REQUISITION.MSG.SURE_' + msg))
                .ariaLabel('Delete modal')
                .targetEvent(event)
                .ok($filter('translate')('REQUISITION.MSG.SI'))
                .cancel($filter('translate')('REQUISITION.MSG.NO'));
            $mdDialog.show(confirm).then(function () {
                $rootScope.loadingProgress = true;
                api.ComprasWS.RequisitionDetail.delete({ idRequisition: vm.requisition.id, id: detail.id, idCircle: $rootScope.bsCircle.id }, function (data) {
                    $rootScope.loadingProgress = false;
                    getDetailRequisition();
                }, function (data) {
                    $log.debug(data);
                    $rootScope.loadingProgress = false;
                });
            }, function () {
                $rootScope.loadingProgress = false;
            });
        }

        function getDateFormat(dataItem) {
            if (dataItem.purchaseOrderDetail && dataItem.purchaseOrderDetail.purchaseOrder.contractPurchase === null) {
                var day = 0;
                var month = 0;
                if (dataItem.createdAt.dayOfMonth < 10) {
                    day = '0' + (dataItem.createdAt.dayOfMonth + 1);
                } else {
                    day = (dataItem.createdAt.dayOfMonth + 1);
                }
                if (dataItem.createdAt.monthValue < 10) {
                    month = '0' + (dataItem.createdAt.monthValue);
                } else {
                    month = dataItem.createdAt.monthValue;
                }
                return new Date(dataItem.createdAt.year + "-" + month + "-" + day);
            } else if (dataItem.purchaseOrderDetail) {
                return new Date(dataItem.purchaseOrderDetail.purchaseOrder.dateDelivery);
            }

        }

        function presentRequisition() {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('REQUISITION.MSG.' + vm.statusToChange + '_REQUISITION'))
                .textContent($filter('translate')('REQUISITION.MSG.CONFIRMACION_' + vm.statusToChange + '_REQUISITION'))
                .ok($filter('translate')('REQUISITION.MSG.SI'))
                .cancel($filter('translate')('REQUISITION.MSG.NO'));
            $mdDialog.show(confirm).then(function () {

                if ($stateParams.status === 'Autorizado') {
                    $state.go('app.quotation.new', { quotationId: 0, requisitionId: $stateParams.id });
                } else {
                    $rootScope.loadingProgress = true;
                    var promise = api.ComprasWS.Requisition.changeStatus({ 'idCircle': $rootScope.bsCircle.id, 'id': vm.requisition.id }, null).$promise;
                    promise.then(function (response) {
                        if (response.circle) {
                            var obj = getObjectTender(response);
                            api.LicitadorWS.Tender.create({ 'circle': response.circle.id }, obj,
                                function (data) {
                                    var msg = 'TENDERCREATED';
                                    $mdToast.show({
                                        template: '<md-toast layout="column" layout-align="center start"><div class="md-toast-content" translate="REQUISITION.MSG.'
                                            + msg + '"></div></md-toast>',
                                        hideDelay: 3000,
                                        position: 'top right'
                                    });
                                    $rootScope.loadingProgress = false;
                                    gotoMerchandises();
                                },
                                function (err) {
                                    $rootScope.loadingProgress = false;
                                    var msg = 'ERROR';
                                    $mdToast.show({
                                        template: '<md-toast layout="column" layout-align="center start"><div class="md-toast-content" translate="REQUISITION.MSG.'
                                            + msg + '"></div></md-toast>',
                                        hideDelay: 3000,
                                        position: 'top right'
                                    });
                                }
                            );
                        } else {
                            $rootScope.loadingProgress = false;
                            MessageService.show("REQUISITION.MSG.CHANGESTATUS." + vm.statusToChange);
                            gotoMerchandises();
                        }
                    }, function (response) {
                        $rootScope.loadingProgress = false;
                        var msg = 'ERROR';
                        if (response.data === 'No Detail') {
                            msg = 'DETAIL';
                        } else {
                            if (response.data.mensaje) {
                                if (response.data.mensaje === 'No_products') {
                                    msg = 'NOT_PRODUCT_NEGOTIATED';
                                }
                            }
                        }

                        MessageService.showErrorMessage("REQUISITION.MSG." + msg);

                    });
                }
            }, function () {
            });
        }

        function viewMerchandisesDetail(ev) {
            api.ComprasWS.MerchandiseHeader.get({ id: vm.merchandiseHeader.id }).$promise.then(function (response) {
                $mdDialog.show({
                    controller: 'MerchandiseEntryDialogController',
                    controllerAs: 'vm',
                    locals: {
                        merchandiseHeader: response
                    },
                    templateUrl: 'app/main/apps/merchandiseEntry/invoiceMerchandiseEntry/view/dialog/details.html',
                    parent: angular.element("#main"),
                    targetEvent: ev,
                    clickOutsideToClose: false
                }).then(function (answer) {
                    init();
                });
            }, function (errResponse) {
                $log.debug(errResponse);
            });
        }

        function saleProducts() {
            api.ComprasWS.SaleProduct.sale(
                {
                    productId: vm.merchandiseEntry.purchaseOrderDetail.product.id,
                    quantity: 2, departmentId: vm.merchandiseHeader.purchaseOrder.department.id,
                    costCenterId: vm.merchandiseHeader.purchaseOrder.costCenter.id,
                    referenceId: vm.merchandiseEntry.id
                }).$promise.then(function (response) {
                }, function (errResponse) {
                    $log(errResponse);
                });
        }

        function rendererInvoiced() {
            var toRet = '<div style="width: 100%;">';

            toRet = toRet + '<div>'
                + '                              <md-icon md-font-icon="{{data.invoiced ? \'icon-check\' : \'icon-close\'}}"></md-icon>'
                + '                                 </div>';

            return toRet + '</div>';
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.invoice', [
            'flow',
            'wipImageZoom',
            'app.files',
        ])
        .config(config)
        .directive('invoiceFileLoader', invoiceFileLoader);


    /** @ngInject **/
    function config($stateProvider, $translatePartialLoaderProvider) {
        // Navigation
        $stateProvider
            .state('app.invoice', {
                abstract: true,
                url: '/invoice'
            })
            .state('app.invoice.Ingresando', {
                url: '/1',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/invoice/invoices.html',
                        controller: 'InvoicesController as vm'
                    }
                },
                params: {
                    status: 'Ingresando'
                },
                bodyClass: 'e-commerce'
            })
            .state('app.invoice.Editando', {
                url: '/5',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/invoice/invoices.html',
                        controller: 'InvoicesController as vm'
                    }
                },
                params: {
                    status: 'Editando'
                },
                bodyClass: 'e-commerce'
            })
            .state('app.invoice.Emitida', {
                url: '/2',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/invoice/invoices.html',
                        controller: 'InvoicesController as vm'
                    }
                },
                params: {
                    status: 'Emitida'
                },
                bodyClass: 'e-commerce'
            })
            .state('app.invoice.PendienteRecibirOriginal', {
                url: '/3',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/invoice/invoices.html',
                        controller: 'InvoicesController as vm'
                    }
                },
                params: {
                    status: 'Pendiente Recibir Original'
                },
                bodyClass: 'e-commerce'
            })
            .state('app.invoice.PendienteProvisionar', {
                url: '/6',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/invoice/invoices.html',
                        controller: 'InvoicesController as vm'
                    }
                },
                params: {
                    status: 'Pendiente Provisionar'
                },
                bodyClass: 'e-commerce'
            })
            .state('app.invoice.Verificada', {
                url: '/4',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/invoice/invoices.html',
                        controller: 'InvoicesController as vm'
                    }
                },
                params: {
                    status: 'Provisionada'
                },
                bodyClass: 'e-commerce'
            })
            .state('app.invoice.Ingresando.detail', {
                url: '/:detail/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/invoice/saleInvoice/saleInvoiceEditor.html',
                        controller: 'SaleInvoiceEditorController as vm'
                    }
                },
                bodyClass: 'e-commerce',
                resolve: {
                    PreviousState: function ($state) {
                        return angular.copy($state.current);
                    }
                }
            })
            .state('app.invoice.Editando.detail', {
                url: '/:detail/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/invoice/saleInvoice/saleInvoiceEditorFile.html',
                        controller: 'SaleInvoiceEditorController as vm'
                    }
                },
                bodyClass: 'e-commerce',
                resolve: {
                    PreviousState: function ($state) {
                        return angular.copy($state.current);
                    }
                }
            })
            .state('app.invoice.Emitida.detail', {
                url: '/:detail/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/documentVerify/invoice.html',
                        controller: 'PurchaseDocumentController as vm'
                    }
                },
                params: {
                    backState: {},
                    docArray: [],
                    mainDoc: {},
                    canEdit: true
                },
                bodyClass: 'e-commerce'
            })
            .state('app.invoice.PendienteRecibirOriginal.detail', {
                url: '/:detail/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/documentVerify/invoice.html',
                        controller: 'PurchaseDocumentController as vm'
                    }
                },
                params: {
                    backState: {},
                    docArray: [],
                    mainDoc: {}
                },
                bodyClass: 'e-commerce'
            })
            .state('app.invoice.Verificada.detail', {
                url: '/:detail/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/invoice/purchases/invoice.html',
                        controller: 'PurchaseInvoiceController as vm'
                    }
                },
                bodyClass: 'e-commerce'
            })
            .state('app.invoice.configureLimitDate', {
                url: '/limit',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/invoice/configureLimitDate/limitDate.html',
                        controller: 'LimitDateController as vm'
                    }
                },
                bodyClass: 'e-commerce'
            });
        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/invoice');
    }

    function invoiceFileLoader() {
      return {
        restrict: 'E',
        scope: {
          fileData: '=',
          onUpdateZoom: '&',
        },
        templateUrl: 'app/main/apps/documentVerify/invoice-files/invoice-file-loader.html',
        controllerAs: 'fl',
        bindToController: true,
        controller: function () { },
      };
    }

})();

(function () {
    'use strict';
    angular
        .module('app.invoice')
        .controller('DicountDialogController', DicountDialogController);

    /** @ngInject */
    function DicountDialogController($mdDialog, $log, api, $rootScope, invoiceDetail, taxes, $filter) {
        var vm = this;

        // Data
        vm.invoicePurchaseDetail = invoiceDetail;
        vm.taxes = taxes;
        // Methods
        vm.closeDialog = closeDialog;
        vm.save = save;
        vm.validateDecimalDiscount = validateDecimalDiscount;
        const NUMBER_SIX = 6;

        //////////
        init();
        /**
         * Initialize
         */
        function init() {
            vm.loading = true;
            $rootScope.loadingProgress = true;
            api.ComprasWS.InvoicePurchaseDetail.byId({ id: vm.invoicePurchaseDetail.id }).$promise.then(function (response) {
                vm.invoicePurchaseDetail.discountBeforeTax = response.discountBeforeTax;
                vm.invoicePurchaseDetail.discountAfterTax = response.discountAfterTax;
                getOriginalPrices();
                vm.loading = false;
                $rootScope.loadingProgress = false;
            }, function (error) {
                $log.error(error.data);
                vm.loading = false;
                $rootScope.loadingProgress = false;
            });
        }

        function closeDialog() {
            $mdDialog.cancel();
        }

        function getOriginalPrices() {
            vm.priceBeforeTaxOriginal = toFixedNumber(vm.invoicePurchaseDetail.discountBeforeTax + vm.invoicePurchaseDetail.priceBeforeTax, NUMBER_SIX);
            vm.priceAfterTaxOriginal = toFixedNumber(vm.invoicePurchaseDetail.discountAfterTax + vm.invoicePurchaseDetail.priceAfterTax, NUMBER_SIX);
            vm.taxes = vm.taxes.concat(vm.invoicePurchaseDetail.product.countryTaxes);
            if (vm.invoicePurchaseDetail.discountBeforeTax || vm.invoicePurchaseDetail.discountAfterTax) {
                var totalNull = 0;
                const splitBeforeTax = getSplitBeforeAfterTax(vm.invoicePurchaseDetail.discountBeforeTax);
                const splitAfterTax = getSplitBeforeAfterTax(vm.invoicePurchaseDetail.discountAfterTax);
                var quantityZeros = (splitBeforeTax[1] || splitAfterTax[1]) ?
                    ((splitBeforeTax[1] && splitAfterTax[1] && splitBeforeTax[1].length > splitAfterTax[1].length)
                        || (splitBeforeTax[1] && !splitAfterTax[1]) ?
                        (splitBeforeTax[1].length) : (getSpliterTaxNumber(splitAfterTax))) : null;

                vm.discountBeforeTax = getDiscountBeforeAndAfterTax(vm.invoicePurchaseDetail.discountBeforeTax, totalNull, quantityZeros);

                vm.discountAfterTax = getDiscountBeforeAndAfterTax(vm.invoicePurchaseDetail.discountAfterTax, totalNull, quantityZeros);
            }
        }

        function save(discount) {
            const confirm = $mdDialog.confirm()
                .title(getTitleConfirm(discount))
                .textContent(getMessageConfirm(discount))
                .multiple(true)
                .ok($filter('translate')('INVOICE.MSG.SI'))
                .cancel($filter('translate')('INVOICE.MSG.NO'));

            $mdDialog.show(confirm).then(function () {
                vm.loading = true;
                $rootScope.loadingProgress = true;
                vm.discount = discount === 0 ? discount : vm.discount;
                vm.taxes = vm.taxes.sort(function (a, b) {
                    return a.calculationOrder - b.calculationOrder;
                });
                if (vm.discount === 0) {
                    if (vm.applyToPrice === '0') {
                        vm.invoicePurchaseDetail.discountBeforeTax = 0;
                        vm.invoicePurchaseDetail.priceBeforeTax = vm.priceBeforeTaxOriginal;
                    } else if (vm.applyToPrice === '1') {
                        vm.invoicePurchaseDetail.discountAfterTax = 0;
                        vm.invoicePurchaseDetail.priceAfterTax = vm.priceAfterTaxOriginal;
                    } else {
                        vm.invoicePurchaseDetail.discountBeforeTax = 0;
                        vm.invoicePurchaseDetail.discountAfterTax = 0;
                    }

                    if (parseFloat(vm.discountBeforeTax) > 0) {
                        vm.invoicePurchaseDetail.priceBeforeTax = vm.priceBeforeTaxOriginal;
                    } else if (parseFloat(vm.discountAfterTax) > 0) {
                        vm.invoicePurchaseDetail.priceAfterTax = vm.priceAfterTaxOriginal;
                    }
                } else {
                    if (vm.applyToPrice === '0') {
                        vm.invoicePurchaseDetail.priceBeforeTax = toFixedNumber(vm.priceBeforeTaxOriginal - vm.discount, NUMBER_SIX);
                        vm.invoicePurchaseDetail.discountBeforeTax = toFixedNumber(vm.priceBeforeTaxOriginal - vm.invoicePurchaseDetail.priceBeforeTax, NUMBER_SIX);
                    } else if (vm.applyToPrice === '1') {
                        vm.invoicePurchaseDetail.priceAfterTax = toFixedNumber(vm.priceAfterTaxOriginal - vm.discount, NUMBER_SIX);
                        vm.invoicePurchaseDetail.discountAfterTax = toFixedNumber(vm.priceAfterTaxOriginal - vm.invoicePurchaseDetail.priceAfterTax, NUMBER_SIX);
                    }

                }
                updateDetail();
            });
        }

        function updateDetail() {
            $mdDialog.hide(vm.invoicePurchaseDetail);
        }

        function validateDecimalDiscount() {
            if (vm.discount) {
                vm.discount = validateNumberDecimal(vm.discount, NUMBER_SIX);
            }
        }

        function validateNumberDecimal(origin, quantityDecimals) {
            var numbers;
            var isPoint = true;
            numbers = origin.toString().split(".");
            if (numbers.length === 1) {
                numbers = origin.toString().split(",");
                if (numbers.length > 1) {
                    isPoint = false;
                }
            }
            if (numbers.length === 2) {
                $log.debug(numbers[1].toString().length);
                if (numbers[1].toString().length > quantityDecimals) {
                    numbers[1] = numbers[1].substring(0, quantityDecimals);
                    if (isPoint) {
                        origin = parseFloat(numbers.join("."));
                    } else {
                        origin = parseFloat(numbers.join(","));
                    }
                }
            }
            return origin;
        }

        function decimalZeros(origin, quantityZeros) {
            var numbers;
            var isPoint = true;
            numbers = origin.toString().split(".");
            if (numbers.length === 1) {
                numbers = origin.toString().split(",");
                if (numbers.length > 1) {
                    isPoint = false;
                }
            }
            if (numbers.length === 2) {
                if (!quantityZeros) {
                    if (numbers[1].toString().length > 3) {
                        quantityZeros = 2;
                    } else {
                        return origin;
                    }
                }
                var decimals = numbers[1].split("");
                for (var i = (decimals.length - 1); i > -1; i--) {
                    if (i === (quantityZeros - 1)) {
                        break;
                    } else if (decimals[i] > 0) {
                        break;
                    }
                    decimals.splice(i, 1);
                }
                numbers[1] = decimals.join("");
                if (isPoint) {
                    origin = numbers.join(".");
                } else {
                    origin = parseFloat(numbers.join(","));
                }
            }
            return origin;
        }

        function toFixedNumber(origin, numberDecimals) {
            var toFixed = origin.toFixed(numberDecimals);
            return parseFloat(toFixed);
        }

        function getDiscountBeforeAndAfterTax(discountTax, totalNull, quantityZeros) {
            let valueOfDiscount = totalNull.toFixed(NUMBER_SIX);
            if (discountTax) {
                valueOfDiscount = discountTax.toFixed(NUMBER_SIX);
            }
            return decimalZeros(valueOfDiscount, quantityZeros);
        }

        function getTitleConfirm(discount) {
            if (discount != null) {
                return $filter('translate')('INVOICE.SALE_INVOICE.DETAIL.DISCOUNT.DEL_DISCOUNT');
            }
            return $filter('translate')('INVOICE.SALE_INVOICE.DETAIL.DISCOUNT.ADD_DISCOUNT');
        }

        function getMessageConfirm(discount) {
            if (discount != null) {
                return $filter('translate')('INVOICE.SALE_INVOICE.DETAIL.DISCOUNT.DEL_DISCOUNT_CONFIRM');
            }
            return $filter('translate')('INVOICE.SALE_INVOICE.DETAIL.DISCOUNT.ADD_DISCOUNT_CONFIRM');
        }

        function getSplitBeforeAfterTax(discountTax) {
            if (discountTax) {
                return discountTax.toString().split('.');
            }
            return [];
        }

        function getSpliterTaxNumber(splitAfterTax) {
            if (splitAfterTax[1].length > NUMBER_SIX) {
                return NUMBER_SIX;
            }
            return splitAfterTax[1].length;
        }

    }
})();

(function () {
    'use strict';
    angular
        .module('app.invoice')
        .controller('DetailEditorController', DetailEditorController);
    /** @ngInject */
    function DetailEditorController($mdDialog, edited, InvoicePurchase, serie, $timeout, Taxes, api, $rootScope, $filter, $log, canEdit, MessageService) {
        var vm = this;

        vm.closeDialog = closeDialog;
        vm.invoicePurchase = InvoicePurchase;
        vm.canEdit = canEdit;

        vm.products = [];
        vm.taxes = Taxes;
        vm.serie = serie;
        vm.detail = [];
        vm.addCountrytax = addCountrytax;
        vm.company = $rootScope.bsCircle.company;
        vm.saveCountryTax = saveCountryTax;
        vm.invoicePurchaseDetail = edited;
        vm.deleteCountryTaxisCanddManual = deleteCountryTaxisCanddManual;
        vm.rol = $rootScope.bsCircle.role.name === 'ROLE_VERIFICADOR_LIQUIDACIONES';
        vm.rolPays = $rootScope.bsCircle.role.name === 'ROLE_PAGOS';

        vm.clearvSearchCountryTax = function () {
            vm.searchCountryTax = "";
        };
        $timeout(function () {
            var keyEvent = function (event) {
                event.stopPropagation();
            };
            var searchSearchCountryTaxInput = document.querySelector("searchCountryTax");
            if (searchSearchCountryTaxInput) {
                searchSearchCountryTaxInput.addEventListener("keydown", keyEvent);
            }

        }, 500);


        function addCountrytax() {
            api.GeneralWS.CountryTax.getAllByCountry.get({ id: vm.company.country.id, onlyManual: true }, function (data) {
                vm.allowRoleAccess = true;
                vm.CountryTaxs = data;
                $log.debug(vm.CountryTaxs);

            });
        }


        if (angular.isDefined(edited)) {


            api.ComprasWS.InvoicePurchaseDetail.byId({ id: edited.id }).$promise.then(function (response) {
                vm.invoicePurchaseDetail = response;
                var totalNull = 0;
                vm.isValidPurchaseStatus = vm.invoicePurchaseDetail.invoicePurchase.purchaseStatus.description === 'Verificada';

                if (vm.invoicePurchaseDetail.priceAfterTax || vm.invoicePurchaseDetail.priceBeforeTax) {
                    var splitBeforeTax = vm.invoicePurchaseDetail.priceBeforeTax ? vm.invoicePurchaseDetail.priceBeforeTax.toString().split(".") : [];
                    var splitAfterTax = vm.invoicePurchaseDetail.priceAfterTax ? vm.invoicePurchaseDetail.priceAfterTax.toString().split(".") : [];
                    var quantityZeros = (splitBeforeTax[1] || splitAfterTax[1]) ?
                        ((splitBeforeTax[1] && splitAfterTax[1] && splitBeforeTax[1].length > splitAfterTax[1].length)
                            || (splitBeforeTax[1] && !splitAfterTax[1]) ? (splitBeforeTax[1].length) :
                            (splitAfterTax[1].length > 6 ? 6 : splitAfterTax[1].length)) : null;

                    vm.invoicePurchaseDetail.priceBeforeTaxCurrency = decimalZeros(vm.invoicePurchaseDetail.priceBeforeTax ?
                        vm.invoicePurchaseDetail.priceBeforeTax.toFixed(6) : totalNull.toFixed(6), quantityZeros);

                    vm.invoicePurchaseDetail.priceAfterTaxCurrency = decimalZeros(vm.invoicePurchaseDetail.priceAfterTax ?
                        vm.invoicePurchaseDetail.priceAfterTax.toFixed(6) : totalNull.toFixed(6), quantityZeros);
                } else {
                    vm.invoicePurchaseDetail.priceAfterTaxCurrency = totalNull.toFixed(2);
                    vm.invoicePurchaseDetail.priceBeforeTaxCurrency = totalNull.toFixed(2);
                }

                vm.invoicePurchaseDetail.subTotalAfterTaxCurrency = (vm.invoicePurchaseDetail.subTotalAfterTax ?
                    vm.invoicePurchaseDetail.subTotalAfterTax.toFixed(2) : totalNull.toFixed(2));

                vm.invoicePurchaseDetail.documentSubTotalAfterTaxCurrency = (vm.invoicePurchaseDetail.documentSubTotalAfterTax ?
                    vm.invoicePurchaseDetail.documentSubTotalAfterTax.toFixed(2) : totalNull.toFixed(2));

                vm.invoicePurchaseDetail.subTotalBeforeTaxCurrency = (vm.invoicePurchaseDetail.subTotalBeforeTax ?
                    vm.invoicePurchaseDetail.subTotalBeforeTax.toFixed(2) : totalNull.toFixed(2));

                vm.invoicePurchaseDetail.documentSubTotalBeforeTaxCurrency = (vm.invoicePurchaseDetail.documentSubTotalBeforeTax ?
                    vm.invoicePurchaseDetail.documentSubTotalBeforeTax.toFixed(2) : totalNull.toFixed(2));

                vm.loading = true;
                api.ComprasWS.InvoicePurchaseDetailTax.InvoicePurchaseDetailTax.byInvoicePurchaseDetail(
                    { id: 'byInvoicePurchaseDetail', invoicePurchaseDetailId: edited.id }).$promise.then(function (response) {

                        vm.detail = new jinqJs()
                            .from(response)
                            .select(function (r) {
                                var d = r;
                                d.invoicePurchaseDetail = vm.invoicePurchaseDetail;
                                d.priceCurrencyDocument = d.invoicePurchaseDetail.invoicePurchase.currency.symbol + ". " + $filter('number')(d.documentPrice, 2);
                                d.priceCurrency = d.invoicePurchaseDetail.invoicePurchase.companyCurrency.symbol + ". " + $filter('number')(d.price, 2);
                                return d;
                            });

                        vm.masterGridOptionsTax.api.setColumnDefs(vm.masterColumnDefs);
                        vm.masterGridOptionsTax.api.setRowData(vm.detail);
                        vm.invoicePurchaseDetailsTaxs = vm.detail;

                        vm.loading = false;
                    }, function (errResponse) {
                        vm.masterGridOptionsTax.api.setColumnDefs(vm.masterColumnDefs);
                        vm.masterGridOptionsTax.api.setRowData([]);

                        vm.loading = false;
                    });

            }, function (errResponse) {
                $log.debug(errResponse);
            });
        }

        vm.masterColumnDefs = [
            {
                headerName: 'INVOICE.TAX.TAX',
                field: "countryTax.tax.name",
                headerCellRenderer: getHeader,
                width: 150,
                enableRowGroup: false,
                enablePivot: false,
                suppressMenu: true,
                cellStyle: { 'padding-top': '12px' }
            },
            {
                headerName: 'INVOICE.TAX.DETAIL.PERCENTAGE',
                field: "rate",
                headerCellRenderer: getHeader,
                width: 150,
                enableRowGroup: false,
                enablePivot: false,
                suppressMenu: true,
                cellStyle: { 'text-align': 'center', 'padding-top': '12px' }
            },
            {
                headerName: 'INVOICE.TAX.DETAIL.VALUE',
                field: "documentPrice",
                headerCellRenderer: getHeader,
                width: 150,
                enableRowGroup: false,
                enablePivot: false,
                suppressMenu: true,
                cellStyle: { 'text-align': 'right' },
                decimals: 2,
                editable: true,
                cellRenderer: function (params) {
                    if (vm.canEdit) {
                        return "<div layout='row' layout-align='center center'> "
                            + " <span>{{data.documentPrice |number: 2}}</span> "
                            + " <span flex>"
                            + " <md-button ng-click='vm.onStartEdit(data)' class='md-icon-button'>"
                            + " <md-icon md-font-icon='icon-pencil' class='s16'></md-icon></md-button>"
                            + " </div>";

                    }

                    return "    <div layout='row' layout-align='center center' style='padding-top:12px;'> "
                        + "     <span>{{data.documentPrice |number: 2}}</span> "
                        + "         </div>";
                }

            },
            {
                headerName: 'INVOICE.TAX.DETAIL.OPTIONS',
                name: 'option',
                headerCellRenderer: getHeader,
                suppressSorting: true,
                suppressMenu: true,
                width: 220,
                cellRenderer: function (params) {
                    if (showDeleteButton(params.data)) {
                        return ''
                            + ' <div layout="row" layout-align="center center"> '
                            + '     <md-button ng-click="vm.deleteCountryTaxisCanddManual(data)" class="md-icon-button">'
                            + '         <md-icon md-font-icon="icon-trash" class="s16 md-warn"></md-icon>'
                            + '     </md-button>'
                            + ' </div>';
                    }
                    return '';
                },
            }

        ];

        function showDeleteButton(data) {
            var invoice = vm.invoicePurchaseDetail.invoicePurchase;
            var orderStatus = invoice.purchaseStatus.orderColumn;
            var purchaseType = 'INVOICE';
            if (vm.serie && vm.serie.invoiceSerieDocumentTypeOb) {
                purchaseType = vm.serie.invoiceSerieDocumentTypeOb.code;
            }
            var statusValid = 2;
            var countryTax = data.countryTax;
            var validatesRole = orderStatus <= statusValid && (vm.rolPays || vm.rol);
            return countryTax.canDeleteInPurchaseDocument
                && validatesRole
                && purchaseType === 'INVOICE_CREDIT_FISCAL';
        }

        vm.masterGridOptionsTax = {
            columnDefs: vm.masterColumnDefs,
            suppressClickEdit: true,
            enableSorting: false,
            debug: false,
            enableFilter: false,
            enableColResize: true,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowData: null,
            groupHeaders: false,
            rowHeight: 45,
            doesDataFlower: function (dataItem) {
                return true;
            },
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            onCellValueChanged: function (event) {
                if (event.oldValue !== event.newValue) {

                    var canUpdate = false;

                    if (!isNaN(parseFloat(event.data.documentPrice))) {
                        canUpdate = true;
                    }

                    if (canUpdate) {
                        adjustDetailsValue(event.data);
                    } else {
                        event.data.documentPrice = event.oldValue;
                    }

                }
            }
        };

        function decimalZeros(origin, quantityZeros) {
            var numbers;
            var isPoint = true;
            numbers = origin.toString().split(".");
            if (numbers.length === 1) {
                numbers = origin.toString().split(",");
                if (numbers.length > 1) {
                    isPoint = false;
                }
            }
            if (numbers.length === 2) {
                if (!quantityZeros) {
                    if (numbers[1].toString().length > 3) {
                        quantityZeros = 2;
                    } else {
                        return origin;
                    }
                }
                var decimals = numbers[1].split("");
                for (var i = (decimals.length - 1); i > -1; i--) {
                    if (i === (quantityZeros - 1)) {
                        break;
                    } else if (decimals[i] > 0) {
                        break;
                    }
                    decimals.splice(i, 1);
                }
                numbers[1] = decimals.join("");
                if (isPoint) {
                    origin = numbers.join(".");
                } else {
                    origin = parseFloat(numbers.join(","));
                }
            }
            return origin;
        }

        function closeDialog() {
            $mdDialog.hide();
        }



        function onStartEdit(data) {
            var index = 0;

            vm.masterGridOptionsTax.api.forEachNode(function (node) {
                if (node.data.id === data.id) {
                    var startEditingParams = {
                        rowIndex: index,
                        colKey: 'documentPrice'
                    };
                    vm.masterGridOptionsTax.api.startEditingCell(startEditingParams);
                }
                index += 1;
            });
        }

        vm.onStartEdit = onStartEdit;

        function adjustDetailsValue(invoicePurchaseDetailTax) {

            $rootScope.loadingProgress = true;

            api.ComprasWS.InvoicePurchaseDetailTax.adjust.update(
                {
                    idCircle: $rootScope.bsCircle.id,
                    id: invoicePurchaseDetailTax.id, totalTax: invoicePurchaseDetailTax.documentPrice
                }).$promise.then(function (response) {

                    $rootScope.loadingProgress = false;

                    MessageService.show($filter('translate')('INVOICE.MSG.DETAILS_UPDATED'));

                    $mdDialog.hide(response);

                }, function (errResponse) {
                    $rootScope.loadingProgress = false;
                    MessageService.showErrorMessage($filter('translate')(errResponse.data));
                });
        }


        function saveCountryTax() {

            $rootScope.loadingProgress = true;

            var invoicePurchaseDetailTax = {
                countryTax: {
                    id: vm.invoicePurchaseDetailTax.countryTax.id
                },
                documentPrice: vm.invoicePurchaseDetailTax.documentPrice
            };
            api.ComprasWS.InvoicePurchaseDetailTax.adjust.create(
                {
                    idCircle: $rootScope.bsCircle.id,
                    id: vm.invoicePurchaseDetail.id
                }, invoicePurchaseDetailTax).$promise.then(function (response) {

                    $rootScope.loadingProgress = false;

                    MessageService.show($filter('translate')('INVOICE.INVOICE_PURCHASE.DETAIL.SAVENEWCOUNTRYTAX'));

                    $mdDialog.hide(response);

                }, function (errResponse) {
                    $rootScope.loadingProgress = false;
                    MessageService.showErrorMessage($filter('translate')(errResponse.data));
                });
        }

        function deleteCountryTaxisCanddManual(data) {
            $rootScope.loadingProgress = true;
            api.ComprasWS.InvoicePurchaseDetailTax.adjust.delete(
                { idCircle: $rootScope.bsCircle.id, id: vm.invoicePurchaseDetail.id, idCountryTax: data.countryTax.id }, function (response) {// Success

                    $rootScope.loadingProgress = false;

                    MessageService.show($filter('translate')('INVOICE.INVOICE_PURCHASE.DETAIL.DELETECOUNTRYTAX'));

                    $mdDialog.hide(response);

                }, function () {// Error
                    $rootScope.loadingProgress = false;
                    showErrorMessage($filter('translate')('INVOICE.INVOICE_PURCHASE.DETAIL.ERROR_DELETE'));
                });
        }


    }
}
)();

(function () {
    'use strict';
    angular
        .module('app.invoice')
        .controller('DescriptionDetailDialogController', DescriptionDetailDialogController);

    /** @ngInject */
    function DescriptionDetailDialogController($mdDialog, $log, api, $rootScope, invoiceDetail) {
        var vm = this;

        vm.invoicePurchaseDetail = invoiceDetail;
        vm.description = vm.invoicePurchaseDetail.description;

        // Methods
        vm.closeDialog = closeDialog;
        vm.save = save;

        //////////
        /**
         * Initialize
         */
        function closeDialog() {
            $mdDialog.cancel();
        }
        function save() {
            vm.invoicePurchaseDetail.description = vm.description;
            vm.loading = true;
            $rootScope.loadingProgress = true;
            api.ComprasWS.InvoicePurchaseDetail.saveDescription(
                { id: 'saveDescription', idCircle: $rootScope.bsCircle.id }, vm.invoicePurchaseDetail).$promise.then(function (response) {
                    $mdDialog.hide(response);
                    $rootScope.loadingProgress = false;
                    vm.loading = false;
                }, function (errResponse) {
                    $log.debug(errResponse);
                    $rootScope.loadingProgress = false;
                    vm.loading = false;
                });
        }


    }
})();

(function () {
    'use strict';

    angular
        .module('app.configuration', [])
        .config(config);


    /** @ngInject **/
    function config($stateProvider, $translatePartialLoaderProvider) {
        // Navigation
        $stateProvider
            .state('app.configuration', {
                url: '/configuration',
                abstract: true
            })

            .state('app.configuration.rejectionReason', {
                url: '/rejectionReason',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/configuration/rejectionReason/rejectionReason.html',
                        controller: 'settlementRejectionReasonController as vm'
                    }
                },
                bodyClass: 'mail'
            }).state('app.configuration.purchaseProductDelivery', {
                url: '/purchaseProductDelivery',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/configuration/purchaseProductDelivery/purchaseProductDelivery.html',
                        controller: 'purchaseProductDeliveryController as vm'
                    }
                },
                bodyClass: 'mail'
            }).state('app.configuration.messageStatus', {
                url: '/messageStatus',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/configuration/messageStatus/messageStatus.html',
                        controller: 'messageStatusController as vm'
                    }
                },
                bodyClass: 'mail'
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/configuration');
    }

})();

(function () {
    'use strict';

    angular
        .module('app.configuration')
        .controller('editLimitDateController', editLimitDateController);

    /** @ngInject */
    function editLimitDateController($mdDialog, invoicePurchaseLimitDate, api, $rootScope, MessageService, $timeout, InvoicePurchaseType) {
        var vm = this;

        vm.page = 1;
        vm.pageSize = 20;
        vm.disableButton = false;

        var isNew = invoicePurchaseLimitDate ? false : true;
        vm.selectedTab = 0;

        if (!isNew) {
            vm.detail = invoicePurchaseLimitDate;
            vm.selectedTab = 1;
        } else {
            vm.detail = {
                company: { id: $rootScope.bsCircle.company.id }
            };
        }
        vm.loading = true;

        // Methods
        vm.closeDialog = closeDialog;
        vm.sendDetail = sendDetail;
        vm.invoicePurchaseType = InvoicePurchaseType;

        //////////

        function closeDialog() {
            $mdDialog.cancel();
        }

        function sendDetail() {
          vm.disableButton = true;
            if (vm.detailForm.$valid) {
                if (vm.detailForm.$dirty) {
                    vm.loading = true;
                    vm.promise;
                    if (isNew) {
                        vm.promise = api.ComprasWS.InvoicePurchaseLimitDate.LimitDate.create(
                            { companyId: $rootScope.bsCircle.company.id }, vm.detail).$promise;
                    } else {
                        vm.promise = api.ComprasWS.InvoicePurchaseLimitDate.LimitDate.update(
                            { companyId: $rootScope.bsCircle.company.id, id: vm.detail.id }, vm.detail).$promise;
                    }

                    vm.promise.then(
                        function (data) {
                            if (isNew) {
                                vm.disableButton = false;
                                MessageService.show('INVOICE.MSG.CONFIRMACION_SAVE');
                            } else {
                                vm.disableButton = false;
                                MessageService.show('INVOICE.MSG.CONFIRMACION_UPDATE');
                            }
                            $mdDialog.hide(data);
                            vm.loading = false;
                            vm.disableButton = false;
                        }
                    );
                } else {
                    $mdDialog.cancel();
                  vm.disableButton = false;
                }
            }
        }


        vm.clearSearchType = function () {
            vm.searchType = "";
        };

        $timeout(function () {

            var keyEvent = function (event) {
                event.stopPropagation();
            };

            var searchTypeInput = document.querySelector("#searchType");

            if (searchTypeInput) {
                searchTypeInput.addEventListener("keydown", keyEvent);
            }

        }, 500);

    }

})();

(function () {
    'use strict';

    angular
        .module('app.expenseSettlement.settlement')
        .controller('SettlementDetailsController', settlementDetailsController);

    /** @ngInject */
    function settlementDetailsController($rootScope, $state, api, $log, $mdDialog, $filter, $mdToast, $timeout) {
        var vm = this;


        //Data
        vm.newDetails = [];
        vm.details = [];
        vm.isAuthorizer = false;
        vm.isExtraAuthorizer = false;
        const EIGTH_HUNDRED_TIME_OUT = 800;
        vm.masterColumnDefs = [
            {
                headerName: $filter('translate')('SETTLEMENT.SETTLEMENT'),
                field: "id",
                width: 100,
                cellRenderer: function (params){
                  var detail=params.data;
                  return '<div>\n' +
                    '                                    <md-button class="blue-300-fg" ng-click="vm.showSettlement(data, $event)">\n' +
                    '                                        <strong># '+ detail.settlement.id +'</strong>\n' +
                    '                                    </md-button>\n' +
                    '                                </div>';
                }
              },
              {
                headerName: $filter('translate')('EXPENSE_SETTLEMENTS.PETTY_CASH.COST_CENTER'),
                field: "settlement.pettyCash.costCenter.description",
                width: 300
              },
              {
                headerName: $filter('translate')('EXPENSE_SETTLEMENTS.PETTY_CASH.DEPARTMENT'),
                field: "settlement.pettyCash.department.description",
                width: 300
              },
              {
                headerName: $filter('translate')('SETTLEMENT.INVOICE.DETAIL.DETAIL'),
                field: "id",
                width: 200,
                cellRenderer: function (params){
                  var detail=params.data;
                  return $filter('translate')((detail.invoicePurchase && detail.invoicePurchase.id > 0) ? 'SETTLEMENT.TYPE_' + detail.invoicePurchase.invoicePurchaseType : 'SETTLEMENT.RECEIPT.RECEIPT') + '' +
                  ' # ' + ((detail.invoicePurchase && detail.invoicePurchase.id > 0) ? detail.invoicePurchase.correlative : detail.paymentReceipt.correlative);
                }
              },
              {
                headerName: $filter('translate')('SETTLEMENT.PROVIDER'),
                field: "id",
                width: 100,
                cellRenderer: function (params){
                  var detail = params.data;
                  return detail.invoicePurchase && detail.invoicePurchase.id > 0 && detail.invoicePurchase.companyProvider ?  detail.invoicePurchase.companyProvider.businessName : detail.paymentReceipt.recipientName;
                }
              },
              {
                headerName: $filter('translate')('SETTLEMENT.STATUS'),
                field: "id",
                width: 150,
                cellRenderer: function (params){
                  return '<div class="actions" layout="row" layout-align="start center">\n' +
                    '                                    <div class="label ng-binding ng-scope md-green-300-bg" role="button" ng-if="data.settlementDetailStatus.name === \'Ingresando\'"\n' +
                    '                                        translate="SETTLEMENT.ENTERING">\n' +
                    '                                        Ingresando\n' +
                    '                                    </div>\n' +
                    '                                    <div class="label ng-binding ng-scope md-lime-A700-bg" role="button" ng-if="data.settlementDetailStatus.name === \'Autorización Extra\'"\n' +
                    '                                        translate="SETTLEMENT.SETTLEMENT_DETAIL.EXTRA_AUTHORIZATION">\n' +
                    '                                        Autorización Extra\n' +
                    '                                    </div>\n' +
                    '                                    <div class="label ng-binding ng-scope md-orange-900-bg" role="button" ng-if="data.settlementDetailStatus.name === \'Pendiente de Autorizar\'"\n' +
                    '                                        translate="SETTLEMENT.SENT">\n' +
                    '                                        Enviada\n' +
                    '                                    </div>\n' +
                    '                                    <div class="label ng-binding ng-scope md-blue-900-bg" role="button" ng-if="data.settlementDetailStatus.name === \'Autorizado\'"\n' +
                    '                                        translate="SETTLEMENT.AUTHORIZED">\n' +
                    '                                        Autorizada\n' +
                    '                                    </div>\n' +
                    '                                    <div class="label ng-binding ng-scope md-amber-300-bg" role="button" ng-if="data.settlementDetailStatus.name === \'No Autorizado\'"\n' +
                    '                                        translate="SETTLEMENT.NO_AUTHORIZED">\n' +
                    '                                        No Autorizada\n' +
                    '                                    </div>\n' +
                    '                                    <div class="label ng-binding ng-scope md-cyan-200-bg" role="button" ng-if="data.settlementDetailStatus.name === \'Validado\'"\n' +
                    '                                        translate="SETTLEMENT.VALIDATED">\n' +
                    '                                        Validada\n' +
                    '                                    </div>\n' +
                    '                                    <div class="label ng-binding ng-scope md-red-900-bg" role="button" ng-if="data.settlementDetailStatus.name === \'No Validado\'"\n' +
                    '                                        translate="SETTLEMENT.NO_VALIDATED">\n' +
                    '                                        No Validada\n' +
                    '                                    </div>\n' +
                    '                                </div>';
                }
              },
              {
                headerName: $filter('translate')('SETTLEMENT.REJECTION_REASON'),
                field: "id",
                width: 200,
                cellRenderer: function (params){
                  return '<div ng-if="data.rejectionReason">\n' +
                    '                                    {{data.rejectionReason.name}}\n' +
                    '                                    <md-tooltip><span>{{data.rejectionReasonDescription}}</span></md-tooltip>\n' +
                    '                                </div>';
                }
              },
              {
                headerName: $filter('translate')('SETTLEMENT.TOTAL'),
                field: "id",
                width: 100,
                cellRenderer: function (params){
                  var detail= params.data;
                  return detail.invoicePurchase && detail.invoicePurchase.id > 0 ? detail.invoicePurchase.currency.symbol : detail.paymentReceipt.currency.symbol +
                    ' ' + $filter('number')(detail.invoicePurchase && detail.invoicePurchase.id > 0 ? detail.invoicePurchase.documentTotalAfterTax : detail.paymentReceipt.documentAmount, 2);
                }
              },
              {
                headerName: $filter('translate')('SETTLEMENT.OPTIONS'),
                field: "id",
                width: 200,
                pinned: 'right',
                cellRenderer: function (params){
                  return '<div>\n' +
                    '                                    <md-button class="edit-button md-icon-button" ng-click="vm.viewDetail(data)" aria-label="Edit detail" translate translate-attr-aria-label="SETTLEMENT.VIEW_DETAIL">\n' +
                    '                                        <md-icon md-font-icon="icon-eye" class="s16"></md-icon>\n' +
                    '                                        <md-tooltip><span translate="SETTLEMENT.VIEW_DETAIL">EDIT</span></md-tooltip>\n' +
                    '                                    </md-button>\n' +
                    '                                    <md-button class="md-icon-button" ng-click="vm.optionsDetail($event, data)" ng-if="vm.isAuthorizer" aria-label="Force detail"\n' +
                    '                                        translate translate-attr-aria-label="SETTLEMENT.FORCE_DETAIL">\n' +
                    '                                        <md-icon md-font-icon="icon-cog" class="s16"></md-icon>\n' +
                    '                                        <md-tooltip><span translate="SETTLEMENT.FORCE_DETAIL">DETAIL FORCED</span></md-tooltip>\n' +
                    '                                    </md-button>\n' +
                    '                                    <md-button class="md-icon-button" ng-click="vm.deleteDetail($event, data)" ng-if="vm.isAuthorizer" aria-label="Delete"\n' +
                    '                                        translate translate-attr-aria-label="INVOICE.DELETE">\n' +
                    '                                        <md-icon md-font-icon="icon-delete" class="s16"></md-icon>\n' +
                    '                                        <md-tooltip><span translate="SETTLEMENT.DELETE">DELETE DETAIL</span></md-tooltip>\n' +
                    '                                    </md-button>\n' +
                    '                                    <md-button class="md-icon-button" ng-click="vm.authorizeDetail($event, data)" ng-if="vm.isExtraAuthorizer" aria-label="Force detail"\n' +
                    '                                        translate translate-attr-aria-label="SETTLEMENT.AUTHORIZE">\n' +
                    '                                        <md-icon md-font-icon="icon-thumb-up" class="s16"></md-icon>\n' +
                    '                                        <md-tooltip><span translate="SETTLEMENT.AUTHORIZE">AUTHORIZE DETAIL</span></md-tooltip>\n' +
                    '                                    </md-button>\n' +
                    '                                    <md-button class="md-icon-button" ng-click="vm.notAuthorizated($index, $event, data)" ng-if="vm.isExtraAuthorizer" aria-label="Force detail"\n' +
                    '                                        translate translate-attr-aria-label="SETTLEMENT.NO_AUTHORIZE">\n' +
                    '                                        <md-icon md-font-icon="icon-thumb-down" class="s16"></md-icon>\n' +
                    '                                        <md-tooltip><span translate="SETTLEMENT.NO_AUTHORIZE">NO AUTHORIZE DETAIL</span></md-tooltip>\n' +
                    '                                    </md-button>\n' +
                    '                                </div>'
                }
              }
        ];

      vm.gridOptions = {
        columnDefs: [],
        suppressContextMenu: true,
        rowSelection: 'multiple',
        suppressRowClickSelection: true,
        angularCompileRows: true,
        angularCompileHeaders: true,
        enableColResize: true,
        rowData: [],
        rowHeight: 50,
        pinnedBottomRowData: []
      };

        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            columnDefs: [
                { targets: 0, className: 'control' },
                // Target the id column
                { targets: 1 },
                // Target the actions column
                { targets: 9, responsivePriority: 1, filterable: false, sortable: false }
            ],
            initComplete: function () {
                var api = this.api(),
                    searchBox = angular.element('body').find('#e-commerce-products-search');
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            lengthMenu: [10, 20, 30, 50, 100],
            pageLength: 10,
            scrollY: 'auto',
            responsive: {
                details: {
                    type: 'column'
                }
            }
        };

        //Methods
        vm.showSettlement = showSettlement;
        vm.cancelDialog = cancelDialog;
        vm.viewDetail = viewDetail;
        vm.authorizeDetail = authorizeDetail;
        vm.notAuthorizated = notAuthorizated;
        vm.optionsDetail = optionsDetail;
        vm.deleteDetail = deleteDetail;

        function showSettlement(data, ev) {
            $mdDialog.show({
                template:'<md-dialog>\n' +
                  '                                                <md-toolbar>\n' +
                  '                                                    <div class="md-toolbar-tools">\n' +
                  '                                                        <h2>{{\'SETTLEMENT.SETTLEMENT\'| translate}} # '+data.settlement.id+'</h2>\n' +
                  '                                                        <span flex></span>\n' +
                  '                                                    </div>\n' +
                  '                                                </md-toolbar>\n' +
                  '                                                <md-dialog-content scroll>\n' +
                  '                                                    <div layout="column" layout-align="center center">\n' +
                  '                                                        <p>{{\'EXPENSE_SETTLEMENTS.PETTY_CASH.PETTY_CASH\'| translate}}:</p>\n' +
                  '                                                        <h2 class="md-title">'+ data.settlement.pettyCash.id+'</h2>\n' +
                  '                                                        <p>{{\'EXPENSE_SETTLEMENTS.PETTY_CASH.COMPANY\'| translate}}:</p>\n' +
                  '                                                        <h2 class="md-title">'+data.settlement.pettyCash.company.name+'</h2>\n' +
                  '                                                        <p>{{\'EXPENSE_SETTLEMENTS.PETTY_CASH.NAME\'| translate}}:</p>\n' +
                  '                                                        <h2 class=\'md-title\'>'+data.settlement.pettyCash.name+'</h2>\n' +
                  '                                                        <p>{{\'EXPENSE_SETTLEMENTS.PETTY_CASH.AMOUNT\'| translate}}:</p>\n' +
                  '                                                        <h2 class=\'md-title\'>'+$filter('number')(data.settlement.pettyCash.amount,2)+'</h2>\n' +
                  '                                                    </div>\n' +
                  '\n' +
                  '                                                </md-dialog-content>\n' +
                  '                                            </md-dialog>',
                parent: angular.element("#main"),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: false,
                locals: { detail: data }
            }).then(function () {
            }, function () {
            });
        }

        init();
        function init() {
            if ($rootScope.bsCircle.role.name === 'ADMIN' || $rootScope.bsCircle.role.name === 'ROLE_AUTORIZADOR_LIQUIDACIONES') {
                vm.isAuthorizer = true;
                getDetails('No Validado');
            } else if ($rootScope.bsCircle.role.name === 'ROLE_EXTRA_AUTORIZADOR_LIQUIDACIONES') {
                vm.isExtraAuthorizer = true;
                getDetails('Autorización Extra');
            }
        }


        function getDetails(status) {
            vm.loading = true;
            api.ComprasWS.SettlementDetails.AllDetailsByStatus.getAll({ status: status, circleId: $rootScope.bsCircle.id }).$promise.then(function (response) {
                vm.settlementDetails = response;
                vm.gridOptions.api.setColumnDefs(vm.masterColumnDefs);
                vm.gridOptions.api.setRowData(vm.settlementDetails);
                getDimensionCompany();
                vm.loading = false;
            }, function (error) {
                $log.error(error.data);
            });
        }

        function viewDetail(detail) {
            if (detail.paymentReceipt) {
                $state.go('app.expenseSettlement.settlement.receiptView',
                    { settlement: detail.settlement.id, detail: detail.id, receipt: detail.paymentReceipt.id });
            } else {
                $state.go('app.expenseSettlement.settlement.invoiceView',
                    { settlement: detail.settlement.id, detail: detail.id, invoiceId: detail.invoicePurchase.id });
            }
        }

        function authorizeDetail(event, detail) {
            vm.pettyCash = detail.settlement.pettyCash;
            if (event) {
                event.stopPropagation();
            }
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('SETTLEMENT.SETTLEMENT_DETAIL.AUTHORIZE_DETAIL'))
                .htmlContent('<strong>' + $filter('translate')('SETTLEMENT.SETTLEMENT_DETAIL.MSG_DETAIL_AUTHORIZED') + '</strong>' + '<br>' +
                    $filter('translate')('SETTLEMENT.SETTLEMENT_DETAIL.MSG_DETAIL_AUTHORIZED2'))
                .ariaLabel('Authorize Detail')
                .ok($filter('translate')('SETTLEMENT.OK'))
                .cancel($filter('translate')('SETTLEMENT.CANCEL'));
            $mdDialog.show(confirm).then(function () {
                $rootScope.loadingProgress = true;
                api.ComprasWS.SettlementDetails.AuthorizeDetail.authorize({ id: detail.id, circleId: $rootScope.bsCircle.id }).$promise.then(function (response) {
                    showMessage($filter('translate')('SETTLEMENT.SETTLEMENT_DETAIL.DETAIL_AUTHORIZED'));
                    init();
                }, function (error) {
                    showErrorMessage($filter('translate')('SETTLEMENT.SETTLEMENT_DETAIL.DETAIL_AUTHORIZED_ERROR'));
                    $log.error(error.data);
                });
            }, function () {
                // Cancel Action
            });
        }

        function notAuthorizated(i, ev, d) {
            $mdDialog.show({
                controller: 'rejectionReasonController',
                controllerAs: 'vm',
                locals: {
                    Data: d,
                    detailId: d.id
                },
                templateUrl: 'app/main/apps/expenseSettlements/settlements/settlement/settlementEditor/rejectionReason/rejectionReason.html',
                parent: angular.element("#main"),
                targetEvent: ev,
                clickOutsideToClose: false,
                multiple: true
            }).then(function (answer) {
                init();
            }, function () {
              init();
            });
        }

        function optionsDetail(event, detail) {
            vm.pettyCash = detail.settlement.pettyCash;
            if (event) {
                event.stopPropagation();
            }
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('SETTLEMENT.FORCE_DETAIL'))
                .htmlContent('<strong>' + $filter('translate')('SETTLEMENT.SURE_FORCE_DETAIL') + '</strong>' + '<br>' +
                    $filter('translate')('SETTLEMENT.SURE_FORCE_DETAIL2'))
                .ariaLabel('Delete Detail')
                .ok($filter('translate')('SETTLEMENT.OK'))
                .cancel($filter('translate')('SETTLEMENT.CANCEL'));
            $mdDialog.show(confirm).then(function () {
                $rootScope.loadingProgress = true;
                api.ComprasWS.SettlementDetails.ForceDetail.force({ id: vm.pettyCash.id }, detail).$promise.then(function (response) {
                    showMessage($filter('translate')('SETTLEMENT.DETAIL_FORCED'));
                    init();
                }, function (error) {
                    if (vm.pettyCash.pettyCashType.name === 'PAID_CASH') {
                        showErrorMessage($filter('translate')('SETTLEMENT.ERROR_DETAIL_FORCED2'));
                    } else {
                        showErrorMessage($filter('translate')('SETTLEMENT.ERROR_DETAIL_FORCED'));
                    }
                    $log.error(error.data);
                });
            }, function () {
                // Cancel Action
            });
        }

        function deleteDetail(event, data) {
            if (event) {
                event.stopPropagation();
            }
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('SETTLEMENT.INVOICE.DETAIL.DELETE_DETAIL.MSG_SURE_DELETE_DETAIL'))
                .content($filter('translate')('SETTLEMENT.INVOICE.DETAIL.DELETE_DETAIL.DELETE_DETAIL'))
                .ariaLabel('Delete Detail')
                .ok($filter('translate')('SETTLEMENT.DELETE'))
                .cancel($filter('translate')('SETTLEMENT.CANCEL'));
            $mdDialog.show(confirm).then(function () {
                $rootScope.loadingProgress = true;
                api.ComprasWS.SettlementDetails.deleteRejectedDetail.deleteDetail(
                    { id: data.id, circleId: $rootScope.bsCircle.id }).$promise.then(function (response) {
                        init();
                        showMessage($filter('translate')('SETTLEMENT.INVOICE.DETAIL.DELETE_DETAIL.DETAIL_DELETED'));
                    }, function (error) {
                        $log.error(error.data);
                    });
            }, function () {
                // Cancel Action
            });
        }


        function cancelDialog() {
            $mdDialog.cancel();
        }

        function showMessage(message) {
            $rootScope.loadingProgress = false;
            $mdToast.show({
                template: '<md-toast layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
                hideDelay: 3000,
                position: 'top right'
            });
        }


        function showErrorMessage(message) {
            $rootScope.loadingProgress = false;
            $mdToast.show({
                template: '<md-toast layout="column" layout-align="center start"><div class="md-toast-content" style="background-color: red">'
                    + message + '</div></md-toast>',
                hideDelay: 5000,
                position: 'top right'
            });
        }

        function getDimensionCompany() {
            const NUMBER_DIMENSION_THREE = 3;
            const NUMBER_DIMENSION_FOUR = 4;
            const NUMBER_DIMENSION_FIVE = 5;
            api.GeneralWS.DimensionCompany.byCompany.getList(
                { 'company': $rootScope.bsCircle.company.id }
            ).$promise.then(function (responseDimension) {
              responseDimension.sort(function (a, b) {
                return a.dimensionNumber - b.dimensionNumber;
              });
                for (let i = 0; i < responseDimension.length; i++) {
                    if (responseDimension[i].dimensionNumber === NUMBER_DIMENSION_THREE) {
                        vm.dimensionCompanyDetail3 = responseDimension[i];
                        addMasterColumnDefs(responseDimension[i].description, 'settlement.pettyCash.dimensionCompanyDetail3.name', responseDimension[i].dimensionNumber);
                    } else if (responseDimension[i].dimensionNumber === NUMBER_DIMENSION_FOUR) {
                        vm.dimensionCompanyDetail4 = responseDimension[i];
                        addMasterColumnDefs(responseDimension[i].description, 'settlement.pettyCash.dimensionCompanyDetail4.name', responseDimension[i].dimensionNumber);
                    } else if (responseDimension[i].dimensionNumber === NUMBER_DIMENSION_FIVE) {
                        vm.dimensionCompanyDetail5 = responseDimension[i];
                        addMasterColumnDefs(responseDimension[i].description, 'settlement.pettyCash.dimensionCompanyDetail5.name', responseDimension[i].dimensionNumber);
                    } else {
                        vm.dimensionCompanyDetail1 = responseDimension[i];
                    }
                }
                $timeout(function () {
                    vm.gridOptions.api.setColumnDefs(vm.masterColumnDefs);
                }, EIGTH_HUNDRED_TIME_OUT);
            });
        }

        function addMasterColumnDefs(name, fieldName, number) {
            const NUMBER_SEVEN_COLUMN_ADD = 7;
            vm.masterColumnDefs.splice((number + NUMBER_SEVEN_COLUMN_ADD), 0, {
                headerName: name,
                field: fieldName,
                headerCellRenderer: getHeader,
                width: 200,
                enableRowGroup: true,
                filter: 'text',
                enablePivot: true
            });
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.expenseSettlement.settlement')
        .controller('settlementController', settlementController);

    /** @ngInject */
    function settlementController($scope, $rootScope, $state, api, $log, $mdDialog, $stateParams, envService, $filter, $sce, $timeout) {
        var vm = this;

        //Data
        vm.settlements = [];
        vm.viewReports = false;

        //Methods
        vm.cancelDialog = cancelDialog;
        vm.openSettlement = openSettlement;
        vm.detailsProductRequired = detailsProductRequired;
        vm.showPDF = showPDF;
        vm.downloadPDF = downloadPDF;
        vm.viewChangeStatus = viewChangeStatus;
        const EIGTH_HUNDRED_TIME_OUT = 800;

        if (($rootScope.bsCircle.role.name === 'ROLE_OPERADOR_LIQUIDACIONES' || $rootScope.bsCircle.role.name === 'ROLE_AUTORIZADOR_LIQUIDACIONES')
            && $stateParams.status === 'Pre-Provisionada') {
            vm.viewReports = true;
        }

        init();
        function init() {
            vm.loading = true;
            api.ComprasWS.Settlement.getSettlements.getAllByUser(
                { idCircle: $rootScope.bsCircle.id, status: $stateParams.status }).$promise.then(function (response) {
                    vm.settlements = new jinqJs()
                        .from(response).
                        select(function (r) {
                            var d = r;
                            d.filter = (
                                d.settlement.pettyCash.id + "," +
                                d.settlement.pettyCash.name + "," +
                                d.settlement.pettyCash.pettyCashType.description + "," +
                                d.settlement.pettyCash.holder.account + "," +
                                d.settlement.pettyCash.department.description + "," +
                                d.settlement.pettyCash.costCenter.description + "," +
                                d.settlement.id + "," +
                                d.settlement.settlementStatus.name + "," +
                                d.settlement.erpReference + "," +
                                d.settlement.cashAmount + "," +
                                d.settlement.settledAmount
                            ).toLowerCase();
                            return d;
                        });
                    $timeout(function () {
                        if (vm.masterGridOptions && vm.masterGridOptions.api) {
                            vm.masterGridOptions.api.setColumnDefs(vm.masterColumnDefs);
                            vm.masterGridOptions.api.setRowData(response);
                        }
                        getDimensionCompany();
                    }, EIGTH_HUNDRED_TIME_OUT);
                    vm.loading = false;
                }, function (error) {
                    $log.debug(error.data);
                });
        }

        vm.masterColumnDefs = [
            {
                headerName: 'EXPENSE_SETTLEMENTS.PETTY_CASH.PETTY',
                field: "settlement.pettyCash.id",
                headerCellRenderer: getHeader,
                width: 60,
                enableRowGroup: true,
                enablePivot: true,
                cellStyle: cellResalt,
                pinned: "left"
            },
            {
                headerName: 'EXPENSE_SETTLEMENTS.PETTY_CASH.PETTYCASHTYPE',
                field: "settlement.pettyCash.pettyCashType.description",
                headerCellRenderer: getHeader,
                width: 200,
                enableRowGroup: true,
                enablePivot: true,
                cellStyle: cellResalt
            },
            {
                headerName: 'EXPENSE_SETTLEMENTS.PETTY_CASH.NAME',
                field: "settlement.pettyCash.name",
                headerCellRenderer: getHeader,
                width: 255,
                enableRowGroup: true,
                enablePivot: true,
                cellStyle: cellResalt
            },
            {
                headerName: 'EXPENSE_SETTLEMENTS.PETTY_CASH.HOLDER',
                field: "settlement.pettyCash.holder.account",
                headerCellRenderer: getHeader,
                width: 255,
                enableRowGroup: true,
                enablePivot: true,
                cellStyle: cellResalt
            },
            {
                headerName: 'EXPENSE_SETTLEMENTS.PETTY_CASH.COST_CENTER',
                field: "settlement.pettyCash.costCenter.description",
                headerCellRenderer: getHeader,
                width: 250,
                enableRowGroup: true,
                enablePivot: true,
                cellStyle: cellResalt
            },
            {
                headerName: 'EXPENSE_SETTLEMENTS.PETTY_CASH.DEPARTMENT',
                field: "settlement.pettyCash.department.description",
                headerCellRenderer: getHeader,
                width: 250,
                enableRowGroup: true,
                enablePivot: true,
                cellStyle: cellResalt
            },
            {
                headerName: 'SETTLEMENT.SETTLEMENT',
                width: 120,
                headerCellRenderer: getHeader,
                enableRowGroup: true,
                enablePivot: true,
                cellRenderer: function renderer() {
                    return '<div style="width: 100%;">'
                        + ' {{data.settlement.id}}  '
                        + ' <md-button class="edit-button md-icon-button" ng-click="vm.viewChangeStatus(data.settlement, $event)" aria-label="settlement"'
                        + ' translate translate-attr-aria-label="SETTLEMENT.CHANGE_STATUS.CHANGE_STATUS">'
                        + ' <md-tooltip md-direction="bottom">'
                        + ' {{"SETTLEMENT.CHANGE_STATUS.CHANGE_STATUS"| translate}}'
                        + ' </md-tooltip>'
                        + ' <md-icon md-font-icon="icon-history" class="s16"></md-icon> '
                        + ' </md-button>'
                        + ' </div>';
                },
                cellStyle: { 'padding': '0px' }
            },
            {
                headerName: 'SETTLEMENT.ERP_REFERENCE',
                field: "settlement.erpReference",
                headerCellRenderer: getHeader,
                width: 155,
                enableRowGroup: true,
                enablePivot: true,
                cellStyle: cellResalt
            },
            {
                headerName: 'SETTLEMENT.CASH_AMOUNT',
                field: "settlement.cashAmount",
                headerCellRenderer: getHeader,
                width: 120,
                valueFormatter: function (params) {
                    return $filter('number')(params.value, 2);
                },
                enableRowGroup: true,
                enablePivot: true,
                cellStyle: cellResalt
            },
            {
                headerName: 'SETTLEMENT.SETTLED_AMOUNT',
                field: "settlement.settledAmount",
                headerCellRenderer: getHeader,
                width: 140,
                valueFormatter: function (params) {
                    return $filter('number')(params.value, 2);
                },
                enableRowGroup: true,
                enablePivot: true,
                cellStyle: cellResalt
            },
            {
                headerName: 'ORDER.ACTIONS',
                name: "actions",
                headerCellRenderer: getHeader,
                suppressSorting: true,
                suppressMenu: true,
                width: 270,
                cellRenderer: function renderer(params) {
                    return '<div style="width: 100%;">'
                        + ' <md-button class="edit-button md-icon-button" ng-click="vm.openSettlement(data.settlement)" aria-label="settlement"'
                        + ' translate translate-attr-aria-label="SETTLEMENT.VIEW_DETAILS">'
                        + ' <md-tooltip md-direction="bottom">'
                        + ' {{"SETTLEMENT.VIEW_DETAILS"| translate}}'
                        + ' </md-tooltip>'
                        + '  <md-icon md-font-icon="icon-eye" class="s16"></md-icon> '
                        + ' </md-button>'
                        + ' <md-button class="edit-button md-icon-button" ng-click="vm.showPDF(\'JASPER_URL_SETTLEMENT\',data.settlement)" aria-label="settlement"'
                        + ' translate translate-attr-aria-label="Generar PDF" ng-if="vm.viewReports">'
                        + ' <md-tooltip md-direction="bottom">'
                        + ' {{"EXPENSE_SETTLEMENTS.GENERATE_PDF"| translate}}'
                        + ' </md-tooltip>'
                        + '  <md-icon md-font-icon="icon-printer" class="s16"></md-icon> '
                        + ' </md-button>'
                        + ' <md-button class="edit-button md-icon-button" ng-click="vm.showPDF(\'JASPER_URL_SETTLEMENT_WITH_DETAILS\',data.settlement)" '
                        + 'aria-label="settlement"'
                        + ' translate translate-attr-aria-label="Generar PDF">'
                        + ' <md-tooltip md-direction="bottom">'
                        + ' {{"EXPENSE_SETTLEMENTS.GENERATE_PDF_WITH_DETAILS"| translate}}'
                        + ' </md-tooltip>'
                        + '  <md-icon md-font-icon="icon-clipboard-text" class="s16"></md-icon> '
                        + ' </md-button>'
                        + ' <md-button class="edit-button md-icon-button" ng-click="vm.downloadPDF(\'JASPER_URL_SETTLEMENT\', data.settlement.id)" '
                        + ' aria-label="settlement"'
                        + ' translate translate-attr-aria-label="Descargar PDF" ng-if="vm.viewReports">'
                        + ' <md-tooltip md-direction="bottom">'
                        + ' {{"Descargar PDF"| translate}}'
                        + ' </md-tooltip>'
                        + '  <md-icon md-font-icon="icon-download" class="s16"></md-icon> '
                        + ' </md-button>'
                        + ' </div>';
                },
                cellStyle: cellResalt,
                pinned: "right"
            }
        ];

        function cellResalt(params) {
            var data = params.data;
            var obR = {};
            if (data.products && data.products.length > 0) {
                obR.backgroundColor = '#BBB9B2';
            }
            return obR;
        }

        vm.masterGridOptions = {
            columnDefs: vm.masterColumnDefs,
            enableSorting: true,
            debug: false,
            enableFilter: true,
            enableColResize: true,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowData: null,
            groupHeaders: true,
            headerHeight: 50,
            rowHeight: 45,
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            },
            doesDataFlower: function (dataItem) {
                return true;
            },
            isExternalFilterPresent: isExternalFilterPresent,
            doesExternalFilterPass: doesExternalFilterPass
        };

        var filter = 'everyone';

        function isExternalFilterPresent() {
            return filter !== '';
        }

        function viewChangeStatus(settlement, ev) {
            $mdDialog.show({
                controller: 'changeStatusController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/expenseSettlements/settlements/settlement/settlementEditor/changeStatus/changeStatus.html',
                targetEvent: ev,
                locals: {
                    settlementId: settlement.id
                },
                clickOutsideToClose: false
            }).then(function (answer) {

            });
        }

        function showPDF(parameter, settlement) {
            var urlRpt = null;
            if (parameter === 'JASPER_URL_SETTLEMENT') {
                urlRpt = $rootScope.getParameterValue('JASPER_URL_SETTLEMENT').replace('[ID]', settlement.id);
            } else if ('JASPER_URL_SETTLEMENT_WITH_DETAILS') {
                urlRpt = $rootScope.getParameterValue('JASPER_URL_SETTLEMENT_WITH_DETAILS').replace("[ID]", settlement.id);
            }

            $mdDialog.show({
                controller: 'ReportShowPDFController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/reports/dialogs/show-pdf/show-pdf.html',
                parent: angular.element("#main"),
                locals: {
                    Url: urlRpt
                },
                clickOutsideToClose: false,
                fullscreen: true
            }).then(function (answer) {
            }, function () {
            });
        }

        function downloadPDF(parameter, id) {
            var theLink = $sce.trustAsResourceUrl(envService.read('baseUrlJReportsWSPdf') + '?rpt=' + $rootScope.getParameterValue(parameter).replace('[ID]', id));

            var a = document.createElement('a');
            a.href = theLink;
            a.target = '_blank';
            a.download = 'file.pdf';
            document.body.appendChild(a);
            a.click();

        }

        function openSettlement(settlement) {
            switch (settlement.settlementStatus.name) {
                case 'Ingresando':
                    $state.go('app.expenseSettlement.settlement.settlementEdit', { settlementId: settlement.id });
                    break;
                case 'Pendiente de Autorizar':
                    $state.go('app.expenseSettlement.settlement.settlementView', { settlementId: settlement.id });
                    break;
                case 'Autorizada':
                    $state.go('app.expenseSettlement.settlement.settlementView', { settlementId: settlement.id });
                    break;
                case 'Pre-Provisionada':
                    $state.go('app.expenseSettlement.settlement.settlementView', { settlementId: settlement.id });
                    break;
                case 'Provisionada':
                    $state.go('app.expenseSettlement.settlement.settlementView', { settlementId: settlement.id });
                    break;
            }
        }

        function detailsProductRequired(data, index, ev) {
            $mdDialog.show({
                controller: 'ComposeDialogProductRequiredController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/expenseSettlements/settlements/details/invoiceEditor/productsRequired/productsRequired.html',
                targetEvent: ev,
                locals: {
                    products: data.products,
                    showButtons: false
                },
                clickOutsideToClose: false
            }).then(function (answer) {

            });
        }

        function doesExternalFilterPass(node) {
            if (filter && filter !== 'everyone') {
                var arrdt = node.data.filter.split(filter);
                return arrdt.length > 1;
            }
            return true;
        }

        $scope.$watch('vm.search',
            function (newValue) {
                filter = newValue ? newValue.toLowerCase() : 'everyone';
                vm.masterGridOptions.api.onFilterChanged();
            }
        );

        function cancelDialog() {
            $mdDialog.cancel();
        }

        function getDimensionCompany() {
            const NUMBER_DIMENSION_THREE = 3;
            const NUMBER_DIMENSION_FOUR = 4;
            const NUMBER_DIMENSION_FIVE = 5;
            api.GeneralWS.DimensionCompany.byCompany.getList(
                { 'company': $rootScope.bsCircle.company.id }
            ).$promise.then(function (responseDimension) {
              responseDimension.sort(function (a, b) {
                return a.dimensionNumber - b.dimensionNumber;
              });
                for (let i = 0; i < responseDimension.length; i++) {
                    if (responseDimension[i].dimensionNumber === NUMBER_DIMENSION_THREE) {
                        vm.dimensionCompanyDetail3 = responseDimension[i];
                        addMasterColumnDefs(responseDimension[i].description, 'settlement.pettyCash.dimensionCompanyDetail3.name', responseDimension[i].dimensionNumber);
                    } else if (responseDimension[i].dimensionNumber === NUMBER_DIMENSION_FOUR) {
                        vm.dimensionCompanyDetail4 = responseDimension[i];
                        addMasterColumnDefs(responseDimension[i].description, 'settlement.pettyCash.dimensionCompanyDetail4.name', responseDimension[i].dimensionNumber);
                    } else if (responseDimension[i].dimensionNumber === NUMBER_DIMENSION_FIVE) {
                        vm.dimensionCompanyDetail5 = responseDimension[i];
                        addMasterColumnDefs(responseDimension[i].description, 'settlement.pettyCash.dimensionCompanyDetail5.name', responseDimension[i].dimensionNumber);
                    } else {
                        vm.dimensionCompanyDetail1 = responseDimension[i];
                    }
                }
                if (vm.masterGridOptions && vm.masterGridOptions.api) {
                    vm.masterGridOptions.api.setColumnDefs(vm.masterColumnDefs);
                }
            });
        }

        function addMasterColumnDefs(name, fieldName, number) {
            const NUMBER_SEVEN_COLUMN_ADD = 7;
            vm.masterColumnDefs.splice((number + NUMBER_SEVEN_COLUMN_ADD), 0, {
                headerName: name,
                field: fieldName,
                headerCellRenderer: getHeader,
                width: 200,
                enableRowGroup: true,
                filter: 'text',
                enablePivot: true
            });
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.expenseSettlement.pettyCashGeneralSets', [])
        .config(config);


    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {
        // State
        $stateProvider

            .state('app.expenseSettlement.pettyCashGeneralSets', {
                url: '/pettyCashGeneralSets',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/expenseSettlements/pettyCashGeneralSets/pettyCashGeneralSets.html',
                        controller: 'pettyCashGeneralSetsController as vm'
                    }
                },
                bodyClass: 'mail'
            });


        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/expenseSettlements/pettyCashGeneralSets');

    }
})();


(function () {
    'use strict';

    angular
        .module('app.expenseSettlement.pettyCashGeneralSets')
        .controller('pettyCashGeneralSetsEditorController', pettyCashGeneralSetsEditorController);

    /** @ngInject */
    function pettyCashGeneralSetsEditorController($mdDialog, data, api, $log, type, $rootScope, $mdToast, $filter) {
        var vm = this;

        // Data
        vm.isNew = data ? false : true;
        vm.pettyCashGeneralSets = {
            pettyCashType: type,
            moreDetails: false
        };

        // Methods
        vm.closeDialog = closeDialog;
        vm.sendForm = sendForm;


        //////////


        if (vm.isNew === false) {
            vm.pettyCashGeneralSets = angular.copy(data);
        }

        function sendForm() {

            if (vm.pettyCashGeneralSets.maxAmountByPettyCash > 0 && vm.pettyCashGeneralSets.maxAmountByDocument > vm.pettyCashGeneralSets.maxAmountByPettyCash) {
                showErrorMessage($filter('translate')('PETTY_CASH_SETS.DOCUMENT_NOMAYOR_THAN_PETTYCASH'));
            } else {
                vm.loading = true;
                if (vm.isNew === true) { //Crear
                    var newPettyMaxAmount = {
                        pettyCashType: {
                            id: vm.pettyCashGeneralSets.pettyCashType.id
                        },
                        company: {
                            id: $rootScope.bsCircle.company.id
                        },
                        maxAmountByDocument: (vm.pettyCashGeneralSets.maxAmountByDocument > 0 ? vm.pettyCashGeneralSets.maxAmountByDocument : null),
                        maxAmountByPettyCash: (vm.pettyCashGeneralSets.maxAmountByPettyCash > 0 ? vm.pettyCashGeneralSets.maxAmountByPettyCash : null),
                        maxInvoiceByProvider: (vm.pettyCashGeneralSets.maxInvoiceByProvider > 0 ? vm.pettyCashGeneralSets.maxInvoiceByProvider : null),
                        moreDetails: vm.pettyCashGeneralSets.moreDetails,
                        askForBudget: vm.pettyCashGeneralSets.askForBudget,
                        useAllProducts: vm.pettyCashGeneralSets.useAllProducts,
                        useExternalProviders: vm.pettyCashGeneralSets.useExternalProviders,
                    };
                    api.ComprasWS.pettyCashGeneralSets.create({ id: '', idCircle: $rootScope.bsCircle.id }, newPettyMaxAmount).$promise.then(function (response) {
                        $mdDialog.hide(response);
                        showMessage($filter('translate')('PETTY_CASH_SETS.CREATE_AMOUNT_SUCCESSFULLY') + vm.pettyCashGeneralSets.pettyCashType.description);
                        vm.loading = false;
                    }, function (error) {
                        showErrorMessage($filter('translate')('PETTY_CASH_SETS.CREATE_AMOUNT_ERROR') + vm.pettyCashGeneralSets.pettyCashType.description);
                        $log.error(error.data);
                        vm.loading = false;
                    });
                } else { //Editar
                    //montos en nulo
                    vm.pettyCashGeneralSets.maxAmountByDocument = (vm.pettyCashGeneralSets.maxAmountByDocument > 0 ? vm.pettyCashGeneralSets.maxAmountByDocument : null);
                    vm.pettyCashGeneralSets.maxAmountByPettyCash = (vm.pettyCashGeneralSets.maxAmountByPettyCash > 0 ? vm.pettyCashGeneralSets.maxAmountByPettyCash : null);
                    vm.pettyCashGeneralSets.maxInvoiceByProvider = (vm.pettyCashGeneralSets.maxInvoiceByProvider > 0 ? vm.pettyCashGeneralSets.maxInvoiceByProvider : null);

                    $log.debug(vm.pettyCashGeneralSets);

                    api.ComprasWS.pettyCashGeneralSets.update(
                        { id: vm.pettyCashGeneralSets.id, idCircle: $rootScope.bsCircle.id }, vm.pettyCashGeneralSets).$promise.then(function (response) {
                            $mdDialog.hide(response);
                            showMessage($filter('translate')('PETTY_CASH_SETS.UPDATE_AMOUNT_SUCCESSFULLY') + vm.pettyCashGeneralSets.pettyCashType.description);
                            vm.loading = false;
                        }, function (error) {
                            showErrorMessage($filter('translate')('PETTY_CASH_SETS.UPDATE_AMOUNT_ERROR') + vm.pettyCashGeneralSets.pettyCashType.description);
                            $log.error(error.data);
                            vm.loading = false;
                        });
                }
            }

        }

        function closeDialog() {
            $mdDialog.cancel();
        }

        function showMessage(message) {
            $rootScope.loadingProgress = false;
            $mdToast.show({
                template: '<md-toast layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
                hideDelay: 3000,
                position: 'top right'
            });
        }

        function showErrorMessage(message) {
            $rootScope.loadingProgress = false;
            $mdToast.show({
                template: '<md-toast layout="column" layout-align="center start"><div class="md-toast-content" style="background-color: red">'
                    + message + '</div></md-toast>',
                hideDelay: 5000,
                position: 'top right'
            });
        }


    }
})();

(function () {
    'use strict';

    angular
        .module('app.expenseSettlement.pettyCash', [])
        .config(config);


    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {
        // State
        $stateProvider
            .state('app.expenseSettlement', {
                abstract: true,
                url: '/expenseSettlement'
            })
            .state('app.expenseSettlement.pettyCash', {
                abstract: true,
                url: '/pettyCash'
            })
            .state('app.expenseSettlement.pettyCash.pettyCash', {
                url: '/pettyCash',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/expenseSettlements/pettyCash/pettyCash.html',
                        controller: 'pettyCashController as vm'
                    }
                },
                bodyClass: 'mail'
            })
            .state('app.expenseSettlement.pettyCash.pettyCash.editor', {
                url: '/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/expenseSettlements/pettyCash/pettyCashEditor/pettyCashEditor.html',
                        controller: 'pettyCashEditorController as vm'
                    }
                },
                bodyClass: 'mail',
                params: {
                    isReport: null
                }
            })

            .state('app.expenseSettlement.pettyCash.withAmountToReturn', {
                url: '/withAmountToReturn',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/expenseSettlements/pettyCash/withAmountToReturn/pettyCashRefund.html',
                        controller: 'pettyCashWithAmountToReturnController as vm'
                    }
                },
                bodyClass: 'mail'
            })
            .state('app.expenseSettlement.pettyCash.settings', {
                url: '/settings',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/expenseSettlements/pettyCash/settings/settings.html',
                        controller: 'settingsController as vm'
                    }
                },
                bodyClass: 'mail'
            })

            ;

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/expenseSettlements');

    }
})();


(function () {
    'use strict';

    angular
        .module('app.expenseSettlement.pettyCash')
        .controller('settingsController', settingsController);

    /** @ngInject */
    function settingsController(api, $log, $rootScope, $timeout, $mdToast, $filter, $scope, msUtils) {

        var vm = this;
        vm.page = 1;
        vm.pageSize = 20;
        vm.company = $rootScope.bsCircle.company;
        vm.roleApplication = $rootScope.bsCircle.role;

        //Data
        vm.roles = [];
        vm.users = {};
        vm.pettyCashType = [];
        vm.settings = {};

        $scope.$watch('vm.settings.roleApplication.id', function (roleId) {
            loadUsers(roleId, 1);
            loadPettyTypes();
            loadPettyTypesProvision();
            var contentHeight = $("#usersList").innerHeight();
            contentHeight -= 112;
            vm.dinamicHeight = { "height": contentHeight + "px" };
        });

        //Methods
        vm.activeSearchAll = activeSearchAll;
        vm.loadUsers = loadUsers;
        vm.selectUser = selectUser;
        vm.exists = msUtils.exists;
        vm.toggleSelectType = toggleSelectType;
        vm.changeFilter = changeFilter;
        vm.selectUserProvision = selectUserProvision;
        vm.loadPettyTypesProvision = loadPettyTypesProvision;
        vm.toggleSelectTypeProvision = toggleSelectTypeProvision;
        vm.user;


        //////////

        $timeout(getAll, 50);

        function getAll() {
            vm.loading = true;
            $rootScope.loadingProgress = true;
            api.GeneralWS.RoleApplication.getRoles(
                { applicationId: $rootScope.bsCircle.role.aplication.id, nameLike: 'LIQUIDACIONES' }).$promise.then(function (response) {
                    vm.roles = response;
                    vm.roles.forEach(function (rol) {
                        if (rol.name === 'ROLE_VERIFICADOR_LIQUIDACIONES' || rol.name === 'ROLE_PAGOS_AUTORIZADOR') {
                            vm.settings.roleApplication = rol;
                        }
                    });
                    vm.loading = false;
                    $rootScope.loadingProgress = false;
                }, function (error) {
                    vm.loading = false;
                    $log.error(error.data);
                });
        }

        vm.clearSearchRoleApplication = function () {
            vm.searchRoleApplication = "";
        };

        $timeout(function () {
            var keyEvent = function (event) {
                event.stopPropagation();
            };
            var searchRolApplicationInput = document.querySelector("#roleApplication");

            if (searchRolApplicationInput) {
                searchRolApplicationInput.addEventListener("keydown", keyEvent);
            }
        }, 500);

        function activeSearchAll() {
            vm.searchModeAll = true;
            $timeout(function () {
                $('#searchFieldAll').focus();
            });
        }

        function loadUsers(roleId, page) {
            vm.selectedUser;
            vm.selectedUserProvision;
            vm.searchText = null;
            vm.page = page;
            if (roleId !== undefined) {
                vm.loading = true;
                $rootScope.loadingProgress = true;
                api.GeneralWS.UsersCompany.get(
                    {
                        company: vm.company.id,
                        roleId: vm.settings.roleApplication.id, 'pageNumber': page, 'pageSize': vm.pageSize, 'search': vm.filterUser
                    }).$promise.then(function (response) {
                        vm.users = response;
                        vm.loading = false;
                        $rootScope.loadingProgress = false;
                    }, function (error) {
                        $log.error(error);
                        vm.loading = false;
                        $rootScope.loadingProgress = false;
                    });
            }
        }

        function loadPettyTypes() {
            vm.loading = true;
            $rootScope.loadingProgress = true;
            api.ComprasWS.pettyCashType.query({}).$promise.then(function (response) {
                vm.pettyCashTypes = response;
                vm.loading = false;
                $rootScope.loadingProgress = false;

            }, function (response) {
                $log.error(response);
                vm.loading = false;
                $rootScope.loadingProgress = false;
            });
        }

        function loadPettyTypesProvision() {
            vm.loading = true;
            $rootScope.loadingProgress = true;
            api.ComprasWS.pettyCashType.query({}).$promise.then(function (response) {
                vm.pettyCashTypesProvision = response;
                vm.loading = false;
                $rootScope.loadingProgress = false;
            }, function (response) {
                vm.loading = false;
                $rootScope.loadingProgress = false;
                $log.error(response);
            });
        }

        function selectUser(user) {

            vm.selectedUser = user;
            vm.user = user;
            vm.searchText = null;
            vm.loadingSettings = true;
            //CARGAR CONFIGURACIONES DE FONDOS DE CAJA A USUARIO SELECCIONADO
            api.ComprasWS.PettyCashTypeSettings.getByUser.get(
                { userId: user.id, rolId: vm.settings.roleApplication.id, circle: $rootScope.bsCircle.id, verification: true }).$promise.then(function (response) {
                    vm.settingsUser = response;
                    vm.pettyCashTypes.forEach(function (type) {
                        var settingUser = {};
                        settingUser = _.find(vm.settingsUser, function (setting) {
                            return type.id === setting.pettyCashType.id;
                        });
                        if (settingUser) {
                            type.isChecked = true;
                        } else {
                            type.isChecked = false;
                        }
                    });
                    selectUserProvision(user);
                    vm.loadingSettings = false;


                }, function (error) {
                    $log.debug(error.data);
                });
        }

        function selectUserProvision(user) {

            vm.selectedUserProvision = user;

            vm.searchText = null;
            vm.loadingSettings = true;
            api.ComprasWS.PettyCashTypeSettings.getByUserProvision.get(
                { userId: user.id, rolId: vm.settings.roleApplication.id, circle: $rootScope.bsCircle.id, provition: true }).$promise.then(function (data) {
                    vm.settingsUserProvision = data;
                    vm.pettyCashTypesProvision.forEach(function (type) {
                        var settingsUserProvision = {};
                        settingsUserProvision = _.find(vm.settingsUserProvision, function (settings) {
                            return type.id === settings.pettyCashType.id;
                        });
                        if (settingsUserProvision) {
                            type.isCheckedValidate = true;
                        } else {
                            type.isCheckedValidate = false;
                        }
                    });
                    vm.loadingSettings = false;
                }, function (error) {
                    $log.debug(error.data);
                });
        }

        function toggleSelectTypeProvision(type, event, validate) {

            var setting = {
                user: {
                    id: vm.selectedUserProvision.id
                },
                roleApplication: {
                    id: vm.settings.roleApplication.id
                },
                company: {
                    id: $rootScope.bsCircle.company.id
                },
                pettyCashType: {
                    id: type.id
                }
            };
            if (event) {
                event.stopPropagation();
            }
            var settingsUserProvision = {};
            settingsUserProvision = _.find(vm.settingsUserProvision, function (setting) {
                return type.id === setting.pettyCashType.id;
            });

            if (settingsUserProvision !== undefined && type.isCheckedValidate === true) {
                $rootScope.loadingProgress = true;
                vm.loadingP = true;
                api.ComprasWS.PettyCashTypeSettings.PettyCashTypeSettings.delete(
                    { id: settingsUserProvision.id, circle: $rootScope.bsCircle.id, validate: validate }).$promise.then(function (response) {
                        vm.settingsUser.splice(vm.settingsUser.indexOf(settingsUserProvision), 1);
                        type.isCheckedValidate = false;
                        showMessage($filter('translate')('EXPENSE_SETTLEMENTS.PETTY_CASH.SETTINGS.MSG_DELETED'));
                        $rootScope.loadingProgress = false;
                        vm.loadingP = false;
                    }, function (error) {
                        showErrorMessage($filter('translate')('EXPENSE_SETTLEMENTS.PETTY_CASH.SETTINGS.MSG_DELETED_ERROR'));
                        selectUserProvision(vm.user);
                        $log.error(error.data);
                        $rootScope.loadingProgress = false;
                        vm.loadingP = false;
                    });


            } else if (type.isCheckedValidate === false) { //Agregar permiso
                $rootScope.loadingProgress = true;
                vm.loadingP = true;
                api.ComprasWS.PettyCashTypeSettings.PettyCashTypeSettings.create(
                    { circle: $rootScope.bsCircle.id, validate: validate }, setting).$promise.then(function (response) {
                        vm.settingsUser.push(response);
                        type.isCheckedValidate = true;
                        showMessage($filter('translate')('EXPENSE_SETTLEMENTS.PETTY_CASH.SETTINGS.MSG_ADDED'));
                        $rootScope.loadingProgress = false;
                        vm.loadingP = false;

                    }, function (error) {
                        showErrorMessage($filter('translate')('EXPENSE_SETTLEMENTS.PETTY_CASH.SETTINGS.MSG_ADDED_ERROR'));
                        $log.error(error.data);
                        $rootScope.loadingProgress = false;
                        vm.loadingP = false;
                    });
            } else if (settingsUserProvision === undefined && type.isCheckedValidate === true) {
                selectUserProvision(vm.user);
            }

        }

        function toggleSelectType(type, event, validate) {

            var setting = {
                user: {
                    id: vm.selectedUser.id
                },
                roleApplication: {
                    id: vm.settings.roleApplication.id
                },
                company: {
                    id: $rootScope.bsCircle.company.id
                },
                pettyCashType: {
                    id: type.id
                }
            };
            if (event) {
                event.stopPropagation();
            }
            var settingUser = {};
            settingUser = _.find(vm.settingsUser, function (setting) {
                return type.id === setting.pettyCashType.id;
            });
            if (settingUser !== undefined && type.isChecked === true) {
                $rootScope.loadingProgress = true;
                vm.loading = true;
                api.ComprasWS.PettyCashTypeSettings.PettyCashTypeSettings.delete(
                    { id: settingUser.id, circle: $rootScope.bsCircle.id, validate: validate }).$promise.then(function (response) {
                        vm.settingsUser.splice(vm.settingsUser.indexOf(settingUser), 1);
                        type.isChecked = false;
                        showMessage($filter('translate')('EXPENSE_SETTLEMENTS.PETTY_CASH.SETTINGS.MSG_DELETED'));
                        $rootScope.loadingProgress = false;
                        vm.loading = false;
                    }, function (error) {
                        showErrorMessage($filter('translate')('EXPENSE_SETTLEMENTS.PETTY_CASH.SETTINGS.MSG_DELETED_ERROR'));
                        selectUser(vm.user);
                        $log.error(error.data);
                        $rootScope.loadingProgress = false;
                        vm.loading = false;
                    });

            } else if (type.isChecked === false) {  //Agregar permiso
                $rootScope.loadingProgress = true;
                vm.loading = true;
                api.ComprasWS.PettyCashTypeSettings.PettyCashTypeSettings.create(
                    { circle: $rootScope.bsCircle.id, validate: validate }, setting).$promise.then(function (response) {
                        vm.settingsUser.push(response);
                        type.isChecked = true;
                        showMessage($filter('translate')('EXPENSE_SETTLEMENTS.PETTY_CASH.SETTINGS.MSG_ADDED'));
                        $rootScope.loadingProgress = false;
                        vm.loading = false;

                    }, function (error) {
                        showErrorMessage($filter('translate')('EXPENSE_SETTLEMENTS.PETTY_CASH.SETTINGS.MSG_ADDED_ERROR'));
                        $log.error(error.data);
                        $rootScope.loadingProgress = false;
                        vm.loading = false;
                    });
            } else if (settingUser === undefined && type.isChecked === true) {
                selectUser(vm.user);
            }
        }

        function changeFilter() {
            if (!vm.filterUser || vm.filterUser === '') {
                loadUsers(vm.settings.roleApplication.id, 1);
            }
        }

        function showMessage(message) {
            $rootScope.loadingProgress = false;
            $mdToast.show({
                template: '<md-toast layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
                hideDelay: 7000,
                position: 'top right'
            });
        }

        function showErrorMessage(message) {
            $rootScope.loadingProgress = false;
            $mdToast.show({
                template: '<md-toast layout="column" layout-align="center start"><div class="md-toast-content" style="background-color: red">'
                    + message + '</div></md-toast>',
                hideDelay: 5000,
                position: 'top right'
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.expenseSettlement.pettyCash')
        .controller('pettyCashWithAmountToReturnController', pettyCashWithAmountToReturnController);

    /** @ngInject */
    function pettyCashWithAmountToReturnController($scope, $rootScope, api, $log, $filter, $mdDialog, $mdToast, $timeout) {
        var vm = this;

        document.addEventListener("mousewheel", function (event) {
            if (document.activeElement.type === "number") {
                document.activeElement.blur();
            }
        });

        //Data
        vm.pettyCashes = [];
        const FOUR_HUNDRED_TIME_OUT = 400;

        vm.masterColumnDefs = [
            {
                headerName: 'EXPENSE_SETTLEMENTS.PETTY_CASH.PETTY',
                field: "id",
                headerCellRenderer: getHeader,
                width: 50,
                enableRowGroup: true,
                enablePivot: true,
                pinned: "left"
            },
            {
                headerName: 'EXPENSE_SETTLEMENTS.PETTY_CASH.PETTYCASHTYPE',
                field: "pettyCashType.description",
                headerCellRenderer: getHeader,
                width: 100,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'EXPENSE_SETTLEMENTS.PETTY_CASH.NAME',
                field: "name",
                headerCellRenderer: getHeader,
                width: 200,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'EXPENSE_SETTLEMENTS.PETTY_CASH.AMOUNT',
                field: "amount",
                headerCellRenderer: getHeader,
                width: 100,
                valueFormatter: function (params) {
                    return $filter('number')(params.value, 2);
                },
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'EXPENSE_SETTLEMENTS.PETTY_CASH.REFUND_AMOUNT',
                field: "amountAvailable",
                headerCellRenderer: getHeader,
                width: 100,
                valueFormatter: function (params) {
                    return $filter('number')(params.value, 2);
                },
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'EXPENSE_SETTLEMENTS.PETTY_CASH.STARTDATE',
                field: "startDate",
                width: 120,
                headerCellRenderer: getHeader,
                valueFormatter: function (params) {
                    return $filter('date')(params.value, 'dd/MM/yyyy');
                },
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'EXPENSE_SETTLEMENTS.PETTY_CASH.DUEDATE',
                field: "dueDate",
                headerCellRenderer: getHeader,
                width: 100,
                valueFormatter: function (params) {
                    return $filter('date')(params.value, 'dd/MM/yyyy');
                },
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'EXPENSE_SETTLEMENTS.PETTY_CASH.VALID',
                field: "isValid",
                headerCellRenderer: getHeader,
                width: 80,
                cellRenderer: function renderer(params) {
                    if (params.value) {
                        return '<md-icon md-font-icon="icon-checkbox-marked-circle green-500-fg"></md-icon>';
                    } else {
                        return '<md-icon md-font-icon="icon-cancel red-500-fg"></md-icon>';
                    }
                }
            },
            {
                headerName: 'EXPENSE_SETTLEMENTS.PETTY_CASH.FINALIZED',
                field: "isFinalized",
                headerCellRenderer: getHeader,
                width: 80,
                cellRenderer: function renderer(params) {
                    if (params.value) {
                        return '<md-icon md-font-icon="icon-checkbox-marked-circle green-500-fg"></md-icon>';
                    } else {
                        return '<md-icon md-font-icon="icon-cancel red-500-fg"></md-icon>';
                    }
                }
            },
            {
                headerName: 'EXPENSE_SETTLEMENTS.PETTY_CASH.DEPARTMENT_COSTCENTER',
                field: "department.description",
                headerCellRenderer: getHeader,
                width: 250,
                enableRowGroup: true,
                enablePivot: true,
                cellRenderer: function renderer(params) {
                    return '<div style="width: 100%;">' +
                        '  {{data.department.description}}' +
                        '<br>  {{data.costCenter.description}}' +
                        '</div>';
                }
            },
            {
                headerName: 'EXPENSE_SETTLEMENTS.PETTY_CASH.DEPOSIT_REFERENCE',
                field: "wireTransferReference",
                headerCellRenderer: getHeader,
                width: 100,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'ORDER.ACTIONS',
                name: "actions",
                headerCellRenderer: getHeader,
                suppressSorting: true,
                suppressMenu: true,
                width: 150,
                cellRenderer: function renderer(params) {
                    return '<div style="width: 100%;">'
                        + ' <md-button ng-if="data.isFinalized && !data.wireTransferReference" '
                        + ' class="edit-button md-icon-button" ng - click="vm.createBankDeposit(data)" aria - label="pettyCash"'
                        + ' translate translate-attr-aria-label="EXPENSE_SETTLEMENTS.PETTY_CASH.REFUND_AMOUNT">'
                        + ' <md-tooltip md-direction="bottom">'
                        + ' {{"EXPENSE_SETTLEMENTS.PETTY_CASH.REFUND_AMOUNT"| translate}}'
                        + ' </md-tooltip>'
                        + '  <md-icon md-font-icon="icon-cash-multiple" class="s16"></md-icon> '
                        + ' </md-button>'
                        + ' </div>';
                },
                cellStyle: { 'padding': '0px' },
                pinned: "right"
            }
        ];

        vm.masterGridOptions = {
            columnDefs: vm.masterColumnDefs,
            enableSorting: true,
            debug: false,
            enableFilter: true,
            enableColResize: true,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowData: null,
            groupHeaders: true,
            headerHeight: 50,
            rowHeight: 45,
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            },
            doesDataFlower: function (dataItem) {
                return true;
            },
            isExternalFilterPresent: isExternalFilterPresent,
            doesExternalFilterPass: doesExternalFilterPass
        };

        var filter = 'everyone';

        function isExternalFilterPresent() {
            return filter !== '';
        }

        function doesExternalFilterPass(node) {
            if (filter && filter !== 'everyone') {
                var arrdt = node.data.filter.split(filter);
                return arrdt.length > 1;
            }
            return true;
        }

        $scope.$watch('vm.search',
            function (newValue) {
                filter = newValue ? newValue.toLowerCase() : 'everyone';
                vm.masterGridOptions.api.onFilterChanged();
            }
        );


        //Methods
        init();

        ////////
        function init() {
            $rootScope.loadingProgress = true;
            api.ComprasWS.pettyCashWithAmountToReturn.query({ idCircle: $rootScope.bsCircle.id }).$promise.then(function (data) {
                $log.debug("data:");
                $log.debug(data);
                vm.pettyCashes = new jinqJs()
                    .from(data).
                    select(function (r) {
                        var d = r;
                        d.filter = (d.id + "," + d.name + ","
                            + d.pettyCashType.description + "," + d.department.description + "," + d.costCenter.description).toLowerCase();
                        return d;
                    });
                $rootScope.loadingProgress = false;
                $log.debug(data);
                $timeout(function () {
                    getDimensionCompany();
                    vm.masterGridOptions.api.setColumnDefs(vm.masterColumnDefs);
                    vm.masterGridOptions.api.setRowData(data);
                }, FOUR_HUNDRED_TIME_OUT);

            }, function (error) {
                $rootScope.loadingProgress = false;
                $log.error(error.data);
            });

        }

        vm.createBankDeposit = function (data) {
            $mdDialog.show({
                controller: 'createBankDepositeController',
                controllerAs: 'vm',
                locals: {
                    pettyCash: angular.copy(data)
                },
                templateUrl: 'app/main/apps/expenseSettlements/pettyCash/withAmountToReturn/depositEditor/depositEditor.html',
                parent: angular.element("#main"),
                clickOutsideToClose: false
            }).then(function (answer) {
                $log.debug("answer:");
                $log.debug(answer);
                var wireTransfer = answer;

                $rootScope.loadingProgress = true;
                //Solo debo ir a actualizar el numero de referencia de la transaccion
                api.ComprasWS.pettyCashDepositReference.set(
                    { circle: $rootScope.bsCircle.id, id: data.id, reference: wireTransfer.id }, function (response) {// Success
                        init();
                        showMessage($filter('translate')('EXPENSE_SETTLEMENTS.PETTY_CASH.DEPOSIT.OK'));
                        $rootScope.loadingProgress = false;
                    }, function (response) {// Error
                        $rootScope.loadingProgress = false;
                        $log.error(response.data);
                        showErrorMessage($filter('translate')('EXPENSE_SETTLEMENTS.PETTY_CASH.DEPOSIT.ERROR'));
                    });

            }, function () {
                $rootScope.loadingProgress = false;
            });
        };


        function showMessage(message) {
            $rootScope.loadingProgress = false;
            $mdToast.show({
                template: '<md-toast layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
                hideDelay: 3000,
                position: 'top right'
            });
        }


        function showErrorMessage(message) {
            $rootScope.loadingProgress = false;
            $mdToast.show({
                template: '<md-toast layout="column" layout-align="center start"><div class="md-toast-content" style="background-color: red">'
                    + message + '</div></md-toast>',
                hideDelay: 5000,
                position: 'top right'
            });
        }

        function getDimensionCompany() {
            const NUMBER_DIMENSION_THREE = 3;
            const NUMBER_DIMENSION_FOUR = 4;
            const NUMBER_DIMENSION_FIVE = 5;
            api.GeneralWS.DimensionCompany.byCompany.getList(
                { 'company': $rootScope.bsCircle.company.id }
            ).$promise.then(function (responseDimension) {
              responseDimension.sort(function (a, b) {
                return a.dimensionNumber - b.dimensionNumber;
              });
                for (let i = 0; i < responseDimension.length; i++) {
                    if (responseDimension[i].dimensionNumber === NUMBER_DIMENSION_THREE) {
                        vm.dimensionCompanyDetail3 = responseDimension[i];
                        addMasterColumnDefs(responseDimension[i].description, 'dimensionCompanyDetail3Name', responseDimension[i].dimensionNumber);
                    } else if (responseDimension[i].dimensionNumber === NUMBER_DIMENSION_FOUR) {
                        vm.dimensionCompanyDetail4 = responseDimension[i];
                        addMasterColumnDefs(responseDimension[i].description, 'dimensionCompanyDetail4Name', responseDimension[i].dimensionNumber);
                    } else if (responseDimension[i].dimensionNumber === NUMBER_DIMENSION_FIVE) {
                        vm.dimensionCompanyDetail5 = responseDimension[i];
                        addMasterColumnDefs(responseDimension[i].description, 'dimensionCompanyDetail5Name', responseDimension[i].dimensionNumber);
                    } else {
                        vm.dimensionCompanyDetail1 = responseDimension[i];
                    }
                }
                vm.masterGridOptions.api.setColumnDefs(vm.masterColumnDefs);
            });
        }

        function addMasterColumnDefs(name, fieldName, number) {
            const NUMBER_NINE_COLUMN_ADD = 9;
            vm.masterColumnDefs.splice((number + NUMBER_NINE_COLUMN_ADD), 0, {
                headerName: name,
                field: fieldName,
                headerCellRenderer: getHeader,
                width: 200,
                enableRowGroup: true,
                filter: 'text',
                enablePivot: true
            });
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.expenseSettlement.pettyCash')
        .controller('pettyCashEditorController', PettyCashEditorController);

    /** @ngInject */
    function PettyCashEditorController(api, $log, $state, $rootScope, $timeout, $mdToast, $filter, $stateParams, $scope) {
        var vm = this;

        document.addEventListener("mousewheel", function (event) {
            if (document.activeElement.type === "number") {
                document.activeElement.blur();
            }
        });
        vm.isReport = $stateParams.isReport;


        //Data
        var isNew = true;

        //Methods
        vm.closeThread = closeThread;
        vm.saveModel = saveModel;
        vm.costCenter = costCenter;
        vm.department = department;
        vm.user = user;
        vm.minDate = correctDate(new Date());
        vm.pettyCash = {};
        vm.pettyCash.startDate = new Date();
        vm.pettyCash.dueDate = new Date();

        vm.dimensionCompanyDetail3 = null;
        vm.dimensionCompanyDetail4 = null;
        vm.dimensionCompanyDetail5 = null;

        vm.searchDimensionCompanyDetail3 = '';
        vm.searchDimensionCompanyDetail4 = '';
        vm.searchDimensionCompanyDetail5 = '';

        vm.dimensionCompanyDetail3List = [];
        vm.dimensionCompanyDetail4List = [];
        vm.dimensionCompanyDetail5List = [];

        vm.loadingdimensionCompanyDetail3List = false;
        vm.loadingdimensionCompanyDetail4List = false;
        vm.loadingdimensionCompanyDetail5List = false;

        vm.NUMBER_THREE = 3;
        vm.NUMBER_FOUR = 4;
        vm.NUMBER_FIVE = 5;

        $scope.$watch('vm.pettyCash.company.id', function (companyId) {
            if (companyId) {
                costCenter(companyId);
                department(companyId);
                project(companyId);
                user(companyId);
                getDimensionCompany(companyId);
            }
        });

        $scope.$watch('vm.pettyCash.pettyCashType.id', function (newVal) {
            if (newVal) {
              $timeout(function (){
                vm.pettyCashTypeSelected = $filter('filter')(vm.pettyCashType, { id: newVal }, 'strict')[0];
                vm.requirePolicyAndContainer = vm.pettyCashTypeSelected.name === 'IMPORT';
              },200);
            }
        });


        vm.clearSearchPettyCashType = function () {
            vm.searchPettyCashType = "";
        };

        vm.clearSearchCompany = function () {
            vm.searchCompany = "";
        };

        vm.clearSearchCostCenter = function () {
            vm.searchCostCenter = "";
        };
        vm.clearSearchDepartment = function () {
            vm.searchDepartment = "";
        };
        vm.clearSearchProject = function () {
            vm.searchProject = "";
        };
        vm.clearSearchHolder = function () {
            vm.searchHolder = "";
        };

        $timeout(function () {
            var keyEvent = function (event) {
                event.stopPropagation();
            };
            var searchPettyCashTypeInput = document.querySelector("#pettyCashType");
            var searchCompanyInput = document.querySelector("#company");
            var searchCostCenterInput = document.querySelector("#costCenter");
            var searchDepartmentInput = document.querySelector("#department");
            var searchProjectInput = document.querySelector("#project");
            var searchHolderInput = document.querySelector("#holder");

            if (searchPettyCashTypeInput) {
                searchPettyCashTypeInput.addEventListener("keydown", keyEvent);
            }
            if (searchCompanyInput) {
                searchCompanyInput.addEventListener("keydown", keyEvent);
            }
            if (searchCostCenterInput) {
                searchCostCenterInput.addEventListener("keydown", keyEvent);
            }
            if (searchDepartmentInput) {
                searchDepartmentInput.addEventListener("keydown", keyEvent);
            }
            if (searchProjectInput) {
                searchProjectInput.addEventListener("keydown", keyEvent);
            }
            if (searchHolderInput) {
                searchHolderInput.addEventListener("keydown", keyEvent);
            }
        }, 500);


        init();
        //////////

        function init() {
            $rootScope.loadingProgress = true;
            api.GeneralWS.getAllCompaniesRolAdmin.query().$promise.then(function (response) {
                vm.companies = response;
                if (vm.companies.length === 1 && !$stateParams.id) {
                    vm.pettyCash.company = vm.companies[0];
                    getDimensionCompany(vm.companies[0]);
                }
                $rootScope.loadingProgress = false;
            }, function (response) {
                $rootScope.loadingProgress = false;
                $log.error(response);
            });

            $rootScope.loadingProgress = true;
            api.ComprasWS.pettyCash.get({ id: $stateParams.id, circle: $rootScope.bsCircle.id }).$promise.then(function (data) {
                data.startDate = correctDate(data.startDate);
                vm.settlementsjson = data;
                vm.minDate = angular.copy(data.startDate);
                data.dueDate = correctDate(data.dueDate);
                $timeout(function () {
                  assignDimensionCompany(data);
                    vm.pettyCash = data;
                    isNew = false;
                    $log.debug(vm.pettyCash.pettyCashType);
                    if (vm.pettyCash.pettyCashType.name === 'IMPORT') {
                        vm.requirePolicyAndContainer = true;
                    }
                    getDimensionCompany(vm.pettyCash.company.id);
                    $rootScope.loadingProgress = false;
                });

            }, function (error) {
                $log.error(error.data);
                $rootScope.loadingProgress = false;
            });

        }


        function costCenter(companyId) {
            if (companyId !== undefined) {
                $rootScope.loadingProgress = true;
                api.GeneralWS.CostCenter.query({ idc: companyId }, function (response) {
                    vm.costCenters = response;
                    if (vm.costCenters.length === 1 && !$stateParams.id) {
                        vm.pettyCash.costCenter = vm.costCenters[0];
                    }
                    let exist = false;
                    for (let i = 0; i < vm.costCenters.length; i++) {
                        if (vm.costCenters[i].id === vm.pettyCash.costCenter.id) {
                            exist = true;
                        }
                    }
                    if (!exist) {
                        vm.costCenters.push(vm.pettyCash.costCenter);
                    }
                    $rootScope.loadingProgress = false;
                }, function (response) {
                    $log.error(response);
                    $rootScope.loadingProgress = false;
                });
            }
        }

        function department(companyId) {
            if (companyId !== undefined) {
                $rootScope.loadingProgress = true;
                api.GeneralWS.Department.query({ idc: companyId }, function (response) {
                    vm.departments = response;
                    if (vm.departments.length === 1 && !$stateParams.id) {
                        vm.pettyCash.department = vm.departments[0];
                    }
                    let exist = false;
                    for (let i = 0; i < vm.departments.length; i++) {
                        if (vm.departments[i].id === vm.pettyCash.department.id) {
                            exist = true;
                        }
                    }
                    if (!exist) {
                        vm.departments.push(vm.pettyCash.department);
                    }
                    $rootScope.loadingProgress = false;
                }, function (response) {
                    $log.error(response);
                    $rootScope.loadingProgress = false;
                });
            }
        }

        function project(companyId) {
            if (companyId !== undefined) {
                $rootScope.loadingProgress = true;
                api.ProyectosWS.getAllActive.query({ companyId: companyId }, function (response) {
                    vm.projects = response;
                    $log.debug("response on project: ");
                    $log.debug(response);
                    $rootScope.loadingProgress = false;
                }, function (response) {
                    $log.error(response);
                    $rootScope.loadingProgress = false;
                });
            }
        }

        vm.pettyCashType = [];
        $rootScope.loadingProgress = true;
        api.ComprasWS.pettyCashType.query({}, function (response) {
            vm.pettyCashType = response;
            $rootScope.loadingProgress = false;
        }, function (response) {
            $log.error(response);
            $rootScope.loadingProgress = false;
        });

        function correctDate(date) {
            $log.debug("date:");
            $log.debug(date);
            if (date) {
                date = new Date(date);
                date.setHours(0);
                date.setMinutes(0);
                date.setSeconds(0);
                return date;
            } else {
                return "yyyy-MM-dd";
            }
        }

        function user(companyId) {
            if (companyId !== undefined) {
                $rootScope.loadingProgress = true;
                api.GeneralWS.getAllCompaniesRol.query({ idc: companyId }, function (response) {
                    vm.users = response;
                    if (vm.users.length === 1 && !$stateParams.id) {
                        vm.pettyCash.holder = vm.users[0];
                    }
                    $rootScope.loadingProgress = false;
                }, function (response) {
                    $log.error(response);
                    $rootScope.loadingProgress = false;
                });
            }
        }

        function validValue(value) {
            return (value !== null && value !== undefined & value !== '');
        }

        function saveModel() {
            vm.amountRequired = false;
            $rootScope.loadingProgress = true;
            var pettyType = _.find(vm.pettyCashType, function (type) {
                return type.id === vm.pettyCash.pettyCashType.id;
            });
            if (pettyType.requiredMaxAmount && !validValue(vm.pettyCash.amount)) {
                vm.amountRequired = true;
                showErrorMessage($filter('translate')('EXPENSE_SETTLEMENTS.PETTY_CASH.AMOUNT_IS_REQUIRED'));
            } else {
                var promise;
                if (vm.requirePolicyAndContainer && (!validValue(vm.pettyCash.importDocument) || !validValue(vm.pettyCash.container))) {
                    showErrorMessage($filter('translate')('EXPENSE_SETTLEMENTS.PETTY_CASH.IMPORT_DOCUMENT_REQUIRED'));
                } else {

                    if (vm.pettyCash.project && vm.pettyCash.projectId) {
                        vm.pettyCash.project = { id: vm.pettyCash.projectId };
                    }
                    $log.debug("vm.pettyCash:");
                    $log.debug(vm.pettyCash);
                    if (isNew) {
                        promise = api.ComprasWS.pettyCash.save({ id: null, circle: $rootScope.bsCircle.id }, vm.pettyCash).$promise;
                    } else {
                        promise = api.ComprasWS.pettyCash.update({ circle: $rootScope.bsCircle.id, id: $stateParams.id }, vm.pettyCash).$promise;
                    }
                    promise.then(function (data) {
                        showMessage($filter('translate')('EXPENSE_SETTLEMENTS.PETTY_CASH.CAJA_GUARDADA_EXITOSAMENTE'));
                        $state.go('app.expenseSettlement.pettyCash.pettyCash');
                        $rootScope.loadingProgress = false;
                    }, function (err) {
                        var msg = $filter('translate')('EXPENSE_SETTLEMENTS.PETTY_CASH.CAJA_ERROR');
                        if (err.data === 'Amount') {
                            msg = $filter('translate')('EXPENSE_SETTLEMENTS.PETTY_CASH.AMOUNT_IS_REQUIRED');
                        }
                        if (err.data === 'PettyCashForHolderExist') {
                            msg = $filter('translate')('EXPENSE_SETTLEMENTS.PETTY_CASH.USERCOSTCENTERANDDEPARTMENT');
                        }
                        if (err.data === 'AMOUNT_GREATER_THAN_MAXAMOUNT_BY_PETTYCASH') {
                            msg = $filter('translate')('EXPENSE_SETTLEMENTS.PETTY_CASH.AMOUNT_GREATER_THAN_MAXAMOUNT_BY_PETTYCASH');
                        }
                        showErrorMessage(msg);
                        $rootScope.loadingProgress = false;
                    });
                }
            }
        }

        function closeThread() {
            $rootScope.snThread = false;
            $state.go('app.expenseSettlement.pettyCash.pettyCash');
        }

        function showMessage(message) {
            $rootScope.loadingProgress = false;
            $mdToast.show({
                template: '<md-toast layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
                hideDelay: 3000,
                position: 'top right'
            });
        }

        function showErrorMessage(message) {
            $rootScope.loadingProgress = false;
            $mdToast.show({
                template: '<md-toast layout="column" layout-align="center start"><div class="md-toast-content" style="background-color: red">'
                    + message + '</div></md-toast>',
                hideDelay: 5000,
                position: 'top right'
            });
        }

      function getDimensionCompany(companyId) {
        api.GeneralWS.Usr.User.basicUserInformation.get().$promise.then(function (usr) {
          api.UserWS.UserDimension.ByUser.get({'userId': usr.userId}).$promise.then(function (userList) {
            vm.userDimensionCompanyDetails = userList;
            vm.loadingdimensionCompanyDetail3List = true;
            vm.loadingdimensionCompanyDetail4List = true;
            vm.loadingdimensionCompanyDetail5List = true;
            vm.dimensionCompanyDetail3 = null;
            vm.dimensionCompanyDetail4 = null;
            vm.dimensionCompanyDetail5 = null;
            vm.dimensionCompanyDetail3List = [];
            vm.dimensionCompanyDetail4List = [];
            vm.dimensionCompanyDetail5List = [];
            api.GeneralWS.DimensionCompany.byCompany.getList(
              {'company': companyId}
            ).$promise.then(function (responseDimension) {
              responseDimension.sort(function (a, b) {
                return a.dimensionNumber - b.dimensionNumber;
              });
              for (let i = 0; i < responseDimension.length; i++) {
                if (responseDimension[i].dimensionNumber === vm.NUMBER_THREE) {
                  vm.dimensionCompanyDetail3 = responseDimension[i];
                  getDimensionCompanyDetail(responseDimension[i].id, responseDimension[i].dimensionNumber);
                } else if (responseDimension[i].dimensionNumber === vm.NUMBER_FOUR) {
                  vm.dimensionCompanyDetail4 = responseDimension[i];
                  getDimensionCompanyDetail(responseDimension[i].id, responseDimension[i].dimensionNumber);
                } else if (responseDimension[i].dimensionNumber === vm.NUMBER_FIVE) {
                  vm.dimensionCompanyDetail5 = responseDimension[i];
                  getDimensionCompanyDetail(responseDimension[i].id, responseDimension[i].dimensionNumber);
                } else {
                  vm.dimensionCompanyDetail1 = responseDimension[i];
                }
              }
              if (responseDimension.length === 0) {
                vm.pettyCash.dimensionCompanyDetail3 = null;
                vm.pettyCash.dimensionCompanyDetail4 = null;
                vm.pettyCash.dimensionCompanyDetail5 = null;
              }
            }, function (err) {
              if (err) {
                vm.loadingdimensionCompanyDetail3List = false;
                vm.loadingdimensionCompanyDetail4List = false;
                vm.loadingdimensionCompanyDetail5List = false;
              }
            });
          }, function (errorUser) {
            $log.debug(errorUser);
          });
        }, function (err) {
          $log.debug(err);
        });
      }

        function getDimensionCompanyDetail(id, number) {
            api.GeneralWS.DimensionCompanyDetail.byDimensionCompany.getList(
                { 'dimensionCompanyId': id }
            ).$promise.then(function (responseDimension) {
              const arrIds = vm.userDimensionCompanyDetails.map(function (row) {
                return row.dimensionCompanyDetailId;
              });
                if (number === vm.NUMBER_THREE) {
                    vm.dimensionCompanyDetail3List = getDimensionCompanyDetailListById(responseDimension, arrIds);
                    vm.loadingdimensionCompanyDetail3List = false;
                } else if (number === vm.NUMBER_FOUR) {
                    vm.dimensionCompanyDetail4List = getDimensionCompanyDetailListById(responseDimension, arrIds);
                    vm.loadingdimensionCompanyDetail4List = false;
                } else if (number === vm.NUMBER_FIVE) {
                    vm.dimensionCompanyDetail5List = getDimensionCompanyDetailListById(responseDimension, arrIds);
                    vm.loadingdimensionCompanyDetail5List = false;
                } else {
                    vm.loadingdimensionCompanyDetail1List = false;
                }
            }, function () {
                vm.loadingdimensionCompanyDetail3List = false;
                vm.loadingdimensionCompanyDetail4List = false;
                vm.loadingdimensionCompanyDetail5List = false;
            });
        }

      function getDimensionCompanyDetailListById(responseDimension, arrIds) {
        if (!isNew) {
          return responseDimension.filter(function (item) {
            return arrIds.includes(item.id);
          });
        } else {
          return responseDimension;
        }
      }

      function assignDimensionCompany(data) {
        if (data.dimensionCompanyDetail3) {
          data.dimensionCompanyDetail3.id = data.dimensionCompanyDetail3.id.toString();
        }
        if (data.dimensionCompanyDetail4) {
          data.dimensionCompanyDetail4.id = data.dimensionCompanyDetail4.id.toString();
        }
        if (data.dimensionCompanyDetail5) {
          data.dimensionCompanyDetail5.id = data.dimensionCompanyDetail5.id.toString();
        }
      }

    }
})();

(function () {
    'use strict';
    angular
        .module('app.invoice')
        .controller('WithholdingController', WithholdingController);

    /** @ngInject */
    function WithholdingController($mdDialog, $scope, api, $rootScope, InvoicePurchase, types, $timeout, MessageService, $filter) {
        var vm = this;

        // Data
        vm.invoice = InvoicePurchase;
        vm.withholdingTypes = angular.copy(types);
        vm.canAddBaseAmount = false;

        const TAX_VAT_ID = 2;
        const HUNDRED_VALUE = 100;
        vm.withholdingTypeVatTax = {};
        vm.applyVatWithholding = false;
        vm.calculateVatWithholdingAmount = calculateVatWithholdingAmount;
        processWithholdingTypes();
        function processWithholdingTypes() {
            const typeWithVatTaxIndex = vm.withholdingTypes.findIndex(function(type) {
                return type.countryTax.tax.id === TAX_VAT_ID;
            });
            if (typeWithVatTaxIndex > -1) {
                const typeWithVatTax = vm.withholdingTypes[typeWithVatTaxIndex];
                vm.withholdingTypeVatTax = {
                    typeId: typeWithVatTax.id,
                    rate: typeWithVatTax.rate,
                    baseAmount: vm.invoice.docObj.totalBeforeTax,
                    amount: 0,
                    calculatedAmount: (
                        vm.invoice.docObj.totalBeforeTax * typeWithVatTax.rate
                    ) / HUNDRED_VALUE
                };
                vm.withholdingTypes.splice(typeWithVatTaxIndex, 1);
            }

            if (!vm.withholdingTypeVatTax.typeId
                && vm.withholdingTypes && vm.withholdingTypes.length === 1) {
                vm.withholdingType = { id: vm.withholdingTypes[0].id.toString() };
                changeWithholdingType(vm.withholdingTypes.id);
            }
        }

        // Methods
        vm.closeDialog = closeDialog;
        vm.save = save;

        function closeDialog() {
            $mdDialog.cancel();
        }

        function save() {
            $rootScope.loadingProgress = true;
            if (vm.withholdingType && vm.withholdingType.id) {
                let baseAmount = vm.invoice.docObj.totalBeforeTax;
                if (vm.canAddBaseAmount) {
                    baseAmount = vm.withholdingBaseAmount;
                }
                saveData(vm.withholdingType.id, vm.withholdingRate,
                    vm.withholdingAmount, baseAmount, !vm.applyVatWithholding);
            }
            if (vm.applyVatWithholding) {
                saveData(vm.withholdingTypeVatTax.typeId, vm.withholdingTypeVatTax.rate,
                    vm.withholdingTypeVatTax.amount, vm.withholdingTypeVatTax.baseAmount, true);
            }
        }

        function saveData(withholdingTypeId, withholdingRate, withholdingAmount, withholdingBaseAmount, hideDialog) {
            vm.loading = true;
            api.ComprasWS.InvoicePurchaseWithholding.addNew(
                {
                    id: 'add', idCircle: $rootScope.bsCircle.id, invoicePurchaseId: vm.invoice.docObj.id,
                    typeId: withholdingTypeId, rate: withholdingRate, amount: withholdingAmount,
                    baseAmount: withholdingBaseAmount,
                }).$promise.then(function (response) {
                    vm.loading = false;
                    if (hideDialog) {
                        MessageService.show($filter('translate')('INVOICE.MSG.WITHHOLDING_SUCESSFULLY'));
                        $rootScope.loadingProgress = false;
                        $mdDialog.hide(response);
                    }
                }, function () {
                    vm.loading = false;
                    $rootScope.loadingProgress = false;
                });
        }

        $scope.$watch('vm.withholdingRate', changeWithholdingRate);

        $scope.$watch('vm.withholdingBaseAmount', changeWithholdingRate);

        $scope.$watch('vm.withholdingType.id', changeWithholdingType);

        function changeWithholdingType(nValue) {
            if (!nValue) {
                return;
            }
            var newValue = vm.withholdingTypes.filter(function(fl) {
                return fl.id.toString() === nValue.toString();
            })[0];
            var rate = null;
            vm.canAddBaseAmount = newValue.canAddBaseAmount;
            if (newValue.rate > 0) {
                rate = newValue.rate;
            }
            vm.withholdingType.rate = rate;
            vm.withholdingRate = rate;
            changeWithholdingRate(rate);
        }

        function changeWithholdingRate(newValue) {
            var amountCalc = vm.invoice.docObj.totalBeforeTax;
            if (vm.canAddBaseAmount) {
                amountCalc = vm.withholdingBaseAmount;
            }
            if (amountCalc > 0) {
                vm.withholdingAmount = (amountCalc * vm.withholdingRate) / HUNDRED_VALUE;
            } else {
                vm.withholdingAmount = 0;
            }
        }

        function calculateVatWithholdingAmount() {
            if (vm.applyVatWithholding) {
                vm.withholdingTypeVatTax.amount = vm.withholdingTypeVatTax.calculatedAmount;
            } else {
                vm.withholdingTypeVatTax.amount = 0;
            }
        }

        vm.clearSearchType = function () {
            vm.searchType = "";
        };

        $timeout(function () {

            var keyEvent = function (event) {
                event.stopPropagation();
            };

            var searchTypeInput = document.querySelector("#searchType");

            if (searchTypeInput) {
                searchTypeInput.addEventListener("keydown", keyEvent);
            }

        }, 500);


    }
})();

(function () {
    'use strict';
    angular
        .module('app.invoice')
        .controller('RejectionReasonController', RejectionReasonController);

    /** @ngInject */
    function RejectionReasonController($mdDialog, $timeout) {
        var vm = this;

        // Methods
        vm.closeDialog = closeDialog;
        vm.save = save;

        function closeDialog() {
            $mdDialog.cancel();
        }

        function save() {
            $mdDialog.hide(vm.reason);
        }

        $timeout(function () {

            var keyEvent = function (event) {
                event.stopPropagation();
            };

            var searchTypeInput = document.querySelector("#searchType");

            if (searchTypeInput) {
                searchTypeInput.addEventListener("keydown", keyEvent);
            }

        }, 500);


    }
})();

(function () {
    'use strict';
    angular
        .module('app.invoice')
        .controller('ProvisionInvoiceComposeController', ProvisionInvoiceComposeController);

    /** @ngInject */
    function ProvisionInvoiceComposeController($mdDialog, $log, api, $rootScope, invoice, $mdToast,
        InvoiceWithholdingDetails, InvoiceWithholdingsArr, isSettlement, MessageService, $filter) {
        var vm = this;

        // Data
        vm.invoice = invoice;
        var year = new Date().getFullYear();
        vm.minDate = new Date(year - 1, new Date().getMonth(), new Date().getDate());
        vm.maxDate = new Date();
        vm.isSettlement = isSettlement;
        vm.invoice.dateInvoiceAccounting = getDateInitializer();
        vm.codeWithholding = '';
        vm.InvoiceWithholdingsArr = InvoiceWithholdingsArr;
        vm.getData = getData;

        // Methods
        vm.closeDialog = closeDialog;
        vm.setStatusInvoice = setStatusInvoice;
        vm.InvoiceWithholdingDetails = InvoiceWithholdingDetails;
        vm.saveWithholding = saveWithholding;
        vm.filesToUpload = [];
        vm.URLPHOTOS = api.baseUrlPhotos;
        verifyFile(false);
        vm.height = vm.InvoiceWithholdingsArr.length > 0 ? "95%" : "60%";

        //////////

        init();
        /**
         * Initialize
         */
        function init() {
            vm.statusToChange = invoice.purchaseStatus.description;
            getData(vm.InvoiceWithholdingsArr[0]);
        }

      function getDateInitializer() {
        if (vm.isSettlement) {
          var today = new Date();
          today.setHours(0, 0, 0, 0);
          return today;
        }

        const date = vm.invoice.dateInvoicePurchase;
        if (typeof date === 'string') {
          return new Date(date + ' 23:59:59');
        } else {
          return date;
        }
      }

        function closeDialog() {
            $mdDialog.cancel();
        }

        function setStatusInvoice() {
            var statusToChange = vm.statusToChange === 'Pendiente Recibir Original' ? "Provisionada" : 'Pendiente Recibir Original';
            if (vm.statusToChange === 'Emitida' &&
                ((vm.invoice.invoiceSerie && vm.invoice.invoiceSerie.electronicInvoice) || vm.invoice.uuid != null)
            ) {
                statusToChange = "Provisionada";
            }
            vm.invoice.dateInvoiceAccounting = new Date(vm.invoice.dateInvoiceAccounting.setHours(0, 0, 0, 0));
            $rootScope.loadingProgress = true;

          var localInvoice = vm.invoice;
          localInvoice.id = vm.invoice.id;
          localInvoice.dateInvoiceAccounting = vm.invoice.dateInvoiceAccounting;
          if (localInvoice.invoiceSerie){
            localInvoice.invoiceSerie = { id: localInvoice.invoiceSerie.id };
          }

            api.ComprasWS.InvoicePurchase.setStatus(
                { id: 'changeStatus', idCircle: $rootScope.bsCircle.id, status: statusToChange }, localInvoice).$promise.then(function (response) {
                    $mdToast.show({
                        template: '<md-toast layout="column" layout-align="center start">'
                            + ' <div class="md-toast-content" translate="INVOICE.MSG.STATUS_CHANGE_SUCCESS"></div></md-toast>',
                        hideDelay: 3000,
                        position: 'top right'
                    });
                    $rootScope.loadingProgress = false;
                    $mdDialog.hide(true);
                }, function (response) {
                    $rootScope.loadingProgress = false;
                    $log.error(response);

                    var err = 'ORDER.MSG.ERROR';
                    if (response.data && response.data.mensaje) {
                        err = response.data.mensaje;
                    }

                    MessageService.showErrorMessage($filter('translate')(err));

                });
        }

        function getData(data) {
            if (data) {
                vm.filesToUpload = [];
                vm.invoicePurchaseWithholding = data;
                vm.showGrid = true;
            }
        }

        function saveWithholding() {
            if (vm.invoicePurchaseWithholding && vm.invoicePurchaseWithholding.codeWithholding && vm.filesToUpload.length > 0) {
                var files = [];

                vm.filesToUpload.forEach(function (r) {
                    files.push(r.file.file);
                });

                $rootScope.loadingProgress = true;
                api.GeneralWS.Common.FileStorage.filesUpload.add({ 'companyId': vm.invoice.companyProvider.id }, files).then(function (response) {
                    $rootScope.loadingProgress = false;
                    vm.invoicePurchaseWithholding.fileWithholding = response.data[0];
                    if (vm.invoicePurchaseWithholding.fileWithholding) {
                        api.ComprasWS.InvoicePurchaseWithholding.setFileWithholding(
                            { id: 'setFileWithholding', invoicePurchaseId: vm.invoice.id, idCircle: $rootScope.bsCircle.id },
                            vm.invoicePurchaseWithholding).$promise.then(function (data) {
                                vm.invoicePurchaseWithholding = data;
                                verifyFile(true);
                                vm.filesToUpload = [];
                                MessageService.show($filter('translate')('INVOICE.MSG.FILE_WITHHOLDING_UPDATED'));
                            }, function (errResponse) {
                                $log.debug(errResponse);
                            });
                    } else {
                        MessageService.showErrorMessage($filter('translate')('INVOICE.MSG.ERROR_TO_SAVE'));
                    }
                }, function (errResponse) {
                    $log.error(errResponse);
                    $rootScope.loadingProgress = false;
                });
            } else if (vm.contentFile) {
                verifyFile(true);
            }
        }

        function verifyFile(save) {
            vm.contentFile = true;
            vm.InvoiceWithholdingsArr.forEach(function (inf) {
                if (!inf.fileWithholding || !vm.invoice.dateInvoiceAccounting) {
                    vm.contentFile = false;
                }
            });
            if (vm.contentFile && vm.invoice.dateInvoiceAccounting && save) {
                setStatusInvoice();
            }
        }



    }
})();

(function () {
    'use strict';
    angular
        .module('app.invoice')
        .controller('VerificationInvoiceComposeController', VerificationInvoiceComposeController);

    /** @ngInject */
    function VerificationInvoiceComposeController($mdDialog, $state, $log, api, settlement, detail, $rootScope, $mdToast, $scope, $filter) {
        var vm = this;

        vm.settlement = settlement;
        vm.detail = detail;
        var year = new Date().getFullYear();
        vm.minDate = new Date(year - 1, new Date().getMonth(), new Date().getDate());
        vm.maxDate = new Date();
        vm.codeWithholding = '';

        vm.provisionSettlement = provisionSettlement;
        vm.closeDialog = closeDialog;
        vm.setFile = setFile;

        init();
        function init() {
            var docArray = [];

            if (vm.detail.createdBy) {
                vm.invoice = vm.detail;

            } else {
                vm.detail.forEach(function (detail) {
                    if (detail.invoicePurchase && detail.invoicePurchase !== null) { //invoice
                        docArray.push(
                            {
                                docType: "invoice", //invoice=facturas, receipt=recibos
                                docObj: detail.invoicePurchase, //objeto invoicePurchase
                                detailId: detail.id
                            }
                        );
                        vm.invoice = detail.invoicePurchase;

                    }
                    if (detail.paymentReceipt && detail.paymentReceipt !== null) { //receipt
                        docArray.push(
                            {
                                docType: "receipt",
                                docObj: detail.paymentReceipt,
                                detailId: detail.id
                            }
                        );
                        vm.invoice = detail.paymentReceipt;

                    }

                });

            }

            var today = new Date();
            today.setHours(0, 0, 0, 0);
            vm.invoice.dateInvoiceAccounting = today;

            $scope.$watch(' vm.invoice.dateInvoiceAccounting', function (date) {
                vm.dateAccounting = date;
            });

        }

        //////////
        //cambiar estado

        function provisionSettlement() {
            var dateAccounting = new Date(vm.dateAccounting);
            dateAccounting = dateAccounting.getFullYear() + '-' + (dateAccounting.getMonth() + 1) + '-' + dateAccounting.getDate();

            if (vm.invoice.invoicePurchase !== null) {
                $rootScope.loadingProgress = true;
                api.ComprasWS.Settlement.provisionSettlement.Provision(
                    { settlementId: vm.settlement.id, idCircle: $rootScope.bsCircle.id, dateAccounting: dateAccounting }, function (response) {
                        vm.settlement = response;
                        showMessage($filter('translate')('SETTLEMENT.SETTLEMENT_VERIFIED'));
                        showPDF(vm.settlement);
                        $rootScope.loadingProgress = false;
                        $mdDialog.hide(vm.settlement);
                    }, function (error) {
                        $rootScope.loadingProgress = false;
                        if (error.data && error.data.mensaje === 'Settlement details not found') {
                            showErrorMessage($filter('translate')('SETTLEMENT.CAN_NOT_VALIDATE_SETTLEMENT'));
                        } else {
                            if (error.data && error.data.mensaje) {
                                showErrorMessage(error.data.mensaje);
                            }
                            else {
                                showErrorMessage($filter('translate')('SETTLEMENT.SETTLEMENT_VERIFIED_ERROR'));
                            }
                        }
                        $log.error(error.data);
                      $mdDialog.cancel(error);
                    });
            } else {
                $rootScope.loadingProgress = true;
                api.ComprasWS.SettlementDetails.AuthorizeDetail.authorize({ id: detail.id, circleId: $rootScope.bsCircle.id }).$promise.then(function (response) {
                    vm.settlementDetail = response;
                    $log.debug("settlementDetail:");
                    $log.debug(vm.settlementDetail);

                    vm.currentDoc.docObj = vm.settlementDetail.paymentReceipt;
                    vm.docArray[vm.currentIndex].docObj = vm.settlementDetail.paymentReceipt;

                    $rootScope.loadingProgress = false;
                    showMessage($filter('translate')('SETTLEMENT.DOCUMENT.AUTHORIZE_SUCCESSFULLY'));
                    vm.changeNextDoc();

                }, function (error) {
                    $rootScope.loadingProgress = false;
                    showErrorMessage($filter('translate')('SETTLEMENT.DOCUMENT.ERROR_AUTHORIZE'));
                    $log.error(error.data);
                    $mdDialog.cancel(error);
                });

            }

        }

        function showPDF(settlement) {

            var urlRpt = $rootScope.getParameterValue('JASPER_URL_SETTLEMENT_INVOICE_RECEIPT').replace('[ID]', settlement.id);

            $mdDialog.show({
                controller: 'ReportShowPDFController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/reports/dialogs/show-pdf/show-pdf.html',
                parent: angular.element("#main"),
                locals: {
                    Url: urlRpt
                },
                clickOutsideToClose: false,
                fullscreen: true
            }).then(function (answer) {
                $state.go('app.expenseSettlement.verificationSettlements');

            }, function () {
                $state.go('app.expenseSettlement.verificationSettlements');

            });
        }

        //Adjuntar archivo de retención de impuestos
        function setFile() {
            if (vm.filesToUpload && vm.filesToUpload.length > 0) {
                var files = [];

                vm.filesToUpload.forEach(function (r) {
                    files.push(r.file.file);
                });

                $rootScope.loadingProgress = true;
                vm.invoicePurchaseWithholding = { invoicePurchase: vm.invoice };
                api.GeneralWS.Common.FileStorage.filesUpload.add({ 'companyId': $rootScope.bsCircle.company.id }, files).then(function (response) {
                    $rootScope.loadingProgress = false;
                    vm.invoicePurchaseWithholding.fileWithholding = response.data[0];
                    vm.invoicePurchaseWithholding.codeWithholding = vm.codeWithholding;
                    api.ComprasWS.InvoicePurchaseWithholding.setFileWithholding(
                        {
                            id: 'setFileWithholding',
                            invoicePurchaseId: vm.invoice.id, idCircle: $rootScope.bsCircle.id
                        }, vm.invoicePurchaseWithholding).$promise.then(function (data) {
                            vm.invoicePurchaseWithholding = data;
                        }, function (errResponse) {
                            $log.debug(errResponse);
                        });
                }, function (errResponse) {
                    $log.error(errResponse);
                    $rootScope.loadingProgress = false;
                });

            }
        }

        function showMessage(message) {
            $rootScope.loadingProgress = false;
            $mdToast.show({
                template: '<md-toast layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
                hideDelay: 3000,
                position: 'top right'
            });
        }

        function showErrorMessage(message) {
            $rootScope.loadingProgress = false;
            $mdToast.show({
                template: '<md-toast layout="column" layout-align="center start"><div class="md-toast-content" style="background-color: red">'
                    + message + '</div></md-toast>',
                hideDelay: 5000,
                position: 'top right'
            });
        }

        function closeDialog() {
            $mdDialog.cancel();
        }


    }
})();

(function () {
    'use strict';

    angular
        .module('app.contract', [
            'flow',
            'wipImageZoom'
        ]).config(config);


    /** @ngInject **/
    function config($stateProvider, $translatePartialLoaderProvider) {
        // Navigation
        $stateProvider
            .state('app.contract', {
                url: '/contract',
                abstract: true
            })
            .state('app.contract.Creando', {
                url: '/1',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/contract/contracts.html',
                        controller: 'ContractsController as vm'
                    }
                },
                params: {
                    status: 'Creando'
                },
                bodyClass: 'e-commerce'
            })
            .state('app.contract.Ingresado', {
                url: '/2',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/contract/contracts.html',
                        controller: 'ContractsController as vm'
                    }
                },
                params: {
                    status: 'Ingresado'
                },
                bodyClass: 'e-commerce'
            })
            .state('app.contract.Autorizado', {
                url: '/3',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/contract/contracts.html',
                        controller: 'ContractsController as vm'
                    }
                },
                params: {
                    status: 'Autorizado',
                    isProvider: false
                },
                bodyClass: 'e-commerce'
            })
            .state('app.contract.Provider', {
                url: '/contractP',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/contract/contracts.html',
                        controller: 'ContractsController as vm'
                    }
                },
                bodyClass: 'e-commerce'
            })
            .state('app.contract.Creando.detail', {
                url: '/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/contract/contract/contract.html',
                        controller: 'ContractController as vm'
                    }
                },
                bodyClass: 'e-commerce'
            })
            .state('app.contract.Ingresado.detail', {
                url: '/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/contract/contract/contract_Autorize.html',
                        controller: 'ContractController as vm'
                    }
                },
                params: {
                    backTo: null,
                    filter: null,
                    onlyView: true
                },
                bodyClass: 'e-commerce'
            })
            .state('app.contract.Autorizado.detail', {
                url: '/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/contract/contract/contract_view.html',
                        controller: 'ContractController as vm'
                    }
                },
                params: {
                    backTo: null,
                    filter: null,
                    onlyView: true
                },
                bodyClass: 'e-commerce'
            })
            .state('app.contract.Provider.detail', {
                url: '/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/contract/contract-report/contract-Report.html',
                        controller: 'ReportContractController as vm'
                    }
                },
                params: {
                    backTo: null,
                    filter: null,
                    onlyView: true
                },
                bodyClass: 'e-commerce'
            })
            .state('app.contract.contractReport', {
                url: '/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/contract/contract-report/contract-Report.html',
                        controller: 'ReportContractController as vm'
                    }
                },
                params: {
                    backTo: null,
                    filter: null,
                    onlyView: true
                },
                bodyClass: 'e-commerce'
            })
            ;
        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/contract');
    }

})();


(function () {
    'use strict';
    angular
        .module('app.contract')
        .controller('DetailProductsContractController', DetailProductsContractController);

    /** @ngInject */
    function DetailProductsContractController($mdDialog, contractPurchase, api, $rootScope, $scope, $filter) {
        var vm = this;

        vm.contractPurchase = contractPurchase;
        vm.selectedTab = 0;

        // Data
        vm.masterColumnDefs = [
            {
                headerName: '#',
                field: "id",
                width: 50,
                cellStyle: { 'text-align': 'center' },
                sort: 'asc'
            },
            {
                headerName: 'CONTRACT.QUANTITY',
                field: "quantity",
                headerCellRenderer: getHeader,
                width: 100,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'CONTRACT.PRODUCT',
                field: "product.name",
                headerCellRenderer: getHeader,
                width: 350,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'CONTRACT.TOTAL',
                field: "total",
                headerCellRenderer: getHeader,
                width: 100,
                enableRowGroup: true,
                enablePivot: true,
                cellStyle: { 'text-align': 'right' },
                valueFormatter: function (params) {
                    return $filter('number')(params.value, 2);
                }
            },
            {
                headerName: 'CONTRACT.TAXESINCLUDED',
                field: "taxesIncluded",
                headerCellRenderer: getHeader,
                width: 160,
                enableRowGroup: true,
                enablePivot: true,
                cellStyle: { 'text-align': 'center' },
                cellRenderer: function (params) {
                    if (params.data.taxesIncluded) {
                        return '<md-icon md-font-icon="icon-check" class="s16"></md-icon>';
                    } else {
                        return '<md-icon md-font-icon="icon-close-circle" class="s16"></md-icon>';
                    }
                }
            }
        ];

        vm.masterGridOptions = {
            columnDefs: vm.masterColumnDefs,
            enableSorting: true,
            debug: false,
            enableFilter: true,
            enableColResize: true,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowData: null,
            groupHeaders: true,
            headerHeight: 40,
            rowHeight: 40,
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            },
            doesDataFlower: function (dataItem) {
                return true;
            },
            isExternalFilterPresent: isExternalFilterPresent,
            doesExternalFilterPass: doesExternalFilterPass
        };

        // Data
        var filter = 'everyone';

        function isExternalFilterPresent() {
            return filter !== '';
        }

        function doesExternalFilterPass(node) {
            if (filter && filter !== 'everyone') {
                var arrdt = node.data.filter.split(filter);
                return arrdt.length > 1;
            }
            return true;
        }

        $scope.$watch('vm.search',
            function (newValue) {
                filter = newValue ? newValue.toLowerCase() : 'everyone';
                if (vm.detailsContract) {
                    vm.masterGridOptions.api.onFilterChanged();
                }
            }
        );


        // Methods
        vm.closeDialog = closeDialog;
        init();

        //////////

        function closeDialog() {
            $mdDialog.cancel();
        }

        function init() {
            api.ComprasWS.ContractDetail.getContractPurchase(
                { idCircle: $rootScope.bsCircle.id, id: 'getByContractPurchase', contractId: vm.contractPurchase.id }, function (detailContract) {
                    vm.detailsContract = new jinqJs()
                        .from(detailContract)
                        .select(function (r) {
                            var d = r;
                            d.filter = (d.product.name + "," + d.total + "," + d.taxesIncluded).toLowerCase();
                            return d;
                        });
                    vm.masterGridOptions.api.setRowData(vm.detailsContract);

                }, function (errResponse) {
                });
        }


    }
})();

(function () {
    'use strict';
    angular
        .module('app.contract')
        .controller('DetailContractController', DetailContractController);

    /** @ngInject */
    function DetailContractController($mdDialog, contractPurchase, api, $timeout, $rootScope, $scope, detail, MessageService) {
        var vm = this;


        // Data

        vm.page = 1;
        vm.pageSize = 20;
        var isNew = (detail && detail.id) ? false : true;
        vm.selectedTab = 0;
        vm.contractPurchase = contractPurchase;
        vm.keySelected = '';
        if (isNew) {
            vm.contractPurchaseDetail = {
                taxesIncluded: true,
                contractPurchase: vm.contractPurchase
            };
        } else {
            vm.contractPurchaseDetail = detail
        }
        vm.productType = 'S';
        if (!isNew) {
            vm.selectedTab = 1;
        }
        vm.loading = true;
        getProducts(vm.page);

        // Methods
        vm.closeDialog = closeDialog;
        vm.selectProduct = selectProduct;
        vm.sendDetail = sendDetail;
        vm.getProducts = getProducts;
        vm.isDefaultClass = isDefaultClass;
        vm.selectedProduct = selectedProduct;
        vm.changeFilter = changeFilter;
        vm.activeSearch = activeSearch;

        //////////

        function closeDialog() {
            $mdDialog.cancel();
        }

        $scope.$watch('vm.filterProduct', function (newVal) {
          if (!vm.filterProduct && vm.filterProduct !== '' && vm.filterProduct !== undefined) {
            getProducts(1);
          }
        });

        function changeFilter() {
            if (!vm.filterProduct && vm.filterProduct !== '' && vm.filterProduct !== undefined) {
                getProducts(1);
            }
        }

        function activeSearch() {
            vm.searchMode = true;
            $timeout(function () {
                $('#searchField').focus();
            });
        }

        function selectProduct(product) {
            vm.searchMode = false;
            var change = isNew ? isNew : (detail && detail.product && detail.product.id !== product.id);
            vm.keySelected = '' + product.id + product.company + product.defaultCC + product.buyPrice;
            vm.contractPurchaseDetail.product = {
                id: product.id,
                productCode: product.productCode,
                name: product.name
            };
            if (isNew || change) {
                $timeout(function () {
                    vm.detailForm.$setDirty();
                });
            }
            vm.selectedTab = 1;

        }

        function selectedProduct(p) {
            var key = '' + p.id + p.company + p.defaultCC + p.buyPrice;
            return key === vm.keySelected;
        }

        function isDefaultClass(prod) {
            if (prod.defaultCC) {
              return 'accent-300';
            }
            if (prod.default) {
              return 'green-300';
            }
            return '';
        }

        function getProducts(page) {
            var costCenterId = vm.contractPurchase ? vm.contractPurchase.costCenter.id : null;
            vm.page = page;
            vm.loading = true;
            api.GeneralWS.ProductAll.get({ circle: $rootScope.bsCircle.id, page: page - 1, size: vm.pageSize, filter: vm.filterProduct, costCenterId: costCenterId.toString() },
                function (data) {
                    vm.productos = data;
                    vm.loading = false;
                },
                function (data) {
                    vm.loading = false;
                }
            );
        }

        function sendDetail() {
            if (vm.detailForm.$valid) {
                if (vm.detailForm.$dirty) {
                    vm.loading = true;
                    vm.promise;

                    $rootScope.loadingProgress = true;
                    var promise;
                    if (isNew) {
                        promise = api.ComprasWS.ContractDetail.create({ idCircle: $rootScope.bsCircle.id }, vm.contractPurchaseDetail).$promise;
                    } else {
                        promise = api.ComprasWS.ContractDetail.update(
                            { idCircle: $rootScope.bsCircle.id, id: vm.contractPurchaseDetail.id }, vm.contractPurchaseDetail).$promise;
                    }
                    promise.then(
                        function (data) {
                            $rootScope.loadingProgress = false;
                            data.dateDelivery = new Date(data.dateDelivery);
                            vm.contractPurchaseDetail = data;
                            if (isNew) {
                                if (data.$status === 202) {
                                    MessageService.show('CONTRACT.MSG.CONTRACTIFEXIST');
                                }

                                vm.currentTab = 2;
                                isNew = false;
                            }
                            vm.currentTab = 2;
                            if (isNew) {
                                MessageService.show('CONTRACT.MSG.CREATED');
                            } else {
                                MessageService.show('CONTRACT.MSG.UPDATED');
                            }
                            vm.currentTab = 2;
                            $mdDialog.hide(vm.contractPurchaseDetail);
                        },
                        function (data) {
                            var message;
                            if (data.status === 409) {
                                message = 'BUDGETEXIST';
                            } else {
                                message = 'ERROR';
                            }
                            MessageService.showErrorMessage('CONTRACT.MSG.' + message);
                            $rootScope.loadingProgress = false;
                        }
                    );

                } else {
                    $mdDialog.cancel();
                }
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.configuration')
        .controller('rejectionReasonEditController', rejectionReasonEditController);

    /** @ngInject */
    function rejectionReasonEditController($mdDialog, data, api, rejectionReason, $rootScope, $mdToast, $filter) {
        var vm = this;

        // Data
        vm.isNew = data ? false : true;
        vm.rejectionReason = rejectionReason;

        // Methods
        vm.closeDialog = closeDialog;
        vm.sendForm = sendForm;
        vm.rol = $rootScope.bsCircle.name;

        function sendForm() {
            var promise;
            if (vm.rejectionReason.id === undefined) {
                vm.rejectionReason.isDefinitive = vm.rejectionReason.isDefinitive ? vm.rejectionReason.isDefinitive : false;
                promise = api.ComprasWS.allRejectionReason.save({ id: null, circleId: $rootScope.bsCircle.id }, vm.rejectionReason).$promise;

            } else {
                promise = api.ComprasWS.allRejectionReason.update(
                    { circleId: $rootScope.bsCircle.id, id: vm.rejectionReason.id }, vm.rejectionReason).$promise;
            }
            promise.then(function (data) {
                $mdDialog.hide(data);
                showMessage($filter('translate')('REJECTIONREASON.SAVEMESSAGED'));
                vm.loading = false;

            }, function (err) {
                showMessage($filter('translate')('REJECTIONREASON.ERRORMESSAJED'));
            });


        }
        function closeDialog() {
            $mdDialog.cancel();
        }

        function showMessage(message) {
            $rootScope.loadingProgress = false;
            $mdToast.show({
                template: '<md-toast layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
                hideDelay: 3000,
                position: 'top right'
            });
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.configuration')
        .controller('rejectionReasonEditController', rejectionReasonEditController);

    /** @ngInject */
    function rejectionReasonEditController($mdDialog, purchaseProductDelivery, api, $rootScope, $scope, MessageService, $timeout) {
        var vm = this;

        vm.page = 1;
        vm.pageSize = 20;

        var isNew = purchaseProductDelivery ? false : true;
        vm.selectedTab = 0;

        if (!isNew) {
            vm.detail = purchaseProductDelivery;
            if (!vm.detail.product) {
                vm.detail.product = { id: -100 }
            }
            vm.selectedTab = 1;
        } else {
            vm.detail = {
                company: { id: $rootScope.bsCircle.company.id }
            };
        }
        vm.loading = true;
        vm.productos = [];

        // Methods
        vm.closeDialog = closeDialog;
        vm.selectProduct = selectProduct;
        vm.sendDetail = sendDetail;
        vm.getProducts = getProducts;
        vm.changeFilter = changeFilter;
        vm.activeSearch = activeSearch;
        vm.loadDeptosDelivery = loadDeptosDelivery;

        getProducts(vm.page);

        //////////

        function closeDialog() {
            $mdDialog.cancel();
        }

        $scope.$watch('vm.filterProduct', function (newVal) {
            if (newVal && newVal.length > -1) {
                getProducts(1);
            }
        });

        function changeFilter() {
            if (!vm.filterProduct || vm.filterProduct === '') {
                getProducts(1);
            }
        }

        function activeSearch() {
            vm.searchMode = true;
            $timeout(function () {
                $('#searchField').focus();
            });
        }

        function selectProduct(product) {
            vm.searchMode = false;
            var change = isNew ? isNew : (vm.detail.product && product && vm.detail.product.id !== product.id);
            if (product) {
                vm.detail.product = {
                    id: product.id,
                    productCode: product.productCode,
                    name: product.name,
                    brand: product.brand,
                    measurementUnit: product.measurementUnit
                };
            } else {
                vm.detail.product = null;
            }

            vm.selectedTab = 1;
            if (isNew || change) {
                $timeout(function () {
                    vm.detailForm.$setDirty();
                });
            }

        }

        function getProducts(page) {
            vm.page = page;
            vm.loading = true;

            api.GeneralWS.ProductAll.get({ circle: $rootScope.bsCircle.id, page: page - 1, size: vm.pageSize, filter: vm.filterProduct },
                function (data) {
                    vm.productos = data;
                    vm.loading = false;
                },
                function (data) {
                    vm.loading = false;
                }
            );

        }

        function sendDetail() {
            if (vm.detailForm.$valid) {
                if (vm.detailForm.$dirty) {
                    vm.loading = true;
                    vm.promise;
                    if (isNew) {
                        vm.promise = api.ComprasWS.PurchaseProductDelivery.PurchaseProductDelivery.create(
                            { company: $rootScope.bsCircle.company.id, idCircle: $rootScope.bsCircle.id },
                            vm.detail).$promise;
                    } else {
                        vm.promise = api.ComprasWS.PurchaseProductDelivery.PurchaseProductDelivery.update(
                            { company: $rootScope.bsCircle.company.id, id: vm.detail.id, idCircle: $rootScope.bsCircle.id },
                            vm.detail).$promise;
                    }

                    vm.promise.then(
                        function (data) {
                            $mdDialog.hide(data);
                            vm.loading = false;
                        },
                        function (data) {
                            var msg = 'ERROR';
                            if (data.status === 409) {
                                msg = data.data;
                                if (msg === 'Product is exist') {
                                    msg = 'PRODUCT';
                                }
                            }
                            MessageService.show('ORDER.MSG.' + msg);
                            vm.loading = false;
                        }
                    );
                } else {
                    $mdDialog.cancel();
                }
            }
        }

        function loadDeptosAndCC(onInit, companyId) {

            if (!companyId) {
                companyId = $rootScope.bsCircle.company.id;
            }

            vm.loadingDepartments = true;
            var params = { idc: companyId };
            api.GeneralWS.DepartmentCompany.DepartmentByCompany.query(params, function (data) {
                if (data.length === 1 && !vm.detail.department) {
                    vm.detail.department = {
                        id: data[0].id.toString()
                    };
                }

                if (onInit) {
                    if (vm.requisitionForm) {
                        vm.requisitionForm.$setDirty();
                    }
                }

                vm.departments = data;
                vm.loadingDepartments = false;
            });

            vm.loadingCostCenter = true;
            api.GeneralWS.CostCenterCompany.CostCenterByCompany.query(params, function (data) {
                if (data.length === 1 && !vm.detail.costCenter) {
                    vm.detail.costCenter = {
                        id: data[0].id.toString()
                    };
                }
                vm.costCenters = data;
                vm.loadingCostCenter = false;
            });


            vm.loadingCostCenter = true;
            api.GeneralWS.CompanyUser.query(params, function (data) {
                if (data.length === 1 && !vm.companyDelivery) {
                    vm.companyDelivery = {
                        id: data[0].id.toString()
                    };
                }

                if (vm.detail.departmentToDelivery) {
                    vm.companyDelivery = vm.detail.departmentToDelivery.company;
                    loadDeptosDelivery();
                }
                vm.companies = data;
                vm.loadingCostCenter = false;
            });

        }

        loadDeptosAndCC(true, $rootScope.bsCircle.company.id);

        function loadDeptosDelivery() {
            vm.loadingDepartmentsDelivery = true;
            var params = { idc: vm.companyDelivery.id };
            api.GeneralWS.DepartmentCompany.DepartmentByCompany.query(params, function (data) {
                if (data.length === 1 && !vm.detail.departmentDelivery) {
                    vm.detail.departmentDelivery = {
                        id: data[0].id.toString()
                    };
                }

                if (vm.detail.departmentDelivery) {
                    for (var i = 0; i < vm.data.length; i++) {
                        if (vm.data[i].id === vm.detail.departmentDelivery.id) {
                            vm.detail.departmentDelivery = vm.data[i];
                        }
                    }
                }

                vm.departmentsDeliverys = data;
                vm.loadingDepartmentsDelivery = false;
            });
        }

        vm.clearSearchDepartment = function () {
            vm.searchDepartment = "";
        };

        vm.clearSearchCostCenter = function () {
            vm.searchCostCenter = "";
        };

        vm.clearSearchDepartmentDelivery = function () {
            vm.searchDepartmentDelivery = "";
        };

        vm.clearSearchCompanyDelivery = function () {
            vm.searchCompanyDelivery = "";
        };

        $timeout(function () {

            var keyEvent = function (event) {
                event.stopPropagation();
            };

            var searchDepartmentInput = document.querySelector("#searchDepartment");
            var searchCostCenterInput = document.querySelector("#searchCostCenter");
            var searchDepartmentDeliveryInput = document.querySelector("#searchDepartmentDelivery");
            var searchCompanyDeliveryInput = document.querySelector("#searchCompanyDelivery");

            if (searchDepartmentInput) {
                searchDepartmentInput.addEventListener("keydown", keyEvent);
            }

            if (searchCostCenterInput) {
                searchCostCenterInput.addEventListener("keydown", keyEvent);
            }

            if (searchDepartmentDeliveryInput) {
                searchDepartmentDeliveryInput.addEventListener("keydown", keyEvent);
            }

            if (searchCompanyDeliveryInput) {
                searchCompanyDeliveryInput.addEventListener("keydown", keyEvent);
            }
        }, 500);

    }

})();

(function () {
    'use strict';

    angular
        .module('app.configuration')
        .controller('messageDialogController', messageDialogController);

    /** @ngInject */
    function messageDialogController($mdDialog, data, api, obj, $rootScope, MessageService, $timeout) {
        var vm = this;

        var isNew = data ? false : true;

        if (!isNew) {
            vm.purchaseStatusCompany = data;
        }

        vm.loading = true;
        vm.statuses = [];

        // Methods
        vm.closeDialog = closeDialog;
        vm.sendDetail = sendDetail;
        loadStatus();

        function closeDialog() {
            $mdDialog.cancel();
        }

        function loadStatus() {
            vm.loadingStatus = true;
            api.ComprasWS.PurchaseStatus.query({ type: obj.statusType }, function (data) {
                if (data.length === 1) {
                    vm.filter.status = [
                        data[0].id.toString()
                    ];
                }
                if (obj.statusUsed.length > 0) {
                    $timeout(function () {
                        new jinqJs()
                            .from(data)
                            .orderBy([{ field: 'orderColumn', sort: 'asc' }])
                            .select(function (r) {
                                var exist = false;
                                obj.statusUsed.forEach(function (inf) {
                                    if (inf.id === r.id) {
                                        exist = true;
                                    }
                                });
                                if (!exist) {
                                    vm.statuses.push(r);
                                    return r;
                                }
                            });
                        if (!isNew) {
                            vm.statuses = [];
                            vm.statuses.push(vm.purchaseStatusCompany.purchaseStatus);
                        }
                    }, 300);
                } else {
                    vm.statuses = data;
                }
                vm.loadingStatus = false;
            });
        }

        function sendDetail() {
            if (vm.detailForm.$valid) {
                if (vm.detailForm.$dirty) {
                    vm.loading = true;
                    vm.promise;
                    if (isNew) {
                        vm.promise = api.ComprasWS.PurchaseStatusCompany.PurchaseStatusCompanyObj.create(
                            { company: $rootScope.bsCircle.company.id, idCircle: $rootScope.bsCircle.id },
                            vm.purchaseStatusCompany).$promise;
                    } else {
                        vm.promise = api.ComprasWS.PurchaseStatusCompany.PurchaseStatusCompanyObj.update(
                            { company: $rootScope.bsCircle.company.id, id: vm.purchaseStatusCompany.id, idCircle: $rootScope.bsCircle.id },
                            vm.purchaseStatusCompany).$promise;
                    }

                    vm.promise.then(
                        function (data) {
                            $mdDialog.hide(data);
                            vm.loading = false;
                            if (isNew) {
                                MessageService.show("MESSAGE_STATUS.CREATED_SUCCESSFULLY");
                            } else {
                                MessageService.show("MESSAGE_STATUS.UPDATED_SUCCESSFULLY");
                            }
                        },
                        function (data) {
                            var msg = 'ERROR';
                            MessageService.showErrorMessage('ORDER.MSG.' + msg);
                            vm.loading = false;
                        }
                    );
                } else {
                    $mdDialog.cancel();
                }
            }
        }

        vm.clearSearchStatus = function () {
            vm.searchStatus = "";
        };

        $timeout(function () {

            var keyEvent = function (event) {
                event.stopPropagation();
            };

            var searchStatusInput = document.querySelector("#searchStatus");

            if (searchStatusInput) {
                searchStatusInput.addEventListener("keydown", keyEvent);
            }
        }, 500);

    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider, msApiProvider)
    {
        // Translation
        $translatePartialLoaderProvider.addPart('app/quick-panel');

        // Api
    }
})();

(function () {

    'use strict';

    angular
        .module('app.quick-panel')
        .controller('ViewNotificationController', ViewNotificationController);

    function ViewNotificationController($mdDialog, api, notification, notificationIndex, $rootScope, $log, $timeout) {

        var vm = this;
        vm.notification = notification;

        //metodos
        vm.closeDialog = closeDialog;

        function closeDialog() {
            $mdDialog.cancel();
        }

        function markAsRead() {

            var _notificationIdArray = [notification.id];

            $rootScope.loadingProgress = true;
            api.NotificacionesWS.UserNotification.markAsRead.update({ 'circleId': $rootScope.bsCircle.id }, _notificationIdArray).$promise.then(function (response) {
                $rootScope.loadingProgress = false;

                $rootScope.msNotificationArray.splice(notificationIndex, 1);
                $rootScope.totalNumberOfNotifications -= 1;

            }, function (response) {
                $rootScope.loadingProgress = false;
                $log.error(response);
            });

        }

        function init() {
            if (notification.isUserNotification) {
                markAsRead();
            }
        }

        $timeout(init, 1000);

    }

})();

(function () {
    'use strict';

    angular
        .module('app.physicalDocumentDelivery', ['flow'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {
        // State
        $stateProvider
            .state('app.physicalDocumentDelivery', {
                url: '/physicalDocumentDelivery',
                abstract: true
            })
            .state('app.physicalDocumentDelivery.prepareDelivery', {
                url: '/prepareDelivery',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/physicalDocumentDelivery/prepareDelivery/prepareDelivery.html',
                        controller: 'prepareDeliveryController as vm'
                    }
                },
                params: {
                    backTo: null,
                    backState: {},
                    status: "Preparando",
                    id: null
                },
                bodyClass: 'e-commerce'
            })
            .state('app.physicalDocumentDelivery.pendingDelivery', {
                url: '/pendingDelivery',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/physicalDocumentDelivery/pendingDelivery/pendingDelivery.html',
                        controller: 'pendingDeliveryController as vm'
                    }
                },
                params: {
                    backTo: null,
                    backState: {},
                    status: "Lote Revisado",
                    id: null
                },
                bodyClass: 'e-commerce'
            })
            .state('app.physicalDocumentDelivery.pendingDelivery.detail', {
                url: '/Dview',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/physicalDocumentDelivery/view/view.html',
                        controller: 'viewDeliveryController as vm'
                    }
                },
                params: {
                    backTo: null,
                    backState: {},
                    status: "Lote Revisado",
                    title: "Pendiente de Entregar",
                    id: null
                },
                bodyClass: 'e-commerce'
            })
            .state('app.physicalDocumentDelivery.pendingReview', {
                url: '/pendingReview',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/physicalDocumentDelivery/pendingDelivery/pendingDelivery.html',
                        controller: 'pendingDeliveryController as vm'
                    }
                },
                params: {
                    backTo: null,
                    backState: {},
                    status: "Pendientes de Revisar",
                    id: null
                },
                bodyClass: 'e-commerce'
            })
            .state('app.physicalDocumentDelivery.pendingReview.detail', {
                url: '/view',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/physicalDocumentDelivery/view/view.html',
                        controller: 'viewDeliveryController as vm'
                    }
                },
                params: {
                    backTo: null,
                    backState: {},
                    status: "Pendientes de Revisar",
                    title: "Pendientes de Revisar",
                    id: null
                },
                bodyClass: 'e-commerce'
            })
            .state('app.physicalDocumentDelivery.consult.detail', {
                url: '/consultView',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/physicalDocumentDelivery/view/view.html',
                        controller: 'viewDeliveryController as vm'
                    }
                },
                params: {
                    backTo: null,
                    backState: {},
                    status: "",
                    title: "Entrega No.",
                    id: null
                },
                bodyClass: 'e-commerce'
            });


        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/physicalDocumentDelivery');

    }

})();

(function () {
    'use strict';
    angular
        .module('app.physicalDocumentDelivery')
        .controller('pendingDeliveryController', pendingDeliveryController);

    /** @ngInject */
    function pendingDeliveryController($state, api, $log, $rootScope,
        $timeout, $filter, $stateParams, $scope) {
        var vm = this;
        vm.pageSize = 100;
        vm.page = 0;

        vm.masterColumnDefs = [
            {
                headerName: '#',
                field: "id",
                width: 50,
                filter: 'number',
                cellStyle: { 'text-align': 'center' },
                pinned: 'left'
            },
            {
                headerName: 'physicalDocumentDelivery.user',
                field: "user.name",
                headerCellRenderer: getHeader,
                width: 350,
                filter: 'text',
                enableRowGroup: true,
                cellRenderer: function (params) {
                    return '<div>{{data.user.name}} - {{data.user.account}}</div>'
                },
                enablePivot: true
            },
            {
                headerName: 'physicalDocumentDelivery.treasure',
                field: "userTreasurer",
                headerCellRenderer: getHeader,
                width: 350,
                filter: 'text',
                enableRowGroup: true,
                cellRenderer: function (params) {
                    return '<div>{{data.userTreasurer.name}} - {{data.userTreasurer.account}}</div>'
                },
                enablePivot: true
            },
            {
                headerName: 'physicalDocumentDelivery.createdAt',
                field: "createdAt",
                headerCellRenderer: getHeader,
                valueFormatter: function (params) {
                    if (params.value) {
                        return $filter('apiDate')(params.value, 'dd/MM/yyyy HH:mm:ss');
                    }
                },
                enableRowGroup: true,
                filter: 'date',
                enablePivot: true
            },
            {
                headerName: 'REQUISITION.ACTIONS',
                name: "actions",
                headerCellRenderer: getHeader,
                suppressSorting: true,
                suppressMenu: true,
                width: 250,
                cellRenderer: function (params) {
                    return '<div style="width: 100%;">'
                        + '         <md-button class="edit-button md-icon-button"'
                        + ' ng-click="vm.viewDetail($event, data, $index)" '
                        + ' aria-label="Product details"'
                        + ' translate translate-attr-aria-label="physicalDocumentDetail.PRODUCT_DETAILS">'
                        + '     <md-icon md-font-icon="icon-eye" class="s16"></md-icon>'
                        + '     <md-tooltip>'
                        + '         <span translate="physicalDocumentDelivery.viewDetail"></span>'
                        + '     </md-tooltip>'
                        + ' </md-button></div>'
                },
                cellStyle: { 'padding': '0px' },
                pinned: 'right'
            }
        ];

        vm.masterGridOptions = {
            columnDefs: vm.masterColumnDefs,
            enableSorting: true,
            debug: false,
            enableFilter: true,
            enableColResize: true,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowData: null,
            groupHeaders: true,
            headerHeight: 50,
            rowHeight: 40,
            rowSelection: 'multiple',
            rowDeselection: true,
            rowModelType: "enterprise",
            cacheBlockSize: vm.pageSize,
            pagination: true,
            paginationPageSize: vm.pageSize,
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            },
            doesDataFlower: function (dataItem) {
                return true;
            },
            isExternalFilterPresent: isExternalFilterPresent,
            doesExternalFilterPass: doesExternalFilterPass
        };

        vm.masterColumnDefs.forEach(function (d) {
            correctFilterParams(d);
        });

        function correctFilterParams(column) {
            switch (column.filter) {
                case 'number':
                    column.filterParams = {
                        filterOptions: ['equals'],
                        newRowsAction: 'keep'
                    };
                    break;
                case 'text':
                    column.filterParams = {
                        filterOptions: ['contains'],
                        newRowsAction: 'keep'
                    };
                    break;
                case 'date':
                    column.suppressFilter = true;
                    break;
            }
        }

        var filter = '';

        function isExternalFilterPresent() {
            return filter !== '';
        }

        function doesExternalFilterPass(node) {
            if (filter && filter !== 'everyone') {
                var arrdt = node.data.filter.split(filter);
                return arrdt.length > 1;
            }
            return true;
        }

        $scope.$watch('vm.search',
            function (newValue) {
                filter = newValue ? newValue.toLowerCase() : '';
                vm.masterGridOptions.api.onFilterChanged();
            }
        );


        function loadData() {
            var dataSource = {
                paginationPageSize: vm.pageSize,
                getRows: function (params) {
                    var o = params.request.filterModel;
                    var arr = [];
                    if (params.request.filterModel) {
                        arr = $.map(o, function (k, ke, sd, ds) {
                            var on = k;
                            on.field = ke;
                            on.filter = on.filter.toString();
                            return on;
                        });
                    }
                    arr.forEach(function (row, index) {
                        filter = filter + "%" + row.filter;
                    });
                    api.ComprasWS.PhysicalDocumentDelivery.PhysicalDocumentDelivery.page(
                        {
                            'idCircle': $rootScope.bsCircle.id, 'status': $stateParams.status,
                            'search': vm.search, 'pageSize': vm.pageSize,
                            'pageNumber': vm.masterGridOptions.api.paginationGetCurrentPage()
                        }, function (response) {
                            vm.data = new jinqJs()
                                .from(response.content)
                                .orderBy([{ field: 'id', sort: 'asc' }])
                                .select(function (r) {
                                    var d = r;
                                    d.filter = (d.id + "," + d.purchaseStatus.description + "," + d.userTreasurer.name).toLowerCase();
                                    return d;
                                });
                            vm.loading = false;
                            filter = '';
                            $rootScope.loadingProgress = false;
                            params.successCallback(vm.data, response.totalElements);
                            $log.debug(vm.data);
                        }, function (response) {// Error
                            $log.debug(response);
                            vm.loading = false;
                            $rootScope.loadingProgress = false;
                        });
                }
            };
            vm.masterGridOptions.api.setEnterpriseDatasource(dataSource);
        }

        init();

        function init() {
            $timeout(function () {
                loadData();
            }, 200);
        }

        vm.viewDetail = function (ev, data, i) {
            if ($stateParams.status === 'Pendientes de Revisar') {
                $state.go("app.physicalDocumentDelivery.pendingReview.detail", { 'id': data.id, backTo: $state.current.name });
            } else {
                $state.go("app.physicalDocumentDelivery.pendingDelivery.detail", { 'id': data.id, backTo: $state.current.name });
            }

        };



    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core',
            [
                'ngAnimate',
                'ngAria',
                'ngCookies',
                'ngMessages',
                'ngResource',
                'ngSanitize',
                'ngMaterial',
                'pascalprecht.translate',
                'ui.router'
            ]);
})();
(function ()
{
    'use strict';

    angular
            .module('app.core')
            .directive('focusMe', focusMe);

    /** @ngInject */
    function focusMe($timeout, $parse)
    {
        return {
            //scope: true,   // optionally create a child scope
            link: function (scope, element, attrs) {
                var model = $parse(attrs.focusMe);
                scope.$watch(model, function (value) {
                    if (value === true) {
                        $timeout(function () {
                            element[0].focus();
                        });
                    }
                });
                // to address @blesh's comment, set attribute value to 'false'
                // on blur event:
                element.bind('blur', function () {
                    scope.$apply(model.assign(scope, false));
                });
            }
        };
    }
})();
(function () {

    'use strict';

    angular
        .module('app.notifications')
        .controller('MyNotifications', MyNotifications);

    function MyNotifications(api, $log, $timeout, $rootScope) {

        var vm = this;

        vm.filter = {
            filterByDates: false,
            startDate: new Date(),
            endDate: new Date(),
            applications: [],
            companies: []
        };

        vm.showAdvancedFilter = false;
        vm.myNotificationsArray = [];
        vm.selectedNotifications = [];
        vm.pagination = {
            pageNumber: 1,
            pageSize: 100,
            totalElements: 0,
            totalPages: 0,
            numberOfElements: 0,
            nextPage: function () {
                this.pageNumber++;
                getMyNotifications();
            },
            beforePage: function () {
                this.pageNumber--;
                getMyNotifications();
            },
            firstPage: function () {
                this.pageNumber = 1;
                getMyNotifications();
            },
            lastPage: function () {
                this.pageNumber = this.totalPages;
                getMyNotifications();
            }
        };

        //metodos
        vm.toggleSelectNotifications = toggleSelectNotifications;
        vm.isSelectedNotification = isSelectedNotification;
        vm.toggleSelectNotification = toggleSelectNotification;
        vm.showNotification = showNotification;
        vm.markAsRead = markAsRead;
        vm.markAllAsRead = markAllAsRead;
        vm.getMyNotifications = getMyNotifications;

        function showNotification(event, notification) {

            event.stopPropagation();

            if (vm.currentNotification !== null && vm.currentNotification !== undefined && vm.currentNotification.id === notification.id) {
                vm.currentNotification = null;
            } else {
                vm.currentNotification = notification;
                if (!notification.markedAsRead) {
                    var _notificationsArray = [];
                    _notificationsArray.push(notification);
                    markAsRead(_notificationsArray);
                }
            }

        }

        function markAllAsRead() {
            $rootScope.loadingProgress = true;
            api.NotificacionesWS.UserNotification.markAllAsRead.update({ 'circleId': $rootScope.bsCircle.id }).$promise.then(function (response) {
                $rootScope.loadingProgress = false;

                for (var i = 0; i < vm.myNotificationsArray.length; i++) {
                    vm.myNotificationsArray[i].markedAsRead = true;
                }

                $rootScope.msNotificationArray = [];
                $rootScope.totalNumberOfNotifications = 0;

            }, function (response) {
                $rootScope.loadingProgress = false;
                $log.error(response);
            });
        }

        function markAsRead(notificationsArray) {

            var _notificationIdArray = [];

            notificationsArray.forEach(function (row) {
                if (!row.markedAsRead) {
                    _notificationIdArray.push(row.id);
                }
            });

            if (_notificationIdArray.length > 0) {

                $rootScope.loadingProgress = true;
                api.NotificacionesWS.UserNotification.markAsRead.update({ 'circleId': $rootScope.bsCircle.id }, _notificationIdArray).$promise.then(function (response) {
                    $rootScope.loadingProgress = false;

                    for (var i = 0; i < notificationsArray.length; i++) {
                        notificationsArray[i].markedAsRead = true;
                        removeFromUnreadNotificationList(notificationsArray[i]);
                    }

                    if (vm.selectedNotifications.length > 0) {
                        deselectNotifications();
                    }

                }, function (response) {
                    $rootScope.loadingProgress = false;
                    $log.error(response);
                });

            }

        }

        function removeFromUnreadNotificationList(notification) {
            for (var i = 0; i < $rootScope.msNotificationArray.length; i++) {
                if (notification.id === $rootScope.msNotificationArray[i].id && $rootScope.msNotificationArray[i].isUserNotification) {
                    $rootScope.msNotificationArray.splice(i, 1);
                    break;
                }
            }
        }

        function toggleSelectNotification(notification, event) {
            if (event) {
                event.stopPropagation();
            }

            if (vm.selectedNotifications.indexOf(notification) > -1) {
                vm.selectedNotifications.splice(vm.selectedNotifications.indexOf(notification), 1);
            } else {
                vm.selectedNotifications.push(notification);
            }
        }

        function isSelectedNotification(notification) {
            return vm.selectedNotifications.indexOf(notification) > -1;
        }

        function selectNotifications(key, value) {

            vm.selectedNotifications = [];

            for (var i = 0; i < vm.myNotificationsArray.length; i++) {

                if (angular.isUndefined(key) && angular.isUndefined(value)) {
                    vm.selectedNotifications.push(vm.myNotificationsArray[i]);
                    continue;
                }

                if (angular.isDefined(key) && angular.isDefined(value) && vm.myNotificationsArray[i][key] === value) {
                    vm.selectedNotifications.push(vm.myNotificationsArray[i]);
                }

            }

        }

        function deselectNotifications() {
            vm.selectedNotifications = [];
        }

        function toggleSelectNotifications() {
            if (vm.selectedNotifications.length > 0) {
                deselectNotifications();
            } else {
                selectNotifications();
            }
        }

        function getMyNotifications() {
            $rootScope.loadingProgress = true;
            api.NotificacionesWS.UserNotification.myNotifications.page({
                'circleId': $rootScope.bsCircle.id,
                'pageSize': vm.pagination.pageSize,
                'pageNumber': vm.pagination.pageNumber
            },
                vm.filter).$promise.then(function (response) {
                    $rootScope.loadingProgress = false;
                    vm.myNotificationsArray = response.content;
                    vm.pagination.totalElements = response.totalElements;
                    vm.pagination.totalPages = response.totalPages;
                    vm.pagination.numberOfElements = response.numberOfElements;
                }, function (response) {
                    $rootScope.loadingProgress = false;
                    $log.error(response);
                });
        }

        function init() {
            getMyNotifications();
        }

        $timeout(init, 1000);

    }

})();

(function () {

    'use strict';

    angular
        .module('app.notifications')
        .controller('NotificationConfigurationController', NotificationConfigurationController);

    function NotificationConfigurationController($filter, APPNAME, $timeout, api, $rootScope, $log) {

        var vm = this;
        vm.userNotificationConfigArray = [];
        vm.isActiveAll = true;
        vm.isReceiveEmailAll = true;
        vm.isReceiveSmsAll = true;
        vm.isReceiveWebNotificationAll = true;
        vm.applicationsArray = [];

        //configuracion de grid
        vm.gridOptions = {
            columnDefs: [
                {
                    headerName: $filter('translate')('notifications.group'),
                    field: "groupName",
                    width: 175,
                    cellRenderer: 'group'
                },
                {
                    headerName: $filter('translate')('notifications.notification_name'),
                    field: "notificationType.notificationTypeDescription",
                    width: 400
                },
                {
                    suppressMenu: true,
                    suppressSorting: true,
                    headerName: $filter('translate')('general.active'),
                    field: "active",
                    width: 150,
                    cellRenderer: function (params) {
                        params.$scope.node = params.node;
                        return getMdChip("active", "!data.notificationType.userCanDisable && data.id !== -1 && !node.group", "vm.changeActive(data, node)", "data.active");
                    }
                },
                {
                    suppressMenu: true,
                    suppressSorting: true,
                    headerName: $filter('translate')("notifications.can_send_email"),
                    field: "receiveEmail",
                    width: 175,
                    cellRenderer: function (params) {
                        params.$scope.node = params.node;

                        if (params.data.id === -1 || params.node.group) {
                            return getMdChip("Email notifications", "!data.hasActive && (data.id === -1 || node.group)", "vm.changeReceiveEmail(data, node)", "data.receiveEmail");
                        } else if (params.data.notificationType && params.data.notificationType.canSendEmail) {
                            return getMdChip("Email notifications",
                                "(!data.notificationType.userCanDisable || !data.active) && data.id !== -1 && !node.group",
                                "vm.changeReceiveEmail(data, node)",
                                "data.receiveEmail");
                        } else {
                            return '';
                        }

                    }
                },
                {
                    suppressMenu: true,
                    suppressSorting: true,
                    headerName: $filter('translate')("notifications.can_send_sms"),
                    field: "receiveSms",
                    width: 175,
                    cellRenderer: function (params) {
                        params.$scope.node = params.node;

                        if (params.data.id === -1 || params.node.group) {
                            return getMdChip("SMS notifications",
                                "!data.hasActive && (data.id === -1 || node.group)", "vm.changeReceiveSms(data, node)",
                                "data.receiveSms");
                        } else if (params.data.notificationType && params.data.notificationType.canSendSms) {
                            return getMdChip("SMS notifications", "(!data.notificationType.userCanDisable || !data.active) && data.id !== -1 && !node.group",
                                "vm.changeReceiveSms(data, node)",
                                "data.receiveSms");
                        } else {
                            return '';
                        }
                    }
                },
                {
                    suppressMenu: true,
                    suppressSorting: true,
                    headerName: $filter('translate')("notifications.can_send_web_notification"),
                    field: "receiveWebNotification",
                    width: 175,
                    cellRenderer: function (params) {
                        params.$scope.node = params.node;

                        if (params.data.id === -1 || params.node.group) {
                            return getMdChip("Web notifications",
                                "!data.hasActive && (data.id === -1 || node.group)",
                                "vm.changeReceiveWebNotification(data, node)",
                                "data.receiveWebNotification");
                        } else if (params.data.notificationType && params.data.notificationType.canSendWebNotification) {
                            return getMdChip("Web notifications",
                                "(!data.notificationType.userCanDisable || !data.active) && data.id !== -1 && !node.group",
                                "vm.changeReceiveWebNotification(data, node)",
                                "data.receiveWebNotification");
                        } else {
                            return '';
                        }
                    }
                }
            ],
            angularCompileRows: true,
            angularCompileHeaders: true,
            enableColResize: true,
            rowData: [],
            rowHeight: 45,
            getNodeChildDetails: getNodeChildDetails
        };

        //metodos
        vm.updateConfiguration = updateConfiguration;
        vm.changeActive = changeActive;
        vm.changeReceiveEmail = changeReceiveEmail;
        vm.changeReceiveSms = changeReceiveSms;
        vm.changeReceiveWebNotification = changeReceiveWebNotification;
        vm.filterConfigByAppName = filterConfigByAppName;

        function getMdChip(ariaLabel, ngDisabled, ngChange, ngModel) {

            var mdChip = "<div layout='row' layout-align='center center'> "
                + " <md-switch aria-label='[ARIA-LABEL]' ng-disabled='[NG-DISABLED]' ng-change='[NG-CHANGE]' ng-model='[NG-MODEL]'> "
                + " </md-switch> "
                + " </div>";

            return mdChip
                .replace("[ARIA-LABEL]", ariaLabel)
                .replace("[NG-DISABLED]", ngDisabled)
                .replace("[NG-CHANGE]", ngChange)
                .replace("[NG-MODEL]", ngModel);

        }

        function getNodeChildDetails(rowItem) {
            if (rowItem.notifications) {
                return {
                    group: true,
                    expanded: true,
                    children: rowItem.notifications,
                    key: rowItem.notifications
                };
            } else {
                return null;
            }
        }

        function changeActive(data, node) {

            var userNotificationConfigArray = [];

            if (data.id === -1) {

                vm.gridOptions.api.forEachNode(function (row, index) {
                    if (row.data.notificationType && row.data.notificationType.userCanDisable) {
                        row.data.active = data.active;
                        userNotificationConfigArray.push(row.data);
                    }
                });

            } else if (node.group) {

                node.allLeafChildren.forEach(function (row) {
                    if (row.data.notificationType && row.data.notificationType.userCanDisable) {
                        row.data.active = data.active;
                        userNotificationConfigArray.push(row.data);
                    }
                });

            } else {
                userNotificationConfigArray.push(data);
            }

            if (userNotificationConfigArray.length > 0) {
                updateConfiguration(userNotificationConfigArray);
            }
        }

        function changeReceiveEmail(data, node) {

            var userNotificationConfigArray = [];

            if (data.id === -1) {

                vm.gridOptions.api.forEachNode(function (row, index) {
                    if (row.data.active && row.data.notificationType && row.data.notificationType.userCanDisable && row.data.notificationType.canSendEmail) {
                        row.data.receiveEmail = data.receiveEmail;
                        userNotificationConfigArray.push(row.data);
                    }
                });

            } else if (node.group) {

                node.allLeafChildren.forEach(function (row) {
                    if (row.data.active && row.data.notificationType && row.data.notificationType.userCanDisable && row.data.notificationType.canSendEmail) {
                        row.data.receiveEmail = data.receiveEmail;
                        userNotificationConfigArray.push(row.data);
                    }
                });

            } else {
                userNotificationConfigArray.push(data);
            }

            if (userNotificationConfigArray.length > 0) {
                updateConfiguration(userNotificationConfigArray);
            }

        }

        function changeReceiveSms(data, node) {
            var userNotificationConfigArray = [];

            if (data.id === -1) {

                vm.gridOptions.api.forEachNode(function (row, index) {
                    if (!row.group && row.data.active && row.data.notificationType && row.data.notificationType.userCanDisable && row.data.notificationType.canSendSms) {
                        row.data.receiveSms = data.receiveSms;
                        userNotificationConfigArray.push(row.data);
                    }
                });

            } else if (node.group) {

                node.allLeafChildren.forEach(function (row) {
                    if (!row.group && row.data.active && row.data.notificationType && row.data.notificationType.userCanDisable && row.data.notificationType.canSendSms) {
                        row.data.receiveSms = data.receiveSms;
                        userNotificationConfigArray.push(row.data);
                    }
                });

            } else {
                userNotificationConfigArray.push(data);
            }

            if (userNotificationConfigArray.length > 0) {
                updateConfiguration(userNotificationConfigArray);
            }
        }

        function changeReceiveWebNotification(data, node) {

            var userNotificationConfigArray = [];

            if (data.id === -1) {

                vm.gridOptions.api.forEachNode(function (row, index) {
                    if (!row.group
                        && row.data.active
                        && row.data.notificationType
                        && row.data.notificationType.userCanDisable
                        && row.data.notificationType.canSendWebNotification) {

                        row.data.receiveWebNotification = data.receiveWebNotification;
                        userNotificationConfigArray.push(row.data);
                    }
                });

            } else if (node.group) {

                node.allLeafChildren.forEach(function (row) {
                    if (!row.group
                        && row.data.active
                        && row.data.notificationType
                        && row.data.notificationType.userCanDisable
                        && row.data.notificationType.canSendWebNotification) {
                        row.data.receiveWebNotification = data.receiveWebNotification;
                        userNotificationConfigArray.push(row.data);
                    }
                });

            } else {
                userNotificationConfigArray.push(data);
            }

            if (userNotificationConfigArray.length > 0) {
                updateConfiguration(userNotificationConfigArray);
            }

        }

        function getApplications(userNotificationConfigArray) {

            var _applicationsArray = [];

            userNotificationConfigArray.forEach(function (row) {
                _applicationsArray.push({
                    id: row.notificationType.notificationGroup.application.id,
                    name: row.notificationType.notificationGroup.application.name
                });
            });

            vm.applicationsArray = new jinqJs()
                .from(_applicationsArray)
                .distinct('id', 'name')
                .select();

            //verifica la aplicacion actual
            for (var i = 0; i < vm.applicationsArray.length; i++) {
                if (vm.applicationsArray[i].name === APPNAME) {
                    vm.applicationsSelected = vm.applicationsArray[i].id;
                    break;
                }
            }

            filterConfigByAppName();

        }

        function getNotificationsByGroup(notificationGroupId) {
            var result = [];

            vm.notificationsByAppArray.forEach(function (row) {

                if (row.notificationType.notificationGroup.id === notificationGroupId) {
                    result.push(row);
                }

            });

            return result;
        }

        function filterConfigByAppName() {
            vm.gridOptions.api.setPinnedTopRowData([]);

            vm.notificationsByAppArray = new jinqJs()
                .from(vm.userNotificationConfigArray)
                .where(function (r, i) {

                    if (r.notificationType.notificationGroup.application.id === vm.applicationsSelected) {
                        return true;
                    }

                    return false;
                })
                .select();

            vm.notificationGroupsArray = [];

            vm.notificationsByAppArray.forEach(function (row) {

                if (!existsNotificationGroupInGroupArray(row.notificationType.notificationGroup.id)) {
                    vm.notificationGroupsArray.push({
                        id: row.notificationType.notificationGroup.id,
                        groupName: row.notificationType.notificationGroup.groupName
                    });
                }

            });


            var gridRowData = [];

            for (var i = 0; i < vm.notificationGroupsArray.length; i++) {

                gridRowData.push({
                    id: vm.notificationGroupsArray[i].id,
                    groupName: vm.notificationGroupsArray[i].groupName,
                    notifications: getNotificationsByGroup(vm.notificationGroupsArray[i].id)
                });

            }

            vm.gridOptions.api.setRowData(gridRowData);


            if (gridRowData.length > 0) {
                vm.gridOptions.api.setPinnedTopRowData([{
                    groupName: "Todo (" + vm.notificationsByAppArray.length + ")",
                    id: -1,
                    active: false,
                    receiveEmail: false,
                    receiveSms: false,
                    receiveWebNotification: false
                }]);

                validateActiveAllNotifications();
            }
        }

        function existsNotificationGroupInGroupArray(notificationGroupId) {
            if (vm.notificationGroupsArray === null || vm.notificationGroupsArray === undefined) {
                return false;
            }

            if (vm.notificationGroupsArray.length === 0) {
                return false;
            }

            for (var i = 0; i < vm.notificationGroupsArray.length; i++) {
                if (vm.notificationGroupsArray[i].id === notificationGroupId) {
                    return true;
                }
            }
            return false;
        }

        function getMyNotifications() {
            $rootScope.loadingProgress = true;
            api.NotificacionesWS.UserNotificationConfig.me.query({ 'companyId': $rootScope.bsCircle.company.id }).$promise.then(function (response) {
                $rootScope.loadingProgress = false;

                vm.userNotificationConfigArray = response;

                //obtiene las aplicaciones
                getApplications(response);

                vm.showGrid = true;

            }, function (response) {
                $rootScope.loadingProgress = false;
                $log.error(response);
            });
        }

        function updateConfiguration(userNotificationConfigArray, event) {
            $rootScope.loadingProgress = true;
            api.NotificacionesWS.UserNotificationConfig.me.update({}, userNotificationConfigArray).$promise.then(function (response) {
                $rootScope.loadingProgress = false;
                validateActiveAllNotifications();
            }, function (response) {
                $rootScope.loadingProgress = false;
                $log.error(response);
            });
        }

        function validateActiveAllNotifications() {

            vm.gridOptions.api.pinnedRowModel.pinnedTopRows[0].data.hasActive = false;
            vm.gridOptions.api.pinnedRowModel.pinnedTopRows[0].data.active = true;
            vm.gridOptions.api.pinnedRowModel.pinnedTopRows[0].data.receiveEmail = true;
            vm.gridOptions.api.pinnedRowModel.pinnedTopRows[0].data.receiveSms = true;
            vm.gridOptions.api.pinnedRowModel.pinnedTopRows[0].data.receiveWebNotification = true;

            vm.gridOptions.api.forEachNode(function (node) {

                if (node.group) {

                    node.data.hasActive = false;
                    node.data.active = true;
                    node.data.receiveEmail = true;
                    node.data.receiveSms = true;
                    node.data.receiveWebNotification = true;

                    node.allLeafChildren.forEach(function (child) {

                        if (child.data.notificationType.userCanDisable) {

                            if (child.data.active) {
                                node.data.hasActive = true;
                            }

                            if (!child.data.active) {
                                node.data.active = false;
                            }

                            if (!child.data.receiveEmail) {
                                node.data.receiveEmail = false;
                            }

                            if (!child.data.receiveSms) {
                                node.data.receiveSms = false;
                            }

                            if (!child.data.receiveWebNotification) {
                                node.data.receiveWebNotification = false;
                            }
                        }

                    });

                }

            });


            vm.gridOptions.api.forEachNode(function (node) {
                if (node.group) {
                    if (node.data.hasActive) {
                        vm.gridOptions.api.pinnedRowModel.pinnedTopRows[0].data.hasActive = true;
                    }

                    if (!node.data.active) {
                        vm.gridOptions.api.pinnedRowModel.pinnedTopRows[0].data.active = false;
                    }

                    if (!node.data.receiveEmail) {
                        vm.gridOptions.api.pinnedRowModel.pinnedTopRows[0].data.receiveEmail = false;
                    }

                    if (!node.data.receiveSms) {
                        vm.gridOptions.api.pinnedRowModel.pinnedTopRows[0].data.receiveSms = false;
                    }

                    if (!node.data.receiveWebNotification) {
                        vm.gridOptions.api.pinnedRowModel.pinnedTopRows[0].data.receiveWebNotification = false;
                    }
                }
            });
        }

        function init() {
            getMyNotifications();
        }

        $timeout(init, 1000);

    }

})();


(function () {

    'use strict';

    angular.module('app.errors', []).config(config);

    /**@ngInject**/
    function config($stateProvider, $translatePartialLoaderProvider) {

        $translatePartialLoaderProvider.addPart('app/main/general/errors/');

        $stateProvider.state('app.errors', {
            url: '/errors',
            abstract: true
        });

        $stateProvider
            .state('app.errors.unauthorized', {
                url: '/unauthorized',
                views: {
                    'main@': {
                        templateUrl: 'app/core/layouts/content-only.html',
                        controller: 'MainController as vm'
                    },
                    'content@app.errors.unauthorized': {
                        templateUrl: 'app/main/general/errors/unauthorized/unauthorized.html',
                        controller: 'UnauthorizedController as vm'
                    }
                }
            })
            .state('app.errors.notFound', {
                url: '/not-found',
                views: {
                    'main@': {
                        templateUrl: 'app/core/layouts/content-only.html',
                        controller: 'MainController as vm'
                    },
                    'content@app.errors.notFound': {
                        templateUrl: 'app/main/general/errors/notFound/error-404.html',
                        controller: 'NotFoundController as vm'
                    }
                }
            })
            .state('app.pages_errors_error-404', {
                url: '/error',
                views: {
                    'main@': {
                        templateUrl: 'app/core/layouts/content-only.html',
                        controller: 'MainController as vm'
                    },
                    'content@app.pages_errors_error-404': {
                        templateUrl: 'app/main/general/errors/404/error-404.html',
                        controller: 'Error404Controller as vm'
                    }
                },
                bodyClass: 'error-404'
            });
    }

})();

(function () {

    'use strict';

    angular.module('app.errors').controller('UnauthorizedController', UnauthorizedController);

    /**@ngInject**/
    function UnauthorizedController(envService, ICON_APP_NAME) {

        var vm = this;
        var urlMsBase = envService.read('msConfigUrl');
        vm.iconApp = envService.read('imagesApps') + ICON_APP_NAME;

        vm.goToConfigureCompany = function () {
            window.location.href = urlMsBase + "company/my-company";
        };
    }

})();

(function () {
    'use strict';

    angular
        .module('app.errors')
        .controller('Error404Controller', Error404Controller);

    /** @ngInject */
    function Error404Controller(envService, ICON_APP_NAME) {
        var vm = this;
        vm.iconApp = envService.read('imagesApps') + ICON_APP_NAME;
    }
})();

(function () {
    'use strict';

    angular
        .module('app.auth.login', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {
        $stateProvider
            .state('auth.login', {
                url: '/auth/login',
                views: {
                    'content@auth': {
                        templateUrl: 'app/main/general/auth/login/login.html',
                        controller: 'AuthController as vm'
                    }
                },
                bodyClass: 'login'
            });
        // Translation
        $translatePartialLoaderProvider.addPart('app/main/general/auth/login');


    }

})();


(function () {
    'use strict';

    angular
        .module('app.auth.login')
        .controller('AuthController', AuthController);

    /** @ngInject */
    function AuthController($rootScope, $auth, $state, MessageService, api, localStorageService, APPNAME, APPINITIALS, ICON_APP_NAME, $log, envService, $filter) {
        var vm = this;
        var urlMsBase = envService.read('msConfigUrl');
        vm.urlIcons = envService.read('imagesApps') + ICON_APP_NAME;

        vm.forgetPassword = forgetPassword;
        vm.register = register;

        vm.app = {
            initials: APPINITIALS,
            name: APPNAME
        };

        vm.authenticate = function (provider) {
            document.title = APPNAME;

            localStorageService.remove('account');
            localStorageService.remove('accountc');
            localStorageService.remove('circles');
            localStorageService.remove('userParameters');

            delete $rootScope.bsCircle;
            delete $rootScope.circles;
            delete $rootScope.userParameters;

            $auth.authenticate(provider)
                .then(function () {
                    getProfile(provider);
                })
                .catch(function (error) {
                    if (error.error) {
                        // Popup error - invalid redirect_uri, pressed cancel button, etc.
                        $log.debug(error.error);
                    } else if (error.data) {
                        // HTTP response error from server
                        $log.debug(error.data.message, error.status);
                    } else {
                        $log.debug(error);
                    }

                    if (error.status === 401) {
                        MessageService.showErrorMessage($filter('translate')('general.error'));
                    }

                });
        };

        function register() {
            window.location.href = urlMsBase + "public/auth/register";
        }

        function forgetPassword() {
            window.location.href = urlMsBase + "public/auth/forgot-password";
        }

        function getProfile(provider) {
            api.UsuarioWS.Yo.get({},
                function (response) {
                    var message = $filter('translate')('LOGIN_V2.SESSION_CORRECT') + provider + '!';
                    MessageService.show(message);

                    $log.debug(response);
                    $rootScope.account = response;
                    localStorageService.set('account', $rootScope.account);
                    api.GeneralWS.MyCircles.query({}, function (response) {// Success
                        $log.debug(response);
                        if (response.length <= 0) {
                            $state.go('app.errors.unauthorized');
                        } else {
                            $rootScope.bsCircle = response[0];
                            localStorageService.set('accountc', $rootScope.bsCircle);
                            $rootScope.circles = response;
                            localStorageService.set('circles', $rootScope.circles);

                            $state.go('app.dashboards_project');
                        }
                    }, function (response) {// Error
                        $state.go('app.errors.unauthorized');
                    });
                },
                function (response) {
                    logoutFinish($auth, $state, 'auth.login');
                }
            );
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('app.auth.lock', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {
        $stateProvider
            .state('auth.lock', {
                url: '/auth/lock',
                views: {
                    'content@auth': {
                        templateUrl: 'app/main/general/auth/lock/lock.html',
                        controller: 'LockController as vm'
                    }
                },
                bodyClass: 'lock'
            });
        // Translation
        $translatePartialLoaderProvider.addPart('app/main/general/auth/lock');

    }

})();



(function () {
    'use strict';
    angular
        .module('app.auth.lock')
        .controller('LockController', LockController);

    /** @ngInject */
    function LockController($filter, $rootScope, api, $auth, $state, localStorageService, $log, APPNAME, MessageService) {
        var vm = this;
        $rootScope.account = localStorageService.get('account');
        vm.userInfo = "";
        vm.isAuthenticated = false;
        vm.token = null;
        vm.credenciales = { username: $rootScope.account.userName, password: '' };

        vm.authenticate = function (provider) {
            document.title = APPNAME;

            $auth.authenticate(provider)
                .then(function () {
                    MessageService.show($filter('translate')('LOGIN_V2.SESSION_CORRECT') + provider + '!');
                    getProfile();

                })
                .catch(function (error) {
                    if (error.error) {
                        // Popup error - invalid redirect_uri, pressed cancel button, etc.
                        $log.debug(error.error);
                    } else if (error.data) {
                        // HTTP response error from server
                        $log.debug(error.data.message, error.status);
                    } else {
                        $log.debug(error);
                    }
                });
        };

        function getProfile() {
            api.UsuarioWS.Yo.get({},
                function (response) {
                    $log.debug(response);
                    if ($rootScope.account.id !== response.id) {
                        localStorageService.remove('accountc');
                        localStorageService.remove('circles');
                        localStorageService.remove('userParameters');
                        delete $rootScope.bsCircle;
                        delete $rootScope.circles;
                        delete $rootScope.userParameters;
                    }
                    $rootScope.account = response;
                    localStorageService.set('account', $rootScope.account);
                    $state.go('app.dashboards_project');
                },
                // Error
                function () {
                }
            );
        }
    }
})();




(function () {
    'use strict';

    angular
        .module('app.directives', [])
        .config(config);

    /** @ngInject */
    function config() {

    }
})();

(function () {
    'use strict';

    angular
        .module('app.shippingOrder', ['flow'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {
        // State
        $stateProvider
            .state('app.shippingOrder', {
                url: '/shippingOrder',
                abstract: true
            })
            .state('app.shippingOrder.detail', {
                url: '/detail/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/shippingOrder/detail_shipping_order/shippingOrder.html',
                        controller: 'ShippingOrderController as vm'
                    }
                },
                params: {
                    filter: null,
                    backTo: null
                },
                bodyClass: 'e-commerce'
            });


        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/shippingOrder');

    }

})();

(function () {
    "use strict";

    angular
        .module("app.shippingOrder")
        .controller("ShippingOrderController", ShippingOrderController);

    /** @ngInject */
    function ShippingOrderController(
        $state,
        api,
        $rootScope,
        $filter,
        $stateParams
    ) {
        var vm = this;

        vm.role = $rootScope.bsCircle.name;
        vm.gotoBack=gotoBack;

        vm.masterColumnDefs = [
            {
                headerName: '#',
                field: "id",
                width: 70,
                cellStyle: { 'text-align': 'center' }
            },
            {
                headerName: 'ORDER.DETAIL.PRODUCT',
                field: "purchaseOrderDetail.product.name",
                headerCellRenderer: getHeader,
                width: 330,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'ORDER.DETAIL.DATE',
                headerCellRenderer: getHeader,
                width: 200,
                cellRenderer: rendererDate,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'ORDER.DETAIL.QUANTITY',
                field: "purchaseOrderDetail.quantity",
                headerCellRenderer: getHeader,
                width: 130,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'SHIPPING_ORDER.QUANTITY_SENT',
                field: "quantity",
                headerCellRenderer: getHeader,
                width: 180,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'SHIPPING_ORDER.COMPLETED',
                field: "quantity",
                headerCellRenderer: getHeader,
                width: 180,
                enableRowGroup: true,
                enablePivot: true,
                cellRenderer: function (params) {
                    return '<md-icon ng-if="data.purchaseOrderDetail.amountShipping===0 && ' +
                        'data.shippingOrder.shippingStatus.description===\'Recibido\'" md-font-icon="icon-check"></md-icon>' +
                        '<md-icon ng-if="data.purchaseOrderDetail.amountShipping>0 && ' +
                        'data.shippingOrder.shippingStatus.description!==\'Recibido\'" md-font-icon="icon-close"></md-icon>'
                }
            }
        ];

        vm.masterGridOptions = {
            columnDefs: vm.masterColumnDefs,
            enableSorting: true,
            debug: false,
            enableFilter: true,
            enableColResize: true,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowData: null,
            groupHeaders: true,
            headerHeight: 50,
            rowHeight: 45,
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            },
            doesDataFlower: function (dataItem) {
                return true;
            }
        };

        init();

        function init() {
            $rootScope.loadingProgress = true;
            api.ComprasWS.ShippingOrder.get(
                { id: $stateParams.id },
                function (data) {
                    vm.shippingOrder = data;
                    getDetail();
                    $rootScope.loadingProgress = false;
                }, function (err) {
                    $rootScope.loadingProgress = false;
                });
        }

        function getDetail() {
            $rootScope.loadingProgress = true;
            api.ComprasWS.ShippingOrderDetailByShippingOrder.getByShippingOrder(
                { shippingOrderId: $stateParams.id },
                function (data) {
                    vm.details = data;
                    vm.masterGridOptions.api.setColumnDefs(vm.masterColumnDefs);
                    vm.masterGridOptions.api.setRowData(vm.details);
                    $rootScope.loadingProgress = false;
                }, function () {
                    $rootScope.loadingProgress = false;
                });
        }

        function rendererDate(params) {
            if (params.data) {
                return '<div>' + params.data.createdAt.dayOfMonth + '/' + params.data.createdAt.monthValue + '/' + params.data.createdAt.year + '</div>';
            } else {
                return '';
            }

        }

        function gotoBack(){
            if ($stateParams.backTo) {
                $state.go($stateParams.backTo, { filter: $stateParams.filter });
              } else {
                $state.go("app.shippingOrder.consult");
              }
        }

    }
})();
(function () {
    'use strict';
    angular
        .module('app.requisition')
        .controller('QuotationReportController', QuotationReportController);

    /** @ngInject */
    function QuotationReportController(api, $log, $rootScope, $mdDialog, $timeout, $filter, MessageService) {
        var vm = this;

        vm.replaceOriginTypedata = replaceOriginTypedata;
        vm.URLPHOTOS = api.baseUrlPhotos;
        vm.viewIMG = viewIMG;
        vm.dimensionCompanyDetail3 = null;
        vm.dimensionCompanyDetail4 = null;
        vm.dimensionCompanyDetail5 = null;

        vm.masterColumnDefs = [
            {
                headerName: 'REQUISITION.DETAIL.QUANTITY',
                field: "quantity",
                headerCellRenderer: getHeader,
                width: 100,
                enableRowGroup: true,
                cellStyle: { 'text-align': 'center' },
                enablePivot: true
            },
            {
                headerName: 'REQUISITION.DETAIL.PRODUCT',
                field: "product.name",
                headerCellRenderer: getHeader,
                width: 300,
                enableRowGroup: true,
                enablePivot: true,
                cellRenderer: function (params) {
                    if (!params.node.group) {
                        if (params.data && params.data.product.brand && params.data.product.measurementUnit) {
                            return params.value + ", " + $filter('translate')('authorize_quotations.measurement_unit')
                                + ": " + params.data.product.measurementUnit.name
                                + ", " + $filter('translate')('authorize_quotations.brand') + ": " + params.data.product.brand.name;
                        } else {
                            return params.value;
                        }

                    } else {
                        return params.value;
                    }
                }
            },
            {
                headerName: 'REQUISITION.DETAIL.CONSIGNACION',
                name: "consignment",
                headerCellRenderer: getHeader,
                width: 100,
                cellRenderer: rendererConsigment,
                enableRowGroup: true,
                enablePivot: true,
                cellStyle: { 'text-align': 'center' }
            },
            {
                headerName: 'REQUISITION.DETAIL.COTIZED',
                name: "cotizated",
                headerCellRenderer: getHeader,
                cellRenderer: rendererCotized,
                enableRowGroup: true,
                enablePivot: true,
                cellStyle: { 'text-align': 'center' }
            },
            {
                headerName: 'REQUISITION.DETAIL.OBSERVATIONS',
                field: "observations",
                width: 200,
                headerCellRenderer: getHeader,
                enableRowGroup: true,
                enablePivot: true
            }
        ];


        vm.masterGridOptions = {
            columnDefs: vm.masterColumnDefs,
            enableSorting: true,
            debug: false,
            enableFilter: true,
            enableColResize: true,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowData: null,
            groupHeaders: true,
            headerHeight: 50,
            rowHeight: 40,
            rowSelection: 'multiple',
            rowDeselection: true,
            rowModelType: "enterprise",
            cacheBlockSize: vm.pageSize,
            pagination: true,
            paginationPageSize: vm.pageSize,
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            },
            doesDataFlower: function (dataItem) {
                return true;
            },
            isExternalFilterPresent: isExternalFilterPresent
        };

        var filter = 'everyone';

        function isExternalFilterPresent() {
            return filter !== '';
        }

        vm.masterColumnDefsQuotation = [
            {
                headerName: 'QUOTATION.QUOTATION',
                field: "quotationDescription",
                headerCellRenderer: getHeader,
                width: 150,
                rowGroupIndex: 0,
                hide: true
            },
            {
                headerName: 'REQUISITION.DETAIL.QUANTITY',
                field: "requisitionDetail.quantity",
                headerCellRenderer: getHeader,
                width: 100,
                enableRowGroup: true,
                cellStyle: { 'text-align': 'center' },
                enablePivot: true
            },
            {
                headerName: 'REQUISITION.DETAIL.PRODUCT',
                field: "requisitionDetail.product.name",
                headerCellRenderer: getHeader,
                width: 200,
                enableRowGroup: true,
                enablePivot: true,
                cellRenderer: function (params) {
                    if (!params.node.group) {
                        if (params.data && params.data.requisitionDetail.product.brand && params.data.requisitionDetail.product.measurementUnit) {
                            return params.value + ", " + $filter('translate')('authorize_quotations.measurement_unit')
                                + ": " + params.data.requisitionDetail.product.measurementUnit.name
                                + ", " + $filter('translate')('authorize_quotations.brand') + ": " + params.data.requisitionDetail.product.brand.name;
                        } else {
                            return params.value;
                        }

                    } else {
                        return params.value;
                    }
                }
            },
            {
                headerName: 'QUOTATION.DETAIL.PRICE',
                field: "price",
                headerCellRenderer: getHeader,
                width: 150,
                enableRowGroup: true,
                enablePivot: true,
                cellStyle: { 'text-align': 'right' },
                valueFormatter: function (params) {
                    return $filter('number')(params.value, 2);
                }
            },
            {
                headerName: 'QUOTATION.TOTAL',
                field: "subTotal",
                headerCellRenderer: getHeader,
                enableRowGroup: true,
                enablePivot: true,
                cellStyle: { 'text-align': 'right' },
                valueFormatter: function (params) {
                    return $filter('number')(params.value, 2);
                }
            },
            {
                headerName: 'QUOTATION.DETAIL.OBSERVATIONS',
                field: "observations",
                width: 200,
                headerCellRenderer: getHeader,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'CONTRACT.BY_CREATED',
                field: "createdBy",
                headerCellRenderer: getHeader,
                width: 160,
                enableRowGroup: true,
                enablePivot: true,
                cellStyle: { 'text-align': 'center' }
            }
        ];


        vm.masterGridOptionsQuotation = {
            columnDefs: vm.masterColumnDefsQuotation,
            enableSorting: true,
            debug: false,
            enableFilter: true,
            enableColResize: true,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowData: null,
            groupHeaders: true,
            headerHeight: 50,
            rowHeight: 45,
            groupUseEntireRow: true,
            animateRows: true,
            groupDefaultExpanded: 1,
            doesDataFlower: function (dataItem) {
                dataItem.quotationDescription = "Cotizacion N. " + dataItem.quotation.id;
            },
            isExternalFilterPresent: isExternalFilterPresent,
            doesExternalFilterPass: doesExternalFilterPass,
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            }
        };

        function doesExternalFilterPass(node) {
            if (filter && filter !== 'everyone') {
                var arrdt = node.data.filter.split(filter.toLowerCase());
                return arrdt.length > 1;
            }
            return true;
        }

        vm.masterColumnDefsPurchaseOrder = [
            {
                headerName: 'ORDER.ORDER',
                field: "orderDescription",
                headerCellRenderer: getHeader,
                width: 150,
                rowGroupIndex: 0,
                hide: true
            },
            {
                headerName: 'REQUISITION.DETAIL.QUANTITY',
                field: "quantityRequired",
                headerCellRenderer: getHeader,
                width: 100,
                enableRowGroup: true,
                cellStyle: { 'text-align': 'center' },
                enablePivot: true
            },
            {
                headerName: 'REQUISITION.DETAIL.PRODUCT',
                field: "productName",
                headerCellRenderer: getHeader,
                width: 250,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'QUOTATION.DETAIL.PRICE',
                field: "price",
                headerCellRenderer: getHeader,
                width: 150,
                enableRowGroup: true,
                enablePivot: true,
                cellStyle: { 'text-align': 'right' },
                valueFormatter: function (params) {
                    return $filter('number')(params.value, 2);
                }
            },
            {
                headerName: 'ORDER.DETAIL.PENDIENTE',
                field: "maxRecibe",
                headerCellRenderer: getHeader,
                width: 150,
                enableRowGroup: true,
                cellStyle: { 'text-align': 'center' },
                enablePivot: true
            },
            {
                headerName: 'ORDER.DETAIL.RECIBIDO',
                field: "pending",
                headerCellRenderer: getHeader,
                width: 150,
                enableRowGroup: true,
                cellStyle: { 'text-align': 'center' },
                enablePivot: true
            }
        ];


        vm.masterGridOptionsPurchaseOrder = {
            columnDefs: vm.masterColumnDefsPurchaseOrder,
            enableSorting: true,
            debug: false,
            enableFilter: true,
            enableColResize: true,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowData: null,
            headerHeight: 50,
            rowHeight: 45,
            groupUseEntireRow: true,
            animateRows: true,
            groupDefaultExpanded: 1,
            doesDataFlower: function (dataItem) {
                dataItem.pending = dataItem.quantityRequired - dataItem.maxRecibe;
                dataItem.orderDescription = "Orden de Compra No."
                    + dataItem.purchaseOrder.id + " {{'CONTRACT.BY_CREATED' | translate}} "
                    + dataItem.purchaseOrder.createdBy + " El " + $filter('date')(getDateFormat(dataItem), 'dd/MM/yyyy');
            },
            isExternalFilterPresent: isExternalFilterPresent,
            doesExternalFilterPass: doesExternalFilterPass,
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            }
        };

        vm.masterColumnDefsInvoice = [
            {
                headerName: 'INVOICE.INVOICE',
                field: "invoiceDescription",
                headerCellRenderer: getHeader,
                width: 150,
                rowGroupIndex: 0,
                hide: true
            },
            {
                headerName: 'INVOICE.PRODUCT.PRODUCT',
                field: "product.name",
                headerCellRenderer: getHeader,
                width: 250,
                enableRowGroup: true,
                enablePivot: true,
                cellRenderer: function (params) {
                    if (!params.node.group) {
                        if (params.data && params.data.product.brand && params.data.product.measurementUnit) {
                            return params.value + ", " + $filter('translate')('authorize_quotations.measurement_unit')
                                + ": " + params.data.product.measurementUnit.name
                                + ", " + $filter('translate')('authorize_quotations.brand') + ": " + params.data.product.brand.name;
                        } else {
                            return params.value;
                        }

                    } else {
                        return params.value;
                    }
                }
            },
            {
                headerName: 'INVOICE.DEPARTMENT',
                field: "merchandiseEntry.purchaseOrderDetail.purchaseOrder.department.description",
                headerCellRenderer: getHeader,
                width: 200,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'INVOICE.COST_CENTER',
                field: "merchandiseEntry.purchaseOrderDetail.purchaseOrder.costCenter.description",
                headerCellRenderer: getHeader,
                width: 200,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'INVOICE.INVOICE_PURCHASE.ELECTRONIC_SIGNATURE',
                field: "invoicePurchase.electronicSignature",
                headerCellRenderer: getHeader,
                width: 160,
                enableRowGroup: true,
                enablePivot: true,
                cellStyle: { 'text-align': 'center' }
            },
            {
                headerName: 'INVOICE.INVOICE_PURCHASE.DETAIL.QUANTITY',
                field: "quantity",
                headerCellRenderer: getHeader,
                width: 100,
                enableRowGroup: true,
                enablePivot: true,
                cellStyle: { 'text-align': 'center' }
            },
            {
                headerName: 'INVOICE.INVOICE_PURCHASE.DETAIL.UNIT_PRICE_AFTER_TAX',
                field: "priceAfterTax",
                headerCellRenderer: getHeader,
                width: 100,
                suppressSorting: true,
                suppressMenu: true,
                cellStyle: { 'text-align': 'right' },
                valueFormatter: function (params) {
                    return $filter('number')(params.value, 2);
                }
            },
            {
                headerName: 'INVOICE.INVOICE_PURCHASE.DETAIL.TOTAL_AFTER_TAX',
                field: "subTotalAfterTax",
                headerCellRenderer: getHeader,
                width: 100,
                suppressSorting: true,
                suppressMenu: true,
                cellStyle: { 'text-align': 'right' },
                valueFormatter: function (params) {
                    return $filter('number')(params.value, 2);
                }
            }
        ];


        vm.masterGridOptionsInvoice = {
            columnDefs: vm.masterColumnDefsInvoice,
            enableSorting: true,
            debug: false,
            enableFilter: true,
            enableColResize: true,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowData: null,
            headerHeight: 50,
            rowHeight: 45,
            groupUseEntireRow: true,
            animateRows: true,
            groupDefaultExpanded: 1,
            doesDataFlower: function (dataItem) {
                var resp = ' ';
                var ref = '';
                dataItem.invoicePurchase.files.forEach(function (file, index, arr) {
                    ref = ref + '<a ng-click="vm.viewIMG(' + file.id + ')">Ver Imagen ' + (index + 1) + '</a> ';
                });
                dataItem.invoiceDescription = "Factura SERIE "
                    + dataItem.invoicePurchase.invoiceSerie.serie + " Correlativo No. "
                    + dataItem.invoicePurchase.correlative + " {{'CONTRACT.BY_CREATED' | translate}} "
                    + dataItem.invoicePurchase.createdBy + " El " + $filter('date')(getDateFormat(dataItem), 'dd/MM/yyyy') + '' + resp + ref + '';
                return false;
            },
            isExternalFilterPresent: isExternalFilterPresent,
            doesExternalFilterPass: doesExternalFilterPass,
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            },
            groupRowInnerRenderer: function (params) {
                return params.value;
            }
        };

        // Methods
        vm.getRequisition = getRequisition;

        function getRequisition(id) {
            vm.requisition = {};
            api.ComprasWS.Quotation.Quotation.get({ companyId: $rootScope.bsCircle.company.id, id: id }, function (data) {
                ifNotFromOther(data.requisition.id);
            }, function (errResponse) {

            });

        }

        function ifNotFromOther(id, ot) {
            if (id) {
                $rootScope.loadingProgress = true;
                api.ComprasWS.RequisitionPendingAuthorize.getBy({ idCircle: $rootScope.bsCircle.id, id: id }, function (data) {

                    if (!data.id) {
                        MessageService.showErrorMessage('REQUISITION.NOX_EXIST');
                        $rootScope.loadingProgress = false;
                        return false;
                    }

                    if (data.originType && data.originType.originTypeCode === '01') {
                        vm.requisitionFromOtherOrigin = true;
                    }

                    data.department.id = data.department.id.toString();
                    data.costCenter.id = data.costCenter.id.toString();

                    if (data.departmentFirsRecept) {
                        data.departmentFirsRecept.id = data.departmentFirsRecept.id.toString();
                    }

                    var ff = data.maxDatePurchase.split("-");
                    var maxDatePurchase = new Date(ff[0], (parseInt(ff[1]) - 1), ff[2]);

                    api.ComprasWS.ProcessFlow.get({ id: data.id, type: 1 }, function (data) {
                        vm.infoProcessFlow = data;
                    });

                    $timeout(function () {
                        vm.requisition = data;
                        getQuotation(vm.requisition.id);
                        getPurchaseOrder(vm.requisition.id);
                        getInvoice(vm.requisition.id);
                        getDimensionCompany();

                        $timeout(function () {
                            data.maxDatePurchase = maxDatePurchase;
                            $rootScope.loadingProgress = false;
                            getDetails();

                        });
                    });
                }, function (err) {
                    MessageService.showErrorMessage('REQUISITION.NOX_EXIST');
                    $rootScope.loadingProgress = false;
                });
            }
        }

        function getDetails() {
            $rootScope.loadingProgress = true;
            api.ComprasWS.RequisitionDetail.query({ idCircle: $rootScope.bsCircle.id, idRequisition: vm.requisition.id }, function (data) {
                vm.details = new jinqJs()
                    .from(data)
                    .orderBy([{ field: 'id', sort: 'asc' }])
                    .select(function (r) {
                        return r;
                    });
                $rootScope.loadingProgress = false;

                vm.masterGridOptions.api.setColumnDefs(vm.masterColumnDefs);
                vm.dataSource = {
                    paginationPageSize: vm.pageSize,
                    getRows: function (params) {
                        vm.loading = false;
                        $rootScope.loadingProgress = false;
                        params.successCallback(vm.details, vm.details.length);
                    }
                };
                vm.masterGridOptions.api.setEnterpriseDatasource(vm.dataSource);
            }, function (data) {
                $log.debug(data);
                $rootScope.loadingProgress = false;
            });
        }

        function rendererConsigment(params) {
            var toRet = '<div style="width: 100%;">';

            toRet = toRet + '<div>'
                + '                              <md-icon md-font-icon="{{data.consignment ? \'icon-check\' : \'icon-close\'}}"></md-icon>'
                + ' </div>';

            return toRet + '</div>';
        }

        function rendererCotized(params) {
            var toRet = '<div style="width: 100%;">';

            toRet = toRet + '<div>'
                + ' <md-icon md-font-icon="{{data.cotizated ? \'icon-check\' : \'icon-close\'}}"></md-icon>'
                + ' </div>';

            return toRet + '</div>';
        }

        function getQuotation(id) {
            $rootScope.loadingProgress = true;
            vm.quotations = [];
            api.ComprasWS.Quotation.byRequisition.getBy({ companyId: $rootScope.bsCircle.company.id, id: id }, function (data) {
                vm.quotationsDetails = new jinqJs()
                    .from(data)
                    .orderBy([{ field: 'id', sort: 'asc' }])
                    .select(function (r) {
                        return r;
                    });
                vm.masterGridOptionsQuotation.api.setColumnDefs(vm.masterColumnDefsQuotation);
                vm.masterGridOptionsQuotation.api.setRowData(vm.quotationsDetails);
            }, function (err) {
                vm.quotationsDetails = [];
            });
            vm.masterGridOptionsQuotation.api.setColumnDefs(vm.masterColumnDefsQuotation);
        }

        function getPurchaseOrder(id) {
            $rootScope.loadingProgress = true;
            api.ComprasWS.PurchaseByRequisition.getBy({ idCircle: $rootScope.bsCircle.id, idPurchaseOrder: 1, requisitionId: id }, function (data) {
                vm.detailsPurchaseOrder = new jinqJs()
                    .from(data)
                    .orderBy([{ field: 'id', sort: 'asc' }])
                    .select(function (r) {
                        r.maxRecibe = angular.copy(r.quantity);
                        r.quantity = 0;
                        return r;
                    });
                $rootScope.loadingProgress = false;
                vm.masterGridOptionsPurchaseOrder.api.setColumnDefs(vm.masterColumnDefsPurchaseOrder);
                vm.masterGridOptionsPurchaseOrder.api.setRowData(vm.detailsPurchaseOrder);
            }, function (data) {
                $log.debug(data);
                $rootScope.loadingProgress = false;
                vm.detailsPurchaseOrder = [];
            });
        }

        function getInvoice(id) {
            $rootScope.loadingProgress = true;
            api.ComprasWS.InvoicesPurchasesDetails.byRequisition.getBy({ idCircle: $rootScope.bsCircle.id, requisitionId: id }, function (data) {
                vm.detailsInvoice = new jinqJs()
                    .from(data)
                    .orderBy([{ field: 'id', sort: 'asc' }])
                    .select(function (r) {
                        return r;
                    });
                $rootScope.loadingProgress = false;
                vm.masterGridOptionsInvoice.api.setColumnDefs(vm.masterColumnDefsInvoice);
                vm.masterGridOptionsInvoice.api.setRowData(vm.detailsInvoice);
            }, function (data) {
                $log.debug(data);
                $rootScope.loadingProgress = false;
            });
        }

        function getDateFormat(dataItem) {
            if (dataItem.purchaseOrder && dataItem.purchaseOrder.contractPurchase === null) {
                var day = 0;
                var month = 0;
                if (dataItem.purchaseOrder.createdAt.dayOfMonth < 10) {
                    day = '0' + (dataItem.purchaseOrder.createdAt.dayOfMonth);
                } else {
                    day = (dataItem.purchaseOrder.createdAt.dayOfMonth);
                }
                if (dataItem.purchaseOrder.createdAt.monthValue < 10) {
                    month = '0' + (dataItem.purchaseOrder.createdAt.monthValue);
                } else {
                    month = dataItem.purchaseOrder.createdAt.monthValue;
                }
                return new Date(dataItem.purchaseOrder.createdAt.year + "-" + month + "-" + day);
            } else if (dataItem.purchaseOrder) {
                return dataItem.purchaseOrder.dateDelivery;
            } else {
                if (dataItem.createdAt.dayOfMonth < 10) {
                    day = '0' + (dataItem.createdAt.dayOfMonth);
                } else {
                    day = (dataItem.createdAt.dayOfMonth);
                }
                if (dataItem.createdAt.monthValue < 10) {
                    month = '0' + (dataItem.createdAt.monthValue);
                } else {
                    month = dataItem.createdAt.monthValue;
                }
                return new Date(dataItem.createdAt.year + "-" + month + "-" + day);
            }

        }

        function viewIMG(id) {
            vm.detailsInvoice.forEach(function (data) {
                data.invoicePurchase.files.forEach(function (file) {
                    if (id === file.id) {
                        $mdDialog.show({
                            controller: 'DialogPhotoController',
                            controllerAs: 'vm',
                            templateUrl: 'app/main/apps/files/dialogPhoto/dialogPhoto.html',
                            parent: angular.element("#main"),
                            name: file.originalName,
                            url: vm.URLPHOTOS + file.parentPath + file.name + file.extension,
                            clickOutsideToClose: false
                        }).then(function (answer) {

                        });
                    }
                });
            });
        }

        function getDimensionCompany() {
            const NUMBER_DIMENSION_THREE = 3;
            const NUMBER_DIMENSION_FOUR = 4;
            const NUMBER_DIMENSION_FIVE = 5;
            api.GeneralWS.DimensionCompany.byCompany.getList(
              { 'company': vm.requisition.department.company.id }
            ).$promise.then(function (responseDimension) {
              for (let i = 0; i < responseDimension.length; i++) {
                if (responseDimension[i].dimensionNumber === NUMBER_DIMENSION_THREE) {
                  vm.dimensionCompanyDetail3 = responseDimension[i];
                } else if (responseDimension[i].dimensionNumber === NUMBER_DIMENSION_FOUR) {
                  vm.dimensionCompanyDetail4 = responseDimension[i];
                } else if (responseDimension[i].dimensionNumber === NUMBER_DIMENSION_FIVE) {
                  vm.dimensionCompanyDetail5 = responseDimension[i];
                } else {
                  vm.dimensionCompanyDetail1 = responseDimension[i];
                }
              }
            });
          }

    }
})();

(function () {
  "use strict";
  angular
    .module("app.quotation")
    .controller("QuotationDetailRowController", QuotationDetailController)
    .controller("QuotationController", QuotationController);

  /** @ngInject */
  function QuotationController(
    $state,
    api,
    $log,
    $rootScope,
    $mdDialog,
    $timeout,
    $filter,
    $stateParams,
    MessageService,
    $mdToast
  ) {
    var vm = this;
    // Data
    vm.URLPHOTOS = api.baseUrlPhotos;
    vm.viewIMG = viewIMG;

    vm.minDate = new Date();
    vm.isCreatedQuotation = $stateParams.status === "Ingresada";
    vm.isEnterFeatures = $stateParams.status === "Aprobado sin caracteristicas";
    vm.completedAllFeatures = false;

    vm.status = $stateParams.status;
    vm.isClient = $stateParams.isClient;
    vm.isReport = $stateParams.isReport;
    vm.optionsTrue = $stateParams.optionsTrue;
    vm.viewDetailPermision = false;
    vm.refuseQuotation = false;
    vm.reasignProvider = false;
    var statusToChange = null;
    vm.changeCancelStatus = changeCancelStatus;
    vm.statusToChange = {};
    vm.dtOptions = {
      responsive: true,
      paging: false,
      searching: false,
      columnDefs: getColumnDefs()
    };
    vm.productId = $stateParams.productId;
    vm.dimensionCompanyDetail3 = null;
    vm.dimensionCompanyDetail4 = null;
    vm.dimensionCompanyDetail5 = null;

    // Methods
    vm.goToQuotations = goToQuotations;
    vm.getDetails = getDetails;
    vm.changeStatus = changeStatus;
    vm.addFeatures = addFeatures;
    vm.viewDetail = viewDetail;
    vm.refuseQuotationStatus = refuseQuotationStatus;
    vm.updateProvider = updateProvider;
    vm.replaceOriginTypedata = replaceOriginTypedata;
    vm.circleQuotation = {};
    vm.detailQuotationAproveRefuse = detailQuotationAproveRefuse;
    vm.arrayAproveRefuse = [];
    vm.selectAllDetailQuotationAproveRefuse = selectAllDetailQuotationAproveRefuse;
    vm.viewDetailFeatures = viewDetailFeatures;

    function getColumnDefs() {
      var cols = [
        {
          targets: 0,
          width: "72px"
        },
        {
          targets: 1,
          responsivePriority: 3,
          width: "300px",
          minWidth: "300px"
        },
        {
          targets: 2,
          responsivePriority: 4,
          width: "150px"
        }
      ];
      if (vm.isCreatedQuotation) {
        cols.push({
          targets: 3,
          responsivePriority: 1,
          minWidth: "300px",
          width: "300px"
        });
      } else if (vm.isEnterFeatures === true) {
        cols.push({
          targets: 4,
          responsivePriority: 1,
          width: "70px"
        });
        cols.push({
          targets: 5,
          responsivePriority: 2,
          filterable: false,
          width: "70px",
          render: function (data, type) {
            if (type === "display") {
              if (data === "true") {
                return '<i class="icon-checkbox-marked-circle green-500-fg"></i>';
              }

              return '<i class="icon-cancel red-500-fg"></i>';
            }

            if (type === "filter") {
              if (data) {
                return "1";
              }

              return "0";
            }

            return data;
          }
        });
      }
      return cols;
    }

    function viewIMG(file) {
      $mdDialog
        .show({
          controller: "DialogPhotoController",
          controllerAs: "vm",
          templateUrl: "app/main/apps/files/dialogPhoto/dialogPhoto.html",
          parent: angular.element("#main"),
          name: file.originalName,
          url: vm.URLPHOTOS + file.parentPath + file.name + file.extension,
          clickOutsideToClose: false
        })
        .then(function (answer) {
          //go to Quotations
          answer === true ? goToInvoicePurchases() : null;
        });
    }

    function getBudgets(id) {
      vm.isShowLoaderBudgets = true;
      api.PresupuestosWS.Budget.findApprovedOfBeforeAndCurrentAndAfterMonth
        .query({
          idc: vm.circleQuotation.id,
          costCenterId: vm.quotation.requisition.costCenter.id,
          departmentId: vm.quotation.requisition.department.id,
          'dimensionCompanyDetail3Id': getDimensionCompanyDetailBudget(vm.quotation.requisition.dimensionCompanyDetail3),
          'dimensionCompanyDetail4Id': getDimensionCompanyDetailBudget(vm.quotation.requisition.dimensionCompanyDetail4),
          'dimensionCompanyDetail5Id': getDimensionCompanyDetailBudget(vm.quotation.requisition.dimensionCompanyDetail5)
        })
        .$promise.then(
          function (response) {
            vm.isShowLoaderBudgets = false;
            vm.budgets = response;
          },
          function (response) {
            vm.isShowLoaderBudgets = false;
            $log.error(response);
          }
        );
    }

    function getDimensionCompanyDetailBudget(dimensionCompanyDetail) {
      if (dimensionCompanyDetail) {
        return dimensionCompanyDetail.id;
      }
      return 0;
    }

    function getDetails() {
      vm.arrayAproveRefuse = [];
      $rootScope.loadingProgress = true;
      api.ComprasWS.QuotationDetail.me.query(
        {
          companyId: $rootScope.bsCircle.company.id,
          circleId: $rootScope.bsCircle.id,
          quotationId: vm.quotation.id
        },
        function (data) {
          vm.details = data.sort(function (a, b) {
            return a.id - b.id;
          });
          if (vm.isEnterFeatures === true) {
            vm.details = [];
            var productsId = data.map(function (value, index) {
              return value.requisitionDetail.product["id"];
            });
            var companyId = vm.quotation.requisition.department.company.id;
            api.ActivosFijosWS.FixedAssetGroupFeature.me.getProductAddons(
              {
                fixedAssetGroupFeatureId: "getProductAddons",
                companyId: companyId,
                fixedAssetGroupId: 0,
                productsId: productsId.join(","),
                isProvider: true
              },
              function (response) {
                response.forEach(function (productAddons) {
                  var detailFind = _.find(data, function (detail) {
                    return (
                      detail.requisitionDetail.product.id ===
                      productAddons.product.id
                    );
                  });
                  detailFind.fixedAssetGroupId =
                    productAddons.fixedAssetGroupId;
                  vm.details.push(detailFind);
                });
                vm.details = vm.details.sort(function (a, b) {
                  return a.id - b.id;
                });
                vm.completedAllFeatures = _.find(vm.details, function (detail) {
                  return (
                    detail.fixedAssetGroupId &&
                    !detail.completedFeatures === true
                  );
                })
                  ? false
                  : true;
                $rootScope.loadingProgress = false;
              },
              function (response) {
                $rootScope.loadingProgress = false;
                $log.error(response);
              }
            );
          } else {
            $rootScope.loadingProgress = false;
          }

          if (vm.statusToChange.actual === "Autorizado") {
            vm.details = new jinqJs()
              .from(vm.details)
              .where(function (r) {
                return r.bought !== true;
              })
              .select(function (r) {
                return r;
              });
          }
          if (vm.details.length <= 0) {
            goToQuotations();
          }
        },
        function (data) {
          $log.debug(data);
          $rootScope.loadingProgress = false;
        }
      );
    }

    /**
     * Go to Requisitions page
     */
    function goToQuotations() {
      if ($stateParams.backTo && $stateParams.filter && !vm.productId) {
        $state.go($stateParams.backTo, { filter: $stateParams.filter });
      } else if ($stateParams.status) {
        if ($stateParams.status === "Aprobado sin caracteristicas") {
          $state.go("app.quotation.Aprobado_sin_caracteristicas");
        } else {
          $state.go("app.quotation." + $stateParams.status);
        }
      } else if (vm.productId) {
        $state.go("app.quotation.reportDetailPendingApprove.list", { id: vm.productId, backTo: $stateParams.backTo, filter: $stateParams.filter });
      } else {
        $state.go("app.dashboards_project");
      }
    }

    /**
     * Cambia estado a una cotización
     * @param {type} ev
     * @returns {undefined}
     */
    function changeStatus(ev) {
      var confirm = $mdDialog
        .confirm()
        .title(
          $filter("translate")(
            "QUOTATION.MSG." + vm.statusToChange.actual + "_QUOTATION"
          )
        )
        .textContent(
          $filter("translate")(
            "QUOTATION.MSG.CONFIRMACION_" +
            vm.statusToChange.actual +
            "_QUOTATION"
          )
        )
        .ok($filter("translate")("QUOTATION.MSG.SI"))
        .cancel($filter("translate")("QUOTATION.MSG.NO"))
        .targetEvent(ev);

      $mdDialog.show(confirm).then(
        function () {
          if ($stateParams.status === "Autorizado") {
            $rootScope.loadingProgress = true;
            validateFixedAssetApp();
          } else if ($stateParams.status === "Ingresada") {
            authorizeQuotation();
          } else if ($stateParams.status === "Aprobado sin caracteristicas") {
            approveQuotation(ev);
          }
        },
        function () { }
      );
    }

    function validateFixedAssetApp() {
      api.GeneralWS.CompanyApplication.byAppName.get(
        {
          company: vm.quotation.requisition.department.company.id,
          app: "Activos Fijos"
        },
        function (data) {
          if (data.active === true) {
            validateFixedAssets();
          } else {
            approveQuotation();
          }
        },
        function (data) {
          $log.debug(data);
          $rootScope.loadingProgress = false;
        }
      );
    }

    function validateFixedAssets() {
      var productsId = vm.details.map(function (value, index) {
        return value.requisitionDetail.product["id"];
      });
      var companysId = vm.quotation.requisition.department.company.id;
      api.GeneralWS.ProductCompanyAddonsByProductsId.getList(
        {
          'companyId':companysId,
          'productsId': productsId.join(','),
        })
        .$promise.then(
          function (data) {
            if (data.length > 0) {
              validateFixedAssetsByProductAddons(data, productsId);
            } else {
              approveQuotation();
            }
          }
        );
    }

    function validateFixedAssetsByProductAddons(data, productsId) {
      var companysId = vm.quotation.requisition.department.company.id;
      data.map(function (value) {
        api.ActivosFijosWS.FixedAssetGroupFeature.countByCompany.get(
          {
            'companyId': companysId,
            'fixedAssetGroupId': value,
            'productsId': productsId.join(','),
            'isProvider': true,
          },
          function (count) {
            if (count.$status === 204) {
              approveQuotation();
            } else {
              vm.statusToChange.name = "Aprobado sin caracteristicas";
              approveQuotation();
            }
          },
          function (data) {
            $log.debug(data);
            $rootScope.loadingProgress = false;
          }
        );
      });
    }

    function goToChangeStatus() {
      api.ComprasWS.Quotation.changeStatus
        .update({
          companyId: $rootScope.bsCircle.company.id,
          circleId: $rootScope.bsCircle.id,
          status: vm.statusToChange.name,
          quotationId: vm.quotation.id
        })
        .$promise.then(
          function (quotation) {
            if (quotation.quotationStatus.description === "Cambio Proveedor") {
              MessageService.show("QUOTATION.Requisition_updated");
              goToQuotations();
            } else {
              vm.quotation = quotation;
              if (vm.statusToChange.name === "Aprobado sin caracteristicas") {
                var confirm = $mdDialog
                  .confirm()
                  .title($filter("translate")("QUOTATION.DETAIL.FEATURES.ADD"))
                  .textContent(
                    $filter("translate")(
                      "QUOTATION.DETAIL.FEATURES.QUESTION_ADD"
                    )
                  )
                  .ok($filter("translate")("QUOTATION.MSG.SI"))
                  .cancel($filter("translate")("QUOTATION.MSG.NO"))
                  .targetEvent();
                $mdDialog.show(confirm).then(
                  function () {
                    $state.go(
                      "app.quotation.Aprobado_sin_caracteristicas.detail",
                      { id: vm.quotation.id }
                    );
                  },
                  function () {
                    goToQuotations();
                  }
                );
              } else {
                if (vm.statusToChange.name === "Compra Cancelada") {
                  MessageService.show("QUOTATION.QUOTATION_CANCEL");
                } else {
                  MessageService.show("QUOTATION.Requisition_updated");
                }
                goToQuotations();
              }
            }
          },
          function (response) {
            $log.error(response);
            $rootScope.loadingProgress = true;
          }
        );
    }

    /**
     * Aprueba una cotización
     * @param {type} ev
     * @returns {undefined}
     */
    function approveQuotation(ev) {
      var inf = new jinqJs().from(vm.arrayAproveRefuse).select(function (r) {
        delete r.selected;
        return r;
      });
      $mdDialog
        .show({
          controller: "ComposeDialogController",
          controllerAs: "vm",
          templateUrl:
            "app/main/apps/quotation/quotation/compose/compose-dialog.html",
          parent: angular.element("#main"),
          targetEvent: ev,
          quotation: vm.quotation,
          status: vm.statusToChange.name,
          quotationDetails: vm.isEnterFeatures === true ? null : inf,
          id: vm.quotation.id,
          clickOutsideToClose: false
        })
        .then(function (answer) {
          answer === true ? goToQuotations() : getDetails();
          $rootScope.loadingProgress = false;
        }, function () {
          vm.arrayAproveRefuse = [];
          $rootScope.loadingProgress = false;
        });
    }

    function authorizeQuotation() {
      if (!vm.hasBudgetApplication) {
        authorizeQuotationDetail(vm.details, 0);
        return;
      }
      var productsToValidate = new jinqJs()
        .from(vm.details)
        .where(function (r) {
          return (
            r.references.length > 0 &&
            (!r.needAmpliataion || r.requestAmpliation)
          );
        })
        .select(function (r) {
          return {
            id: r.id,
            product: r.requisitionDetail.product,
            amount: r.requestAmpliation
              ? (r.subTotalCompanyBuyer - r.sreferences[0].disponible) /
              r.budgetExchangeRateOfficial
              : r.subTotalCompanyBuyer,
            unitPrice: 0,
            currency: r.currencyCompanyBuyer,
            exchangeRate: r.exchangeRateCompanyBuyer,
            requestAmpliation: r.requestAmpliation,
            references: r.references,
            referenceHeaderId: r.quotation.id
          };
        });

      if (productsToValidate.length <= 0) {
        MessageService.show("QUOTATION.NO_BUDGET_FOR_THIS_PRODUCT");
        return null;
      }

      $rootScope.loadingProgress = true;
      api.PresupuestosWS.Budget.validatesBudgetedProducts
        .validate(
          { idc: vm.circleQuotation.id },
          { quotations: productsToValidate }
        )
        .$promise.then(
          function (response) {
            $rootScope.loadingProgress = false;
            vm.productsToValidate = response;

            var quotationDetailToAuthorize = new jinqJs()
              .from(response)
              .where(function (r) {
                return r.lessOrEqualAmount;
              })
              .select();

            var requestAmpliation = new jinqJs()
              .from(response)
              .where(function (r) {
                return !r.lessOrEqualAmount && r.requestAmpliation;
              })
              .select();

            authorizeQuotationDetail(
              quotationDetailToAuthorize,
              requestAmpliation.length
            );
          },
          function (response) {
            $rootScope.loadingProgress = false;
            $log.error(response);
          }
        );
    }

    function authorizeQuotationDetail(
      quotationDetailToAuthorize,
      lengthrequestAmpliation
    ) {
      var template =
        lengthrequestAmpliation > 0
          ? "{{'QUOTATION.REQUESTED_AMPLIATION'| translate}} " +
          lengthrequestAmpliation +
          " {{'QUOTATION.BUDGETDETAIL'| translate}}"
          : "";
      if (quotationDetailToAuthorize.length === 0) {
        MessageService.show("QUOTATION.NO_BUDGET_FOR_THIS_PRODUCT");
        return null;
      }

      $rootScope.loadingProgress = true;
      api.ComprasWS.Quotation.authorize
        .update(
          {
            companyId: $rootScope.bsCircle.company.id,
            idCircle: $rootScope.bsCircle.id,
            quotationId: vm.quotation.id
          },
          quotationDetailToAuthorize
        )
        .$promise.then(
          function (response) {
            $rootScope.loadingProgress = true;
            var msg = "";
            if (
              response.quotationStatus &&
              response.quotationStatus.description === "Autorizado"
            ) {
              msg = "QUOTATION.QUOTATION_AUTHORIZED_SUCCESSFULLY";
            } else {
              msg = "QUOTATION.QUOTATION_AUTHORIZED_PARTIAL";
            }
            $mdToast.show({
              template:
                '<md-toast layout="column" layout-align="center start"><div class="md-toast-content"><p>' +
                template +
                '<br><br><span translate="' +
                msg +
                '"></span></p></div></md-toast>',
              hideDelay: 3000,
              position: "top right"
            });

            goToQuotations();
          },
          function (response) {
            $log.error(response);
            $rootScope.loadingProgress = true;
          }
        );
    }

    /**
     * Devuelve un objeto con el siguiente estado al que pasa una cotización
     * @returns statusTochange
     */
    function getStatusTochange() {
      switch ($stateParams.status) {
        case "Ingresada":
          statusToChange = {};
          statusToChange.actual = "Ingresada";
          statusToChange.name = "Autorizado";
          statusToChange.icon = "icon-thumb-up-outline";
          statusToChange.buttonDescription = "QUOTATION.AUTHORIZE";
          break;
        case "Autorizado":
          statusToChange = {};
          statusToChange.actual = "Autorizado";
          statusToChange.name = "Aprobado Proveedor";
          statusToChange.icon = "icon-thumb-up-outline";
          statusToChange.buttonDescription = "QUOTATION.APPROVE";
          break;
        case "Aprobado sin caracteristicas":
          statusToChange = {};
          statusToChange.actual = "Aprobado sin caracteristicas";
          statusToChange.name = "Aprobado Proveedor";
          statusToChange.icon = "icon-thumb-up-outline";
          statusToChange.buttonDescription = "QUOTATION.FINALIZE";
          break;
      }
      return statusToChange;
    }

    function validateHasBudgetApplication(id) {
      api.GeneralWS.CompanyApplication.byAppName
        .get({ company: id, app: "Presupuestos" })
        .$promise.then(
          function (responseParameter) {
            if (responseParameter.$status === 200) {
              if (responseParameter.$data && responseParameter.$data !== "") {
                vm.hasBudgetApplication = responseParameter.$data.active;
                if (vm.isCreatedQuotation && vm.hasBudgetApplication) {
                  getBudgets(id);
                }
              }
            }
          },
          function (response) {
            $log.error(response);
          }
        );
    }

    function getQuotation() {
      $rootScope.loadingProgress = true;
      api.ComprasWS.Quotation.Quotation.get(
        { companyId: $rootScope.bsCircle.company.id, id: $stateParams.id },
        function (data) {
          validateHasBudgetApplication(data.requisition.department.company.id);
          vm.statusToChange = getStatusTochange();
          if (!vm.statusToChange) {
            vm.statusToChange = {};
            vm.statusToChange.actual = data.quotationStatus.description;
            vm.statusToChange.name = "Aprobado Proveedor";
            vm.statusToChange.icon = "icon-thumb-up-outline";
            vm.statusToChange.buttonDescription = "QUOTATION.FINALIZE";
          }
          for (var i = 0; i < $rootScope.circles.length; i++) {
            if (
              $rootScope.circles[i].company.id ===
              data.requisition.department.company.id
            ) {
              vm.circleQuotation = $rootScope.circles[i];
              break;
            }
          }
          var maxDatePurchase = new Date(data.requisition.maxDatePurchase);
          data.requisition.maxDatePurchase = new Date();
          data.maxDatePurchase = maxDatePurchase;
          vm.quotation = data;
          if (vm.quotation.quotationStatus.description === "Autorizado") {
            vm.refuseQuotation = true;
          }
          if (vm.quotation.quotationStatus.description !== "Ingresada") {
            vm.viewDetailPermision = true;
          }
          $rootScope.loadingProgress = false;
          getDetails();
          getDimensionCompany();
          for (
            var i = 0;
            i < $rootScope.bsCircle.role.roleSpecialActions.length;
            i++
          ) {
            if (
              $rootScope.bsCircle.role.roleSpecialActions[i].specialAction
                .actionName === "Reasignar Proveedor"
            ) {
              vm.reasignProvider = true;
              break;
            }
          }

          api.ComprasWS.ProcessFlow.get({ id: data.id, type: 2 }, function (
            data
          ) {
            vm.infoProcessFlow = data;
          });
        }
      );
    }

    function addFeatures(detail, index, ev) {
      $mdDialog
        .show({
          controller: "FeaturesDialogController",
          controllerAs: "vm",
          templateUrl:
            "app/main/apps/quotation/quotation/compose/features-dialog.html",
          parent: angular.element("#main"),
          targetEvent: ev,
          quotationDetail: angular.copy(detail),
          quotationId: vm.quotation.id,
          clickOutsideToClose: false
        })
        .then(function (quotationDetail) {
          vm.details[index] = quotationDetail;
          vm.completedAllFeatures = _.find(vm.details, function (detail) {
            return (
              detail.fixedAssetGroupId && !(detail.completedFeatures === true)
            );
          })
            ? false
            : true;
        });
    }

    /**
     * Initialize
     */
    function init() {
      getQuotation();
    }

    $timeout(function () {
      init();
    }, 1000);

    function viewDetail(data, index, ev) {
      api.ComprasWS.QuotationDetailReference.QuotationDetailReference.getQuotationDetail(
        {
          id: "byQuatationDetail",
          circleId: $rootScope.bsCircle.id,
          quotationDetailId: data.id
        },
        function (response) {
          vm.detailReference = response;
          $mdDialog
            .show({
              controller: "QuotationDetailBudgetDialogController",
              controllerAs: "vm",
              templateUrl:
                "app/main/apps/quotation/dialog/quotationDetail-budget/quotationDetail-budget-dialog.html",
              parent: angular.element("#main"),
              targetEvent: ev,
              quotationDetail: angular.copy(response),
              clickOutsideToClose: false
            })
            .then(function (quotationDetail) {
              vm.details[index] = quotationDetail;
            });
        },
        function (errResponse) {
          $log.debug(errResponse);
        }
      );
    }

    function refuseQuotationStatus() {
      var confirm = $mdDialog
        .confirm()
        .title(
          $filter("translate")("QUOTATION.MSG.Rechazada_Proveedor_QUOTATION")
        )
        .textContent(
          $filter("translate")(
            "QUOTATION.MSG.CONFIRMACION_Rechazada_Proveedor_QUOTATION"
          )
        )
        .ok($filter("translate")("QUOTATION.MSG.SI"))
        .cancel($filter("translate")("QUOTATION.MSG.NO"));

      $mdDialog.show(confirm).then(
        function () {
          if (vm.hasBudgetApplication) {
            var productsToValidate = new jinqJs()
              .from(vm.arrayAproveRefuse)
              .select(function (r) {
                return {
                  id: r.id,
                  product: r.requisitionDetail.product,
                  amount: r.subTotal,
                  unitPrice: 0,
                  currency: r.currency,
                  exchangeRate: r.exchangeRate,
                  requestAmpliation: r.requestAmpliation,
                  references: r.references
                };
              });

            if (productsToValidate.length <= 0) {
              MessageService.show("QUOTATION.NO_BUDGET_FOR_THIS_PRODUCT");
              return null;
            }

            $rootScope.loadingProgress = true;
            api.PresupuestosWS.Budget.revertBudgetedProducts
              .revertBudgeted(
                { idc: $rootScope.bsCircle.id },
                productsToValidate
              )
              .$promise.then(
                function (response) {
                  $rootScope.loadingProgress = false;
                  vm.productsToValidate = response;
                  vm.statusToChange.name = "Rechazada Proveedor";
                  refuseStatus();
                },
                function (response) {
                  $rootScope.loadingProgress = false;
                  $log.error(response);
                }
              );
          } else {
            vm.statusToChange.name = "Rechazada Proveedor";
            refuseStatus();
          }
        },
        function () { }
      );
    }

    function refuseStatus() {
      var details = new jinqJs().from(vm.arrayAproveRefuse).select(function (r) {
        delete r.selected;
        return r;
      });
      api.ComprasWS.Quotation.changeStatusRefuse
        .update(
          {
            companyId: $rootScope.bsCircle.company.id,
            circleId: $rootScope.bsCircle.id,
            status: vm.statusToChange.name,
            quotationId: vm.quotation.id
          },
          details
        )
        .$promise.then(
          function (quotation) {
            vm.quotation = quotation;
            showMessageByRequisitionRefuse(details);
            goToQuotations();
            vm.arrayAproveRefuse = [];
          },
          function (response) {
            $log.error(response);
            $rootScope.loadingProgress = true;
          }
        );
    }

    function updateProvider() {
      var confirm = $mdDialog
        .confirm()
        .title($filter("translate")("QUOTATION.MSG.Cambio_Proveedor_QUOTATION"))
        .textContent(
          $filter("translate")(
            "QUOTATION.MSG.CONFIRMACION_Cambio_Proveedor_QUOTATION"
          ) +
          " No." +
          vm.quotation.requisition.id
        )
        .ok($filter("translate")("QUOTATION.MSG.SI"))
        .cancel($filter("translate")("QUOTATION.MSG.NO"));

      $mdDialog.show(confirm).then(
        function () {
          vm.statusToChange.name = "Cambio Proveedor";
          goToChangeStatus();
        },
        function () { }
      );
    }

    function changeCancelStatus() {
      var confirm = $mdDialog
        .confirm()
        .title($filter("translate")("QUOTATION.MSG.Cancelar_Compra_QUOTATION"))
        .textContent(
          $filter("translate")(
            "QUOTATION.MSG.CONFIRMACION_Cancelar_Compra_QUOTATION"
          )
        )
        .ok($filter("translate")("QUOTATION.MSG.SI"))
        .cancel($filter("translate")("QUOTATION.MSG.NO"));

      $mdDialog.show(confirm).then(
        function () {
          vm.statusToChange.name = "Compra Cancelada";
          goToChangeStatus();
        },
        function () { }
      );
    }

    function detailQuotationAproveRefuse(data) {
      if (data.selected) {
        vm.arrayAproveRefuse.push(data);
      } else {
        for (let i = 0; i < vm.arrayAproveRefuse.length; i++) {
          if (vm.arrayAproveRefuse[i].id === data.id) {
            vm.arrayAproveRefuse.splice(i, 1);
          }
        }
      }
    }

    function selectAllDetailQuotationAproveRefuse() {
      vm.arrayAproveRefuse = [];
      for (var i = 0; i < vm.details.length; i++) {
        vm.details[i].selected = vm.selectAll;
        if (vm.selectAll) {
          vm.arrayAproveRefuse.push(vm.details[i]);
        }
      }
    }

    function viewDetailFeatures(detail, index, ev) {
      $mdDialog
        .show({
          controller: "FeaturesDialogController",
          controllerAs: "vm",
          templateUrl:
            "app/main/apps/quotation/quotation/compose/features-dialogView.html",
          parent: angular.element("#main"),
          targetEvent: ev,
          quotationDetail: angular.copy(detail),
          quotationId: vm.quotation.id,
          clickOutsideToClose: false
        })
        .then(function (quotationDetail) {
          vm.details[index] = quotationDetail;
          vm.completedAllFeatures = _.find(vm.details, function (detail) {
            return (
              detail.fixedAssetGroupId && !(detail.completedFeatures === true)
            );
          })
            ? false
            : true;
        });
    }

    function getDimensionCompany() {
      const NUMBER_DIMENSION_THREE = 3;
      const NUMBER_DIMENSION_FOUR = 4;
      const NUMBER_DIMENSION_FIVE = 5;
      api.GeneralWS.DimensionCompany.byCompany.getList(
        { 'company': vm.quotation.requisition.department.company.id }
      ).$promise.then(function (responseDimension) {
        for (let i = 0; i < responseDimension.length; i++) {
          if (responseDimension[i].dimensionNumber === NUMBER_DIMENSION_THREE) {
            vm.dimensionCompanyDetail3 = responseDimension[i];
          } else if (responseDimension[i].dimensionNumber === NUMBER_DIMENSION_FOUR) {
            vm.dimensionCompanyDetail4 = responseDimension[i];
          } else if (responseDimension[i].dimensionNumber === NUMBER_DIMENSION_FIVE) {
            vm.dimensionCompanyDetail5 = responseDimension[i];
          } else {
            vm.dimensionCompanyDetail1 = responseDimension[i];
          }
        }
      });
    }

    function showMessageByRequisitionRefuse(details) {
      const productsIds = details.map(function (value) {
        return value.requisitionDetail.product['id'];
      });
      api.GeneralWS.GetProductCompanyAddons.getByProductsListAndCompany.getList(
        {
          'companyId': vm.quotation.requisition.department.company.id,
          'productsId': productsIds.join()
        }
      ).$promise.then(function (resp) {
        let canReQuote = false;
        for (let i = 0; i < resp.length; i++) {
          if (resp[i].canReQuote) {
            canReQuote = true;
            break;
          }
        }
        if (canReQuote) {
          MessageService.show('QUOTATION.Requisition_updated');
        } else {
          MessageService.show('QUOTATION.Quotation_Refuse');
        }
      });
    }

  }

  function QuotationDetailController($scope, $filter) {
    var row = this;
    var vm = $scope.vm;
    if (vm.isCreatedQuotation === true) {
      $scope.$watch("vm.budgets", function (newVal) {
        row.budgets = [];
        if (newVal) {
          row.budgets = new jinqJs()
            .from(newVal)
            .where(function (r) {
              return (
                r.product.id === $scope.detail.requisitionDetail.product.id
              );
            })
            .select(function (r) {
              r.disponible =
                r.amountOfficial -
                (r.amountExecuted ? r.amountExecuted : 0) -
                (r.amountReserved ? r.amountReserved : 0) -
                (r.amountNotExecuted ? r.amountNotExecuted : 0);
              return r;
            });
        }
      });
      $scope.$watch("detail.sreferences", function (newVal) {
        row.totalBudget = 0;
        $scope.detail.references = [];
        if (newVal) {
          newVal.forEach(function (r) {
            var referenceDetail = {
              referenceId: r.id,
              budgetId: r.budget.id
            };
            $scope.detail.references.push(referenceDetail);
            $scope.detail.budgetExchangeRateOfficial = r.exchangeRateOfficial;
            row.totalBudget += r.disponible;
          });
        }
        $scope.detail.needAmpliataion =
          $scope.detail.references.length > 0 &&
          $scope.detail.subTotal * $scope.detail.quotation.exchangeRate >
          row.totalBudget;
        checkNeedAmpliation();
      });

      $scope.$watch("detail.requestAmpliation", function (nval) {
        checkNeedAmpliation();
      });
    }

    function checkNeedAmpliation() {
      var needs = new jinqJs()
        .from(vm.details)
        .where(function (r) {
          return r.needAmpliataion && r.requestAmpliation;
        })
        .select();
      var budgeteds = new jinqJs()
        .from(vm.details)
        .where(function (r) {
          return r.references ? r.references.length > 0 : false;
        })
        .select();
      if (vm.details.length <= 0) {
        vm.actionmake = false;
      } else if (budgeteds.length <= 0) {
        vm.actionmake = "AUTHORIZE";
      } else if (needs.length <= 0) {
        vm.actionmake = "AUTHORIZE";
      } else if (needs.length === vm.details.length) {
        vm.actionmake = "AMPLIATION";
      } else if (needs.length < vm.details.length) {
        vm.actionmake = "AUTHORIZE_AMPLIATION";
      }

      if (vm.actionmake) {
        vm.statusToChange = {
          buttonDescription: "QUOTATION." + vm.actionmake,
          actual: vm.actionmake
        };
      }
    }

  }
})();

(function () {

    'use strict';

    angular
        .module('app.quotation')
        .controller('QuotationPendingAuthorizeTicketController', QuotationPendingAuthorizeTicketController);

    function QuotationPendingAuthorizeTicketController(
        $rootScope, $scope, $log, api, $filter, $timeout, $state
    ) {

        var vm = this;
        vm.NUMBER_DIMENSION_THREE = 3;
        vm.NUMBER_DIMENSION_FOUR = 4;
        vm.NUMBER_DIMENSION_FIVE = 5;

        //metodos
        vm.goToDetail = goToDetail;

        vm.quotationsToAuthorize = [];
        vm.gridOptions = {
            columnDefs: [
                {
                    headerName: $filter('translate')('authorize_quotations.requisition_number'),
                    field: "requisition.id",
                    width: 135,
                    hide: true,
                    rowGroupIndex: 0,
                    headerCheckboxSelection: true,
                    pinned: "left"
                },
                {
                    headerName: $filter('translate')('authorize_quotations.quotation_number'),
                    field: "id",
                    width: 125
                },
                {
                    headerName: $filter('translate')('authorize_quotations.company'),
                    field: "requisition.department.company.name",
                    width: 150
                },
                {
                    headerName: $filter('translate')('authorize_quotations.department'),
                    field: "requisition.department.description",
                    width: 150
                },
                {
                    headerName: $filter('translate')('authorize_quotations.cost_center'),
                    field: "requisition.costCenter.description",
                    width: 170
                },
                {
                    headerName: $filter('translate')('authorize_quotations.department_origin'),
                    field: "requisition.createdInDepartment.description",
                    width: 150
                },
                {
                    headerName: $filter('translate')('REQUISITION.REQUISITION_TYPE'),
                    field: "requisition.requisitionType.description",
                    width: 170
                },
                {
                    headerName: $filter('translate')('authorize_quotations.id_ticket'),
                    field: "requisition.referenceId",
                    width: 150
                },
                {
                    headerName: $filter('translate')('authorize_quotations.max_date_purchase'),
                    field: "requisition.maxDatePurchase",
                    width: 170,
                    valueFormatter: function (params) {
                        return $filter('date')(params.value, 'dd/MM/yyyy');
                    }
                },
                {
                    headerName: $filter('translate')('authorize_quotations.provider_name'),
                    field: "provider.name",
                    width: 150
                },
                {
                    headerName: $filter('translate')('authorize_quotations.expire_date'),
                    field: "expireDate",
                    width: 170,
                    valueFormatter: function (params) {
                        return $filter('date')(params.value, 'dd/MM/yyyy');
                    }
                },
                {
                    headerName: $filter('translate')('authorize_quotations.currency'),
                    field: "currency.description",
                    width: 150
                },
                {
                    headerName: $filter('translate')('QUOTATION.TOTAL'),
                    field: "total",
                    width: 100,
                    valueFormatter: function (params) {
                        return $filter('number')(params.value, 2);
                    },
                    cellStyle: { 'text-align': 'right' },
                    aggFunc: 'sum'
                }
            ],
            groupHeaders: true,
            groupDefaultExpanded: 1,
            groupSelectsChildren: true,
            rowSelection: 'multiple',
            autoGroupColumnDef: {
                headerName: $filter('translate')('authorize_quotations.requisition_number'),
                field: "requisition.id",
                width: 135,
                cellRenderer: 'group',
                hide: true,
                cellRendererParams: {
                    checkbox: true
                },
                pinned: "left"
            },
            angularCompileRows: true,
            angularCompileHeaders: true,
            suppressRowClickSelection: true,
            enableColResize: true,
            rowData: null,
            rowHeight: 45,
            doesDataFlower: function (dataItem) {
                dataItem.filter = (dataItem.requisition.id + "," + dataItem.id
                    + "," + dataItem.requisition.department.company.name + ","
                    + dataItem.requisition.department.description + ","
                    + dataItem.requisition.costCenter.description + ","
                    + dataItem.provider.name + "," + dataItem.total + ","
                    + dataItem.requisition.createdInDepartment.description + ","
                    + dataItem.requisition.requisitionType.description).toLowerCase();
            },
            onSelectionChanged: selectionChangedFunc,
            isExternalFilterPresent: isExternalFilterPresent,
            doesExternalFilterPass: doesExternalFilterPass
        };


        function selectionChangedFunc(params, other) {

            vm.quotationsToAuthorize = [];

            for (var i = 0; i < vm.gridOptions.api.getSelectedNodes().length; i++) {

                if (!addQuotationToRequisition(vm.gridOptions.api.getSelectedNodes()[i].data)) {
                    var requisition = {
                        companyName: vm.gridOptions.api.getSelectedNodes()[i].data.requisition.department.company.name,
                        departmentName: vm.gridOptions.api.getSelectedNodes()[i].data.requisition.department.description,
                        costCenterDescription: vm.gridOptions.api.getSelectedNodes()[i].data.requisition.costCenter.description,
                        maxDatePurchase: vm.gridOptions.api.getSelectedNodes()[i].data.requisition.maxDatePurchase,
                        originType: vm.gridOptions.api.getSelectedNodes()[i].data.requisition.originType,
                        referenceId: vm.gridOptions.api.getSelectedNodes()[i].data.requisition.referenceId,
                        departmentId: vm.gridOptions.api.getSelectedNodes()[i].data.requisition.department.id,
                        costCenterId: vm.gridOptions.api.getSelectedNodes()[i].data.requisition.costCenter.id,
                        companyId: vm.gridOptions.api.getSelectedNodes()[i].data.requisition.department.company.id,
                        requisitionId: vm.gridOptions.api.getSelectedNodes()[i].data.requisition.id,
                        quotations: [vm.gridOptions.api.getSelectedNodes()[i].data],
                        dimensionCompanyDetail3Id: getDimensionCompanyDetail(i, vm.NUMBER_DIMENSION_THREE, 'id'),
                        dimensionCompanyDetail3Name: getDimensionCompanyDetail(i, vm.NUMBER_DIMENSION_THREE, 'name'),
                        dimensionCompanyDetail4Id: getDimensionCompanyDetail(i, vm.NUMBER_DIMENSION_FOUR, 'id'),
                        dimensionCompanyDetail4Name: getDimensionCompanyDetail(i, vm.NUMBER_DIMENSION_FOUR, 'name'),
                        dimensionCompanyDetail5Id: getDimensionCompanyDetail(i, vm.NUMBER_DIMENSION_FIVE, 'id'),
                        dimensionCompanyDetail5Name: getDimensionCompanyDetail(i, vm.NUMBER_DIMENSION_FIVE, 'name')
                    };

                    vm.quotationsToAuthorize.push(requisition);
                }

            }

            $scope.$apply();

        }

        var filter = 'everyone';

        function isExternalFilterPresent() {
            return filter !== '';
        }

        function doesExternalFilterPass(node) {
            if (filter && filter !== 'everyone') {
                var arrdt = node.data.filter.split(filter.toLowerCase());
                return arrdt.length > 1;
            }
            return true;
        }

        $timeout(function () {
            $scope.$watch('vm.search',
                function (newValue) {
                    filter = newValue;
                    if (vm.gridOptions.api) {
                        vm.gridOptions.api.onFilterChanged();
                    }
                }
            );
        }, 500);

        function addQuotationToRequisition(quotation) {
            for (var i = 0; i < vm.quotationsToAuthorize.length; i++) {
                if (quotation.requisition.id === vm.quotationsToAuthorize[i].requisitionId) {
                    vm.quotationsToAuthorize[i].quotations.push(quotation);
                    return true;
                }
            }

            return false;
        }

        function goToDetail() {

            $state.go('app.quotation.IngresadaTicket.detail', { 'requisitionArray': vm.quotationsToAuthorize });

        }

        function getQuotations() {

            $rootScope.loadingProgress = true;
            api.ComprasWS.Quotation.findByStatusTicket.query(
                { 'companyId': $rootScope.bsCircle.company.id, 'statusName': 'Ingresada' }).$promise.then(function (response) {
                    $rootScope.loadingProgress = false;
                    addColumnsDimensions();
                    vm.gridOptions.api.setRowData(response);
                    vm.showGrid = true;

                }, function (response) {
                    $rootScope.loadingProgress = false;
                    $log.error(response);
                });
        }

        function addColumnsDimensions() {
            api.GeneralWS.DimensionCompany.byCompany.getList(
                { 'company': $rootScope.bsCircle.company.id }
            ).$promise.then(function (responseDimension) {
                for (let i = 0; i < responseDimension.length; i++) {
                    if (responseDimension[i].dimensionNumber === vm.NUMBER_DIMENSION_THREE) {
                        vm.dimensionCompanyDetail3 = responseDimension[i];
                        addMasterColumnDefs(responseDimension[i].description, 'requisition.dimensionCompanyDetail3.name', responseDimension[i].dimensionNumber);
                    } else if (responseDimension[i].dimensionNumber === vm.NUMBER_DIMENSION_FOUR) {
                        addMasterColumnDefs(responseDimension[i].description, 'requisition.dimensionCompanyDetail4.name', responseDimension[i].dimensionNumber);
                    } else if (responseDimension[i].dimensionNumber === vm.NUMBER_DIMENSION_FIVE) {
                        addMasterColumnDefs(responseDimension[i].description, 'requisition.dimensionCompanyDetail5.name', responseDimension[i].dimensionNumber);
                    } else {
                        vm.dimensionCompanyDetail1 = '';
                    }
                }
                const NUMBER_EIGHT_HUNDRED = 800;
                $timeout(function () {
                    vm.gridOptions.api.setColumnDefs(vm.gridOptions.columnDefs);
                }, NUMBER_EIGHT_HUNDRED);
            });
        }

        function addMasterColumnDefs(name, fieldName, number) {
            const NUMBER_COLUMN_ADD = 2;
            vm.gridOptions.columnDefs.splice((number + NUMBER_COLUMN_ADD), 0, {
                headerName: name,
                field: fieldName,
                headerCellRenderer: getHeader,
                width: 200,
                enableRowGroup: true,
                filter: 'text',
                enablePivot: true,
                cellRenderer: cellRendererColumnDimension()
            });
        }

        function getDimensionCompanyDetail(i, number, property) {
            if (vm.gridOptions.api.getSelectedNodes()[i].data.requisition['dimensionCompanyDetail' + number]) {
                return vm.gridOptions.api.getSelectedNodes()[i].data.requisition['dimensionCompanyDetail' + number][property];
            }
            return '';
        }

        function cellRendererColumnDimension() {
            return function (params) {
                if (params && params.data && params.data.requisition && params.data.requisition.department.company.id === $rootScope.bsCircle.company.id) {
                    return params.value;
                }
                return '';
            }
        }

        function init() {
            getQuotations();
        }

        $timeout(init, 500);

    }

})();

(function () {

    'use strict';

    angular
        .module('app.quotation')
        .controller('QuotationPendingAuthorizeController', QuotationPendingAuthorizeController);

    function QuotationPendingAuthorizeController($rootScope, $scope, $log, api, $filter, $timeout, $state) {

        var vm = this;

        //metodos
        vm.goToDetail = goToDetail;
        vm.totalPending = 0;
        vm.NUMBER_DIMENSION_THREE = 3;
        vm.NUMBER_DIMENSION_FOUR = 4;
        vm.NUMBER_DIMENSION_FIVE = 5;

        vm.quotationsToAuthorize = [];
        vm.gridOptions = {
            columnDefs: [
                {
                    headerName: $filter('translate')('authorize_quotations.requisition_number'),
                    field: "requisition.id",
                    width: 135,
                    hide: true,
                    rowGroupIndex: 0,
                    headerCheckboxSelection: true,
                    pinned: "left"
                },
                {
                    headerName: $filter('translate')('authorize_quotations.quotation_number'),
                    field: "id",
                    width: 125
                },
                {
                    headerName: $filter('translate')('authorize_quotations.company'),
                    field: "requisition.department.company.name",
                    width: 150
                },
                {
                    headerName: $filter('translate')('authorize_quotations.department'),
                    field: "requisition.department.description",
                    width: 150
                },
                {
                    headerName: $filter('translate')('authorize_quotations.cost_center'),
                    field: "requisition.costCenter.description",
                    width: 170
                },
                {
                    headerName: $filter('translate')('REQUISITION.REQUISITION_TYPE'),
                    field: "requisition.requisitionType.description",
                    width: 170
                },
                {
                    headerName: $filter('translate')('authorize_quotations.max_date_purchase'),
                    field: "requisition.maxDatePurchase",
                    width: 170,
                    valueFormatter: function (params) {
                        return $filter('date')(params.value, 'dd/MM/yyyy');
                    }
                },
                {
                    headerName: $filter('translate')('authorize_quotations.provider_name'),
                    field: "provider.name",
                    width: 150
                },
                {
                    headerName: $filter('translate')('authorize_quotations.expire_date'),
                    field: "expireDate",
                    width: 170,
                    valueFormatter: function (params) {
                        return $filter('date')(params.value, 'dd/MM/yyyy');
                    }
                },
                {
                    headerName: $filter('translate')('authorize_quotations.currency'),
                    field: "currency.description",
                    width: 150
                },
                {
                    headerName: $filter('translate')('QUOTATION.TOTAL'),
                    field: "total",
                    width: 100,
                    valueFormatter: function (params) {
                        return $filter('number')(params.value, 2);
                    },
                    cellStyle: { 'text-align': 'right' },
                    aggFunc: 'sum'
                }
            ],
            groupHeaders: true,
            groupDefaultExpanded: 1,
            groupSelectsChildren: true,
            rowSelection: 'multiple',
            autoGroupColumnDef: {
                headerName: $filter('translate')('authorize_quotations.requisition_number'),
                field: "requisition.id",
                width: 135,
                cellRenderer: 'group',
                hide: true,
                cellRendererParams: {
                    checkbox: true
                },
                pinned: "left"
            },
            angularCompileRows: true,
            angularCompileHeaders: true,
            suppressRowClickSelection: true,
            enableColResize: true,
            rowData: null,
            rowHeight: 45,
            onSelectionChanged: selectionChangedFunc,
            doesDataFlower: function (dataItem) {
                dataItem.filter = (dataItem.requisition.id + ","
                    + dataItem.id + "," + dataItem.requisition.department.company.name
                    + "," + dataItem.requisition.department.description + ","
                    + dataItem.requisition.costCenter.description + ","
                    + dataItem.provider.name + "," + dataItem.total + "," + dataItem.requisition.requisitionType.description).toLowerCase();
            },
            isExternalFilterPresent: isExternalFilterPresent,
            doesExternalFilterPass: doesExternalFilterPass
        };

        function selectionChangedFunc(params, other) {

            vm.quotationsToAuthorize = [];

            for (var i = 0; i < vm.gridOptions.api.getSelectedNodes().length; i++) {

                if (!addQuotationToRequisition(vm.gridOptions.api.getSelectedNodes()[i].data)) {
                    var requisition = {
                        companyName: vm.gridOptions.api.getSelectedNodes()[i].data.requisition.department.company.name,
                        departmentName: vm.gridOptions.api.getSelectedNodes()[i].data.requisition.department.description,
                        costCenterDescription: vm.gridOptions.api.getSelectedNodes()[i].data.requisition.costCenter.description,
                        maxDatePurchase: vm.gridOptions.api.getSelectedNodes()[i].data.requisition.maxDatePurchase,
                        originType: vm.gridOptions.api.getSelectedNodes()[i].data.requisition.originType,
                        referenceId: vm.gridOptions.api.getSelectedNodes()[i].data.requisition.referenceId,
                        departmentId: vm.gridOptions.api.getSelectedNodes()[i].data.requisition.department.id,
                        costCenterId: vm.gridOptions.api.getSelectedNodes()[i].data.requisition.costCenter.id,
                        companyId: vm.gridOptions.api.getSelectedNodes()[i].data.requisition.department.company.id,
                        requisitionId: vm.gridOptions.api.getSelectedNodes()[i].data.requisition.id,
                        quotations: [vm.gridOptions.api.getSelectedNodes()[i].data],
                        dimensionCompanyDetail3Id: getDimensionCompanyDetail(i, vm.NUMBER_DIMENSION_THREE, 'id'),
                        dimensionCompanyDetail3Name: getDimensionCompanyDetail(i, vm.NUMBER_DIMENSION_THREE, 'name'),
                        dimensionCompanyDetail4Id: getDimensionCompanyDetail(i, vm.NUMBER_DIMENSION_FOUR, 'id'),
                        dimensionCompanyDetail4Name: getDimensionCompanyDetail(i, vm.NUMBER_DIMENSION_FOUR, 'name'),
                        dimensionCompanyDetail5Id: getDimensionCompanyDetail(i, vm.NUMBER_DIMENSION_FIVE, 'id'),
                        dimensionCompanyDetail5Name: getDimensionCompanyDetail(i, vm.NUMBER_DIMENSION_FIVE, 'name')
                    };

                    vm.quotationsToAuthorize.push(requisition);
                }

            }

            $scope.$apply();

        }

        var filter = 'everyone';

        function isExternalFilterPresent() {
            return filter !== '';
        }

        function doesExternalFilterPass(node) {
            if (filter && filter !== 'everyone') {
                var arrdt = node.data.filter.split(filter.toLowerCase());
                return arrdt.length > 1;
            }
            return true;
        }

        $timeout(function () {
            $scope.$watch('vm.search',
                function (newValue) {
                    filter = newValue;
                    if (vm.gridOptions.api) {
                        vm.gridOptions.api.onFilterChanged();
                    }
                }
            );
        }, 500);



        function addQuotationToRequisition(quotation) {
            for (var i = 0; i < vm.quotationsToAuthorize.length; i++) {
                if (quotation.requisition.id === vm.quotationsToAuthorize[i].requisitionId) {
                    vm.quotationsToAuthorize[i].quotations.push(quotation);
                    return true;
                }
            }

            return false;
        }

        function goToDetail() {

            $state.go('app.quotation.Ingresada.detail', { 'requisitionArray': vm.quotationsToAuthorize });

        }

        function getQuotations() {

            $rootScope.loadingProgress = true;
            api.ComprasWS.Quotation.findByStatus.query(
                { 'companyId': $rootScope.bsCircle.company.id, 'statusName': 'Ingresada' }).$promise.then(function (response) {
                    addColumnsDimensions();
                    $rootScope.loadingProgress = false;
                    vm.totalPending = response.length;
                    vm.gridOptions.api.setRowData(response);
                    vm.showGrid = true;

                }, function (response) {
                    $rootScope.loadingProgress = false;
                    $log.error(response);
                });
        }

        function addColumnsDimensions() {
            api.GeneralWS.DimensionCompany.byCompany.getList(
                { 'company': $rootScope.bsCircle.company.id }
            ).$promise.then(function (responseDimension) {
                for (let i = 0; i < responseDimension.length; i++) {
                    if (responseDimension[i].dimensionNumber === vm.NUMBER_DIMENSION_THREE) {
                        vm.dimensionCompanyDetail3 = responseDimension[i];
                        addMasterColumnDefs(responseDimension[i].description, 'requisition.dimensionCompanyDetail3.name', responseDimension[i].dimensionNumber);
                    } else if (responseDimension[i].dimensionNumber === vm.NUMBER_DIMENSION_FOUR) {
                        addMasterColumnDefs(responseDimension[i].description, 'requisition.dimensionCompanyDetail4.name', responseDimension[i].dimensionNumber);
                    } else if (responseDimension[i].dimensionNumber === vm.NUMBER_DIMENSION_FIVE) {
                        addMasterColumnDefs(responseDimension[i].description, 'requisition.dimensionCompanyDetail5.name', responseDimension[i].dimensionNumber);
                    }
                }
                $timeout(function () {
                    vm.gridOptions.api.setColumnDefs(vm.gridOptions.columnDefs);
                }, 800);
            });
        }

        function addMasterColumnDefs(name, fieldName, number) {
            const NUMBER_COLUMN_ADD = 2;
            vm.gridOptions.columnDefs.splice((number + NUMBER_COLUMN_ADD), 0, {
                headerName: name,
                field: fieldName,
                headerCellRenderer: getHeader,
                width: 200,
                enableRowGroup: true,
                filter: 'text',
                enablePivot: true,
                cellRenderer: cellRendererColumnDimension()
            });
        }

        function getDimensionCompanyDetail(i, number, property) {
            if (vm.gridOptions.api.getSelectedNodes()[i].data.requisition['dimensionCompanyDetail' + number]) {
                return vm.gridOptions.api.getSelectedNodes()[i].data.requisition['dimensionCompanyDetail' + number][property];
            }
            return '';
        }

        function cellRendererColumnDimension() {
            return function (params) {
                if (params && params.data && params.data.requisition && params.data.requisition.department.company.id === $rootScope.bsCircle.company.id) {
                    return params.value;
                }
                return '';
            }
        }

        function init() {
            getQuotations();
        }

        $timeout(init, 500);

    }

})();

(function () {

    'use strict';

    angular
        .module('app.quotation.create', [])
        .config(config);

    /**@ngInject**/
    function config($stateProvider, $translatePartialLoaderProvider) {
        $translatePartialLoaderProvider.addPart('app/main/apps/quotation/create');

        $stateProvider
            .state('app.quotation.new', {
                url: '/create',
                params: {
                    quotationId: 0,
                    requisitionId: null,
                    detailsListId: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/quotation/create/views/create.html',
                        controller: 'CreateQuotationController',
                        controllerAs: 'vm'
                    }
                }
            });

    }

})();

(function () {

    'use strict';

    angular
        .module('app.quotation.create')
        .controller('CreateQuotationController', createQuotationController);

    /**@ngInject**/
    function createQuotationController($rootScope, $state, $stateParams, api, $log, MessageService, $timeout, $mdDialog) {

        var vm = this;
        vm.filesToUpload = [];
        vm.maxNumberFiles = 1;
        vm.quotationId = $stateParams.quotationId;
        vm.quotationDetailArray = [];
        vm.quotationDetailArraySave = [];
        vm.currencyArray = [];
        vm.stepper;
        vm.loading = false;
        vm.paginationCompanies = {
            pageNumber: 1,
            pageSize: 100,
            totalElements: 0,
            totalPages: 0,
            numberOfElements: 0,
            nextPage: function () {
                this.pageNumber++;
            },
            beforePage: function () {
                this.pageNumber--;
            },
            firstPage: function () {
                this.pageNumber = 1;
            },
            lastPage: function () {
                this.pageNumber = this.totalPages;
            },
            getPage: function (pageNumber) {
                this.pageNumber = pageNumber;
                getAllCompanies();
            }
        };
        vm.toggleCompany = toggleCompany;
        vm.quotation = {
            id: 0,
            expireDate: new Date(),
            total: 0,
            exchangeRate: 1
        };
        vm.minExpireDate = new Date();

        //Metodos:
        vm.calculateSubtotal = calculateSubtotal;
        vm.getAllCompanies = getAllCompanies;
        vm.create = create;
        vm.changeAllTaxesIncluded = changeAllTaxesIncluded;
        vm.detailQuotation = detailQuotation;
        vm.selectAllDetailQuotation = selectAllDetailQuotation;
        vm.viewTaxeRow = viewTaxeRow;

        function getRequisitionDetail() {
            $rootScope.loadingProgress = true;
            api.ComprasWS.RequisitionDetail.query(
                {
                    'idRequisition': $stateParams.requisitionId,
                    'idCircle': $rootScope.bsCircle.id,
                    'cotized': true, detailsList: $stateParams.detailsListId
                }).$promise.then(function (response) {
                    $rootScope.loadingProgress = false;

                    if (response.length > 0) {

                        vm.quotation.requisition = response[0].requisition;
                        getAllCompanies();

                        response = new jinqJs()
                            .from(response)
                            .orderBy([{ field: 'id', sort: 'asc' }])
                            .select();

                        response.forEach(function (row) {
                            vm.quotationDetailArray.push({
                                requisitionDetail: row,
                                quotation: null,
                                price: null,
                                currency: null,
                                subTotal: 0,
                                exchangeRate: 1,
                                taxesIncluded: true,
                                selected: true
                            });
                        });
                        vm.taxesIncludedAll = true;
                        vm.selectAll = true;
                        vm.quotationDetailArraySave = vm.quotationDetailArray;
                    }
                }, function (response) {
                    $rootScope.loadingProgress = false;
                    $log.error(response);
                });
        }

        function getCurrency() {
            api.GeneralWS.Currency.query({}).$promise.then(function (response) {
                vm.currencyArray = response;
                if (response.length === 1) {
                    $timeout(function () {
                        vm.quotationDetailArraySave.forEach(function (row) {
                            row.currency = response[0];
                        });
                    }, 2000);

                    vm.quotation.currency = response[0];
                }
            }, function (response) {
                $log.error(response);
            });
        }

        function toggleCompany(event, company) {
            vm.quotation.provider = company;
        }

        function getAllCompanies() {
            vm.isShowLoaderCompanies = true;
            api.GeneralWS.getAllCompaniesProviders.page(
                {
                    'pageNumber': vm.paginationCompanies.pageNumber,
                    'pageSize': vm.paginationCompanies.pageSize, 'search': vm.searchCompanyInput,
                    'companyId': vm.quotation.requisition.department.company.id, 'includeMe': false
                }).$promise.then(function (response) {
                    vm.isShowLoaderCompanies = false;
                    vm.companyArray = response.content;
                    vm.paginationCompanies.totalElements = response.totalElements;
                    vm.paginationCompanies.totalPages = response.totalPages;
                    vm.paginationCompanies.numberOfElements = response.numberOfElements;
                }, function (response) {
                    vm.isShowLoaderCompanies = false;
                    $log.error(response);
                });
        }

        function calculateSubtotal(event, quotationDetail) {
            vm.quotation.total = 0;

            if (quotationDetail.price === null || quotationDetail.price === undefined || quotationDetail.price === "") {
                quotationDetail.subTotal = 0;
            } else {
                quotationDetail.price = validateNumberDecimal(quotationDetail.price, 6);
                quotationDetail.subTotal = quotationDetail.requisitionDetail.quantity * quotationDetail.price;
                var toFixed = quotationDetail.subTotal.toFixed(2);
                quotationDetail.subTotal = parseFloat(toFixed);
            }

            vm.quotationDetailArray.forEach(function (row) {
                vm.quotation.total += row.subTotal;
            });

            vm.totalQuotation = vm.quotation.total;
        }

        function create() {
            vm.loading = true;
            if (vm.quotation.provider === null || vm.quotation.provider === undefined) {
                MessageService.show("QUOTATION.CREATE.SELECT_PROVIDER");
                return null;
            }

            if (vm.quotation.currency === null || vm.quotation.currency === undefined) {
                MessageService.show("QUOTATION.CREATE.SELECT_CURRENCY");
                return null;
            }

            if (vm.quotation.expireDate === null) {
                MessageService.show("QUOTATION.CREATE.ENTER_EXPIRE_DATE");
                return null;
            }

            if (vm.quotation.exchangeRate === null) {
                MessageService.show("QUOTATION.CREATE.VERIFY_ENTER_ALL_EXCHANGE_RATE");
                return null;
            }

            if (vm.quotation.exchangeRate <= 0) {
                MessageService.show("QUOTATION.CREATE.VERIFY_ENTER_ALL_EXCHANGE_RATE");
                return null;
            }

            //valida que hayan ingresado precios validos
            var priceValid = true;
            var exchangeRateValid = true;

            var hasNegativPrice = false;
            var hasNegativeExchangeRate = false;

            vm.quotationcreateDetail = new jinqJs()
                .from(vm.quotationDetailArraySave)
                .where(function (r) {
                    return (r.selected === true && r.price);
                })
                .select(function (r) {
                    return r;
                });

            vm.quotationcreateDetail.forEach(function (row) {
                row.quotation = angular.copy(vm.quotation);

                if (row.price === undefined || row.price === null || row.price === 0) {
                    priceValid = false;
                } else if (row.price < 0) {
                    hasNegativPrice = true;
                }

                if (row.exchangeRate === undefined || row.exchangeRate === null) {
                    exchangeRateValid = false;
                } else if (row.exchangeRate < 0) {
                    hasNegativeExchangeRate = true;
                }
            });

            if (!priceValid) {
                MessageService.show("QUOTATION.CREATE.VERIFY_ENTER_ALL_PRICES");
                return null;
            }

            if (hasNegativPrice) {
                MessageService.show("QUOTATION.CREATE.YOU_CAN_NOT_ENTER_NEGATIVE_PRICES");
                return null;
            }

            if (!exchangeRateValid) {
                MessageService.show("QUOTATION.CREATE.VERIFY_ENTER_ALL_EXCHANGE_RATE");
                return null;
            }

            if (hasNegativeExchangeRate) {
                MessageService.show("QUOTATION.CREATE.YOU_CAN_NOT_ENTER_NEGATIVE_EXCHANGE_RATE");
                return null;
            }

            if (vm.filesToUpload.length > 0) {
                saveFiles(vm.quotation);
            } else {
                createDetail(vm.quotation);
            }
        }

        function createDetail(data) {
            $rootScope.loadingProgress = true;

            api.ComprasWS.QuotationDetail.me.create(
                {
                    'companyId': $rootScope.bsCircle.company.id,
                    'quotationId': vm.quotation.id, autorized: false
                }, vm.quotationcreateDetail).$promise.then(function (response) {
                    $rootScope.loadingProgress = false;
                    MessageService.show("QUOTATION.CREATE.QUOTATION_CREATED_SUCCESSFULLY");

                    redirectAfterSave();

                }, function (response) {
                    $rootScope.loadingProgress = false;
                    MessageService.show("QUOTATION.CREATE.ERROR");
                    vm.loading = false;
                    $log.error(response);
                });
        }

        function redirectAfterSave() {
            if (vm.quotation.requisition.originType && vm.quotation.requisition.originType.originTypeCode === '01') {
                $state.go('app.requisition.AutorizadoTickets', {});
            } else if ($rootScope.bsCircle.name === 'ROLE_COMPRAS_OPERADOR') {
                $state.go('app.requisition.MisAutorizados', {});
            } else {
                $state.go('app.requisition.Autorizado', {});
            }
        }

        function saveFiles(data) {
            var files = [];

            vm.filesToUpload.forEach(function (r) {
                files.push(r.file.file);
            });

            $rootScope.loadingProgress = true;
            api.GeneralWS.Common.FileStorage.filesUpload.add({ 'companyId': $rootScope.bsCircle.company.id }, files).then(function (response) {
                $rootScope.loadingProgress = false;
                vm.quotationDetailArray.forEach(function (row) {
                    if (row.quotation) {
                        row.quotation.files = response.data;
                    }
                });
                createDetail();
            }, function (errResponse) {
                $log.error(errResponse);
                $rootScope.loadingProgress = false;
                vm.loading = false;
            });
        }

        function validateNumberDecimal(origin, quantityDecimals) {
            var numbers;
            var isPoint = true;
            numbers = origin.toString().split(".");
            if (numbers.length === 1) {
                numbers = origin.toString().split(",");
                if (numbers.length > 1) {
                    isPoint = false;
                }
            }
            if (numbers.length === 2) {
                $log.debug(numbers[1].toString().length);
                if (numbers[1].toString().length > quantityDecimals) {
                    numbers[1] = numbers[1].substring(0, quantityDecimals);
                    if (isPoint) {
                        var number = parseFloat(numbers.join("."));
                        origin = number;
                    } else {
                        var number = parseFloat(numbers.join(","));
                        origin = number;
                    }
                }
            }
            return origin;
        }

        $timeout(function () {
            getRequisitionDetail();
            getCurrency();

        }, 1000);

        function changeAllTaxesIncluded() {
            vm.quotationDetailArray.forEach(function (row) {
                row.taxesIncluded = vm.taxesIncludedAll;
            });
            if (vm.quotationDetailArraySave.length > 0) {
                vm.quotationDetailArraySave.forEach(function (row) {
                    row.taxesIncluded = vm.taxesIncludedAll;
                });
            }
        }

        function detailQuotation(data) {
            if (data.selected) {
                data.price = 0;
                vm.quotationDetailArraySave.push(data);
                vm.calculateSubtotal(null, data);
            } else {
                data.price = 0;
                vm.calculateSubtotal(null, data);
            }

        }

        function selectAllDetailQuotation() {
            vm.quotationDetailArraySave = [];
            for (var i = 0; i < vm.quotationDetailArray.length; i++) {
                vm.quotationDetailArray[i].selected = vm.selectAll;
                if (vm.selectAll) {
                    vm.quotationDetailArraySave.push(vm.quotationDetailArray[i]);
                } else {
                    vm.quotationDetailArraySave = [];
                    vm.quotationDetailArray.forEach(function (row) {
                        row.price = 0;
                        vm.calculateSubtotal(null, row);
                    });
                }
            }
        }

        function viewTaxeRow(data) {
            if (vm.quotationDetailArraySave.length > 0) {
                vm.quotationDetailArraySave.forEach(function (row) {
                    if (row.requisitionDetail.id === data.requisitionDetail.id) {
                        row.taxesIncluded = data.taxesIncluded;
                    }
                });
            }
        }

        vm.showHistory = function (data) {
            $mdDialog.show({
                controller: 'QuotationHistoryProductController',
                controllerAs: 'vm',
                locals: {
                    'quotationDetail': data,
                    'departmentId': vm.quotation.requisition.department.id,
                    'costCenterId': vm.quotation.requisition.costCenter.id
                },
                templateUrl: 'app/main/apps/quotation/pending-authorize/detail/show-history-product/history-product.html',
                parent: angular.element("#main"),
                targetEvent: null,
                clickOutsideToClose: false
            }).then(function (response) {
                if (response) {
                }
            }, function () {
            });
        };

    }

})();

(function () {
    'use strict';

    angular
        .module('app.requisition')
        .controller('RequisitionsAutorizeController', RequisitionsController);

    /** @ngInject */
    function RequisitionsController($state, api, $rootScope, $log, $mdDialog, $filter, $timeout,
        $scope, $stateParams, MessageService, $templateRequest) {
        var vm = this;

        vm.statusNameByRole = "";
        vm.iconChangeStatusButton = "";
        vm.showChangeStatusButton = false;
        vm.isCreate = $stateParams.status === 'Creando';
        vm.statusToChange = $stateParams.status;
        vm.isTicket = $stateParams.tickets;
        vm.chageStatusButton = getDatasToChange($stateParams.status);
        vm.isBuyer = $stateParams.isBuyer;
        vm.pageSize = 100;
        vm.page = 0;
        vm.requisitionToAuthorize = [];
        vm.authorizeRequisitions = authorizeRequisitions;
        vm.cancelRequisitions = cancelRequisitions;
        vm.userToQuote = $rootScope.bsCircle.name === 'ROLE_COMPRAS_OPERADOR';

        vm.masterColumnDefs = [
            {
                headerName: '#',
                field: "id",
                width: 135,
                cellRenderer: 'group',
                cellRendererParams: {
                    checkbox: true
                },
                pinned: 'left'
            },
            {
                headerName: 'REQUISITION.DEPARTMENT',
                field: "department.description",
                headerCellRenderer: getHeader,
                width: 250,
                filter: 'text',
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'REQUISITION.COSTCENTER',
                field: "costCenter.description",
                headerCellRenderer: getHeader,
                width: 200,
                filter: 'text',
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'REQUISITION.PROJECT',
                field: "prjName",
                headerCellRenderer: getHeader,
                width: 150,
                filter: 'text',
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'REQUISITION.MAXDATEPURCHASE',
                field: "maxDatePurchase",
                headerCellRenderer: getHeader,
                valueFormatter: function (params) {
                    return $filter('date')(params.value, 'dd/MM/yyyy');
                },
                enableRowGroup: true,
                filter: 'date',
                enablePivot: true
            },
            {
                headerName: 'REQUISITION.REQUISITION_TYPE',
                field: "requisitionType.description",
                headerCellRenderer: getHeader,
                valueFormatter: function (params) {
                    return $filter('date')(params.value, 'dd/MM/yyyy');
                },
                enableRowGroup: true,
                filter: 'date',
                enablePivot: true
            },
            {
                headerName: 'REQUISITION.DESCRIPTION',
                field: "description",
                headerCellRenderer: getHeader,
                valueFormatter: function (params) {
                    return $filter('date')(params.value, 'dd/MM/yyyy');
                },
                enableRowGroup: true,
                filter: 'date',
                enablePivot: true
            },
            {
                headerName: 'REQUISITION.ACTIONS',
                name: "actions",
                headerCellRenderer: getHeader,
                suppressSorting: true,
                suppressMenu: true,
                width: 250,
                cellRenderer: renderer,
                cellStyle: { 'padding': '0px' },
                pinned: 'right'
            }
        ];

        if ($stateParams.status === 'Autorizado') {
            vm.masterColumnDefs.splice(4, 0, {
                headerName: 'REQUISITION.STATUS',
                field: "purchaseStatus.description",
                headerCellRenderer: getHeader,
                width: 200,
                enableRowGroup: true,
                filter: 'text',
                enablePivot: true
            });
        }

        if ($stateParams.status === 'Ingresado' || $stateParams.status === "Autorizado") {
            vm.masterColumnDefs.splice(1, 0, {
                headerName: 'REQUISITION.COMPANY_BUYER',
                field: "department.company.name",
                headerCellRenderer: getHeader,
                width: 200,
                filter: 'text',
                enableRowGroup: true,
                enablePivot: true
            });
        }

        vm.masterGridOptions = {
            columnDefs: vm.masterColumnDefs,
            enableSorting: true,
            debug: false,
            enableFilter: true,
            enableColResize: true,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowData: null,
            headerHeight: 50,
            rowHeight: 40,
            onSelectionChanged: selectionChangedFunc,
            groupHeaders: false,
            rowModelType: "enterprise",
            rowSelection: 'multiple',
            toolPanelSuppressGroups: true,
            pagination: true,
            paginationPageSize: vm.pageSize,
            cacheBlockSize: vm.pageSize,
            groupSuppressBlankHeader: true,
            suppressRowClickSelection: true,
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            },
            doesDataFlower: function (dataItem) {
                return true;
            },
            isExternalFilterPresent: isExternalFilterPresent,
            doesExternalFilterPass: doesExternalFilterPass,
            fullWidthCellRenderer: getDetails,
            isFullWidthCell: function (rowNode) {
                return rowNode.level === 1;
            },
            getRowHeight: function (params) {
                var rowIsDetailRow = params.node.level === 1;
                return rowIsDetailRow ? 250 : 45;
            },
            onGridReady: function (params) {

            }
        };

        vm.masterColumnDefs.forEach(function (d) {
            correctFilterParams(d);
        });

        var templateDetail;
        $templateRequest("app/main/apps/requisition/requisition-autorize/detailRow/requisitionDetail.html").then(function (template) {
            templateDetail = template;
        }, function () {
        });

        function getDetails(params) {
            params.$scope.id = 'det' + params.data.id;

            params.$scope.dtOptions = {
                dom: 'rt',
                scrollY: '200px',
                responsive: true
            };

            var mouseWheelListener = function (event) {
                event.stopPropagation();
            };

            setTimeout(function () {
                var container = document.querySelector("#containerDetailNeg" + params.$scope.id);
                if (container) {
                    container.addEventListener('mousewheel', mouseWheelListener);
                    container.addEventListener('DOMMouseScroll', mouseWheelListener);
                }

                api.ComprasWS.RequisitionDetail.query({ idCircle: $rootScope.bsCircle.id, idRequisition: params.data.id },
                    function (data) {
                        params.$scope.details = data;
                    },
                    function (error) {

                    }
                );



            }, 1000);
            return templateDetail;
        }

        function selectionChangedFunc(params, other) {

            vm.requisitionToAuthorize = [];

            for (var i = 0; i < vm.masterGridOptions.api.getSelectedNodes().length; i++) {

                if (!addQuotationToRequisition(vm.masterGridOptions.api.getSelectedNodes()[i].data)) {
                    vm.requisitionToAuthorize.push(vm.masterGridOptions.api.getSelectedNodes()[i].data);
                }

            }

            $scope.$apply();

        }

        function addQuotationToRequisition(data) {
            for (var i = 0; i < vm.requisitionToAuthorize.length; i++) {
                if (data.id === vm.requisitionToAuthorize[i].id) {
                    vm.requisitionToAuthorize.push(data);
                    return true;
                }
            }

            return false;
        }

        function correctFilterParams(column) {
            switch (column.filter) {
                case 'number':
                    column.filterParams = {
                        filterOptions: ['equals'],
                        newRowsAction: 'keep'
                    };
                    break;
                case 'text':
                    column.filterParams = {
                        filterOptions: ['contains'],
                        newRowsAction: 'keep'
                    };
                    break;
                case 'date':
                    column.suppressFilter = true;
                    break;
            }
        }

        var filter = '';

        function isExternalFilterPresent() {
            return filter !== '';
        }

        function doesExternalFilterPass(node) {
            if (filter && filter !== 'everyone') {
                var arrdt = node.data.filter.split(filter);
                return arrdt.length > 1;
            }
            return true;
        }

        $scope.$watch('vm.search',
            function (newValue) {
                filter = newValue ? newValue.toLowerCase() : '';
                vm.masterGridOptions.api.onFilterChanged();
            }
        );

        function loadData() {
            var projectIds = [];
            vm.masterGridOptions.api.paginationSetPageSize(vm.pageSize);
            var dataSource = {
                paginationPageSize: vm.pageSize,
                getRows: function (params) {
                    api.ComprasWS.Requisition.page(
                        {
                            idCircle: $rootScope.bsCircle.id, status: vm.status,
                            page: vm.masterGridOptions.api.paginationGetCurrentPage(),
                            pageSize: vm.pageSize,
                            tickets: $stateParams.tickets,
                            'filter': filter
                        },
                        function (response) {// Success

                            vm.requisitions = new jinqJs()
                                .from(response.content)
                                .orderBy([{ field: 'id', sort: 'asc' }])
                                .select(function (r) {
                                    var d = r;
                                    d.filter = (d.id + "," + d.department.description + "," + d.costCenter.description).toLowerCase();
                                    if (d.projectId !== undefined) {
                                        if (projectIds.length > 0) {
                                            if (projectIds.indexOf(r.projectId) < 0) {
                                                projectIds.push(r.projectId);
                                            }
                                        } else {
                                            projectIds.push(d.projectId);
                                        }
                                    }
                                    return d;
                                });
                            if (projectIds.length > 0) {
                                getAllProject(params, response, vm.requisitions, projectIds);
                            } else {
                                params.successCallback(vm.requisitions, response.totalElements);
                                vm.loading = false;
                                $rootScope.loadingProgress = false;
                                $log.debug(vm.requisitions);
                            }
                        }, function (response) {// Error
                            $log.debug(response);
                            vm.loading = false;
                            $rootScope.loadingProgress = false;
                        });
                }
            };
            vm.masterGridOptions.api.setEnterpriseDatasource(dataSource);

            getDimensionCompany();
        }

        function getAllProject(params, response, data, projectIds) {
            api.ProyectosWS.getAllProject.get({ 'ids': projectIds }, function (pjr) {
                data.forEach(function (row) {
                    pjr.forEach(function (res) {
                        if (row.projectId === res.id) {
                            row.prjName = res.name;
                        }
                    });
                });
                params.successCallback(data, response.totalElements);
                vm.loading = false;
                $rootScope.loadingProgress = false;
            }, function(){
                params.successCallback(data, response.totalElements);
              });
        }


        function loadDataToCotize() {
            vm.masterGridOptions.api.paginationSetPageSize(vm.pageSize);
            var dataSource = {
                paginationPageSize: vm.pageSize,
                getRows: function (params) {
                    api.ComprasWS.Requisitions.toCotize.page(
                        {
                            idCircle: $rootScope.bsCircle.id,
                            page: vm.masterGridOptions.api.paginationGetCurrentPage(),
                            pageSize: vm.pageSize,
                            tickets: $stateParams.tickets,
                            userToQuote: vm.userToQuote,
                            'filter': filter
                        },
                        function (response) {// Success
                            vm.requisitions = new jinqJs()
                                .from(response.content)
                                .orderBy([{ field: 'id', sort: 'asc' }])
                                .select(function (r) {
                                    var d = r;
                                    d.filter = (d.id + "," + d.department.description + "," + d.costCenter.description).toLowerCase();
                                    if (d.projectId !== undefined) {
                                        if (projectIds.length > 0) {
                                            if (projectIds.indexOf(r.projectId) < 0) {
                                                projectIds.push(r.projectId);
                                            }
                                        } else {
                                            projectIds.push(d.projectId);
                                        }
                                    }
                                    return d;
                                });
                            if (projectIds.length > 0) {
                                getAllProject(params, response, vm.requisitions, projectIds);
                            } else {
                                vm.loading = false;
                                $rootScope.loadingProgress = false;
                                params.successCallback(vm.requisitions, response.totalElements);
                                $log.debug(vm.requisitions);
                            }
                        }, function (response) {// Error
                            $log.debug(response);
                            vm.loading = false;
                            $rootScope.loadingProgress = false;
                        });
                }
            };
            vm.masterGridOptions.api.setEnterpriseDatasource(dataSource);
        }

        vm.loading = true;
        $timeout(function (d) {
            if ($rootScope.bsCircle) {
                $rootScope.loadingProgress = true;
                vm.loading = true;
                vm.status = $stateParams.status === 'Autorizado' ? 'Autorizado,Licitando' : $stateParams.status;
                vm.masterGridOptions.api.setColumnDefs(vm.masterColumnDefs);

                if ($stateParams.status === 'Autorizado') {
                    loadDataToCotize();
                } else {
                    loadData();
                }

            } else {
                vm.loading = false;
                $state.go('app.dashboard_project');
            }
        }, 300);

        // Methods
        vm.convertDate = convertDate;
        vm.gotoRequisitionDetail = gotoRequisitionDetail;
        vm.newRequisition = newRequisition;
        vm.deleteRequisition = deleteRequisition;
        vm.presentRequisition = presentRequisition;

        //////////

        function convertDate(dateS) {
            return new Date(dateS + ' 00:00:00');
        }

        function presentRequisition(data, i) {


            var confirm = $mdDialog.confirm()
                .title($filter('translate')('REQUISITION.MSG.' + vm.statusToChange + '_REQUISITION'))
                .textContent($filter('translate')('REQUISITION.MSG.CONFIRMACION_' + vm.statusToChange + '_REQUISITION'))
                .ok($filter('translate')('REQUISITION.MSG.SI'))
                .cancel($filter('translate')('REQUISITION.MSG.NO'));
            $mdDialog.show(confirm).then(function () {

                if ($stateParams.status === 'Autorizado') {
                    $state.go('app.quotation.new', { quotationId: 0, requisitionId: data.id });
                } else {

                    $rootScope.loadingProgress = true;

                    var promise = api.ComprasWS.Requisition.changeStatus({ 'idCircle': $rootScope.bsCircle.id, 'id': data.id }, null).$promise;
                    promise.then(function (response) {
                        if (response.circle) {
                            var obj = getObjectTender(response);
                            api.LicitadorWS.Tender.create({ 'circle': response.circle.id }, obj,
                                function (data) {
                                    MessageService.show('REQUISITION.MSG.TENDERCREATED');

                                    $rootScope.loadingProgress = false;
                                    spliceRequisition(data.id);
                                    vm.masterGridOptions.api.setRowData(vm.requisitions);
                                },
                                function (err) {
                                    $rootScope.loadingProgress = false;
                                    MessageService.show('REQUISITION.MSG.ERROR');
                                }
                            );
                        } else {
                            MessageService.show("REQUISITION.MSG.CHANGESTATUS." + vm.statusToChange);
                            $rootScope.loadingProgress = false;
                            spliceRequisition(data.id);
                            vm.masterGridOptions.api.setRowData(vm.requisitions);
                        }
                    }, function (response) {
                        $rootScope.loadingProgress = false;
                        var msg = 'ERROR';
                        if (response.data === 'No Detail') {
                            msg = 'DETAIL';
                        }
                        if (response.data === 'No_products') {
                            msg = 'NOT_PRODUCT_NEGOTIATED';
                        }

                        MessageService.show('REQUISITION.MSG.' + msg);
                    });
                }

            }, function () {
            });
        }


        /**
         * Delete
         *
         * @param e
         * @param id
         * @param i
         * @returns {*}
         */
        function deleteRequisition(e, id, i) {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('REQUISITION.CANCELAR'))
                .textContent($filter('translate')('REQUISITION.MSG.CONFIRMACION_CANCEL'))
                .ok($filter('translate')('REQUISITION.MSG.SI'))
                .cancel($filter('translate')('REQUISITION.MSG.NO'));

            $mdDialog.show(confirm).then(function () {

                $rootScope.loadingProgress = true;

                api.ComprasWS.Requisition.delete({ idCircle: $rootScope.bsCircle.id, id: id }, function (response) {// Success
                    spliceRequisition(id);
                    $rootScope.loadingProgress = false;
                    vm.masterGridOptions.api.setRowData(vm.requisitions);

                    MessageService.show('REQUISITION.MSG.DELETED');
                }, function (response) {// Error
                    $log.debug(response);
                });

            }, function () {
            });
        }

        /**
         * Go to product detail
         *
         * @param id
         */
        function gotoRequisitionDetail(id) {
            if (vm.isTicket) {
                if ($stateParams.status === 'Autorizado') {
                    $state.go('app.requisition.AutorizadoTickets.detail', { id: id });
                } else {
                    $state.go('app.requisition.CreandoTickets.detail', { id: id });
                }
            } else if ($stateParams.isBuyer && $stateParams.status === 'Autorizado') {
                $state.go($state.current.name + '.detail', { id: id, isBuyer: true });
            } else {
                $state.go('app.requisition.' + $stateParams.status + '.detail', { id: id });
            }
        }

        /**
         * Go to product detail
         *
         */
        function newRequisition() {
            $state.go('app.requisition.Creando.detail');
        }

        function renderer(params) {
            var toRet = '<div style="width: 100%;">';
            if (vm.isCreate) {
                toRet = toRet + '<md-button class="edit-button md-icon-button" ' +
                    'ng-click="vm.gotoRequisitionDetail(data.id)" aria-label="Order details"' +
                    'translate translate-attr-aria-label="REQUISITION.ORDER_DETAILS">' +
                    '<md-tooltip md-direction="bottom">' +
                    '{{"REQUISITION.DETAIL.EDIT"| translate}}' +
                    '</md-tooltip>' +
                    '<md-icon md-font-icon="icon-border-color" class="s16"></md-icon> ' +
                    '</md-button>';
            } else {
                toRet = toRet + '<md-button class="edit-button md-icon-button" ' +
                    'ng-click="vm.gotoRequisitionDetail(data.id)" aria-label="Order details"' +
                    'translate translate-attr-aria-label="REQUISITION.ORDER_DETAILS">' +
                    '<md-tooltip md-direction="bottom">' +
                    '{{"REQUISITION.DETAIL.VIEW"| translate}}' +
                    '</md-tooltip>' +
                    '<md-icon md-font-icon="icon-eye" class="s16"></md-icon> ' +
                    '</md-button>';
            }

            if (params.data && params.data.purchaseStatus.description !== 'Licitando' && !vm.isBuyer) {
                toRet = toRet + '<md-button class="edit-button md-icon-button" ' +
                    'ng-click="vm.presentRequisition(data, ' + params.rowIndex + ')" aria-label="present requisition"' +
                    'translate translate-attr-aria-label="REQUISITION.ORDER_DETAILS">' +
                    '<md-tooltip md-direction="bottom">' +
                    '{{vm.chageStatusButton.desc| translate}}' +
                    '</md-tooltip>' +
                    '<md-icon md-font-icon="{{vm.chageStatusButton.icon}}" class="s16"></md-icon>' +
                    '</md-button>';
            }

            if (vm.isCreate || (params.data && params.data.purchaseStatus.description !== 'Licitando' && !vm.isBuyer)) {
                toRet = toRet + '<md-button class="edit-button md-icon-button" ' +
                    'ng-click="vm.deleteRequisition($event, data.id,' + params.rowIndex + ')" aria-label="Cancel"' +
                    'translate translate-attr-aria-label="REQUISITION.CANCELAR">' +
                    '<md-tooltip md-direction="bottom">' +
                    '{{"REQUISITION.CANCELAR"| translate}}' +
                    '</md-tooltip>' +
                    '<md-icon md-font-icon="icon-minus-circle" class="s16 md-warn"></md-icon> ' +
                    '</md-button>';
            }

            return toRet + '</div>';
        }

        function getDatasToChange(status) {
            var ret = { desc: 'REQUISITION.STATUSCHANGE.' + status };
            switch (status) {
                case 'Creando':
                    ret.icon = 'icon-content-paste';
                    break;
                case 'Ingresado':
                    ret.icon = 'icon-key-variant';
                    break;
                case 'Autorizado':
                    ret.icon = 'icon-thumb-up-outline';
                    break;
            }
            return ret;
        }

        function spliceRequisition(id) {
            var nro = 0;
            vm.requisitions.forEach(function (row) {
                if (row.id === id) {
                    vm.requisitions.splice(nro, 1);
                }
                nro += 1;
            });

            loadData();
        }

        function authorizeRequisitions(createTender) {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('REQUISITION.STATUSCHANGE.Ingresado'))
                .textContent($filter('translate')('REQUISITION.MSG.CONFIRMACION_Ingresado_REQUISITION'))
                .ok($filter('translate')('REQUISITION.MSG.SI'))
                .cancel($filter('translate')('REQUISITION.MSG.NO'));

            $mdDialog.show(confirm).then(function () {
                if (vm.requisitionToAuthorize.length > 0) {
                    for (var i = 0; i < vm.requisitionToAuthorize.length; i++) {
                        $rootScope.loadingProgress = true;
                        var promise = api.ComprasWS.Requisition.changeStatus(
                            { 'idCircle': $rootScope.bsCircle.id, 'id': vm.requisitionToAuthorize[i].id }, null).$promise;
                        promise.then(function (response) {
                            if (response.circle) {
                                var obj = getObjectTender(response);
                                api.LicitadorWS.Tender.create({ 'circle': response.circle.id }, obj,
                                    function (data) {
                                        MessageService.show('REQUISITION.MSG.TENDERCREATED');

                                        $rootScope.loadingProgress = false;
                                    },
                                    function (err) {
                                        $rootScope.loadingProgress = false;
                                        MessageService.show('REQUISITION.MSG.ERROR');
                                    }
                                );
                            } else {
                                MessageService.show("REQUISITION.MSG.CHANGESTATUS." + vm.statusToChange);
                                $rootScope.loadingProgress = false;
                            }
                            loadData();
                        }, function (response) {
                            $rootScope.loadingProgress = false;
                            var msg = 'ERROR';
                            if (response.data === 'No Detail') {
                                msg = 'DETAIL';
                            }
                            if (response.data === 'No_products') {
                                msg = 'NOT_PRODUCT_NEGOTIATED';
                            }

                            MessageService.show('REQUISITION.MSG.' + msg);
                        });
                    }
                    $timeout(function (d) {
                        vm.requisitionToAuthorize = [];
                    }, 300);
                }
                desSelectedGrid();
            }, function () {
            });
        }

        function cancelRequisitions() {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('REQUISITION.CANCELAR'))
                .textContent($filter('translate')('REQUISITION.MSG.CONFIRMACION_CANCEL'))
                .ok($filter('translate')('REQUISITION.MSG.SI'))
                .cancel($filter('translate')('REQUISITION.MSG.NO'));

            $mdDialog.show(confirm).then(function () {
                if (vm.requisitionToAuthorize.length > 0) {
                    for (var i = 0; i < vm.requisitionToAuthorize.length; i++) {
                        $rootScope.loadingProgress = true;
                        api.ComprasWS.Requisition.delete({ idCircle: $rootScope.bsCircle.id, id: vm.requisitionToAuthorize[i].id }, function (response) {// Success
                            spliceRequisition(response.id);
                            $rootScope.loadingProgress = false;
                            vm.masterGridOptions.api.setRowData(vm.requisitions);

                            MessageService.show('REQUISITION.MSG.DELETED');
                        }, function (response) {// Error
                            $log.debug(response);
                        });
                    }
                }
                desSelectedGrid();
            }, function () {
            });
        }

        function desSelectedGrid() {
            vm.masterGridOptions.api.forEachNode(function (node) {
                node.setSelected(false);
            });
        }

        function getDimensionCompany() {
            const NUMBER_DIMENSION_THREE = 3;
            const NUMBER_DIMENSION_FOUR = 4;
            const NUMBER_DIMENSION_FIVE = 5;
            api.GeneralWS.DimensionCompany.byCompany.getList(
                { 'company': $rootScope.bsCircle.company.id }
            ).$promise.then(function (responseDimension) {
                for (let i = 0; i < responseDimension.length; i++) {
                    if (responseDimension[i].dimensionNumber === NUMBER_DIMENSION_THREE && !vm.dimensionCompanyDetail3) {
                        vm.dimensionCompanyDetail3 = responseDimension[i];
                        addMasterColumnDefs(responseDimension[i].description, 'dimensionCompanyDetail3.name', responseDimension[i].dimensionNumber);
                    } else if (responseDimension[i].dimensionNumber === NUMBER_DIMENSION_FOUR && !vm.dimensionCompanyDetail4) {
                        vm.dimensionCompanyDetail4 = responseDimension[i];
                        addMasterColumnDefs(responseDimension[i].description, 'dimensionCompanyDetail4.name', responseDimension[i].dimensionNumber);
                    } else if (responseDimension[i].dimensionNumber === NUMBER_DIMENSION_FIVE && !vm.dimensionCompanyDetail5) {
                        vm.dimensionCompanyDetail5 = responseDimension[i];
                        addMasterColumnDefs(responseDimension[i].description, 'dimensionCompanyDetail5.name', responseDimension[i].dimensionNumber);
                    } else {
                        vm.dimensionCompanyDetail1 = responseDimension[i];
                    }
                }
                vm.masterGridOptions.api.setColumnDefs(vm.masterColumnDefs);
            });
        }

        function addMasterColumnDefs(name, fieldName, number) {
            const NUMBER_FIVE_COLUMN_ADD = 5;
            vm.masterColumnDefs.splice((number + NUMBER_FIVE_COLUMN_ADD), 0, {
                headerName: name,
                field: fieldName,
                headerCellRenderer: getHeader,
                width: 200,
                enableRowGroup: true,
                filter: 'text',
                enablePivot: true
            });
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.requisition')
        .controller('requisitionTypeController', requisitionTypeController);

    /** @ngInject */
    function requisitionTypeController(api, $rootScope, $log, $mdDialog, $filter, $mdToast) {

        var vm = this;

        // Methods
        vm.currentThread = null;
        vm.createRequisitionType = createRequisitionType;
        vm.deleteRequisitionType = deleteRequisitionType;
        init();

        //////////

        function init() {
            $rootScope.loadingProgress = true;
            api.ComprasWS.RequisitionType.RequisitionTypeCompany.query({ company: $rootScope.bsCircle.company.id }, function (data) {
                vm.allowRoleAccess = true;
                $log.debug(data);

                vm.masterGridOptions.api.setColumnDefs(vm.masterColumnDefs);
                vm.masterGridOptions.api.setRowData(new jinqJs()
                    .from(data)
                    .orderBy([{ field: 'id', sort: 'asc' }])
                    .select());

                vm.loading = false;
                $rootScope.loadingProgress = false;
            }, function (response) {
                vm.loading = false;
                vm.allowRoleAccess = false;
                $log.error(response);
            });
        }

        vm.masterColumnDefs = [

            {
                headerName: 'REQUISITION_TYPE.DESCRIPTION',
                field: "description",
                headerCellRenderer: getHeader,
                width: 350,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'PURCHASEPRODUCTDELIVERY.OPTIONS',
                name: "actions",
                headerCellRenderer: getHeader,
                suppressSorting: true,
                suppressMenu: true,
                width: 200,
                cellRenderer: function renderer(params) {
                    return '<div style="width: 100%;">' +
                        '<md-button class="edit-button md-icon-button" ng-disabled="" ' +
                        'ng-click="vm.createRequisitionType($index, data.id, data)" aria-label="rejectionReason"' +
                        'translate translate-attr-aria-label="REJECTIONREASON.EDIT">' +
                        '<md-tooltip md-direction="bottom">' +
                        '{{"REJECTIONREASON.EDIT"| translate}}' +
                        '</md-tooltip>' +
                        '<md-icon md-font-icon="icon-pencil" class="s16"></md-icon> ' +
                        '</md-button>' +
                        '<md-button class="edit-button md-icon-button" ng-disabled="" ' +
                        'ng-click="vm.deleteRequisitionType($event, data.id, data, $index)" aria-label="pettyCash"' +
                        'translate translate-attr-aria-label="REJECTIONREASON.DELETE">' +
                        '<md-tooltip md-direction="bottom">' +
                        '{{"REJECTIONREASON.DELETE"| translate}}' +
                        '</md-tooltip>' +
                        '<md-icon md-font-icon="icon-delete" class="s16 md-warn"></md-icon> ' +
                        '</md-button>' +
                        '</div>';
                },
                cellStyle: { 'padding': '0px' }
            }
        ];

        vm.masterGridOptions = {
            columnDefs: vm.masterColumnDefs,
            enableSorting: true,
            debug: false,
            enableFilter: true,
            enableColResize: true,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowData: null,
            groupHeaders: true,
            headerHeight: 54,
            rowHeight: 40,
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            },
            doesDataFlower: function (dataItem) {
                return true;
            },
            isExternalFilterPresent: isExternalFilterPresent,
            doesExternalFilterPass: doesExternalFilterPass
        };

        var filter = 'everyone';

        function isExternalFilterPresent() {
            return filter !== '';
        }

        function doesExternalFilterPass(node) {
            if (filter && filter !== 'everyone') {
                var arrdt = node.data.filter.split(filter);
                return arrdt.length > 1;
            }
            return true;
        }

        function createRequisitionType(i, id, data) {
            var detail = angular.copy(data);
            $mdDialog.show({
                controller: 'requisitionTypeEditController',
                controllerAs: 'vm',
                locals: {
                    requisitionType: detail
                },
                templateUrl: 'app/main/apps/requisition/requisitionType/requisitionTypeEdit/requisitionTypeEdit.html',
                parent: angular.element("#main"),
                clickOutsideToClose: false
            }).then(function (answer) {
                init();
                $rootScope.loadingProgress = false;
            }, function () {
                $rootScope.loadingProgress = false;
            });
        }

        function deleteRequisitionType(e, id, data, i) {


            var confirm = $mdDialog.confirm()
                .title($filter('translate')('REQUISITION_TYPE.MSGTXTDELETE'))
                .htmlContent($filter('translate')('REQUISITION_TYPE.MSGDELETE'))
                .ariaLabel('Delete Detail')
                .ok($filter('translate')('REJECTIONREASON.DELETE'))
                .cancel($filter('translate')('REJECTIONREASON.CANCEL'));

            $mdDialog.show(confirm).then(function () {
                $rootScope.loadingProgress = true;
                api.ComprasWS.RequisitionType.RequisitionTypeCompany.delete({ company: $rootScope.bsCircle.company.id, id: id }, function (response) {// Success
                    init();
                    showMessage($filter('translate')('REQUISITION_TYPE.MSGDELETESUCCESSFULL'));
                    $rootScope.loadingProgress = false;
                }, function (response) {// Error
                    $log.debug(response);
                    $rootScope.loadingProgress = false;
                    if (response.data === "can not deleted") {
                        showErrorMessage($filter('translate')('REJECTIONREASON.MSGDELETEERROR'));
                    }
                });

            }, function () {
            });
        }


        function showMessage(message) {
            $rootScope.loadingProgress = false;
            $mdToast.show({
                template: '<md-toast layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
                hideDelay: 3000,
                position: 'top right'
            });
        }
        function showErrorMessage(message) {
            $rootScope.loadingProgress = false;
            $mdToast.show({
                template: '<md-toast layout="column" layout-align="center start"><div class="md-toast-content" style="background-color: red">' + message + '</div></md-toast>',
                hideDelay: 5000,
                position: 'top right'
            });
        }
    }


})();

(function () {
    'use strict';
    angular
        .module('app.requisition')
        .controller('RequisitionReportController', RequisitionReportController);

    /** @ngInject */
    function RequisitionReportController(api, $log, $rootScope, $mdDialog, $timeout, $filter, $stateParams, MessageService) {
        var vm = this;

        vm.replaceOriginTypedata = replaceOriginTypedata;
        vm.URLPHOTOS = api.baseUrlPhotos;
        vm.viewIMG = viewIMG;
        vm.selectRequisition = selectRequisition;
        vm.purchaseOrderStatus = '';
        vm.editBussines = editBussines;
        vm.editBussinesData = $rootScope.getEspecialActionByName("Cambio departamento y centro de costo a requerimiento");
        vm.viewImgReq = viewImgReq;
        vm.dimensionCompanyDetail3 = null;
        vm.dimensionCompanyDetail4 = null;
        vm.dimensionCompanyDetail5 = null;
        vm.dinamicSize = 0;
        vm.filesToUpload = [];

        init();

        function init() {
            vm.dinamicSize = $(window).innerHeight();
            if ($stateParams.id && $stateParams.id !== '') {
                vm.search = parseInt($stateParams.id);
                vm.hiddenSearch = true;
                getRequisition(vm.search);
            }
        }

        vm.masterColumnDefs = [
            {
                headerName: 'REQUISITION.DETAIL.QUANTITY',
                field: "quantity",
                headerCellRenderer: getHeader,
                width: 100,
                enableRowGroup: true,
                cellStyle: { 'text-align': 'center' },
                enablePivot: true
            },
            {
                headerName: 'REQUISITION.DETAIL.PRODUCT',
                field: "product.name",
                headerCellRenderer: getHeader,
                width: 300,
                enableRowGroup: true,
                enablePivot: true,
                cellRenderer: function (params) {
                    if (!params.node.group) {
                        if (params.data && params.data.product.brand && params.data.product.measurementUnit) {
                            return params.value
                                + ", " + $filter('translate')('authorize_quotations.measurement_unit')
                                + ": " + params.data.product.measurementUnit.name
                                + ", " + $filter('translate')('authorize_quotations.brand')
                                + ": " + params.data.product.brand.name;
                        } else {
                            return params.value;
                        }

                    } else {
                        return params.value;
                    }
                }
            },
            {
                headerName: 'REQUISITION.DETAIL.CONSIGNACION',
                name: "consignment",
                headerCellRenderer: getHeader,
                width: 100,
                cellRenderer: rendererConsigment,
                enableRowGroup: true,
                enablePivot: true,
                cellStyle: { 'text-align': 'center' }
            },
            {
                headerName: 'REQUISITION.DETAIL.COTIZED',
                name: "cotizated",
                headerCellRenderer: getHeader,
                cellRenderer: rendererCotized,
                enableRowGroup: true,
                enablePivot: true,
                cellStyle: { 'text-align': 'center' }
            },
            {
                headerName: 'REQUISITION.DETAIL.OBSERVATIONS',
                field: "observations",
                width: 200,
                headerCellRenderer: getHeader,
                enableRowGroup: true,
                enablePivot: true
            }
        ];


        vm.masterGridOptions = {
            columnDefs: vm.masterColumnDefs,
            enableSorting: true,
            debug: false,
            enableFilter: true,
            enableColResize: true,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowData: null,
            groupHeaders: true,
            headerHeight: 50,
            rowHeight: 40,
            rowSelection: 'multiple',
            rowDeselection: true,
            rowModelType: "enterprise",
            cacheBlockSize: vm.pageSize,
            pagination: true,
            paginationPageSize: vm.pageSize,
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            },
            doesDataFlower: function (dataItem) {
                return true;
            },
            isExternalFilterPresent: isExternalFilterPresent
        };

        var filter = 'everyone';

        function isExternalFilterPresent() {
            return filter !== '';
        }

        vm.masterGridOptionsFiles = {
            columnDefs: vm.masterColumnDefsFiles,
            rowData: null,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowSelection: 'multiple',
            headerHeight: 50,
            rowHeight: 45,
            suppressRowClickSelection: true,
            getMainMenuItems: getMainMenuItems(),
            localeTextFunc: getLocaleTextFunc()
        };

        vm.masterColumnDefsFiles = [
            {
                headerName: 'requisition_files.name',
                headerCellRenderer: getHeader,
                width: 350,
                cellStyle: { 'text-align': 'left' },
                suppressSorting: true,
                suppressMenu: true,
                cellRenderer : getCellRendererFilesName()
            },
            {
                headerName: 'requisition_files.photo',
                headerCellRenderer: getHeader,
                width: 150,
                suppressSorting: true,
                suppressMenu: true,
                cellRenderer: getCellRendererFilesPhoto()
            },
            {
                headerName: 'requisition_files.user',
                field: 'user.account',
                headerCellRenderer: getHeader,
                suppressSorting: true,
                suppressMenu: true,
                width: 350,
                cellStyle: { 'text-align': 'center' }
            }
        ];

        vm.masterColumnDefsQuotation = [
            {
                headerName: 'QUOTATION.QUOTATION',
                field: "quotationDescription",
                headerCellRenderer: getHeader,
                width: 150,
                rowGroupIndex: 0,
                hide: true
            },
            {
                headerName: 'REQUISITION.DETAIL.QUANTITY',
                field: "requisitionDetail.quantity",
                headerCellRenderer: getHeader,
                width: 100,
                enableRowGroup: true,
                cellStyle: { 'text-align': 'center' },
                enablePivot: true
            },
            {
                headerName: 'REQUISITION.DETAIL.PRODUCT',
                field: "requisitionDetail.product.name",
                headerCellRenderer: getHeader,
                width: 200,
                enableRowGroup: true,
                enablePivot: true,
                cellRenderer: function (params) {
                    if (!params.node.group) {
                        if (params.data && params.data.requisitionDetail.product.brand && params.data.requisitionDetail.product.measurementUnit) {
                            return params.value
                                + ", " + $filter('translate')('authorize_quotations.measurement_unit')
                                + ": " + params.data.requisitionDetail.product.measurementUnit.name
                                + ", " + $filter('translate')('authorize_quotations.brand')
                                + ": " + params.data.requisitionDetail.product.brand.name;
                        } else {
                            return params.value;
                        }

                    } else {
                        return params.value;
                    }
                }
            },
            {
                headerName: 'QUOTATION.DETAIL.PRICE',
                field: "price",
                headerCellRenderer: getHeader,
                width: 150,
                enableRowGroup: true,
                enablePivot: true,
                cellStyle: { 'text-align': 'right' },
                valueFormatter: function (params) {
                    return $filter('number')(params.value, 2);
                }
            },
            {
                headerName: 'QUOTATION.TOTAL',
                field: "subTotal",
                headerCellRenderer: getHeader,
                enableRowGroup: true,
                enablePivot: true,
                cellStyle: { 'text-align': 'right' },
                valueFormatter: function (params) {
                    return $filter('number')(params.value, 2);
                }
            },
            {
                headerName: 'QUOTATION.DETAIL.OBSERVATIONS',
                field: "observations",
                width: 200,
                headerCellRenderer: getHeader,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'CONTRACT.BY_CREATED',
                field: "createdBy",
                headerCellRenderer: getHeader,
                width: 160,
                enableRowGroup: true,
                enablePivot: true,
                cellStyle: { 'text-align': 'center' }
            }
        ];


        vm.masterGridOptionsQuotation = {
            columnDefs: [],
            enableSorting: true,
            debug: false,
            enableFilter: true,
            enableColResize: true,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowData: null,
            groupHeaders: true,
            headerHeight: 50,
            rowHeight: 45,
            groupUseEntireRow: true,
            groupDefaultExpanded: 1,
            doesDataFlower: function (dataItem) {
                dataItem.quotationDescription = "Cotizacion N. " + dataItem.quotation.id;
            },
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            }
        };

        function doesExternalFilterPass(node) {
            if (filter && filter !== 'everyone') {
                var arrdt = node.data.filter.split(filter.toLowerCase());
                return arrdt.length > 1;
            }
            return true;
        }

        vm.masterColumnDefsPurchaseOrder = [
            {
                headerName: 'ORDER.ORDER',
                field: "orderDescription",
                headerCellRenderer: getHeader,
                width: 150,
                rowGroupIndex: 0,
                hide: true
            },
            {
                headerName: 'REQUISITION.DETAIL.QUANTITY',
                field: "quantityRequired",
                headerCellRenderer: getHeader,
                width: 100,
                enableRowGroup: true,
                cellStyle: { 'text-align': 'center' },
                enablePivot: true
            },
            {
                headerName: 'REQUISITION.DETAIL.PRODUCT',
                field: "productName",
                headerCellRenderer: getHeader,
                width: 250,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'QUOTATION.DETAIL.PRICE',
                field: "price",
                headerCellRenderer: getHeader,
                width: 150,
                enableRowGroup: true,
                enablePivot: true,
                cellStyle: { 'text-align': 'right' },
                valueFormatter: function (params) {
                    return $filter('number')(params.value, 2);
                }
            },
            {
                headerName: 'ORDER.DETAIL.PENDIENTE',
                field: "maxRecibe",
                headerCellRenderer: getHeader,
                width: 150,
                enableRowGroup: true,
                cellStyle: { 'text-align': 'center' },
                enablePivot: true
            },
            {
                headerName: 'ORDER.DETAIL.RECIBIDO',
                field: "pending",
                headerCellRenderer: getHeader,
                width: 150,
                enableRowGroup: true,
                cellStyle: { 'text-align': 'center' },
                enablePivot: true
            }
        ];


        vm.masterGridOptionsPurchaseOrder = {
            columnDefs: vm.masterColumnDefsPurchaseOrder,
            enableSorting: true,
            debug: false,
            enableFilter: true,
            enableColResize: true,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowData: null,
            headerHeight: 50,
            rowHeight: 45,
            groupUseEntireRow: true,
            animateRows: true,
            groupDefaultExpanded: 1,
            doesDataFlower: function (dataItem) {
                dataItem.pending = dataItem.quantityRequired - dataItem.maxRecibe;
                dataItem.orderDescription = "Orden de Compra No." + dataItem.purchaseOrder.id +
                    " {{'CONTRACT.BY_CREATED' | translate}} " + dataItem.purchaseOrder.createdBy + " El "
                    + $filter('date')(getDateFormat(dataItem), 'dd/MM/yyyy');
            },
            isExternalFilterPresent: isExternalFilterPresent,
            doesExternalFilterPass: doesExternalFilterPass,
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            }
        };

        vm.masterColumnDefsInvoice = [
            {
                headerName: 'INVOICE.INVOICE',
                field: "invoiceDescription",
                headerCellRenderer: getHeader,
                width: 150,
                rowGroupIndex: 0,
                hide: true
            },
            {
                headerName: 'INVOICE.PRODUCT.PRODUCT',
                field: "product.name",
                headerCellRenderer: getHeader,
                width: 250,
                enableRowGroup: true,
                enablePivot: true,
                cellRenderer: function (params) {
                    if (!params.node.group) {
                        if (params.data && params.data.product.brand && params.data.product.measurementUnit) {
                            return params.value + ", " + $filter('translate')('authorize_quotations.measurement_unit')
                                + ": " + params.data.product.measurementUnit.name + ", " + $filter('translate')('authorize_quotations.brand')
                                + ": " + params.data.product.brand.name;
                        } else {
                            return params.value;
                        }

                    } else {
                        return params.value;
                    }
                }
            },
            {
                headerName: 'INVOICE.DEPARTMENT',
                field: "merchandiseEntry.purchaseOrderDetail.purchaseOrder.department.description",
                headerCellRenderer: getHeader,
                width: 200,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'INVOICE.COST_CENTER',
                field: "merchandiseEntry.purchaseOrderDetail.purchaseOrder.costCenter.description",
                headerCellRenderer: getHeader,
                width: 200,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'INVOICE.INVOICE_PURCHASE.ELECTRONIC_SIGNATURE',
                field: "invoicePurchase.electronicSignature",
                headerCellRenderer: getHeader,
                width: 160,
                enableRowGroup: true,
                enablePivot: true,
                cellStyle: { 'text-align': 'center' }
            },
            {
                headerName: 'INVOICE.INVOICE_PURCHASE.DETAIL.QUANTITY',
                field: "quantity",
                headerCellRenderer: getHeader,
                width: 100,
                enableRowGroup: true,
                enablePivot: true,
                cellStyle: { 'text-align': 'center' }
            },
            {
                headerName: 'INVOICE.INVOICE_PURCHASE.DETAIL.UNIT_PRICE_AFTER_TAX',
                field: "priceAfterTax",
                headerCellRenderer: getHeader,
                width: 100,
                suppressSorting: true,
                suppressMenu: true,
                cellStyle: { 'text-align': 'right' },
                valueFormatter: function (params) {
                    return $filter('number')(params.value, 2);
                }
            },
            {
                headerName: 'INVOICE.INVOICE_PURCHASE.DETAIL.TOTAL_AFTER_TAX',
                field: "subTotalAfterTax",
                headerCellRenderer: getHeader,
                width: 100,
                suppressSorting: true,
                suppressMenu: true,
                cellStyle: { 'text-align': 'right' },
                valueFormatter: function (params) {
                    return $filter('number')(params.value, 2);
                }
            }
        ];


        vm.masterGridOptionsInvoice = {
            columnDefs: vm.masterColumnDefsInvoice,
            enableSorting: true,
            debug: false,
            enableFilter: true,
            enableColResize: true,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowData: null,
            headerHeight: 50,
            rowHeight: 45,
            groupUseEntireRow: true,
            animateRows: true,
            groupDefaultExpanded: 1,
            doesDataFlower: function (dataItem) {
                var resp = ' ';
                var ref = '';
                dataItem.invoicePurchase.files.forEach(function (file, index, arr) {
                    ref = ref + '<a ng-click="vm.viewIMG(' + file.id + ')">Ver Imagen ' + (index + 1) + '</a> ';
                });
                dataItem.invoiceDescription = "Factura SERIE " + dataItem.invoicePurchase.invoiceSerie.serie +
                    " Correlativo No. " + dataItem.invoicePurchase.correlative + " {{'CONTRACT.BY_CREATED' | translate}} " +
                    dataItem.invoicePurchase.createdBy + " El " + $filter('date')(getDateFormat(dataItem), 'dd/MM/yyyy') + '' +
                    resp + ref + '';
            },
            isExternalFilterPresent: isExternalFilterPresent,
            doesExternalFilterPass: doesExternalFilterPass,
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            },
            groupRowInnerRenderer: function (params) {
                return params.value;
            }
        };

        vm.masterColumnDefsRequisitions = [
            {
                headerName: '#',
                field: "id",
                headerCellRenderer: getHeader,
                width: 70,
                pinned: 'left'
            },
            {
                headerName: 'REQUISITION.DEPARTMENT',
                field: "department.description",
                headerCellRenderer: getHeader,
                width: 250,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'INVOICE.COST_CENTER',
                field: "costCenter.description",
                headerCellRenderer: getHeader,
                width: 250,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'REQUISITION.MAXDATEPURCHASE',
                field: "maxDatePurchase",
                headerCellRenderer: getHeader,
                width: 200,
                enableRowGroup: true,
                enablePivot: true,
                cellStyle: { 'text-align': 'center' },
                valueFormatter: function (params) {
                    var ff = params.data.maxDatePurchase.split("-");
                    var maxDatePurchase = new Date(ff[0], (parseInt(ff[1]) - 1), ff[2]);
                    return $filter('date')(maxDatePurchase, 'dd/MM/yyyy');
                }
            },
            {
                headerName: 'REQUISITION.ORIGIN',
                field: "originType.originTypeUrlDescription",
                headerCellRenderer: getHeader,
                width: 100,
                enableRowGroup: true,
                enablePivot: true,
                cellStyle: { 'text-align': 'center' },
                cellRenderer: function (params) {
                    return params.data.originType.originTypeUrlDescription.replace('{referenceId}', params.data.referenceId);
                }
            },
            {
                headerName: 'REQUISITION.STATUS',
                field: "purchaseStatus.description",
                headerCellRenderer: getHeader,
                width: 100,
                suppressSorting: true,
                suppressMenu: true,
                cellStyle: { 'text-align': 'center' }
            },
            {
                headerName: 'REQUISITION.REQUISITION_TYPE',
                field: "requisitionType.description",
                headerCellRenderer: getHeader,
                width: 150,
                suppressSorting: true,
                suppressMenu: true,
                cellStyle: { 'text-align': 'right' }
            },
            {
                headerName: 'REQUISITION.ACTIONS',
                headerCellRenderer: getHeader,
                width: 100,
                suppressSorting: true,
                suppressMenu: true,
                cellStyle: { 'text-align': 'right' },
                cellRenderer: function (params) {
                    return '<div>'
                        + '<md-button class="edit-button md-icon-button" ng-click="vm.selectRequisition(data)" aria-label="Order details"'
                        + '                                 translate translate-attr-aria-label="REQUISITION.ORDER_DETAILS">'
                        + '                     <md-tooltip md-direction="bottom">'
                        + '                         {{"REQUISITION.VIEW_REQUISITION"| translate}}'
                        + '                     </md-tooltip>'
                        + '                     <md-icon md-font-icon="icon-eye" class="s16"></md-icon> '
                        + '                 </md-button>'
                        + '</div>';
                },
                pinned: 'right'
            }
        ];


        function loadMasterGridOptionsrequisitions() {
            vm.masterGridOptionsRequisitions = {
                columnDefs: vm.masterColumnDefsRequisitions,
                enableSorting: true,
                debug: false,
                enableFilter: true,
                enableColResize: true,
                angularCompileRows: true,
                angularCompileHeaders: true,
                rowData: null,
                headerHeight: 50,
                rowHeight: 45,
                groupUseEntireRow: true,
                animateRows: true,
                isExternalFilterPresent: isExternalFilterPresent,
                doesExternalFilterPass: doesExternalFilterPass,
                getMainMenuItems: function (params) {
                    return getHeaderMenu(params, $filter);
                },
                localeTextFunc: function (key, defaultValue) {
                    return translateGrid(key, defaultValue, $filter);
                },
                groupRowInnerRenderer: function (params) {
                    return params.value;
                }
            };
            $timeout(function () {
                vm.masterGridOptionsRequisitions.api.setColumnDefs(vm.masterColumnDefsRequisitions);
                vm.masterGridOptionsRequisitions.api.setRowData(vm.requisitionList);
            }, 300);

        }


        // Methods
        vm.getRequisition = getRequisition;


        function getRequisition(id) {
            vm.requisition = {};

            ifNotFromOther(id);
            getDimensionCompany();
        }

        function ifNotFromOther(id, ot) {
            cleanData();
            vm.requisitionList = [];
            if (id) {
                $rootScope.loadingProgress = true;

                var promise = api.ComprasWS.RequisitionPendingAuthorize.getBy({ idCircle: $rootScope.bsCircle.id, id: id }).$promise;

                if (vm.searchTicket) {
                    promise = api.ComprasWS.Requisitions.byReference.get(
                        { idCircle: $rootScope.bsCircle.id, 'referenceId': id, 'originTypeCode': '01' }).$promise;
                }

                promise.then(
                    function (data) {
                        if (!data.id && (!data.length || data.length === 0)) {
                            MessageService.showErrorMessage('REQUISITION.NOX_EXIST');
                            $rootScope.loadingProgress = false;
                            return false;
                        }
                        if (!data.id && data.length > 1) {
                            vm.requisitionList = data;
                            loadMasterGridOptionsrequisitions();
                            $rootScope.loadingProgress = false;
                        } else if (!data.id && data.length === 1) {
                            var row = data[0];
                            if (row.originType && row.originType.originTypeCode === '01') {
                                vm.requisitionFromOtherOrigin = true;
                            }

                            row.department.id = row.department.id.toString();
                            row.costCenter.id = row.costCenter.id.toString();

                            if (row.departmentFirsRecept) {
                                row.departmentFirsRecept.id = row.departmentFirsRecept.id.toString();
                            }

                            api.ComprasWS.ProcessFlow.get({ id: row.id, type: 1 }, function (data) {
                                vm.infoProcessFlow = data;
                            });

                            $timeout(function () {
                                vm.requisition = row;
                                getInfoRequisitions();
                            });
                        } else {
                            if (data.originType && data.originType.originTypeCode === '01') {
                                vm.requisitionFromOtherOrigin = true;
                            }

                            data.department.id = data.department.id.toString();
                            data.costCenter.id = data.costCenter.id.toString();

                            if (data.departmentFirsRecept) {
                                data.departmentFirsRecept.id = data.departmentFirsRecept.id.toString();
                            }
                            vm.purchaseOrderStatus = '';
                            api.ComprasWS.ProcessFlow.get({ id: data.id, type: 1 }, function (data) {
                                vm.infoProcessFlow = data;
                                if (vm.infoProcessFlow.purchaseOrders.length != 0) {
                                    vm.purchaseOrderStatus = vm.infoProcessFlow.purchaseOrders[0].childStatus;
                                }
                            });

                            $timeout(function () {
                                vm.requisition = data;
                                getInfoRequisitions();
                            });
                        }

                    }, function (err) {
                        MessageService.showErrorMessage('REQUISITION.NOX_EXIST');
                        $rootScope.loadingProgress = false;
                    });
            }
        }

        function getDetails() {
            $rootScope.loadingProgress = true;
            api.ComprasWS.RequisitionDetail.query({ idCircle: $rootScope.bsCircle.id, idRequisition: vm.requisition.id }, function (data) {
                vm.details = new jinqJs()
                    .from(data)
                    .orderBy([{ field: 'id', sort: 'asc' }])
                    .select(function (r) {
                        return r;
                    });
                $rootScope.loadingProgress = false;

                vm.masterGridOptions.api.setColumnDefs(vm.masterColumnDefs);
                vm.dataSource = {
                    paginationPageSize: vm.pageSize,
                    getRows: function (params) {
                        vm.loading = false;
                        $rootScope.loadingProgress = false;
                        params.successCallback(vm.details, vm.details.length);
                    }
                };
                vm.masterGridOptions.api.setEnterpriseDatasource(vm.dataSource);
            }, function (data) {
                $log.debug(data);
                $rootScope.loadingProgress = false;
            });
        }

        function rendererConsigment(params) {
            var toRet = '<div style="width: 100%;">';

            toRet = toRet + '<div>' +
                '<md-icon md-font-icon="{{data.consignment ? \'icon-check\' : \'icon-close\'}}"></md-icon>' +
                '</div>';

            return toRet + '</div>';
        }

        function rendererCotized(params) {
            var toRet = '<div style="width: 100%;">';

            toRet = toRet + '<div>' +
                '<md-icon md-font-icon="{{data.cotizated ? \'icon-check\' : \'icon-close\'}}"></md-icon>' +
                '</div>';

            return toRet + '</div>';
        }

        function getQuotation(id) {
            $rootScope.loadingProgress = true;
            api.ComprasWS.Quotation.byRequisition.getBy({ companyId: $rootScope.bsCircle.company.id, id: id }, function (data) {
                vm.quotationsDetails = new jinqJs()
                    .from(data)
                    .orderBy([{ field: 'id', sort: 'asc' }])
                    .select(function (r) {
                        return r;
                    });
                $rootScope.loadingProgress = false;
                vm.masterGridOptionsQuotation.api.setRowData(vm.quotationsDetails);
            }, function (err) {
                vm.quotationsDetails = [];
                $rootScope.loadingProgress = false;
            });
          vm.masterGridOptionsQuotation.api.setColumnDefs(vm.masterColumnDefsQuotation);
          vm.masterGridOptionsQuotation.api.refreshCells({ force: true });
        }

        function getPurchaseOrder(id) {
            $rootScope.loadingProgress = true;
            api.ComprasWS.PurchaseByRequisition.getBy({ idCircle: $rootScope.bsCircle.id, idPurchaseOrder: 1, requisitionId: id }, function (data) {
                vm.detailsPurchaseOrder = new jinqJs()
                    .from(data)
                    .orderBy([{ field: 'id', sort: 'asc' }])
                    .select(function (r) {
                        r.maxRecibe = angular.copy(r.quantity);
                        r.quantity = 0;
                        return r;
                    });
                $rootScope.loadingProgress = false;
                vm.masterGridOptionsPurchaseOrder.api.setColumnDefs(vm.masterColumnDefsPurchaseOrder);
                vm.masterGridOptionsPurchaseOrder.api.setRowData(vm.detailsPurchaseOrder);
            }, function (data) {
                $log.debug(data);
                $rootScope.loadingProgress = false;
                vm.detailsPurchaseOrder = [];
            });
        }

        function getInvoice(id) {
            $rootScope.loadingProgress = true;
            api.ComprasWS.InvoicesPurchasesDetails.byRequisition.getBy({ idCircle: $rootScope.bsCircle.id, requisitionId: id }, function (data) {
                vm.detailsInvoice = new jinqJs()
                    .from(data)
                    .orderBy([{ field: 'id', sort: 'asc' }])
                    .select(function (r) {
                        return r;
                    });
                $rootScope.loadingProgress = false;
                vm.masterGridOptionsInvoice.api.setColumnDefs(vm.masterColumnDefsInvoice);
                vm.masterGridOptionsInvoice.api.setRowData(vm.detailsInvoice);
            }, function (data) {
                $log.debug(data);
                $rootScope.loadingProgress = false;
            });
        }

        function getDateFormat(dataItem) {
            if (dataItem.purchaseOrder && dataItem.purchaseOrder.contractPurchase === null) {
                var day = 0;
                var month = 0;
                if (dataItem.purchaseOrder.createdAt.dayOfMonth < 10) {
                    day = '0' + (dataItem.purchaseOrder.createdAt.dayOfMonth);
                } else {
                    day = (dataItem.purchaseOrder.createdAt.dayOfMonth);
                }
                if (dataItem.purchaseOrder.createdAt.monthValue < 10) {
                    month = '0' + (dataItem.purchaseOrder.createdAt.monthValue);
                } else {
                    month = dataItem.purchaseOrder.createdAt.monthValue;
                }
                return new Date(dataItem.purchaseOrder.createdAt.year + "-" + month + "-" + day);
            } else if (dataItem.purchaseOrder) {
                return dataItem.purchaseOrder.dateDelivery;
            } else {
                if (dataItem.createdAt.dayOfMonth < 10) {
                    day = '0' + (dataItem.createdAt.dayOfMonth);
                } else {
                    day = (dataItem.createdAt.dayOfMonth);
                }
                if (dataItem.createdAt.monthValue < 10) {
                    month = '0' + (dataItem.createdAt.monthValue);
                } else {
                    month = dataItem.createdAt.monthValue;
                }
                return new Date(dataItem.createdAt.year + "-" + month + "-" + day);
            }

        }

        function viewIMG(id) {
            vm.detailsInvoice.forEach(function (data) {
                data.invoicePurchase.files.forEach(function (file) {
                    if (id === file.id) {
                        $mdDialog.show({
                            controller: 'DialogPhotoController',
                            controllerAs: 'vm',
                            templateUrl: 'app/main/apps/files/dialogPhoto/dialogPhoto.html',
                            parent: angular.element("#main"),
                            name: file.originalName,
                            url: vm.URLPHOTOS + file.parentPath + file.name + file.extension,
                            clickOutsideToClose: false
                        }).then(function (answer) {

                        });
                    }
                });
            });

        }

        function selectRequisition(row) {
            cleanData();
            if (row.originType && row.originType.originTypeCode === '01') {
                vm.requisitionFromOtherOrigin = true;
            }

            row.department.id = row.department.id.toString();
            row.costCenter.id = row.costCenter.id.toString();

            if (row.departmentFirsRecept) {
                row.departmentFirsRecept.id = row.departmentFirsRecept.id.toString();
            }

            api.ComprasWS.ProcessFlow.get({ id: row.id, type: 1 }, function (row) {
                vm.infoProcessFlow = row;

            });

            $timeout(function () {
                vm.requisition = row;
                getQuotation(vm.requisition.id);
                getPurchaseOrder(vm.requisition.id);
                getInvoice(vm.requisition.id);

                $timeout(function () {
                    $rootScope.loadingProgress = false;
                    getDetails();
                    vm.currentTab++;

                });
            });
        }

        function editBussines(ev) {
            $mdDialog.show({
                controller: 'RequisitionEditDataBussinesController',
                controllerAs: 'vm',
                locals: {
                    requisition: vm.requisition,
                },
                templateUrl: 'app/main/apps/requisition/requisition-report/requisitionEditDataBussines/requisitionEditDataBussines.html',
                parent: angular.element("#main"),
                targetEvent: ev,
                clickOutsideToClose: false
            }).then(function (response) {
                vm.requisition = response;
            });
        }



        function cleanData() {
            vm.requisition = {};
            vm.quotationsDetails = [];
            vm.detailsPurchaseOrder = [];
            vm.detailsInvoice = [];
            vm.details = [];
            vm.quotations = [];
        }

        function getDimensionCompany() {
            const NUMBER_DIMENSION_THREE = 3;
            const NUMBER_DIMENSION_FOUR = 4;
            const NUMBER_DIMENSION_FIVE = 5;
            api.GeneralWS.DimensionCompany.byCompany.getList(
                { 'company': $rootScope.bsCircle.company.id }
            ).$promise.then(function (responseDimension) {
                for (let i = 0; i < responseDimension.length; i++) {
                    if (responseDimension[i].dimensionNumber === NUMBER_DIMENSION_THREE) {
                        vm.dimensionCompanyDetail3 = responseDimension[i];
                    } else if (responseDimension[i].dimensionNumber === NUMBER_DIMENSION_FOUR) {
                        vm.dimensionCompanyDetail4 = responseDimension[i];
                    } else if (responseDimension[i].dimensionNumber === NUMBER_DIMENSION_FIVE) {
                        vm.dimensionCompanyDetail5 = responseDimension[i];
                    } else {
                        vm.dimensionCompanyDetail1 = responseDimension[i];
                    }
                }
            });
        }

        function getFilesByRequisition() {
            api.ComprasWS.RequisitionFiles.getFilesByRequisition.getList(
                { 'requisitionId': vm.requisition.id, 'idCircle': $rootScope.bsCircle.id },
                function (respFiles) {
                    vm.requisitionFiles = respFiles;
                    vm.masterGridOptionsFiles.api.setColumnDefs(vm.masterColumnDefsFiles);
                    vm.masterGridOptionsFiles.api.setRowData(vm.requisitionFiles);
                });
        }

        function getInfoRequisitions() {
            getQuotation(vm.requisition.id);
            getPurchaseOrder(vm.requisition.id);
            getInvoice(vm.requisition.id);

            $timeout(function () {
                $rootScope.loadingProgress = false;
                getDetails();
                getFilesByRequisition();

            });
        }

        function viewImgReq(file) {
            $mdDialog.show({
                controller: 'DialogPhotoController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/files/dialogPhoto/dialogPhoto.html',
                parent: angular.element('#main'),
                name: file.originalName,
                url: vm.URLPHOTOS + file.parentPath + file.name + file.extension,
                clickOutsideToClose: false
            }).then(function (answer) {
                $log.debug(answer);
            });
        }

        function getMainMenuItems(){
            return function (params) {
                return getHeaderMenu(params, $filter);
            };
        }

        function getLocaleTextFunc(){
            return function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            };
        }

        function getCellRendererFilesName() {
            return function (params) {
                return params.data.fileStorage.originalName + params.data.fileStorage.extension;
            };
        }

        function getCellRendererFilesPhoto() {
            return function (params) {
                if (params.data) {
                    return '<div class="custom-image" layout="column"'+
                        'ng-if="data.fileStorage.extension===\'.jpg\' ' +
                        '|| data.fileStorage.extension===\'.jpeg\' ' +
                        '|| data.fileStorage.extension===\'.JPEG\' ' +
                        '|| data.fileStorage.extension===\'.png\' ' +
                        '|| data.fileStorage.extension === \'.JPG\' || data.fileStorage.extension === \'.PNG\'" ' +
                        'layout-align="center center" ng-click="vm.viewImgReq(data.fileStorage)"> ' +
                        '<img class="custom-img" width="100%" ' +
                        ' style="padding-left:15px; padding-right:15px"'+
                        'height="100%" id="fullUrl" alt="{{data.fileStorage.name}}" ng-src="{{vm.URLPHOTOS + ' +
                        'data.fileStorage.parentPath + ' +
                        'data.fileStorage.name + data.fileStorage.extension}}" /> ' +
                        '</div> ' +
                        '<div layout="column" ng-if="data.fileStorage.extension!==\'.jpg\'  ' +
                        '&& data.fileStorage.extension!==\'.jpeg\' ' +
                        '&& data.fileStorage.extension!==\'.JPEG\' ' +
                        '&& data.fileStorage.extension!==\'.png\' ' +
                        '&& data.fileStorage.extension !== \'.JPG\' ' +
                        '&& data.fileStorage.extension !== \'.PNG\'" ' +
                        'layout-align="center center"> ' +
                        '<a title="{{data.fileStorage.originalName +  ' +
                        'data.fileStorage.extension}}" ' +
                        'data-gallery ng-href="{{vm.URLPHOTOS + data.fileStorage.parentPath + ' +
                        'data.fileStorage.name + ' +
                        'data.fileStorage.extension}}" download="{{data.fileStorage.originalName + ' +
                        'data.fileStorage.extension}}" target="_blank" ng-if="data.fileStorage !== null ' +
                        '&& data.fileStorage !== undefined ' +
                        '&& data.fileStorage.extension !== \'.jpg\' && data.fileStorage.extension !== \'.png\' ' +
                        '&& data.fileStorage.extension !== \'.JPG\' && data.fileStorage.extension !== \'.PNG\' ' +
                        '&& data.fileStorage.extension !== \'.jpeg\' && data.fileStorage.extension !== \'.JPEG\'"> ' +
                        '<md-icon md-font-icon="icon-file-document"></md-icon> ' +
                        '</a> ' +
                        '</div>';
                }
                return '';
            };

        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.requisition')
        .controller('RequisitionTemplatesController', RequisitionTemplatesController);

    /** @ngInject */
    function RequisitionTemplatesController($state, api, $rootScope, $log, $mdDialog, $filter, $timeout, $scope, MessageService) {
        var vm = this;

        vm.masterColumnDefs = [
            {
                headerName: 'TEMPLATE.DESCRIPTION',
                field: "description",
                headerCellRenderer: getHeader,
                width: 300,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'TEMPLATE.DEPARTMENT',
                field: "department.description",
                headerCellRenderer: getHeader,
                width: 300,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'TEMPLATE.COSTCENTER',
                field: "costCenter.description",
                width: 250,
                headerCellRenderer: getHeader,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'REQUISITION.REQUISITION_TYPE',
                field: "requisitionType.description",
                width: 250,
                headerCellRenderer: getHeader,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'TEMPLATE.PT.MONTHSTART',
                field: "monthStart",
                headerCellRenderer: getHeader,
                cellRenderer: function (params) {
                    return '<span translate="TEMPLATE.PT.MONTH.' + params.data.monthStart + '"></span>';
                },
                width: 125,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'TEMPLATE.PT.YEARSTART',
                field: "yearStart",
                headerCellRenderer: getHeader,
                width: 125,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'TEMPLATE.PT.FRECUENCY',
                field: "frecuency",
                headerCellRenderer: getHeader,
                cellRenderer: function (params) {
                    return '<span translate="TEMPLATE.PT.DATETYPES.' + params.data.frecuency + '"></span>';
                },
                width: 125,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'TEMPLATE.PT.REPITITIONS',
                field: "repititions",
                headerCellRenderer: getHeader,
                width: 125,
                enableRowGroup: true,
                enablePivot: true,
                cellStyle: { 'text-align': 'center' }
            },
            {
                headerName: 'TEMPLATE.ACTIVE',
                field: "active",
                headerCellRenderer: getHeader,
                cellRenderer: function (params) {
                    if (params.value) {
                        return '<div layout="row" layout-align="center center"><i class="icon-checkbox-marked-circle green-500-fg"></i></div>';
                    }
                    return '<div layout="row" layout-align="center center"><i class="icon-cancel red-500-fg"></i></div>';
                },
                width: 125,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'TEMPLATE.ACTIONS',
                name: "actions",
                headerCellRenderer: getHeader,
                suppressSorting: true,
                suppressMenu: true,
                width: 250,
                cellRenderer: function (params) {
                    return '<div style="width: 100%;">' +
                        '<md-button class="edit-button md-icon-button" ng-show="data.active"' +
                        'ng-click="vm.gotoTemplateDetail(data.id, data.shareMe)" aria-label="Order details"' +
                        'translate translate-attr-aria-label="TEMPLATE.PT.ORDER_DETAILS">' +
                        '<md-tooltip ng-if="!data.shareMe" md-direction="bottom">' +
                        '{{"TEMPLATE.EDIT"| translate}}' +
                        '</md-tooltip>' +
                        '<md-tooltip ng-if="data.shareMe" md-direction="bottom">' +
                        '{{"TEMPLATE.VIEW"| translate}}' +
                        '</md-tooltip>' +
                        '<md-icon ng-if="!data.shareMe" md-font-icon="icon-border-color" class="s16"></md-icon> ' +
                        '<md-icon ng-if="data.shareMe" md-font-icon="icon-eye" class="s16"></md-icon> ' +
                        '</md-button>' +
                        '<md-button ng-if="!data.shareMe" class="edit-button md-icon-button"' +
                        'ng-show="data.active" ng-click="vm.deleteTemplate($event, data.id,' + params.rowIndex + ')" aria-label="Compare"' +
                        'translate translate-attr-aria-label="TEMPLATE.PT.COMPARE">' +
                        '<md-tooltip md-direction="bottom">' +
                        '{{"TEMPLATE.CANCELAR"| translate}}' +
                        '</md-tooltip>' +
                        '<md-icon md-font-icon="icon-minus-circle" class="s16 md-warn"></md-icon> ' +
                        '</md-button>' +
                        '<md-button ng-if="!data.shareMe" class="edit-button md-icon-button" ng-show="data.active" ' +
                        'ng-click="vm.shareTemplate($event, data,' + params.rowIndex + ')" aria-label="Compare"' +
                        'translate translate-attr-aria-label="TEMPLATE.PT.COMPARE">' +
                        '<md-tooltip md-direction="bottom">' +
                        '{{"TEMPLATE.SHARE"| translate}}' +
                        '</md-tooltip>' +
                        '<md-icon md-font-icon="icon-share-variant" class="s16"></md-icon> ' +
                        '</md-button>' +
                        '</div>';
                },
                cellStyle: { 'padding': '0px' },
                pinned: "right"
            }
        ];

        vm.masterGridOptions = {
            enableSorting: true,
            debug: false,
            enableFilter: true,
            enableColResize: true,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowData: null,
            groupHeaders: true,
            headerHeight: 50,
            rowHeight: 40,
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            },
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            doesDataFlower: function (dataItem) {
                return true;
            },
            isExternalFilterPresent: isExternalFilterPresent,
            doesExternalFilterPass: doesExternalFilterPass
        };

        var filter = 'everyone';

        function isExternalFilterPresent() {
            return filter !== '';
        }

        function doesExternalFilterPass(node) {
            if (filter && filter !== 'everyone') {
                var arrdt = node.data.filter.split(filter);
                return arrdt.length > 1;
            }
            return true;
        }

        $scope.$watch('vm.search',
            function (newValue) {
                filter = newValue ? newValue.toLowerCase() : 'everyone';
                vm.masterGridOptions.api.onFilterChanged();
            }
        );

        // Methods
        vm.convertDate = convertDate;
        vm.gotoTemplateDetail = gotoTemplateDetail;
        vm.newTemplateDetail = newTemplateDetail;
        vm.deleteTemplate = deleteTemplate;

        //////////

        function convertDate(dateS) {
            return new Date(dateS + ' 00:00:00');
        }

        function deleteTemplate(e, id, i) {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('TEMPLATE.CANCELAR'))
                .textContent($filter('translate')('TEMPLATE.MSG.CONFIRMACION_CANCEL'))
                .ok($filter('translate')('TEMPLATE.MSG.SI'))
                .cancel($filter('translate')('TEMPLATE.MSG.NO'));

            $mdDialog.show(confirm).then(function () {
                $rootScope.loadingProgress = true;
                api.ComprasWS.RequisitionTemplate.delete({ company: $rootScope.bsCircle.company.id, id: id }, function (response) {

                    vm.productTemplates[i].active = false;

                    $rootScope.loadingProgress = false;
                    vm.masterGridOptions.api.setRowData(vm.productTemplates);

                    MessageService.show('TEMPLATE.MSG.DELETED');
                }, function (response) {// Error
                    $log.debug(response);
                });

            }, function () {
            });
        }

        function gotoTemplateDetail(id, shareMe) {
            if (!shareMe) {
                $state.go('app.requisition.template.detail', { id: id });
            } else {
                $state.go('app.requisition.template.detail', { id: id, "shareMe": shareMe });
            }
        }

        function newTemplateDetail() {
            $state.go('app.requisition.template.detail');
        }

        function onInit() {
            $rootScope.loadingProgress = true;
            vm.loading = true;

            api.ComprasWS.RequisitionTemplate.query({ company: $rootScope.bsCircle.company.id }, function (response) {
                vm.productTemplates = new jinqJs()
                    .from(response)
                    .select(function (r) {
                        var d = r;
                        var frecuency = $filter('translate')('TEMPLATE.PT.DATETYPES.' + d.frecuency);
                        d.department = d.userDepartment.department;
                        d.costCenter = d.userCostCenter.costCenter;
                        d.filter = (d.description + "," + d.department.description + "," +
                            d.costCenter.description + "," + frecuency + "," +
                            (d.requisitionType ? d.requisitionType.description : "")).toLowerCase();
                        return d;
                    });

                vm.productTemplates = response;

                api.ComprasWS.RequisitionTemplateShareMe.query({ company: $rootScope.bsCircle.company.id }, function (response) {
                    new jinqJs()
                        .from(response)
                        .select(function (r) {
                            r.shareMe = true;

                            vm.productTemplates.push(r);
                            return r;

                        });
                    vm.masterGridOptions.api.setColumnDefs(vm.masterColumnDefs);
                    vm.masterGridOptions.api.setRowData(vm.productTemplates);
                });

                vm.loading = false;
                $rootScope.loadingProgress = false;

            }, function (response) {// Error
                $log.debug(response);

                vm.loading = false;
                vm.masterGridOptions.api.setColumnDefs(vm.masterColumnDefs);
                vm.masterGridOptions.api.setRowData([]);

                $rootScope.loadingProgress = false;
            });
        }

        $timeout(function (d) {
            onInit();
        }, 300);

        vm.shareTemplate = function (ev, data, index) {
            $state.go('app.requisition.template.detailShares', { id: data.id });
        };


    }
})();

(function () {
    'use strict';

    angular
        .module('app.requisition')
        .controller('RequisitionsCotizeController', RequisitionsCotizeController);

    /** @ngInject */
    function RequisitionsCotizeController($state, api, $rootScope, $log, $mdDialog, $filter,
        $timeout, $scope, $stateParams, MessageService, $templateRequest) {
        var vm = this;

        vm.statusNameByRole = "";
        vm.nameRole = $rootScope.bsCircle.name;
        vm.iconChangeStatusButton = "";
        vm.showChangeStatusButton = false;
        vm.isCreate = $stateParams.status === 'Creando';
        vm.statusToChange = $stateParams.status;
        vm.isTicket = $stateParams.tickets;
        vm.chageStatusButton = getDatasToChange($stateParams.status);
        vm.isBuyer = $stateParams.isBuyer;
        vm.pageSize = 100;
        vm.page = 0;
        vm.requisitionToAuthorize = [];
        vm.authorizeRequisitions = authorizeRequisitions;
        vm.cancelRequisitions = cancelRequisitions;
        vm.addUserRequisitionToQuote = addUserRequisitionToQuote;
        vm.userToQuote = $rootScope.bsCircle.name === 'ROLE_COMPRAS_OPERADOR';
        vm.pendingAssignment = false;
        vm.loadDataToCotize = loadDataToCotize;
        const ASSIGN_REQUIREMENT_TO_QUOTE = 'Asignar requerimiento para cotizar';
        vm.filterPendingQuote = $rootScope.getEspecialActionByName(ASSIGN_REQUIREMENT_TO_QUOTE);
        const NUMBER_NINE = 9;

        vm.masterColumnDefs = [
            {
                headerName: '#',
                field: "id",
                width: 135,
                cellRenderer: 'group',
                pinned: 'left'
            },
            {
                headerName: 'REQUISITION.DEPARTMENT',
                field: "department.description",
                headerCellRenderer: getHeader,
                width: 250,
                filter: 'text',
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'REQUISITION.COSTCENTER',
                field: "costCenter.description",
                headerCellRenderer: getHeader,
                width: 200,
                filter: 'text',
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'REQUISITION.PROJECT',
                field: "prjName",
                headerCellRenderer: getHeader,
                width: 150,
                filter: 'text',
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'REQUISITION.MAXDATEPURCHASE',
                field: "maxDatePurchase",
                headerCellRenderer: getHeader,
                valueFormatter: function (params) {
                    return $filter('date')(params.value, 'dd/MM/yyyy');
                },
                enableRowGroup: true,
                filter: 'date',
                enablePivot: true
            },
            {
                headerName: 'REQUISITION.REQUISITION_TYPE',
                field: "requisitionType.description",
                headerCellRenderer: getHeader,
                valueFormatter: function (params) {
                    return $filter('date')(params.value, 'dd/MM/yyyy');
                },
                enableRowGroup: true,
                filter: 'date',
                enablePivot: true
            },
            {
                headerName: 'REQUISITION.DESCRIPTION',
                field: "description",
                headerCellRenderer: getHeader,
                valueFormatter: function (params) {
                    return $filter('date')(params.value, 'dd/MM/yyyy');
                },
                enableRowGroup: true,
                filter: 'date',
                enablePivot: true
            },
            {
                headerName: 'REQUISITION.ACTIONS',
                name: "actions",
                headerCellRenderer: getHeader,
                suppressSorting: true,
                suppressMenu: true,
                width: 250,
                cellRenderer: renderer,
                cellStyle: { 'padding': '0px' },
                pinned: 'right'
            }
        ];

        if ($stateParams.status === 'Autorizado') {
            vm.masterColumnDefs.splice(4, 0, {
                headerName: 'REQUISITION.STATUS',
                field: "purchaseStatus.description",
                headerCellRenderer: getHeader,
                width: 200,
                enableRowGroup: true,
                filter: 'text',
                enablePivot: true
            });
        }

        if ($stateParams.status === 'Ingresado' || $stateParams.status === "Autorizado") {
            vm.masterColumnDefs.splice(1, 0, {
                headerName: 'REQUISITION.COMPANY_BUYER',
                field: "department.company.name",
                headerCellRenderer: getHeader,
                width: 200,
                filter: 'text',
                enableRowGroup: true,
                enablePivot: true,
            });
        }

        if ($stateParams.status === 'Autorizado'
            && $rootScope.getEspecialActionByName(ASSIGN_REQUIREMENT_TO_QUOTE)) {
            vm.masterColumnDefs.splice(NUMBER_NINE, 0, {
                headerName: 'REQUISITION.USER_TO_QUOTE',
                field: 'userToQuote.account',
                headerCellRenderer: getHeader,
                width: 250,
                filter: 'text',
                enableRowGroup: true,
                enablePivot: true
            });
        }

        if (vm.isTicket) {
            vm.masterColumnDefs.splice(1, 0, {
                headerName: 'REQUISITION.TICKET_ID',
                field: "referenceId",
                headerCellRenderer: getHeader,
                width: 200,
                filter: 'text',
                enableRowGroup: true,
                enablePivot: true
            });
        }

        vm.masterGridOptions = {
            columnDefs: vm.masterColumnDefs,
            enableSorting: true,
            debug: false,
            enableFilter: true,
            enableColResize: true,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowData: null,
            headerHeight: 50,
            rowHeight: 40,
            groupHeaders: false,
            rowModelType: "enterprise",
            rowSelection: 'multiple',
            toolPanelSuppressGroups: true,
            pagination: true,
            paginationPageSize: vm.pageSize,
            cacheBlockSize: vm.pageSize,
            groupSuppressBlankHeader: true,
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            },
            doesDataFlower: function (dataItem) {
                return true;
            },
            isExternalFilterPresent: isExternalFilterPresent,
            doesExternalFilterPass: doesExternalFilterPass,
            fullWidthCellRenderer: getDetails,
            isFullWidthCell: function (rowNode) {
                return rowNode.level === 1;
            },
            getRowHeight: function (params) {
                var rowIsDetailRow = params.node.level === 1;
                return rowIsDetailRow ? 250 : 45;
            },
            onGridReady: function (params) {

            }
        };

        vm.masterColumnDefs.forEach(function (d) {
            correctFilterParams(d);
        });

        var templateDetail;
        $templateRequest("app/main/apps/requisition/requisition-cotize/detailRow/requisitionDetail.html").then(function (template) {
            templateDetail = template;
        }, function () {
        });

        function getDetails(params) {
            params.$scope.id = 'det' + params.data.id;

            params.$scope.dtOptions = {
                dom: 'rt',
                scrollY: '200px',
                responsive: true
            };

            var mouseWheelListener = function (event) {
                event.stopPropagation();
            };

            setTimeout(function () {
                var container = document.querySelector("#containerDetailNeg" + params.$scope.id);
                if (container) {
                    container.addEventListener('mousewheel', mouseWheelListener);
                    container.addEventListener('DOMMouseScroll', mouseWheelListener);
                }

                api.ComprasWS.RequisitionDetail.query({ idCircle: $rootScope.bsCircle.id, idRequisition: params.data.id },
                    function (data) {
                        params.$scope.details = data;
                    },
                    function (error) {

                    }
                );



            }, 1000);
            return templateDetail;
        }

        function correctFilterParams(column) {
            switch (column.filter) {
                case 'number':
                    column.filterParams = {
                        filterOptions: ['equals'],
                        newRowsAction: 'keep'
                    };
                    break;
                case 'text':
                    column.filterParams = {
                        filterOptions: ['contains'],
                        newRowsAction: 'keep'
                    };
                    break;
                case 'date':
                    column.suppressFilter = true;
                    break;
            }
        }

        var filter = '';

        function isExternalFilterPresent() {
            return filter !== '';
        }

        function doesExternalFilterPass(node) {
            if (filter && filter !== 'everyone') {
                var arrdt = node.data.filter.split(filter);
                return arrdt.length > 1;
            }
            return true;
        }

        $scope.$watch('vm.search',
            function (newValue) {
                filter = newValue ? newValue.toLowerCase() : '';
                vm.masterGridOptions.api.onFilterChanged();
            }
        );

        function loadData() {
            var projectIds = [];
            vm.masterGridOptions.api.paginationSetPageSize(vm.pageSize);
            api.ComprasWS.Requisition.page(
                {
                    idCircle: $rootScope.bsCircle.id,
                    status: vm.status,
                    page: vm.masterGridOptions.api.paginationGetCurrentPage(),
                    pageSize: vm.pageSize,
                    tickets: $stateParams.tickets,
                    'filter': filter
                },
                function (response) {// Success
                    vm.requisitions = new jinqJs()
                        .from(response.content)
                        .orderBy([{ field: 'id', sort: 'asc' }])
                        .select(function (r) {
                            var d = r;
                            d.filter = (d.id + "," + d.department.description + "," +
                                d.costCenter.description + "," + (d.requisitionType !== null ? d.requisitionType.description : '') +
                                "," + d.description).toLowerCase();
                            if (d.projectId !== undefined) {
                                if (projectIds.length > 0) {
                                    if (projectIds.indexOf(r.projectId) < 0) {
                                        projectIds.push(r.projectId);
                                    }
                                } else {
                                    projectIds.push(d.projectId);
                                }
                            }
                            return d;
                        });
                    if (projectIds.length > 0) {
                        getAllProject(param.response);
                    } else {
                        vm.loading = false;
                        vm.masterGridOptions.api.setRowData(vm.requisitions);
                        filter = '';
                        $rootScope.loadingProgress = false;
                        $log.debug(vm.requisitions);
                    }
                }, function (response) {// Error
                    $log.debug(response);
                    vm.loading = false;
                    $rootScope.loadingProgress = false;
                });

        }

        function loadDataToCotize() {
            var projectIds = [];
            vm.masterGridOptions.api.paginationSetPageSize(vm.pageSize);
            var dataSource = {
                paginationPageSize: vm.pageSize,
                getRows: function (params) {
                    vm.isShowProgressLinear = true;
                    api.ComprasWS.Requisitions.toCotize.page(
                        {
                            idCircle: $rootScope.bsCircle.id,
                            page: vm.masterGridOptions.api.paginationGetCurrentPage(),
                            pageSize: vm.pageSize,
                            tickets: $stateParams.tickets,
                            userToQuote: vm.userToQuote,
                            'pendingAssignment': vm.pendingAssignment,
                            'filter': filter
                        },
                        function (response) {// Success
                            vm.requisitions = new jinqJs()
                                .from(response.content)
                                .orderBy([{ field: 'id', sort: 'asc' }])
                                .select(function (r) {
                                    var d = r;
                                    d.filter = (d.id + "," + d.department.description + "," +
                                        d.costCenter.description + "," + (d.requisitionType !== null ? d.requisitionType.description : '') +
                                        "," + d.description).toLowerCase();
                                    if (projectIds.length > 0) {
                                        if (projectIds.indexOf(r.projectId) < 0) {
                                            projectIds.push(r.projectId);
                                        }
                                    } else {
                                        projectIds.push(d.projectId);
                                    }
                                    return d;
                                });
                            if (projectIds.length > 0) {
                                getAllProject(params, response, vm.requisitions, projectIds);
                            } else {
                                params.successCallback(vm.requisitions, response.totalElements);
                                vm.isShowProgressLinear = false;
                                vm.showGrid = true;
                                vm.hasData = response.content.length > 0;
                                $rootScope.loadingProgress = false;
                                vm.loading = false;
                            }
                        }, function (response) {
                            vm.isShowProgressLinear = false;
                            $log.error(response);
                        });
                }
            };
            vm.masterGridOptions.api.setEnterpriseDatasource(dataSource);

        }
        function getAllProject(params, response, data, projectIds) {
            api.ProyectosWS.getAllProject.get({ 'ids': projectIds }, function (pjr) {
                data.forEach(function (row) {
                    pjr.forEach(function (res) {
                        if (row.projectId === res.id) {
                            row.prjName = res.name;
                        }
                    });
                });
                params.successCallback(data, response.totalElements);
                vm.isShowProgressLinear = false;
                vm.showGrid = true;
                vm.hasData = response.content.length > 0;
                $rootScope.loadingProgress = false;
                vm.loading = false;
            }, function () {
                params.successCallback(data, response.totalElements);
            });
        }

        vm.loading = true;
        const FOUR_HUNDRED_TIME_OUT = 400;
        $timeout(function (d) {
            if ($rootScope.bsCircle) {
                $rootScope.loadingProgress = true;
                vm.loading = true;
                vm.status = $stateParams.status === 'Autorizado' ? 'Autorizado,Licitando' : $stateParams.status;
                vm.masterGridOptions.api.setColumnDefs(vm.masterColumnDefs);

                if ($stateParams.status === 'Autorizado') {
                    loadDataToCotize();
                } else {
                    loadData();
                }
                $timeout(function () {
                    getDimensionCompany();
                }, FOUR_HUNDRED_TIME_OUT);
            } else {
                vm.loading = false;
                $state.go('app.dashboard_project');
            }
        }, FOUR_HUNDRED_TIME_OUT);

        // Methods
        vm.convertDate = convertDate;
        vm.gotoRequisitionDetail = gotoRequisitionDetail;
        vm.newRequisition = newRequisition;
        vm.deleteRequisition = deleteRequisition;
        vm.presentRequisition = presentRequisition;

        //////////

        function convertDate(dateS) {
            return new Date(dateS + ' 00:00:00');
        }

        function presentRequisition(data, i) {


            var confirm = $mdDialog.confirm()
                .title($filter('translate')('REQUISITION.MSG.' + vm.statusToChange + '_REQUISITION'))
                .textContent($filter('translate')('REQUISITION.MSG.CONFIRMACION_' + vm.statusToChange + '_REQUISITION'))
                .ok($filter('translate')('REQUISITION.MSG.SI'))
                .cancel($filter('translate')('REQUISITION.MSG.NO'));
            $mdDialog.show(confirm).then(function () {

                if ($stateParams.status === 'Autorizado') {
                    $state.go('app.quotation.new', { quotationId: 0, requisitionId: data.id });
                } else {

                    $rootScope.loadingProgress = true;

                    var promise = api.ComprasWS.Requisition.changeStatus({ 'idCircle': $rootScope.bsCircle.id, 'id': data.id }, null).$promise;
                    promise.then(function (response) {
                        if (response.circle) {
                            var obj = getObjectTender(response);
                            api.LicitadorWS.Tender.create({ 'circle': response.circle.id }, obj,
                                function (data) {
                                    MessageService.show('REQUISITION.MSG.TENDERCREATED');

                                    $rootScope.loadingProgress = false;
                                    spliceRequisition(data.id);
                                    vm.masterGridOptions.api.setRowData(vm.requisitions);
                                },
                                function (err) {
                                    $rootScope.loadingProgress = false;
                                    MessageService.show('REQUISITION.MSG.ERROR');
                                }
                            );
                        } else {
                            MessageService.show("REQUISITION.MSG.CHANGESTATUS." + vm.statusToChange);
                            $rootScope.loadingProgress = false;
                            spliceRequisition(data.id);
                            vm.masterGridOptions.api.setRowData(vm.requisitions);
                        }
                    }, function (response) {
                        $rootScope.loadingProgress = false;
                        var msg = 'ERROR';
                        if (response.data === 'No Detail') {
                            msg = 'DETAIL';
                        }
                        if (response.data === 'No_products') {
                            msg = 'NOT_PRODUCT_NEGOTIATED';
                        }

                        MessageService.show('REQUISITION.MSG.' + msg);
                    });
                }

            }, function () {
            });
        }


        /**
         * Delete
         *
         * @param e
         * @param id
         * @param i
         * @returns {*}
         */
        function deleteRequisition(e, id, i) {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('REQUISITION.CANCELAR'))
                .textContent($filter('translate')('REQUISITION.MSG.CONFIRMACION_CANCEL'))
                .ok($filter('translate')('REQUISITION.MSG.SI'))
                .cancel($filter('translate')('REQUISITION.MSG.NO'));

            $mdDialog.show(confirm).then(function () {

                $rootScope.loadingProgress = true;

                api.ComprasWS.Requisition.delete({ idCircle: $rootScope.bsCircle.id, id: id }, function (response) {// Success
                    spliceRequisition(id);
                    $rootScope.loadingProgress = false;
                    vm.masterGridOptions.api.setRowData(vm.requisitions);

                    MessageService.show('REQUISITION.MSG.DELETED');
                }, function (response) {// Error
                    $log.debug(response);
                });

            }, function () {
            });
        }

        /**
         * Go to product detail
         *
         * @param id
         */
        function gotoRequisitionDetail(id) {
            if (vm.isTicket) {
                if ($stateParams.status === 'Autorizado') {
                    $state.go('app.requisition.AutorizadoTickets.detail', { id: id });
                } else {
                    $state.go('app.requisition.CreandoTickets.detail', { id: id });
                }
            } else if ($stateParams.isBuyer && $stateParams.status === 'Autorizado') {
                $state.go($state.current.name + '.detail', { id: id, isBuyer: true });
            } else {
                $state.go('app.requisition.' + $stateParams.status + '.detail', { id: id });
            }
        }

        /**
         * Go to product detail
         *
         */
        function newRequisition() {
            $state.go('app.requisition.Creando.detail');
        }

        function renderer(params) {
            var toRet = '<div style="width: 100%;">';
            if (vm.isCreate) {
                toRet = toRet + '<md-button class="edit-button md-icon-button"' +
                    'ng-click="vm.gotoRequisitionDetail(data.id)" aria-label="Order details"' +
                    'translate translate-attr-aria-label="REQUISITION.ORDER_DETAILS">' +
                    '<md-tooltip md-direction="bottom">' +
                    '{{"REQUISITION.DETAIL.EDIT"| translate}}' +
                    '</md-tooltip>' +
                    '<md-icon md-font-icon="icon-border-color" class="s16"></md-icon> ' +
                    '</md-button>';
            } else {
                toRet = toRet + '<md-button class="edit-button md-icon-button"' +
                    'ng-click="vm.gotoRequisitionDetail(data.id)" aria-label="Order details"' +
                    'translate translate-attr-aria-label="REQUISITION.ORDER_DETAILS">' +
                    '<md-tooltip md-direction="bottom">' +
                    '{{"REQUISITION.DETAIL.VIEW"| translate}}' +
                    '</md-tooltip>' +
                    '<md-icon md-font-icon="icon-eye" class="s16"></md-icon> ' +
                    '</md-button>';
            }

            if (params.data && params.data.purchaseStatus.description !== 'Licitando' && !vm.isBuyer) {
                toRet = toRet + '<md-button class="edit-button md-icon-button" ' +
                    'ng-click="vm.presentRequisition(data, ' + params.rowIndex + ')" aria-label="present requisition"' +
                    'translate translate-attr-aria-label="REQUISITION.ORDER_DETAILS">' +
                    '<md-tooltip md-direction="bottom">' +
                    '{{vm.chageStatusButton.desc| translate}}' +
                    '</md-tooltip>' +
                    '<md-icon md-font-icon="{{vm.chageStatusButton.icon}}" class="s16"></md-icon>' +
                    '</md-button>';
            }

            if (vm.isCreate || (params.data && params.data.purchaseStatus.description !== 'Licitando'
                && params.data.purchaseStatus.description !== 'Autorizado' && !vm.isBuyer)) {
                toRet = toRet + '<md-button ng-if="vm.nameRole !== \'ROLE_COMPRAS\'" ' +
                    'class="edit-button md-icon-button" ng-click="vm.deleteRequisition($event, data.id,' + params.rowIndex + ')"' +
                    ' aria-label="Cancel"' +
                    'translate translate-attr-aria-label="REQUISITION.CANCELAR">' +
                    '<md-tooltip md-direction="bottom">' +
                    '{{"REQUISITION.CANCELAR"| translate}}' +
                    '</md-tooltip>' +
                    '<md-icon md-font-icon="icon-minus-circle" class="s16 md-warn"></md-icon> ' +
                    '</md-button>';
            }

            if ($rootScope.getEspecialActionByName(ASSIGN_REQUIREMENT_TO_QUOTE)) {
                toRet = toRet + '<md-button class="edit-button md-icon-button" ng-click="vm.addUserRequisitionToQuote(data)" aria-label="Cancel"'
                    + '                            translate translate-attr-aria-label="REQUISITION.ADD_REQUISITION_TO_COTIZE">'
                    + '                     <md-tooltip md-direction="bottom">'
                    + '                         {{"REQUISITION.ADD_REQUISITION_TO_COTIZE"| translate}}'
                    + '                     </md-tooltip>'
                    + '                     <md-icon md-font-icon="icon-account-plus" class="s16"></md-icon> '
                    + '                 </md-button>';
            }

            return toRet + '</div>';
        }

        function getDatasToChange(status) {
            var ret = { desc: 'REQUISITION.STATUSCHANGE.' + status };
            switch (status) {
                case 'Creando':
                    ret.icon = 'icon-content-paste';
                    break;
                case 'Ingresado':
                    ret.icon = 'icon-key-variant';
                    break;
                case 'Autorizado':
                    ret.icon = 'icon-thumb-up-outline';
                    break;
            }
            return ret;
        }

        function spliceRequisition(id) {
            var nro = 0;
            vm.requisitions.forEach(function (row) {
                if (row.id === id) {
                    vm.requisitions.splice(nro, 1);
                }
                nro += 1;
            });

            loadData();
        }

        function authorizeRequisitions(createTender) {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('REQUISITION.STATUSCHANGE.Ingresado'))
                .textContent($filter('translate')('REQUISITION.MSG.CONFIRMACION_Ingresado_REQUISITION'))
                .ok($filter('translate')('REQUISITION.MSG.SI'))
                .cancel($filter('translate')('REQUISITION.MSG.NO'));

            $mdDialog.show(confirm).then(function () {
                if (vm.requisitionToAuthorize.length > 0) {
                    for (var i = 0; i < vm.requisitionToAuthorize.length; i++) {
                        $rootScope.loadingProgress = true;
                        var promise = api.ComprasWS.Requisition.changeStatus(
                            { 'idCircle': $rootScope.bsCircle.id, 'id': vm.requisitionToAuthorize[i].id }, null).$promise;
                        promise.then(function (response) {
                            if (response.circle) {
                                var obj = getObjectTender(response);
                                api.LicitadorWS.Tender.create({ 'circle': response.circle.id }, obj,
                                    function (data) {
                                        MessageService.show('REQUISITION.MSG.TENDERCREATED');

                                        $rootScope.loadingProgress = false;
                                    },
                                    function (err) {
                                        $rootScope.loadingProgress = false;
                                        MessageService.show('REQUISITION.MSG.ERROR');
                                    }
                                );
                            } else {
                                MessageService.show("REQUISITION.MSG.CHANGESTATUS." + vm.statusToChange);
                                $rootScope.loadingProgress = false;
                            }
                        }, function (response) {
                            $rootScope.loadingProgress = false;
                            var msg = 'ERROR';
                            if (response.data === 'No Detail') {
                                msg = 'DETAIL';
                            }
                            if (response.data === 'No_products') {
                                msg = 'NOT_PRODUCT_NEGOTIATED';
                            }

                            MessageService.show('REQUISITION.MSG.' + msg);
                        });
                    }
                    $timeout(function (d) {
                        loadData();
                        vm.requisitionToAuthorize = [];
                    }, 300);
                }
                desSelectedGrid();
            }, function () {
            });
        }

        function cancelRequisitions() {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('REQUISITION.CANCELAR'))
                .textContent($filter('translate')('REQUISITION.MSG.CONFIRMACION_CANCEL'))
                .ok($filter('translate')('REQUISITION.MSG.SI'))
                .cancel($filter('translate')('REQUISITION.MSG.NO'));

            $mdDialog.show(confirm).then(function () {
                if (vm.requisitionToAuthorize.length > 0) {
                    for (var i = 0; i < vm.requisitionToAuthorize.length; i++) {
                        $rootScope.loadingProgress = true;
                        api.ComprasWS.Requisition.delete(
                            { idCircle: $rootScope.bsCircle.id, id: vm.requisitionToAuthorize[i].id }, function (response) {// Success
                                spliceRequisition(response.id);
                                $rootScope.loadingProgress = false;
                                vm.masterGridOptions.api.setRowData(vm.requisitions);

                                MessageService.show('REQUISITION.MSG.DELETED');
                            }, function (response) {// Error
                                $log.debug(response);
                            });
                    }
                }
                desSelectedGrid();
            }, function () {
            });
        }

        function desSelectedGrid() {
            vm.masterGridOptions.api.forEachNode(function (node) {
                node.setSelected(false);
            });
        }

        function getDimensionCompany() {
            const NUMBER_DIMENSION_THREE = 3;
            const NUMBER_DIMENSION_FOUR = 4;
            const NUMBER_DIMENSION_FIVE = 5;
            api.GeneralWS.DimensionCompany.byCompany.getList(
                { 'company': $rootScope.bsCircle.company.id }
            ).$promise.then(function (responseDimension) {
                for (let i = 0; i < responseDimension.length; i++) {
                    if (responseDimension[i].dimensionNumber === NUMBER_DIMENSION_THREE && !vm.dimensionCompanyDetail3) {
                        vm.dimensionCompanyDetail3 = responseDimension[i];
                        addMasterColumnDefs(responseDimension[i].description, 'dimensionCompanyDetail3.name', responseDimension[i].dimensionNumber);
                    } else if (responseDimension[i].dimensionNumber === NUMBER_DIMENSION_FOUR && !vm.dimensionCompanyDetail4) {
                        vm.dimensionCompanyDetail4 = responseDimension[i];
                        addMasterColumnDefs(responseDimension[i].description, 'dimensionCompanyDetail4.name', responseDimension[i].dimensionNumber);
                    } else if (responseDimension[i].dimensionNumber === NUMBER_DIMENSION_FIVE && !vm.dimensionCompanyDetail5) {
                        vm.dimensionCompanyDetail5 = responseDimension[i];
                        addMasterColumnDefs(responseDimension[i].description, 'dimensionCompanyDetail5.name', responseDimension[i].dimensionNumber);
                    } else {
                        vm.dimensionCompanyDetail1 = responseDimension[i];
                    }
                }
                vm.masterGridOptions.api.setColumnDefs(vm.masterColumnDefs);
            });
        }

        function addMasterColumnDefs(name, fieldName, number) {
            const NUMBER_FIVE_COLUMN_ADD = 7;
            vm.masterColumnDefs.splice((number + NUMBER_FIVE_COLUMN_ADD), 0, {
                headerName: name,
                field: fieldName,
                headerCellRenderer: getHeader,
                width: 200,
                enableRowGroup: true,
                filter: 'text',
                enablePivot: true
            });
        }

        function addUserRequisitionToQuote(data) {
            $mdDialog.show({
                controller: 'AddRequisitionToQuoteController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/requisition/requisition-cotize/addRequisitionToQuote/addRequisitionToQuote.html',
                parent: angular.element('#main'),
                clickOutsideToClose: false,
                fullscreen: true,
                locals: {
                    requisition: data
                }
            }).then(function () {
                loadDataToCotize();
            });
        }

    }
})();

(function () {
    'use strict';
    angular
        .module('app.requisition')
        .controller('requisitionCompareController', requisitionCompareController);

    /** @ngInject */
    function requisitionCompareController($state, api, $log, $rootScope, $mdDialog, $timeout, $filter, $stateParams, MessageService) {
        const vm = this;
        vm.loading = false;
        vm.currencies = [];
        vm.showExangeRate = false;
        vm.currencyExchangeRate = 1;
        vm.number2 = 2;
        vm.number100 = 100;
        vm.number500 = 500;
        vm.currentCurrencyData = {
            id: 0,
            exchangeRate: 1,
        };
        vm.masterColumnDefs = [
            {
                headerName: '',
                children: [
                    {
                        headerName: 'REQUISITION.DETAIL.PRODUCT',
                        field: 'productName',
                        headerCellRenderer: getHeader,
                        width: 250,
                        enableRowGroup: true,
                        enablePivot: true,
                    },
                ],
            },
            {
                headerName: '',
                children: [
                    {
                        headerName: 'REQUISITION.TOTAL',
                        field: 'total',
                        headerCellRenderer: getHeader,
                        width: 120,
                        cellStyle: { 'text-align': 'right' },
                    },
                ],
            },
        ];

        vm.masterColumnDefs[1].children[0].valueFormatter = function (params) {
            return $filter('number')(params.value, vm.number2);
        };

        vm.masterGridOptions = {
            columnDefs: vm.masterColumnDefs,
            enableSorting: true,
            debug: false,
            enableFilter: true,
            enableColResize: true,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowData: null,
            groupHeaders: true,
            headerHeight: 48,
            rowHeight: 40,
        };
        vm.masterGridOptions.getMainMenuItems = function (params) {
            return getHeaderMenu(params, $filter);
        };
        vm.masterGridOptions.localeTextFunc = function (key, defaultValue) {
            return translateGrid(key, defaultValue, $filter);
        };
        vm.masterGridOptions.doesDataFlower = function () {
            return true;
        };
        vm.requisition = {};
        vm.isHorizontalPer = false;
        vm.isVerticalPer = false;

        vm.gotoRequisitions = gotoRequisitions;
        vm.showPercentageByOrientation = showPercentageByOrientation;
        vm.changeCurrency = changeCurrency;
        vm.convertAmounts = convertAmounts;


        /**
         * Go to Requisitions page
         */
        function gotoRequisitions() {
            if ($stateParams.backTo) {
                $state.go($stateParams.backTo, { 'filter': $stateParams.filter });
            } else {
                $state.go('app.report.requisition', { 'filter': $stateParams.filter });
            }
        }

        init();
        /**
         * Initialize
         */
        function init() {
            $rootScope.loadingProgress = true;
            api.ComprasWS.Requisition.getId({ idCircle: $rootScope.bsCircle.id, id: $stateParams.id }, function (data) {
                $rootScope.loadingProgress = false;
                vm.requisition = data;
                requisitionCompareDialog();
            });
            api.GeneralWS.Currency.query({}).$promise.then(function (response) {
                vm.currencies = response;
                vm.currency = vm.currencies.find(function (currency) {
                    return currency.id === $rootScope.bsCircle.company.currency.id;
                });
                vm.currentCurrencyId = vm.currency.id;
            }, function (response) {
                $log.error(response);
            });
        }

        function requisitionCompareDialog() {
            $mdDialog.show({
                controller: 'requisitionCompareDialogController',
                controllerAs: 'vm',
                locals: {
                    requisitionId: $stateParams.id,
                },
                templateUrl: 'app/main/apps/requisition/requisition-compare/requisition-compare-dialog/requisition-compare-dialog.html',
                parent: angular.element('#main'),
                clickOutsideToClose: false,
            }).then(function (answer) {

                vm.loading = true;
                const selectedIds = [];

                selectedIds.push(vm.requisition.id);
                answer.forEach(function (selected) {
                    selectedIds.push(selected.id);
                });

                $rootScope.loadingProgress = true;
                api.ComprasWS.RequisitionDetails.toCompare.getList({
                    reqId: 0,
                    circleId: $rootScope.bsCircle.id,
                    requisitions: selectedIds.toString(),
                }, vm.filter).$promise.then(function (response) {
                    vm.data = processData(answer, response);
                    const columndDefs = vm.masterColumnDefs.concat(vm.data.columnsParentAndChild);
                    vm.masterGridOptions.api.setColumnDefs(columndDefs);
                    vm.masterGridOptions.api.setRowData(vm.data.processedData);
                    vm.masterGridOptions.api.setPinnedBottomRowData([vm.data.bottomRow]);
                    $rootScope.loadingProgress = false;
                    vm.loading = false;
                }, function (response) {
                    $log.error(response);
                    $rootScope.loadingProgress = false;
                    vm.loading = false;
                    MessageService.showErrorMessage('REQUISITION.MSG.ERROR');
                });

            }, function () {
                gotoRequisitions();
            });
        }

        function processData(requisitions, details) {
            const compareModel = {
                productId: '',
                productName: '',
                total: 0,
            };
            const amountFieldsName = [];
            compareModel['costCenter' + vm.requisition.id] = 0;
            amountFieldsName.push('costCenter' + vm.requisition.id);

            let headerNameWithDate = getDateToHeader(vm.requisition.createdAt);
            headerNameWithDate += '  (Req. ';
            headerNameWithDate += vm.requisition.id;
            headerNameWithDate += ') ';
            headerNameWithDate += '||' + vm.requisition.costCenter.description;

            const columnsParentAndChild = [
                getParentAndChildColumn(
                    vm.requisition.department.description,
                    'departmentPrincipal',
                    headerNameWithDate,
                    'costCenter' + vm.requisition.id
                ),
            ];
            columnsParentAndChild[0].children[0].cellStyle = function cellResalt() {
                return {
                    'height': '90%',
                    'text-align': 'right',
                    'background-color': '#CDFFCD',
                };
            };

            requisitions.forEach(function (requisition) {
                compareModel['costCenter' + requisition.id] = 0;
                amountFieldsName.push('costCenter' + requisition.id);

                const departmentParent = columnsParentAndChild.find(function (column) {
                    return column.field === ('department' + requisition.departmentId);
                });

                headerNameWithDate = getDateToHeader(requisition.createdAt);
                headerNameWithDate += '  (Req. ';
                headerNameWithDate += requisition.id;
                headerNameWithDate += ') ';
                headerNameWithDate += '||';
                headerNameWithDate += requisition.costCenterDescription;

                if (departmentParent) {
                    departmentParent.children.push(
                        getChildColumn(headerNameWithDate, 'costCenter' + requisition.id));
                    return;
                }
                columnsParentAndChild.push(
                    getParentAndChildColumn(
                        requisition.departmentDescription,
                        'department' + requisition.departmentId,
                        headerNameWithDate,
                        'costCenter' + requisition.id
                    ));
            });

            const processedData = getProcessedData(details, amountFieldsName, compareModel);

            const columnsParentAndChildV = [];
            const columnsParentAndChildH = [];

            columnsParentAndChild.forEach(function (column) {
                let copyColumns = angular.copy(column);
                copyColumns.children.forEach(function (child) {
                    child.field = child.field + 'V';
                });
                columnsParentAndChildV.push(copyColumns);

                copyColumns = angular.copy(column);
                copyColumns.children.forEach(function (child) {
                    child.field = child.field + 'H';
                });
                columnsParentAndChildH.push(copyColumns);
            });

            const response = {
                processedData: processedData.processedData,
                bottomRow: processedData.bottomRow,
            };
            response.details = details;
            response.amountFieldsName = amountFieldsName;
            response.compareModel = compareModel;
            response.columnsParentAndChild = columnsParentAndChild;
            response.columnsParentAndChildV = columnsParentAndChildV;
            response.columnsParentAndChildH = columnsParentAndChildH;
            return response;
        }

        function getParentAndChildColumn(parentHeaderName, parentField, childHeaderHame, childField) {
            return {
                field: parentField,
                headerName: parentHeaderName,
                headerCellRenderer: getHeader,
                children: [
                    getChildColumn(childHeaderHame, childField),
                ],
            };
        }

        function getChildColumn(childHeaderHame, childField) {
            const response = {
                headerName: childHeaderHame,
                field: childField,
                headerCellRenderer: getHeaderDoubleLine,
                width: 200,
                cellStyle: { 'text-align': 'right' },
            };
            response.valueFormatter = function (params) {
                if (!params.value) {
                    return '';
                }
                let suffix = '';
                if (params.column.colId.endsWith('H')
                    || params.column.colId.endsWith('V')) {
                    suffix = ' %';
                }
                return $filter('number')(params.value, vm.number2) + suffix;
            };
            return response;
        }

        function getDateToHeader(date) {
            let prefix = '';
            let month = 0;
            const maxMonth = 10;

            if (date.monthValue < maxMonth) {
                prefix = '0';
            }
            month = prefix + date.monthValue.toString();
            month += '-';
            return month + date.year;
        }

        function getHeaderDoubleLine(name) {
            const headerNames = name.value.split('||');
            let resp = '<div style="width: 100%; font-size:12px" layout-gt-xs="row" layout-align="start"> ';
            resp += '<span>';
            resp += headerNames[0];
            resp += '</span><br></div>';
            resp += '<div style="width: 100%; font-size:12px" layout-gt-xs="row" layout-align="start"> ';
            resp += '<span>';
            resp += headerNames[1];
            resp += '</span></div>';
            return resp;
        }

        function getProcessedData(details, amountFieldsName, compareModel) {
            const productIndex = {};
            const processedData = [];
            let currentIndex = 0;
            const bottomRow = angular.copy(compareModel);
            bottomRow.productName = 'Total';
            details.forEach(function (detail) {
                let index = productIndex[detail.productId];
                if (index === undefined) {
                    productIndex[detail.productId] = currentIndex;
                    index = currentIndex;
                    currentIndex = currentIndex + 1;

                    const newCompareModel = angular.copy(compareModel);
                    newCompareModel.productId = detail.productId;
                    newCompareModel.productName = detail.productName;
                    processedData.push(newCompareModel);

                }
                const propertyName = 'costCenter' + detail.requisitionId;
                processedData[index][propertyName] = (detail.purchaseOrderDetailSubTotal * vm.currencyExchangeRate);
                processedData[index].total = processedData[index].total + (detail.purchaseOrderDetailSubTotal * vm.currencyExchangeRate);

                bottomRow[propertyName] += (detail.purchaseOrderDetailSubTotal * vm.currencyExchangeRate);
                bottomRow[propertyName + 'H'] = bottomRow[propertyName];
                bottomRow[propertyName + 'V'] = bottomRow[propertyName];
                bottomRow.total += (detail.purchaseOrderDetailSubTotal * vm.currencyExchangeRate);
            });

            processedData.forEach(function (data) {
                amountFieldsName.forEach(function (amountFieldName) {
                    data[amountFieldName + 'H'] = '';
                    data[amountFieldName + 'V'] = '';
                    if (data[amountFieldName] > 0) {
                        data[amountFieldName + 'H'] = (data[amountFieldName] * vm.number100) / data.total;
                        data[amountFieldName + 'V'] = (data[amountFieldName] * vm.number100) / bottomRow[amountFieldName];
                    }
                });
            });

            const response = {
                id: 0,
            };
            response.processedData = processedData;
            response.bottomRow = bottomRow;
            return response;
        }

        function showPercentageByOrientation(propertyName, suffix) {

            let columndDefs;
            let bottomRow;
            if (vm[propertyName]) {
                columndDefs = vm.masterColumnDefs.concat(vm.data.columnsParentAndChild);
                bottomRow = [vm.data.bottomRow];
            } else {
                columndDefs = vm.masterColumnDefs.concat(vm.data['columnsParentAndChild' + suffix]);
                bottomRow = [];
            }
            vm[propertyName] = !vm[propertyName];

            vm.masterGridOptions.api.setColumnDefs(columndDefs);
            vm.masterGridOptions.api.setRowData(vm.data.processedData);
            vm.masterGridOptions.api.setPinnedBottomRowData(bottomRow);
        }

        function changeCurrency() {
            if (vm.currency.id === $rootScope.bsCircle.company.currency.id) {
                vm.currencyExchangeRate = 1;
                vm.showExangeRate = false;
                convertAmounts();
                return;
            }
            if (vm.currentCurrencyData.id === vm.currency.id) {
                vm.currencyExchangeRate = vm.currentCurrencyData.exchangeRate;
            } else {
                vm.currencyExchangeRate = '';
            }
            vm.showExangeRate = true;
            $timeout(function () {
                $('#currencyExchangeRate').focus();
            }, vm.number500);
        }

        function convertAmounts() {
            const exchangeRateNumber = parseInt(vm.currencyExchangeRate) > 0;
            if (!exchangeRateNumber) {
                return;
            }

            vm.currentCurrencyData = {
                id: vm.currency.id,
                exchangeRate: vm.currencyExchangeRate,
            };

            const processedData = getProcessedData(vm.data.details, vm.data.amountFieldsName, vm.data.compareModel);
            vm.data.processedData = processedData.processedData;
            vm.data.bottomRow = processedData.bottomRow;

            vm.masterGridOptions.api.setRowData(vm.data.processedData);
            vm.masterGridOptions.api.setPinnedBottomRowData([vm.data.bottomRow]);
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('app.requisition')
        .controller('RequisitionController', RequisitionController);

    /** @ngInject */
    function RequisitionController($state, api, $log, $rootScope, $mdDialog, $timeout, $filter, $stateParams,
        MessageService, $scope, localStorageService, PreviousState, configuration, STATUS_CODES) {
        var vm = this;
        vm.replaceOriginTypedata = replaceOriginTypedata;
        var isNew = true;
        const NUMBER_THREE_HUNDRED = 300;
        const NUMBER_FOUR_HUNDRED = 400;
        vm.minDate = new Date();
        vm.loadDeptosUser = loadDeptosUser;
        vm.isBuyer = $stateParams.isBuyer;
        vm.duplicateRequisition = duplicateRequisition;
        vm.productsByBudget = productsByBudget;
        vm.viewIMG = viewIMG;
        vm.canDuplicate = false;
        vm.viewChangeTemplates = false;
        vm.check = false;
        vm.dimensionCompanyDetail3 = null;
        vm.dimensionCompanyDetail4 = null;
        vm.dimensionCompanyDetail5 = null;
        vm.maxNumberFiles = 3;

        vm.searchDimensionCompanyDetail3 = '';
        vm.searchDimensionCompanyDetail4 = '';
        vm.searchDimensionCompanyDetail5 = '';

        vm.dimensionCompanyDetail3List = [];
        vm.dimensionCompanyDetail4List = [];
        vm.dimensionCompanyDetail5List = [];

        vm.loadingdimensionCompanyDetail3List = false;
        vm.loadingdimensionCompanyDetail4List = false;
        vm.loadingdimensionCompanyDetail5List = false;
        vm.idFilesDeletes = [];
        vm.requisitionFiles = [];

        vm.dinamicSize = 0;

        vm.NUMBER_THREE = 3;
        vm.NUMBER_FOUR = 4;
        vm.NUMBER_FIVE = 5;
        vm.URLPHOTOS = api.baseUrlPhotos;
        vm.roleNameTickets = 'ROLE_TICKETS';
        vm.departmentsF = null;

        if ($stateParams.status && $stateParams.status !== 'Creando' && $stateParams.id === '') {
            $state.go('app.requisition.' + $stateParams.status);
        }
        vm.fromCart = false;
        vm.requisition = {
            maxDatePurchase: new Date(),
            receivedDouble: false,
            urgentPurchase: false
        };
        vm.masterColumnDefs = [
            {
                headerName: 'REQUISITION.DETAIL.QUANTITY',
                field: "quantity",
                headerCellRenderer: getHeader,
                width: 100,
                enableRowGroup: true,
                enablePivot: true,
                cellStyle: { 'text-align': 'center' }
            },
            {
                headerName: 'REQUISITION.DETAIL.PRODUCT',
                field: "product.name",
                headerCellRenderer: getHeader,
                width: 300,
                enableRowGroup: true,
                enablePivot: true,
                cellRenderer: function (params) {
                    if (!params.node.group) {
                        if (params.data && params.data.product.brand && params.data.product.measurementUnit) {
                            return params.value + ", " + $filter('translate')('authorize_quotations.measurement_unit')
                                + ": " + params.data.product.measurementUnit.name
                                + ", " + $filter('translate')('authorize_quotations.brand')
                                + ": " + params.data.product.brand.name;
                        } else {
                            return params.value;
                        }

                    } else {
                        return params.value;
                    }
                }
            },
            {
                headerName: 'REQUISITION.DETAIL.CURRENT_PRICE',
                field: "currentPrice",
                headerCellRenderer: getHeader,
                width: 100,
                cellStyle: { 'text-align': 'right' },
                cellRenderer: function (params) {
                    if (!params.node.group) {
                        if (params.data && params.data.currentCurrency && params.data.currentPrice) {
                            return params.data.currentCurrency.symbol + ". " + $filter('number')(params.data.currentPrice, 2);
                        } else {
                            return params.value;
                        }
                    } else {
                        return params.value;
                    }
                }
            },
            {
                headerName: 'REQUISITION.DETAIL.CONSIGNACION',
                name: "consignment",
                headerCellRenderer: getHeader,
                suppressSorting: true,
                suppressMenu: true,
                width: 100,
                cellRenderer: rendererConsigment,
                cellStyle: { 'text-align': 'center' }
            },
            {
                headerName: 'REQUISITION.DETAIL.OBSERVATIONS',
                field: "observations",
                width: 200,
                headerCellRenderer: getHeader,
                enableRowGroup: true,
                enablePivot: true
            }
        ];

        if ($stateParams.status === 'Autorizado') {
            vm.masterColumnDefs.splice(4, 0, {
                headerName: 'REQUISITION.DETAIL.COTIZED',
                name: "cotizated",
                headerCellRenderer: getHeader,
                suppressSorting: true,
                suppressMenu: true,
                cellRenderer: rendererCotized,
                cellStyle: { 'text-align': 'center' }
            });
            vm.masterColumnDefs.splice(0, 0, {
                headerName: 'ID',
                field: "requisition.id",
                headerCellRenderer: getHeader,
                width: 50,
                rowGroupIndex: 0,
                hide: true,
                pinned: "left"
            });
        }

        vm.statusToChange = $stateParams.status;

        if ($stateParams.status && ($stateParams.status !== 'Autorizado' && $stateParams.status !== 'Cotizado')) {
            vm.masterColumnDefs.splice(5, 0, {
                headerName: 'REQUISITION.ACTIONS',
                name: "actions",
                headerCellRenderer: getHeader,
                suppressSorting: true,
                suppressMenu: true,
                width: 150,
                cellRenderer: renderer,
                cellStyle: { 'padding': '0px' }
            });
        }


        vm.masterGridOptions = {
            columnDefs: vm.masterColumnDefs,
            enableSorting: true,
            debug: false,
            enableFilter: true,
            enableColResize: true,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowData: null,
            groupHeaders: true,
            headerHeight: 50,
            rowHeight: 45,
            suppressRowClickSelection: true,
            groupDefaultExpanded: 1,
            groupSelectsChildren: true,
            rowSelection: 'multiple',
            autoGroupColumnDef: {
                headerName: 'ID',
                field: "id",
                cellRenderer: 'group',
                width: 100,
                hide: true,
                headerCellRenderer: getHeader,
                valueGetter: function (params) {
                    return params.data.cotizated === false ? params.data.id : null;
                },
                cellRendererParams: {
                    checkbox: true
                },
                pinned: "left"
            },
            onSelectionChanged: selectionChangedFunc,
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            },
            doesDataFlower: function (dataItem) {
                return false;
            },
            isExternalFilterPresent: isExternalFilterPresent,
            doesExternalFilterPass: doesExternalFilterPass,
        };

        var filter = 'everyone';

        function isExternalFilterPresent() {
            return filter !== '';
        }

        function doesExternalFilterPass(node) {
            if (filter && filter !== 'everyone') {
                var arrdt = node.data.filter.split(filter);
                return arrdt.length > 1;
            }
            return true;
        }

        function selectionChangedFunc(data) {
            if (vm.masterGridOptions.api.getSelectedNodes().length > 0) {
                $timeout(function () {
                    vm.refuseRequisition = true;
                }, 500);
            } else {
                $timeout(function () {
                    vm.refuseRequisition = false;
                }, 500);
            }
        }

        vm.masterGridOptionsFiles = {
            columnDefs: vm.masterColumnDefsFiles,
            rowData: null,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowSelection: 'multiple',
            headerHeight: 50,
            rowHeight: 45,
            suppressRowClickSelection: true,
            getMainMenuItems: getMainMenuItems(),
            localeTextFunc: getLocaleTextFunc()
        };

        vm.masterColumnDefsFiles = [
            {
                headerName: 'requisition_files.name',
                headerCellRenderer: getHeader,
                width: 350,
                cellStyle: { 'text-align': 'left' },
                suppressSorting: true,
                suppressMenu: true,
                cellRenderer : getCellRendererFilesName()
            },
            {
                headerName: 'requisition_files.photo',
                headerCellRenderer: getHeader,
                width: 150,
                suppressSorting: true,
                suppressMenu: true,
                cellRenderer: getCellRendererFilesPhoto()
            },
            {
                headerName: 'requisition_files.user',
                field: 'user.account',
                headerCellRenderer: getHeader,
                suppressSorting: true,
                suppressMenu: true,
                width: 350,
                cellStyle: { 'text-align': 'center' }
            }
        ];

        function loadDeptosAndCC(onInit, companyId) {

            if (!companyId) {
                companyId = $rootScope.bsCircle.company.id;
            }

            vm.loadingDepartments = true;
            var params = { idc: companyId };
            api.GeneralWS.Department.query(params, function (data) {
                if (data.length === 1 && !vm.requisition.department) {
                    vm.requisition.department = {
                        id: data[0].id.toString()
                    };
                }

                if (onInit) {
                    if (vm.requisitionForm) {
                        vm.requisitionForm.$setDirty();
                    }
                }

                vm.departments = data;
                vm.loadingDepartments = false;
            });

            vm.loadingCostCenter = true;
            api.GeneralWS.CostCenter.query(params, function (data) {
                if (data.length === 1 && !vm.requisition.costCenter) {
                    vm.requisition.costCenter = {
                        id: data[0].id.toString()
                    };
                }
                vm.costCenters = data;
                vm.loadingCostCenter = false;
            });

            //carga proyectos
            vm.loadingProjects = true;
            api.ProyectosWS.getAllActive.query({ 'companyId': companyId }, function (data) {
                vm.projects = data;
                vm.loadingProjects = false;
            });

            vm.loading = true;
            api.ComprasWS.RequisitionType.RequisitionTypeCompany.query({ 'company': companyId }, function (data) {
                if (data.length === 1 && !vm.requisition.requisitionType) {
                    vm.requisition.requisitionType = {
                        id: data[0].id.toString()
                    };
                }

                if (onInit) {
                    if (vm.requisitionForm) {
                        vm.requisitionForm.$setDirty();
                    }
                }

                vm.requisitionTypes = data;
                vm.loading = false;
            });
        }

        function loadDeptosUser() {
            var params = { companyId: 0, id: 'Me' };
            if (vm.requisition.receivedDouble) {
                api.GeneralWS.getDepartmentsByMe.query(params, function (data) {
                    vm.departmentsF = data;
                    vm.loadingDepartments = false;
                });
            }
        }

        function loadMenusUser() {
            if ($rootScope.items) {
                for (var i = 0; i < $rootScope.items.length; i++) {
                    switch ($rootScope.items[i].menuItem.itemName) {
                        case 'apps.requisition.pendingInsert':
                            vm.canDuplicate = true;
                            break;
                    }
                }
            }
        }

        vm.newStatus = '';

        // Methods
        vm.gotoRequisitions = gotoRequisitions;
        vm.openDialog = openDialog;
        vm.openAddDialog = openAddDialog;
        vm.saveHeader = saveHeader;
        vm.getDetails = getDetails;
        vm.deleteDetail = deleteDetail;
        vm.presentRequisition = presentRequisition;
        vm.noAutorize = noAutorize;
        vm.changeCart = changeCart;
        vm.autorizeRequisition = autorizeRequisition;
        vm.getTemplates = getTemplates;
        //////////

        init();
        /**
         * Initialize
         */
        function init(id, ot) {
            vm.dinamicSize = $(window).innerHeight();
            if (!vm.statusToChange) {
                loadMenusUser();
            }

            if (!ot) {
                $timeout(validateRequisitionFromOtherOrigin(id)
                    , 1000);
            } else {
                ifNotFromOther(id, ot);
            }
        }

        function validateHasTenderApplication(company, app) {
            api.GeneralWS.CompanyApplication.byAppName.get({ 'company': company, 'app': app }).$promise.then(function (responseParameter) {
                if (responseParameter.$status === 200) {
                    if (responseParameter.$data && responseParameter.$data !== "") {
                        if (responseParameter.$data.application && responseParameter.$data.application.name === 'Licitador') {
                            vm.hasTenderApplication = responseParameter.$data.active;
                        } else {
                            vm.hasBudgetApplication = responseParameter.$data.active;
                        }

                    }
                }
            }, function (response) {
                $log.error(response);
            });
        }

        function ifNotFromOther(id, ot) {
            var isLocal = id ? true : false;
            id = id ? id : $stateParams.id;

            if (id) {
                $rootScope.loadingProgress = true;
                api.ComprasWS.Requisition.getId({ idCircle: $rootScope.bsCircle.id, id: id }, function (data) {

                    if ($stateParams.status !== data.purchaseStatus.description) {
                        if ($stateParams.status === 'Creando') {
                            $state.go('app.requisition.' + $stateParams.status);
                        }
                        vm.statusToChange = null;
                    } else {
                        vm.statusToChange = data.purchaseStatus.description;
                    }

                    if (data.originType && data.originType.originTypeCode === '01') {
                        loadOtherDeptosTicket(data.department.company.id);
                        vm.requisitionFromOtherOrigin = true;
                    } else {
                        loadDeptosAndCC(false, data.department.company.id);
                    }

                    validateHasTenderApplication(data.department.company.id, 'Licitador');
                    validateHasTenderApplication(data.department.company.id, 'Presupuestos');

                    if ($stateParams.status === 'Creando') {
                        valideCostCenter(data.costCenter.id);
                        valideDepto(data.department.id);
                    }

                    data.department.id = data.department.id.toString();
                    data.costCenter.id = data.costCenter.id.toString();

                    if (data.departmentFirsRecept) {
                        data.departmentFirsRecept.id = data.departmentFirsRecept.id.toString();
                    }

                    if (data.maxDatePurchase) {
                        var maxDatePurchase = new Date(data.maxDatePurchase + ' 23:59:59');
                        data.maxDatePurchase = maxDatePurchase;
                    }

                    api.ComprasWS.ProcessFlow.get({ id: data.id, type: 1 }, function (data) {
                        vm.infoProcessFlow = data;
                    });

                  if (!isLocal) {
                    getDimensionCompany($rootScope.bsCircle.company.id);
                  }

                    $timeout(function () {
                        vm.requisition = data;
                        doSetDimensionCompanyDetails();
                        if (vm.requisition.department.company.id !== $rootScope.bsCircle.company.id) {
                            $timeout(function () {
                                getDimensionCompany(vm.requisition.department.company.id);
                            }, NUMBER_THREE_HUNDRED + NUMBER_THREE_HUNDRED);
                        }

                        getTemplates(vm.requisition.id);

                        $timeout(function () {

                            $rootScope.loadingProgress = false;
                            if (ot) {
                                $timeout(function () {
                                    vm.currentTab = 1;
                                }, NUMBER_FOUR_HUNDRED);
                            } else {
                                getFilesByRequisition();
                            }
                            getDetails(true);

                            if ($stateParams.status === 'Creando' && !vm.cartExist && !data.originType) {
                                loadCart(1);
                            }

                            loadDeptosUser();
                            if (vm.requisitionForm && !vm.requisitionForm.$invalid) {
                              $timeout(function () {
                                if (!$rootScope.loadingProgress) {
                                  vm.currentTab = 1;
                                }
                              }, NUMBER_FOUR_HUNDRED);
                            }
                        }, 300);
                        if (!isLocal) {
                            vm.currentTab = 0;
                        }
                    });
                    isNew = false;
                });
            } else {
                getDimensionCompany($rootScope.bsCircle.company.id);
                loadDeptosAndCC(true, $rootScope.bsCircle.company.id);
                vm.allowEdit = true;
                vm.editHeader = true;
                loadCart(null);
            }
        }

        function changeCart() {
            queryIfLoadCart(vm.cartDefault, 1);
        }

        function loadCart(valIsNew) {
            api.TiendaWS.CartCurrent.get({},
                function (data) {
                    if (data.id) {
                        vm.cartDefault = data;
                        queryIfLoadCart(vm.cartDefault, valIsNew);
                    }
                },
                function (err) {
                }
            );
        }

        function getTemplates(idRequisition) {

            if (vm.requisition.createdFromTemplate) {
                vm.viewChangeTemplates = true;
                vm.requisition.createdFromTemplate = !vm.requisition.createdFromTemplate;
            }

            if ((configuration.getTemplates && !vm.requisition.createdFromTemplate) || vm.viewChangeTemplates) {
                api.ComprasWS.RequisitionTemplateBudget.query(
                    { company: $rootScope.bsCircle.company.id, idRequisition: idRequisition, requisitionTypeId: vm.requisition.requisitionType.id },
                    function (data) {
                        if (data.length > 0) {
                            vm.viewChangeTemplates = true;
                            var dl = $mdDialog.confirm()
                                .title($filter('translate')('REQUISITION.MSG.TEMPLATES'))
                                .textContent($filter('translate')('REQUISITION.MSG.TEMPLATESC'))
                                .ariaLabel('Lucky')
                                .clickOutsideToClose(true)
                                .parent(angular.element("#main"))
                                .ok($filter('translate')('general.si'))
                                .cancel($filter('translate')('general.no'));
                            $mdDialog.show(dl).then(function () {
                                $mdDialog.show({
                                    controller: 'SelectTemplatesController',
                                    controllerAs: 'vm',
                                    locals: {
                                        templates: data,
                                        idRequisition: idRequisition,
                                        requisitionTypes: vm.requisitionTypes,
                                        requisitionType: vm.requisition.requisitionType
                                    },
                                    templateUrl: 'app/main/apps/requisition/requisition/selectTemplates/selecttemplates-dialog.html',
                                    parent: angular.element("#main"),
                                    clickOutsideToClose: false
                                }).then(function (answer) {
                                    $timeout(function () {
                                        if (vm.currentTab === 0) {
                                          $timeout(function () {
                                              vm.currentTab = 1;
                                          }, NUMBER_FOUR_HUNDRED);
                                        }
                                        getDetails(true);
                                    }, 500);

                                }, function (e) {
                                    vm.showTemplateButton = true;
                                });
                            }, function (e) {
                                vm.showTemplateButton = true;
                            });
                        }
                    },
                    function (err) {
                    }
                );
            }

        }

        function queryIfLoadCart(cart, valIsNew) {
            if ($stateParams.status === 'Creando') {
                var dl = $mdDialog.confirm()
                    .title($filter('translate')('REQUISITION.MSG.CART'))
                    .textContent($filter('translate')('REQUISITION.MSG.CARTC'))
                    .ariaLabel('Lucky')
                    .clickOutsideToClose(true)
                    .parent(angular.element("#main"))
                    .ok($filter('translate')('REQUISITION.MSG.SI'))
                    .cancel($filter('translate')('REQUISITION.MSG.NO'));
                $mdDialog.show(dl).then(function () {
                    vm.cartExist = 1;
                    if (vm.fromCart) {
                        $mdDialog.show({
                            controller: 'SelectCompanyController',
                            controllerAs: 'vm',
                            templateUrl: 'app/main/apps/requisition/requisition/selectCompany/selectcompany-dialog.html',
                            parent: angular.element("#main"),
                            clickOutsideToClose: false,
                            fullscreen: true
                        }).then(function (answer) {
                            $rootScope.bsCircle = answer;
                            localStorageService.set('accountc', $rootScope.bsCircle);
                            $rootScope.getScreenByRole();
                            loadDeptosAndCC(false, $rootScope.bsCircle.company.id);
                        });
                    }
                    if (valIsNew === 1) {
                        addCartDetail(cart, vm.requisition.id);
                    }
                }, function (answer) {
                    vm.cartExist = 2;
                });
            }
        }

        function addCartDetail(cart, idRequisition) {
            if (idRequisition) {
                var details = new jinqJs()
                    .from(cart.details)
                    .select(function (r) {
                        var p = r.productCompanySale;
                        return {
                            product: {
                                id: p.product.id
                            },
                            quantity: r.quantity,
                            observations: 0
                        };
                    });

                api.ComprasWS.Requisition.updateBatch(
                    { id: idRequisition, tipo: 'batch', companyId: $rootScope.bsCircle.company.id, 'idCircle': $rootScope.bsCircle.id },
                    details, function (data) {
                        vm.currentTab = 1;
                        getDetails();
                        vm.cartDefault = false;
                        vm.cartExist = false;
                        api.TiendaWS.Cart.clear({ id: cart.id, options: 'close' });
                    }, function (data) {
                        var msg = 'ERROR';
                        if (data.status === 409) {
                            msg = data.data;
                        }
                        MessageService.show('ORDER.MSG.' + msg);

                    });
            }
        }

        function validateRequisitionFromOtherOrigin(id) {

            //Valida si es un requerimiento de un origen
            if ($stateParams.referenceId !== undefined && $stateParams.referenceId !== null) {
              //valida si estoy en el mismo circulo
              $rootScope.changeCircleByNameAndCompanyId($stateParams.circleName, $stateParams.companyUserId, false);
              $rootScope.statesAutorized.push('app.requisition.Creando.detail');

                if ($stateParams.costCenterId === undefined && $stateParams.costCenterId === null) {
                    return null;
                }

                if ($stateParams.departmentId === undefined && $stateParams.departmentId === null) {
                    return null;
                }


                if ($stateParams.companyUserId) {
                    loadOtherDeptosTicket($stateParams.companyUserId);
                    getDimensionCompany($stateParams.companyUserId);
                }

                $timeout(function () {

                    vm.requisition.maxDatePurchase = new Date();
                    vm.requisition.department = {
                        id: $stateParams.departmentId.toString()
                    };
                    vm.requisition.costCenter = {
                        id: $stateParams.costCenterId.toString()
                    };
                    vm.requisition.referenceId = $stateParams.referenceId;
                    vm.requisition.originType = {
                        originTypeCode: $stateParams.originTypeCode
                    };

                  if ($stateParams.createdInDepartmentId) {
                    vm.requisition.createdInDepartment = {id: $stateParams.createdInDepartmentId.toString()};
                  }

                  if (vm.requisition.departmentFirsRecept) {
                      vm.requisition.departmentFirsRecept.id = vm.requisition.departmentFirsRecept.id.toString();
                  }

                    vm.requisitionFromOtherOrigin = true;

                    if (vm.requisitionForm) {
                        vm.requisitionForm.$setDirty();
                    }

                    $timeout(function () {
                        $rootScope.getScreenByRole();
                    }, 2000);

                }, 2000);

            } else {
                if ($stateParams.companyCart) {
                    //valida si estoy en el mismo circulo
                    $rootScope.changeCircleByNameAndCompanyId('ROLE_OPERADOR', $stateParams.companyCart, false);

                    $rootScope.statesAutorized.push('app.requisition.Creando.detail');

                    $timeout(function () {

                        if (vm.requisitionForm) {
                            vm.requisitionForm.$setDirty();
                        }

                        $timeout(function () {
                            $rootScope.getScreenByRole();
                        }, 2000);

                    }, 2000);

                    vm.fromCart = true;
                    ifNotFromOther(id);
                } else {
                    ifNotFromOther(id);
                }
            }
        }

        $scope.$watch('vm.currentTab', function (newVal) {
            if (newVal === 1) {
                if (!vm.requisition.id) {
                    vm.currentTab = 0;
                } else if (vm.cartExist === 1) {
                    addCartDetail(vm.cartDefault, vm.requisition.id);
                }
            }
        });

        function valideCostCenter(ccid) {
            $timeout(function () {
                if (!vm.costCenters) {
                    valideCostCenter(ccid);
                } else {
                    var cc = $.grep(vm.costCenters, function (e) {
                        return e.id === ccid;
                    });
                    if (cc.length === 0) {
                        $state.go('app.requisition');
                    }
                }
            }, 50);
        }

        function valideDepto(dtid) {
            $timeout(function () {
                if (!vm.departments) {
                    valideDepto(dtid);
                } else {
                    var dt = $.grep(vm.departments, function (e) {
                        return e.id === dtid;
                    });
                    if (dt.length === 0) {
                        $state.go('app.requisition');
                    }
                }
            }, 50);
        }

        /**
         * Save Requisition Header
         */
        function saveHeader() {
            vm.showChangeStatusButton = false;


            if (vm.requisitionForm.$valid && vm.requisitionForm.$dirty) {
                vm.fileAddedOrRemoved = false;
                $rootScope.loadingProgress = true;
                if (vm.requisition.originType && vm.requisition.originType.originTypeCode === '01') {
                    if (!vm.requisition.receivedDouble) {
                        vm.requisition.receivedDouble = false;
                    }
                    saveOrUpdate();
                } else {
                    vm.requisition.receivedDouble = false;
                    saveOrUpdate();
                }
            } else {
                if (vm.cartDefault) {
                    addCartDetail(vm.cartDefault, $state.params.id);
                } else {
                    vm.fileAddedOrRemoved = false;
                    vm.currentTab = 1;
                    getDetails(true);
                }
                validateHasTenderApplication(vm.requisition.department.company.id, 'Presupuestos');
                saveFiles();
            }
        }

        function saveOrUpdate() {
            var promise;
            if (isNew) {
                promise = api.ComprasWS.Requisition.create({ idCircle: $rootScope.bsCircle.id }, vm.requisition).$promise;
            } else {
                promise = api.ComprasWS.Requisition.update({ idCircle: $rootScope.bsCircle.id, id: $state.params.id }, vm.requisition).$promise;
            }
            promise.then(
                function (data) {
                    $rootScope.loadingProgress = false;

                    data.maxDatePurchase = new Date(data.maxDatePurchase);
                    vm.requisition = data;
                    vm.requisitionForm.$setPristine();
                    saveFiles();
                    if (isNew) {
                        if (data.$status === 202) {
                            MessageService.show('REQUISITION.MSG.REQUISITIONIFEXIST');
                        } else {
                            vm.currentTab = 1;
                            ifNotFromOther(vm.requisition.id, true);
                        }

                        $state.go($state.current.name, { id: data.id }, { notify: false });
                        isNew = false;

                    } else {
                        vm.currentTab = 1;
                    }
                },
                function (data) {
                    if (data.data && data.data.mensaje) {
                        MessageService.showErrorMessage(data.data.mensaje);
                    } else {
                        var message;
                        if (data.status === 409) {
                            message = 'BUDGETEXIST';
                        } else {
                            message = 'ERROR';
                        }

                        MessageService.show('REQUISITION.MSG.' + message);
                    }

                    $rootScope.loadingProgress = false;
                }
            );
        }

        function getDetails(isInit) {
            if (vm.currentTab === 1 || isInit) {
                vm.showChangeStatusButton = false;
                $rootScope.loadingProgress = true;
                api.ComprasWS.RequisitionDetail.query({ idCircle: $rootScope.bsCircle.id, idRequisition: vm.requisition.id }, function (data) {
                    vm.details = new jinqJs()
                        .from(data)
                        .orderBy([{ field: 'id', sort: 'asc' }])
                        .select(function (r) {
                            if (!r.cotizated) {
                                vm.isBuyer = null;
                            }
                            return r;
                        });
                    $rootScope.loadingProgress = false;
                    vm.showChangeStatusButton = !(vm.details.length <= 0);
                    vm.masterGridOptions.api.setColumnDefs(vm.masterColumnDefs);
                    vm.masterGridOptions.api.setRowData(vm.details);
                }, function (data) {
                    $log.debug(data);
                    $rootScope.loadingProgress = false;
                });
            }
        }

        function deleteDetail(detail, e, i) {
            var msg = 'DELETE';
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('REQUISITION.MSG.SURE_' + msg))
                .ariaLabel('Delete modal')
                .targetEvent(e)
                .ok($filter('translate')('REQUISITION.MSG.SI'))
                .cancel($filter('translate')('REQUISITION.MSG.NO'));
            $mdDialog.show(confirm).then(function () {
                $rootScope.loadingProgress = true;
                api.ComprasWS.RequisitionDetail.delete({ idRequisition: vm.requisition.id, id: detail.id, idCircle: $rootScope.bsCircle.id }, function (data) {
                    vm.details.splice(i, 1);

                    getDetails(true);

                    $rootScope.loadingProgress = false;
                }, function (data) {
                    $log.debug(data);
                    $rootScope.loadingProgress = false;
                });
            }, function () {
                $rootScope.loadingProgress = false;
            });
        }

        /**
         * Go to Requisitions page
         */
        function gotoRequisitions() {
            if ($stateParams.backTo && $stateParams.filter) {
                $state.go($stateParams.backTo, { 'filter': $stateParams.filter });
            } else if (PreviousState && PreviousState.name && !vm.requisition.originType) {
                $state.go(PreviousState.name);
            } else if ($stateParams.status && $stateParams.status !== 'Creando' && $stateParams.status !== 'Autorizado') {
                $state.go('app.requisition.' + $stateParams.status);
            } else if (vm.requisition.originType && vm.requisition.originType.originTypeCode === '01') {
                $state.go("app.requisition." + $stateParams.status + "Tickets");
            } else {
                $state.go('app.requisition.Creando');
            }
        }

        /**
         * Open compose dialog
         *
         * @param ev
         */

        function openAddDialog(ev) {
          if (validateCanCreateRequisition()) {
            if (vm.currentTab === 0) {
              vm.saveHeader();
            } else {
              composeDialog(ev);
            }
          }
        }

      function validateCanCreateRequisition() {
        if (verifyIsNewAndRoleTickets() && (verifyMissingFieldsRequisitionTickets() || verifyMissingParametersTickets())) {
          MessageService.showErrorMessage('REQUISITION.ERROR.PARAMETER_CREATED_MISSING');
          return false;
        } else {
          return true;
        }
      }

      function verifyIsNewAndRoleTickets() {
        return isNew && $rootScope.bsCircle.name === vm.roleNameTickets;
      }

      function verifyMissingFieldsRequisitionTickets() {
        return !vm.requisition.createdInDepartment
          || !vm.requisition.originType
          || !vm.requisition.referenceId;
      }

      function verifyMissingParametersTickets() {
        return !$stateParams.companyUserId
          || !$stateParams.circleName;
      }

        /**
         * Open compose dialog
         *
         * @param ev
         * @param det
         */

        function openDialog(ev, det, i) {
            if (vm.isHighLevel) {
                correctDialog(ev, det, i);
            } else {
                composeDialog(ev, det);
            }
        }


        function composeDialog(ev, det) {
            var detail = angular.copy(det);

            $mdDialog.show({
                controller: 'DetailRequisitionController',
                controllerAs: 'vm',
                locals: {
                    requisition: vm.requisition,
                    requisitionDetail: detail
                },
                templateUrl: 'app/main/apps/requisition/requisition/compose/compose-dialog.html',
                parent: angular.element("#main"),
                targetEvent: ev,
                clickOutsideToClose: false
            }).then(function (answer) {
                getDetails();
            });
        }

        function presentRequisition(createTender) {
            var isAviable = true;
            if ($stateParams.status === STATUS_CODES.requisition.Creando) {
                vm.details.forEach(function (dat) {
                    if (dat.quantity <= 0) {
                        isAviable = false;
                    }
                });
            }

            if (isAviable) {
                var confirm = $mdDialog.confirm()
                    .title($filter('translate')('REQUISITION.MSG.' + vm.statusToChange + '_REQUISITION'))
                    .textContent($filter('translate')('REQUISITION.MSG.CONFIRMACION_' + vm.statusToChange + '_REQUISITION'))
                    .ok($filter('translate')('REQUISITION.MSG.SI'))
                    .cancel($filter('translate')('REQUISITION.MSG.NO'));
                $mdDialog.show(confirm).then(function () {
                    changeStatus(createTender);

                }, function () {
                });
            } else {
                $mdDialog.show({
                    controller: 'DialogDetailZeroController',
                    controllerAs: 'vm',
                    locals: {
                        requisition: vm.requisition,
                        requisitionDetail: vm.details
                    },
                    templateUrl: 'app/main/apps/requisition/requisition/dialogDetailZero/dialogDetailZero.html',
                    parent: angular.element("#main"),
                    clickOutsideToClose: false
                }).then(function (response) {
                    if (response) {
                        getDetails(true);
                        $timeout(function () {
                            changeStatus(createTender);
                        }, 500);
                    }
                }, function () { });
            }
        }

        function changeStatus(createTender) {
            vm.detailsListId = [];
            vm.masterGridOptions.api.getSelectedNodes().forEach(function (node) {
                if (!node.group) {
                    vm.detailsListId.push(node.data.id);
                }
            });

            if ($stateParams.status === 'Autorizado') {
                $state.go('app.quotation.new', { quotationId: 0, requisitionId: $stateParams.id, detailsListId: vm.detailsListId });
            } else {
                $rootScope.loadingProgress = true;

                if (createTender) {
                    var dto = {
                        requisition: vm.requisition,
                        details: vm.details
                    };
                    var obj = getObjectTender(dto);
                    api.LicitadorWS.Tender.create({ 'circle': $rootScope.bsCircle.id }, obj,
                        function (data) {
                            api.ComprasWS.Requisition.changeStatus(
                                { 'idCircle': $rootScope.bsCircle.id, 'id': vm.requisition.id, createTender: createTender },
                                null).$promise.then(function (response) {
                                    MessageService.show('REQUISITION.MSG.TENDERCREATED');
                                    $rootScope.loadingProgress = false;
                                    gotoRequisitions();
                                }, function (response) {
                                    $rootScope.loadingProgress = false;
                                    var msg = 'ERROR';
                                    if (response.data === 'No Detail') {
                                        msg = 'DETAIL';
                                    }

                                    MessageService.show('REQUISITION.MSG.' + msg);
                                });
                        },
                        function (err) {
                            $rootScope.loadingProgress = false;
                            MessageService.show('REQUISITION.MSG.ERROR');
                            gotoRequisitions();
                        }
                    );
                } else {
                    api.ComprasWS.Requisition.changeStatus(
                        { 'idCircle': $rootScope.bsCircle.id, 'id': vm.requisition.id, createTender: createTender },
                        null).$promise.then(function (response) {
                            $rootScope.loadingProgress = false;
                            MessageService.show("REQUISITION.MSG.CHANGESTATUS." + vm.statusToChange);
                            gotoRequisitions();
                        }, function (response) {
                            $rootScope.loadingProgress = false;
                            var msg = 'ERROR';
                            if (response.data === 'No Detail') {
                                msg = 'DETAIL';
                            }

                            MessageService.show('REQUISITION.MSG.' + msg);
                        });
                }
            }
        }

        function noAutorize() {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('REQUISITION.MSG.NoAutorizado_REQUISITION'))
                .textContent($filter('translate')('REQUISITION.MSG.CONFIRMACION_NoAutorizado_REQUISITION'))
                .ok($filter('translate')('REQUISITION.MSG.SI'))
                .cancel($filter('translate')('REQUISITION.MSG.NO'));
            $mdDialog.show(confirm).then(function () {

                $rootScope.loadingProgress = true;
                var promise = api.ComprasWS.RequisitionRechaze.changeStatus({ 'idCircle': $rootScope.bsCircle.id, 'id': vm.requisition.id }, null).$promise;
                promise.then(function (response) {
                    $rootScope.loadingProgress = false;
                    MessageService.show("REQUISITION.MSG.CHANGESTATUS.NoAutorizado");
                    gotoRequisitions();
                }, function (response) {
                    $rootScope.loadingProgress = false;
                    var msg = 'ERROR';
                    if (response.data === 'No Detail') {
                        msg = 'DETAIL';
                    }

                    MessageService.show('REQUISITION.MSG.' + msg);
                });

            }, function () {
            });
        }

        function autorizeRequisition() {
            vm.statusToChange = 'Ingresado';
            presentRequisition();
        }
        ////////////////////

        vm.clearSearchDepartment = function () {
            vm.searchDepartment = "";
        };

        vm.clearSearchCostCenter = function () {
            vm.searchCostCenter = "";
        };

        vm.clearSearchProject = function () {
            vm.searchProject = "";
        };

        vm.clearSearchDepartmentFirsRecept = function () {
            vm.searchDepartmentFirsRecept = "";
        };

        vm.clearSearchRequisitionType = function () {
            vm.searchRequisitionType = "";
        };

        $timeout(function () {

            var keyEvent = function (event) {
                event.stopPropagation();
            };

            var searchDepartmentInput = document.querySelector("#searchDepartment");
            var searchCostCenterInput = document.querySelector("#searchCostCenter");
            var searchProjectInput = document.querySelector("#searchProject");
            var searchBudgetStatusInput = document.querySelector("#searchBudgetStatus");
            var searchDepartmentFirsReceptInput = document.querySelector("#searchDepartmentFirsRecept");
            var searchRequisitionTypeInput = document.querySelector("#searchRequisitionType");

            if (searchDepartmentInput) {
                searchDepartmentInput.addEventListener("keydown", keyEvent);
            }

            if (searchCostCenterInput) {
                searchCostCenterInput.addEventListener("keydown", keyEvent);
            }

            if (searchProjectInput) {
                searchProjectInput.addEventListener("keydown", keyEvent);
            }

            if (searchBudgetStatusInput) {
                searchBudgetStatusInput.addEventListener("keydown", keyEvent);
            }
            if (searchDepartmentFirsReceptInput) {
                searchDepartmentFirsReceptInput.addEventListener("keydown", keyEvent);
            }
            if (searchRequisitionTypeInput) {
                searchRequisitionTypeInput.addEventListener("keydown", keyEvent);
            }
        }, 500);

        function loadOtherDeptosTicket(company) {
            vm.loadingDepartments = true;
            var params = { idc: company };
            api.GeneralWS.getAllDepartment.query(params, function (data) {
                vm.departments = data;
                vm.loadingDepartments = false;
            });

            vm.loadingCostCenter = true;
            api.GeneralWS.getAllCost.query(params, function (data) {
                vm.costCenters = data;
                vm.loadingCostCenter = false;
            });

            //carga proyectos
            vm.loadingProjects = true;
            api.ProyectosWS.getAllActive.query({ 'companyId': company }, function (data) {
                vm.projects = data;
                vm.loadingProjects = false;
            });

            vm.loading = true;
            api.ComprasWS.RequisitionType.RequisitionTypeCompany.query({ 'company': company }, function (data) {
                if (data.length === 1 && !vm.requisition.requisitionType) {
                    vm.requisition.requisitionType = {
                        id: data[0].id.toString()
                    };
                }
                vm.requisitionTypes = data;
                vm.loading = false;
            });
        }

        function duplicateRequisition() {
            var dl = $mdDialog.confirm()
                .title($filter('translate')('REQUISITION.DUPLICATE_REQUISITION'))
                .textContent($filter('translate')('REQUISITION.MSG.CONFIRMACION_Duplicar_REQUISITION'))
                .ariaLabel('duplicate')
                .clickOutsideToClose(true)
                .parent(angular.element("#main"))
                .ok($filter('translate')('REQUISITION.MSG.SI'))
                .cancel($filter('translate')('REQUISITION.MSG.NO'));
            $mdDialog.show(dl).then(function () {
                api.ComprasWS.Requisition.duplicateRequisition(
                    { 'id': 'duplicateRequisition', requisitionId: vm.requisition.id, 'idCircle': $rootScope.bsCircle.id },
                    null).$promise.then(function (response) {
                        if (response) {
                            MessageService.show('REQUISITION.MSG.CHANGESTATUS.Duplicado');
                            $state.go('app.requisition.Creando.detail', { id: response.id });
                        }
                    }, function (errResponse) {
                        $log.debug(errResponse);
                        vm.loading = false;
                        $rootScope.loadingProgress = false;
                    });
            }, function (err) {
                $log.debug(err);
            });
        }

        function renderer(params) {
            var toRet = '<div style="width: 100%;">';
            if ($stateParams.status) {
                toRet = toRet + '<md-button class="edit-button md-icon-button"' +
                    'ng-click="vm.openDialog($event, data, $index)" ng-show="!vm.canDuplicate"' +
                    'aria-label="Product details"' +
                    'translate translate-attr-aria-label="REQUISITION.PRODUCT_DETAILS">' +
                    '<md-icon md-font-icon="icon-pencil" class="s16"></md-icon>' +
                    '<md-tooltip>' +
                    '<span translate="REQUISITION.DETAIL.EDIT"></span>' +
                    '</md-tooltip>' +
                    '</md-button>' +
                    '<md-button class="edit-button md-icon-button" ng-show="!vm.canDuplicate"' +
                    'ng-click="vm.deleteDetail(data, $event, $index)"' +
                    'aria-label="Product details"' +
                    'translate translate-attr-aria-label="REQUISITION.DELETE">' +
                    '<md-icon md-font-icon="icon-delete" class="s16 md-warn"></md-icon>' +
                    '<md-tooltip>' +
                    '<span translate="REQUISITION.DELETE"></span>' +
                    '</md-tooltip>' +
                    '</md-button>';
            }


            return toRet + '</div>';
        }

        function rendererConsigment(params) {
            var toRet = '<div style="width: 100%;">';

            toRet = toRet + '<div>' +
                '<md-icon md-font-icon="{{data.consignment ? \'icon-check\' : \'icon-close\'}}"></md-icon>' +
                '</div>';

            return toRet + '</div>';
        }

        function rendererCotized(params) {
            var toRet = '<div style="width: 100%;">';

            toRet = toRet + '<div>' +
                '<md-icon md-font-icon="{{data.cotizated ? \'icon-check\' : \'icon-close\'}}"></md-icon>' +
                '</div>';

            return toRet + '</div>';
        }

        function productsByBudget() {
            $mdDialog.show({
                controller: 'ProductsByBudgetController',
                controllerAs: 'vm',
                locals: {
                    idRequisition: vm.requisition.id
                },
                templateUrl: 'app/main/apps/requisition/requisition/productsByBudget/productsByBudget-dialog.html',
                parent: angular.element("#main"),
                clickOutsideToClose: false
            }).then(function (answer) {
                $timeout(function () {
                    getDetails(true);
                }, 600);
            }, function (e) {
                vm.showTemplateButton = true;
            });
        }

        vm.noAutorizeDetail = function () {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('REQUISITION.CANCELAR'))
                .textContent($filter('translate')('REQUISITION.MSG.CONFIRMACION_CANCEL'))
                .ok($filter('translate')('REQUISITION.MSG.SI'))
                .cancel($filter('translate')('REQUISITION.MSG.NO'));

            $mdDialog.show(confirm).then(function () {
                vm.requisitionDetailIds = [];
                vm.requisitionDetailDeletedIds = [];
                vm.masterGridOptions.api.getSelectedNodes().forEach(function (param) {
                    vm.requisitionDetailIds.push(param.data.id);
                });
                $rootScope.loadingProgress = true;
                api.ComprasWS.RequisitionDetail.deleteList(
                    { idRequisition: vm.requisition.id, 'requisitionDetailIds': vm.requisitionDetailIds, idCircle: $rootScope.bsCircle.id },
                    function (data) {
                        if (data.length > 0) {
                            MessageService.show('REQUISITION.MSG.DELETED');
                        } else {
                            MessageService.show('REQUISITION.MSG.NOT_HAVE_DELETE');
                        }
                        getDetails(true);
                        $timeout(function () {
                            var haveNotCotizated = false;
                            vm.masterGridOptions.api.rowModel.rowsToDisplay.forEach(function (param) {
                                if (param.data && param.data.cotizated === false) {
                                    haveNotCotizated = true;
                                }
                            });

                            if (haveNotCotizated !== true) {
                                $state.go('app.requisition.' + $stateParams.status);
                            }
                        }, 500);

                        $rootScope.loadingProgress = false;
                    }, function (data) {
                        $log.debug(data);
                        $rootScope.loadingProgress = false;
                    });
            }, function () {
            });
        };

        function getDimensionCompany(companyId) {
          $rootScope.loadingProgress = true;
          clearDimensionObjectAndList();
          api.GeneralWS.Usr.User.basicUserInformation.get().$promise.then(function (user) {
            api.UserWS.UserDimension.ByUser.get({'userId': user.userId}).$promise.then(function (userList) {
              vm.userDimensionCompanyDetails = userList;

              vm.loadingdimensionCompanyDetail3List = true;
              vm.loadingdimensionCompanyDetail4List = true;
              vm.loadingdimensionCompanyDetail5List = true;
              api.GeneralWS.DimensionCompany.byCompany.getList(
                {'company': companyId}
              ).$promise.then(function (responseDimension) {
                for (let i = 0; i < responseDimension.length; i++) {
                  if (responseDimension[i].dimensionNumber === vm.NUMBER_THREE) {
                    vm.dimensionCompanyDetail3 = responseDimension[i];
                    getDimensionCompanyDetail(responseDimension[i].id, responseDimension[i].dimensionNumber);
                  } else if (responseDimension[i].dimensionNumber === vm.NUMBER_FOUR) {
                    vm.dimensionCompanyDetail4 = responseDimension[i];
                    getDimensionCompanyDetail(responseDimension[i].id, responseDimension[i].dimensionNumber);
                  } else if (responseDimension[i].dimensionNumber === vm.NUMBER_FIVE) {
                    vm.dimensionCompanyDetail5 = responseDimension[i];
                    getDimensionCompanyDetail(responseDimension[i].id, responseDimension[i].dimensionNumber);
                  } else {
                    vm.dimensionCompanyDetail1 = responseDimension[i];
                  }
                }
                if (responseDimension.length === 0) {
                  vm.requisition.dimensionCompanyDetail3 = null;
                  vm.requisition.dimensionCompanyDetail4 = null;
                  vm.requisition.dimensionCompanyDetail5 = null;
                }
                if (vm.masterGridOptions.api) {
                  vm.masterGridOptions.api.setColumnDefs(vm.masterColumnDefs);
                }

                $timeout(function () {
                  doSetDimensionCompanyDetails();
                  $rootScope.loadingProgresss = false;
                }, 200);
              }, function (err) {
                if (err) {
                  vm.loadingdimensionCompanyDetail3List = false;
                  vm.loadingdimensionCompanyDetail4List = false;
                  vm.loadingdimensionCompanyDetail5List = false;
                }
              });
            }, function (errorUser) {
              $log.debug(errorUser);
            });
          }, function (err) {
            $log.debug(err);
          });
        }

        function getDimensionCompanyDetail(id, number) {
            api.GeneralWS.DimensionCompanyDetail.byDimensionCompany.getList(
                { 'dimensionCompanyId': id }
            ).$promise.then(function (responseDimension) {
              const arrIds = vm.userDimensionCompanyDetails.map(function (row) {
                return row.dimensionCompanyDetailId;
              });
                if (number === vm.NUMBER_THREE) {
                    vm.dimensionCompanyDetail3List = getArrayDimensionCompanyDetail(responseDimension, arrIds);
                    vm.loadingdimensionCompanyDetail3List = false;
                }
                if (number === vm.NUMBER_FOUR) {
                    vm.dimensionCompanyDetail4List = getArrayDimensionCompanyDetail(responseDimension, arrIds);
                    vm.loadingdimensionCompanyDetail4List = false;
                }
                if (number === vm.NUMBER_FIVE) {
                    vm.dimensionCompanyDetail5List = getArrayDimensionCompanyDetail(responseDimension, arrIds);
                    vm.loadingdimensionCompanyDetail5List = false;
                }
            }, function () {
                vm.loadingdimensionCompanyDetail3List = false;
                vm.loadingdimensionCompanyDetail4List = false;
                vm.loadingdimensionCompanyDetail5List = false;
            });
        }

      function getArrayDimensionCompanyDetail(responseDimension, arrIds) {
        if ($stateParams.companyUserId) {
          vm.requisition.dimensionCompanyDetail3 = doSetDimensionCompanyByTicket(vm.NUMBER_THREE);
          vm.requisition.dimensionCompanyDetail4 = doSetDimensionCompanyByTicket(vm.NUMBER_FOUR);
          vm.requisition.dimensionCompanyDetail5 = doSetDimensionCompanyByTicket(vm.NUMBER_FIVE);
          return responseDimension;
        }else if (vm.requisition.originType && vm.requisition.originType.originTypeCode === '01'){
          return responseDimension;
        }else {
          return responseDimension.filter(function (item) {
            return arrIds.includes(item.id);
          });
        }
      }

      function doSetDimensionCompanyByTicket(number){
        if ($stateParams.dimensionCompanyDetail3Id && $stateParams.dimensionCompanyDetail3Id > 0 && number === vm.NUMBER_THREE) {
          return {id: $stateParams.dimensionCompanyDetail3Id.toString()};
        } else if ($stateParams.dimensionCompanyDetail4Id && $stateParams.dimensionCompanyDetail4Id > 0 && number === vm.NUMBER_FOUR) {
          return {id: $stateParams.dimensionCompanyDetail4Id.toString()};
        } else if ($stateParams.dimensionCompanyDetail5Id && $stateParams.dimensionCompanyDetail5Id > 0 && number === vm.NUMBER_FIVE) {
          return {id: $stateParams.dimensionCompanyDetail5Id.toString()};
        } else {
          return null;
        }
      }

      function doSetDimensionCompanyDetails() {
          getDimensionCompanyDetailRequisition(vm.NUMBER_THREE);
          getDimensionCompanyDetailRequisition(vm.NUMBER_FOUR);
          getDimensionCompanyDetailRequisition(vm.NUMBER_FIVE);
      }

        function getDimensionCompanyDetailRequisition(number) {
          if (number === vm.NUMBER_THREE && vm.requisition.dimensionCompanyDetail3 && vm.dimensionCompanyDetail3List.length > 0) {
            vm.requisition.dimensionCompanyDetail3.id = vm.requisition.dimensionCompanyDetail3.id.toString();
          }
          if (number === vm.NUMBER_FOUR && vm.requisition.dimensionCompanyDetail4 && vm.dimensionCompanyDetail4List.length > 0) {
            vm.requisition.dimensionCompanyDetail4.id = vm.requisition.dimensionCompanyDetail4.id.toString();
          }
          if (number === vm.NUMBER_FIVE && vm.requisition.dimensionCompanyDetail5 && vm.dimensionCompanyDetail5List.length > 0) {
            vm.requisition.dimensionCompanyDetail5.id = vm.requisition.dimensionCompanyDetail5.id.toString();
          }
        }

        function saveFiles() {
            if (vm.filesToUpload.length > 0 && vm.requisition.id && vm.filesToUpload.length <= vm.maxNumberFiles) {
                const files = [];
                vm.filesToUpload.forEach(function (r) {
                    if (r.file.file && r.file.file.size) {
                        files.push(r.file.file);
                    }
                    let exist = false;
                    for (let i = 0; i < vm.idFilesDeletes.length; i++) {
                        if (vm.idFilesDeletes[i] === r.id) {
                            exist = true;
                        }
                    }

                    if (exist) {
                        vm.idFilesDeletes.splice(vm.idFilesDeletes.indexOf(r.id), 1);
                    }
                });

                deleteFiles((files.length === 0));

                if (files.length > 0) {
                    vm.loadingFiles = true;
                    vm.fileAddedOrRemoved = false;
                    $rootScope.loadingProgress = true;
                    api.GeneralWS.Common.FileStorage.filesUpload.add(
                        { 'companyId': vm.requisition.department.company.id },
                        files
                    ).then(function (response) {
                        $rootScope.loadingProgress = false;
                        vm.requisitionFiles = response.data;
                        api.ComprasWS.RequisitionFiles.saveRequisitionFiles.create({
                            'requisitionId': vm.requisition.id,
                            'idCircle': $rootScope.bsCircle.id
                        }, vm.requisitionFiles, function () {
                            getFilesByRequisition();
                        });
                    }, function (errResponse) {
                        $log.error(errResponse);
                        $rootScope.loadingProgress = false;
                    });
                }

            } else {
                deleteFiles(true);
            }

        }

        function getFilesByRequisition() {
            vm.filesToUpload = [];
            vm.idFilesDeletes = [];
            vm.loadingFiles = true;
            $timeout(function () {
                api.ComprasWS.RequisitionFiles.getFilesByRequisition.getList(
                    { 'requisitionId': vm.requisition.id, 'idCircle': $rootScope.bsCircle.id },
                    function (respFiles) {
                        vm.requisitionFiles = respFiles;
                        vm.masterGridOptionsFiles.api.setColumnDefs(vm.masterColumnDefsFiles);
                        vm.masterGridOptionsFiles.api.setRowData(vm.requisitionFiles);
                        respFiles.forEach(function (file) {
                            vm.idFilesDeletes.push(file.fileStorage.id);
                            const fileS = file.fileStorage;
                            let typeFile = 'image';
                            if (fileS.extension.toLowerCase() !== '.jpg'
                                && fileS.extension.toLowerCase() !== '.jpeg'
                                && fileS.extension.toLowerCase() !== '.png') {
                                typeFile = 'application/pdf';
                                fileS.image = 'assets/images/logos/gulp.png';
                            }
                            fileS.file = { 'name': fileS.originalName + fileS.extension, type: typeFile };
                            fileS.type = 'image';
                            fileS.url = vm.URLPHOTOS + fileS.parentPath + fileS.name + fileS.extension;
                            vm.filesToUpload.push(fileS);
                        });
                        vm.loadingFiles = false;
                        vm.fileAddedOrRemoved = false;
                    });
            }, NUMBER_THREE_HUNDRED);
        }

        function deleteFiles(reload) {
            if (vm.idFilesDeletes.length > 0) {
                vm.idFilesDeletes.forEach(function (id) {
                    api.GeneralWS.Common.FileStorage.deletePhoto.deletePhoto(
                        { 'fileStorageId': id }, function (e) {
                            $log.debug(e);
                         });
                });

                api.ComprasWS.RequisitionFiles.delFilesByRequisition.deleteList(
                    { 'idCircle': $rootScope.bsCircle.id }, vm.idFilesDeletes,
                    function () {
                        vm.fileAddedOrRemoved = false;
                        if(reload){
                            getFilesByRequisition();
                        }
                    });
            } else {
                vm.requisitionFiles.forEach(function (file) {
                    vm.idFilesDeletes.push(file.fileStorage.id);
                });
            }
        }

        function viewIMG(file) {
            $mdDialog.show({
                controller: 'DialogPhotoController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/files/dialogPhoto/dialogPhoto.html',
                parent: angular.element('#main'),
                name: file.originalName,
                url: vm.URLPHOTOS + file.parentPath + file.name + file.extension,
                clickOutsideToClose: false
            }).then(function (answer) {
                $log.debug(answer);
            });
        }

        function getMainMenuItems(){
            return function (params) {
                return getHeaderMenu(params, $filter);
            };
        }

        function getLocaleTextFunc(){
            return function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            };
        }

        function getCellRendererFilesName() {
            return function (params) {
                return params.data.fileStorage.originalName + params.data.fileStorage.extension;
            };
        }

        function getCellRendererFilesPhoto() {
            return function (params) {
                if (params.data) {
                    return '<div class="custom-image" layout="column"' +
                    'style="padding-left: 15px; padding-right: 15px"' +
                        'ng-if="data.fileStorage.extension===\'.jpg\' ' +
                        '|| data.fileStorage.extension===\'.jpeg\' ' +
                        '|| data.fileStorage.extension===\'.JPEG\' ' +
                        '|| data.fileStorage.extension===\'.png\' ' +
                        '|| data.fileStorage.extension === \'.JPG\' || data.fileStorage.extension === \'.PNG\'" ' +
                        'layout-align="center center" ng-click="vm.viewIMG(data.fileStorage)"> ' +
                        '<img class="custom-img" width="100%" ' +
                        'height="100%" id="fullUrl" alt="{{data.fileStorage.name}}" ng-src="{{vm.URLPHOTOS + ' +
                        'data.fileStorage.parentPath + ' +
                        'data.fileStorage.name + data.fileStorage.extension}}" /> ' +
                        '</div> ' +
                        '<div layout="column" ng-if="data.fileStorage.extension!==\'.jpg\'  ' +
                        '&& data.fileStorage.extension!==\'.jpeg\' ' +
                        '&& data.fileStorage.extension!==\'.JPEG\' ' +
                        '&& data.fileStorage.extension!==\'.png\' ' +
                        '&& data.fileStorage.extension !== \'.JPG\' ' +
                        '&& data.fileStorage.extension !== \'.PNG\'" ' +
                        'layout-align="center center"> ' +
                        '<a title="{{data.fileStorage.originalName +  ' +
                        'data.fileStorage.extension}}" ' +
                        'data-gallery ng-href="{{vm.URLPHOTOS + data.fileStorage.parentPath + ' +
                        'data.fileStorage.name + ' +
                        'data.fileStorage.extension}}" download="{{data.fileStorage.originalName + ' +
                        'data.fileStorage.extension}}" target="_blank" ng-if="data.fileStorage !== null ' +
                        '&& data.fileStorage !== undefined ' +
                        '&& data.fileStorage.extension !== \'.jpg\' && data.fileStorage.extension !== \'.png\' ' +
                        '&& data.fileStorage.extension !== \'.JPG\' && data.fileStorage.extension !== \'.PNG\' ' +
                        '&& data.fileStorage.extension !== \'.jpeg\' && data.fileStorage.extension !== \'.JPEG\'"> ' +
                        '<md-icon md-font-icon="icon-file-document"></md-icon> ' +
                        '</a> ' +
                        '</div>';
                }
                return '';
            };
        }

        function clearDimensionObjectAndList(){
          vm.dimensionCompanyDetail3 = null;
          vm.dimensionCompanyDetail4 = null;
          vm.dimensionCompanyDetail5 = null;
          vm.dimensionCompanyDetail3List = [];
          vm.dimensionCompanyDetail4List = [];
          vm.dimensionCompanyDetail5List = [];
        }


    }
})();

(function () {
    'use strict';
    angular
        .module('app.physicalDocumentDelivery')
        .controller('viewDeliveryController', prepareDeliveryController);

    /** @ngInject */
    function prepareDeliveryController($state, api, $log, $rootScope, $mdDialog, $timeout, $filter, $stateParams, MessageService, LINK_SETTLEMENT_REPORT) {
        var vm = this;

        vm.replaceOriginTypedata = replaceOriginTypedata;

        vm.minDate = new Date();
        vm.isBuyer = $stateParams.isBuyer;
        vm.validatePhysicalDocument = validatePhysicalDocument;
        vm.type = "";
        vm.statusToChange = $stateParams.status;
        vm.title = $stateParams.title;
        if ($stateParams.id) {
            api.ComprasWS.PhysicalDocumentDelivery.byId.get({ 'id': $stateParams.id }, function (response) {
                vm.physicalDocument = response;
                getDetail();
            }, function (errResponse) {
                $log.debug(errResponse);
            });
        } else {
            $state.go('app.dashboards_project');
        }

        vm.masterColumnDefs = [
            {
                headerName: '#',
                field: "id",
                width: 50,
                filter: 'number',
                cellStyle: { 'text-align': 'center' },
                pinned: 'left'
            },
            {
                headerName: 'physicalDocumentDelivery.type',
                field: "type",
                headerCellRenderer: getHeader,
                width: 300,
                filter: 'text',
                enableRowGroup: true,
                cellRenderer: function (params) {
                    return "<div>{{'physicalDocumentDelivery.'+data.type | translate}}</div>"
                },
                enablePivot: true
            },
            {
                headerName: 'physicalDocumentDelivery.document',
                field: "document",
                headerCellRenderer: getHeader,
                width: 450,
                filter: 'text',
                enableRowGroup: true,
                cellRenderer: function (params) {
                    if (params && params.data && params.data.type === 'INVOICE') {
                        return (params.data.invoicePurchase.invoiceSerie ?
                            params.data.invoicePurchase.invoiceSerie.serie :
                            params.data.invoicePurchase.uuid.substring(0, 8)) + " - " + params.data.invoicePurchase.correlative;
                    } else if (params && params.data && params.data.settlement && params.data.type === 'SETTLEMENT') {
                        return params.data.settlement.id;
                    }
                },
                enablePivot: true
            },
            {
                headerName: 'physicalDocumentDelivery.total',
                field: "document",
                headerCellRenderer: getHeader,
                width: 250,
                filter: 'text',
                enableRowGroup: true,
                cellRenderer: function (params) {
                    if (params && params.data && params.data.type === 'INVOICE') {
                        return $filter('number')(params.data.invoicePurchase.documentTotalBeforeTax, 2);
                    } else if (params && params.data && params.data.settlement && params.data.type === 'SETTLEMENT') {
                        return $filter('number')(params.data.settlement.settledAmount, 2);
                    }
                },
                cellStyle: { 'text-align': 'right' },
                enablePivot: true
            },
            {
                headerName: 'REQUISITION.ACTIONS',
                name: "actions",
                headerCellRenderer: getHeader,
                suppressSorting: true,
                suppressMenu: true,
                width: 250,
                cellRenderer: function (params) {
                    return '<div style="width: 100%;">'
                        + ' <md-button class="edit-button md-icon-button"'
                        + ' ng-click="vm.viewDetail($event, data, $index)" '
                        + ' aria-label="Product details"'
                        + ' translate translate-attr-aria-label="physicalDocumentDetail.PRODUCT_DETAILS">'
                        + '     <md-icon md-font-icon="icon-eye" class="s16"></md-icon>'
                        + '     <md-tooltip>'
                        + '         <span translate="physicalDocumentDelivery.viewDetail"></span>'
                        + '     </md-tooltip>'
                        + ' </md-button>'
                        + ' </div>';
                },
                cellStyle: { 'padding': '0px' },
                pinned: 'right'
            }
        ];

        vm.masterGridOptions = {
            columnDefs: vm.masterColumnDefs,
            enableSorting: true,
            debug: false,
            enableFilter: true,
            enableColResize: true,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowData: null,
            groupHeaders: true,
            headerHeight: 50,
            rowHeight: 40,
            rowSelection: 'multiple',
            rowDeselection: true,
            rowModelType: "enterprise",
            cacheBlockSize: vm.pageSize,
            pagination: true,
            paginationPageSize: vm.pageSize,
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            },
            doesDataFlower: function (dataItem) {
                return true;
            },
            isExternalFilterPresent: isExternalFilterPresent,
            doesExternalFilterPass: doesExternalFilterPass
        };

        vm.masterColumnDefs.forEach(function (d) {
            correctFilterParams(d);
        });

        function correctFilterParams(column) {
            switch (column.filter) {
                case 'number':
                    column.filterParams = {
                        filterOptions: ['equals'],
                        newRowsAction: 'keep'
                    };
                    break;
                case 'text':
                    column.filterParams = {
                        filterOptions: ['contains'],
                        newRowsAction: 'keep'
                    };
                    break;
                case 'date':
                    column.suppressFilter = true;
                    break;
            }
        }

        var filter = '';

        function isExternalFilterPresent() {
            return filter !== '';
        }

        function doesExternalFilterPass(node) {
            if (filter && filter !== 'everyone') {
                var arrdt = node.data.filter.split(filter);
                return arrdt.length > 1;
            }
            return true;
        }

        init();
        /**
         * Initialize
         */
        function init(id, ot) {
            api.GeneralWS.UserRoleTreasurer.getbyCorporateAndRoleTreasure.get(
                { 'idCircle': $rootScope.bsCircle.id, 'pageNumber': 0, 'pageSize': 100, 'search': '' }, function (response) {
                    vm.treasures = response.content;
                }, function (errResponse) {
                    $log.debug(errResponse);
                });
        }

        function validatePhysicalDocument() {
            if (vm.physicalDocument.barCode) {
                if (vm.physicalDocument.barCode.indexOf("fac") === 0) {
                    vm.type = "F";
                    vm.physicalDocument.barCode = vm.physicalDocument.barCode.replace('fac', '');
                    api.ComprasWS.InvoicePurchase.query({ 'id': vm.physicalDocument.barCode }, function (response) {
                        vm.invoicePurchase = response;
                        if ((vm.invoicePurchase.invoiceSerie && !vm.invoicePurchase.invoiceSerie.electronicInvoice) || vm.invoicePurchase.uuid == null) {
                            if (vm.invoicePurchase.purchaseStatus.description === 'Provisionada') {
                                api.ComprasWS.PhysicalDocumentDeliveryDetail.PhysicalDocumentDeliveryDetail.create(
                                    {}, {
                                    invoicePurchase: { id: vm.physicalDocument.barCode },
                                    physicalDocumentDelivery: { id: vm.physicalDocument.id }
                                }, function (response) {
                                    getDetail();
                                    vm.physicalDocument.barCode = '';
                                    MessageService.show($filter('translate')('physicalDocumentDelivery.addedSuccessfully'));
                                }, function (errResponse) {
                                    $log.debug(errResponse);
                                    MessageService.showErrorMessage($filter('translate')('physicalDocumentDelivery.' + errResponse.data.mensaje));
                                    vm.physicalDocument.barCode = '';
                                });
                            } else {
                                MessageService.showErrorMessage($filter('translate')('physicalDocumentDelivery.isDocumentNotProvisioned'));
                            }
                        } else {
                            MessageService.showErrorMessage($filter('translate')('physicalDocumentDelivery.isDocumentElectronic'));
                        }
                    }, function (errResponse) {
                        $log.debug(errResponse);
                    });
                } else if (vm.physicalDocument.barCode.indexOf(LINK_SETTLEMENT_REPORT) === 0) {
                    vm.type = "L";
                    vm.physicalDocument.barCode = vm.physicalDocument.barCode.replace(LINK_SETTLEMENT_REPORT, '');
                    api.ComprasWS.Settlement.Settlement.query({ 'id': vm.physicalDocument.barCode }, function (response) {
                        api.ComprasWS.SettlementDetails.getAllDetailsBySettlement.getAll(
                            { 'settlementId': response.id, 'circleId': $rootScope.bsCircle.id }, function (responseDetail) {
                                if (response.settlementStatus.name === 'Provisionada') {
                                    var add = false;
                                    responseDetail.forEach(function (data) {
                                        if (data.invoicePurchase &&
                                            ((data.invoicePurchase.invoiceSerie && !data.invoicePurchase.invoiceSerie.electronicInvoice)
                                                || data.invoicePurchase.uuid == null)
                                        ) {
                                            add = true;
                                        }
                                    });
                                    if (add) {
                                        api.ComprasWS.PhysicalDocumentDeliveryDetail.PhysicalDocumentDeliveryDetail.create({},
                                            {
                                                settlement: { id: vm.physicalDocument.barCode },
                                                physicalDocumentDelivery: { id: vm.physicalDocument.id }
                                            }, function (response) {
                                                getDetail();
                                                vm.physicalDocument.barCode = '';
                                                MessageService.show($filter('translate')('physicalDocumentDelivery.addedSuccessfully'));
                                            }, function (errResponse) {
                                                $log.debug(errResponse);
                                                MessageService.showErrorMessage($filter('translate')('physicalDocumentDelivery.' + errResponse.data.mensaje));
                                                vm.physicalDocument.barCode = '';
                                            });
                                    }
                                }

                            }, function (errResponse) {
                                $log.debug(errResponse);
                            });
                    }, function (errResponse) {
                        $log.debug(errResponse);
                    });
                }
            }
        }

        vm.focusBarcode = function () {

            api.ComprasWS.PhysicalDocumentDelivery.PhysicalDocumentDelivery.getById(
                { 'idCircle': $rootScope.bsCircle.id }, vm.physicalDocument, function (response) {
                    vm.physicalDocument = response;
                    getDetail();
                    $timeout(function () {
                        document.querySelector('#barCode').focus();
                    }, 500);
                }, function (errResponse) {
                    $log.debug(errResponse);
                });

        };

        function getDetail() {
            var dataSource = {
                paginationPageSize: vm.pageSize,
                getRows: function (params) {
                    var o = params.request.filterModel;
                    var arr = [];
                    if (params.request.filterModel) {
                        arr = $.map(o, function (k, ke, sd, ds) {
                            var on = k;
                            on.field = ke;
                            on.filter = on.filter.toString();
                            return on;
                        });
                    }
                    arr.forEach(function (row, index) {
                        filter = filter + "%" + row.filter;
                    });
                    api.ComprasWS.PhysicalDocumentDeliveryDetail.byPhysicalDocumentDelivery.query(
                        { 'physicalDocumentDeliveryId': vm.physicalDocument.id }, vm.physicalDocument, function (response) {
                            vm.detail = new jinqJs()
                                .from(response)
                                .orderBy([{ field: 'id', sort: 'asc' }])
                                .select(function (r) {
                                    var d = r;
                                    d.type = r.invoicePurchase ? 'INVOICE' : 'SETTLEMENT';
                                    d.document = r.invoicePurchase ? r.invoicePurchase : r.settlement;
                                    return d;
                                });
                            vm.loading = false;
                            filter = '';
                            $rootScope.loadingProgress = false;

                            params.successCallback(vm.detail, response.length);
                            $log.debug(vm.detail);
                        }, function (response) {// Error
                            $log.debug(response);
                            vm.loading = false;
                            $rootScope.loadingProgress = false;
                        });
                }
            };
            vm.masterGridOptions.api.setEnterpriseDatasource(dataSource);
        }

        vm.deleteDetail = function (data, ev, i) {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('physicalDocumentDelivery.delete'))
                .textContent($filter('translate')('physicalDocumentDelivery.confirmeDelete'))
                .ok($filter('translate')('REQUISITION.MSG.SI'))
                .cancel($filter('translate')('REQUISITION.MSG.NO'));

            $mdDialog.show(confirm).then(function () {
                api.ComprasWS.PhysicalDocumentDeliveryDetail.PhysicalDocumentDeliveryDetail.del({ 'id': data.id }, function (response) {
                    getDetail();
                    MessageService.show($filter('translate')('physicalDocumentDelivery.deleteSuccessfully'));
                }, function (errResponse) {
                    $log.debug(errResponse);
                    MessageService.showErrorMessage($filter('translate')('physicalDocumentDelivery.' + errResponse.data.mensaje));
                });
            }, function () {
            });
        };

        vm.viewDetail = function (ev, data, i) {
            if (data.type === 'INVOICE') {
                $state.go("app.report.invoiceP.detail",
                    { id: data.invoicePurchase.id, backTo: $state.current.name, filter: { id: data.physicalDocumentDelivery.id } });
            } else {
                $state.go("app.expenseSettlement.settlement.settlementView",
                    { settlementId: data.settlement.id, backTo: $state.current.name, filter: { id: data.physicalDocumentDelivery.id } });
            }
        };

        vm.presentPhysicalDocumentDelivery = function () {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('physicalDocumentDelivery.changeStatus'))
                .textContent($filter('translate')('physicalDocumentDelivery.confirm.'
                    + $filter("translate")('physicalDocumentDelivery.STATUSCHANGE.' + vm.statusToChange)))
                .ok($filter('translate')('REQUISITION.MSG.SI'))
                .cancel($filter('translate')('REQUISITION.MSG.NO'));

            $mdDialog.show(confirm).then(function () {
                api.ComprasWS.PhysicalDocumentDelivery.changeStatus.update(
                    {
                        'physicalDocumentDeliveryId': vm.physicalDocument.id,
                        'status': $filter("translate")('physicalDocumentDelivery.STATUSCHANGE.' + vm.statusToChange)
                    }, function (response) {
                        vm.physicalDocument = {};
                        vm.detail = [];
                        vm.goToPhysicalDocumentDelivery();
                        MessageService.show($filter('translate')("physicalDocumentDelivery.updatedSuccessfullyTo")
                            + $filter('translate')("physicalDocumentDelivery.STATUSCHANGE." + vm.statusToChange));
                    }, function (errResponse) {
                        $log.debug(errResponse);
                    })
            }, function () {
            })
        };

        vm.goToPhysicalDocumentDelivery = function () {
            if ($stateParams.backTo !== null && $stateParams.backTo !== undefined) {
                vm.isReport = true;
                $state.go($stateParams.backTo, { 'filter': $stateParams.filter });
            } else {
                $state.go('app.dashboards_project');
            }
        };


    }
})();

(function () {
    'use strict';
    angular
        .module('app.physicalDocumentDelivery')
        .controller('prepareDeliveryController', prepareDeliveryController);

    /** @ngInject */
    function prepareDeliveryController($state, api, $log, $rootScope, $mdDialog, $timeout, $filter, $stateParams, MessageService, LINK_SETTLEMENT_REPORT) {
        var vm = this;

        vm.replaceOriginTypedata = replaceOriginTypedata;

        vm.minDate = new Date();
        vm.isBuyer = $stateParams.isBuyer;
        vm.validatePhysicalDocument = validatePhysicalDocument;
        vm.type = "";
        vm.statusToChange = $stateParams.status;
        if ($stateParams.id) {
            api.ComprasWS.PhysicalDocumentDelivery.byId.get({ 'id': $stateParams.id }, function (response) {
                vm.physicalDocument = response;
                getDetail();
            }, function (errResponse) {
                $log.debug(errResponse);
            });
        }

        vm.masterColumnDefs = [
            {
                headerName: '#',
                field: "id",
                width: 50,
                filter: 'number',
                cellStyle: { 'text-align': 'center' },
                pinned: 'left'
            },
            {
                headerName: 'physicalDocumentDelivery.type',
                field: "type",
                headerCellRenderer: getHeader,
                width: 300,
                filter: 'text',
                enableRowGroup: true,
                cellRenderer: function (params) {
                    return "<div>{{'physicalDocumentDelivery.'+data.type | translate}}</div>"
                },
                enablePivot: true
            },
            {
                headerName: 'physicalDocumentDelivery.document',
                field: "document",
                headerCellRenderer: getHeader,
                width: 450,
                filter: 'text',
                enableRowGroup: true,
                cellRenderer: function (params) {
                    if (params && params.data && params.data.type === 'INVOICE') {
                        return (params.data.invoicePurchase.invoiceSerie ?
                            params.data.invoicePurchase.invoiceSerie.serie :
                            params.data.invoicePurchase.uuid.substring(0, 8))
                            + " - " + params.data.invoicePurchase.correlative;
                    } else if (params && params.data && params.data.settlement && params.data.type === 'SETTLEMENT') {
                        return params.data.settlement.id;
                    }
                },
                enablePivot: true
            },
            {
                headerName: 'physicalDocumentDelivery.total',
                field: "document",
                headerCellRenderer: getHeader,
                width: 250,
                filter: 'text',
                enableRowGroup: true,
                cellRenderer: function (params) {
                    if (params && params.data && params.data.type === 'INVOICE') {
                        return $filter('number')(params.data.invoicePurchase.documentTotalBeforeTax, 2);
                    } else if (params && params.data && params.data.settlement && params.data.type === 'SETTLEMENT') {
                        return $filter('number')(params.data.settlement.settledAmount, 2);
                    }
                },
                cellStyle: { 'text-align': 'right' },
                enablePivot: true
            },
            {
                headerName: 'REQUISITION.ACTIONS',
                name: "actions",
                headerCellRenderer: getHeader,
                suppressSorting: true,
                suppressMenu: true,
                width: 250,
                cellRenderer: function (params) {
                    return '<div style="width: 100%;">'
                        + '      <md-button class="edit-button md-icon-button"'
                        + ' ng-click="vm.viewDetail($event, data, $index)" '
                        + '                         aria-label="Product details"'
                        + '                         translate translate-attr-aria-label="physicalDocumentDetail.PRODUCT_DETAILS">'
                        + '     <md-icon md-font-icon="icon-eye" class="s16"></md-icon>'
                        + '     <md-tooltip>'
                        + '         <span translate="physicalDocumentDelivery.viewDetail"></span>'
                        + '     </md-tooltip>'
                        + ' </md-button>'
                        + ' <md-button class="edit-button md-icon-button" '
                        + '     ng-click="vm.deleteDetail(data, $event, $index)"'
                        + '     aria-label="Product details"'
                        + '     translate translate-attr-aria-label="REQUISITION.DELETE">'
                        + '     <md-icon md-font-icon="icon-delete" class="s16 md-warn"></md-icon>'
                        + '     <md-tooltip>'
                        + '         <span translate="REQUISITION.DELETE"></span>'
                        + '     </md-tooltip>'
                        + ' </md-button>'
                        + ' </div>';
                },
                cellStyle: { 'padding': '0px' },
                pinned: 'right'
            }
        ];

        vm.masterGridOptions = {
            columnDefs: vm.masterColumnDefs,
            enableSorting: true,
            debug: false,
            enableFilter: true,
            enableColResize: true,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowData: null,
            groupHeaders: true,
            headerHeight: 50,
            rowHeight: 40,
            rowSelection: 'multiple',
            rowDeselection: true,
            rowModelType: "enterprise",
            cacheBlockSize: vm.pageSize,
            pagination: true,
            paginationPageSize: vm.pageSize,
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            },
            doesDataFlower: function (dataItem) {
                return true;
            },
            isExternalFilterPresent: isExternalFilterPresent,
            doesExternalFilterPass: doesExternalFilterPass
        };

        vm.masterColumnDefs.forEach(function (d) {
            correctFilterParams(d);
        });

        function correctFilterParams(column) {
            switch (column.filter) {
                case 'number':
                    column.filterParams = {
                        filterOptions: ['equals'],
                        newRowsAction: 'keep'
                    };
                    break;
                case 'text':
                    column.filterParams = {
                        filterOptions: ['contains'],
                        newRowsAction: 'keep'
                    };
                    break;
                case 'date':
                    column.suppressFilter = true;
                    break;
            }
        }

        var filter = '';

        function isExternalFilterPresent() {
            return filter !== '';
        }

        function doesExternalFilterPass(node) {
            if (filter && filter !== 'everyone') {
                var arrdt = node.data.filter.split(filter);
                return arrdt.length > 1;
            }
            return true;
        }

        init();
        /**
         * Initialize
         */
        function init(id, ot) {
            api.GeneralWS.UserRoleTreasurer.getbyCorporateAndRoleTreasure.get(
                { 'idCircle': $rootScope.bsCircle.id, 'pageNumber': 0, 'pageSize': 100, 'search': '' }, function (response) {
                    vm.treasures = response.content;
                }, function (errResponse) {
                    $log.debug(errResponse);
                });
        }

        function validatePhysicalDocument() {
            if (vm.physicalDocument.barCode) {
                if (vm.physicalDocument.barCode.toLowerCase().indexOf("fac") === 0) {
                    vm.type = "F";
                    vm.physicalDocument.barCode = vm.physicalDocument.barCode.toLowerCase().replace('fac', '');
                    api.ComprasWS.InvoicePurchase.query({ 'id': vm.physicalDocument.barCode }, function (response) {
                        vm.invoicePurchase = response;
                        if ((vm.invoicePurchase.invoiceSerie && !vm.invoicePurchase.invoiceSerie.electronicInvoice) || vm.invoicePurchase.uuid == null) {
                            if (vm.invoicePurchase.purchaseStatus.description === 'Provisionada') {
                                api.ComprasWS.PhysicalDocumentDeliveryDetail.PhysicalDocumentDeliveryDetail.create(
                                    {}, {
                                    invoicePurchase: { id: vm.physicalDocument.barCode }, physicalDocumentDelivery:
                                        { id: vm.physicalDocument.id }
                                }, function (response) {
                                    getDetail();
                                    vm.physicalDocument.barCode = '';
                                    MessageService.show($filter('translate')('physicalDocumentDelivery.addedSuccessfully'));
                                }, function (errResponse) {
                                    $log.debug(errResponse);
                                    if (errResponse.data.mensaje.indexOf("DOCUMENT_EXIST_IN") === 0) {
                                        MessageService.showErrorMessage(errResponse.data.mensaje.replace("DOCUMENT_EXIST_IN",
                                            $filter('translate')("physicalDocumentDelivery.DOCUMENT_EXIST_IN")));
                                    } else {
                                        MessageService.showErrorMessage($filter('translate')('physicalDocumentDelivery.' + errResponse.data.mensaje));
                                    }
                                    vm.physicalDocument.barCode = '';
                                });
                            } else {
                                MessageService.showErrorMessage($filter('translate')('physicalDocumentDelivery.isDocumentNotProvisioned'));
                            }
                        } else {
                            MessageService.showErrorMessage($filter('translate')('physicalDocumentDelivery.isDocumentElectronic'));
                        }
                    }, function (errResponse) {
                        $log.debug(errResponse);
                    });
                } else if (vm.physicalDocument.barCode.indexOf(LINK_SETTLEMENT_REPORT) === 0) {
                    vm.type = "L";
                    vm.physicalDocument.barCode = vm.physicalDocument.barCode.replace(LINK_SETTLEMENT_REPORT, '');
                    api.ComprasWS.Settlement.Settlement.query({ 'id': vm.physicalDocument.barCode }, function (response) {
                        api.ComprasWS.SettlementDetails.getAllDetailsBySettlement.getAll(
                            { 'settlementId': response.id, 'circleId': $rootScope.bsCircle.id }, function (responseDetail) {
                                if (response.settlementStatus.name === 'Provisionada') {
                                    var add = false;
                                    responseDetail.forEach(function (data) {
                                        if (data.invoicePurchase &&
                                            ((data.invoicePurchase.invoiceSerie && !data.invoicePurchase.invoiceSerie.electronicInvoice)
                                                || data.invoicePurchase.uuid == null)) {
                                            add = true;
                                        }
                                    });
                                    if (add) {
                                        api.ComprasWS.PhysicalDocumentDeliveryDetail.PhysicalDocumentDeliveryDetail.create(
                                            {}, {
                                            settlement: { id: vm.physicalDocument.barCode },
                                            physicalDocumentDelivery: { id: vm.physicalDocument.id }
                                        }, function (response) {
                                            getDetail();
                                            vm.physicalDocument.barCode = '';
                                            MessageService.show($filter('translate')('physicalDocumentDelivery.addedSuccessfully'));
                                        }, function (errResponse) {
                                            $log.debug(errResponse);
                                            if (errResponse.data.mensaje.indexOf("DOCUMENT_EXIST_IN") === 0) {
                                                MessageService.showErrorMessage(errResponse.data.mensaje.replace("DOCUMENT_EXIST_IN",
                                                    $filter('translate')("physicalDocumentDelivery.DOCUMENT_EXIST_IN")));
                                            } else {
                                                MessageService.showErrorMessage($filter('translate')('physicalDocumentDelivery.' + errResponse.data.mensaje));
                                            }
                                            vm.physicalDocument.barCode = '';
                                        });
                                    } else {
                                        MessageService.showErrorMessage($filter('translate')('physicalDocumentDelivery.isDocumentElectronic'));
                                    }
                                } else {
                                    MessageService.showErrorMessage($filter('translate')('physicalDocumentDelivery.isDocumentNotProvisioned'));
                                }

                            }, function (errResponse) {
                                $log.debug(errResponse);
                            });
                    }, function (errResponse) {
                        $log.debug(errResponse);
                    });
                } else {
                    vm.physicalDocument.barCode = '';
                    MessageService.showErrorMessage($filter('translate')('physicalDocumentDelivery.documentError'));
                }
            }
        }

        vm.focusBarcode = function () {

            api.ComprasWS.PhysicalDocumentDelivery.PhysicalDocumentDelivery.getById(
                { 'idCircle': $rootScope.bsCircle.id }, vm.physicalDocument, function (response) {
                    vm.physicalDocument = response;
                    getDetail();
                    $timeout(function () {
                        document.querySelector('#barCode').focus();
                    }, 500);
                }, function (errResponse) {
                    $log.debug(errResponse);
                });

        };

        function getDetail() {
            var dataSource = {
                paginationPageSize: vm.pageSize,
                getRows: function (params) {
                    var o = params.request.filterModel;
                    var arr = [];
                    if (params.request.filterModel) {
                        arr = $.map(o, function (k, ke, sd, ds) {
                            var on = k;
                            on.field = ke;
                            on.filter = on.filter.toString();
                            return on;
                        });
                    }
                    arr.forEach(function (row, index) {
                        filter = filter + "%" + row.filter;
                    });
                    api.ComprasWS.PhysicalDocumentDeliveryDetail.byPhysicalDocumentDelivery.query(
                        { 'physicalDocumentDeliveryId': vm.physicalDocument.id }, vm.physicalDocument, function (response) {
                            vm.detail = new jinqJs()
                                .from(response)
                                .orderBy([{ field: 'id', sort: 'asc' }])
                                .select(function (r) {
                                    var d = r;
                                    d.type = r.invoicePurchase ? 'INVOICE' : 'SETTLEMENT';
                                    d.document = r.invoicePurchase ? r.invoicePurchase : r.settlement;
                                    return d;
                                });
                            vm.loading = false;
                            filter = '';
                            $rootScope.loadingProgress = false;

                            params.successCallback(vm.detail, response.length);
                            $log.debug(vm.detail);
                        }, function (response) {// Error
                            $log.debug(response);
                            vm.loading = false;
                            $rootScope.loadingProgress = false;
                        });
                }
            };
            vm.masterGridOptions.api.setEnterpriseDatasource(dataSource);
        }

        vm.deleteDetail = function (data, ev, i) {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('physicalDocumentDelivery.delete'))
                .textContent($filter('translate')('physicalDocumentDelivery.confirmeDelete'))
                .ok($filter('translate')('REQUISITION.MSG.SI'))
                .cancel($filter('translate')('REQUISITION.MSG.NO'));

            $mdDialog.show(confirm).then(function () {
                api.ComprasWS.PhysicalDocumentDeliveryDetail.PhysicalDocumentDeliveryDetail.del({ 'id': data.id }, function (response) {
                    getDetail();
                    MessageService.show($filter('translate')('physicalDocumentDelivery.deleteSuccessfully'));
                }, function (errResponse) {
                    $log.debug(errResponse);
                    MessageService.showErrorMessage($filter('translate')('physicalDocumentDelivery.' + errResponse.data.mensaje));
                });
            }, function () {
            });
        };

        vm.viewDetail = function (ev, data, i) {
            if (data.type === 'INVOICE') {
                $state.go("app.report.invoiceP.detail",
                    { id: data.invoicePurchase.id, backTo: $state.current.name, filter: { id: data.physicalDocumentDelivery.id } });
            } else {
                $state.go("app.expenseSettlement.settlement.settlementView",
                    { settlementId: data.settlement.id, backTo: $state.current.name, filter: { id: data.physicalDocumentDelivery.id } });
            }
        };

        vm.presentPhysicalDocumentDelivery = function () {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('physicalDocumentDelivery.changeStatus'))
                .textContent($filter('translate')('physicalDocumentDelivery.confirm.'
                    + $filter("translate")('physicalDocumentDelivery.STATUSCHANGE.' + vm.statusToChange)))
                .ok($filter('translate')('REQUISITION.MSG.SI'))
                .cancel($filter('translate')('REQUISITION.MSG.NO'));

            $mdDialog.show(confirm).then(function () {
                api.ComprasWS.PhysicalDocumentDelivery.changeStatus.update(
                    {
                        'physicalDocumentDeliveryId': vm.physicalDocument.id,
                        'status': $filter("translate")('physicalDocumentDelivery.STATUSCHANGE.' + vm.statusToChange)
                    }, function (response) {
                        vm.physicalDocument = {};
                        vm.detail = [];
                        MessageService.show($filter('translate')("physicalDocumentDelivery.updatedSuccessfullyTo")
                            + $filter('translate')("physicalDocumentDelivery.STATUSCHANGE." + vm.statusToChange));
                    }, function (errResponse) {
                        $log.debug(errResponse);
                    })
            }, function () {
            })
        };

        $timeout(function () {
            var searchUserTreasurerInput = document.querySelector("#searchUserTreasurer");
            if (searchUserTreasurerInput) {
                searchUserTreasurerInput.addEventListener("keydown", keyEvent);
            }
        }, 200);

        vm.cancelPhysicalDocumentDelivery = function () {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('physicalDocumentDelivery.STATUSCHANGE.cancelPhysicalDocumentDelivery'))
                .textContent($filter('translate')('physicalDocumentDelivery.confirm.cancelPhysicalDocumentDelivery'))
                .ok($filter('translate')('REQUISITION.MSG.SI'))
                .cancel($filter('translate')('REQUISITION.MSG.NO'));

            $mdDialog.show(confirm).then(function () {
                api.ComprasWS.PhysicalDocumentDelivery.cancelProcess.cancel(
                    { 'id': vm.physicalDocument.id, 'idCircle': $rootScope.bsCircle.id }, function (response) {
                        vm.physicalDocument = {};
                        vm.detail = [];
                        MessageService.show($filter('translate')("physicalDocumentDelivery.canceledSuccessfully"));
                    }, function (errResponse) {
                        $log.debug(errResponse);
                    })
            }, function () {
            })
        }

    }
})();

(function () {
    'use strict';
    angular
        .module('app.order')
        .controller('OrderProviderController', OrderProviderController)
        .controller('TableDetailPurchaseOrderController', TableDetailPurchaseOrderController);

    /** @ngInject */
    function OrderProviderController($state, api,
        $log, $rootScope, $mdDialog, $stateParams, $filter, MessageService, $timeout) {
        var vm = this;

        vm.petition = 0;
        vm.minDate = new Date();
        vm.updateProvider = updateProvider;
        vm.notReceived = notReceived;
        vm.cancelPurchase = cancelPurchase;
        vm.addFeatures = addFeatures;
        vm.daysForCancelPurchase = 0;
        vm.canCancelPurchase = false;
        vm.isEnterFeatures = $stateParams.type === 'PIC';
        vm.approvePurchase = approvePurchase;
        vm.URLPHOTOS = api.baseUrlPhotos;

        vm.reasignProvider = false;

        vm.NUMBER_DIMENSION_THREE = 3;
        vm.NUMBER_DIMENSION_FOUR = 4;
        vm.NUMBER_DIMENSION_FIVE = 5;

        vm.dimensionCompanyDetail3 = null;
        vm.dimensionCompanyDetail4 = null;
        vm.dimensionCompanyDetail5 = null;

        vm.dinamicSize = 0;

        if ($stateParams.id === '') {
            $state.go('app.order.' + $stateParams.status);
        }


        vm.dtOptions = {
            responsive: true,
            paging: false, searching: false,
            columnDefs: getColumnDefs()
        };
        vm.dtOptions2 = {
            responsive: true,
            paging: false, searching: false,
            columnDefs: getColumnDefs()
        };
        vm.newStatus = '';
        // Methods
        vm.gotoOrders = gotoOrders;
        vm.saveEntries = saveEntries;
        vm.getDetails = getDetails;
        vm.merchandiseEntryDialog = merchandiseEntryDialog;
        vm.notFileMerchandise = false;

        vm.masterColumnDefs = [
            {
                headerName: '#',
                name: "no",
                width: 50,
                cellStyle: { 'text-align': 'center' },
                cellRenderer: function (params) {
                    return params.rowIndex + 1;
                },
                sort: 'asc',
                pinned: "left"
            },
            {
                headerName: 'ORDER.DETAIL.PRODUCT',
                field: "productName",
                headerCellRenderer: getHeader,
                width: 250,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'ORDER.DETAIL.PRICE',
                name: "price",
                headerCellRenderer: getHeader,
                width: 150,
                enableRowGroup: true,
                enablePivot: true,
                cellStyle: { 'text-align': 'right' },
                cellRenderer: function (params) {
                    return $filter('number')(params.data.price, 6);
                }
            },
            {
                headerName: 'ORDER.DETAIL.QUANTITY',
                name: "quantity",
                headerCellRenderer: getHeader,
                width: 200,
                enableRowGroup: true,
                enablePivot: true,
                cellStyle: { 'text-align': 'center' },
                cellRenderer: function (params) {
                    return $filter('number')(params.data.quantityRequired, 2);
                }
            },
            {
                headerName: 'ORDER.DETAIL.PENDIENTE',
                name: "pending",
                headerCellRenderer: getHeader,
                width: 150,
                enableRowGroup: true,
                enablePivot: true,
                cellStyle: { 'text-align': 'center' },
                cellRenderer: function (params) {
                    if (params.data.completed) {
                        return "<md-icon md-font-icon=\"icon-check\"></md-icon>";
                    } else {
                        return $filter('number')(params.data.maxRecibe, 2);
                    }
                }
            },
            {
                headerName: 'ORDER.ACTIONS',
                name: "actions",
                headerCellRenderer: getHeader,
                suppressSorting: true,
                suppressMenu: true,
                width: 150,
                cellRenderer: function (params) {
                    var resp = '<md-button class="edit-button md-icon-button"'
                        + '                                                     ng-if="data.quantityRequired > data.maxRecibe"'
                        + '                                                            ng-click="vm.merchandiseEntryDialog($event, data)"'
                        + '                                                            aria-label="Product details"'
                        + '                                                            translate translate-attr-aria-label="REQUISITION.PRODUCT_DETAILS">'
                        + '                                                     <md-icon md-font-icon="icon-eye" class="s16"></md-icon>'
                        + '                                                     <md-tooltip md-direction="bottom">'
                        + '                                                         {{"ORDER.DETAIL.VIEW"| translate}}'
                        + '                                                     </md-tooltip>'
                        + '                                                 </md-button>';
                    if ($stateParams.type === 'C') {
                        resp = resp + '<md-button class="edit-button md-icon-button"'
                            + '            ng-if="data.maxRecibe > 0 && (data.quantityRequired !== data.maxRecibe)"'
                            + '        ng-click="vm.notReceived($event, data)"'
                            + '        aria-label="Product details"'
                            + '        translate translate-attr-aria-label="REQUISITION.PRODUCT_DETAILS">'
                            + ' <md-icon md-font-icon="icon-close" class="s16"></md-icon>'
                            + ' <md-tooltip md-direction="bottom">'
                            + '     {{"ORDER.DETAIL.NOT_RECEIVED"| translate}}'
                            + ' </md-tooltip>'
                            + ' </md-button>';
                    }

                    if ($stateParams.type === 'PIC') {
                        resp = resp + '<md-button class="edit-button md-icon-button"'
                            + '        ng-click="vm.addFeatures(data, $index, $event)"'
                            + '        aria-label="Product details"'
                            + '        translate translate-attr-aria-label="REQUISITION.PRODUCT_DETAILS">'
                            + ' <md-icon md-font-icon="icon-border-color" class="s16"></md-icon> '
                            + '                             <md-tooltip md-direction="left">{{"QUOTATION.DETAIL.FEATURES.EDIT"| translate}}</md-tooltip>'
                            + ' </md-button>';
                    }

                    return resp;
                },
                cellStyle: { 'padding': '0px' },
                pinned: "right"
            }
        ];

        if ($stateParams.type === 'C' || $stateParams.type === 'PR') {
            vm.masterColumnDefs.splice(5, 0, {
                headerName: 'ORDER.DETAIL.RECIBIR',
                name: "recibir",
                headerCellRenderer: getHeader,
                width: 200,
                enableRowGroup: true,
                enablePivot: true,
                cellRenderer: function (params) {
                    return '<div ng-if="!data.completed && data.maxRecibe > 0" style="background-color: rgba(134, 244, 54, 0.37);" '
                        + ' ng-controller="TableDetailPurchaseOrderController">'
                        + ' <md-input-container>'
                        + '     <label></label>'
                        + '     <input ng-model="data.quantity" type="number" max="{{data.maxRecibe}}" min="0" ng-model-options="{\'debounce\': 300}">'
                        + ' </md-input-container>'
                        + ' </td>'
                        + ' <div>';
                }
            });
        }

        vm.masterGridOptions = {
            columnDefs: vm.masterColumnDefs,
            enableSorting: true,
            debug: false,
            enableFilter: true,
            enableColResize: true,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowData: null,
            groupHeaders: true,
            headerHeight: 50,
            rowHeight: 45,
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            },
            doesDataFlower: function (dataItem) {
                return true;
            },
            isExternalFilterPresent: isExternalFilterPresent,
            doesExternalFilterPass: doesExternalFilterPass
        };

        // Data
        var filter = 'everyone';

        function isExternalFilterPresent() {
            // if ageType is not everyone, then we are filtering
            return filter !== '';
        }

        function doesExternalFilterPass(node) {
            if (filter && filter !== 'everyone') {
                var arrdt = node.data.filter.split(filter);
                return arrdt.length > 1;
            }
            return true;
        }
        //////////


        ///////FACTURA

        vm.masterColumnDefsInvoice = [
            {
                headerName: 'INVOICE.INVOICE',
                field: "invoiceDescription",
                headerCellRenderer: getHeader,
                width: 250,
                rowGroupIndex: 0,
                hide: true
            },
            {
                headerName: 'INVOICE.PRODUCT.PRODUCT',
                field: "product.name",
                headerCellRenderer: getHeader,
                width: 350,
                enableRowGroup: true,
                enablePivot: true,
                cellRenderer: function (params) {
                    if (!params.node.group) {
                        if (params.data && params.data.product.brand && params.data.product.measurementUnit) {
                            return params.value + ", " + $filter('translate')('authorize_quotations.measurement_unit')
                                + ": " + params.data.product.measurementUnit.name + ", " + $filter('translate')('authorize_quotations.brand')
                                + ": " + params.data.product.brand.name;
                        } else {
                            return params.value;
                        }

                    } else {
                        return params.value;
                    }
                }
            },
            {
                headerName: 'INVOICE.INVOICE_PURCHASE.ELECTRONIC_SIGNATURE',
                field: "invoicePurchase.electronicSignature",
                headerCellRenderer: getHeader,
                width: 160,
                enableRowGroup: true,
                enablePivot: true,
                cellStyle: { 'text-align': 'center' }
            },
            {
                headerName: 'INVOICE.INVOICE_PURCHASE.DETAIL.QUANTITY',
                field: "quantity",
                headerCellRenderer: getHeader,
                width: 100,
                enableRowGroup: true,
                enablePivot: true,
                cellStyle: { 'text-align': 'center' }
            },
            {
                headerName: 'INVOICE.INVOICE_PURCHASE.DETAIL.UNIT_PRICE_AFTER_TAX',
                field: "priceAfterTax",
                headerCellRenderer: getHeader,
                width: 100,
                suppressSorting: true,
                suppressMenu: true,
                cellStyle: { 'text-align': 'right' },
                valueFormatter: function (params) {
                    return $filter('number')(params.value, 2);
                }
            },
            {
                headerName: 'INVOICE.INVOICE_PURCHASE.DETAIL.TOTAL_AFTER_TAX',
                field: "subTotalAfterTax",
                headerCellRenderer: getHeader,
                width: 100,
                suppressSorting: true,
                suppressMenu: true,
                cellStyle: { 'text-align': 'right' },
                valueFormatter: function (params) {
                    return $filter('number')(params.value, 2);
                }
            }
        ];

        vm.masterGridOptionsInvoice = {
            columnDefs: vm.masterColumnDefsInvoice,
            enableSorting: true,
            debug: false,
            enableFilter: true,
            enableColResize: true,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowData: null,
            headerHeight: 50,
            rowHeight: 45,
            groupUseEntireRow: true,
            animateRows: true,
            groupDefaultExpanded: 1,
            doesDataFlower: function (dataItem) {
                var resp = ' ';
                var ref = '';
                dataItem.invoicePurchase.files.forEach(function (file, index, arr) {
                    ref = ref + '<a href="' + vm.URLPHOTOS + file.parentPath + file.name + file.extension + '">Ver Imagen ' + (index + 1) + '</a> ';
                });
                dataItem.invoiceDescription = "Factura SERIE "
                    + (dataItem.invoicePurchase.invoiceSerie ? dataItem.invoicePurchase.invoiceSerie.serie : dataItem.invoicePurchase.uuid.substring(0,8))
                    + " Correlativo No. " + dataItem.invoicePurchase.correlative
                    + " {{'CONTRACT.BY_CREATED' | translate}} " + dataItem.invoicePurchase.createdBy
                    + " El " + $filter('date')(getDateFormat(dataItem), 'dd/MM/yyyy') + '' + resp + ref + '';
            },
            isExternalFilterPresent: isExternalFilterPresent,
            doesExternalFilterPass: doesExternalFilterPass,
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            },
            groupRowInnerRenderer: function (params) {
                return params.value;
            }
        };


        init();
        /**
         * Initialize
         */
        function init() {
            vm.dinamicSize = $(window).innerHeight();
            $rootScope.loadingProgress = true;
            var type;
            if (!$stateParams.isClient && $stateParams.type) {
                type = $stateParams.type ? $stateParams.type : 'C';
            } else {
                type = $stateParams.isClient ? 'C' : 'P';
            }
            api.ComprasWS.PurchaseOrder.get({ idCircle: $rootScope.bsCircle.id, id: $stateParams.id, type: type }, function (data) {
                if ($stateParams.type === 'C' && data.purchaseStatus.orderColumn !== 1) {
                    $state.go('app.order.' + $stateParams.type);
                }
                vm.order = data;
                $rootScope.loadingProgress = false;
                getDetails();


                $timeout(function () {
                    vm.requisition = data;
                    if (vm.order.id && vm.order.quotation && vm.order.quotation.requisition) {
                        getInvoice(vm.order.quotation.requisition.id);
                    }
                });

                validateAccessToBudget(data.company.id);
                for (var i = 0; i < $rootScope.bsCircle.role.roleSpecialActions.length; i++) {
                    if ($rootScope.bsCircle.role.roleSpecialActions[i].specialAction.actionName === 'Reasignar Proveedor'
                        && vm.order.purchaseStatus.description === 'Pendiente Recibir') {
                        if (vm.order.quotation) {
                            if (vm.order.quotation.requisition) {
                                if (vm.order.quotation.requisition.receivedDouble) {
                                    vm.reasignProvider = false;
                                    vm.notFileMerchandise = true;
                                    break;
                                } else {
                                    vm.reasignProvider = true;
                                    break;
                                }
                            } else {
                                vm.reasignProvider = true;
                                break;
                            }
                        } else {
                            vm.reasignProvider = true;
                            break;
                        }
                    }
                }

                getDimensionCompany();

                vm.showProcessFlow = false;
                if ($stateParams.filter && !$stateParams.filter.isProvider) {
                    vm.showProcessFlow = true;
                    api.ComprasWS.ProcessFlow.get({ id: data.id, type: 3 }, function (data) {
                        vm.infoProcessFlow = data;
                    });
                }

            }, function (err) {

            });
        }


        function getColumnDefs() {
            return [
                {
                    targets: 0,
                    width: '72px'
                },
                {
                    targets: 1,
                    responsivePriority: 1,
                    render: function (data, type) {
                        return '<p>' + data + '</p>';
                    },
                    width: '300px'
                },
                {
                    targets: 2,
                    responsivePriority: 3,
                    width: '100px'
                },
                {
                    targets: 3,
                    responsivePriority: 2,
                    width: '100px'
                },
                {
                    targets: 4,
                    responsivePriority: 2,
                    width: '100px'
                }];
        }

        function saveEntries(e, ev) {

            var datasToSave = new jinqJs()
                .from(vm.details)
                .where(function (r) {
                    return r.quantity > 0;
                })
                .select(function (r) {
                    delete r.maxRecibe;
                    return r;
                });

            if (datasToSave.length <= 0) {
                return;
            }

            if (vm.notFileMerchandise) {
                var confirm = $mdDialog.confirm()
                    .title($filter('translate')('ORDER.MSG.SURE_SEND'))
                    .ariaLabel('add modal')
                    .ok($filter('translate')('ORDER.MSG.SI'))
                    .cancel($filter('translate')('ORDER.MSG.NO'));
                $mdDialog.show(confirm).then(function () {

                    var promise = api.ComprasWS.MerchandiseEntry.create({ idCircle: $rootScope.bsCircle.id }, datasToSave).$promise;
                    promise.then(
                        function (data) {
                            MessageService.show('ORDER.MSG.SENDED');
                            var addproducts = new jinqJs()
                                .from(datasToSave)
                                .where(function (r) {
                                    return r.addProduct === true;
                                })
                                .select(function (r) {
                                    return r;
                                });
                            if (addproducts.length > 0) {
                                var confirm = $mdDialog.confirm()
                                    .title($filter('translate')('ORDER.MSG.ADD_PRODUCTS'))
                                    .ariaLabel('add modal')
                                    .targetEvent(e)
                                    .ok($filter('translate')('ORDER.MSG.SI'))
                                    .cancel($filter('translate')('ORDER.MSG.NO'));
                                $mdDialog.show(confirm).then(function () {
                                    $state.go('app.merchandiseEntry.view', { id: data[0].merchandiseHeader.id });
                                }, function () {
                                    gotoOrders();
                                });
                            } else {
                                gotoOrders();
                            }
                            $rootScope.loadingProgress = false;
                            vm.loadingLocal = false;
                        },
                        function (err) {
                            MessageService.showErrorMessage('ORDER.MSG.ERR');
                            vm.loadingLocal = false;
                        }
                    );

                }, function () {

                });
            } else {
                $mdDialog.show({
                    controller: 'receiveMerchandiseEntryController',
                    controllerAs: 'vm',
                    locals: {
                        order: vm.order,
                        details: vm.details
                    },
                    templateUrl: 'app/main/apps/order/order/receiveMerchandiseEntry/receiveMerchandiseEntry.html',
                    parent: angular.element("#main"),
                    targetEvent: ev,
                    clickOutsideToClose: false
                }).then(function (answer) {
                    $rootScope.loadingProgress = true;
                    vm.loadingLocal = true;
                    var datasToSave = new jinqJs()
                        .from(vm.details)
                        .where(function (r) {
                            return r.quantity > 0;
                        })
                        .select(function (r) {
                            delete r.maxRecibe;
                            return r;
                        });

                    datasToSave[0].filesMerchandiseEntry = answer;
                    var promise = api.ComprasWS.MerchandiseEntry.create({ idCircle: $rootScope.bsCircle.id }, datasToSave).$promise;
                    promise.then(
                        function (data) {
                            MessageService.show('ORDER.MSG.SENDED');
                            var addproducts = new jinqJs()
                                .from(datasToSave)
                                .where(function (r) {
                                    return r.addProduct === true;
                                })
                                .select(function (r) {
                                    return r;
                                });
                            if (addproducts.length > 0) {
                                $state.go('app.merchandiseEntry.view', { id: data[0].merchandiseHeader.id });
                            } else {
                                gotoOrders();
                            }
                            $rootScope.loadingProgress = false;
                            vm.loadingLocal = false;
                        },
                        function (err) {
                            MessageService.showErrorMessage('ORDER.MSG.ERR');
                            vm.loadingLocal = false;
                        }
                    );
                });
            }
        }

        function getDetails() {
            $rootScope.loadingProgress = true;
            vm.loadingLocal = true;
            api.ComprasWS.PurchaseOrderDetail.query({ idCircle: $rootScope.bsCircle.id, idPurchaseOrder: vm.order.id }, function (data) {
                vm.details = new jinqJs()
                    .from(data)
                    .orderBy([{ field: 'id', sort: 'asc' }])
                    .select(function (r) {
                        r.maxRecibe = angular.copy(r.quantity);
                        r.quantity = 0;
                        return r;
                    });

                if (vm.order.quotation) {
                    api.GeneralWS.CompanyParameterByName.get(
                        { id: $rootScope.bsCircle.company.id, parameter: 'DAYS_TO_CANCEL_PURCHASE_AFTER_DELIVERYDATE' }, function (response) {
                            if (response) {
                                vm.daysForCancelPurchase = response.parameterValue;

                                if (getDifDays(vm.order.dateDelivery) >= 0 && vm.order.purchaseStatus.description === 'Pendiente Recibir') {
                                    vm.canCancelPurchase = true;
                                }

                                for (var i = 0; i < vm.details.length; i++) {
                                    if (vm.details[i].quantityRequired !== vm.details[i].maxRecibe) {
                                        vm.canCancelPurchase = false;
                                        vm.reasignProvider = false;
                                        break;
                                    }
                                }
                            }
                        },
                        function (errResponse) {
                            $log.debug(errResponse);
                        });
                }


                if (vm.isEnterFeatures === true) {
                    var productsId = data.map(function (value, index) {
                        return value['productId'];
                    });
                    var companyId = $rootScope.bsCircle.company.id;
                    api.ActivosFijosWS.FixedAssetGroupFeature.me.getProductAddons(
                        {
                            'fixedAssetGroupFeatureId': 'getProductAddons',
                            'companyId': companyId, 'fixedAssetGroupId': 0, 'productsId': productsId.join(","), isProvider: true
                        }, function (response) {
                            response.forEach(function (productAddons) {
                                var detailFind = _.find(data, function (detail) {
                                    return detail.productId === productAddons.product.id;
                                });
                                detailFind.fixedAssetGroupId = productAddons.fixedAssetGroupId;
                                vm.details.push(detailFind);
                            });
                            vm.details = vm.details.sort(function (a, b) {
                                return a.id - b.id;
                            });
                            vm.completedAllFeatures = _.find(vm.details, function (detail) {
                                return detail.fixedAssetGroupId && !detail.completedFeatures === true;
                            }) ? false : true;
                            $rootScope.loadingProgress = false;
                        }, function (response) {
                            $rootScope.loadingProgress = false;
                            $log.error(response);
                        });
                } else {
                    $rootScope.loadingProgress = false;
                }
                loadData();

                $rootScope.loadingProgress = false;
                vm.loadingLocal = false;
            }, function (data) {
                $log.debug(data);
                $rootScope.loadingProgress = false;
                vm.loadingLocal = false;
            });
        }

        /**
         * Go to Orders page
         */
        function gotoOrders() {
            if ($stateParams.backTo) {
                $state.go($stateParams.backTo, { 'filter': $stateParams.filter });
            } else {
                $state.go('app.order.' + $stateParams.type);
            }
        }

        function merchandiseEntryDialog(ev, det) {
            var detail = angular.copy(det);

            $mdDialog.show({
                controller: 'OrderDetailMerchandiseController',
                controllerAs: 'vm',
                locals: {
                    detail: detail
                },
                templateUrl: 'app/main/apps/order/order/merchandiseEntry/merchandiseEntry.html',
                parent: angular.element("#main"),
                targetEvent: ev,
                clickOutsideToClose: false
            });
        }

        function updateProvider() {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('ORDER.MSG.UPDATE_PROVIDER'))
                .ariaLabel('add modal')
                .ok($filter('translate')('ORDER.MSG.SI'))
                .cancel($filter('translate')('ORDER.MSG.NO'));
            $mdDialog.show(confirm).then(function () {
                vm.statusToChange = {};
                vm.statusToChange.name = 'Cambio Proveedor';
                refuseBudgetedByPurchaseOrder();
            }, function () {

            });
        }

        function cancelPurchase() {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('QUOTATION.MSG.Cancelar_Compra_QUOTATION'))
                .textContent($filter('translate')('QUOTATION.MSG.CONFIRMACION_Cancelar_Compra_QUOTATION'))
                .ok($filter('translate')('QUOTATION.MSG.SI'))
                .cancel($filter('translate')('QUOTATION.MSG.NO'));

            $mdDialog.show(confirm).then(function () {
                vm.statusToChange = {};
                vm.statusToChange.name = 'Cancelar';
                refuseBudgetedByPurchaseOrder();
            }, function () {

            });
        }

        function goToChangeStatus() {
            $rootScope.loadingProgress = true;
            api.ComprasWS.PurchaseOrders.changeStatus.put(
                { 
                    idCircle: $rootScope.bsCircle.id, 
                    status: vm.statusToChange.name,
                    purchaseOrderId: vm.order.id 
                }, null).$promise.then(function (order) {
                    if (order.purchaseStatus.description === "Cambio Proveedor") {
                        MessageService.show("QUOTATION.Requisition_updated");
                        gotoOrders();
                    } else {
                        vm.order = order;
                        gotoOrders();
                    }
                    $rootScope.loadingProgress = false;
                }, function (response) {
                    $log.error(response);
                    $rootScope.loadingProgress = false;
                    MessageService.show("QUOTATION." + response.data);
                });
        }

        function notReceived(ev, det) {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('ORDER.MSG.NOT_RECEIVED'))
                .ariaLabel('add modal')
                .ok($filter('translate')('ORDER.MSG.SI'))
                .cancel($filter('translate')('ORDER.MSG.NO'));
            $mdDialog.show(confirm).then(function () {

                vm.detailsNotReceived = [det];

                var datasToSave = new jinqJs()
                    .from(vm.detailsNotReceived)
                    .select(function (r) {
                        r.quantity = r.maxRecibe;
                        delete r.maxRecibe;
                        r.received = false;
                        return r;
                    });

                var promise = api.ComprasWS.MerchandiseEntry.create({ idCircle: $rootScope.bsCircle.id }, datasToSave).$promise;
                promise.then(
                    function (data) {
                        MessageService.show('ORDER.MSG.SENDED');

                        gotoOrders();

                        $rootScope.loadingProgress = false;
                        vm.loadingLocal = false;
                    },
                    function (err) {
                        MessageService.showErrorMessage('ORDER.MSG.ERR');
                        vm.loadingLocal = false;
                    }
                );

            }, function () {

            });
        }

        function getDifDays(data) {
            var fecha1 = new Date();
            var fecha2 = new Date(data);
            fecha2.setDate(fecha2.getDate() + parseInt(vm.daysForCancelPurchase));
            var diasDif = fecha1.getTime() - fecha2.getTime();
            return Math.round(diasDif / (1000 * 60 * 60 * 24));
        }

        function refuseBudgetedByPurchaseOrder() {
            if (vm.order && vm.order.quotation) {
                api.ComprasWS.QuotationDetail.me.query(
                    { companyId: $rootScope.bsCircle.company.id, circleId: $rootScope.bsCircle.id, quotationId: vm.order.quotation.id }, function (data) {
                        vm.detailsQuotation = data.sort(function (a, b) {
                            return a.id - b.id;
                        });

                        if (vm.valideBudget) {
                            var productsToValidate = new jinqJs()
                                .from(vm.detailsQuotation)
                                .select(function (r) {
                                    return {
                                        id: r.id,
                                        product: r.requisitionDetail.product,
                                        amount: r.subTotal,
                                        unitPrice: r.price,
                                        currency: r.currency,
                                        exchangeRate: r.exchangeRate,
                                        requestAmpliation: r.requestAmpliation,
                                        references: r.references
                                    };
                                });

                            if (productsToValidate.length <= 0) {
                                MessageService.show("QUOTATION.NO_BUDGET_FOR_THIS_PRODUCT");
                                return null;
                            }

                            $rootScope.loadingProgress = true;
                            api.PresupuestosWS.Budget.revertBudgetedProducts.revertBudgeted(
                                { 'idc': $rootScope.bsCircle.id }, productsToValidate).$promise.then(function (response) {
                                    $rootScope.loadingProgress = false;
                                    vm.productsToValidate = response;
                                    goToChangeStatus();
                                }, function (response) {
                                    $rootScope.loadingProgress = false;
                                    $log.error(response);
                                });
                        } else {
                            goToChangeStatus();
                        }
                    }, function () {

                    });
            }
        }

        function validateAccessToBudget(id) {
            api.GeneralWS.CompanyApplication.byAppName.get({ company: id, app: 'Presupuestos' },
                function (data) {
                    vm.valideBudget = data.active;
                },
                function (err) {
                    vm.valideBudget = true;
                }
            );
        }

        function loadData() {
            vm.masterGridOptions.api.setColumnDefs(vm.masterColumnDefs);
            vm.masterGridOptions.api.setRowData(vm.details);
        }

        function addFeatures(detail, index, ev) {

            api.ComprasWS.PurchaseOrderDetail.getId({ 'id': detail.id, idCircle: $rootScope.bsCircle.id, idPurchaseOrder: vm.order.id }, function (data) {
                api.ActivosFijosWS.FixedAssetGroupFeature.me.getProductAddons(
                    {
                        'fixedAssetGroupFeatureId': 'getProductAddons',
                        'companyId': $rootScope.bsCircle.company.id,
                        'fixedAssetGroupId': 0, 'productsId': data.product.id, isProvider: true
                    }, function (response) {
                        response.forEach(function (productAddons) {
                            vm.detail = data;
                            vm.detail.fixedAssetGroupId = productAddons.fixedAssetGroupId;
                        });

                        $mdDialog.show({
                            controller: 'FeaturesDialogController',
                            controllerAs: 'vm',
                            templateUrl: 'app/main/apps/order/order/compose/features-dialog.html',
                            parent: angular.element("#main"),
                            targetEvent: ev,
                            detail: angular.copy(vm.detail),
                            orderId: vm.order.id,
                            clickOutsideToClose: false
                        }).then(function (quotationDetail) {
                            vm.details[index] = quotationDetail;
                            vm.completedAllFeatures = _.find(vm.details, function (detail) {
                                return detail.fixedAssetGroupId && !(detail.completedFeatures === true);
                            }) ? false : true;
                        });

                        $rootScope.loadingProgress = false;
                    }, function (response) {
                        $rootScope.loadingProgress = false;
                        $log.error(response);
                    });
            }, function (errResponse) {
                $log.debug(errResponse);
            });

        }

        function approvePurchase() {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('ORDER.APPROVE_PURCHASE'))
                .ariaLabel('add modal')
                .ok($filter('translate')('ORDER.MSG.SI'))
                .cancel($filter('translate')('ORDER.MSG.NO'));
            $mdDialog.show(confirm).then(function () {
                vm.statusToChange = {};
                vm.statusToChange.name = "Pendiente Recibir";
                goToChangeStatus();
            }, function (err) {
                $log.debug(err);
            });
        }

        function getInvoice(id) {
            $rootScope.loadingProgress = true;
            api.ComprasWS.InvoicesPurchasesDetails.byRequisition.getBy({ idCircle: $rootScope.bsCircle.id, requisitionId: id }, function (data) {
                vm.detailsInvoice = new jinqJs()
                    .from(data)
                    .orderBy([{ field: 'id', sort: 'asc' }])
                    .select(function (r) {
                        return r;
                    });
                $rootScope.loadingProgress = false;
                vm.masterGridOptionsInvoice.api.setColumnDefs(vm.masterColumnDefsInvoice);
                vm.masterGridOptionsInvoice.api.setRowData(vm.detailsInvoice);
            }, function (data) {
                $log.debug(data);
                $rootScope.loadingProgress = false;
            });
        }

        function getDateFormat(dataItem) {
            if (dataItem.purchaseOrder && dataItem.purchaseOrder.contractPurchase === null) {
                var day = 0;
                var month = 0;
                if (dataItem.purchaseOrder.createdAt.dayOfMonth < 10) {
                    day = '0' + (dataItem.purchaseOrder.createdAt.dayOfMonth);
                } else {
                    day = (dataItem.purchaseOrder.createdAt.dayOfMonth);
                }
                if (dataItem.purchaseOrder.createdAt.monthValue < 10) {
                    month = '0' + (dataItem.purchaseOrder.createdAt.monthValue);
                } else {
                    month = dataItem.purchaseOrder.createdAt.monthValue;
                }
                return new Date(dataItem.purchaseOrder.createdAt.year + "-" + month + "-" + day);
            } else if (dataItem.purchaseOrder) {
                return dataItem.purchaseOrder.dateDelivery;
            } else {
                if (dataItem.createdAt.dayOfMonth < 10) {
                    day = '0' + (dataItem.createdAt.dayOfMonth);
                } else {
                    day = (dataItem.createdAt.dayOfMonth);
                }
                if (dataItem.createdAt.monthValue < 10) {
                    month = '0' + (dataItem.createdAt.monthValue);
                } else {
                    month = dataItem.createdAt.monthValue;
                }
                return new Date(dataItem.createdAt.year + "-" + month + "-" + day);
            }

        }

        function getDimensionCompany() {
            api.GeneralWS.DimensionCompany.byCompany.getList(
                { 'company': vm.order.department.company.id }
            ).$promise.then(function (responseDimension) {
                for (let i = 0; i < responseDimension.length; i++) {
                    if (responseDimension[i].dimensionNumber === vm.NUMBER_DIMENSION_THREE) {
                        vm.dimensionCompanyDetail3 = responseDimension[i];
                    } else if (responseDimension[i].dimensionNumber === vm.NUMBER_DIMENSION_FOUR) {
                        vm.dimensionCompanyDetail4 = responseDimension[i];
                    } else if (responseDimension[i].dimensionNumber === vm.NUMBER_DIMENSION_FIVE) {
                        vm.dimensionCompanyDetail5 = responseDimension[i];
                    } else {
                        vm.dimensionCompanyDetail1 = responseDimension[i];
                    }
                }
            });
        }

    }


    function TableDetailPurchaseOrderController($scope) {
        $scope.$watch('data.quantity', function (newVal, oldVal) {
            if (!newVal && newVal !== 0) {
                $scope.data.quantity = 0;
            } else if (newVal === 0) {
                if (oldVal) {
                    $scope.vm.petition = $scope.vm.petition - oldVal;
                }
            } else {
                $scope.vm.petition = $scope.vm.petition + newVal;
            }
        });
    }
})();

(function () {
    'use strict';
    angular
        .module('app.requisition')
        .controller('PurchaseOrderReportController', PurchaseOrderReportController);

    /** @ngInject */
    function PurchaseOrderReportController($state, api, $log, $rootScope, $mdDialog, $timeout, $filter, $stateParams, MessageService) {
        var vm = this;

        vm.replaceOriginTypedata = replaceOriginTypedata;
        vm.URLPHOTOS = api.baseUrlPhotos;
        vm.viewIMG = viewIMG;
        vm.isContract = false;
        vm.canCancelPurchase = false;
        vm.cancelPurchaseOrder = $stateParams.cancelPurchase;
        vm.notRevertBudget = false;

        vm.NUMBER_DIMENSION_THREE = 3;
        vm.NUMBER_DIMENSION_FOUR = 4;
        vm.NUMBER_DIMENSION_FIVE = 5;

        vm.dimensionCompanyDetail3 = null;
        vm.dimensionCompanyDetail4 = null;
        vm.dimensionCompanyDetail5 = null;

        vm.dinamicSize = 0;

        vm.masterColumnDefs = [
            {
                headerName: 'REQUISITION.DETAIL.QUANTITY',
                field: "quantity",
                headerCellRenderer: getHeader,
                width: 100,
                enableRowGroup: true,
                cellStyle: { 'text-align': 'center' },
                enablePivot: true
            },
            {
                headerName: 'REQUISITION.DETAIL.PRODUCT',
                field: "product.name",
                headerCellRenderer: getHeader,
                width: 300,
                enableRowGroup: true,
                enablePivot: true,
                cellRenderer: function (params) {
                    if (!params.node.group) {
                        if (params.data && params.data.product.brand && params.data.product.measurementUnit) {
                            return params.value + ", " + $filter('translate')('authorize_quotations.measurement_unit')
                                + ": " + params.data.product.measurementUnit.name
                                + ", " + $filter('translate')('authorize_quotations.brand')
                                + ": " + params.data.product.brand.name;
                        } else {
                            return params.value;
                        }

                    } else {
                        return params.value;
                    }
                }
            },
            {
                headerName: 'REQUISITION.DETAIL.CONSIGNACION',
                name: "consignment",
                headerCellRenderer: getHeader,
                width: 100,
                cellRenderer: rendererConsigment,
                enableRowGroup: true,
                enablePivot: true,
                cellStyle: { 'text-align': 'center' }
            },
            {
                headerName: 'REQUISITION.DETAIL.COTIZED',
                name: "cotizated",
                headerCellRenderer: getHeader,
                cellRenderer: rendererCotized,
                enableRowGroup: true,
                enablePivot: true,
                cellStyle: { 'text-align': 'center' }
            },
            {
                headerName: 'REQUISITION.DETAIL.OBSERVATIONS',
                field: "observations",
                width: 200,
                headerCellRenderer: getHeader,
                enableRowGroup: true,
                enablePivot: true
            }
        ];


        vm.masterGridOptions = {
            columnDefs: vm.masterColumnDefs,
            enableSorting: true,
            debug: false,
            enableFilter: true,
            enableColResize: true,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowData: null,
            groupHeaders: true,
            headerHeight: 50,
            rowHeight: 40,
            rowSelection: 'multiple',
            rowDeselection: true,
            rowModelType: "enterprise",
            cacheBlockSize: vm.pageSize,
            pagination: true,
            paginationPageSize: vm.pageSize,
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            },
            doesDataFlower: function (dataItem) {
                return true;
            },
            isExternalFilterPresent: isExternalFilterPresent
        };

        var filter = 'everyone';

        function isExternalFilterPresent() {
            return filter !== '';
        }

        vm.masterColumnDefsE = [
            {
                headerName: 'CONTRACT.QUANTITY',
                field: "quantity",
                headerCellRenderer: getHeader,
                width: 100,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'CONTRACT.PRODUCT',
                field: "product.name",
                headerCellRenderer: getHeader,
                width: 350,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'CONTRACT.TOTAL',
                field: "total",
                headerCellRenderer: getHeader,
                width: 100,
                enableRowGroup: true,
                enablePivot: true,
                cellStyle: { 'text-align': 'right' },
                valueFormatter: function (params) {
                    return $filter('number')(params.value, 2);
                }
            },
            {
                headerName: 'CONTRACT.TAXESINCLUDED',
                field: "taxesIncluded",
                headerCellRenderer: getHeader,
                width: 160,
                enableRowGroup: true,
                enablePivot: true,
                cellStyle: { 'text-align': 'center' },
                cellRenderer: function (params) {
                    if (params.data.taxesIncluded) {
                        return '<md-icon md-font-icon="icon-check" class="s16"></md-icon>';
                    } else {
                        return '<md-icon md-font-icon="icon-close-circle" class="s16"></md-icon>';
                    }
                }
            }
        ];

        vm.masterGridOptionsE = {
            columnDefs: vm.masterColumnDefsE,
            enableSorting: true,
            debug: false,
            enableFilter: true,
            enableColResize: true,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowData: null,
            groupHeaders: true,
            headerHeight: 40,
            rowHeight: 40,
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            },
            doesDataFlower: function (dataItem) {
                return true;
            },
            isExternalFilterPresent: isExternalFilterPresent,
            doesExternalFilterPass: doesExternalFilterPass
        };

        vm.masterColumnDefsCuot = [
            {
                headerName: 'CONTRACT.QUANTITY',
                field: "quantityReceived",
                headerCellRenderer: getHeader,
                width: 100,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'CONTRACT.MAXDATEPURCHASE',
                field: "fecha",
                headerCellRenderer: getHeader,
                valueFormatter: function (params) {
                    return $filter('date')(params.value, 'dd/MM/yyyy');
                }
            },
            {
                headerName: 'CONTRACT.DETAIL.OBSERVATIONS',
                field: "observations",
                headerCellRenderer: getHeader,
                width: 300,
                enableRowGroup: true,
                enablePivot: true,
                cellRenderer: function (params) {
                    if (params.data.taxesIncluded) {
                        return '{{\'INVOICE_MERCHANDISE_ENTRY.PAYMENTS\'| translate}}';
                    } else {
                        return '{{\'INVOICE_MERCHANDISE_ENTRY.PAYMENTS\'| translate}} {{data.noPayment}} -  {{data.invoiced==true?\'Facturado\':\'Pendiente de Facturar\'}}';
                    }
                }
            },
            {
                headerName: 'CONTRACT.BY_CREATED',
                field: "createdBy",
                headerCellRenderer: getHeader,
                width: 160,
                enableRowGroup: true,
                enablePivot: true,
                cellStyle: { 'text-align': 'center' }
            }
        ];

        vm.masterGridOptionsCuot = {
            columnDefs: vm.masterColumnDefsCuot,
            enableSorting: true,
            debug: false,
            enableFilter: true,
            enableColResize: true,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowData: null,
            groupHeaders: true,
            headerHeight: 50,
            rowHeight: 45,
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            },
            doesDataFlower: function (dataItem) {
                dataItem.fecha = getDateFormat(dataItem);
                return true;
            },
            isExternalFilterPresent: isExternalFilterPresent,
            doesExternalFilterPass: doesExternalFilterPass
        };

        vm.masterColumnDefsQuotation = [
            {
                headerName: 'QUOTATION.QUOTATION',
                field: "quotationDescription",
                headerCellRenderer: getHeader,
                width: 150,
                rowGroupIndex: 0,
                hide: true
            },
            {
                headerName: 'REQUISITION.DETAIL.QUANTITY',
                field: "requisitionDetail.quantity",
                headerCellRenderer: getHeader,
                width: 100,
                enableRowGroup: true,
                cellStyle: { 'text-align': 'center' },
                enablePivot: true
            },
            {
                headerName: 'REQUISITION.DETAIL.PRODUCT',
                field: "requisitionDetail.product.name",
                headerCellRenderer: getHeader,
                width: 200,
                enableRowGroup: true,
                enablePivot: true,
                cellRenderer: function (params) {
                    if (!params.node.group) {
                        if (params.data && params.data.requisitionDetail.product.brand && params.data.requisitionDetail.product.measurementUnit) {
                            return params.value
                                + ", " + $filter('translate')('authorize_quotations.measurement_unit')
                                + ": " + params.data.requisitionDetail.product.measurementUnit.name
                                + ", " + $filter('translate')('authorize_quotations.brand')
                                + ": " + params.data.requisitionDetail.product.brand.name;
                        } else {
                            return params.value;
                        }

                    } else {
                        return params.value;
                    }
                }
            },
            {
                headerName: 'QUOTATION.DETAIL.PRICE',
                field: "price",
                headerCellRenderer: getHeader,
                width: 150,
                enableRowGroup: true,
                enablePivot: true,
                cellStyle: { 'text-align': 'right' },
                valueFormatter: function (params) {
                    return $filter('number')(params.value, 2);
                }
            },
            {
                headerName: 'QUOTATION.TOTAL',
                field: "subTotal",
                headerCellRenderer: getHeader,
                enableRowGroup: true,
                enablePivot: true,
                cellStyle: { 'text-align': 'right' },
                valueFormatter: function (params) {
                    return $filter('number')(params.value, 2);
                }
            },
            {
                headerName: 'QUOTATION.DETAIL.OBSERVATIONS',
                field: "observations",
                width: 200,
                headerCellRenderer: getHeader,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'CONTRACT.BY_CREATED',
                field: "createdBy",
                headerCellRenderer: getHeader,
                width: 160,
                enableRowGroup: true,
                enablePivot: true,
                cellStyle: { 'text-align': 'center' }
            }
        ];


        vm.masterGridOptionsQuotation = {
            columnDefs: vm.masterColumnDefsQuotation,
            enableSorting: true,
            debug: false,
            enableFilter: true,
            enableColResize: true,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowData: null,
            groupHeaders: true,
            headerHeight: 50,
            rowHeight: 45,
            groupUseEntireRow: true,
            animateRows: true,
            groupDefaultExpanded: 1,
            doesDataFlower: function (dataItem) {
                dataItem.quotationDescription = "Cotizacion N. " + dataItem.quotation.id;
            },
            isExternalFilterPresent: isExternalFilterPresent,
            doesExternalFilterPass: doesExternalFilterPass,
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            }
        };

        function doesExternalFilterPass(node) {
            if (filter && filter !== 'everyone') {
                var arrdt = node.data.filter.split(filter.toLowerCase());
                return arrdt.length > 1;
            }
            return true;
        }

        vm.masterColumnDefsPurchaseOrder = [
            {
                headerName: 'ORDER.ORDER',
                field: "orderDescription",
                headerCellRenderer: getHeader,
                width: 150,
                rowGroupIndex: 0,
                hide: true
            },
            {
                headerName: 'REQUISITION.DETAIL.QUANTITY',
                field: "quantityRequired",
                headerCellRenderer: getHeader,
                width: 100,
                enableRowGroup: true,
                cellStyle: { 'text-align': 'center' },
                enablePivot: true
            },
            {
                headerName: 'REQUISITION.DETAIL.PRODUCT',
                field: "productName",
                headerCellRenderer: getHeader,
                width: 250,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'QUOTATION.DETAIL.PRICE',
                field: "price",
                headerCellRenderer: getHeader,
                width: 150,
                enableRowGroup: true,
                enablePivot: true,
                cellStyle: { 'text-align': 'right' },
                valueFormatter: function (params) {
                    return $filter('number')(params.value, 2);
                }
            },
            {
                headerName: 'ORDER.DETAIL.RECIBIDO',
                field: "maxRecibe",
                headerCellRenderer: getHeader,
                width: 150,
                enableRowGroup: true,
                cellStyle: { 'text-align': 'center' },
                enablePivot: true
            },
            {
                headerName: 'ORDER.DETAIL.PENDIENTE',
                field: "pending",
                headerCellRenderer: getHeader,
                width: 150,
                enableRowGroup: true,
                cellStyle: { 'text-align': 'center' },
                enablePivot: true
            }
        ];


        vm.masterGridOptionsPurchaseOrder = {
            columnDefs: vm.masterColumnDefsPurchaseOrder,
            enableSorting: true,
            debug: false,
            enableFilter: true,
            enableColResize: true,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowData: null,
            headerHeight: 50,
            rowHeight: 45,
            groupUseEntireRow: true,
            animateRows: true,
            groupDefaultExpanded: 1,
            doesDataFlower: function (dataItem) {
                dataItem.pending = dataItem.quantityRequired - dataItem.maxRecibe;
                dataItem.orderDescription = "Orden de Compra No."
                    + dataItem.purchaseOrder.id + " {{'CONTRACT.BY_CREATED' | translate}} "
                    + dataItem.purchaseOrder.createdBy + " El " + $filter('date')(getDateFormat(dataItem), 'dd/MM/yyyy');
            },
            isExternalFilterPresent: isExternalFilterPresent,
            doesExternalFilterPass: doesExternalFilterPass,
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            }
        };

        vm.masterColumnDefsInvoice = [
            {
                headerName: 'INVOICE.INVOICE',
                field: "invoiceDescription",
                headerCellRenderer: getHeader,
                width: 150,
                rowGroupIndex: 0,
                hide: true
            },
            {
                headerName: 'INVOICE.PRODUCT.PRODUCT',
                field: "product.name",
                headerCellRenderer: getHeader,
                width: 250,
                enableRowGroup: true,
                enablePivot: true,
                cellRenderer: function (paramsProd) {
                    if (!paramsProd.node.group) {
                        if (paramsProd.data && paramsProd.data.product.brand && paramsProd.data.product.measurementUnit) {
                            return paramsProd.value + ", " + $filter('translate')('authorize_quotations.measurement_unit')
                                + ": " + paramsProd.data.product.measurementUnit.name + ", " + $filter('translate')('authorize_quotations.brand') + ": "
                                + paramsProd.data.product.brand.name;
                        } else {
                            return paramsProd.value;
                        }

                    } else {
                        return paramsProd.value;
                    }
                }
            },
            {
                headerName: 'INVOICE.DEPARTMENT',
                field: "merchandiseEntry.purchaseOrderDetail.purchaseOrder.department.description",
                headerCellRenderer: getHeader,
                width: 200,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'INVOICE.COST_CENTER',
                field: "merchandiseEntry.purchaseOrderDetail.purchaseOrder.costCenter.description",
                headerCellRenderer: getHeader,
                width: 200,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'INVOICE.INVOICE_PURCHASE.ELECTRONIC_SIGNATURE',
                field: "invoicePurchase.electronicSignature",
                headerCellRenderer: getHeader,
                width: 160,
                enableRowGroup: true,
                enablePivot: true,
                cellStyle: { 'text-align': 'center' }
            },
            {
                headerName: 'INVOICE.INVOICE_PURCHASE.DETAIL.QUANTITY',
                field: "quantity",
                headerCellRenderer: getHeader,
                width: 100,
                enableRowGroup: true,
                enablePivot: true,
                cellStyle: { 'text-align': 'center' }
            },
            {
                headerName: 'INVOICE.INVOICE_PURCHASE.DETAIL.UNIT_PRICE_AFTER_TAX',
                field: "priceAfterTax",
                headerCellRenderer: getHeader,
                width: 100,
                suppressSorting: true,
                suppressMenu: true,
                cellStyle: { 'text-align': 'right' },
                valueFormatter: function (params) {
                    return $filter('number')(params.value, 2);
                }
            },
            {
                headerName: 'INVOICE.INVOICE_PURCHASE.DETAIL.TOTAL_AFTER_TAX',
                field: "subTotalAfterTax",
                headerCellRenderer: getHeader,
                width: 100,
                suppressSorting: true,
                suppressMenu: true,
                cellStyle: { 'text-align': 'right' },
                valueFormatter: function (params) {
                    return $filter('number')(params.value, 2);
                }
            }
        ];


        vm.masterGridOptionsInvoice = {
            columnDefs: vm.masterColumnDefsInvoice,
            enableSorting: true,
            debug: false,
            enableFilter: true,
            enableColResize: true,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowData: null,
            headerHeight: 50,
            rowHeight: 45,
            groupUseEntireRow: true,
            animateRows: true,
            groupDefaultExpanded: 1,
            doesDataFlower: function (dataItem) {
                var resp = ' ';
                var ref = '';
                dataItem.invoicePurchase.files.forEach(function (file, index, arr) {
                    ref = ref + '<a ng-click="vm.viewIMG(' + file.id + ')">Ver Imagen ' + (index + 1) + '</a> ';
                });
                dataItem.invoiceDescription = "Factura SERIE " +
                    (dataItem.invoicePurchase.invoiceSerie ?
                        dataItem.invoicePurchase.invoiceSerie.serie :
                        dataItem.invoicePurchase.uuid.substring(0, 8))
                    + " Correlativo No. " + dataItem.invoicePurchase.correlative + " {{'CONTRACT.BY_CREATED' | translate}} "
                    + dataItem.invoicePurchase.createdBy + " El " + $filter('date')(getDateFormat(dataItem), 'dd/MM/yyyy') + '' + resp + ref + '';
                return false;
            },
            isExternalFilterPresent: isExternalFilterPresent,
            doesExternalFilterPass: doesExternalFilterPass,
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            },
            groupRowInnerRenderer: function (params) {
                return params.value;
            }
        };

        // Methods
        vm.getRequisition = getRequisition;

        init();

        function init() {
            vm.dinamicSize = $(window).innerHeight();
        }

        function getRequisition(id) {
            vm.requisition = {};
            vm.canCancelPurchase = false;
            api.ComprasWS.PurchaseOrder.get({ idCircle: $rootScope.bsCircle.id, id: id, type: 'P' }, function (data) {
                vm.order = data;
                validateAccessToBudget(data.company.id);
                if (data.quotation && data.quotation.requisition) {
                    vm.isContract = false;
                    getRequisitionById(data.quotation.requisition.id);
                    vm.contractPurchase = {};

                } else if (data.contractPurchase) {
                    vm.isContract = true;
                    vm.requisition = {};

                    getContractById(data.contractPurchase.id);
                }
                getDimensionCompany();

            });

        }

        function getRequisitionById(id, ot) {
            if (id) {
                $rootScope.loadingProgress = true;
                api.ComprasWS.RequisitionPendingAuthorize.getBy({ idCircle: $rootScope.bsCircle.id, id: id }, function (data) {

                    if (!data.id) {
                        MessageService.showErrorMessage('REQUISITION.NOX_EXIST');
                        $rootScope.loadingProgress = false;
                        return false;
                    }

                    if (data.originType && data.originType.originTypeCode === '01') {
                        vm.requisitionFromOtherOrigin = true;
                    }

                    data.department.id = data.department.id.toString();
                    data.costCenter.id = data.costCenter.id.toString();

                    if (data.departmentFirsRecept) {
                        data.departmentFirsRecept.id = data.departmentFirsRecept.id.toString();
                    }

                    var ff = data.maxDatePurchase.split("-");
                    var maxDatePurchase = new Date(ff[0], (parseInt(ff[1]) - 1), ff[2]);

                    api.ComprasWS.ProcessFlow.get({ id: data.id, type: 1 }, function (data) {
                        vm.infoProcessFlow = data;
                    });

                    $timeout(function () {
                        vm.requisition = data;
                        getQuotation(vm.requisition.id);
                        getPurchaseOrder(vm.requisition.id);
                        getInvoice(vm.requisition.id);

                        $timeout(function () {
                            data.maxDatePurchase = maxDatePurchase;
                            $rootScope.loadingProgress = false;
                            getDetails();

                        });
                    });
                }, function (err) {
                    MessageService.showErrorMessage('REQUISITION.NOX_EXIST');
                    $rootScope.loadingProgress = false;
                });
                return true;
            } else {
                return true;
            }
        }

        function getContractById(id, ot) {
            var isLocal = id ? true : false;
            id = id ? id : $stateParams.id;
            if (id) {
                $rootScope.loadingProgress = true;
                api.ComprasWS.ContractByNumber.getBy({ idCircle: $rootScope.bsCircle.id, id: id }, function (data) {

                    if (!data.id) {
                        MessageService.showErrorMessage('CONTRACT.NOX_EXIST');
                        $rootScope.loadingProgress = false;
                        return false;
                    }

                    api.ComprasWS.ContractMerchandiseEntryHeader.get({ idCircle: $rootScope.bsCircle.id, id: '', contractId: id }, function (response) {
                        vm.details = response;
                        vm.masterGridOptionsCuot.api.setRowData(vm.details);
                    }, function (errResponse) {
                        $log.debug(errResponse);
                    });

                    var ff = data.dateDelivery.split("-");
                    var dateDelivery = new Date(ff[0], (parseInt(ff[1]) - 1), ff[2]);

                    data.dateDelivery = new Date();

                    vm.contractPurchase = data;
                    $timeout(function () {
                        data.dateDelivery = dateDelivery;
                        $rootScope.loadingProgress = false;
                        if (ot) {
                            $timeout(function () {

                            }, 200);
                        }

                        if (vm.contractPurchase.id) {
                            getPurchaseOrder(vm.contractPurchase.id);
                            getInvoice(vm.contractPurchase.id);
                        }
                    });

                    api.ComprasWS.ContractDetail.getContractPurchase(
                        { idCircle: $rootScope.bsCircle.id, id: 'getByContractPurchase', contractId: vm.contractPurchase.id }, function (detailContract) {
                            vm.detailsContract = new jinqJs()
                                .from(detailContract)
                                .select(function (r) {
                                    var d = r;
                                    d.filter = (d.product.name + "," + d.total + "," + d.taxesIncluded).toLowerCase();
                                    return d;
                                });
                            vm.masterGridOptionsE.api.setRowData(vm.detailsContract);

                        }, function (errResponse) {
                        });
                    if (!isLocal) {
                        vm.currentTab = 0;
                    }

                    vm.showProcessFlow = true;
                    api.ComprasWS.ProcessFlow.get({ id: data.id, type: 5 }, function (data) {
                        vm.infoProcessFlow = data;
                    });


                });
            } else {
                vm.allowEdit = true;
                vm.editHeader = true;
            }
        }

        function getDetails() {
            $rootScope.loadingProgress = true;
            api.ComprasWS.RequisitionDetail.query({ idCircle: $rootScope.bsCircle.id, idRequisition: vm.requisition.id }, function (data) {
                vm.details = new jinqJs()
                    .from(data)
                    .orderBy([{ field: 'id', sort: 'asc' }])
                    .select(function (r) {
                        return r;
                    });
                $rootScope.loadingProgress = false;

                vm.masterGridOptions.api.setColumnDefs(vm.masterColumnDefs);
                vm.dataSource = {
                    paginationPageSize: vm.pageSize,
                    getRows: function (params) {
                        vm.loading = false;
                        $rootScope.loadingProgress = false;
                        params.successCallback(vm.details, vm.details.length);
                    }
                };
                vm.masterGridOptions.api.setEnterpriseDatasource(vm.dataSource);

                api.GeneralWS.CompanyParameterByName.get(
                    { id: $rootScope.bsCircle.company.id, parameter: 'DAYS_TO_CANCEL_PURCHASE_AFTER_DELIVERYDATE' }, function (response) {
                        if (response) {
                            vm.daysForCancelPurchase = response.parameterValue;
                            if (getDifDays(vm.order.dateDelivery) >= 0 && (vm.order.purchaseStatus.description === 'Pendiente Recibir'
                                || vm.order.purchaseStatus.description === 'Primera Recepcion')) {
                                for (var i = 0; i < $rootScope.bsCircle.role.roleSpecialActions.length; i++) {
                                    if ($rootScope.bsCircle.role.roleSpecialActions[i].specialAction.actionName === 'Cancelar Compra') {
                                        vm.canCancelPurchase = true;
                                        vm.quantityDays = getDifDays(vm.order.dateDelivery);
                                    }
                                }
                            }
                        }
                    }, function (errResponse) {
                        $log.debug(errResponse);
                    });


            }, function (data) {
                $log.debug(data);
                $rootScope.loadingProgress = false;
            });


        }

        function rendererConsigment(params) {
            var toRet = '<div style="width: 100%;">';

            toRet = toRet + '<div>'
                + '                         <md-icon md-font-icon="{{data.consignment ? \'icon-check\' : \'icon-close\'}}"></md-icon>'
                + '                                 </div>';

            return toRet + '</div>';
        }

        function rendererCotized(params) {
            var toRet = '<div style="width: 100%;">';

            toRet = toRet + '<div>'
                + '                          <md-icon md-font-icon="{{data.cotizated ? \'icon-check\' : \'icon-close\'}}"></md-icon>'
                + '                                 </div>';

            return toRet + '</div>';
        }

        function getQuotation(id) {
            $rootScope.loadingProgress = true;
            vm.quotations = [];
            api.ComprasWS.Quotation.byRequisition.getBy({ companyId: $rootScope.bsCircle.company.id, id: id }, function (data) {
                vm.quotationsDetails = new jinqJs()
                    .from(data)
                    .orderBy([{ field: 'id', sort: 'asc' }])
                    .select(function (r) {
                        return r;
                    });
                if (vm.masterGridOptionsQuotation && vm.masterGridOptionsQuotation.api) {
                    vm.masterGridOptionsQuotation.api.setColumnDefs(vm.masterColumnDefsQuotation);
                    vm.masterGridOptionsQuotation.api.setRowData(vm.quotationsDetails);
                }
            }, function (err) {
                vm.quotationsDetails = [];
            });
            if (vm.masterGridOptionsQuotation && vm.masterGridOptionsQuotation.api) {
                vm.masterGridOptionsQuotation.api.setColumnDefs(vm.masterColumnDefsQuotation);
            }
        }

        function getPurchaseOrder(id) {
            $rootScope.loadingProgress = true;
            var promise;

            if (vm.isContract) {
                promise = api.ComprasWS.PurchaseByContract.getBy({ idCircle: $rootScope.bsCircle.id, idPurchaseOrder: 1, contractId: id }).$promise;
            } else {
                promise = api.ComprasWS.PurchaseByRequisition.getBy({ idCircle: $rootScope.bsCircle.id, idPurchaseOrder: 1, requisitionId: id }).$promise;
            }

            promise.then(function (data) {
                var isDoubleReceipt = false;
                vm.detailsPurchaseOrder = new jinqJs()
                    .from(data)
                    .orderBy([{ field: 'id', sort: 'asc' }])
                    .select(function (r) {
                        r.maxRecibe = angular.copy(r.quantity);
                        r.quantity = 0;
                        isDoubleReceipt = r.receivedDouble;
                        return r;
                    });

                if (data.length > 0
                    && data[0].purchaseOrder && data[0].purchaseOrder.purchaseStatus.description === 'Pendiente Recibir'
                    && isDoubleReceipt && !vm.isContract) {
                    vm.notRevertBudget = true;
                }
                $rootScope.loadingProgress = false;
                vm.masterGridOptionsPurchaseOrder.api.setColumnDefs(vm.masterColumnDefsPurchaseOrder);
                vm.masterGridOptionsPurchaseOrder.api.setRowData(vm.detailsPurchaseOrder);
            }, function (data) {
                $log.debug(data);
                $rootScope.loadingProgress = false;
                vm.detailsPurchaseOrder = [];
            });
        }

        function getInvoice(id) {
            $rootScope.loadingProgress = true;
            var promise;

            if (vm.isContract) {
                promise = api.ComprasWS.InvoicesPurchasesDetails.byContract.getBy({ idCircle: $rootScope.bsCircle.id, contractId: id }).$promise;
            } else {

                promise = api.ComprasWS.InvoicesPurchasesDetails.byRequisition.getBy({ idCircle: $rootScope.bsCircle.id, requisitionId: id }).$promise;

            }
            promise.then(function (data) {
                vm.detailsInvoice = new jinqJs()
                    .from(data)
                    .orderBy([{ field: 'id', sort: 'asc' }])
                    .select(function (r) {
                        return r;
                    });
                $rootScope.loadingProgress = false;
                if (vm.masterGridOptionsInvoice && vm.masterGridOptionsInvoice.api) {
                    vm.masterGridOptionsInvoice.api.setColumnDefs(vm.masterColumnDefsInvoice);
                    vm.masterGridOptionsInvoice.api.setRowData(vm.detailsInvoice);
                }
            }, function (data) {
                $log.debug(data);
                $rootScope.loadingProgress = false;
            });
        }

        function getDateFormat(dataItem) {
            if (dataItem.purchaseOrder && dataItem.purchaseOrder.contractPurchase === null) {
                var day = 0;
                var month = 0;
                if (dataItem.purchaseOrder.createdAt.dayOfMonth < 10) {
                    day = '0' + (dataItem.purchaseOrder.createdAt.dayOfMonth);
                } else {
                    day = (dataItem.purchaseOrder.createdAt.dayOfMonth);
                }
                if (dataItem.purchaseOrder.createdAt.monthValue < 10) {
                    month = '0' + (dataItem.purchaseOrder.createdAt.monthValue);
                } else {
                    month = dataItem.purchaseOrder.createdAt.monthValue;
                }
                return new Date(dataItem.purchaseOrder.createdAt.year + "-" + month + "-" + day);
            } else if (dataItem.purchaseOrder) {
                return dataItem.purchaseOrder.dateDelivery;
            } else {
                if (dataItem.createdAt.dayOfMonth < 10) {
                    day = '0' + (dataItem.createdAt.dayOfMonth);
                } else {
                    day = (dataItem.createdAt.dayOfMonth);
                }
                if (dataItem.createdAt.monthValue < 10) {
                    month = '0' + (dataItem.createdAt.monthValue);
                } else {
                    month = dataItem.createdAt.monthValue;
                }
                return new Date(dataItem.createdAt.year + "-" + month + "-" + day);
            }

        }

        function viewIMG(id) {
            vm.detailsInvoice.forEach(function (data) {
                data.invoicePurchase.files.forEach(function (file) {
                    if (id === file.id) {
                        $mdDialog.show({
                            controller: 'DialogPhotoController',
                            controllerAs: 'vm',
                            templateUrl: 'app/main/apps/files/dialogPhoto/dialogPhoto.html',
                            parent: angular.element("#main"),
                            name: file.originalName,
                            url: vm.URLPHOTOS + file.parentPath + file.name + file.extension,
                            clickOutsideToClose: false
                        }).then(function (answer) {

                        });
                    }
                });
            });

        }

        function getDifDays(data) {
            var fecha1 = new Date();
            var fecha2 = new Date(data);
            fecha2.setDate(fecha2.getDate() + parseInt(vm.daysForCancelPurchase));
            var diasDif = fecha1.getTime() - fecha2.getTime();
            var dias = Math.round(diasDif / (1000 * 60 * 60 * 24));
            return dias - 1;
        }

        vm.cancelPurchase = function (ev) {
            var confirm = $mdDialog.prompt()
                .title($filter('translate')('QUOTATION.MSG.Cancelar_Compra_QUOTATION'))
                .textContent($filter('translate')('QUOTATION.MSG.CONFIRMACION_Cancelar_Compra_QUOTATION'))
                .placeholder($filter('translate')('ORDER.REASON'))
                .ariaLabel("cancel")
                .initialValue(vm.reason)
                .targetEvent(ev)
                .ok($filter('translate')('QUOTATION.MSG.SI'))
                .cancel($filter('translate')('QUOTATION.MSG.NO'));

            $mdDialog.show(confirm).then(function (dat) {
                if (!dat) {
                    MessageService.showErrorMessage('ORDER.INSERT_REASON');
                    return false;
                } else {
                    vm.reason = dat;
                }
                vm.statusToChange = {};
                vm.statusToChange.name = 'Compra Cancelada';
                refuseBudgetedByPurchaseOrder();
            }, function () {

            });
        };

        function refuseBudgetedByPurchaseOrder() {
            if (vm.order && vm.order.quotation) {
                api.ComprasWS.PurchaseOrderDetail.query({ idCircle: $rootScope.bsCircle.id, idPurchaseOrder: vm.order.id }, function (data) {
                    api.ComprasWS.MerchandiseByPurchaseOrder.byPurchaseOrder.get(
                        { "idCircle": $rootScope.bsCircle.id, "purchaseOrderId": vm.order.id }, function (response) {
                            vm.merchandiseEntriesR = response;
                            vm.detailsQuotation = data.sort(function (a, b) {
                                return a.id - b.id;
                            });

                            if (vm.valideBudget && !vm.notRevertBudget
                                && vm.detailsQuotation.length > 0) {
                                var productsToValidate = new jinqJs()
                                    .from(vm.detailsQuotation)
                                    .select(function (r) {
                                        return {
                                            id: r.quotationDetailId,
                                            product: { id: r.productId },
                                            unitPrice: r.price,
                                            references: r.references,
                                            amount: (r.quantity * r.price)
                                        };
                                    });

                                if (productsToValidate.length <= 0) {
                                    MessageService.show("QUOTATION.NO_BUDGET_FOR_THIS_PRODUCT");
                                    return null;
                                }

                                $rootScope.loadingProgress = true;
                                api.PresupuestosWS.Budget.revertBudgetedProducts.revertBudgeted(
                                    { 'idc': $rootScope.bsCircle.id }, productsToValidate).$promise.then(function (response) {
                                        $rootScope.loadingProgress = false;
                                        vm.productsToValidate = response;
                                        goToChangeStatus();
                                    }, function (response) {
                                        $rootScope.loadingProgress = false;
                                        $log.error(response);
                                    });
                            } else {
                                goToChangeStatus();
                            }
                        }, function (errResponse) {

                        });



                }, function () {

                });
            }
        }

        function goToChangeStatus() {
            $rootScope.loadingProgress = true;
            api.ComprasWS.PurchaseOrders.changeStatus.put(
                {
                    idCircle: $rootScope.bsCircle.id,
                    status: vm.statusToChange.name,
                    'reason': vm.reason,
                    purchaseOrderId: vm.order.id
                }, null).$promise.then(function (order) {
                    if (order.purchaseStatus.description === "Cambio Proveedor") {
                        MessageService.show("QUOTATION.Requisition_updated");
                        gotoOrders();
                    } else {
                        vm.order = order;
                        if (vm.order.purchaseStatus.description === 'Recibido') {
                            MessageService.show('ORDER.purchase_order_received');
                        } else {
                            MessageService.show("QUOTATION.Requisition_updated");
                        }
                        gotoOrders();
                    }
                    $rootScope.loadingProgress = false;
                }, function (response) {
                    $log.error(response);
                    $rootScope.loadingProgress = false;
                    MessageService.show("QUOTATION." + response.data);
                });
        }

        function gotoOrders() {
            if ($stateParams.backTo) {
                $state.go($stateParams.backTo, { 'filter': $stateParams.filter });
            } else if ($stateParams.type) {
                $state.go('app.order.' + $stateParams.type);
            } else {
                location.reload(true);
            }
        }

        function validateAccessToBudget(id) {
            api.GeneralWS.CompanyApplication.byAppName.get({ company: id, app: 'Presupuestos' },
                function (data) {
                    vm.valideBudget = data.active;
                },
                function (err) {
                    vm.valideBudget = true;
                }
            );
        }

        function getDimensionCompany() {
            api.GeneralWS.DimensionCompany.byCompany.getList(
              { 'company': vm.order.department.company.id }
            ).$promise.then(function (responseDimension) {
              for (let i = 0; i < responseDimension.length; i++) {
                if (responseDimension[i].dimensionNumber === vm.NUMBER_DIMENSION_THREE) {
                  vm.dimensionCompanyDetail3 = responseDimension[i];
                } else if (responseDimension[i].dimensionNumber === vm.NUMBER_DIMENSION_FOUR) {
                  vm.dimensionCompanyDetail4 = responseDimension[i];
                } else if (responseDimension[i].dimensionNumber === vm.NUMBER_DIMENSION_FIVE) {
                  vm.dimensionCompanyDetail5 = responseDimension[i];
                } else {
                  vm.dimensionCompanyDetail1 = responseDimension[i];
                }
              }
            });
          }

    }
})();

(function () {
  "use strict";
  angular
    .module("app.order")
    .controller("OrderController", OrderController)
    .controller(
      "TableDetailPurchaseOrderController",
      TableDetailPurchaseOrderController
    );

  /** @ngInject */
  function OrderController(
    $state,
    api,
    $log,
    $rootScope,
    $mdDialog,
    $stateParams,
    $filter,
    MessageService,
    $timeout
  ) {
    var vm = this;

    vm.petition = 0;
    vm.petitionInvoice = 0;
    vm.minDate = new Date();
    vm.updateProvider = updateProvider;
    vm.notReceived = notReceived;
    vm.cancelPurchase = cancelPurchase;
    vm.addFeatures = addFeatures;
    vm.daysForCancelPurchase = 0;
    vm.canCancelPurchase = false;
    vm.isEnterFeatures =
      $stateParams.type === "PIC" ||
      $stateParams.type === "C" ||
      $stateParams.type === "P";
    vm.PIC = $stateParams.type === "PIC";
    vm.approvePurchase = approvePurchase;
    vm.type = $stateParams.type;

    vm.selectAll = false;
    vm.selectAllShipping = false;
    vm.selectAllReceive = false;
    vm.existCanInvoiceBefore = false;
    vm.reasignProvider = false;
    vm.notRevertBudget = false;
    vm.purchaseOrderDetailToInvoice = [];

    vm.NUMBER_DIMENSION_THREE = 3;
    vm.NUMBER_DIMENSION_FOUR = 4;
    vm.NUMBER_DIMENSION_FIVE = 5;

    vm.dimensionCompanyDetail3 = null;
    vm.dimensionCompanyDetail4 = null;
    vm.dimensionCompanyDetail5 = null;

    vm.two_hundred = 200;

    vm.dinamicSize = 0;

    if ($stateParams.id === "") {
      $state.go("app.order." + $stateParams.status);
    }

    vm.dtOptions = {
      responsive: true,
      paging: false,
      searching: false,
      columnDefs: getColumnDefs()
    };
    vm.dtOptions2 = {
      responsive: true,
      paging: false,
      searching: false,
      columnDefs: getColumnDefs()
    };
    vm.newStatus = "";
    // Methods
    vm.gotoOrders = gotoOrders;
    vm.saveEntries = saveEntries;
    vm.saveShippingOrder = saveShippingOrder;
    vm.getDetails = getDetails;
    vm.merchandiseEntryDialog = merchandiseEntryDialog;
    vm.shippingOrderViewDialog = shippingOrderViewDialog;
    vm.notFileMerchandise = false;
    vm.notFileMerchandiseToInvoice = false;
    vm.addToInvoice = addToInvoice;
    vm.invoicePurchaseOrderDetail = invoicePurchaseOrderDetail;
    vm.selectAllDetail = selectAllDetail;
    vm.selectAllShippingDetail = selectAllShippingDetail;
    vm.selectAllToReceive = selectAllToReceive;
    vm.addToShipping = addToShipping;
    vm.addToReceive = addToReceive;

    vm.masterColumnDefs = [
      {
        headerName: "#",
        name: "no",
        width: 50,
        cellStyle: { "text-align": "center" },
        cellRenderer: function (params) {
          return params.rowIndex + 1;
        },
        sort: "asc"
      },
      {
        headerName: "ORDER.DETAIL.PRODUCT",
        field: "productName",
        headerCellRenderer: getHeader,
        width: 250,
        enableRowGroup: true,
        enablePivot: true
      },
      {
        headerName: "ORDER.DETAIL.PRICE",
        name: "price",
        headerCellRenderer: getHeader,
        width: 150,
        enableRowGroup: true,
        enablePivot: true,
        cellStyle: { "text-align": "right" },
        cellRenderer: function (params) {
          return $filter("number")(params.data.price, 6);
        }
      },
      {
        headerName: "ORDER.DETAIL.QUANTITY",
        name: "quantity",
        headerCellRenderer: getHeader,
        width: 200,
        enableRowGroup: true,
        enablePivot: true,
        cellStyle: { "text-align": "center" },
        cellRenderer: function (params) {
          return $filter("number")(params.data.quantityRequired, 2);
        }
      },
      {
        headerName: "ORDER.DETAIL.PENDIENTE",
        name: "pending",
        headerCellRenderer: getHeader,
        width: 150,
        enableRowGroup: true,
        enablePivot: true,
        cellStyle: { "text-align": "center" },
        cellRenderer: function (params) {
          if (params.data.completed) {
            return '<md-icon md-font-icon="icon-check"></md-icon>';
          } else {
            return $filter("number")(params.data.maxRecibe, 2);
          }
        }
      },
      {
        headerName: "ORDER.ACTIONS",
        name: "actions",
        headerCellRenderer: getHeader,
        suppressSorting: true,
        suppressMenu: true,
        width: 150,
        cellRenderer: function (params) {
          var resp =
            '<md-button class="edit-button md-icon-button"' +
            '                                                                                    ng-if="data.quantityRequired > data.maxRecibe"' +
            '                                                            ng-click="vm.merchandiseEntryDialog($event, data)"' +
            '                                                            aria-label="Product details"' +
            '                                                            translate translate-attr-aria-label="REQUISITION.PRODUCT_DETAILS">' +
            '                                                     <md-icon md-font-icon="icon-eye" class="s16"></md-icon>' +
            '                                                     <md-tooltip md-direction="bottom">' +
            '                                                         {{"ORDER.DETAIL.VIEW"| translate}}' +
            "                                                     </md-tooltip>" +
            "                                                 </md-button>";
          if ($stateParams.type === "C" || $stateParams.type === "PR") {
            resp =
              resp +
              '<md-button class="edit-button md-icon-button"' +
              '            ng-if="data.maxRecibe > 0 &&  vm.canCancelPurchase"' +
              '        ng-click="vm.notReceived($event, data)"' +
              '        aria-label="Product details"' +
              '        translate translate-attr-aria-label="REQUISITION.PRODUCT_DETAILS">' +
              ' <md-icon md-font-icon="icon-close" class="s16"></md-icon>' +
              '                             <md-tooltip md-direction="bottom">' +
              '     {{"ORDER.DETAIL.NOT_RECEIVED"| translate}}' +
              "                             </md-tooltip>" +
              " </md-button>";
          }

          if (
            $stateParams.type === "PIC" ||
            $stateParams.type === "P" ||
            $stateParams.type === "C"
          ) {
            resp =
              resp +
              '<md-button class="edit-button md-icon-button" ng-if="data.fixedAssetGroupId"' +
              '                ng-click="vm.addFeatures(data, $index, $event)"' +
              '        aria-label="Product details"' +
              '        translate translate-attr-aria-label="REQUISITION.PRODUCT_DETAILS">' +
              ' <md-icon md-font-icon="icon-border-color" class="s16"></md-icon> ' +
              '                             <md-tooltip md-direction="left">{{"QUOTATION.DETAIL.FEATURES.EDIT"| translate}}</md-tooltip>' +
              ' </md-button>' +
              '<md-button class="edit-button md-icon-button" ng-if="data.amountShipping>0"' +
              '                ng-click="vm.shippingOrderViewDialog($eventev,data)"' +
              '        aria-label="Product details"' +
              '        translate translate-attr-aria-label="REQUISITION.SHIPPING_VIEW">' +
              ' <md-icon md-font-icon="icon-file-find" class="s16"></md-icon> ' +
              '                             <md-tooltip md-direction="left">{{"ORDER.SHIPPING_ORDER.VIEW_SHIPPING"| translate}}</md-tooltip>' +
              ' </md-button>';
          }

          return resp;
        },
        cellStyle: { padding: "0px" },
        pinned: "right"
      }
    ];

    if ($stateParams.type === "C" || $stateParams.type === "PR") {
      vm.masterColumnDefs.splice(5, 0, {
        headerName: "ORDER.DETAIL.RECIBIR",
        name: "recibir",
        headerCellRenderer: getHeader,
        width: 200,
        enableRowGroup: true,
        enablePivot: true,
        cellRenderer: function (params) {
          return (
            '<div ng-if="!data.completed && data.maxRecibe > 0" ' +
            'style="background-color: rgba(134, 244, 54, 0.37);" ng-controller="TableDetailPurchaseOrderController">' +
            " <md-input-container>" +
            " <label></label>" +
            ' <input ng-disabled="data.onlyReceivePOS" ng-model="data.quantity" type="number" max="{{data.maxRecibe}}" min="0" ' +
            ' step="0.01" ng-model-options="{\'debounce\': 300}">' +
            "                         </md-input-container>" +
            "                         </td>" +
            "                         <div>"
          );
        }
      });
      vm.masterColumnDefs.splice(0, 0, {
        headerName: '',
        name: 'id',
        headerCellRenderer: getHeaderCellRendererToReceive(),
        width: 50,
        pinned: 'left',
        suppressSorting: true,
        suppressMenu: true,
        cellRendererParams: {
          checkbox: true
        },
        cellRenderer: getCellRendererToReceive()
      });
    }
    if ($stateParams.type === "P") {
      vm.masterColumnDefs.splice(5, 0, {
        headerName: "ORDER.DETAIL.ENVIAR",
        name: "enviar",
        headerCellRenderer: getHeader,
        width: 200,
        enableRowGroup: true,
        enablePivot: true,
        cellRenderer: function (params) {
          return (
            '<div ng-if="!data.completed && data.maxRecibe > 0 && data.consignment" ' +
            'style="background-color: rgba(134, 244, 54, 0.37);" ng-controller="TableDetailPurchaseOrderController">' +
            " <md-input-container>" +
            " <label></label>" +
            ' <input ng-model="data.quantity" type="number" max="{{data.maxRecibe}}" min="0" step="0.01" ng-model-options="{\'debounce\': 300}">' +
            "                         </md-input-container>" +
            "                         </td>" +
            "                         <div>"
          );
        }
      });
      vm.masterColumnDefs.splice(0, 0, {
        headerName: "",
        name: "id",
        headerCellRenderer: function () {
          return (
            '<div layout="row" layout-align="center center" style="padding-left: 0.6em" ng-if="vm.existCanInvoiceBefore">' +
            '   <md-checkbox ng-model="vm.selectAll" ng-change="vm.selectAllDetail()" aria-label="selectAll">' +
            '   </md-checkbox>' +
            '   <md-tooltip md-direction="top">{{"ORDER.SELECT_ALL"| translate}}</md-tooltip>' +
            '</div>'+
          '<div layout="row" layout-align="center center" style="padding-left: 0.6em" ng-if="vm.existCanShipping">' +
          '   <md-checkbox ng-model="vm.selectAllShipping" ng-change="vm.selectAllShippingDetail()" aria-label="selectAll">' +
          '   </md-checkbox>' +
          '   <md-tooltip md-direction="top">{{"ORDER.SELECT_ALL"| translate}}</md-tooltip>' +
          '</div>'
          );
        },
        width: 50,
        pinned: "left",
        suppressSorting: true,
        suppressMenu: true,
        cellRendererParams: {
          checkbox: true
        },
        cellRenderer: function (params) {
          return (
            '<div ng-if="!data.completed && data.maxRecibe > 0 && data.consignment" layout="row" layout-align="center center">' +
            ' <md-checkbox ng-model="data.toShipping" ng-click="vm.addToShipping(data)" aria-label="selectDetail"></md-checkbox>' +
            '                         </div>' +
            '<div ng-if="data.providerCanInvoiceBeforeReceive" layout="row" layout-align="center center">' +
            ' <md-checkbox ng-model="data.toInvoice" ng-click="vm.addToInvoice(data)" aria-label="selectDetail"></md-checkbox>' +
            '                         </div>'
          );

        }
      });
      vm.masterColumnDefs.splice(6, 0, {
        headerName: "ORDER.DETAIL.FACTURAR",
        name: "id",
        headerCellRenderer: getHeader,
        width: 200,
        cellRenderer: function (params) {
          return (
            '<div ng-if="data.providerCanInvoiceBeforeReceive && data.toInvoice" layout="row" layout-align="center center" ' +
            'style="background-color: rgba(134, 244, 54, 0.37);" ng-controller="TableDetailPurchaseOrderController">' +
            " <md-input-container>" +
            " <label></label>" +
            ' <input ng-model="data.quantityInvoice" type="number" step="0.01" max="{{data.maxInvoice}}" min="0" ng-model-options="{\'debounce\': 300}">' +
            "                         </md-input-container>" +
            "                         </div>"
          );

        }
      });
    }

    vm.masterGridOptions = {
      columnDefs: vm.masterColumnDefs,
      enableSorting: true,
      debug: false,
      enableFilter: true,
      enableColResize: true,
      angularCompileRows: true,
      angularCompileHeaders: true,
      rowData: null,
      groupHeaders: true,
      headerHeight: 50,
      rowHeight: 45,
      rowSelection: 'multiple',
      getMainMenuItems: function (params) {
        return getHeaderMenu(params, $filter);
      },
      localeTextFunc: function (key, defaultValue) {
        return translateGrid(key, defaultValue, $filter);
      },
      doesDataFlower: function (dataItem) {
        return true;
      },
      isExternalFilterPresent: isExternalFilterPresent,
      doesExternalFilterPass: doesExternalFilterPass
    };

    // Data
    var filter = "everyone";

    function isExternalFilterPresent() {
      // if ageType is not everyone, then we are filtering
      return filter !== "";
    }

    function doesExternalFilterPass(node) {
      if (filter && filter !== "everyone") {
        var arrdt = node.data.filter.split(filter);
        return arrdt.length > 1;
      }
      return true;
    }
    //////////

    init();
    /**
     * Initialize
     */
    function init() {
      vm.dinamicSize = $(window).innerHeight();
      $rootScope.loadingProgress = true;
      var type;
      if (!$stateParams.isClient && $stateParams.type) {
        type =
          $stateParams.type === "PIC" || $stateParams.type === "PR"
            ? "P"
            : $stateParams.type;
      } else {
        type = $stateParams.isClient ? "C" : "P";
      }
      api.ComprasWS.PurchaseOrder.get(
        { idCircle: $rootScope.bsCircle.id, id: $stateParams.id, type: type },
        function (data) {
          vm.order = data;
          $rootScope.loadingProgress = false;
          getDetails();

          validateAccessToBudget(data.company.id);
          for (
            var i = 0;
            i < $rootScope.bsCircle.role.roleSpecialActions.length;
            i++
          ) {
            if (
              $rootScope.bsCircle.role.roleSpecialActions[i].specialAction
                .actionName === "Reasignar Proveedor" &&
              vm.order.purchaseStatus.description === "Pendiente Recibir"
            ) {
              if (vm.order.quotation) {
                if (vm.order.quotation.requisition) {
                  if (vm.order.quotation.requisition.receivedDouble) {
                    vm.reasignProvider = false;
                    vm.notFileMerchandise = true;
                    break;
                  } else {
                    vm.reasignProvider = true;
                    break;
                  }
                } else {
                  vm.reasignProvider = true;
                  break;
                }
              } else {
                vm.reasignProvider = true;
                break;
              }
            }
          }

          vm.showProcessFlow = false;
          if ($stateParams.filter && !$stateParams.filter.isProvider) {
            vm.showProcessFlow = true;
            api.ComprasWS.ProcessFlow.get({ id: data.id, type: 3 }, function (
              data
            ) {
              vm.infoProcessFlow = data;
            });
          }
          getDimensionCompany();
        });
    }

    function getColumnDefs() {
      return [
        {
          targets: 0,
          width: "72px"
        },
        {
          targets: 1,
          responsivePriority: 1,
          render: function (data, type) {
            return "<p>" + data + "</p>";
          },
          width: "300px"
        },
        {
          targets: 2,
          responsivePriority: 3,
          width: "100px"
        },
        {
          targets: 3,
          responsivePriority: 2,
          width: "100px"
        },
        {
          targets: 4,
          responsivePriority: 2,
          width: "100px"
        }
      ];
    }

    function invoicePurchaseOrderDetail(event) {
      vm.entryToInvoice = true;
      vm.notFileMerchandiseToInvoice = true;
      saveEntries(event);
    }

    function selectAllDetail() {
      vm.purchaseOrderDetailToInvoice = [];
      vm.petitionInvoice = 0;
      if (vm.selectAll) {
        var confirm = $mdDialog
          .confirm()
          .title($filter("translate")("ORDER.MSG.INVOICE_ALL_ITEM"))
          .ariaLabel("invoice modal")
          .ok($filter("translate")("ORDER.MSG.SI"))
          .cancel($filter("translate")("ORDER.MSG.NO"));
        $mdDialog.show(confirm).then(
          function () {
            verifyItemInvoice();
          }, function () {
            vm.selectAll = false;
            verifyItemInvoice();
          });
      } else {
        verifyItemInvoice();
      }
    }


    function selectAllShippingDetail() {
      vm.shipp = [];
      vm.petitionInvoice = 0;
      if (vm.selectAllShipping) {
        var confirm = $mdDialog
          .confirm()
          .title($filter("translate")("ORDER.MSG.SHIPPING_ALL_ITEM"))
          .ariaLabel("invoice modal")
          .ok($filter("translate")("ORDER.MSG.SI"))
          .cancel($filter("translate")("ORDER.MSG.NO"));
        $mdDialog.show(confirm).then(
          function () {
            verifyItemShipping();
          }, function () {
            vm.selectAllShipping = false;
            verifyItemShipping();
          });
      } else {
        verifyItemShipping();
      }
    }

    function selectAllToReceive() {
      vm.purchaseOrderDetailToReceive = [];
      vm.petitionInvoice = 0;
      if (vm.selectAllReceive) {
        const confirm = $mdDialog
          .confirm()
          .title($filter('translate')('ORDER.MSG.RECEIVE_ALL_ITEM'))
          .ariaLabel('received modal')
          .ok($filter('translate')('ORDER.MSG.SI'))
          .cancel($filter('translate')('ORDER.MSG.NO'));
        $mdDialog.show(confirm).then(
          function () {
            verifyItemToReceive();
          }, function () {
            vm.selectAllReceive = false;
            vm.petition = 0;
            verifyItemToReceive();
          });
      } else {
        verifyItemToReceive();
      }
    }

    function verifyItemInvoice(){
      vm.details
        .filter(function (detail) {
          return detail.providerCanInvoiceBeforeReceive;
        })
        .forEach(function (detail) {
          detail.toInvoice = vm.selectAll;
          if (vm.selectAll) {
            getQuantityInvoiced(detail);
            detail.quantityInvoice = detail.maxInvoice;
            vm.purchaseOrderDetailToInvoice.push(detail);
            vm.petitionInvoice += detail.quantityInvoice;
          } else {
            detail.quantityInvoice = 0;
          }
        });
    }

    function verifyItemShipping(){
      vm.details
        .forEach(function (detail) {
          detail.toShipping = vm.selectAllShipping;
          if (vm.selectAllShipping) {
            detail.quantity = detail.maxRecibe;
            vm.petition += detail.quantity;
          } else {
            detail.quantity = 0;
          }
        });
    }

    function verifyItemToReceive(){
      vm.details
        .forEach(function (detail) {
          detail.toReceive = vm.selectAllReceive;
          if (vm.selectAllReceive && !detail.onlyReceivePOS) {
            detail.quantity = detail.maxRecibe;
            vm.petition += detail.quantity;
          } else {
            vm.petition -= detail.quantity;
            detail.quantity = 0;
          }
        });
    }

    function saveEntries(e, ev) {
      var datasToSave = new jinqJs()
        .from(vm.details)
        .where(function (r) {
          if (vm.entryToInvoice) {
            return (r.quantityInvoice && r.quantityInvoice > 0);
          } else {
            return (r.quantity > 0);
          }
        })
        .select(function (r) {
          delete r.maxRecibe;
          return r;
        });

      if (datasToSave.length <= 0) {
        return;
      }

      if (vm.notFileMerchandise || vm.notFileMerchandiseToInvoice) {
        var confirm = $mdDialog
          .confirm()
          .title(vm.notFileMerchandiseToInvoice ? $filter("translate")("ORDER.MSG.SURE_SEND_TO_INVOICE") : $filter("translate")("ORDER.MSG.SURE_SEND"))
          .ariaLabel("add modal")
          .ok($filter("translate")("ORDER.MSG.SI"))
          .cancel($filter("translate")("ORDER.MSG.NO"));
        $mdDialog.show(confirm).then(
          function () {
            if (vm.entryToInvoice) {
              datasToSave = new jinqJs()
                .from(vm.details)
                .where(function (r) {
                  return (r.quantityInvoice && r.quantityInvoice > 0);
                })
                .select(function (r) {
                  if (r.quantityInvoice && r.quantityInvoice > 0) {
                    r.quantity = angular.copy(r.quantityInvoice);

                  }
                  delete r.quantityInvoice;
                  delete r.toInvoice;
                  return r;
                })
            }

            if (datasToSave.length <= 0) {
              return;
            }
            var promise = api.ComprasWS.MerchandiseEntry.create(
              { idCircle: $rootScope.bsCircle.id, entryToInvoice: vm.entryToInvoice },
              datasToSave
            ).$promise;
            promise.then(
              function (data) {
                MessageService.show("ORDER.MSG.SENDED");
                var addproducts = new jinqJs()
                  .from(datasToSave)
                  .where(function (r) {
                    return r.addProduct === true;
                  })
                  .select(function (r) {
                    return r;
                  });
                if (addproducts.length > 0) {
                  var confirm = $mdDialog
                    .confirm()
                    .title($filter("translate")("ORDER.MSG.ADD_PRODUCTS"))
                    .ariaLabel("add modal")
                    .targetEvent(e)
                    .ok($filter("translate")("ORDER.MSG.SI"))
                    .cancel($filter("translate")("ORDER.MSG.NO"));
                  $mdDialog.show(confirm).then(
                    function () {
                      $state.go("app.merchandiseEntry.view", {
                        id: data[0].merchandiseHeader.id
                      });
                    },
                    function () {
                      if (vm.entryToInvoice) {
                        var detail = "";
                        for (var i = 0; i < data.length; i++) {
                          detail = detail + "," + data[i].id;
                        }
                        $state.go('app.invoice.Ingresando.detail', { detail: detail.substring(1) });
                      } else {
                        gotoOrders();
                      }
                    }
                  );
                } else {
                  if (vm.entryToInvoice) {
                    var detail = "";
                    for (var i = 0; i < data.length; i++) {
                      detail = detail + "," + data[i].id;
                    }
                    $state.go('app.invoice.Ingresando.detail', { detail: detail.substring(1) });
                  } else {
                    gotoOrders();
                  }
                }
                $rootScope.loadingProgress = false;
                vm.loadingLocal = false;
              },
              function (err) {
                MessageService.showErrorMessage("ORDER.MSG.ERR");
                vm.loadingLocal = false;
                vm.petitionInvoice = 0;
                init();
              }
            );
          },
          function () {
            vm.petitionInvoice = 0;
            vm.purchaseOrderDetailToInvoice = [];
            init();
          }
        );
      } else {
        $mdDialog
          .show({
            controller: "receiveMerchandiseEntryController",
            controllerAs: "vm",
            locals: {
              order: vm.order,
              details: vm.details
            },
            templateUrl:
              "app/main/apps/order/order/receiveMerchandiseEntry/receiveMerchandiseEntry.html",
            parent: angular.element("#main"),
            targetEvent: ev,
            clickOutsideToClose: false
          })
          .then(function (answer) {
            $rootScope.loadingProgress = true;
            vm.loadingLocal = true;
            var datasToSave = new jinqJs()
              .from(vm.details)
              .where(function (r) {
                return r.quantity > 0;
              })
              .select(function (r) {
                delete r.maxRecibe;
                return r;
              });

            datasToSave[0].filesMerchandiseEntry = answer;
            var promise = api.ComprasWS.MerchandiseEntry.create(
              { idCircle: $rootScope.bsCircle.id, entryToInvoice: vm.entryToInvoice },
              datasToSave
            ).$promise;
            promise.then(
              function (data) {
                MessageService.show("ORDER.MSG.SENDED");
                var addproducts = new jinqJs()
                  .from(datasToSave)
                  .where(function (r) {
                    return r.addProduct === true;
                  })
                  .select(function (r) {
                    return r;
                  });
                if (addproducts.length > 0) {
                  $state.go("app.merchandiseEntry.view", {
                    id: data[0].merchandiseHeader.id
                  });
                } else {
                  if (vm.entryToInvoice) {
                    var detail = "";
                    for (var i = 0; i < data.length; i++) {
                      detail = detail + "," + data[i].id;
                    }
                    $state.go('app.invoice.Ingresando.detail', { detail: detail.substring(1) });
                  } else {
                    gotoOrders();
                  }
                }
                $rootScope.loadingProgress = false;
                vm.loadingLocal = false;
              },
              function (err) {
                MessageService.showErrorMessage("ORDER.MSG.ERR");
                vm.loadingLocal = false;
                init();
              }
            );
          }, function (){
            new jinqJs()
              .from(vm.details)
              .where(function (r) {
                r.maxRecibe = r.quantity;
              })
              .select(function (r) {
                return r;
              });
          });
      }
    }

    function saveShippingOrder(ev) {
      var confirm = $mdDialog
        .confirm()
        .title($filter("translate")("ORDER.SHIPPING_ORDER.SHIPPING_ORDER_SEND"))
        .ariaLabel("add modal")
        .ok($filter("translate")("ORDER.MSG.SI"))
        .cancel($filter("translate")("ORDER.MSG.NO"));
      $mdDialog.show(confirm).then(
        function () {
          var datasToSave = new jinqJs()
            .from(vm.details)
            .where(function (r) {
              return r.quantity > 0;
            })
            .select(function (r) {
              delete r.maxRecibe;
              return { purchaseOrderDetailId: r.id, amountShipping: r.quantity };
            });

          if (datasToSave.length <= 0) {
            return;
          }
          var promise = api.ComprasWS.ShippingOrderDetail.create(
            { idCircle: $rootScope.bsCircle.id, purchaseOrderId: $stateParams.id },
            datasToSave
          ).$promise;
          promise.then(
            function (data) {
              MessageService.show("ORDER.SHIPPING_ORDER.SHIPPING_ORDER_SENDED");

              gotoOrders();
              $rootScope.loadingProgress = false;
              vm.loadingLocal = false;
            },
            function (err) {
              MessageService.showErrorMessage("ORDER.MSG.ERR");
              vm.loadingLocal = false;
            }
          );
        },
        function () { }
      );

    }

    function getDetails() {
      $rootScope.loadingProgress = true;
      vm.loadingLocal = true;
      api.ComprasWS.PurchaseOrderDetail.query(
        { idCircle: $rootScope.bsCircle.id, idPurchaseOrder: vm.order.id },
        function (data) {


          var isDoubleReceipt = false;

          // processData(data);

          vm.details = new jinqJs()
            .from(data)
            .orderBy([{ field: "id", sort: "asc" }])
            .select(function (r) {
              r.maxRecibe = angular.copy(r.quantity);
              r.maxInvoice = angular.copy(r.quantity);
              if (vm.type === 'P') {
                r.maxRecibe = angular.copy(r.quantity - r.amountShipping);
              }
              r.quantity = 0;
              r.quantityInvoice = 0;
              isDoubleReceipt = r.receivedDouble;
              verifyCanInvoiceBeforeReceive(r);
              return r;
            });


          if ($stateParams.type === "C" && isDoubleReceipt) {
            vm.notRevertBudget = true;
          }

          if (vm.order.quotation) {
            api.GeneralWS.CompanyParameterByName.get(
              {
                id: $rootScope.bsCircle.company.id,
                parameter: "DAYS_TO_CANCEL_PURCHASE_AFTER_DELIVERYDATE"
              },
              function (response) {
                if (response) {
                  vm.daysForCancelPurchase = response.parameterValue;
                  if (
                    getDifDays(vm.order.dateDelivery) >= 0 &&
                    (vm.order.purchaseStatus.description ===
                      "Pendiente Recibir" ||
                      vm.order.purchaseStatus.description ===
                      "Primera Recepcion")
                  ) {
                    for (
                      var i = 0;
                      i < $rootScope.bsCircle.role.roleSpecialActions.length;
                      i++
                    ) {
                      if (
                        $rootScope.bsCircle.role.roleSpecialActions[i]
                          .specialAction.actionName === "Cancelar Compra"
                      ) {
                        vm.canCancelPurchase = true;
                        vm.quantityDays = getDifDays(vm.order.dateDelivery);
                      }
                    }
                  }
                }
              },
              function (errResponse) {
                $log.debug(errResponse);
              }
            );
          }

          if (vm.isEnterFeatures === true) {
            var productsId = data.map(function (value, index) {
              return value["productId"];
            });
            var companyId = $rootScope.bsCircle.company.id;
            api.ActivosFijosWS.FixedAssetGroupFeature.me.getProductAddons(
              {
                fixedAssetGroupFeatureId: "getProductAddons",
                companyId: companyId,
                fixedAssetGroupId: 0,
                productsId: productsId.join(","),
                isProvider: true
              },
              function (response) {
                if (response.length > 0) {
                  vm.details = [];
                }
                response.forEach(function (productAddons) {
                  var detailFind = _.find(data, function (detail) {
                    return detail.productId === productAddons.product.id;
                  });
                  detailFind.fixedAssetGroupId =
                    productAddons.fixedAssetGroupId;
                  vm.details.push(detailFind);
                });
                vm.details = vm.details.sort(function (a, b) {
                  return a.id - b.id;
                });
                vm.completedAllFeatures = _.find(vm.details, function (detail) {
                  return (
                    detail.fixedAssetGroupId &&
                    !detail.completedFeatures === true
                  );
                })
                  ? false
                  : true;
                $rootScope.loadingProgress = false;
              },
              function (response) {
                $rootScope.loadingProgress = false;
                $log.error(response);
              }
            );
          } else {
            $rootScope.loadingProgress = false;
          }
          loadData();

          $rootScope.loadingProgress = false;
          vm.loadingLocal = false;
        },
        function (data) {
          $log.debug(data);
          $rootScope.loadingProgress = false;
          vm.loadingLocal = false;
        }
      );
    }

    /**
     * Go to Orders page
     */
    function gotoOrders() {
      if ($stateParams.backTo) {
        $state.go($stateParams.backTo, { filter: $stateParams.filter });
      } else if ($stateParams.type) {
        $state.go("app.order." + $stateParams.type);
      } else {
        location.reload(true);
      }
    }

    function merchandiseEntryDialog(ev, det) {
      var detail = angular.copy(det);

      $mdDialog.show({
        controller: "OrderDetailMerchandiseController",
        controllerAs: "vm",
        locals: {
          detail: detail
        },
        templateUrl:
          "app/main/apps/order/order/merchandiseEntry/merchandiseEntry.html",
        parent: angular.element("#main"),
        targetEvent: ev,
        multiple: true,
        clickOutsideToClose: false
      }).then(function (resp) {
        getDetails();
      }, function (err) {
        getDetails();
      });
    }

    function shippingOrderViewDialog(ev, det) {
      var detail = angular.copy(det);

      $mdDialog.show({
        controller: "ShippingOrderViewController",
        controllerAs: "vm",
        locals: {
          id: detail.id
        },
        templateUrl:
          "app/main/apps/order/order/shippingOrderView/shippingOrderView.html",
        parent: angular.element("#main"),
        targetEvent: ev,
        clickOutsideToClose: false,
        multiple: true
      }).then(function (resp) {
        init();
      }, function (err) {
        init();
      });
    }

    function updateProvider() {
      var confirm = $mdDialog
        .confirm()
        .title($filter("translate")("ORDER.MSG.UPDATE_PROVIDER"))
        .ariaLabel("add modal")
        .ok($filter("translate")("ORDER.MSG.SI"))
        .cancel($filter("translate")("ORDER.MSG.NO"));
      $mdDialog.show(confirm).then(
        function () {
          vm.statusToChange = {};
          vm.statusToChange.name = "Cambio Proveedor";
          refuseBudgetedByPurchaseOrder();
        },
        function () { }
      );
    }

    function cancelPurchase(ev) {
      var confirm = $mdDialog
        .prompt()
        .title($filter("translate")("QUOTATION.MSG.Cancelar_Compra_QUOTATION"))
        .textContent(
          $filter("translate")(
            "QUOTATION.MSG.CONFIRMACION_Cancelar_Compra_QUOTATION"
          )
        )
        .placeholder($filter("translate")("ORDER.REASON"))
        .ariaLabel("cancel")
        .initialValue(vm.reason)
        .targetEvent(ev)
        .ok($filter("translate")("QUOTATION.MSG.SI"))
        .cancel($filter("translate")("QUOTATION.MSG.NO"));

      $mdDialog.show(confirm).then(
        function (dat) {
          if (!dat) {
            MessageService.showErrorMessage("ORDER.INSERT_REASON");
            return false;
          } else {
            vm.reason = dat;
          }
          vm.statusToChange = {};
          vm.statusToChange.name = "Compra Cancelada";
          refuseBudgetedByPurchaseOrder();
        },
        function () { }
      );
    }

    function goToChangeStatus() {
      $rootScope.loadingProgress = true;
      api.ComprasWS.PurchaseOrders.changeStatus.put(
        {
          idCircle: $rootScope.bsCircle.id,
          status: vm.statusToChange.name,
          reason: vm.reason,
          purchaseOrderId: vm.order.id
        },
        null
      ).$promise.then(
        function (order) {
          if (order.purchaseStatus.description === "Cambio Proveedor") {
            MessageService.show("QUOTATION.Requisition_updated");
            gotoOrders();
          } else {
            vm.order = order;
            gotoOrders();
          }
          $rootScope.loadingProgress = false;
        },
        function (response) {
          $log.error(response);
          $rootScope.loadingProgress = false;
          MessageService.show("QUOTATION." + response.data);
        }
      );
    }

    function notReceived(ev, det) {
      var confirm = $mdDialog
        .confirm()
        .title($filter("translate")("ORDER.MSG.NOT_RECEIVED"))
        .ariaLabel("add modal")
        .ok($filter("translate")("ORDER.MSG.SI"))
        .cancel($filter("translate")("ORDER.MSG.NO"));
      $mdDialog.show(confirm).then(
        function () {
          vm.detailsNotReceived = [det];

          var datasToSave = new jinqJs()
            .from(vm.detailsNotReceived)
            .select(function (r) {
              r.quantity = r.maxRecibe;
              delete r.maxRecibe;
              r.received = false;
              return r;
            });

          var promise = api.ComprasWS.MerchandiseEntry.create(
            { idCircle: $rootScope.bsCircle.id },
            datasToSave
          ).$promise;
          promise.then(
            function (data) {
              if (vm.valideBudget && !vm.notRevertBudget) {
                var productsToValidate = new jinqJs()
                  .from(data)
                  .select(function (r) {
                    return {
                      id: r.purchaseOrderDetail.quotationDetail.id,
                      product:
                      r.purchaseOrderDetail.quotationDetail.requisitionDetail
                        .product,
                      amount:
                        r.quantity *
                        (r.purchaseOrderDetail.subTotal /
                          r.purchaseOrderDetail.quantity),
                      unitPrice: r.purchaseOrderDetail.price,
                      currency: r.purchaseOrderDetail.currency,
                      exchangeRate:
                      r.purchaseOrderDetail.exchangeRateCompanyBuyer,
                      requestAmpliation: false,
                      references: r.references
                    };
                  });

                if (productsToValidate.length <= 0) {
                  MessageService.show("QUOTATION.NO_BUDGET_FOR_THIS_PRODUCT");
                  return null;
                }

                $rootScope.loadingProgress = true;
                api.PresupuestosWS.Budget.revertBudgetedProducts
                  .revertBudgeted(
                    { idc: $rootScope.bsCircle.id },
                    productsToValidate
                  )
                  .$promise.then(
                  function (response) {
                    $rootScope.loadingProgress = false;
                    vm.productsToValidate = response;
                    MessageService.show("ORDER.MSG.SENDED");
                    gotoOrders();
                  },
                  function (response) {
                    $rootScope.loadingProgress = false;
                    $log.error(response);
                  }
                );
              } else {
                gotoOrders();
              }

              $rootScope.loadingProgress = false;
              vm.loadingLocal = false;
            },
            function (err) {
              MessageService.showErrorMessage("ORDER.MSG.ERR");
              vm.loadingLocal = false;
            }
          );
        },
        function () { }
      );
    }

    function getDifDays(data) {
      var fecha1 = new Date();
      var fecha2 = new Date(data);
      fecha2.setDate(fecha2.getDate() + parseInt(vm.daysForCancelPurchase));
      var diasDif = fecha1.getTime() - fecha2.getTime();
      var dias = Math.round(diasDif / (1000 * 60 * 60 * 24));
      return dias - 1;
    }

    function refuseBudgetedByPurchaseOrder() {
      if (vm.order && vm.order.quotation) {
        api.ComprasWS.PurchaseOrderDetail.query(
          { idCircle: $rootScope.bsCircle.id, idPurchaseOrder: vm.order.id },
          function (data) {
            api.ComprasWS.MerchandiseByPurchaseOrder.byPurchaseOrder.get(
              {
                idCircle: $rootScope.bsCircle.id,
                purchaseOrderId: vm.order.id
              },
              function (response) {
                vm.merchandiseEntriesR = response;
                vm.detailsQuotation = data.sort(function (a, b) {
                  return a.id - b.id;
                });

                if (vm.valideBudget && !vm.notRevertBudget
                  && vm.detailsQuotation.length>0) {
                  var productsToValidate = new jinqJs()
                    .from(vm.detailsQuotation)
                    .select(function (r) {
                      var row = {
                        id: r.quotationDetailId,
                        product: { id: r.productId },
                        unitPrice: r.price,
                        references: r.references,
                        amount: r.quantity * r.price
                      };
                      return row;
                    });

                  if (productsToValidate.length <= 0) {
                    MessageService.show("QUOTATION.NO_BUDGET_FOR_THIS_PRODUCT");
                    return null;
                  }

                  $rootScope.loadingProgress = true;
                  api.PresupuestosWS.Budget.revertBudgetedProducts
                    .revertBudgeted(
                      { idc: $rootScope.bsCircle.id },
                      productsToValidate
                    )
                    .$promise.then(
                    function (response) {
                      $rootScope.loadingProgress = false;
                      vm.productsToValidate = response;
                      goToChangeStatus();
                    },
                    function (response) {
                      $rootScope.loadingProgress = false;
                      $log.error(response);
                    }
                  );
                } else {
                  goToChangeStatus();
                }
              },
              function (errResponse) { }
            );
          },
          function () { }
        );
      }
    }

    function validateAccessToBudget(id) {
      api.GeneralWS.CompanyApplication.byAppName.get(
        { company: id, app: "Presupuestos" },
        function (data) {
          vm.valideBudget = data.active;
        },
        function (err) {
          vm.valideBudget = true;
        }
      );
    }

    function loadData() {
      vm.masterGridOptions.api.setColumnDefs(vm.masterColumnDefs);
      setTimeout(function () {
        loadHeaderProviderCanInvoiceBefore();
        loadHeaderProviderCanShipping();
        vm.masterGridOptions.api.setRowData(vm.details);
      }, 300);
    }

    function loadHeaderProviderCanInvoiceBefore() {
      vm.existCanInvoiceBefore = vm.details
        .filter(function (detail) {
          return detail.providerCanInvoiceBeforeReceive;
        }).length > 0;
    }

    function loadHeaderProviderCanShipping() {
      vm.existCanShipping = vm.details
        .filter(function (data) {
          return data.consignment && data.amountShipping < data.quantityRequired;
        }).length > 0;
    }

    function addFeatures(detail, index, ev) {
      api.ComprasWS.PurchaseOrderDetail.getId(
        {
          id: detail.id,
          idCircle: $rootScope.bsCircle.id,
          idPurchaseOrder: vm.order.id
        },
        function (data) {
          api.ActivosFijosWS.FixedAssetGroupFeature.me.getProductAddons(
            {
              fixedAssetGroupFeatureId: "getProductAddons",
              companyId: $rootScope.bsCircle.company.id,
              fixedAssetGroupId: 0,
              productsId: data.product.id,
              isProvider: true
            },
            function (response) {
              response.forEach(function (productAddons) {
                vm.detail = data;
                vm.detail.fixedAssetGroupId = productAddons.fixedAssetGroupId;
              });

              $mdDialog
                .show({
                  controller: "FeaturesDialogController",
                  controllerAs: "vm",
                  templateUrl:
                    "app/main/apps/order/order/compose/features-dialog.html",
                  parent: angular.element("#main"),
                  targetEvent: ev,
                  detail: angular.copy(vm.detail),
                  orderId: vm.order.id,
                  clickOutsideToClose: false
                })
                .then(function (quotationDetail) {
                  getDetails();
                });

              $rootScope.loadingProgress = false;
            },
            function (response) {
              $rootScope.loadingProgress = false;
              $log.error(response);
            }
          );
        },
        function (errResponse) {
          $log.debug(errResponse);
        }
      );
    }

    function approvePurchase() {
      var confirm = $mdDialog
        .confirm()
        .title($filter("translate")("ORDER.APPROVE_PURCHASE"))
        .ariaLabel("add modal")
        .ok($filter("translate")("ORDER.MSG.SI"))
        .cancel($filter("translate")("ORDER.MSG.NO"));

      if (!vm.completedAllFeatures) {
        confirm = $mdDialog
          .confirm()
          .title($filter("translate")("ORDER.APPROVE_PURCHASE"))
          .textContent($filter("translate")("ORDER.CAN_ADDFEATURES"))
          .ariaLabel("add modal")
          .ok($filter("translate")("ORDER.MSG.SI"))
          .cancel($filter("translate")("ORDER.MSG.NO"));
      }

      $mdDialog.show(confirm).then(
        function () {
          vm.statusToChange = {};
          vm.statusToChange.name = "Pendiente Recibir";
          goToChangeStatus();
        },
        function (err) {
          $log.debug(err);
        }
      );
    }

    function verifyCanInvoiceBeforeReceive(r) {
      return new Promise(function (resolve, reject) {
        api.ComprasWS
          .verifyCanInvoiceBeforeReceive.get({ id: r.id, idPurchaseOrder: vm.order.id }).$promise.then(function (response) {
          if (response && response.id) {
            r.providerCanInvoiceBeforeReceive = true;
            resolve(r);
          } else {
            r.providerCanInvoiceBeforeReceive = false;
            resolve(r);
          }

        }, function (err) {
          reject(err);
        });
      });
    }

    function getQuantityInvoiced(r) {
      return new Promise(function (resolve, reject) {
        api.ComprasWS
          .getQuantityInvoiced.get({ purchaseOrderDetailId: r.id, idPurchaseOrder: vm.order.id }).$promise.then(function (response) {
          if (response && response > 0) {
            r.maxInvoice = r.maxInvoice - response;
          }
          resolve(r);
        }, function (err) {
          reject(err);
        });
      });
    }

    function addToInvoice(data) {
      $timeout(function () {
        if (data.toInvoice) {
          getQuantityInvoiced(data);
          vm.purchaseOrderDetailToInvoice.push(data);
        } else {
          vm.petitionInvoice -= data.quantityInvoice;
          data.quantityInvoice=0;
          for (i = 0; i < vm.purchaseOrderDetailToInvoice.length; i++) {
            if (vm.purchaseOrderDetailToInvoice[i].id === data.id) {
              vm.purchaseOrderDetailToInvoice.splice(i, 1);
            }
          }
          vm.selectAll = false;
        }
        $timeout(function () {
          vm.purchaseOrderDetailToInvoice = angular.copy(vm.purchaseOrderDetailToInvoice);
        }, 100);
      }, 200);
    }

    function addToShipping(data) {
      $timeout(function () {
        if (data.toShipping) {
          data.quantity = data.maxRecibe;
          vm.petition += data.quantity;
        } else {
          vm.petition -= data.quantity;
          data.quantity = 0;
          vm.selectAllShipping = false;
        }
      }, 200);
    }

    function addToReceive(data) {
      $timeout(function () {
        if (data.toReceive) {
          data.quantity = data.maxRecibe;
          vm.petition += data.quantity;
        } else {
          vm.petition -= data.quantity;
          data.quantity = 0;
          vm.selectAllReceive = false;
        }
      }, vm.two_hundred);
    }

    function getDimensionCompany() {
      api.GeneralWS.DimensionCompany.byCompany.getList(
        { 'company': vm.order.department.company.id }
      ).$promise.then(function (responseDimension) {
        for (let i = 0; i < responseDimension.length; i++) {
          if (responseDimension[i].dimensionNumber === vm.NUMBER_DIMENSION_THREE) {
            vm.dimensionCompanyDetail3 = responseDimension[i];
          } else if (responseDimension[i].dimensionNumber === vm.NUMBER_DIMENSION_FOUR) {
            vm.dimensionCompanyDetail4 = responseDimension[i];
          } else if (responseDimension[i].dimensionNumber === vm.NUMBER_DIMENSION_FIVE) {
            vm.dimensionCompanyDetail5 = responseDimension[i];
          } else {
            vm.dimensionCompanyDetail1 = responseDimension[i];
          }
        }
      });
    }

  }

  function TableDetailPurchaseOrderController($scope) {
    $scope.$watch("data.quantity", function (newVal, oldVal) {
      if (!newVal && newVal !== 0) {
        $scope.data.quantity = 0;
        if (oldVal) {
          $scope.vm.petition = $scope.vm.petition - oldVal;
        }
      } else if (newVal === 0) {
        if (oldVal) {
          $scope.vm.petition = $scope.vm.petition - oldVal;
        }
      } else {
        if (oldVal) {
          $scope.vm.petition = $scope.vm.petition - oldVal;
        }
        $scope.vm.petition = $scope.vm.petition + newVal;
      }
    });
    $scope.$watch("data.quantityInvoice", function (newVal, oldVal) {
      if (!newVal && newVal !== 0) {
        $scope.data.quantityInvoice = 0;
        if (oldVal) {
          $scope.vm.petitionInvoice = $scope.vm.petitionInvoice - oldVal;
        }

      } else if (newVal === 0) {
        if (oldVal) {
          $scope.vm.petitionInvoice = $scope.vm.petitionInvoice - oldVal;
        }
      } else {
        if (oldVal) {
          $scope.vm.petitionInvoice = $scope.vm.petitionInvoice - oldVal;
        }
        $scope.vm.petitionInvoice = $scope.vm.petitionInvoice + newVal;

      }
    });
  }

  function getHeaderCellRendererToReceive(){
    return function () {
      return (
        '<div layout="row" layout-align="center center" style="padding-left: 0.6em">' +
        '   <md-checkbox ng-model="vm.selectAllReceive" ng-change="vm.selectAllToReceive()" aria-label="selectAll">' +
        '   </md-checkbox><md-tooltip md-direction="top">{{"ORDER.SELECT_ALL"| translate}}</md-tooltip>' +
        '</div>'
      );
    }
  }

  function getCellRendererToReceive(){
    return function () {
      return (
        '<div ng-if="!data.completed && data.maxRecibe > 0 && !data.onlyReceivePOS" layout="row" layout-align="center center">' +
        ' <md-checkbox ng-model="data.toReceive" ng-click="vm.addToReceive(data)" aria-label="selectDetail"></md-checkbox>' +
        '</div>'
      );

    }
  }

})();

(function () {
  "use strict";
  angular
    .module("app.order")
    .controller("DetailsPendingDelivery", DetailsPendingDelivery);

  /** @ngInject */
  function DetailsPendingDelivery(
    $scope,
    $rootScope,
    $log,
    $timeout,
    $filter,
    api
  ) {
    var vm = this;
    vm.loading = false;
    vm.search = '';
    vm.data = [];
    vm.objFilter = {};
    vm.parameters = {};
    vm.pageSize = 500;

    const NUMBER_DIMENSION_THREE = 3;
    const NUMBER_DIMENSION_FOUR = 4;
    const NUMBER_DIMENSION_FIVE = 5;

    vm.filter = 'everyone';

    vm.masterGridOptions = {
      columnDefs: vm.masterColumnDefs,
      enableSorting: true,
      debug: false,
      enableFilter: true,
      enableColResize: true,
      angularCompileRows: true,
      angularCompileHeaders: true,
      groupSuppressBlankHeader: true,
      rowGroupPanelShow: 'always',
      toolPanelSuppressGroups: true,
      groupHeaders: true,
      rowModelType: 'enterprise',
      rowSelection: 'multiple',
      rowDeselection: true,
      cacheBlockSize: vm.pageSize,
      maxBlocksInCache: vm.pageSize,
      paginationPageSize: vm.pageSize,
      pagination: true,
      fullWidthCellRenderer: true,
      rowData: null,
      pinnedBottomRowData: [],
      headerHeight: 50,
      rowHeight: 45,
      localeTextFunc: function (key, defaultValue) {
        return translateGrid(key, defaultValue, $filter);
      },
      getMainMenuItems: function (params) {
        return getHeaderMenu(params, $filter);
      }
    };

    vm.masterColumnDefs = [
      {
        headerName: 'ORDER.ORDER',
        field: "ordenCompra",
        headerCellRenderer: getHeader,
        width: 150,
        cellStyle: {'text-align': 'center'},
        sort: 'asc',
        pinned: "left"
      },
      {
        headerName: 'ORDER.PROVIDER',
        field: "proveedor",
        headerCellRenderer: getHeader,
        width: 250,
        enableRowGroup: true,
        enablePivot: true
      },
      {
        headerName: 'ORDER.COMPANY',
        field: "comprador",
        headerCellRenderer: getHeader,
        width: 250,
        enableRowGroup: true,
        enablePivot: true
      },
      {
        headerName: 'ORDER.COST_CENTER',
        field: "centroCosto",
        headerCellRenderer: getHeader,
        width: 250,
        enableRowGroup: true,
        enablePivot: true
      },
      {
        headerName: 'ORDER.DATEDELIVERY',
        field: "fechaEntrega",
        headerCellRenderer: getHeader,
        width: 150,
        valueFormatter: function (params) {
          return $filter('date')(params.value, 'dd/MM/yyyy');
        },
        enableRowGroup: true,
        enablePivot: true
      },
      {
        headerName: 'ORDER.PENDING_DELIVERY.PRODUCT_CODE',
        field: "codigoProducto",
        headerCellRenderer: getHeader,
        width: 200,
        enableRowGroup: true,
        enablePivot: true,
        cellStyle: {"text-align": "center"},
      },
      {
        headerName: 'ORDER.DETAIL.PRODUCT',
        field: "producto",
        headerCellRenderer: getHeader,
        width: 300,
        enableRowGroup: true,
        enablePivot: true
      },
      {
        headerName: 'ORDER.PENDING_DELIVERY.QUANTITY',
        field: "cantidadProductos",
        headerCellRenderer: getHeader,
        width: 200,
        enableRowGroup: true,
        enablePivot: true,
        cellStyle: {"text-align": "center"},
        cellRenderer: function (params) {
          return $filter("number")(params.data.cantidadProductos, 2);
        }
      },
      {
        headerName: 'ORDER.PENDING_DELIVERY.MONEY',
        field: "dinero",
        headerCellRenderer: getHeader,
        width: 150,
        enableRowGroup: true,
        enablePivot: true,
        cellStyle: {"text-align": "right"},
        cellRenderer: function (params) {
          return $filter("number")(params.data.dinero, 2);
        }
      },
    ];

    $scope.$watch('vm.search',
      function (newValue) {
        vm.filter = newValue ? newValue.toLowerCase() : 'everyone';
        vm.masterGridOptions.api.onFilterChanged();
      }
    );

    $timeout(function (d) {
      correctFilterColumns();
      createDataSource(null);
    }, 300);

    function createDataSource(paramsExport) {
      vm.hasData = false;
      if (paramsExport) {
        vm.masterGridOptions.cacheBlockSize = vm.objFilter.totalElements;
        vm.masterGridOptions.maxBlocksInCache = vm.objFilter.totalElements;
        vm.masterGridOptions.paginationPageSize = vm.objFilter.totalElements;
      }
      if ($rootScope.bsCircle) {
        vm.masterGridOptions.api.setColumnDefs(vm.masterColumnDefs);
        vm.masterGridOptions.api.paginationSetPageSize(vm.pageSize);
        var dataSource = {
          paginationPageSize: vm.pageSize,
          getRows: function (params) {
            var o = params.request.filterModel;
            vm.search = '';
            $.map(o, function (k, ke) {
              var on = k;
              on.field = ke;
              on.filter = on.filter.toString();
              vm.search = on.filter.toString();
              return on;
            });
            var parameters = {
              idPurchaseOrder: 0,
              pageNumber: vm.masterGridOptions.api.paginationGetCurrentPage(),
              pageSize: vm.pageSize,
              search: vm.search
            };
            vm.parameters = parameters;
            vm.isShowProgressLinear = true;
            api.ComprasWS.PurchaseOrderDetailPendingDelivery
              .getReportDetail(
                vm.parameters
                , {}, function (response) {
                  vm.isShowProgressLinear = false;
                  vm.objFilter.totalElements = response.totalElements;
                  vm.infData = new jinqJs()
                    .from(response.content)
                    .orderBy([{field: "ordenCompra", sort: "asc"}])
                    .select(function (r) {
                      return r;
                    });

                  const listDimensions3 = new jinqJs()
                    .from(response.content)
                    .where(function (d) {
                      return d.dimensionCompany3Id;
                    })
                    .select(function (r) {
                      return r.dimensionCompany3Id;
                    });

                  const listDimensions4 = new jinqJs()
                    .from(response.content)
                    .where(function (d) {
                      return d.dimensionCompany4Id;
                    })
                    .select(function (r) {
                      return r.dimensionCompany4Id;
                    });

                  const listDimensions5 = new jinqJs()
                    .from(response.content)
                    .where(function (d) {
                      return d.dimensionCompany5Id;
                    })
                    .select(function (r) {
                      return r.dimensionCompany5Id;
                    });

                  if (listDimensions3.length > 0 ||
                    listDimensions4.length > 0 ||
                    listDimensions4.length > 0
                  ) {
                    const distinctListDimensionCompanies = new jinqJs()
                      .from(listDimensions3, listDimensions4, listDimensions5)
                      .distinct()
                      .select(function (r) {
                        return r;
                      });

                    if (distinctListDimensionCompanies.length > 0) {
                      getDimensionCompanyByList(distinctListDimensionCompanies);
                    }
                  }

                  params.successCallback(vm.infData, vm.objFilter.totalElements);

                  vm.hasData = response.content.length > 0;
                  if (paramsExport) {
                    vm.masterGridOptions.api.exportDataAsExcel(paramsExport);
                    vm.pageSize=500;
                    vm.masterGridOptions.cacheBlockSize = vm.pageSize;
                    vm.masterGridOptions.maxBlocksInCache = vm.pageSize;
                    vm.masterGridOptions.paginationPageSize = vm.pageSize;
                    createDataSource(null);
                  }
                },
                function (response) {
                  vm.isShowProgressLinear = false;
                  $log.error(response);
                });
          }
        };
        vm.masterGridOptions.api.setEnterpriseDatasource(dataSource);
      }
    }

    function correctFilterColumns() {
      vm.masterColumnDefs.forEach(function (column) {
        correctFilter(column);
      });
    }

    function correctFilter(column) {
      switch (column.field) {
        case 'cantidadProductos':
          column.suppressFilter = true;
          break;
        case 'dinero':
          column.suppressFilter = true;
          break;
        case 'ordenCompra':
          column.filter = "number";
          break;
        case 'fechaEntrega':
          column.suppressFilter = true;
          break
        default:
          column.filter = "text";
          break;
      }
      correctFilterParams(column);
    }

    function correctFilterParams(column) {
      switch (column.filter) {
        case "number":
          column.filterParams = {
            filterOptions: ["equals"],
            newRowsAction: "keep"
          };
          break;
        case "text":
          column.filterParams = {
            filterOptions: ["contains"],
            newRowsAction: "keep"
          };
          break;
        case "date":
          column.suppressFilter = true;
          break;
      }
    }

    vm.onExportXLS = function () {
      vm.pageSize= vm.objFilter.totalElements;
      createDataSource(null);

      var params = {
        skipHeader: false,
        skipFooters: false,
        skipGroups: false,
        allColumns: true,
        onlySelected: false,
        fileName: $filter("translate")('ORDER.DETAILS_PENDING_DELIVERY') + ".xls",
        columnSeparator: ",",
        sheetName: "data"
      };

      params.processCellCallback = function (params) {
        if (params.column.colId.indexOf("fecha") !== -1) {
          return $filter("date")(params.value, "dd/MM/yyyy");
        } else if (params.column.colId.indexOf("createdAt") !== -1) {
          return $filter("apiDate")(params.value, "dd/MM/yyyy HH:mm:ss");
        } else {
          return params.value;
        }
      };

      params.processHeaderCallback = function (params) {
        return $filter("translate")(params.column.colDef.headerName);
      };

      $timeout(function () {
        createDataSource(params);
      }, 300);
    };

    function getDimensionCompanyByList(ids) {
      api.GeneralWS.DimensionCompany.getByIdList.getList(
        {'company': vm.companyId}, ids
      ).$promise.then(function (responseDimension) {
        responseDimension.sort(function (a, b) {
          return a.dimensionNumber - b.dimensionNumber;
        });
        verifyDimensionCompanyGetDetails(responseDimension);
      });
    }

    function verifyDimensionCompanyGetDetails(responseDimension) {
      for (let i = 0; i < responseDimension.length; i++) {
        if (responseDimension[i].dimensionNumber === NUMBER_DIMENSION_THREE && !vm.dimensionCompanyDetail3) {
          vm.dimensionCompanyDetail3 = responseDimension[i];
          addMasterColumnDefs(responseDimension[i].description, 'dimensionCompanyDetail3Name', responseDimension[i].dimensionNumber);
        } else if (responseDimension[i].dimensionNumber === NUMBER_DIMENSION_FOUR && !vm.dimensionCompanyDetail4) {
          vm.dimensionCompanyDetail4 = responseDimension[i];
          addMasterColumnDefs(responseDimension[i].description, 'dimensionCompanyDetail4Name', responseDimension[i].dimensionNumber);
        } else if (responseDimension[i].dimensionNumber === NUMBER_DIMENSION_FIVE && !vm.dimensionCompanyDetail3) {
          vm.dimensionCompanyDetail5 = responseDimension[i];
          addMasterColumnDefs(responseDimension[i].description, 'dimensionCompanyDetail5Name', responseDimension[i].dimensionNumber);
        } else {
          vm.dimensionCompanyDetail1 = responseDimension[i];
        }
        if (responseDimension[responseDimension.length - 1] === responseDimension[i]) {
          vm.masterGridOptions.api.setColumnDefs(vm.masterColumnDefs);
        }
      }
    }

    function addMasterColumnDefs(name, fieldName, number) {
      const NUMBER_COLUMN_ADD = 3;
      let exist = false;
      vm.masterColumnDefs.forEach(function (r) {
        if (r.headerName === name) {
          exist = true;
        }
      });
      if (!exist) {
        vm.masterColumnDefs.splice((number + NUMBER_COLUMN_ADD), 0, {
          headerName: name,
          field: fieldName,
          headerCellRenderer: getHeader,
          width: 200,
          enableRowGroup: true,
          filter: 'text',
          enablePivot: true
        });
      }
    }

  }
})();

(function () {
    'use strict';

    angular
        .module('app.merchandiseEntry.invoiceMerchandiseEntry', [])
        .config(config);


    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {
        // State
        $stateProvider
            .state('app.merchandiseEntry.invoiceMerchandiseEntry', {
                url: '/invoiceMerchandiseEntry',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/merchandiseEntry/invoiceMerchandiseEntry/invoiceMerchandiseEntry.html',
                        controller: 'InvoiceMerchandiseEntryController as vm'
                    }
                },
                bodyClass: 'e-commerce'
            });


        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/merchandiseEntry/invoiceMerchandiseEntry');

    }
})();


(function () {
    'use strict';

    angular
        .module('app.merchandiseEntry.invoiceMerchandiseEntry')
        .controller('InvoiceMerchandiseEntryController', InvoiceMerchandiseEntryController);

    /** @ngInject */
    function InvoiceMerchandiseEntryController($state, api, $rootScope, $log, $filter, $mdToast, $timeout, $scope) {
        var vm = this;
        vm.merchandiseEntries = [];
        vm.companyInvoice = {};
        vm.comaniesMerchandiseEntries = [];
        vm.querySearch = querySearch;

        vm.getMerchandiseEntry = getMerchandiseEntry;
        vm.selectAllMerchandise = selectAllMerchandise;
        vm.merchandiseEntrysSend = [];
        vm.invoiceMerchandiseEntrys = invoiceMerchandiseEntrys;
        vm.selectAll = false;
        vm.hasBudgetApplication = false;

        const FORMAT_DD_MM_YY_HH_MM_SS = 'dd/MM/yyyy HH:mm:ss';
        const EXPORT_TRANSLATE = $filter('translate')('REPORT.EXPORT');
        const TITLE_INVOICE_MERCHANDISE_ENTRY = $filter('translate')('INVOICE_MERCHANDISE_ENTRY.MERCHANDISE_ENTRIES');

        vm.two_hundred = 200;

        const NUMBER_DIMENSION_THREE = 3;
        const NUMBER_DIMENSION_FOUR = 4;
        const NUMBER_DIMENSION_FIVE = 5;

        // Data

        vm.masterColumnDefs = getBasicColumnsDefs();

        vm.masterGridOptions = {
            columnDefs: [],
            enableSorting: true,
            debug: false,
            enableFilter: true,
            enableColResize: true,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowData: null,
            headerHeight: 50,
            rowHeight: 45,
            animateRows: true,
            groupDefaultExpanded: 1,
            groupSelectsChildren: true,
            groupHeaders: true,
            rowSelection: 'multiple',
            suppressRowClickSelection: true,
            autoGroupColumnDef: {
                headerName: 'INVOICE_MERCHANDISE_ENTRY.PURCHASE_ORDER',
                field: "purchaseOrderDescription",
                width: 280,
                cellRenderer: 'group',
                hide: true,
                headerCellRenderer: getHeader,
                cellRendererParams: {
                    checkbox: true
                },
                pinned: "left"
            },
            onSelectionChanged: selectionChangedFunc,
            doesDataFlower: function (dataItem) {
                dataItem.fecha = getDateFormat(dataItem);
                dataItem.deptoCostCenter = dataItem.purchaseOrderDetail.purchaseOrder.department.description
                    + ', ' + dataItem.purchaseOrderDetail.purchaseOrder.costCenter.description;
                dataItem.invoice = false;
                dataItem.price = dataItem.purchaseOrderDetail.purchaseOrder.currency.symbol + " " + $filter('number')(dataItem.purchaseOrderDetail.price, 2);

                if (dataItem.purchaseOrderDetail.purchaseOrder.contractPurchase) {
                    dataItem.purchaseOrderDescription = "Contrato # " + dataItem.purchaseOrderDetail.purchaseOrder.contractPurchase.id
                        + " Cuota " + dataItem.merchandiseHeader.noPayment;
                } else {
                    dataItem.purchaseOrderDescription = "Orden de Compra # " + dataItem.purchaseOrderDetail.purchaseOrder.id;
                }

                dataItem.filter = (dataItem.purchaseOrderDescription + "," + dataItem.purchaseOrderDetail.purchaseOrder.id
                    + "," + dataItem.purchaseOrderDetail.purchaseOrder.department.description
                    + "," + dataItem.purchaseOrderDetail.purchaseOrder.costCenter.description + ","
                    + dataItem.purchaseOrderDetail.product.name + "," + dataItem.purchaseOrder + ","
                    + dataItem.purchaseOrderDetail.purchaseOrder.companyProvider.name).toLowerCase();
            },
            isExternalFilterPresent: isExternalFilterPresent,
            doesExternalFilterPass: doesExternalFilterPass,
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            },
          getContextMenuItems: isGetContextMenuItems
        };

        var filter = 'everyone';

        function selectionChangedFunc(data) {
            vm.merchandiseEntrysSend = [];
            for (var i = 0; i < vm.masterGridOptions.api.getSelectedNodes().length; i++) {
                vm.masterGridOptions.api.getSelectedNodes()[i].data.invoice = true;
                vm.gotoDetail(vm.masterGridOptions.api.getSelectedNodes()[i].data);
            }
            $timeout(function () {
                vm.merchandiseEntrysSend = angular.copy(vm.merchandiseEntrysSend);
            }, 100);
        }

        function isExternalFilterPresent() {
            return filter !== '';
        }

        function doesExternalFilterPass(node) {
            if (filter && filter !== 'everyone') {
                var arrdt = node.data.filter.split(filter.toLowerCase());
                return arrdt.length > 1;
            }
            return true;
        }

      function isGetContextMenuItems() {
        const paramrs = getParameterToExport();

        paramrs.processCellCallback = isProcessCellCallBack();

        paramrs.processHeaderCallback = function (param) {
          return $filter('translate')(param.column.colDef.headerName);
        };

        return [
          'copy',
          'copyWithHeaders',
          'paste',
          'separator',
          {
            name: $filter('translate')('REPORT.EXPORT'),
            subMenu: getContextSubMenuItems(paramrs)
          }
        ];
      }

        $scope.$watch('vm.search',
            function (newValue) {
                filter = newValue;
                vm.masterGridOptions.api.onFilterChanged();
            }
        );

        vm.loading = true;
        $timeout(function (d) {
            if ($rootScope.bsCircle) {
                $rootScope.loadingProgress = true;
                vm.loading = true;
                api.ComprasWS.MerchandiseEntry.provider(
                    { idCircle: $rootScope.bsCircle.id, id: 'byCompanyDistinct', invoiced: false, status: 'Recibida' }, function (response) {// Success
                        vm.companies = response;
                        if (vm.companies.length > 0) {
                            vm.companyInvoice = vm.companies[0];
                            getMerchandiseEntry();
                        } else {
                            $timeout(function () {
                                vm.masterGridOptions.api.setColumnDefs(vm.masterColumnDefs);
                                vm.masterGridOptions.api.setRowData(vm.merchandiseEntries);
                            }, 200);
                        }
                        vm.loading = false;
                        $rootScope.loadingProgress = false;
                        $log.debug(vm.merchandiseEntries);
                    }, function (response) {// Error
                        $log.debug(response);
                        vm.loading = false;
                        $rootScope.loadingProgress = false;
                    });
            } else {
                vm.loading = false;
                $state.go('app.dashboard_project');
            }
        }, 3000);


        function getMerchandiseEntry() {
            cleanDimensionsCompany();
            getDimensionCompany();
            if (vm.companyInvoice === null) {
                $timeout(function () {
                    vm.masterGridOptions.api.setColumnDefs(vm.masterColumnDefs);
                    vm.masterGridOptions.api.setRowData(vm.merchandiseEntries);
                }, 200);
            } else {
                $rootScope.loadingProgress = true;
                vm.masterGridOptions.api.setRowData([]);

                api.ComprasWS.MerchandiseEntry.page(
                    {
                        idCircle: $rootScope.bsCircle.id, id: 'byUserProvider',
                        idCompany: vm.companyInvoice.id,
                        invoiced: false, page: 0, pageSize: 5000, status: 'Recibida'
                    }, function (response) {// Success

                        vm.merchandiseEntries = new jinqJs()
                            .from(response.content)
                            .orderBy([{ field: 'id', sort: 'asc' }])
                            .select();

                        $timeout(function () {
                            vm.masterGridOptions.api.setColumnDefs(vm.masterColumnDefs);
                            vm.masterGridOptions.api.setRowData(vm.merchandiseEntries);
                        }, 200);
                        $log.debug(vm.merchandiseEntries);
                        $rootScope.loadingProgress = false;
                    }, function (response) {// Error
                        $log.debug(response);
                        vm.loading = false;
                        $timeout(function () {
                            vm.masterGridOptions.api.setColumnDefs(vm.masterColumnDefs);
                            vm.masterGridOptions.api.setRowData([]);
                        }, 200);
                        $rootScope.loadingProgress = false;
                    });
            }
        }

        function rendererProduct(params) {
            if (params.data) {
                if (params.data.purchaseOrderDetail.product.measurementUnit === null) {
                    return '<div>' + params.data.purchaseOrderDetail.product.name + '</div>';
                } else {
                    return params.data.purchaseOrderDetail.product.name + '(<small>'
                        + params.data.purchaseOrderDetail.product.measurementUnit.name + '</small>)</div>';
                }
            } else {
                return '';
            }
        }

        function querySearch(numberSelect, query) {
            var results;
            if (numberSelect) {
                if (numberSelect === 1) {
                    results = query ? vm.companies.filter(createFilterFor(1, query)) : vm.companies;
                }
            }
            return results;
        }

        function createFilterFor(fieldFilter, query) {
            var lowercaseQuery = angular.lowercase(query);
            return function filterFn(model) {
                var lowercaseName = '';
                if (fieldFilter === 1) {
                    lowercaseName = angular.lowercase(model.name);
                }

                return (lowercaseName.indexOf(lowercaseQuery) === 0 || lowercaseName.indexOf(lowercaseQuery) > 0);
            };
        }

        vm.gotoDetail = function (data) {
            if (data.invoice) {
                if (vm.merchandiseEntrysSend.length === 0) {
                    vm.merchandiseEntrysSend.push(data);
                    validateHasBudgetApplication(data);

                } else {
                    if (data.purchaseOrderDetail.purchaseOrder.currency.id === vm.merchandiseEntrysSend[0].purchaseOrderDetail.purchaseOrder.currency.id) {
                        var exist = false;
                        for (var i = 0; i < vm.merchandiseEntrysSend.length; i++) {
                            if (data.id === vm.merchandiseEntrysSend[i].id) {
                                exist = true;
                                break;
                            }
                        }
                        if (!exist) {
                            vm.merchandiseEntrysSend.push(data);
                        }
                    } else {
                        vm.merchandiseEntrysSend.splice(data, 1);
                        for (var j = 0; j < vm.merchandiseEntries.length; j++) {
                            vm.merchandiseEntries[j].invoice = false;
                        }
                        showErrorMessage('ERROR NO PUEDE FACTURAR EN DIFERENTE MONEDA');
                    }
                }
            } else {
                vm.merchandiseEntrysSend = [];
                vm.merchandiseEntrysSend.splice(data, 1);
            }
        };

        function selectAllMerchandise() {

            vm.merchandiseEntrysSend = [];

            for (var i = 0; i < vm.merchandiseEntries.length; i++) {
                vm.merchandiseEntries[i].invoice = !vm.selectAll;

                if (!vm.selectAll) {
                    vm.masterGridOptions.api.selectAll();
                    vm.merchandiseEntrysSend.push(vm.merchandiseEntries[i]);
                } else {
                    vm.masterGridOptions.api.deselectAll();
                }
            }
        }

        function invoiceMerchandiseEntrys() {
            var detail = "";
            for (var i = 0; i < vm.merchandiseEntrysSend.length; i++) {
                detail = detail + "," + vm.merchandiseEntrysSend[i].id;
            }
            $state.go('app.invoice.Ingresando.detail', { detail: detail.substring(1) });
        }

        function showErrorMessage(message) {
            $rootScope.loadingProgress = false;
            $mdToast.show({
                template: '<md-toast layout="column" layout-align="center start"><div class="md-toast-content" style="background-color: red">'
                    + message + '</div></md-toast>',
                hideDelay: 5000,
                position: 'top right'
            });
        }

        vm.clearSearchCompany = function () {
            vm.searchCompany = "";
        };

        $timeout(function () {

            var keyEvent = function (event) {
                event.stopPropagation();
            };

            var searchCompanyInput = document.querySelector("#searchCompany");

            if (searchCompanyInput) {
                searchCompanyInput.addEventListener("keydown", keyEvent);
            }

        }, 500);


        function rendererOptions(params) {
            if (params.data) {
                return '<div>'
                    + '   <md-button class="edit-button md-icon-button" ng-click="vm.invoiceDetail(data)" aria-label="present merchandise"'
                    + '                     translate translate-attr-aria-label="INVOICE_MERCHANDISE_ENTRY.INVOICE">'
                    + '     <md-tooltip md-direction="bottom">'
                    + '                         {{"INVOICE_MERCHANDISE_ENTRY.INVOICE"| translate}}'
                    + '                     </md-tooltip>'
                    + ' <md-icon md-font-icon="icon-receipt" class="s16"></md-icon>'
                    + ' </md-button>'
                    + '             </div>';
            } else {
                return '';
            }

        }

        function rendererObservations(params) {
            if (params.data && params.data.purchaseOrderDetail.purchaseOrder.contractPurchase) {
                return '<div style="width: 100%; margin:0 auto;">'
                    + ' <p align="center">{{"INVOICE_MERCHANDISE_ENTRY.PAYMENTS" | translate}}{{data.merchandiseHeader.noPayment}}</p>'
                    + ' </div>';
            } else {
                return '';
            }
        }

        vm.invoiceDetail = function (data) {
            vm.merchandiseEntrysSend = [];
            vm.merchandiseEntrysSend.push(data);
            if (data.purchaseOrderDetail.purchaseOrder.contractPurchase) {
                for (var i = 0; i < vm.merchandiseEntries.length; i++) {
                    if (vm.merchandiseEntries[i].purchaseOrderDetail.purchaseOrder.contractPurchase) {
                        if (vm.merchandiseEntries[i].purchaseOrderDetail.purchaseOrder.contractPurchase.id === data.purchaseOrderDetail.purchaseOrder.contractPurchase.id
                            && vm.merchandiseEntries[i].id !== data.id && vm.merchandiseEntries[i].merchandiseHeader.noPayment === data.merchandiseHeader.noPayment) {
                            vm.merchandiseEntrysSend.push(vm.merchandiseEntries[i]);
                            vm.merchandiseEntries[i].invoice = true;
                        }
                    }
                }
            }
            invoiceMerchandiseEntrys();
        };

        function getDateFormat(dataItem) {
            if (dataItem.purchaseOrderDetail.purchaseOrder.contractPurchase === null) {
                var day = 0;
                var month = 0;
                if (dataItem.createdAt.dayOfMonth < 10) {
                    day = '0' + (dataItem.createdAt.dayOfMonth);
                } else {
                    day = (dataItem.createdAt.dayOfMonth);
                }
                if (dataItem.createdAt.monthValue < 10) {
                    month = '0' + (dataItem.createdAt.monthValue);
                } else {
                    month = dataItem.createdAt.monthValue;
                }
                return new Date(dataItem.createdAt.year + "-" + month + "-" + day);
            } else {
                return dataItem.purchaseOrderDetail.purchaseOrder.dateDelivery;
            }

        }

      function validateHasBudgetApplication(data) {
        var companyId = data.purchaseOrderDetail.purchaseOrder.department.company.id;
        api.GeneralWS.CompanyApplication.byAppName.get({
          'company': companyId,
          'app': 'Presupuestos'
        }).$promise.then(function (responseParameter) {
          if (responseParameter.$status === 200) {
            if (responseParameter.$data && responseParameter.$data !== '') {
              api.GeneralWS.CompanyParameterByName.get(
                {
                  id: companyId,
                  parameter: 'REQUEST_A_BUDGET_IN_CONTRACTS'
                }, function (responseParameterRequestBudget) {
                  if (responseParameterRequestBudget) {
                    nodeSelectedByContract(data, responseParameterRequestBudget.parameterValue === 'true');
                  } else {
                    nodeSelectedByContract(data, false);
                  }
                });
            } else {
              nodeSelectedByContract(data, false);
            }
          } else {
            nodeSelectedByContract(data, false);
          }
        });
      }

      function nodeSelectedByContract(data, hasBudgetApplication){
        if (data.purchaseOrderDetail.purchaseOrder.contractPurchase) {
          vm.masterGridOptions.api.forEachNode(function (node) {
            if (node.data) {
              if (node.data.purchaseOrderDetail.purchaseOrder.contractPurchase) {
                if (node.data.purchaseOrderDetail.purchaseOrder.contractPurchase.id === data.purchaseOrderDetail.purchaseOrder.contractPurchase.id
                  && node.data.merchandiseHeader.noPayment === data.merchandiseHeader.noPayment) {
                  if (node.data.id !== data.id) {
                    vm.merchandiseEntrysSend.push(node.data);
                    node.setSelected(true);
                  }
                }else if (hasBudgetApplication){
                  node.setSelected(false);
                }
              }
            }

          });
        }
      }

      function getParameterToExport() {
        return {
          skipHeader: false,
          skipFooters: false,
          skipGroups: false,
          allColumns: true,
          onlySelected: false,
          columnSeparator: ',',
          sheetName: TITLE_INVOICE_MERCHANDISE_ENTRY
        };
      }

      function getContextSubMenuItems(paramrs) {
        return [
          {
            name: EXPORT_TRANSLATE + ' CSV',
            action: dataExportCSV(paramrs)
          },
          {
            name: EXPORT_TRANSLATE + ' Excel (.xlsx)',
            action: dataExportExcel(paramrs)
          }
        ];
      }

      function isProcessCellCallBack() {
        return function (param) {
          if (param.column.colId.indexOf('fecha') !== -1) {
            return $filter('date')(param.value, 'dd/MM/yyyy');
          } else if (
            param.column.colId.indexOf('createdAt') !== -1 &&
            param.value
          ) {
            return $filter('apiDate')(param.value, FORMAT_DD_MM_YY_HH_MM_SS);
          } else if (
            param.column.colId.indexOf('quantity') !== -1 &&
            param.node && param.node.data
            ){
            if (param.node.data.quantitySold) {
              return param.node.data.quantitySold - param.node.data.quantityInvoice;
            } else {
              return 0;
            }
          } else {
            return param.value;
          }
        };
      }

      function dataExportCSV(paramrs) {
        return function () {
          paramrs.fileName = TITLE_INVOICE_MERCHANDISE_ENTRY;
          vm.masterGridOptions.api.exportDataAsCsv(paramrs);
        };
      }

      function dataExportExcel(paramrs) {
        return function () {
          paramrs.fileName = TITLE_INVOICE_MERCHANDISE_ENTRY + new Date().getTime() + '.xlsx';
          vm.masterGridOptions.api.exportDataAsExcel(paramrs);
        };
      }

      function getBasicColumnsDefs(){
        return [
          {
            headerName: 'INVOICE_MERCHANDISE_ENTRY.PROVIDER',
            field: "purchaseOrderDetail.purchaseOrder.companyProvider.name",
            headerCellRenderer: getHeader,
            width: 180
          },
          {
            headerName: 'INVOICE_MERCHANDISE_ENTRY.COMPANY',
            field: "purchaseOrderDetail.purchaseOrder.department.company.name",
            headerCellRenderer: getHeader,
            width: 180
          },
          {
            headerName: 'INVOICE_MERCHANDISE_ENTRY.DEPARTMENT',
            field: "purchaseOrderDetail.purchaseOrder.department.description",
            headerCellRenderer: getHeader,
            width: 280
          },
          {
            headerName: 'INVOICE_MERCHANDISE_ENTRY.COSTCENTER',
            field: "purchaseOrderDetail.purchaseOrder.costCenter.description",
            headerCellRenderer: getHeader,
            width: 280
          },
          {
            headerName: 'INVOICE_MERCHANDISE_ENTRY.PURCHASE_ORDER',
            field: "purchaseOrderDescription",
            headerCellRenderer: getHeader,
            width: 280,
            rowGroupIndex: 0,
            hide: true,
            headerCheckboxSelection: true,
            pinned: "left"
          },
          {
            headerName: 'INVOICE_MERCHANDISE_ENTRY.ENTRYDATEPURCHASE',
            field: "fecha",
            headerCellRenderer: getHeader,
            valueFormatter: function (params) {
              return $filter('date')(params.value, 'dd/MM/yyyy');
            },
            width: 130
          },
          {
            headerName: 'INVOICE_MERCHANDISE_ENTRY.DETAIL.PRODUCT',
            field: "purchaseOrderDetail.product.name",
            headerCellRenderer: getHeader,
            cellRenderer: rendererProduct,
            width: 280
          },
          {
            headerName: 'INVOICE_MERCHANDISE_ENTRY.DETAIL.QUANTITY',
            field: "quantity",
            width: 100,
            headerCellRenderer: getHeader,
            cellStyle: { 'text-align': 'center' },
            cellRenderer: function (params) {
              if (params.data && params.data.quantitySold) {
                return params.data.quantitySold - params.data.quantityInvoice;
              }
              return 0;
            }
          },
          {
            headerName: 'INVOICE_MERCHANDISE_ENTRY.DETAIL.PRICE',
            field: "price",
            width: 100,
            headerCellRenderer: getHeader,
            cellStyle: { 'text-align': 'right' }
          },
          {
            headerName: 'INVOICE_MERCHANDISE_ENTRY.DETAIL.OBSERVATIONS',
            suppressSorting: true,
            suppressMenu: true,
            width: 150,
            headerCellRenderer: getHeader,
            cellRenderer: rendererObservations,
            cellStyle: { 'padding': '0px' }
          },
          {
            headerName: 'INVOICE_MERCHANDISE_ENTRY.OPTIONS',
            suppressSorting: true,
            suppressMenu: true,
            width: 150,
            headerCellRenderer: getHeader,
            cellRenderer: rendererOptions,
            pinned: "right"
          }
        ];
      }

      function getDimensionCompany() {
        api.GeneralWS.DimensionCompany.byCompanyNotActive.getList(
          { 'company': vm.companyInvoice.id }
        ).$promise.then(function (responseDimension) {
          responseDimension.sort(function (a, b) {
            return a.dimensionNumber - b.dimensionNumber;
          });
          vm.masterColumnDefs = getBasicColumnsDefs();
          verifyDimensionCompanyGetDetails(responseDimension);
          $timeout(function (){
            if (vm.masterGridOptions && vm.masterGridOptions.api) {
              vm.masterGridOptions.api.setColumnDefs(vm.masterColumnDefs);
            }
          }, vm.two_hundred);
        });
      }

      function verifyDimensionCompanyGetDetails(responseDimension) {
        for (let i = 0; i < responseDimension.length; i++) {
          if (responseDimension[i].dimensionNumber === NUMBER_DIMENSION_THREE && !vm.dimensionCompanyDetail3) {
            vm.dimensionCompanyDetail3 = responseDimension[i];
            addMasterColumnDefs(responseDimension[i].description, 'dimensionCompanyDetail3Name', responseDimension[i].dimensionNumber);
          } else if (responseDimension[i].dimensionNumber === NUMBER_DIMENSION_FOUR && !vm.dimensionCompanyDetail4) {
            vm.dimensionCompanyDetail4 = responseDimension[i];
            addMasterColumnDefs(responseDimension[i].description, 'dimensionCompanyDetail4Name', responseDimension[i].dimensionNumber);
          } else if (responseDimension[i].dimensionNumber === NUMBER_DIMENSION_FIVE && !vm.dimensionCompanyDetail5) {
            vm.dimensionCompanyDetail5 = responseDimension[i];
            addMasterColumnDefs(responseDimension[i].description, 'dimensionCompanyDetail5Name', responseDimension[i].dimensionNumber);
          } else {
            vm.dimensionCompanyDetail1 = responseDimension[i];
          }
          if (responseDimension[responseDimension.length - 1] === responseDimension[i]) {
            vm.masterGridOptions.api.setColumnDefs(vm.masterColumnDefs);
          }
        }
      }

      function addMasterColumnDefs(name, fieldName, number) {
        const NUMBER_COLUMN_ADD = 4;
        let exist = false;

        vm.masterColumnDefs.forEach(function (r) {
          if (r.headerName === name) {
            exist = true;
          }
        });

        if (!exist) {
          vm.masterColumnDefs.splice((number + NUMBER_COLUMN_ADD), 0, {
            headerName: name,
            field: fieldName,
            headerCellRenderer: getHeader,
            width: 200,
            enableRowGroup: true,
            filter: 'text',
            enablePivot: true
          });
        }
      }

      function cleanDimensionsCompany() {
        vm.dimensionCompanyDetail3 = null;
        vm.dimensionCompanyDetail4 = null;
        vm.dimensionCompanyDetail5 = null;
      }

    }
})();

(function () {
  'use strict';
  angular
      .module('app.invoice')
      .controller('SaleInvoiceEditorController', SaleInvoiceEditorController);
  /** @ngInject */
  function SaleInvoiceEditorController(
      $scope, $rootScope, $state, api, $log, $mdDialog, $filter, PreviousState, $timeout, $stateParams, MessageService, $sce, $templateRequest,
      REGEX_UUID, INVOICE_PURCHASE_TYPES
    ) {
      var vm = this;
      /*GENERAL*/
      vm.regexUUID = REGEX_UUID;
      vm.invoicePurchaseTypes = INVOICE_PURCHASE_TYPES;
      vm.status = $state.params.status;
      vm.merchandiseEntries = [];
      vm.invoicePurchase = {};
      vm.companies = [];
      vm.details = [];
      vm.regimes = [];
      vm.isInvoice = true;
      vm.currencies = [];
      vm.filesToUpload = [];
      vm.filesToUploadQuotation = [];
      vm.maxNumberFilesQuotation = 1;
      vm.maxFileSizeMBQuotation = 1;
      vm.fileContainerWithoutBorders = true;
      vm.taxes = [];
      vm.series = [];
      vm.URLPHOTOS = api.baseUrlPhotos;
      vm.filesPurchase = [];
      vm.isContractFixed = true;
      vm.InvoiceWithholdingDetails = [];
      vm.detailTaxesCreate = [];
      vm.isNew = false;
      vm.invoiceDTO = {};
      vm.quotation = {};
      vm.requestAmpliationButton = false;
      vm.addFeatures = addFeatures;

      vm.getRegimeProvider = getRegimeProvider;
      vm.goToInvoicePurchaseDetailEdit = goToInvoicePurchaseDetailEdit;
      vm.setStatusInvoices = setStatusInvoices;
      vm.viewIMG = viewIMG;
      vm.updateFileInvoicePurchase = updateFileInvoicePurchase;

      $rootScope.loadingProgress = true;
      vm.goToInvoicePurchases = goToInvoicePurchases;
      vm.saveInvoicePurchase = saveInvoicePurchase;
      vm.updateInvoicePurchase = updateInvoicePurchase;
      vm.nextInvoicePurchase = nextInvoicePurchase;
      vm.querySearch = querySearch;
      vm.updatePrice = updatePrice;
      vm.goToAddDiscount = goToAddDiscount;
      vm.changeCancelStatusInvoice = changeCancelStatusInvoice;
      vm.validateDateInvoicePurchace = validateDateInvoicePurchace;

      vm.invoicePurchaseDetails = [];
      vm.invoicePurchaseDetail = {};
      vm.canEditExchangeRate = false;
      vm.canModifyTotal = false;
      vm.newInvoicePurchase = {};
      vm.viewButton = true;
      vm.addFeaturesInvoice = addFeaturesInvoice;
      vm.validateRegime = validateRegime;
      vm.viewUuid = false;
      vm.almostEnd = '';
      vm.hasBudgetApplication = false;
      vm.productBudget = {};
      vm.budgets=[];
      var budgetsTemplate = null;
      vm.showButton = true;
      vm.showButtonCancel = true;
      vm.showFelSV = false;
      vm.electronicInvoiceTitle = 'INVOICE.INVOICE_PURCHASE.ELECTRONIC_SIGNATURE';
      vm.uuidTitle = 'INVOICE.INVOICE_PURCHASE.UUID';
      vm.uuidErrorTitle = 'INVOICE.ERROR.FIELD_REQUIRED_PATTERN';


    vm.NUMBER_ONE = 1
    vm.NUMBER_DIMENSION_THREE = 3;
    vm.NUMBER_DIMENSION_FOUR = 4;
    vm.NUMBER_DIMENSION_FIVE = 5;

    vm.dimensionCompanyDetail3 = null;
    vm.dimensionCompanyDetail4 = null;
    vm.dimensionCompanyDetail5 = null;
    vm.sumTotalQuantity = 0;
    vm.sumSubTotalAfterTaxCurrency = 0;
    vm.sumSubTotalAfterTaxDocumentCurrency = 0;
    vm.sumSubTotalAfterTaxForeignCurrency = 0;
    vm.one_thousand_eight_hundred = 1800;
    vm.number_two = 2;

      if ($state.params.detail && $state.params.detail !== null && $state.params.detail !== '' && $state.params.id === '') {
          api.ComprasWS.MerchandiseEntry.getAllByIds(
              { idCircle: $rootScope.bsCircle.id, id: 'getAllByIds', invoiced: false, ids: $state.params.detail }, function (response) {// Success
                  vm.merchandiseEntries = response;
                  if (!vm.merchandiseEntries[0].purchaseOrderDetail) {
                      goToInvoicePurchases();
                  }
                  vm.companies.push(vm.merchandiseEntries[0].purchaseOrderDetail.purchaseOrder.department.company);
                  vm.invoicePurchase.companyBuyer = vm.merchandiseEntries[0].purchaseOrderDetail.purchaseOrder.department.company;
                  vm.invoicePurchase.companyProvider = vm.merchandiseEntries[0].purchaseOrderDetail.purchaseOrder.companyProvider;
                  vm.invoicePurchase.currency = vm.merchandiseEntries[0].purchaseOrderDetail.purchaseOrder.currency;
                  vm.invoicePurchase.dateInvoicePurchase = new Date();
                if (vm.merchandiseEntries[0].merchandiseHeader.purchaseOrder.quotation &&
                  vm.merchandiseEntries[0].merchandiseHeader.purchaseOrder.quotation !== null) {
                  vm.invoicePurchase.exchangeRate = vm.merchandiseEntries[0].merchandiseHeader.purchaseOrder.quotation.exchangeRate;
                } else {
                  vm.invoicePurchase.exchangeRate = vm.NUMBER_ONE;
                }

                if (vm.merchandiseEntries[0].merchandiseHeader.purchaseOrder.quotation &&
                  vm.merchandiseEntries[0].merchandiseHeader.purchaseOrder.quotation !== null) {
                  vm.quotation = vm.merchandiseEntries[0].merchandiseHeader.purchaseOrder.quotation;
                } else {
                  vm.quotation = {};
                }

                  vm.currencies.push(vm.invoicePurchase.currency);
                  if (vm.invoicePurchase.companyBuyer) {
                    validateHasBudgetApplication(vm.invoicePurchase.companyBuyer.id);
                  }
                  if (vm.invoicePurchase.companyProvider) {
                      getRegimeProvider();
                      validateRegime();
                  }
                  getSeries();
                  vm.loading = false;
                  $rootScope.loadingProgress = false;
                  $log.debug(vm.merchandiseEntries);
              }, function (response) {// Error
                  $log.debug(response);
                  vm.loading = false;
                  $rootScope.loadingProgress = false;
              });
      } else if ($state.params.id !== null && $state.params.id > 0) {
          getInvoiceDTO($state.params.id);
      }

    function resetSumTotals() {
      vm.sumTotalQuantity = 0;
      vm.sumSubTotalAfterTaxCurrency = 0;
      vm.sumSubTotalAfterTaxDocumentCurrency = 0;
      vm.sumSubTotalAfterTaxForeignCurrency = 0;
    }

      function getInvoiceDTO(id) {
          api.ComprasWS.InvoicePurchase.get({ id: 'getInvoicePurchaseDTO', idInvoice: id }, function (response) {// Success
              const responseConverted = convertInvoicePurchaseDTOtoEntityStructure(response);
              vm.invoiceDTO = responseConverted;
              vm.invoicePurchase = responseConverted.invoicePurchase;
              if (vm.invoicePurchase) {
                  const date = new Date(responseConverted.invoicePurchase.dateInvoicePurchase + ' 23:59:59');
                  vm.invoicePurchase.dateInvoicePurchase = date.toGMTString();
              }
              vm.currencies.push(vm.invoicePurchase.currency);
              if (vm.invoicePurchase.companyBuyer) {
                validateHasBudgetApplication(vm.invoicePurchase.companyBuyer.id);
              }
              if (vm.invoicePurchase.companyProvider) {
                  getRegimeProvider();
                  validateRegime();
              }
              verifyInvoiceLoadedPOS();
              vm.companies.push(vm.invoicePurchase.companyBuyer);
              getSeries();
              vm.invoicePurchase.filesQuotation = [];
              if (response.quotationFile) {
                vm.invoicePurchase.filesQuotation = [response.quotationFile];
              }
              api.ComprasWS.InvoicePurchaseFiles.get({ id: $state.params.id }, function (response) {// Success
                  vm.invoicePurchase.files = response;
                  vm.filesPurchase = response;
                  $timeout(function () {
                      if (vm.invoicePurchaseForm.$valid && vm.filesPurchase.length > 0 && $state.params.detail !== null && $state.params.detail !== '') {
                          vm.currentTab = 1;
                      }
                  }, 400);
              }, function (response) {// Error
                  vm.loading = false;
                  $rootScope.loadingProgress = false;
              });
              vm.details = responseConverted.details;
              setColumnsAndDataMasterGridOptionsE(vm.details);

              pinnedBottomRowDataDetails();
              processInvoicePurchaseWithholdings(responseConverted.invoicePurchaseWithholdings);
              vm.loading = false;
              $rootScope.loadingProgress = false;
              $log.debug(vm.merchandiseEntries);
              validateFixedAssets();
          }, function (errgetInvoiceDTO) {// Error
              $log.debug(errgetInvoiceDTO);
              vm.loading = false;
              $rootScope.loadingProgress = false;
          });
      }

    function processInvoicePurchaseWithholdings(invoicePurchaseWithholdings) {
      vm.InvoiceWithholdingDetails = [];
      vm.masterGridOptionsRet.api.setColumnDefs(vm.masterColumnDefsRet);

      if (!invoicePurchaseWithholdings) {
        vm.masterGridOptionsRet.api.setRowData(vm.InvoiceWithholdingDetails);
        return;
      }
      invoicePurchaseWithholdings.forEach(
        function (invoicePurchaseWithholding) {
          invoicePurchaseWithholding.invoicePurchaseWithholdingDetails.forEach(
            function (detail) {
              detail.invoicePurchaseWithholding = invoicePurchaseWithholding;
              vm.InvoiceWithholdingDetails.push(detail);
            });
        });
      vm.masterGridOptionsRet.api.setRowData(vm.InvoiceWithholdingDetails);
    }

      function setColumnsAndDataMasterGridOptionsE(details) {
        resetSumTotals();
        vm.masterGridOptionsE.api.setColumnDefs(vm.masterColumnDefs);
        vm.masterGridOptionsE.api.setRowData(details);
      }

      function verifyFeaturesDetail() {
          vm.details.forEach(function (detail) {
              api.ComprasWS.PurchaseOrderDetail.getId(
                  {
                      'id': detail.invoicePurchaseDetail.merchandiseEntry.purchaseOrderDetail.id,
                      idCircle: $rootScope.bsCircle.id, idPurchaseOrder: detail.invoicePurchaseDetail.merchandiseEntry.purchaseOrderDetail.purchaseOrder.id
                  }, function (data) {
                      api.ActivosFijosWS.FixedAsset.me.query({
                          'fixedAssetId': 'byQuotatonDetail',
                          'companyId': detail.invoicePurchaseDetail.merchandiseEntry.purchaseOrderDetail.purchaseOrder.companyProvider.id,
                          'quotationDetailId': detail.invoicePurchaseDetail.merchandiseEntry.purchaseOrderDetail.id
                      }).$promise.then(function (fixedAssets) {
                          vm.fixedAssets = fixedAssets.sort(function (a, b) {
                              return a.id - b.id;
                          });
                          vm.fixedAssetsToUpdate = fixedAssets;
                          vm.viewButton = !(data.quotationDetail.requisitionDetail.quantity > vm.fixedAssets.length);
                      }, function (response) {
                          $log.error(response);
                      });
                  }, function (errResponse) {
                  });

          });
      }

      function validateFixedAssets() {
        var productsId = vm.details.map(function (value) {
          return value.invoicePurchaseDetail.product["id"];
        });
        var companysId = vm.invoicePurchase.companyBuyer.id;
        api.GeneralWS.ProductCompanyAddonsByProductsId.getList(
          {
            'companyId': companysId,
            'productsId': productsId.join(','),
          })
          .$promise.then(
            function (data) {
              if (data.length > 0) {
                validateFixedAssetsByProductAddons(data);
              }
            }
          );
      }

    function validateFixedAssetsByProductAddons(data) {
      data.map(function (value) {
        var companysId = vm.quotation.requisition.department.company.id;
        api.ActivosFijosWS.FixedAssetGroupFeature.countByCompany.get(
          {
            'companyId': companysId,
            'fixedAssetGroupId': value,
            'isProvider': true,
          }, function (count) {
            if (count.$status !== 204) {
              verifyFeaturesDetail();
            }
          }, function (data) {
            $log.debug(data);
            $rootScope.loadingProgress = false;
          });
      });
    }


      vm.masterColumnDefs = [

      ];


      vm.masterColumnDefsRet = [
          {
              headerName: 'INVOICE.WITHHOLDING_DETAIL.RATE',
              field: "ratepercent",
              headerCellRenderer: getHeader,
              width: 250
          },
          {
              headerName: $filter('translate')('INVOICE.WITHHOLDING_DETAIL.VALUE_RATE'),
              field: "valueWithholding",
              headerCellRenderer: getHeader,
              width: 200,
              enableRowGroup: true,
              enablePivot: true,
              cellStyle: { 'text-align': 'right' },
              valueFormatter: function (params) {
                  return $filter('number')(params.value, 2);
              },
              aggFunc: 'sum'
          }

      ];

    function getPriceAfterTaxCurrency(dataItem) {
      let result = 0;
      if (dataItem.invoicePurchaseDetail.priceAfterTax) {
        result = dataItem.invoicePurchaseDetail.priceAfterTax.toFixed(vm.number_two);
      } else {
        result = result.toFixed(vm.number_two);
      }
      return dataItem.invoicePurchaseDetail.invoicePurchase.currency.symbol + '. ' + $filter('number')(result, vm.number_two);
    }

    function getSubTotalAfterTaxCurrency(dataItem) {
      let result = 0;
      if (dataItem.invoicePurchaseDetail.subTotalAfterTax) {
        result = dataItem.invoicePurchaseDetail.subTotalAfterTax.toFixed(vm.number_two);
      } else {
        result = result.toFixed(vm.number_two);
      }
      return dataItem.invoicePurchaseDetail.invoicePurchase.companyCurrency.symbol + '. ' + $filter('number')(result, vm.number_two);
    }

    function getSubTotalAfterTaxDocumentCurrency(dataItem) {
      let result = 0;
      if (dataItem.invoicePurchaseDetail.documentSubTotalAfterTax) {
        result = dataItem.invoicePurchaseDetail.documentSubTotalAfterTax.toFixed(vm.number_two);
      } else {
        result = result.toFixed(vm.number_two);
      }
      return dataItem.invoicePurchaseDetail.invoicePurchase.currency.symbol + '. ' + $filter('number')(result, vm.number_two);
    }

    function getSubTotalAfterTaxForeignCurrency(dataItem) {
      let result = 0;
      if (dataItem.invoicePurchaseDetail.foreignSubTotalAfterTax) {
        result = dataItem.invoicePurchaseDetail.foreignSubTotalAfterTax.toFixed(vm.number_two);
      } else {
        result = result.toFixed(vm.number_two);
      }
      return dataItem.invoicePurchaseDetail.invoicePurchase.foreignCurrency.symbol + '. ' + $filter('number')(result, vm.number_two);
    }

      vm.masterGridOptionsE = {
          columnDefs: vm.masterColumnDefs,
          enableSorting: true,
          debug: false,
          enableFilter: true,
          enableColResize: true,
          angularCompileRows: true,
          angularCompileHeaders: true,
          rowData: null,
          groupHeaders: true,
          headerHeight: 50,
          rowHeight: 45,
          pinnedBottomRowData:[],
          doesDataFlower: function (dataItem) {
            vm.symbol = dataItem.invoicePurchaseDetail.invoicePurchase.currency.symbol;
            vm.sumTotalQuantity = vm.sumTotalQuantity + dataItem.invoicePurchaseDetail.quantity;
            dataItem.invoicePurchaseDetail.priceAfterTaxCurrency = getPriceAfterTaxCurrency(dataItem);

            dataItem.invoicePurchaseDetail.subTotalAfterTaxCurrency = getSubTotalAfterTaxCurrency(dataItem);
            vm.sumSubTotalAfterTaxDocumentCurrency = vm.sumSubTotalAfterTaxDocumentCurrency + dataItem.invoicePurchaseDetail.subTotalAfterTax;

            dataItem.invoicePurchaseDetail.subTotalAfterTaxDocumentCurrency = getSubTotalAfterTaxDocumentCurrency(dataItem);
            vm.sumSubTotalAfterTaxCurrency = vm.sumSubTotalAfterTaxCurrency + dataItem.invoicePurchaseDetail.documentSubTotalAfterTax;

            dataItem.invoicePurchaseDetail.subTotalAfterTaxForeignCurrency = getSubTotalAfterTaxForeignCurrency(dataItem);
            vm.sumSubTotalAfterTaxForeignCurrency = vm.sumSubTotalAfterTaxForeignCurrency + dataItem.invoicePurchaseDetail.foreignSubTotalAfterTax;
            return true;
          },
          isExternalFilterPresent: isExternalFilterPresent,
          doesExternalFilterPass: doesExternalFilterPass,
          getMainMenuItems: function (params) {
              return getHeaderMenu(params, $filter);
          },
          localeTextFunc: function (key, defaultValue) {
              return translateGrid(key, defaultValue, $filter);
          }
      };

      vm.masterGridOptionsRet = {
          columnDefs: vm.masterColumnDefsRet,
          enableSorting: true,
          debug: false,
          enableFilter: true,
          enableColResize: true,
          angularCompileRows: true,
          angularCompileHeaders: true,
          rowData: null,
          headerHeight: 50,
          rowHeight: 45,
          doesDataFlower: function (dataItem) {
              var ref = '';
              if (dataItem.invoicePurchaseWithholding.fileWithholdingId) {
                const invoicePurchaseWithholding = dataItem.invoicePurchaseWithholding;
                ref = '<a href="' + vm.URLPHOTOS
                  + invoicePurchaseWithholding.fileWithholdingParentPath
                  + invoicePurchaseWithholding.fileWithholdingName
                  + invoicePurchaseWithholding.fileWithholdingExtension
                  + '">Ver Imagen </a> ';
              }
              dataItem.ratepercent = dataItem.withholdingCode + ' ' + dataItem.rate + '% ' + ref;
              return false;
          },
          getMainMenuItems: function (params) {
              return getHeaderMenu(params, $filter);
          },
          localeTextFunc: function (key, defaultValue) {
              return translateGrid(key, defaultValue, $filter);
          },
          groupRowInnerRenderer: function (params) {
              return params.value;
          }
      };

      var filter = 'everyone';

      function isExternalFilterPresent() {
          // if ageType is not everyone, then we are filtering
          return filter !== '';
      }

      function doesExternalFilterPass(node) {
          if (filter && filter !== 'everyone') {
              var arrdt = node.data.filter.split(filter);
              return arrdt.length > 1;
          }
          return true;
      }

      $scope.$watch('vm.search',
          function (newValue) {
              filter = newValue;
              if (vm.masterGridOptionsE.api) {
                  vm.masterGridOptionsE.api.onFilterChanged();
              }
              if (vm.masterGridOptionsRet.api) {
                  vm.masterGridOptionsRet.api.onFilterChanged();
              }

          }
      );

      $scope.originForm;

      function goToInvoicePurchases() {
          if (PreviousState && PreviousState.name) {
              $state.go(PreviousState.name.replace('.detail', ''));
          } else {
              $state.go('app.invoice.Ingresando');
          }
      }

      function saveInvoicePurchase() {
          $rootScope.loadingProgress = true;
          vm.newInvoicePurchase = {
              invoiceSerie: { id: vm.invoicePurchase.invoiceSerie },
              correlative: vm.invoicePurchase.correlative,
              regime: { id: vm.invoicePurchase.regime.id },
              companyBuyer: {
                  id: vm.invoicePurchase.companyBuyer.id
              },
              companyProvider: {
                  id: vm.invoicePurchase.companyProvider.id
              },
              dateInvoicePurchase: vm.invoicePurchase.dateInvoicePurchase,
              currency: { id: vm.invoicePurchase.currency.id },
              purchaseStatus: { description: 'Ingresando' },
              totalAfterTax: 0,
              originType: { originTypeCode: '10' },
              exchangeRate: vm.invoicePurchase.exchangeRate,
              electronicSignature: vm.invoicePurchase.electronicSignature,
              controlNumber: vm.invoicePurchase.controlNumber,
              uuid: vm.invoicePurchase.uuid,
              invoicePurchaseType: vm.invoicePurchase.invoicePurchaseType,

          };

          if(vm.invoicePurchase.invoiceSerie) {
            vm.newInvoicePurchase.invoiceSerie = { id: vm.invoicePurchase.invoiceSerie.id };
          }
          if (vm.filesToUpload.length > 0 || vm.filesToUploadQuotation.length > 0) {
              vm.loadFilesConfig = {
                invoice: {
                  loading: false,
                  filesToUpload: vm.filesToUpload,
                  processFilesFunction: invoiceFilesToSaveInvoice,
                  saveInvoiceFunction: save,
                },
                quotation: {
                  loading: false,
                  filesToUpload: vm.filesToUploadQuotation,
                  processFilesFunction: quotationFilesToSaveInvoice,
                  saveInvoiceFunction: save,
                },
              };
              processFilesAndSave('invoice');
              processFilesAndSave('quotation');
          } else {
              save();
          }

      }

      function processFilesAndSave(fileType) {
        if (vm.loadFilesConfig[fileType].filesToUpload.length === 0) {
          return;
        }
        vm.loadFilesConfig[fileType].loading = true;

        var files = [];
        vm.loadFilesConfig[fileType].filesToUpload.forEach(function (r) {
          files.push(r.file.file);
        });

        $rootScope.loadingProgress = true;
        api.GeneralWS.Common.FileStorage.filesUpload.add({ 'companyId': vm.invoicePurchase.companyProvider.id }, files).then(function (response) {
          afterSaveFile(fileType, response.data);
        }, function (errResponse) {
          $log.error(errResponse);
          $rootScope.loadingProgress = false;
          MessageService.showErrorMessage(errResponse.data.mensaje);
        });
      }

      function afterSaveFile(fileType, files) {
        vm.loadFilesConfig[fileType].loading = false;
        if (files.length > 0) {
          vm.loadFilesConfig[fileType].processFilesFunction(files);
        }
        if (vm.loadFilesConfig.invoice.loading === false && vm.loadFilesConfig.quotation.loading === false) {
          $rootScope.loadingProgress = false;
          vm.loadFilesConfig[fileType].saveInvoiceFunction();
        }
      }

      function invoiceFilesToSaveInvoice(files) {
          vm.invoicePurchase.files = files;
          vm.newInvoicePurchase.files = files;
          vm.filesPurchase = files;
      }

      function quotationFilesToSaveInvoice(files) {
        vm.invoicePurchase.quotationFileId = files[0].id;
        vm.invoicePurchase.filesQuotation = files;
        vm.newInvoicePurchase.quotationFileId = files[0].id;
        vm.newInvoicePurchase.filesQuotation = files;
      }

      function updateInvoicePurchase() {
          if (vm.filesToUpload.length > 0 || vm.filesToUploadQuotation.length > 0) {
            vm.loadFilesConfig = {
              invoice: {
                loading: false,
                filesToUpload: vm.filesToUpload,
                processFilesFunction: invoiceFilesToUpdateInvoice,
                saveInvoiceFunction: update,
              },
              quotation: {
                loading: false,
                filesToUpload: vm.filesToUploadQuotation,
                processFilesFunction: quotationFilesToUpdateInvoice,
                saveInvoiceFunction: update,
              },
            };
            processFilesAndSave('invoice');
            processFilesAndSave('quotation');
          } else {
              update();
          }
      }

      function invoiceFilesToUpdateInvoice(files) {
        vm.invoicePurchase.files = files;
        vm.filesToUpload = [];
      }

      function quotationFilesToUpdateInvoice(files) {
        vm.invoicePurchase.quotationFileId = files[0].id;
        vm.invoicePurchase.filesQuotation = files;
        vm.filesToUploadQuotation = [];
        vm.loadFilesConfig.quotation.newFiles = files;
      }

      function getRegimeProvider() {
          if (vm.invoicePurchase.companyProvider) {
              api.GeneralWS.Regime.getByCompany.get({ id: 'Company', companyId: vm.invoicePurchase.companyProvider.id }).$promise.then(function (response) {
                  vm.regimes = response;
                  if (vm.regimes.length === 1 && !vm.invoicePurchase.id) {
                      vm.invoicePurchase.regime = vm.regimes[0];
                  }

                  if (vm.invoicePurchase.regime) {
                      for (var i = 0; i < vm.regimes.length; i++) {
                          if (vm.regimes[i].id === vm.invoicePurchase.regime.id) {
                              vm.invoicePurchase.regime = vm.regimes[i];
                          }
                      }
                  }
              }, function (errResponse) {
                  $rootScope.loadingProgress = false;
                  MessageService.showErrorMessage(errResponse.data.mensaje);
              });
          }
      }

      function renderer(params) {

          if (params.data.invoicePurchaseDetail && params.data.invoicePurchaseDetail.merchandiseEntry
            && params.data.invoicePurchaseDetail.merchandiseEntry.purchaseOrderDetail.contractPurchaseDetail) {
              vm.isContractFixed = params.data.invoicePurchaseDetail.merchandiseEntry.purchaseOrderDetail.contractPurchaseDetail.contractPurchase.fixed;
          }
          var resp = '';
          if (vm.isContractFixed) {
              resp = '<div style="width: 100%;"> '
                  + ' <md-button '
                  + 'ng-if="data.invoicePurchaseDetail.id" '
                  + 'class="edit-button md-icon-button" '
                  + 'ng-click="vm.goToInvoicePurchaseDetailEdit(data.invoicePurchaseDetail)" aria-label="Order details"'
                  + '        translate translate-attr-aria-label="REQUISITION.ORDER_DETAILS">'
                  + ' <md-tooltip md-direction="bottom">'
                  + '     {{"REQUISITION.DETAIL.VIEW"| translate}}'
                  + ' </md-tooltip>'
                  + ' <md-icon md-font-icon="icon-eye" class="s16"></md-icon> '
                  + ' </md-button>'
                  + '                                     <md-button ng-if="data.invoicePurchaseDetail.id" '
                  + 'class="edit-button md-icon-button" ng-click="vm.goToAddDiscount(data)" '
                  + ' aria-label="Order details" translate translate-attr-aria-label="REQUISITION.ADD_DISCOUNT">'
                  + ' <md-tooltip md-direction="bottom">'
                  + '     {{"INVOICE.SALE_INVOICE.DETAIL.DISCOUNT.DISCOUNT"| translate}}'
                  + ' </md-tooltip>'
                  + ' <md-icon md-font-icon="icon-square-inc-cash" class="s16"></md-icon> '
                  + ' </md-button>';
          } else {
              resp = '<div style="width: 100%;">'
                  + '             <md-button ng-if="data.invoicePurchaseDetail.id" '
                  + 'class="edit-button md-icon-button" ng-click="vm.goToInvoicePurchaseDetailEdit(data.invoicePurchaseDetail)" '
                  + ' aria-label="Order details"'
                  + '                            translate translate-attr-aria-label="REQUISITION.ORDER_DETAILS">'
                  + '                     <md-tooltip md-direction="bottom">'
                  + '                         {{"REQUISITION.DETAIL.VIEW"| translate}}'
                  + '                     </md-tooltip>'
                  + '                     <md-icon md-font-icon="icon-eye" class="s16"></md-icon> '
                  + '                 </md-button>'
                  + '                 <md-button ng-if="!vm.viewInput && data.invoicePurchaseDetail.product" class="edit-button md-icon-button" '
                  + ' ng-click="vm.viewInput=true; vm.priceToUpdate = data.invoicePurchaseDetail.priceAfterTax" aria-label="Order details"'
                  + '                            translate translate-attr-aria-label="REQUISITION.ORDER_DETAILS">'
                  + '                     <md-tooltip md-direction="bottom">'
                  + '                         {{"INVOICE.EDIT"| translate}}'
                  + '                     </md-tooltip>'
                  + '                     <md-icon md-font-icon="icon-pencil" class="s16"></md-icon> '
                  + '                 </md-button>'
                  + '                 <md-button ng-if="vm.viewInput && data.invoicePurchaseDetail.product" class="edit-button md-icon-button" '
                  + ' ng-click="vm.viewInput=false; vm.updatePrice(data.invoicePurchaseDetail)" aria-label="Order details"'
                  + '                            translate translate-attr-aria-label="REQUISITION.ORDER_DETAILS">'
                  + '                     <md-tooltip md-direction="bottom">'
                  + '                         {{"INVOICE.INVOICE_PURCHASE.DETAIL.SAVE_CHANGES"| translate}}'
                  + '                     </md-tooltip>'
                  + '                     <md-icon md-font-icon="icon-content-save" class="s16"></md-icon> '
                  + '                 </md-button>';
          }
        if (params.data.invoicePurchaseDetail && params.data.invoicePurchaseDetail.merchandiseEntry
          && params.data.invoicePurchaseDetail.merchandiseEntry.purchaseOrderDetail.quotationDetail
          && params.data.invoicePurchaseDetail.merchandiseEntry.purchaseOrderDetail.quotationDetail.isFixedAsset) {
          resp = resp + '<md-button ng-if="data.invoicePurchaseDetail.id" class="edit-button md-icon-button"'
            + ' ng-click="vm.addFeatures(data.invoicePurchaseDetail.merchandiseEntry.purchaseOrderDetail, $index, $event)"'
            + '            aria-label="Product details"'
            + '            translate translate-attr-aria-label="REQUISITION.PRODUCT_DETAILS">'
            + '     <md-icon md-font-icon="icon-border-color" class="s16"></md-icon> '
            + ' <md-tooltip md-direction="left">{{"QUOTATION.DETAIL.FEATURES.EDIT"| translate}}</md-tooltip>'
            + ' </md-button>';
        }
          return resp + '</div>';
      }

      function rendererDescription(data) {
        if (data) {
          return '<div style="width: 100%;">'
            + ' <md-button ng-if="data.invoicePurchaseDetail.id" '
            + 'class="edit-button md-icon-button" ng-click="vm.editDescription(data.invoicePurchaseDetail)" '
            + 'aria-label="Order details"'
            + '                                translate translate-attr-aria-label="REQUISITION.ORDER_DETAILS">'
            + '                         <md-tooltip md-direction="bottom">'
            + '                             {{"INVOICE.EDIT"| translate}}'
            + '                         </md-tooltip>'
            + '                         <md-icon md-font-icon="icon-pencil" class="s16"></md-icon> '
            + '                     </md-button>'
            + ' <span>{{data.invoicePurchaseDetail.description}}</span>'
            + ' </div>';
        }else {
          return '';
        }
      }

      vm.editDescription = function (data) {
          $mdDialog.show({
              controller: 'DescriptionDetailDialogController',
              controllerAs: 'vm',
              templateUrl: 'app/main/apps/invoice/saleInvoice/editDescription/description-dialog.html',
              parent: angular.element("#main"),
              invoiceDetail: data,
              clickOutsideToClose: false
          }).then(function (answer) {
              data = answer;
          });
      };

      function goToInvoicePurchaseDetailEdit(data) {
          $mdDialog.show({
              controller: 'DetailEditorController',
              controllerAs: 'vm',
              templateUrl: 'app/main/apps/invoice/saleInvoice/detailEditor/detailEditor.html',
              parent: angular.element("#main"),
              InvoicePurchase: vm.invoicePurchase,
              serie: vm.invoicePurchase.invoiceSerie,
              edited: data,
              id: data.id,
              Taxes: vm.taxes,
              canEdit: false,
              clickOutsideToClose: false
          }).then(function (answer) {
              answer === true ? goToInvoicePurchases() : null;
          });
      }
      function goToAddDiscount(data, index) {
          $mdDialog.show({
              controller: 'DicountDialogController',
              controllerAs: 'vm',
              templateUrl: 'app/main/apps/invoice/saleInvoice/detailEditor/discount-dialog.html',
              parent: angular.element("#main"),
              invoiceDetail: angular.copy(data.invoicePurchaseDetail),
              taxes: angular.copy(vm.taxes),
              clickOutsideToClose: false,
              multiple: true
          }).then(function (answer) {
              answer.invoicePurchase = Object.assign({}, vm.invoicePurchase, answer.invoicePurchase);
              answer.filter = (answer.product.name + ","
                  + answer.merchandiseEntry.purchaseOrderDetail.purchaseOrder.department.description + ","
                  + answer.merchandiseEntry.purchaseOrderDetail.purchaseOrder.costCenter.description).toLowerCase();
              var detailDTO = { detailTax: {}, invoicePurchaseDetail: answer };
              vm.details[vm.details.indexOf(data)] = detailDTO;
            setColumnsAndDataMasterGridOptionsE(vm.details);
            pinnedBottomRowDataDetails();
              resizeAllColumns();
              update();

          });
      }

      function save() {
        const invoicePurchaseDetails = [];
          if (vm.merchandiseEntries) {
              $rootScope.loadingProgress = true;
              var details = vm.merchandiseEntries;
              var newInvoicePurchaseDetail;
              for (var i = 0; i < details.length; i++) {
                  newInvoicePurchaseDetail = {
                    merchandiseEntry: { id: details[i].id },
                    product: {
                      id: details[i].purchaseOrderDetail.product.id
                    },
                    quantity: details[i].quantitySold - details[i].quantityInvoice,
                    priceAfterTax: details[i].purchaseOrderDetail.price
                  };
                  invoicePurchaseDetails.push(newInvoicePurchaseDetail);
                }
          }
        const invoicePurchaseCreateDTO = {
          invoicePurchase: vm.newInvoicePurchase,
          details: invoicePurchaseDetails,
        };

        cleanInvoiceSerieAndCorrelative(invoicePurchaseCreateDTO.invoicePurchase);

          api.ComprasWS.InvoicePurchase.saveInvoice(
            { id: 'createInvoice', idCircle: $rootScope.bsCircle.id }, invoicePurchaseCreateDTO).$promise.then(function (invoicePurchase) {
                  invoicePurchase = convertInvoicePurchaseDTOtoEntityStructure(invoicePurchase);
                  vm.invoiceDTO = invoicePurchase;
                  invoicePurchase.invoicePurchase.dateInvoicePurchase = new Date(invoicePurchase.invoicePurchase.dateInvoicePurchase + ' 23:59:59');
                  vm.invoicePurchase = invoicePurchase.invoicePurchase;
                  vm.details = invoicePurchase.details;
                  if (vm.merchandiseEntries.length > 0) {
                      $state.go('app.invoice.Ingresando.detail', { id: invoicePurchase.invoicePurchase.id });
                  } else {
                      getInvoiceDTO(invoicePurchase.invoicePurchase.id);
                  }
                  vm.merchandiseEntries = [];
                  vm.currentTab = 1;
                  $rootScope.loadingProgress = false;
              }, function (errResponse) {
                  $rootScope.loadingProgress = false;
                  if (errResponse.data && errResponse.data.mensaje) {
                      if (errResponse.data.mensaje === 'MerchandiseEntry Diferente Type') {
                          MessageService.showErrorMessage($filter('translate')('INVOICE.MSG.DIFERENT_TYPE_'));
                      } else {
                          MessageService.showErrorMessage($filter('translate')(errResponse.data.mensaje));
                      }
                  } else if (errResponse.data){
                    MessageService.showErrorMessage(errResponse.data);
                  } else {
                      MessageService.showErrorMessage($filter('translate')('INVOICE.MSG.ERROR_TO_SAVE_INVOICE'));
                  }
              });
      }

      function update() {
          const invoicePurchaseDetails = [];
          $rootScope.loadingProgress = true;
          var details = vm.details;
          for (var i = 0; i < details.length; i++) {
            invoicePurchaseDetails.push(details[i].invoicePurchaseDetail);
          }

        cleanInvoiceSerieAndCorrelative(vm.invoicePurchase);
          const invoicePurchaseCreateDTO = {
              invoicePurchase: vm.invoicePurchase,
              details: invoicePurchaseDetails
          };

          if (invoicePurchaseCreateDTO.invoicePurchase.invoiceSerie){
            invoicePurchaseCreateDTO.invoicePurchase.invoiceSerie = {
              id: invoicePurchaseCreateDTO.invoicePurchase.invoiceSerie.id,
            };
          }

        api.ComprasWS.InvoicePurchase.updateDTO(
              {
                  id: 'updateDTO', idCircle: $rootScope.bsCircle.id,
                  idInvoice: invoicePurchaseCreateDTO.invoicePurchase.id
                }, invoicePurchaseCreateDTO).$promise.then(function (response) {
                  response.body = convertInvoicePurchaseDTOtoEntityStructure(response.body);
                  vm.invoiceDTO = response.body;
                  vm.invoicePurchase = vm.invoiceDTO.invoicePurchase;
                  vm.invoicePurchase.dateInvoicePurchase = new Date(vm.invoicePurchase.dateInvoicePurchase);
                  $rootScope.loadingProgress = false;
                  vm.currentTab = 1;
                  if (vm.isNew) {
                      MessageService.show($filter('translate')('INVOICE.CREATED'));
                  } else {
                      MessageService.show($filter('translate')('INVOICE.UPDATED'));
                  }
                  vm.details = vm.invoiceDTO.details;
            setColumnsAndDataMasterGridOptionsE(vm.details);
            pinnedBottomRowDataDetails();
                  vm.productBudget = {};
                  processInvoicePurchaseWithholdings(response.invoicePurchaseWithholdings);
                  getInvoiceDTO(vm.invoicePurchase.id);
              }, function (errResponseUpDTO) {
                  $rootScope.loadingProgress = false;
                  if (errResponseUpDTO.data && errResponseUpDTO.data.mensaje) {
                      MessageService.showErrorMessage($filter('translate')(errResponseUpDTO.data.mensaje));
                  } else {
                      MessageService.showErrorMessage($filter('translate')(errResponseUpDTO.data));
                  }
              });
      }

      function querySearch(numberSelect, query) {
          var results;
          if (numberSelect) {
              if (numberSelect === 1) {
                  results = query ? vm.companies.filter(createFilterFor(1, query)) : vm.companies;
              }
              if (numberSelect === 2) {
                  results = query ? vm.regimes.filter(createFilterFor(1, query)) : vm.regimes;
              }
              if (numberSelect === 1) {
                  results = query ? vm.currencies.filter(createFilterFor(1, query)) : vm.currencies;
              }
          }
          return results;
      }
      function createFilterFor(fieldFilter, query) {
          var lowercaseQuery = angular.lowercase(query);
          return function filterFn(model) {
              var lowercaseName = '';
              if (fieldFilter === 1) {
                  lowercaseName = angular.lowercase(model.name);
              }
              if (fieldFilter === 2) {
                  lowercaseName = angular.lowercase(model.name);
              }
              if (fieldFilter === 3) {
                  lowercaseName = angular.lowercase(model.description);
              }

              return (lowercaseName.indexOf(lowercaseQuery) === 0 || lowercaseName.indexOf(lowercaseQuery) > 0);
          };
      }

      function getSeries() {
          if (vm.invoicePurchase.companyProvider) {
              api.GeneralWS.InvoiceSeries.getByCompany({ companyId: vm.invoicePurchase.companyProvider.id }).$promise.then(function (response) {
                  vm.series = new jinqJs()
                      .from(response)
                      .select();
                  getDocumentTypeSeries(vm.series);
                  if (vm.series.length === 1 && !vm.invoicePurchase.invoiceSerie) {
                      vm.invoicePurchase.invoiceSerie = vm.series[0];
                      validateDateInvoicePurchace();
                  }

                  if (vm.invoicePurchase.invoiceSerie) {
                      for (var i = 0; i < vm.series.length; i++) {
                          if (vm.series[i].id === vm.invoicePurchase.invoiceSerie.id) {
                              vm.invoicePurchase.invoiceSerie = vm.series[i];
                          }
                      }
                  }

              }, function (errResponse) {
                  $rootScope.loadingProgress = false;
                  MessageService.showErrorMessage(errResponse.data.mensaje);
              });
          }
      }

      function getDocumentTypeSeries(series) {
        api.GeneralWS.InvoiceSeriesDocumentType.query({ companyId: vm.invoicePurchase.companyProvider.id }).$promise.then(function (response) {
          var seriesChanged = series.map(function (sr) {
            var resp = response.filter(function (rp) { return rp.id === sr.invoiceSerieDocumentType });
            if (resp.length > 0) {
              sr.invoiceSerieDocumentTypeOb = resp[0];
            }
            return sr;
          });
          vm.series = seriesChanged;
        }, function (errResponse) {
          $rootScope.loadingProgress = false;
        });
      }

      function setStatusInvoices() {
          var confirm = $mdDialog.confirm()
              .title($filter('translate')('INVOICE.MSG.' + $stateParams.status + '_INVOICE'))
              .textContent($filter('translate')('INVOICE.MSG.CONFIRMACION_' + $stateParams.status + '_INVOICE'))
              .ok($filter('translate')('INVOICE.MSG.SI'))
              .cancel($filter('translate')('INVOICE.MSG.NO'));
        if (vm.requestAmpliationButton) {
          confirm = $mdDialog.confirm()
            .title($filter('translate')('INVOICE.MSG.REQUEST_AMPLIATION_INVOICE'))
            .textContent($filter('translate')('INVOICE.MSG.CONFIRMACION_REQUEST_AMPLIATION_INVOICE'))
            .ok($filter('translate')('INVOICE.MSG.SI'))
            .cancel($filter('translate')('INVOICE.MSG.NO'));
        }
          $mdDialog.show(confirm).then(function () {
              changeToEmittedStatus();
          }, function () {
          });
      }

      function viewIMG(file) {
          $mdDialog.show({
              controller: 'DialogPhotoController',
              controllerAs: 'vm',
              templateUrl: 'app/main/apps/files/dialogPhoto/dialogPhoto.html',
              parent: angular.element("#main"),
              name: file.originalName,
              url: vm.URLPHOTOS + file.parentPath + file.name + file.extension,
              clickOutsideToClose: false
          }).then(function (answer) {
              //go to Quotations
              answer === true ? goToInvoicePurchases() : null;
          });
      }

      vm.clearSearchCompanyBuyer = function () {
          vm.searchCompanyBuyer = "";
      };

      vm.clearSearchSerie = function () {
          vm.searchSerie = "";
      };

      vm.clearSearchRegime = function () {
          vm.searchRegime = "";
      };

      $timeout(function () {

          var keyEvent = function (event) {
              event.stopPropagation();
          };

          var searchSerieInput = document.querySelector("#searchSerie");
          var searchCompanyBuyerInput = document.querySelector("#searchCompanyBuyer");
          var searchRegimeInput = document.querySelector("#searchRegime");

          if (searchSerieInput) {
              searchSerieInput.addEventListener("keydown", keyEvent);
          }

          if (searchCompanyBuyerInput) {
              searchCompanyBuyerInput.addEventListener("keydown", keyEvent);
          }

          if (searchRegimeInput) {
              searchRegimeInput.addEventListener("keydown", keyEvent);
          }
      }, 500);

      function nextInvoicePurchase() {
          if (vm.invoicePurchase.id) {
              updateInvoicePurchase();
          } else {
              saveInvoicePurchase();
              vm.isNew = true;
          }
      }

      function updateFileInvoicePurchase() {

          if (vm.filesToUpload.length > 0 || vm.filesToUploadQuotation.length > 0) {
            vm.loadFilesConfig = {
              invoice: {
                loading: false,
                filesToUpload: vm.filesToUpload,
                processFilesFunction: invoiceFilesToUpdateInvoice,
                saveInvoiceFunction: invoiceSetFiles,
              },
              quotation: {
                loading: false,
                filesToUpload: vm.filesToUploadQuotation,
                processFilesFunction: quotationFilesToUpdateInvoice,
                saveInvoiceFunction: invoiceSetFiles,
                newFiles: [],
              },
            };
            processFilesAndSave('invoice');
            processFilesAndSave('quotation');
          }

      }

      function invoiceSetFiles() {
        $rootScope.loadingProgress = true;
        api.ComprasWS.InvoicePurchase.setFile(
          { id: 'setFile', idCircle: $rootScope.bsCircle.id }, vm.invoicePurchase).$promise.then(function (invoicePurchase) {
            invoicePurchase.dateInvoicePurchase = new Date(vm.invoicePurchase.dateInvoicePurchase);
            var quotationFiles = vm.invoicePurchase.filesQuotation;
            if (vm.loadFilesConfig && vm.loadFilesConfig.quotation && vm.loadFilesConfig.quotation.newFiles.length > 0) {
              quotationFiles = vm.loadFilesConfig.quotation.newFiles;
            }
            vm.invoicePurchase = invoicePurchase;
            vm.invoicePurchase.filesQuotation = quotationFiles;
            $rootScope.loadingProgress = false;
            vm.currentTab = 1;
            MessageService.show($filter('translate')('INVOICE.UPDATED'));
          }, function (errResponse) {
            MessageService.showErrorMessage(errResponse.data.mensaje);
          });
      }

    function rendererInput(data) {
      var viewInput = false;

      if (data.data.invoicePurchaseDetail && data.data.invoicePurchaseDetail.merchandiseEntry) {
          if (data.data.invoicePurchaseDetail.contractPurchaseFixed === false) {
            viewInput = true;
            vm.isContractFixed = false;
          }

        var includeTax = data.data.invoicePurchaseDetail.quotationDetailTaxesIncluded ?
          data.data.invoicePurchaseDetail.quotationDetailTaxesIncluded :
          data.data.invoicePurchaseDetail.contractPurchaseDetailTaxesIncluded;

        if (viewInput) {
          if (includeTax) {
            return '<div>'
              + '  <input ng-show="vm.viewInput" type="number" ng-model="data.invoicePurchaseDetail.priceAfterTax" '
              + ' name="inputPrice" title="Precio Con Impuesto" required id="inputPrice" style="width:90px"/>'
              + '    <span ng-show="!vm.viewInput">{{data.invoicePurchaseDetail.priceAfterTax | number : 2}}</span>'
              + '  </div>';
          } else {
            return '<div>'
              + '     <input ng-show="vm.viewInput" type="number" ng-model="data.invoicePurchaseDetail.priceBeforeTax" '
              + ' name="inputPrice" title="Precio Antes de Impuesto" required id="inputPrice" style="width:90px"/>'
              + '     <span ng-show="!vm.viewInput">{{data.invoicePurchaseDetail.priceBeforeTax | number : 2}}</span>'
              + '   </div>';
          }
        } else {
          return data.data.invoicePurchaseDetail.priceAfterTaxCurrency;
        }
      } else {
        return data.data.invoicePurchaseDetail.priceAfterTaxCurrency;
      }
    }

      function rendererSubtotal(data) {
        if (data.data.invoicePurchaseDetail) {
          return data.data.invoicePurchaseDetail.subTotalAfterTaxCurrency;
        } else {
          return 0;
        }
      }

      function rendererSubtotalDocument(data) {
        if (data.data.invoicePurchaseDetail) {
          return data.data.invoicePurchaseDetail.subTotalAfterTaxDocumentCurrency;
        } else {
          return 0;
        }
      }

      function rendererSubtotalForeign(data) {
        if (data.data.invoicePurchaseDetail) {
          return data.data.invoicePurchaseDetail.subTotalAfterTaxForeignCurrency;
        } else {
          return 0;
        }
      }

      function updatePrice(data) {
          if (data.priceAfterTax > 0 && !(vm.priceToUpdate === data.priceAfterTax)) {
              $rootScope.loadingProgress = true;
              api.ComprasWS.InvoicePurchaseDetailTax.InvoicePurchaseDetailTax.byInvoicePurchaseDetail(
                  { id: 'byInvoicePurchaseDetail', invoicePurchaseDetailId: data.id }).$promise.then(function (response) {
                      vm.detailsTax = response;
                  }, function (error) {
                      $rootScope.loadingProgress = false;
                      MessageService.showErrorMessage(error.data.mensaje);
                  });
          } else {
              data.priceAfterTax = vm.priceToUpdate;
          }
          update();
      }


      function changeToEmittedStatus() {
          $rootScope.loadingProgress = true;

          var valid = true;
          var invoiceDetails = new jinqJs()
              .from(vm.details)
              .where(function (detail) {
                  return detail.invoicePurchaseDetail.merchandiseEntry.purchaseOrderDetail.quotationDetail;
              })
              .select();
          for (var i = 0; i < vm.details.length; i++) {
              if (!vm.details[i].invoicePurchaseDetail.description
                  || vm.details[i].invoicePurchaseDetail.description === ''
                  || vm.details[i].invoicePurchaseDetail.description === undefined) {
                  valid = false;

                  break;
              }
          }

          if (!valid) {
              MessageService.showErrorMessage($filter('translate')('INVOICE.SALE_INVOICE.DETAIL.ADDDESCRIPTION'));
              $rootScope.loadingProgress = false;
              return false;
          }


          if (invoiceDetails.length > 0) {
              var quotationDetailsId = invoiceDetails.map(function (detail) {
                  return detail.invoicePurchaseDetail.merchandiseEntry.purchaseOrderDetail.quotationDetail.id;
              });
              api.ComprasWS.QuotationDetailReference.QuotationDetailReference.getByQuotationDetails(
                  {
                      id: 'byQuatationDetails',
                      circleId: $rootScope.bsCircle.id, quotationDetailsId: quotationDetailsId.toString()
                  }, function (quotationReferences) {
                      if (quotationReferences.length > 0) {
                          var invoiceDetailDTO = [];
                          var invoiceDetail;
                          var originTaxesIncluded;
                          quotationReferences.forEach(function (quotationReference) {
                              invoiceDetail = _.find(invoiceDetails, function (detail) {
                                  return detail.invoicePurchaseDetail.merchandiseEntry.purchaseOrderDetail.quotationDetail.id === quotationReference.quotationDetail.id;
                              });
                              originTaxesIncluded = quotationReference.quotationDetail.taxesIncluded;
                              invoiceDetailDTO.push({
                                  id: invoiceDetail.invoicePurchaseDetail.id,
                                  quantity: invoiceDetail.invoicePurchaseDetail.quantity,
                                  price: originTaxesIncluded === true ?
                                      (invoiceDetail.invoicePurchaseDetail.priceAfterTax * vm.invoicePurchase.exchangeRate) :
                                      (invoiceDetail.invoicePurchaseDetail.priceBeforeTax * vm.invoicePurchase.exchangeRate),
                                  subTotal: originTaxesIncluded === true ? invoiceDetail.invoicePurchaseDetail.subTotalAfterTax :
                                      invoiceDetail.invoicePurchaseDetail.subTotalBeforeTax,
                                  discount: originTaxesIncluded === true ?
                                      (invoiceDetail.invoicePurchaseDetail.discountAfterTax * vm.invoicePurchase.exchangeRate) :
                                      (invoiceDetail.invoicePurchaseDetail.discountBeforeTax * vm.invoicePurchase.exchangeRate),
                                  reference: quotationReference.noReference,
                                  quotationDetailId: quotationReference.quotationDetail.id,
                                  reservedQuantity: invoiceDetail.invoicePurchaseDetail.merchandiseEntry.quantity,
                                  referenceHeaderId: vm.invoicePurchase.id
                              });
                          });
                          var sendToBudgetApp = new jinqJs()
                              .from(invoiceDetailDTO)
                              .groupBy('id', 'quantity', 'price', 'subTotal', 'discount', 'quotationDetailId', 'reservedQuantity', 'referenceHeaderId')
                              .sum('reference')
                              .select(function (data) {
                                  data.reference = 0;
                                  return data;
                              });
                          api.PresupuestosWS.BudgetDetail.updateExecutedAmounts.update(
                              { idb: 0, circleId: $rootScope.bsCircle.id }, sendToBudgetApp, function (budgetDetailReferences) {
                                  var invoiceDetailReferences = [];
                                  budgetDetailReferences.forEach(function (budgetDetailReference) {
                                      invoiceDetailReferences.push({
                                          invoicePurchaseDetail: { id: budgetDetailReference.noReference },
                                          originType: { originTypeCode: '08' },
                                          noReference: budgetDetailReference.budgetDetail.id
                                      });
                                  });
                                  api.ComprasWS.InvoicePurchaseDetailReference.me.saveReferences(
                                      {
                                          id: 'createReferences',
                                          idCircle: $rootScope.bsCircle.id
                                      }, invoiceDetailReferences).$promise.then(function (invoiceDetailReferences) {
                                          changeStatus('Emitida');
                                      }, function (errResponse) {
                                          $rootScope.loadingProgress = false;
                                          MessageService.showErrorMessage(errResponse.data.mensaje);
                                      });
                              }, function (errResponse) {
                                  if (errResponse.status === 409) {
                                      var errorMessage = errResponse.data.split(";");
                                      MessageService.showErrorMessage(($filter('translate')(errorMessage[0])) + errorMessage[1]);
                                  } else {
                                      MessageService.showErrorMessage(errResponse.data.mensaje);
                                  }
                                  $rootScope.loadingProgress = false;
                                  $log.debug(errResponse);
                              });
                      } else {
                          changeStatus('Emitida');
                      }

                  }, function (errResponse) {
                      $rootScope.loadingProgress = false;
                      MessageService.showErrorMessage(errResponse.data.mensaje);
                      $log.debug(errResponse);
                  });
          } else {
             if(vm.hasBudgetApplication
              && vm.details[0].invoicePurchaseDetail.merchandiseEntry.purchaseOrderDetail.contractPurchaseDetail.contractPurchase
              && !vm.details[0].invoicePurchaseDetail.merchandiseEntry.purchaseOrderDetail.contractPurchaseDetail.contractPurchase.fixed){
              reserveBudgetByContract();
            } else{
              changeStatus('Emitida');
            }
          }
      }
      function changeStatus(status) {
        var localInvoice = vm.invoicePurchase;
        if (localInvoice.invoiceSerie){
          localInvoice.invoiceSerie = { id: localInvoice.invoiceSerie.id };
        }
          api.ComprasWS.InvoicePurchase.setStatus(
              { id: 'changeStatus', idCircle: $rootScope.bsCircle.id, status: status }, localInvoice).$promise.then(function (response) {
                  if (response.purchaseStatus.description === 'Emitida') {
                      MessageService.show("Nuevo Estado: " + ($filter('translate')('INVOICE.PENDING_PRECHECK')) + " Para la factura No. " + response.id);
                  } else {
                      MessageService.show("Nuevo Estado: " + response.purchaseStatus.description + " Para la factura No. " + response.id);
                  }
                  $state.go('app.invoice.' + $stateParams.status);
                  $rootScope.loadingProgress = false;
              }, function (errResponse) {
                  $rootScope.loadingProgress = false;
                  MessageService.showErrorMessage(errResponse.data.mensaje);
              });
      }

      function resizeAllColumns() {
          //hace el autoSize para ajustar todas las columnas
          var allColumnIds = [];
          vm.masterColumnDefs.forEach(function (columnDef) {
              if (columnDef.field) {
                  allColumnIds.push(columnDef.field);
              }
          });

          $timeout(function () {
              vm.masterGridOptionsE.columnApi.autoSizeColumns(allColumnIds);
              vm.masterGridOptionsE.api.sizeColumnsToFit();
          }, 500);
      }

    function changeCancelStatusInvoice() {
      $rootScope.loadingProgress = true;
      if (!vm.showButtonCancel) {
        MessageService.showErrorMessage('INVOICE.MSG.CANOT_CANCEL_LOADED_POS_INVOICE');
        $rootScope.loadingProgress = false;
      } else {
        var confirm = $mdDialog.confirm()
          .title($filter('translate')('INVOICE.MSG.Cancelar_INVOICE'))
          .textContent($filter('translate')('INVOICE.MSG.CONFIRMACION_Cancelar_INVOICE'))
          .ok($filter('translate')('INVOICE.MSG.SI'))
          .cancel($filter('translate')('INVOICE.MSG.NO'));
        $mdDialog.show(confirm).then(function () {
          api.ComprasWS.CancelInvoicePurchase.cancel({ id: vm.invoicePurchase.id, idCircle: $rootScope.bsCircle.id }).$promise.then(function (response) {
            MessageService.show($filter('translate')('INVOICE.INVOCIE_CENCELED'));
            $state.go('app.invoice.' + $stateParams.status);
            $rootScope.loadingProgress = false;
          }, function (errResponse) {
            $rootScope.loadingProgress = false;
            MessageService.showErrorMessage(errResponse.data.mensaje);
          });
        }, function () {
        });
      }
    }

      function validateDateInvoicePurchace() {
          vm.dueDate = new Date(vm.invoicePurchase.invoiceSerie.dueDate + " 00:00:00");
          if (vm.dueDate && vm.dueDate < vm.invoicePurchase.dateInvoicePurchase) {
              MessageService.showErrorMessage($filter('translate')('INVOICE.INVOICE_DATE_INVALID'));
              vm.invoicePurchase.dateInvoicePurchase = null;
          }
          var dias = parseInt(((vm.dueDate.getTime() - (new Date().getTime())) / (1000 * 60 * 60 * 24)) + 1);
          if (dias > 0 && dias <= 60) {
              vm.almostEnd = ($filter('translate')('INVOICE.ERROR.ALMOST_END')).replace('X', dias);
          } else if (dias < 0) {
              vm.almostEnd = ($filter('translate')('INVOICE.ERROR.INVOICE_EXPIRED')).replace('X', (dias * (-1)) + 1);
          } else {
              vm.almostEnd = '';
          }
      }

    function addFeatures(detail, index, ev) {

      api.ComprasWS.PurchaseOrderDetail.getId(
        { 'id': detail.id, idCircle: $rootScope.bsCircle.id, idPurchaseOrder: detail.purchaseOrder.id }, function (data) {
          vm.detailPurchaseOrder = data;
          var companyId = detail.purchaseOrder.company.id;
          api.ActivosFijosWS.FixedAssetGroupFeature.getProductsToProvider.get(
            {
              'companyId': companyId, isProvider: true
            }, function (response) {
              api.GeneralWS.ProductCompanyAddonsByCompanyAndProductsIsProvider.getList(
                { 'productsId': data.product.id, 'groupsId': response.join(','), 'companyId': companyId },
                function (groups) {
                  groups.forEach(function (fixedAssetGroupId) {
                    vm.detailPurchaseOrder.fixedAssetGroupId = fixedAssetGroupId;
                  });

                  $mdDialog.show({
                    controller: 'FeaturesDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/apps/order/order/compose/features-dialog.html',
                    parent: angular.element("#main"),
                    targetEvent: ev,
                    detail: angular.copy(vm.detailPurchaseOrder),
                    orderId: detail.purchaseOrder.id,
                    clickOutsideToClose: false
                  }).then(function (quotationDetail) {
                    getInvoiceDTO($state.params.id);
                  });

                  $rootScope.loadingProgress = false;
                }, function (response) {
                  $rootScope.loadingProgress = false;
                  $log.error(response);
                })
            }, function (response) {
              $rootScope.loadingProgress = false;
              $log.error(response);
            });
        }, function (errResponse) {
          $log.debug(errResponse);
        });


    }

      function addFeaturesInvoice() {
          var confirm = $mdDialog.alert()
              .textContent($filter('translate')('INVOICE.INVOICE_PURCHASE.CAN_ADDFEATURES'))
              .ariaLabel('add modal')
              .ok($filter('translate')('ORDER.MSG.SI'));

          $mdDialog.show(confirm).then(function () {

          }, function (err) {
              $log.debug(err);
          });
      }

      function validateRegime() {
          api.GeneralWS.Regime.byCompanyIsInvoice.get({ 'idCircle': $rootScope.bsCircle.id, 'companyId': vm.invoicePurchase.companyProvider.id }, function (resp) {
            const verifyFel = resp.filter(function (r) {
              return r.code === 'FEL';
            });
            if (verifyFel.length > 0) {
              vm.invoicePurchase.invoiceSerie = null;
              vm.invoicePurchase.correlative = null;
              vm.viewUuid = true;
              validateElectronicInvoice();
            } else {
              vm.viewUuid = false;
              vm.invoicePurchase.uuid = null;
            }
          }, function (err) {
              $log.debug(err);
          })
      }

      function validateElectronicInvoice() {
        api.GeneralWS.Company.me.get({id: vm.invoicePurchase.companyProvider.id}).$promise.then(function (cp) {
          if (cp.country.name === 'El Salvador') {
            vm.showFelSV = true;
            vm.electronicInvoiceTitle = 'INVOICE.INVOICE_PURCHASE.RECEIPT_STAMP';
            vm.uuidTitle = 'INVOICE.INVOICE_PURCHASE.GENERATION_CODE';
            vm.uuidErrorTitle = 'INVOICE.ERROR.FIELD_GENERATION_CODE_PATTERN';
          }
        });
      }

    function validateHasBudgetApplication(companyId) {
      getDimensionCompany(companyId);
      vm.circleContract = null;
      for (var i = 0; i < $rootScope.circles.length; i++) {
        if ($rootScope.circles[i].company.id === companyId) {
          vm.circleContract = $rootScope.circles[i];
          break;
        }
      }
      if (!vm.circleContract) {
        vm.circleContract = {
          id: 0,
          company: {
            id: companyId
          }
        };
      }
      api.GeneralWS.CompanyApplication.byAppName.get({ 'company': companyId, 'app': 'Presupuestos' }).$promise.then(function (responseParameter) {
        if (responseParameter.$status === 200) {
          if (responseParameter.$data && responseParameter.$data !== "") {
            vm.hasBudgetApplication = responseParameter.$data.active;
            api.GeneralWS.CompanyParameterByName.get(
              {
                id: companyId,
                parameter: 'REQUEST_A_BUDGET_IN_CONTRACTS',
              }, function (responseParameterRequestBudget) {
                if (responseParameterRequestBudget) {
                  vm.hasBudgetApplication = responseParameterRequestBudget.parameterValue === 'true';
                  if (vm.hasBudgetApplication) {
                    getBudgets();
                  } else {
                    setColumnsToGrid();
                  }
                } else {
                  setColumnsToGrid();
                }
              }, function (errParameterRequestBudget) {
                $log.error(errParameterRequestBudget);
              });
          }else{
            $timeout(function (){
              setColumnsToGrid();
            },200);
          }
        }
      }, function (response) {
        $log.error(response);
        $timeout(function (){
          setColumnsToGrid();
        },200);
      });
    }

    function getBudgets() {
      vm.budgets=[];
      var mapDepartmentAndCostCenter=vm.details
        .map(function (r, index){
          return {
            'department':r.invoicePurchaseDetail.merchandiseEntry.purchaseOrderDetail.purchaseOrder.department.id,
            'costCenter':r.invoicePurchaseDetail.merchandiseEntry.purchaseOrderDetail.purchaseOrder.costCenter.id,
            'dimensionCompanyDetail3Id': getDimensionCompanyDetailBudget(
              r.invoicePurchaseDetail.merchandiseEntry.purchaseOrderDetail.purchaseOrder.dimensionCompanyDetail3),
            'dimensionCompanyDetail4Id': getDimensionCompanyDetailBudget(
              r.invoicePurchaseDetail.merchandiseEntry.purchaseOrderDetail.purchaseOrder.dimensionCompanyDetail4),
            'dimensionCompanyDetail5Id': getDimensionCompanyDetailBudget(
              r.invoicePurchaseDetail.merchandiseEntry.purchaseOrderDetail.purchaseOrder.dimensionCompanyDetail5)
          };
        });
      vm.distinctBudget=new jinqJs()
        .from(mapDepartmentAndCostCenter)
        .distinct(
          'department',
          'costCenter',
          'dimensionCompanyDetail3Id',
          'dimensionCompanyDetail4Id',
          'dimensionCompanyDetail5Id'
        )
        .select();
      for (var i = 0; i < vm.distinctBudget.length; i++) {
        vm.isShowLoaderBudgets = true;
        api.PresupuestosWS.Budget.findApprovedOfBeforeAndCurrentAndAfterMonth.query(
          {
            'idc': vm.circleContract.id,
            'costCenterId': vm.distinctBudget[i].costCenter,
            'departmentId': vm.distinctBudget[i].department,
            'dimensionCompanyDetail3Id': vm.distinctBudget[i].dimensionCompanyDetail3Id,
            'dimensionCompanyDetail4Id': vm.distinctBudget[i].dimensionCompanyDetail4Id,
            'dimensionCompanyDetail5Id': vm.distinctBudget[i].dimensionCompanyDetail5Id,
            'companyId': vm.circleContract.company.id
          }).$promise.then(function (response) {
          vm.isShowLoaderBudgets = false;
          response.forEach(function (row) {
            vm.budgets.push(row);
          });
          if (vm.budgets && vm.details && vm.details.length>0
            && verifyContractIsFixed()
          ) {
            vm.showButton = false;
          }
          $timeout(function (){
            setColumnsToGrid();
          },200);
        }, function (response) {
          vm.isShowLoaderBudgets = false;
          vm.showButton = false;
          $log.error(response);
        });
      }
    }

    function getDimensionCompanyDetailBudget(dimensionCompanyDetail) {
      if (dimensionCompanyDetail) {
        return dimensionCompanyDetail.id;
      }
      return 0;
    }

    function setColumnsToGrid() {
      vm.masterColumnDefsDet = [
      {
        headerName: 'INVOICE.PRODUCT.PRODUCT',
          field: "invoicePurchaseDetail.product.name",
        headerCellRenderer: getHeader,
        width: 300,
        enableRowGroup: true,
        enablePivot: true
      },
      {
        headerName: 'INVOICE.DEPARTMENT',
          field: "invoicePurchaseDetail.merchandiseEntry.purchaseOrderDetail.purchaseOrder.department.description",
        headerCellRenderer: getHeader,
        width: 200,
        enableRowGroup: true,
        enablePivot: true
      },
      {
        headerName: 'INVOICE.COST_CENTER',
          field: "invoicePurchaseDetail.merchandiseEntry.purchaseOrderDetail.purchaseOrder.costCenter.description",
        headerCellRenderer: getHeader,
        width: 200,
        enableRowGroup: true,
        enablePivot: true
      },
      {
        headerName: 'INVOICE.INVOICE_PURCHASE.DETAIL.QUANTITY',
          field: "invoicePurchaseDetail.quantity",
        headerCellRenderer: getHeader,
        width: 100,
        enableRowGroup: true,
        enablePivot: true,
        cellStyle: { 'text-align': 'right' }
      },
      {
        headerName: 'INVOICE.INVOICE_PURCHASE.DETAIL.UNIT_PRICE_AFTER_TAX',
          headerCellRenderer: getHeader,
        field: 'invoicePurchaseDetail.priceAfterTax',
        width: 100,
        suppressSorting: true,
        suppressMenu: true,
        cellRenderer: rendererInput,
        cellStyle: { 'text-align': 'right' },
        valueFormatter: function (params) {
          return $filter('number')(params.value, 2);
        }
      },
      {
        headerName: 'INVOICE.INVOICE_PURCHASE.DETAIL.TOTAL_AFTER_TAX_DOCUMENT',
          headerCellRenderer: getHeader,
        width: 100,
        suppressSorting: true,
        suppressMenu: true,
        cellRenderer: rendererSubtotalDocument,
        cellStyle: { 'text-align': 'right' },
        valueFormatter: function (params) {
          return $filter('number')(params.value, 2);
        }
      },
      {
        headerName: 'INVOICE.INVOICE_PURCHASE.DETAIL.TOTAL_AFTER_TAX',
          headerCellRenderer: getHeader,
        width: 100,
        suppressSorting: true,
        suppressMenu: true,
        cellRenderer: rendererSubtotal,
        cellStyle: { 'text-align': 'right' },
        valueFormatter: function (params) {
          return $filter('number')(params.value, 2);
        },
        hide: true
      },
      {
        headerName: 'INVOICE.INVOICE_PURCHASE.DETAIL.TOTAL_AFTER_TAX_FOREIGN',
          headerCellRenderer: getHeader,
        width: 100,
        suppressSorting: true,
        suppressMenu: true,
        cellRenderer: rendererSubtotalForeign,
        cellStyle: { 'text-align': 'right' },
        valueFormatter: function (params) {
          return $filter('number')(params.value, 2);
        },
        hide: true
      }
      ];
      if (vm.hasBudgetApplication
        && vm.details[0].invoicePurchaseDetail.merchandiseEntry
        && verifyContractIsFixed()
      ) {
        vm.masterColumnDefsDet.splice(6,0,{
          headerName: $filter('translate')('CONTRACT.SELECT_BUDGETS'),
          name: "budgets",
          headerCellRenderer: getHeader,
          suppressSorting: true,
          suppressMenu: true,
          width: 400,
          cellRenderer: function (params) {
            if (verifyExistProduct(params.data.invoicePurchaseDetail.product)) {
            const products = getBudgetsByProduct(
              params.data.invoicePurchaseDetail.product.id,
              params.data.invoicePurchaseDetail.merchandiseEntry.purchaseOrderDetail.purchaseOrder.department.id,
              params.data.invoicePurchaseDetail.merchandiseEntry.purchaseOrderDetail.purchaseOrder.costCenter.id
            );
            vm.productBudget[params.data.invoicePurchaseDetail.product.id] = products;
            params.$scope.isSelected = isSelected;
            params.$scope.toggleSelectBudget = toggleSelectBudget;
            params.$scope.validateRequestAmpliation = validateRequestAmpliation;
            params.data.invoicePurchaseDetail.merchandiseEntry.purchaseOrderDetail.contractPurchaseDetail.needExtension = false;

            params.data.invoicePurchaseDetail.merchandiseEntry.purchaseOrderDetail.contractPurchaseDetail.totalCovered = assignTotalCovered(
              params.data.invoicePurchaseDetail.merchandiseEntry.purchaseOrderDetail.contractPurchaseDetail.totalCovered
            );

            params.data.invoicePurchaseDetail.merchandiseEntry.purchaseOrderDetail.contractPurchaseDetail.requestAmpliation = false;

              assignTheFirstBudget(products, params);

              return budgetsTemplate;
            } else {
              return '';
            }
          }
        });
      }

      if ($state.params.status === 'Ingresando') {
        vm.masterColumnDefsDet.push({
          headerName: 'INVOICE.INVOICE_PURCHASE.OPTIONS',
          headerCellRenderer: getHeader,
          suppressSorting: true,
          suppressMenu: true,
          width: 150,
          cellRenderer: renderer,
          cellStyle: { 'padding': '0px' },
          pinned: "right"
        });

        vm.masterColumnDefsDet.splice(1, 0, {
          headerName: 'INVOICE.INVOICE_PURCHASE.DETAIL.DESCRIPTION',
          headerCellRenderer: getHeader,
          cellRenderer: rendererDescription,
          cellStyle: { 'padding': '0px' },
          width: 300,
          enableRowGroup: true,
          enablePivot: true
        });
      }

      getColumnDimensionCompany(vm.NUMBER_DIMENSION_THREE);
      getColumnDimensionCompany(vm.NUMBER_DIMENSION_FOUR);
      getColumnDimensionCompany(vm.NUMBER_DIMENSION_FIVE);

      vm.masterGridOptionsE.api.setColumnDefs(vm.masterColumnDefsDet);
    }

    function verifyContractIsFixed(){
        return vm.details[0].invoicePurchaseDetail.merchandiseEntry.purchaseOrderDetail.contractPurchaseDetail
          && vm.details[0].invoicePurchaseDetail.merchandiseEntry.purchaseOrderDetail.contractPurchaseDetail.contractPurchase
          && !vm.details[0].invoicePurchaseDetail.merchandiseEntry.purchaseOrderDetail.contractPurchaseDetail.contractPurchase.fixed;
    }

    function verifyExistProduct(product) {
        return product && product.id;
    }

    function assignTotalCovered(totalCovered) {
      if (!totalCovered) {
        return 0;
      }
      return totalCovered;
    }

    function assignTheFirstBudget(products, params) {
      if (products.length === 1) {

        $timeout(function () {
          if (products[0].available >= (parseFloat(params.data.invoicePurchaseDetail.subTotalAfterTax)
          )) {
            params.$scope.toggleSelectBudget(products[0], null, true);
          }
        }, 2000);
      }
    }

    function pinnedBottomRowDataDetails() {
      $timeout(function () {
        const result = [];
        result.push({
          invoicePurchaseDetail: {
            quantity: vm.sumTotalQuantity,
            subTotalAfterTaxCurrency: vm.symbol + '. ' + $filter('number')(vm.sumSubTotalAfterTaxCurrency, vm.number_two),
            subTotalAfterTaxForeignCurrency: vm.symbol + '. ' + $filter('number')(vm.sumSubTotalAfterTaxForeignCurrency, vm.number_two),
            subTotalAfterTaxDocumentCurrency: vm.symbol + '. ' + $filter('number')(vm.sumSubTotalAfterTaxDocumentCurrency, vm.number_two)
          }
        });
        vm.masterGridOptionsE.api.setPinnedBottomRowData(result);
      }, vm.one_thousand_eight_hundred);
    }

    function getBudgetsByProduct(productId, departmentId, costCenterId) {

      if (vm.productBudget[productId] !== undefined && vm.productBudget[productId] !== null) {
        return vm.productBudget[productId];
      }

      var result = [];
      if (vm.budgets.length>0) {
        vm.budgets.forEach(function (row) {
          if (row.product.id === productId && row.budget.department.id === departmentId && row.budget.costCenter.id === costCenterId) {
            row.available = (row.amountOfficial - (row.amountExecuted ? row.amountExecuted : 0) - (row.amountReserved ? row.amountReserved : 0) - (row.amountNotExecuted ? row.amountNotExecuted : 0)).toFixed(2);
            result.push(row);
          }
        });
      }

      return result;

    }

    function isSelected(budgetDetail) {

      var scopeParent = this.$parent.$parent;

      if (scopeParent.data.invoicePurchaseDetail.merchandiseEntry.purchaseOrderDetail.contractPurchaseDetail.references === undefined || scopeParent.data.invoicePurchaseDetail.merchandiseEntry.purchaseOrderDetail.contractPurchaseDetail.references === null) {
        scopeParent.data.invoicePurchaseDetail.merchandiseEntry.purchaseOrderDetail.contractPurchaseDetail.references = [];
      }

      for (var i = 0; i < scopeParent.data.invoicePurchaseDetail.merchandiseEntry.purchaseOrderDetail.contractPurchaseDetail.references.length; i++) {
        if (scopeParent.data.invoicePurchaseDetail.merchandiseEntry.purchaseOrderDetail.contractPurchaseDetail.references[i].budgetDetailId === budgetDetail.id) {
          return true;
        }
      }

      return false;
    }

    function toggleSelectBudget(budgetDetail, event, fromParent) {

      var scopeParent;


      if (fromParent) {
        scopeParent = this;
      } else {
        scopeParent = this.$parent;
      }
      scopeParent.data.invoicePurchaseDetail.merchandiseEntry.purchaseOrderDetail.contractPurchaseDetail.needExtension = false;
      vm.currentDetail = scopeParent.data.invoicePurchaseDetail.merchandiseEntry.purchaseOrderDetail.contractPurchaseDetail;
      if (scopeParent.data.invoicePurchaseDetail.merchandiseEntry.purchaseOrderDetail.contractPurchaseDetail.references === undefined
        || scopeParent.data.invoicePurchaseDetail.merchandiseEntry.purchaseOrderDetail.contractPurchaseDetail.references === null || fromParent) {
        scopeParent.data.invoicePurchaseDetail.merchandiseEntry.purchaseOrderDetail.contractPurchaseDetail.references = [];
      }

      if (event) {
        event.stopPropagation();
      }

      var selected = false;

      for (var i = 0; i < scopeParent.data.invoicePurchaseDetail.merchandiseEntry.purchaseOrderDetail.contractPurchaseDetail.references.length; i++) {
        if (scopeParent.data.invoicePurchaseDetail.merchandiseEntry.purchaseOrderDetail.contractPurchaseDetail.references[i].budgetDetailId === budgetDetail.id) {
          scopeParent.data.invoicePurchaseDetail.merchandiseEntry.purchaseOrderDetail.contractPurchaseDetail.totalCovered -= scopeParent.data.invoicePurchaseDetail.merchandiseEntry.purchaseOrderDetail.contractPurchaseDetail.references[i].amountToUse;
          calculateAvailable(scopeParent.data.invoicePurchaseDetail.merchandiseEntry.purchaseOrderDetail.contractPurchaseDetail.references[i].budgetDetailId,
            scopeParent.data.invoicePurchaseDetail.merchandiseEntry.purchaseOrderDetail.contractPurchaseDetail.references[i].amountToUse, vm.productBudget[scopeParent.data.invoicePurchaseDetail.merchandiseEntry.purchaseOrderDetail.contractPurchaseDetail.product.id]);
          scopeParent.data.invoicePurchaseDetail.merchandiseEntry.purchaseOrderDetail.contractPurchaseDetail.references.splice(i, 1);
          selected = true;
          break;
        }
      }

      if (!selected) {
        scopeParent.data.invoicePurchaseDetail.merchandiseEntry.purchaseOrderDetail.contractPurchaseDetail.needExtension = (
          parseFloat(scopeParent.data.invoicePurchaseDetail.subTotalAfterTax)
        ) > budgetDetail.available;

        var reference = {
          referenceId: budgetDetail.id,
          budgetId: budgetDetail.budget.id,
          budgetDetailId: budgetDetail.id,
          amountToUse: (parseFloat(scopeParent.data.invoicePurchaseDetail.subTotalAfterTax) ) > parseFloat(budgetDetail.available) ?
            parseFloat(budgetDetail.available) :
            (parseFloat(scopeParent.data.invoicePurchaseDetail.subTotalAfterTax) ),
          budgetStartDate: budgetDetail.budget.startDate,
          budgetEndDate: budgetDetail.budget.endDate,
          currencyCode: budgetDetail.currencyOfficial.code,
          budgetType: budgetDetail.budget.budgetType.description,
          budgetExchangeRateOfficial: budgetDetail.exchangeRateOfficial
        };

        scopeParent.data.invoicePurchaseDetail.merchandiseEntry.purchaseOrderDetail.contractPurchaseDetail.references.push(reference);
        scopeParent.data.invoicePurchaseDetail.merchandiseEntry.purchaseOrderDetail.contractPurchaseDetail.totalCovered += reference.amountToUse;
        calculateAvailable(budgetDetail.id, reference.amountToUse * -1, vm.productBudget[scopeParent.data.invoicePurchaseDetail.merchandiseEntry.purchaseOrderDetail.contractPurchaseDetail.product.id]);
      }
      $timeout(function(){
        verifiActiveButtonAuthorize();
      },200);
    }

    function calculateAvailable(budgetDetailId, amountToAdd, budgetDetailArray) {
      budgetDetailArray.forEach(function (budgetDetail) {
        if (budgetDetailId === budgetDetail.id) {
          budgetDetail.available = parseFloat(budgetDetail.available) + parseFloat(amountToAdd);
        }
      });

    }

    function verifiActiveButtonAuthorize() {
      var verifyAllItems = true;
      for (var r = 0; r < vm.details.length; r++) {
        if (!vm.details[r].invoicePurchaseDetail.merchandiseEntry.purchaseOrderDetail.contractPurchaseDetail.references
          || vm.details[r].invoicePurchaseDetail.merchandiseEntry.purchaseOrderDetail.contractPurchaseDetail.references.length === 0) {
          verifyAllItems = false;
          break;
        }else if(vm.details[r].invoicePurchaseDetail.merchandiseEntry.purchaseOrderDetail.contractPurchaseDetail.references.length>0){
          for(var j=0; j<vm.details[r].invoicePurchaseDetail.merchandiseEntry.purchaseOrderDetail.contractPurchaseDetail.references.length; j++){
            if(vm.details[r].invoicePurchaseDetail.merchandiseEntry.purchaseOrderDetail.contractPurchaseDetail.references[j].amountToUse <
                (vm.details[r].invoicePurchaseDetail.subTotalAfterTax)
                && !vm.details[r].invoicePurchaseDetail.merchandiseEntry.purchaseOrderDetail.contractPurchaseDetail.requestAmpliation){
              verifyAllItems = false;
            }
            if(vm.details[r].invoicePurchaseDetail.merchandiseEntry.purchaseOrderDetail.contractPurchaseDetail.references[j].amountToUse <
              (vm.details[r].invoicePurchaseDetail.subTotalAfterTax)
              && vm.details[r].invoicePurchaseDetail.merchandiseEntry.purchaseOrderDetail.contractPurchaseDetail.requestAmpliation){
              vm.requestAmpliationButton = true;
            }
          }
        }
      }
      vm.showButton = verifyAllItems;
    }

    function validateRequestAmpliation(event, scope) {
      $timeout(function(){
        verifiActiveButtonAuthorize();
      },200);
    }

    function getBudgetsTemplate() {
      var resource = $sce.getTrustedResourceUrl('app/main/apps/invoice/saleInvoice/budgetsTemplate.html');

      $templateRequest(resource).then(function (template) {
        budgetsTemplate = template;
      }, function () {
        $log.error("Ocurrio un error al leer el template");
      });

    }

    getBudgetsTemplate();

    function reserveBudgetByContract(){
      vm.detailsContract=vm.details.map(function (r){
        r.invoicePurchaseDetail.merchandiseEntry.purchaseOrderDetail.contractPurchaseDetail['total']= r.invoicePurchaseDetail.subTotalAfterTax;
        return r.invoicePurchaseDetail.merchandiseEntry.purchaseOrderDetail.contractPurchaseDetail;
      });
      vm.productsToValidate = [];
      vm.detailsContract.forEach(function (data){
        var productToValidate = {
          id: data.id,
          product: data.product,
          amount: data.requestAmpliation ?
            (((data.total) - data.totalCovered) / data.references[data.references.length - 1].budgetExchangeRateOfficial) :
            (data.total),
          referenceAmpliationId: data.references[data.references.length - 1].referenceId,
          unitPrice: 0,
          currency: data.currencyCompanyBuyer,
          exchangeRate: data.exchangeRateCompanyBuyer,
          requestAmpliation: data.requestAmpliation,
          references: data.references,
          referenceHeaderId: data.contractPurchase.id,
          noPayments:vm.details[0].invoicePurchaseDetail.merchandiseEntry.merchandiseHeader.noPayment
        };

        vm.productsToValidate.push(productToValidate);
      });
      vm.noPaymentNotFixed = vm.details[0].invoicePurchaseDetail.merchandiseEntry.merchandiseHeader.noPayment;
       $rootScope.loadingProgress = true;
       vm.requestAmpliation=false;
       for (var i = 0; i < vm.productsToValidate.length; i++) {
         if (vm.productsToValidate[i].requestAmpliation) {
           vm.requestAmpliation = true;
           break;
         }
       }
       if (vm.requestAmpliation) {
         var productAmpliation = new jinqJs()
           .from(vm.productsToValidate)
           .where(function (r) {
             return r.requestAmpliation;
           })
           .select();
         vm.productsToValidate = productAmpliation;
       }
       if (vm.productsToValidate.length > 0) {
         api.PresupuestosWS.Budget.validatesBudgetedProductsContract.validate(
           {
             'idc': vm.circleContract.id, 'noPaymentNotFixed': vm.noPaymentNotFixed,
             'companyId': vm.circleContract.company.id
           }, {quotations: vm.productsToValidate}
         ).$promise.then(function (response) {
           $rootScope.loadingProgress = false;
           vm.productsToValidate = response;
           vm.requestAmpliation = false;
           for (var i = 0; i < vm.productsToValidate.length; i++) {
             if (vm.productsToValidate[i].requestAmpliation) {
               vm.requestAmpliation = true;
               break;
             }
           }
           if (!vm.requestAmpliation) {
             vm.contractPurchase= vm.detailsContract[0].contractPurchase;
             $rootScope.loadingProgress = false;
             vm.showButton = false;
             $rootScope.loadingProgress = true;
             api.ComprasWS.ContractDetailReference.createReferences.create(
               {
                 'id': vm.contractPurchase.id,
                 'idCircle': vm.circleContract.id,
                 'noPayment': vm.details[0].invoicePurchaseDetail.merchandiseEntry.merchandiseHeader.noPayment
               }, {'quotations': vm.productsToValidate}).$promise.then(function (responseUp) {
               vm.contractPurchase = responseUp;
               changeStatus('Emitida');
             }, function (responseErr) {
               $rootScope.loadingProgress = false;
               var msg = 'ERROR';
               if (responseErr.data === 'No Detail') {
                 msg = 'DETAIL';
               }

               MessageService.showErrorMessage('REQUISITION.MSG.' + msg);
             });
           } else {
             MessageService.show('INVOICE.REQUEST_AMPLIATION');
             $state.go('app.invoice.' + $stateParams.status);
             $rootScope.loadingProgress = false;
           }

         }, function (response) {
           vm.showButton = true;
           $rootScope.loadingProgress = false;
           $log.error(response);
         });
       }
    }

    vm.validateUUID = function () {
      if (vm.invoicePurchase.uuid) {
        vm.invoicePurchase.uuid = vm.invoicePurchase.uuid.toUpperCase();
      } else {
        if(vm.showFelSV) {
          MessageService.showErrorMessage('INVOICE.MSG.ERROR_TO_GENERATION_CODE');
        } else {
          MessageService.showErrorMessage('INVOICE.MSG.ERROR_TO_UUID');
        }
      }
    };

    function verifyInvoiceLoadedPOS() {
      if (vm.invoicePurchase.purchaseStatus.description === 'Ingresando' && vm.invoicePurchase.loadedPOS) {
        vm.showButtonCancel = false;
      }
    }

    function cleanInvoiceSerieAndCorrelative(invoicePurchaseClean){
      if (vm.viewUuid) {
        invoicePurchaseClean.uuid = vm.invoicePurchase.uuid.toUpperCase();
        invoicePurchaseClean.invoiceSerie = null;
        invoicePurchaseClean.correlative = null;
      } else {
        invoicePurchaseClean.uuid = null;
      }
    }

    function getDimensionCompany(companyId) {
      api.GeneralWS.DimensionCompany.byCompany.getList(
        { 'company': companyId }
      ).$promise.then(function (responseDimension) {
        for (let i = 0; i < responseDimension.length; i++) {
          if (responseDimension[i].dimensionNumber === vm.NUMBER_DIMENSION_THREE) {
            vm.dimensionCompanyDetail3 = responseDimension[i];
          } else if (responseDimension[i].dimensionNumber === vm.NUMBER_DIMENSION_FOUR) {
            vm.dimensionCompanyDetail4 = responseDimension[i];
          } else if (responseDimension[i].dimensionNumber === vm.NUMBER_DIMENSION_FIVE) {
            vm.dimensionCompanyDetail5 = responseDimension[i];
          } else {
            vm.dimensionCompanyDetail1 = responseDimension[i];
          }
        }
      });
    }

    function getColumnDimensionCompany(number) {
      if (vm['dimensionCompanyDetail' + number]) {
        vm.masterColumnDefsDet.splice((number + vm.NUMBER_ONE), 0, {
          headerName: vm['dimensionCompanyDetail' + number].description,
          field: 'invoicePurchaseDetail.merchandiseEntry.purchaseOrderDetail.purchaseOrder.dimensionCompanyDetail' + number + '.name',
          headerCellRenderer: getHeader,
          width: 250,
          enableRowGroup: true,
          enablePivot: true,
          cellStyle: { 'text-align': 'center' }
        });
      }
    }

    vm.detailsBatches = [];
    vm.currentDetailsBatchIndex = -1;
    vm.generateDesciptions = function () {
      const confirm = $mdDialog.confirm()
        .title($filter('translate')('INVOICE.SALE_INVOICE.DETAIL.GENERATE_DESCRIPTION'))
        .textContent($filter('translate')('INVOICE.SALE_INVOICE.DETAIL.GENEARTE_DESCRIPTION_AUTOMATICALLY_CONFIRM'))
        .ok($filter('translate')('INVOICE.MSG.SI'))
        .cancel($filter('translate')('INVOICE.MSG.NO'));

      $mdDialog.show(confirm)
        .then(function () {
          $rootScope.loadingProgress = true;
          const details = [];
          vm.masterGridOptionsE.api.forEachNode(function (node) {
            details.push(node.data.invoicePurchaseDetail);
          });

          const batchSize = 5;
          vm.detailsBatches = splitDetailsIntoSublists(details, batchSize);
          vm.currentDetailsBatchIndex = -1;
          sendNextDetailBatchToSaveDescrition();
        });
    }

    function splitDetailsIntoSublists(list, size) {
      const subLists = [];
      for (var i = 0; i < list.length; i += size) {
        const subList = list.slice(i, i + size);
        subLists.push({ sent: 0, details: subList });
      }
      return subLists;
    }

    function sendNextDetailBatchToSaveDescrition() {
      vm.currentDetailsBatchIndex++;
      if (vm.currentDetailsBatchIndex === vm.detailsBatches.length) {
        $rootScope.loadingProgress = false;
        MessageService.show('INVOICE.SALE_INVOICE.DETAIL.MESSAGE.DESCRIPTIONS_UPDATED');
        return;
      }
      vm.detailsBatches[vm.currentDetailsBatchIndex].details.forEach(function (detail) {
        saveInvoiceSaleDetailDescriptionWithProductName(detail);
      });
    }

    function saveInvoiceSaleDetailDescriptionWithProductName(detail) {
      const currentBatch = vm.detailsBatches[vm.currentDetailsBatchIndex];
      const invoicePurchaseDetail = angular.copy(detail);
      invoicePurchaseDetail.description = invoicePurchaseDetail.product.name;

      api.ComprasWS.InvoicePurchaseDetail.saveDescription(
        { id: 'saveDescription', idCircle: $rootScope.bsCircle.id }, invoicePurchaseDetail).$promise.then(function (response) {
          detail.description = response.description;
          currentBatch.sent++;
          if (currentBatch.sent === currentBatch.details.length) {
            sendNextDetailBatchToSaveDescrition();
          }
        }, function (errResponse) {
          $log.debug(errResponse);
          currentBatch.sent++;
          if (currentBatch.sent === currentBatch.details.length) {
            sendNextDetailBatchToSaveDescrition();
          }
        });
    }

  }
})();

(function () {
    'use strict';

    angular
        .module('app.merchandiseEntry.merchandiseEntryR', [])
        .config(config);


    /** @ngInject */
    function config($translatePartialLoaderProvider) {
        // State

        $translatePartialLoaderProvider.addPart('app/main/apps/merchandiseEntry/merchandiseEntry');


    }
})();


(function () {
    'use strict';

    angular
        .module('app.merchandiseEntry.merchandiseEntryR')
        .controller('MerchandiseEntryController', MerchandiseEntryController);

    /** @ngInject */
    function MerchandiseEntryController($state, api, $rootScope, $log, $timeout, $scope) {
        var vm = this;
        vm.merchandiseEntries = [];

        // Data
        vm.masterColumnDefs = [
            {
                headerName: 'MERCHANDISE_ENTRY.PROVIDER',
                field: "purchaseOrderDetail.purchaseOrder.companyProvider.name",
                headerCellRenderer: getHeader,
                width: 200,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'MERCHANDISE_ENTRY.DEPARTMENT',
                field: "deptoCostCenter",
                headerCellRenderer: getHeader,
                width: 250,
                enableRowGroup: true,
                enablePivot: true,
                cellRenderer: rendererDepto,
                cellStyle: { 'padding': '0px' }
            },
            {
                headerName: 'MERCHANDISE_ENTRY.PURCHASE_ORDER',
                field: "purchaseOrderDetail.purchaseOrder.id",
                headerCellRenderer: getHeader,
                width: 150,
                enableRowGroup: true,
                enablePivot: true,
                cellStyle: { 'padding': '0px' }
            },
            {
                headerName: 'MERCHANDISE_ENTRY.ENTRYDATEPURCHASE',
                field: "fecha",
                headerCellRenderer: getHeader,
                width: 130,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'MERCHANDISE_ENTRY.DETAIL.PRODUCT',
                field: "purchaseOrderDetail.product.name",
                headerCellRenderer: getHeader,
                enableRowGroup: true,
                cellRenderer: rendererProduct,
                width: 200,
                enablePivot: true
            },
            {
                headerName: 'MERCHANDISE_ENTRY.DETAIL.QUANTITY',
                field: "quantity",
                width: 130,
                headerCellRenderer: getHeader,
                enableRowGroup: true,
            }
        ];

        vm.masterGridOptions = {
            columnDefs: vm.masterColumnDefs,
            enableSorting: true,
            debug: false,
            enableFilter: true,
            enableColResize: true,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowData: null,
            groupHeaders: true,
            headerHeight: 50,
            rowHeight: 45,
            doesDataFlower: function (dataItem) {
                dataItem.fecha = dataItem.createdAt.dayOfMonth + "/" + dataItem.createdAt.monthValue + "/" + dataItem.createdAt.year;
                dataItem.deptoCostCenter = dataItem.purchaseOrderDetail.purchaseOrder.department.description
                    + ', ' + dataItem.purchaseOrderDetail.purchaseOrder.costCenter.description
                dataItem.filter = (dataItem.purchaseOrderDetail.purchaseOrder.companyProvider.name
                    + ', ' + dataItem.purchaseOrderDetail.purchaseOrder.department.description
                    + "," + dataItem.purchaseOrderDetail.purchaseOrder.costCenter.description
                    + "," + dataItem.purchaseOrderDetail.product.name + "," + dataItem.purchaseOrderDetail.purchaseOrder.id).toLowerCase();
                return true;
            },
            isExternalFilterPresent: isExternalFilterPresent,
            doesExternalFilterPass: doesExternalFilterPass
        };

        var filter = 'everyone';

        function isExternalFilterPresent() {
            // if ageType is not everyone, then we are filtering
            return filter !== '';
        }

        function doesExternalFilterPass(node) {
            if (filter && filter !== 'everyone') {
                var arrdt = node.data.filter.split(filter.toLowerCase());
                return arrdt.length > 1;
            }
            return true;
        }

        $scope.$watch('vm.search',
            function (newValue) {
                filter = newValue;
                vm.masterGridOptions.api.onFilterChanged();
            }
        );

        vm.loading = true;
        $timeout(function (d) {
            if ($rootScope.bsCircle) {
                $rootScope.loadingProgress = true;
                vm.loading = true;
                api.ComprasWS.MerchandiseEntry.page(
                    { idCircle: $rootScope.bsCircle.id, id: 'byUser', invoiced: false, page: 0, pageSize: 100 }, function (response) {// Success
                        vm.merchandiseEntries = response.content;
                        vm.masterGridOptions.api.setColumnDefs(vm.masterColumnDefs);
                        vm.masterGridOptions.api.setRowData(vm.merchandiseEntries);
                        vm.loading = false;
                        $rootScope.loadingProgress = false;
                        $log.debug(vm.merchandiseEntries);
                    }, function (response) {// Error
                        $log.debug(response);
                        vm.loading = false;
                        vm.masterGridOptions.api.setColumnDefs(vm.masterColumnDefs);
                        vm.masterGridOptions.api.setRowData([]);
                        $rootScope.loadingProgress = false;
                    });
            } else {
                vm.loading = false;
                $state.go('app.dashboard_project');
            }
        }, 300);



        function rendererDepto(params) {
            if (params.data) {
                return '<div style="width: 100%;">'
                    + '   <p>' + params.data.purchaseOrderDetail.purchaseOrder.department.description
                    + ' <br> <small>' + params.data.purchaseOrderDetail.purchaseOrder.costCenter.description + '</small></p>  '
                    + '             </div>';
            } else {
                return '';
            }
        }

        function rendererProduct(params) {
            if (params.data) {
                if (params.data.purchaseOrderDetail.product.measurementUnit === null) {
                    return '<div">'
                        + '   <p>' + params.data.purchaseOrderDetail.product.name + ' <br> '
                        + '         </div>';
                } else {
                    return '<div">'
                        + ' <p>' + params.data.purchaseOrderDetail.product.name
                        + ' <br> <small>' + params.data.purchaseOrderDetail.product.measurementUnit.name + '</small></p>  '
                        + ' </div>';
                }
            } else {
                return '';
            }
        }


    }
})();

(function() {
  "use strict";
  angular
    .module("app.invoice")
    .controller("PurchaseInvoiceController", PurchaseInvoiceController);

  /** @ngInject */
  function PurchaseInvoiceController(
    $mdDialog,
    api,
    $rootScope,
    $state,
    $mdToast,
    $stateParams,
    $log,
    $filter,
    $sce,
    $scope,
    $timeout,
    envService,
    MessageService
  ) {
    var vm = this;
    // Data
    vm.baseUrlFiles = api.baseUrlFiles;
    vm.zoomLvl = 3;
    vm.hiddenCC = true;
    vm.hiddenBCC = true;
    vm.valRotate = 0;
    vm.styleImage;
    vm.imageZoomOptions = {};
    vm.details = [];
    vm.currentTab = 0;
    vm.fromparams = $stateParams.fromparams;
    // Methods
    vm.gotToInvoices = gotToInvoices;
    vm.changeStatusInvoice = changeStatusInvoice;
    vm.updateImageZoomOptions = updateImageZoomOptions;
    vm.goToInvoicePurchaseDetailEdit = goToInvoicePurchaseDetailEdit;
    vm.changeTab = changeTab;
    vm.notAuthorizated = notAuthorizated;
    vm.isRechzed = $stateParams.status === "Rechazada";
    vm.changeOtherStatusInvoice = changeOtherStatusInvoice;
    vm.InvoiceWithholdingDetails = [];
    vm.URLPHOTOS = api.baseUrlPhotos;
    vm.fileWithholding = {};
    vm.viewIMG = viewIMG;
    vm.rotate = rotate;
    var keyContrasena = "JASPER_URL_CONTRASENA_PAGO";
    vm.permissionCancelInvoice = false;
    vm.changeCancelStatusInvoice = changeCancelStatusInvoice;
    const INVOICE_MSG_SI = 'INVOICE.MSG.SI';
    const INVOICE_MSG_NO = 'INVOICE.MSG.NO';

    vm.NUMBER_DIMENSION_THREE = 3;
    vm.NUMBER_DIMENSION_FOUR = 4;
    vm.NUMBER_DIMENSION_FIVE = 5;

    vm.masterColumnDefsRet = [
      {
        headerName: "INVOICE.WITHHOLDING_DETAIL.RATE",
        field: "ratepercent",
        headerCellRenderer: getHeader,
        width: 300,
        enableRowGroup: true,
        enablePivot: true
      },
      {
        headerName: "INVOICE.INVOICE_PURCHASE.CODE_WITHHOLDING",
        field: "invoicePurchaseWithholding.codeWithholding",
        headerCellRenderer: getHeader,
        width: 300,
        enableRowGroup: true,
        enablePivot: true
      },
      {
        headerName: "INVOICE.WITHHOLDING_DETAIL.VALUE_RATE",
        field: "valueWithholding",
        headerCellRenderer: getHeader,
        width: 200,
        enableRowGroup: true,
        enablePivot: true,
        cellStyle: { "text-align": "right" },
        valueFormatter: function(params) {
          return $filter("number")(params.value, 2);
        }
      }
    ];

    vm.masterGridOptionsRet = {
      columnDefs: vm.masterColumnDefsRet,
      enableSorting: true,
      debug: false,
      enableFilter: true,
      enableColResize: true,
      angularCompileRows: true,
      angularCompileHeaders: true,
      rowData: null,
      headerHeight: 50,
      rowHeight: 45,
      doesDataFlower: function(dataItem) {
        var ref = "";
        if (dataItem.invoicePurchaseWithholding.fileWithholding) {
          ref =
            ref +
            '<a ng-click="vm.viewIMG(data.invoicePurchaseWithholding.fileWithholding)">Ver Imagen ' +
            "</a> ";
        }
        dataItem.ratepercent =
          dataItem.withholding.withholdingCode +
          " " +
          dataItem.rate +
          "% " +
          ref;
        return false;
      },
      getMainMenuItems: function(params) {
        return getHeaderMenu(params, $filter);
      },
      localeTextFunc: function(key, defaultValue) {
        return translateGrid(key, defaultValue, $filter);
      },
      groupRowInnerRenderer: function(params) {
        return params.value;
      }
    };

    //////////ORDEN DE COMPRA.
    vm.masterColumnDefsPurchaseOrder = [
      {
        headerName: "ORDER.ORDER",
        field: "orderDescription",
        headerCellRenderer: getHeader,
        width: 150,
        rowGroupIndex: 0,
        hide: true
      },
      {
        headerName: "REQUISITION.DETAIL.QUANTITY",
        field: "quantityRequired",
        headerCellRenderer: getHeader,
        width: 100,
        enableRowGroup: true,
        cellStyle: { "text-align": "center" },
        enablePivot: true
      },
      {
        headerName: "REQUISITION.DETAIL.PRODUCT",
        field: "productName",
        headerCellRenderer: getHeader,
        width: 250,
        enableRowGroup: true,
        enablePivot: true
      },
      {
        headerName: "QUOTATION.DETAIL.PRICE",
        field: "price",
        headerCellRenderer: getHeader,
        width: 150,
        enableRowGroup: true,
        enablePivot: true,
        cellStyle: { "text-align": "right" },
        valueFormatter: function(params) {
          return $filter("number")(params.value, 2);
        }
      },
      {
        headerName: "ORDER.DETAIL.PENDIENTE",
        field: "maxRecibe",
        headerCellRenderer: getHeader,
        width: 150,
        enableRowGroup: true,
        cellStyle: { "text-align": "center" },
        enablePivot: true
      },
      {
        headerName: "ORDER.DETAIL.RECIBIDO",
        field: "pending",
        headerCellRenderer: getHeader,
        width: 150,
        enableRowGroup: true,
        cellStyle: { "text-align": "center" },
        enablePivot: true
      }
    ];

    vm.masterGridOptionsPurchaseOrder = {
      columnDefs: vm.masterColumnDefsPurchaseOrder,
      enableSorting: true,
      debug: false,
      enableFilter: true,
      enableColResize: true,
      angularCompileRows: true,
      angularCompileHeaders: true,
      rowData: null,
      headerHeight: 50,
      rowHeight: 45,
      groupUseEntireRow: true,
      animateRows: true,
      groupDefaultExpanded: 1,
      doesDataFlower: function(dataItem) {
        dataItem.pending = dataItem.quantityRequired - dataItem.maxRecibe;
        dataItem.orderDescription =
          "Orden de Compra No." +
          dataItem.purchaseOrder.id +
          " {{'CONTRACT.BY_CREATED' | translate}} " +
          dataItem.purchaseOrder.createdBy +
          " El " +
          $filter("date")(getDateFormat(dataItem), "dd/MM/yyyy");
      },
      isExternalFilterPresent: isExternalFilterPresent,
      doesExternalFilterPass: doesExternalFilterPass,
      getMainMenuItems: function(params) {
        return getHeaderMenu(params, $filter);
      },
      localeTextFunc: function(key, defaultValue) {
        return translateGrid(key, defaultValue, $filter);
      }
    };

    init();
    /**
     * Initialize
     */
    function init() {
      if ($stateParams.backTo !== null && $stateParams.backTo !== undefined) {
        vm.isReport = true;
      }

      $rootScope.loadingProgress = true;
      if ($stateParams.id) {
        api.ComprasWS.InvoicePurchase.get(
          { id: $state.params.id },
          function(response) {
            // Success
            vm.statusToChange = response.purchaseStatus.description;
            $timeout(function() {
              if (vm.statusToChange === "Provisionada") {
                if ($stateParams.cl) {
                  vm.currentTab = 2;
                }
                var Url = $rootScope
                  .getParameterValue(keyContrasena)
                  .replace("[ID]", response.id);
                vm.reportContrasena = $sce.trustAsResourceUrl(
                  envService.read("baseUrlJReportsWSPdf") + "?rpt=" + Url
                );
              }
            }, 150);
            var ff = response.dateInvoicePurchase.split("-");
            var dateInvoicePurchase = new Date(
              ff[0],
              parseInt(ff[1]) - 1,
              ff[2]
            );
            response.dateInvoicePurchase = dateInvoicePurchase;
            ff = response.dateInvoiceAccounting.split("-");
            var dateInvoiceAccounting = new Date(
              ff[0],
              parseInt(ff[1]) - 1,
              ff[2]
            );
            response.dateInvoiceAccounting = dateInvoiceAccounting;

            if (response.companyProvider.documents) {
              response.companyProvider.documents = new jinqJs()
                .from(response.companyProvider.documents)
                .where(function(r) {
                  return (
                    r.document.documentType.name === "NIT" ||
                    r.document.documentType.name === "RTN"
                  );
                })
                .select();
            }

            vm.invoice = response;
            vm.permissionCancelInvoice = $rootScope.getEspecialActionByName('Cancelar Factura')
              && vm.statusToChange === 'Pendiente de Carga POS';
            getDimensionCompany();

            var totalNull = 0;
            vm.invoice.totalBeforeTax = vm.invoice.totalBeforeTax
              ? vm.invoice.totalBeforeTax.toFixed(2)
              : totalNull.toFixed(2);
            vm.invoice.totalAfterTax = vm.invoice.totalAfterTax
              ? vm.invoice.totalAfterTax.toFixed(2)
              : totalNull.toFixed(2);
            api.ComprasWS.InvoicePurchaseFiles.get(
              { id: $state.params.id },
              function(response) {
                // Success
                vm.invoice.files = response;
                vm.filesToUpload = response;
                vm.images = [];
                vm.otherFormats = [];
                vm.invoice.files.forEach(function(r) {
                  var ft = {
                    url: getPhoto(null, r),
                    type: "image",
                    original: r,
                    extension: r.extension
                  };
                  if (ft.url + "s.jpg" === vm.photoUp) {
                    ft.default = true;
                  }
                  if (ft.extension === ".pdf") {
                    vm.otherFormats.push(ft);
                  } else {
                    vm.images.push(ft);
                  }
                });
                if (vm.images.length > 0) {
                  vm.updateImageZoomOptions(vm.images[0]);
                } else {
                  if (vm.otherFormats.length > 0) {
                    vm.fileOtherFormat = vm.otherFormats[0];
                    vm.fileUrl = $sce.trustAsResourceUrl(
                      vm.fileOtherFormat.url + vm.fileOtherFormat.extension
                    );
                  } else {
                    vm.updateImageZoomOptions({
                      url: getPhoto(),
                      type: "image",
                      extension: ".jpg"
                    });
                  }
                }
                getDetailByInvoice();
                withholdingToInvoice();
                $rootScope.loadingProgress = false;
              },
              function(response) {
                // Error
                $log.debug(response);
                $rootScope.loadingProgress = false;
              }
            );
          },
          function(response) {
            // Error
            $log.debug(response);
            $rootScope.loadingProgress = false;
          }
        );
      } else {
        $state.go("app.invoice." + $stateParams.status.replace("-", ""));
        $state.params.company = $rootScope.company;
      }
    }

    function rotate() {
      vm.valRotate =
        vm.valRotate && vm.valRotate !== 270 ? vm.valRotate + 90 : 0;
      vm.styleImage = "rotate-" + vm.valRotate + "-class";
    }

    function getDetailByInvoice() {
      getMasterColumnsDefs();
      if (vm.invoice) {
        getColumnDimensionCompany(vm.NUMBER_DIMENSION_THREE);
        getColumnDimensionCompany(vm.NUMBER_DIMENSION_FOUR);
        getColumnDimensionCompany(vm.NUMBER_DIMENSION_FIVE);
        api.ComprasWS.InvoicePurchaseDetail.byInvoice(
          {
            id: "byInvoicePurchase",
            invoiceId: vm.invoice.id,
            idCircle: $rootScope.bsCircle.id
          },
          function(response) {
            vm.details = new jinqJs().from(response).select(function(r) {
              var d = r;
              d.invoicePurchase = vm.invoice;
              d.filter = d.merchandiseEntry
                ? (
                    d.product.name +
                    "," +
                    d.merchandiseEntry.purchaseOrderDetail.purchaseOrder
                      .department.description +
                    "," +
                    d.merchandiseEntry.purchaseOrderDetail.purchaseOrder
                      .costCenter.description
                  ).toLowerCase()
                : d.product.name.toLowerCase();
              return d;
            });
            vm.masterGridOptionsE.api.setColumnDefs(vm.masterColumnDefs);
            vm.masterGridOptionsE.api.setRowData(vm.details);
            resizeAllColumns();
          },
          function(response) {
            // Error
            $log.debug(response);
            vm.loading = false;
            $rootScope.loadingProgress = false;
            vm.masterGridOptionsE.api.setColumnDefs(vm.masterColumnDefs);
            vm.masterGridOptionsE.api.setRowData([]);
          }
        );
        $timeout(function() {
          getPurchaseOrder();
        }, 3000);
      }
    }

    vm.masterColumnDefs = [
      {
        headerName: "INVOICE.PRODUCT.PRODUCT",
        field: "product.name",
        headerCellRenderer: getHeader,
        width: 300,
        enableRowGroup: true,
        enablePivot: true
      },
      {
        headerName: "INVOICE.DEPARTMENT",
        field:
          "merchandiseEntry.purchaseOrderDetail.purchaseOrder.department.description",
        headerCellRenderer: getHeader,
        width: 200,
        enableRowGroup: true,
        enablePivot: true
      },
      {
        headerName: "INVOICE.COST_CENTER",
        field:
          "merchandiseEntry.purchaseOrderDetail.purchaseOrder.costCenter.description",
        headerCellRenderer: getHeader,
        width: 200,
        enableRowGroup: true,
        enablePivot: true
      },
      {
        headerName: "INVOICE.INVOICE_PURCHASE.DETAIL.QUANTITY",
        field: "quantity",
        headerCellRenderer: getHeader,
        width: 100,
        enableRowGroup: true,
        enablePivot: true,
        cellStyle: { "text-align": "center" }
      },
      {
        headerName: "INVOICE.INVOICE_PURCHASE.DETAIL.UNIT_PRICE_AFTER_TAX",
        field: "priceAfterTaxCurrency",
        headerCellRenderer: getHeader,
        width: 100,
        suppressSorting: true,
        suppressMenu: true,
        cellStyle: { "text-align": "right" }
      },
      {
        headerName: "INVOICE.INVOICE_PURCHASE.DETAIL.TOTAL_AFTER_TAX",
        field: "subTotalAfterTaxCurrency",
        headerCellRenderer: getHeader,
        suppressSorting: true,
        suppressMenu: true,
        width: 100,
        cellStyle: { "text-align": "right" }
      },
      {
        headerName: "INVOICE.INVOICE_PURCHASE.OPTIONS",
        headerCellRenderer: getHeader,
        suppressSorting: true,
        suppressMenu: true,
        width: 100,
        cellRenderer: renderer,
        cellStyle: { padding: "0px" }
      }
    ];

    vm.masterGridOptionsE = {
      columnDefs: vm.masterColumnDefs,
      enableSorting: true,
      debug: false,
      enableFilter: true,
      enableColResize: true,
      angularCompileRows: true,
      angularCompileHeaders: true,
      rowData: null,
      groupHeaders: true,
      headerHeight: 50,
      rowHeight: 45,
      doesDataFlower: function(dataItem) {
        var totalNull = 0;
        dataItem.priceAfterTaxCurrency = dataItem.priceAfterTax
          ? dataItem.priceAfterTax.toFixed(2)
          : totalNull.toFixed(2);
        dataItem.subTotalAfterTaxCurrency = dataItem.subTotalAfterTax
          ? dataItem.subTotalAfterTax.toFixed(2)
          : totalNull.toFixed(2);
        dataItem.priceAfterTaxCurrency =
          dataItem.invoicePurchase.currency.symbol +
          ". " +
          dataItem.priceAfterTaxCurrency;
        dataItem.subTotalAfterTaxCurrency =
          dataItem.invoicePurchase.currency.symbol +
          ". " +
          dataItem.subTotalAfterTaxCurrency;
        return true;
      },
      isExternalFilterPresent: isExternalFilterPresent,
      doesExternalFilterPass: doesExternalFilterPass,
      getMainMenuItems: function(params) {
        return getHeaderMenu(params, $filter);
      },
      localeTextFunc: function(key, defaultValue) {
        return translateGrid(key, defaultValue, $filter);
      }
    };

    var filter = "everyone";

    function isExternalFilterPresent() {
      // if ageType is not everyone, then we are filtering
      return filter !== "";
    }

    function doesExternalFilterPass(node) {
      if (filter && filter !== "everyone") {
        var arrdt = node.data.filter.split(filter);
        return arrdt.length > 1;
      }
      return true;
    }

    $scope.$watch("vm.search", function(newValue) {
      filter = newValue;
      if (vm.masterGridOptionsE.api) {
        vm.masterGridOptionsE.api.onFilterChanged();
      }
    });

    function renderer(params) {
      return (
        '<div style="width: 100%;">' +
        '       <md-button class="edit-button md-icon-button" ng-click="vm.goToInvoicePurchaseDetailEdit(data)" aria-label="Order details"' +
        '                                translate translate-attr-aria-label="REQUISITION.ORDER_DETAILS">' +
        '                         <md-tooltip md-direction="bottom">' +
        '                             {{"REQUISITION.DETAIL.VIEW"| translate}}' +
        "                         </md-tooltip>" +
        '                         <md-icon md-font-icon="icon-eye" class="s16"></md-icon> ' +
        "                     </md-button>" +
        "                 </div>"
      );
    }
    function getPhoto(url, ph) {
      if (ph) {
        url = ph.parentPath + ph.name;
      }
      if (url) {
        return vm.URLPHOTOS + url;
      }
      return "assets/images/etc/thumbPhoto";
    }

    function gotToInvoices() {
      if ($stateParams.backTo !== null && $stateParams.backTo !== undefined) {
        vm.isReport = true;
        $state.go($stateParams.backTo, { filter: $stateParams.filter });
      } else if ($stateParams.isSettlement) {
        $state.go("app.expenseSettlement.settlement.settlementView", {
          settlementId: $stateParams.fromparams.settlementId
        });
      } else {
        $state.go("app.invoice." + $stateParams.status);
      }
    }

    function updateImageZoomOptions(img) {
      var url = img.url;
      var extension = img.extension;
      vm.imageZoomOptions = {
        images: [
          {
            thumb: url + extension,
            medium: url + extension,
            large: url + extension
          }
        ]
      };
    }

    /**
     * Cambia estado a una factura
     * @param {type} ev
     * @returns {undefined}
     */
    function changeStatusInvoice(ev) {
      var confirm = $mdDialog
        .confirm()
        .title(
          $filter('translate')(
            "INVOICE.MSG." + $stateParams.status + "_INVOICE"
          )
        )
        .textContent(
          $filter('translate')(
            "INVOICE.MSG.CONFIRMACION_" + $stateParams.status + "_INVOICE"
          )
        )
        .ok($filter('translate')(INVOICE_MSG_SI))
        .cancel($filter('translate')(INVOICE_MSG_NO));
      $mdDialog.show(confirm).then(
        function() {
          if ($stateParams.status === "Verificada") {
            provisionInvioce(ev);
          }

          if ($stateParams.status === "Emitida") {
            provisionInvioce(ev);
          }
        },
        function() {}
      );
    }
    /**
     * Abre compose para verificar fecha de contabilización
     * @param {type} ev
     * @returns {undefined}
     */
    function provisionInvioce(ev) {
      $mdDialog
        .show({
          controller: "ProvisionInvoiceComposeController",
          controllerAs: "vm",
          templateUrl:
            "app/main/apps/documentVerify/purchase/compose/compose-dialog.html",
          parent: angular.element("#main"),
          targetEvent: ev,
          locals: {
            InvoiceWithholdingDetails: vm.InvoiceWithholdingDetails
          },
          invoice: vm.invoice,
          clickOutsideToClose: false
        })
        .then(function(answer) {
          answer === true ? gotToInvoices() : null;
        });
    }

    function goToInvoicePurchaseDetailEdit(data) {
      $mdDialog
        .show({
          controller: "DetailEditorController",
          controllerAs: "vm",
          templateUrl:
            "app/main/apps/invoice/saleInvoice/detailEditor/detailEditor.html",
          parent: angular.element("#main"),
          InvoicePurchase: vm.invoicePurchase,
          serie: vm.invoice.invoiceSerie,
          edited: data,
          id: data.id,
          Taxes: vm.taxes,
          canEdit: false,
          clickOutsideToClose: false
        })
        .then(function(answer) {
          //go to Quotations
          answer === true ? goToInvoicePurchases() : null;
        });
    }
    function changeTab() {
      vm.maxHeight = vm.currentTab === 0 ? "160px" : "80px";
    }

    //AUTORIZAR, NO AUTORIZAR
    function notAuthorizated(ev) {
      $mdDialog
        .show({
          controller: "rejectionReasonController",
          controllerAs: "vm",
          locals: {
            Data: $stateParams.detail,
            detailId: 0
          },
          templateUrl:
            "app/main/apps/expenseSettlements/settlements/settlement/settlementEditor/rejectionReason/rejectionReason.html",
          parent: angular.element("#main"),
          targetEvent: ev,
          clickOutsideToClose: false
        })
        .then(
          function(answer) {
            gotToInvoices();
          },
          function() {}
        );
    }

    function changeOtherStatusInvoice(status) {
      var confirm = $mdDialog
        .confirm()
        .title($filter('translate')('INVOICE.MSG.' + status + '_INVOICE'))
        .textContent(
          $filter('translate')(
            "INVOICE.MSG.CONFIRMACION_" + status + "_INVOICE"
          )
        )
        .ok($filter('translate')(INVOICE_MSG_SI))
        .cancel($filter('translate')(INVOICE_MSG_NO));
      $mdDialog.show(confirm).then(
        function() {

          if (vm.invoice.invoiceSerie){
            vm.invoice.invoiceSerie = { id: vm.invoice.invoiceSerie.id };
          }
          api.ComprasWS.InvoicePurchase.setStatus(
            {
              id: "changeStatus",
              idCircle: $rootScope.bsCircle.id,
              status: status
            },
            vm.invoice
          ).$promise.then(
            function(response) {
              $rootScope.loadingProgress = false;
              $mdToast.show({
                template:
                  '<md-toast layout="column" layout-align="center start">' +
                  '<div class="md-toast-content" translate="INVOICE.MSG.STATUS_CHANGE_SUCCESS"></div></md-toast>',
                hideDelay: 3000,
                position: "top right"
              });
              gotToInvoices();
            },
            function(response) {
              $rootScope.loadingProgress = false;
              $log.error(response);
            }
          );
        },
        function() {}
      );
    }

    function withholdingToInvoice() {
      if (vm.invoice) {
        vm.invoicePurchaseWithholding = {
          totalWithholding: 0,
          invoicePurchase: vm.invoice
        };

        api.ComprasWS.InvoicePurchaseWithholdingDetail.Details.getByInvoice(
          { id: "byInvoicePurchaseWithholding", invoiceId: vm.invoice.id },
          function(data) {
            vm.InvoiceWithholdingDetails = data;
            if (vm.InvoiceWithholdingDetails.length > 0) {
              vm.fileWithholding =
                data[0].invoicePurchaseWithholding.fileWithholding;
              vm.masterGridOptionsRet.api.setColumnDefs(vm.masterColumnDefsRet);
              vm.masterGridOptionsRet.api.setRowData(
                vm.InvoiceWithholdingDetails
              );
              vm.invoicePurchaseWithholding =
                vm.InvoiceWithholdingDetails[0].invoicePurchaseWithholding;
            }
          },
          function(errResponse) {
            $log.debug(errResponse);
          }
        );
      }
    }

    function viewIMG(file) {
      $mdDialog
        .show({
          controller: "DialogPhotoController",
          controllerAs: "vm",
          templateUrl: "app/main/apps/files/dialogPhoto/dialogPhoto.html",
          parent: angular.element("#main"),
          name: file.originalName,
          url: vm.URLPHOTOS + file.parentPath + file.name + file.extension,
          clickOutsideToClose: false
        })
        .then(function(answer) {});
    }

    function resizeAllColumns() {
      //hace el autoSize para ajustar todas las columnas
      var allColumnIds = [];
      vm.masterColumnDefs.forEach(function(columnDef) {
        if (columnDef.field) {
          allColumnIds.push(columnDef.field);
        }
      });

      $timeout(function() {
        vm.masterGridOptionsE.columnApi.autoSizeColumns(allColumnIds, false);
      }, 500);
    }

    function getPurchaseOrder() {
      vm.quotationsToAuthorize = [];
      vm.detailsPurchaseOrder = [];
      vm.details.forEach(function(data, index) {
        if (data.merchandiseEntry.purchaseOrderDetail) {
          if (
            !addPurchaseOrderToInvoice(
              data.merchandiseEntry.purchaseOrderDetail.purchaseOrder
            )
          ) {
            vm.quotationsToAuthorize.push(
              data.merchandiseEntry.purchaseOrderDetail.purchaseOrder
            );
            $rootScope.loadingProgress = true;
            api.ComprasWS.PurchaseOrderDetail.query(
              {
                idCircle: $rootScope.bsCircle.id,
                idPurchaseOrder:
                  data.merchandiseEntry.purchaseOrderDetail.purchaseOrder.id
              },
              function(response) {
                response.forEach(function(r) {
                  r.maxRecibe = angular.copy(r.quantity);
                  r.quantity = 0;
                  r.purchaseOrder =
                    data.merchandiseEntry.purchaseOrderDetail.purchaseOrder;
                  vm.detailsPurchaseOrder.push(r);
                });
                $rootScope.loadingProgress = false;
                vm.masterGridOptionsPurchaseOrder.api.setColumnDefs(
                  vm.masterColumnDefsPurchaseOrder
                );
                vm.masterGridOptionsPurchaseOrder.api.setRowData(
                  vm.detailsPurchaseOrder
                );
              },
              function(errResponse) {
                $log.debug(errResponse);
                $rootScope.loadingProgress = false;
                vm.detailsPurchaseOrder = [];
              }
            );
          }
        }
      });
    }

    function addPurchaseOrderToInvoice(purchaseOrder) {
      for (var i = 0; i < vm.quotationsToAuthorize.length; i++) {
        if (purchaseOrder.id === vm.quotationsToAuthorize[i].id) {
          return true;
        }
      }

      return false;
    }

    function getDateFormat(dataItem) {
      if (
        dataItem.purchaseOrder &&
        dataItem.purchaseOrder.contractPurchase === null
      ) {
        var day = 0;
        var month = 0;
        if (dataItem.purchaseOrder.createdAt.dayOfMonth < 10) {
          day = "0" + dataItem.purchaseOrder.createdAt.dayOfMonth;
        } else {
          day = dataItem.purchaseOrder.createdAt.dayOfMonth;
        }
        if (dataItem.purchaseOrder.createdAt.monthValue < 10) {
          month = "0" + dataItem.purchaseOrder.createdAt.monthValue;
        } else {
          month = dataItem.purchaseOrder.createdAt.monthValue;
        }
        return new Date(
          dataItem.purchaseOrder.createdAt.year + "-" + month + "-" + day
        );
      } else if (dataItem.purchaseOrder) {
        return dataItem.purchaseOrder.dateDelivery;
      } else {
        if (dataItem.createdAt.dayOfMonth < 10) {
          day = "0" + dataItem.createdAt.dayOfMonth;
        } else {
          day = dataItem.createdAt.dayOfMonth;
        }
        if (dataItem.createdAt.monthValue < 10) {
          month = "0" + dataItem.createdAt.monthValue;
        } else {
          month = dataItem.createdAt.monthValue;
        }
        return new Date(dataItem.createdAt.year + "-" + month + "-" + day);
      }
    }

    function getMasterColumnsDefs() {
      vm.masterColumnDefs = [
        {
          headerName: 'INVOICE.PRODUCT.PRODUCT',
          field: 'product.name',
          headerCellRenderer: getHeader,
          width: 300,
          enableRowGroup: true,
          enablePivot: true
        },
        {
          headerName: 'INVOICE.DEPARTMENT',
          field:
            'merchandiseEntry.purchaseOrderDetail.purchaseOrder.department.description',
          headerCellRenderer: getHeader,
          width: 200,
          enableRowGroup: true,
          enablePivot: true
        },
        {
          headerName: 'INVOICE.COST_CENTER',
          field:
            'merchandiseEntry.purchaseOrderDetail.purchaseOrder.costCenter.description',
          headerCellRenderer: getHeader,
          width: 200,
          enableRowGroup: true,
          enablePivot: true
        },
        {
          headerName: 'INVOICE.INVOICE_PURCHASE.DETAIL.QUANTITY',
          field: 'quantity',
          headerCellRenderer: getHeader,
          width: 100,
          enableRowGroup: true,
          enablePivot: true,
          cellStyle: { 'text-align': 'center' }
        },
        {
          headerName: 'INVOICE.INVOICE_PURCHASE.DETAIL.UNIT_PRICE_AFTER_TAX',
          field: 'priceAfterTaxCurrency',
          headerCellRenderer: getHeader,
          width: 100,
          suppressSorting: true,
          suppressMenu: true,
          cellStyle: { 'text-align': 'right' }
        },
        {
          headerName: 'INVOICE.INVOICE_PURCHASE.DETAIL.TOTAL_AFTER_TAX',
          field: 'subTotalAfterTaxCurrency',
          headerCellRenderer: getHeader,
          suppressSorting: true,
          suppressMenu: true,
          width: 100,
          cellStyle: { 'text-align': 'right' }
        },
        {
          headerName: 'INVOICE.INVOICE_PURCHASE.OPTIONS',
          headerCellRenderer: getHeader,
          suppressSorting: true,
          suppressMenu: true,
          width: 100,
          cellRenderer: renderer,
          cellStyle: { padding: '0px' }
        }
      ];
    }

    function getDimensionCompany() {
      api.GeneralWS.DimensionCompany.byCompany.getList(
        { 'company': vm.invoice.companyBuyer.id }
      ).$promise.then(function (responseDimension) {
        for (let i = 0; i < responseDimension.length; i++) {
          if (responseDimension[i].dimensionNumber === vm.NUMBER_DIMENSION_THREE) {
            vm.dimensionCompanyDetail3 = responseDimension[i];
          } else if (responseDimension[i].dimensionNumber === vm.NUMBER_DIMENSION_FOUR) {
            vm.dimensionCompanyDetail4 = responseDimension[i];
          } else if (responseDimension[i].dimensionNumber === vm.NUMBER_DIMENSION_FIVE) {
            vm.dimensionCompanyDetail5 = responseDimension[i];
          } else {
            vm.dimensionCompanyDetail1 = responseDimension[i];
          }
        }
      });
    }

    function getColumnDimensionCompany(number) {
      if (vm['dimensionCompanyDetail' + number]) {
        vm.masterColumnDefs.splice(number, 0, {
          headerName: vm['dimensionCompanyDetail' + number].description,
          field: 'merchandiseEntry.purchaseOrderDetail.purchaseOrder.dimensionCompanyDetail' + number + '.name',
          headerCellRenderer: getHeader,
          width: 250,
          enableRowGroup: true,
          enablePivot: true,
          cellStyle: { 'text-align': 'center' }
        });
      }
    }

    function changeCancelStatusInvoice() {
      $rootScope.loadingProgress = true;
      const confirm = $mdDialog.confirm()
        .title($filter('translate')('INVOICE.MSG.Cancelar_INVOICE'))
        .textContent($filter('translate')('INVOICE.MSG.CONFIRMACION_Cancelar_INVOICE'))
        .ok($filter('translate')(INVOICE_MSG_SI))
        .cancel($filter('translate')(INVOICE_MSG_NO));
      $mdDialog.show(confirm).then(function () {
        api.ComprasWS.CancelInvoicePurchase.cancel({ id: vm.invoice.id, idCircle: $rootScope.bsCircle.id }).$promise.then(function () {
          $rootScope.loadingProgress = false;
          MessageService.show($filter('translate')('INVOICE.INVOCIE_CENCELED'));
          gotToInvoices();
        }, function (errResponse) {
          $rootScope.loadingProgress = false;
          MessageService.showErrorMessage(errResponse.data.mensaje);
        });
      }, function () {
        $rootScope.loadingProgress = false;
      });
    }

  }
})();

(function () {
    'use strict';

    angular
        .module('app.invoice')
        .controller('LimitDateController', LimitDateController);

    /** @ngInject */
    function LimitDateController($scope, $rootScope, $state, api, $log, $filter, $mdDialog, MessageService) {
        var vm = this;

        vm.createInvoiceLimitDate = createInvoiceLimitDate;
        vm.deleteInvoiceLimitDate = deleteInvoiceLimitDate;

        if ($rootScope.bsCircle) {
            $rootScope.loadingProgress = true;
            vm.loading = true;
            init();
        } else {
            vm.loading = false;
            $state.go('app.dashboard_project');
        }

        onStart();
        function onStart() {
            api.ComprasWS.InvoicePurchaseLimitDateType.Active.query({}).$promise.then(function (response) {
                vm.limitDateType = response;
            }, function (response) {
            });
        }

        function init() {

            api.ComprasWS.InvoicePurchaseLimitDate.LimitDate.query(
                { companyId: $rootScope.bsCircle.company.id, page: 0, pageSize: 100 }).$promise.then(function (response) {

                    vm.invoicePurchases = response;
                    vm.masterGridOptions.api.setColumnDefs(vm.masterColumnDefs);
                    vm.masterGridOptions.api.setRowData(new jinqJs()
                        .from(vm.invoicePurchases.content)
                        .orderBy([{ field: 'id', sort: 'asc' }])
                        .select());
                    vm.loading = false;
                }, function (response) {
                    $log.debug(response);
                    vm.loading = false;
                    vm.masterGridOptions.api.setColumnDefs(vm.masterColumnDefs);
                    vm.masterGridOptions.api.setRowData([]);
                    $rootScope.loadingProgress = false;
                });
        }

        vm.masterColumnDefs = [
            {
                headerName: 'INVOICE.LIMIT_DATE.TYPE',
                field: "invoicePurchaseLimitDateType.limitDateTypeName",
                headerCellRenderer: getHeader,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'INVOICE.INVOICE_PURCHASE.DATE_MIN',
                field: "minDate",
                headerCellRenderer: getHeader,
                valueFormatter: function (params) {
                    return $filter('date')(new Date(params.value), 'dd/MM/yyyy');
                },
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'INVOICE.INVOICE_PURCHASE.DATE_MAX',
                field: "maxDate",
                headerCellRenderer: getHeader,
                valueFormatter: function (params) {
                    return $filter('date')(new Date(params.value), 'dd/MM/yyyy');
                },
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'INVOICE.INVOICE_PURCHASE.DATE_REFERENCE',
                field: "referenceDate",
                headerCellRenderer: getHeader,
                valueFormatter: function (params) {
                    return $filter('date')(new Date(params.value), 'dd/MM/yyyy');
                },
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'INVOICE.INVOICE_PURCHASE.OPTIONS',
                headerCellRenderer: getHeader,
                suppressSorting: true,
                suppressMenu: true,
                width: 150,
                cellRenderer: renderer,
                cellStyle: { 'padding': '0px' }
            }
        ];


        vm.masterGridOptions = {
            columnDefs: vm.masterColumnDefs,
            enableSorting: true,
            debug: false,
            enableFilter: true,
            enableColResize: true,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowData: null,
            groupHeaders: true,
            headerHeight: 50,
            rowHeight: 45,
            doesDataFlower: function (dataItem) {
                dataItem.minDate = new Date(dataItem.minDate + ' 00:00:00');
                dataItem.maxDate = new Date(dataItem.maxDate + ' 00:00:00');
                dataItem.referenceDate = new Date(dataItem.referenceDate + ' 00:00:00');
                return true;
            },
            isExternalFilterPresent: isExternalFilterPresent,
            doesExternalFilterPass: doesExternalFilterPass,
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            }
        };

        var filter = 'everyone';

        function isExternalFilterPresent() {
            return filter !== '';
        }

        function doesExternalFilterPass(node) {
            if (filter && filter !== 'everyone') {
                var arrdt = node.data.filter.split(filter);
                return arrdt.length > 1;
            }
            return true;
        }

        $scope.$watch('vm.search',
            function (newValue) {
                filter = newValue ? newValue.toLowerCase() : 'everyone';
                vm.masterGridOptions.api.onFilterChanged();
            }
        );

        function renderer(params) {
            return '<div style="width: 100%;">'
                + '                 <md-button class="edit-button md-icon-button" ng-disabled="" ng-click="vm.createInvoiceLimitDate($index, data.id, data)" '
                + ' aria-label="rejectionReason"'
                + '                               translate translate-attr-aria-label="REJECTIONREASON.EDIT">'
                + '                        <md-tooltip md-direction="bottom">'
                + '                            {{"REJECTIONREASON.EDIT"| translate}}'
                + '                        </md-tooltip>'
                + '                        <md-icon md-font-icon="icon-pencil" class="s16"></md-icon> '
                + '                     </md-button>'
                + '                     <md-button class="edit-button md-icon-button md-warn" ng-disabled="" '
                + ' ng-click="vm.deleteInvoiceLimitDate($event, data.id, data, $index)" aria-label="pettyCash"'
                + '                               translate translate-attr-aria-label="REJECTIONREASON.DELETE">'
                + '                        <md-tooltip md-direction="bottom">'
                + '                            {{"REJECTIONREASON.DELETE"| translate}}'
                + '                        </md-tooltip>'
                + '                        <md-icon md-font-icon="icon-delete" class="s16"></md-icon> '
                + '                     </md-button>'
                + '                </div>';
        }

        function createInvoiceLimitDate(i, id, data) {
            var detail = angular.copy(data);
            $mdDialog.show({
                controller: 'editLimitDateController',
                controllerAs: 'vm',
                locals: {
                    invoicePurchaseLimitDate: detail,
                    InvoicePurchaseType: vm.limitDateType
                },
                templateUrl: 'app/main/apps/invoice/configureLimitDate/editLimitDate/editLimitDate.html',
                parent: angular.element("#main"),
                clickOutsideToClose: false
            }).then(function (answer) {
                init();
                $rootScope.loadingProgress = false;
            }, function () {
                $rootScope.loadingProgress = false;
            });
        }

        function deleteInvoiceLimitDate(e, id, data, i) {

            var confirm = $mdDialog.confirm()
                .title($filter('translate')('INVOICE.DELETE'))
                .htmlContent($filter('translate')('INVOICE.MSG.CONFIRMACION_Eliminar'))
                .ariaLabel('Delete Detail')
                .ok($filter('translate')('REJECTIONREASON.DELETE'))
                .cancel($filter('translate')('REJECTIONREASON.CANCEL'));

            $mdDialog.show(confirm).then(function () {
                $rootScope.loadingProgress = true;
                api.ComprasWS.InvoicePurchaseLimitDate.LimitDate.delete({ companyId: $rootScope.bsCircle.company.id, 'id': id }, function (response) {
                    init();
                    MessageService.show($filter('translate')('INVOICE.DELETED'));
                    $rootScope.loadingProgress = false;
                }, function (response) {// Error
                    $log.debug(response);
                    $rootScope.loadingProgress = false;
                    if (response.data === "can not deleted") {
                        MessageService.show($filter('translate')('REJECTIONREASON.MSGDELETEERROR'));
                    }
                });

            }, function () {
            });
        }
    }
})();

(function () {

    'use strict';

    angular
        .module('app.files', [])
        .config(config)
        .directive('filesUploader', function() {
            return {
                restrict: 'E',
                scope: {
                    fileType: '@',
                    vm: '=',
                },
                template: '<div ng-include="\'app/main/apps/files/files.html\'"></div>',
            };
        });

    /**@ngInject**/
    function config($translatePartialLoaderProvider) {
        $translatePartialLoaderProvider.addPart('app/main/apps/files');
    }

})();

(function () {

    'use strict';

    angular
        .module('app.files')
        .controller('DialogPhotoController', DialogPhotoController);

    function DialogPhotoController(name, url, $mdDialog, $log, $sce) {

        var vm = this;

        vm.name = name;
        vm.url = url;
        vm.isIMG = true;

        if (url.endsWith('.pdf')) {
            vm.isIMG = false;
            vm.isPDF = true;
        }

        vm.trustSrc = function (src) {
            return $sce.trustAsResourceUrl(src);
        }


        vm.closeDialog = function () {
            $mdDialog.cancel();
        };

        vm.printElement = function (divName) {
            $log.debug('entra imprimir');
            var printContents = document.getElementById(divName).innerHTML;
            var w = window.open();
            w.document.write(printContents);
            w.print();
            w.close();
        };

    }

})();

(function () {
    'use strict';

    angular
        .module('app.expenseSettlement.provisioned', [])
        .config(config);


    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {
        // State
        $stateProvider
            .state('app.expenseSettlement.provisionedx', {
                url: '/provisioned',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/expenseSettlements/settlementsProvisioned/settlementProvisioned.html',
                        controller: 'settlementsProvisionedController as vm'
                    }
                },
                bodyClass: 'mail'
            });
        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/expenseSettlements');


    }
})();


(function () {
    'use strict';

    angular
        .module('app.expenseSettlement.provisioned')
        .controller('settlementsProvisionedController', settlementsProvisionedController);

    /** @ngInject */
    function settlementsProvisionedController($scope, $rootScope, $mdToast, api, $log, $mdDialog, $filter, $state) {
        var vm = this;

        //Data

        //Methods
        vm.cancelProvision = cancelProvision;
        vm.openSettlement = openSettlement;
        vm.viewChangeStatus = viewChangeStatus;

        /////////
        init();

        function init() {
            $rootScope.loadingProgress = true;
            api.ComprasWS.Settlement.getAllSettlementProvisioned.allProvisioned({ idCircle: $rootScope.bsCircle.id }).$promise.then(function (data) {
                vm.settlements = new jinqJs()
                    .from(data).
                    select(function (r) {
                        var d = r;
                        d.filter = (
                            d.pettyCashId + "," +
                            d.pettyCashDescription + "," +
                            d.companyName + "," +
                            d.holderAccount + "," +
                            d.costCenterDescription + "," +
                            d.departmentDescription + "," +
                            d.erpReference + "," +
                            d.settlementStatusName + "," +
                            d.settlementId
                        ).toLowerCase();
                        return d;
                    });
                vm.masterGridOptions.api.setColumnDefs(vm.masterColumnDefs);
                vm.settlementsjson = data;

                $rootScope.loadingProgress = false;
                vm.masterGridOptions.api.setRowData(data);
            }, function (error) {
                $log.error(error.data);
                $rootScope.loadingProgress = false;
            });
        }

        vm.masterColumnDefs = [
            {
                headerName: 'EXPENSE_SETTLEMENTS.PETTY_CASH.PETTY_CASH',
                field: "pettyCashId",
                headerCellRenderer: getHeader,
                width: 125,
                enableRowGroup: true,
                enablePivot: true,
                pinned: "left"
            },
            {
                headerName: 'EXPENSE_SETTLEMENTS.PETTY_CASH.PETTYCASHTYPE',
                field: "pettyCashDescription",
                headerCellRenderer: getHeader,
                width: 200,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'EXPENSE_SETTLEMENTS.PETTY_CASH.COMPANY',
                field: "companyName",
                headerCellRenderer: getHeader,
                width: 250,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'EXPENSE_SETTLEMENTS.PETTY_CASH.HOLDER',
                field: "holderAccount",
                headerCellRenderer: getHeader,
                width: 250,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'EXPENSE_SETTLEMENTS.PETTY_CASH.COST_CENTER',
                field: "costCenterDescription",
                headerCellRenderer: getHeader,
                width: 250,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'EXPENSE_SETTLEMENTS.PETTY_CASH.DEPARTMENT',
                field: "departmentDescription",
                headerCellRenderer: getHeader,
                width: 250,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'EXPENSE_SETTLEMENTS.SETTLEMENT.SETTLEMENT',
                headerCellRenderer: getHeader,
                width: 100,
                enableRowGroup: true,
                enablePivot: true,
                cellRenderer: function renderer() {
                    return '<div style="width: 100%;">'
                        + ' {{data.settlementId}}  '
                        + ' <md-button class="edit-button md-icon-button" ng-click="vm.viewChangeStatus(data, $event)" aria-label="settlement"'
                        + ' translate translate-attr-aria-label="SETTLEMENT.CHANGE_STATUS.CHANGE_STATUS">'
                        + ' <md-tooltip md-direction="bottom">'
                        + ' {{"SETTLEMENT.CHANGE_STATUS.CHANGE_STATUS"| translate}}'
                        + ' </md-tooltip>'
                        + '  <md-icon md-font-icon="icon-history" class="s16"></md-icon> '
                        + ' </md-button>'
                        + ' </div>';
                },
                cellStyle: { 'padding': '0px' }
            },
            {
                headerName: 'EXPENSE_SETTLEMENTS.PROVISIONED.ERP_REFERENCE',
                headerCellRenderer: getHeader,
                width: 150,
                enableRowGroup: false,
                enablePivot: false,
                suppressSorting: true,
                suppressMenu: true,
                cellRenderer: function renderer() {
                    return '<div style="width: 100%;">'
                        + ' {{data.erpReference}}  '
                        + ' <md-button class="edit-button md-icon-button" ng-click="vm.viewErpHistory(data)" aria-label="settlement"'
                        + ' translate translate-attr-aria-label="EXPENSE_SETTLEMENTS.PROVISIONED.ERP_HISTORY">'
                        + ' <md-tooltip md-direction="bottom">'
                        + ' {{"EXPENSE_SETTLEMENTS.PROVISIONED.ERP_HISTORY"| translate}}'
                        + ' </md-tooltip>'
                        + '  <md-icon md-font-icon="icon-history" class="s16"></md-icon> '
                        + ' </md-button>'
                        + ' </div>';
                },
                cellStyle: { 'padding': '0px' }
            },
            {
                headerName: 'EXPENSE_SETTLEMENTS.PROVISIONED.CANCEL_IN_ERP',
                field: "erpSendToCancel",
                headerCellRenderer: getHeader,
                width: 130,
                cellRenderer: function renderer(params) {
                    if (params.value) {
                        return '<md-icon md-font-icon="icon-checkbox-marked-circle green-500-fg"></md-icon>';
                    } else {
                        return '';
                    }
                }
            },
            {
                headerName: 'EXPENSE_SETTLEMENTS.SETTLEMENT.SETTLED_AMOUNT',
                field: "settledAmount",
                headerCellRenderer: getHeader,
                width: 150,
                valueFormatter: function (params) {
                    return $filter('number')(params.value, 2);
                },
                enableRowGroup: true,
                enablePivot: true,
                cellStyle: { 'text-align': 'right' }
            },
            {
                headerName: 'EXPENSE_SETTLEMENTS.OPTIONS',
                headerCellRenderer: getHeader,
                suppressSorting: true,
                suppressMenu: true,
                width: 215,
                cellRenderer: function renderer() {
                    return '<div style="width: 100%;">'
                        + ' <md-button class="edit-button md-icon-button" ng-click="vm.openSettlement(data.settlementId)" aria-label="settlement"'
                        + ' translate translate-attr-aria-label="SETTLEMENT.VIEW_DETAILS">'
                        + ' <md-tooltip md-direction="bottom">'
                        + ' {{"SETTLEMENT.VIEW_DETAILS"| translate}}'
                        + ' </md-tooltip>'
                        + '  <md-icon md-font-icon="icon-eye" class="s16"></md-icon> '
                        + ' </md-button>'
                        + ' <md-button class="edit-button md-icon-button" ng-click="vm.showPDF(\'JASPER_URL_SETTLEMENT\',data)" aria-label="settlement"'
                        + ' translate translate-attr-aria-label="SETTLEMENT.VIEW_DETAILS">'
                        + '     <md-tooltip md-direction="bottom">'
                        + '                    {{"SETTLEMENT.REPRINT_TENDER"| translate}}'
                        + '                </md-tooltip>'
                        + '                <md-icon md-font-icon="icon-printer" class="s16"></md-icon> '
                        + '           </md-button>'
                        + '             \n\<md-button class="edit-button md-icon-button" ng-click="vm.showPDF(\'JASPER_URL_SETTLEMENT_WITH_DETAILS\',data)" '
                        + ' aria-label="settlement"'
                        + '                       translate translate-attr-aria-label="Generar PDF">'
                        + '                <md-tooltip md-direction="bottom">'
                        + '                    {{"EXPENSE_SETTLEMENTS.GENERATE_PDF_WITH_DETAILS"| translate}}'
                        + '                </md-tooltip>'
                        + '                <md-icon md-font-icon="icon-clipboard-text" class="s16"></md-icon> '
                        + '            </md-button>'
                        + '           <md-button class="edit-button md-icon-button" ng-click="vm.cancelProvision(data)" aria-label="settlement" '
                        + ' ng-disabled="data.erpSendToCancel"'
                        + '                       translate translate-attr-aria-label="EXPENSE_SETTLEMENTS.PROVISIONED.CANCEL_PROVISION">'
                        + '                <md-tooltip md-direction="bottom">'
                        + '                    {{"EXPENSE_SETTLEMENTS.PROVISIONED.CANCEL_PROVISION"| translate}}'
                        + '                </md-tooltip>'
                        + '                <md-icon md-font-icon="icon-cancel" class="s16"></md-icon> '
                        + '            </md-button>'
                        + '        </div>';
                },
                cellStyle: { 'padding': '0px' },
                pinned: "right"
            }

        ];

        function viewChangeStatus(settlement, ev) {
            $mdDialog.show({
                controller: 'changeStatusController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/expenseSettlements/settlements/settlement/settlementEditor/changeStatus/changeStatus.html',
                targetEvent: ev,
                locals: {
                    settlementId: settlement.settlementId
                },
                clickOutsideToClose: false
            }).then(function (answer) {

            });
        }

        vm.showPDF = function (parameter, settlement) {

            var urlRpt = null;
            if (parameter === 'JASPER_URL_SETTLEMENT') {
                urlRpt = $rootScope.getParameterValue('JASPER_URL_SETTLEMENT').replace('[ID]', settlement.settlementId);
            } else if ('JASPER_URL_SETTLEMENT_WITH_DETAILS') {
                urlRpt = $rootScope.getParameterValue('JASPER_URL_SETTLEMENT_WITH_DETAILS').replace("[ID]", settlement.settlementId);
            }

            $mdDialog.show({
                controller: 'ReportShowPDFController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/reports/dialogs/show-pdf/show-pdf.html',
                parent: angular.element("#main"),
                locals: {
                    Url: urlRpt
                },
                clickOutsideToClose: false,
                fullscreen: true
            }).then(function (answer) {
            }, function () {
            });
        };

        vm.masterGridOptions = {
            columnDefs: vm.masterColumnDefs,
            enableSorting: true,
            debug: false,
            enableFilter: true,
            enableColResize: true,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowData: null,
            groupHeaders: true,
            headerHeight: 50,
            rowHeight: 45,
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            },
            doesDataFlower: function (dataItem) {
                return true;
            },
            isExternalFilterPresent: isExternalFilterPresent,
            doesExternalFilterPass: doesExternalFilterPass
        };

        var filter = 'everyone';

        function isExternalFilterPresent() {
            return filter !== '';
        }

        function doesExternalFilterPass(node) {
            if (filter && filter !== 'everyone') {
                var arrdt = node.data.filter.split(filter);
                return arrdt.length > 1;
            }
            return true;
        }

        $scope.$watch('vm.search',
            function (newValue) {
                filter = newValue ? newValue.toLowerCase() : 'everyone';
                vm.masterGridOptions.api.onFilterChanged();
            }
        );

        function openSettlement(id) {
            $state.go('app.expenseSettlement.settlement.settlementView', { settlementId: id });
        }

        function cancelProvision(settlement) {
            var i = vm.settlements.indexOf(settlement);
            $rootScope.loadingProgress = true;
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('EXPENSE_SETTLEMENTS.PROVISIONED.MSG_SURE_CANCEL_PROVISION'))
                .content($filter('translate')('EXPENSE_SETTLEMENTS.PROVISIONED.MSG_CANCEL_PROVISION'))
                .ariaLabel('Delete Detail')
                .ok($filter('translate')('SETTLEMENT.OK'))
                .cancel($filter('translate')('SETTLEMENT.CANCEL'));
            $mdDialog.show(confirm).then(function () {
                $rootScope.loadingProgress = true;
                api.ComprasWS.Settlement.cancelProvisionSettlement.cancel(
                    { settlementId: settlement.settlementId, idCircle: $rootScope.bsCircle.id }).$promise.then(function (response) {
                        if (settlement.erpReference === null) {
                            vm.settlements.splice(i, 1);
                            showMessage($filter('translate')('EXPENSE_SETTLEMENTS.PROVISIONED.CANCEL_PROVISION_OK2'));
                        } else {
                            vm.settlements[i].erpSendToCancel = response.erpSendToCancel;
                            showMessage($filter('translate')('EXPENSE_SETTLEMENTS.PROVISIONED.CANCEL_PROVISION_OK'));
                        }
                        vm.masterGridOptions.api.setRowData(vm.settlements);
                    }, function (error) {
                        $log.error(error.data);
                        showErrorMessage($filter('translate')('EXPENSE_SETTLEMENTS.PROVISIONED.CANCEL_PROVISION_ERROR'));
                    });
            }, function () {
                // Cancel Action
                $rootScope.loadingProgress = false;
            });
        }

        loadEntityCatalog();
        function loadEntityCatalog() {
            vm.loadingEntity = true;
            api.InterfazWS.EntityCatalog.me.query({}).$promise.then(function (response) {
                vm.loadingEntity = false;
                vm.entityCatalog = response;

                for (var i = 0; i < response.length; i++) {
                    if (response[i].entityName === 'settlement') {
                        vm.entity = response[i];
                        $log.debug("vm.entity:");
                        $log.debug(vm.entity);
                    }
                }

            }, function (response) {
                vm.loadingEntity = false;
                $log.error(response);
            });
        }

        vm.viewErpHistory = function (settlement) {
            $log.debug(settlement);
            $mdDialog.show({
                controller: 'InterfazReportDetailController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/reports/dialogs/show-interfaz-detail/show-interfaz-detail.html',
                parent: angular.element("#main"),
                targetEvent: event,
                locals: {
                    'entity': vm.entity,
                    'id': settlement.settlementId,
                    'companyId': settlement.companyId
                },
                clickOutsideToClose: false
            }).then(function (response) {
            }, function (response) {
            });
        };

        function showMessage(message) {
            $rootScope.loadingProgress = false;
            $mdToast.show({
                template: '<md-toast layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
                hideDelay: 3000,
                position: 'top right'
            });
        }


        function showErrorMessage(message) {
            $rootScope.loadingProgress = false;
            $mdToast.show({
                template: '<md-toast layout="column" layout-align="center start"><div class="md-toast-content" style="background-color: red">'
                    + message + '</div></md-toast>',
                hideDelay: 5000,
                position: 'top right'
            });
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.expenseSettlement.verificationSettlement', [])
        .config(config);


    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {
        // State
        $stateProvider
            .state('app.expenseSettlement.verificationSettlements', {
                url: '/verificationSettlement',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/expenseSettlements/verificationSettlement/verificationSettlement.html',
                        controller: 'verificationSettlementController as vm'
                    }
                },
                bodyClass: 'mail'
            });
        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/expenseSettlements');


    }
})();


(function () {
    'use strict';

    angular
        .module('app.expenseSettlement.verificationSettlement')
        .controller('verificationSettlementController', verificationSettlementController);

    /** @ngInject */
    function verificationSettlementController($scope, $rootScope, $state, api, $log, $mdDialog, $filter) {
        var vm = this;

        //Data

        //Methods
        vm.openSettlement = openSettlement;
        vm.cancelDialog = cancelDialog;
        vm.viewChangeStatus = viewChangeStatus;

        /////////
        init();

        function init() {
            $rootScope.loadingProgress = true;
            api.ComprasWS.Settlement.Settlement.query({ idCircle: $rootScope.bsCircle.id }).$promise.then(function (data) {
                vm.settlements = new jinqJs()
                    .from(data).
                    select(function (r) {
                        var d = r;
                        d.filter = (d.pettyCashId + "," + d.pettyCashTypeDescription + ","
                            + d.pettyCashName + "," + d.holderAccount + "," + d.departmentDescription + ","
                            + d.costCenterDescription + "," + d.id + "," + d.settlementStatusName).toLowerCase();
                        return d;
                    });
                vm.masterGridOptions.api.setColumnDefs(vm.masterColumnDefs);
                vm.settlementsjson = data;

                $rootScope.loadingProgress = false;
                getDimensionCompany();
                vm.masterGridOptions.api.setRowData(data);
            }, function (error) {
                $log.error(error.data);
                $rootScope.loadingProgress = false;
            });
        }

        vm.masterColumnDefs = [
            {
                headerName: 'EXPENSE_SETTLEMENTS.PETTY_CASH.PETTY_CASH',
                field: "pettyCashId",
                headerCellRenderer: getHeader,
                width: 125,
                enableRowGroup: true,
                enablePivot: true,
                pinned: "left"
            },
            {
                headerName: 'EXPENSE_SETTLEMENTS.PETTY_CASH.PETTYCASHTYPE',
                field: "pettyCashTypeDescription",
                headerCellRenderer: getHeader,
                width: 200,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'EXPENSE_SETTLEMENTS.PETTY_CASH.NAME',
                field: "pettyCashName",
                headerCellRenderer: getHeader,
                width: 250,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'EXPENSE_SETTLEMENTS.PETTY_CASH.HOLDER',
                field: "holderAccount",
                headerCellRenderer: getHeader,
                width: 250,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'EXPENSE_SETTLEMENTS.PETTY_CASH.COMPANY',
                field: "companyName",
                headerCellRenderer: getHeader,
                width: 250,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'EXPENSE_SETTLEMENTS.SETTLEMENT.SETTLEMENT',
                headerCellRenderer: getHeader,
                width: 100,
                enableRowGroup: true,
                enablePivot: true,
                cellRenderer: function renderer() {
                    return '<div style="width: 100%;">'
                        + ' {{data.id}}  '
                        + '         <md-button class="edit-button md-icon-button" ng-click="vm.viewChangeStatus(data, $event)" aria-label="settlement"'
                        + '                       translate translate-attr-aria-label="SETTLEMENT.CHANGE_STATUS.CHANGE_STATUS">'
                        + '                <md-tooltip md-direction="bottom">'
                        + '                    {{"SETTLEMENT.CHANGE_STATUS.CHANGE_STATUS"| translate}}'
                        + '                </md-tooltip>'
                        + '                <md-icon md-font-icon="icon-history" class="s16"></md-icon> '
                        + '            </md-button>'
                        + '        </div>';
                },
                cellStyle: { 'padding': '0px' }
            },
            {
                headerName: 'EXPENSE_SETTLEMENTS.PETTY_CASH.COST_CENTER',
                field: "costCenterDescription",
                headerCellRenderer: getHeader,
                width: 250,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'EXPENSE_SETTLEMENTS.PETTY_CASH.DEPARTMENT',
                field: "departmentDescription",
                width: 250,
                headerCellRenderer: getHeader,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'EXPENSE_SETTLEMENTS.STATUS',
                field: "settlementStatusName",
                headerCellRenderer: getHeader,
                width: 150,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'EXPENSE_SETTLEMENTS.SETTLEMENT.CASH_AMOUNT',
                field: "cashAmount",
                headerCellRenderer: getHeader,
                width: 150,
                valueFormatter: function (params) {
                    return $filter('number')(params.value, 2);
                },
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'EXPENSE_SETTLEMENTS.SETTLEMENT.SETTLED_AMOUNT',
                field: "settledAmount",
                headerCellRenderer: getHeader,
                width: 150,
                valueFormatter: function (params) {
                    return $filter('number')(params.value, 2);
                },
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'EXPENSE_SETTLEMENTS.OPTIONS',
                field: "holderAccount",
                headerCellRenderer: getHeader,
                suppressSorting: true,
                suppressMenu: true,
                width: 260,
                cellRenderer: function renderer(params) {
                    return '<div style="width: 100%;">'
                        + '          <md-button class="edit-button md-icon-button" ng-click="vm.openSettlement(data.id)" aria-label="settlement"'
                        + '                       translate translate-attr-aria-label="SETTLEMENT.VIEW_DETAILS">'
                        + '                <md-tooltip md-direction="bottom">'
                        + '                    {{"SETTLEMENT.VIEW_DETAILS"| translate}}'
                        + '                </md-tooltip>'
                        + '                <md-icon md-font-icon="icon-eye" class="s16"></md-icon> '
                        + '            </md-button>'
                        + '            <md-button class="edit-button md-icon-button" ng-click="vm.showPDF(\'JASPER_URL_SETTLEMENT\',data)" aria-label="settlement"'
                        + '                       translate translate-attr-aria-label="SETTLEMENT.VIEW_DETAILS">'
                        + '                <md-tooltip md-direction="bottom">'
                        + '                    {{"SETTLEMENT.REPRINT_TENDER"| translate}}'
                        + '                </md-tooltip>'
                        + '                <md-icon md-font-icon="icon-printer" class="s16"></md-icon> '
                        + '            </md-button>'
                        + '             \n\<md-button class="edit-button md-icon-button" ng-click="vm.showPDF(\'JASPER_URL_SETTLEMENT_WITH_DETAILS\',data)" '
                        + ' aria-label="settlement"'
                        + '                       translate translate-attr-aria-label="Generar PDF">'
                        + '                <md-tooltip md-direction="bottom">'
                        + '                    {{"EXPENSE_SETTLEMENTS.GENERATE_PDF_WITH_DETAILS"| translate}}'
                        + '                </md-tooltip>'
                        + '                <md-icon md-font-icon="icon-clipboard-text" class="s16"></md-icon> '
                        + '            </md-button>'
                      + '         <md-button ng-if="data.settlementStatus.name===\'Autorizada\' && data.pettyCash.pettyCashType.name===\'TRAVEL\'"'
                      +' class="edit-button md-icon-button" ng-click="vm.showPDFTravel(\'JASPER_URL_SETTLEMENT_TRAVEL\',data)" '
                      + ' aria-label="settlement"'
                      + '                       translate translate-attr-aria-label="Generar PDF">'
                      + '                <md-tooltip md-direction="bottom">'
                      + '                    {{"REPORT.SETTLEMENT.PRINT_SETLEMENT_TRAVEL"| translate}}'
                      + '                </md-tooltip>'
                      + '                <md-icon md-font-icon="icon-file" class="s16"></md-icon> '
                      + '            </md-button>'
                      + '        </div>';
                },
                cellStyle: { 'padding': '0px' },
                pinned: "right"
            }

        ];

        function viewChangeStatus(settlement, ev) {
            $mdDialog.show({
                controller: 'changeStatusController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/expenseSettlements/settlements/settlement/settlementEditor/changeStatus/changeStatus.html',
                targetEvent: ev,
                locals: {
                    settlementId: settlement.id
                },
                clickOutsideToClose: false
            }).then(function (answer) {

            });
        }

        vm.showPDF = function (parameter, settlement) {

            $log.debug("settlement in showPDF: ");
            $log.debug(settlement);

            var urlRpt = null;
            if (parameter === 'JASPER_URL_SETTLEMENT') {
                urlRpt = $rootScope.getParameterValue('JASPER_URL_SETTLEMENT').replace('[ID]', settlement.id);
            } else if ('JASPER_URL_SETTLEMENT_WITH_DETAILS') {
                urlRpt = $rootScope.getParameterValue('JASPER_URL_SETTLEMENT_WITH_DETAILS').replace("[ID]", settlement.id);
            }

            $mdDialog.show({
                controller: 'ReportShowPDFController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/reports/dialogs/show-pdf/show-pdf.html',
                parent: angular.element("#main"),
                locals: {
                    Url: urlRpt
                },
                clickOutsideToClose: false,
                fullscreen: true
            }).then(function (answer) {
            }, function () {
            });
        };

        vm.showPDFTravel = function (parameter, settlement) {

            $log.debug("settlement in showPDF: ");
            $log.debug(settlement);

          if ($rootScope.APPParameters) {

            for (var i = 0; i < $rootScope.APPParameters.length; i++) {
              if ($rootScope.APPParameters[i].applicationParameter.parameterName === parameter && $rootScope.APPParameters[i].applicationParameter.configByCountry) {
                api.GeneralWS.ApplicationParameterCountryValue.byParameterNameAndCountry.get({'parameterName': parameter, 'countryId': settlement.pettyCash.company.country.id}, function (response) {
                  if(response && response.parameterValue){
                    showpdfDialog(response.parameterValue.replace("[ID]", settlement.id));
                  } else if ($rootScope.APPParameters[i].appParameterValue) {
                    showpdfDialog($rootScope.APPParameters[i].appParameterValue.replace("[ID]", settlement.id));
                  }

                }, function (err) { });
                break;
              } else if ($rootScope.APPParameters[i].applicationParameter.parameterName === parameter) {
                showpdfDialog($rootScope.APPParameters[i].appParameterValue.replace("[ID]", settlement.id));
                break;
              }
            }

          }

        };

        function showpdfDialog(urlRpt){
          $mdDialog.show({
            controller: 'ReportShowPDFController',
            controllerAs: 'vm',
            templateUrl: 'app/main/apps/reports/dialogs/show-pdf/show-pdf.html',
            parent: angular.element("#main"),
            locals: {
              Url: urlRpt
            },
            clickOutsideToClose: false,
            fullscreen: true
          }).then(function (answer) {
          }, function () {
          });
        }

        vm.masterGridOptions = {
            columnDefs: vm.masterColumnDefs,
            enableSorting: true,
            debug: false,
            enableFilter: true,
            enableColResize: true,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowData: null,
            groupHeaders: true,
            headerHeight: 50,
            rowHeight: 45,
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            },
            doesDataFlower: function (dataItem) {
                return true;
            },
            isExternalFilterPresent: isExternalFilterPresent,
            doesExternalFilterPass: doesExternalFilterPass
        };

        var filter = 'everyone';

        function isExternalFilterPresent() {
            return filter !== '';
        }

        function doesExternalFilterPass(node) {
            if (filter && filter !== 'everyone') {
                var arrdt = node.data.filter.split(filter);
                return arrdt.length > 1;
            }
            return true;
        }

        $scope.$watch('vm.search',
            function (newValue) {
                filter = newValue ? newValue.toLowerCase() : 'everyone';
                vm.masterGridOptions.api.onFilterChanged();
            }
        );

        function cancelDialog() {
            $mdDialog.cancel();
        }

        function openSettlement(id) {
            $state.go('app.expenseSettlement.settlement.settlementView', { settlementId: id });
        }

        function getDimensionCompany() {
            const NUMBER_DIMENSION_THREE = 3;
            const NUMBER_DIMENSION_FOUR = 4;
            const NUMBER_DIMENSION_FIVE = 5;
            api.GeneralWS.DimensionCompany.byCompany.getList(
                { 'company': $rootScope.bsCircle.company.id }
            ).$promise.then(function (responseDimension) {
                responseDimension.sort(function (a, b) {
                  return a.dimensionNumber - b.dimensionNumber;
                });
                for (let i = 0; i < responseDimension.length; i++) {
                    if (responseDimension[i].dimensionNumber === NUMBER_DIMENSION_THREE) {
                        vm.dimensionCompanyDetail3 = responseDimension[i];
                        addMasterColumnDefs(responseDimension[i].description, 'dimensionCompanyDetail3Name', responseDimension[i].dimensionNumber);
                    }
                    if (responseDimension[i].dimensionNumber === NUMBER_DIMENSION_FOUR) {
                        vm.dimensionCompanyDetail4 = responseDimension[i];
                        addMasterColumnDefs(responseDimension[i].description, 'dimensionCompanyDetail4Name', responseDimension[i].dimensionNumber);
                    }
                    if (responseDimension[i].dimensionNumber === NUMBER_DIMENSION_FIVE) {
                        vm.dimensionCompanyDetail5 = responseDimension[i];
                        addMasterColumnDefs(responseDimension[i].description, 'dimensionCompanyDetail5Name', responseDimension[i].dimensionNumber);
                    } else {
                        vm.dimensionCompanyDetail1 = responseDimension[i];
                    }
                }
                if (vm.masterGridOptions && vm.masterGridOptions.api) {
                    vm.masterGridOptions.api.setColumnDefs(vm.masterColumnDefs);
                }
            });
        }

        function addMasterColumnDefs(name, fieldName, number) {
          const NUMBER_SEVEN_COLUMN_ADD = 7;
            vm.masterColumnDefs.splice((number + NUMBER_SEVEN_COLUMN_ADD), 0, {
                headerName: name,
                field: fieldName,
                headerCellRenderer: getHeader,
                width: 200,
                enableRowGroup: true,
                filter: 'text',
                enablePivot: true
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.expenseSettlement.pettyCashGeneralSets')
        .controller('pettyCashGeneralSetsController', pettyCashGeneralSetsController);

    /** @ngInject */
    function pettyCashGeneralSetsController(api, $log, $rootScope, $mdDialog, $mdToast, $filter) {

        var vm = this;

        document.addEventListener("mousewheel", function (event) {
            if (document.activeElement.type === "number") {
                document.activeElement.blur();
            }
        });


        //Data
        vm.pettyCashTypes = [];
        vm.pettyCashGeneralSets = [];
        vm.company = $rootScope.bsCircle.company;
        vm.URLPHOTOS = api.baseUrlPhotos;
        vm.listType = 'all';

        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            columnDefs: [
                {
                    // Target the actions column
                    targets: 6,
                    filterable: false,
                    sortable: false
                }
            ],
            bInfo: false,
            paging: false

        };

        //Methods
        vm.editPettyCashGeneralSets = editPettyCashGeneralSets;
        vm.deletePettyCashGeneralSets = deletePettyCashGeneralSets;
        vm.findOrCreatePettyCashGeneralSets = findOrCreatePettyCashGeneralSets;
        vm.filterChange = filterChange;


        init();

        //////////

        function init() {
            api.ComprasWS.pettyCashType.query({}, function (response) {
                vm.pettyCashTypes = response;
                getAll();
            }, function (response) {
                $log.error(response);
            });
        }

        function getAll() {
            api.ComprasWS.pettyCashGeneralSets.getAll({ idCircle: $rootScope.bsCircle.id }).$promise.then(function (response) {
                vm.pettyCashGeneralSets = response;
                vm.pettyCashGeneralSetsFilter = vm.pettyCashGeneralSets;
            }, function (error) {
                $log.error(error.data);
            });
        }

        function filterChange(type) {
            vm.listType = type;
            if (type === 'all') {
                vm.pettyCashGeneralSetsFilter = vm.pettyCashGeneralSets;
            } else {
                findOrCreatePettyCashGeneralSets(type);
            }
        }

        function findOrCreatePettyCashGeneralSets(type) {
            var pettyCashGeneralSets = _.find(vm.pettyCashGeneralSets, function (pettySets) {
                return pettySets.pettyCashType.id === type.id;
            });
            if (pettyCashGeneralSets) {
                vm.pettyCashGeneralSetsFilter = [];
                vm.pettyCashGeneralSetsFilter.push(pettyCashGeneralSets);
            } else {
                var confirm = $mdDialog.confirm()
                    .title($filter('translate')('PETTY_CASH_SETS.MAX_AMOUNT_NOT_EXIST'))
                    .htmlContent($filter('translate')('PETTY_CASH_SETS.THE_PETTY_TYPE ') + '<strong>'
                        + type.description + '</strong>'
                        + $filter('translate')('PETTY_CASH_SETS.NO_MAX_AMOUNT_ASSOCIATED'))
                    .ariaLabel('Add max amount')
                    .ok($filter('translate')('PETTY_CASH_SETS.OK'))
                    .cancel($filter('translate')('PETTY_CASH_SETS.CANCEL'));
                $mdDialog.show(confirm).then(function () {
                    $rootScope.loadingProgress = true;
                    editPettyCashGeneralSets(null, null, type);
                }, function () {
                    vm.filterChange('all');
                    // Cancel Action
                });
            }
        }


        function editPettyCashGeneralSets(i, data, type) {
            var detail = angular.copy(data);
            $mdDialog.show({
                controller: 'pettyCashGeneralSetsEditorController',
                controllerAs: 'vm',
                locals: {
                    data: detail,
                    type: type
                },
                templateUrl: 'app/main/apps/expenseSettlements/pettyCashGeneralSets/pettyCashGeneralSetsEditor/pettyCashGeneralSetsEditor.html',
                parent: angular.element("#main"),
                clickOutsideToClose: false
            }).then(function (answer) {
                init();
                vm.filterChange('all');
                $rootScope.loadingProgress = false;
            }, function () {
                $rootScope.loadingProgress = false;
            });
        }

        function deletePettyCashGeneralSets(index, event, data) {
            if (event) {
                event.stopPropagation();
            }
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('PETTY_CASH_SETS.MSG_ARE_YOU_SURE_DELETE'))
                .htmlContent($filter('translate')('PETTY_CASH_SETS.MSG_AMOUNT_WAS_DELETED') + '<strong>'
                    + data.pettyCashType.description + '</strong>'
                    + $filter('translate')('PETTY_CASH_SETS.MSG_AMOUNT_WAS_DELETED2'))
                .ariaLabel('Delete Detail')
                .ok($filter('translate')('PETTY_CASH_SETS.DELETE'))
                .cancel($filter('translate')('PETTY_CASH_SETS.CANCEL'));
            $mdDialog.show(confirm).then(function () {
                $rootScope.loadingProgress = true;
                api.ComprasWS.pettyCashGeneralSets.delete({ id: data.id, idCircle: $rootScope.bsCircle.id }).$promise.then(function (response) {
                    vm.pettyCashGeneralSetsFilter.splice(index, 1);
                    vm.pettyCashGeneralSets.splice(index, 1);
                    vm.filterChange('all');
                    showMessage($filter('translate')('PETTY_CASH_SETS.DELETE_AMOUNT_SUCCESSFULLY') + data.pettyCashType.description);
                    $rootScope.loadingProgress = false;
                }, function (error) {
                    showErrorMessage($filter('translate')('PETTY_CASH_SETS.DELETE_AMOUNT_ERROR') + data.pettyCashType.description);
                    $log.error(error.data);
                    $rootScope.loadingProgress = false;
                });
            }, function () {
                // Cancel Action
            });
        }



        function showMessage(message) {
            $rootScope.loadingProgress = false;
            $mdToast.show({
                template: '<md-toast layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
                hideDelay: 7000,
                position: 'top right'
            });
        }

        function showErrorMessage(message) {
            $rootScope.loadingProgress = false;
            $mdToast.show({
                template: '<md-toast layout="column" layout-align="center start"><div class="md-toast-content" style="background-color: red">'
                    + message + '</div></md-toast>',
                hideDelay: 5000,
                position: 'top right'
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.expenseSettlement.requiredProduct', [])
        .config(config);


    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {
        // State
        $stateProvider

            .state('app.expenseSettlement.requiredProduct', {
                url: '/requiredProduct',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/expenseSettlements/settlementRequiredProduct/requiredProduct.html',
                        controller: 'requiredProductController as vm'
                    }
                },
                bodyClass: 'mail'
            });


        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/expenseSettlements');

    }
})();


(function () {
  "use strict";

  angular
    .module("app.expenseSettlement.requiredProduct")
    .controller("requiredProductController", requiredProductController);

  /** @ngInject */
  function requiredProductController(
    api,
    $log,
    $rootScope,
    $timeout,
    $mdToast,
    $filter,
    $scope
  ) {
    var vm = this;
    vm.arrMembersToDelete = [];
    vm.page = 1;
    vm.pageM = 1;
    vm.pageSize = 50;
    vm.pageSizeM = 50;
    vm.selectedTab = 0;
    vm.ModifyNameGroup = true;
    $rootScope.snThread = true;

    //Methods
    vm.loadProductAvailable = loadProductAvailable;
    vm.loadMembersList = loadMembersList;
    vm.addMember = addMember;
    vm.deleteMember = deleteMember;
    vm.activeSearchAll = activeSearchAll;
    vm.activeSearchMem = activeSearchMem;
    vm.updateMember = updateMember;
    vm.selectedArray = [];
    vm.selectedAssociatedArray = [];
    vm.membersList = [];

    $scope.$watch("vm.requiredProduct.pettyCashType.id", function (
      pettyCashTypeId
    ) {
      loadProductAvailable(pettyCashTypeId, 1, vm.settlementProductType);
      loadMembersList(pettyCashTypeId, 1);
      vm.pettyCashTypeId = pettyCashTypeId;
    });

    $scope.$watch("vm.requiredProduct.settlementProductType.id", function (
      settlementProductType
    ) {
      vm.settlementProductType = settlementProductType;
      loadProductAvailable(vm.pettyCashTypeId, 1);
      loadMembersList(vm.pettyCashTypeId, 1);
    });

    $rootScope.settlementProductType = vm.settlementProductType;

    vm.isSelected = function (data) {
      return vm.selectedArray.indexOf(data) > -1;
    };

    vm.toggle = function (data, event) {
      if (event) {
        event.stopPropagation();
      }
      if (vm.selectedArray.indexOf(data) > -1) {
        vm.selectedArray.splice(vm.selectedArray.indexOf(data), 1);
      } else {
        vm.selectedArray.push(data);
      }
    };

    vm.toggleAssociated = function (data, event) {
      if (event) {
        event.stopPropagation();
      }

      if (vm.selectedAssociatedArray.indexOf(data) > -1) {
        vm.selectedAssociatedArray.splice(
          vm.selectedAssociatedArray.indexOf(data),
          1
        );
      } else {
        vm.selectedAssociatedArray.push(data);
      }
    };

    vm.isSelectedAssociated = function (data) {
      return vm.selectedAssociatedArray.indexOf(data) > -1;
    };

    vm.associate = function () {
      var itemIdArray = [];

      if (!vm.isCheckAllItem) {
        vm.selectedArray.forEach(function (row) {
          addMember(row);
        });
      }

      if (itemIdArray.length === 0 && !vm.isCheckAllItem) {
        return null;
      }
    };

    vm.disassociate = function () {
      var itemIdArray = [];

      if (!vm.isCheckAllUserItem) {
        vm.selectedAssociatedArray.forEach(function (row) {
          deleteMember(row.producto);
        });
      }

      if (itemIdArray.length === 0 && !vm.isCheckAllUserItem) {
        return null;
      }
      return true;
    };

    function activeSearchAll() {
      vm.searchModeAll = true;
      $timeout(function () {
        $("#searchFieldAll").focus();
      });
    }

    function activeSearchMem() {
      vm.searchModeMem = true;
      $timeout(function () {
        $("#searchFieldMem").focus();
      });
    }

    vm.clearSearchPettyCashType = function () {
      vm.searchPettyCashType = "";
    };

    vm.clearSearchSettlementProductType = function () {
      vm.searchSettlementProdductType = "";
    };

    $timeout(function () {
      var keyEvent = function (event) {
        event.stopPropagation();
      };
      var searchSettlementProductTypeInput = document.querySelector(
        "settlementProductType"
      );
      var searchPettyCashTypeInput = document.querySelector("#pettyCashType");

      if (searchSettlementProductTypeInput) {
        searchSettlementProductTypeInput.addEventListener("keydown", keyEvent);
      }
      if (searchPettyCashTypeInput) {
        searchPettyCashTypeInput.addEventListener("keydown", keyEvent);
      }
    }, 500);

    init();

    //////////

    function init() {
      vm.settlementProductType = [];
      api.ComprasWS.settlementProductType.query(
        {},
        function (data) {
          vm.settlementProductsType = data;
          $log.debug(vm.settlementProductsType);
        },
        function (data) {
          $log.error(data);
        }
      );

      vm.pettyCashType = [];
      api.ComprasWS.pettyCashType.query(
        {},
        function (response) {
          vm.pettyCashType = response;
          $log.debug(vm.pettyCashType);
        },
        function (response) {
          $log.error(response);
        }
      );
    }

    function loadProductAvailable(
      pettyCashTypeId,
      page,
      settlementProductType,
      filter
    ) {
      if (pettyCashTypeId !== undefined) {
        if (vm.settlementProductType === undefined) {
          vm.settlementProductType = $rootScope.settlementProductType;
        }
        page--;
        api.ComprasWS.allProducts.get(
          {
            pettyCashTypeId: pettyCashTypeId,
            page: page,
            size: 50,
            filter: filter,
            idCircle: $rootScope.bsCircle.id,
            companyId: $rootScope.bsCircle.company.id,
            settlementProductTypeId: vm.settlementProductType
          },
          function (data) {
            vm.allProducts = data;
          },
          function (error) { }
        );
      }
    }
    //Listado de productos por tipo de caja

    function loadMembersList(pettyCashTypeId, page, filter) {
      if (pettyCashTypeId !== undefined) {
        if (vm.settlementProductType === undefined) {
          vm.settlementProductType = $rootScope.settlementProductType;
        }
        page--;
        api.ComprasWS.allMembers.get(
          {
            pettyCashTypeId: pettyCashTypeId,
            page: page,
            size: 50,
            filter: filter,
            idCircle: $rootScope.bsCircle.id,
            companyId: $rootScope.bsCircle.company.id,
            settlementProductTypeId: vm.settlementProductType
          },
          function (data) {
            vm.membersList = data;
          },
          function (error) { }
        );
      }
    }

    function addMember(item) {
      api.ComprasWS.settlementProduct.create(
        {
          productId: item.id,
          pettyCashTypeId: vm.pettyCashTypeId,
          companyId: $rootScope.bsCircle.company.id,
          idCircle: $rootScope.bsCircle.id,
          settlementProductTypeId: vm.settlementProductType
        },
        function (data) {
          showMessage(
            $filter("translate")(
              "EXPENSE_SETTLEMENTS.SETTLEMENTPRODUCT.TXTSAVE"
            )
          );
          var i = vm.allProducts.content.indexOf(item);
          vm.allProducts.content.splice(i, 1);
          vm.allProducts.totalElements--;
          loadMembersList(vm.pettyCashTypeId, 1);
        },
        function (error) { }
      );
    }

    function deleteMember(item) {
      api.ComprasWS.settlementProduct.remove(
        {
          productId: item.id,
          pettyCashTypeId: vm.pettyCashTypeId,
          companyId: $rootScope.bsCircle.company.id,
          idCircle: $rootScope.bsCircle.id,
          settlementProductTypeId: vm.settlementProductType
        },
        function (data) {
          if (data.active === false) {
            showMessage(
              $filter("translate")(
                "EXPENSE_SETTLEMENTS.SETTLEMENTPRODUCT.TXTDELETE"
              )
            );
            loadProductAvailable(vm.pettyCashTypeId, 1);
            loadMembersList(vm.pettyCashTypeId, 1);
          } else {
            showMessage(
              $filter("translate")(
                "EXPENSE_SETTLEMENTS.SETTLEMENTPRODUCT.DEDUCTIBLEACTIVE"
              )
            );
            loadMembersList();
          }
        },
        function (error) { }
      );
    }

    function updateMember(item) {
      api.ComprasWS.settlementProductDeductible.update(
        {
          id: item.id
        },
        function (data) {
          if (data.deductible === true) {
            showMessage(
              $filter("translate")(
                "EXPENSE_SETTLEMENTS.SETTLEMENTPRODUCT.DEDUCTIBLEACTIVE"
              )
            );
            loadMembersList();
          } else {
            showMessage(
              $filter("translate")(
                "EXPENSE_SETTLEMENTS.SETTLEMENTPRODUCT.DEDUCTIBLEFALSE"
              )
            );
            loadMembersList();
          }
        },
        function (error) { }
      );
    }

    function showMessage(message) {
      $mdToast.show({
        template:
          '<md-toast layout="column" layout-align="center start"><div class="md-toast-content">' +
          message +
          "</div></md-toast>",
        hideDelay: 7000,
        position: "top right"
      });
    }

    $timeout(function () {
      var mdDialog = $("#requiredProduct");
      var windowHeight = parseInt(mdDialog.innerHeight());

      windowHeight -= 205;

      vm.dinamicHeight = {
        height: windowHeight + "px"
      };
    }, 1000);
  }
})();

(function () {
    'use strict';

    angular
        .module('app.expenseSettlement.pettyCash')
        .controller('pettyCashController', pettyCashController);

    /** @ngInject */
    function pettyCashController($scope, $rootScope, $state, api, $log, $filter, $mdDialog, $mdToast, $timeout) {
        var vm = this;

        //Data
        vm.pettyCashes = [];
        vm.amountAvailable = null;
        vm.validatedSetlements = [];

        //Methods
        vm.newPettyCash = newPettyCash;
        vm.deletePettyCash = deletePettyCash;
        vm.cancelPettycash = cancelPettycash;
        vm.finalizePettyCash = finalizePettyCash;
        vm.getValidatedSettlements = getValidatedSettlements;
        const FOUR_HUNDRED_TIME_OUT = 400;
        init();

        ////////
        function init() {
            $rootScope.loadingProgress = true;
            api.ComprasWS.pettyCash.query({ circle: $rootScope.bsCircle.id }).$promise.then(function (data) {
                vm.pettyCashes = new jinqJs()
                    .from(data).
                    select(function (r) {
                        var d = r;
                        d.filter = (d.pettyCashId + "," + d.pettyCashName + "," + d.pettyCashTypeDescription + ","
                            + d.departmentDescription + "," + d.costCenterDescription + "," + d.holderAccount).toLowerCase();
                        return d;
                    });
                $rootScope.loadingProgress = false;
                $timeout(function (){
                    getDimensionCompany();
                },FOUR_HUNDRED_TIME_OUT);
                vm.masterGridOptions.api.setRowData(data);
            }, function (error) {
                $log.error(error.data);
            });

        }

        vm.masterColumnDefs = [
            {
                headerName: 'EXPENSE_SETTLEMENTS.PETTY_CASH.PETTY',
                field: "pettyCashId",
                headerCellRenderer: getHeader,
                width: 100,
                enableRowGroup: true,
                enablePivot: true,
                pinned: "left",
                cellStyle: {
                    "text-align": "center"
                }
            },
            {
                headerName: 'EXPENSE_SETTLEMENTS.PETTY_CASH.PETTYCASHTYPE',
                field: "pettyCashTypeDescription",
                headerCellRenderer: getHeader,
                width: 200,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'EXPENSE_SETTLEMENTS.PETTY_CASH.NAME',
                field: "pettyCashName",
                headerCellRenderer: getHeader,
                width: 255,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'EXPENSE_SETTLEMENTS.PETTY_CASH.AMOUNT',
                field: "amount",
                headerCellRenderer: getHeader,
                width: 120,
                valueFormatter: function (params) {
                    return $filter('number')(params.value, 2);
                },
                enableRowGroup: true,
                enablePivot: true,
                cellStyle: {
                    "text-align": "right"
                }
            },
            {
                headerName: 'EXPENSE_SETTLEMENTS.PETTY_CASH.STARTDATE',
                field: "startDate",
                width: 120,
                headerCellRenderer: getHeader,
                valueFormatter: function (params) {
                    return $filter('date')(params.value, 'dd/MM/yyyy');
                },
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'EXPENSE_SETTLEMENTS.PETTY_CASH.DUEDATE',
                field: "dueDate",
                headerCellRenderer: getHeader,
                width: 100,
                valueFormatter: function (params) {
                    return $filter('date')(params.value, 'dd/MM/yyyy');
                },
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'Vigente',
                field: "isValid",
                headerCellRenderer: getHeader,
                width: 120,
                cellRenderer: function renderer(params) {
                    if (params.value) {
                        return '<md-icon md-font-icon="icon-checkbox-marked-circle green-500-fg"></md-icon>';
                    } else {
                        return '<md-icon md-font-icon="icon-cancel red-500-fg"></md-icon>';
                    }
                },
                cellStyle: {
                    "text-align": "center"
                }
            },
            {
                headerName: 'EXPENSE_SETTLEMENTS.PETTY_CASH.DEPARTMENT',
                field: "departmentDescription",
                headerCellRenderer: getHeader,
                width: 250,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'EXPENSE_SETTLEMENTS.PETTY_CASH.COSTCENTER',
                field: "costCenterDescription",
                headerCellRenderer: getHeader,
                width: 250,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'EXPENSE_SETTLEMENTS.PETTY_CASH.HOLDER',
                field: "holderAccount",
                headerCellRenderer: getHeader,
                width: 250,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'ORDER.ACTIONS',
                name: "actions",
                headerCellRenderer: getHeader,
                suppressSorting: true,
                suppressMenu: true,
                width: 220,
                cellRenderer: function renderer(params) {
                    return '<div style="width: 100%;">'
                        + ' <md-button class="edit-button md-icon-button" ng-disabled="!data.isValid" ng-click="vm.newPettyCash(data.pettyCashId)" '
                        + ' aria-label="pettyCash"'
                        + ' translate translate-attr-aria-label="EXPENSE_SETTLEMENTS.PETTY_CASH.EDIT">'
                        + ' <md-tooltip md-direction="bottom">'
                        + ' {{"EXPENSE_SETTLEMENTS.PETTY_CASH.EDIT"| translate}}'
                        + ' </md-tooltip>'
                        + '  <md-icon md-font-icon="icon-pencil" class="s16"></md-icon> '
                        + ' </md-button>'
                        + ' <md-button class="edit-button md-icon-button" ng-disabled="!data.isValid" ng-click="vm.deletePettyCash($event, data.pettyCashId, data)" '
                        + ' aria-label="pettyCash"'
                        + ' translate translate-attr-aria-label="EXPENSE_SETTLEMENTS.PETTY_CASH.DELETE">'
                        + ' <md-tooltip md-direction="bottom">'
                        + ' {{"EXPENSE_SETTLEMENTS.PETTY_CASH.DELETE"| translate}}'
                        + ' </md-tooltip>'
                        + '  <md-icon md-font-icon="icon-delete" class="s16"></md-icon> '
                        + ' </md-button>'
                        + ' <md-button class="edit-button md-icon-button" ng-disabled="!data.isValid" ng-click="vm.cancelPettycash(data.pettyCashId)" '
                        + ' aria-label="pettyCash"'
                        + ' translate translate-attr-aria-label="EXPENSE_SETTLEMENTS.PETTY_CASH.TO_DISABLE">'
                        + ' <md-tooltip md-direction="bottom">'
                        + ' {{"EXPENSE_SETTLEMENTS.PETTY_CASH.TO_DISABLE"| translate}}'
                        + ' </md-tooltip>'
                        + '  <md-icon md-font-icon="icon-alert" class="s16"></md-icon> '
                        + ' </md-button>'
                        + ' <md-button class="edit-button md-icon-button" ng-disabled="data.isValid || data.isFinalized" ng-click="vm.getValidatedSettlements(data)"'
                        + ' aria-label="pettyCash" translate translate-attr-aria-label="EXPENSE_SETTLEMENTS.PETTY_CASH.FINALIZE">'
                        + ' <md-tooltip md-direction="bottom">'
                        + ' {{"EXPENSE_SETTLEMENTS.PETTY_CASH.FINALIZE"| translate}}'
                        + ' </md-tooltip>'
                        + '  <md-icon md-font-icon="icon-cancel" class="s16"></md-icon> '
                        + ' </md-button>'
                        + ' </div>';
                },
                cellStyle: { 'padding': '0px' },
                pinned: "right"
            }
        ];

        vm.masterGridOptions = {
            columnDefs: vm.masterColumnDefs,
            enableSorting: true,
            debug: false,
            enableFilter: true,
            enableColResize: true,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowData: null,
            groupHeaders: true,
            headerHeight: 50,
            rowHeight: 45,
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            },
            doesDataFlower: function (dataItem) {
                return true;
            },
            isExternalFilterPresent: isExternalFilterPresent,
            doesExternalFilterPass: doesExternalFilterPass
        };

        var filter = 'everyone';

        function isExternalFilterPresent() {
            return filter !== '';
        }

        function doesExternalFilterPass(node) {
            if (filter && filter !== 'everyone') {
                var arrdt = node.data.filter.split(filter);
                return arrdt.length > 1;
            }
            return true;
        }

        $scope.$watch('vm.search',
            function (newValue) {
                filter = newValue ? newValue.toLowerCase() : 'everyone';
                vm.masterGridOptions.api.onFilterChanged();
            }
        );

        function newPettyCash(id) {
            $state.go('app.expenseSettlement.pettyCash.pettyCash.editor', { id: id });

        }

        function deletePettyCash(e, id, data) {
            var i = vm.pettyCashes.indexOf(data);

            var confirm = $mdDialog.confirm()
                .title($filter('translate')('EXPENSE_SETTLEMENTS.PETTY_CASH.CANCELAR'))
                .textContent($filter('translate')('EXPENSE_SETTLEMENTS.PETTY_CASH.CONFIRMACION_CANCEL'))
                .ok($filter('translate')('EXPENSE_SETTLEMENTS.PETTY_CASH.SI'))
                .cancel($filter('translate')('EXPENSE_SETTLEMENTS.PETTY_CASH.CANCELAR'));

            $mdDialog.show(confirm).then(function () {
                $rootScope.loadingProgress = true;
                api.ComprasWS.pettyCash.del({ circle: $rootScope.bsCircle.id, id: id }, function (response) {// Success
                    vm.pettyCashes.splice(i, 1);
                    vm.masterGridOptions.api.setRowData(vm.pettyCashes);
                    showMessage($filter('translate')('EXPENSE_SETTLEMENTS.PETTY_CASH.DELETE_PETTYCASH'));
                    $rootScope.loadingProgress = false;
                }, function (response) {// Error
                    $log.debug(response);
                    $rootScope.loadingProgress = false;
                    if (response.data === "Petty cash can not deleted") {
                        showErrorMessage($filter('translate')('EXPENSE_SETTLEMENTS.PETTY_CASH.ERROR_DELETE_PETTY_CASH'));
                    }
                });

            }, function () {
            });
        }

        function cancelPettycash(id) {
            var confirm = $mdDialog.confirm()
                .title(($filter('translate')('EXPENSE_SETTLEMENTS.PETTY_CASH.CANCEL_PETTY.MSG_SURE_CANCEL')) + id + ' ' +
                    $filter('translate')('EXPENSE_SETTLEMENTS.PETTY_CASH.CANCEL_PETTY.MSG_SURE_CANCEL2'))
                .textContent($filter('translate')('EXPENSE_SETTLEMENTS.PETTY_CASH.CANCEL_PETTY.MSG_CANCEL'))
                .ok($filter('translate')('EXPENSE_SETTLEMENTS.PETTY_CASH.SI'))
                .cancel($filter('translate')('EXPENSE_SETTLEMENTS.PETTY_CASH.CANCELAR'));

            $mdDialog.show(confirm).then(function () {
                $rootScope.loadingProgress = true;
                api.ComprasWS.cancelPettyCash.cancel({ circle: $rootScope.bsCircle.id, id: id }, function (response) {// Success
                    init();
                    showMessage($filter('translate')('EXPENSE_SETTLEMENTS.PETTY_CASH.CANCEL_PETTY.CANCEL_PETTY_OK'));
                    $rootScope.loadingProgress = false;
                }, function (response) {// Error
                    $rootScope.loadingProgress = false;
                    $log.debug(response.data);
                    if (response.data === "Settlements in process") {
                        showErrorMessage($filter('translate')('EXPENSE_SETTLEMENTS.PETTY_CASH.ERROR_FINALIZE_PETTY_CASH'));
                    } else {
                        showErrorMessage($filter('translate')('EXPENSE_SETTLEMENTS.PETTY_CASH.CANCEL_PETTY.CANCEL_PETTY_ERROR'));
                    }
                });

            }, function () {
            });
        }

        function getAmountAvailable(petty) {
            if (petty.amount > 0) {
                $rootScope.loadingProgress = true;
                api.ComprasWS.Settlement.getAmountAvailable.getTotal({ id: petty.pettyCashId }).$promise.then(function (response) {
                    $log.debug("response getAmountAvailabe:");
                    $log.debug(response);
                    vm.amountAvailable = parseFloat(response.$data);
                    $rootScope.loadingProgress = false;
                }, function (error) {
                    $rootScope.loadingProgress = false;
                    $log.error(error.data);
                });
            } else {
                vm.amountAvailable = 0;
            }

        }

        function getValidatedSettlements(petty) {
            $rootScope.loadingProgress = true;
            api.ComprasWS.Settlement.getByPettyAndStatus.getSettlements({ id: petty.pettyCashId, status: 'Validada' }).$promise.then(function (response) {
                vm.validatedSetlements = response;
                $rootScope.loadingProgress = false;
                finalizePettyCash(petty);
            }, function (error) {
                $log.error(error.data);
                $rootScope.loadingProgress = false;
            });
        }

        function finalizePettyCash(petty) {
            getAmountAvailable(petty);
            var confirm = $mdDialog.confirm()
                .title(($filter('translate')('EXPENSE_SETTLEMENTS.PETTY_CASH.FINALIZE_PETTY.MSG_SURE_FINALIZE')) + petty.pettyCashId)
                .content(vm.validatedSetlements.length > 0 ? vm.validatedSetlements.length === 1 ?
                    ($filter('translate')('EXPENSE_SETTLEMENTS.PETTY_CASH.FINALIZE_PETTY.THERE_ARE')) +
                    vm.validatedSetlements.length + ' ' + ($filter('translate')('EXPENSE_SETTLEMENTS.PETTY_CASH.FINALIZE_PETTY.PENDING_PAYMENT2')) :
                    ($filter('translate')('EXPENSE_SETTLEMENTS.PETTY_CASH.FINALIZE_PETTY.THERE_ARE')) +
                    vm.validatedSetlements.length + ' ' + ($filter('translate')('EXPENSE_SETTLEMENTS.PETTY_CASH.FINALIZE_PETTY.PENDING_PAYMENT')) :
                    ($filter('translate')('EXPENSE_SETTLEMENTS.PETTY_CASH.FINALIZE_PETTY.MSG_FINALIZE')))
                .ok($filter('translate')('EXPENSE_SETTLEMENTS.PETTY_CASH.SI'))
                .cancel($filter('translate')('EXPENSE_SETTLEMENTS.PETTY_CASH.CANCELAR'));
            $mdDialog.show(confirm).then(function () {
                $rootScope.loadingProgress = true;
                if (vm.amountAvailable >= 0) {
                    api.ComprasWS.finalizePettyCash.finalize(
                        { circle: $rootScope.bsCircle.id, id: petty.pettyCashId, amountAvailable: vm.amountAvailable }, function (response) {// Success
                            init();
                            showMessage($filter('translate')('EXPENSE_SETTLEMENTS.PETTY_CASH.FINALIZE_PETTY.FINALIZE_PETTY_OK'));
                            $rootScope.loadingProgress = false;
                        }, function (response) {// Error
                            $rootScope.loadingProgress = false;
                            $log.debug(response.data);
                            if (response.data === "Settlements in process") {
                                showErrorMessage($filter('translate')('EXPENSE_SETTLEMENTS.PETTY_CASH.ERROR_FINALIZE_PETTY_CASH'));
                            } else {
                                showErrorMessage($filter('translate')('EXPENSE_SETTLEMENTS.PETTY_CASH.FINALIZE_PETTY.FINALIZE_PETTY_ERROR'));
                            }
                        });
                }
            }, function () {
                $rootScope.loadingProgress = false;
            });
        }

        function showMessage(message) {
            $rootScope.loadingProgress = false;
            $mdToast.show({
                template: '<md-toast layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
                hideDelay: 3000,
                position: 'top right'
            });
        }


        function showErrorMessage(message) {
            $rootScope.loadingProgress = false;
            $mdToast.show({
                template: '<md-toast layout="column" layout-align="center start"><div class="md-toast-content" style="background-color: red">'
                    + message + '</div></md-toast>',
                hideDelay: 5000,
                position: 'top right'
            });
        }

        function getDimensionCompany() {
            const NUMBER_DIMENSION_THREE = 3;
            const NUMBER_DIMENSION_FOUR = 4;
            const NUMBER_DIMENSION_FIVE = 5;
            api.GeneralWS.DimensionCompany.byCompany.getList(
                { 'company': $rootScope.bsCircle.company.id }
            ).$promise.then(function (responseDimension) {
              responseDimension.sort(function (a, b) {
                return a.dimensionNumber - b.dimensionNumber;
              });
                for (let i = 0; i < responseDimension.length; i++) {
                    if (responseDimension[i].dimensionNumber === NUMBER_DIMENSION_THREE) {
                        vm.dimensionCompanyDetail3 = responseDimension[i];
                        addMasterColumnDefs(responseDimension[i].description, 'dimensionCompanyDetail3Name', responseDimension[i].dimensionNumber);
                    } else if (responseDimension[i].dimensionNumber === NUMBER_DIMENSION_FOUR) {
                        vm.dimensionCompanyDetail4 = responseDimension[i];
                        addMasterColumnDefs(responseDimension[i].description, 'dimensionCompanyDetail4Name', responseDimension[i].dimensionNumber);
                    } else if (responseDimension[i].dimensionNumber === NUMBER_DIMENSION_FIVE) {
                        vm.dimensionCompanyDetail5 = responseDimension[i];
                        addMasterColumnDefs(responseDimension[i].description, 'dimensionCompanyDetail5Name', responseDimension[i].dimensionNumber);
                    } else {
                        vm.dimensionCompanyDetail1 = responseDimension[i];
                    }
                }
                vm.masterGridOptions.api.setColumnDefs(vm.masterColumnDefs);
            });
        }

        function addMasterColumnDefs(name, fieldName, number) {
            const NUMBER_SEVEN_COLUMN_ADD = 7;
            vm.masterColumnDefs.splice((number + NUMBER_SEVEN_COLUMN_ADD), 0, {
                headerName: name,
                field: fieldName,
                headerCellRenderer: getHeader,
                width: 200,
                enableRowGroup: true,
                filter: 'text',
                enablePivot: true
            });
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.expenseSettlement.paymentSettlement', [])
        .config(config);


    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {
        // State
        $stateProvider
            .state('app.expenseSettlement.paymentSettlements', {
                url: '/paymentSettlement',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/expenseSettlements/paymentSettlement/paymentSettlement.html',
                        controller: 'paymentSettlementController as vm'
                    }
                },
                bodyClass: 'mail'
            });
        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/expenseSettlements/paymentSettlement');


    }
})();


(function () {
    'use strict';

    angular
        .module('app.expenseSettlement.paymentSettlement')
        .controller('paymentSettlementController', paymentSettlementController);

    /** @ngInject */
    function paymentSettlementController($scope, $rootScope, $state, api, $log, $mdDialog, $filter) {
        var vm = this;

        document.addEventListener("mousewheel", function (event) {
            if (document.activeElement.type === "number") {
                document.activeElement.blur();
            }
        });

        //Methods
        vm.openSettlement = openSettlement;
        vm.showPettyCash = showPettyCash;
        vm.cancelDialog = cancelDialog;
        vm.viewChangeStatus = viewChangeStatus;


        init();

        function init() {
            api.ComprasWS.Settlement.getSettlements.getAllByUser({ idCircle: $rootScope.bsCircle.id, status: 'Provisionada' }).$promise.then(function (data) {
                vm.settlements = new jinqJs()
                    .from(data).
                    select(function (r) {
                        var d = r;
                        d.filter = (d.settlement.pettyCash.id + "," +
                            d.settlement.pettyCash.name + "," +
                            d.settlement.pettyCash.holder.account + "," +
                            d.settlement.pettyCash.department.description + "," +
                            d.settlement.pettyCash.costCenter.description + "," +
                            d.id + "," +
                            d.settlement.id + "," +
                            d.settlement.settlementStatus.name).toLowerCase();
                        return d;
                    });
                vm.masterGridOptions.api.setColumnDefs(vm.masterColumnDefs);
                vm.settlementsjson = data;
                getDimensionCompany();

                vm.masterGridOptions.api.setRowData(data);
            }, function (error) {
                $log.error(error.data);
            });

        }

        vm.masterColumnDefs = [
            {
                headerName: 'EXPENSE_SETTLEMENTS.PETTY_CASH.PETTY_CASH',
                field: "settlement.pettyCash.id",
                headerCellRenderer: getHeader,
                width: 125,
                enableRowGroup: true,
                enablePivot: true,
                pinned: "left"
            },
            {
                headerName: 'EXPENSE_SETTLEMENTS.PETTY_CASH.NAME',
                field: "settlement.pettyCash.name",
                headerCellRenderer: getHeader,
                width: 250,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'EXPENSE_SETTLEMENTS.PETTY_CASH.HOLDER',
                field: "settlement.pettyCash.holder.account",
                headerCellRenderer: getHeader,
                width: 250,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'EXPENSE_SETTLEMENTS.PETTY_CASH.COMPANY',
                field: "settlement.pettyCash.company.name",
                headerCellRenderer: getHeader,
                width: 250,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'PAYMENT_SETTLEMENT.SETTLEMENT',
                headerCellRenderer: getHeader,
                width: 100,
                enableRowGroup: true,
                enablePivot: true,
                cellRenderer: function renderer() {
                    return '<div style="width: 100%;">'
                        + ' {{data.settlement.id}}  '
                        + ' <md-button class="edit-button md-icon-button" ng-click="vm.viewChangeStatus(data.settlement, $event)" aria-label="settlement"'
                        + ' translate translate-attr-aria-label="SETTLEMENT.CHANGE_STATUS.CHANGE_STATUS">'
                        + ' <md-tooltip md-direction="bottom">'
                        + ' {{"SETTLEMENT.CHANGE_STATUS.CHANGE_STATUS"| translate}}'
                        + ' </md-tooltip>'
                        + '  <md-icon md-font-icon="icon-history" class="s16"></md-icon> '
                        + ' </md-button>'
                        + ' </div>';
                },
                cellStyle: { 'padding': '0px' }
            },
            {
                headerName: 'EXPENSE_SETTLEMENTS.PETTY_CASH.COST_CENTER',
                field: "settlement.pettyCash.costCenter.description",
                headerCellRenderer: getHeader,
                width: 250,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'EXPENSE_SETTLEMENTS.PETTY_CASH.DEPARTMENT',
                field: "settlement.pettyCash.department.description",
                width: 250,
                headerCellRenderer: getHeader,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'PAYMENT_SETTLEMENT.SETTLEMENT_STATUS',
                field: "settlement.settlementStatus.name",
                headerCellRenderer: getHeader,
                width: 150,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'PAYMENT_SETTLEMENT.CASH_AMOUNT',
                field: "settlement.cashAmount",
                headerCellRenderer: getHeader,
                width: 150,
                valueFormatter: function (params) {
                    return $filter('number')(params.value, 2);
                },
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'PAYMENT_SETTLEMENT.SETTLED_AMOUNT',
                field: "settlement.settledAmount",
                headerCellRenderer: getHeader,
                width: 150,
                valueFormatter: function (params) {
                    return $filter('number')(params.value, 2);
                },
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'PAYMENT_SETTLEMENT.OPTIONS',
                field: "settlement.holder.account",
                headerCellRenderer: getHeader,
                suppressSorting: true,
                suppressMenu: true,
                width: 150,
                cellRenderer: function renderer(params) {
                    return '<div style="width: 100%;">'
                        + ' <md-button class="edit-button md-icon-button" ng-click="vm.openSettlement(data.settlement.id)" aria-label="settlement"'
                        + ' translate translate-attr-aria-label="PAYMENT_SETTLEMENT.VIEW_DETAILS">'
                        + ' <md-tooltip md-direction="bottom">'
                        + ' {{"PAYMENT_SETTLEMENT.VIEW_DETAILS"| translate}}'
                        + ' </md-tooltip>'
                        + '  <md-icon md-font-icon="icon-eye" class="s16"></md-icon> '
                        + ' </md-button>'
                        + ' </div>';
                },
                cellStyle: { 'padding': '0px' },
                pinned: "right"
            }

        ];

        function viewChangeStatus(settlement, ev) {
            $mdDialog.show({
                controller: 'changeStatusController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/expenseSettlements/settlements/settlement/settlementEditor/changeStatus/changeStatus.html',
                targetEvent: ev,
                locals: {
                    settlementId: settlement.id
                },
                clickOutsideToClose: false
            }).then(function (answer) {

            });
        }

        vm.masterGridOptions = {
            columnDefs: vm.masterColumnDefs,
            enableSorting: true,
            debug: false,
            enableFilter: true,
            enableColResize: true,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowData: null,
            groupHeaders: true,
            headerHeight: 50,
            rowHeight: 45,
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            },
            doesDataFlower: function (dataItem) {
                return true;
            },
            isExternalFilterPresent: isExternalFilterPresent,
            doesExternalFilterPass: doesExternalFilterPass
        };

        var filter = 'everyone';

        function isExternalFilterPresent() {
            return filter !== '';
        }

        function doesExternalFilterPass(node) {
            if (filter && filter !== 'everyone') {
                var arrdt = node.data.filter.split(filter);
                return arrdt.length > 1;
            }
            return true;
        }

        $scope.$watch('vm.search',
            function (newValue) {
                filter = newValue ? newValue.toLowerCase() : 'everyone';
                vm.masterGridOptions.api.onFilterChanged();
            }
        );

        function showPettyCash(index, ev) {
            $mdDialog.show({
                contentElement: '#myStaticDialog' + index,
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: false
            }).then(function () {
            }, function () {
            });
        }

        function cancelDialog() {
            $mdDialog.cancel();
        }

        function openSettlement(id) {
            $state.go('app.expenseSettlement.settlement.settlementView', { settlementId: id });
        }

      function getDimensionCompany() {
        const NUMBER_DIMENSION_THREE = 3;
        const NUMBER_DIMENSION_FOUR = 4;
        const NUMBER_DIMENSION_FIVE = 5;
        api.GeneralWS.DimensionCompany.byCompany.getList(
          { 'company': $rootScope.bsCircle.company.id }
        ).$promise.then(function (responseDimension) {
          responseDimension.sort(function (a, b) {
            return a.dimensionNumber - b.dimensionNumber;
          });
          for (let i = 0; i < responseDimension.length; i++) {
            if (responseDimension[i].dimensionNumber === NUMBER_DIMENSION_THREE) {
              vm.dimensionCompanyDetail3 = responseDimension[i];
              addMasterColumnDefs(responseDimension[i].description, 'settlement.pettyCash.dimensionCompanyDetail3.name', responseDimension[i].dimensionNumber);
            } else if (responseDimension[i].dimensionNumber === NUMBER_DIMENSION_FOUR) {
              vm.dimensionCompanyDetail4 = responseDimension[i];
              addMasterColumnDefs(responseDimension[i].description, 'settlement.pettyCash.dimensionCompanyDetail4.name', responseDimension[i].dimensionNumber);
            } else if (responseDimension[i].dimensionNumber === NUMBER_DIMENSION_FIVE) {
              vm.dimensionCompanyDetail5 = responseDimension[i];
              addMasterColumnDefs(responseDimension[i].description, 'settlement.pettyCash.dimensionCompanyDetail5.name', responseDimension[i].dimensionNumber);
            } else {
              vm.dimensionCompanyDetail1 = responseDimension[i];
            }
          }
          if (vm.masterGridOptions && vm.masterGridOptions.api) {
            vm.masterGridOptions.api.setColumnDefs(vm.masterColumnDefs);
          }
        });
      }

      function addMasterColumnDefs(name, fieldName, number) {
        const NUMBER_SEVEN_COLUMN_ADD = 7;
        vm.masterColumnDefs.splice((number + NUMBER_SEVEN_COLUMN_ADD), 0, {
          headerName: name,
          field: fieldName,
          headerCellRenderer: getHeader,
          width: 200,
          enableRowGroup: true,
          filter: 'text',
          enablePivot: true
        });
      }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.expenseSettlement.paidSettlements', [])
        .config(config);


    /** @ngInject */
    function config($translatePartialLoaderProvider) {

        $translatePartialLoaderProvider.addPart('app/main/apps/expenseSettlements/paidSettlements');


    }
})();


(function () {
    'use strict';

    angular
        .module('app.expenseSettlement.paidSettlements')
        .controller('paidSettlementsController', paidSettlementsController);

    /** @ngInject */
    function paidSettlementsController($scope, $rootScope, $mdToast, api, $log, $mdDialog, $filter, $state) {
        var vm = this;

        //Data
        vm.cancelPayment = cancelPayment;
        vm.openSettlement = openSettlement;
        vm.viewChangeStatus = viewChangeStatus;

        /////////
        init();

        function init() {
            $rootScope.loadingProgress = true;
            api.ComprasWS.Settlement.getSettlements.getAllByUser({ idCircle: $rootScope.bsCircle.id, status: 'Pagada' }).$promise.then(function (data) {
                vm.settlements = new jinqJs()
                    .from(data).
                    select(function (r) {
                        var d = r;
                        d.filter = (d.settlement.pettyCash.id + "," +
                            d.settlement.pettyCash.name + "," +
                            d.settlement.pettyCash.holder.account + "," +
                            d.settlement.pettyCash.department.description + "," +
                            d.settlement.pettyCash.costCenter.description + "," +
                            d.id + "," +
                            d.settlement.id + "," +
                            d.settlement.settlementStatus.name).toLowerCase();
                        return d;
                    });
                vm.masterGridOptions.api.setColumnDefs(vm.masterColumnDefs);
                vm.settlementsjson = data;

                vm.masterGridOptions.api.setRowData(data);
            }, function (error) {
                $log.error(error.data);
            });
        }

        vm.masterColumnDefs = [
            {
                headerName: 'EXPENSE_SETTLEMENTS.PETTY_CASH.PETTY_CASH',
                field: "settlement.pettyCash.id",
                headerCellRenderer: getHeader,
                width: 125,
                enableRowGroup: true,
                enablePivot: true,
                pinned: "left"
            },
            {
                headerName: 'EXPENSE_SETTLEMENTS.PETTY_CASH.NAME',
                field: "settlement.pettyCash.name",
                headerCellRenderer: getHeader,
                width: 250,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'EXPENSE_SETTLEMENTS.PETTY_CASH.HOLDER',
                field: "settlement.pettyCash.holder.account",
                headerCellRenderer: getHeader,
                width: 250,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'EXPENSE_SETTLEMENTS.PETTY_CASH.COMPANY',
                field: "settlement.pettyCash.company.name",
                headerCellRenderer: getHeader,
                width: 250,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'PAID_SETTLEMENT.SETTLEMENT',
                headerCellRenderer: getHeader,
                width: 100,
                enableRowGroup: true,
                enablePivot: true,
                cellRenderer: function renderer() {
                    return '<div style="width: 100%;">'
                        + ' {{data.settlement.id}}  '
                        + ' <md-button class="edit-button md-icon-button" ng-click="vm.viewChangeStatus(data.settlement, $event)" aria-label="settlement"'
                        + ' translate translate-attr-aria-label="SETTLEMENT.CHANGE_STATUS.CHANGE_STATUS">'
                        + ' <md-tooltip md-direction="bottom">'
                        + ' {{"SETTLEMENT.CHANGE_STATUS.CHANGE_STATUS"| translate}}'
                        + ' </md-tooltip>'
                        + '  <md-icon md-font-icon="icon-history" class="s16"></md-icon> '
                        + ' </md-button>'
                        + ' </div>';
                },
                cellStyle: { 'padding': '0px' }
            },
            {
                headerName: 'EXPENSE_SETTLEMENTS.PETTY_CASH.COST_CENTER',
                field: "settlement.pettyCash.costCenter.description",
                headerCellRenderer: getHeader,
                width: 250,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'EXPENSE_SETTLEMENTS.PETTY_CASH.DEPARTMENT',
                field: "settlement.pettyCash.department.description",
                width: 250,
                headerCellRenderer: getHeader,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'PAID_SETTLEMENT.SETTLEMENT_STATUS',
                field: "settlement.settlementStatus.name",
                headerCellRenderer: getHeader,
                width: 150,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'SETTLEMENT.CASH_AMOUNT',
                field: "settlement.cashAmount",
                headerCellRenderer: getHeader,
                width: 150,
                valueFormatter: function (params) {
                    return $filter('number')(params.value, 2);
                },
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'SETTLEMENT.SETTLED_AMOUNT',
                field: "settlement.settledAmount",
                headerCellRenderer: getHeader,
                width: 150,
                valueFormatter: function (params) {
                    return $filter('number')(params.value, 2);
                },
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'SETTLEMENT.OPTIONS',
                field: "settlement.holder.account",
                headerCellRenderer: getHeader,
                suppressSorting: true,
                suppressMenu: true,
                width: 150,
                cellRenderer: function renderer(params) {
                    return '<div style="width: 100%;">'
                        + ' <md-button class="edit-button md-icon-button" ng-click="vm.openSettlement(data.settlement.id)" aria-label="settlement"'
                        + ' translate translate-attr-aria-label="PAID_SETTLEMENT.VIEW_DETAILS">'
                        + ' <md-tooltip md-direction="bottom">'
                        + ' {{"PAID_SETTLEMENT.VIEW_DETAILS"| translate}}'
                        + ' </md-tooltip>'
                        + '  <md-icon md-font-icon="icon-eye" class="s16"></md-icon> '
                        + ' </md-button>'
                        + ' <md-button class="edit-button md-icon-button" ng-click="vm.cancelPayment(data.settlement)" aria-label="settlement"'
                        + ' translate translate-attr-aria-label="PAID_SETTLEMENT.CANCEL_PAYMENT">'
                        + ' <md-tooltip md-direction="bottom">'
                        + ' {{"PAID_SETTLEMENT.CANCEL_PAYMENT"| translate}}'
                        + ' </md-tooltip>'
                        + '  <md-icon md-font-icon="icon-cancel" class="s16"></md-icon> '
                        + ' </md-button>'
                        + ' </div>';
                },
                cellStyle: { 'padding': '0px' },
                pinned: "right"
            }

        ];

        vm.masterGridOptions = {
            columnDefs: vm.masterColumnDefs,
            enableSorting: true,
            debug: false,
            enableFilter: true,
            enableColResize: true,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowData: null,
            groupHeaders: true,
            headerHeight: 50,
            rowHeight: 45,
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            },
            doesDataFlower: function (dataItem) {
                return true;
            },
            isExternalFilterPresent: isExternalFilterPresent,
            doesExternalFilterPass: doesExternalFilterPass
        };

        var filter = 'everyone';

        function isExternalFilterPresent() {
            return filter !== '';
        }

        function doesExternalFilterPass(node) {
            if (filter && filter !== 'everyone') {
                var arrdt = node.data.filter.split(filter);
                return arrdt.length > 1;
            }
            return true;
        }

        $scope.$watch('vm.search',
            function (newValue) {
                filter = newValue ? newValue.toLowerCase() : 'everyone';
                vm.masterGridOptions.api.onFilterChanged();
            }
        );

        function viewChangeStatus(settlement, ev) {
            $mdDialog.show({
                controller: 'changeStatusController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/expenseSettlements/settlements/settlement/settlementEditor/changeStatus/changeStatus.html',
                targetEvent: ev,
                locals: {
                    settlementId: settlement.id
                },
                clickOutsideToClose: false
            }).then(function (answer) {

            });
        }

        function openSettlement(id) {
            $state.go('app.expenseSettlement.settlement.settlementView', { settlementId: id });
        }

        function cancelPayment(settlement) {
            var i = vm.settlements.indexOf(settlement);
            $rootScope.loadingProgress = true;
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('PAID_SETTLEMENT.MSG_SURE_CANCEL_PAYMENT'))
                .content($filter('translate')('PAID_SETTLEMENT.MSG_CANCEL_PAYMENT'))
                .ariaLabel('Delete Detail')
                .ok($filter('translate')('SETTLEMENT.OK'))
                .cancel($filter('translate')('SETTLEMENT.CANCEL'));
            $mdDialog.show(confirm).then(function () {
                $rootScope.loadingProgress = true;
                api.ComprasWS.Settlement.cancelPaymentSettlement.cancel(
                    { settlementId: settlement.id, idCircle: $rootScope.bsCircle.id }).$promise.then(function (response) {
                        vm.settlements.splice(i, 1);
                        vm.masterGridOptions.api.setRowData(vm.settlements);
                        showMessage($filter('translate')('PAID_SETTLEMENT.CANCEL_PAYMENT_OK'));
                    }, function (error) {
                        $log.error(error);
                        $log.error(error.data);
                        showErrorMessage($filter('translate')('PAID_SETTLEMENT.CANCEL_PAYMENT_ERROR'));
                    });
            }, function () {
                // Cancel Action
                $rootScope.loadingProgress = false;
            });
        }

        function showMessage(message) {
            $rootScope.loadingProgress = false;
            $mdToast.show({
                template: '<md-toast layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
                hideDelay: 3000,
                position: 'top right'
            });
        }


        function showErrorMessage(message) {
            $rootScope.loadingProgress = false;
            $mdToast.show({
                template: '<md-toast layout="column" layout-align="center start">'
                    + '<div class="md-toast-content" style="background-color: red">' + message + '</div></md-toast>',
                hideDelay: 5000,
                position: 'top right'
            });
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.expenseSettlement.consultSettlements', [])
        .config(config);


    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {
        // State
        $stateProvider
            .state('app.expenseSettlement.consultSettlement', {
                url: '/consultSettlement/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/expenseSettlements/consultSettlement/consultSettlement.html',
                        controller: 'ConsultSettlementController as vm'
                    }
                },
                bodyClass: 'e-commerce'
            });
        $translatePartialLoaderProvider.addPart('app/main/apps/expenseSettlements/consultSettlement');
    }
})();


(function () {
    'use strict';

    angular
        .module('app.expenseSettlement.consultSettlements')
        .controller('ConsultSettlementController', ConsultSettlementController);

    /** @ngInject */
    function ConsultSettlementController($rootScope, api, $log, $filter, $timeout, $state, $stateParams, MessageService) {

        var vm = this;
        vm.settlement = {};

        if ($stateParams.id && $stateParams.id !== '') {
            vm.search = parseInt($stateParams.id);
            getSettlement(vm.search);
        }

        $timeout(function () {
            $("#settlementInput").focus();
        }, 500);

        vm.masterColumnDefs = [
            {
                headerName: 'CONSULT_SETTLEMENT.TYPE',
                field: "type",
                headerCellRenderer: getHeader,
                width: 100,
                cellStyle: { 'text-align': 'center' },
                cellRenderer: function (params) {
                    if (params.value != null) {
                        return $filter('translate')('CONSULT_SETTLEMENT.' + params.value);
                    }
                }
            },
            {
                headerName: 'CONSULT_SETTLEMENT.NUMBER',
                field: "number",
                headerCellRenderer: getHeader,
                width: 120,
                cellRenderer: numberCellRenderer,
            },
            {
                headerName: 'CONSULT_SETTLEMENT.PROVIDER',
                field: "provider",
                headerCellRenderer: getHeader,
                width: 250
            },
            {
                headerName: 'CONSULT_SETTLEMENT.TOTAL',
                field: "total",
                width: 100,
                headerCellRenderer: getHeader,
                cellStyle: { 'text-align': 'right' },
                valueFormatter: function (params) {
                    return $filter('number')(params.value, 2);
                }
            },
            {
                headerName: 'CONSULT_SETTLEMENT.DEDUCTIBLE',
                field: "taxDeductible",
                width: 200,
                headerCellRenderer: getHeader,
                cellRenderer: function (params) {
                    var deductible = "";
                    if (params.data != null) {
                        if (params.data.expenseDeductible) {
                            deductible = "Gasto deducible, ";
                        }
                        if (params.data.taxDeductible) {
                            deductible = deductible + " Impuesto deducible";
                        }
                    }
                    return deductible;
                }
            },
            {
                headerName: 'CONSULT_SETTLEMENT.STATUS',
                field: "status",
                width: 150,
                headerCellRenderer: getHeader
            },
            {
                headerName: 'CONSULT_SETTLEMENT.REJECTION_REASON',
                field: "rejectionReason",
                width: 200,
                headerCellRenderer: getHeader,
                cellRenderer: function (params) {
                    if (params.data != null && params.data.rejectionReason != null) {
                        return '<label> {{data.rejectionReason}} {{"SETTLEMENT.IS_DEFINITIVE_" + data.definitive | translate}} ' +
                            '<md-tooltip md-direction="top"><span>{{data.rejectionDescription}}</span></md-tooltip> </label>';
                    }
                }
            },
            {
                headerName: 'CONSULT_SETTLEMENT.OPTIONS',
                width: 100,
                headerCellRenderer: getHeader,
                cellRenderer: function (params) {
                    return '<center> <md-button class="md-icon-button" ng-click="vm.viewDetail(data)"> ' +
                        '<md-icon md-font-icon="icon-eye"></md-icon> ' +
                        ' </md-button> </center>';
                },
                pinned: "right"
            }
        ];

        function numberCellRenderer(params) {
            if (params.data.invoicePurchaseId) {
              return getNumberValueByInvoicePurchase(params.data);
            }
            return getNumberValueByPaymentReceipt(params.data);
        }

        function getNumberValueByPaymentReceipt(data) {
          if (data.paymentReceiptSerie) {
            return data.paymentReceiptSerie + '-' + data.paymentReceiptCorrelative;
          }
          return data.paymentReceiptCorrelative;
        }

        function getNumberValueByInvoicePurchase(data) {
          if (data.companyBuyerCountryCode === 'SV' && data.invoicePurchaseUuid) {
            return data.invoicePurchaseUuid;
          }
          if (data.invoicePurchaseSerie) {
            return data.invoicePurchaseSerie + '-' + data.invoicePurchaseCorrelative;
          }
          return data.invoicePurchaseCorrelative;
        }

        vm.masterGridOptions = {
            rowSelection: 'multiple',
            rowDeselection: true,
            columnDefs: vm.masterColumnDefs,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowHeight: 35,
            enableColResize: true,
            rowData: [],
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            }

        };

        //Methods
        vm.getSettlement = getSettlement;
        vm.viewDetail = viewDetail;

        function getSettlement(settlementId) {

            vm.settlement = {};
            $rootScope.loadingProgress = true;

            api.ComprasWS.Settlement.getSettlementByNumber.get({ idCircle: $rootScope.bsCircle.id, settlementId: settlementId }).$promise.then(function (response) {
                vm.settlement = response;

                $timeout(function () {
                    vm.masterGridOptions.api.setRowData(vm.settlement.details);
                });

                getAmountAvailable();

                $rootScope.loadingProgress = false;
            }, function (error) {
                if (error.status == 404) {
                    MessageService.showErrorMessage('CONSULT_SETTLEMENT.NO_EXIST');
                }
                $log.error(error);
                $rootScope.loadingProgress = false;
            });
        }

        function getAmountAvailable() {
            if (vm.settlement.settlementHeader.amount > 0) {
                api.ComprasWS.Settlement.getAmountAvailable
                    .getTotal({ id: vm.settlement.settlementHeader.pettyId })
                    .$promise.then(
                        function (response) {
                            vm.amountAvailable = parseFloat(response.$data);
                        },
                        function (error) {
                            $log.error(error.data);
                        }
                    );
            }
        }

        function viewDetail(detail) {
            if (detail.type == "INVOICE") {
                $state.go("app.expenseSettlement.settlement.invoiceView", {
                    settlement: vm.settlement.id,
                    detail: detail.detailId,
                    invoiceId: detail.id
                });
            } else {
                $state.go("app.expenseSettlement.settlement.receiptView", {
                    settlement: vm.settlement.id,
                    detail: detail.detailId,
                    receipt: detail.id
                });
            }
        }
    }
})();

(function () {
  'use strict';
  angular
    .module('app.invoice')
    .controller('InvoiceFilesComparatorController', InvoiceFilesComparatorController);

  function InvoiceFilesComparatorController(fileDataLeft, fileDataRight, $mdDialog) {

    var vm = this;

    vm.fileDataLeft = fileDataLeft;
    vm.fileDataRight = fileDataRight;

    vm.closeDialog = function () {
      $mdDialog.cancel();
    };

    vm.updateImageZoomOptions = function (img, fileData) {
      const url = img.url;
      const extension = img.extension;
      fileData.imageZoomOptions = {
        zoomLevel: 2,
        images: [
          {
            thumb: url + extension,
            medium: url + extension,
            large: url + extension,
          },
        ],
      };
    };

  }

})();

(function () {
    'use strict';

    angular
        .module('app.dashboards.project', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.dashboards_project', {
            url: '/dashboard-project',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/dashboards/project/dashboard-project.html',
                    controller: 'DashboardProjectController as vm'
                }
            },
            bodyClass: 'dashboard-project'
        });
    }

})();

(function () {
    'use strict';

    angular
        .module('app.dashboards.project')
        .controller('DashboardProjectController', DashboardProjectController);

    /** @ngInject */
    function DashboardProjectController($rootScope, $state, $log, api, $timeout, STATUS_CODES) {
        var vm = this;
        vm.requisitionsPendingInsert = [];
        vm.requisitionsPendingAutorize = [];
        vm.requisitionsPendingCotize = [];
        vm.quotationsPendingApproval = [];
        vm.quotationsPendingAuthorize = [];
        vm.quotationsReportPendingAuthorize = [];
        vm.quotationsReportPendingApproval = [];
        vm.quotationsPendingFeatures = [];
        vm.ordersProvider = [];
        vm.ordersClient = [];
        vm.ordersReportClient = [];
        vm.ordersFirsRecept = [];
        vm.merchandiseEntries = [];
        vm.invoicesPendingEmit = [];
        vm.invoicesPendingEdit = [];
        vm.invoicesPendingCheck = [];
        vm.invoicesPendingPreCheck = [];
        vm.invoicesPendingProvide = [];
        vm.contractsPendingInsert = [];
        vm.contractsPendingAutorize = [];
        vm.contractsPendingCancel = [];
        vm.settlementsPendingAuthorization = [];
        vm.settlementPendingVerification = [];
        vm.settlementPendingProsivioning = [];
        vm.settlementPendingPayment = [];
        vm.detailsNotValidated = [];
        vm.detailsExtraAuthorization = [];
        vm.pettiesWithAmountToReturn = [];


        vm.viewGoto = viewGoto;

        function init() {
            if ($rootScope.items) {
                for (var i = 0; i < $rootScope.items.length; i++) {
                    switch ($rootScope.items[i].menuItem.itemName) {
                        case 'apps.requisition.pendingInsert':
                            vm.loadingRequisitionsPendingInsert = true;
                            requisitionPending(STATUS_CODES.requisition.Creando);
                            break;
                        case 'apps.requisition.pendingAutorize':
                            vm.loadingRequisitionsPendingAutorize = true;
                            requisitionPending(STATUS_CODES.requisition.Ingresado);
                            break;
                        case 'apps.requisition.pendingCotize':
                            vm.loadingRequisitionsPendingCotize = true;
                            requisitionPendingToCotize(STATUS_CODES.requisition.Autorizado);
                            break;
                        case 'apps.quotation.pendingAuthorize':
                            vm.loadingQuotationsPendingAuthorize = true;
                            getQuotations(STATUS_CODES.Quotation.Ingresada);
                            break;
                        case 'apps.quotation.reportPendingAuthorize':
                            vm.loadingQuotationsReportPendingAuthorize = true;
                            getQuotationsReport(STATUS_CODES.Quotation.Ingresada);
                            break;
                        case 'apps.quotation.pendingApproval':
                            vm.loadingQuotationsPendingApproval = true;
                            getQuotations(STATUS_CODES.Quotation.Autorizado);
                            break;
                        case 'apps.quotation.reportPendingApprove':
                            vm.loadingQuotationsReportPendingApprove = true;
                            getQuotationsReport(STATUS_CODES.Quotation.Autorizado);
                            break;
                        case 'apps.quotation.pendingEnterFeatures':
                            vm.loadingQuotationsPendingFeatures = true;
                            getQuotations(STATUS_CODES.Quotation.AprobadoProveedorSinCaracteristicas);
                            break;
                        case 'apps.purchaseOrder.pendingDelivery.provider':
                            vm.loadingOrdersProvider = true;
                            getPurchaseOrder('P');
                            break;
                        case 'apps.purchaseOrder.buyer':
                            vm.loadingOrdersClient = true;
                            getPurchaseOrder('C');
                            break;
                        case 'apps.purchaseOrder.firstRecept':
                            vm.loadingOrdersFirsRecept = true;
                            getPurchaseOrder('PR');
                            break;
                        case 'apps.purchaseOrder.invoiceMerchandiseEntry':
                            vm.loadingMerchandiseEntries = true;
                            getMerchandise();
                            break;
                        case 'apps.purchaseOrder.reportPendingDelivery':
                            vm.loadingOrdersReportClient = true;
                            getPurchaseOrderReport('C', STATUS_CODES.PurchaseOrder.PendienteRecibir);
                            break;
                        case 'apps.invoice.pendingEmit':
                            vm.loadingInvoicesPendingEmit = true;
                            getInvoices(STATUS_CODES.InvoicePurchase.Ingresando);
                            break;
                        case 'apps.invoice.pendingEdit':
                            vm.loadingInvoicesPendingEdit = true;
                            getInvoices(STATUS_CODES.InvoicePurchase.Editando);
                            break;
                        case 'apps.invoice.pendingPreCheck':
                            vm.loadingInvoicesPendingPreCheck = true;
                            getInvoices(STATUS_CODES.InvoicePurchase.Emitida);
                            break;
                        case 'apps.invoice.pendingCheck':
                            vm.loadingInvoicesPendingCheck = true;
                            getInvoices(STATUS_CODES.InvoicePurchase.PendienteRecibirOriginal);
                            break;
                        case 'apps.contract.pendingInsert':
                            vm.loadingContractsPendingInsert = true;
                            getContracs(STATUS_CODES.Contract.Creando);
                            break;
                        case 'apps.contract.pendingAutorize':
                            vm.loadingContractsPendingAutorize = true;
                            getContracs(STATUS_CODES.Contract.Ingresado);
                            break;
                        case 'apps.contract.pendingCancel':
                            vm.loadingContractsPendingCancel = true;
                            getContracs(STATUS_CODES.Contract.Autorizado);
                            break;
                        case 'apps.expenseSettlement.settlement.pendingAuthorize':
                            vm.loadingSettlementPendingAuthorization = true;
                            getSettlements('Pendiente de Autorizar');
                            break;
                        case 'apps.expenseSettlement.verificationSettlements':
                            vm.loadingSettlementPendingVerification = true;
                            getSettlementsPendingVerification();
                            break;
                        case 'apps.expenseSettlement.settlement.preProvisioned':
                            vm.loadingSettlementPendingProsivioning = true;
                            getSettlements('Pre-Provisionada');
                            break;
                        case 'apps.expenseSettlement.settlement.details':
                            if ($rootScope.bsCircle.role.name === 'ROLE_EXTRA_AUTORIZADOR_LIQUIDACIONES') {
                                vm.loadingDetailsExtraAuthorization = true;
                                getSettlementDetails('Autorización Extra');
                            } else {
                                vm.loadingDetailsNotValidated = true;
                                getSettlementDetails('No Validado');
                            }
                            break;
                        case 'apps.expenseSettlement.paymentSettlements':
                            vm.loadingSettlementPendingPayment = false;
                            getSettlements('Provisionada');
                            break;
                        case 'apps.expenseSettlement.pettyCash.withAmountToReturn':
                            vm.loadingPettiesWithAmountToReturn = false;
                            getPettyCashWithAmountToReturn();
                            break;

                    }
                }
            }
        }

        function requisitionPending(statuses) {
            api.ComprasWS.Requisition.page({ idCircle: $rootScope.bsCircle.id, status: statuses, page: 0, pageSize: 1 }, function (response) {
                switch (statuses) {
                    case STATUS_CODES.requisition.Creando:
                        vm.requisitionsPendingInsert = response.totalElements;
                        vm.loadingRequisitionsPendingInsert = false;
                        break;
                    case STATUS_CODES.requisition.Ingresado:
                        vm.requisitionsPendingAutorize = response.totalElements;
                        vm.loadingRequisitionsPendingAutorize = false;
                        break;
                }
                vm.loading = false;
            }, function (response) {// Error
                $log.debug(response);
                vm.loading = false;
                return [];
            });
        }

        function requisitionPendingToCotize(statuses) {
            api.ComprasWS.Requisitions.toCotize.page(
                { idCircle: $rootScope.bsCircle.id, status: statuses, page: 0, pageSize: 1, tickets: false }, function (response) {
                    vm.requisitionsPendingCotize = response.totalElements;
                    vm.loadingRequisitionsPendingCotize = false;
                    vm.loading = false;
                }, function (response) {// Error
                    $log.debug(response);
                    return [];
                });
        }

        function getQuotations(status) {
            api.ComprasWS.Quotation.findByStatus.query(
                { 'companyId': $rootScope.bsCircle.company.id, 'statusName': status }).$promise.then(function (response) {
                    switch (status) {
                        case STATUS_CODES.Quotation.Ingresada:
                            vm.quotationsPendingAuthorize = response;
                            vm.loadingQuotationsPendingAuthorize = false;
                            break;
                        case STATUS_CODES.Quotation.Autorizado:
                            vm.quotationsPendingApproval = response;
                            vm.loadingQuotationsPendingApproval = false;
                            break;
                        case STATUS_CODES.Quotation.AprobadoProveedorSinCaracteristicas:
                            vm.quotationsPendingFeatures = response;
                            vm.loadingQuotationsPendingFeatures = false;
                            break;
                    }
                }, function (response) {
                    $log.error(response);
                });
        }

        function getQuotationsReport(status) {
            vm.filter = {
                appName: $rootScope.bsCircle.role.aplication.name,
                isProvider: false,
                isGeneral: true
            };
            var parameters = {
                circle: $rootScope.bsCircle.id,
                idCircle: $rootScope.bsCircle.id,
                company: $rootScope.bsCircle.company.id,
                page: 1,
                pageSize: 1
            };

            api.GeneralWS.Usr.User.Company.CompanyRolUser.page(parameters, function (data) {
                vm.filter.companies = [];
                data.forEach(function (company) {
                    vm.filter.companies.push(company.id);
                });
                api.ComprasWS.PurchaseStatus.query({ type: 2 }, function (data) {
                    vm.statuses = data;
                    vm.filter.statuses = [];
                    vm.statuses.forEach(function (data) {
                        if (status === data.description) {
                            vm.filter.statuses.push(data.id);
                        }
                    });
                    api.ComprasWS.Report.Quotation.page(parameters, vm.filter).$promise.then(function (response) {
                        switch (status) {
                            case STATUS_CODES.Quotation.Ingresada:
                                vm.quotationsReportPendingAuthorize.length = response.totalElements;
                                vm.loadingQuotationsReportPendingAuthorize = false;
                                break;
                            case STATUS_CODES.Quotation.Autorizado:
                                vm.quotationsReportPendingApproval.length = response.totalElements;
                                vm.loadingQuotationsReportPendingApproval = false;
                                break;
                            case STATUS_CODES.Quotation.AprobadoProveedorSinCaracteristicas:
                                vm.quotationsReportPendingFeatures.length = response.totalElements;
                                vm.loadingQuotationsReportPendingFeatures = false;
                                break;
                        }
                    }, function (response) {
                        $log.error(response);
                    });
                });
            });
        }

        function getPurchaseOrder(type) {
            api.ComprasWS.PurchaseOrder.query({ idCircle: $rootScope.bsCircle.id, type: type }, function (response) {
                switch (type) {
                    case 'P':
                        vm.ordersProvider = response;
                        vm.loadingOrdersProvider = false;
                        break;
                    case 'C':
                        vm.ordersClient = response;
                        vm.loadingOrdersClient = false;
                        break;
                    case 'PR':
                        vm.ordersFirsRecept = response;
                        vm.loadingOrdersFirsRecept = false;
                        break;
                }
            }, function (response) {// Error
                $log.debug(response);
            });
        }

        function getPurchaseOrderReport(type, status) {
            vm.filter = {
                appName: $rootScope.bsCircle.role.aplication.name,
                isProvider: false,
                isGeneral: true
            };
            var parameters = {
                circle: $rootScope.bsCircle.id,
                idCircle: $rootScope.bsCircle.id,
                company: $rootScope.bsCircle.company.id,
                page: 1,
                pageSize: 1
            };

            api.GeneralWS.Usr.User.Company.CompanyRolUser.page(parameters, function (data) {
                vm.filter.companies = [];
                data.forEach(function (company) {
                    vm.filter.companies.push(company.id);
                });
                api.ComprasWS.PurchaseStatus.query({ type: 3 }, function (data) {
                    vm.statuses = data;
                    vm.filter.statuses = [];
                    vm.statuses.forEach(function (st) {
                        if (status === st.description) {
                            vm.filter.statuses.push(st.id);
                        }
                    });
                    api.ComprasWS.Report.PurchaseOrder.page(parameters, vm.filter).$promise.then(function (response) {
                        switch (type) {
                            case 'P':
                                vm.ordersReportProvider.length = response.totalElements;
                                vm.loadingOrdersReportProvider = false;
                                break;
                            case 'C':
                                vm.ordersReportClient.length = response.totalElements;
                                vm.loadingOrdersReportClient = false;
                                break;
                            case 'PR':
                                vm.ordersReportFirsRecept.length = response.totalElements;
                                vm.loadingOrdersReportFirsRecept = false;
                                break;
                        }
                    }, function (response) {
                        $log.error(response);
                    });
                });
            });
        }


        function getMerchandise() {
            api.ComprasWS.MerchandiseEntry2.countByUserProvider.get(
                { idCircle: $rootScope.bsCircle.id, invoiced: false, status: 'Recibida' }, function (response) {

                    vm.merchandiseEntries = response.$data;

                    vm.loadingMerchandiseEntries = false;
                    $log.debug(vm.merchandiseEntries);
                }, function (response) {// Error
                    $log.debug(response);
                    vm.loadingMerchandiseEntries = false;
                });
        }

        function getInvoices(status) {
            api.ComprasWS.InvoicePurchase.list(
                { id: 'byUserAndStatus', idCircle: $rootScope.bsCircle.id, status: status }).$promise.then(function (response) {
                    switch (status) {
                        case STATUS_CODES.InvoicePurchase.Ingresando:
                            vm.invoicesPendingEmit = response;
                            vm.loadingInvoicesPendingEmit = false;
                            break;
                        case STATUS_CODES.InvoicePurchase.Editando:
                            vm.invoicesPendingEdit = response;
                            vm.loadingInvoicesPendingEdit = false;
                            break;
                        case STATUS_CODES.InvoicePurchase.Emitida:
                            vm.invoicesPendingPreCheck = response;
                            vm.loadingInvoicesPendingPreCheck = false;
                            break;
                        case STATUS_CODES.InvoicePurchase.Verificada:
                            vm.invoicesPendingProvide = response;
                            vm.loadingInvoicesPendingProvide = false;
                            break;
                        case 'Pre-Verificada':
                            vm.invoicesPendingCheck = response;
                            vm.loadingInvoicesPendingCheck = false;
                            break;
                    }
                    vm.loading = false;
                }, function (response) {// Error
                    $log.debug(response);
                    vm.loading = false;
                    $rootScope.loadingProgress = false;
                });
        }

        function getContracs(status) {
            api.ComprasWS.ContractFind.page({ idCircle: $rootScope.bsCircle.id, status: status, page: 0, pageable: 20 }, function (response) {
                switch (status) {
                    case STATUS_CODES.Contract.Creando:
                        vm.contractsPendingInsert = response.totalElements;
                        vm.loadingContractsPendingInsert = false;
                        break;
                    case STATUS_CODES.Contract.Ingresado:
                        vm.contractsPendingAutorize = response.totalElements;
                        vm.loadingContractsPendingAutorize = false;
                        break;
                    case STATUS_CODES.Contract.Autorizado:
                        vm.contractsPendingCancel = response.totalElements;
                        vm.loadingContractsPendingCancel = false;
                        break;
                }
                $log.debug(vm.contracts);
            }, function (response) {// Error
                $log.debug(response);
                vm.loadingContractsPendingInsert = false;
                vm.loadingContractsPendingAutorize = false;
                vm.loadingContractsPendingCancel = false;
            });
        }

        function getSettlements(status) {
            api.ComprasWS.Settlement.getSettlements.getAllByUser({ idCircle: $rootScope.bsCircle.id, status: status }).$promise.then(function (response) {
                switch (status) {
                    case 'Pendiente de Autorizar':
                        vm.settlementsPendingAuthorization = response;
                        vm.loadingSettlementPendingAuthorization = false;
                        break;
                    case 'Pre-Provisionada':
                        vm.settlementPendingProvisioning = response;
                        vm.loadingSettlementPendingProsivioning = false;
                        break;
                    case 'Provisionada':
                        vm.settlementPendingPayment = response;
                        vm.loadingSettlementPendingPayment = false;
                        break;
                }
            }, function (error) {
                $log.error(error);
                vm.loadingSettlementPendingAuthorization = false;
                vm.loadingSettlementPendingVerification = false;
                vm.loadingSettlementPendingPayment = false;
            });
        }

        function getSettlementsPendingVerification() {
            api.ComprasWS.Settlement.Settlement.query({ idCircle: $rootScope.bsCircle.id }).$promise.then(function (response) {
                vm.settlementPendingVerification = response;
                vm.loadingSettlementPendingVerification = false;
            }, function (error) {
                $log.error(error);
                vm.loadingSettlementPendingVerification = false;

            });
        }

        function getSettlementDetails(status) {
            api.ComprasWS.SettlementDetails.AllDetailsByStatus.getAll({ status: status, circleId: $rootScope.bsCircle.id }).$promise.then(function (response) {
                switch (status) {
                    case 'No Validado':
                        vm.detailsNotValidated = response;
                        vm.loadingDetailsNotValidated = false;
                        break;
                    case 'Autorización Extra':
                        vm.detailsExtraAuthorization = response;
                        vm.loadingDetailsExtraAuthorization = false;
                        break;
                }
            }, function (error) {
                $log.error(error);
                vm.loadingDetailsNotValidated = false;
                vm.loadingDetailsExtraAuthorization = false;
            });
        }

        function getPettyCashWithAmountToReturn() {
            api.ComprasWS.pettyCashWithAmountToReturn.query({ idCircle: $rootScope.bsCircle.id }).$promise.then(function (response) {
                vm.pettiesWithAmountToReturn = response;
                vm.loadingPettiesWithAmountToReturn = false;
            }, function (error) {
                $log.error(error);
                vm.loadingPettiesWithAmountToReturn = false;
            });
        }

        function viewGoto(state, params) {
            $state.go(state, params);
        }

        $timeout(function () {
            init();
        }, 2000);

    }

})();

(function () {
    'use strict';
    angular
        .module('app.contract')
        .controller('ReportContractController', ContractController);

    /** @ngInject */
    function ContractController(
        api, $log, $rootScope, $mdDialog, $timeout,
        $filter, MessageService, $stateParams, $state
        ) {
        var vm = this;
        // Data
        vm.page = 1;
        vm.minDate = new Date();
        vm.statusToChange = $stateParams.status;
        vm.details = [];
        vm.hiddenSearch = false;
        vm.viewIMG = viewIMG;
        vm.URLPHOTOS = api.baseUrlPhotos;
        vm.dimensionCompanyDetail3 = null;
        vm.dimensionCompanyDetail4 = null;
        vm.dimensionCompanyDetail5 = null;
        vm.gotoContracts = gotoContracts;
        vm.dinamicSize =0;

        if ($stateParams.id && $stateParams.id !== '') {
            vm.search = parseInt($stateParams.id);
            vm.hiddenSearch = true;
            searchContract(vm.search);
        }

        vm.masterColumnDefsE = [
            {
                headerName: 'CONTRACT.QUANTITY',
                field: "quantity",
                headerCellRenderer: getHeader,
                width: 100,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'CONTRACT.PRODUCT',
                field: "product.name",
                headerCellRenderer: getHeader,
                width: 350,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'CONTRACT.TOTAL',
                field: "total",
                headerCellRenderer: getHeader,
                width: 100,
                enableRowGroup: true,
                enablePivot: true,
                cellStyle: { 'text-align': 'right' },
                valueFormatter: function (params) {
                    return $filter('number')(params.value, 2);
                }
            },
            {
                headerName: 'CONTRACT.TAXESINCLUDED',
                field: "taxesIncluded",
                headerCellRenderer: getHeader,
                width: 160,
                enableRowGroup: true,
                enablePivot: true,
                cellStyle: { 'text-align': 'center' },
                cellRenderer: function (params) {
                    if (params.data.taxesIncluded) {
                        return '<md-icon md-font-icon="icon-check" class="s16"></md-icon>';
                    } else {
                        return '<md-icon md-font-icon="icon-close-circle" class="s16"></md-icon>';
                    }
                }
            }
        ];

        vm.masterGridOptionsE = {
            columnDefs: vm.masterColumnDefsE,
            enableSorting: true,
            debug: false,
            enableFilter: true,
            enableColResize: true,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowData: null,
            groupHeaders: true,
            headerHeight: 40,
            rowHeight: 40,
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            },
            doesDataFlower: function (dataItem) {
                return true;
            },
            isExternalFilterPresent: isExternalFilterPresent,
            doesExternalFilterPass: doesExternalFilterPass
        };

        vm.masterColumnDefs = [
            {
                headerName: 'CONTRACT.QUANTITY',
                field: "quantityReceived",
                headerCellRenderer: getHeader,
                width: 100,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'CONTRACT.MAXDATEPURCHASE',
                field: "fecha",
                headerCellRenderer: getHeader,
                valueFormatter: function (params) {
                    return $filter('date')(params.value, 'dd/MM/yyyy');
                }
            },
            {
                headerName: 'CONTRACT.DETAIL.OBSERVATIONS',
                field: "observations",
                headerCellRenderer: getHeader,
                width: 300,
                enableRowGroup: true,
                enablePivot: true,
                cellRenderer: function (params) {
                    if (params.data.taxesIncluded) {
                        return '{{\'INVOICE_MERCHANDISE_ENTRY.PAYMENTS\'| translate}}';
                    } else {
                        return '{{\'INVOICE_MERCHANDISE_ENTRY.PAYMENTS\'| translate}} {{data.noPayment}} -  {{data.invoiced==true?\'Facturado\':\'Pendiente de Facturar\'}}';
                    }
                }
            },
            {
                headerName: 'CONTRACT.BY_CREATED',
                field: "createdBy",
                headerCellRenderer: getHeader,
                width: 160,
                enableRowGroup: true,
                enablePivot: true,
                cellStyle: { 'text-align': 'center' }
            }
        ];

        vm.masterGridOptions = {
            columnDefs: vm.masterColumnDefs,
            enableSorting: true,
            debug: false,
            enableFilter: true,
            enableColResize: true,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowData: null,
            groupHeaders: true,
            headerHeight: 50,
            rowHeight: 45,
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            },
            doesDataFlower: function (dataItem) {
                dataItem.fecha = getDateFormat(dataItem);
                return true;
            },
            isExternalFilterPresent: isExternalFilterPresent,
            doesExternalFilterPass: doesExternalFilterPass
        };

        // Data
        var filter = 'everyone';

        function isExternalFilterPresent() {
            // if ageType is not everyone, then we are filtering
            return filter !== '';
        }

        function doesExternalFilterPass(node) {
            if (filter && filter !== 'everyone') {
                var arrdt = node.data.filter.split(filter);
                return arrdt.length > 1;
            }
            return true;
        }

        vm.masterColumnDefsPurchaseOrder = [
            {
                headerName: '#',
                field: "id",
                width: 50,
                cellStyle: { 'text-align': 'center' }
            },
            {
                headerName: 'ORDER.ORDER',
                field: "orderDescription",
                headerCellRenderer: getHeader,
                width: 150,
                rowGroupIndex: 0,
                hide: true
            },
            {
                headerName: 'REQUISITION.DETAIL.QUANTITY',
                field: "quantityRequired",
                headerCellRenderer: getHeader,
                width: 100,
                enableRowGroup: true,
                cellStyle: { 'text-align': 'center' },
                enablePivot: true
            },
            {
                headerName: 'REQUISITION.DETAIL.PRODUCT',
                field: "productName",
                headerCellRenderer: getHeader,
                width: 250,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'QUOTATION.DETAIL.PRICE',
                field: "price",
                headerCellRenderer: getHeader,
                width: 150,
                enableRowGroup: true,
                enablePivot: true,
                cellStyle: { 'text-align': 'right' },
                valueFormatter: function (params) {
                    return $filter('number')(params.value, 2);
                }
            },
            {
                headerName: 'ORDER.DETAIL.PENDIENTE',
                field: "maxRecibe",
                headerCellRenderer: getHeader,
                width: 150,
                enableRowGroup: true,
                cellStyle: { 'text-align': 'center' },
                enablePivot: true
            },
            {
                headerName: 'ORDER.DETAIL.RECIBIDO',
                field: "pending",
                headerCellRenderer: getHeader,
                width: 150,
                enableRowGroup: true,
                cellStyle: { 'text-align': 'center' },
                enablePivot: true
            }
        ];


        vm.masterGridOptionsPurchaseOrder = {
            columnDefs: vm.masterColumnDefsPurchaseOrder,
            enableSorting: true,
            debug: false,
            enableFilter: true,
            enableColResize: true,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowData: null,
            headerHeight: 50,
            rowHeight: 45,
            groupUseEntireRow: true,
            animateRows: true,
            groupDefaultExpanded: 1,
            doesDataFlower: function (dataItem) {
                dataItem.pending = dataItem.quantityRequired - dataItem.maxRecibe;
                dataItem.orderDescription = "Orden de Compra No." + dataItem.purchaseOrder.id + " {{'CONTRACT.BY_CREATED' | translate}} "
                    + dataItem.purchaseOrder.createdBy + " El " + $filter('date')(getDateFormat(dataItem), 'dd/MM/yyyy');
            },
            isExternalFilterPresent: isExternalFilterPresent,
            doesExternalFilterPass: doesExternalFilterPass,
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            }
        };

        vm.masterColumnDefsInvoice = [
            {
                headerName: 'INVOICE.INVOICE',
                field: "invoiceDescription",
                headerCellRenderer: getHeader,
                width: 150,
                rowGroupIndex: 0,
                hide: true
            },
            {
                headerName: 'INVOICE.PRODUCT.PRODUCT',
                field: "product.name",
                headerCellRenderer: getHeader,
                width: 300,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'INVOICE.DEPARTMENT',
                field: "merchandiseEntry.purchaseOrderDetail.purchaseOrder.department.description",
                headerCellRenderer: getHeader,
                width: 200,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'INVOICE.COST_CENTER',
                field: "merchandiseEntry.purchaseOrderDetail.purchaseOrder.costCenter.description",
                headerCellRenderer: getHeader,
                width: 200,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'INVOICE.INVOICE_PURCHASE.DETAIL.QUANTITY',
                field: "quantity",
                headerCellRenderer: getHeader,
                width: 100,
                enableRowGroup: true,
                enablePivot: true,
                cellStyle: { 'text-align': 'center' }
            },
            {
                headerName: 'INVOICE.INVOICE_PURCHASE.DETAIL.UNIT_PRICE_AFTER_TAX',
                field: "priceAfterTax",
                headerCellRenderer: getHeader,
                width: 100,
                suppressSorting: true,
                suppressMenu: true,
                cellStyle: { 'text-align': 'right' },
                valueFormatter: function (params) {
                    return $filter('number')(params.value, 2);
                }
            },
            {
                headerName: 'INVOICE.INVOICE_PURCHASE.DETAIL.TOTAL_AFTER_TAX',
                field: "subTotalAfterTax",
                headerCellRenderer: getHeader,
                width: 100,
                suppressSorting: true,
                suppressMenu: true,
                cellStyle: { 'text-align': 'right' },
                valueFormatter: function (params) {
                    return $filter('number')(params.value, 2);
                }
            }
        ];


        vm.masterGridOptionsInvoice = {
            columnDefs: vm.masterColumnDefsInvoice,
            enableSorting: true,
            debug: false,
            enableFilter: true,
            enableColResize: true,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowData: null,
            headerHeight: 50,
            rowHeight: 45,
            groupUseEntireRow: true,
            animateRows: true,
            groupDefaultExpanded: 1,
            doesDataFlower: function (dataItem) {
                var resp = ' ';
                var ref = '';
                dataItem.invoicePurchase.files.forEach(function (file, index, arr) {
                    ref = ref + '<a ng-click="vm.viewIMG(' + file.id + ')">Ver Imagen ' + (index + 1) + '</a> ';
                });
                dataItem.invoiceDescription = "Factura SERIE " +
                    (dataItem.invoicePurchase.invoiceSerie ?
                        dataItem.invoicePurchase.invoiceSerie.serie :
                        dataItem.invoicePurchase.uuid.substring(0, 8)) + " Correlativo No. "
                    + dataItem.invoicePurchase.correlative + " {{'CONTRACT.BY_CREATED' | translate}} " + dataItem.invoicePurchase.createdBy
                    + " El " + $filter('date')(getDateFormat(dataItem), 'dd/MM/yyyy') + '' + resp + ref + '';
            },
            isExternalFilterPresent: isExternalFilterPresent,
            doesExternalFilterPass: doesExternalFilterPass,
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            },
            groupRowInnerRenderer: function (params) {
                return params.value;
            }
        };

        vm.contractPurchase = {
            dateDelivery: new Date(),
            companyBuyer: $rootScope.bsCircle.company,
            fixed: true
        };


        vm.newStatus = '';
        // Methods
        //////////

        vm.searchContract = searchContract;


        function searchContract(id) {
            init(id);
        }

        /**
         * Initialize
         */
        function init(id) {
            vm.dinamicSize = $(window).innerHeight();
            var isLocal = id ? true : false;
            id = id ? id : $stateParams.id;
            if (id) {
                $rootScope.loadingProgress = true;
                api.ComprasWS.ContractByNumber.getBy({ idCircle: $rootScope.bsCircle.id, id: id }, function (data) {
                    if (!data.id) {
                        MessageService.showErrorMessage('CONTRACT.NOX_EXIST');
                        $rootScope.loadingProgress = false;
                        return false;
                    }

                    api.ComprasWS.ContractMerchandiseEntryHeader.get({ idCircle: $rootScope.bsCircle.id, id: '', contractId: id }, function (response) {
                        vm.details = response;
                        vm.masterGridOptions.api.setRowData(vm.details);
                    }, function (errResponse) {
                        $log.debug(errResponse);
                    });

                    var ff = data.dateDelivery.split("-");
                    var dateDelivery = new Date(ff[0], (parseInt(ff[1]) - 1), ff[2]);

                    data.dateDelivery = new Date();

                    vm.contractPurchase = data;
                    $timeout(function () {
                        data.dateDelivery = dateDelivery;
                        $rootScope.loadingProgress = false;

                        if (vm.contractPurchase.id) {
                            getPurchaseOrder(vm.contractPurchase.id);
                            getInvoice(vm.contractPurchase.id);
                        }
                        getDimensionCompany();
                    });

                    api.ComprasWS.ContractDetail.getContractPurchase(
                        { idCircle: $rootScope.bsCircle.id, id: 'getByContractPurchase', contractId: vm.contractPurchase.id }, function (detailContract) {
                            vm.detailsContract = new jinqJs()
                                .from(detailContract)
                                .select(function (r) {
                                    var d = r;
                                    d.filter = (d.product.name + "," + d.total + "," + d.taxesIncluded).toLowerCase();
                                    return d;
                                });
                            vm.masterGridOptionsE.api.setRowData(vm.detailsContract);

                        }, function (errResponse) {
                        });
                    if (!isLocal) {
                        vm.currentTab = 0;
                    }

                    vm.showProcessFlow = false;
                    if ($stateParams.onlyView && !$stateParams.isProvider) {
                        vm.showProcessFlow = true;
                        api.ComprasWS.ProcessFlow.get({ id: data.id, type: 5 }, function (data) {
                            vm.infoProcessFlow = data;
                        });
                    }

                });
            } else {
                vm.allowEdit = true;
                vm.editHeader = true;
            }
            return true;
        }

        function getDateFormat(dataItem) {
            if (dataItem.purchaseOrder && dataItem.purchaseOrder.contractPurchase === null) {
                var day = 0;
                var month = 0;
                if (dataItem.createdAt.dayOfMonth < 10) {
                    day = '0' + (dataItem.createdAt.dayOfMonth);
                } else {
                    day = (dataItem.createdAt.dayOfMonth);
                }
                if (dataItem.createdAt.monthValue < 10) {
                    month = '0' + (dataItem.createdAt.monthValue);
                } else {
                    month = dataItem.createdAt.monthValue;
                }
                return new Date(dataItem.createdAt.year + "-" + month + "-" + day);
            } else if (dataItem.purchaseOrder) {
                return dataItem.purchaseOrder.dateDelivery;
            } else {
                if (dataItem.createdAt.dayOfMonth < 10) {
                    day = '0' + (dataItem.createdAt.dayOfMonth);
                } else {
                    day = (dataItem.createdAt.dayOfMonth);
                }
                if (dataItem.createdAt.monthValue < 10) {
                    month = '0' + (dataItem.createdAt.monthValue);
                } else {
                    month = dataItem.createdAt.monthValue;
                }
                return new Date(dataItem.createdAt.year + "-" + month + "-" + day);
            }

        }

        function getPurchaseOrder(id) {
            $rootScope.loadingProgress = true;
            api.ComprasWS.PurchaseByContract.getBy({ idCircle: $rootScope.bsCircle.id, idPurchaseOrder: 1, contractId: id }, function (data) {
                vm.detailsPurchaseOrder = new jinqJs()
                    .from(data)
                    .orderBy([{ field: 'id', sort: 'asc' }])
                    .select(function (r) {
                        r.maxRecibe = angular.copy(r.quantity);
                        r.quantity = 0;
                        return r;
                    });
                $rootScope.loadingProgress = false;
                vm.masterGridOptionsPurchaseOrder.api.setColumnDefs(vm.masterColumnDefsPurchaseOrder);
                vm.masterGridOptionsPurchaseOrder.api.setRowData(vm.detailsPurchaseOrder);
            }, function (data) {
                $log.debug(data);
                $rootScope.loadingProgress = false;
            });
        }

        function getInvoice(id) {
            $rootScope.loadingProgress = true;
            api.ComprasWS.InvoicesPurchasesDetails.byContract.getBy({ idCircle: $rootScope.bsCircle.id, contractId: id }, function (data) {
                vm.detailsInvoice = new jinqJs()
                    .from(data)
                    .orderBy([{ field: 'id', sort: 'asc' }])
                    .select(function (r) {
                        return r;
                    });
                $rootScope.loadingProgress = false;
                vm.masterGridOptionsInvoice.api.setColumnDefs(vm.masterColumnDefsInvoice);
                vm.masterGridOptionsInvoice.api.setRowData(vm.detailsInvoice);
            }, function (data) {
                $log.debug(data);
                $rootScope.loadingProgress = false;
            });
        }

        function viewIMG(id) {
            var invoices = [];
            vm.detailsInvoice.forEach(function (element) {
                var exist = false;
                invoices.forEach(function (verify) {
                    if (element.invoicePurchase.id === verify.id) {
                        exist = true;
                    }
                });
                if (!exist) {
                    invoices.push(element.invoicePurchase);
                }
            });
            invoices.forEach(function (data) {
                data.files.forEach(function (file) {
                    if (id === file.id) {
                        $mdDialog.show({
                            controller: 'DialogPhotoController',
                            controllerAs: 'vm',
                            templateUrl: 'app/main/apps/files/dialogPhoto/dialogPhoto.html',
                            parent: angular.element("#main"),
                            name: file.originalName,
                            url: vm.URLPHOTOS + file.parentPath + file.name + file.extension,
                            clickOutsideToClose: false
                        }).then(function (answer) {

                        });
                    }
                });
            });

        }

        function getDimensionCompany() {
            const NUMBER_DIMENSION_THREE = 3;
            const NUMBER_DIMENSION_FOUR = 4;
            const NUMBER_DIMENSION_FIVE = 5;
            api.GeneralWS.DimensionCompany.byCompany.getList(
                { 'company': vm.contractPurchase.department.company.id }
            ).$promise.then(function (responseDimension) {
                for (let i = 0; i < responseDimension.length; i++) {
                    if (responseDimension[i].dimensionNumber === NUMBER_DIMENSION_THREE) {
                        vm.dimensionCompanyDetail3 = responseDimension[i];
                    } else if (responseDimension[i].dimensionNumber === NUMBER_DIMENSION_FOUR) {
                        vm.dimensionCompanyDetail4 = responseDimension[i];
                    } else if (responseDimension[i].dimensionNumber === NUMBER_DIMENSION_FIVE) {
                        vm.dimensionCompanyDetail5 = responseDimension[i];
                    } else {
                        vm.dimensionCompanyDetail1 = responseDimension[i];
                    }
                }
            });
        }

        function gotoContracts() {
            if ($stateParams.backTo) {
                $state.go($stateParams.backTo, { 'filter': $stateParams.filter });
            } else if ($stateParams.status) {
                $state.go('app.contract.' + $stateParams.status);
            } else {
                $state.go('app.dashboards_project');
            }
        }

    }
})();

(function () {
    'use strict';
    angular
        .module('app.contract')
        .controller('ContractController', ContractController);

    /** @ngInject */
    function ContractController($state, api, $log, $rootScope, $mdDialog, $timeout, $filter, MessageService, $stateParams, $scope, $sce, $templateRequest) {
        var vm = this;
        // Data
        var isNew = true;
        vm.page = 1;
        vm.minDate = new Date();
        vm.toggleCompany = toggleCompany;
        vm.getAllCompanies = getAllCompanies;
        vm.getContractTypes = getContractTypes;
        vm.statusToChange = $stateParams.status;
        vm.composeDialog = composeDialog;
        vm.viewDetail = viewDetail;
        vm.chageStatusButton = getDatasToChange($stateParams.status);
        vm.details = [];
        vm.showButton = true;
        vm.hasBudgetApplication = false;
        var budgetsTemplate = null;

        vm.masterColumnDefs = [];
        vm.productBudget = {};
        vm.requestAmpliationButton = false;

        vm.three_hundred = 300;

        vm.dimensionCompanyDetail3 = null;
        vm.dimensionCompanyDetail4 = null;
        vm.dimensionCompanyDetail5 = null;

        vm.searchDimensionCompanyDetail3 = '';
        vm.searchDimensionCompanyDetail4 = '';
        vm.searchDimensionCompanyDetail5 = '';

        vm.dimensionCompanyDetail3List = [];
        vm.dimensionCompanyDetail4List = [];
        vm.dimensionCompanyDetail5List = [];

        vm.loadingdimensionCompanyDetail3List = false;
        vm.loadingdimensionCompanyDetail4List = false;
        vm.loadingdimensionCompanyDetail5List = false;

        vm.dinamicSize =0;

        vm.masterGridOptions = {
            columnDefs: vm.masterColumnDefs,
            enableSorting: true,
            debug: false,
            enableFilter: true,
            enableColResize: true,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowData: null,
            groupHeaders: true,
            headerHeight: 50,
            rowHeight: 45,
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            },
            doesDataFlower: function (dataItem) {
                return true;
            },
            isExternalFilterPresent: isExternalFilterPresent,
            doesExternalFilterPass: doesExternalFilterPass
        };

        // Data
        var filter = 'everyone';

        function isExternalFilterPresent() {
            // if ageType is not everyone, then we are filtering
            return filter !== '';
        }

        function doesExternalFilterPass(node) {
            if (filter && filter !== 'everyone') {
                var arrdt = node.data.filter.split(filter);
                return arrdt.length > 1;
            }
            return true;
        }

        $scope.$watch('vm.search',
            function (newValue) {
                filter = newValue ? newValue.toLowerCase() : 'everyone';
                if (vm.detailsContract) {
                    vm.masterGridOptions.api.onFilterChanged();
                }
            }
        );

        vm.paginationCompanies = {
            pageNumber: 1,
            pageSize: 100,
            totalElements: 0,
            totalPages: 0,
            numberOfElements: 0,
            nextPage: function () {
                this.pageNumber++;
            },
            beforePage: function () {
                this.pageNumber--;
            },
            firstPage: function () {
                this.pageNumber = 1;
            },
            lastPage: function () {
                this.pageNumber = this.totalPages;
            },
            getPage: function (pageNumber) {
                this.pageNumber = pageNumber;
                getAllCompanies();
            }
        };

        if ($stateParams.status !== 'Creando' && $stateParams.id === '') {
            $state.go('app.contract.' + $stateParams.status);
        }


        vm.contractPurchase = {
            dateDelivery: new Date(),
            companyBuyer: $rootScope.bsCircle.company,
            fixed: true,
            exchangeRate:1
        };

        function initCatalogs() {

            var params = { idc: $rootScope.bsCircle.company.id };

            vm.loadingDepartments = true;
            api.GeneralWS.Department.query(params, function (data) {
                if (data.length === 1) {
                    vm.contractPurchase.department = {
                        id: data[0].id.toString()
                    };
                }
                vm.departments = data;
                vm.loadingDepartments = false;
            });

            vm.loadingCostCenter = true;
            api.GeneralWS.CostCenter.query(params, function (data) {
                if (data.length === 1) {
                    vm.contractPurchase.costCenter = data[0];
                }
                vm.costCenters = data;
                vm.loadingCostCenter = false;
            });

            //carga proyectos
            vm.loadingProjects = true;
            api.ProyectosWS.getAllActive.query({ 'companyId': $rootScope.bsCircle.company.id }, function (data) {
                vm.projects = data;
                vm.loadingProjects = false;
            });
        }

        vm.dtOptions = {
            responsive: true,
            paging: false, searching: false,
            columnDefs: getColumnDefs(true)
        };

        vm.dtOptions2 = {
            responsive: true,
            paging: false, searching: false,
            columnDefs: getColumnDefs(false)
        };
        vm.newStatus = '';
        // Methods
        vm.gotoContracts = gotoContracts;
        vm.openAddDialog = openAddDialog;
        vm.saveHeader = saveHeader;
        //////////

        init();
        /**
         * Initialize
         */
        function init(id, ot) {
          vm.dinamicSize = $(window).innerHeight();
          vm.circleContract={};
            var isLocal = id ? true : false;
            id = id ? id : $stateParams.id;
            if (id) {
                $rootScope.loadingProgress = true;
                api.ComprasWS.Contract.get({ idCircle: $rootScope.bsCircle.id, id: id }, function (data) {
                  validateHasBudgetApplication(data.companyBuyer.id);
                  for (var i = 0; i < $rootScope.circles.length; i++) {
                    if ($rootScope.circles[i].company.id === data.companyBuyer.id) {
                      vm.circleContract = $rootScope.circles[i];
                      break;
                    }
                  }

                    if ($stateParams.status !== data.purchaseStatus.description) {
                        if ($stateParams.status === 'Creando') {
                            $state.go('app.contract.' + $stateParams.status);
                        }
                        vm.statusToChange = null;
                    } else {
                        vm.statusToChange = data.purchaseStatus.description;
                    }

                    vm.searchCompanyInput = data.companyProvider.name;

                    if ($stateParams.status === 'Autorizado' || data.purchaseStatus.orderColumn > 2) {
                        api.ComprasWS.ContractMerchandiseEntryHeader.get(
                            { idCircle: $rootScope.bsCircle.id, id: '', contractId: id }, function (response) {
                                vm.details = response;
                            }, function (errResponse) {
                                $log.debug(errResponse);
                            });
                    }



                    var dateDelivery = new Date(data.dateDelivery);

                    data.dateDelivery = new Date();

                    if(data.projectId != null){
                      getAllProject(data);
                    }
                    vm.contractPurchase = data;
                    $timeout(function () {
                        data.dateDelivery = dateDelivery;
                        $rootScope.loadingProgress = false;
                        if (ot) {
                            $timeout(function () {
                                vm.currentTab = 2;
                            }, 200);
                        }
                    });
                    if (!isLocal) {
                        vm.currentTab = 0;
                    }

                    isNew = false;

                    vm.showProcessFlow = false;
                    if ($stateParams.onlyView && !$stateParams.isProvider) {
                        vm.showProcessFlow = true;
                        api.ComprasWS.ProcessFlow.get({ id: data.id, type: 5 }, function (data) {
                            vm.infoProcessFlow = data;
                        });
                    }

                });
            } else {
                vm.allowEdit = true;
                vm.editHeader = true;
            }
            getDimensionCompany();
        }

        function getDetails() {
            api.ComprasWS.ContractDetail.getContractPurchase(
                { idCircle: $rootScope.bsCircle.id, id: 'getByContractPurchase', contractId: vm.contractPurchase.id },
                function (detailContract) {
                    vm.detailsContract = new jinqJs()
                        .from(detailContract)
                        .select(function (r) {
                            var d = r;
                            d.filter = (d.product.name + "," + d.total + "," + d.taxesIncluded).toLowerCase();
                            return d;
                        });

                    if ($stateParams.status && $stateParams.status !== 'Autorizado') {
                      if ($stateParams.status === 'Ingresado' && vm.budgets && vm.budgets.length > 0) {
                        vm.detailsList = [];
                        vm.detailsContract.forEach(function (i) {
                          for (var j = 0; j < vm.contractPurchase.payments; j++) {
                            var pay = (j + 1);
                            var data = angular.copy(i);
                            data.id_i = (i.id * j);
                            data.payment = pay;
                            vm.detailsList.push(data);
                          }
                        });
                        vm.detailsContract = vm.detailsList;
                      }
                      if (vm.detailsContract.length === 0) {
                        vm.showButton = false;
                      }
                        vm.masterGridOptions.api.setRowData(vm.detailsContract);
                    }

                }, function (errResponse) {
                    $log.debug(errResponse);
                });
        }

        function getAllProject(data) {
          api.ProyectosWS.getAllProject.get({ 'ids': data.projectId }, function (pjr) {
              pjr.forEach(function (res) {
                if (data.projectId === res.id) {
                  data.prjName = res.name;
                }
            });
          });
        }

        /**
         * Save Contract Header
         */
        function saveHeader() {
            vm.showChangeStatusButton = false;
            vm.contractPurchase.purchaseStatus = { description: 'Creando' };

            if (!vm.contractPurchase.fixed) {
                vm.contractPurchase.fixed = false;
            }

            $rootScope.loadingProgress = true;
            var promise;
            if (isNew) {
                promise = api.ComprasWS.Contract.create({ idCircle: $rootScope.bsCircle.id }, vm.contractPurchase).$promise;
            } else {
                promise = api.ComprasWS.Contract.update({ idCircle: $rootScope.bsCircle.id, id: vm.contractPurchase.id }, vm.contractPurchase).$promise;
            }
            promise.then(
                function (data) {
                    $rootScope.loadingProgress = false;
                    data.dateDelivery = new Date(data.dateDelivery);
                    vm.contractPurchase = data;
                    vm.contractPurchaseForm.$setPristine();
                    if (isNew) {
                        if (data.$status === 202) {
                            MessageService.show('CONTRACT.MSG.CONTRACTIFEXIST');
                        }

                        vm.currentTab = 2;
                        isNew = false;
                    }
                    init(data.id, true);
                    vm.currentTab = 2;
                    if (isNew) {
                        MessageService.show('CONTRACT.MSG.CREATED');
                    } else {
                        MessageService.show('CONTRACT.MSG.UPDATED');
                    }
                    vm.currentTab = 2;
                },
                function (data) {
                    var message;
                    if (data.status === 409) {
                        message = 'BUDGETEXIST';
                    } else {
                        message = 'ERROR';
                    }
                    MessageService.showErrorMessage('CONTRACT.MSG.' + message);
                    $rootScope.loadingProgress = false;
                }
            );

        }

        function getColumnDefs(neg) {
            var cols = [
                {
                    targets: 0,
                    width: '72px'
                },
                {
                    targets: 2,
                    responsivePriority: 2,
                    render: function (data, type) {
                        return '<p>' + data + '</p>';
                    }
                },
                {
                    targets: 1,
                    responsivePriority: 3
                },
                {
                    targets: 3,
                    responsivePriority: 4
                }
            ];
            if ($stateParams.status === 'Creando') {
                cols.push({
                    targets: 4,
                    responsivePriority: 1,
                    filterable: false,
                    sortable: false
                });
            }
            return cols;
        }



        /**
         * Go to Contracs page
         */
        function gotoContracts() {
            if ($stateParams.backTo) {
                $state.go($stateParams.backTo, { 'filter': $stateParams.filter });
            } else if ($stateParams.status) {
                $state.go('app.contract.' + $stateParams.status);
            } else {
                $state.go('app.dashboards_project');
            }
        }

        /**
         * Open compose dialog
         *
         * @param ev
         */

        function openAddDialog(ev) {
            if (vm.currentTab > 0) {
                saveHeader();
            }
        }

        function composeDialog(ev, det) {
            var detail = angular.copy(det);

            $mdDialog.show({
                controller: 'DetailContractController',
                controllerAs: 'vm',
                locals: {
                    contractPurchase: vm.contractPurchase,
                    detail: detail
                },
                templateUrl: 'app/main/apps/contract/contract/compose/compose-dialog.html',
                parent: angular.element("#main"),
                targetEvent: ev,
                clickOutsideToClose: false
            }).then(function (answer) {
                getDetails();
            });
        }


        vm.clearSearchDepartment = function () {
            vm.searchDepartment = "";
        };

        vm.clearSearchCostCenter = function () {
            vm.searchCostCenter = "";
        };

        vm.clearSearchContractType = function () {
            vm.searchContractType = "";
        };

        vm.clearSearchProject = function () {
            vm.searchProject = "";
        };

        $timeout(function () {

            var keyEvent = function (event) {
                event.stopPropagation();
            };

            var searchDepartmentInput = document.querySelector("#searchDepartment");
            var searchCostCenterInput = document.querySelector("#searchCostCenter");
            var searchContractTypeInput = document.querySelector("#searchContractType");
            var searchProductInput = document.querySelector("#searchProduct");
            var searchCurrencyInput = document.querySelector("#searchCurrency");
            var searchProjectInput = document.querySelector("#searchProject");

            if (searchDepartmentInput) {
                searchDepartmentInput.addEventListener("keydown", keyEvent);
            }

            if (searchCostCenterInput) {
                searchCostCenterInput.addEventListener("keydown", keyEvent);
            }

            if (searchContractTypeInput) {
                searchContractTypeInput.addEventListener("keydown", keyEvent);
            }
            if (searchProductInput) {
                searchProductInput.addEventListener("keydown", keyEvent);
            }
            if (searchCurrencyInput) {
                searchCurrencyInput.addEventListener("keydown", keyEvent);
            }
            if (searchProjectInput) {
                searchProjectInput.addEventListener("keydown", keyEvent);
            }

        }, 500);

        function getAllCompanies() {
            vm.isShowLoaderCompanies = true;
            api.GeneralWS.getAllCompaniesProviders.page(
                {
                    'pageNumber': vm.paginationCompanies.pageNumber, 'pageSize': vm.paginationCompanies.pageSize,
                    'search': vm.searchCompanyInput, 'companyId': $rootScope.bsCircle.company.id, 'includeMe': false
                }).$promise.then(function (response) {
                    vm.isShowLoaderCompanies = false;
                    vm.companyArray = response.content;
                    vm.paginationCompanies.totalElements = response.totalElements;
                    vm.paginationCompanies.totalPages = response.totalPages;
                    vm.paginationCompanies.numberOfElements = response.numberOfElements;
                }, function (response) {
                    vm.isShowLoaderCompanies = false;
                    $log.error(response);
                });
        }

        function toggleCompany(event, company) {
            vm.contractPurchase.companyProvider = company;
            vm.currentTab = 1;
        }

        function getContractTypes() {
            vm.loading = true;
            api.ComprasWS.ContractType.getAll({},
                function (data) {
                    $filter('orderBy')(data, 'contractypeorder');
                    vm.contractTypes = data;
                    vm.loading = false;
                },
                function (data) {
                    vm.loading = false;
                }
            );
        }

        function getCurrency() {
            api.GeneralWS.Currency.query({}).$promise.then(function (response) {
                vm.currencyArray = response;
                if (response.length === 1) {
                    vm.contractPurchase.currency = response[0];
                }
            }, function (response) {
                $log.error(response);
            });
        }

        vm.presentContract = function () {
          var confirm = $mdDialog.confirm()
            .title($filter('translate')('CONTRACT.MSG.' + vm.statusToChange + '_CONTRACT'))
            .textContent($filter('translate')('CONTRACT.MSG.CONFIRMACION_' + vm.statusToChange + '_CONTRACT'))
            .ok($filter('translate')('CONTRACT.MSG.SI'))
            .cancel($filter('translate')('CONTRACT.MSG.NO'));
          if (vm.requestAmpliationButton) {
            confirm = $mdDialog.confirm()
              .title($filter('translate')('CONTRACT.MSG.REQUEST_AMPLIATION_CONTRACT'))
              .textContent($filter('translate')('CONTRACT.MSG.CONFIRMACION_REQUEST_AMPLIATION_CONTRACT'))
              .ok($filter('translate')('CONTRACT.MSG.SI'))
              .cancel($filter('translate')('CONTRACT.MSG.NO'));
          }
            $mdDialog.show(confirm).then(function () {
                if (vm.chageStatusButton.statusNext === 'Cancelado') {
                    var confirm2 = $mdDialog.confirm()
                        .title($filter('translate')('CONTRACT.CANCELAR'))
                        .textContent($filter('translate')('CONTRACT.MSG.CONFIRMACION_CANCELAll'))
                        .ok($filter('translate')('CONTRACT.MSG.SI_ALL'))
                        .cancel($filter('translate')('CONTRACT.MSG.NO_ALL'));
                    $mdDialog.show(confirm2).then(function () {
                        $rootScope.loadingProgress = true;
                      if (vm.hasBudgetApplication && vm.contractPurchase.fixed) {
                          var maxNoPayment = vm.details.map(function (r) {
                            return r.noPayment;
                          }).reduce(function (prev, curr) {
                            return Math.max(prev, curr);
                          });
                          var productsToValidate = new jinqJs()
                            .from(vm.detailsContract)
                            .select(function(r) {
                              return {
                                id: r.id,
                                product: r.product,
                                amount: (r.total * r.quantity),
                                unitPrice: r.total,
                                currency: r.currency,
                                exchangeRate: r.exchangeRateCompanyBuyer,
                                requestAmpliation: false,
                                references: null
                              };
                            });

                          if (productsToValidate.length <= 0) {
                            MessageService.show("INVOICE.NO_BUDGET_FOR_THIS_PRODUCT");
                            return null;
                          }

                          $rootScope.loadingProgress = true;
                          api.PresupuestosWS.Budget.revertBudgetedProducts
                            .revertBudgeted(
                              { idc: $rootScope.bsCircle.id,
                                'originType': '28',
                                minPaymentFixed: (maxNoPayment-1) },
                              productsToValidate
                            )
                            .$promise.then(
                            function(response) {
                              $rootScope.loadingProgress = false;
                              changeStatusDelete();
                            },
                            function(response) {
                              $rootScope.loadingProgress = false;
                              $log.error(response);
                            }
                          );

                        } else {
                          changeStatusDelete();
                        }

                    }, function () {
                        $rootScope.loadingProgress = true;
                        var promise = api.ComprasWS.ContractChangeStatus.update(
                            {
                                'id': vm.contractPurchase.id,
                                'idCircle': $rootScope.bsCircle.id, status: vm.chageStatusButton.statusNext, 'deleteAll': false
                            }).$promise;
                        promise.then(function (responseStatus) {
                            vm.contractPurchase = responseStatus;

                            MessageService.show(responseStatus.purchaseStatus.description);
                            gotoContracts();
                        }, function (response) {
                            $rootScope.loadingProgress = false;
                            var msg = 'ERROR';
                            if (response.data === 'No Detail') {
                                msg = 'DETAIL';
                            }

                            MessageService.showErrorMessage('REQUISITION.MSG.' + msg);
                        });
                    });
                } else {
                  if (vm.chageStatusButton.statusNext === 'Autorizado' && vm.hasBudgetApplication && vm.showButton && vm.contractPurchase.fixed) {
                    vm.productsToValidate = [];
                    vm.detailsContract.forEach(function (data){
                      var productToValidate = {
                        id: data.id,
                        product: data.product,
                        amount: data.requestAmpliation ?
                          (((data.subTotalCompanyBuyer * data.quantity) - data.totalCovered) / data.references[data.references.length - 1].budgetExchangeRateOfficial) :
                          (data.subTotalCompanyBuyer * data.quantity),
                        referenceAmpliationId: data.references[data.references.length - 1].referenceId,
                        unitPrice: 0,
                        currency: data.currencyCompanyBuyer,
                        exchangeRate: data.exchangeRateCompanyBuyer,
                        requestAmpliation: data.requestAmpliation,
                        references: data.references,
                        referenceHeaderId: data.contractPurchase.id,
                        noPayments: data.payment
                      };

                      vm.productsToValidate.push(productToValidate);
                    });
                    $rootScope.loadingProgress = true;
                    vm.requestAmpliation=false;
                    for (var i = 0; i < vm.productsToValidate.length; i++) {
                      if (vm.productsToValidate[i].requestAmpliation) {
                        vm.requestAmpliation = true;
                        break;
                      }
                    }
                    if (vm.requestAmpliation) {
                      var productAmpliation = new jinqJs()
                        .from(vm.productsToValidate)
                        .where(function (r) {
                          return r.requestAmpliation;
                        })
                        .select();
                      vm.productsToValidate = productAmpliation;
                    }
                    if (vm.productsToValidate.length > 0) {
                      api.PresupuestosWS.Budget.validatesBudgetedProductsContract.validate(
                        { 'idc': vm.circleContract.id }, { quotations: vm.productsToValidate }).$promise.then(function (response) {
                        $rootScope.loadingProgress = false;
                        vm.productsToValidate = response;
                        vm.requestAmpliation = false;
                        for (var i = 0; i < vm.productsToValidate.length; i++) {
                          if (vm.productsToValidate[i].requestAmpliation) {
                            vm.requestAmpliation = true;
                            break;
                          }
                        }
                        if (!vm.requestAmpliation) {
                          changeStatusContractPurchase();
                        } else {
                          MessageService.show('CONTRACT.REQUEST_AMPLIATION');
                          gotoContracts();
                        }

                      }, function (response) {
                        $rootScope.loadingProgress = false;
                        $log.error(response);
                      });
                    }
                  } else {
                    $rootScope.loadingProgress = true;
                    var promise = api.ComprasWS.ContractChangeStatus.update(
                      {
                        'id': vm.contractPurchase.id,
                        'idCircle': $rootScope.bsCircle.id, status: vm.chageStatusButton.statusNext, 'deleteAll': false
                      }).$promise;
                    promise.then(function (responseUp) {
                      vm.contractPurchase = responseUp;

                      MessageService.show(responseUp.purchaseStatus.description);
                      gotoContracts();
                    }, function (responseErr) {
                      $rootScope.loadingProgress = false;
                      var msg = 'ERROR';
                      if (responseErr.data === 'No Detail') {
                        msg = 'DETAIL';
                      }

                      MessageService.showErrorMessage('REQUISITION.MSG.' + msg);
                    });
                  }
                }

            }, function () {
            });
        };

        function getDatasToChange(status) {
            var ret = { desc: 'CONTRACT.STATUSCHANGE.' + status };
            switch (status) {
                case 'Creando':
                    ret.icon = 'icon-content-paste';
                    ret.statusNext = 'Ingresado';
                    break;
                case 'Ingresado':
                    ret.icon = 'icon-key-variant';
                    ret.statusNext = 'Autorizado';
                    break;
                case 'Autorizado':
                    ret.icon = 'icon-cancel';
                    ret.statusNext = 'Cancelado';
                    break;
            }
            return ret;
        }

        $timeout(function () {

            if (!$stateParams.onlyView) {
                initCatalogs();
                getContractTypes();
                getAllCompanies();
                getCurrency();
            }

        }, 1000);

        function renderer(params) {

            if ($stateParams.status !== 'Autorizado') {
                var toRet = '<div style="width: 100%;">';

                toRet = toRet + '<md-button class="edit-button md-icon-button" ng-click="vm.editContractDetail(data)" aria-label="Order details"'
                    + ' translate translate-attr-aria-label="CONTRACT.ORDER_DETAILS">'
                    + ' <md-tooltip md-direction="bottom">'
                    + ' {{"CONTRACT.DETAIL.EDIT"| translate}}'
                    + ' </md-tooltip>'
                    + ' <md-icon md-font-icon="icon-border-color" class="s16"></md-icon> '
                    + ' </md-button>';

                toRet = toRet + '<md-button class="edit-button md-icon-button" ng-click="vm.deleteContractDetail($event, data.id,'
                    + params.rowIndex + ')" aria-label="Compare"'
                    + ' translate translate-attr-aria-label="CONTRACT.COMPARE">'
                    + ' <md-tooltip md-direction="bottom">'
                    + ' {{"CONTRACT.DELETE"| translate}}'
                    + ' </md-tooltip>'
                    + '       <md-icon md-font-icon="icon-minus-circle" class="s16 md-warn"></md-icon> '
                    + ' </md-button>';

                return toRet + '</div>';
            }
            return '';
        }

        vm.editContractDetail = function (data) {
            composeDialog(null, data);
        };

        vm.deleteContractDetail = function (ev, id, index) {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('CONTRACT.DELETE'))
                .textContent($filter('translate')('CONTRACT.MSG.SURE_DELETE'))
                .ok($filter('translate')('CONTRACT.MSG.SI'))
                .cancel($filter('translate')('CONTRACT.MSG.NO'));
            $mdDialog.show(confirm).then(function () {
                $rootScope.loadingProgress = true;
                if($stateParams.status==='Ingresado' && vm.hasBudgetApplication && vm.budgets.length>0){
                  var promise = api.ComprasWS.ContractDeleteNoPayment.delete({
                    idCircle: $rootScope.bsCircle.id,
                    id: vm.contractPurchase.id
                  }).$promise;
                  promise.then(
                    function (data) {
                      if (data) {
                        vm.contractPurchase.payments=data.payments;
                        vm.masterGridOptions.api.setRowData([]);
                        $timeout(function (){
                          getBudgets();
                        },vm.three_hundred);

                      }
                      $rootScope.loadingProgress = false;
                      vm.detailsContract.splice(index, 1);
                    },
                    function (errResp) {
                      var message;
                      if (errResp.status === 409) {
                        message = 'BUDGETEXIST';
                      } else {
                        message = 'ERROR';
                      }
                      MessageService.showErrorMessage('CONTRACT.MSG.' + message);
                      $rootScope.loadingProgress = false;
                    }
                  );
                }else {
                  var promiseDelete = api.ComprasWS.ContractDetail.delete({
                    idCircle: $rootScope.bsCircle.id,
                    id: id
                  }).$promise;
                  promiseDelete.then(
                    function (data) {
                      if (data) {
                        getDetails();
                      }
                      $rootScope.loadingProgress = false;
                      vm.detailsContract.splice(index, 1);
                    },
                    function (errResp) {
                      var message;
                      if (errResp.status === 409) {
                        message = 'BUDGETEXIST';
                      } else {
                        message = 'ERROR';
                      }
                      MessageService.showErrorMessage('CONTRACT.MSG.' + message);
                      $rootScope.loadingProgress = false;
                    }
                  );
                }
            }, function (data) {

            });
        };

        function viewDetail(ev) {

            $mdDialog.show({
                controller: 'DetailProductsContractController',
                controllerAs: 'vm',
                locals: {
                    contractPurchase: vm.contractPurchase
                },
                templateUrl: 'app/main/apps/contract/contract/detail/detail.html',
                parent: angular.element("#main"),
                targetEvent: ev,
                clickOutsideToClose: false
            }).then(function (answer) {
                getDetails();
            });
        }

      function validateHasBudgetApplication(companyId) {
        api.GeneralWS.CompanyApplication.byAppName.get({ 'company': companyId, 'app': 'Presupuestos' }).$promise.then(function (responseParameter) {
          if (responseParameter.$status === 200) {
            if (responseParameter.$data && responseParameter.$data !== '') {
              vm.hasBudgetApplication = responseParameter.$data.active;
              api.GeneralWS.CompanyParameterByName.get(
                {
                  id: $rootScope.bsCircle.company.id,
                  parameter: 'REQUEST_A_BUDGET_IN_CONTRACTS'
                }, function (responseParameterRequestBudget) {
                  if (responseParameterRequestBudget) {
                    vm.hasBudgetApplication = responseParameterRequestBudget.parameterValue === 'true';
                    verifyBudgetCompanyAndParameterApplication();
                  } else {
                    verifyBudgetCompanyAndParameterApplication();
                  }
                }, function (errParameterRequestBudget) {
                  $log.error(errParameterRequestBudget);
                });
            } else {
              setColumnsToGrid();
              getDetails();
            }
          } else {
            getDetails();
          }
        }, function (response) {
          $log.error(response);
          vm.showButton = false;
        });
      }

      function verifyBudgetCompanyAndParameterApplication(){
        if (vm.hasBudgetApplication && vm.contractPurchase.fixed && $stateParams.status === 'Ingresado') {
          vm.showButton = false;
          $timeout(function (){
            getBudgets();
          },vm.three_hundred);
        } else {
          setColumnsToGrid();
          getDetails();
        }
      }

      function setColumnsToGrid() {
        var columns = [
          {
            headerName: '#',
            field: "id",
            width: 50,
            cellStyle: { 'text-align': 'center' },
            sort: 'asc'
          },
          {
            headerName: 'CONTRACT.QUANTITY',
            field: "quantity",
            headerCellRenderer: getHeader,
            width: 100,
            enableRowGroup: true,
            enablePivot: true,
            cellStyle: { 'text-align': 'center' },
            valueFormatter: function (params) {
              return $filter('number')(params.value, '0');
            }
          },
          {
            headerName: 'CONTRACT.PRODUCT',
            field: "product.name",
            headerCellRenderer: getHeader,
            width: 350,
            enableRowGroup: true,
            enablePivot: true
          },
          {
            headerName: 'CONTRACT.UNIT_PRICE',
            field: "total",
            headerCellRenderer: getHeader,
            width: 200,
            enableRowGroup: true,
            enablePivot: true,
            cellStyle: { 'text-align': 'right' },
            valueFormatter: function (params) {
              return $filter('number')(params.value, '2');
            }
          },
          {
            headerName: 'CONTRACT.TOTAL',
            field: "total",
            headerCellRenderer: getHeader,
            width: 200,
            enableRowGroup: true,
            enablePivot: true,
            cellStyle: { 'text-align': 'right' },
            cellRenderer: function (params) {
              return $filter('number')((params.value*params.data.quantity), '2');
            }
          },
          {
            headerName: 'CONTRACT.TAXESINCLUDED',
            field: "taxesIncluded",
            headerCellRenderer: getHeader,
            width: 200,
            enableRowGroup: true,
            enablePivot: true,
            cellStyle: { 'text-align': 'center' },
            cellRenderer: function (params) {
              if (params.data.taxesIncluded) {
                return '<md-icon md-font-icon="icon-check" class="s16"></md-icon>';
              } else {
                return '<md-icon md-font-icon="icon-close-circle" class="s16"></md-icon>';
              }
            }
          },
          {
            headerName: 'CONTRACT.ACTIONS',
            name: "actions",
            headerCellRenderer: getHeader,
            suppressSorting: true,
            suppressMenu: true,
            width: 150,
            cellRenderer: renderer,
            cellStyle: { 'padding': '0px' },
            pinned: 'right'
          }
        ];

        if (vm.hasBudgetApplication && $stateParams.status === 'Ingresado' && vm.contractPurchase.fixed) {
          columns.splice(4,0,{
            headerName: $filter('translate')('CONTRACT.PAYMENT'),
            name: "payment",
            field: "payment",
            headerCellRenderer: getHeader,
            suppressSorting: true,
            suppressMenu: true,
            width: 200});

          columns.splice(5,0,{
            headerName: $filter('translate')('CONTRACT.SELECT_BUDGETS'),
            name: "budgets",
            headerCellRenderer: getHeader,
            suppressSorting: true,
            suppressMenu: true,
            width: 400,
            pinned: 'right',
            cellRenderer: function (params) {
              var products = getBudgetsByProduct(params.data.product.id);
              vm.productBudget[params.data.product.id] = products;
              params.$scope.isSelected = isSelected;
              params.$scope.toggleSelectBudget = toggleSelectBudget;
              params.$scope.validateRequestAmpliation = validateRequestAmpliation;
              params.data.needExtension = false;

              if (!params.data.totalCovered) {
                params.data.totalCovered = 0;
              }

              params.data.requestAmpliation = false;

              if (products.length === 1) {

                $timeout(function () {
                  if (products[0].available >= (parseFloat(params.data.total) * parseFloat(params.data.quantity))) {
                    params.$scope.toggleSelectBudget(products[0], null, true);
                  }
                }, 2000);
              }

              return budgetsTemplate;
            }
          });
        }

        if (vm.masterGridOptions.api) {
          vm.masterGridOptions.api.setColumnDefs(columns);
        }
      }

      function getBudgets() {
        vm.isShowLoaderBudgets = true;
        api.PresupuestosWS.Budget.findApprovedAndAuthorizeOfBeforeAndCurrentAndAfterMonth.query(
          {
            'idc': vm.circleContract.id, 'costCenterId': vm.contractPurchase.costCenter.id,
            'departmentId': vm.contractPurchase.department.id,
            'dimensionCompanyDetail3Id': getDimensionCompanyDetailContract(vm.contractPurchase.dimensionCompanyDetail3),
            'dimensionCompanyDetail4Id': getDimensionCompanyDetailContract(vm.contractPurchase.dimensionCompanyDetail4),
            'dimensionCompanyDetail5Id': getDimensionCompanyDetailContract(vm.contractPurchase.dimensionCompanyDetail5)
          }).$promise.then(function (response) {
          vm.isShowLoaderBudgets = false;
          vm.budgets = response;
          if (vm.budgets && vm.contractPurchase.fixed) {
            vm.showButton = false;
          }
          getDetails();
          setColumnsToGrid();
        }, function (response) {
          vm.isShowLoaderBudgets = false;
          $log.error(response);
        });
      }

      function getBudgetsByProduct(productId) {

        if (vm.productBudget[productId] !== undefined && vm.productBudget[productId] !== null) {
          return vm.productBudget[productId];
        }

        var result = [];

        if (vm.budgets) {
          vm.budgets.forEach(function (row) {

            if (row.product.id === productId) {
              row.available = (row.amountOfficial - (row.amountExecuted ? row.amountExecuted : 0) - (row.amountReserved ? row.amountReserved : 0) - (row.amountNotExecuted ? row.amountNotExecuted : 0)).toFixed(2);
              result.push(row);
            }

          });
        }

        return result;

      }

      function isSelected(budgetDetail) {

        var scopeParent = this.$parent.$parent;

        if (scopeParent.data.references === undefined || scopeParent.data.references === null) {
          scopeParent.data.references = [];
        }

        for (var i = 0; i < scopeParent.data.references.length; i++) {
          if (scopeParent.data.references[i].budgetDetailId === budgetDetail.id) {
            return true;
          }
        }

        return false;
      }

      function toggleSelectBudget(budgetDetail, event, fromParent) {

        var scopeParent;


        if (fromParent) {
          scopeParent = this;
        } else {
          scopeParent = this.$parent;
        }

        scopeParent.data.needExtension = false;
        vm.currentDetail = scopeParent.data;
        if (scopeParent.data.references === undefined || scopeParent.data.references === null || fromParent) {
          scopeParent.data.references = [];
        }

        if (event) {
          event.stopPropagation();
        }

        var selected = false;

        for (var i = 0; i < scopeParent.data.references.length; i++) {
          if (scopeParent.data.references[i].budgetDetailId === budgetDetail.id) {
            scopeParent.data.totalCovered -= scopeParent.data.references[i].amountToUse;
            calculateAvailable(scopeParent.data.references[i].budgetDetailId,
              scopeParent.data.references[i].amountToUse, vm.productBudget[scopeParent.data.product.id]);
            scopeParent.data.references.splice(i, 1);
            selected = true;
            break;
          }
        }

        if (!selected) {
          scopeParent.data.needExtension = (parseFloat(scopeParent.data.total) * parseFloat(scopeParent.data.quantity)) > budgetDetail.available;

          var reference = {
            referenceId: budgetDetail.id,
            budgetId: budgetDetail.budget.id,
            budgetDetailId: budgetDetail.id,
            amountToUse: (parseFloat(scopeParent.data.total) * parseFloat(scopeParent.data.quantity)) > parseFloat(budgetDetail.available) ?
              parseFloat(budgetDetail.available) :
              (parseFloat(scopeParent.data.total) * parseFloat(scopeParent.data.quantity)),
            budgetStartDate: budgetDetail.budget.startDate,
            budgetEndDate: budgetDetail.budget.endDate,
            currencyCode: budgetDetail.currencyOfficial.code,
            budgetType: budgetDetail.budget.budgetType.description,
            budgetExchangeRateOfficial: budgetDetail.exchangeRateOfficial
          };

          scopeParent.data.references.push(reference);
          scopeParent.data.totalCovered += reference.amountToUse;
          calculateAvailable(budgetDetail.id, reference.amountToUse * -1, vm.productBudget[scopeParent.data.product.id]);
        }
        $timeout(function(){
          verifiActiveButtonAuthorize();
        },200);
      }

      function calculateAvailable(budgetDetailId, amountToAdd, budgetDetailArray) {

        budgetDetailArray.forEach(function (budgetDetail) {
          if (budgetDetailId === budgetDetail.id) {
            budgetDetail.available = parseFloat(budgetDetail.available) + parseFloat(amountToAdd);
          }
        });

      }

      function verifiActiveButtonAuthorize() {
        var verifiAllItems = true;
        for (var r = 0; r < vm.detailsContract.length; r++) {
          if (!vm.detailsContract[r].references || vm.detailsContract[r].references.length === 0) {
            verifiAllItems = false;
            break;
          }else if(vm.detailsContract[r].references.length>0){
            for(var j=0; j<vm.detailsContract[r].references.length; j++){
              if(vm.detailsContract[r].references[j].amountToUse < (vm.detailsContract[r].total) && !vm.detailsContract[r].requestAmpliation){
                verifiAllItems = false;
              }
              if(vm.detailsContract[r].references[j].amountToUse < (vm.detailsContract[r].total) && vm.detailsContract[r].requestAmpliation){
                vm.requestAmpliationButton = true;
              }
            }
          }
        }
        vm.showButton = verifiAllItems;
      }

      function changeStatusContractPurchase() {
        $rootScope.loadingProgress = true;
        var promise = api.ComprasWS.ContractChangeStatusAuthorize.update(
          {
            'id': vm.contractPurchase.id,
            'idCircle': $rootScope.bsCircle.id,
            'status': vm.chageStatusButton.statusNext
          }, {'quotations': vm.productsToValidate}).$promise;
        promise.then(function (responseUp) {
          vm.contractPurchase = responseUp;

          MessageService.show(responseUp.purchaseStatus.description);
          gotoContracts();
        }, function (responseErr) {
          $rootScope.loadingProgress = false;
          var msg = 'ERROR';
          if (responseErr.data === 'No Detail') {
            msg = 'DETAIL';
          }

          MessageService.showErrorMessage('REQUISITION.MSG.' + msg);
        });
      }

      function getBudgetsTemplate() {
        var resource = $sce.getTrustedResourceUrl('app/main/apps/contract/contract/budgetsTemplate.html');

        $templateRequest(resource).then(function (template) {
          budgetsTemplate = template;
        }, function () {
          $log.error("Ocurrio un error al leer el template");
        });

      }

      getBudgetsTemplate();

      function validateRequestAmpliation(event, scope) {
        $timeout(function(){
          verifiActiveButtonAuthorize();
        },200);
      }

      function changeStatusDelete(){
        var promise = api.ComprasWS.ContractChangeStatus.update(
          {
            'id': vm.contractPurchase.id,
            'idCircle': $rootScope.bsCircle.id, status: vm.chageStatusButton.statusNext, 'deleteAll': true
          }).$promise;
        promise.then(function (response) {
          vm.contractPurchase = response;

          MessageService.show(response.purchaseStatus.description);
          gotoContracts();
        }, function (response) {
          $rootScope.loadingProgress = false;
          var msg = 'ERROR';
          if (response.data === 'No Detail') {
            msg = 'DETAIL';
          }

          MessageService.showErrorMessage('REQUISITION.MSG.' + msg);
        });
      }

      function getDimensionCompany() {
        api.GeneralWS.Usr.User.basicUserInformation.get().$promise.then(function (user) {
          api.UserWS.UserDimension.ByUser.get({'userId': user.userId}).$promise.then(function (userList) {
            vm.userDimensionCompanyDetails = userList;
            vm.loadingdimensionCompanyDetail3List = true;
            vm.loadingdimensionCompanyDetail4List = true;
            vm.loadingdimensionCompanyDetail5List = true;
            const NUMBER_DIMENSION_THREE = 3;
            const NUMBER_DIMENSION_FOUR = 4;
            const NUMBER_DIMENSION_FIVE = 5;
            api.GeneralWS.DimensionCompany.byCompany.getList(
              {'company': $rootScope.bsCircle.company.id}
            ).$promise.then(function (responseDimension) {
              for (let i = 0; i < responseDimension.length; i++) {
                if (responseDimension[i].dimensionNumber === NUMBER_DIMENSION_THREE) {
                  vm.dimensionCompanyDetail3 = responseDimension[i];
                  getDimensionCompanyDetail(responseDimension[i].id, responseDimension[i].dimensionNumber);
                } else if (responseDimension[i].dimensionNumber === NUMBER_DIMENSION_FOUR) {
                  vm.dimensionCompanyDetail4 = responseDimension[i];
                  getDimensionCompanyDetail(responseDimension[i].id, responseDimension[i].dimensionNumber);
                } else if (responseDimension[i].dimensionNumber === NUMBER_DIMENSION_FIVE) {
                  vm.dimensionCompanyDetail5 = responseDimension[i];
                  getDimensionCompanyDetail(responseDimension[i].id, responseDimension[i].dimensionNumber);
                } else {
                  vm.dimensionCompanyDetail1 = responseDimension[i];
                }
              }
            }, function (err) {
              if (err) {
                vm.loadingdimensionCompanyDetail3List = false;
                vm.loadingdimensionCompanyDetail4List = false;
                vm.loadingdimensionCompanyDetail5List = false;
              }
            });
          }, function (errorUser) {
            $log.debug(errorUser);
          });
        }, function (err) {
          $log.debug(err);
        });
      }

      function getDimensionCompanyDetail(id, number) {
        const NUMBER_THREE = 3;
        const NUMBER_FOUR = 4;
        const NUMBER_FIVE = 5;
        api.GeneralWS.DimensionCompanyDetail.byDimensionCompany.getList(
          {'dimensionCompanyId': id}
        ).$promise.then(function (responseDimension) {
          const arrIds = vm.userDimensionCompanyDetails.map(function (row) {
            return row.dimensionCompanyDetailId;
          });
          if (number === NUMBER_THREE) {
            vm.dimensionCompanyDetail3List = responseDimension.filter(function (item) {
              return arrIds.includes(item.id);
            });
            vm.loadingdimensionCompanyDetail3List = false;
          } else if (number === NUMBER_FOUR) {
            vm.dimensionCompanyDetail4List = responseDimension.filter(function (item) {
              return arrIds.includes(item.id);
            });
            vm.loadingdimensionCompanyDetail4List = false;
          } else if (number === NUMBER_FIVE) {
            vm.dimensionCompanyDetail5List = responseDimension.filter(function (item) {
              return arrIds.includes(item.id);
            });
            vm.loadingdimensionCompanyDetail5List = false;
          } else {
            vm.loadingdimensionCompanyDetail1List = false;
          }
        }, function () {
          vm.loadingdimensionCompanyDetail3List = false;
          vm.loadingdimensionCompanyDetail4List = false;
          vm.loadingdimensionCompanyDetail5List = false;
        });
      }

      function getDimensionCompanyDetailContract(dimensionCompanyDetail) {
        if (dimensionCompanyDetail) {
          return dimensionCompanyDetail.id;
        } else {
          return 0;
        }
      }

    }

})();

(function () {
    'use strict';

    angular
        .module('app.configuration')
        .controller('settlementRejectionReasonController', settlementRejectionReasonController);

    /** @ngInject */
    function settlementRejectionReasonController(api, $rootScope, $log, $mdDialog, $filter, $mdToast) {

        var vm = this;
        // Methods


        // Methods
        vm.currentThread = null;
        vm.createRejectionReason = createRejectionReason;
        vm.deleteRejectionReason = deleteRejectionReason;
        init();

        //////////

        function init() {

            api.ComprasWS.allRejectionReason.query({ idCircle: $rootScope.bsCircle.id }, function (data) {
                vm.allowRoleAccess = true;
                vm.allrejectionReason = data;
                $log.debug(data);

                vm.masterGridOptions.api.setColumnDefs(vm.masterColumnDefs);
                vm.masterGridOptions.api.setRowData(data);

                vm.loading = false;
            }, function (response) {
                vm.loading = false;
                // Error
                vm.allowRoleAccess = false;
                $log.error(response);

            });
        }

        vm.masterColumnDefs = [
            {
                headerName: 'REJECTIONREASON.REJECTIONREASONID',
                field: "id",
                headerCellRenderer: getHeader,
                width: 200,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'REJECTIONREASON.NAME',
                field: "name",
                headerCellRenderer: getHeader,
                width: 250,
                enableRowGroup: true,
                enablePivot: true
            },

            {
                headerName: 'REJECTIONREASON.DEFINITIVE',
                field: "isDefinitive",
                headerCellRenderer: getHeader,
                width: 150,
                cellRenderer: function (params) {
                    if (params.value) {
                        return '<div style="width: 100%;" layout="row" layout-align="center center"><i class="icon-checkbox-marked-circle green-500-fg"></i></div>';
                    }
                    return '<div style="width: 100%;" layout="row" layout-align="center center"><i class="icon-cancel red-500-fg"></i></div>';
                }
            },
            {
                headerName: 'REJECTIONREASON.REJECTIONREASONTYPE',
                field: "rejectionReasonType",
                headerCellRenderer: getHeader,
                width: 150,
                enableRowGroup: true,
                enablePivot: true

            },
            {
                headerName: 'REJECTIONREASON.OPTIONS',
                name: "actions",
                headerCellRenderer: getHeader,
                suppressSorting: true,
                suppressMenu: true,
                width: 200,
                cellRenderer: function renderer(params) {
                    return '<div style="width: 100%;"> '
                        + ' <md-button class="edit-button md-icon-button" ng-disabled="" ng-click="vm.createRejectionReason($index, data.id, data)" aria-label="rejectionReason"'
                        + ' translate translate-attr-aria-label="REJECTIONREASON.EDIT">'
                        + ' <md-tooltip md-direction="bottom">'
                        + ' {{"REJECTIONREASON.EDIT"| translate}}'
                        + '    </md-tooltip>'
                        + ' <md-icon md-font-icon="icon-pencil" class="s16"></md-icon> '
                        + ' </md-button>'
                        + ' <md-button class="edit-button md-icon-button" ng-disabled="" ng-click="vm.deleteRejectionReason($event, data.id, data)" aria-label="pettyCash"'
                        + ' translate translate-attr-aria-label="REJECTIONREASON.DELETE">'
                        + ' <md-tooltip md-direction="bottom">'
                        + ' {{"REJECTIONREASON.DELETE"| translate}}'
                        + ' </md-tooltip>'
                        + ' <md-icon md-font-icon="icon-delete" class="s16"></md-icon> '
                        + ' </md-button>'
                        + ' </div>';
                },
                cellStyle: { 'padding': '0px' }
            }
        ];

        vm.masterGridOptions = {
            columnDefs: vm.masterColumnDefs,
            enableSorting: true,
            debug: false,
            enableFilter: true,
            enableColResize: true,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowData: null,
            groupHeaders: true,
            headerHeight: 64,
            rowHeight: 64,
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            },
            doesDataFlower: function (dataItem) {
                return true;
            },
            isExternalFilterPresent: isExternalFilterPresent,
            doesExternalFilterPass: doesExternalFilterPass
        };

        var filter = 'everyone';

        function isExternalFilterPresent() {
            return filter !== '';
        }

        function doesExternalFilterPass(node) {
            if (filter && filter !== 'everyone') {
                var arrdt = node.data.filter.split(filter);
                return arrdt.length > 1;
            }
            return true;
        }

        function createRejectionReason(i, data, rejectionReason) {
            var detail = angular.copy(data);
            $mdDialog.show({
                controller: 'rejectionReasonEditController',
                controllerAs: 'vm',
                locals: {
                    data: detail,
                    rejectionReason: rejectionReason
                },
                templateUrl: 'app/main/apps/configuration/rejectionReason/rejectionReasonEdit/rejectionReasonEdit.html',
                parent: angular.element("#main"),
                clickOutsideToClose: false
            }).then(function (answer) {
                init();

                $rootScope.loadingProgress = false;
            }, function () {
                $rootScope.loadingProgress = false;
            });
        }

        function deleteRejectionReason(e, id, data) {

            var i = vm.allrejectionReason.indexOf(data);

            var confirm = $mdDialog.confirm()
                .title($filter('translate')('REJECTIONREASON.MSGTXTDELETE'))
                .htmlContent($filter('translate')('REJECTIONREASON.MSGDELETE'))
                .ariaLabel('Delete Detail')
                .ok($filter('translate')('REJECTIONREASON.DELETE'))
                .cancel($filter('translate')('REJECTIONREASON.CANCEL'));

            $mdDialog.show(confirm).then(function () {
                $rootScope.loadingProgress = true;
                api.ComprasWS.allRejectionReason.delete({ circleId: $rootScope.bsCircle.id, id: id }, function (response) {// Success
                    vm.allrejectionReason.splice(i, 1);
                    vm.masterGridOptions.api.setRowData(vm.allrejectionReason);
                    showMessage($filter('translate')('REJECTIONREASON.MSGDELETESUCCESSFULL'));
                    $rootScope.loadingProgress = false;
                }, function (response) {// Error
                    $log.debug(response);
                    $rootScope.loadingProgress = false;
                    if (response.data === "can not deleted") {
                        showErrorMessage($filter('translate')('REJECTIONREASON.MSGDELETEERROR'));
                    }
                });

            }, function () {
            });
        }


        function showMessage(message) {
            $rootScope.loadingProgress = false;
            $mdToast.show({
                template: '<md-toast layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
                hideDelay: 3000,
                position: 'top right'
            });
        }
        function showErrorMessage(message) {
            $rootScope.loadingProgress = false;
            $mdToast.show({
                template: '<md-toast layout="column" layout-align="center start"><div class="md-toast-content" style="background-color: red">' + message + '</div></md-toast>',
                hideDelay: 5000,
                position: 'top right'
            });
        }
    }


})();

(function () {
    'use strict';

    angular
        .module('app.configuration')
        .controller('purchaseProductDeliveryController', purchaseProductDeliveryController);

    /** @ngInject */
    function purchaseProductDeliveryController(api, $rootScope, $log, $mdDialog, $filter, $mdToast) {

        var vm = this;

        vm.currentThread = null;
        vm.createPurchaseProductDelivery = createPurchaseProductDelivery;
        vm.deletePurchaseProductDelivery = deletePurchaseProductDelivery;
        init();

        //////////

        function init() {
            $rootScope.loadingProgress = true;
            api.ComprasWS.PurchaseProductDelivery.PurchaseProductDelivery.query({ company: $rootScope.bsCircle.company.id }, function (data) {
                vm.allowRoleAccess = true;
                $log.debug(data);

                vm.masterGridOptions.api.setColumnDefs(vm.masterColumnDefs);
                vm.masterGridOptions.api.setRowData(new jinqJs()
                    .from(data)
                    .orderBy([{ field: 'id', sort: 'asc' }])
                    .select());

                vm.loading = false;
                $rootScope.loadingProgress = false;
            }, function (response) {
                vm.loading = false;
                // Error
                vm.allowRoleAccess = false;
                $log.error(response);
            });
        }

        vm.masterColumnDefs = [
            {
                headerName: 'REJECTIONREASON.REJECTIONREASONID',
                field: "id",
                headerCellRenderer: getHeader,
                width: 60,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'PURCHASEPRODUCTDELIVERY.DEPARTMENT',
                field: "department.description",
                headerCellRenderer: getHeader,
                width: 250,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'PURCHASEPRODUCTDELIVERY.COSTCENTER',
                field: "costCenter.description",
                headerCellRenderer: getHeader,
                width: 150,
                enableRowGroup: true,
                enablePivot: true

            },
            {
                headerName: 'PURCHASEPRODUCTDELIVERY.PRODUCT',
                name: "product.name",
                headerCellRenderer: getHeader,
                width: 150,
                enableRowGroup: true,
                enablePivot: true,
                cellRenderer: function renderer(params) {
                    return '<div style="width: 100%;">' +
                        '<div ng-if="data.product">{{data.product.name}}</div> ' +
                        '<div ng-if="!data.product">{{\'PURCHASEPRODUCTDELIVERY.ALL_PRODUCTS_ASOCIATED\' | translate}}</div> ' +
                        '</div>';
                }

            },
            {
                headerName: 'PURCHASEPRODUCTDELIVERY.DEPARTMENTDELIVERY',
                field: "departmentToDelivery.description",
                headerCellRenderer: getHeader,
                width: 250,
                enableRowGroup: true,
                enablePivot: true

            },
            {
                headerName: 'PURCHASEPRODUCTDELIVERY.PERSONWHORECIEVES',
                field: "personWhoRecieves",
                headerCellRenderer: getHeader,
                width: 150,
                enableRowGroup: true,
                enablePivot: true

            },
            {
                headerName: 'PURCHASEPRODUCTDELIVERY.ADDRESSTODELIVERY',
                field: "addressToDelivery",
                headerCellRenderer: getHeader,
                width: 150,
                enableRowGroup: true,
                enablePivot: true

            },
            {
                headerName: 'PURCHASEPRODUCTDELIVERY.COMMENTSFORDELIVERY',
                field: "commentsForDelivery",
                headerCellRenderer: getHeader,
                width: 150,
                enableRowGroup: true,
                enablePivot: true

            },
            {
                headerName: 'PURCHASEPRODUCTDELIVERY.OPTIONS',
                name: "actions",
                headerCellRenderer: getHeader,
                suppressSorting: true,
                suppressMenu: true,
                width: 200,
                cellRenderer: function renderer(params) {
                    return '<div style="width: 100%;">' +
                        '<md-button class="edit-button md-icon-button" ' +
                        'ng-disabled="" ng-click="vm.createPurchaseProductDelivery($index, data.id, data)" aria-label="rejectionReason"' +
                        'translate translate-attr-aria-label="REJECTIONREASON.EDIT">' +
                        '<md-tooltip md-direction="bottom">' +
                        '{{"REJECTIONREASON.EDIT"| translate}}' +
                        '</md-tooltip>' +
                        '<md-icon md-font-icon="icon-pencil" class="s16"></md-icon> ' +
                        '</md-button>' +
                        '<md-button class="edit-button md-icon-button" ng-disabled="" ' +
                        'ng-click="vm.deletePurchaseProductDelivery($event, data.id, data, $index)" aria-label="pettyCash"' +
                        'translate translate-attr-aria-label="REJECTIONREASON.DELETE">' +
                        '<md-tooltip md-direction="bottom">' +
                        '{{"REJECTIONREASON.DELETE"| translate}}' +
                        '</md-tooltip>' +
                        '<md-icon md-font-icon="icon-delete" class="s16"></md-icon> ' +
                        '</md-button>' +
                        '</div>';
                },
                cellStyle: { 'padding': '0px' },
                pinned: "right"
            }
        ];

        vm.masterGridOptions = {
            columnDefs: vm.masterColumnDefs,
            enableSorting: true,
            debug: false,
            enableFilter: true,
            enableColResize: true,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowData: null,
            groupHeaders: true,
            headerHeight: 64,
            rowHeight: 64,
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            },
            doesDataFlower: function (dataItem) {
                return true;
            },
            isExternalFilterPresent: isExternalFilterPresent,
            doesExternalFilterPass: doesExternalFilterPass
        };

        var filter = 'everyone';

        function isExternalFilterPresent() {
            return filter !== '';
        }

        function doesExternalFilterPass(node) {
            if (filter && filter !== 'everyone') {
                var arrdt = node.data.filter.split(filter);
                return arrdt.length > 1;
            }
            return true;
        }

        function createPurchaseProductDelivery(i, id, data) {
            var detail = angular.copy(data);
            $mdDialog.show({
                controller: 'rejectionReasonEditController',
                controllerAs: 'vm',
                locals: {
                    purchaseProductDelivery: detail
                },
                templateUrl: 'app/main/apps/configuration/purchaseProductDelivery/purchaseProductDeliveryEdit/purchaseProductDeliveryEdit.html',
                parent: angular.element("#main"),
                clickOutsideToClose: false
            }).then(function (answer) {
                init();
                $rootScope.loadingProgress = false;
            }, function () {
                $rootScope.loadingProgress = false;
            });
        }

        function deletePurchaseProductDelivery(e, id, data, i) {


            var confirm = $mdDialog.confirm()
                .title($filter('translate')('PURCHASEPRODUCTDELIVERY.MSGTXTDELETE'))
                .htmlContent($filter('translate')('PURCHASEPRODUCTDELIVERY.MSGDELETE'))
                .ariaLabel('Delete Detail')
                .ok($filter('translate')('REJECTIONREASON.DELETE'))
                .cancel($filter('translate')('REJECTIONREASON.CANCEL'));

            $mdDialog.show(confirm).then(function () {
                $rootScope.loadingProgress = true;
                api.ComprasWS.PurchaseProductDelivery.PurchaseProductDelivery.delete(
                    { company: $rootScope.bsCircle.company.id, id: id }, function (response) {// Success
                        init();
                        showMessage($filter('translate')('REJECTIONREASON.MSGDELETESUCCESSFULL'));
                        $rootScope.loadingProgress = false;
                    }, function (response) {// Error
                        $log.debug(response);
                        $rootScope.loadingProgress = false;
                        if (response.data === "can not deleted") {
                            showErrorMessage($filter('translate')('REJECTIONREASON.MSGDELETEERROR'));
                        }
                    });

            }, function () {
            });
        }


        function showMessage(message) {
            $rootScope.loadingProgress = false;
            $mdToast.show({
                template: '<md-toast layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
                hideDelay: 3000,
                position: 'top right'
            });
        }
        function showErrorMessage(message) {
            $rootScope.loadingProgress = false;
            $mdToast.show({
                template: '<md-toast layout="column" layout-align="center start"><div class="md-toast-content" style="background-color: red">'
                    + message + '</div></md-toast>',
                hideDelay: 5000,
                position: 'top right'
            });
        }
    }


})();

(function () {
    'use strict';

    angular
        .module('app.configuration')
        .controller('messageStatusController', messageStatusController);

    /** @ngInject */
    function messageStatusController(api, $rootScope, $log, $mdDialog, $filter, MessageService, STATUS_TYPES, $timeout) {

        var vm = this;
        // Methods

        vm.statusTypes = STATUS_TYPES;
        vm.getData = getData;
        vm.statusUsed = [];

        // Methods
        vm.currentThread = null;
        init();

        //////////
        function init() {
            getData();
        }

        function getData() {
            $rootScope.loadingProgress = true;
            if (!vm.statusType) {
                vm.statusType = vm.statusTypes[0].value;
            }
            api.ComprasWS.PurchaseStatusCompany.PurchaseStatusCompany.get({ company: $rootScope.bsCircle.company.id, type: vm.statusType }, function (data) {
                vm.allowRoleAccess = true;
                $log.debug(data);

                vm.masterGridOptions.api.setColumnDefs(vm.masterColumnDefs);
                vm.masterGridOptions.api.setRowData(new jinqJs()
                    .from(data)
                    .orderBy([{ field: 'id', sort: 'asc' }])
                    .select(function (r) {
                        vm.statusUsed.push(r.purchaseStatus);
                        return r;
                    }));

                vm.loading = false;
                $rootScope.loadingProgress = false;
            }, function (response) {
                vm.loading = false;
                // Error
                vm.allowRoleAccess = false;
                $log.error(response);
            });
        }

        vm.masterColumnDefs = [
            {
                headerName: '#',
                field: "id",
                hide: true,
                headerCellRenderer: getHeader,
                width: 60,
                enableRowGroup: true,
                enablePivot: true,
                cellRenderer: function (params) {
                    return params.rowIndex + 1;
                }
            },
            {
                headerName: 'MESSAGE_STATUS.STATUS',
                field: "purchaseStatus.description",
                headerCellRenderer: getHeader,
                width: 350,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'MESSAGE_STATUS.MESSAGE',
                field: "ticketsMessage",
                headerCellRenderer: getHeader,
                width: 650,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'PURCHASEPRODUCTDELIVERY.OPTIONS',
                name: "actions",
                headerCellRenderer: getHeader,
                suppressSorting: true,
                suppressMenu: true,
                width: 200,
                cellRenderer: function renderer(params) {
                    return '<div style="width: 100%;">' +
                        '<md-button class="edit-button md-icon-button" ng-disabled="" ' +
                        'ng-click="vm.editData($index, data)" aria-label="rejectionReason"' +
                        'translate translate-attr-aria-label="REJECTIONREASON.EDIT">' +
                        '<md-tooltip md-direction="bottom">' +
                        '{{"REJECTIONREASON.EDIT"| translate}}' +
                        '</md-tooltip>' +
                        '<md-icon md-font-icon="icon-pencil" class="s16"></md-icon> ' +
                        '</md-button>' +
                        '<md-button class="edit-button md-icon-button" ng-disabled="" ' +
                        'ng-click="vm.deleteData($event, data, $index)" aria-label="pettyCash"' +
                        'translate translate-attr-aria-label="REJECTIONREASON.DELETE">' +
                        '<md-tooltip md-direction="bottom">' +
                        '{{"REJECTIONREASON.DELETE"| translate}}' +
                        '</md-tooltip>' +
                        '<md-icon md-font-icon="icon-delete" class="s16 md-warn"></md-icon> ' +
                        '</md-button>' +
                        '</div>';
                },
                cellStyle: { 'padding': '0px' },
                pinned: "right"
            }
        ];

        vm.masterGridOptions = {
            columnDefs: vm.masterColumnDefs,
            enableSorting: true,
            debug: false,
            enableFilter: true,
            enableColResize: true,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowData: null,
            groupHeaders: true,
            headerHeight: 64,
            rowHeight: 64,
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            },
            doesDataFlower: function (dataItem) {
                return true;
            },
            isExternalFilterPresent: isExternalFilterPresent,
            doesExternalFilterPass: doesExternalFilterPass
        };

        var filter = 'everyone';

        function isExternalFilterPresent() {
            return filter !== '';
        }

        function doesExternalFilterPass(node) {
            if (filter && filter !== 'everyone') {
                var arrdt = node.data.filter.split(filter);
                return arrdt.length > 1;
            }
            return true;
        }

        vm.editData = function (ev, data, index) {
            var obj = {
                statusType: vm.statusType,
                statusUsed: vm.statusUsed
            }
            $mdDialog.show({
                controller: 'messageDialogController',
                controllerAs: 'vm',
                locals: {
                    data: data,
                    obj: obj,
                },
                templateUrl: 'app/main/apps/configuration/messageStatus/messageDialog/messageDialog.html',
                parent: angular.element("#main"),
                clickOutsideToClose: false
            }).then(function (answer) {
                init();
                $rootScope.loadingProgress = false;
            }, function () {
                $rootScope.loadingProgress = false;
            });
        };

        vm.deleteData = function (ev, data, index) {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('MESSAGE_STATUS.DELETE'))
                .htmlContent($filter('translate')('MESSAGE_STATUS.CONFIRM_DELETE'))
                .ariaLabel('Delete Detail')
                .ok($filter('translate')('REJECTIONREASON.DELETE'))
                .cancel($filter('translate')('REJECTIONREASON.CANCEL'));

            $mdDialog.show(confirm).then(function () {
                $rootScope.loadingProgress = true;
                api.ComprasWS.PurchaseStatusCompany.PurchaseStatusCompanyObj.del(
                    { company: $rootScope.bsCircle.company.id, id: data.id }, function (response) {// Success
                        init();
                        MessageService.show($filter('translate')('MESSAGE_STATUS.DELETED_SUCCESSFULLY'));
                        $rootScope.loadingProgress = false;
                    }, function (response) {// Error
                        $log.debug(response);
                        $rootScope.loadingProgress = false;
                        MessageService.showErrorMessage($filter('translate')('MESSAGE_STATUS.ERROR_DELETE'));
                    });

            }, function () {
            });
        };

        vm.clearSearchType = function () {
            vm.searchType = "";
        };

        $timeout(function () {

            var keyEvent = function (event) {
                event.stopPropagation();
            };

            var searchTypeInput = document.querySelector("#searchType");

            if (searchTypeInput) {
                searchTypeInput.addEventListener("keydown", keyEvent);
            }
        }, 500);

    }

})();


(function () {
    'use strict';

    angular
        .module('app.generalReports', ['flow'])
        .config(config)
        .directive('expandGrid', expandGrid);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider) {

        $stateProvider
            .state('app.reports', {
                url: '/generalR',
                abstract: true
            })
            .state('app.reports.providerByConsumed', {
                url: '/providerByConsumed',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/generalReports/horizontalFilterReport.html',
                        controller: 'GeneralReportsProviderController as vm'
                    }
                },
                resolve: {
                    Report: function (msApi) {
                        return msApi.resolve('report.providerByConsumed@get');
                    }
                },
                params: {
                    filter: null
                },
                bodyClass: 'file-manager'
            })
            .state('app.reports.consumedByDepartment', {
                url: '/consumedByDepartment',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/generalReports/horizontalFilterReport.html',
                        controller: 'GeneralReportsProviderController as vm'
                    }
                },
                resolve: {
                    Report: function (msApi) {
                        return msApi.resolve('report.consumedByDepartment@get');
                    }
                },
                params: {
                    filter: null
                },
                bodyClass: 'file-manager'
            })
            .state('app.reports.consumedByProduct', {
                url: '/consumedByProduct',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/generalReports/horizontalFilterReport.html',
                        controller: 'GeneralReportsProviderController as vm'
                    }
                },
                resolve: {
                    Report: function (msApi) {
                        return msApi.resolve('report.consumedByProduct@get');
                    }
                },
                params: {
                    filter: null
                },
                bodyClass: 'file-manager'
            })
            .state('app.reports.requisitionByUser', {
                url: '/requisitionByUser',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/generalReports/horizontalFilterReport.html',
                        controller: 'GeneralReportsController as vm'
                    }
                },
                resolve: {
                    Report: function (msApi) {
                        return msApi.resolve('report.requisitionByUser@get');
                    }
                },
                params: {
                    filter: null
                },
                bodyClass: 'file-manager'
            })
            .state('app.reports.requisitionByDepartment', {
                url: '/requisitionByDepartment',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/generalReports/horizontalFilterReport.html',
                        controller: 'GeneralReportsController as vm'
                    }
                },
                resolve: {
                    Report: function (msApi) {
                        return msApi.resolve('report.requisitionByDepartment@get');
                    }
                },
                params: {
                    filter: null
                },
                bodyClass: 'file-manager'
            })
            ;

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/generalReports');

        // Api
        msApiProvider.register('report.providerByConsumed', ['app/main/apps/generalReports/data/providerByConsumed.json']);
        msApiProvider.register('report.consumedByDepartment', ['app/main/apps/generalReports/data/consumedByDepartment.json']);
        msApiProvider.register('report.consumedByProduct', ['app/main/apps/generalReports/data/consumedByProduct.json']);
        msApiProvider.register('report.requisitionByUser', ['app/main/apps/generalReports/data/requisitionByUser.json']);
        msApiProvider.register('report.requisitionByDepartment', ['app/main/apps/generalReports/data/requisitionByDepartment.json']);
    }

    function expandGrid() {
        var directive = {
            link: link, // The function attaching the behavior
            restrict: 'A' // Restrict directive to be used only as attribute
        };
        return directive;


        function link(scope, element, attrs) {

            var gridElement = $(element);
            var idGrid = attrs.id;
            var min = attrs.min ? parseInt(attrs.min) : 250;
            var other = attrs.other ? parseInt(attrs.other) : 0;
            resizeGridM("#" + idGrid, other, min);
            // Attach an eventHandler to the resize event of the
            // window to resize the data area of the grid accordingly
            scope.$watch(
                function () {
                    return gridElement.parent().height();
                },
                function (height) {
                    resizeGridM("#" + idGrid, other, min);
                });
        }
    }
    function resizeGridM(gridName, other, min) {
        //Define Elements Needed
        var grid = $(gridName);

        other = other ? other : 0;
        //Other variables
        var minimumAcceptableGridHeight = min ? min : 250; //This is roughly 5 rows

        //Get Window Height
        var windowHeight = $(window).innerHeight();

        //Padding you want to apply below your page
        var bottomPadding = 60;

        //Check if Calculated height is below threshold
        var calculatedHeight = windowHeight - bottomPadding - other - 150;
        var finalHeight = calculatedHeight < minimumAcceptableGridHeight ? minimumAcceptableGridHeight : calculatedHeight;

        //Apply the height for the content area
        grid.css('height', finalHeight + 'px');
    }

})();

(function () {
  "use strict";

  angular
    .module("app.generalReports")
    .controller("GeneralReportsProviderController", GeneralReportsProviderController);

  /** @ngInject */
  function GeneralReportsProviderController(
    $mdSidenav,
    $stateParams,
    Report,
    api,
    $rootScope,
    $state,
    $timeout,
    $templateRequest,
    $sce,
    $log,
    $filter,
    $mdDialog,
    envService,
    MessageService
  ) {
    var vm = this;

    const EXPORT_TRANSLATE = $filter('translate')('REPORT.EXPORT');
    const FORMAT_DD_MM_YY_HH_MM_SS = 'dd/MM/yyyy HH:mm:ss';
    const FORMAT_DD_MM_YY = 'dd/MM/yyyy';
    const NEGATIVE_ONE_THOUSAND = -1000;
    var pageSize = Report.pageSize;
    vm.minDate = new Date();
    var params = { idc: $rootScope.bsCircle.company.id };
    vm.filter = {
      startDate: new Date(vm.minDate.getTime()),
      endDate: new Date(vm.minDate.getTime()),
      isProvider: Report.isProvider,
      appName: Report.filter.appName,
      isGeneral: Report.filter.isGeneral
    };
    vm.changeDeptoAndCCByCompany = changeDeptoAndCCByCompany;
    vm.selectAllItemsCompanies = selectAllItemsCompanies;
    vm.selectAllItemsStatus = selectAllItemsStatus;

    if ($stateParams.isTicket) {
      vm.filter.originTypeCode = "01";
    }

    vm.exportXLS = Report.exportXLS;
    vm.snFilter = Report.filter;
    vm.title = Report.title;
    vm.masterColumnDefs = Report.columns;
    vm.isShowFilter = true;
    vm.loadSettlementStatus = loadSettlementStatus;
    var filter = "everyone";
    vm.totalquantity = 0;
    vm.totalsubTotalAfterTax = 0;
    const TEXT_PROVIDERS = 'providers';
    vm.THREE_HUNDRED = 300;

    //metodos
    vm.clearSearchDepartment = clearSearchDepartment;
    vm.clearSearchCostCenter = clearSearchCostCenter;
    vm.clearSearchStatus = clearSearchStatus;
    vm.clearSettlementStatus = clearSettlementStatus;
    vm.clearSearchProject = clearSearchProject;
    vm.goToRef = goToRef;
    vm.replaceOriginTypedata = replaceOriginTypedata;
    vm.showPDF = showPDF;
    vm.rejectInvoice = rejectInvoice;
    vm.showInterfazDetail = showInterfazDetail;
    vm.selectContractsValid = selectContractsValid;
    vm.showInvoiceDetail = showInvoiceDetail;
    vm.statuses = [];
    vm.statusesInvoice = [];
    vm.typeses = [];
    vm.exceptionLimitDateButton = false;
    vm.exceptionLimitDate = exceptionLimitDate;
    vm.selectAllItemsDepartments = selectAllItemsDepartments;
    vm.selectAllItemsCostCenters = selectAllItemsCostCenters;
    vm.selectCompanies = selectCompanies;

    rowsColumns();

    vm.api = api;
    Report.api.forEach(function (d) {
      vm.api = vm.api[d];
    });

    function correctFilter(column) {
      switch (column.dataTypes) {
        case "Long":
        case "BigDecimal":
        case "Double":
        case "Integer":
          column.filter = "number";
          break;
        case "text":
          column.filter = "text";
          break;
        default:
          column.filter = "date";
          break;
      }
      correctFilterParams(column);
    }

    function correctFilterParams(column) {
      switch (column.filter) {
        case "number":
          column.filterParams = {
            filterOptions: ["equals"],
            newRowsAction: "keep"
          };
          break;
        case "text":
          column.filterParams = {
            filterOptions: ["contains"],
            newRowsAction: "keep"
          };
          break;
        case "date":
          column.suppressFilter = true;
          break;
      }
    }

    function rowsColumns() {
      vm.masterColumnDefs.forEach(function (d) {
        d.headerCellRenderer = function () {
          return "{{'" + d.headerName + "'|translate}}";
        };
        if (d.valueFormatter) {
          d.valueFormatter = getCellFormater(d.valueFormatter);
        }
        if (d.rendererCurrencyDescAmount) {
          d.cellRenderer = getFormedAmountCurrencyDescription(
            d.rendererCurrencyDescAmount.amountField,
            d.rendererCurrencyDescAmount.currecyField
          );
          delete d.rendererCurrencyDescAmount;
        }
        if (d.rendererButtons) {
          d.cellRenderer = getButtons(d.rendererButtons);
          delete d.rendererButtons;
        }
        if (d.rendererLink) {
          d.cellRenderer = getURL(d.rendererLink);
          delete d.rendererLink;
        }
        if (d.rendererButtonsM) {
          d.cellRenderer = getButtonsM(d.rendererButtonsM);
          delete d.rendererButtonsM;
        }
        if (d.rendererTranslateValue) {
          d.cellRenderer = getTranslateValue(
            d.rendererTranslateValue.prefixTranslate,
            d.rendererTranslateValue.keyValue
          );
          delete d.rendererTranslateValue;
        }
        if (d.dataTypes) {
          correctFilter(d);
        }
      });
    }

    var gridOptions = Report.masterGridOptions;
    if (Report.detailGrid) {
      var templateDetail = null;
      vm.loadTemplate = function () {
        var otherTemplate = $sce.getTrustedResourceUrl(
          Report.detailGrid.templateUrl
        );
        $templateRequest(otherTemplate).then(
          function (template) {
            templateDetail = template;
          },
          function () {
            $log.error("Ocurrio un error al leer el template");
          }
        );
      };

      gridOptions.fullWidthCellRenderer = fullWidthCellRendererFn;
      gridOptions.isFullWidthCell = function (rowNode) {
        return rowNode.level === 1;
      };
      gridOptions.getRowHeight = function (params) {
        var rowIsDetailRow = params.node.level === 1;

        return rowIsDetailRow ? 450 : 45;
      };
    }
    gridOptions.doesDataFlower = function (dataItem) {
      if (dataItem.quantity) {
        vm.totalquantity += dataItem.quantity;
      }
      if (dataItem.subTotalAfterTax) {
        vm.totalsubTotalAfterTax += dataItem.subTotalAfterTax;
      }
      //
    };

    gridOptions.onFilterChanged = function (c, d, e, f) {
      delete vm.filter.totalElements;
    };

    if (gridOptions.autoGroupColumnDef) {
      gridOptions.autoGroupColumnDef.headerCellRenderer = function (name) {
        return "{{'" + name.value + "'|translate}}";
      };
    }

    gridOptions.doesExternalFilterPass = function (node) {
      if (filter && filter !== "everyone") {
        var arrdt = node.data.filter.split(filter.toLowerCase());
        return arrdt.length > 1;
      }
      return true;
    };

    gridOptions.isExternalFilterPresent = function () {
      return filter !== "";
    };

    gridOptions.localeTextFunc = function (key, defaultValue) {
      return translateGrid(key, defaultValue, $filter);
    };

    gridOptions.getMainMenuItems = function (params) {
      params.columnApi.getAllColumns().forEach(function (r) {
        r.colDef.hN = r.colDef.hN
          ? r.colDef.hN
          : angular.copy(r.colDef.headerName);
        r.colDef.headerName = $filter("translate")(r.colDef.hN);
      });
      return params.defaultItems;
    };

    gridOptions.columnDefs = vm.masterColumnDefs;

    gridOptions.getContextMenuItems = isGetContextMenuItems;

    function isGetContextMenuItems() {
      const paramrs = getParameterToExport();

      paramrs.processCellCallback = isProcessCellCallBack();

      paramrs.processHeaderCallback = function (param) {
        return $filter('translate')(param.column.colDef.headerName);
      };

      return [
        'copy',
        'copyWithHeaders',
        'paste',
        'separator',
        {
          name: $filter('translate')('REPORT.EXPORT'),
          subMenu: getContextSubMenuItems(paramrs)
        }
      ];
    }

    function isProcessCellCallBack() {
      return function (param) {
        if (param.column.colId.indexOf('fecha') !== -1) {
          return $filter('date')(param.value, FORMAT_DD_MM_YY);
        } else if (
          param.column.colId.indexOf('createdAt') !== -1 &&
          param.value
        ) {
          return $filter('apiDate')(param.value, FORMAT_DD_MM_YY_HH_MM_SS);
        } else {
          return param.value;
        }
      };
    }

    function getParameterToExport() {
      return {
        skipHeader: false,
        skipFooters: false,
        skipGroups: false,
        allColumns: true,
        onlySelected: false,
        columnSeparator: ',',
        sheetName: $filter('translate')(Report.exportXLS.nameFile)
      };
    }

    function getContextSubMenuItems(paramrs) {
      return [
        {
          name: EXPORT_TRANSLATE + ' Excel (.xlsx)',
          action: dataExportExcel(paramrs)
        }
      ];
    }

    function dataExportExcel(paramrs) {
      return function () {
        paramrs.fileName = $filter('translate')(Report.exportXLS.nameFile) + new Date().getTime() + '.xlsx';
        vm.masterGridOptions.api.exportDataAsExcel(paramrs);
      };
    }

    gridOptions.components = {
      customPinnedRowRenderer: CustomPinnedRowRenderer
    };

    vm.masterGridOptions = gridOptions;

    function CustomPinnedRowRenderer() { }

    CustomPinnedRowRenderer.prototype.init = function (params) {
      this.eGui = document.createElement("div");
      this.eGui.style = params.style;
      this.eGui.innerHTML = params.value;
    };

    CustomPinnedRowRenderer.prototype.getGui = function () {
      return this.eGui;
    };

    if (vm.snFilter.companies) {
      loadCompanyByRole();
    }

    if (vm.snFilter.department) {
      if (vm.filter.originTypeCode === "01" || Report.filter.queryAll) {
        loadByDepartmentsCompany();
      } else if (vm.snFilter.companiesDialog) {
        vm.filter.departments = [];
      } else {
        loadDepartments();
      }
    }
    if (vm.snFilter.costCenter) {
      if (vm.filter.originTypeCode === "01" || Report.filter.queryAll) {
        loadByCostCentersCompany();
      } else if (vm.snFilter.companiesDialog) {
        vm.filter.costCenters = [];
      } else {
        loadCostCenter();
      }
    }

    if (vm.snFilter.project) {
      loadProjects();
    }

    if (vm.snFilter.status) {
      loadStatus();
    }
    if (vm.snFilter.statusInvoice) {
      loadStatus();
    }

    if (Report.statusFilter) {
      loadStatus();
    }

    if (vm.snFilter.SettlementStatus) {
      loadSettlementStatus();
    }

    if (vm.snFilter.pettyCashStatus) {
      loadPettyCashStatus();
    }

    if (vm.snFilter.entities) {
      loadEntityCatalog();
    }

    if (vm.snFilter.type) {
      loadTypes();
    }

    if (vm.exportXLS) {
      vm.onExportXLS = function () {
        var params = {
          skipHeader: false,
          skipFooters: false,
          skipGroups: false,
          allColumns: true,
          onlySelected: false,
          fileName: Report.exportXLS.nameFile + new Date().getTime() + ".xls",
          columnSeparator: ",",
          sheetName: $filter('translate')(Report.exportXLS.nameFile)
        };

        params.processCellCallback = function (params) {
          if (params.column.colId.indexOf("fecha") !== -1) {
            return $filter('date')(params.value, FORMAT_DD_MM_YY);
          } else if (params.column.colId.indexOf("createdAt") !== -1) {
            return $filter('apiDate')(params.value, FORMAT_DD_MM_YY_HH_MM_SS);
          } else {
            return params.value;
          }
        };

        params.processHeaderCallback = function (params) {
          return $filter("translate")(params.column.colDef.headerName);
        };

        vm.masterGridOptions.api.exportDataAsExcel(params);
      };
    }

    // Methods
    vm.search = search;
    vm.gotoDetail = gotoDetail;
    vm.toggleSidenav = toggleSidenav;
    vm.changeStartDate = changeStartDate;

    //////////
    if (Report.verticalFilter) {
      $timeout(function () {
        toggleSidenav("main-sidenav");
      }, 300);
    }

    function getCellFormater(type) {
      switch (type) {
        case "date":
          return function (params) {
            if (params.value) {
              return $filter('date')(params.value, FORMAT_DD_MM_YY);
            }
            return '';
          };
        case "currency":
          return function (params) {
            if (params.value) {
              return $filter("number")(params.value, "2");
            }
            return '';
          };
        case "localDateTime":
          return function (params) {
            if (params.value) {
              return $filter('apiDate')(params.value, FORMAT_DD_MM_YY_HH_MM_SS);
            }
            return '';
          };
        case "dateTime":
          return function (params) {
            if (params.value) {
              return $filter('date')(params.value, FORMAT_DD_MM_YY_HH_MM_SS);
            }
            return '';
          };
        case "boolean":
          return function (params) {
            if (params.value) {
              return '<md-icon md-font-icon="icon-checkbox-marked-circle green-500-fg"></md-icon>';
            }
            return '<md-icon md-font-icon="icon-cancel red-500-fg"></md-icon>';
          };

        default:
          break;
      }
    }

    function fixDataTypesFilters(arr) {
      if (arr) {
        arr.forEach(function (r) {
          if (r.filterType === "number") {
            var clDef = vm.masterGridOptions.api.getColumnDef(r.field);
            r.filterType = clDef.dataTypes ? clDef.dataTypes : "number";
          }
        });
      }
    }

    function createNewDatasource() {
      vm.totalquantity = 0;
      vm.totalsubTotalAfterTax = 0;

      vm.masterGridOptions.api.setRowData([]);

      vm.masterGridOptions.api.paginationSetPageSize(pageSize);

      var o = vm.masterGridOptions.api.getFilterModel();
      var parameters = {
        circle: $rootScope.bsCircle.id,
        idCircle: $rootScope.bsCircle.id,
        company: $rootScope.bsCircle.company.id,
        electronic: vm.electronic,
        page: vm.masterGridOptions.api.paginationGetCurrentPage(),
        pageSize: pageSize
      };
      var arr = $.map(o, function (k, ke, sd, ds) {
        var on = k;
        on.field = ke;
        on.filter = on.filter.toString();
        return on;
      });
      fixDataTypesFilters(arr);
      vm.parameters = parameters;
      vm.isShowProgressLinear = true;
      vm.filter.sorts = vm.masterGridOptions.api.getSortModel();
      vm.filter.filters = arr;
      vm.api(
        parameters,
        vm.filter,
        function (response) {
          vm.isShowProgressLinear = false;
          vm.showGrid = true;
          vm.filter.totalElements = response.length;
          vm.filter.id = null;
          vm.masterGridOptions.api.setRowData(response);
          var result = [];
          result.push({
            provider: "",
            quantity: $filter("number")(vm.totalquantity),
            product: "",
            price: "",
            department: "",
            costCenter: "",
            status: "",
            description: "",
            subTotalAfterTax: vm.totalsubTotalAfterTax
          });
          vm.masterGridOptions.api.setPinnedBottomRowData(result);

          vm.hasData = response.length > 0;
        },
        function (response) {
          vm.isShowProgressLinear = false;
          $log.error(response);
        }
      );
    }

    /**
     * Select an item
     *
     * @param item
     */
    function search() {
      if (vm.snFilter.isGeneral && !vm.snFilter.filterByDates) {
        delete vm.filter.startDate;
        delete vm.filter.endDate;
      } else {
        if (!vm.filter.startDate) {
          vm.filter.startDate = new Date();
        }
        if (!vm.filter.endDate) {
          vm.filter.endDate = new Date();
        }
        vm.filter.startDate.setHours(0);
        vm.filter.startDate.setMinutes(0);
        vm.filter.startDate.setSeconds(0);

        vm.filter.endDate.setHours(23);
        vm.filter.endDate.setMinutes(59);
        vm.filter.endDate.setSeconds(59);
      }

      if (!Report.filter.queryAll) {
        if (!vm.filter.departments || vm.filter.departments.length <= 0) {
          vm.filter.departments = [];

          if (vm.departments) {
            for (var i = 0; i < vm.departments.length; i++) {
              vm.filter.departments.push(vm.departments[i].id);
            }
          } else {
            vm.filter.departments.push(NEGATIVE_ONE_THOUSAND);
          }
        }

        if (!vm.filter.costCenters || vm.filter.costCenters.length <= 0) {
          vm.filter.costCenters = [];

          if (vm.costCenters) {
            for (var j = 0; j < vm.costCenters.length; j++) {
              vm.filter.costCenters.push(vm.costCenters[j].id);
            }
          } else {
            vm.filter.costCenters.push(NEGATIVE_ONE_THOUSAND);
          }
        }
      }

      if (!vm.filter.statuses || vm.filter.statuses.length <= 0) {
        vm.filter.statuses = [];

        if (vm.statuses) {
          for (var k = 0; k < vm.statuses.length; k++) {
            vm.filter.statuses.push(vm.statuses[k].id);
          }
        } else {
          vm.filter.statuses.push(NEGATIVE_ONE_THOUSAND);
        }
      }

      if (!vm.filter.statusesInvoice || vm.filter.statusesInvoice.length <= 0) {
        vm.filter.statusesInvoice = [];
        if (vm.statusesInvoice) {
          for (let j = 0; j < vm.statusesInvoice.length; j++) {
            vm.filter.statusesInvoice.push(vm.statusesInvoice[j].id);
          }
        } else {
          vm.filter.statusesInvoice.push(NEGATIVE_ONE_THOUSAND);
        }
      }

      if (vm.snFilter.isRejectedAutomatically) {
        vm.filter.isRejectedAutomatically = vm.snFilter.isRejectedAutomatically;
      }

      delete vm.filter.totalElements;
      vm.masterGridOptions.api.setColumnDefs(vm.masterColumnDefs);
      createNewDatasource();
      vm.isShowFilter = false;
    }

    function loadCostCenter() {
      vm.loadingCostCenter = true;
      api.GeneralWS.CostCenter.query(params, function (data) {
        if (data.length === 1) {
          vm.filter.costCenters = [data[0].id.toString()];
        }
        vm.costCenters = data;
        vm.loadingCostCenter = false;
      }, function (){
        vm.loadingCostCenter = false;
      });
    }

    function loadDepartments() {
      vm.loadingDepartments = true;
      api.GeneralWS.Department.query(params, function (data) {
        if (data.length === 1) {
          vm.filter.departments = [data[0].id.toString()];
        }
        vm.departments = data;
        vm.loadingDepartments = false;
      }, function (){
        vm.loadingDepartments = false;
      });
    }

    function loadProjects() {
      vm.loadingProject = true;
      api.ProyectosWS.getAll.query(
        { companyId: $rootScope.bsCircle.company.id },
        function (data) {
          vm.projects = data;
          vm.loadingProject = false;
        }
      );
    }

    function loadByDepartmentsCompany() {
      vm.loadingDepartments = true;
      api.GeneralWS.getAllDepartment.query(params, function (data) {
        vm.departments = data;
        vm.loadingDepartments = false;
      });
    }

    function loadByCostCentersCompany() {
      vm.loadingCostCenter = true;
      api.GeneralWS.getAllCost.query(params, function (data) {
        vm.costCenters = data;
        vm.loadingCostCenter = false;
      });
    }

    function loadCompanyByRole() {
      vm.loadingCompanies = true;
      params.idCircle = $rootScope.bsCircle.id;
      api.GeneralWS.Usr.User.Company.CompanyRolUser.page(params, function (
        data
      ) {
        if (data.length === 1) {
          vm.filter.companies = [data[0].id.toString()];
        }
        vm.companies = data;
        vm.loadingCompanies = false;
      });
    }

    function loadStatus() {
      vm.loadingStatus = true;
      api.ComprasWS.PurchaseStatus.query({ type: Report.statusType }, function (
        data
      ) {
        if (data.length === 1) {
          vm.filter.status = [data[0].id.toString()];
        }
        if(vm.snFilter.statusInvoice){
          vm.statusesInvoice = data;
        }else {
          vm.statuses = data;
        }

        vm.loadingStatus = false;
        if (Report.statusFilter) {
          vm.filter.statuses = [];
          Report.statusFilter.forEach(function (status) {
            vm.statuses.forEach(function (data) {
              if (status === data.description) {
                vm.filter.statuses.push(data.id);
              }
            });
          });
        }
      });
    }
    function loadSettlementStatus() {
      vm.loadingStatus = true;
      api.ComprasWS.Settlement.SettlementStatus.query({}, function (data) {
        if (data.length === 1) {
          vm.filter.settlementStatus = [data[0].id.toString()];
        }
        vm.settlementStatus = data;
        if ($stateParams.status === "Provisionada") {
          vm.settlementStatus.forEach(function (sts) {
            if (sts.name === "Provisionada") {
              vm.filter.settlementStatus = [sts.id.toString()];
              vm.settlementStatus = [sts];
            }
          });
        }
        if ($stateParams.status === "Pagada") {
          vm.settlementStatus.forEach(function (sts) {
            if (sts.name === "Pagada") {
              vm.filter.settlementStatus = [sts.id.toString()];
              vm.settlementStatus = [sts];
            }
          });
        }
        vm.loadingSettlementStatus = false;
      });
    }
    function loadPettyCashStatus() {
      vm.loadingStatus = true;
      vm.pettyCashStatus = [
        { id: false, name: "En Proceso" },
        { id: true, name: "Finalizada" }
      ];
    }

    function loadEntityCatalog() {
      vm.loadingEntity = true;
      api.InterfazWS.EntityCatalog.me.query({}).$promise.then(
        function (response) {
          vm.loadingEntity = false;
          vm.entityCatalog = response;

          for (var i = 0; i < response.length; i++) {
            if (response[i].entityName === "invoicepurchase") {
              vm.entity = response[i];
            }
          }
        },
        function (response) {
          vm.loadingEntity = false;
          $log.error(response);
        }
      );
    }

    function changeStartDate(isStart) {
      if (isStart) {
        if (vm.filter.startDate > vm.filter.endDate) {
          vm.filter.endDate = vm.filter.startDate;
        }
      }
      vm.filter.startDate = setDateType(vm.filter.startDate, false);
      vm.filter.endDate = setDateType(vm.filter.endDate, true);
    }

    function setDateType(date, end) {
      if (end) {
        date.setHours(23);
        date.setMinutes(59);
        date.setSeconds(59);
      } else {
        date.setHours(0);
        date.setMinutes(0);
        date.setSeconds(0);
      }
      return date;
    }

    /**
     * Toggle sidenav
     *
     * @param sidenavId
     */
    function toggleSidenav(sidenavId) {
      $mdSidenav(sidenavId).toggle();
    }

    function rejectInvoice(data) {
      var confirm = $mdDialog
        .confirm()
        .title($filter("translate")("INVOICE.MSG.Rechazada_INVOICE"))
        .textContent(
          $filter("translate")("INVOICE.MSG.CONFIRMACION_Rechazada_INVOICE")
        )
        .ok($filter("translate")("INVOICE.MSG.SI"))
        .cancel($filter("translate")("INVOICE.MSG.NO"));
      $mdDialog.show(confirm).then(
        function () {
          $rootScope.loadingProgress = true;
          api.ComprasWS.InvoicePurchase.setStatus(
            {
              id: "changeStatus",
              idCircle: $rootScope.bsCircle.id,
              status: "Emitida",
              cancelInErp: true
            },
            data
          ).$promise.then(
            function (response) {
              $rootScope.loadingProgress = false;
              MessageService.show(
                $filter("translate")("INVOICE.MSG.STATUS_CHANGE_SUCCESS")
              );

              vm.masterGridOptions.api.forEachNode(function (row, index) {
                if (row.data.id === data.id) {
                  row.data.purchaseStatus.description = "Emitida";
                }
              });
              vm.masterGridOptions.api.redrawRows();
            },
            function (response) {
              $rootScope.loadingProgress = false;
              $log.error(response);
            }
          );
        },
        function () { }
      );
    }

    function getButtons(buttons) {
      return function renderer(params) {
        var render = '<div style="width: 100%;">\n';
        if (buttons.details) {
          render +=
            '<md-button class="edit-button md-icon-button" ng-click="vm.gotoDetail(data.id)" aria-label="Order details"' +
            ' translate translate-attr-aria-label="REPORT.VIEW_DETAILS">' +
            ' <md-tooltip md-direction="bottom">' +
            '                     {{"REPORT.VIEW_DETAILS"| translate}}' +
            "                 </md-tooltip>" +
            '                 <md-icon md-font-icon="icon-eye" class="s16"></md-icon> ' +
            "             </md-button>";
        }

        if (
          buttons.pdfInvoice &&
          params.data &&
          statusForPDF(params.data.purchaseStatus.description)
        ) {
          render +=
            '<md-button class="edit-button md-icon-button" ng-click="vm.downloadPdf(\'JASPER_URL_DOC_ENTREGA\', data.id)" ' +
            ' aria-label="Order details"' +
            '                translate translate-attr-aria-label="REPORT.VIEW_DETAILS">' +
            '                 <md-tooltip md-direction="bottom">' +
            '                     {{"REPORT.PDF_INVOICE"| translate}}' +
            "                 </md-tooltip>" +
            '                 <md-icon md-font-icon="icon-download" class="s16"></md-icon> ' +
            "             </md-button>";
        }

        if (
          buttons.showPDFInvoice &&
          params.data &&
          statusForPDF(params.data.purchaseStatus.description)
        ) {
          render +=
            '<md-button class="edit-button md-icon-button" ng-click="vm.showPDF(\'JASPER_URL_DOC_ENTREGA\', data)" aria-label="Order details"' +
            '                        translate translate-attr-aria-label="REPORT.VIEW_DETAILS">' +
            '                 <md-tooltip md-direction="bottom">' +
            '                     {{"REPORT.VER"| translate}}' +
            "                 </md-tooltip>" +
            '                 <md-icon md-font-icon="icon-clipboard-text" class="s16"></md-icon> ' +
            "             </md-button>";
        }

        if (
          buttons.pdfContrasenaPago &&
          params.data &&
          statusForContrasenaPago(params.data.purchaseStatus.description)
        ) {
          render +=
            '<md-button class="edit-button md-icon-button" ng-click="vm.downloadPdf(\'JASPER_URL_CONTRASENA_PAGO\', data.id)" ' +
            ' aria-label="Order details"' +
            '                 translate translate-attr-aria-label="REPORT.VIEW_DETAILS">' +
            '                 <md-tooltip md-direction="bottom">' +
            '                     {{"REPORT.PDF_GENERAR"| translate}}' +
            "                 </md-tooltip>" +
            '                 <md-icon md-font-icon="icon-download" class="s16"></md-icon> ' +
            "             </md-button>";
        }

        if (
          buttons.showPDFContrasenaPago &&
          params.data &&
          statusForContrasenaPago(params.data.purchaseStatus.description)
        ) {
          render +=
            '<md-button class="edit-button md-icon-button" ng-click="vm.showPDF(\'JASPER_URL_CONTRASENA_PAGO\', data)" aria-label="Order details"' +
            '                    translate translate-attr-aria-label="REPORT.VIEW_DETAILS">' +
            '                 <md-tooltip md-direction="bottom">' +
            '                     {{"REPORT.VER"| translate}}' +
            "                 </md-tooltip>" +
            '                 <md-icon md-font-icon="icon-clipboard-text" class="s16"></md-icon> ' +
            "             </md-button>";
        }

        if (
          buttons.rechazeInvoice &&
          params.data &&
          params.data.purchaseStatus.description === "Provisionada" &&
          $rootScope.getEspecialActionByName("Rechaza Factura Provisionada")
        ) {
          render +=
            '<md-button class="edit-button md-icon-button" ng-click="vm.rejectInvoice(data)" aria-label="Rechaze"' +
            '                        translate translate-attr-aria-label="REPORT.REJECT_INVOICE">' +
            '                 <md-tooltip md-direction="bottom">' +
            '                     {{"REPORT.REJECT_INVOICE"| translate}}' +
            "                 </md-tooltip>" +
            '                 <md-icon md-font-icon="icon-thumb-down" class="s16 md-warn"></md-icon> ' +
            "             </md-button>";
        }

        if (buttons.showInterfazDetail) {
          render +=
            '<md-button class="edit-button md-icon-button" ng-click="vm.showInterfazDetail(data)" aria-label="detail"' +
            '                    translate translate-attr-aria-label="REPORT.VIEW_DETAILS">' +
            '                 <md-tooltip md-direction="bottom">' +
            '                     {{"REPORT.VIEW_DETAILS"| translate}}' +
            "                 </md-tooltip>" +
            '                 <md-icon md-font-icon="icon-eye" class="s16 "></md-icon> ' +
            "             </md-button>";
        }

        for (
          var i = 0;
          i < $rootScope.bsCircle.role.roleSpecialActions.length;
          i++
        ) {
          if (
            $rootScope.bsCircle.role.roleSpecialActions[i].specialAction
              .actionName === "Excepcion limites fechas"
          ) {
            vm.exceptionLimitDateButton = true;
            break;
          }
        }

        if (vm.exceptionLimitDateButton) {
          render +=
            '<md-button ng-if="!data.limitDateException" class="edit-button md-icon-button" ' +
            ' ng-click="vm.invoiceExceptionLimitDate(data)" aria-label="invoiceException"' +
            '              translate translate-attr-aria-label="SETTLEMENT.VIEW_DETAILS">' +
            '                 <md-tooltip md-direction="bottom">' +
            '                     {{"INVOICE.MSG.EXCEPTION_LIMIT_DATE"| translate}}' +
            "                 </md-tooltip>" +
            '                 <md-icon md-font-icon="icon-calendar-remove" class="s16 "></md-icon> ' +
            "             </md-button>";
        }

        if (
          $rootScope.getEspecialActionByName("Desactivar Factura") &&
          params.data &&
          params.data.purchaseStatus.description === "Rechazada"
        ) {
          render +=
            '<md-button class="edit-button md-icon-button" ng-click="vm.deactiveInvoice(data)" aria-label="invoiceExceptionS"' +
            '                        translate translate-attr-aria-label="SETTLEMENT.VIEW_DETAILSX">' +
            '                 <md-tooltip md-direction="bottom">' +
            '                     {{"INVOICE.MSG.DEACTIVE_INVOICE"| translate}}' +
            "                 </md-tooltip>" +
            '                 <md-icon md-font-icon="icon-close-circle" class="s16 "></md-icon> ' +
            "             </md-button>";
        }

        if (
          $rootScope.getEspecialActionByName("Cancelar Pago") &&
          params.data &&
          params.data.purchaseStatus.description === "Pagada"
        ) {
          render +=
            '<md-button class="edit-button md-icon-button" ng-click="vm.cancePayment(data)" aria-label="invoiceExceptionS"' +
            '                        translate translate-attr-aria-label="SETTLEMENT.VIEW_DETAILSX">' +
            '                 <md-tooltip md-direction="bottom">' +
            '                     {{"INVOICE.MSG.CANCEL_PAYMENT"| translate}}' +
            "                 </md-tooltip>" +
            '                 <md-icon md-font-icon="icon-close-circle" class="s16 "></md-icon> ' +
            "             </md-button>";
        }

        render += "</div>";

        return render;
      };
    }

    function getFormedAmountCurrencyDescription(amountField, currencyField) {
      return function renderer(params) {
        var render = '<div style="width: 100%;">\n';
        render += "{{data." + currencyField + "}}";
        render += "{{data." + amountField + "| number:2}} ";
        render += "</div>";
        return render;
      };
    }

    function getTranslateValue(prefixTranslate, keyValue) {
      return function renderer(params) {
        var render = '<div style="width: 100%;">\n';
        render +=
          "{{'" + prefixTranslate + ".' + data." + keyValue + "| translate}} ";
        render += "</div>";
        return render;
      };
    }

    function statusForPDF(description) {
      if (description === "Ingresando") {
        return false;
      }

      if (description === "Editando") {
        return false;
      }

      if (description === "Cancelada") {
        return false;
      }

      if (description === "Rechazada") {
        return false;
      }

      return true;
    }

    function statusForContrasenaPago(description) {
      if (description === "Provisionada") {
        return true;
      }

      return false;
    }

    function statusForPDFOC(description) {
      if (description === "Pendiente Recibir") {
        return true;
      }

      if (description === "Primera Recepcion") {
        return true;
      }

      if (description === "Recibido") {
        return true;
      }

      return false;
    }

    vm.downloadPdf = function (parameter, id) {
      var theLink = $sce.trustAsResourceUrl(
        envService.read("baseUrlJReportsWSPdf") +
        "?rpt=" +
        $rootScope.getParameterValue(parameter).replace("[ID]", id)
      );

      var a = document.createElement("a");
      a.href = theLink;
      a.target = "_blank";
      a.download = "file.pdf";
      document.body.appendChild(a);
      a.click();
    };

    function getButtonsM(buttons) {
      return function renderer(params) {
        var render = '<div style="width: 100%;">\n';
        if (buttons.details) {
          render +=
            '<md-button class="edit-button md-icon-button" ng-click="vm.gotoDetail(data.id)" aria-label="Order details"' +
            '                  translate translate-attr-aria-label="REPORT.VIEW_DETAILS">' +
            '                 <md-tooltip md-direction="bottom">' +
            '                     {{"REPORT.VIEW_DETAILS"| translate}}' +
            "                 </md-tooltip>" +
            '                 <md-icon md-font-icon="icon-eye" class="s16"></md-icon> ' +
            "             </md-button>";
        }

        if (buttons.pdfEM) {
          render +=
            '<md-button class="edit-button md-icon-button" ng-click="vm.downloadPdf(\'JASPER_URL_ENTRADA_MERCANCIA\', data.id)" ' +
            ' aria-label="Order details"' +
            '                        translate translate-attr-aria-label="REPORT.VIEW_DETAILS">' +
            '                 <md-tooltip md-direction="bottom">' +
            '                     {{"REPORT.PDF_GENERAR"| translate}}' +
            "                 </md-tooltip>" +
            '                 <md-icon md-font-icon="icon-download" class="s16"></md-icon> ' +
            "             </md-button>";
        }

        if (buttons.showPdfEM) {
          render +=
            '<md-button class="edit-button md-icon-button" ng-click="vm.showPDF(\'JASPER_URL_ENTRADA_MERCANCIA\', data)" ' +
            ' aria-label="Order details"' +
            '                        translate translate-attr-aria-label="REPORT.VIEW_DETAILS">' +
            '                 <md-tooltip md-direction="bottom">' +
            '                     {{"REPORT.VER"| translate}}' +
            "                 </md-tooltip>" +
            '                 <md-icon md-font-icon="icon-clipboard-text" class="s16"></md-icon> ' +
            "             </md-button>";
        }

        if (
          buttons.pdfOC &&
          params.data &&
          statusForPDFOC(params.data.purchaseStatus.description)
        ) {
          render +=
            '<md-button class="edit-button md-icon-button" ng-click="vm.downloadPdf(\'JASPER_URL_ORDEN_COMPRA\', data.id)" aria-label="pdf"' +
            '                        translate translate-attr-aria-label="REPORT.VIEW_DETAILS">' +
            '                 <md-tooltip md-direction="bottom">' +
            '                     {{"REPORT.PDF_GENERAR"| translate}}' +
            "                 </md-tooltip>" +
            '                 <md-icon md-font-icon="icon-download" class="s16"></md-icon> ' +
            "             </md-button>";
        }

        if (
          buttons.showPdfOC &&
          params.data &&
          statusForPDFOC(params.data.purchaseStatus.description)
        ) {
          render +=
            '<md-button class="edit-button md-icon-button" ng-click="vm.showPDF(\'JASPER_URL_ORDEN_COMPRA\', data)" aria-label="ver"' +
            '         translate translate-attr-aria-label="REPORT.VIEW_DETAILS">' +
            '                 <md-tooltip md-direction="bottom">' +
            '                     {{"REPORT.VER"| translate}}' +
            "                 </md-tooltip>" +
            '                 <md-icon md-font-icon="icon-clipboard-text" class="s16"></md-icon> ' +
            "             </md-button>";
        }
        render += "</div>";

        return render;
      };
    }

    function getURL(buttons) {
      return function renderer(params) {
        if (buttons.link) {
          return (
            '<div style="width: 100%;"  layout-align="center center">' +
            '    <a ng-if="data.originType" href="" ng-click="vm.goToRef(data)">' +
            "{{vm.replaceOriginTypedata(data, data.originType.originTypeUrlDescription)}}</a> " +
            "   </div>"
          );
        } else {
          return "";
        }
      };
    }

    function goToRef(data) {
      window.open(data.originType.queryUrl + data.referenceId, "_blank");
    }

    /**
     * Go to product detail
     *
     * @param id
     */
    function gotoDetail(id) {
      $state.go(Report.stateDetail, {
        id: id,
        filter: vm.filter,
        backTo: $state.current.name,
        isClient: !Report.isProvider,
        isReport: true
      });
    }

    function fullWidthCellRendererFn(params) {
      params.$scope.id = params.data.id;
      if (Report.detailGrid) {
        params.$scope.detailGridOptions = Report.detailGrid.options;

        if (Report.detailGrid.exportXLS) {
          params.$scope.onExportDetailXLS = function () {
            var _params = {
              skipHeader: false,
              skipFooters: false,
              skipGroups: false,
              allColumns: true,
              onlySelected: false,
              fileName:
                Report.detailGrid.exportXLS.nameFile +
                params.$scope.id +
                "-" +
                new Date().getTime() +
                ".xls",
              columnSeparator: ",",
              sheetName: "data"
            };

            _params.processCellCallback = function (params) {
              if (params.column.colId.indexOf("fecha") !== -1) {
                return $filter('date')(params.value, FORMAT_DD_MM_YY);
              } else if (params.column.colId.indexOf("createdAt") !== -1) {
                return $filter('apiDate')(params.value, FORMAT_DD_MM_YY_HH_MM_SS);
              } else {
                return params.value;
              }
            };

            _params.processHeaderCallback = function (para) {
              return $filter("translate")(para.column.colDef.headerName);
            };

            params.$scope.detailGridOptions.api.exportDataAsExcel(_params);
          };
        }

        var dataSource = {
          paginationPageSize: pageSize,
          getRows: function (p) {
            vm.isShowProgressLinear = true;
            api.PresupuestosWS.BudgetDetail.getDetailByBuget(
              { idb: params.data.budgetId },
              function (response) {
                vm.isShowProgressLinear = false;

                p.successCallback(response, response.length);

                var floatingRows = [];
                var totalQuantity = 0;
                var totalAmount = 0;

                response.forEach(function (row, index) {
                  totalQuantity += row.quantity;
                  totalAmount += row.amount;
                });

                floatingRows.push({
                  product: {
                    name: $filter("translate")("general.totales")
                  },
                  quantity: totalQuantity,
                  amount: totalAmount
                });

                params.$scope.detailGridOptions.api.setPinnedBottomRowData(
                  floatingRows
                );
              },
              function (response) {
                vm.isShowProgressLinear = false;
              }
            );
          }
        };
        var mouseWheelListener = function (event) {
          event.stopPropagation();
        };

        setTimeout(function () {
          var container = document.querySelector(
            "#containerDetail" + params.$scope.id
          );

          container.addEventListener("mousewheel", mouseWheelListener);
          container.addEventListener("DOMMouseScroll", mouseWheelListener);

          params.$scope.detailGridOptions.api.setEnterpriseDatasource(
            dataSource
          );
        }, 1000);

        $rootScope.$on("$translateChangeSuccess", function () {
          params.$scope.detailGridOptions.api.setColumnDefs(
            vm.detailColumnDefs
          );
        });

        return templateDetail;
      }
      return true;
    }

    function clearSearchDepartment() {
      vm.searchDepartment = "";
    }

    function clearSearchCostCenter() {
      vm.searchCostCenter = "";
    }

    function clearSearchStatus() {
      vm.searchStatus = "";
    }
    function clearSettlementStatus() {
      vm.searchSettlementStatus = "";
    }

    function clearSearchProject() {
      vm.searchProject = "";
    }

    if ($stateParams.filter !== null && $stateParams.filter !== undefined) {
      $timeout(function () {
        vm.filter = angular.copy($stateParams.filter);
        vm.search();
      }, 1000);
    }

    $timeout(function () {
      var keyEvent = function (event) {
        event.stopPropagation();
      };

      var searchDepartmentInput = document.querySelector("#searchDepartment");
      var searchCostCenterInput = document.querySelector("#searchCostCenter");
      var searchStatusInput = document.querySelector("#searchStatus");
      var searchSettlementStatusInput = document.querySelector(
        "#searchSettlementStatus"
      );
      var searchProjectInput = document.querySelector("#searchProject");
      var searchTypeInput = document.querySelector("#searchType");

      if (searchDepartmentInput) {
        searchDepartmentInput.addEventListener("keydown", keyEvent);
      }
      if (searchCostCenterInput) {
        searchCostCenterInput.addEventListener("keydown", keyEvent);
      }
      if (searchStatusInput) {
        searchStatusInput.addEventListener("keydown", keyEvent);
      }
      if (searchSettlementStatusInput) {
        searchSettlementStatusInput.addEventListener("keydown", keyEvent);
      }
      if (searchProjectInput) {
        searchProjectInput.addEventListener("keydown", keyEvent);
      }
      if (searchTypeInput) {
        searchTypeInput.addEventListener("keydown", keyEvent);
      }

      if (
        $state.current.name === "app.report.quotationC" &&
        $stateParams.id !== null &&
        $stateParams.id !== undefined
      ) {
        vm.filter.id = $stateParams.id;
        vm.search();
      }
    }, 1000);

    function showPDF(parameterName, data) {
      var urlRpt = $rootScope
        .getParameterValue(parameterName)
        .replace("[ID]", data.id);

      $mdDialog
        .show({
          controller: "ReportShowPDFController",
          controllerAs: "vm",
          templateUrl: "app/main/apps/reports/dialogs/show-pdf/show-pdf.html",
          parent: angular.element("#main"),
          locals: {
            Url: urlRpt
          },
          clickOutsideToClose: false,
          fullscreen: true
        })
        .then(function (answer) { }, function () { });
    }

    vm.showPDFSettlement = function (parameter, data) {
      $log.debug("settlement in showPDFSettlement: ");
      $log.debug(data);
      $log.debug(parameter);

      var urlRpt = $rootScope
        .getParameterValue(parameter)
        .replace("[ID]", data.settlementId);

      $mdDialog
        .show({
          controller: "ReportShowPDFController",
          controllerAs: "vm",
          templateUrl: "app/main/apps/reports/dialogs/show-pdf/show-pdf.html",
          parent: angular.element("#main"),
          locals: {
            Url: urlRpt
          },
          clickOutsideToClose: false,
          fullscreen: true
        })
        .then(function (answer) { }, function () { });
    };

    vm.openSettlement = function (id) {
      $state.go("app.expenseSettlement.settlement.settlementView", {
        settlementId: id,
        backTo: $state.current.name,
        filter: vm.filter
      });
    };

    function showInterfazDetail(data) {
      $mdDialog
        .show({
          controller: "InterfazReportDetailController",
          controllerAs: "vm",
          templateUrl:
            "app/main/apps/reports/dialogs/show-interfaz-detail/show-interfaz-detail.html",
          parent: angular.element("#main"),
          targetEvent: event,
          locals: {
            entity: vm.entity,
            id: data.id,
            companyId: data.companyBuyer.id
          },
          clickOutsideToClose: false
        })
        .then(function (response) { }, function (response) { });
    }

    function showInvoiceDetail(data) {
      $mdDialog
        .show({
          controller: "InvoiceReportDetailController",
          controllerAs: "vm",
          templateUrl:
            "app/main/apps/reports/dialogs/show-invoiceView-detail/show-invoiceView-detail.html",
          parent: angular.element("#main"),
          targetEvent: event,
          locals: {
            entity: vm.entity,
            settlementId: data.settlementId,
            detail: data,
            invoiceId: data.invoicePurchaseId
          },
          clickOutsideToClose: false
        })
        .then(function (response) { }, function (response) { });
    }

    $timeout(function () {
      if (Report.filter.searchOnLoad) {
        search();
      }
    }, 1000);

    function selectContractsValid() {
      vm.filter.statuses = [];
      vm.snFilter.status = !vm.snFilter.status;
      vm.snFilter.filterByDates = !vm.snFilter.filterByDates;
      vm.filter.noFilterDate = !vm.filter.noFilterDate;
    }

    function exceptionLimitDate(data) {
      var confirm = $mdDialog
        .confirm()
        .title($filter("translate")("INVOICE.MSG.EXCEPTION_LIMIT_DATE"))
        .textContent(
          $filter("translate")("INVOICE.MSG.CONFIRMACION_EXCEPTION_LIMIT_DATE")
        )
        .ok($filter("translate")("INVOICE.MSG.SI"))
        .cancel($filter("translate")("INVOICE.MSG.NO"));
      $mdDialog.show(confirm).then(
        function (inf) {
          api.ComprasWS.Settlement.limitDateException.update(
            {
              idCircle: $rootScope.bsCircle.id,
              settlementId: data.settlementId
            },
            function (response) {
              if (response) {
                MessageService.show(
                  "INVOICE.MSG.EXCEPTION_LIMIT_DATE_SUCCESSFULLY"
                );
              }
            },
            function (err) { }
          );
        },
        function (err) { }
      );
    }

    vm.invoiceExceptionLimitDate = invoiceExceptionLimitDate;
    function invoiceExceptionLimitDate(data) {
      var confirm = $mdDialog
        .confirm()
        .title($filter("translate")("INVOICE.MSG.EXCEPTION_LIMIT_DATE"))
        .textContent(
          $filter("translate")("INVOICE.MSG.CONFIRMACION_EXCEPTION_LIMIT_DATE")
        )
        .ok($filter("translate")("INVOICE.MSG.SI"))
        .cancel($filter("translate")("INVOICE.MSG.NO"));
      $mdDialog.show(confirm).then(
        function (inf) {
          $rootScope.loadingProgress = true;
          api.ComprasWS.Invoices.limitDateException.update(
            { id: data.id },
            function (response) {
              $rootScope.loadingProgress = false;
              if (response) {
                MessageService.show(
                  "INVOICE.MSG.EXCEPTION_LIMIT_DATE_SUCCESSFULLY"
                );

                search();
              }
            },
            function (err) {
              $rootScope.loadingProgress = false;
            }
          );
        },
        function (err) { }
      );
    }

    vm.clearSearchCompany = function () {
      vm.searchCompany = "";
    };

    vm.viewChangeStatus = function (settlement, ev) {
      $mdDialog
        .show({
          controller: "changeStatusController",
          controllerAs: "vm",
          templateUrl:
            "app/main/apps/expenseSettlements/settlements/settlement/settlementEditor/changeStatus/changeStatus.html",
          targetEvent: ev,
          locals: {
            settlementId: settlement.id
          },
          clickOutsideToClose: false
        })
        .then(function (answer) { });
    };

    vm.cancelProvision = function (settlement) {
      $rootScope.loadingProgress = true;
      var confirm = $mdDialog
        .confirm()
        .title(
          $filter("translate")(
            "EXPENSE_SETTLEMENTS.PROVISIONED.MSG_SURE_CANCEL_PROVISION"
          )
        )
        .content(
          $filter("translate")(
            "EXPENSE_SETTLEMENTS.PROVISIONED.MSG_CANCEL_PROVISION"
          )
        )
        .ariaLabel("Delete Detail")
        .ok($filter("translate")("SETTLEMENT.OK"))
        .cancel($filter("translate")("SETTLEMENT.CANCEL"));
      $mdDialog.show(confirm).then(
        function () {
          $rootScope.loadingProgress = true;
          api.ComprasWS.Settlement.cancelProvisionSettlement
            .cancel({
              settlementId: settlement.id,
              idCircle: $rootScope.bsCircle.id
            })
            .$promise.then(
              function (response) {
                if (settlement.erpReference === null) {
                  MessageService.show(
                    $filter("translate")(
                      "EXPENSE_SETTLEMENTS.PROVISIONED.CANCEL_PROVISION_OK2"
                    )
                  );
                } else {
                  MessageService.show(
                    $filter("translate")(
                      "EXPENSE_SETTLEMENTS.PROVISIONED.CANCEL_PROVISION_OK"
                    )
                  );
                }
                vm.masterGridOptions.api.redrawRows();
                $rootScope.loadingProgress = false;
              },
              function (error) {
                $log.error(error.data);
                MessageService.show(
                  $filter("translate")(
                    "EXPENSE_SETTLEMENTS.PROVISIONED.CANCEL_PROVISION_ERROR"
                  )
                );
              }
            );
        },
        function () {
          // Cancel Action
          $rootScope.loadingProgress = false;
        }
      );
    };

    vm.viewErpHistory = function (settlement) {
      $log.debug(settlement);
      $mdDialog
        .show({
          controller: "InterfazReportDetailController",
          controllerAs: "vm",
          templateUrl:
            "app/main/apps/reports/dialogs/show-interfaz-detail/show-interfaz-detail.html",
          parent: angular.element("#main"),
          targetEvent: event,
          locals: {
            entity: vm.entity,
            id: settlement.settlementId,
            companyId: settlement.companyId
          },
          clickOutsideToClose: false
        })
        .then(function (response) { }, function (response) { });
    };

    vm.cancelPayment = cancelPayment;
    function cancelPayment(settlement) {
      $rootScope.loadingProgress = true;
      var confirm = $mdDialog
        .confirm()
        .title($filter("translate")("PAID_SETTLEMENT.MSG_SURE_CANCEL_PAYMENT"))
        .content($filter("translate")("PAID_SETTLEMENT.MSG_CANCEL_PAYMENT"))
        .ariaLabel("Delete Detail")
        .ok($filter("translate")("SETTLEMENT.OK"))
        .cancel($filter("translate")("SETTLEMENT.CANCEL"));
      $mdDialog.show(confirm).then(
        function () {
          $rootScope.loadingProgress = true;
          api.ComprasWS.Settlement.cancelPaymentSettlement
            .cancel({
              settlementId: settlement.settlementId,
              idCircle: $rootScope.bsCircle.id
            })
            .$promise.then(
              function (response) {
                $rootScope.loadingProgress = false;
                MessageService.show(
                  $filter("translate")("PAID_SETTLEMENT.CANCEL_PAYMENT_OK")
                );

                search();
              },
              function (error) {
                $rootScope.loadingProgress = false;
                $log.error(error);
                $log.error(error.data);
                MessageService.showErrorMessage(
                  $filter("translate")("PAID_SETTLEMENT.CANCEL_PAYMENT_ERROR")
                );
              }
            );
        },
        function () {
          $rootScope.loadingProgress = false;
        }
      );
    }

    vm.deactiveInvoice = function (data) {
      var confirm = $mdDialog
        .confirm()
        .title($filter("translate")("INVOICE.MSG.DEACTIVE_INVOICE"))
        .content($filter("translate")("INVOICE.MSG.DEACTIVE_INVOICE_Confirm"))
        .ariaLabel("Deactive Detail")
        .ok($filter("translate")("SETTLEMENT.OK"))
        .cancel($filter("translate")("SETTLEMENT.CANCEL"));
      $mdDialog.show(confirm).then(
        function () {
          $rootScope.loadingProgress = true;
          api.ComprasWS.Invoices.deactivate.update(
            { id: data.id },
            function (response) {
              $rootScope.loadingProgress = false;
              MessageService.show(
                $filter("translate")(
                  "INVOICE.MSG.DEACTIVE_INVOICE_successfully"
                )
              );
              search();
            },
            function (errResponse) {
              $rootScope.loadingProgress = false;
            }
          );
        },
        function () { }
      );
    };

    vm.cancePayment = function (data) {
      var confirm = $mdDialog
        .confirm()
        .title($filter("translate")("INVOICE.MSG.CANCEL_PAYMENT"))
        .content($filter("translate")("INVOICE.MSG.CANCEL_PAYMENT_Confirm"))
        .ariaLabel("Deactive Detail")
        .ok($filter("translate")("SETTLEMENT.OK"))
        .cancel($filter("translate")("SETTLEMENT.CANCEL"));
      $mdDialog.show(confirm).then(
        function () {
          $rootScope.loadingProgress = true;
          api.ComprasWS.Invoices.cancelPayment.update(
            { id: data.id },
            function (response) {
              $rootScope.loadingProgress = false;
              MessageService.show(
                $filter("translate")("INVOICE.MSG.CANCEL_PAYMENT_successfully")
              );
              search();
            },
            function (errResponse) {
              $rootScope.loadingProgress = false;
            }
          );
        },
        function () { }
      );
    };

    function loadTypes() {
      if (Report.title === "SETTLEMENT") {
        api.ComprasWS.pettyCashType.query(
          {},
          function (response) {
            vm.typeses = response;
          },
          function (errResponse) { }
        );
      }
    }

    $timeout(function () {
      var keyEvent = function (event) {
        event.stopPropagation();
      };

      var searchCompanyInput = document.querySelector("#searchCompany");

      if (searchCompanyInput) {
        searchCompanyInput.addEventListener("keydown", keyEvent);
      }
    }, 500);

    function selectAllItemsCompanies(companyId) {
      $timeout(function () {
        if (companyId === '-1' && vm.filter.companies.length === 1) {
          vm.filter.companies = vm.companies.map(function (company) {
            return company.id;
          });
          vm.filter.companies.push('-1');
        } else if (companyId === '-1' && vm.filter.companies.length > 1) {
          vm.filter.companies = [];
        }
        $timeout(function () {
          changeDeptoAndCCByCompany();
        }, vm.THREE_HUNDRED);
      }, vm.THREE_HUNDRED);
    }

    function changeDeptoAndCCByCompany() {
      vm.isShowProgressLinear = true;
      vm.loadingCompanies = true;
      vm.filter.departments = [];
      vm.filter.costCenters = [];
      vm.departments = [];
      vm.costCenters = [];
      $timeout(function () {
        if (vm.filter.companies && vm.filter.companies.length > 0) {
          vm.filter.companies.forEach(function (a) {
            vm.isShowProgressLinear = true;
            params = { idc: a };

            vm.loadingDepartments = true;
            api.GeneralWS.getAllDepartment.query(params, function (data) {
              vm.departments = vm.departments.concat(data);
              vm.loadingDepartments = false;
              vm.isShowProgressLinear = false;
            });

            vm.loadingCostCenter = true;
            api.GeneralWS.getAllCost.query(params, function (data) {
              vm.costCenters = vm.costCenters.concat(data);
              vm.loadingCostCenter = false;
              vm.isShowProgressLinear = false;
            });
          });
          vm.loadingCompanies = false;
          vm.isShowProgressLinear = false;
        } else {
          loadDepartments();
          loadCostCenter();
          vm.loadingCompanies = false;
          vm.isShowProgressLinear = false;
        }
      }, 200);
    }

    function selectAllItemsDepartments(departmentId) {
      vm.isShowProgressLinear = true;
      vm.loadingDepartments = true;
      $timeout(function () {
        if (vm.filter.departments.length === 1 && departmentId === '-1') {
          vm.filter.departments = vm.departments.map(function (a) {
            return a.id;
          });
          vm.filter.departments.push('-1');
        } else if (vm.filter.departments.length > 1 && departmentId === '-1') {
          vm.filter.departments = [];
        } else {
          $log.debug('valor inesperado para filtro');
        }
        vm.loadingDepartments = false;
        vm.isShowProgressLinear = false;
      }, vm.THREE_HUNDRED);
    }

    function selectAllItemsCostCenters(ccId) {
      vm.isShowProgressLinear = true;
      vm.loadingCostCenters = true;
      $timeout(function () {
        if (vm.filter.costCenters.length === 1 && ccId === '-1') {
          vm.filter.costCenters = vm.costCenters.map(function (a) {
            return a.id;
          });
          vm.filter.costCenters.push('-1');
        } else if (ccId === '-1' && vm.filter.costCenters.length > 1) {
          vm.filter.costCenters = [];
        } else {
          $log.debug('valor inesperado para filtro');
        }
        vm.loadingCostCenters = false;
        vm.isShowProgressLinear = false;
      }, vm.THREE_HUNDRED);
    }

    function selectCompanies(typeCompany) {
      let idCompanies = vm.filter.companies;
      if (typeCompany === TEXT_PROVIDERS) {
        idCompanies = vm.filter.providers;
      }
      $mdDialog
        .show({
          controller: 'DialogCompaniesController',
          controllerAs: 'vm',
          templateUrl: 'app/main/apps/reports/dialogs/dialog-companies/dialog-companies.html',
          parent: angular.element('#main'),
          locals: {
            'companiesIds': idCompanies,
            'type': typeCompany
          },
          clickOutsideToClose: false,
          fullscreen: true
        })
        .then(function (answer) {
          if (typeCompany === TEXT_PROVIDERS) {
            vm.filter.providers = [];
          } else {
            vm.filter.companies = [];
          }
          answer.forEach(function (comp) {
            if (typeCompany === TEXT_PROVIDERS) {
              vm.filter.providers.push(comp.id);
            } else {
              vm.filter.companies.push(comp.id);
            }

          });
          if (typeCompany !== TEXT_PROVIDERS) {
            vm.namesCompaniesDialogArr = answer.map(function (comp) {
              return comp.name;
            });
            vm.namesCompaniesDialog = vm.namesCompaniesDialogArr.join();
            getDepartmentsAndCostCentersByCompaniesIds();
          } else {
            vm.namesProvidersArr = answer.map(function (comp) {
              return comp.name;
            });
            vm.namesProviders = vm.namesProvidersArr.join();
          }
        });
    }

    function getDepartmentsAndCostCentersByCompaniesIds() {
      vm.loadingDepartments = true;
      vm.loadingCostCenter = true;
      vm.departments = [];
      vm.costCenters = [];
      vm.filter.departments = [];
      vm.filter.costCenters = [];
      vm.loadingDepartments = true;
      api.GeneralWS.getAllDepartmentByCompanyIds.query({ 'idc': 0 }, vm.filter.companies, function (data) {
        data.forEach(function (department) {
          vm.departments.push(department);
        });
        vm.loadingDepartments = false;
      });

      api.GeneralWS.getAllCostByCompanyIds.query({ 'idc': 0 }, vm.filter.companies, function (data) {
        vm.loadingCostCenter = true;
        data.forEach(function (costCenter) {
          vm.costCenters.push(costCenter);
        });
        vm.loadingCostCenter = false;
      });
      if (!vm.filter.companies || vm.filter.companies.length === 0) {
        vm.loadingCostCenter = false;
        vm.loadingDepartments = false;
      }
    }

    function selectAllItemsStatus(statusId) {
      $timeout(function () {
        if (statusId === '-1' && vm.filter.statusesInvoice.length === 1) {
          vm.filter.statusesInvoice = vm.statusesInvoice.map(function (status) {
            return status.id;
          });
          vm.filter.statusesInvoice.push('-1');
        } else if (statusId === '-1' && vm.filter.statusesInvoice.length > 1) {
          vm.filter.statusesInvoice = [];
        }
      }, vm.THREE_HUNDRED);
    }

  }
})();

(function () {
  "use strict";

  angular
    .module("app.generalReports")
    .controller("GeneralReportsController", GeneralReportsController);

  /** @ngInject */
  function GeneralReportsController(
    $mdSidenav,
    $stateParams,
    Report,
    api,
    $rootScope,
    $state,
    $timeout,
    $templateRequest,
    $sce,
    $log,
    $filter,
    $mdDialog,
    envService,
    MessageService
  ) {
    var vm = this;

    var pageSize = Report.pageSize;
    vm.minDate = new Date();
    var params = { idc: $rootScope.bsCircle.company.id };
    vm.filter = {
      startDate: new Date(vm.minDate.getTime()),
      endDate: new Date(vm.minDate.getTime()),
      isProvider: Report.isProvider,
      appName: Report.filter.appName,
      isGeneral: Report.filter.isGeneral
    };
    vm.changeDeptoAndCCByCompany = changeDeptoAndCCByCompany;

    if ($stateParams.isTicket) {
      vm.filter.originTypeCode = "01";
    }

    vm.exportXLS = Report.exportXLS;
    vm.snFilter = Report.filter;
    vm.title = Report.title;
    vm.masterColumnDefs = Report.columns;
    vm.isShowFilter = true;
    vm.loadSettlementStatus = loadSettlementStatus;
    var filter = "everyone";
    vm.totalquantity = 0;
    vm.totalsubTotalAfterTax = 0;

    //metodos
    vm.clearSearchDepartment = clearSearchDepartment;
    vm.clearSearchCostCenter = clearSearchCostCenter;
    vm.clearSearchStatus = clearSearchStatus;
    vm.clearSettlementStatus = clearSettlementStatus;
    vm.clearSearchProject = clearSearchProject;
    vm.goToRef = goToRef;
    vm.replaceOriginTypedata = replaceOriginTypedata;
    vm.showPDF = showPDF;
    vm.rejectInvoice = rejectInvoice;
    vm.showInterfazDetail = showInterfazDetail;
    vm.selectContractsValid = selectContractsValid;
    vm.showInvoiceDetail = showInvoiceDetail;
    vm.statuses = [];
    vm.typeses = [];
    vm.exceptionLimitDateButton = false;
    vm.exceptionLimitDate = exceptionLimitDate;

    rowsColumns();

    vm.api = api;
    Report.api.forEach(function (d) {
      vm.api = vm.api[d];
    });

    function correctFilter(column) {
      switch (column.dataTypes) {
        case "Long":
        case "BigDecimal":
        case "Double":
        case "Integer":
          column.filter = "number";
          break;
        case "text":
          column.filter = "text";
          break;
        default:
          column.filter = "date";
          break;
      }
      correctFilterParams(column);
    }

    function correctFilterParams(column) {
      switch (column.filter) {
        case "number":
          column.filterParams = {
            filterOptions: ["equals"],
            newRowsAction: "keep"
          };
          break;
        case "text":
          column.filterParams = {
            filterOptions: ["contains"],
            newRowsAction: "keep"
          };
          break;
        case "date":
          column.suppressFilter = true;
          break;
      }
    }

    function rowsColumns() {
      vm.masterColumnDefs.forEach(function (d) {
        d.headerCellRenderer = function () {
          return "{{'" + d.headerName + "'|translate}}";
        };
        if (d.valueFormatter) {
          d.valueFormatter = getCellFormater(d.valueFormatter);
        }
        if (d.rendererCurrencyDescAmount) {
          d.cellRenderer = getFormedAmountCurrencyDescription(
            d.rendererCurrencyDescAmount.amountField,
            d.rendererCurrencyDescAmount.currecyField
          );
          delete d.rendererCurrencyDescAmount;
        }
        if (d.rendererButtons) {
          d.cellRenderer = getButtons(d.rendererButtons);
          delete d.rendererButtons;
        }
        if (d.rendererLink) {
          d.cellRenderer = getURL(d.rendererLink);
          delete d.rendererLink;
        }
        if (d.rendererButtonsM) {
          d.cellRenderer = getButtonsM(d.rendererButtonsM);
          delete d.rendererButtonsM;
        }
        if (d.rendererTranslateValue) {
          d.cellRenderer = getTranslateValue(
            d.rendererTranslateValue.prefixTranslate,
            d.rendererTranslateValue.keyValue
          );
          delete d.rendererTranslateValue;
        }
        if (d.dataTypes) {
          correctFilter(d);
        }
      });
    }

    var gridOptions = Report.masterGridOptions;
    if (Report.detailGrid) {
      var templateDetail = null;
      vm.loadTemplate = function () {
        var otherTemplate = $sce.getTrustedResourceUrl(
          Report.detailGrid.templateUrl
        );
        $templateRequest(otherTemplate).then(
          function (template) {
            templateDetail = template;
          },
          function () {
            $log.error("Ocurrio un error al leer el template");
          }
        );
      };

      gridOptions.fullWidthCellRenderer = fullWidthCellRendererFn;
      gridOptions.isFullWidthCell = function (rowNode) {
        return rowNode.level === 1;
      };
      gridOptions.getRowHeight = function (params) {
        var rowIsDetailRow = params.node.level === 1;

        return rowIsDetailRow ? 450 : 45;
      };
    }
    gridOptions.doesDataFlower = function (dataItem) {
      if (dataItem.quantity) {
        vm.totalquantity += dataItem.quantity;
      }
      if (dataItem.subTotalAfterTax) {
        vm.totalsubTotalAfterTax += dataItem.subTotalAfterTax;
      }
      //
    };

    gridOptions.onFilterChanged = function (c, d, e, f) {
      delete vm.filter.totalElements;
    };

    if (gridOptions.autoGroupColumnDef) {
      gridOptions.autoGroupColumnDef.headerCellRenderer = function (name) {
        return "{{'" + name.value + "'|translate}}";
      };
    }

    gridOptions.doesExternalFilterPass = function (node) {
      if (filter && filter !== "everyone") {
        var arrdt = node.data.filter.split(filter.toLowerCase());
        return arrdt.length > 1;
      }
      return true;
    };

    gridOptions.isExternalFilterPresent = function () {
      return filter !== "";
    };

    gridOptions.localeTextFunc = function (key, defaultValue) {
      return translateGrid(key, defaultValue, $filter);
    };

    gridOptions.getMainMenuItems = function (params) {
      params.columnApi.getAllColumns().forEach(function (r) {
        r.colDef.hN = r.colDef.hN
          ? r.colDef.hN
          : angular.copy(r.colDef.headerName);
        r.colDef.headerName = $filter("translate")(r.colDef.hN);
      });
      return params.defaultItems;
    };

    gridOptions.columnDefs = vm.masterColumnDefs;

    gridOptions.components = {
      customPinnedRowRenderer: CustomPinnedRowRenderer
    };

    vm.masterGridOptions = gridOptions;

    function CustomPinnedRowRenderer() { }

    CustomPinnedRowRenderer.prototype.init = function (params) {
      this.eGui = document.createElement("div");
      this.eGui.style = params.style;
      this.eGui.innerHTML = params.value;
    };

    CustomPinnedRowRenderer.prototype.getGui = function () {
      return this.eGui;
    };

    if (vm.snFilter.companies) {
      loadCompanyByRole();
    }

    if (vm.snFilter.department) {
      if (vm.filter.originTypeCode === "01" || Report.filter.queryAll) {
        loadByDepartmentsCompany();
      } else {
        loadDepartments();
      }
    }
    if (vm.snFilter.costCenter) {
      if (vm.filter.originTypeCode === "01" || Report.filter.queryAll) {
        loadByCostCentersCompany();
      } else {
        loadCostCenter();
      }
    }

    if (vm.snFilter.project) {
      loadProjects();
    }

    if (vm.snFilter.status) {
      loadStatus();
    }

    if (Report.statusFilter) {
      loadStatus();
    }

    if (vm.snFilter.SettlementStatus) {
      loadSettlementStatus();
    }

    if (vm.snFilter.pettyCashStatus) {
      loadPettyCashStatus();
    }

    if (vm.snFilter.entities) {
      loadEntityCatalog();
    }

    if (vm.snFilter.type) {
      loadTypes();
    }

    if (vm.exportXLS) {
      vm.onExportXLS = function () {
        var params = {
          skipHeader: false,
          skipFooters: false,
          skipGroups: false,
          allColumns: true,
          onlySelected: false,
          fileName: Report.exportXLS.nameFile + new Date().getTime() + ".xls",
          columnSeparator: ",",
          sheetName: "data"
        };

        params.processCellCallback = function (params) {
          if (params.column.colId.indexOf("fecha") !== -1) {
            return $filter("date")(params.value, "dd/MM/yyyy");
          } else if (params.column.colId.indexOf("createdAt") !== -1) {
            return $filter("apiDate")(params.value, "dd/MM/yyyy HH:mm:ss");
          } else {
            return params.value;
          }
        };

        params.processHeaderCallback = function (params) {
          return $filter("translate")(params.column.colDef.headerName);
        };

        vm.masterGridOptions.api.exportDataAsExcel(params);
      };
    }

    // Methods
    vm.search = search;
    vm.gotoDetail = gotoDetail;
    vm.toggleSidenav = toggleSidenav;
    vm.changeStartDate = changeStartDate;

    //////////
    if (Report.verticalFilter) {
      $timeout(function () {
        toggleSidenav("main-sidenav");
      }, 300);
    }

    function getCellFormater(type) {
      switch (type) {
        case "date":
          return function (params) {
            if (params.value) {
              return $filter("date")(params.value, "dd/MM/yyyy");
            }
            return '';
          };
        case "currency":
          return function (params) {
            if (params.value) {
              return $filter("number")(params.value, "2");
            }
            return '';
          };
        case "localDateTime":
          return function (params) {
            if (params.value) {
              return $filter("apiDate")(params.value, "dd/MM/yyyy HH:mm:ss");
            }
            return '';
          };
        case "dateTime":
          return function (params) {
            if (params.value) {
              return $filter("date")(params.value, "dd/MM/yyyy HH:mm:ss");
            }
            return '';
          };
        case "boolean":
          return function (params) {
            if (params.value) {
              return '<md-icon md-font-icon="icon-checkbox-marked-circle green-500-fg"></md-icon>';
            }
            return '<md-icon md-font-icon="icon-cancel red-500-fg"></md-icon>';
          };

        default:
          break;
      }
    }

    function fixDataTypesFilters(arr) {
      if (arr) {
        arr.forEach(function (r) {
          if (r.filterType === "number") {
            var clDef = vm.masterGridOptions.api.getColumnDef(r.field);
            r.filterType = clDef.dataTypes ? clDef.dataTypes : "number";
          }
        });
      }
    }

    function createNewDatasource() {
      vm.totalquantity = 0;
      vm.totalsubTotalAfterTax = 0;

      vm.masterGridOptions.api.setRowData([]);

      vm.masterGridOptions.api.paginationSetPageSize(pageSize);

      var o = vm.masterGridOptions.api.getFilterModel();
      var parameters = {
        circle: $rootScope.bsCircle.id,
        idCircle: $rootScope.bsCircle.id,
        company: $rootScope.bsCircle.company.id,
        electronic: vm.electronic,
        page: vm.masterGridOptions.api.paginationGetCurrentPage(),
        pageSize: pageSize
      };
      var arr = $.map(o, function (k, ke, sd, ds) {
        var on = k;
        on.field = ke;
        on.filter = on.filter.toString();
        return on;
      });
      fixDataTypesFilters(arr);
      vm.parameters = parameters;
      vm.isShowProgressLinear = true;
      vm.filter.sorts = vm.masterGridOptions.api.getSortModel();
      vm.filter.filters = arr;
      vm.api(
        parameters,
        vm.filter,
        function (response) {
          vm.isShowProgressLinear = false;
          vm.showGrid = true;
          vm.filter.totalElements = response.totalElements;
          vm.filter.id = null;
          vm.masterGridOptions.api.setRowData(response.content);
          var result = [];
          result.push({
            provider: "",
            quantity: $filter("number")(vm.totalquantity),
            product: "",
            price: "",
            department: "",
            costCenter: "",
            status: "",
            description: "",
            subTotalAfterTax: vm.totalsubTotalAfterTax
          });
          vm.masterGridOptions.api.setPinnedBottomRowData(result);

          vm.hasData = response.content.length > 0;
        },
        function (response) {
          vm.isShowProgressLinear = false;
          $log.error(response);
        }
      );
    }

    /**
     * Select an item
     *
     * @param item
     */
    function search() {
      if (vm.snFilter.isGeneral && !vm.snFilter.filterByDates) {
        delete vm.filter.startDate;
        delete vm.filter.endDate;
      } else {
        if (!vm.filter.startDate) {
          vm.filter.startDate = new Date();
        }
        if (!vm.filter.endDate) {
          vm.filter.endDate = new Date();
        }
        vm.filter.startDate.setHours(0);
        vm.filter.startDate.setMinutes(0);
        vm.filter.startDate.setSeconds(0);

        vm.filter.endDate.setHours(23);
        vm.filter.endDate.setMinutes(59);
        vm.filter.endDate.setSeconds(59);
      }

      if (!Report.filter.queryAll) {
        if (!vm.filter.departments || vm.filter.departments.length <= 0) {
          vm.filter.departments = [];

          if (vm.departments) {
            for (var i = 0; i < vm.departments.length; i++) {
              vm.filter.departments.push(vm.departments[i].id);
            }
          } else {
            vm.filter.departments.push(-1000);
          }
        }

        if (!vm.filter.costCenters || vm.filter.costCenters.length <= 0) {
          vm.filter.costCenters = [];

          if (vm.costCenters) {
            for (var j = 0; j < vm.costCenters.length; j++) {
              vm.filter.costCenters.push(vm.costCenters[j].id);
            }
          } else {
            vm.filter.costCenters.push(-1000);
          }
        }
      }

      if (!vm.filter.statuses || vm.filter.statuses.length <= 0) {
        vm.filter.statuses = [];

        if (vm.statuses) {
          for (var k = 0; k < vm.statuses.length; k++) {
            vm.filter.statuses.push(vm.statuses[k].id);
          }
        } else {
          vm.filter.statuses.push(-1000);
        }
      }

      if (vm.snFilter.isRejectedAutomatically) {
        vm.filter.isRejectedAutomatically = vm.snFilter.isRejectedAutomatically;
      }

      delete vm.filter.totalElements;
      vm.masterGridOptions.api.setColumnDefs(vm.masterColumnDefs);
      createNewDatasource();
      vm.isShowFilter = false;
    }

    function loadCostCenter() {
      vm.loadingCostCenter = true;
      api.GeneralWS.CostCenter.query(params, function (data) {
        if (data.length === 1) {
          vm.filter.costCenters = [data[0].id.toString()];
        }
        vm.costCenters = data;
        vm.loadingCostCenter = false;
      });
    }

    function loadDepartments() {
      vm.loadingDepartments = true;
      api.GeneralWS.Department.query(params, function (data) {
        if (data.length === 1) {
          vm.filter.departments = [data[0].id.toString()];
        }
        vm.departments = data;
        vm.loadingDepartments = false;
      });
    }

    function loadProjects() {
      vm.loadingProject = true;
      api.ProyectosWS.getAll.query(
        { companyId: $rootScope.bsCircle.company.id },
        function (data) {
          vm.projects = data;
          vm.loadingProject = false;
        }
      );
    }

    function loadByDepartmentsCompany() {
      vm.loadingDepartments = true;
      api.GeneralWS.getAllDepartment.query(params, function (data) {
        vm.departments = data;
        vm.loadingDepartments = false;
      });
    }

    function loadByCostCentersCompany() {
      vm.loadingCostCenter = true;
      api.GeneralWS.getAllCost.query(params, function (data) {
        vm.costCenters = data;
        vm.loadingCostCenter = false;
      });
    }

    function loadCompanyByRole() {
      vm.loadingCompanies = true;
      params.idCircle = $rootScope.bsCircle.id;
      api.GeneralWS.Usr.User.Company.CompanyRolUser.page(params, function (
        data
      ) {
        if (data.length === 1) {
          vm.filter.companies = [data[0].id.toString()];
        }
        vm.companies = data;
        vm.loadingCompanies = false;
      });
    }

    function loadStatus() {
      vm.loadingStatus = true;
      api.ComprasWS.PurchaseStatus.query({ type: Report.statusType }, function (
        data
      ) {
        if (data.length === 1) {
          vm.filter.status = [data[0].id.toString()];
        }
        vm.statuses = data;
        vm.loadingStatus = false;
        if (Report.statusFilter) {
          vm.filter.statuses = [];
          Report.statusFilter.forEach(function (status) {
            vm.statuses.forEach(function (data) {
              if (status === data.description) {
                vm.filter.statuses.push(data.id);
              }
            });
          });
        }
      });
    }
    function loadSettlementStatus() {
      vm.loadingStatus = true;
      api.ComprasWS.Settlement.SettlementStatus.query({}, function (data) {
        if (data.length === 1) {
          vm.filter.settlementStatus = [data[0].id.toString()];
        }
        vm.settlementStatus = data;
        if ($stateParams.status === "Provisionada") {
          vm.settlementStatus.forEach(function (sts) {
            if (sts.name === "Provisionada") {
              vm.filter.settlementStatus = [sts.id.toString()];
              vm.settlementStatus = [sts];
            }
          });
        }
        if ($stateParams.status === "Pagada") {
          vm.settlementStatus.forEach(function (sts) {
            if (sts.name === "Pagada") {
              vm.filter.settlementStatus = [sts.id.toString()];
              vm.settlementStatus = [sts];
            }
          });
        }
        vm.loadingSettlementStatus = false;
      });
    }
    function loadPettyCashStatus() {
      vm.loadingStatus = true;
      vm.pettyCashStatus = [
        { id: false, name: "En Proceso" },
        { id: true, name: "Finalizada" }
      ];
    }

    function loadEntityCatalog() {
      vm.loadingEntity = true;
      api.InterfazWS.EntityCatalog.me.query({}).$promise.then(
        function (response) {
          vm.loadingEntity = false;
          vm.entityCatalog = response;

          for (var i = 0; i < response.length; i++) {
            if (response[i].entityName === "invoicepurchase") {
              vm.entity = response[i];
            }
          }
        },
        function (response) {
          vm.loadingEntity = false;
          $log.error(response);
        }
      );
    }

    function changeStartDate(isStart) {
      if (isStart) {
        if (vm.filter.startDate > vm.filter.endDate) {
          vm.filter.endDate = vm.filter.startDate;
        }
      }
      vm.filter.startDate = setDateType(vm.filter.startDate, false);
      vm.filter.endDate = setDateType(vm.filter.endDate, true);
    }

    function setDateType(date, end) {
      if (end) {
        date.setHours(23);
        date.setMinutes(59);
        date.setSeconds(59);
      } else {
        date.setHours(0);
        date.setMinutes(0);
        date.setSeconds(0);
      }
      return date;
    }

    /**
     * Toggle sidenav
     *
     * @param sidenavId
     */
    function toggleSidenav(sidenavId) {
      $mdSidenav(sidenavId).toggle();
    }

    function rejectInvoice(data) {
      var confirm = $mdDialog
        .confirm()
        .title($filter("translate")("INVOICE.MSG.Rechazada_INVOICE"))
        .textContent(
          $filter("translate")("INVOICE.MSG.CONFIRMACION_Rechazada_INVOICE")
        )
        .ok($filter("translate")("INVOICE.MSG.SI"))
        .cancel($filter("translate")("INVOICE.MSG.NO"));
      $mdDialog.show(confirm).then(
        function () {
          $rootScope.loadingProgress = true;
          api.ComprasWS.InvoicePurchase.setStatus(
            {
              id: "changeStatus",
              idCircle: $rootScope.bsCircle.id,
              status: "Emitida",
              cancelInErp: true
            },
            data
          ).$promise.then(
            function (response) {
              $rootScope.loadingProgress = false;
              MessageService.show(
                $filter("translate")("INVOICE.MSG.STATUS_CHANGE_SUCCESS")
              );

              vm.masterGridOptions.api.forEachNode(function (row, index) {
                if (row.data.id === data.id) {
                  row.data.purchaseStatus.description = "Emitida";
                }
              });
              vm.masterGridOptions.api.redrawRows();
            },
            function (response) {
              $rootScope.loadingProgress = false;
              $log.error(response);
            }
          );
        },
        function () { }
      );
    }

    function getButtons(buttons) {
      return function renderer(params) {
        var render = '<div style="width: 100%;">\n';
        if (buttons.details) {
          render +=
            '<md-button class="edit-button md-icon-button" ng-click="vm.gotoDetail(data.id)" aria-label="Order details"' +
            ' translate translate-attr-aria-label="REPORT.VIEW_DETAILS">' +
            ' <md-tooltip md-direction="bottom">' +
            '                     {{"REPORT.VIEW_DETAILS"| translate}}' +
            "                 </md-tooltip>" +
            '                 <md-icon md-font-icon="icon-eye" class="s16"></md-icon> ' +
            "             </md-button>";
        }

        if (
          buttons.pdfInvoice &&
          params.data &&
          statusForPDF(params.data.purchaseStatus.description)
        ) {
          render +=
            '<md-button class="edit-button md-icon-button" ng-click="vm.downloadPdf(\'JASPER_URL_DOC_ENTREGA\', data.id)" ' +
            ' aria-label="Order details"' +
            '                translate translate-attr-aria-label="REPORT.VIEW_DETAILS">' +
            '                 <md-tooltip md-direction="bottom">' +
            '                     {{"REPORT.PDF_INVOICE"| translate}}' +
            "                 </md-tooltip>" +
            '                 <md-icon md-font-icon="icon-download" class="s16"></md-icon> ' +
            "             </md-button>";
        }

        if (
          buttons.showPDFInvoice &&
          params.data &&
          statusForPDF(params.data.purchaseStatus.description)
        ) {
          render +=
            '<md-button class="edit-button md-icon-button" ng-click="vm.showPDF(\'JASPER_URL_DOC_ENTREGA\', data)" aria-label="Order details"' +
            '                        translate translate-attr-aria-label="REPORT.VIEW_DETAILS">' +
            '                 <md-tooltip md-direction="bottom">' +
            '                     {{"REPORT.VER"| translate}}' +
            "                 </md-tooltip>" +
            '                 <md-icon md-font-icon="icon-clipboard-text" class="s16"></md-icon> ' +
            "             </md-button>";
        }

        if (
          buttons.pdfContrasenaPago &&
          params.data &&
          statusForContrasenaPago(params.data.purchaseStatus.description)
        ) {
          render +=
            '<md-button class="edit-button md-icon-button" ng-click="vm.downloadPdf(\'JASPER_URL_CONTRASENA_PAGO\', data.id)" ' +
            ' aria-label="Order details"' +
            '                 translate translate-attr-aria-label="REPORT.VIEW_DETAILS">' +
            '                 <md-tooltip md-direction="bottom">' +
            '                     {{"REPORT.PDF_GENERAR"| translate}}' +
            "                 </md-tooltip>" +
            '                 <md-icon md-font-icon="icon-download" class="s16"></md-icon> ' +
            "             </md-button>";
        }

        if (
          buttons.showPDFContrasenaPago &&
          params.data &&
          statusForContrasenaPago(params.data.purchaseStatus.description)
        ) {
          render +=
            '<md-button class="edit-button md-icon-button" ng-click="vm.showPDF(\'JASPER_URL_CONTRASENA_PAGO\', data)" aria-label="Order details"' +
            '                    translate translate-attr-aria-label="REPORT.VIEW_DETAILS">' +
            '                 <md-tooltip md-direction="bottom">' +
            '                     {{"REPORT.VER"| translate}}' +
            "                 </md-tooltip>" +
            '                 <md-icon md-font-icon="icon-clipboard-text" class="s16"></md-icon> ' +
            "             </md-button>";
        }

        if (
          buttons.rechazeInvoice &&
          params.data &&
          params.data.purchaseStatus.description === "Provisionada" &&
          $rootScope.getEspecialActionByName("Rechaza Factura Provisionada")
        ) {
          render +=
            '<md-button class="edit-button md-icon-button" ng-click="vm.rejectInvoice(data)" aria-label="Rechaze"' +
            '                        translate translate-attr-aria-label="REPORT.REJECT_INVOICE">' +
            '                 <md-tooltip md-direction="bottom">' +
            '                     {{"REPORT.REJECT_INVOICE"| translate}}' +
            "                 </md-tooltip>" +
            '                 <md-icon md-font-icon="icon-thumb-down" class="s16 md-warn"></md-icon> ' +
            "             </md-button>";
        }

        if (buttons.showInterfazDetail) {
          render +=
            '<md-button class="edit-button md-icon-button" ng-click="vm.showInterfazDetail(data)" aria-label="detail"' +
            '                    translate translate-attr-aria-label="REPORT.VIEW_DETAILS">' +
            '                 <md-tooltip md-direction="bottom">' +
            '                     {{"REPORT.VIEW_DETAILS"| translate}}' +
            "                 </md-tooltip>" +
            '                 <md-icon md-font-icon="icon-eye" class="s16 "></md-icon> ' +
            "             </md-button>";
        }

        for (
          var i = 0;
          i < $rootScope.bsCircle.role.roleSpecialActions.length;
          i++
        ) {
          if (
            $rootScope.bsCircle.role.roleSpecialActions[i].specialAction
              .actionName === "Excepcion limites fechas"
          ) {
            vm.exceptionLimitDateButton = true;
            break;
          }
        }

        if (vm.exceptionLimitDateButton) {
          render +=
            '<md-button ng-if="!data.limitDateException" class="edit-button md-icon-button" ' +
            ' ng-click="vm.invoiceExceptionLimitDate(data)" aria-label="invoiceException"' +
            '              translate translate-attr-aria-label="SETTLEMENT.VIEW_DETAILS">' +
            '                 <md-tooltip md-direction="bottom">' +
            '                     {{"INVOICE.MSG.EXCEPTION_LIMIT_DATE"| translate}}' +
            "                 </md-tooltip>" +
            '                 <md-icon md-font-icon="icon-calendar-remove" class="s16 "></md-icon> ' +
            "             </md-button>";
        }

        if (
          $rootScope.getEspecialActionByName("Desactivar Factura") &&
          params.data &&
          params.data.purchaseStatus.description === "Rechazada"
        ) {
          render +=
            '<md-button class="edit-button md-icon-button" ng-click="vm.deactiveInvoice(data)" aria-label="invoiceExceptionS"' +
            '                        translate translate-attr-aria-label="SETTLEMENT.VIEW_DETAILSX">' +
            '                 <md-tooltip md-direction="bottom">' +
            '                     {{"INVOICE.MSG.DEACTIVE_INVOICE"| translate}}' +
            "                 </md-tooltip>" +
            '                 <md-icon md-font-icon="icon-close-circle" class="s16 "></md-icon> ' +
            "             </md-button>";
        }

        if (
          $rootScope.getEspecialActionByName("Cancelar Pago") &&
          params.data &&
          params.data.purchaseStatus.description === "Pagada"
        ) {
          render +=
            '<md-button class="edit-button md-icon-button" ng-click="vm.cancePayment(data)" aria-label="invoiceExceptionS"' +
            '                        translate translate-attr-aria-label="SETTLEMENT.VIEW_DETAILSX">' +
            '                 <md-tooltip md-direction="bottom">' +
            '                     {{"INVOICE.MSG.CANCEL_PAYMENT"| translate}}' +
            "                 </md-tooltip>" +
            '                 <md-icon md-font-icon="icon-close-circle" class="s16 "></md-icon> ' +
            "             </md-button>";
        }

        render += "</div>";

        return render;
      };
    }

    function getFormedAmountCurrencyDescription(amountField, currencyField) {
      return function renderer(params) {
        var render = '<div style="width: 100%;">\n';
        render += "{{data." + currencyField + "}}";
        render += "{{data." + amountField + "| number:2}} ";
        render += "</div>";
        return render;
      };
    }

    function getTranslateValue(prefixTranslate, keyValue) {
      return function renderer(params) {
        var render = '<div style="width: 100%;">\n';
        render +=
          "{{'" + prefixTranslate + ".' + data." + keyValue + "| translate}} ";
        render += "</div>";
        return render;
      };
    }

    function statusForPDF(description) {
      if (description === "Ingresando") {
        return false;
      }

      if (description === "Editando") {
        return false;
      }

      if (description === "Cancelada") {
        return false;
      }

      if (description === "Rechazada") {
        return false;
      }

      return true;
    }

    function statusForContrasenaPago(description) {
      if (description === "Provisionada") {
        return true;
      }

      return false;
    }

    function statusForPDFOC(description) {
      if (description === "Pendiente Recibir") {
        return true;
      }

      if (description === "Primera Recepcion") {
        return true;
      }

      if (description === "Recibido") {
        return true;
      }

      return false;
    }

    vm.downloadPdf = function (parameter, id) {
      var theLink = $sce.trustAsResourceUrl(
        envService.read("baseUrlJReportsWSPdf") +
        "?rpt=" +
        $rootScope.getParameterValue(parameter).replace("[ID]", id)
      );

      var a = document.createElement("a");
      a.href = theLink;
      a.target = "_blank";
      a.download = "file.pdf";
      document.body.appendChild(a);
      a.click();
    };

    function getButtonsM(buttons) {
      return function renderer(params) {
        var render = '<div style="width: 100%;">\n';
        if (buttons.details) {
          render +=
            '<md-button class="edit-button md-icon-button" ng-click="vm.gotoDetail(data.id)" aria-label="Order details"' +
            '                  translate translate-attr-aria-label="REPORT.VIEW_DETAILS">' +
            '                 <md-tooltip md-direction="bottom">' +
            '                     {{"REPORT.VIEW_DETAILS"| translate}}' +
            "                 </md-tooltip>" +
            '                 <md-icon md-font-icon="icon-eye" class="s16"></md-icon> ' +
            "             </md-button>";
        }

        if (buttons.pdfEM) {
          render +=
            '<md-button class="edit-button md-icon-button" ng-click="vm.downloadPdf(\'JASPER_URL_ENTRADA_MERCANCIA\', data.id)" ' +
            ' aria-label="Order details"' +
            '                        translate translate-attr-aria-label="REPORT.VIEW_DETAILS">' +
            '                 <md-tooltip md-direction="bottom">' +
            '                     {{"REPORT.PDF_GENERAR"| translate}}' +
            "                 </md-tooltip>" +
            '                 <md-icon md-font-icon="icon-download" class="s16"></md-icon> ' +
            "             </md-button>";
        }

        if (buttons.showPdfEM) {
          render +=
            '<md-button class="edit-button md-icon-button" ng-click="vm.showPDF(\'JASPER_URL_ENTRADA_MERCANCIA\', data)" ' +
            ' aria-label="Order details"' +
            '                        translate translate-attr-aria-label="REPORT.VIEW_DETAILS">' +
            '                 <md-tooltip md-direction="bottom">' +
            '                     {{"REPORT.VER"| translate}}' +
            "                 </md-tooltip>" +
            '                 <md-icon md-font-icon="icon-clipboard-text" class="s16"></md-icon> ' +
            "             </md-button>";
        }

        if (
          buttons.pdfOC &&
          params.data &&
          statusForPDFOC(params.data.purchaseStatus.description)
        ) {
          render +=
            '<md-button class="edit-button md-icon-button" ng-click="vm.downloadPdf(\'JASPER_URL_ORDEN_COMPRA\', data.id)" aria-label="pdf"' +
            '                        translate translate-attr-aria-label="REPORT.VIEW_DETAILS">' +
            '                 <md-tooltip md-direction="bottom">' +
            '                     {{"REPORT.PDF_GENERAR"| translate}}' +
            "                 </md-tooltip>" +
            '                 <md-icon md-font-icon="icon-download" class="s16"></md-icon> ' +
            "             </md-button>";
        }

        if (
          buttons.showPdfOC &&
          params.data &&
          statusForPDFOC(params.data.purchaseStatus.description)
        ) {
          render +=
            '<md-button class="edit-button md-icon-button" ng-click="vm.showPDF(\'JASPER_URL_ORDEN_COMPRA\', data)" aria-label="ver"' +
            '         translate translate-attr-aria-label="REPORT.VIEW_DETAILS">' +
            '                 <md-tooltip md-direction="bottom">' +
            '                     {{"REPORT.VER"| translate}}' +
            "                 </md-tooltip>" +
            '                 <md-icon md-font-icon="icon-clipboard-text" class="s16"></md-icon> ' +
            "             </md-button>";
        }
        render += "</div>";

        return render;
      };
    }

    function getURL(buttons) {
      return function renderer(params) {
        if (buttons.link) {
          return (
            '<div style="width: 100%;"  layout-align="center center">' +
            '    <a ng-if="data.originType" href="" ng-click="vm.goToRef(data)">' +
            "{{vm.replaceOriginTypedata(data, data.originType.originTypeUrlDescription)}}</a> " +
            "   </div>"
          );
        } else {
          return "";
        }
      };
    }

    function goToRef(data) {
      window.open(data.originType.queryUrl + data.referenceId, "_blank");
    }

    /**
     * Go to product detail
     *
     * @param id
     */
    function gotoDetail(id) {
      $state.go(Report.stateDetail, {
        id: id,
        filter: vm.filter,
        backTo: $state.current.name,
        isClient: !Report.isProvider,
        isReport: true
      });
    }

    function fullWidthCellRendererFn(params) {
      params.$scope.id = params.data.id;
      if (Report.detailGrid) {
        params.$scope.detailGridOptions = Report.detailGrid.options;

        if (Report.detailGrid.exportXLS) {
          params.$scope.onExportDetailXLS = function () {
            var _params = {
              skipHeader: false,
              skipFooters: false,
              skipGroups: false,
              allColumns: true,
              onlySelected: false,
              fileName:
                Report.detailGrid.exportXLS.nameFile +
                params.$scope.id +
                "-" +
                new Date().getTime() +
                ".xls",
              columnSeparator: ",",
              sheetName: "data"
            };

            _params.processCellCallback = function (params) {
              if (params.column.colId.indexOf("fecha") !== -1) {
                return $filter("date")(params.value, "dd/MM/yyyy");
              } else if (params.column.colId.indexOf("createdAt") !== -1) {
                return $filter("apiDate")(params.value, "dd/MM/yyyy HH:mm:ss");
              } else {
                return params.value;
              }
            };

            _params.processHeaderCallback = function (para) {
              return $filter("translate")(para.column.colDef.headerName);
            };

            params.$scope.detailGridOptions.api.exportDataAsExcel(_params);
          };
        }

        var dataSource = {
          paginationPageSize: pageSize,
          getRows: function (p) {
            vm.isShowProgressLinear = true;
            api.PresupuestosWS.BudgetDetail.getDetailByBuget(
              { idb: params.data.budgetId },
              function (response) {
                vm.isShowProgressLinear = false;

                p.successCallback(response, response.length);

                var floatingRows = [];
                var totalQuantity = 0;
                var totalAmount = 0;

                response.forEach(function (row, index) {
                  totalQuantity += row.quantity;
                  totalAmount += row.amount;
                });

                floatingRows.push({
                  product: {
                    name: $filter("translate")("general.totales")
                  },
                  quantity: totalQuantity,
                  amount: totalAmount
                });

                params.$scope.detailGridOptions.api.setPinnedBottomRowData(
                  floatingRows
                );
              },
              function (response) {
                vm.isShowProgressLinear = false;
              }
            );
          }
        };
        var mouseWheelListener = function (event) {
          event.stopPropagation();
        };

        setTimeout(function () {
          var container = document.querySelector(
            "#containerDetail" + params.$scope.id
          );

          container.addEventListener("mousewheel", mouseWheelListener);
          container.addEventListener("DOMMouseScroll", mouseWheelListener);

          params.$scope.detailGridOptions.api.setEnterpriseDatasource(
            dataSource
          );
        }, 1000);

        $rootScope.$on("$translateChangeSuccess", function () {
          params.$scope.detailGridOptions.api.setColumnDefs(
            vm.detailColumnDefs
          );
        });

        return templateDetail;
      }
      return true;
    }

    function clearSearchDepartment() {
      vm.searchDepartment = "";
    }

    function clearSearchCostCenter() {
      vm.searchCostCenter = "";
    }

    function clearSearchStatus() {
      vm.searchStatus = "";
    }
    function clearSettlementStatus() {
      vm.searchSettlementStatus = "";
    }

    function clearSearchProject() {
      vm.searchProject = "";
    }

    if ($stateParams.filter !== null && $stateParams.filter !== undefined) {
      $timeout(function () {
        vm.filter = angular.copy($stateParams.filter);
        vm.search();
      }, 1000);
    }

    $timeout(function () {
      var keyEvent = function (event) {
        event.stopPropagation();
      };

      var searchDepartmentInput = document.querySelector("#searchDepartment");
      var searchCostCenterInput = document.querySelector("#searchCostCenter");
      var searchStatusInput = document.querySelector("#searchStatus");
      var searchSettlementStatusInput = document.querySelector(
        "#searchSettlementStatus"
      );
      var searchProjectInput = document.querySelector("#searchProject");
      var searchTypeInput = document.querySelector("#searchType");

      if (searchDepartmentInput) {
        searchDepartmentInput.addEventListener("keydown", keyEvent);
      }
      if (searchCostCenterInput) {
        searchCostCenterInput.addEventListener("keydown", keyEvent);
      }
      if (searchStatusInput) {
        searchStatusInput.addEventListener("keydown", keyEvent);
      }
      if (searchSettlementStatusInput) {
        searchSettlementStatusInput.addEventListener("keydown", keyEvent);
      }
      if (searchProjectInput) {
        searchProjectInput.addEventListener("keydown", keyEvent);
      }
      if (searchTypeInput) {
        searchTypeInput.addEventListener("keydown", keyEvent);
      }

      if (
        $state.current.name === "app.report.quotationC" &&
        $stateParams.id !== null &&
        $stateParams.id !== undefined
      ) {
        vm.filter.id = $stateParams.id;
        vm.search();
      }
    }, 1000);

    function showPDF(parameterName, data) {
      var urlRpt = $rootScope
        .getParameterValue(parameterName)
        .replace("[ID]", data.id);

      $mdDialog
        .show({
          controller: "ReportShowPDFController",
          controllerAs: "vm",
          templateUrl: "app/main/apps/reports/dialogs/show-pdf/show-pdf.html",
          parent: angular.element("#main"),
          locals: {
            Url: urlRpt
          },
          clickOutsideToClose: false,
          fullscreen: true
        })
        .then(function (answer) { }, function () { });
    }

    vm.showPDFSettlement = function (parameter, data) {
      $log.debug("settlement in showPDFSettlement: ");
      $log.debug(data);
      $log.debug(parameter);

      var urlRpt = $rootScope
        .getParameterValue(parameter)
        .replace("[ID]", data.settlementId);

      $mdDialog
        .show({
          controller: "ReportShowPDFController",
          controllerAs: "vm",
          templateUrl: "app/main/apps/reports/dialogs/show-pdf/show-pdf.html",
          parent: angular.element("#main"),
          locals: {
            Url: urlRpt
          },
          clickOutsideToClose: false,
          fullscreen: true
        })
        .then(function (answer) { }, function () { });
    };

    vm.openSettlement = function (id) {
      $state.go("app.expenseSettlement.settlement.settlementView", {
        settlementId: id,
        backTo: $state.current.name,
        filter: vm.filter
      });
    };

    function showInterfazDetail(data) {
      $mdDialog
        .show({
          controller: "GeneralInterfazReportDetailController",
          controllerAs: "vm",
          templateUrl:
            "app/main/apps/reports/dialogs/show-interfaz-detail/show-interfaz-detail.html",
          parent: angular.element("#main"),
          targetEvent: event,
          locals: {
            entity: vm.entity,
            id: data.id,
            companyId: data.companyBuyer.id
          },
          clickOutsideToClose: false
        })
        .then(function (response) { }, function (response) { });
    }

    function showInvoiceDetail(data) {
      $mdDialog
        .show({
          controller: "InvoiceReportDetailController",
          controllerAs: "vm",
          templateUrl:
            "app/main/apps/reports/dialogs/show-invoiceView-detail/show-invoiceView-detail.html",
          parent: angular.element("#main"),
          targetEvent: event,
          locals: {
            entity: vm.entity,
            settlementId: data.settlementId,
            detail: data,
            invoiceId: data.invoicePurchaseId
          },
          clickOutsideToClose: false
        })
        .then(function (response) { }, function (response) { });
    }

    $timeout(function () {
      if (Report.filter.searchOnLoad) {
        search();
      }
    }, 1000);

    function selectContractsValid() {
      vm.filter.statuses = [];
      vm.snFilter.status = !vm.snFilter.status;
      vm.snFilter.filterByDates = !vm.snFilter.filterByDates;
      vm.filter.noFilterDate = !vm.filter.noFilterDate;
    }

    function exceptionLimitDate(data) {
      var confirm = $mdDialog
        .confirm()
        .title($filter("translate")("INVOICE.MSG.EXCEPTION_LIMIT_DATE"))
        .textContent(
          $filter("translate")("INVOICE.MSG.CONFIRMACION_EXCEPTION_LIMIT_DATE")
        )
        .ok($filter("translate")("INVOICE.MSG.SI"))
        .cancel($filter("translate")("INVOICE.MSG.NO"));
      $mdDialog.show(confirm).then(
        function (inf) {
          api.ComprasWS.Settlement.limitDateException.update(
            {
              idCircle: $rootScope.bsCircle.id,
              settlementId: data.settlementId
            },
            function (response) {
              if (response) {
                MessageService.show(
                  "INVOICE.MSG.EXCEPTION_LIMIT_DATE_SUCCESSFULLY"
                );
              }
            },
            function (err) { }
          );
        },
        function (err) { }
      );
    }

    vm.invoiceExceptionLimitDate = invoiceExceptionLimitDate;
    function invoiceExceptionLimitDate(data) {
      var confirm = $mdDialog
        .confirm()
        .title($filter("translate")("INVOICE.MSG.EXCEPTION_LIMIT_DATE"))
        .textContent(
          $filter("translate")("INVOICE.MSG.CONFIRMACION_EXCEPTION_LIMIT_DATE")
        )
        .ok($filter("translate")("INVOICE.MSG.SI"))
        .cancel($filter("translate")("INVOICE.MSG.NO"));
      $mdDialog.show(confirm).then(
        function (inf) {
          $rootScope.loadingProgress = true;
          api.ComprasWS.Invoices.limitDateException.update(
            { id: data.id },
            function (response) {
              $rootScope.loadingProgress = false;
              if (response) {
                MessageService.show(
                  "INVOICE.MSG.EXCEPTION_LIMIT_DATE_SUCCESSFULLY"
                );

                search();
              }
            },
            function (err) {
              $rootScope.loadingProgress = false;
            }
          );
        },
        function (err) { }
      );
    }

    vm.clearSearchCompany = function () {
      vm.searchCompany = "";
    };

    vm.viewChangeStatus = function (settlement, ev) {
      $mdDialog
        .show({
          controller: "changeStatusController",
          controllerAs: "vm",
          templateUrl:
            "app/main/apps/expenseSettlements/settlements/settlement/settlementEditor/changeStatus/changeStatus.html",
          targetEvent: ev,
          locals: {
            settlementId: settlement.id
          },
          clickOutsideToClose: false
        })
        .then(function (answer) { });
    };

    vm.cancelProvision = function (settlement) {
      $rootScope.loadingProgress = true;
      var confirm = $mdDialog
        .confirm()
        .title(
          $filter("translate")(
            "EXPENSE_SETTLEMENTS.PROVISIONED.MSG_SURE_CANCEL_PROVISION"
          )
        )
        .content(
          $filter("translate")(
            "EXPENSE_SETTLEMENTS.PROVISIONED.MSG_CANCEL_PROVISION"
          )
        )
        .ariaLabel("Delete Detail")
        .ok($filter("translate")("SETTLEMENT.OK"))
        .cancel($filter("translate")("SETTLEMENT.CANCEL"));
      $mdDialog.show(confirm).then(
        function () {
          $rootScope.loadingProgress = true;
          api.ComprasWS.Settlement.cancelProvisionSettlement
            .cancel({
              settlementId: settlement.id,
              idCircle: $rootScope.bsCircle.id
            })
            .$promise.then(
              function (response) {
                if (settlement.erpReference === null) {
                  MessageService.show(
                    $filter("translate")(
                      "EXPENSE_SETTLEMENTS.PROVISIONED.CANCEL_PROVISION_OK2"
                    )
                  );
                } else {
                  MessageService.show(
                    $filter("translate")(
                      "EXPENSE_SETTLEMENTS.PROVISIONED.CANCEL_PROVISION_OK"
                    )
                  );
                }
                vm.masterGridOptions.api.redrawRows();
                $rootScope.loadingProgress = false;
              },
              function (error) {
                $log.error(error.data);
                MessageService.show(
                  $filter("translate")(
                    "EXPENSE_SETTLEMENTS.PROVISIONED.CANCEL_PROVISION_ERROR"
                  )
                );
              }
            );
        },
        function () {
          // Cancel Action
          $rootScope.loadingProgress = false;
        }
      );
    };

    vm.viewErpHistory = function (settlement) {
      $log.debug(settlement);
      $mdDialog
        .show({
          controller: "InterfazReportDetailController",
          controllerAs: "vm",
          templateUrl:
            "app/main/apps/reports/dialogs/show-interfaz-detail/show-interfaz-detail.html",
          parent: angular.element("#main"),
          targetEvent: event,
          locals: {
            entity: vm.entity,
            id: settlement.settlementId,
            companyId: settlement.companyId
          },
          clickOutsideToClose: false
        })
        .then(function (response) { }, function (response) { });
    };

    vm.cancelPayment = cancelPayment;
    function cancelPayment(settlement) {
      $rootScope.loadingProgress = true;
      var confirm = $mdDialog
        .confirm()
        .title($filter("translate")("PAID_SETTLEMENT.MSG_SURE_CANCEL_PAYMENT"))
        .content($filter("translate")("PAID_SETTLEMENT.MSG_CANCEL_PAYMENT"))
        .ariaLabel("Delete Detail")
        .ok($filter("translate")("SETTLEMENT.OK"))
        .cancel($filter("translate")("SETTLEMENT.CANCEL"));
      $mdDialog.show(confirm).then(
        function () {
          $rootScope.loadingProgress = true;
          api.ComprasWS.Settlement.cancelPaymentSettlement
            .cancel({
              settlementId: settlement.settlementId,
              idCircle: $rootScope.bsCircle.id
            })
            .$promise.then(
              function (response) {
                $rootScope.loadingProgress = false;
                MessageService.show(
                  $filter("translate")("PAID_SETTLEMENT.CANCEL_PAYMENT_OK")
                );

                search();
              },
              function (error) {
                $rootScope.loadingProgress = false;
                $log.error(error);
                $log.error(error.data);
                MessageService.showErrorMessage(
                  $filter("translate")("PAID_SETTLEMENT.CANCEL_PAYMENT_ERROR")
                );
              }
            );
        },
        function () {
          $rootScope.loadingProgress = false;
        }
      );
    }

    vm.deactiveInvoice = function (data) {
      var confirm = $mdDialog
        .confirm()
        .title($filter("translate")("INVOICE.MSG.DEACTIVE_INVOICE"))
        .content($filter("translate")("INVOICE.MSG.DEACTIVE_INVOICE_Confirm"))
        .ariaLabel("Deactive Detail")
        .ok($filter("translate")("SETTLEMENT.OK"))
        .cancel($filter("translate")("SETTLEMENT.CANCEL"));
      $mdDialog.show(confirm).then(
        function () {
          $rootScope.loadingProgress = true;
          api.ComprasWS.Invoices.deactivate.update(
            { id: data.id },
            function (response) {
              $rootScope.loadingProgress = false;
              MessageService.show(
                $filter("translate")(
                  "INVOICE.MSG.DEACTIVE_INVOICE_successfully"
                )
              );
              search();
            },
            function (errResponse) {
              $rootScope.loadingProgress = false;
            }
          );
        },
        function () { }
      );
    };

    vm.cancePayment = function (data) {
      var confirm = $mdDialog
        .confirm()
        .title($filter("translate")("INVOICE.MSG.CANCEL_PAYMENT"))
        .content($filter("translate")("INVOICE.MSG.CANCEL_PAYMENT_Confirm"))
        .ariaLabel("Deactive Detail")
        .ok($filter("translate")("SETTLEMENT.OK"))
        .cancel($filter("translate")("SETTLEMENT.CANCEL"));
      $mdDialog.show(confirm).then(
        function () {
          $rootScope.loadingProgress = true;
          api.ComprasWS.Invoices.cancelPayment.update(
            { id: data.id },
            function (response) {
              $rootScope.loadingProgress = false;
              MessageService.show(
                $filter("translate")("INVOICE.MSG.CANCEL_PAYMENT_successfully")
              );
              search();
            },
            function (errResponse) {
              $rootScope.loadingProgress = false;
            }
          );
        },
        function () { }
      );
    };

    function loadTypes() {
      if (Report.title === "SETTLEMENT") {
        api.ComprasWS.pettyCashType.query(
          {},
          function (response) {
            vm.typeses = response;
          },
          function (errResponse) { }
        );
      }
    }

    $timeout(function () {
      var keyEvent = function (event) {
        event.stopPropagation();
      };

      var searchCompanyInput = document.querySelector("#searchCompany");

      if (searchCompanyInput) {
        searchCompanyInput.addEventListener("keydown", keyEvent);
      }
    }, 500);

    function changeDeptoAndCCByCompany() {
      vm.filter.departments = [];
      vm.filter.costCenters = [];
      vm.departments = [];
      vm.costCenters = [];
      if (vm.filter.companies.length === 1 && vm.filter.companies[0] === -1) {
        vm.filter.companies = vm.companies.map(function (company) { return company.id });
      }
      $timeout(function () {
        if (vm.filter.companies && vm.filter.companies.length > 0) {
          vm.filter.companies.forEach(function (a) {
            params = {idc: a};

            vm.loadingDepartments = true;
            api.GeneralWS.getAllDepartment.query(params, function (data) {
              vm.departments = vm.departments.concat(data);
              vm.loadingDepartments = false;
            });

            vm.loadingCostCenter = true;
            api.GeneralWS.getAllCost.query(params, function (data) {
              vm.costCenters = vm.costCenters.concat(data);
              vm.loadingCostCenter = false;
            });
          });
        } else {
          loadDepartments();
          loadCostCenter();
        }
      }, 200);
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('ChatTabController', ChatTabController);

    /** @ngInject */
    function ChatTabController(msApi, $timeout) {
        var vm = this;

        // Data
        vm.chat = {};
        vm.chatActive = false;
        vm.replyMessage = '';

        msApi.request('quickPanel.contacts@get', {},
            // Success
            function (response) {
                vm.contacts = response.data;
            }
        );

        // Methods
        vm.toggleChat = toggleChat;
        vm.reply = reply;

        //////////

        function toggleChat(contact) {
            vm.chatActive = !vm.chatActive;

            if (vm.chatActive) {
                vm.replyMessage = '';
                vm.chat.contact = contact;
                scrollToBottomOfChat(0);
            }
        }

        function reply() {
            if (vm.replyMessage === '') {
                return;
            }

            if (!vm.chat.contact.dialog) {
                vm.chat.contact.dialog = [];
            }

            vm.chat.contact.dialog.push({
                who: 'user',
                message: vm.replyMessage,
                time: 'Just now'
            });

            vm.replyMessage = '';

            scrollToBottomOfChat(400);
        }

        function scrollToBottomOfChat(speed) {
            var chatDialog = angular.element('#chat-dialog');

            $timeout(function () {
                chatDialog.animate({
                    scrollTop: chatDialog[0].scrollHeight
                }, speed);
            }, 0);

        }
    }

})();

(function () {

    'use strict';

    angular
            .module('app.core')
            .service('MessageService', function ($mdToast) {

                var service = this;

                service.show = function (message) {

                    $mdToast.show({
                        template: '<md-toast layout="column" layout-align="center start"><div class="md-toast-content">{{\'' + message + '\'| translate}}</div></md-toast>',
                        hideDelay: 7000,
                        position: 'top right'
                    });

                };

                service.showErrorMessage = function (message) {
                    $mdToast.show({
                        template: '<md-toast layout="column" layout-align="center start"><div class="md-toast-content" style="background-color: red">{{\'' + message + '\'| translate}}</div></md-toast>',
                        hideDelay: 5000,
                        position: 'top right'
                    });
                };

            });

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsTimelineController', MsTimelineController)
        .directive('msTimeline', msTimelineDirective)
        .directive('msTimelineItem', msTimelineItemDirective);

    /** @ngInject */
    function MsTimelineController()
    {
        var vm = this;

        // Data
        vm.scrollEl = undefined;

        // Methods
        vm.setScrollEl = setScrollEl;
        vm.getScrollEl = getScrollEl;

        //////////

        /**
         * Set scroll element
         *
         * @param scrollEl
         */
        function setScrollEl(scrollEl)
        {
            vm.scrollEl = scrollEl;
        }

        /**
         * Get scroll element
         *
         * @returns {undefined|*}
         */
        function getScrollEl()
        {
            return vm.scrollEl;
        }
    }

    /** @ngInject */
    function msTimelineDirective()
    {
        return {
            scope     : {
                msTimeline: '=?',
                loadMore  : '&?msTimelineLoadMore'
            },
            controller: 'MsTimelineController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-timeline');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    // Create an element for triggering the load more action and append it
                    var loadMoreEl = angular.element('<div class="ms-timeline-loader md-accent-bg md-whiteframe-4dp"><span class="spinner animate-rotate"></span></div>');
                    iElement.append(loadMoreEl);

                    // Default config
                    var config = {
                        scrollEl: '#content'
                    };

                    // Extend the configuration
                    config = angular.extend(config, scope.msTimeline, {});
                    
                    // Grab the scrollable element and store it in the controller for general use
                    var scrollEl = angular.element(config.scrollEl);
                    MsTimelineCtrl.setScrollEl(scrollEl);

                    // Threshold
                    var threshold = 144;

                    // Register onScroll event for the first time
                    registerOnScroll();

                    /**
                     * onScroll Event
                     */
                    function onScroll()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() + threshold > loadMoreEl.position().top )
                        {
                            // Show the loader
                            loadMoreEl.addClass('show');

                            // Unregister scroll event to prevent triggering the function over and over again
                            unregisterOnScroll();

                            // Trigger load more event
                            scope.loadMore().then(
                                // Success
                                function ()
                                {
                                    // Hide the loader
                                    loadMoreEl.removeClass('show');

                                    // Register the onScroll event again
                                    registerOnScroll();
                                },

                                // Error
                                function ()
                                {
                                    // Remove the loader completely
                                    loadMoreEl.remove();
                                }
                            );
                        }
                    }

                    /**
                     * onScroll event registerer
                     */
                    function registerOnScroll()
                    {
                        scrollEl.on('scroll', onScroll);
                    }

                    /**
                     * onScroll event unregisterer
                     */
                    function unregisterOnScroll()
                    {
                        scrollEl.off('scroll', onScroll);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        unregisterOnScroll();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msTimelineItemDirective($timeout, $q)
    {
        return {
            scope  : true,
            require: '^msTimeline',
            compile: function (tElement)
            {
                tElement.addClass('ms-timeline-item').addClass('hidden');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    var threshold = 72,
                        itemLoaded = false,
                        itemInViewport = false,
                        scrollEl = MsTimelineCtrl.getScrollEl();

                    //////////

                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Check if the timeline item has ms-card
                        if ( iElement.find('ms-card') )
                        {
                            // If the ms-card template loaded...
                            scope.$on('msCard::cardTemplateLoaded', function (event, args)
                            {
                                var cardEl = angular.element(args[0]);

                                // Test the card to see if there is any image on it
                                testForImage(cardEl).then(function ()
                                {
                                    $timeout(function ()
                                    {
                                        itemLoaded = true;
                                    });
                                });
                            });
                        }
                        else
                        {
                            // Test the element to see if there is any image on it
                            testForImage(iElement).then(function ()
                            {
                                $timeout(function ()
                                {
                                    itemLoaded = true;
                                });
                            });
                        }

                        // Check if the loaded element also in the viewport
                        scrollEl.on('scroll', testForVisibility);

                        // Test for visibility for the first time without waiting for the scroll event
                        testForVisibility();
                    }

                    // Item ready watcher
                    var itemReadyWatcher = scope.$watch(
                        function ()
                        {
                            return itemLoaded && itemInViewport;
                        },
                        function (current, old)
                        {
                            if ( angular.equals(current, old) )
                            {
                                return;
                            }

                            if ( current )
                            {
                                iElement.removeClass('hidden').addClass('animate');

                                // Unbind itemReadyWatcher
                                itemReadyWatcher();
                            }
                        }, true);

                    /**
                     * Test the given element for image
                     *
                     * @param element
                     * @returns promise
                     */
                    function testForImage(element)
                    {
                        var deferred = $q.defer(),
                            imgEl = element.find('img');

                        if ( imgEl.length > 0 )
                        {
                            imgEl.on('load', function ()
                            {
                                deferred.resolve('Image is loaded');
                            });
                        }
                        else
                        {
                            deferred.resolve('No images');
                        }

                        return deferred.promise;
                    }

                    /**
                     * Test the element for visibility
                     */
                    function testForVisibility()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() > iElement.position().top + threshold )
                        {
                            $timeout(function ()
                            {
                                itemInViewport = true;
                            });

                            // Unbind the scroll event
                            scrollEl.off('scroll', testForVisibility);
                        }
                    }
                };
            }
        };
    }
})();
(function () {

    'use strict';

    angular
            .module('app.core')
            .filter('topCharactersHtml', topCharactersHtml);

    /**@ngInject**/
    function topCharactersHtml($log) {

        return function (htmlMessage, topNumber) {
            
            var a = document.createElement('div');
            
            a.innerHTML = htmlMessage;
            
            var elements = angular.element(a);
            var plainText = "";

            for (var i = 0; i < elements.length; i++) {
                plainText += (elements[i].innerText || elements[i].textContent) + " ";

                if (plainText.length > topNumber) {
                    break;
                }
            }

            plainText = plainText.split("\n").join(" ");
            plainText = plainText.substring(0, topNumber);

            return plainText;

        };

    }

})();
(function ()
{
    'use strict';

    angular
            .module('app.core')
            .filter('sumOfValue', sumOfValue)
            .filter('totalSumPriceQty', totalSumPriceQty);

    /** @ngInject */
    function sumOfValue($filter)
    {
        return function (data, key, decimals) {
            if (angular.isUndefined(data) || angular.isUndefined(key))
                return 0;
            var sum = 0;
            var field = key.split(".");
            angular.forEach(data, function (value) {
                var val = value;
                field.forEach(function (f) {
                    if (val) {
                        val = val[f];
                    }
                });
                sum = sum + parseFloat(val ? val : 0, 10);
            });
            if (decimals) {
                return $filter('number')(sum, decimals);
            }
            return sum;
        };
    }

    /** @ngInject */
    function totalSumPriceQty()
    {
        return function (data, key1, key2) {
            if (angular.isUndefined(data) || angular.isUndefined(key1) || angular.isUndefined(key2))
                return 0;
            var sum = 0;
            angular.forEach(data, function (value) {
                sum = sum + (parseInt(value[key1], 10) * parseInt(value[key2], 10));
            });
            return sum;
        }
    }

})();
(function ()
{
    'use strict';

    angular
            .module('app.core')
            .filter('flipdate', flipdate);

    /** @ngInject */
    function flipdate($filter)
    {
        return function (input, format)
        {
            if (input === null) {
                return "";
            }

            var _date = $filter('date')(new Date(input + ' 00:00:00'), format);

            return _date;
        };
    }

})();
(function () {

    'use strict';

    angular
            .module('app.core')
            .filter('apiDate', apiDate);

    /**@ngInject**/
    function apiDate($filter, $log) {

        return function (dateObject, format) {
            var date = new Date(dateObject.year, dateObject.monthValue - 1, dateObject.dayOfMonth);
            if (dateObject.hour || dateObject.hour === 0) {
              date = new Date(dateObject.year, dateObject.monthValue - 1, dateObject.dayOfMonth, dateObject.hour, dateObject.minute, dateObject.second);
            }
            var currentDate = new Date();

            var yesterdayDate = new Date();
            yesterdayDate.setDate(yesterdayDate.getDate() - 1);

            var isToday = (dateObject.year === currentDate.getFullYear() && dateObject.monthValue === (currentDate.getMonth() + 1) && dateObject.dayOfMonth === currentDate.getDate());
            var isYesterday = (dateObject.year === currentDate.getFullYear() && dateObject.monthValue === (currentDate.getMonth() + 1) && dateObject.dayOfMonth === yesterdayDate.getDate());;

            if (isToday) {
                return $filter('translate')('general.today') + ' ' + $filter('date')(date, 'HH:mm');
            } else if(isYesterday) {
                return $filter('translate')('general.yesterday') + ' ' + $filter('date')(date, 'HH:mm');
            } else {
                return $filter('date')(date, format);
            }

        };

    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSplashScreen', msSplashScreenDirective);

    /** @ngInject */
    function msSplashScreenDirective($animate)
    {
        return {
            restrict: 'E',
            link    : function (scope, iElement)
            {
                var splashScreenRemoveEvent = scope.$on('msSplashScreen::remove', function ()
                {
                    $animate.leave(iElement).then(function ()
                    {
                        // De-register scope event
                        splashScreenRemoveEvent();

                        // Null-ify everything else
                        scope = iElement = null;
                    });
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
            .module('app.core')
            .directive('ngFallback', ngFallback);

    /** @ngInject */
    function ngFallback()
    {
        return{
            link: function postLink(scope, element, attrs) {
                element.bind('error', function () {
                    angular.element(this).attr("src", attrs.ngFallback);
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsWidgetController', MsWidgetController)
        .directive('msWidget', msWidgetDirective)
        .directive('msWidgetFront', msWidgetFrontDirective)
        .directive('msWidgetBack', msWidgetBackDirective);

    /** @ngInject */
    function MsWidgetController($scope, $element)
    {
        var vm = this;

        // Data
        vm.flipped = false;

        // Methods
        vm.flip = flip;

        //////////

        /**
         * Flip the widget
         */
        function flip()
        {
            if ( !isFlippable() )
            {
                return;
            }

            // Toggle flipped status
            vm.flipped = !vm.flipped;

            // Toggle the 'flipped' class
            $element.toggleClass('flipped', vm.flipped);
        }

        /**
         * Check if widget is flippable
         *
         * @returns {boolean}
         */
        function isFlippable()
        {
            return (angular.isDefined($scope.flippable) && $scope.flippable === true);
        }
    }

    /** @ngInject */
    function msWidgetDirective()
    {
        return {
            restrict  : 'E',
            scope     : {
                flippable: '=?'
            },
            controller: 'MsWidgetController',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    //////////
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetFrontDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-front');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetBackDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-back');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
            .module('app.core')
            .controller('MsStepperController', MsStepperController)
            .directive('msHorizontalStepper', msHorizontalStepperDirective)
            .directive('msHorizontalStepperStep', msHorizontalStepperStepDirective)
            .directive('msVerticalStepper', msVerticalStepperDirective)
            .directive('msVerticalStepperStep', msVerticalStepperStepDirective);

    /** @ngInject */
    function MsStepperController($timeout, $scope)
    {
        var vm = this;

        // Data
        vm.mainForm = undefined;

        vm.orientation = 'horizontal';
        vm.steps = [];
        vm.currentStep = undefined;
        vm.currentStepNumber = 1;
        vm.stepSubmitToo;
        vm.validChange;

        // Methods
        vm.setStepSubmitToo = setStepSubmitToo;
        vm.setOrientation = setOrientation;
        vm.registerMainForm = registerMainForm;
        vm.registerStep = registerStep;
        vm.setupSteps = setupSteps;
        vm.resetForm = resetForm;

        vm.setCurrentStep = setCurrentStep;
        vm.setValidChange = setValidChange;

        vm.gotoStep = gotoStep;
        vm.gotoPreviousStep = gotoPreviousStep;
        vm.gotoNextStep = gotoNextStep;
        vm.gotoFirstStep = gotoFirstStep;
        vm.gotoLastStep = gotoLastStep;

        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.isStepCurrent = isStepCurrent;
        vm.isStepDisabled = isStepDisabled;
        vm.isStepOptional = isStepOptional;
        vm.isStepHidden = isStepHidden;
        vm.filterHiddenStep = filterHiddenStep;
        vm.isStepValid = isStepValid;
        vm.isStepNumberValid = isStepNumberValid;

        vm.isFormValid = isFormValid;
        vm.isFormDirty = isFormDirty;

        //////////

        /**
         * Set the orientation of the stepper
         *
         * @param orientation
         */
        function setOrientation(orientation)
        {
            vm.orientation = orientation || 'horizontal';
        }

        /**
         * Set the orientation of the stepper
         *
         * @param step
         */
        function setStepSubmitToo(step)
        {
            vm.stepSubmitToo = step || null;
        }

        /**
         * Set the orientation of the stepper
         *
         * @param field
         */
        function setValidChange(field)
        {
            vm.validChange = field || null;
        }

        /**
         * Register the main form
         *
         * @param form
         */
        function registerMainForm(form)
        {
            vm.mainForm = form;
        }

        /**
         * Register a step
         *
         * @param element
         * @param scope
         * @param form
         */
        function registerStep(element, scope, form)
        {
            var step = {
                element: element,
                scope: scope,
                form: form,
                stepNumber: scope.step || (vm.steps.length + 1),
                stepTitle: scope.stepTitle
            };

            // Push the step into steps array
            vm.steps.push(step);

            // Sort steps by stepNumber
            vm.steps.sort(function (a, b)
            {
                return a.stepNumber - b.stepNumber;
            });

            return step;
        }

        /**
         * Setup steps for the first time
         */
        function setupSteps()
        {
            vm.setCurrentStep(vm.currentStepNumber);
        }

        /**
         * Reset steps and the main form
         */
        function resetForm()
        {
            // Timeout is required here because we need to
            // let form model to reset before setting the
            // statuses
            var isReset = true;
            if (vm.stepSubmitToo && vm.currentStepNumber === vm.stepSubmitToo) {
                isReset = false;
            }

            $timeout(function ()
            {
                // Reset all the steps
                for (var x = 0; x < vm.steps.length; x++)
                {
                    vm.steps[x].form.$setPristine();
                    vm.steps[x].form.$setUntouched();
                }

                // Reset the main form
                vm.mainForm.$setPristine();
                vm.mainForm.$setUntouched();

                // Go to first step
                if (isReset) {
                    gotoFirstStep();
                } else {
                    if (vm.validChange) {
                        $scope.$watch('vm.model.' + vm.validChange, function (newVal) {
                            if (newVal) {
                                gotoNextStep();
                            }
                        });
                    }
                }
            });
        }

        /**
         * Set current step
         *
         * @param stepNumber
         */
        function setCurrentStep(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            $("#step" + stepNumber).scrollTop();
            if (!isStepNumberValid(stepNumber))
            {
                return;
            }

            // Update the current step number
            vm.currentStepNumber = stepNumber;

            if (vm.orientation === 'horizontal')
            {
                // Hide all steps
                for (var i = 0; i < vm.steps.length; i++)
                {
                    vm.steps[i].element.hide();
                }

                // Show the current step
                vm.steps[vm.currentStepNumber - 1].element.show();
            } else if (vm.orientation === 'vertical')
            {
                // Hide all step content
                for (var j = 0; j < vm.steps.length; j++)
                {
                    vm.steps[j].element.find('.ms-stepper-step-content').hide();
                }

                // Show the current step content
                vm.steps[vm.currentStepNumber - 1].element.find('.ms-stepper-step-content').show();
            }
        }

        /**
         * Go to a step
         *
         * @param stepNumber
         */
        function gotoStep(stepNumber)
        {
            // If the step we are about to go
            // is hidden, bail...
            if (isStepHidden(stepNumber))
            {
                return;
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the previous step
         */
        function gotoPreviousStep()
        {
            var stepNumber = vm.currentStepNumber - 1;

            // Test the previous steps and make sure we
            // will land to the one that is not hidden
            for (var s = stepNumber; s >= 1; s--)
            {
                if (!isStepHidden(s))
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the next step
         */
        function gotoNextStep()
        {
            var stepNumber = vm.currentStepNumber + 1;

            // Test the following steps and make sure we
            // will land to the one that is not hidden
            for (var s = stepNumber; s <= vm.steps.length; s++)
            {
                if (!isStepHidden(s))
                {
                    stepNumber = s;
                    break;
                }
            }
            vm.setCurrentStep(stepNumber);
            $("#step" + (stepNumber - 1)).scrollTop();
        }

        /**
         * Go to the first step
         */
        function gotoFirstStep()
        {
            vm.setCurrentStep(1);
        }

        /**
         * Go to the last step
         */
        function gotoLastStep()
        {
            vm.setCurrentStep(vm.steps.length);
        }

        /**
         * Check if the current step is the first step
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.currentStepNumber === 1;
        }

        /**
         * Check if the current step is the last step
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            if (vm.stepSubmitToo && vm.currentStepNumber === vm.stepSubmitToo && isFormDirty()) {
                return true;
            }
            return vm.currentStepNumber === vm.steps.length;
        }

        /**
         * Check if the given step is the current one
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepCurrent(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if (!isStepNumberValid(stepNumber))
            {
                return null;
            }

            return vm.currentStepNumber === stepNumber;
        }

        /**
         * Check if the given step should be disabled
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepDisabled(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if (!isStepNumberValid(stepNumber))
            {
                return null;
            }

            var disabled = false;

            for (var i = 1; i < stepNumber; i++)
            {
                if (!isStepValid(i))
                {
                    disabled = true;
                    break;
                }
            }

            return disabled;
        }

        /**
         * Check if the given step is optional
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepOptional(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if (!isStepNumberValid(stepNumber))
            {
                return null;
            }

            return vm.steps[stepNumber - 1].scope.optionalStep;
        }

        /**
         * Check if the given step is hidden
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepHidden(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if (!isStepNumberValid(stepNumber))
            {
                return null;
            }

            return !!vm.steps[stepNumber - 1].scope.hideStep;
        }

        /**
         * Check if the given step is hidden as a filter
         *
         * @param step
         * @returns {boolean}
         */
        function filterHiddenStep(step)
        {
            return !isStepHidden(step.stepNumber);
        }

        /**
         * Check if the given step is valid
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepValid(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if (!isStepNumberValid(stepNumber))
            {
                return null;
            }

            // If the step is optional, always return true
            if (isStepOptional(stepNumber))
            {
                return true;
            }

            return vm.steps[stepNumber - 1].form.$valid;
        }

        /**
         * Check if the given step number is a valid step number
         *
         * @param stepNumber
         * @returns {boolean}
         */
        function isStepNumberValid(stepNumber)
        {
            return !(angular.isUndefined(stepNumber) || stepNumber < 1 || stepNumber > vm.steps.length);
        }

        /**
         * Check if the entire form is valid
         *
         * @returns {boolean}
         */
        function isFormValid()
        {
            return vm.mainForm.$valid;
        }

        /**
         * Check if the entire form is dirty
         *
         * @returns {boolean}
         */
        function isFormDirty()
        {
            return vm.mainForm.$dirty;
        }
    }

    /** @ngInject */
    function msHorizontalStepperDirective()
    {
        return {
            restrict: 'A',
            scope: {
                stepSubmitToo: '=?',
                validChange: '=?'
            },
            require: ['form', 'msHorizontalStepper'],
            priority: 1001,
            controller: 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude: true,
            templateUrl: 'app/core/directives/ms-stepper/templates/horizontal/horizontal.html',
            compile: function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                            MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time

                    MsStepperCtrl.nextDescriptionButton = iAttrs.nextButtonDescription ? iAttrs.nextButtonDescription : "NEXT";
                    MsStepperCtrl.backDescriptionButton = iAttrs.backButtonDescription ? iAttrs.backButtonDescription : "BACK";
                    MsStepperCtrl.submitDescriptionButton = iAttrs.submitButtonDescription ? iAttrs.submitButtonDescription : "SUBMIT";
                    MsStepperCtrl.setOrientation('horizontal');
                    MsStepperCtrl.setStepSubmitToo(scope.stepSubmitToo);
                    MsStepperCtrl.setValidChange(scope.validChange);
                    MsStepperCtrl.registerMainForm(FormCtrl);
                    MsStepperCtrl.setupSteps();
                };
            }
        };
    }

    /** @ngInject */
    function msHorizontalStepperStepDirective()
    {
        return {
            restrict: 'E',
            require: ['form', '^msHorizontalStepper'],
            priority: 1000,
            scope: {
                step: '=?',
                stepTitle: '=?',
                optionalStep: '=?',
                hideStep: '=?'
            },
            compile: function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                            MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Hide the step by default
                    iElement.hide();
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperDirective($timeout)
    {
        return {
            restrict: 'A',
            scope: {
                stepSubmitToo: '=?',
                validChange: '=?',
                msScopeStepper: '=?'
            },
            require: ['form', 'msVerticalStepper'],
            priority: 1001,
            controller: 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude: true,
            templateUrl: 'app/core/directives/ms-stepper/templates/vertical/vertical.html',
            compile: function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                            MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time

                    // Timeout is required in vertical stepper
                    // as we are using transclusion in steps.
                    // We have to wait for them to be transcluded
                    // and registered to the controller
                    $timeout(function ()
                    {
                        MsStepperCtrl.nextDescriptionButton = iAttrs.nextButtonDescription ? iAttrs.nextButtonDescription : "NEXT";
                        MsStepperCtrl.backDescriptionButton = iAttrs.backButtonDescription ? iAttrs.backButtonDescription : "BACK";
                        MsStepperCtrl.submitDescriptionButton = iAttrs.submitButtonDescription ? iAttrs.submitButtonDescription : "SUBMIT";
                        MsStepperCtrl.setOrientation('vertical');
                        MsStepperCtrl.registerMainForm(FormCtrl);
                        MsStepperCtrl.setValidChange(scope.validChange);
                        MsStepperCtrl.setStepSubmitToo(scope.stepSubmitToo);
                        MsStepperCtrl.setupSteps();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperStepDirective()
    {
        return {
            restrict: 'E',
            require: ['form', '^msVerticalStepper'],
            priority: 1000,
            scope: {
                step: '=?',
                stepTitle: '=?',
                optionalStep: '=?',
                hideStep: '=?'
            },
            transclude: true,
            templateUrl: 'app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html',
            compile: function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                            MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    scope.stepInfo = MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Expose the controller to the scope
                    scope.MsStepper = MsStepperCtrl;

                    // Hide the step content by default
                    iElement.find('.ms-stepper-step-content').hide();
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsShortcutsController', MsShortcutsController)
        .directive('msShortcuts', msShortcutsDirective);

    /** @ngInject */
    function MsShortcutsController($log, $rootScope, api, $scope, $cookies, $document, $timeout, $q, msNavigationService)
    {
        var vm = this;
        
        vm.userParameterName = "USER_SHORTCUTS";

        // Data
        vm.query = '';
        vm.queryOptions = {
            debounce: 300
        };
        vm.resultsLoading = false;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;
        vm.mobileBarActive = false;

        vm.results = null;
        vm.shortcuts = [];

        vm.sortableOptions = {
            ghostClass   : 'ghost',
            forceFallback: true,
            fallbackClass: 'dragging',
            onSort       : function ()
            {
                vm.saveShortcuts();
            }
        };

        // Methods
        vm.populateResults = populateResults;
        vm.loadShortcuts = loadShortcuts;
        vm.saveShortcuts = saveShortcuts;
        vm.addShortcut = addShortcut;
        vm.removeShortcut = removeShortcut;
        vm.handleResultClick = handleResultClick;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;
        vm.toggleMobileBar = toggleMobileBar;

        //////////

        init();

        function init()
        {
            // Load the shortcuts
            vm.loadShortcuts().then(
                // Success
                function (response)
                {
                    vm.shortcuts = response;

                    // Add shortcuts as results by default
                    if ( vm.shortcuts.length > 0 )
                    {
                        vm.results = response;
                    }
                }
            );

            // Watch the model changes to trigger the search
            $scope.$watch('MsShortcuts.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                // Show the loader
                vm.resultsLoading = true;

                // Populate the results
                vm.populateResults().then(
                    // Success
                    function (response)
                    {
                        vm.results = response;
                    },
                    // Error
                    function ()
                    {
                        vm.results = [];
                    }
                ).finally(
                    function ()
                    {
                        // Hide the loader
                        vm.resultsLoading = false;
                    }
                );
            });
        }

        /**
         * Populate the results
         */
        function populateResults()
        {
            var results = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for ( var x = 0; x < flatNavigation.length; x++ )
            {
                if ( flatNavigation[x].uisref )
                {
                    results.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the results
            if ( vm.query )
            {
                results = results.filter(function (item)
                {
                    if ( angular.lowercase(item.title).search(angular.lowercase(vm.query)) > -1 )
                    {
                        return true;
                    }
                });

                // Iterate through one last time and
                // add required properties to items
                for ( var i = 0; i < results.length; i++ )
                {
                    // Add false to hasShortcut by default
                    results[i].hasShortcut = false;

                    // Test if the item is in the shortcuts list
                    for ( var y = 0; y < vm.shortcuts.length; y++ )
                    {
                        if ( vm.shortcuts[y]._id === results[i]._id )
                        {
                            results[i].hasShortcut = true;
                            break;
                        }
                    }
                }
            }
            else
            {
                // If the query is empty, that means
                // there is nothing to search for so
                // we will populate the results with
                // current shortcuts if there is any
                if ( vm.shortcuts.length > 0 )
                {
                    results = vm.shortcuts;
                }
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Fake the service delay
            $timeout(function ()
            {
                // Resolve the promise
                deferred.resolve(results);
            }, 250);

            // Return a promise
            return deferred.promise;
        }

        /**
         * Load shortcuts
         */
        function loadShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // load the shortcuts from the cookies.
            // But here you can make an API call
            // to load them from the DB.
            
            var shortcuts = angular.fromJson($rootScope.getUserParameterValueByName(vm.userParameterName, true));
            
            // No cookie available. Generate one
            // for the demo purposes...
            if ( angular.isUndefined(shortcuts) || shortcuts === null )
            {
                shortcuts = [];
                
                $rootScope.createUserParameter(vm.userParameterName, angular.toJson(shortcuts), true);
                
            }

            // Resolve the promise
            deferred.resolve(shortcuts);

            return deferred.promise;
        }

        /**
         * Save the shortcuts
         */
        function saveShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // keep the shortcuts in the cookies.
            // But here you can make an API call
            // to save them to the DB.
            
            $rootScope.updateUserParameterValue(vm.userParameterName, angular.toJson(vm.shortcuts), true);
            
            // Fake the service delay
            $timeout(function ()
            {
                deferred.resolve({'success': true});
            }, 250);

            return deferred.promise;
        }

        /**
         * Add item as shortcut
         *
         * @param item
         */
        function addShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = true;
            
            delete item.createdAt;
            delete item.modifiedAt;
            delete item.application;
            
            // Add as a shortcut
            vm.shortcuts.push(item);

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Remove item from shortcuts
         *
         * @param item
         */
        function removeShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = false;

            // Remove the shortcut
            for ( var x = 0; x < vm.shortcuts.length; x++ )
            {
                if ( vm.shortcuts[x]._id === item._id )
                {
                    // Remove the x-th item from the array
                    vm.shortcuts.splice(x, 1);

                    // If we aren't searching for anything...
                    if ( !vm.query )
                    {
                        // If all the shortcuts have been removed,
                        // null-ify the results
                        if ( vm.shortcuts.length === 0 )
                        {
                            vm.results = null;
                        }
                        // Otherwise update the selected index
                        else
                        {
                            if ( x >= vm.shortcuts.length )
                            {
                                vm.selectedResultIndex = vm.shortcuts.length - 1;
                            }
                        }
                    }
                }
            }

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            // Add or remove the shortcut
            if ( item.hasShortcut )
            {
                vm.removeShortcut(item);
            }
            else
            {
                vm.addShortcut(item);
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $document.find('#ms-shortcut-add-menu').find('.results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }

        /**
         * Toggle mobile bar
         */
        function toggleMobileBar()
        {
            vm.mobileBarActive = !vm.mobileBarActive;
        }
    }

    /** @ngInject */
    function msShortcutsDirective()
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msShortcuts',
            controller      : 'MsShortcutsController as MsShortcuts',
            bindToController: {},
            templateUrl     : 'app/core/directives/ms-shortcuts/ms-shortcuts.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-shortcuts');

                return function postLink(scope, iElement)
                {
                    // Data

                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSidenavHelper', msSidenavHelperDirective);

    /** @ngInject */
    function msSidenavHelperDirective()
    {
        return {
            restrict: 'A',
            require : '^mdSidenav',
            link    : function (scope, iElement, iAttrs, MdSidenavCtrl)
            {
                // Watch md-sidenav open & locked open statuses
                // and add class to the ".page-layout" if only
                // the sidenav open and NOT locked open
                scope.$watch(function ()
                {
                    return MdSidenavCtrl.isOpen() && !MdSidenavCtrl.isLockedOpen();
                }, function (current)
                {
                    if ( angular.isUndefined(current) )
                    {
                        return;
                    }

                    iElement.parent().toggleClass('full-height', current);
                    angular.element('html').toggleClass('sidenav-open', current);
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msNavigationService', msNavigationServiceProvider)
        .controller('MsNavigationController', MsNavigationController)
        // Vertical
        .directive('msNavigation', msNavigationDirective)
        .controller('MsNavigationNodeController', MsNavigationNodeController)
        .directive('msNavigationNode', msNavigationNodeDirective)
        .directive('msNavigationItem', msNavigationItemDirective)
        //Horizontal
        .directive('msNavigationHorizontal', msNavigationHorizontalDirective)
        .controller('MsNavigationHorizontalNodeController', MsNavigationHorizontalNodeController)
        .directive('msNavigationHorizontalNode', msNavigationHorizontalNodeDirective)
        .directive('msNavigationHorizontalItem', msNavigationHorizontalItemDirective);

    /** @ngInject */
    function msNavigationServiceProvider()
    {
        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        // Navigation array
        var navigation = [];

        var service = this;

        // Methods
        service.saveItem = saveItem;
        service.deleteItem = deleteItem;
        service.sortByWeight = sortByWeight;

        //////////

        /**
         * Create or update the navigation item
         *
         * @param path
         * @param item
         */
        function saveItem(path, item)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            var parts = path.split('.');

            // Generate the object id from the parts
            var id = parts[parts.length - 1];

            // Get the parent item from the parts
            var parent = _findOrCreateParent(parts);

            // Decide if we are going to update or create
            var updateItem = false;

            for ( var i = 0; i < parent.length; i++ )
            {
                if ( parent[i]._id === id )
                {
                    updateItem = parent[i];

                    break;
                }
            }

            // Update
            if ( updateItem )
            {
                angular.extend(updateItem, item);

                // Add proper ui-sref
                updateItem.uisref = _getUiSref(updateItem);
            }
            // Create
            else
            {
                // Create an empty children array in the item
                item.children = [];

                // Add the default weight if not provided or if it's not a number
                if ( angular.isUndefined(item.weight) || !angular.isNumber(item.weight) )
                {
                    item.weight = 1;
                }

                // Add the item id
                item._id = id;

                // Add the item path
                item._path = path;

                // Add proper ui-sref
                item.uisref = _getUiSref(item);

                // Push the item into the array
                parent.push(item);
            }
        }

        /**
         * Delete navigation item
         *
         * @param path
         */
        function deleteItem(path)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            // Locate the item by using given path
            var item = navigation,
                parts = path.split('.');

            for ( var p = 0; p < parts.length; p++ )
            {
                var id = parts[p];

                for ( var i = 0; i < item.length; i++ )
                {
                    if ( item[i]._id === id )
                    {
                        // If we have a matching path,
                        // we have found our object:
                        // remove it.
                        if ( item[i]._path === path )
                        {
                            item.splice(i, 1);
                            return true;
                        }

                        // Otherwise grab the children of
                        // the current item and continue
                        item = item[i].children;
                        break;
                    }
                }
            }

            return false;
        }

        /**
         * Sort the navigation items by their weights
         *
         * @param parent
         */
        function sortByWeight(parent)
        {
            // If parent not provided, sort the root items
            if ( !parent )
            {
                parent = navigation;
                parent.sort(_byWeight);
            }

            // Sort the children
            for ( var i = 0; i < parent.length; i++ )
            {
                var children = parent[i].children;

                if ( children.length > 1 )
                {
                    children.sort(_byWeight);
                }

                if ( children.length > 0 )
                {
                    sortByWeight(children);
                }
            }
        }

        /* ----------------- */
        /* Private Functions */
        /* ----------------- */

        /**
         * Find or create parent
         *
         * @param parts
         * @returns {Array|Boolean}
         * @private
         */
        function _findOrCreateParent(parts)
        {
            // Store the main navigation
            var parent = navigation;

            // If it's going to be a root item
            // return the navigation itself
            if ( parts.length === 1 )
            {
                return parent;
            }

            // Remove the last element from the parts as
            // we don't need that to figure out the parent
            parts.pop();

            // Find and return the parent
            for ( var i = 0; i < parts.length; i++ )
            {
                var _id = parts[i],
                    createParent = true;

                for ( var p = 0; p < parent.length; p++ )
                {
                    if ( parent[p]._id === _id )
                    {
                        parent = parent[p].children;
                        createParent = false;

                        break;
                    }
                }

                // If there is no parent found, create one, push
                // it into the current parent and assign it as a
                // new parent
                if ( createParent )
                {
                    var item = {
                        _id     : _id,
                        _path   : parts.join('.'),
                        title   : _id,
                        weight  : 1,
                        children: []
                    };

                    parent.push(item);
                    parent = item.children;
                }
            }

            return parent;
        }

        /**
         * Sort by weight
         *
         * @param x
         * @param y
         * @returns {number}
         * @private
         */
        function _byWeight(x, y)
        {
            return parseInt(x.weight) - parseInt(y.weight);
        }

        /**
         * Setup the ui-sref using state & state parameters
         *
         * @param item
         * @returns {string}
         * @private
         */
        function _getUiSref(item)
        {
            var uisref = '';

            if ( angular.isDefined(item.state) )
            {
                uisref = item.state;

                if ( angular.isDefined(item.stateParams) && angular.isObject(item.stateParams) )
                {
                    uisref = uisref + '(' + angular.toJson(item.stateParams) + ')';
                }
            }

            return uisref;
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */

        this.$get = function ()
        {
            var activeItem = null,
                navigationScope = null,
                folded = null,
                foldedOpen = null;

            var service = {
                saveItem          : saveItem,
                deleteItem        : deleteItem,
                sort              : sortByWeight,
                clearNavigation   : clearNavigation,
                setActiveItem     : setActiveItem,
                getActiveItem     : getActiveItem,
                getNavigation     : getNavigation,
                getFlatNavigation : getFlatNavigation,
                setNavigationScope: setNavigationScope,
                setFolded         : setFolded,
                getFolded         : getFolded,
                setFoldedOpen     : setFoldedOpen,
                getFoldedOpen     : getFoldedOpen,
                toggleFolded      : toggleFolded
            };

            return service;

            //////////

            /**
             * Clear the entire navigation
             */
            function clearNavigation()
            {
                // Clear the navigation array
                navigation = [];

                // Clear the vm.navigation from main controller
                if ( navigationScope )
                {
                    navigationScope.vm.navigation = navigation;
                }
            }

            /**
             * Set active item
             *
             * @param node
             * @param scope
             */
            function setActiveItem(node, scope)
            {
                activeItem = {
                    node : node,
                    scope: scope
                };
            }

            /**
             * Return active item
             */
            function getActiveItem()
            {
                return activeItem;
            }

            /**
             * Return navigation array
             *
             * @param root
             * @returns Array
             */
            function getNavigation(root)
            {
                if ( root )
                {
                    for ( var i = 0; i < navigation.length; i++ )
                    {
                        if ( navigation[i]._id === root )
                        {
                            return [navigation[i]];
                        }
                    }

                    return null;
                }

                return navigation;
            }

            /**
             * Return flat navigation array
             *
             * @param root
             * @returns Array
             */
            function getFlatNavigation(root)
            {
                // Get the correct navigation array
                var navigation = getNavigation(root);

                // Flatten the navigation object
                return _flattenNavigation(navigation);
            }

            /**
             * Store navigation's scope for later use
             *
             * @param scope
             */
            function setNavigationScope(scope)
            {
                navigationScope = scope;
            }

            /**
             * Set folded status
             *
             * @param status
             */
            function setFolded(status)
            {
                folded = status;
            }

            /**
             * Return folded status
             *
             * @returns {*}
             */
            function getFolded()
            {
                return folded;
            }

            /**
             * Set folded open status
             *
             * @param status
             */
            function setFoldedOpen(status)
            {
                foldedOpen = status;
            }

            /**
             * Return folded open status
             *
             * @returns {*}
             */
            function getFoldedOpen()
            {
                return foldedOpen;
            }


            /**
             * Toggle fold on stored navigation's scope
             */
            function toggleFolded()
            {
                navigationScope.toggleFolded();
            }

            /**
             * Flatten the given navigation
             *
             * @param navigation
             * @private
             */
            function _flattenNavigation(navigation)
            {
                var flatNav = [];

                for ( var x = 0; x < navigation.length; x++ )
                {
                    // Copy and clear the children of the
                    // navigation that we want to push
                    var navToPush = angular.copy(navigation[x]);
                    navToPush.children = [];

                    // Push the item
                    flatNav.push(navToPush);

                    // If there are child items in this navigation,
                    // do some nested function magic
                    if ( navigation[x].children.length > 0 )
                    {
                        flatNav = flatNav.concat(_flattenNavigation(navigation[x].children));
                    }
                }

                return flatNav;
            }
        };
    }

    /** @ngInject */
    function MsNavigationController($scope, msNavigationService)
    {
        var vm = this;

        // Data
        if ( $scope.root )
        {
            vm.navigation = msNavigationService.getNavigation($scope.root);
        }
        else
        {
            vm.navigation = msNavigationService.getNavigation();
        }

        // Methods
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Sort the navigation before doing anything else
            msNavigationService.sort();
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            angular.element('body').toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }
    }

    /** @ngInject */
    function msNavigationDirective($rootScope, $timeout, $mdSidenav, msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                folded: '=',
                root  : '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/vertical.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        foldExpanderEl = angular.element('<div id="ms-navigation-fold-expander"></div>'),
                        foldCollapserEl = angular.element('<div id="ms-navigation-fold-collapser"></div>'),
                        sidenav = $mdSidenav('navigation');

                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Set the folded status for the first time.
                        // First, we have to check if we have a folded
                        // status available in the service already. This
                        // will prevent navigation to act weird if we already
                        // set the fold status, remove the navigation and
                        // then re-initialize it, which happens if we
                        // change to a view without a navigation and then
                        // come back with history.back() function.

                        // If the service didn't initialize before, set
                        // the folded status from scope, otherwise we
                        // won't touch anything because the folded status
                        // already set in the service...
                        if ( msNavigationService.getFolded() === null )
                        {
                            msNavigationService.setFolded(scope.folded);
                        }

                        if ( msNavigationService.getFolded() )
                        {
                            // Collapse everything.
                            // This must be inside a $timeout because by the
                            // time we call this, the 'msNavigation::collapse'
                            // event listener is not registered yet. $timeout
                            // will ensure that it will be called after it is
                            // registered.
                            $timeout(function ()
                            {
                                $rootScope.$broadcast('msNavigation::collapse');
                            });

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                    }

                    // Sidenav locked open status watcher
                    scope.$watch(function ()
                    {
                        return sidenav.isLockedOpen();
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        var folded = msNavigationService.getFolded();

                        if ( folded )
                        {
                            if ( current )
                            {
                                // Collapse everything
                                $rootScope.$broadcast('msNavigation::collapse');
                            }
                            else
                            {
                                // Expand the active one and its parents
                                var activeItem = msNavigationService.getActiveItem();
                                if ( activeItem )
                                {
                                    activeItem.scope.$emit('msNavigation::stateMatched');
                                }
                            }
                        }
                    });

                    // Folded status watcher
                    scope.$watch('folded', function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        setFolded(current);
                    });

                    /**
                     * Set folded status
                     *
                     * @param folded
                     */
                    function setFolded(folded)
                    {
                        // Store folded status on the service for global access
                        msNavigationService.setFolded(folded);

                        if ( folded )
                        {
                            // Collapse everything
                            $rootScope.$broadcast('msNavigation::collapse');

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                        else
                        {
                            // Expand the active one and its parents
                            var activeItem = msNavigationService.getActiveItem();
                            if ( activeItem )
                            {
                                activeItem.scope.$emit('msNavigation::stateMatched');
                            }

                            // Remove body class
                            bodyEl.removeClass('ms-navigation-folded ms-navigation-folded-open');

                            // Remove fold collapser
                            removeFoldCollapser();
                        }
                    }

                    /**
                     * Set fold expander
                     */
                    function setFoldExpander()
                    {
                        iElement.parent().append(foldExpanderEl);

                        // Let everything settle for a moment
                        // before registering the event listener
                        $timeout(function ()
                        {
                            foldExpanderEl.on('mouseenter touchstart', onFoldExpanderHover);
                        });
                    }

                    /**
                     * Set fold collapser
                     */
                    function setFoldCollapser()
                    {
                        bodyEl.find('#main').append(foldCollapserEl);
                        foldCollapserEl.on('mouseenter touchstart', onFoldCollapserHover);
                    }

                    /**
                     * Remove fold collapser
                     */
                    function removeFoldCollapser()
                    {
                        foldCollapserEl.remove();
                    }

                    /**
                     * onHover event of foldExpander
                     */
                    function onFoldExpanderHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(true);

                        // Expand the active one and its parents
                        var activeItem = msNavigationService.getActiveItem();
                        if ( activeItem )
                        {
                            activeItem.scope.$emit('msNavigation::stateMatched');
                        }

                        // Add class to the body
                        bodyEl.addClass('ms-navigation-folded-open');

                        // Remove the fold opener
                        foldExpanderEl.remove();

                        // Set fold collapser
                        setFoldCollapser();
                    }

                    /**
                     * onHover event of foldCollapser
                     */
                    function onFoldCollapserHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(false);

                        // Collapse everything
                        $rootScope.$broadcast('msNavigation::collapse');

                        // Remove body class
                        bodyEl.removeClass('ms-navigation-folded-open');

                        // Remove the fold collapser
                        foldCollapserEl.remove();

                        // Set fold expander
                        setFoldExpander();
                    }

                    /**
                     * Public access for toggling folded status externally
                     */
                    scope.toggleFolded = function ()
                    {
                        var folded = msNavigationService.getFolded();

                        setFolded(!folded);
                    };

                    /**
                     * On $stateChangeStart
                     */
                    scope.$on('$stateChangeStart', function ()
                    {
                        // Close the sidenav
                        sidenav.close();
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        foldCollapserEl.off('mouseenter touchstart');
                        foldExpanderEl.off('mouseenter touchstart');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationNodeController($scope, $element, $rootScope, $animate, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.collapsed = undefined;
        vm.collapsable = undefined;
        vm.group = undefined;
        vm.animateHeightClass = 'animate-height';

        // Methods
        vm.toggleCollapsed = toggleCollapsed;
        vm.collapse = collapse;
        vm.expand = expand;
        vm.getClass = getClass;
        vm.isHidden = isHidden;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Is collapsable?
            if ( !vm.hasChildren || vm.group )
            {
                vm.collapsable = false;
            }
            else
            {
                vm.collapsable = !!(angular.isUndefined(vm.node.collapsable) || typeof vm.node.collapsable !== 'boolean' || vm.node.collapsable === true);
            }

            // Is collapsed?
            if ( !vm.collapsable )
            {
                vm.collapsed = false;
            }
            else
            {
                vm.collapsed = !!(angular.isUndefined(vm.node.collapsed) || typeof vm.node.collapsed !== 'boolean' || vm.node.collapsed === true);
            }

            // Expand all parents if we have a matching state or
            // the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Expand if the current scope is collapsable and is collapsed
                if ( vm.collapsable && vm.collapsed )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.collapsed = false;
                    });
                }
            });

            // Listen for collapse event
            $scope.$on('msNavigation::collapse', function (event, path)
            {
                if ( vm.collapsed || !vm.collapsable )
                {
                    return;
                }

                // If there is no path defined, collapse
                if ( angular.isUndefined(path) )
                {
                    vm.collapse();
                }
                // If there is a path defined, do not collapse
                // the items that are inside that path. This will
                // prevent parent items from collapsing
                else
                {
                    var givenPathParts = path.split('.'),
                        activePathParts = [];

                    var activeItem = msNavigationService.getActiveItem();
                    if ( activeItem )
                    {
                        activePathParts = activeItem.node._path.split('.');
                    }

                    // Test for given path
                    if ( givenPathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    // Test for active path
                    if ( activePathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    vm.collapse();
                }
            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Collapse everything except the one we're using
                    $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
                }

                // Expand the parents if we the current
                // state is a child of the node's state
                if ( $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Emit the stateMatched
                    $scope.$emit('msNavigation::stateMatched');
                }
            });
        }

        /**
         * Toggle collapsed
         */
        function toggleCollapsed()
        {
            if ( vm.collapsed )
            {
                vm.expand();
            }
            else
            {
                vm.collapse();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Grab the element that we are going to collapse
            var collapseEl = vm.element.children('ul');

            // Grab the height
            var height = collapseEl[0].offsetHeight;

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = true;

                // Add collapsing class to the node
                vm.element.addClass('collapsing');

                // Animate the height
                $animate.animate(collapseEl,
                    {
                        'display': 'block',
                        'height' : height + 'px'
                    },
                    {
                        'height': '0px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        collapseEl.css({
                            'display': '',
                            'height' : ''
                        });

                        // Clear collapsing class from the node
                        vm.element.removeClass('collapsing');
                    }
                );

                // Broadcast the collapse event so child items can also be collapsed
                $scope.$broadcast('msNavigation::collapse');
            });
        }

        /**
         * Expand
         */
        function expand()
        {
            // Grab the element that we are going to expand
            var expandEl = vm.element.children('ul');

            // Move the element out of the dom flow and
            // make it block so we can get its height
            expandEl.css({
                'position'  : 'absolute',
                'visibility': 'hidden',
                'display'   : 'block',
                'height'    : 'auto'
            });

            // Grab the height
            var height = expandEl[0].offsetHeight;

            // Reset the style modifications
            expandEl.css({
                'position'  : '',
                'visibility': '',
                'display'   : '',
                'height'    : ''
            });

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = false;

                // Add expanding class to the node
                vm.element.addClass('expanding');

                // Animate the height
                $animate.animate(expandEl,
                    {
                        'display': 'block',
                        'height' : '0px'
                    },
                    {
                        'height': height + 'px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        expandEl.css({
                            'height': ''
                        });

                        // Clear expanding class from the node
                        vm.element.removeClass('expanding');
                    }
                );

                // If item expanded, broadcast the collapse event from rootScope so that the other expanded items
                // can be collapsed. This is necessary for keeping only one parent expanded at any time
                $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }

        /**
         * Check if node should be hidden
         *
         * @returns {boolean}
         */
        function isHidden()
        {
            if ( angular.isDefined(vm.node.hidden) && angular.isFunction(vm.node.hidden) )
            {
                return vm.node.hidden();
            }

            return false;
        }
    }

    /** @ngInject */
    function msNavigationNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationNode'
            },
            controller      : 'MsNavigationNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationItemDirective()
    {
        return {
            restrict: 'A',
            require : '^msNavigationNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // If the item is collapsable...
                    if ( MsNavigationNodeCtrl.collapsable )
                    {
                        iElement.on('click', MsNavigationNodeCtrl.toggleCollapsed);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalDirective(msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                root: '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/horizontal.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal');

                return function postLink(scope)
                {
                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationHorizontalNodeController($scope, $element, $rootScope, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.group = undefined;

        // Methods
        vm.getClass = getClass;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Is active
            vm.isActive = false;

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Mark all parents as active if we have a matching state
            // or the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Mark as active if has children
                if ( vm.hasChildren )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
            });

            // Listen for clearActive event
            $scope.$on('msNavigation::clearActive', function ()
            {
                if ( !vm.hasChildren )
                {
                    return;
                }

                var activePathParts = [];

                var activeItem = msNavigationService.getActiveItem();
                if ( activeItem )
                {
                    activePathParts = activeItem.node._path.split('.');
                }

                // Test for active path
                if ( activePathParts.indexOf(vm.node._id) > -1 )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
                else
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = false;
                    });
                }

            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Clear all active states except the one we're using
                    $rootScope.$broadcast('msNavigation::clearActive');
                }
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }
    }

    /** @ngInject */
    function msNavigationHorizontalNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationHorizontalNode'
            },
            controller      : 'MsNavigationHorizontalNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationHorizontalNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationHorizontalNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalItemDirective($mdMedia)
    {
        return {
            restrict: 'A',
            require : '^msNavigationHorizontalNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    iElement.on('click', onClick);

                    function onClick()
                    {
                        if ( !MsNavigationHorizontalNodeCtrl.hasChildren || $mdMedia('gt-md') )
                        {
                            return;
                        }

                        iElement.toggleClass('expanded');
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msScrollConfig', msScrollConfigProvider)
        .directive('msScroll', msScrollDirective);

    /** @ngInject */
    function msScrollConfigProvider()
    {
        // Default configuration
        var defaultConfiguration = {
            wheelSpeed            : 1,
            wheelPropagation      : false,
            swipePropagation      : true,
            minScrollbarLength    : null,
            maxScrollbarLength    : null,
            useBothWheelAxes      : false,
            useKeyboard           : true,
            suppressScrollX       : false,
            suppressScrollY       : false,
            scrollXMarginOffset   : 0,
            scrollYMarginOffset   : 0,
            stopPropagationOnClick: true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig
            };

            return service;

            //////////

            /**
             * Return the config
             */
            function getConfig()
            {
                return defaultConfiguration;
            }
        };
    }

    /** @ngInject */
    function msScrollDirective($timeout, msScrollConfig, msUtils, fuseConfig)
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                // Do not replace scrollbars if
                // 'disableCustomScrollbars' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbars') )
                {
                    return;
                }

                // Do not replace scrollbars on mobile devices
                // if 'disableCustomScrollbarsOnMobile' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbarsOnMobile') && msUtils.isMobile() )
                {
                    return;
                }

                // Add class
                tElement.addClass('ms-scroll');

                return function postLink(scope, iElement, iAttrs)
                {
                    var options = {};

                    // If options supplied, evaluate the given
                    // value. This is because we don't want to
                    // have an isolated scope but still be able
                    // to use scope variables.
                    // We don't want an isolated scope because
                    // we should be able to use this everywhere
                    // especially with other directives
                    if ( iAttrs.msScroll )
                    {
                        options = scope.$eval(iAttrs.msScroll);
                    }

                    // Extend the given config with the ones from provider
                    options = angular.extend({}, msScrollConfig.getConfig(), options);

                    // Initialize the scrollbar
                    $timeout(function ()
                    {
                        PerfectScrollbar.initialize(iElement[0], options);
                    }, 0);

                    // Update the scrollbar on element mouseenter
                    iElement.on('mouseenter', updateScrollbar);

                    // Watch scrollHeight and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollHeight');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    // Watch scrollWidth and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollWidth');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    /**
                     * Update the scrollbar
                     */
                    function updateScrollbar()
                    {
                        PerfectScrollbar.update(iElement[0]);
                    }

                    // Cleanup on destroy
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('mouseenter');
                        PerfectScrollbar.destroy(iElement[0]);
                    });
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsSearchBarController', MsSearchBarController)
        .directive('msSearchBar', msSearchBarDirective);

    /** @ngInject */
    function MsSearchBarController($scope, $element, $timeout)
    {
        var vm = this;

        // Data
        vm.collapsed = true;
        vm.query = '';
        vm.queryOptions = {
            debounce: vm.debounce || 0
        };
        vm.resultsLoading = false;
        vm.results = null;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;

        // Methods
        vm.populateResults = populateResults;

        vm.expand = expand;
        vm.collapse = collapse;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.handleResultClick = handleResultClick;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;

        //////////

        init();

        function init()
        {
            // Watch the model changes to trigger the search
            $scope.$watch('MsSearchBar.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                if ( vm.collapsed )
                {
                    return;
                }

                // Evaluate the onSearch function to access the
                // function itself
                var onSearchEvaluated = $scope.$parent.$eval(vm.onSearch, {query: current}),
                    isArray = angular.isArray(onSearchEvaluated),
                    isPromise = (onSearchEvaluated && !!onSearchEvaluated.then);

                if ( isArray )
                {
                    // Populate the results
                    vm.populateResults(onSearchEvaluated);
                }

                if ( isPromise )
                {
                    // Show the loader
                    vm.resultsLoading = true;

                    onSearchEvaluated.then(
                        // Success
                        function (response)
                        {
                            // Populate the results
                            vm.populateResults(response);
                        },
                        // Error
                        function ()
                        {
                            // Assign an empty array to show
                            // the no-results screen
                            vm.populateResults([]);
                        }
                    ).finally(function ()
                        {
                            // Hide the loader
                            vm.resultsLoading = false;
                        }
                    );
                }
            });
        }

        /**
         * Populate the results
         *
         * @param results
         */
        function populateResults(results)
        {
            // Before doing anything,
            // make sure the search bar is expanded
            if ( vm.collapsed )
            {
                return;
            }

            var isArray = angular.isArray(results),
                isNull = results === null;

            // Only accept arrays and null values
            if ( !isArray && !isNull )
            {
                return;
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Populate the results
            vm.results = results;
        }

        /**
         * Expand
         */
        function expand()
        {
            // Set collapsed status
            vm.collapsed = false;

            // Call expand on scope
            $scope.expand();

            // Callback
            if ( vm.onExpand && angular.isFunction(vm.onExpand) )
            {
                vm.onExpand();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Empty the query
            vm.query = '';

            // Empty results to hide the results view
            vm.populateResults(null);

            // Set collapsed status
            vm.collapsed = true;

            // Call collapse on scope
            $scope.collapse();

            // Callback
            if ( vm.onCollapse && angular.isFunction(vm.onCollapse) )
            {
                vm.onCollapse();
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [27, 38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Escape
                case 27:

                    // Collapse the search bar
                    vm.collapse();

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    if ( !vm.results )
                    {
                        return;
                    }

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            if ( vm.onResultClick )
            {
                vm.onResultClick({item: item});
            }

            // Collapse the search bar
            vm.collapse();
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $element.find('.ms-search-bar-results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }
    }

    /** @ngInject */
    function msSearchBarDirective($document)
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msSearchBar',
            controller      : 'MsSearchBarController as MsSearchBar',
            bindToController: {
                debounce     : '=?',
                onSearch     : '@',
                onResultClick: '&?',
                onExpand     : '&?',
                onCollapse   : '&?'
            },
            templateUrl     : 'app/core/directives/ms-search-bar/ms-search-bar.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-search-bar');

                return function postLink(scope, iElement)
                {
                    // Data
                    var inputEl,
                        bodyEl = $document.find('body');

                    // Methods
                    scope.collapse = collapse;
                    scope.expand = expand;

                    //////////

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Grab the input element
                        inputEl = iElement.find('#ms-search-bar-input');
                    }

                    /**
                     * Expand action
                     */
                    function expand()
                    {
                        // Add expanded class
                        iElement.addClass('expanded');

                        // Add helper class to the body
                        bodyEl.addClass('ms-search-bar-expanded');

                        // Focus on the input
                        inputEl.focus();
                    }

                    /**
                     * Collapse action
                     */
                    function collapse()
                    {
                        // Remove expanded class
                        iElement.removeClass('expanded');

                        // Remove helper class from the body
                        bodyEl.removeClass('ms-search-bar-expanded');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msResponsiveTable', msResponsiveTableDirective);

    /** @ngInject */
    function msResponsiveTableDirective()
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement)
            {
                // Wrap the table
                var wrapper = angular.element('<div class="ms-responsive-table-wrapper"></div>');
                iElement.after(wrapper);
                wrapper.append(iElement);

                //////////
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msRandomClass', msRandomClassDirective);

    /** @ngInject */
    function msRandomClassDirective()
    {
        return {
            restrict: 'A',
            scope   : {
                msRandomClass: '='
            },
            link    : function (scope, iElement)
            {
                var randomClass = scope.msRandomClass[Math.floor(Math.random() * (scope.msRandomClass.length))];
                iElement.addClass(randomClass);
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msNavFoldService', msNavFoldService)
        .directive('msNavIsFolded', msNavIsFoldedDirective)
        .controller('MsNavController', MsNavController)
        .directive('msNav', msNavDirective)
        .directive('msNavTitle', msNavTitleDirective)
        .directive('msNavButton', msNavButtonDirective)
        .directive('msNavToggle', msNavToggleDirective);

    /** @ngInject */
    function msNavFoldService()
    {
        var foldable = {};

        var service = {
            setFoldable    : setFoldable,
            isNavFoldedOpen: isNavFoldedOpen,
            toggleFold     : toggleFold,
            openFolded     : openFolded,
            closeFolded    : closeFolded
        };

        return service;

        //////////

        /**
         * Set the foldable
         *
         * @param scope
         * @param element
         */
        function setFoldable(scope, element)
        {
            foldable = {
                'scope'  : scope,
                'element': element
            };
        }

        /**
         * Is folded open
         */
        function isNavFoldedOpen()
        {
            return foldable.scope.isNavFoldedOpen();
        }

        /**
         * Toggle fold
         */
        function toggleFold()
        {
            foldable.scope.toggleFold();
        }

        /**
         * Open folded navigation
         */
        function openFolded()
        {
            foldable.scope.openFolded();
        }

        /**
         * Close folded navigation
         */
        function closeFolded()
        {
            foldable.scope.closeFolded();
        }
    }

    /** @ngInject */
    function msNavIsFoldedDirective($document, $rootScope, msNavFoldService)
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement, iAttrs)
            {
                var isFolded = (iAttrs.msNavIsFolded === 'true'),
                    isFoldedOpen = false,
                    body = angular.element($document[0].body),
                    openOverlay = angular.element('<div id="ms-nav-fold-open-overlay"></div>'),
                    closeOverlay = angular.element('<div id="ms-nav-fold-close-overlay"></div>'),
                    sidenavEl = iElement.parent();

                // Initialize the service
                msNavFoldService.setFoldable(scope, iElement, isFolded);

                // Set the fold status for the first time
                if ( isFolded )
                {
                    fold();
                }
                else
                {
                    unfold();
                }

                /**
                 * Is nav folded open
                 */
                function isNavFoldedOpen()
                {
                    return isFoldedOpen;
                }

                /**
                 * Toggle fold
                 */
                function toggleFold()
                {
                    isFolded = !isFolded;

                    if ( isFolded )
                    {
                        fold();
                    }
                    else
                    {
                        unfold();
                    }
                }

                /**
                 * Fold the navigation
                 */
                function fold()
                {
                    // Add classes
                    body.addClass('ms-nav-folded');

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    // Append the openOverlay to the element
                    sidenavEl.append(openOverlay);

                    // Event listeners
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Open folded navigation
                 */
                function openFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    body.addClass('ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Remove open overlay
                    sidenavEl.find(openOverlay).remove();

                    // Append close overlay and bind its events
                    sidenavEl.parent().append(closeOverlay);
                    closeOverlay.on('mouseenter touchstart', function (event)
                    {
                        closeFolded(event);
                        isFoldedOpen = false;
                    });
                }

                /**
                 * Close folded navigation
                 */
                function closeFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    body.removeClass('ms-nav-folded-open');

                    // Remove close overlay
                    sidenavEl.parent().find(closeOverlay).remove();

                    // Append open overlay and bind its events
                    sidenavEl.append(openOverlay);
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Unfold the navigation
                 */
                function unfold()
                {
                    body.removeClass('ms-nav-folded ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    iElement.off('mouseenter mouseleave');
                }

                // Expose functions to the scope
                scope.toggleFold = toggleFold;
                scope.openFolded = openFolded;
                scope.closeFolded = closeFolded;
                scope.isNavFoldedOpen = isNavFoldedOpen;

                // Cleanup
                scope.$on('$destroy', function ()
                {
                    openOverlay.off('mouseenter touchstart');
                    closeOverlay.off('mouseenter touchstart');
                    iElement.off('mouseenter mouseleave');
                });
            }
        };
    }


    /** @ngInject */
    function MsNavController()
    {
        var vm = this,
            disabled = false,
            toggleItems = [],
            lockedItems = [];

        // Data

        // Methods
        vm.isDisabled = isDisabled;
        vm.enable = enable;
        vm.disable = disable;
        vm.setToggleItem = setToggleItem;
        vm.getLockedItems = getLockedItems;
        vm.setLockedItem = setLockedItem;
        vm.clearLockedItems = clearLockedItems;

        //////////

        /**
         * Is navigation disabled
         *
         * @returns {boolean}
         */
        function isDisabled()
        {
            return disabled;
        }

        /**
         * Disable the navigation
         */
        function disable()
        {
            disabled = true;
        }

        /**
         * Enable the navigation
         */
        function enable()
        {
            disabled = false;
        }

        /**
         * Set toggle item
         *
         * @param element
         * @param scope
         */
        function setToggleItem(element, scope)
        {
            toggleItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Get locked items
         *
         * @returns {Array}
         */
        function getLockedItems()
        {
            return lockedItems;
        }

        /**
         * Set locked item
         *
         * @param element
         * @param scope
         */
        function setLockedItem(element, scope)
        {
            lockedItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Clear locked items list
         */
        function clearLockedItems()
        {
            lockedItems = [];
        }
    }

    /** @ngInject */
    function msNavDirective($rootScope, $mdComponentRegistry, msNavFoldService)
    {
        return {
            restrict  : 'E',
            scope     : {},
            controller: 'MsNavController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-nav');

                return function postLink(scope)
                {
                    // Update toggle status according to the ui-router current state
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Update toggles on state changes
                    var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
                    {
                        $rootScope.$broadcast('msNav::expandMatchingToggles');

                        // Close navigation sidenav on stateChangeSuccess
                        $mdComponentRegistry.when('navigation').then(function (navigation)
                        {
                            navigation.close();

                            if ( msNavFoldService.isNavFoldedOpen() )
                            {
                                msNavFoldService.closeFolded();
                            }
                        });
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        stateChangeSuccessEvent();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavTitleDirective()
    {
        return {
            restrict: 'A',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-title');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavButtonDirective()
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-button');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavToggleDirective($rootScope, $q, $animate, $state)
    {
        return {
            restrict: 'A',
            require : '^msNav',
            scope   : true,
            compile : function (tElement, tAttrs)
            {
                tElement.addClass('ms-nav-toggle');

                // Add collapsed attr
                if ( angular.isUndefined(tAttrs.collapsed) )
                {
                    tAttrs.collapsed = true;
                }

                tElement.attr('collapsed', tAttrs.collapsed);

                return function postLink(scope, iElement, iAttrs, MsNavCtrl)
                {
                    var classes = {
                        expanded         : 'expanded',
                        expandAnimation  : 'expand-animation',
                        collapseAnimation: 'collapse-animation'
                    };

                    // Store all related states
                    var links = iElement.find('a');
                    var states = [];
                    var regExp = /\(.*\)/g;

                    angular.forEach(links, function (link)
                    {
                        var state = angular.element(link).attr('ui-sref');

                        if ( angular.isUndefined(state) )
                        {
                            return;
                        }

                        // Remove any parameter definition from the state name before storing it
                        state = state.replace(regExp, '');

                        states.push(state);
                    });

                    // Store toggle-able element and its scope in the main nav controller
                    MsNavCtrl.setToggleItem(iElement, scope);

                    // Click handler
                    iElement.children('.ms-nav-button').on('click', toggle);

                    // Toggle function
                    function toggle()
                    {
                        // If navigation is disabled, do nothing...
                        if ( MsNavCtrl.isDisabled() )
                        {
                            return;
                        }

                        // Disable the entire navigation to prevent spamming
                        MsNavCtrl.disable();

                        if ( isCollapsed() )
                        {
                            // Clear the locked items list
                            MsNavCtrl.clearLockedItems();

                            // Emit pushToLockedList event
                            scope.$emit('msNav::pushToLockedList');

                            // Collapse everything but locked items
                            $rootScope.$broadcast('msNav::collapse');

                            // Expand and then...
                            expand().then(function ()
                            {
                                // Enable the entire navigation after animations completed
                                MsNavCtrl.enable();
                            });
                        }
                        else
                        {
                            // Collapse with all children
                            scope.$broadcast('msNav::forceCollapse');
                        }
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.children('.ms-nav-button').off('click');
                    });

                    /*---------------------*/
                    /* Scope Events        */
                    /*---------------------*/

                    /**
                     * Collapse everything but locked items
                     */
                    scope.$on('msNav::collapse', function ()
                    {
                        // Only collapse toggles that are not locked
                        var lockedItems = MsNavCtrl.getLockedItems();
                        var locked = false;

                        angular.forEach(lockedItems, function (lockedItem)
                        {
                            if ( angular.equals(lockedItem.scope, scope) )
                            {
                                locked = true;
                            }
                        });

                        if ( locked )
                        {
                            return;
                        }

                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Collapse everything
                     */
                    scope.$on('msNav::forceCollapse', function ()
                    {
                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Expand toggles that match with the current states
                     */
                    scope.$on('msNav::expandMatchingToggles', function ()
                    {
                        var currentState = $state.current.name;
                        var shouldExpand = false;

                        angular.forEach(states, function (state)
                        {
                            if ( currentState === state )
                            {
                                shouldExpand = true;
                            }
                        });

                        if ( shouldExpand )
                        {
                            expand();
                        }
                        else
                        {
                            collapse();
                        }
                    });

                    /**
                     * Add toggle to the locked list
                     */
                    scope.$on('msNav::pushToLockedList', function ()
                    {
                        // Set expanded item on main nav controller
                        MsNavCtrl.setLockedItem(iElement, scope);
                    });

                    /*---------------------*/
                    /* Internal functions  */
                    /*---------------------*/

                    /**
                     * Is element collapsed
                     *
                     * @returns {bool}
                     */
                    function isCollapsed()
                    {
                        return iElement.attr('collapsed') === 'true';
                    }

                    /**
                     * Is element expanded
                     *
                     * @returns {bool}
                     */
                    function isExpanded()
                    {
                        return !isCollapsed();
                    }

                    /**
                     * Expand the toggle
                     *
                     * @returns $promise
                     */
                    function expand()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already expanded, do nothing..
                        if ( isExpanded() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', false);

                        // Grab the element to expand
                        var elementToExpand = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Move the element out of the dom flow and
                        // make it block so we can get its height
                        elementToExpand.css({
                            'position'  : 'absolute',
                            'visibility': 'hidden',
                            'display'   : 'block',
                            'height'    : 'auto'
                        });

                        // Grab the height
                        var height = elementToExpand[0].offsetHeight;

                        // Reset the style modifications
                        elementToExpand.css({
                            'position'  : '',
                            'visibility': '',
                            'display'   : '',
                            'height'    : ''
                        });

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToExpand,
                                {
                                    'display': 'block',
                                    'height' : '0px'
                                },
                                {
                                    'height': height + 'px'
                                },
                                classes.expandAnimation
                            ).then(
                                function ()
                                {
                                    // Add expanded class
                                    elementToExpand.addClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToExpand.css({'height': ''});

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }

                    /**
                     * Collapse the toggle
                     *
                     * @returns $promise
                     */
                    function collapse()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already collapsed, do nothing..
                        if ( isCollapsed() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', true);

                        // Grab the element to collapse
                        var elementToCollapse = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Grab the height
                        var height = elementToCollapse[0].offsetHeight;

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToCollapse,
                                {
                                    'height': height + 'px'
                                },
                                {
                                    'height': '0px'
                                },
                                classes.collapseAnimation
                            ).then(
                                function ()
                                {
                                    // Remove expanded class
                                    elementToCollapse.removeClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToCollapse.css({
                                        'display': '',
                                        'height' : ''
                                    });

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMaterialColorPickerController', msMaterialColorPickerController)
        .directive('msMaterialColorPicker', msMaterialColorPicker);

    /** @ngInject */
    function msMaterialColorPickerController($scope, $mdColorPalette, $mdMenu, fuseGenerator)
    {
        var vm = this;
        vm.palettes = $mdColorPalette; // Material Color Palette
        vm.selectedPalette = false;
        vm.selectedHues = false;
        $scope.$selectedColor = {};

        // Methods
        vm.activateHueSelection = activateHueSelection;
        vm.selectColor = selectColor;
        vm.removeColor = removeColor;

        /**
         * Initialize / Watch model changes
         */
        $scope.$watch('ngModel', setSelectedColor);

        /**
         * Activate Hue Selection
         * @param palette
         * @param hues
         */
        function activateHueSelection(palette, hues)
        {
            vm.selectedPalette = palette;
            vm.selectedHues = hues;
        }

        /**
         * Select Color
         * @type {selectColor}
         */
        function selectColor(palette, hue)
        {
            // Update Selected Color
            updateSelectedColor(palette, hue);

            // Update Model Value
            updateModel();

            // Hide The picker
            $mdMenu.hide();
        }

        function removeColor()
        {
            vm.selectedColor = {
                palette: '',
                hue    : '',
                class  : ''
            };

            activateHueSelection(false, false);

            updateModel();
        }

        /**
         * Set SelectedColor by model type
         */
        function setSelectedColor()
        {
            if ( !vm.modelCtrl.$viewValue || vm.modelCtrl.$viewValue === '' )
            {
                removeColor();
                return;
            }

            var palette, hue;

            // If ModelType Class
            if ( vm.msModelType === 'class' )
            {
                var color = vm.modelCtrl.$viewValue.split('-');
                if ( color.length >= 5 )
                {
                    palette = color[1] + '-' + color[2];
                    hue = color[3];
                }
                else
                {
                    palette = color[1];
                    hue = color[2];
                }
            }

            // If ModelType Object
            else if ( vm.msModelType === 'obj' )
            {
                palette = vm.modelCtrl.$viewValue.palette;
                hue = vm.modelCtrl.$viewValue.hue || 500;
            }

            // Update Selected Color
            updateSelectedColor(palette, hue);
        }

        /**
         * Update Selected Color
         * @param palette
         * @param hue
         */
        function updateSelectedColor(palette, hue)
        {
            vm.selectedColor = {
                palette     : palette,
                hue         : hue,
                class       : 'md-' + palette + '-' + hue + '-bg',
                bgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].value),
                fgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].contrast)
            };

            // If Model object not Equals the selectedColor update it
            // it can be happen when the model only have pallete and hue values
            if ( vm.msModelType === 'obj' && !angular.equals(vm.selectedColor, vm.modelCtrl.$viewValue) )
            {
                // Update Model Value
                updateModel();
            }

            activateHueSelection(palette, vm.palettes[palette]);

            $scope.$selectedColor = vm.selectedColor;
        }

        /**
         * Update Model Value by model type
         */
        function updateModel()
        {
            if ( vm.msModelType === 'class' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor.class);
            }
            else if ( vm.msModelType === 'obj' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor);
            }
        }
    }

    /** @ngInject */
    function msMaterialColorPicker()
    {
        return {
            require    : ['msMaterialColorPicker', 'ngModel'],
            restrict   : 'E',
            scope      : {
                ngModel    : '=',
                msModelType: '@?'
            },
            controller : 'msMaterialColorPickerController as vm',
            transclude : true,
            templateUrl: 'app/core/directives/ms-material-color-picker/ms-material-color-picker.html',
            link       : function (scope, element, attrs, controllers, transclude)
            {
                var ctrl = controllers[0];

                /**
                 *  Pass model controller to directive controller
                 */
                ctrl.modelCtrl = controllers[1];

                /**
                 * ModelType: 'obj', 'class'(default)
                 * @type {string|string}
                 */
                ctrl.msModelType = scope.msModelType || 'class';

                transclude(scope, function (clone)
                {
                    clone = clone.filter(function (i, el)
                    {
                        return ( el.nodeType === 1 ) ? true : false;
                    });

                    if ( clone.length )
                    {
                        element.find('ms-color-picker-button').replaceWith(clone);
                    }
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMasonryController', msMasonryController)
        .directive('msMasonry', msMasonry)
        .directive('msMasonryItem', msMasonryItem);

    /** @ngInject */
    function msMasonryController($scope, $window, $mdMedia, $timeout)
    {
        var vm = this,
            defaultOpts = {
                columnCount     : 5,
                respectItemOrder: false,
                reLayoutDebounce: 400,
                responsive      : {
                    md: 3,
                    sm: 2,
                    xs: 1
                }
            },
            reLayoutTimeout = true;

        vm.options = null;
        vm.container = [];
        vm.containerPos = '';
        vm.columnWidth = '';
        vm.items = [];

        // Methods
        vm.reLayout = reLayout;
        vm.initialize = initialize;
        vm.waitImagesLoaded = waitImagesLoaded;

        function initialize()
        {
            vm.options = !vm.options ? defaultOpts : angular.extend(defaultOpts, vm.options);


            watchContainerResize();
        }

        $scope.$on('msMasonry:relayout', function ()
        {
            reLayout();
        });

        function waitImagesLoaded(element, callback)
        {
            if ( typeof imagesLoaded !== 'undefined' )
            {
                var imgLoad = $window.imagesLoaded(element);

                imgLoad.on('done', function ()
                {
                    callback();
                });
            }
            else
            {
                callback();
            }
        }

        function watchContainerResize()
        {
            $scope.$watch(
                function ()
                {
                    return vm.container.width();
                },
                function (newValue, oldValue)
                {
                    if ( newValue !== oldValue )
                    {
                        reLayout();
                    }
                }
            );
        }

        function reLayout()
        {
            // Debounce for relayout
            if ( reLayoutTimeout )
            {
                $timeout.cancel(reLayoutTimeout);
            }

            reLayoutTimeout = $timeout(function ()
            {
                start();

                $scope.$broadcast('msMasonry:relayoutFinished');

            }, vm.options.reLayoutDebounce);

            // Start relayout
            function start()
            {
                vm.containerPos = vm.container[0].getBoundingClientRect();

                updateColumnOptions();

                $scope.$broadcast('msMasonry:relayoutStarted');

                vm.items = vm.container.find('ms-masonry-item');

                //initialize lastRowBottomArr
                var referenceArr = Array.apply(null, new Array(vm.columnCount)).map(function ()
                {
                    return 0;
                });

                // set item positions
                for ( var i = 0; i < vm.items.length; i++ )
                {
                    var item = vm.items[i],
                        xPos, yPos, column, refTop;

                    item = angular.element(item);

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:startReLayout');
                    }

                    item.css({'width': vm.columnWidth});

                    if ( vm.options.respectItemOrder )
                    {
                        column = i % vm.columnCount;
                        refTop = referenceArr[column];
                    }
                    else
                    {
                        refTop = Math.min.apply(Math, referenceArr);
                        column = referenceArr.indexOf(refTop);
                    }

                    referenceArr[column] = refTop + item[0].getBoundingClientRect().height;

                    xPos = Math.round(column * vm.columnWidth);
                    yPos = refTop;

                    item.css({'transform': 'translate3d(' + xPos + 'px,' + yPos + 'px,0px)'});
                    item.addClass('placed');

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:finishReLayout');
                    }
                }
            }
        }

        function updateColumnOptions()
        {
            vm.columnCount = vm.options.columnCount;

            if ( $mdMedia('gt-md') )
            {
                vm.columnCount = vm.options.columnCount;
            }
            else if ( $mdMedia('md') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.md ? vm.options.responsive.md : vm.columnCount);
            }
            else if ( $mdMedia('sm') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.sm ? vm.options.responsive.sm : vm.columnCount);
            }
            else
            {
                vm.columnCount = vm.options.responsive.xs;
            }

            vm.columnWidth = vm.containerPos.width / vm.columnCount;

        }
    }

    /** @ngInject */
    function msMasonry($timeout)
    {
        return {
            restrict  : 'AEC',
            controller: 'msMasonryController',
            compile   : compile
        };
        function compile(element, attributes)
        {
            return {
                pre : function preLink(scope, iElement, iAttrs, controller)
                {
                    controller.options = angular.fromJson(attributes.options || '{}');
                    controller.container = element;
                },
                post: function postLink(scope, iElement, iAttrs, controller)
                {
                    $timeout(function ()
                    {
                        controller.initialize();
                    });
                }
            };
        }
    }

    /** @ngInject */
    function msMasonryItem()
    {
        return {
            restrict: 'AEC',
            require : '^msMasonry',
            priority: 1,
            link    : link
        };

        function link(scope, element, attributes, controller)
        {
            controller.waitImagesLoaded(element, function ()
            {
                controller.reLayout();

            });

            scope.$on('msMasonryItem:finishReLayout', function ()
            {
                scope.$watch(function ()
                {
                    return element.height();
                }, function (newVal, oldVal)
                {
                    if ( newVal !== oldVal )
                    {
                        controller.reLayout();
                    }
                });
            });

            element.on('$destroy', function ()
            {
                controller.reLayout();
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msInfoBar', msInfoBarDirective);

    /** @ngInject */
    function msInfoBarDirective($document)
    {
        return {
            restrict   : 'E',
            scope      : {},
            transclude : true,
            templateUrl: 'app/core/directives/ms-info-bar/ms-info-bar.html',
            link       : function (scope, iElement)
            {
                var body = $document.find('body'),
                    bodyClass = 'ms-info-bar-active';

                // Add body class
                body.addClass(bodyClass);

                /**
                 * Remove the info bar
                 */
                function removeInfoBar()
                {
                    body.removeClass(bodyClass);
                    iElement.remove();
                    scope.$destroy();
                }

                // Expose functions
                scope.removeInfoBar = removeInfoBar;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msDatepickerFixConfig', msDatepickerFixConfigProvider)
        .directive('msDatepickerFix', msDatepickerFix);

    /** @ngInject */
    function msDatepickerFixConfigProvider()
    {
        var service = this;

        // Default configuration
        var defaultConfig = {
            // To view
            formatter: function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return val === '' ? val : new Date(val);
            },
            // To model
            parser   : function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return moment(val).add(moment(val).utcOffset(), 'm').toDate();
            }
        };

        // Methods
        service.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfig = angular.extend({}, defaultConfig, configuration);
        }

        /**
         * Service
         */
        service.$get = function ()
        {
            return defaultConfig;
        };
    }

    /** @ngInject */
    function msDatepickerFix(msDatepickerFixConfig)
    {
        return {
            require : 'ngModel',
            priority: 1,
            link    : function (scope, elem, attrs, ngModel)
            {
                ngModel.$formatters.push(msDatepickerFixConfig.formatter); // to view
                ngModel.$parsers.push(msDatepickerFixConfig.parser); // to model
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msCard', msCardDirective);

    /** @ngInject */
    function msCardDirective()
    {
        return {
            restrict: 'E',
            scope   : {
                templatePath: '=template',
                card        : '=ngModel',
                vm          : '=viewModel'
            },
            template: '<div class="ms-card-content-wrapper" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
            compile : function (tElement)
            {
                // Add class
                tElement.addClass('ms-card');

                return function postLink(scope, iElement)
                {
                    // Methods
                    scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                    function cardTemplateLoaded()
                    {
                        scope.$emit('msCard::cardTemplateLoaded', iElement);
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsFormWizardController', MsFormWizardController)
        .directive('msFormWizard', msFormWizardDirective)
        .directive('msFormWizardForm', msFormWizardFormDirective);

    /** @ngInject */
    function MsFormWizardController()
    {
        var vm = this;

        // Data
        vm.forms = [];
        vm.selectedIndex = 0;

        // Methods
        vm.registerForm = registerForm;

        vm.previousStep = previousStep;
        vm.nextStep = nextStep;
        vm.firstStep = firstStep;
        vm.lastStep = lastStep;

        vm.totalSteps = totalSteps;
        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.currentStepInvalid = currentStepInvalid;
        vm.previousStepInvalid = previousStepInvalid;
        vm.formsIncomplete = formsIncomplete;
        vm.resetForm = resetForm;

        //////////

        /**
         * Register form
         *
         * @param form
         */
        function registerForm(form)
        {
            vm.forms.push(form);
        }

        /**
         * Go to previous step
         */
        function previousStep()
        {
            if ( isFirstStep() )
            {
                return;
            }

            vm.selectedIndex--;
        }

        /**
         * Go to next step
         */
        function nextStep()
        {
            if ( isLastStep() )
            {
                return;
            }

            vm.selectedIndex++;
        }

        /**
         * Go to first step
         */
        function firstStep()
        {
            vm.selectedIndex = 0;
        }

        /**
         * Go to last step
         */
        function lastStep()
        {
            vm.selectedIndex = totalSteps() - 1;
        }

        /**
         * Return total steps
         *
         * @returns {int}
         */
        function totalSteps()
        {
            return vm.forms.length;
        }

        /**
         * Is first step?
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.selectedIndex === 0;
        }

        /**
         * Is last step?
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.selectedIndex === totalSteps() - 1;
        }

        /**
         * Is current step invalid?
         *
         * @returns {boolean}
         */
        function currentStepInvalid()
        {
            return angular.isDefined(vm.forms[vm.selectedIndex]) && vm.forms[vm.selectedIndex].$invalid;
        }

        /**
         * Is previous step invalid?
         *
         * @returns {boolean}
         */
        function previousStepInvalid()
        {
            return vm.selectedIndex > 0 && angular.isDefined(vm.forms[vm.selectedIndex - 1]) && vm.forms[vm.selectedIndex - 1].$invalid;
        }

        /**
         * Check if there is any incomplete forms
         *
         * @returns {boolean}
         */
        function formsIncomplete()
        {
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                if ( vm.forms[x].$invalid )
                {
                    return true;
                }
            }

            return false;
        }

        /**
         * Reset form
         */
        function resetForm()
        {
            // Go back to the first step
            vm.selectedIndex = 0;

            // Make sure all the forms are back in the $pristine & $untouched status
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                vm.forms[x].$setPristine();
                vm.forms[x].$setUntouched();
            }
        }
    }

    /** @ngInject */
    function msFormWizardDirective()
    {
        return {
            restrict  : 'E',
            scope     : true,
            controller: 'MsFormWizardController as msWizard',
            compile   : function (tElement)
            {
                tElement.addClass('ms-form-wizard');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msFormWizardFormDirective()
    {
        return {
            restrict: 'A',
            require : ['form', '^msFormWizard'],
            compile : function (tElement)
            {
                tElement.addClass('ms-form-wizard-form');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var formCtrl = ctrls[0],
                        MsFormWizardCtrl = ctrls[1];

                    MsFormWizardCtrl.registerForm(formCtrl);
                };
            }
        };
    }

})();
(function () {

    'use strict';

    angular
            .module('app.core')
            .directive('numbersOnly', numbersOnly);

    function numbersOnly() {
        return {
            require: 'ngModel',
            link: function (scope, element, attrs, modelCtrl) {
                modelCtrl.$parsers.push(function (inputValue) {
                    if (inputValue === undefined)
                        return '';
                    var transformedInput = inputValue.replace(/[^0-9]/g, '');
                    if (transformedInput !== inputValue) {
                        modelCtrl.$setViewValue(transformedInput);
                        modelCtrl.$render();
                    }

                    return transformedInput;
                });
            }
        };
    }

})();
/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */
(function ()
{
    'use strict';

    angular
            .module('app.core')
            .directive('ngEnter', ngEnterDirective)

    /** @ngInject */
    function ngEnterDirective($parse) {
        return function (scope, element, attrs) {
            element.bind("keydown keypress", function (event) {
                if (event.which === 13) {
                    scope.$apply(function () {
                        scope.$eval(attrs.ngEnter);
                    });

                    event.preventDefault();
                }
            });
        };
    }


})();


(function ()
{
    'use strict';

    angular
            .module('app.core')
            .directive('ngFileModel', ngFileModelDirective)
            .directive('fileModel', fileModel);
    /** @ngInject */
    function ngFileModelDirective($parse) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                var model = $parse(attrs.ngFileModel);
                var isMultiple = attrs.multiple;
                var modelSetter = model.assign;
                element.bind('change', function () {
                    var values = [];
                    angular.forEach(element[0].files, function (item) {
                        var value = {
                            // File Name 
                            name: item.name,
                            //File Size 
                            size: item.size,
                            //File URL to view 
                            url: URL.createObjectURL(item),
                            // File Input Value 
                            _file: item
                        };
                        values.push(value);
                    });
                    scope.$apply(function () {
                        if (isMultiple) {
                            modelSetter(scope, values);
                        } else {
                            modelSetter(scope, values[0]);
                        }
                    });
                });
            }
        };
    }


    function fileModel($parse) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                var model = $parse(attrs.fileModel);
                var modelSetter = model.assign;
                element.bind('change', function () {
                    scope.$apply(function () {
                        modelSetter(scope, element[0].files[0]);
                    });
                });
            }
        };
    }
})();
/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */
(function ()
{
    'use strict';

    angular
            .module('app.core')
            .directive('expandGrid', expandGrid);

    /** @ngInject */
    function expandGrid($log) {
        var directive = {
            link: link, // The function attaching the behavior
            restrict: 'A' // Restrict directive to be used only as attribute
        };
        return directive;


        function link(scope, element, attrs) {
            
            var gridElement = $(element);
            var idGrid = attrs.id;
            var min = attrs.min ? parseInt(attrs.min) : 250;
            var other = attrs.other ? parseInt(attrs.other) : 0;
            resizeGridM("#" + idGrid, other, min);
            // Attach an eventHandler to the resize event of the
            // window to resize the data area of the grid accordingly
            scope.$watch(
                    function () {
                        return gridElement.parent().height();
                    },
                    function (height) {
                        resizeGridM("#" + idGrid, other, min);
                    });
        }
    }

    function resizeGridM(gridName, other, min) {
        //Define Elements Needed
        var grid = $(gridName);

        other = other ? other : 0;
        //Other variables
        var minimumAcceptableGridHeight = min ? min : 250; //This is roughly 5 rows 

        //Get Window Height 
        var windowHeight = $(window).innerHeight();

        //Padding you want to apply below your page
        var bottomPadding = 60;

        //Check if Calculated height is below threshold
        var calculatedHeight = windowHeight - bottomPadding - other - 150;
        var finalHeight = calculatedHeight < minimumAcceptableGridHeight ? minimumAcceptableGridHeight : calculatedHeight;

        //Apply the height for the content area
        grid.css('height', finalHeight + 'px');
    }


})();


(function () {

    'use strict';

    angular
            .module('app.core')
            .directive('decimalsOnly', decimalsOnly);

    function decimalsOnly() {
        return {
            require: 'ngModel',
            link: function (scope, element, attrs, modelCtrl) {
                modelCtrl.$parsers.push(function (inputValue) {
                    if (inputValue === undefined) {
                        modelCtrl.$setViewValue('0.00');
                        modelCtrl.$render();
                    }

                    if (inputValue.substring(0, 1) === ".") {
                        modelCtrl.$setViewValue('0' + inputValue);
                        modelCtrl.$render();
                    }

                    var transformedInput = inputValue.replace(/[^\.0-9]/g, '');
                    if (transformedInput !== inputValue) {
                        modelCtrl.$setViewValue(transformedInput);
                        modelCtrl.$render();
                    }

                    return transformedInput;
                });
            }
        };
    }

})();
(function () {

    'use strict';

    angular
            .module('app.core')
            .directive('currencyMask', currencyMask);

    function currencyMask() {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, element, attrs, ngModelController) {

                var formatNumber = function (value) {

                    value = value.toString();
                    value = value.replace(/[^0-9\.]/g, "");
                    var parts = value.split('.');
                    parts[0] = parts[0].replace(/\d{1,3}(?=(\d{3})+(?!\d))/g, "$&,");
                    if (parts[1] && parts[1].length > 2) {
                        parts[1] = parts[1].substring(0, 2);
                    }

                    return parts.join(".");
                };
                var applyFormatting = function () {
                    var value = element.val();
                    var original = value;
                    if (!value || value.length == 0) {
                        return
                    }
                    value = formatNumber(value);
                    if (value != original) {
                        element.val(value);
                        element.triggerHandler('input')
                    }
                };
                element.bind('keyup', function (e) {
                    var keycode = e.keyCode;
                    var isTextInputKey =
                            (keycode > 47 && keycode < 58) || // number keys
                            keycode == 32 || keycode == 8 || // spacebar or backspace
                            (keycode > 64 && keycode < 91) || // letter keys
                            (keycode > 95 && keycode < 112) || // numpad keys
                            (keycode > 185 && keycode < 193) || // ;=,-./` (in order)
                            (keycode > 218 && keycode < 223); // [\]' (in order)
                    if (isTextInputKey) {
                        applyFormatting();
                    }
                });
                element.bind('blur', function (evt) {
                    if (angular.isDefined(ngModelController.$modelValue)) {
                        var val = ngModelController.$modelValue.split('.');
                        if (val && val.length == 1) {
                            if (val != "") {
                                ngModelController.$setViewValue(val + '.00');
                                ngModelController.$render();
                            }
                        } else if (val && val.length == 2) {
                            if (val[1] && val[1].length == 1) {
                                ngModelController.$setViewValue(val[0] + '.' + val[1] + '0');
                                ngModelController.$render();
                            } else if (val[1].length == 0) {
                                ngModelController.$setViewValue(val[0] + '.00');
                                ngModelController.$render();
                            }
                            applyFormatting();
                        }
                    }
                })
                ngModelController.$parsers.push(function (value) {
                    if (!value || value.length == 0) {
                        return value;
                    }
                    value = value.toString();
                    value = value.replace(/[^0-9\.]/g, "");
                    return value;
                });
                ngModelController.$formatters.push(function (value) {
                    if (!value || value.length == 0) {
                        return value;
                    }
                    value = formatNumber(value);
                    return value;
                });
            }
        };
    }

})();
(function () {
    'use strict';

    angular
        .module('app.general', [
            'app.auth',
            'app.profile',
            'app.role',
            'app.errors',
            'app.notifications'
        ]).config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider) {
        $translatePartialLoaderProvider.addPart('app/main/general/');
    }

})();


(function () {

    'use strict';

    angular
        .module('app.general')
        .service('GeneralService', generalService);

    /**@ngInject**/
    function generalService() {

        var service = this;

        var DataTypeEnum = {
            TEXT: { translate: "general.text" },
            NUMBER: { translate: "general.number" },
            DECIMAL: { translate: "general.decimal" },
            BOOLEAN: { translate: "general.boolean" }
        };

        service.getDataTypeEnumArray = function () {

            var enumArray = [];

            for (var propertyName in DataTypeEnum) {

                var _enum = {
                    name: propertyName,
                    translate: DataTypeEnum[propertyName].translate
                };

                enumArray.push(_enum);

            }

            return enumArray;

        };

        service.getTranslateDataTypeEnumByName = function (name) {
            return DataTypeEnum[name].translate;
        };

    }

})();

(function () {
    'use strict';

    angular
        .module('app.role', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {
        $stateProvider.state('app.role', {
            url: '/roles',
            views: {
                'content@app': {
                    templateUrl: 'app/main/general/role/role.html',
                    controller: 'RolesController as vm'
                }
            }
        });
        // Translation
        $translatePartialLoaderProvider.addPart('app/main/general/role');
    }

})();

(function () {
    'use strict';

    angular
        .module('app.role')
        .controller('RolesController', RolesController);

    /** @ngInject */
    function RolesController($rootScope, localStorageService, $state) {
        // Data
        var vm = this;
        vm.tipoFiltro = '0';
        vm.roles = [];
        vm.companies = [];

        var roleMap = {};
        var companyMap = {};
        var i = 0, j = 0;

        if ($rootScope.circles) {

            var arrayOfData = new jinqJs()
                .from($rootScope.circles)
                .orderBy([{ field: 'id', sort: 'asc' }])
                .select();

            arrayOfData.forEach(function (r) {

                var comp;
                if (companyMap[r.company.id] >= 0) {
                    comp = vm.companies[companyMap[r.company.id]];
                    comp.roles.push({ name: r.role.description, circle: r });
                } else {
                    companyMap[r.company.id] = i;
                    comp = {
                        name: r.company.name,
                        roles: [
                            { name: r.role.description, circle: r }
                        ]
                    };
                    vm.companies.splice(i, 0, comp);
                    i++;
                }

                var role;

                if (roleMap[r.role.id] >= 0) {
                    role = vm.roles[roleMap[r.role.id]];
                    role.companies.push({ name: r.company.name, circle: r });
                } else {
                    roleMap[r.role.id] = j;
                    role = {
                        name: r.role.description,
                        companies: [
                            { name: r.company.name, circle: r }
                        ]
                    };
                    vm.roles.splice(j, 0, role);
                    j++;
                }

            });
        }
        // Methods

        vm.changeCircle = changeCircle;

        function changeCircle(c) {
            $rootScope.bsCircle = c;

            localStorageService.set('accountc', $rootScope.bsCircle);
            $rootScope.msNotificationArray = [];

            if ($state.is('app.dashboards_project')) {
                $state.reload();
            } else {
                $state.go('app.dashboards_project', {}, { reload: true });
            }
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('app.profile', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {

        $stateProvider.state('app.profile', {
            url: '/profile',
            views: {
                'content@app': {
                    templateUrl: 'app/main/general/profile/profile.html',
                    controller: 'ProfileController as vm'
                }
            },
            bodyClass: 'profile'
        });

        $stateProvider.state('app.profile.edit', {
            url: '/edit',
            views: {
                'content@app': {
                    templateUrl: 'app/main/general/profile/profileEditor/profileEditor.html',
                    controller: 'ProfileEditController as vm'
                }
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/general/profile');

    }
})();

(function () {
    'use strict';

    angular
        .module('app.profile')
        .controller('ProfileController', ProfileController)
        .controller('ProfileEditController', ProfileEditController);


    function ProfileController($rootScope, $scope, $filter, localStorageService, api, envService, $state, $log, MessageService) {

        var vm = this;
        vm.editMode = false;

        vm.cancelarEdit = cancelarEdit;
        vm.sendForm = sendForm;
        vm.sendFormChangePassword = sendFormChangePassword;

        vm.filesToUpload;
        vm.uploadFiles = uploadFiles;

        vm.userInfo = angular.copy($rootScope.account);
        vm.userInfo.birthdate = vm.userInfo.birthdate ? new Date(vm.userInfo.birthdate) : new Date('1900-01-01');
        vm.userInfo.preferredUsername = { password: "" };

        vm.genders = ['F', 'M'];
        vm.pass = { newPassword: "", validatePassword: "" };

        $scope.originForm = angular.copy(vm.userInfo);

        api.GeneralWS.Company.me.getByMe({ id: 'bycircles' }, function (response) {// Success
            vm.company = response;
        }, function (response) {// Error
        });

        function cancelarEdit() {
            vm.userInfo = angular.copy($scope.originForm);
            vm.editMode = false;
        }

        function sendForm() {
            if (vm.filesToUpload) {
                saveUserAndPicture();
            } else {
                saveUser();
            }
        }

        function saveUserAndPicture() {
            vm.loading = true;
            var fd = getFDt2(vm.filesToUpload);

            api.GeneralWS.LoadAvatar.save({ sub: vm.userInfo.sub }, fd).$promise.then(
                function (response) {
                    vm.loading = false;
                    $log.debug(response);
                    vm.userInfo.picture = "https://www.megapaca.com/ms/images" + response.parentPath + response.name + "m" + response.extension;
                    saveUser();
                },
                function (errResponse) {
                    vm.loading = false;
                }
            );

        }

        function saveUser() {
            vm.loading = true;
            api.UsuarioWS.UserInfo.update({ sub: vm.userInfo.sub }, vm.userInfo).$promise.then(
                function (UserInfo) {
                    vm.loading = false;

                    vm.userInfo = angular.copy(UserInfo);
                    vm.userInfo.birthdate = vm.userInfo.birthdate ? new Date(vm.userInfo.birthdate) : null;

                    var name = UserInfo.name;

                    if (UserInfo.middleName !== '') {
                        name += ' ' + UserInfo.middleName;
                    }

                    if (UserInfo.familyName !== '') {
                        name += ' ' + UserInfo.familyName;
                    }

                    var userLocal = {
                        name: name
                    };

                    api.GeneralWS.UserSub.update({ 'sub': vm.userInfo.sub }, userLocal).$promise.then(function (User) {
                        $rootScope.account = vm.userInfo;
                        localStorageService.set('account', $rootScope.account);

                        MessageService.show($filter('translate')('PROFILE.UPDATED'));
                        vm.editMode = false;
                        $state.go('app.profile');
                    }, function (errResponse) {
                        vm.loading = false;
                    });
                },
                function (errResponse) {
                    vm.loading = false;
                }
            );
        }


        function sendFormChangePassword() {
            vm.loading = true;
            vm.userInfo.preferredUsername.password = vm.pass.newPassword;
            api.UsuarioWS.UserPass.update({ sub: vm.userInfo.sub }, vm.userInfo).$promise.then(function (response) {

                api.GeneralWS.UserSub.patch({ 'sub': vm.userInfo.sub }, { 'password': vm.pass.newPassword, 'name': response.name }).$promise.then(function (User) {
                    vm.loading = false;
                    vm.pass = { newPassword: "", validatePassword: "" };
                    MessageService.show($filter('translate')('PROFILE.PWD_UPDATED'));
                    vm.editMode = false;
                    $state.go('app.profile');
                }, function (errResponse) {
                });

            }, function (errResponse) {
            });
        }

        function getFDt2(file) {
            var fd = new FormData();
            fd.append('files', file);
            return fd;
        }

        function uploadFiles() {
            $log.debug(vm.filesToUpload.length + " files selected ... Write your Upload Code");

            $log.debug("vm.filesToUpload:");
            $log.debug(vm.filesToUpload);

            var fd = getFDt2(vm.filesToUpload);

            api.GeneralWS.LoadAvatar.save({ sub: vm.userInfo.sub }, fd).$promise.then(
                function (response) {
                    $log.debug(response);
                    var baseUrlSharedFiles = envService.read('baseUrlSharedFiles');
                    vm.userInfo.picture = baseUrlSharedFiles + response.parentPath + response.name + "m" + response.extension;
                },
                function (errResponse) {
                }
            );
        }

        $scope.uploadf3 = function () {
            angular.element(document.querySelector('#fileInput')).click();
        };

    }

    function ProfileEditController($rootScope, api, localStorageService, MessageService, $state) {

        var vm = this;

        vm.userInfo = angular.copy($rootScope.account);
        vm.userInfo.birthdate = vm.userInfo.birthdate ? new Date(vm.userInfo.birthdate) : null;
        vm.userInfo.preferredUsername = null;
        vm.genders = ['F', 'M'];

        vm.sendForm = function () {

            vm.loading = true;

            api.UsuarioWS.UserInfo.update({ sub: vm.userInfo.sub }, vm.userInfo).$promise.then(function (UserInfo) {

                vm.userInfo = angular.copy(UserInfo);

                $rootScope.account = vm.userInfo;
                localStorageService.set('account', $rootScope.account);

                vm.loading = false;

                MessageService.show($filter('translate')('PROFILE.UPDATED'));

                $state.go('app.profile');
            }, function (errResponse) {
                vm.loading = false;
            });
        };

    }
})();

(function () {
  "use strict";

  angular
    .module("app.quotation")
    .controller("QuotationsController", QuotationsController);

  /** @ngInject */
  function QuotationsController(
    $state,
    api,
    $rootScope,
    $log,
    $mdDialog,
    $filter,
    $timeout,
    $scope,
    $stateParams,
    $sce,
    envService
  ) {
    var vm = this;

    const REQUISITION_DEPARTMENT_COMPANY_NAME = 'requisition.department.company.name';
    const EXPORT_TRANSLATE = $filter('translate')('REPORT.EXPORT');
    const QUOTATION_TRANSLATE = 'QUOTATION.QUOTATION';
    const TIMEOUT_FIVE_THOUSAND = 5000;

    const NUMBER_DIMENSION_THREE = 3;
    const NUMBER_DIMENSION_FOUR = 4;
    const NUMBER_DIMENSION_FIVE = 5;

    String.prototype.replaceAll = function (find, replace) {
      var str = this;
      return str.replace(
        new RegExp(find.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&"), "g"),
        replace
      );
    };

    vm.status = $stateParams.status.replaceAll(" ", "");
    vm.statusToChange = getStatusTochange();
    vm.gridData = [];
    vm.hasBudgetApplication = false;
    vm.productId = $stateParams.id;

    //metodos
    vm.gotoQuotationDetail = gotoQuotationDetail;
    vm.changeStatus = changeStatus;
    vm.printQuotation = printQuotation;
    vm.downloadPdf = downloadPdf;
    vm.goToBack = goToBack;
    vm.buttonExportDisable = false;

    vm.masterColumnDefs = [
      {
        headerName: "#",
        field: "id",
        width: 50,
        cellStyle: { "text-align": "center" },
        sort: "asc",
        pinned: "left"
      },
      {
        headerName: getHeaderIsProviderOrClient(),
        field: getFieldIsProviderOrClient(),
        headerCellRenderer: getHeader,
        width: 250,
        enableRowGroup: true,
        enablePivot: true
      },
      {
        headerName: "QUOTATION.DEPARTMENT",
        field: "requisition.department.description",
        headerCellRenderer: getHeader,
        width: 250,
        enableRowGroup: true,
        enablePivot: true
      },
      {
        headerName: "QUOTATION.COST_CENTER",
        field: "requisition.costCenter.description",
        headerCellRenderer: getHeader,
        width: 200,
        enableRowGroup: true,
        enablePivot: true
      },
      {
        headerName: "QUOTATION.EXPIRE_DATE",
        field: "expireDate",
        headerCellRenderer: getHeader,
        valueFormatter: function (params) {
          return $filter("date")(params.value, "dd/MM/yyyy");
        },
        enableRowGroup: true,
        enablePivot: true
      },
      {
        headerName: "QUOTATION.MAX_DATE_DELIVERY",
        field: "requisition.maxDatePurchase",
        headerCellRenderer: getHeader,
        valueFormatter: function (params) {
          return $filter("date")(params.value, "dd/MM/yyyy");
        },
        enableRowGroup: true,
        enablePivot: true
      },
      {
        headerName: "QUOTATION.CURRENCY",
        field: "currency.description",
        headerCellRenderer: getHeader,
        cellRenderer: function (params) {
          if (!params.data || !params.data.currency) {
            return "";
          }
          return (
            params.data.currency.code + " " + params.data.currency.description
          );
        },
        enableRowGroup: true,
        enablePivot: true
      },
      {
        headerName: "QUOTATION.TOTAL",
        field: "total",
        headerCellRenderer: getHeader,
        width: 100,
        enableRowGroup: true,
        enablePivot: true,
        valueFormatter: function (params) {
          return $filter("number")(params.value, 2);
        },
        cellStyle: { "text-align": "right" }
      }
    ];

    if (!$stateParams.isClient) {
      vm.masterColumnDefs.push({
        suppressMenu: true,
        suppressSorting: true,
        headerName: "QUOTATION.PENDING_APPROVAL_DATE",
        headerCellRenderer: getHeader,
        name: "approve",
        width: 90,
        cellStyle: { "text-align": "center" },
        cellRenderer: function (params) {
          if (!params.data.detail) {
            return getDifDays(params.data);
          }
          return "";
        }
      });
      vm.masterColumnDefs.splice(1, 0, {
        headerName: "REQUISITION.COMPANY_BUYER",
        field: "provider.name",
        headerCellRenderer: getHeader,
        width: 200,
        enableRowGroup: true,
        enablePivot: true
      });
    }

    vm.masterColumnDefs.push(
      {
        headerName: "QUOTATION.AUTHORIZATIONDATE",
        field: "requisition.authorizationDate",
        headerCellRenderer: getHeader,
        width: 200,
        valueFormatter: function (params) {
          return $filter("date")(params.value, "dd/MM/yyyy HH:mm:ss");
        },
        enableRowGroup: true,
        enablePivot: true
      }
    );

    vm.masterColumnDefs.push(
      {
        headerName: "QUOTATION.QUOTATION_DATE",
        field: "createdAt",
        headerCellRenderer: getHeader,
        valueFormatter: valueFormatterQuotationDate(),
        enableRowGroup: true,
        enablePivot: true
      }
    );

    if (vm.productId) {
      vm.masterColumnDefs = getColumnsByProduct();
    }

    if ($stateParams.status === "Ingresada") {
      vm.masterColumnDefs.splice(1, 0, {
        headerName: "REQUISITION.COMPANY_BUYER",
        field: REQUISITION_DEPARTMENT_COMPANY_NAME,
        headerCellRenderer: getHeader,
        width: 200,
        enableRowGroup: true,
        enablePivot: true
      });
    }

    vm.masterColumnDefs.push({
      suppressMenu: true,
      suppressSorting: true,
      headerName: "QUOTATION.VIEW_DETAIL",
      headerCellRenderer: getHeader,
      name: "detail",
      width: 90,
      cellRenderer: function (params) {
        if (!params.data.detail) {
          return (
            '<div layout="row" layout-align="center center"> ' +
            '<md-button class="md-icon-button" ng-click="vm.gotoQuotationDetail(data.id)"> ' +
            '<md-icon md-font-icon="icon-eye" class="s16"></md-icon> ' +
            '<md-tooltip md-direction="left">{{"QUOTATION.VIEW_DETAIL" | translate}}</md-tooltip> ' +
            "</md-button> </div>"
          );
        }
        return "";
      },
      cellStyle: { padding: "0px" },
      pinned: "right"
    });

    if (vm.statusToChange && !vm.productId) {
      vm.masterColumnDefs.push({
        suppressMenu: true,
        suppressSorting: true,
        headerName: "QUOTATION.PDF",
        headerCellRenderer: getHeader,
        name: "print",
        width: 90,
        cellRenderer: cellRendererFunctionPrint(),
        cellStyle: { padding: "0px" },
        pinned: "right"
      });
      vm.masterColumnDefs.push({
        suppressMenu: true,
        suppressSorting: true,
        headerName: vm.statusToChange.buttonDescription,
        headerCellRenderer: getHeader,
        name: "approve",
        width: 90,
        cellRenderer: function (params) {
          if (!params.data.detail) {
            return (
              '<div ' +
              'layout="row" layout-align="center center"> ' +
              '<md-button ng-disabled="vm.button' +
              params.rowIndex +
              '" ng-model="vm.button' +
              params.rowIndex +
              '" ' +
              'class="md-icon-button" ng-click="vm.changeStatus(data, ' +
              params.rowIndex +
              ", $event); vm.button" +
              params.rowIndex +
              '=true"> ' +
              '<md-icon md-font-icon="' +
              vm.statusToChange.icon +
              '" class="s16"></md-icon> ' +
              '<md-tooltip md-direction="left">{{"' +
              vm.statusToChange.buttonDescription +
              '" | translate}}</md-tooltip> ' +
              "</md-button> </div>"
            );
          }
          return "";
        },
        cellStyle: { padding: "0px" },
        pinned: "right"
      });
    }

    vm.masterGridOptions = {
      columnDefs: vm.masterColumnDefs,
      enableSorting: true,
      debug: false,
      enableFilter: true,
      enableColResize: true,
      angularCompileRows: true,
      angularCompileHeaders: true,
      rowData: null,
      groupHeaders: true,
      headerHeight: 50,
      rowHeight: 45,
      doesDataFlower: function (dataItem) {
        return true;
      },
      isExternalFilterPresent: isExternalFilterPresent,
      doesExternalFilterPass: doesExternalFilterPass,
      pinnedBottomRowData: [],
      getMainMenuItems: function (params) {
        return getHeaderMenu(params, $filter);
      },
      localeTextFunc: function (key, defaultValue) {
        return translateGrid(key, defaultValue, $filter);
      },
      getContextMenuItems: isGetContextMenuItems
    };

    var filter = "everyone";
    function isExternalFilterPresent() {
      return filter !== "";
    }

    function doesExternalFilterPass(node) {
      if (filter && filter !== "everyone") {
        var arrdt = node.data.filter.split(filter);
        return arrdt.length > 1;
      }
      return true;
    }

    function isGetContextMenuItems() {
      const paramrs = getParameterToExport();

      paramrs.processCellCallback = isProcessCellCallBack();

      paramrs.processHeaderCallback = function (params) {
        return $filter('translate')(params.column.colDef.headerName);
      };

      return [
        'copy',
        'copyWithHeaders',
        'paste',
        'separator',
        {
          name: EXPORT_TRANSLATE,
          subMenu: getContextSubMenuItems(paramrs)
        }
      ];
    }

    function getQuotations() {
      vm.masterGridOptions.api.setRowData([]);
      vm.loading = true;
      api.ComprasWS.Quotation.findByStatus
        .query({
          companyId: $rootScope.bsCircle.company.id,
          statusName: $stateParams.status,
          productId: vm.productId
        })
        .$promise.then(
          function (response) {
            vm.loading = false;
            if (response.length > 0) {
              vm.gridData = response;
              var total = new jinqJs()
                .from(response)
                .sum("total")
                .select(function (d) {
                  return { total: d, detail: 1 };
                });

              const listDimensions3 = new jinqJs()
                .from(response)
                .where(function (d) {
                  return d.requisition.dimensionCompanyDetail3;
                })
                .select(function (r) {
                  return r.requisition.dimensionCompanyDetail3;
                });
              const listDimensions4 = new jinqJs()
                .from(response)
                .where(function (d) {
                  return d.requisition.dimensionCompanyDetail4;
                })
                .select(function (r) {
                  return r.requisition.dimensionCompanyDetail4;
                });
              const listDimensions5 = new jinqJs()
                .from(response)
                .where(function (d) {
                  return d.requisition.dimensionCompanyDetail5;
                })
                .select(function (r) {
                  return r.requisition.dimensionCompanyDetail5;
                });

              if (listDimensions3.length > 0 ||
                listDimensions4.length > 0 ||
                listDimensions4.length > 0
              ) {
                const distinctListDimensionCompanies = new jinqJs()
                  .from(listDimensions3, listDimensions4, listDimensions5)
                  .distinct(
                    'dimensionCompanyId'
                  )
                  .select(function (r) {
                    return r.dimensionCompanyId;
                  });

                if (distinctListDimensionCompanies.length > 0) {
                  getDimensionCompanyByList(distinctListDimensionCompanies);
                }
              }

              vm.masterGridOptions.api.setRowData(vm.gridData);
              vm.masterGridOptions.api.setPinnedBottomRowData(total);
            }
          },
          function (response) {
            vm.loading = false;
            $log.error(response);
          }
        );
    }

    $scope.$watch("vm.search", function (newValue) {
      if (vm.masterGridOptions.api) {
        vm.masterGridOptions.api.setRowData(
          $filter("filter")(vm.gridData, vm.search)
        );
      }
    });

    /**
     * Go to product detail
     *
     * @param id
     */
    function gotoQuotationDetail(id) {
      if (vm.productId) {
        $state.go("app.quotation.reportDetailPendingApprove.detail", { id: id, productId: vm.productId, backTo: $stateParams.backTo, filter: $stateParams.filter });
      } else {
        $state.go("app.quotation." + $stateParams.status + ".detail", { id: id });
      }
    }

    /**
     * Cambia estado a una cotización
     * @param {type} data
     * @param {type} i
     * @param {type} ev
     * @returns {undefined}
     */
    function changeStatus(data, i, ev) {
      var confirm = $mdDialog
        .confirm()
        .title(
          $filter("translate")("QUOTATION.MSG." + vm.status + "_QUOTATION")
        )
        .textContent(
          $filter("translate")(
            "QUOTATION.MSG.CONFIRMACION_" + vm.status + "_QUOTATION"
          )
        )
        .ok($filter("translate")("QUOTATION.MSG.SI"))
        .cancel($filter("translate")("QUOTATION.MSG.NO"))
        .targetEvent(ev);

      $mdDialog.show(confirm).then(
        function () {
          if ($stateParams.status === "Autorizado") {
            $rootScope.loadingProgress = true;
            validateFixedAssetApp(data, i, ev);
          }
        },
        function () {
          eval("vm.button" + i + "  =false;");
        }
      );
    }

    function validateFixedAssetApp(quotation, i, ev) {
      api.GeneralWS.CompanyApplication.byAppName.get(
        {
          company: quotation.requisition.department.company.id,
          app: "Activos Fijos"
        },
        function (data) {
          if (data.active === true) {
            vm.quotation = quotation;
            getDetails(i);

          } else {
            approveQuotation(quotation, i, ev);
          }
        },
        function (data) {
          $log.debug(data);
          $rootScope.loadingProgress = false;
        }
      );
    }

    /**
     * Aprueba una cotización
     * @param {type} data
     * @param {type} index
     * @param {type} ev
     * @returns {undefined}
     */
    function approveQuotation(data, i, ev) {
      $mdDialog
        .show({
          controller: "ComposeDialogController",
          controllerAs: "vm",
          templateUrl:
            "app/main/apps/quotation/quotation/compose/compose-dialog.html",
          parent: angular.element("#main"),
          targetEvent: ev,
          quotation: data,
          quotationDetails: null,
          id: data.id,
          status: vm.statusToChange.name,
          clickOutsideToClose: false
        })
        .then(function (answer) {
          $rootScope.loadingProgress = false;
          eval("vm.button" + i + "  =false;");
          $timeout(function () {
            getQuotations();
          }, 100);
        }, function () {
          eval("vm.button" + i + "  =false;");
        });
    }

    /**
     * Devuelve un objeto con el siguiente estado al que pasa una cotización
     * @returns statusTochange
     */
    function getStatusTochange() {
      var statusToChange = null;

      switch ($stateParams.status) {
        case "Autorizado":
          statusToChange = {};
          statusToChange.name = "Aprobado Proveedor";
          statusToChange.icon = "icon-thumb-up-outline";
          statusToChange.buttonDescription = "QUOTATION.APPROVE";
          break;
      }

      return statusToChange;
    }

    function validateHasBudgetApplication() {
      api.GeneralWS.CompanyApplication.byAppName
        .get({ company: $rootScope.bsCircle.company.id, app: "Presupuestos" })
        .$promise.then(
          function (responseParameter) {
            if (responseParameter.$status === 200) {
              if (responseParameter.$data && responseParameter.$data !== "") {
                vm.hasBudgetApplication = responseParameter.$data.active;
              }
            }
          },
          function (response) {
            $log.error(response);
          }
        );
    }

    function init() {
      validateHasBudgetApplication();
      getQuotations();
      getDimensionCompany();
    }

    $timeout(function () {
      init();
    }, 1000);

    function getDifDays(data) {
      var hoy = new Date();
      var fecha1 = new Date(
        hoy.getFullYear() + "-" + (hoy.getMonth() + 1) + "-" + hoy.getDate()
      );
      var fecha2 = getDate(data);
      var diasDif = fecha1.getTime() - fecha2.getTime();
      return Math.round(diasDif / (1000 * 60 * 60 * 24));
    }

    function getDate(dataItem) {
      var day = 0;
      var month = 0;
      if (dataItem.createdAt.dayOfMonth < 10) {
        day = "0" + dataItem.createdAt.dayOfMonth;
      } else {
        day = dataItem.createdAt.dayOfMonth;
      }
      if (dataItem.createdAt.monthValue < 10) {
        month = "0" + dataItem.createdAt.monthValue;
      } else {
        month = dataItem.createdAt.monthValue;
      }
      return new Date(dataItem.createdAt.year + "-" + month + "-" + day);
    }

    function validateFixedAssets(i) {
      var productsId = vm.details.map(function (value, index) {
        return value.requisitionDetail.product["id"];
      });
      var companysId = vm.quotation.requisition.department.company.id;
      api.GeneralWS.ProductCompanyAddonsByProductsId.getList(
        {
          'companyId': companysId,
          'productsId': productsId.join(','),
        })
        .$promise.then(
          function (data) {
            if (data.length > 0) {
              validateFixedAssetsByProductAddons(i, data, productsId);
            } else {
              approveQuotation();
            }
          }
        );

    }

    function validateFixedAssetsByProductAddons(i, data, productsId) {
      var companysId = vm.quotation.requisition.department.company.id;
      data.map(function (value) {
        api.ActivosFijosWS.FixedAssetGroupFeature.countByCompany.get(
          {
            'companyId': companysId,
            'fixedAssetGroupId': value,
            'productsId': productsId.join(','),
            'isProvider': true,
          },
          function (count) {
            if (count.$status === 204) {
              approveQuotation(vm.quotation, i);
            } else {
              vm.statusToChange.name = "Aprobado sin caracteristicas";
              approveQuotation(vm.quotation, i);
            }
          },
          function (data) {
            $log.debug(data);
            $rootScope.loadingProgress = false;
          }
        );
      });
    }

    function getDetails(i) {
      $rootScope.loadingProgress = true;
      api.ComprasWS.QuotationDetail.me.query(
        {
          companyId: $rootScope.bsCircle.company.id,
          circleId: $rootScope.bsCircle.id,
          quotationId: vm.quotation.id
        },
        function (data) {
          vm.details = data.sort(function (a, b) {
            return a.id - b.id;
          });
          if (vm.statusToChange.name === 'Aprobado Proveedor') {
            vm.details = new jinqJs()
              .from(vm.details)
              .where(function (r) {
                return r.bought !== true;
              })
              .select(function (r) {
                return r;
              });
          }
          validateFixedAssets(i);
          $rootScope.loadingProgress = false;
        },
        function (data) {
          $log.debug(data);
          $rootScope.loadingProgress = false;
        }
      );
    }

    vm.onExportXLS = function () {
      vm.buttonExportDisable = true;
      const parameters = getParameterToExport();

      parameters.processCellCallback = isProcessCellCallBack();

      parameters.fileName = $filter('translate')(QUOTATION_TRANSLATE) + new Date().getTime() + '.xlsx';

      parameters.processHeaderCallback = function (params) {
        return $filter('translate')(params.column.colDef.headerName);
      };

      vm.masterGridOptions.api.exportDataAsExcel(parameters);
      $timeout(function () {
        vm.buttonExportDisable = false;
      }, TIMEOUT_FIVE_THOUSAND);
    };

    function goToBack() {
      if ($stateParams.backTo && $stateParams.filter) {
        $state.go($stateParams.backTo, { filter: $stateParams.filter });
      } else {
        $state.go("app.quotation.reportDetailPendingApprove");
      }
    }

    function printQuotation(data) {
      const urlRpt = $rootScope
        .getParameterValue('JASPER_URL_QUOTATIONS')
        .replace("[ID]", data.id);

      $mdDialog
        .show({
          controller: "ReportShowPDFController",
          controllerAs: "vm",
          templateUrl: "app/main/apps/reports/dialogs/show-pdf/show-pdf.html",
          parent: angular.element("#main"),
          locals: {
            Url: urlRpt
          },
          clickOutsideToClose: false,
          fullscreen: true
        })
        .then();
    }

    function downloadPdf(id) {
      const theLink = $sce.trustAsResourceUrl(
        envService.read("baseUrlJReportsWSPdf") +
        "?rpt=" +
        $rootScope.getParameterValue('JASPER_URL_QUOTATIONS').replace("[ID]", id)
      );

      const a = document.createElement("a");
      a.href = theLink;
      a.target = "_blank";
      a.download = "file.pdf";
      document.body.appendChild(a);
      a.click();
    }

    function cellRendererFunctionPrint() {
      return function (params) {
        if (!params.data.detail) {
          return (
            '<div layout="row" ' +
            'layout-align="center center"> ' +
            '<md-button class="md-icon-button" ng-click="vm.downloadPdf(data.id)"> ' +
            '<md-icon md-font-icon="icon-download" class="s16"></md-icon> ' +
            '<md-tooltip md-direction="left">{{"QUOTATION.DOWNLOAD" | translate}}</md-tooltip> ' +
            '</md-button>'
            + '<md-button class="md-icon-button" ng-click="vm.printQuotation(data)"> ' +
            '<md-icon md-font-icon="icon-printer" class="s16"></md-icon> ' +
            '<md-tooltip md-direction="left">{{"QUOTATION.PRINT" | translate}}</md-tooltip> ' +
            '</md-button>'
            + ' </div>'
          );
        }
        return "";
      };
    }

    function valueFormatterQuotationDate() {
      return function (params) {
        if (params.value === undefined || params.value === null) {
          return '';
        } else {
          return $filter('apiDate')(params.value, 'dd/MM/yyyy HH:mm:ss');
        }
      };
    }

    function getColumnsByProduct() {
      return [
        {
          headerName: QUOTATION_TRANSLATE,
          field: 'id',
          headerCellRenderer: getHeader,
          width: 180,
          cellStyle: { 'text-align': 'center' },
          sort: 'asc',
          pinned: 'left'
        },
        {
          headerName: 'QUOTATION.CLIENT',
          field: REQUISITION_DEPARTMENT_COMPANY_NAME,
          headerCellRenderer: getHeader,
          width: 350,
          enableRowGroup: true,
          enablePivot: true
        },
        {
          headerName: 'QUOTATION.DEPARTMENT',
          field: 'requisition.department.description',
          headerCellRenderer: getHeader,
          width: 350,
          enableRowGroup: true,
          enablePivot: true
        },
        {
          headerName: 'QUOTATION.COST_CENTER',
          field: 'requisition.costCenter.description',
          headerCellRenderer: getHeader,
          width: 350,
          enableRowGroup: true,
          enablePivot: true
        }
      ];
    }

    function isProcessCellCallBack() {
      return function (params) {
        if (params.column.colId.indexOf('fecha') !== -1) {
          return $filter('date')(params.value, 'dd/MM/yyyy');
        } else if (
          params.column.colId.indexOf('createdAt') !== -1 &&
          params.value
        ) {
          return $filter('apiDate')(params.value, 'dd/MM/yyyy HH:mm:ss');
        } else {
          return params.value;
        }
      };
    }

    function getContextSubMenuItems(paramrs) {
      return [
        {
          name: EXPORT_TRANSLATE + ' CSV',
          action: dataExportCSV(paramrs)
        },
        {
          name: EXPORT_TRANSLATE + ' Excel (.xlsx)',
          action: dataExportExcel(paramrs)
        },
        {
          name: EXPORT_TRANSLATE + ' Excel (.xml)',
          action: dataExportXml(paramrs)
        }
      ];
    }

    function dataExportCSV(paramrs) {
      return function () {
        paramrs.fileName = $filter('translate')(QUOTATION_TRANSLATE);
        vm.masterGridOptions.api.exportDataAsCsv(paramrs);
      };
    }

    function dataExportExcel(paramrs) {
      return function () {
        paramrs.fileName = $filter('translate')(QUOTATION_TRANSLATE) + new Date().getTime() + '.xlsx';
        vm.masterGridOptions.api.exportDataAsExcel(paramrs);
      };
    }

    function dataExportXml(paramrs) {
      return function () {
        paramrs.fileName = $filter('translate')(QUOTATION_TRANSLATE);
        paramrs.exportMode = 'xml';
        vm.masterGridOptions.api.exportDataAsExcel(paramrs);
      };
    }

    function getParameterToExport() {
      return {
        skipHeader: false,
        skipFooters: false,
        skipGroups: false,
        allColumns: true,
        onlySelected: false,
        columnSeparator: ',',
        sheetName: $filter('translate')(QUOTATION_TRANSLATE)
      };
    }

    function getHeaderIsProviderOrClient() {
      if ($stateParams.isClient === true) {
        return 'QUOTATION.PROVIDER';
      }
      return 'QUOTATION.CLIENT';
    }

    function getFieldIsProviderOrClient() {
      if ($stateParams.isClient === true) {
        return 'provider.name';
      }
      return REQUISITION_DEPARTMENT_COMPANY_NAME;
    }

    function getDimensionCompany() {
      api.GeneralWS.DimensionCompany.byCompany.getList(
        { 'company': $rootScope.bsCircle.company.id }
      ).$promise.then(function (responseDimension) {
        sortResponseDimension(responseDimension);
        verifyDimensionCompanyGetDetails(responseDimension);
      });
    }

    function addMasterColumnDefs(name, fieldName, number) {
      const NUMBER_COLUMN_ADD = 3;
      let exist = false;
      vm.masterColumnDefs.forEach(function (r) {
        if (r.headerName === name) {
          exist = true;
        }
      });
      if (!exist) {
        vm.masterColumnDefs.splice((number + NUMBER_COLUMN_ADD), 0, {
          headerName: name,
          field: fieldName,
          headerCellRenderer: getHeader,
          width: 200,
          enableRowGroup: true,
          filter: 'text',
          enablePivot: true
        });
      }
    }

    function getDimensionCompanyByList(ids) {
      api.GeneralWS.DimensionCompany.getByIdList.getList(
        { 'company': vm.companyId }, ids
      ).$promise.then(function (responseDimension) {
        sortResponseDimension(responseDimension);
        verifyDimensionCompanyGetDetails(responseDimension);
      });
    }

    function verifyDimensionCompanyGetDetails(responseDimension) {
      for (let i = 0; i < responseDimension.length; i++) {
        if (responseDimension[i].dimensionNumber === NUMBER_DIMENSION_THREE && !vm.dimensionCompanyDetail3) {
          vm.dimensionCompanyDetail3 = responseDimension[i];
          addMasterColumnDefs(responseDimension[i].description, 'requisition.dimensionCompanyDetail3.name', responseDimension[i].dimensionNumber);
        } else if (responseDimension[i].dimensionNumber === NUMBER_DIMENSION_FOUR && !vm.dimensionCompanyDetail4) {
          vm.dimensionCompanyDetail4 = responseDimension[i];
          addMasterColumnDefs(responseDimension[i].description, 'requisition.dimensionCompanyDetail4.name', responseDimension[i].dimensionNumber);
        } else if (responseDimension[i].dimensionNumber === NUMBER_DIMENSION_FIVE && !vm.dimensionCompanyDetail5) {
          vm.dimensionCompanyDetail5 = responseDimension[i];
          addMasterColumnDefs(responseDimension[i].description, 'requisition.dimensionCompanyDetail5.name', responseDimension[i].dimensionNumber);
        } else {
          vm.dimensionCompanyDetail1 = responseDimension[i];
        }
        if (responseDimension[responseDimension.length - 1] === responseDimension[i]) {
          vm.masterGridOptions.api.setColumnDefs(vm.masterColumnDefs);
        }
      }
    }

    function sortResponseDimension(responseDimension) {
      responseDimension.sort(function (a, b) {
        return a.dimensionNumber - b.dimensionNumber;
      });
    }

  }
})();

(function () {
    'use strict';

    angular
        .module('app.requisition')
        .controller('RequisitionsController', RequisitionsController);

    /** @ngInject */
    function RequisitionsController($state, api, $rootScope, $log, $mdDialog, $filter, $timeout, $scope, $stateParams, MessageService) {
        var vm = this;

        vm.statusNameByRole = "";
        vm.iconChangeStatusButton = "";
        vm.showChangeStatusButton = false;
        vm.isCreate = $stateParams.status === 'Creando';
        vm.statusToChange = $stateParams.status;
        vm.isTicket = $stateParams.tickets;
        vm.chageStatusButton = getDatasToChange($stateParams.status);
        vm.isBuyer = $stateParams.isBuyer;
        vm.pageSize = 100;
        vm.page = 0;
        vm.userToQuote = $rootScope.bsCircle.name === 'ROLE_COMPRAS_OPERADOR';

        vm.masterColumnDefs = [
            {
                headerName: '#',
                field: "id",
                width: 50,
                filter: 'number',
                cellStyle: { 'text-align': 'center' },
                pinned: 'left'
            },
            {
                headerName: 'REQUISITION.DEPARTMENT',
                field: "department.description",
                headerCellRenderer: getHeader,
                width: 250,
                filter: 'text',
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'REQUISITION.COSTCENTER',
                field: "costCenter.description",
                headerCellRenderer: getHeader,
                width: 200,
                filter: 'text',
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'REQUISITION.PROJECT',
                field: "prjName",
                headerCellRenderer: getHeader,
                width: 150,
                filter: 'text',
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'REQUISITION.MAXDATEPURCHASE',
                field: "maxDatePurchase",
                headerCellRenderer: getHeader,
                valueFormatter: function (params) {
                    return $filter('date')(params.value, 'dd/MM/yyyy');
                },
                enableRowGroup: true,
                filter: 'date',
                enablePivot: true
            },
            {
                headerName: 'REQUISITION.REQUISITION_TYPE',
                field: "requisitionType.description",
                headerCellRenderer: getHeader,
                valueFormatter: function (params) {
                    return $filter('date')(params.value, 'dd/MM/yyyy');
                },
                enableRowGroup: true,
                filter: 'date',
                enablePivot: true
            },
            {
                headerName: 'REQUISITION.DESCRIPTION',
                field: "description",
                headerCellRenderer: getHeader,
                valueFormatter: function (params) {
                    return $filter('date')(params.value, 'dd/MM/yyyy');
                },
                enableRowGroup: true,
                filter: 'date',
                enablePivot: true
            },
            {
                headerName: 'REQUISITION.ACTIONS',
                name: "actions",
                headerCellRenderer: getHeader,
                suppressSorting: true,
                suppressMenu: true,
                width: 250,
                cellRenderer: renderer,
                cellStyle: { 'padding': '0px' },
                pinned: 'right'
            }
        ];

        if ($stateParams.status === 'Autorizado') {
            vm.masterColumnDefs.splice(4, 0, {
                headerName: 'REQUISITION.STATUS',
                field: "purchaseStatus.description",
                headerCellRenderer: getHeader,
                width: 200,
                enableRowGroup: true,
                filter: 'text',
                enablePivot: true
            });
        }

        if ($stateParams.status === 'Ingresado' || $stateParams.status === "Autorizado") {
            vm.masterColumnDefs.splice(1, 0, {
                headerName: 'REQUISITION.COMPANY_BUYER',
                field: "department.company.name",
                headerCellRenderer: getHeader,
                width: 200,
                filter: 'text',
                enableRowGroup: true,
                enablePivot: true
            });
        }

        vm.masterGridOptions = {
            columnDefs: vm.masterColumnDefs,
            enableSorting: true,
            debug: false,
            enableFilter: true,
            enableColResize: true,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowData: null,
            groupHeaders: true,
            headerHeight: 50,
            rowHeight: 40,
            rowSelection: 'multiple',
            rowDeselection: true,
            rowModelType: "enterprise",
            cacheBlockSize: vm.pageSize,
            pagination: true,
            paginationPageSize: vm.pageSize,
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            },
            doesDataFlower: function (dataItem) {
                return true;
            },
            isExternalFilterPresent: isExternalFilterPresent,
            doesExternalFilterPass: doesExternalFilterPass
        };

        vm.masterColumnDefs.forEach(function (d) {
            correctFilterParams(d);
        });

        function correctFilterParams(column) {
            switch (column.filter) {
                case 'number':
                    column.filterParams = {
                        filterOptions: ['equals'],
                        newRowsAction: 'keep'
                    };
                    break;
                case 'text':
                    column.filterParams = {
                        filterOptions: ['contains'],
                        newRowsAction: 'keep'
                    };
                    break;
                case 'date':
                    column.suppressFilter = true;
                    break;
            }
        }

        var filter = '';

        function isExternalFilterPresent() {
            return filter !== '';
        }

        function doesExternalFilterPass(node) {
            if (filter && filter !== 'everyone') {
                var arrdt = node.data.filter.split(filter);
                return arrdt.length > 1;
            }
            return true;
        }

        $scope.$watch('vm.search',
            function (newValue) {
                filter = newValue ? newValue.toLowerCase() : '';
                vm.masterGridOptions.api.onFilterChanged();
            }
        );


        function loadData() {
            vm.projectId = [];
            var dataSource = {
                paginationPageSize: vm.pageSize,
                getRows: function (params) {
                    var o = params.request.filterModel;
                    var arr = [];
                    if (params.request.filterModel) {
                        arr = $.map(o, function (k, ke) {
                            var on = k;
                            on.field = ke;
                            on.filter = on.filter.toString();
                            return on;
                        });
                    }
                    arr.forEach(function (row) {
                        filter = filter + "%" + row.filter;
                    });
                    api.ComprasWS.Requisition.page(
                        {
                            idCircle: $rootScope.bsCircle.id, status: vm.status,
                            page: vm.masterGridOptions.api.paginationGetCurrentPage(), pageSize: vm.pageSize, tickets: $stateParams.tickets, 'filter': filter
                        },
                        function (response) {// Success
                            var projectIds = [];
                            vm.requisitions = new jinqJs()
                                .from(response.content)
                                .orderBy([{ field: 'id', sort: 'asc' }])
                                .select(function (r) {
                                    var d = r;
                                    d.filter = (d.id + "," + d.department.description + "," + d.costCenter.description).toLowerCase();
                                    if (d.projectId !== undefined) {
                                        if (projectIds.length > 0) {
                                            if (projectIds.indexOf(d.projectId) < 0) {
                                                projectIds.push(d.projectId);
                                            }
                                        } else {
                                            projectIds.push(d.projectId);
                                        }

                                    }
                                    return d;
                                });
                            if (projectIds.length > 0) {
                                getAllProject(params, response, vm.requisitions, projectIds);
                            } else {
                                params.successCallback(vm.requisitions, response.totalElements);
                                vm.loading = false;
                                filter = '';
                                $rootScope.loadingProgress = false;
                                $log.debug(vm.requisitions);
                            }

                        }, function (response) {// Error
                            $log.debug(response);
                            vm.loading = false;
                            $rootScope.loadingProgress = false;
                        });

                }
            };
            vm.masterGridOptions.api.setEnterpriseDatasource(dataSource);
        }

        function getAllProject(params, response, data, projectIds) {
            api.ProyectosWS.getAllProject.get({ 'ids': projectIds }, function (pjr) {
                data.forEach(function (row) {
                    pjr.forEach(function (res) {
                        if (row.projectId === res.id) {
                            row.prjName = res.name;
                        }
                    });
                });
                params.successCallback(data, response.totalElements);
                vm.loading = false;
                filter = '';
                $rootScope.loadingProgress = false;
                $log.debug(vm.requisitions);
            }, function(){
                params.successCallback(data, response.totalElements);
              });
        }

        function loadDataToCotize() {
            var projectIds = [];
            var dataSource = {
                paginationPageSize: vm.pageSize,
                getRows: function (params) {
                    api.ComprasWS.Requisitions.toCotize.page(
                        {
                            idCircle: $rootScope.bsCircle.id,
                            page: vm.masterGridOptions.api.paginationGetCurrentPage(),
                            pageSize: vm.pageSize,
                            tickets: $stateParams.tickets,
                            userToQuote: vm.userToQuote,
                            'filter': filter
                        },
                        function (response) {// Success
                            vm.requisitions = new jinqJs()
                                .from(response.content)
                                .orderBy([{ field: 'id', sort: 'asc' }])
                                .select(function (r) {
                                    var d = r;
                                    d.filter = (d.id + "," + d.department.description + "," + d.costCenter.description).toLowerCase();
                                    if (d.projectId !== undefined) {
                                        if (projectIds.length > 0 ) {
                                            if (projectIds.indexOf(d.projectId) < 0) {
                                                projectIds.push(d.projectId);
                                            }
                                        } else {
                                            projectIds.push(d.projectId);
                                        }
                                    }
                                    return d;
                                });
                            if (projectIds.length  > 0) {
                                getAllProject(params, response, vm.requisitions, projectIds);
                            }  else {
                                vm.loading = false;
                                $rootScope.loadingProgress = false;
                                params.successCallback(vm.requisitions, response.totalElements);
                                $log.debug(vm.requisitions);
                            }
                        }, function (response) {// Error
                            $log.debug(response);
                            vm.loading = false;
                            $rootScope.loadingProgress = false;
                        });
                }
            };
            vm.masterGridOptions.api.setEnterpriseDatasource(dataSource);
        }

        vm.loading = true;
        const FOUR_HUNDRED_TIME_OUT = 400;
        $timeout(function (d) {
            if ($rootScope.bsCircle) {
                $rootScope.loadingProgress = true;
                vm.loading = true;
                vm.status = $stateParams.status === 'Autorizado' ? 'Autorizado,Licitando' : $stateParams.status;
                vm.masterGridOptions.api.setColumnDefs(vm.masterColumnDefs);
                if ($stateParams.status === 'Autorizado') {
                    loadDataToCotize();
                } else {
                    loadData();
                }
                $timeout(function () {
                    getDimensionCompany();
                }, FOUR_HUNDRED_TIME_OUT);
            } else {
                vm.loading = false;
                $state.go('app.dashboard_project');
            }
        }, FOUR_HUNDRED_TIME_OUT);

        // Methods
        vm.convertDate = convertDate;
        vm.gotoRequisitionDetail = gotoRequisitionDetail;
        vm.newRequisition = newRequisition;
        vm.deleteRequisition = deleteRequisition;
        vm.presentRequisition = presentRequisition;

        //////////

        function convertDate(dateS) {
            return new Date(dateS + ' 00:00:00');
        }

        function presentRequisition(data, i) {


            var confirm = $mdDialog.confirm()
                .title($filter('translate')('REQUISITION.MSG.' + vm.statusToChange + '_REQUISITION'))
                .textContent($filter('translate')('REQUISITION.MSG.CONFIRMACION_' + vm.statusToChange + '_REQUISITION'))
                .ok($filter('translate')('REQUISITION.MSG.SI'))
                .cancel($filter('translate')('REQUISITION.MSG.NO'));
            $mdDialog.show(confirm).then(function () {

                if ($stateParams.status === 'Autorizado') {
                    $state.go('app.quotation.new', { quotationId: 0, requisitionId: data.id });
                } else {

                    $rootScope.loadingProgress = true;

                    var promise = api.ComprasWS.Requisition.changeStatus({ 'idCircle': $rootScope.bsCircle.id, 'id': data.id }, null).$promise;
                    promise.then(function (response) {
                        if (response.circle) {
                            var obj = getObjectTender(response);
                            api.LicitadorWS.Tender.create({ 'circle': response.circle.id }, obj,
                                function (data) {
                                    MessageService.show('REQUISITION.MSG.TENDERCREATED');

                                    $rootScope.loadingProgress = false;
                                    spliceRequisition(data.id);
                                    vm.masterGridOptions.api.setRowData(vm.requisitions);
                                },
                                function (err) {
                                    $rootScope.loadingProgress = false;
                                    MessageService.show('REQUISITION.MSG.ERROR');
                                }
                            );
                        } else {
                            MessageService.show("REQUISITION.MSG.CHANGESTATUS." + vm.statusToChange);
                            $rootScope.loadingProgress = false;
                            spliceRequisition(data.id);
                            vm.masterGridOptions.api.setRowData(vm.requisitions);
                        }
                    }, function (response) {
                        $rootScope.loadingProgress = false;
                        var msg = 'ERROR';
                        if (response.data === 'No Detail') {
                            msg = 'DETAIL';
                        }
                        if (response.data === 'No_products') {
                            msg = 'NOT_PRODUCT_NEGOTIATED';
                        }

                        MessageService.show('REQUISITION.MSG.' + msg);
                    });
                }

            }, function () {
            });
        }


        /**
         * Delete
         *
         * @param e
         * @param id
         * @param i
         * @returns {*}
         */
        function deleteRequisition(e, id, i) {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('REQUISITION.CANCELAR'))
                .textContent($filter('translate')('REQUISITION.MSG.CONFIRMACION_CANCEL'))
                .ok($filter('translate')('REQUISITION.MSG.SI'))
                .cancel($filter('translate')('REQUISITION.MSG.NO'));

            $mdDialog.show(confirm).then(function () {

                $rootScope.loadingProgress = true;

                api.ComprasWS.Requisition.delete({ idCircle: $rootScope.bsCircle.id, id: id }, function (response) {// Success
                    spliceRequisition(id);
                    $rootScope.loadingProgress = false;
                    vm.masterGridOptions.api.setRowData(vm.requisitions);

                    MessageService.show('REQUISITION.MSG.DELETED');
                }, function (response) {// Error
                    $log.debug(response);
                });

            }, function () {
            });
        }

        /**
         * Go to product detail
         *
         * @param id
         */
        function gotoRequisitionDetail(id) {
            if (vm.isTicket) {
                if ($stateParams.status === 'Autorizado') {
                    $state.go('app.requisition.AutorizadoTickets.detail', { id: id });
                } else {
                    $state.go('app.requisition.CreandoTickets.detail', { id: id });
                }
            } else if ($stateParams.isBuyer && $stateParams.status === 'Autorizado') {
                $state.go('app.requisition.PendienteCotizar.detail', { id: id, isBuyer: true });
            } else {
                $state.go('app.requisition.' + $stateParams.status + '.detail', { id: id });
            }
        }

        /**
         * Go to product detail
         *
         */
        function newRequisition() {
            $state.go('app.requisition.Creando.detail');
        }

        function renderer(params) {
            var toRet = '<div style="width: 100%;">';
            if (vm.isCreate) {
                toRet = toRet + '<md-button class="edit-button md-icon-button" ng-click="vm.gotoRequisitionDetail(data.id)" aria-label="Order details"'
                    + '                                 translate translate-attr-aria-label="REQUISITION.ORDER_DETAILS">'
                    + '                     <md-tooltip md-direction="bottom">'
                    + '                         {{"REQUISITION.DETAIL.EDIT"| translate}}'
                    + '                     </md-tooltip>'
                    + '                     <md-icon md-font-icon="icon-border-color" class="s16"></md-icon> '
                    + '                 </md-button>';
            } else {
                toRet = toRet + '<md-button class="edit-button md-icon-button" ng-click="vm.gotoRequisitionDetail(data.id)" aria-label="Order details"'
                    + '                            translate translate-attr-aria-label="REQUISITION.ORDER_DETAILS">'
                    + '                     <md-tooltip md-direction="bottom">'
                    + '                         {{"REQUISITION.DETAIL.VIEW"| translate}}'
                    + '                     </md-tooltip>'
                    + '                     <md-icon md-font-icon="icon-eye" class="s16"></md-icon> '
                    + '                 </md-button>';
            }

            if (params.data && params.data.purchaseStatus.description !== 'Licitando' && !vm.isBuyer) {
                toRet = toRet + '<md-button class="edit-button md-icon-button" ng-click="vm.presentRequisition(data, '
                    + params.rowIndex + ')" aria-label="present requisition"'
                    + '                            translate translate-attr-aria-label="REQUISITION.ORDER_DETAILS">'
                    + '                     <md-tooltip md-direction="bottom">'
                    + '                         {{vm.chageStatusButton.desc| translate}}'
                    + '                     </md-tooltip>'
                    + '                     <md-icon md-font-icon="{{vm.chageStatusButton.icon}}" class="s16"></md-icon>'
                    + '                 </md-button>';
            }

            if (vm.isCreate || (params.data && params.data.purchaseStatus.description !== 'Licitando' && !vm.isBuyer)) {
                toRet = toRet + '<md-button class="edit-button md-icon-button" ng-click="vm.deleteRequisition($event, data.id,'
                    + params.rowIndex + ')" aria-label="Cancel"'
                    + '                            translate translate-attr-aria-label="REQUISITION.CANCELAR">'
                    + '                     <md-tooltip md-direction="bottom">'
                    + '                         {{"REQUISITION.CANCELAR"| translate}}'
                    + '                     </md-tooltip>'
                    + '                     <md-icon md-font-icon="icon-minus-circle" class="s16 md-warn"></md-icon> '
                    + '                 </md-button>';
            }

            return toRet + '</div>';
        }

        function getDatasToChange(status) {
            var ret = { desc: 'REQUISITION.STATUSCHANGE.' + status };
            switch (status) {
                case 'Creando':
                    ret.icon = 'icon-content-paste';
                    break;
                case 'Ingresado':
                    ret.icon = 'icon-key-variant';
                    break;
                case 'Autorizado':
                    ret.icon = 'icon-thumb-up-outline';
                    break;
            }
            return ret;
        }

        function spliceRequisition(id) {
            var nro = 0;
            vm.requisitions.forEach(function (row) {
                if (row.id === id) {
                    vm.requisitions.splice(nro, 1);
                }
                nro += 1;
            });

            loadData();
        }

        function getDimensionCompany() {
            const NUMBER_DIMENSION_THREE = 3;
            const NUMBER_DIMENSION_FOUR = 4;
            const NUMBER_DIMENSION_FIVE = 5;
            api.GeneralWS.DimensionCompany.byCompany.getList(
                { 'company': $rootScope.bsCircle.company.id }
            ).$promise.then(function (responseDimension) {
                for (let i = 0; i < responseDimension.length; i++) {
                    if (responseDimension[i].dimensionNumber === NUMBER_DIMENSION_THREE) {
                        vm.dimensionCompanyDetail3 = responseDimension[i];
                        addMasterColumnDefs(responseDimension[i].description, 'dimensionCompanyDetail3.name', responseDimension[i].dimensionNumber);
                    } else if (responseDimension[i].dimensionNumber === NUMBER_DIMENSION_FOUR) {
                        vm.dimensionCompanyDetail4 = responseDimension[i];
                        addMasterColumnDefs(responseDimension[i].description, 'dimensionCompanyDetail4.name', responseDimension[i].dimensionNumber);
                    } else if (responseDimension[i].dimensionNumber === NUMBER_DIMENSION_FIVE) {
                        vm.dimensionCompanyDetail5 = responseDimension[i];
                        addMasterColumnDefs(responseDimension[i].description, 'dimensionCompanyDetail5.name', responseDimension[i].dimensionNumber);
                    } else {
                        vm.dimensionCompanyDetail1 = responseDimension[i];
                    }
                }
                vm.masterGridOptions.api.setColumnDefs(vm.masterColumnDefs);
            });
        }

        function addMasterColumnDefs(name, fieldName, number) {
            const NUMBER_SIX_COLUMN_ADD = 6;
            vm.masterColumnDefs.splice((number + NUMBER_SIX_COLUMN_ADD), 0, {
                headerName: name,
                field: fieldName,
                headerCellRenderer: getHeader,
                width: 200,
                enableRowGroup: true,
                filter: 'text',
                enablePivot: true
            });
        }

    }
})();

(function () {
  "use strict";

  angular
    .module("app.reports")
    .controller("ReportsController", ReportsController);

  /** @ngInject */
  function ReportsController(
    $mdSidenav,
    $stateParams,
    Report,
    api,
    $rootScope,
    $state,
    $timeout,
    $templateRequest,
    $sce,
    $log,
    $filter,
    $mdDialog,
    envService,
    MessageService,
    $scope
  ) {
    var vm = this;

    const EXPORT_TRANSLATE = $filter('translate')('REPORT.EXPORT');
    const FORMAT_DD_MM_YY_HH_MM_SS = 'dd/MM/yyyy HH:mm:ss';
    const FORMAT_DD_MM_YYYY = 'dd/MM/yyyy';
    const TIMEOUT_THREE_THOUSAND = 300;
    const TIMEOUT_FIVE_THOUSAND = 5000;
    const TIMEOUT_ELEVEN_THOUSAND = 11500;
    const NUMBER_ONE = 1;
    const NUMBER_THREE = 3;
    const TEXT_PROVIDERS = 'providers';

    var pageSize = Report.pageSize;
    vm.minDate = new Date();
    var params = { idc: $rootScope.bsCircle.company.id };
    vm.filter = {
      startDate: new Date(vm.minDate.getTime()),
      endDate: new Date(vm.minDate.getTime()),
      isProvider: Report.isProvider,
      appName: Report.filter.appName,
      isGeneral: Report.filter.isGeneral,
      noFilter: Report.filter.noFilter,
      providers: []
    };

    if ($stateParams.isTicket) {
      vm.filter.originTypeCode = "01";
    }

    vm.exportXLS = Report.exportXLS;
    vm.snFilter = Report.filter;
    vm.title = Report.title;
    vm.masterColumnDefs = angular.copy(Report.columns);
    vm.isShowFilter = true;
    vm.loadSettlementStatus = loadSettlementStatus;

    //metodos
    vm.clearSearchDepartment = clearSearchDepartment;
    vm.clearSearchCostCenter = clearSearchCostCenter;
    vm.clearSearchStatus = clearSearchStatus;
    vm.clearRequisitionType = clearRequisitionType;
    vm.clearSettlementStatus = clearSettlementStatus;
    vm.clearSearchProject = clearSearchProject;
    vm.clearSearchReceivingPOUser = clearSearchReceivingPOUser;
    vm.goToRef = goToRef;
    vm.replaceOriginTypedata = replaceOriginTypedata;
    vm.showPDF = showPDF;
    vm.rejectInvoice = rejectInvoice;
    vm.showInterfazDetail = showInterfazDetail;
    vm.selectContractsValid = selectContractsValid;
    vm.showInvoiceDetail = showInvoiceDetail;
    vm.statuses = [];
    vm.requisitionTypes = [];
    vm.typeses = [];
    vm.providersSelect = [];
    vm.exceptionLimitDateButton = false;
    vm.exceptionLimitDate = exceptionLimitDate;
    vm.URLPHOTOS = api.baseUrlPhotos;
    vm.selectCompanies = selectCompanies;
    vm.selectProducts = selectProducts;
    vm.loadProviders = loadProviders;
    vm.clearSearchProviderSelect = clearSearchProviderSelect;
    vm.selectAllItemsProviders = selectAllItemsProviders;
    vm.loadCompanyByRole = loadCompanyByRole;
    vm.changeDeptosAndCc = changeDeptosAndCc;
    vm.loadProducts = loadProducts;
    vm.changeDeptosAndCcUser = changeDeptosAndCcUser;

    vm.searchProviderSelect = '';
    vm.searchProductInput = '';

    vm.number_three = 3;
    vm.number_four = 4;
    vm.number_five = 5;

    clearObjectDimensionCompany();

    vm.searchDimensionCompanyDetail3 = '';
    vm.searchDimensionCompanyDetail4 = '';
    vm.searchDimensionCompanyDetail5 = '';

    vm.dimensionCompanyDetail3List = [];
    vm.dimensionCompanyDetail4List = [];
    vm.dimensionCompanyDetail5List = [];

    vm.loadingdimensionCompanyDetail3List = false;
    vm.loadingdimensionCompanyDetail4List = false;
    vm.loadingdimensionCompanyDetail5List = false;

    vm.userDimensionCompanyDetails = [];

    vm.companyId = $rootScope.bsCircle.company.id;

    vm.filter.filterType = 'ALL';

    vm.hasBudgetApplication = false;

    vm.isShowLoaderUsers = false;

    vm.searchUserInput = '';

    vm.exporting = false;

    vm.masterColumnDefs.forEach(function (d) {
      d.headerCellRenderer = getHeader;
      if (d.valueFormatter) {
        d.valueFormatter = getCellFormater(d.valueFormatter);
      }
      if (d.rendererCurrencyDescAmount) {
        d.cellRenderer = getFormedAmountCurrencyDescription(
          d.rendererCurrencyDescAmount.amountField,
          d.rendererCurrencyDescAmount.currecyField
        );
        delete d.rendererCurrencyDescAmount;
      }
      if (d.rendererButtons) {
        d.cellRenderer = getButtons(d.rendererButtons);
        delete d.rendererButtons;
      }
      if (d.rendererLink) {
        d.cellRenderer = getURL(d.rendererLink);
        delete d.rendererLink;
      }
      if (d.rendererButtonsM) {
        d.cellRenderer = getButtonsM(d.rendererButtonsM);
        delete d.rendererButtonsM;
      }
      if (d.rendererButtonsSettlement) {
        d.cellRenderer = getButtonsSettlement(d.rendererButtonsSettlement);
        delete d.rendererButtonsSettlement;
      }
      if (d.rendererTranslateValue) {
        d.cellRenderer = getTranslateValue(
          d.rendererTranslateValue.prefixTranslate,
          d.rendererTranslateValue.keyValue
        );
        delete d.rendererTranslateValue;
      }
      if (d.rendererSerie) {
        d.cellRenderer = getRendererSerie();
      }
      if (d.rendererFile) {
        d.cellRenderer = getRendererFile(d.rendererFile.field);
      }
      if (d.dataTypes) {
        correctFilter(d);
      }
      if (d.cellRendererSerie) {
        d.cellRenderer = function (params) {
          return params.data.invoiceSerie ? params.data.invoiceSerie : params.data.uuid;
        }
      }
    });

    function getRendererFile(field) {
      return function (params) {
        if (field === 'fileWithholding' && params.data && params.data.fileWithholding) {
          return '<a href="" ng-click="vm.viewIMG(data.fileWithholding)"> Ver Archivo</a>';
        }
      }
    }

    function getRendererSerie() {
      return function (params) {
        if (params.data) {
          if (params.data.invoicePurchase.invoiceSerie && !params.data.invoicePurchase.uuid) {
            return params.data.invoicePurchase.invoiceSerie.serie;
          } else {
            return params.data.invoicePurchase.uuid;
          }
        }
      }
    }

    vm.api = api;
    Report.api.forEach(function (d) {
      vm.api = vm.api[d];
    });

    function correctFilter(column) {
      switch (column.dataTypes) {
        case "Long":
        case "BigDecimal":
        case "Double":
        case "Integer":
          column.filter = "number";
          break;
        case "text":
          column.filter = "text";
          break;
        default:
          column.filter = "date";
          break;
      }
      correctFilterParams(column);
    }

    function correctFilterParams(column) {
      switch (column.filter) {
        case "number":
          column.filterParams = {
            filterOptions: ["equals"],
            newRowsAction: "keep"
          };
          break;
        case "text":
          column.filterParams = {
            filterOptions: ["contains"],
            newRowsAction: "keep"
          };
          break;
        case "date":
          column.suppressFilter = true;
          break;
      }
    }

    var gridOptions = Report.masterGridOptions;
    if (Report.detailGrid) {
      var templateDetail = null;
      vm.loadTemplate = function () {
        var otherTemplate = $sce.getTrustedResourceUrl(
          Report.detailGrid.templateUrl
        );
        $templateRequest(otherTemplate).then(
          function (template) {
            templateDetail = template;
          },
          function () {
            $log.error("Ocurrio un error al leer el template");
          }
        );
      };

      gridOptions.fullWidthCellRenderer = fullWidthCellRendererFn;
      gridOptions.isFullWidthCell = function (rowNode) {
        return rowNode.level === 1;
      };
      gridOptions.getRowHeight = function (params) {
        var rowIsDetailRow = params.node.level === 1;

        return rowIsDetailRow ? 450 : 45;
      };
      gridOptions.doesDataFlower = function (dataItem) {
        return true;
      };
    }
    gridOptions.onFilterChanged = function (c, d, e, f) {
      delete vm.filter.totalElements;
    };

    gridOptions.localeTextFunc = function (key, defaultValue) {
      return translateGrid(key, defaultValue, $filter);
    };

    gridOptions.getMainMenuItems = function (params) {
      return getHeaderMenu(params, $filter);
    };
    gridOptions.columnDefs = vm.masterColumnDefs;

    gridOptions.getContextMenuItems = isGetContextMenuItems;

    function isGetContextMenuItems() {
      const paramrs = getParameterToExport();

      paramrs.processCellCallback = isProcessCellCallBack();

      paramrs.processHeaderCallback = function (param) {
        return $filter('translate')(param.column.colDef.headerName);
      };

      return [
        'copy',
        'copyWithHeaders',
        'paste',
        'separator',
        {
          name: $filter('translate')('REPORT.EXPORT'),
          subMenu: getContextSubMenuItems(paramrs)
        }
      ];
    }

    function isProcessCellCallBack() {
      return function (param) {
        if (param.column.colId.indexOf('fecha') !== -1) {
          return $filter('date')(param.value, FORMAT_DD_MM_YYYY);
        }
        if (param.column.colId.toLowerCase().indexOf('expiredate') !== -1) {
          return $filter('apiDate')(param.value, FORMAT_DD_MM_YY_HH_MM_SS);
        }
        if (param.column.colId.toLowerCase().indexOf('date') !== -1) {
          return $filter('apiDate')(param.value, FORMAT_DD_MM_YYYY);
        }
        if (
          param.column.colId.toLowerCase().indexOf('createdat') !== -1 &&
          param.value
        ) {
          return $filter('apiDate')(param.value, FORMAT_DD_MM_YY_HH_MM_SS);
        } else {
          return param.value;
        }
      };
    }

    function getParameterToExport() {
      return {
        skipHeader: false,
        skipFooters: false,
        skipGroups: false,
        allColumns: true,
        onlySelected: false,
        columnSeparator: ',',
        sheetName: $filter('translate')(Report.exportXLS.nameFile)
      };
    }

    function getContextSubMenuItems(paramrs) {
      return [
        {
          name: EXPORT_TRANSLATE + ' CSV',
          action: dataExportCSV(paramrs)
        },
        {
          name: EXPORT_TRANSLATE + ' Excel (.xlsx)',
          action: dataExportExcel(paramrs)
        },
        {
          name: EXPORT_TRANSLATE + ' Excel (.xml)',
          action: dataExportXml(paramrs)
        }
      ];
    }

    function dataExportCSV(paramrs) {
      return function () {
        paramrs.fileName = $filter('translate')(Report.exportXLS.nameFile);
        vm.masterGridOptions.api.exportDataAsCsv(paramrs);
      };
    }

    function dataExportExcel(paramrs) {
      return function () {
        paramrs.fileName = $filter('translate')(Report.exportXLS.nameFile) + new Date().getTime() + '.xlsx';
        vm.masterGridOptions.api.exportDataAsExcel(paramrs);
      };
    }

    function dataExportXml(paramrs) {
      return function () {
        paramrs.fileName = $filter('translate')(Report.exportXLS.nameFile);
        paramrs.exportMode = 'xml';
        vm.masterGridOptions.api.exportDataAsExcel(paramrs);
      };
    }

    vm.masterGridOptions = gridOptions;

    if (vm.snFilter.companies) {
      loadCompanyByRole();
    }

    if (vm.snFilter.companiesLoadDeptoAndCC || vm.snFilter.companiesLoadDeptoAndCCUser) {
      loadCompanyByRole();
    }

    if (vm.snFilter.department) {
      if (vm.filter.originTypeCode === "01" || Report.filter.queryAll) {
        loadByDepartmentsCompany();
      } else if (vm.snFilter.companiesDialog || vm.snFilter.companiesLoadDeptoAndCC || vm.snFilter.companiesLoadDeptoAndCCUser) {
        vm.departments = [];
      } else {
        loadDepartments();
      }
    }
    if (vm.snFilter.costCenter) {
      if (vm.filter.originTypeCode === "01" || Report.filter.queryAll) {
        loadByCostCentersCompany();
      } else if (vm.snFilter.companiesDialog || vm.snFilter.companiesLoadDeptoAndCC || vm.snFilter.companiesLoadDeptoAndCCUser) {
        vm.costCenters = [];
      } else {
        loadCostCenter();
      }
    }

    if (vm.snFilter.project) {
      loadProjects();
    }

    if (vm.snFilter.productsSelect) {
      loadProducts();
    }

    if (vm.snFilter.providersSelect) {
      loadProviders();
    }

    if (vm.snFilter.status) {
      loadStatus();
    }

    if (vm.snFilter.statusRequisition) {
      loadStatusByType(NUMBER_ONE);
    }

    if (vm.snFilter.statusPurchaseOrder) {
      loadStatusByType(NUMBER_THREE);
    }

    if (vm.snFilter.requisitionTypes) {
      loadRequisitionTypes();
    }

    if (Report.statusFilter) {
      loadStatus();
    }

    if (vm.snFilter.SettlementStatus) {
      loadSettlementStatus();
    }

    if (vm.snFilter.pettyCashStatus) {
      loadPettyCashStatus();
    }

    if (vm.snFilter.entities) {
      loadEntityCatalog();
    }

    if (vm.snFilter.type) {
      loadTypes();
    }

    if (vm.snFilter.receivingPOUsers) {
      loadUsersByRoleAndUserCompanies();
    }

    if (vm.snFilter.loadDimensionCompanyDetail || vm.snFilter.loadOnlyColumnDimensionCompany) {
      api.GeneralWS.Usr.User.basicUserInformation.get().$promise.then(function (user) {
        api.UserWS.UserDimension.ByUser.get({'userId': user.userId}).$promise.then(function (userList) {
          vm.userDimensionCompanyDetails = userList.map(function (row) {
            return row.dimensionCompanyDetailId;
          });
          getDimensionCompany();
        });
      });
    }

    if (vm.snFilter.userRoleComprasOperator) {
      api.GeneralWS.RoleApplication.getRoles(
        {
          applicationId: $rootScope.bsCircle.role.aplication.id,
          nameLike: 'ROLE_COMPRAS_OPERADOR'
        }
      ).$promise.then(function (response) {
        vm.roleComprasOperador = response[0];
        searchUser();
      });
    }

    if (vm.exportXLS) {

      $scope.$watch('vm.exportXLSEnd',
        function (newValue) {
         if(newValue){
           vm.isShowProgressLinear = true;
           vm.hasData = false;
           const parameters = getParameterToExport();

           parameters.processCellCallback = isProcessCellCallBack();

           parameters.fileName = $filter('translate')(Report.exportXLS.nameFile) + new Date().getTime() + '.xlsx';

           parameters.processHeaderCallback = function (param) {
             return $filter('translate')(param.column.colDef.headerName);
           };
           vm.masterGridOptions.api.exportDataAsExcel(parameters);
           vm.hasData = true;
           vm.exporting = false;
           vm.isShowProgressLinear = false;
           vm.exportXLSEnd  = false;
         }
        }
      );

      vm.onExportXLS = function () {
        vm.exportXLSEnd  = false;
        vm.exporting = true;
        vm.isShowProgressLinear = true;
        pageSize = vm.filter.totalElements;
        vm.masterGridOptions.cacheBlockSize = vm.filter.totalElements;
        createNewDatasource(true);
      };
    }

    // Methods
    vm.search = search;
    vm.gotoDetail = gotoDetail;
    vm.toggleSidenav = toggleSidenav;
    vm.changeStartDate = changeStartDate;
    vm.goToState = goToState;

    //////////
    if (Report.verticalFilter) {
      $timeout(function () {
        toggleSidenav("main-sidenav");
      }, 300);
    }

    function getCellFormater(type) {
      return function (params) {
        if (params.value) {
          if (type === "date") {
            return $filter('date')(params.value, FORMAT_DD_MM_YYYY);
          } else if (type === "currency") {
            return $filter("number")(params.value, "2");
          } else if (type === "localDateTime") {
            return $filter('apiDate')(params.value, FORMAT_DD_MM_YY_HH_MM_SS);
          } else if (type === 'localDate') {
            return $filter('apiDate')(params.value, FORMAT_DD_MM_YYYY);
          } else if (type === "dateTime") {
            return $filter('date')(params.value, FORMAT_DD_MM_YY_HH_MM_SS);
          } else if (type === "boolean") {
            return '<md-icon md-font-icon="icon-checkbox-marked-circle green-500-fg"></md-icon>';
          } else {
            return params.value;
          }
        } else if (type === "boolean") {
          return '<md-icon md-font-icon="icon-cancel red-500-fg"></md-icon>';
        } else {
          return '';
        }
      };
    }

    function fixDataTypesFilters(arr) {
      if (arr) {
        arr.forEach(function (r) {
          const nameFilter = vm.masterGridOptions.api.getColumnDef(r.field);
          if (nameFilter.nameFilter) {
            r.field = nameFilter.nameFilter;
          }
          if (r.filterType === "number") {
            var clDef = vm.masterGridOptions.api.getColumnDef(r.field);
            r.filterType = clDef.dataTypes ? clDef.dataTypes : "number";
          }
        });
      }
    }

    function createNewDatasource(isExport) {
      var projectIds = [];
      vm.masterGridOptions.api.paginationSetPageSize(pageSize);
      var dataSource = {
        paginationPageSize: pageSize,
        getRows: function (params) {
          var o = params.request.filterModel;
          var parameters = {
            circle: $rootScope.bsCircle.id,
            idCircle: $rootScope.bsCircle.id,
            circleId: $rootScope.bsCircle.id,
            company: $rootScope.bsCircle.company.id,
            companyId: vm.snFilter.isNotCompaniesMultiple ? vm.filter.companies : $rootScope.bsCircle.company.id,
            electronic: vm.electronic,
            quotationId: 0,
            page: vm.masterGridOptions.api.paginationGetCurrentPage(),
            pageSize: pageSize
          };
          var arr = $.map(o, function (k, ke, sd, ds) {
            var on = k;
            on.field = ke;
            on.filter = on.filter.toString();
            return on;
          });
          fixDataTypesFilters(arr);
          const sorts = params.request.sortModel;
          verifyFieldSort(sorts);
          vm.parameters = parameters;
          vm.isShowProgressLinear = true;
          vm.filter.sorts = sorts;
          vm.filter.filters = arr;
          vm.api(
            parameters,
            vm.filter,
            function (response) {
              vm.isShowProgressLinear = isExport;
              vm.showGrid = true;
              vm.filter.totalElements = response.totalElements;
              vm.infData = new jinqJs()
                .from(response.content)
                .orderBy([{ field: getFieldFilter(), sort: "asc" }])
                .select(function (r) {
                  if (r.invoicePurchase && r.fileWithholding) {
                    r.serie = getInvoiceSerieOrUuid(r);
                    if (r.invoicePurchase && r.fileWithholding) {
                      r.file = vm.URLPHOTOS + r.fileWithholding.parentPath + r.fileWithholding.name + r.fileWithholding.extension;
                    }
                  }
                  if (r.projectId !== undefined) {
                    if (projectIds.length > 0) {
                      if (projectIds.indexOf(r.projectId) < 0) {
                        projectIds.push(r.projectId);
                    }
                    } else {
                      projectIds.push(r.projectId);
                    }

                  }
                  validateVatReceived(r);
                  return r;
                });
                addColumnsDimensionsByProvider();

              if (projectIds.length > 0) {
                getAllProject(params, response, vm.infData, projectIds, isExport);
              } else {
                params.successCallback(vm.infData, vm.filter.totalElements);
                vm.filter.id = null;
                vm.hasData = response.content.length > 0;
                vm.exportXLSEnd = isExport;
              }
              verifyAssignCompanies();
            },
            function (response) {
              vm.isShowProgressLinear = false;
              $log.error(response);
            }
          );
        }
      };
      vm.masterGridOptions.api.setEnterpriseDatasource(dataSource);
    }

    function validateVatReceived(row) {
      if (row.vatReceived > 0) {
        row.totalAfterVat = row.totalAfterTax + row.vatReceived;
      } else {
        row.totalAfterVat = row.totalAfterTax;
      }
    }

    /**
     * Select an item
     *
     * @param item
     */
    function search() {
      if (vm.snFilter.isGeneral && !vm.snFilter.filterByDates) {
        delete vm.filter.startDate;
        delete vm.filter.endDate;
      } else {
        if (!vm.filter.startDate) {
          vm.filter.startDate = new Date();
        }
        if (!vm.filter.endDate) {
          vm.filter.endDate = new Date();
        }
        vm.filter.startDate.setHours(0);
        vm.filter.startDate.setMinutes(0);
        vm.filter.startDate.setSeconds(0);

        vm.filter.endDate.setHours(23);
        vm.filter.endDate.setMinutes(59);
        vm.filter.endDate.setSeconds(59);
      }

      verifyDeleteFilterCompanies();

      if (!Report.filter.queryAll && !$stateParams.isTicket) {
        if (!vm.filter.departments || vm.filter.departments.length <= 0) {
          vm.filter.departments = [];

          if (vm.departments) {
            for (var i = 0; i < vm.departments.length; i++) {
              vm.filter.departments.push(vm.departments[i].id);
            }
          } else {
            vm.filter.departments.push(-1000);
          }
        }

        if (!vm.filter.costCenters || vm.filter.costCenters.length <= 0) {
          vm.filter.costCenters = [];

          if (vm.costCenters) {
            for (var i = 0; i < vm.costCenters.length; i++) {
              vm.filter.costCenters.push(vm.costCenters[i].id);
            }
          } else {
            vm.filter.costCenters.push(-1000);
          }
        }
      }

      if (!vm.filter.statuses || vm.filter.statuses.length <= 0) {
        vm.filter.statuses = [];

        if (vm.statuses) {
          for (var i = 0; i < vm.statuses.length; i++) {
            vm.filter.statuses.push(vm.statuses[i].id);
          }
        } else {
          vm.filter.statuses.push(-1000);getInvoicePurchaseDTO
        }
      }

      if (!vm.filter.requisitionTypes || vm.filter.requisitionTypes.length <= 0) {
        vm.filter.requisitionTypes = [];

        if (vm.requisitionTypes && vm.requisitionTypes.length > 0) {
          vm.requisitionTypes.forEach(function (rT) {
            vm.filter.requisitionTypes.push(rT.id);
          });
        }
      }

      if (!vm.filter.companies || vm.filter.companies.length <= 0) {
        vm.filter.companies = [];

        if (vm.companies) {
          for (var i = 0; i < vm.companies.length; i++) {
            vm.filter.companies.push(vm.companies[i].id);
          }
        }
      }

      if (vm.snFilter.isRejectedAutomatically) {
        vm.filter.isRejectedAutomatically = vm.snFilter.isRejectedAutomatically;
      }

      if (vm.snFilter.userRoleComprasOperator && (!vm.filter.usersToQuote || vm.filter.usersToQuote.length <= 0)) {
        vm.filter.usersToQuote = [];
        vm.userArray.forEach(function (a) {
          vm.filter.usersToQuote.push(a.id);
        });
      }

      delete vm.filter.totalElements;
      vm.masterGridOptions.api.setColumnDefs(vm.masterColumnDefs);
      createNewDatasource(false);
      vm.isShowFilter = false;
    }

    function loadCostCenter() {
      vm.loadingCostCenter = true;
      api.GeneralWS.CostCenter.query(params, function (data) {
        if (data.length === 1) {
          vm.filter.costCenters = [data[0].id.toString()];
        }
        vm.costCenters = data;
        vm.loadingCostCenter = false;
      });
    }

    function loadDepartments() {
      vm.loadingDepartments = true;
      api.GeneralWS.Department.query(params, function (data) {
        if (data.length === 1) {
          vm.filter.departments = [data[0].id.toString()];
        }
        vm.departments = data;
        vm.loadingDepartments = false;
      });
    }

    function loadProjects() {
      vm.loadingProject = true;
      api.ProyectosWS.getAll.query(
        { companyId: $rootScope.bsCircle.company.id },
        function (data) {
          vm.projects = data;
          vm.loadingProject = false;
        }
      );
    }

    function loadByDepartmentsCompany() {
      vm.loadingDepartments = true;
      api.GeneralWS.getAllDepartment.query(params, function (data) {
        vm.departments = data;
        vm.loadingDepartments = false;
      });
    }

    function loadByCostCentersCompany() {
      vm.loadingCostCenter = true;
      api.GeneralWS.getAllCost.query(params, function (data) {
        vm.costCenters = data;
        vm.loadingCostCenter = false;
      });
    }

    function loadCompanyByRole() {
      vm.loadingCompanies = true;
      params.idCircle = $rootScope.bsCircle.id;
      api.GeneralWS.Usr.User.Company.CompanyRolUser.page(params, function (
        data
      ) {
        if (data.length === 1) {
          vm.filter.companies = [data[0].id.toString()];
        }
        vm.companies = data;
        vm.loadingCompanies = false;
      });
    }

    function loadStatus() {
      vm.loadingStatus = true;
      api.ComprasWS.PurchaseStatus.query({ type: Report.statusType }, function (
        response
      ) {
        if (Report.validStatus) {
          Report.validStatus.forEach(function (status) {
            response.forEach(function (responseData) {
              if (status === responseData.description) {
                vm.statuses.push(responseData);
                return;
              }
            });
          });
        } else {
          vm.statuses = response;
        }

        vm.loadingStatus = false;
        if (vm.statuses.length === 1) {
          vm.filter.status = [data[0].id.toString()];
          return;
        }

        if (Report.statusFilter) {
          vm.filter.statuses = [];
          Report.statusFilter.forEach(function (status) {
            vm.statuses.forEach(function (data) {
              if (status === data.description) {
                vm.filter.statuses.push(data.id);
              }
            });
          });
        }
      });
    }

    function loadRequisitionTypes() {
      vm.loadingRequisitionTypes = true;
      api.ComprasWS.RequisitionType.RequisitionTypeCompany
        .query({ 'company': $rootScope.bsCircle.company.id }, function (data) {
          vm.requisitionTypes = data;
          vm.loadingRequisitionTypes = false;
        });
    }

    function loadSettlementStatus() {
      vm.loadingStatus = true;
      api.ComprasWS.Settlement.SettlementStatus.query({}, function (data) {
        if (data.length === 1) {
          vm.filter.settlementStatus = [data[0].id.toString()];
        }
        vm.settlementStatus = data;
        if ($stateParams.status === "Provisionada") {
          vm.settlementStatus.forEach(function (sts) {
            if (sts.name === "Provisionada") {
              vm.filter.settlementStatus = [sts.id.toString()];
              vm.settlementStatus = [sts];
            }
          });
        }
        if ($stateParams.status === "Pagada") {
          vm.settlementStatus.forEach(function (sts) {
            if (sts.name === "Pagada") {
              vm.filter.settlementStatus = [sts.id.toString()];
              vm.settlementStatus = [sts];
            }
          });
        }
        vm.loadingSettlementStatus = false;
      });
    }
    function loadPettyCashStatus() {
      vm.loadingStatus = true;
      vm.pettyCashStatus = [
        { id: false, name: "En Proceso" },
        { id: true, name: "Finalizada" }
      ];
    }

    function loadEntityCatalog() {
      vm.loadingEntity = true;
      api.InterfazWS.EntityCatalog.me.query({}).$promise.then(
        function (response) {
          vm.loadingEntity = false;
          vm.entityCatalog = response;

          for (var i = 0; i < response.length; i++) {
            if (response[i].entityName === "invoicepurchase") {
              vm.entity = response[i];
            }
          }
        },
        function (response) {
          vm.loadingEntity = false;
          $log.error(response);
        }
      );
    }

    function changeStartDate(isStart) {
      if (isStart) {
        if (vm.filter.startDate > vm.filter.endDate) {
          vm.filter.endDate = vm.filter.startDate;
        }
      }
      vm.filter.startDate = setDateType(vm.filter.startDate, false);
      vm.filter.endDate = setDateType(vm.filter.endDate, true);

      if (Report.daysMaxDate && vm.filter.startDate) {
        vm.maxDate = new Date(vm.filter.startDate.getTime() + (Report.daysMaxDate * 24 * 60 * 60 * 1000));
        vm.filter.endDate = vm.maxDate;
      }

    }

    function setDateType(date, end) {
      if (end) {
        date.setHours(23);
        date.setMinutes(59);
        date.setSeconds(59);
      } else {
        date.setHours(0);
        date.setMinutes(0);
        date.setSeconds(0);
      }
      return date;
    }

    /**
     * Toggle sidenav
     *
     * @param sidenavId
     */
    function toggleSidenav(sidenavId) {
      $mdSidenav(sidenavId).toggle();
    }

    function rejectInvoice(data) {
      $rootScope.loadingProgress = true;
      api.ComprasWS.InvoicePurchase.get({ id: 'getInvoicePurchaseDTO', idInvoice: data.id }, function (invoice) {
        invoice = convertInvoicePurchaseDTOtoEntityStructure(invoice);
        validateHasBudgetApplication(invoice, data);
      },
        function () {
        }
      );
    }

    function getButtons(buttons) {
      return function renderer(params) {
        var render = '<div style="width: 100%;">\n';
        if (buttons.details) {
          render +=
            '<md-button ng-if="data.id" class="edit-button md-icon-button" ng-click="vm.gotoDetail(data.id)" aria-label="Order details" ' +
            ' translate translate-attr-aria-label="REPORT.VIEW_DETAILS">' +
            '<md-tooltip md-direction="bottom">' +
            '{{"REPORT.VIEW_DETAILS"| translate}}' +
            "</md-tooltip>" +
            '<md-icon md-font-icon="icon-eye" class="s16"></md-icon> ' +
            "</md-button>";
        }
        if (buttons.reports) {
          render += getButtonsReports(buttons);
        }
        if (buttons.detailsInvoicePurchaseWithholding) {
          render +=
            '<md-button class="edit-button md-icon-button" ng-click="vm.gotoDetail(data.invoicePurchase.id)" aria-label="Order details" ' +
            ' translate translate-attr-aria-label="REPORT.VIEW_DETAILS">' +
            '<md-tooltip md-direction="bottom">' +
            '{{"REPORT.VIEW_DETAILS"| translate}}' +
            "</md-tooltip>" +
            '<md-icon md-font-icon="icon-eye" class="s16"></md-icon> ' +
            "</md-button>";
        }

        if (
          buttons.pdfInvoice &&
          params.data && params.data.purchaseStatus &&
          statusForPDF(params.data.purchaseStatus)
        ) {
          render +=
            '<md-button class="edit-button md-icon-button" ng-click="vm.downloadPdf(\'JASPER_URL_DOC_ENTREGA\', data.id)" ' +
            ' aria-label="Order details"' +
            'translate translate-attr-aria-label="REPORT.VIEW_DETAILS">' +
            '<md-tooltip md-direction="bottom">' +
            '{{"REPORT.PDF_INVOICE"| translate}}' +
            "</md-tooltip>" +
            '   <md-icon md-font-icon="icon-download" class="s16"></md-icon> ' +
            "</md-button>";
        }

        if (
          buttons.showPDFInvoice &&
          params.data && params.data.purchaseStatus &&
          statusForPDF(params.data.purchaseStatus)
        ) {
          render +=
            '<md-button class="edit-button md-icon-button" ng-click="vm.showPDF(\'JASPER_URL_DOC_ENTREGA\', data)" aria-label="Order details"' +
            '                           translate translate-attr-aria-label="REPORT.VIEW_DETAILS">' +
            '<md-tooltip md-direction="bottom">' +
            '{{"REPORT.VER"| translate}}' +
            "</md-tooltip>" +
            '<md-icon md-font-icon="icon-clipboard-text" class="s16"></md-icon> ' +
            "</md-button>";
        }

        if (
          buttons.pdfContrasenaPago &&
          params.data && params.data.purchaseStatus &&
          statusForContrasenaPago(params.data.purchaseStatus)
        ) {
          render +=
            '<md-button class="edit-button md-icon-button" ng-click="vm.downloadPdf(\'JASPER_URL_CONTRASENA_PAGO\', data.id)" ' +
            ' aria-label="Order details"' +
            'translate translate-attr-aria-label="REPORT.VIEW_DETAILS">' +
            '<md-tooltip md-direction="bottom">' +
            '{{"REPORT.PDF_GENERAR"| translate}}' +
            "</md-tooltip>" +
            '   <md-icon md-font-icon="icon-download" class="s16"></md-icon> ' +
            "</md-button>";
        }

        if (
          buttons.showPDFContrasenaPago &&
          params.data && params.data.purchaseStatus &&
          statusForContrasenaPago(params.data.purchaseStatus)
        ) {
          render +=
            '<md-button class="edit-button md-icon-button" ng-click="vm.showPDF(\'JASPER_URL_CONTRASENA_PAGO\', data)" aria-label="Order details"' +
            'translate translate-attr-aria-label="REPORT.VIEW_DETAILS">' +
            '<md-tooltip md-direction="bottom">' +
            '{{"REPORT.VER"| translate}}' +
            "</md-tooltip>" +
            '   <md-icon md-font-icon="icon-clipboard-text" class="s16"></md-icon> ' +
            "</md-button>";
        }

        if (
          buttons.rechazeInvoice &&
          params.data && params.data.purchaseStatus &&
          params.data.purchaseStatus === "Provisionada" &&
          $rootScope.getEspecialActionByName("Rechaza Factura Provisionada")
        ) {
          render +=
            '<md-button class="edit-button md-icon-button" ng-click="vm.rejectInvoice(data)" aria-label="Rechaze"' +
            'translate translate-attr-aria-label="REPORT.REJECT_INVOICE">' +
            '<md-tooltip md-direction="bottom">' +
            '{{"REPORT.REJECT_INVOICE"| translate}}' +
            "</md-tooltip>" +
            '   <md-icon md-font-icon="icon-thumb-down" class="s16 md-warn"></md-icon> ' +
            "</md-button>";
        }

        if (buttons.showInterfazDetail) {
          render +=
            '<md-button class="edit-button md-icon-button" ng-click="vm.showInterfazDetail(data)" aria-label="detail"' +
            'translate translate-attr-aria-label="REPORT.VIEW_DETAILS">' +
            '<md-tooltip md-direction="bottom">' +
            '{{"REPORT.VIEW_DETAILS"| translate}}' +
            "</md-tooltip>" +
            '   <md-icon md-font-icon="icon-eye" class="s16 "></md-icon> ' +
            "</md-button>";
        }

        for (
          var i = 0;
          i < $rootScope.bsCircle.role.roleSpecialActions.length;
          i++
        ) {
          if (
            $rootScope.bsCircle.role.roleSpecialActions[i].specialAction
              .actionName === "Excepcion limites fechas"
          ) {
            vm.exceptionLimitDateButton = true;
            break;
          }
        }

        if (vm.exceptionLimitDateButton) {
          render +=
            '<md-button ng-if="!data.limitDateException" class="edit-button md-icon-button" ng-click="vm.invoiceExceptionLimitDate(data)" ' +
            ' aria-label="invoiceException"' +
            'translate translate-attr-aria-label="SETTLEMENT.VIEW_DETAILS">' +
            '<md-tooltip md-direction="bottom">' +
            '{{"INVOICE.MSG.EXCEPTION_LIMIT_DATE"| translate}}' +
            "</md-tooltip>" +
            '   <md-icon md-font-icon="icon-calendar-remove" class="s16 "></md-icon> ' +
            "</md-button>";
        }
        if (
          $rootScope.getEspecialActionByName("Desactivar Factura") &&
          params.data && params.data.purchaseStatus &&
          (params.data.purchaseStatus === "Rechazada" || params.data.purchaseStatus === "Cancelada")
        ) {
          render +=
            '<md-button class="edit-button md-icon-button" ng-click="vm.deactiveInvoice(data)" aria-label="invoiceExceptionS"' +
            'translate translate-attr-aria-label="SETTLEMENT.VIEW_DETAILSX">' +
            '<md-tooltip md-direction="bottom">' +
            '{{"INVOICE.MSG.DEACTIVE_INVOICE"| translate}}' +
            "</md-tooltip>" +
            '   <md-icon md-font-icon="icon-close-circle" class="s16 "></md-icon> ' +
            "</md-button>";
        }

        if (
          $rootScope.getEspecialActionByName("Cancelar Pago") &&
          params.data && params.data.purchaseStatus &&
          params.data.purchaseStatus === "Pagada"
        ) {
          render +=
            '<md-button class="edit-button md-icon-button" ng-click="vm.cancePayment(data)" aria-label="invoiceExceptionS"' +
            'translate translate-attr-aria-label="SETTLEMENT.VIEW_DETAILSX">' +
            '<md-tooltip md-direction="bottom">' +
            '{{"INVOICE.MSG.CANCEL_PAYMENT"| translate}}' +
            '</md-tooltip>' +
            '   <md-icon md-font-icon="icon-close-circle" class="s16 "></md-icon> ' +
            "</md-button>";
        }
        if (
          params.data && params.data.id && buttons.showPDFShippingOrder
        ) {
          render +=
            '<md-button class="edit-button md-icon-button" ng-click="vm.showPDF(\'JASPER_URL_SHIPPING_ODER\', data)" ' +
            ' aria-label="settlement"' +
            'translate translate-attr-aria-label="PRINT_SHIPPING_ORDER">' +
            '<md-tooltip md-direction="bottom">' +
            '{{"REPORT.PRINT_SHIPPING_ORDER"| translate}}' +
            "</md-tooltip>" +
            '  <md-icon md-font-icon="icon-printer" class="s16"></md-icon> ' +
            '</md-button>';
        }

        if (buttons.compareRequisition && $rootScope.getEspecialActionByName('Comparar Requerimiento')) {
          render +=
            '<md-button ng-if="data.id && data.havePurchaseOrder === true" class="edit-button md-icon-button" ng-click="vm.goToState(data.id, ' +
            "'stateCompare'" +
            ')" aria-label="Order details" ' +
            ' translate translate-attr-aria-label="REPORT.COMPARE">' +
            '<md-tooltip md-direction="bottom">' +
            '{{"REPORT.COMPARE"| translate}}' +
            '</md-tooltip>' +
            '<md-icon md-font-icon="icon-swap-horizontal" class="s16"></md-icon> ' +
            "</md-button>";
        }

        render += "</div>";

        return render;
      };
    }

    function getFormedAmountCurrencyDescription(amountField, currencyField) {
      return function renderer(params) {
        var render = '<div style="width: 100%;">\n';
        render += "{{data." + currencyField + "}}";
        render += "{{data." + amountField + "| number:2}} ";
        render += "</div>";
        return render;
      };
    }

    function getTranslateValue(prefixTranslate, keyValue) {
      return function renderer(params) {
        var render = '<div style="width: 100%;">\n';
        render +=
          "{{'" + prefixTranslate + ".' + data." + keyValue + "| translate}} ";
        render += "</div>";
        return render;
      };
    }

    function statusForPDF(description) {
      if (description === "Ingresando") {
        return false;
      }

      if (description === "Editando") {
        return false;
      }

      if (description === "Cancelada") {
        return false;
      }

      if (description === "Rechazada") {
        return false;
      }

      return true;
    }

    function statusForContrasenaPago(description) {
      if (description === "Provisionada") {
        return true;
      }

      return false;
    }

    function statusForPDFOC(description) {
      if (description === "Pendiente Recibir") {
        return true;
      }

      if (description === "Primera Recepcion") {
        return true;
      }

      if (description === "Recibido") {
        return true;
      }

      return false;
    }

    vm.downloadPdf = function (parameter, id) {
      var theLink = $sce.trustAsResourceUrl(
        envService.read("baseUrlJReportsWSPdf") +
        "?rpt=" +
        $rootScope.getParameterValue(parameter).replace("[ID]", id)
      );

      var a = document.createElement("a");
      a.href = theLink;
      a.target = "_blank";
      a.download = "file.pdf";
      document.body.appendChild(a);
      a.click();
    };

    function getButtonsM(buttons) {
      return function renderer(params) {
        var render = '<div style="width: 100%;">\n';
        if (buttons.details) {
          render +=
            '<md-button class="edit-button md-icon-button" ng-click="vm.gotoDetail(data.id)" aria-label="Order details"' +
            'translate translate-attr-aria-label="REPORT.VIEW_DETAILS">' +
            '<md-tooltip md-direction="bottom">' +
            '{{"REPORT.VIEW_DETAILS"| translate}}' +
            "</md-tooltip>" +
            '   <md-icon md-font-icon="icon-eye" class="s16"></md-icon> ' +
            "</md-button>";
        }

        if (buttons.pdfEM) {
          render +=
            '<md-button class="edit-button md-icon-button" ng-click="vm.downloadPdf(\'JASPER_URL_ENTRADA_MERCANCIA\', data.id)" ' +
            ' aria-label="Order details"' +
            'translate translate-attr-aria-label="REPORT.VIEW_DETAILS">' +
            '<md-tooltip md-direction="bottom">' +
            '{{"REPORT.PDF_GENERAR"| translate}}' +
            "</md-tooltip>" +
            '   <md-icon md-font-icon="icon-download" class="s16"></md-icon> ' +
            "</md-button>";
        }

        if (buttons.showPdfEM) {
          render +=
            '<md-button class="edit-button md-icon-button" ng-click="vm.showPDF(\'JASPER_URL_ENTRADA_MERCANCIA\', data)" ' +
            ' aria-label="Order details"' +
            'translate translate-attr-aria-label="REPORT.VIEW_DETAILS">' +
            '<md-tooltip md-direction="bottom">' +
            '{{"REPORT.VER"| translate}}' +
            "</md-tooltip>" +
            '   <md-icon md-font-icon="icon-clipboard-text" class="s16"></md-icon> ' +
            "</md-button>";
        }

        if (
          buttons.pdfOC &&
          params.data &&
          statusForPDFOC(params.data.purchaseStatusDescription)
        ) {
          render +=
            '<md-button class="edit-button md-icon-button" ng-click="vm.downloadPdf(\'JASPER_URL_ORDEN_COMPRA\', data.id)" aria-label="pdf"' +
            'translate translate-attr-aria-label="REPORT.VIEW_DETAILS">' +
            '<md-tooltip md-direction="bottom">' +
            '{{"REPORT.PDF_GENERAR"| translate}}' +
            "</md-tooltip>" +
            '   <md-icon md-font-icon="icon-download" class="s16"></md-icon> ' +
            "</md-button>";
        }

        if (
          buttons.showPdfOC &&
          params.data &&
          statusForPDFOC(params.data.purchaseStatusDescription)
        ) {
          render +=
            '<md-button class="edit-button md-icon-button" ng-click="vm.showPDF(\'JASPER_URL_ORDEN_COMPRA\', data)" aria-label="ver"' +
            'translate translate-attr-aria-label="REPORT.VIEW_DETAILS">' +
            '<md-tooltip md-direction="bottom">' +
            '{{"REPORT.VER"| translate}}' +
            "</md-tooltip>" +
            '           <md-icon md-font-icon="icon-clipboard-text" class="s16"></md-icon> ' +
            "</md-button>";
        }
        render += "</div>";

        return render;
      };
    }

    function getButtonsSettlement(buttons) {
      return function renderer(params) {
        var render = '<div style="width: 100%;">\n';
        if (buttons.showPdfSettlementDetail) {
          render +=
            '<md-button class="edit-button md-icon-button" ng-click="vm.showPDFSettlement(\'JASPER_URL_SETTLEMENT_WITH_DETAILS\', data)" ' +
            ' aria-label="settlement"' +
            'translate translate-attr-aria-label="Generar PDF">' +
            '<md-tooltip md-direction="bottom">' +
            '{{"EXPENSE_SETTLEMENTS.GENERATE_PDF_WITH_DETAILS"| translate}}' +
            "</md-tooltip>" +
            '  <md-icon md-font-icon="icon-clipboard-text" class="s16"></md-icon> ' +
            "</md-button>";
        }
        if (buttons.showPdfSettlement) {
          render +=
            '<md-button class="edit-button md-icon-button" ng-click="vm.showPDFSettlement(\'JASPER_URL_SETTLEMENT\', data)" ' +
            ' aria-label="settlement"' +
            'translate translate-attr-aria-label="SETTLEMENT.VIEW_DETAILS">' +
            '<md-tooltip md-direction="bottom">' +
            '{{"SETTLEMENT.REPRINT_TENDER"| translate}}' +
            "</md-tooltip>" +
            '  <md-icon md-font-icon="icon-printer" class="s16"></md-icon> ' +
            '</md-button>' +
            '<md-button ng-if="data.settlementStatusName===\'Autorizada\' && data.pettyCashTypeDescription===\'Viaticos\'" ' +
            ' class="edit-button md-icon-button" ng-click="vm.showPDFSettlement(\'JASPER_URL_SETTLEMENT_TRAVEL\', data)" ' +
            ' aria-label="settlement"' +
            'translate translate-attr-aria-label="SETTLEMENT.VIEW_DETAILS_TRAVEL">' +
            '<md-tooltip md-direction="bottom">' +
            '{{"REPORT.SETTLEMENT.PRINT_SETLEMENT_TRAVEL"| translate}}' +
            "</md-tooltip>" +
            '  <md-icon md-font-icon="icon-file" class="s16"></md-icon> ' +
            '</md-button>';
        }
        if (buttons.openDetailSettlement) {
          render +=
            '<md-button class="edit-button md-icon-button" ng-click="vm.showInvoiceDetail(data)" aria-label="settlement"' +
            'translate translate-attr-aria-label="SETTLEMENT.VIEW_DETAILS">' +
            '<md-tooltip md-direction="bottom">' +
            '{{"SETTLEMENT.VIEW_DETAILS"| translate}}' +
            "</md-tooltip>" +
            '   <md-icon md-font-icon="icon-eye" class="s16 "></md-icon> ' +
            "</md-button>";
        }

        for (
          var i = 0;
          i < $rootScope.bsCircle.role.roleSpecialActions.length;
          i++
        ) {
          if (
            $rootScope.bsCircle.role.roleSpecialActions[i].specialAction
              .actionName === "Excepcion limites fechas"
          ) {
            vm.exceptionLimitDateButton = true;
            break;
          }
        }

        if (vm.exceptionLimitDateButton) {
          render +=
            '<md-button ng-if="!data.limitDateException" class="edit-button md-icon-button" ng-click="vm.exceptionLimitDate(data)" ' +
            ' aria-label="settlement"' +
            'translate translate-attr-aria-label="SETTLEMENT.VIEW_DETAILS">' +
            '<md-tooltip md-direction="bottom">' +
            '{{"INVOICE.MSG.EXCEPTION_LIMIT_DATE"| translate}}' +
            "</md-tooltip>" +
            '<md-icon md-font-icon="icon-calendar-remove" class="s16 "></md-icon> ' +
            "</md-button>";
        }

        if (
          $stateParams.status === "Provisionada" &&
          $stateParams.otherOptions
        ) {
          render =
            ' <div style="width: 100%;"><md-button class="edit-button md-icon-button" ng-click="vm.showInvoiceDetail(data)" ' +
            ' aria-label="settlement"' +
            'translate translate-attr-aria-label="SETTLEMENT.VIEW_DETAILS">' +
            '<md-tooltip md-direction="bottom">' +
            '{{"SETTLEMENT.VIEW_DETAILS"| translate}}' +
            "</md-tooltip>" +
            '  <md-icon md-font-icon="icon-eye" class="s16"></md-icon> ' +
            "</md-button>" +
            '<md-button class="edit-button md-icon-button" ng-click="vm.showPDFSettlement(\'JASPER_URL_SETTLEMENT\',data)" aria-label="settlement"' +
            'translate translate-attr-aria-label="Generar PDF" ng-if="vm.viewReports">' +
            '<md-tooltip md-direction="bottom">' +
            '{{"EXPENSE_SETTLEMENTS.GENERATE_PDF"| translate}}' +
            "</md-tooltip>" +
            '  <md-icon md-font-icon="icon-printer" class="s16"></md-icon> ' +
            "</md-button>" +
            '                                    <md-button class="edit-button md-icon-button" ' +
            ' ng-click="vm.showPDFSettlement(\'JASPER_URL_SETTLEMENT_WITH_DETAILS\',data)" aria-label="settlement"' +
            'translate translate-attr-aria-label="Generar PDF">' +
            '<md-tooltip md-direction="bottom">' +
            '{{"EXPENSE_SETTLEMENTS.GENERATE_PDF_WITH_DETAILS"| translate}}' +
            "</md-tooltip>" +
            '  <md-icon md-font-icon="icon-clipboard-text" class="s16"></md-icon> ' +
            "</md-button>" +
            '<md-button class="edit-button md-icon-button" ng-click="vm.downloadPDF(\'JASPER_URL_SETTLEMENT\', data.settlementId)" ' +
            ' aria-label="settlement"' +
            'translate translate-attr-aria-label="Descargar PDF" ng-if="vm.viewReports">' +
            '<md-tooltip md-direction="bottom">' +
            '{{"Descargar PDF"| translate}}' +
            "</md-tooltip>" +
            '  <md-icon md-font-icon="icon-download" class="s16"></md-icon> ' +
            "</md-button>" +
            '<md-button class="edit-button md-icon-button" ng-click="vm.viewChangeStatus(data, $event)" aria-label="settlement"' +
            'translate translate-attr-aria-label="SETTLEMENT.CHANGE_STATUS.CHANGE_STATUS">' +
            '<md-tooltip md-direction="bottom">' +
            '{{"SETTLEMENT.CHANGE_STATUS.CHANGE_STATUS"| translate}}' +
            "</md-tooltip>" +
            '  <md-icon md-font-icon="icon-history" class="s16"></md-icon> ' +
            "</md-button>";
        }
        if ($stateParams.status === "Provisionada" && $stateParams.roleVerify) {
          render =
            '<div style="width: 100%;"><md-button class="edit-button md-icon-button" ng-click="vm.openSettlement(data.id)" aria-label="settlement"' +
            'translate translate-attr-aria-label="SETTLEMENT.VIEW_DETAILS">' +
            '<md-tooltip md-direction="bottom">' +
            '{{"SETTLEMENT.VIEW_DETAILS"| translate}}' +
            "</md-tooltip>" +
            '  <md-icon md-font-icon="icon-eye" class="s16"></md-icon> ' +
            "</md-button>" +
            '<md-button class="edit-button md-icon-button" ng-click="vm.showPDF(\'JASPER_URL_SETTLEMENT\',data)" aria-label="settlement"' +
            'translate translate-attr-aria-label="SETTLEMENT.VIEW_DETAILS">' +
            '<md-tooltip md-direction="bottom">' +
            '{{"SETTLEMENT.REPRINT_TENDER"| translate}}' +
            "</md-tooltip>" +
            '  <md-icon md-font-icon="icon-printer" class="s16"></md-icon> ' +
            "</md-button>" +
            '<md-button class="edit-button md-icon-button" ng-click="vm.showPDF(\'JASPER_URL_SETTLEMENT_WITH_DETAILS\',data)" aria-label="settlement"' +
            'translate translate-attr-aria-label="Generar PDF">' +
            '<md-tooltip md-direction="bottom">' +
            '{{"EXPENSE_SETTLEMENTS.GENERATE_PDF_WITH_DETAILS"| translate}}' +
            "</md-tooltip>" +
            '  <md-icon md-font-icon="icon-clipboard-text" class="s16"></md-icon> ' +
            "</md-button>" +
            '<md-button class="edit-button md-icon-button" ng-click="vm.cancelProvision(data)" aria-label="settlement" ' +
            ' ng-disabled="data.erpSendToCancel"' +
            'translate translate-attr-aria-label="EXPENSE_SETTLEMENTS.PROVISIONED.CANCEL_PROVISION">' +
            '<md-tooltip md-direction="bottom">' +
            '{{"EXPENSE_SETTLEMENTS.PROVISIONED.CANCEL_PROVISION"| translate}}' +
            "</md-tooltip>" +
            '  <md-icon md-font-icon="icon-cancel" class="s16"></md-icon> ' +
            "</md-button>" +
            '<md-button class="edit-button md-icon-button" ng-click="vm.viewChangeStatus(data, $event)" aria-label="settlement"' +
            'translate translate-attr-aria-label="EXPENSE_SETTLEMENTS.PROVISIONED.ERP_HISTORY">' +
            '<md-tooltip md-direction="bottom">' +
            '{{"EXPENSE_SETTLEMENTS.PROVISIONED.ERP_HISTORY"| translate}}' +
            "</md-tooltip>" +
            '  <md-icon md-font-icon="icon-history" class="s16"></md-icon> ' +
            "</md-button>";
        }

        if ($stateParams.showButtonCancelPayment) {
          render +=
            '<md-button class="edit-button md-icon-button" ng-click="vm.cancelPayment(data)" aria-label="settlement"' +
            'translate translate-attr-aria-label="PAID_SETTLEMENT.CANCEL_PAYMENT">' +
            '<md-tooltip md-direction="bottom">' +
            '{{"PAID_SETTLEMENT.CANCEL_PAYMENT"| translate}}' +
            "</md-tooltip>" +
            '<md-icon md-font-icon="icon-cancel" class="s16"></md-icon> ' +
            "</md-button>";
        }

        render += "</div>";
        return render;
      };
    }

    function getURL(buttons) {
      return function renderer(params) {
        if (buttons.link) {
          return (
            '<div style="width: 100%;"  layout-align="center center">' +
            '<a ng-if="data.originType" href="" ng-click="vm.goToRef(data)">' +
            "{{vm.replaceOriginTypedata(data, data.originType.originTypeUrlDescription)}}</a> " +
            '<a ng-if="!data.originType && data.originTypeUrlDescription" href="" ng-click="vm.goToRef(data)">' +
            '{{vm.replaceOriginTypedata(data, data.originTypeUrlDescription)}}</a> ' +
            "</div>"
          );
        } else {
          return "";
        }
      };
    }

    function goToRef(data) {
      if (data.originType) {
        window.open(data.originType.queryUrl + data.referenceId, "_blank");
      } else {
        window.open(data.originTypeQueryUrl + data.referenceId, '_blank');
      }
    }

    /**
     * Go to product detail
     *
     * @param id
     */
    function gotoDetail(id) {
      $state.go(Report.stateDetail, {
        id: id,
        filter: vm.filter,
        backTo: $state.current.name,
        isClient: !Report.isProvider,
        isReport: true
      });
    }

    function fullWidthCellRendererFn(params) {
      params.$scope.id = params.data.id;
      if (Report.detailGrid) {
        params.$scope.detailGridOptions = Report.detailGrid.options;

        if (Report.detailGrid.exportXLS) {
          params.$scope.onExportDetailXLS = function () {
            var _params = {
              skipHeader: false,
              skipFooters: false,
              skipGroups: false,
              allColumns: true,
              onlySelected: false,
              fileName:
                Report.detailGrid.exportXLS.nameFile +
                params.$scope.id +
                "-" +
                new Date().getTime() +
                ".xls",
              columnSeparator: ",",
              sheetName: "data"
            };

            _params.processCellCallback = isProcessCellCallBack();

            _params.processHeaderCallback = function (para) {
              return $filter("translate")(para.column.colDef.headerName);
            };

            params.$scope.detailGridOptions.api.exportDataAsExcel(_params);
          };
        }

        var dataSource = {
          paginationPageSize: pageSize,
          getRows: function (p) {
            vm.isShowProgressLinear = true;
            api.PresupuestosWS.BudgetDetail.getDetailByBuget(
              { idb: params.data.budgetId },
              function (response) {
                vm.isShowProgressLinear = false;

                p.successCallback(response, response.length);

                var floatingRows = [];
                var totalQuantity = 0;
                var totalAmount = 0;

                response.forEach(function (row, index) {
                  totalQuantity += row.quantity;
                  totalAmount += row.amount;
                });

                floatingRows.push({
                  product: {
                    name: $filter("translate")("general.totales")
                  },
                  quantity: totalQuantity,
                  amount: totalAmount
                });

                params.$scope.detailGridOptions.api.setPinnedBottomRowData(
                  floatingRows
                );
              },
              function (response) {
                vm.isShowProgressLinear = false;
              }
            );
          }
        };
        var mouseWheelListener = function (event) {
          event.stopPropagation();
        };

        setTimeout(function () {
          var container = document.querySelector(
            "#containerDetail" + params.$scope.id
          );

          container.addEventListener("mousewheel", mouseWheelListener);
          container.addEventListener("DOMMouseScroll", mouseWheelListener);

          params.$scope.detailGridOptions.api.setEnterpriseDatasource(
            dataSource
          );
        }, 1000);

        $rootScope.$on("$translateChangeSuccess", function () {
          params.$scope.detailGridOptions.api.setColumnDefs(
            vm.detailColumnDefs
          );
        });

        return templateDetail;
      }
    }
    function getAllProject(params, response, data, projectIds, isExport) {
      api.ProyectosWS.getAllProject.get({ 'ids': projectIds }, function (pjr) {
        data.forEach(function (row) {
          pjr.forEach(function (res) {
            if (row.projectId === res.id) {
              row.prjName = res.name;
            }
          });
        });
        params.successCallback(data, response.totalElements);
        vm.filter.id = null;
        vm.hasData = response.content.length > 0;
        vm.exportXLSEnd = isExport;
      }, function(){
        params.successCallback(data, response.totalElements);
      });
    }

    function clearSearchDepartment() {
      vm.searchDepartment = "";
    }

    function clearSearchCostCenter() {
      vm.searchCostCenter = "";
    }

    function clearSearchStatus() {
      vm.searchStatus = "";
    }
    function clearRequisitionType() {
      vm.searchRequisitionType = '';
    }
    function clearSettlementStatus() {
      vm.searchSettlementStatus = "";
    }

    function clearSearchProviderSelect() {
      vm.searchProviderSelect = '';
    }

    function clearSearchProject() {
      vm.searchProject = "";
    }

    function clearSearchReceivingPOUser() {
      vm.searchReceivingPOUser = '';
    }

    if ($stateParams.filter !== null && $stateParams.filter !== undefined) {
      $timeout(function () {
        vm.filter = angular.copy($stateParams.filter);
        vm.search();
      }, 1000);
    }

    if (vm.filter.noFilter) {
      $timeout(function () {
        vm.search();
      }, 1000);
    }

    $timeout(function () {
      var keyEvent = function (event) {
        event.stopPropagation();
      };

      var searchDepartmentInput = document.querySelector("#searchDepartment");
      var searchCostCenterInput = document.querySelector("#searchCostCenter");
      var searchStatusInput = document.querySelector("#searchStatus");
      const searchRequisitionTypeInput = document.querySelector('#searchRequisitionType');
      var searchSettlementStatusInput = document.querySelector(
        "#searchSettlementStatus"
      );
      var searchProjectInput = document.querySelector("#searchProject");
      var searchTypeInput = document.querySelector("#searchType");

      addEventListenerSearchElements(searchDepartmentInput, keyEvent);
      addEventListenerSearchElements(searchCostCenterInput, keyEvent);
      addEventListenerSearchElements(searchStatusInput, keyEvent);
      addEventListenerSearchElements(searchRequisitionTypeInput, keyEvent);
      addEventListenerSearchElements(searchSettlementStatusInput, keyEvent);
      addEventListenerSearchElements(searchProjectInput, keyEvent);
      addEventListenerSearchElements(searchTypeInput, keyEvent);
      addEventListenerSearchElements(searchDepartmentInput, keyEvent);
      addEventListenerSearchElements(searchDepartmentInput, keyEvent);

      if (
        $state.current.name === "app.report.quotationC" &&
        $stateParams.id !== null &&
        $stateParams.id !== undefined
      ) {
        vm.filter.id = $stateParams.id;
        vm.search();
      }
    }, 1000);

    function addEventListenerSearchElements(element, keyEvent) {
      if (element) {
        element.addEventListener('keydown', keyEvent);
      }
    }

    function showPDF(parameterName, data) {
      var urlRpt = $rootScope
        .getParameterValue(parameterName)
        .replace("[ID]", data.id);

      $mdDialog
        .show({
          controller: "ReportShowPDFController",
          controllerAs: "vm",
          templateUrl: "app/main/apps/reports/dialogs/show-pdf/show-pdf.html",
          parent: angular.element("#main"),
          locals: {
            Url: urlRpt
          },
          clickOutsideToClose: false,
          fullscreen: true
        })
        .then(function (answer) { }, function () { });
    }

    vm.showPDFSettlement = function (parameter, data) {
      $log.debug("settlement in showPDFSettlement: ");
      $log.debug(data);
      $log.debug(parameter);

      var urlRpt = $rootScope
        .getParameterValue(parameter)
        .replace("[ID]", data.settlementId);

      if ($rootScope.APPParameters) {

        for (var i = 0; i < $rootScope.APPParameters.length; i++) {
          if ($rootScope.APPParameters[i].applicationParameter.parameterName === parameter && $rootScope.APPParameters[i].applicationParameter.configByCountry) {
            api.GeneralWS.ApplicationParameterCountryValue.byParameterNameAndCountry.get({ 'parameterName': parameter, 'countryId': data.countryId }, function (response) {
              if (response && response.parameterValue) {
                showpdfDialog(response.parameterValue.replace("[ID]", data.settlementId));
              } else if ($rootScope.APPParameters[i].appParameterValue) {
                showpdfDialog($rootScope.APPParameters[i].appParameterValue.replace("[ID]", data.settlementId));
              }

            }, function (err) { });
            break;
          } else if ($rootScope.APPParameters[i].applicationParameter.parameterName === parameter) {
            showpdfDialog($rootScope.APPParameters[i].appParameterValue.replace("[ID]", data.settlementId));
            break;
          }
        }

      }

    };


    function showpdfDialog(urlRpt) {
      $timeout(function () {
        $mdDialog
          .show({
            controller: "ReportShowPDFController",
            controllerAs: "vm",
            templateUrl: "app/main/apps/reports/dialogs/show-pdf/show-pdf.html",
            parent: angular.element("#main"),
            locals: {
              Url: urlRpt
            },
            clickOutsideToClose: false,
            fullscreen: true
          })
          .then(function (answer) {
          }, function () {
          });
      }, 500);
    }

    vm.openSettlement = function (id) {
      $state.go("app.expenseSettlement.settlement.settlementView", {
        settlementId: id,
        backTo: $state.current.name,
        filter: vm.filter
      });
    };

    function showInterfazDetail(data) {
      $mdDialog
        .show({
          controller: "InterfazReportDetailController",
          controllerAs: "vm",
          templateUrl:
            "app/main/apps/reports/dialogs/show-interfaz-detail/show-interfaz-detail.html",
          parent: angular.element("#main"),
          targetEvent: event,
          locals: {
            entity: vm.entity,
            id: data.id,
            companyId: data.companyBuyer.id,
            invoicePurchase: data
          },
          clickOutsideToClose: false
        })
        .then(function (response) { }, function (response) { });
    }

    function showInvoiceDetail(data) {
      $mdDialog
        .show({
          controller: "InvoiceReportDetailController",
          controllerAs: "vm",
          templateUrl:
            "app/main/apps/reports/dialogs/show-invoiceView-detail/show-invoiceView-detail.html",
          parent: angular.element("#main"),
          targetEvent: event,
          locals: {
            entity: vm.entity,
            settlementId: data.settlementId,
            detail: data,
            invoiceId: data.invoicePurchaseId
          },
          clickOutsideToClose: false
        })
        .then(function (response) { }, function (response) { });
    }

    $timeout(function () {
      if (Report.filter.searchOnLoad) {
        search();
      }
    }, 1000);

    function selectContractsValid() {
      vm.filter.statuses = [];
      vm.snFilter.status = !vm.snFilter.status;
      vm.snFilter.filterByDates = !vm.snFilter.filterByDates;
      vm.filter.noFilterDate = !vm.filter.noFilterDate;
    }

    function exceptionLimitDate(data) {
      var confirm = $mdDialog
        .confirm()
        .title($filter("translate")("INVOICE.MSG.EXCEPTION_LIMIT_DATE"))
        .textContent(
          $filter("translate")("INVOICE.MSG.CONFIRMACION_EXCEPTION_LIMIT_DATE")
        )
        .ok($filter("translate")("INVOICE.MSG.SI"))
        .cancel($filter("translate")("INVOICE.MSG.NO"));
      $mdDialog.show(confirm).then(
        function (inf) {
          api.ComprasWS.Settlement.limitDateException.update(
            {
              idCircle: $rootScope.bsCircle.id,
              settlementId: data.settlementId
            },
            function (response) {
              if (response) {
                MessageService.show(
                  "INVOICE.MSG.EXCEPTION_LIMIT_DATE_SUCCESSFULLY"
                );
              }
            },
            function (err) { }
          );
        },
        function (err) { }
      );
    }

    vm.invoiceExceptionLimitDate = invoiceExceptionLimitDate;
    function invoiceExceptionLimitDate(data) {
      var confirm = $mdDialog
        .confirm()
        .title($filter("translate")("INVOICE.MSG.EXCEPTION_LIMIT_DATE"))
        .textContent(
          $filter("translate")("INVOICE.MSG.CONFIRMACION_EXCEPTION_LIMIT_DATE")
        )
        .ok($filter("translate")("INVOICE.MSG.SI"))
        .cancel($filter("translate")("INVOICE.MSG.NO"));
      $mdDialog.show(confirm).then(
        function (inf) {
          $rootScope.loadingProgress = true;
          api.ComprasWS.Invoices.limitDateException.update(
            { id: data.id },
            function (response) {
              $rootScope.loadingProgress = false;
              if (response) {
                MessageService.show(
                  "INVOICE.MSG.EXCEPTION_LIMIT_DATE_SUCCESSFULLY"
                );

                search();
              }
            },
            function (err) {
              $rootScope.loadingProgress = false;
            }
          );
        },
        function (err) { }
      );
    }

    vm.clearSearchCompany = function () {
      vm.searchCompany = "";
    };

    vm.viewChangeStatus = function (settlement, ev) {
      $mdDialog
        .show({
          controller: "changeStatusController",
          controllerAs: "vm",
          templateUrl:
            "app/main/apps/expenseSettlements/settlements/settlement/settlementEditor/changeStatus/changeStatus.html",
          targetEvent: ev,
          locals: {
            settlementId: settlement.id
          },
          clickOutsideToClose: false
        })
        .then(function (answer) { });
    };

    vm.cancelProvision = function (settlement) {
      $rootScope.loadingProgress = true;
      var confirm = $mdDialog
        .confirm()
        .title(
          $filter("translate")(
            "EXPENSE_SETTLEMENTS.PROVISIONED.MSG_SURE_CANCEL_PROVISION"
          )
        )
        .content(
          $filter("translate")(
            "EXPENSE_SETTLEMENTS.PROVISIONED.MSG_CANCEL_PROVISION"
          )
        )
        .ariaLabel("Delete Detail")
        .ok($filter("translate")("SETTLEMENT.OK"))
        .cancel($filter("translate")("SETTLEMENT.CANCEL"));
      $mdDialog.show(confirm).then(
        function () {
          api.ComprasWS.pettyCash.get({
            id: settlement.pettyCashId,
            circle: $rootScope.bsCircle.id
          }).$promise.then(function (response) {
            vm.pettyCash = response;
            api.ComprasWS.pettyCashGeneralSets.getByPettyCashType(
              {
                id: 'byPettyCashType',
                pettyCashTypeId: vm.pettyCash.pettyCashType.id, idCircle: $rootScope.bsCircle.id
              }).$promise.then(function (response) {
                if (response.id) {
                  vm.pettyCashGeneralSets = response;
                  if (vm.pettyCashGeneralSets && vm.pettyCashGeneralSets.askForBudget) {
                    api.GeneralWS.CompanyApplication.byAppName.get(
                      { 'company': $rootScope.bsCircle.company.id, 'app': 'Presupuestos' }
                    ).$promise.then(function (responseParameter) {
                      if (responseParameter.$status === 200) {
                        if (responseParameter.$data && responseParameter.$data !== "") {
                          reverBudgetBySettlement(settlement);
                        } else {
                          changeStatusCanceProvision(settlement);
                        }
                      }
                    }, function (err) { });
                  } else {
                    changeStatusCanceProvision(settlement);
                  }
                } else {
                  changeStatusCanceProvision(settlement);
                }
              }, function (err) {
              });
          }, function (err) {
          });
        },
        function () {
          // Cancel Action
          $rootScope.loadingProgress = false;
        }
      );
    };

    function changeStatusCanceProvision(settlement) {
      $rootScope.loadingProgress = true;
      api.ComprasWS.Settlement.cancelProvisionSettlement
        .cancel({
          settlementId: settlement.id,
          idCircle: $rootScope.bsCircle.id
        })
        .$promise.then(
          function (response) {
            if (settlement.erpReference === null) {
              MessageService.show(
                $filter("translate")(
                  "EXPENSE_SETTLEMENTS.PROVISIONED.CANCEL_PROVISION_OK2"
                )
              );
            } else {
              MessageService.show(
                $filter("translate")(
                  "EXPENSE_SETTLEMENTS.PROVISIONED.CANCEL_PROVISION_OK"
                )
              );
            }
            createNewDatasource(false);
            $rootScope.loadingProgress = false;
          },
          function (error) {
            $log.error(error.data);
            MessageService.show(
              $filter("translate")(
                "EXPENSE_SETTLEMENTS.PROVISIONED.CANCEL_PROVISION_ERROR"
              )
            );
          }
        );
    }

    vm.viewErpHistory = function (settlement) {
      $log.debug(settlement);
      $mdDialog
        .show({
          controller: "InterfazReportDetailController",
          controllerAs: "vm",
          templateUrl:
            "app/main/apps/reports/dialogs/show-interfaz-detail/show-interfaz-detail.html",
          parent: angular.element("#main"),
          targetEvent: event,
          locals: {
            entity: vm.entity,
            id: settlement.settlementId,
            companyId: settlement.companyId
          },
          clickOutsideToClose: false
        })
        .then(function (response) { }, function (response) { });
    };

    vm.cancelPayment = cancelPayment;
    function cancelPayment(settlement) {
      $rootScope.loadingProgress = true;
      var confirm = $mdDialog
        .confirm()
        .title($filter("translate")("PAID_SETTLEMENT.MSG_SURE_CANCEL_PAYMENT"))
        .content($filter("translate")("PAID_SETTLEMENT.MSG_CANCEL_PAYMENT"))
        .ariaLabel("Delete Detail")
        .ok($filter("translate")("SETTLEMENT.OK"))
        .cancel($filter("translate")("SETTLEMENT.CANCEL"));
      $mdDialog.show(confirm).then(
        function () {
          $rootScope.loadingProgress = true;
          api.ComprasWS.Settlement.cancelPaymentSettlement
            .cancel({
              settlementId: settlement.settlementId,
              idCircle: $rootScope.bsCircle.id
            })
            .$promise.then(
              function (response) {
                $rootScope.loadingProgress = false;
                MessageService.show(
                  $filter("translate")("PAID_SETTLEMENT.CANCEL_PAYMENT_OK")
                );

                search();
              },
              function (error) {
                $rootScope.loadingProgress = false;
                $log.error(error);
                $log.error(error.data);
                MessageService.showErrorMessage(
                  $filter("translate")("PAID_SETTLEMENT.CANCEL_PAYMENT_ERROR")
                );
              }
            );
        },
        function () {
          $rootScope.loadingProgress = false;
        }
      );
    }

    vm.deactiveInvoice = function (data) {
      var confirm = $mdDialog
        .confirm()
        .title($filter("translate")("INVOICE.MSG.DEACTIVE_INVOICE"))
        .content($filter("translate")("INVOICE.MSG.DEACTIVE_INVOICE_Confirm"))
        .ariaLabel("Deactive Detail")
        .ok($filter("translate")("SETTLEMENT.OK"))
        .cancel($filter("translate")("SETTLEMENT.CANCEL"));
      $mdDialog.show(confirm).then(
        function () {
          $rootScope.loadingProgress = true;
          api.ComprasWS.Invoices.deactivate.update(
            { id: data.id },
            function (response) {
              $rootScope.loadingProgress = false;
              MessageService.show(
                $filter("translate")(
                  "INVOICE.MSG.DEACTIVE_INVOICE_successfully"
                )
              );
              search();
            },
            function (errResponse) {
              $rootScope.loadingProgress = false;
            }
          );
        },
        function () { }
      );
    };

    vm.cancePayment = function (data) {
      var confirm = $mdDialog
        .confirm()
        .title($filter("translate")("INVOICE.MSG.CANCEL_PAYMENT"))
        .content($filter("translate")("INVOICE.MSG.CANCEL_PAYMENT_Confirm"))
        .ariaLabel("Deactive Detail")
        .ok($filter("translate")("SETTLEMENT.OK"))
        .cancel($filter("translate")("SETTLEMENT.CANCEL"));
      $mdDialog.show(confirm).then(
        function () {
          $rootScope.loadingProgress = true;
          api.ComprasWS.Invoices.cancelPayment.update(
            { id: data.id },
            function (response) {
              $rootScope.loadingProgress = false;
              MessageService.show(
                $filter("translate")("INVOICE.MSG.CANCEL_PAYMENT_successfully")
              );
              search();
            },
            function (errResponse) {
              $rootScope.loadingProgress = false;
            }
          );
        },
        function () { }
      );
    };

    function loadTypes() {
      if (Report.title === "SETTLEMENT") {
        api.ComprasWS.pettyCashType.query(
          {},
          function (response) {
            vm.typeses = response;
          },
          function (errResponse) { }
        );
      }
    }

    vm.viewIMG = function (file) {
      if (file.id && (file.extension === '.jpg' || file.extension === '.png' || file.extension === '.pdf')) {
        $mdDialog
          .show({
            controller: "DialogPhotoController",
            controllerAs: "vm",
            templateUrl: "app/main/apps/files/dialogPhoto/dialogPhoto.html",
            parent: angular.element("#main"),
            name: file.originalName,
            url:
              vm.URLPHOTOS +
              file.parentPath +
              file.name +
              file.extension,
            clickOutsideToClose: false
          })
          .then(function (answer) {
            $log.debug(answer);
          });
      } else if (file.id) {
        window.open(vm.URLPHOTOS +
          file.parentPath +
          file.name +
          file.extension);
      }
    };

    function reverseBudgetByContract(invoicePurchase, data) {
      var invoiceDetails = new jinqJs()
        .from(invoicePurchase.details.map(function (r) { return r.invoicePurchaseDetail }))
        .where(function (detail) {
          return detail.merchandiseEntry.purchaseOrderDetail.contractPurchaseDetail;
        })
        .select();
      var contractDetailsId = invoiceDetails.map(function (detail) {
        return detail.merchandiseEntry.purchaseOrderDetail.contractPurchaseDetail.id;
      });
      api.ComprasWS.ContractDetailReference.byContractDetailsId.getByDetailsIdAndNoPayment(
        {
          circleId: $rootScope.bsCircle.id,
          noPayment: invoiceDetails[0].merchandiseEntry.merchandiseHeader.noPayment
        }, contractDetailsId, function (contractReferences) {
          if (contractReferences.length > 0) {
            var invoiceDetailDTO = [];
            var invoiceDetail;
            var originTaxesIncluded;
            contractReferences.forEach(function (reference) {
              invoiceDetail = _.find(invoiceDetails, function (detail) {
                return detail.merchandiseEntry.purchaseOrderDetail.contractPurchaseDetail.id === reference.contractPurchaseDetail.id;
              });
              originTaxesIncluded = reference.contractPurchaseDetail.taxesIncluded;
              invoiceDetailDTO.push({
                id: invoiceDetail.id,
                quantity: (-invoiceDetail.quantity * invoicePurchase.invoicePurchase.exchangeRate),
                price: originTaxesIncluded === true ?
                  (-invoiceDetail.priceAfterTax * invoicePurchase.invoicePurchase.exchangeRate) :
                  (-invoiceDetail.priceBeforeTax * invoicePurchase.invoicePurchase.exchangeRate),
                subTotal: originTaxesIncluded === true ?
                  (-invoiceDetail.subTotalAfterTax * invoicePurchase.invoicePurchase.exchangeRate) :
                  (-invoiceDetail.subTotalBeforeTax * invoicePurchase.invoicePurchase.exchangeRate),
                discount: originTaxesIncluded === true ?
                  (-invoiceDetail.discountAfterTax * invoicePurchase.invoicePurchase.exchangeRate) :
                  (-invoiceDetail.discountBeforeTax * invoicePurchase.invoicePurchase.exchangeRate),
                reference: reference.noReference,
                quotationDetailId: reference.contractPurchaseDetail.id,
                reservedQuantity: invoiceDetail.merchandiseEntry.purchaseOrderDetail.quantity,
                referenceHeaderId: 0
              });
            });
            api.PresupuestosWS.BudgetDetail.updateExecutedAmounts.reverse(
              { idb: 0, circleId: $rootScope.bsCircle.id }, invoiceDetailDTO, function (budgetDetailReferences) {
                var invoiceDetailReferences = [];
                budgetDetailReferences.forEach(function (budgetDetailReference) {
                  invoiceDetailReferences.push({
                    invoicePurchaseDetail: { id: budgetDetailReference.noReference },
                    originType: { originTypeCode: '08' },
                    noReference: budgetDetailReference.budgetDetail.id
                  });
                });
                api.ComprasWS.InvoicePurchaseDetailReference.me.saveReferences(
                  {
                    id: 'createReferences',
                    idCircle: $rootScope.bsCircle.id
                  }, invoiceDetailReferences).$promise.then(function (invoiceDetailReferences) {
                    changeInvoiceToEmit(data);
                  }, function (errResponse) {
                    $rootScope.loadingProgress = false;
                  });
              }, function (errResponse) {
                $rootScope.loadingProgress = false;
                $log.debug(errResponse);
              });
          } else {
            changeInvoiceToEmit(data);
          }
        }, function (err) {

        });
    }

    function validateHasBudgetApplication(invoice, data) {
      verifyParameterIsContractBudget();
      api.GeneralWS.CompanyApplication.byAppName.get({
        'company': invoice.invoicePurchase.companyBuyer.id,
        'app': 'Presupuestos'
      }).$promise.then(function (responseParameter) {
        var confirm = $mdDialog
          .confirm()
          .title($filter("translate")("INVOICE.MSG.Rechazada_INVOICE"))
          .textContent(
            $filter("translate")("INVOICE.MSG.CONFIRMACION_Rechazada_INVOICE")
          )
          .ok($filter("translate")("INVOICE.MSG.SI"))
          .cancel($filter("translate")("INVOICE.MSG.NO"));
        $mdDialog.show(confirm).then(
          function () {
            if (responseParameter.$status === 200) {
              if (responseParameter.$data && responseParameter.$data !== ""
                && invoice.details[0].invoicePurchaseDetail.merchandiseEntry.purchaseOrderDetail
                && invoice.details[0].invoicePurchaseDetail.merchandiseEntry.purchaseOrderDetail.contractPurchaseDetail
                && vm.hasBudgetApplication
              ) {
                reverseBudgetByContract(invoice, data);
              } else {
                changeInvoiceToEmit(data);
              }
            } else {
              changeInvoiceToEmit(data);
            }
          },
          function () {
          }
        );
      }, function (response) {
        $log.error(response);
      });
    }

    function changeInvoiceToEmit(data) {
      $rootScope.loadingProgress = true;
      api.ComprasWS.InvoicePurchase.setStatus(
        {
          id: "changeStatus",
          idCircle: $rootScope.bsCircle.id,
          status: "Emitida",
          cancelInErp: true
        },
        {id: data.id,
         dateInvoiceAccounting: data.dateInvoiceAccounting}
      ).$promise.then(
        function (response) {
          $rootScope.loadingProgress = false;
          MessageService.show(
            $filter("translate")("INVOICE.MSG.STATUS_CHANGE_SUCCESS")
          );

          vm.masterGridOptions.api.forEachNode(function (row, index) {
            if (row.data.id === data.id) {
              row.data.purchaseStatus = "Emitida";
            }
          });
          vm.masterGridOptions.api.redrawRows();
        },
        function (response) {
          $rootScope.loadingProgress = false;
          $log.error(response);
        }
      );
    }

    $timeout(function () {
      var keyEvent = function (event) {
        event.stopPropagation();
      };

      var searchCompanyInput = document.querySelector("#searchCompany");

      if (searchCompanyInput) {
        searchCompanyInput.addEventListener("keydown", keyEvent);
      }

      const searchReceivingPOUserInput = document.querySelector('#searchReceivingPOUser');

      if (searchReceivingPOUserInput) {
        searchReceivingPOUserInput.addEventListener('keydown', keyEvent);
      }
    }, 500);

    function reverBudgetBySettlement(settlement) {
      api.ComprasWS.SettlementDetails.getAllDetailsBySettlement
        .getAll({
          settlementId: settlement.id,
          circleId: $rootScope.bsCircle.id
        })
        .$promise.then(
          function (data) {
            vm.details = data;
            vm.details.forEach(function (r) {
              if (r.invoicePurchase) {
                api.ComprasWS.InvoicePurchaseDetail.byInvoice(
                  {
                    id: 'byInvoicePurchase',
                    invoiceId: r.invoicePurchase.id,
                    idCircle: $rootScope.bsCircle.id
                  }, function (response) {
                    var invoiceDetails = response;
                    var quotationDetailsId = invoiceDetails.map(function (detail) {
                      return detail.id;
                    });
                    api.ComprasWS.SettlementDetailReference.byInvoiceDetailsId.get(
                      {
                        circleId: $rootScope.bsCircle.id, ids: quotationDetailsId.toString()
                      }, function (quotationReferences) {
                        if (quotationReferences.length > 0) {
                          var invoiceDetailDTO = [];
                          var invoiceDetail;
                          quotationReferences.forEach(function (quotationReference) {
                            invoiceDetail = _.find(invoiceDetails, function (detail) {
                              return detail.id === quotationReference.invoicePurchaseDetail.id;
                            });
                            invoiceDetailDTO.push({
                              id: invoiceDetail.id,
                              quantity: (-invoiceDetail.quantity * r.invoicePurchase.exchangeRate),
                              price: (-invoiceDetail.priceAfterTax * r.invoicePurchase.exchangeRate),
                              subTotal: (-invoiceDetail.subTotalAfterTax * r.invoicePurchase.exchangeRate),
                              discount: (-invoiceDetail.discountAfterTax * r.invoicePurchase.exchangeRate),
                              reference: quotationReference.noReference,
                              quotationDetailId: quotationReference.invoicePurchaseDetail.id,
                              reservedQuantity: invoiceDetail.quantity,
                              referenceHeaderId: 0
                            });
                          });
                          api.PresupuestosWS.BudgetDetail.updateExecutedAmounts.reverse(
                            { idb: 0, circleId: $rootScope.bsCircle.id, origin: '31' }, invoiceDetailDTO, function (budgetDetailReferences) {
                              var invoiceDetailReferences = [];
                              budgetDetailReferences.forEach(function (budgetDetailReference) {
                                invoiceDetailReferences.push({
                                  invoicePurchaseDetail: { id: budgetDetailReference.noReference },
                                  originType: { originTypeCode: '08' },
                                  noReference: budgetDetailReference.budgetDetail.id
                                });
                              });
                              api.ComprasWS.InvoicePurchaseDetailReference.me.saveReferences(
                                {
                                  id: 'createReferences',
                                  idCircle: $rootScope.bsCircle.id
                                }, invoiceDetailReferences).$promise.then(function () {

                                }, function () {
                                  $rootScope.loadingProgress = false;
                                });
                            }, function (errResponse) {
                              $rootScope.loadingProgress = false;
                              $log.debug(errResponse);
                            });
                        }
                      }, function (err) { });

                  }, function (err) {
                  });
              } else {
                var invoiceDetails = [r.paymentReceipt];
                var quotationDetailsId = invoiceDetails.map(function (detail) {
                  return detail.id;
                });
                api.ComprasWS.SettlementDetailReference.byInvoiceDetailsId.get(
                  {
                    circleId: $rootScope.bsCircle.id, ids: quotationDetailsId.toString(), type: 'receipt'
                  }, function (quotationReferences) {
                    if (quotationReferences.length > 0) {
                      var invoiceDetailDTO = [];
                      var invoiceDetail;
                      quotationReferences.forEach(function (quotationReference) {
                        invoiceDetail = _.find(invoiceDetails, function (detail) {
                          return detail.id === quotationReference.paymentReceipt.id;
                        });
                        invoiceDetailDTO.push({
                          id: invoiceDetail.id,
                          quantity: (-1),
                          price: (-invoiceDetail.amount),
                          subTotal: (-invoiceDetail.amount),
                          discount: (0),
                          reference: quotationReference.noReference,
                          quotationDetailId: quotationReference.paymentReceipt.id,
                          reservedQuantity: 1,
                          referenceHeaderId: 0
                        });
                      });
                      api.PresupuestosWS.BudgetDetail.updateExecutedAmounts.reverse(
                        { idb: 0, circleId: $rootScope.bsCircle.id, origin: '31' }, invoiceDetailDTO, function (budgetDetailReferences) {
                          var invoiceDetailReferences = [];
                          budgetDetailReferences.forEach(function (budgetDetailReference) {
                            invoiceDetailReferences.push({
                              invoicePurchaseDetail: { id: budgetDetailReference.noReference },
                              originType: { originTypeCode: '08' },
                              noReference: budgetDetailReference.budgetDetail.id
                            });
                          });
                          api.ComprasWS.InvoicePurchaseDetailReference.me.saveReferences(
                            {
                              id: 'createReferences',
                              idCircle: $rootScope.bsCircle.id
                            }, invoiceDetailReferences).$promise.then(function () {

                            }, function () {
                              $rootScope.loadingProgress = false;
                            });
                        }, function (errResponse) {
                          $rootScope.loadingProgress = false;
                          $log.debug(errResponse);
                        });
                    }
                  }, function (err) { });
              }
            });
          }, function (err) {
          });
      $timeout(function () {
        changeStatusCanceProvision(settlement);
      }, 1800);
    }

    function getFieldFilter() {
      if (Report.data && Report.data.orderBy) {
        return Report.data.orderBy;
      } else {
        return "id";
      }
    }

    function verifyFieldSort(arr) {
      if (arr) {
        arr.forEach(function (r) {
          const nameFilter = vm.masterGridOptions.api.getColumnDef(r.colId);
          if (nameFilter.nameFilter) {
            r.colId = nameFilter.nameFilter;
          }
        });
      }
    }

    function getButtonsReports(buttons) {
      return (
        '<md-button class="md-icon-button" ng-click="vm.downloadPdf(\'' + buttons.reports + '\', data.id)"> ' +
        '<md-icon md-font-icon="icon-download" class="s16"></md-icon> ' +
        '<md-tooltip md-direction="left">{{"QUOTATION.DOWNLOAD" | translate}}</md-tooltip> ' +
        '</md-button>'
        + '<md-button class="md-icon-button" ng-click="vm.showPDF(\'' + buttons.reports + '\', data)"> ' +
        '<md-icon md-font-icon="icon-printer" class="s16"></md-icon> ' +
        '<md-tooltip md-direction="left">{{"QUOTATION.PRINT" | translate}}</md-tooltip> ' +
        '</md-button>');
    }

    function getInvoiceSerieOrUuid(r) {
      if (r.invoicePurchase.invoiceSerie) {
        return r.invoicePurchase.invoiceSerie.serie;
      } else {
        return r.invoicePurchase.uuid;
      }
    }

    function getDimensionCompany() {
      vm.loadingdimensionCompanyDetail3List = true;
      vm.loadingdimensionCompanyDetail4List = true;
      vm.loadingdimensionCompanyDetail5List = true;
      api.GeneralWS.DimensionCompany.byCompany.getList(
        { 'company': vm.companyId }
      ).$promise.then(function (responseDimension) {
        responseDimension.sort(function (a, b) {
          return a.dimensionNumber - b.dimensionNumber;
        });
        verifyDimensionCompanyGetDetails(responseDimension);
        addColumnsMasterGrid(responseDimension);
      }, function (err) {
        if (err) {
          clearItemsDimensionCompanyDetail();
        }
      });
    }

    function getDimensionCompanyDetail(id, number) {
      const NUMBER_FOUR = 4;
      const NUMBER_FIVE = 5;
      api.GeneralWS.DimensionCompanyDetail.byDimensionCompany.getList(
        { 'dimensionCompanyId': id }
      ).$promise.then(function (responseDimension) {
        if (number === NUMBER_THREE) {
          vm.dimensionCompanyDetail3List = getArrayDimensionCompanyDetail(responseDimension, vm.userDimensionCompanyDetails);
          vm.loadingdimensionCompanyDetail3List = false;
        }
        if (number === NUMBER_FOUR) {
          vm.dimensionCompanyDetail4List = getArrayDimensionCompanyDetail(responseDimension, vm.userDimensionCompanyDetails);
          vm.loadingdimensionCompanyDetail4List = false;
        }
        if (number === NUMBER_FIVE) {
          vm.dimensionCompanyDetail5List = getArrayDimensionCompanyDetail(responseDimension, vm.userDimensionCompanyDetails);
          vm.loadingdimensionCompanyDetail5List = false;
        }
      }, function () {
        vm.loadingdimensionCompanyDetail3List = false;
        vm.loadingdimensionCompanyDetail4List = false;
        vm.loadingdimensionCompanyDetail5List = false;
      });
    }

    function getArrayDimensionCompanyDetail(responseDimension, arrIds) {
      if (Report.filterAllDimensions) {
        return responseDimension;
      } else {
        return responseDimension.filter(function (item) {
          return arrIds.includes(item.id);
        });
      }
    }

    function addMasterColumnDefs(name, fieldName, number, filterField) {
      var nameColumn = '';
      if (number === 3) {
        nameColumn = 'dimensionCompanyDetail3.name'
      } else if (number === 4) {
        nameColumn = 'dimensionCompanyDetail4.name'
      } else if (number === 5) {
        nameColumn = 'dimensionCompanyDetail5.name'
      }
      const NUMBER_NINE_COLUMN_ADD = 9;
      if (vm.title === 'PETTYCASH') {
        vm.masterColumnDefs.splice((number + NUMBER_NINE_COLUMN_ADD), 0, {
          headerName: name,
          field: nameColumn,
          headerCellRenderer: getHeader,
          width: 200,
          enableRowGroup: true,
          filter: 'text',
          enablePivot: true
        });
      } else if (vm.title === 'SETTLEMENT_PROVISIONED') {
        const NUMBER_SIX_COLUMN_ADD = 6;
        vm.masterColumnDefs.splice((number + NUMBER_SIX_COLUMN_ADD), 0, {
          headerName: name,
          field: 'pettyCash.' + nameColumn,
          headerCellRenderer: getHeader,
          width: 200,
          enableRowGroup: true,
          filter: 'text',
          enablePivot: true
        });
      } else if (vm.title === 'ORDER') {
        const NUMBER_SIX_COLUMN_ADD = 3;
        vm.masterColumnDefs.splice((number + NUMBER_SIX_COLUMN_ADD), 0, {
          headerName: name,
          field: fieldName,
          headerCellRenderer: getHeader,
          width: 200,
          enableRowGroup: true,
          filter: 'text',
          enablePivot: true
        });
      } else if (vm.title !== 'INVOICE') {
        const NUMBER_SIX_COLUMN_ADD = 6;
        vm.masterColumnDefs.splice((number + NUMBER_SIX_COLUMN_ADD), 0, {
          headerName: name,
          field: fieldName,
          colId: filterField,
          fieldFilter: filterField,
          headerCellRenderer: getHeader,
          width: 200,
          enableRowGroup: true,
          filter: 'text',
          enablePivot: true
        });
      }
    }

    function getColumnNameDimension(number) {
        return 'dimensionCompanyDetail' + number + 'Name';
    }

    function verifyParameterIsContractBudget() {

      api.GeneralWS.CompanyParameterByName.get(
        {
          id: $rootScope.bsCircle.company.id,
          parameter: 'REQUEST_A_BUDGET_IN_CONTRACTS'
        }, function (responseParameterRequestBudget) {
          if (responseParameterRequestBudget) {
            vm.hasBudgetApplication = responseParameterRequestBudget.parameterValue === 'true';
          } else {
            vm.hasBudgetApplication = false;
          }
        }, function (errParameterRequestBudget) {
          $log.error(errParameterRequestBudget);
        });
    }

    function searchUser() {
      vm.isShowLoaderUsers = true;
      api.GeneralWS.UsersCompany.getArray({
        'company': $rootScope.bsCircle.company.id,
        'roleId': vm.roleComprasOperador.id
      }).$promise.then(function (response) {
        vm.userArray = response;
        vm.isShowLoaderUsers = false;
      });
    }

    /**
     * Go to state
     *
     * @param id
     * @param propertyName
    */
    function goToState(idToGo, propertyName) {
      $state.go(Report[propertyName], {
        id: idToGo,
        filter: vm.filter,
        backTo: $state.current.name,
      });
    }

    function loadStatusByType(typeStatus) {
      if (typeStatus === NUMBER_ONE) {
        vm.loadingStatusRequisition = true;
      } else {
        vm.loadingStatusPurchaseOrder = true;
      }
      api.ComprasWS.PurchaseStatus.query({ 'type': typeStatus }, function (
        data
      ) {
        if (data.length === NUMBER_ONE) {
          if (typeStatus === NUMBER_ONE) {
            vm.filter.statusesRequisition = [data[0].id.toString()];
          } else {
            vm.filter.statusesPurchaseOrder = [data[0].id.toString()];
          }
        }

        if (typeStatus === NUMBER_ONE) {
          vm.statusesRequisition = data;
          vm.loadingStatusRequisition = false;
        } else {
          vm.statusesPurchaseOrder = data;
          vm.loadingStatusPurchaseOrder = false;
        }
      });
    }

    function selectCompanies(typeCompany) {
      let idCompanies = vm.filter.companies;
      if (typeCompany === TEXT_PROVIDERS) {
        idCompanies = vm.filter.providers;
      }
      $mdDialog
        .show({
          controller: 'DialogCompaniesController',
          controllerAs: 'vm',
          templateUrl: 'app/main/apps/reports/dialogs/dialog-companies/dialog-companies.html',
          parent: angular.element('#main'),
          locals: {
            'companiesIds': idCompanies,
            'type': typeCompany
          },
          clickOutsideToClose: false,
          fullscreen: true
        })
        .then(function (answer) {
          if (typeCompany === TEXT_PROVIDERS) {
            vm.filter.providers = [];
          } else {
            vm.filter.companies = [];
          }
          answer.forEach(function (comp) {
            if (typeCompany === TEXT_PROVIDERS) {
              vm.filter.providers.push(comp.id);
            } else {
              vm.filter.companies.push(comp.id);
            }

          });
          if (typeCompany !== TEXT_PROVIDERS) {
            vm.namesCompaniesDialogArr = answer.map(function (comp) {
              return comp.name;
            });
            vm.namesCompaniesDialog = vm.namesCompaniesDialogArr.join();
            getDepartmentsAndCostCentersByCompaniesIds();
          } else {
            vm.namesProvidersArr = answer.map(function (comp) {
              return comp.name;
            });
            vm.namesProviders = vm.namesProvidersArr.join();
          }
        });
    }

    function getDepartmentsAndCostCentersByCompaniesIds() {
      vm.loadingDepartments = true;
      vm.loadingCostCenter = true;
      vm.departments = [];
      vm.costCenters = [];
      vm.filter.departments = [];
      vm.filter.costCenters = [];
      vm.filter.companies.forEach(function (companyId) {
        const parameters = { 'idc': companyId };
        vm.loadingDepartments = true;
        api.GeneralWS.getAllDepartment.query(parameters, function (data) {
          data.forEach(function (department) {
            vm.departments.push(department);
          });
          vm.loadingDepartments = false;
        });

        api.GeneralWS.getAllCost.query(parameters, function (data) {
          vm.loadingCostCenter = true;
          data.forEach(function (costCenter) {
            vm.costCenters.push(costCenter);
          });
          vm.loadingCostCenter = false;
        });
      });
      if (!vm.filter.companies || vm.filter.companies.length === 0) {
        vm.loadingCostCenter = false;
        vm.loadingDepartments = false;
      }
    }

    function selectProducts() {
      $mdDialog
        .show({
          controller: 'DialogProductsController',
          controllerAs: 'vm',
          templateUrl: 'app/main/apps/reports/dialogs/dialog-products/dialog-products.html',
          parent: angular.element('#main'),
          locals: {
            'productsIds': vm.filter.products,
            'originTypeCode': ''
          },
          clickOutsideToClose: false,
          fullscreen: true
        })
        .then(function (answer) {
          vm.filter.products = [];
          vm.namesProducts = '';
          answer.forEach(function (product) {
            vm.filter.products.push(product.id);
          });
          vm.namesProductsArr = answer.map(function (prod) {
            return prod.name;
          });
          vm.namesProducts = vm.namesProductsArr.join();
        });
    }

    function loadProviders() {
      vm.loadingProviderSelect = true;
      const providerSelected = [];
      vm.filter.providers.forEach(function (p) {
        vm.providersSelect.forEach(function (r) {
          if (p === r.id.toString()) {
            providerSelected.push(r);
          }
        });
      });
      api.GeneralWS.getAllCompaniesProviders.page(
        {
          'pageNumber': 1,
          'pageSize': 100, 'search': vm.searchProviderSelect,
          'companyId': $rootScope.bsCircle.company.id, 'includeMe': false
        }).$promise.then(function (response) {
          vm.provs = response;
          vm.providersSelect = new jinqJs()
            .from(response.content)
            .orderBy([{ field: 'name', sort: 'asc' }])
            .select(function (r) {
              return r;
            });
          providerSelected.forEach(function (p) {
            let exist = false;
            vm.providersSelect.forEach(function (r) {
              if (p.id === r.id) {
                exist = true;
              }
            });
            if (!exist) {
              vm.providersSelect.push(p);
            }
          });
          vm.loadingProviderSelect = false;
        }, function (errResponse) {
          vm.loadingProviderSelect = false;
          $log.error(errResponse);
        });
    }

    function selectAllItemsProviders() {
      if (vm.filter.providers.length === 1 && vm.filter.providers[0] === '-1') {
        api.GeneralWS.getAllCompaniesProviders.page(
          {
            'pageNumber': 1,
            'pageSize': vm.provs.totalElements, 'search': '',
            'companyId': $rootScope.bsCircle.company.id, 'includeMe': false
          }).$promise.then(function (response) {
            vm.isShowLoaderCompanies = false;
            vm.providersSelect = new jinqJs()
              .from(response.content)
              .orderBy([{ field: 'name', sort: 'asc' }])
              .select(function (r) {
                return r;
              });
            $timeout(function () {
              vm.filter.providers = vm.providersSelect.map(function (a) {
                return a.id;
              });
            }, TIMEOUT_FIVE_THOUSAND);

          }, function (errResponse) {
            vm.isShowLoaderCompanies = false;
            $log.error(errResponse);
          });
      }
    }

    function changeDeptosAndCc() {
      getDepartmentsAndCostCentersByCompaniesIds();
    }

    function changeDeptosAndCcUser() {
      params.idc = vm.filter.companies;
      vm.companyId = params.idc;
      clearItemsDimensionCompanyDetail();
      getBasicColumnsGrid();
      getDimensionCompany();
      vm.departments = [];
      vm.filter.departments = [];
      loadDepartments();
      vm.costCenters = [];
      vm.filter.costCenters = [];
      loadCostCenter();
    }

    function verifyDeleteFilterCompanies(){
      if (vm.snFilter.companiesLoadDeptoAndCCUser && vm.filter.companies && !Array.isArray(vm.filter.companies)) {
        vm.filter.companies = [Number(vm.filter.companies)];
      }
    }

    function clearItemsDimensionCompanyDetail() {
      vm.dimensionCompanyDetail3List = [];
      vm.dimensionCompanyDetail4List = [];
      vm.dimensionCompanyDetail5List = [];
      vm.loadingdimensionCompanyDetail3List = false;
      vm.loadingdimensionCompanyDetail4List = false;
      vm.loadingdimensionCompanyDetail5List = false;
      clearObjectDimensionCompany();
    }

    function getBasicColumnsGrid(){
      vm.masterColumnDefs = angular.copy(Report.columns);

      vm.masterColumnDefs.forEach(function (row) {
        row.headerCellRenderer = getHeader;
        if (row.valueFormatter) {
          row.valueFormatter = getCellFormater(row.valueFormatter);
        }
        verifyDeleteRendererButtom(row);
        if (row.rendererSerie) {
          row.cellRenderer = getRendererSerie();
        }
        if (row.rendererFile) {
          row.cellRenderer = getRendererFile(row.rendererFile.field);
        }
        if (row.dataTypes) {
          correctFilter(row);
        }
        if (row.cellRendererSerie) {
          row.cellRenderer = function (param) {
            if (param.data.invoiceSerie) {
              return param.data.invoiceSerie;
            }
            return param.data.uuid;
          };
        }
      });
    }

    function verifyAssignCompanies() {
      if (vm.snFilter.companiesLoadDeptoAndCCUser && vm.filter.companies.length === 1) {
        vm.filter.companies = vm.filter.companies[0];
        loadDepartments();
        loadCostCenter();
      }
    }

    function verifyDeleteRendererButtom(row) {
      if (row.rendererCurrencyDescAmount) {
        row.cellRenderer = getFormedAmountCurrencyDescription(
          row.rendererCurrencyDescAmount.amountField,
          row.rendererCurrencyDescAmount.currecyField
        );
        delete row.rendererCurrencyDescAmount;
      }
      if (row.rendererButtons) {
        row.cellRenderer = getButtons(row.rendererButtons);
        delete row.rendererButtons;
      }
      if (row.rendererLink) {
        row.cellRenderer = getURL(row.rendererLink);
        delete row.rendererLink;
      }
      if (row.rendererButtonsM) {
        row.cellRenderer = getButtonsM(row.rendererButtonsM);
        delete row.rendererButtonsM;
      }
      if (row.rendererButtonsSettlement) {
        row.cellRenderer = getButtonsSettlement(row.rendererButtonsSettlement);
        delete row.rendererButtonsSettlement;
      }
      if (row.rendererTranslateValue) {
        row.cellRenderer = getTranslateValue(
          row.rendererTranslateValue.prefixTranslate,
          row.rendererTranslateValue.keyValue
        );
        delete row.rendererTranslateValue;
      }
    }

    function loadProducts() {
      vm.loadingProducts = true;
      api.GeneralWS.ProductAll.get({
        circle: $rootScope.bsCircle.id,
        page: 0,
        size: 100,
        filter: vm.searchProductInput,
        validateToPurchaseRequisition: false,
        excludeDepartmentProducts: false,
        hideInBudget: false
      },
        function (response) {
          vm.products = response;
          vm.loadingProducts = false;
        },
        function () {
          vm.loadingProducts = false;
        }
      );
    }

    function addColumnsDimensionsByProvider() {
      if ($stateParams.provider) {
        const listDimensions3 = new jinqJs()
          .from(vm.infData)
          .where(function (d) {
            return d.dimensionCompany3Id;
          })
          .select(function (r) {
            return r.dimensionCompany3Id;
          });

        const listDimensions4 = new jinqJs()
          .from(vm.infData)
          .where(function (d) {
            return d.dimensionCompany4Id;
          })
          .select(function (r) {
            return r.dimensionCompany4Id;
          });

        const listDimensions5 = new jinqJs()
          .from(vm.infData)
          .where(function (d) {
            return d.dimensionCompany5Id;
          })
          .select(function (r) {
            return r.dimensionCompany5Id;
          });

        if (listDimensions3.length > 0 ||
          listDimensions4.length > 0 ||
          listDimensions4.length > 0
        ) {
          const distinctListDimensionCompanies = new jinqJs()
            .from(listDimensions3, listDimensions4, listDimensions5)
            .distinct()
            .select();

          if (distinctListDimensionCompanies.length > 0) {
            getDimensionCompanyByList(distinctListDimensionCompanies);
          }
        } else {
          getBasicColumnsGrid();
          vm.masterGridOptions.api.setColumnDefs(vm.masterColumnDefs);
        }
      }
    }

    function getDimensionCompanyByList(ids) {
      api.GeneralWS.DimensionCompany.getByIdList.getList(
        {'company': vm.companyId}, ids
      ).$promise.then(function (responseDimension) {
        responseDimension.sort(function (a, b) {
          return a.dimensionNumber - b.dimensionNumber;
        });
        verifyDimensionCompanyGetDetails(responseDimension);
      });
    }

    function verifyDimensionCompanyGetDetails(responseDimension) {
      getBasicColumnsGrid();
      clearObjectDimensionCompany();
      const NUMBER_DIMENSION_THREE = 3;
      const NUMBER_DIMENSION_FOUR = 4;
      const NUMBER_DIMENSION_FIVE = 5;
      const NAME_DIMENSION_THREE = 'purchaseOrder.dimensionCompanyDetail3.name';
      const NAME_DIMENSION_FOUR = 'purchaseOrder.dimensionCompanyDetail4.name';
      const NAME_DIMENSION_FIVE = 'purchaseOrder.dimensionCompanyDetail5.name';
      for (let i = 0; i < responseDimension.length; i++) {
        if (responseDimension[i].dimensionNumber === NUMBER_DIMENSION_THREE && !vm.dimensionCompanyDetail3) {
          vm.dimensionCompanyDetail3 = responseDimension[i];
          addMasterColumnDefs(
            responseDimension[i].description,
            getColumnNameDimension(vm.number_three),
            responseDimension[i].dimensionNumber,
            NAME_DIMENSION_THREE
          );

          getDimensionCompanyDetail(responseDimension[i].id, responseDimension[i].dimensionNumber);

        } else if (responseDimension[i].dimensionNumber === NUMBER_DIMENSION_FOUR && !vm.dimensionCompanyDetail4) {
          vm.dimensionCompanyDetail4 = responseDimension[i];
          addMasterColumnDefs(
            responseDimension[i].description,
            getColumnNameDimension(vm.number_four),
            responseDimension[i].dimensionNumber,
            NAME_DIMENSION_FOUR
            );

          getDimensionCompanyDetail(responseDimension[i].id, responseDimension[i].dimensionNumber);

        } else if (responseDimension[i].dimensionNumber === NUMBER_DIMENSION_FIVE && !vm.dimensionCompanyDetail5) {
          vm.dimensionCompanyDetail5 = responseDimension[i];
          addMasterColumnDefs(
            responseDimension[i].description,
            getColumnNameDimension(vm.number_five),
            responseDimension[i].dimensionNumber,
            NAME_DIMENSION_FIVE
          );
          getDimensionCompanyDetail(responseDimension[i].id, responseDimension[i].dimensionNumber);
        } else {
          vm.dimensionCompanyDetail1 = responseDimension[i];
        }
      }

      addColumnsMasterGrid(responseDimension);
    }

    function addColumnsMasterGrid(responseDimension) {
      $timeout(function () {
        if (vm.masterGridOptions) {
          vm.masterGridOptions.api.setColumnDefs(vm.masterColumnDefs);
          if (responseDimension.length === 0) {
            clearItemsDimensionCompanyDetail();
          }
        }
      }, TIMEOUT_THREE_THOUSAND);
    }

    function clearObjectDimensionCompany() {
      vm.dimensionCompanyDetail3 = null;
      vm.dimensionCompanyDetail4 = null;
      vm.dimensionCompanyDetail5 = null;
    }

    function loadUsersByRoleAndUserCompanies() {
      vm.loadingUsersByRoleAndUserCompanies = true;
      api.GeneralWS.BusinessCircleMembers.UsersByRoleAndCompanies.query(
        {
          'applicationId': $rootScope.APPQ.id,
          'roleName': Report.data.roleToSearchUsersInUserCompanies,
        },
        $rootScope.userCompanies,
        function (data) {
          vm.usersByRoleAndUserCompanies = data;
          vm.loadingUsersByRoleAndUserCompanies = false;
        },
        function () {
          vm.loadingUsersByRoleAndUserCompanies = false;
        });
    }

  }
})();

(function () {
    'use strict';

    angular
        .module('app.order')
        .controller('OrdersController', ordersController);

    /** @ngInject */
    function ordersController(
        $state, api, $rootScope, $log, $mdDialog, $filter,
        MessageService, $timeout, $scope, $stateParams, envService, $http
    ) {
        var vm = this;

        vm.isProvider = ($stateParams.type === 'P' || $stateParams.type === 'PIC');
        vm.typeDisplay = $stateParams.type;
        vm.NUMBER_DIMENSION_THREE = 3;
        vm.NUMBER_DIMENSION_FOUR = 4;
        vm.NUMBER_DIMENSION_FIVE = 5;
        vm.filterType = 'ALL';
        vm.two_hundred = 200;

        vm.masterColumnDefs = getBasicColumnsDefs();

        vm.masterGridOptions = {
            columnDefs: vm.masterColumnDefs,
            enableSorting: true,
            debug: false,
            enableFilter: true,
            enableColResize: true,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowData: null,
            groupHeaders: true,
            headerHeight: 50,
            rowHeight: 45,
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            },
            doesDataFlower: function (dataItem) {
                return true;
            },
            isExternalFilterPresent: isExternalFilterPresent,
            doesExternalFilterPass: doesExternalFilterPass
        };

        var filter = 'everyone';

        function isExternalFilterPresent() {
            return filter !== '';
        }

        function doesExternalFilterPass(node) {
            if (filter && filter !== 'everyone') {
                var arrdt = node.data.filter.split(filter);
                return arrdt.length > 1;
            }
            return true;
        }

        $scope.$watch('vm.search',
            function (newValue) {
                filter = newValue ? newValue.toLowerCase() : 'everyone';
                vm.masterGridOptions.api.onFilterChanged();
            }
        );

        $timeout(function (d) {
            getOrders();
        }, 300);

        function getOrders() {
            vm.loading = true;
            if ($rootScope.bsCircle) {
                $rootScope.loadingProgress = true;
                vm.loading = true;
                getDimensionCompany();
                api.ComprasWS.PurchaseOrder.query({
                    idCircle: $rootScope.bsCircle.id,
                    type: $stateParams.type,
                    filterType: vm.filterType }, function (response) {// Success
                    vm.orders = new jinqJs()
                        .from(response)
                        .select(function (r) {
                            var d = r;
                            d.companyBuy = angular.copy(d.company);
                            if (!vm.isProvider) {
                                d.company = angular.copy(d.companyProvider);
                            }
                            d.filter = (d.id + "," + d.department.description + ","
                                + d.costCenter.description + "," + d.company.name + "," + d.companyProvider.name).toLowerCase();
                            return d;
                        });
                  const listDimensions3 = new jinqJs()
                    .from(response)
                    .where(function (d) {
                      return d.dimensionCompanyDetail3;
                    })
                    .select(function (r) {
                      return r.dimensionCompanyDetail3;
                    });

                  const listDimensions4 = new jinqJs()
                    .from(response)
                    .where(function (d) {
                      return d.dimensionCompanyDetail4;
                    })
                    .select(function (r) {
                      return r.dimensionCompanyDetail4;
                    });

                  const listDimensions5 = new jinqJs()
                    .from(response)
                    .where(function (d) {
                      return d.dimensionCompanyDetail5;
                    })
                    .select(function (r) {
                      return r.dimensionCompanyDetail5;
                    });

                  if (listDimensions3.length > 0 ||
                    listDimensions4.length > 0 ||
                    listDimensions4.length > 0
                  ) {
                    const distinctListDimensionCompanies = new jinqJs()
                      .from(listDimensions3, listDimensions4, listDimensions5)
                      .distinct(
                        'dimensionCompanyId'
                      )
                      .select(function (r) {
                        return r.dimensionCompanyId;
                      });

                    if (distinctListDimensionCompanies.length > 0) {
                      getDimensionCompanyByList(distinctListDimensionCompanies);
                    }
                  }

                    vm.masterGridOptions.api.setColumnDefs(vm.masterColumnDefs);
                    vm.masterGridOptions.api.setRowData(vm.orders);
                    vm.loading = false;
                    $rootScope.loadingProgress = false;
                    $log.debug(vm.orders);
                }, function (response) {// Error
                    $log.debug(response);
                    vm.loading = false;
                    vm.masterGridOptions.api.setColumnDefs(vm.masterColumnDefs);
                    vm.masterGridOptions.api.setRowData([]);
                    $rootScope.loadingProgress = false;
                });
            } else {
                vm.loading = false;
                $state.go('app.dashboard_project');
            }
        }

        // Methods
        vm.getOrders = getOrders;
        vm.convertDate = convertDate;
        vm.gotoOrderDetail = gotoOrderDetail;
        vm.deleteRequisition = deleteRequisition;

        //////////

        function convertDate(dateS) {
            return new Date(dateS + ' 00:00:00');
        }


        /**
         * Delete
         *
         * @param e
         * @param id
         * @param i
         * @returns {*}
         */
        function deleteRequisition(e, id, i) {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('ORDER.CANCELAR'))
                .textContent($filter('translate')('ORDER.MSG.CONFIRMACION_CANCEL'))
                .ok($filter('translate')('ORDER.MSG.SI'))
                .cancel($filter('translate')('ORDER.MSG.NO'));

            $mdDialog.show(confirm).then(function () {
                $rootScope.loadingProgress = true;
                api.ComprasWS.Requisition.delete({ idCircle: $rootScope.bsCircle.id, id: id }, function (response) {// Success
                    vm.orders.splice(i, 1);
                    $rootScope.loadingProgress = false;
                    vm.masterGridOptions.api.setRowData(vm.orders);

                    MessageService.show('ORDER.MSG.DELETED');
                }, function (response) {// Error
                    $log.debug(response);
                });

            }, function () {
            });
        }

        /**
         * Go to product detail
         *
         * @param id
         */
        function gotoOrderDetail(id) {
            $state.go('app.order.' + $stateParams.type + '.detail', { id: id });
        }

        function renderer(params) {
            vm.openTooltipBottom = '<md-tooltip md-direction="bottom">';
            vm.closeTooltipBootom = '</md-tooltip>';
            return '<div style="width: 100%;">'
                + ' <md-button class="edit-button md-icon-button" ng-click="vm.gotoOrderDetail(data.id)" aria-label="Order details"'
                + '                                translate translate-attr-aria-label="ORDER.ORDER_DETAILS">'
                + vm.openTooltipBottom
                + '                             {{"ORDER.DETAIL.VIEW"| translate}}'
                + vm.closeTooltipBootom
                + '                         <md-icon md-font-icon="icon-eye" class="s16"></md-icon> '
                + '                     </md-button>'
                + ' <md-button class="edit-button md-icon-button" ng-click="vm.downloadPdf(\'JASPER_URL_ORDEN_COMPRA\', data.id)" aria-label="Order details"'
                + '                                ng-if="vm.isProvider" translate translate-attr-aria-label="ORDER.ORDER_DETAILS">'
                + vm.openTooltipBottom
                + '                             {{"QUOTATION.DOWNLOAD"| translate}}'
                + vm.closeTooltipBootom
                + '                         <md-icon md-font-icon="icon-download" class="s16"></md-icon> '
                + '                     </md-button>'
                + ' <md-button class="edit-button md-icon-button" ng-click="vm.showPDF(\'JASPER_URL_ORDEN_COMPRA\', data.id)" aria-label="Order details"'
                + '                                ng-if="vm.isProvider" translate translate-attr-aria-label="ORDER.ORDER_DETAILS">'
                + vm.openTooltipBottom
                + '                             {{"QUOTATION.PRINT"| translate}}'
                + vm.closeTooltipBootom
                + '                         <md-icon md-font-icon="icon-printer" class="s16"></md-icon> '
                + '                     </md-button>'
                + '                 </div>';
        }

        vm.downloadPdf = function (parameter, id) {

            vm.fullUrl = envService.read('baseUrlJReportsWSPdf') +
                '?rpt=' +
                getUrlByParameterName(parameter, id);

            const config = {
                responseType: 'arraybuffer',
                headers: {
                    'Content-type': 'application/pdf',
                }
            };

            $http.get(vm.fullUrl, config).then(function (file) {
                const NUMBER_FIVE_HUNDRED = 500;
                $timeout(function () {
                    const fileBlob = new Blob([file.data], {
                        type: 'application/pdf'
                    });
                    const fileURL = URL.createObjectURL(fileBlob);
                    const a = document.createElement('a');
                    a.download = $filter('translate')('ORDER.ORDER') + ' ' + id;
                    a.href = fileURL;
                    a.target = '_blank';
                    a.click();
                    a.remove();
                }, NUMBER_FIVE_HUNDRED);

            });
        };

        vm.showPDF = function (parameterName, id) {
            const urlRpt = getUrlByParameterName(parameterName, id);

            $mdDialog
                .show({
                    controller: 'ReportShowPDFController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/apps/reports/dialogs/show-pdf/show-pdf.html',
                    parent: angular.element('#main'),
                    locals: {
                        Url: urlRpt
                    },
                    clickOutsideToClose: false,
                    fullscreen: true
                })
                .then();
        };

        function getUrlByParameterName(parameterName, id){
            return $rootScope
            .getParameterValue(parameterName)
            .replace('[ID]', id);
        }

        function getDimensionCompany() {
            api.GeneralWS.DimensionCompany.byCompany.getList(
                { 'company': $rootScope.bsCircle.company.id }
            ).$promise.then(function (responseDimension) {
              responseDimension.sort(function (a, b) {
                return a.dimensionNumber - b.dimensionNumber;
              });
              vm.masterColumnDefs = getBasicColumnsDefs();
              verifyDimensionCompanyGetDetails(responseDimension);
                $timeout(function (){
                  if (vm.masterGridOptions && vm.masterGridOptions.api) {
                    vm.masterGridOptions.api.setColumnDefs(vm.masterColumnDefs);
                  }
                }, vm.two_hundred);
            });
        }

        function addMasterColumnDefs(name, fieldName, number) {
          let exist = false;
          vm.masterColumnDefs.forEach(function (r) {
            if (r.headerName === name) {
              exist = true;
            }
          });
          if (!exist) {
            const NUMBER_COLUMN_ADD = 6;
            vm.masterColumnDefs.splice((number + NUMBER_COLUMN_ADD), 0, {
                headerName: name,
                field: fieldName,
                headerCellRenderer: getHeader,
                width: 200,
                enableRowGroup: true,
                filter: 'text',
                enablePivot: true
            });
          }
        }

      function getBasicColumnsDefs() {
        const columnsDefs = [
          {
            headerName: '#',
            field: "id",
            width: 50,
            cellStyle: {'text-align': 'center'},
            sort: 'asc',
            pinned: "left"
          },
          {
            headerName: 'ORDER.PROVIDER',
            field: "company.name",
            headerCellRenderer: getHeader,
            width: 250,
            enableRowGroup: true,
            enablePivot: true
          },
          {
            headerName: 'ORDER.DEPARTMENT',
            field: "department.description",
            headerCellRenderer: getHeader,
            width: 250,
            enableRowGroup: true,
            enablePivot: true
          },
          {
            headerName: 'ORDER.COSTCENTER',
            field: "costCenter.description",
            headerCellRenderer: getHeader,
            width: 200,
            enableRowGroup: true,
            enablePivot: true
          },
          {
            headerName: 'ORDER.DATEDELIVERY',
            field: "dateDelivery",
            headerCellRenderer: getHeader,
            width: 150,
            valueFormatter: function (params) {
              return $filter('date')(params.value, 'dd/MM/yyyy');
            },
            enableRowGroup: true,
            enablePivot: true
          },
          {
            headerName: 'ORDER.TOTAL',
            field: "total",
            width: 125,
            headerCellRenderer: getHeader,
            valueFormatter: function (params) {
              return $filter('number')(params.value, '2');
            },
            enableRowGroup: true,
            enablePivot: true,
            cellStyle: {'text-align': 'right'}
          },
          {
            headerName: 'ORDER.ACTIONS',
            name: "actions",
            headerCellRenderer: getHeader,
            suppressSorting: true,
            suppressMenu: true,
            width: 180,
            cellRenderer: renderer,
            cellStyle: {'padding': '0px'},
            pinned: "right"
          }
        ];

        if (vm.isProvider) {
          columnsDefs[1].headerName = 'ORDER.BUYER';
          columnsDefs.splice(1, 0, {
            headerName: 'REQUISITION.COMPANY_BUYER',
            field: "companyProvider.name",
            headerCellRenderer: getHeader,
            width: 200,
            enableRowGroup: true,
            enablePivot: true
          });
        }

        return columnsDefs;
      }

      function getDimensionCompanyByList(ids) {
        api.GeneralWS.DimensionCompany.getByIdList.getList(
          {'company': vm.companyId}, ids
        ).$promise.then(function (responseDimension) {
          responseDimension.sort(function (a, b) {
            return a.dimensionNumber - b.dimensionNumber;
          });
          verifyDimensionCompanyGetDetails(responseDimension);
        });
      }

      function verifyDimensionCompanyGetDetails(responseDimension) {
        for (let i = 0; i < responseDimension.length; i++) {
          if (responseDimension[i].dimensionNumber === vm.NUMBER_DIMENSION_THREE) {
            vm.dimensionCompanyDetail3 = responseDimension[i];
            addMasterColumnDefs(responseDimension[i].description, 'dimensionCompanyDetail3.name', responseDimension[i].dimensionNumber);
          } else if (responseDimension[i].dimensionNumber === vm.NUMBER_DIMENSION_FOUR) {
            vm.dimensionCompanyDetail4 = responseDimension[i];
            addMasterColumnDefs(responseDimension[i].description, 'dimensionCompanyDetail4.name', responseDimension[i].dimensionNumber);
          } else if (responseDimension[i].dimensionNumber === vm.NUMBER_DIMENSION_FIVE) {
            vm.dimensionCompanyDetail5 = responseDimension[i];
            addMasterColumnDefs(responseDimension[i].description, 'dimensionCompanyDetail5.name', responseDimension[i].dimensionNumber);
          } else {
            vm.dimensionCompanyDetail1 = responseDimension[i];
          }
          if (responseDimension[responseDimension.length - 1] === responseDimension[i]) {
            vm.masterGridOptions.api.setColumnDefs(vm.masterColumnDefs);
          }
        }
      }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.invoice')
        .controller('InvoicesController', InvoicesController);

    /** @ngInject */
    function InvoicesController($scope, $rootScope, $state, api, $log, $filter, $stateParams, $mdDialog, $timeout, MessageService) {
        var vm = this;

        vm.statusName = $stateParams.status ? $stateParams.status : '';

        if ($rootScope.bsCircle) {
            getInvoices();
        } else {
            vm.loading = false;
            $state.go('app.dashboard_project');
        }

        function getInvoices() {
            $rootScope.loadingProgress = true;
            vm.loading = true;
            api.ComprasWS.InvoicePurchase.list(
                { id: 'byUserAndStatus', idCircle: $rootScope.bsCircle.id, status: $stateParams.status }).$promise.then(function (response) {// Success

                    vm.invoicePurchases = response;
                    vm.masterGridOptions.api.setColumnDefs(vm.masterColumnDefs);
                    vm.masterGridOptions.api.setRowData(vm.invoicePurchases);
                    vm.loading = false;
                    $rootScope.loadingProgress = false;
                }, function (response) {// Error
                    $log.debug(response);
                    vm.loading = false;
                    vm.masterGridOptions.api.setColumnDefs(vm.masterColumnDefs);
                    vm.masterGridOptions.api.setRowData([]);
                    $rootScope.loadingProgress = false;
                });
        }



        vm.masterColumnDefs = [
            {
                headerName: "REPORT.DOC_ENTREGA",
                headerCellRenderer: getHeader,
                field: "id",
                width: 100,
                cellStyle: {
                    "text-align": "center"
                },
                pinned: "left"
            },
            {
                headerName: $stateParams.status === 'Ingresando' ? 'INVOICE.COMPANY.COMPANY_CLIENT' : 'INVOICE.COMPANY.COMPANY_PROVIDER',
                field: $stateParams.status === 'Ingresando' ? "companyBuyerName" : "companyProviderName",
                headerCellRenderer: getHeader,
                width: 300,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'INVOICE.INVOICE_PURCHASE.DATE',
                field: "dateInvoicePurchase",
                headerCellRenderer: getHeader,
                valueFormatter: function (params) {
                    return $filter('date')(new Date(params.value), 'dd/MM/yyyy');
                },
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'INVOICE.INVOICE_PURCHASE.SERIE',
                field: "invoiceSerie",
                headerCellRenderer: getHeader,
                width: 100,
                enableRowGroup: true,
                enablePivot: true,
                cellStyle: { 'text-align': 'center' }
            },
            {
                headerName: 'INVOICE.INVOICE_PURCHASE.SERIE_TYPE',
                field: "typeSerie",
                headerCellRenderer: getHeader,
                width: 100,
                enableRowGroup: true,
                enablePivot: true,
                cellStyle: { 'text-align': 'center' }
            },
            {
                headerName: 'INVOICE.INVOICE_PURCHASE.CORRELATIVE',
                field: "correlative",
                headerCellRenderer: getHeader,
                width: 100,
                enableRowGroup: true,
                enablePivot: true,
                cellStyle: { 'text-align': 'center' }
            },
            {
                headerName: 'INVOICE.INVOICE_PURCHASE.UUID',
                field: "uuid",
                headerCellRenderer: getHeader,
                width: 350,
                enableRowGroup: true,
                enablePivot: true,
                cellStyle: { 'text-align': 'center' }
            },
            {
                headerName: 'INVOICE.INVOICE_PURCHASE.RECEIPT_STAMP',
                field: 'electronicSignature',
                headerCellRenderer: getHeader,
                width: 200,
                enableRowGroup: true,
                enablePivot: true,
                cellStyle: { 'text-align': 'center' },
            },
            {
                headerName: 'INVOICE.INVOICE_PURCHASE.TOTAL_AFTER_TAX',
                field: "totalAfterTaxCurrency",
                headerCellRenderer: getHeader,
                suppressSorting: true,
                suppressMenu: true,
                width: 150,
                cellStyle: { 'text-align': 'right' }
            },
            {
                headerName: 'INVOICE.INVOICE_PURCHASE.OPTIONS',
                headerCellRenderer: getHeader,
                suppressSorting: true,
                suppressMenu: true,
                width: 100,
                cellRenderer: renderer,
                cellStyle: { 'padding': '0px' },
                pinned: "right"
            }
        ];

        if ($stateParams.status === 'Emitida' || $stateParams.status === 'Pendiente Recibir Original') {
            vm.masterColumnDefs.splice(1, 0, {
                headerName: 'REQUISITION.COMPANY_BUYER',
                field: "companyBuyerName",
                headerCellRenderer: getHeader,
                width: 200,
                enableRowGroup: true,
                enablePivot: true
            });
            const correlativeColumn = _.find(vm.masterColumnDefs, function (row) {
                return row.field === 'correlative';
              });
            if (correlativeColumn) {
                correlativeColumn.field = 'documentComposedCode'
            }
        }
        if ($stateParams.status === 'Ingresando') {
            vm.masterColumnDefs.splice(1, 0, {
                headerName: 'REQUISITION.COMPANY_BUYER',
                field: "companyProviderName",
                headerCellRenderer: getHeader,
                width: 200,
                enableRowGroup: true,
                enablePivot: true
            });
        }

        vm.masterGridOptions = {
            columnDefs: vm.masterColumnDefs,
            enableSorting: true,
            debug: false,
            enableFilter: true,
            enableColResize: true,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowData: null,
            groupHeaders: true,
            headerHeight: 50,
            rowHeight: 45,
            doesDataFlower: function (dataItem) {
                var dateInvoicePurchase = new Date(dataItem.dateInvoicePurchase + " 00:00:00");
                dataItem.dateInvoicePurchase = dateInvoicePurchase;
                var dateInvoiceAccounting = new Date(dataItem.dateInvoiceAccounting + " 00:00:00");
                dataItem.dateInvoiceAccounting = dateInvoiceAccounting;
                var totalNull = 0;
                const decimalsFix = 2;
                dataItem.vatReceived = getValueOrDefault(dataItem.vatReceived, totalNull);
                dataItem.totalAfterTax = getValueOrDefault(dataItem.totalAfterTax, totalNull);
                dataItem.totalWithVat = (dataItem.vatReceived + dataItem.totalAfterTax).toFixed(decimalsFix);
                dataItem.totalAfterTaxCurrency = dataItem.currency + '. ' + $filter('number')(dataItem.totalWithVat, decimalsFix);
                dataItem.typeSerie = ((dataItem.invoiceSerie && dataItem.electronicInvoice) ? "Electronica" : "Manual");
                dataItem.filter = 'fac'
                    + dataItem.id + ','
                    + ($stateParams.status === 'Ingresando' ? ((dataItem.invoiceSerie)
                        + ',' + dataItem.correlative + ',' + dataItem.companyBuyerName
                        + ',' + dataItem.totalWithVat).toLowerCase() :
                        (dataItem.invoiceSerie + ','
                            + dataItem.correlative + ',' + dataItem.companyProviderName + ',' + dataItem.typeSerie + ',' + dataItem.uuid + ','
                            + dataItem.totalWithVat).toLowerCase());
                return true;
            },
            isExternalFilterPresent: isExternalFilterPresent,
            doesExternalFilterPass: doesExternalFilterPass,
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            }
        };

        function getValueOrDefault(value, def) {
            if (value) {
                return value;
            }
            return def;
        }

        var filter = 'everyone';

        function isExternalFilterPresent() {
            // if ageType is not everyone, then we are filtering
            return filter !== '';
        }

        function doesExternalFilterPass(node) {
            if (filter && filter !== 'everyone') {
                var arrdt = node.data.filter.split(filter);
                return arrdt.length > 1;
            }
            return true;
        }

        $scope.$watch('vm.search',
            function (newValue) {
                filter = newValue ? newValue.toLowerCase() : 'everyone';
                vm.masterGridOptions.api.onFilterChanged();
            }
        );
        $scope.$watch('vm.barCode',
            function (newValue) {
                filter = newValue ? newValue.toLowerCase() : 'everyone';
                vm.masterGridOptions.api.onFilterChanged();
            }
        );

        vm.goToInvoicePurchaseEdit = goToInvoicePurchaseEdit;
        vm.newInvoicePurchase = newInvoicePurchase;
        vm.searchByInvoice = searchByInvoice;



        function goToInvoicePurchaseEdit(dataId) {
          $rootScope.loadingProgress = true;
            if ($stateParams.status === 'Emitida' || $stateParams.status === 'Pendiente Recibir Original' || $stateParams.status === 'Pendiente Provisionar') {
              vm.masterGridOptions.api.showLoadingOverlay();
              api.ComprasWS.InvoicePurchase.get({ id: dataId }, function (response) {
                var docArray = [];
                docArray.push(
                    {
                        docType: "invoice", //invoice=facturas, receipt=recibos
                        docObj: response,
                        detailId: dataId
                    }
                );
                $state.go('app.invoice.' + $stateParams.status.replace("-", "").replace(/ /g, "") + '.detail', {
                    docArray: docArray, //el array de los documentos ej. invoicePurchase
                    backState: {
                        stateToBack: 'app.invoice.' + $stateParams.status.replace("-", "").replace(/ /g, ""), //state a donde debe regresar
                        paramsToBack: $state.params
                    },
                    mainDoc: {
                        type: $filter('translate')('INVOICE.INVOICE'), //descripcion del typo
                        typeCode: 'PURCHASE', //PURCHASE_ORDER= para compras, SETTLEMENT para liquidaciones
                        number: dataId,
                        description: '', //Una descripcion a mostrar
                        detailIndex: 0
                    }
                });
              $rootScope.loadingProgress = false;
              }, function (errgetInvoiceDTO) {// Error
                $log.debug(errgetInvoiceDTO);
                vm.loading = false;
                $rootScope.loadingProgress = false;
              });

            } else {
                $state.go('app.invoice.' + $stateParams.status.replace("-", "") + '.detail', { id: dataId });
            }
        }

        function newInvoicePurchase() {
            $state.go('app.invoice.Ingresando.detail');
        }

        function renderer(params) {
            return '<div style="width: 100%;">'
                + '               <md-button class="edit-button md-icon-button" ng-click="vm.goToInvoicePurchaseEdit(data.id)" aria-label="Order details"'
                + '                                translate translate-attr-aria-label="REQUISITION.ORDER_DETAILS">'
                + '                         <md-tooltip md-direction="bottom">'
                + '                             {{"REQUISITION.DETAIL.VIEW"| translate}}'
                + '                         </md-tooltip>'
                + '                         <md-icon md-font-icon="icon-eye" class="s16"></md-icon> '
                + '                     </md-button>'
                + '                 </div>';
        }

        function searchByInvoice() {
            $timeout(function () {
                if (vm.masterGridOptions.api.rowModel.rowsToDisplay.length === 1) {
                    goToInvoicePurchaseEdit(vm.masterGridOptions.api.rowModel.rowsToDisplay[0].data.id);
                }
            }, 2000);
        }

        vm.provisionInvioce = function (ev) {

            if (!vm.inputBarCodeDisabled) {
                vm.inputBarCodeDisabled = true;

                $rootScope.loadingProgress = true;

                $timeout(function () {

                    if (vm.masterGridOptions.api.rowModel.rowsToDisplay.length === 1) {

                        vm.invoice = vm.masterGridOptions.api.rowModel.rowsToDisplay[0].data;

                      var localInvoice = vm.invoice;
                      if (localInvoice.invoiceSerie){
                        localInvoice.invoiceSerie = { id: localInvoice.invoiceSerie.id };
                      }

                        vm.statusToChange = vm.invoice.purchaseStatus.description;

                        vm.withholdingToInvoice({ docObj: vm.invoice });

                        var statusToChange = vm.statusToChange === 'Pendiente Recibir Original' ? "Provisionada" : 'Pendiente Recibir Original';
                        if (vm.statusToChange === 'Emitida' &&
                            ((vm.invoice.invoiceSerie && vm.invoice.invoiceSerie.electronicInvoice) || vm.invoice.uuid != null)
                        ) {
                            statusToChange = "Provisionada";
                        }
                        $rootScope.loadingProgress = true;
                        api.ComprasWS.InvoicePurchase.setStatus(
                            { id: 'changeStatus', idCircle: $rootScope.bsCircle.id, status: statusToChange }, localInvoice).$promise.then(function (response) {

                                MessageService.show($filter('translate')("INVOICE.MSG.STATUS_CHANGE_SUCCESS"));
                                $timeout(function () {
                                    vm.barCode = '';

                                    var urlRpt = $rootScope.getParameterValue('JASPER_URL_CONTRASENA_PAGO').replace('[ID]', vm.invoice.id);
                                    $mdDialog.show({
                                        controller: 'ReportShowPDFController',
                                        controllerAs: 'vm',
                                        templateUrl: 'app/main/apps/reports/dialogs/show-pdf/show-pdf.html',
                                        parent: angular.element("#main"),
                                        locals: {
                                            Url: urlRpt
                                        },
                                        clickOutsideToClose: false,
                                        fullscreen: true
                                    }).then(function (answer) {
                                        getInvoices();
                                    }, function () {
                                        getInvoices();
                                    });

                                }, 500);
                                $rootScope.loadingProgress = false;
                                vm.inputBarCodeDisabled = false;
                                $mdDialog.hide(true);
                            }, function (response) {
                                $rootScope.loadingProgress = false;
                                vm.inputBarCodeDisabled = false;
                                $log.error(response);

                                var err = 'ORDER.MSG.ERROR';
                                if (response.data && response.data.mensaje) {
                                    err = response.data.mensaje;
                                }

                                MessageService.showErrorMessage($filter('translate')(err));

                            });

                    }
                    else {
                        vm.inputBarCodeDisabled = false;
                    }

                }, 2000);
            }

        };

        vm.InvoiceWithholdingDetails = [];
        vm.InvoiceWithholdingsArr = [];
        vm.withholdingToInvoice = function (doc) {
            if (doc.docObj) {
                $rootScope.loadingProgress = true;
                vm.invoicePurchaseWithholding = {
                    totalWithholding: 0,
                    invoicePurchase: doc.docObj

                };

                vm.totalWithholding = 0;

                api.ComprasWS.InvoicePurchaseWithholdingDetail.Details.getByInvoice(
                  { id: 'byInvoicePurchaseWithholding', invoiceId: doc.docObj.id }, function (data) {
                    $rootScope.loadingProgress = false;
                    vm.InvoiceWithholdingDetails = data;

                    for (var i = 0; i < data.length; i++) {
                        vm.totalWithholding += data[i].valueWithholding;
                    }

                    $log.debug("vm.InvoiceWithholdingDetails: ");
                    $log.debug(vm.InvoiceWithholdingDetails);
                    if (vm.InvoiceWithholdingDetails.length > 0) {
                        vm.invoicePurchaseWithholding = vm.InvoiceWithholdingDetails[0].invoicePurchaseWithholding;
                        vm.InvoiceWithholdingDetails.forEach(function (inf) {
                            if (!addtoArrayInvoiceWithholding(inf)) {
                                inf.invoicePurchaseWithholding.withholding = inf.withholding;
                                vm.InvoiceWithholdingsArr.push(inf.invoicePurchaseWithholding);
                            }
                        });
                    }

                }, function (errResponse) {
                    $rootScope.loadingProgress = false;
                    $log.debug(errResponse);
                });
            }
        };

        function addtoArrayInvoiceWithholding(withholding) {
            for (var i = 0; i < vm.InvoiceWithholdingsArr.length; i++) {
                if (withholding.invoicePurchaseWithholding.id === vm.InvoiceWithholdingsArr[i].id) {
                    return true;
                }
            }
        }

        $timeout(function () {
            $("#inputBarCode").focus();
        }, 500);

    }
})();

(function () {

    'use strict';

    angular
        .module('app.files')
        .controller('FilesController', FilesController);

    function FilesController(MessageService, $scope) {

        var fl = this;
        var vm = $scope.vm;

        fl.fileType = $scope.$parent.fileType || '';
        var maxFileSizeDefault = 5;
        fl.maxFileSizeMB = vm['maxFileSizeMB' + fl.fileType] || maxFileSizeDefault;
        fl.dropTranslateKey = 'files.DROP' + fl.maxFileSizeMB;
        vm['filesToUpload' + fl.fileType] = [];
        vm['fileAddedOrRemoved' + fl.fileType] = false;
        fl.ngFlowOptions = {
            target: '/Compras'
        };
        fl.ngFlow = {
            flow: {}
        };
        fl.dropping = false;
        fl.imageZoomOptions = {};
        //Methods

        fl.fileAdded = fileAdded;
        fl.fileRemove = fileRemove;
        fl.upload = upload;
        fl.uploadFiles = uploadFiles;
        fl.fileSuccess = fileSuccess;
        fl.updateZoomOptions = updateZoomOptions;


        //////////

        init();

        /**
         * Initialize
         */
        function init() {
            if (vm['filesToUpload' + fl.fileType].length > 0) {
                fl.updateZoomOptions(vm['filesToUpload' + fl.fileType][0].url);
            }
        }


        /**
         * File added callback
         * Triggers when files added to the uploader
         *
         * @param file
         */
        function fileAdded(file) {
            // Prepare the temp file data for media list
            var uploadingFile = {
                id: file.uniqueIdentifier,
                file: file,
                type: 'uploading'
            };

            if (!file.name.match(/.(jpg|jpeg|png|gif)$/i)) {
                uploadingFile.image = getImageFile(file.name);
            }

            // Append it to the media list
            const bytesPerKilobytes = 1024;
            const maxBytes = fl.maxFileSizeMB * bytesPerKilobytes * bytesPerKilobytes;
            if (file.size <= maxBytes) {
                if (vm.isInvoice) {
                    if (file.name.match(/.(pdf|jpg|jpeg|png)$/i)) {
                        vm['filesToUpload' + fl.fileType].push(uploadingFile);
                    } else {
                        MessageService.showErrorMessage(file.name + ' tiene un formato inválido.');
                    }
                } else {
                    vm['filesToUpload' + fl.fileType].push(uploadingFile);
                    vm['fileAddedOrRemoved' + fl.fileType] = true;
                }
            } else {
                MessageService.showErrorMessage(file.name + ' tiene un tamaño mayor al máximo permitido (Max. ' + fl.maxFileSizeMB + 'MB)');
            }
        }

        function fileRemove(file) {
            fl.ngFlow.flow.files.splice(fl.ngFlow.flow.files.indexOf(file.file), 1);
            vm['filesToUpload' + fl.fileType].splice(vm['filesToUpload' + fl.fileType].indexOf(file), 1);
            vm['fileAddedOrRemoved' + fl.fileType] = true;
        }

        /**
         * Upload
         * Automatically triggers when files added to the uploader
         */
        function upload() {
            // Set headers
            fl.ngFlow.flow.opts.headers = {
                'X-Requested-With': 'XMLHttpRequest'
            };

            fl.ngFlow.flow.upload();
        }

        /**
         * File upload success callback
         * Triggers when single upload completed
         *
         * @param file
         * @param message
         */
        function fileSuccess(file, message) {
            // Iterate through the media list, find the one we
            // are added as a temp and replace its data
            // Normally you would parse the message and extract
            // the uploaded file data from it
            angular.forEach(vm['filesToUpload' + fl.fileType], function (media, index) {
                if (media.id === file.uniqueIdentifier) {
                    // Normally you would update the media item
                    // from database but we are cheating here!
                    var fileReader = new FileReader();
                    fileReader.readAsDataURL(media.file.file);
                    fileReader.onload = function (event) {
                        media.url = event.target.result;
                    };

                    // Update the image type so the overlay can go away
                    media.type = 'image';
                }
            });
        }

        /**
         * Update image zoom options
         *
         * @param url
         */
        function updateZoomOptions(url) {
            fl.imageZoomOptions = {
                images: [
                    {
                        thumb: url,
                        medium: url,
                        large: url
                    }
                ]
            };
        }

        function uploadFiles() {
            fl.loadingFiles = true;
            var files = [];
            vm['filesToUpload' + fl.fileType].forEach(function (r) {
                files.push(r.file.file);
            });
            var message = 'PRODUCT.MSG.SAVEIMAGE';
            MessageService.show(message);
            vm.uploadFiles(files);
        }

    }

})();

/* global getHeader */

(function () {
    'use strict';
    angular
        .module('app.invoice')
        .controller('PurchaseDocumentController', PurchaseDocumentController)
        .controller('InvoiceSettlementActionsController', InvoiceSettlementActionsController)
        .controller('InvoicePurchaseActionsController', InvoicePurchaseActionsController);

    /** @ngInject */
    function PurchaseDocumentController($mdDialog, api, $rootScope, $state, $stateParams, $log, $filter, $sce, $scope, MessageService, $timeout) {
        var vm = this;
        vm.URLPHOTOS = api.baseUrlPhotos;
        if (!($stateParams.docArray.length > 0)) {
            $state.go('app.dashboards_project');
        }
        vm.viewButton = false;

        // Data
        vm.baseUrlFiles = api.baseUrlFiles;
        vm.hiddenCC = true;
        vm.hiddenBCC = true;
        vm.filesData = {
          invoice: {
            titleKey: 'INVOICE.TAB_FILES.INVOICE',
            valRotate: 0,
            imageZoomOptions: {},
          },
          quotation: {
            titleKey: 'INVOICE.TAB_FILES.QUOTATION',
            valRotate: 0,
            imageZoomOptions: {},
          },
        };
        vm.currentFileTab;
        vm.details = [];
        vm.compareDocuments = compareDocuments;
        vm.currentTab = 0;
        vm.goToInvoicePurchaseDetailEdit = goToInvoicePurchaseDetailEdit;
        vm.calculateTaxes = calculateTaxes;
        vm.adjustDetailsValue = adjustDetailsValue;
        vm.setTaxIsNoDeductible = setTaxIsNoDeductible;
        vm.settlement;
        vm.isContract = false;
        //params
        vm.docArray = $stateParams.docArray;
        vm.backState = $stateParams.backState;
        vm.mainDoc = $stateParams.mainDoc;
        $log.debug("vm.mainDoc: ");
        $log.debug(vm.mainDoc);
        vm.canEdit = $stateParams.canEdit;
        vm.currentDoc = {};
        vm.currentIndex = 0;
        vm.vatReceived = 0;
        vm.myCompany = $rootScope.bsCircle.company;
        $log.debug("vm.myCompany: ");
        $log.debug(vm.myCompany);
        vm.viewIMG = viewIMG;
        vm.showButton = true;

        vm.NUMBER_DIMENSION_THREE = 3;
        vm.NUMBER_DIMENSION_FOUR = 4;
        vm.NUMBER_DIMENSION_FIVE = 5;

        vm.dimensionCompanyDetail3 = null;
        vm.dimensionCompanyDetail4 = null;
        vm.dimensionCompanyDetail5 = null;
        vm.fiscalNumberTitle = "NIT";

        vm.FIVEHUNDRED = 500;
        vm.holding = 6;

        vm.onGenerateCsvRetention = onGenerateCsvRetention;

        if (vm.mainDoc.typeCode === 'SETTLEMENT') {
            api.ComprasWS.Settlement.Settlement.get({ id: vm.mainDoc.number }).$promise.then(function (response) {
                vm.settlement = response;
                api.ComprasWS.pettyCashGeneralSets.getByPettyCashType(
                    {
                        id: 'byPettyCashType',
                        pettyCashTypeId: vm.settlement.pettyCash.pettyCashType.id, idCircle: $rootScope.bsCircle.id
                    }).$promise.then(function (response) {
                        if (response.id) {
                            vm.pettyCashGeneralSets = response;
                            if (vm.pettyCashGeneralSets && vm.pettyCashGeneralSets.askForBudget) {
                                validateHasBudgetApplication(vm.pettyCashGeneralSets.company.id);
                            }
                        }
                    }, function (error) {
                        $log.error(error.data);
                    });
            }, function (error) {
                $log.debug(error);
            });
        }

        vm.dateFormatString = function (dt) {
            if (dt) {
                if (Object.prototype.toString.call(dt) === "[object Date]") {
                    return $filter('date')(dt, 'dd-MM-yyyy');
                } else {
                    var ff = dt.split("-");
                    var theDate = new Date(ff[0], (parseInt(ff[1]) - 1), ff[2]);
                    return $filter('date')(theDate, 'dd-MM-yyyy');
                }
            } else {
                return ff;
            }
        };

        vm.dateFormatStringWithDiag = function (dt) {
            if (dt) {
                if (Object.prototype.toString.call(dt) === "[object Date]") {
                    return $filter('date')(dt, 'dd/MM/yyyy');
                } else {
                    var ff = dt.split("-");
                    var theDate = new Date(ff[0], (parseInt(ff[1]) - 1), ff[2]);
                    return $filter('date')(theDate, 'dd/MM/yyyy');
                }
            } else {
                return ff;
            }
        };

        vm.getFullUrlPhoto = function (url, ph) {
            if (ph) {
                url = ph.parentPath + ph.name;
            }
            if (url) {
                return vm.URLPHOTOS + url;
            }
            return 'assets/images/etc/thumbPhoto';
        };

        vm.updateImageZoomOptions = function(img, fileData) {
            var url = img.url;
            var extension = img.extension;
            fileData.imageZoomOptions = {
                zoomLevel: 2,
                images: [
                    {
                        thumb: url + extension,
                        medium: url + extension,
                        large: url + extension
                    }
                ]
            };
        };

        function getPhotosToZoom(fileData, files) {
            fileData.images = [];
            fileData.otherFormats = [];
            fileData.fileOtherFormat = false;
            files.forEach(
                function (r) {
                    var ft = {
                        url: vm.getFullUrlPhoto(null, r),
                        type: 'image',
                        original: r,
                        extension: r.extension
                    };
                    if (ft.url + 's.jpg' === vm.photoUp) {
                        ft.default = true;
                    }
                    if (ft.extension === '.pdf') {
                        fileData.otherFormats.push(ft);
                    } else {
                        fileData.images.push(ft);
                    }
                }
            );
            if (fileData.images.length > 0) {
                vm.updateImageZoomOptions(fileData.images[0], fileData);
            } else {
                if (fileData.otherFormats.length > 0) {
                    fileData.fileOtherFormat = fileData.otherFormats[0];
                    fileData.fileUrl = $sce.trustAsResourceUrl(
                      fileData.fileOtherFormat.url + fileData.fileOtherFormat.extension + '#zoom=200&nameddest=Invoice&pagemode=bookmarks');
                } else {
                    const image = {
                        url: vm.getFullUrlPhoto(),
                        type: 'image',
                        extension: '.jpg'
                    };
                    vm.updateImageZoomOptions(image, fileData);
                }
            }
            $rootScope.loadingProgress = false;
        }

        vm.getPhotos = function (doc) {
            if (doc.docObj) {
                if (doc.docType === 'invoice') {
                    $rootScope.loadingProgress = true;
                    api.ComprasWS.Invoices.relatedFiles.get({ id: doc.docObj.id }, function (response) {
                        $log.debug("response photos:");
                        $log.debug(response);
                        $rootScope.loadingProgress = false;
                        doc.docObj.files = response.files;
                        doc.docObj.quotationFile = response.quotationFile;
                        getPhotosToZoom(vm.filesData.invoice, doc.docObj.files);
                        validateShowQuotationFile(response.quotationFile);
                    }, function (response) {// Error
                        $log.error(response);
                        $rootScope.loadingProgress = false;
                    });
                }
                if (doc.docType === 'receipt') {
                    $rootScope.loadingProgress = true;
                    api.ComprasWS.PaymentReceiptFiles.get({ id: doc.docObj.id }, function (response) {// Success
                        $rootScope.loadingProgress = false;
                        doc.docObj.files = response;
                        getPhotosToZoom(vm.filesData.invoice, doc.docObj.files);
                    }, function (response) {// Error
                        $log.error(response);
                        vm.loading = false;
                        $rootScope.loadingProgress = false;
                    });
                }
            }
        };

        function validateShowQuotationFile(quotationFile) {
          if (!quotationFile) {
            return;
          }

          api.GeneralWS.ApplicationParameterCountryValue.byParameterNameAndCountry
          .get({ 'parameterName': 'SHOW_QUOTATION_FILE_INVOICE_PROCESS', 'countryId': vm.myCompany.country.id }, function (response) {
            if (response && response.parameterValue && angular.lowercase(response.parameterValue.toString()) === 'true') {
              getPhotosToZoom(vm.filesData.quotation, [quotationFile]);
              vm.currentFileTab = 0;
              vm.showQuotationFile = true;
            }
          }, function (err) { });
        }

        vm.getDetailByInvoice = function (doc) {
            if (doc.docObj && doc.docType === 'invoice') {
                vm.loading = true;
                $rootScope.loadingProgress = true;
                api.ComprasWS.InvoicePurchaseDetail.byInvoice(
                    { id: 'byInvoicePurchase', invoiceId: doc.docObj.id, idCircle: $rootScope.bsCircle.id }, function (response) {

                        doc.docObj.details = new jinqJs()
                            .from(response)
                            .orderBy([{ field: 'id', sort: 'asc' }])
                            .select();

                        $timeout(function () {
                          getColumnDimensionCompany(vm.NUMBER_DIMENSION_THREE);
                          getColumnDimensionCompany(vm.NUMBER_DIMENSION_FOUR);
                          getColumnDimensionCompany(vm.NUMBER_DIMENSION_FIVE);
                          vm.masterGridOptionsE.api.setColumnDefs(vm.masterColumnDefs);
                          vm.masterGridOptionsE.api.setRowData(doc.docObj.details);
                          vm.loading = false;
                        }, vm.FIVEHUNDRED);
                        verifyParameterIsContractBudget();

                        $rootScope.loadingProgress = false;
                    }, function (response) {// Error
                        $log.error(response);
                        vm.loading = false;
                        $rootScope.loadingProgress = false;
                    });
            }
        };
        function onStartEdit(data, colKey) {
            var index = 0;
            switch (colKey) {
                case 1:
                    colKey = 'subTotalBeforeTax';
                    break;
                case 3:
                    colKey = 'productCodeErp1';
                    break;
                default:
                    colKey = 'taxes';
            }


            vm.masterGridOptionsE.api.forEachNode(function (node) {
                if (node.data.id === data.id) {
                    var startEditingParams = {
                        rowIndex: index,
                        colKey: colKey
                    };
                    vm.masterGridOptionsE.api.startEditingCell(startEditingParams);
                }
                index += 1;
            });
        }

        vm.onStartEdit = onStartEdit;

        function getTotalAmount() {
            let vatReceived = 0;
            if (vm.currentDoc.docObj.vatReceived > 0) {
                vatReceived = vm.currentDoc.docObj.vatReceived;
            }
            return vm.currentDoc.docObj.documentTotalAfterTax - vm.totalWithholding + vatReceived;
        }

        vm.getTotalAmount = getTotalAmount;

        //detalle de factura
        vm.masterColumnDefs = [
            {
                headerName: 'INVOICE.INVOICE_PURCHASE.DETAIL.ERP_CODE1',
                field: "productCodeErp1",
                headerCellRenderer: getHeader,
                width: 100,
                enableRowGroup: true,
                enablePivot: true,
                editable: true,
                cellRenderer: function (params) {
                    if (vm.canEdit) {
                        return "<div layout='row' layout-align='center center'> "
                            + " <span>{{data.productCodeErp1}}</span> "
                            + " <span flex>"
                            + " <md-button ng-click='vm.onStartEdit(data, 3)' class='md-icon-button'><md-icon md-font-icon='icon-pencil' class='s16'>"
                            + " </md-icon></md-button>"
                            + " </div>";
                    }

                    return "    <div layout='row' layout-align='center center' style='padding-top:12px;'> "
                        + " <span>{{data.productCodeErp1}}</span> "
                        + " </div>";
                }
            },
            {
                headerName: 'INVOICE.PRODUCT.PRODUCT',
                field: "product.name",
                headerCellRenderer: getHeader,
                width: 300,
                enableRowGroup: true,
                enablePivot: true,
                cellStyle: { 'padding-top': '12px' }
            },
            {
                headerName: 'INVOICE.DEPARTMENT',
                field: "merchandiseEntry.purchaseOrderDetail.purchaseOrder.department.description",
                headerCellRenderer: getHeader,
                width: 200,
                hide: true,
                enableRowGroup: true,
                enablePivot: true,
                cellStyle: { 'padding-top': '12px' }
            },
            {
                headerName: 'INVOICE.COST_CENTER',
                field: "merchandiseEntry.purchaseOrderDetail.purchaseOrder.costCenter.description",
                headerCellRenderer: getHeader,
                width: 200,
                hide: true,
                enableRowGroup: true,
                enablePivot: true,
                cellStyle: { 'padding-top': '12px' }
            },
            {
                headerName: 'INVOICE.INVOICE_PURCHASE.DETAIL.QUANTITY',
                field: "quantity",
                headerCellRenderer: getHeader,
                width: 100,
                enableRowGroup: true,
                enablePivot: true,
                cellStyle: { 'text-align': 'center', 'padding-top': '12px' }
            },
            {
                headerName: 'INVOICE.INVOICE_PURCHASE.DETAIL.UNIT_PRICE_AFTER_TAX',
                field: "priceAfterTaxCurrency",
                headerCellRenderer: getHeader,
                width: 150,
                suppressSorting: true,
                suppressMenu: true,
                cellStyle: { 'text-align': 'right', 'padding-top': '12px' }
            },
            {
                headerName: 'INVOICE.INVOICE_PURCHASE.DETAIL.TOTAL_BEFORE_TAX', //SUBTOTAL SI NIMPUESTO
                field: "subTotalBeforeTax",
                headerCellRenderer: getHeader,
                width: 100,
                enableRowGroup: false,
                enablePivot: false,
                cellStyle: { 'text-align': 'right', 'padding-top': '12px' },
                cellRenderer: function (params) {
                    if (params.data && params.data.invoicePurchase.companyCurrency && params.data.subTotalAfterTax) {
                        return params.data.invoicePurchase.companyCurrency.symbol + ". " + $filter('number')(params.data.subTotalBeforeTax, 2);
                    } else {
                        return params.value;
                    }
                }
            },
            {
                headerName: 'INVOICE.INVOICE_PURCHASE.TAXES',
                field: "taxes",
                headerCellRenderer: getHeader,
                width: 100,
                enableRowGroup: false,
                enablePivot: false,
                cellStyle: { 'text-align': 'right', 'padding-top': '12px' },
                cellRenderer: function (params) {
                    if (params.data && params.data.invoicePurchase.companyCurrency && params.data.taxes) {
                        return params.data.invoicePurchase.companyCurrency.symbol + ". " + $filter('number')(params.data.taxes, 2);
                    } else {
                        return params.value;
                    }
                }
            },
            {
                headerName: 'INVOICE.INVOICE_PURCHASE.DETAIL.TOTAL_AFTER_TAX', //SUBTOTAL
                field: "subTotalAfterTax",
                headerCellRenderer: getHeader,
                width: 100,
                enableRowGroup: false,
                enablePivot: false,
                cellStyle: { 'text-align': 'right', 'padding-top': '12px' },
                cellRenderer: function (params) {
                    if (params.data && params.data.invoicePurchase.companyCurrency && params.data.subTotalAfterTax) {
                        return params.data.invoicePurchase.companyCurrency.symbol + ". " + $filter('number')(params.data.subTotalAfterTax, 2);
                    } else {
                        return params.value;
                    }
                }
            },
            {
                suppressMenu: true,
                suppressSorting: true,
                headerName: $filter('translate')('INVOICE.INVOICE_PURCHASE.DETAIL.EXENTO'),
                field: "isExento",
                width: 150,
                headerCellRenderer: function (params) {
                    params.$scope.node = params.node;
                    if (vm.canEdit) {
                        return "<div layout='row' layout-align='center center'>Exento</div> "
                            + " <div layout='row' layout-align='center center'>"
                            + " <md-switch aria-label='allExento' ng-change='vm.calculateTaxes(true)' ng-model='vm.allExento'></md-switch></div>";
                    } else {
                        return "<div layout='row' layout-align='center center'>Exento</div>";
                    }
                },
                cellRenderer: function (params) {
                    params.$scope.node = params.node;
                    return getMdChip("isExento", !vm.canEdit, "vm.calculateTaxes(false, data, node)", "data.isExento");
                }
            },
            {
                suppressMenu: true,
                suppressSorting: true,
                headerName: $filter('translate')('INVOICE.INVOICE_PURCHASE.TAX.NO_DEDUCTIBLE'),
                field: "taxIsNoDeductible",
                width: 150,
                headerCellRenderer: function (params) {
                    params.$scope.node = params.node;
                    if (vm.canEdit) {
                        return "<div layout='row' layout-align='center center'>Impuesto no deducible</div>"
                            + " <div layout='row' layout-align='center center'>"
                            + " <md-switch aria-label='taxIsNoDeductible' ng-change='vm.setTaxIsNoDeductible(true)' ng-model='vm.allTaxIsNoDeductible'>"
                            + "</md-switch></div>";
                    } else {
                        return "<div layout='row' layout-align='center center'>Impuesto NO deducible</div>";
                    }
                },
                cellRenderer: function (params) {
                    params.$scope.node = params.node;
                    return getMdChip("taxIsNoDeductible", !vm.canEdit, "vm.setTaxIsNoDeductible(false, data, node)", "data.taxIsNoDeductible");
                }
            },
            {
                headerName: 'INVOICE.INVOICE_PURCHASE.OPTIONS',
                headerCellRenderer: getHeader,
                suppressSorting: true,
                suppressMenu: true,
                width: 100,
                cellRenderer: renderer,
                cellStyle: { 'padding': '0px' },
                pinned: "right"
            }

        ];
        function getMdChip(ariaLabel, ngDisabled, ngChange, ngModel) {

            var mdChip = "<div layout='row' layout-align='center center'>"
                + "<md-switch aria-label='[ARIA-LABEL]' ng-disabled='[NG-DISABLED]' ng-change='[NG-CHANGE]' ng-model='[NG-MODEL]'></md-switch></div>";
            return mdChip
                .replace("[ARIA-LABEL]", ariaLabel)
                .replace("[NG-DISABLED]", ngDisabled)
                .replace("[NG-CHANGE]", ngChange)
                .replace("[NG-MODEL]", ngModel);
        }


        function calculateTaxes(all, data) {

            $rootScope.loadingProgress = true;
            var ids = '';
            var isExento;
            if (all) {
                var tempoList = [];
                for (var i = 0; i < vm.currentDoc.docObj.details.length; i++) {
                    tempoList.push(vm.currentDoc.docObj.details[i].id);
                }
                ids = tempoList.join(",");
                isExento = vm.allExento;
            } else {
                ids = data.id;
                isExento = data.isExento;
            }

            if (vm.mainDoc.typeCode === "PURCHASE") {
                api.ComprasWS.InvoicePurchaseDetail2.calculateTaxes.update(
                    {
                        idCircle: $rootScope.bsCircle.id, invoicePurchaseId: vm.currentDoc.docObj.id,
                        ids: ids, isExento: isExento
                    }).$promise.then(function (response) {
                        refreshInvoice(response, true);
                        $rootScope.loadingProgress = false;
                        MessageService.show($filter('translate')('INVOICE.MSG.TAXES_CALCULATE_SUCESSFULLY'));
                    }, function (errResponse) {
                        $rootScope.loadingProgress = false;
                        MessageService.showErrorMessage($filter('translate')(errResponse.data));
                    });
            }
            if (vm.mainDoc.typeCode === "SETTLEMENT") {
                api.ComprasWS.InvoicePurchaseDetail.update({ id: data.id, idCircle: $rootScope.bsCircle.id }, data).$promise.then(function (response) {
                    $rootScope.loadingProgress = false;
                    vm.getDetailByInvoice(vm.currentDoc);
                    MessageService.show($filter('translate')('SETTLEMENT.INVOICE.DETAIL.DETAIL_UPDATED'));
                }, function (error) {
                    $rootScope.loadingProgress = false;
                    $log.error(error);
                    MessageService.showErrorMessage(error.data.message);
                });
            }
        }


        function setTaxIsNoDeductible(all, data) {

            $rootScope.loadingProgress = true;
            var theId;
            var noDeductible;
            if (all) {
                theId = 0;
                noDeductible = vm.allTaxIsNoDeductible;
            } else {
                theId = data.id;
                noDeductible = data.taxIsNoDeductible;
            }

            if (vm.mainDoc.typeCode === "PURCHASE") {
                api.ComprasWS.InvoicePurchaseDetail2.taxNoDeductible.update(
                    {
                        idCircle: $rootScope.bsCircle.id,
                        invoicePurchaseId: vm.currentDoc.docObj.id, id: theId, all: all, noDeductible: noDeductible, erpCode: ''
                    }).$promise.then(function (response) {
                        refreshInvoice(response, true);
                        $rootScope.loadingProgress = false;
                        MessageService.show($filter('translate')('INVOICE.MSG.DETAILS_UPDATED'));
                    }, function (errResponse) {
                        $rootScope.loadingProgress = false;
                        MessageService.showErrorMessage($filter('translate')(errResponse.data));
                    });
            }
        }




        vm.refreshInvoice = refreshInvoice;
        function refreshInvoice(response, isFromDTO) {
            if (isFromDTO) {
                response = convertInvoicePurchaseDTOtoEntityStructure(response);
            }
            var list = [];
            for (var i = 0; i < response.details.length; i++) {
                list.push(response.details[i].invoicePurchaseDetail);
            }

            vm.masterGridOptionsE.api.setRowData(list);
            vm.currentDoc.docObj = response.invoicePurchase;
            vm.currentDoc.docObj.details = list;
            vm.withholdingToInvoice(vm.currentDoc);
            vm.vatReceivedFromInvoice(vm.currentDoc);
            getSeriesType();
        }

        function adjustDetailsValue(data) {

            $rootScope.loadingProgress = true;
            api.ComprasWS.InvoicePurchaseDetail2.adjust.update(
                {
                    idCircle: $rootScope.bsCircle.id, id: data.id,
                    totalBeforeTax: data.subTotalBeforeTax, totalTax: data.taxes
                }).$promise.then(function (response) {

                    refreshInvoice(response, true);
                    $rootScope.loadingProgress = false;
                    MessageService.show($filter('translate')('INVOICE.MSG.DETAILS_UPDATED'));
                }, function (errResponse) {
                    $rootScope.loadingProgress = false;
                    MessageService.showErrorMessage($filter('translate')(errResponse.data));
                });
        }

        function onChangeErpCode(data) {
            $rootScope.loadingProgress = true;
            api.ComprasWS.InvoicePurchaseDetail2.changeErpCode.update(
                {
                    idCircle: $rootScope.bsCircle.id, id: data.id,
                    erpCode: data.productCodeErp1
                }).$promise.then(function (response) {

                    refreshInvoice(response, true);
                    $rootScope.loadingProgress = false;
                    MessageService.show($filter('translate')('INVOICE.MSG.DETAILS_UPDATED'));
                }, function (errResponse) {
                    $rootScope.loadingProgress = false;
                    MessageService.showErrorMessage($filter('translate')(errResponse.data));
                });
        }

        vm.masterGridOptionsE = {
            columnDefs: vm.masterColumnDefs,
            suppressClickEdit: true,
            enableSorting: true,
            debug: false,
            enableFilter: true,
            enableColResize: true,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowData: null,
            groupHeaders: true,
            headerHeight: 50,
            rowHeight: 45,
            doesDataFlower: function (dataItem) {
                $log.debug("dataItem:");
                $log.debug(dataItem);
                var totalNull = 0;
                dataItem.priceAfterTaxCurrency = (dataItem.priceAfterTax ? dataItem.priceAfterTax.toFixed(2) : totalNull.toFixed(2));
                dataItem.subTotalAfterTaxCurrency = (dataItem.subTotalAfterTax ? dataItem.subTotalAfterTax.toFixed(2) : totalNull.toFixed(2));
                dataItem.priceAfterTaxCurrency = dataItem.invoicePurchase.currency.symbol + ". " + $filter('number')(dataItem.priceAfterTaxCurrency, 2);
                dataItem.subTotalAfterTaxCurrency = dataItem.invoicePurchase.currency.symbol + ". " + $filter('number')(dataItem.subTotalAfterTaxCurrency, 2);
                dataItem.taxes = (dataItem.subTotalAfterTax - dataItem.subTotalBeforeTax).toFixed(6);
                return true;
            },
            isExternalFilterPresent: isExternalFilterPresent,
            doesExternalFilterPass: doesExternalFilterPass,
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            },
            onCellValueChanged: function (event) {
                if (event.oldValue !== event.newValue) {

                    var canUpdate = false;
                    if (event.column.colId === "productCodeErp1") {

                        if (event.newValue !== '') {
                            onChangeErpCode(event.data);
                        } else {
                            event.data.productCodeErp1 = event.oldValue;
                        }

                    } else {
                        if (!isNaN(parseFloat(event.data.taxes))) {
                            canUpdate = true;
                        }

                        if (canUpdate) {
                            adjustDetailsValue(event.data);
                        } else {
                            event.data.taxes = event.oldValue;
                        }
                    }

                }
            }
        };
        var filter = 'everyone';
        function isExternalFilterPresent() {
            // if ageType is not everyone, then we are filtering
            return filter !== '';
        }

        function doesExternalFilterPass(node) {
            if (filter && filter !== 'everyone') {
                var arrdt = node.data.filter.split(filter);
                return arrdt.length > 1;
            }
            return true;
        }

        $scope.$watch('vm.search',
            function (newValue) {
                filter = newValue;
                if (vm.masterGridOptionsE.api) {
                    vm.masterGridOptionsE.api.onFilterChanged();
                }
            }
        );
        function renderer(params) {
            return '<div style="width: 100%;">'
                + ' <md-button class="edit-button md-icon-button" ng-click="vm.goToInvoicePurchaseDetailEdit(data)" aria-label="Order details"'
                + ' translate translate-attr-aria-label="REQUISITION.ORDER_DETAILS">'
                + ' <md-tooltip md-direction="bottom">'
                + ' {{"REQUISITION.DETAIL.VIEW"| translate}}'
                + ' </md-tooltip>'
                + ' <md-icon md-font-icon="icon-eye" class="s16"></md-icon> '
                + ' </md-button>'
                + ' </div>';
        }

        function goToInvoicePurchaseDetailEdit(data) {
            $mdDialog.show({
                controller: 'DetailEditorController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/invoice/saleInvoice/detailEditor/detailEditor.html',
                parent: angular.element("#main"),
                InvoicePurchase: vm.invoicePurchase,
                serie: vm.currentDoc.docObj.invoiceSerie,
                edited: data,
                id: data.id,
                Taxes: vm.taxes,
                canEdit: vm.canEdit,
                clickOutsideToClose: false
            }).then(function (answer) {

                if (answer) {
                    refreshInvoice(answer, true);
                }
            });
        }

        //retenciones
        vm.masterColumnDefsRet = [
            {
                headerName: 'INVOICE.WITHHOLDING_DETAIL.RATE',
                field: "ratepercent",
                headerCellRenderer: getHeader,
                width: 250
            },
            {
                headerName: 'INVOICE.INVOICE_PURCHASE.CODE_WITHHOLDING',
                field: "invoicePurchaseWithholding.codeWithholding",
                headerCellRenderer: getHeader,
                width: 250
            },
            {
                headerName: $filter('translate')('INVOICE.WITHHOLDING_DETAIL.VALUE_RATE'),
                field: "valueWithholding",
                headerCellRenderer: getHeader,
                width: 200,
                enableRowGroup: true,
                enablePivot: true,
                cellStyle: { 'text-align': 'right' },
                valueFormatter: function (params) {
                    return $filter('number')(params.value, 2);
                },
                aggFunc: 'sum'
            },
            {
                headerName: 'CSV',
                headerCellRenderer: getHeader,
                suppressSorting: true,
                suppressMenu: true,
                width: 80,
                cellRenderer: function (params) {
                    return '<div ng-if="vm.currentDoc.docObj.companyBuyer.country.name === \'Guatemala\'" style="width: 100%;text-align:center;"> '
                        + ' <button ng-click=vm.onGenerateCsvRetention(data)>'
                        + ' <md-tooltip md-direction="bottom">'
                        + ' CSV'
                        + '             </md-tooltip>'
                        + ' <md-icon md-font-icon="icon-arrow-down-bold-hexagon-outline"></md-icon> '
                        + ' </button>'
                        + ' </div>';
                },
                cellStyle: { 'padding': '0px' }
            }
        ];

        //IVA Percibido
        vm.masterColumnDefsVatReceived = [
            {
                headerName: 'INVOICE.CODE',
                field: 'code',
                headerCellRenderer: getHeader,
                width: 200,
            },
            {
                headerName: 'INVOICE.DESCRIPTION',
                field: 'description',
                width: 200,
                headerCellRenderer: getHeader,
            },
            {
                headerName: 'INVOICE.PERCENTAGE',
                field: 'percentage',
                width: 200,
                headerCellRenderer: getHeader,
            },
            {
                headerName: 'INVOICE.VALUE',
                field: 'value',
                width: 200,
                cellStyle: { 'text-align': 'right' },
                valueFormatter: function (params) {
                    return $filter('number')(params.value, 2);
                },
                headerCellRenderer: getHeader,
            },
        ];

        if (vm.canEdit) {
            vm.masterColumnDefsVatReceived.push({
                headerName: 'general.delete',
                headerCellRenderer: getHeader,
                suppressSorting: true,
                suppressMenu: true,
                width: 80,
                cellRenderer: function (params) {
                    return '<div style="width: 100%;"> '
                        + ' <md-button class="edit-button md-icon-button"'
                        + ' ng-click="vm.deleteWithVatReceived(data)" aria - label="delete"'
                        + ' translate translate-attr-aria-label="delete">'
                        + ' <md-tooltip md-direction="bottom">'
                        + ' {{"general.delete"| translate}}'
                        + ' </md-tooltip>'
                        + '   <md-icon md-font-icon="icon-delete" class="md-warn"></md-icon> '
                        + ' </md-button>'
                        + ' </div>';
                },
                cellStyle: { 'padding': '0px' }
            });
            vm.masterColumnDefsRet.push({
                headerName: 'general.delete',
                headerCellRenderer: getHeader,
                suppressSorting: true,
                suppressMenu: true,
                width: 80,
                cellRenderer: function (params) {
                    return '<div style="width: 100%;"> '
                        + ' <md-button ng-if="data.withholding.canAddManually" class="edit-button md-icon-button"'
                        + ' ng-click="vm.deleteWithholding(data)" aria - label="delete"'
                        + ' translate translate-attr-aria-label="delete">'
                        + ' <md-tooltip md-direction="bottom">'
                        + ' {{"general.delete"| translate}}'
                        + ' </md-tooltip>'
                        + '   <md-icon md-font-icon="icon-delete" class="md-warn"></md-icon> '
                        + ' </md-button>'
                        + ' </div>';
                },
                cellStyle: { 'padding': '0px' }
            });
        }

        vm.getFileNameCsv = getFileNameCsv;

        function getFileNameCsv(data) {

            var d = new Date();
            var datestring = d.getFullYear() + "" + (d.getMonth() + 1) + "" + d.getDate() + "" + d.getHours() + "" + d.getMinutes() + "" + d.getSeconds();

            return data.withholding.withholdingCode + '-' + datestring + '-'
                + (vm.currentDoc.docObj.invoiceSerie ?
                    vm.currentDoc.docObj.invoiceSerie.serie :
                    vm.currentDoc.docObj.uuid.substring(0, 8))
                + '-' + vm.currentDoc.docObj.correlative + '.csv';
        }

        vm.deleteWithholding = deleteWithholding;
        function deleteWithholding(data) {

            var confirm = $mdDialog.confirm()
                .title($filter('translate')('INVOICE.MSG.WHITHOLDING_CONFIRM_DELETE'))
                .textContent($filter('translate')('INVOICE.MSG.WHITHOLDING_CONFIRM_DELETE'))
                .ok($filter('translate')('general.si'))
                .cancel($filter('translate')('general.no'));
            $mdDialog.show(confirm).then(function () {
                $rootScope.loadingProgress = true;
                api.ComprasWS.InvoicePurchaseWithholdingDetail.Details.delete({ idCircle: $rootScope.bsCircle.id, id: data.id }).$promise.then(function (response) {
                    const rowIndex = vm.InvoiceWithholdingsArr.findIndex(function(row) {
                        return row.id === data.invoicePurchaseWithholding.id;
                    });
                    vm.InvoiceWithholdingsArr.splice(rowIndex, 1);

                    refreshInvoice(response, true);
                    $rootScope.loadingProgress = false;
                    MessageService.show($filter('translate')('INVOICE.MSG.DETAILS_UPDATED'));
                }, function (errResponse) {
                    $rootScope.loadingProgress = false;
                    MessageService.showErrorMessage($filter('translate')(errResponse.data));
                });
            }, function () {
            });
        }

        vm.deleteWithVatReceived = deleteWithVatReceived;
        function deleteWithVatReceived(data) {

            var confirm = $mdDialog.confirm()
                .title($filter('translate')('INVOICE.MSG.VATRECEIVED_DELETE'))
                .textContent($filter('translate')('INVOICE.MSG.VATRECEIVED_CONFIRM_DELETE'))
                .ok($filter('translate')('general.si'))
                .cancel($filter('translate')('general.no'));
            $mdDialog.show(confirm).then(function () {
                $rootScope.loadingProgress = true;
                api.ComprasWS.InvoicePurchaseVatReceived.delete({ id: vm.currentDoc.docObj.id }).$promise.then(function (response) {
                    vm.currentDoc.docObj.vatReceived = 0;
                    vm.vatReceived = 0;
                    vm.currentTab = 0;
                    $rootScope.loadingProgress = false;
                    vm.masterGridOptionsVatReceived.api.setRowData([]);
                    MessageService.show($filter('translate')('INVOICE.MSG.DETAILS_UPDATED'));
                }, function (errResponse) {
                    $rootScope.loadingProgress = false;
                    MessageService.showErrorMessage($filter('translate')(errResponse.data));
                });
            }, function () {
            });
        }

        function onDownloadCSV(data, csvString) {
            var a = $('<a/>', {
                style: 'display:none',
                href: 'data:application/octet-stream;base64,' + btoa(csvString),
                download: getFileNameCsv(data)
            }).appendTo('body')
            a[0].click()
            a.remove();
        }

        function onGenerateCsvRetention(data) {

            vm.finalData = [];
            var csvString = "";

            if (data.withholding.withholdingCode === 'IVA') {

                var montoAfectado = 0;
                var montoRetencion = 0;
                var retencion = 0;
                var pequeMonto = 0;
                var retencionPeque = 0;
                var pequeMontoAfectado = 0;

                if (vm.currentDoc.docObj.regime.name === 'Pequeño Contribuyente') {
                    pequeMonto = vm.currentDoc.docObj.documentTotalAfterTax;
                    pequeMontoAfectado = vm.currentDoc.docObj.documentTotalAfterTax;
                    retencionPeque = data.valueWithholding;
                }
                else {
                    montoAfectado = vm.currentDoc.docObj.documentTotalAfterTax;
                    retencion = data.valueWithholding;
                    montoRetencion = vm.currentDoc.docObj.documentTotalAfterTax - vm.currentDoc.docObj.documentTotalBeforeTax;
                }

                csvString += vm.companyDoc.number.replace("-", "") + ",";
                csvString += vm.dateFormatStringWithDiag(vm.currentDoc.docObj.dateInvoicePurchase) + ",";
                csvString += (vm.currentDoc.docObj.invoiceSerie ? vm.currentDoc.docObj.invoiceSerie.serie : vm.currentDoc.docObj.uuid.substring(0, 8)) + ",";
                csvString += vm.currentDoc.docObj.correlative + ",";
                csvString += montoAfectado + ",";
                csvString += montoRetencion + ",";
                csvString += retencion + ",";  //Retencion Factura
                csvString += vm.dateFormatStringWithDiag(vm.currentDoc.docObj.dateInvoicePurchase) + ",";
                csvString += 1 + ","; //valor fijo
                csvString += pequeMonto + ","; //Total con Impuestos - pequeño contribuyente
                csvString += pequeMontoAfectado + ","; //Monto que va ser afectado por la Retencion - pequeño contribuyente
                csvString += retencionPeque //Retención Peque - pequeño contribuyente

                onDownloadCSV(data, csvString);

            }
            else {

                var codeConcepto = '11';

                var confirm = $mdDialog.prompt()
                    .title('Ingrese el código del concepto')
                    .textContent('')
                    .placeholder('Codigo')
                    .ariaLabel('Codigo')
                    .ok($filter('translate')('general.accept'))
                    .cancel($filter('translate')('general.cancel'));

                $mdDialog.show(confirm).then(function (result) {

                    codeConcepto = result;

                    csvString += 'NIT Proveedor,Renta,Concepto,Serie Documento,Numero de Documento,Fecha Documento,Valor Facturado' + '\n';

                    csvString += vm.companyDoc.number.replace("-", "") + ",1,";
                    csvString += codeConcepto + ",";
					csvString += (vm.currentDoc.docObj.invoiceSerie ? vm.currentDoc.docObj.invoiceSerie.serie : vm.currentDoc.docObj.uuid.substring(0, 8)) + ",";
					csvString += vm.currentDoc.docObj.correlative + ",";
					csvString += vm.dateFormatStringWithDiag(vm.currentDoc.docObj.dateInvoicePurchase) + ",";
                    csvString += vm.currentDoc.docObj.documentTotalAfterTax;

                    onDownloadCSV(data, csvString);

                });
            }
        }

        vm.masterGridOptionsRet = {
            columnDefs: vm.masterColumnDefsRet,
            enableSorting: true,
            debug: false,
            enableFilter: true,
            enableColResize: true,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowData: null,
            headerHeight: 50,
            rowHeight: 45,
            autoGroupColumnDef: {
                headerName: 'INVOICE.WITHHOLDING_DETAIL.RATE',
                field: "ratepercent",
                width: 235,
                hide: true,
                headerCellRenderer: getHeader,
                cellRenderer: 'group'
            },
            doesDataFlower: function (dataItem) {
                var ref = '';
                if (dataItem.invoicePurchaseWithholding.fileWithholding) {
                    ref = ref + '<a ng-click="vm.viewIMG(data.invoicePurchaseWithholding.fileWithholding)">Ver Imagen ' + '</a> ';
                }
                dataItem.ratepercent = dataItem.withholding.withholdingCode + " " + dataItem.rate + '% ' + ref;
                return false;
            },
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            groupRowInnerRenderer: function (params) {
                return params.value;
            }
        };

        vm.masterGridOptionsVatReceived = {
            columnDefs: vm.masterColumnDefsVatReceived,
            enableSorting: true,
            debug: false,
            enableFilter: true,
            enableColResize: true,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowData: null,
            headerHeight: 50,
            rowHeight: 45,
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
        };

        function viewIMG(file) {
            $mdDialog.show({
                controller: 'DialogPhotoController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/files/dialogPhoto/dialogPhoto.html',
                parent: angular.element("#main"),
                name: file.originalName,
                url: vm.URLPHOTOS + file.parentPath + file.name + file.extension,
                clickOutsideToClose: false
            }).then(function (answer) {

            });
        }

        vm.InvoiceWithholdingDetails = [];
        vm.InvoiceWithholdingsArr = [];
        vm.withholdingToInvoice = function (doc) {
          if (doc.docObj) {
                $rootScope.loadingProgress = true;
                vm.invoicePurchaseWithholding = {
                    totalWithholding: 0,
                    invoicePurchase: doc.docObj

                };

                vm.totalWithholding = 0;
                if (doc.docType === 'invoice') {
                  getInvoicePurchaseWithholdingDetail(doc.docObj.id);
            }
          }
        };

        function getInvoicePurchaseWithholdingDetail(idInvoice) {
          api.ComprasWS.InvoicePurchaseWithholdingDetail.Details.getByInvoice({ id: 'byInvoicePurchaseWithholding', invoiceId: idInvoice }, function (data) {
            $rootScope.loadingProgress = false;
            vm.InvoiceWithholdingDetails = data;

            for (var i = 0; i < data.length; i++) {
              vm.totalWithholding += data[i].valueWithholding;
            }

            $log.debug("vm.InvoiceWithholdingDetails: ");
            $log.debug(vm.InvoiceWithholdingDetails);
            if (vm.InvoiceWithholdingDetails.length > 0) {
              vm.invoicePurchaseWithholding = vm.InvoiceWithholdingDetails[0].invoicePurchaseWithholding;
              vm.InvoiceWithholdingDetails.forEach(function (inf) {
                if (!addtoArrayInvoiceWithholding(inf)) {
                  inf.invoicePurchaseWithholding.withholding = inf.withholding;
                  vm.InvoiceWithholdingsArr.push(inf.invoicePurchaseWithholding);
                }
              });
              $timeout(function(){
                vm.masterGridOptionsRet.api.setColumnDefs(vm.masterColumnDefsRet);
                vm.masterGridOptionsRet.api.setRowData(vm.InvoiceWithholdingDetails);
              }, 1000);

            }

          }, function (errResponse) {
            $rootScope.loadingProgress = false;
            $log.debug(errResponse);
          });
        }

        vm.vatReceivedFromInvoice = function (doc) {
            if (doc.docObj && doc.docObj.vatReceived > 0) {
                $rootScope.loadingProgress = true;
                var provider = doc.docObj.companyProvider;
                api.GeneralWS.CompanyCategory
                    .get({ id: provider.companyCategoryId },
                        function (ct) {
                            vm.vatReceived = doc.docObj.vatReceived;
                            ct.percentage = '' + (ct.rateMultiply * 100) + '%';
                            ct.value = doc.docObj.vatReceived;
                            var arrDt = [];
                            arrDt.push(ct);
                            $timeout(function(){
                                vm.masterGridOptionsVatReceived.api.setColumnDefs(vm.masterColumnDefsVatReceived);
                                vm.masterGridOptionsVatReceived.api.setRowData(arrDt);
                            }, 1000);
                        });
            }
        };

        vm.changeDoc = function (doc, index) {
            vm.currentDoc = doc;
            $log.debug("vm.currentDoc");
            $log.debug(vm.currentDoc);
            vm.currentIndex = index;
            getCompanyDocument();
            vm.getPhotos(doc);
            vm.getDetailByInvoice(doc);
            vm.withholdingToInvoice(doc);
            vm.vatReceivedFromInvoice(doc);
            getWithholding();
            lockEmitida();
            getSeriesType();
            getDimensionCompany();
        };
        function lockEmitida() {
            vm.canEdit = vm.currentDoc.docObj &&
                vm.currentDoc.docObj.purchaseStatus.description === 'Emitida'
                && $stateParams.canEdit;
        }

        vm.addtoArrayInvoiceWithholding = addtoArrayInvoiceWithholding();
        function addtoArrayInvoiceWithholding(withholding) {
            for (var i = 0; i < vm.InvoiceWithholdingsArr.length; i++) {
                if (withholding.invoicePurchaseWithholding.id === vm.InvoiceWithholdingsArr[i].id) {
                    return true;
                }
            }
        }

        function getCompanyDocument() {
            if (vm.currentDoc.docObj && vm.currentDoc.docObj.companyProvider) {
                api.GeneralWS.CompanyDocumentActive.getAll({ id: vm.currentDoc.docObj.companyProvider.id }, function (response) {
                    for (var i = 0; i < response.length; i++) {
                        if (response[i].document.documentType.name === 'NIT' || response[i].document.documentType.name === 'RTN') {
                            vm.companyDoc = response[i].document;
                        }
                    }

                }, function (errResponse) {
                });
            }
        }

        if (vm.docArray && vm.docArray.length > 0) {

            if (vm.mainDoc.detailIndex && vm.docArray[vm.mainDoc.detailIndex]) {
                vm.changeDoc(vm.docArray[vm.mainDoc.detailIndex], vm.mainDoc.detailIndex);
            } else {
                vm.changeDoc(vm.docArray[0], 0);
            }
        }

        function getSeriesType() {
            if (vm.currentDoc.docObj.invoiceSerie) {
                var serie = vm.currentDoc.docObj.invoiceSerie;
                api.GeneralWS.InvoiceSeriesDocumentType.query({ companyId: vm.currentDoc.docObj.companyProvider.id }).$promise.then(function (response) {
                    var resp = response.filter(function (rp) { return rp.id === serie.invoiceSerieDocumentType });
                    if (resp.length > 0) {
                        serie.invoiceSerieDocumentTypeOb = resp[0];
                    }
                    vm.currentDoc.docObj.invoiceSerie = serie;
                }, function (errResponse) {
                    $rootScope.loadingProgress = false;
                });
            }
        }

        vm.changeNextDoc = function (ev) {
            if (vm.docArray && vm.docArray.length > 0 && vm.currentIndex >= 0) {
                var foundEmited = false;
                var lastDoc = false;
                var newCurrentIndex = vm.currentIndex;
                while (newCurrentIndex < vm.docArray.length && !foundEmited && !lastDoc) {
                    newCurrentIndex += 1;
                    if (newCurrentIndex < vm.docArray.length) {
                        if (vm.docArray[newCurrentIndex].docObj.purchaseStatus.description === 'Emitida'
                            || vm.docArray[newCurrentIndex].docObj.purchaseStatus.description === 'Emitido') {
                            foundEmited = true;
                            vm.changeDoc(vm.docArray[newCurrentIndex], newCurrentIndex);
                        }
                    } else {
                        lastDoc = true;
                        if (vm.settlement.pettyCash.pettyCashType.name === 'IMPORT') {

                            $mdDialog.show({
                                controller: 'VerificationInvoiceComposeController',
                                controllerAs: 'vm',
                                templateUrl: 'app/main/apps/documentVerify/settlement/compose/compose-dialog.html',
                                parent: angular.element("#main"),
                                targetEvent: ev,
                                locals: {
                                    settlement: vm.settlement,
                                    detail: vm.docArray[vm.currentIndex].docObj
                                },
                                clickOutsideToClose: false
                            }).then(function (answer) {
                                var settlement = answer;
                                $log.debug("settlement:");
                                $log.debug(settlement);
                                vm.settlement = settlement;

                                vm.gotToInvoices();
                            });
                        }

                    }
                }

                if (lastDoc) {
                    if (vm.settlement.pettyCash.pettyCashType.name !== 'IMPORT') {
                        vm.gotToInvoices();
                    }

                }
            }
        };

        vm.selectedClass = function (doc) {
            if (doc.docObj && vm.currentDoc.docObj && doc.docObj.id === vm.currentDoc.docObj.id
                && doc.docType === vm.currentDoc.docType) {
                return { 'selected': true };
            }
            return '';
        };

        vm.statusClass = function (purchaseStatus) {
            var respClass = '';
            if (purchaseStatus === 'Rechazado' || purchaseStatus === 'Rechazada') {
                respClass = { 'rejected': true };

            }
            //Ingresando,Emitida,Rechazada,Cancelada
            if (purchaseStatus === 'Verificada' || purchaseStatus === 'Verificado' || purchaseStatus === 'Provisionada' || purchaseStatus === 'Provisionado') {
                respClass = { 'verified': true };

            }
            return respClass;
        };
        vm.gotToInvoices = function () {
            if ($stateParams.backTo !== null && $stateParams.backTo !== undefined) {
                vm.isReport = true;
            } else {
                $state.go(vm.backState.stateToBack, vm.backState.paramsToBack);
            }
        };
        vm.changeTab = function () {
            vm.maxHeight = (vm.currentTab === 0 || vm.currentTab === 1) ? '160px' : '100px';
        };

        //cambiar estado
        vm.showCompanyInfo = function (ev) {
            $mdDialog.show({
                contentElement: '#myStaticDialog',
                parent: angular.element("#main"),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: false
            }).then(function () {
            }, function () {
            });
        };
        vm.cancelDialog = function () {
            $mdDialog.cancel();
        };

        function getWithholding() {
            if (vm.currentDoc.docObj && vm.currentDoc.docObj.regime) {
                api.GeneralWS.Withholding.getByRegime.get({ regimeId: vm.currentDoc.docObj.regime.id, onlyManual: 'true' }, function (data) {
                    var withHolding = [];
                    var withHoldingDocumentType = [];
                    data.forEach(function(wh) {
                        if (wh.asocToDocumentType) {
                            withHoldingDocumentType.push(wh);
                        } else {
                            withHolding.push(wh);
                        }
                    });
                    vm.withHoldingManually = withHolding;
                    getAsociedWithHoldingDocumentType(withHoldingDocumentType);
                }, function (errResponse) {
                });
            }
        }

        function getAsociedWithHoldingDocumentType(withHolding) {
            if (withHolding.length > 0) {
                var withholdingId = withHolding.map(function(wh) {
                    return wh.id;
                });
                api.GeneralWS.WithholdingDocumentType.InvoiceSerie
                    .filterExists({ invoiceserie: vm.currentDoc.docObj.invoiceSerie.id, withholding: withholdingId }, function (data) {
                        withHolding.forEach(function(wh){
                            data.forEach(function(dt){
                                if(dt === wh.id) {
                                    vm.withHoldingManually.push(wh);
                                }
                            });
                        });
                    }, function (errResponse) {
                    });
            }
        }

        function validateHasBudgetApplication(companyId) {
            api.GeneralWS.CompanyApplication.byAppName.get({ 'company': companyId, 'app': 'Presupuestos' }).$promise.then(function (responseParameter) {
                if (responseParameter.$status === 200) {
                    if (responseParameter.$data && responseParameter.$data !== "") {
                      vm.hasBudgetApplication = responseParameter.$data.active;
                    }
                }
            }, function (response) {
                $log.error(response);
            });
        }

        function verifyParameterIsContractBudget() {
            if (
                vm.currentDoc.docObj.details[0].merchandiseEntry
                && vm.currentDoc.docObj.details[0].merchandiseEntry.purchaseOrderDetail.contractPurchaseDetail
            ) {
                api.GeneralWS.CompanyParameterByName.get(
                    {
                        id: $rootScope.bsCircle.company.id,
                        parameter: 'REQUEST_A_BUDGET_IN_CONTRACTS'
                    }, function (responseParameterRequestBudget) {
                        if (responseParameterRequestBudget) {
                            vm.hasBudgetApplication = responseParameterRequestBudget.parameterValue === 'true';
                        } else {
                            vm.hasBudgetApplication = false;
                        }
                    }, function (errParameterRequestBudget) {
                        $log.error(errParameterRequestBudget);
                    });
            }
        }

        function getDimensionCompany() {
            if (vm.currentDoc.docObj) {
                api.GeneralWS.DimensionCompany.byCompany.getList(
                    { 'company': vm.currentDoc.docObj.companyBuyer.id }
                ).$promise.then(function (responseDimension) {
                    for (let i = 0; i < responseDimension.length; i++) {
                        if (responseDimension[i].dimensionNumber === vm.NUMBER_DIMENSION_THREE) {
                            vm.dimensionCompanyDetail3 = responseDimension[i];
                        } else if (responseDimension[i].dimensionNumber === vm.NUMBER_DIMENSION_FOUR) {
                            vm.dimensionCompanyDetail4 = responseDimension[i];
                        } else if (responseDimension[i].dimensionNumber === vm.NUMBER_DIMENSION_FIVE) {
                            vm.dimensionCompanyDetail5 = responseDimension[i];
                        } else {
                            vm.dimensionCompanyDetail1 = responseDimension[i];
                        }
                    }
                });
            }
        }

          function getColumnDimensionCompany(number) {
            if (vm['dimensionCompanyDetail' + number] && vm.mainDoc.typeCode !== 'SETTLEMENT') {
                vm.masterColumnDefs.splice(number, 0, {
                    headerName: vm['dimensionCompanyDetail' + number].description,
                    field: 'merchandiseEntry.purchaseOrderDetail.purchaseOrder.dimensionCompanyDetail' + number + '.name',
                    headerCellRenderer: getHeader,
                    width: 250,
                    enableRowGroup: true,
                    enablePivot: true,
                    cellStyle: { 'text-align': 'center' }
                });
            }
          }

        function compareDocuments() {
          $mdDialog.show({
            controller: 'InvoiceFilesComparatorController',
            controllerAs: 'vm',
            templateUrl: 'app/main/apps/documentVerify/invoice-files-comparator/invoice-files-comparator.html',
            parent: angular.element('#main'),
            fileDataLeft: angular.copy(vm.filesData.invoice),
            fileDataRight: angular.copy(vm.filesData.quotation),
            clickOutsideToClose: true,
          });
        }

    }

    function InvoiceSettlementActionsController($mdDialog, api, $scope, $rootScope, $mdToast, $filter, $log, $document) {
        var vms = this;
        var vm = $scope.vm;
        var settlementDetail = null;
      //cambiar estado
      vms.setValidatedInvoice = function (ev, doc) {
        if (vm.pettyCashGeneralSets && vm.pettyCashGeneralSets.askForBudget && vm.hasBudgetApplication) {
          executeBudgetBySettlement(ev, doc);
        } else {
          withHoldingValidation(ev, doc);
        }
      };

        function validateHasHolding(doc) {
          vm.holdingArray = [];
          vm.InvoiceWithholdingsArr.forEach(function (resp){
            if(resp.invoicePurchase.id === doc.docObj.id){
              vm.holdingArray.push(resp);
            }
          });
        }

        function withHoldingValidation(ev, doc) {

          validateHasHolding(doc);
          if(vm.holdingArray.length > 0) {
            $mdDialog.show({
              controller: 'ProvisionInvoiceComposeController',
              controllerAs: 'vm',
              templateUrl: 'app/main/apps/documentVerify/purchase/compose/compose-dialog.html',
              parent: angular.element("#main"),
              targetEvent: ev,
              locals: {
                InvoiceWithholdingDetails: vm.InvoiceWithholdingDetails,
                InvoiceWithholdingsArr: vm.holdingArray,
                isSettlement: true,
              },
              invoice: vm.currentDoc.docObj,
              clickOutsideToClose: false,
            }).then(function (answer) {
              if(answer) {
                changeValidateInvoice(ev,doc);
                vm.refreshInvoice(answer);
              }
            });
          } else {
              changeValidateInvoice(ev, doc);
          }
        }


        function changeValidateInvoice(ev, doc) {
            api.ComprasWS.SettlementDetails.validateDetail.validate({ id: doc.detailId, circleId: $rootScope.bsCircle.id }).$promise.then(function (response) {
                settlementDetail = response;
                if (doc.docType === 'receipt') {
                    vm.currentDoc.docObj = settlementDetail.paymentReceipt;
                    vm.docArray[vm.currentIndex].docObj = settlementDetail.paymentReceipt;
                } else if (doc.docType === 'invoice') {
                    vm.currentDoc.docObj = settlementDetail.invoicePurchase;
                    vm.docArray[vm.currentIndex].docObj = settlementDetail.invoicePurchase;
                }

                $rootScope.loadingProgress = false;
                showMessage($filter('translate')('SETTLEMENT.DOCUMENT.AUTHORIZE_SUCCESSFULLY'));
                vm.changeNextDoc();


            }, function (error) {
                $rootScope.loadingProgress = false;
                showErrorMessage($filter('translate')('SETTLEMENT.DOCUMENT.ERROR_AUTHORIZE'));
                $log.error(error.data);
            });
        }

        function executeBudgetBySettlement(ev, doc) {
            var quotationDetailsId = [];
            var invoiceDetails = [];
            if (vm.currentDoc.docType === 'receipt') {
                invoiceDetails = [vm.currentDoc.docObj];
                quotationDetailsId = [vm.currentDoc.docObj.id];
            } else {
                invoiceDetails = vm.currentDoc.docObj.details;
                quotationDetailsId = vm.currentDoc.docObj.details.map(function (detail) {
                    return detail.id;
                });
            }
            api.ComprasWS.SettlementDetailReference.byInvoiceDetailsId.get(
                {
                    circleId: $rootScope.bsCircle.id, ids: quotationDetailsId.toString(), type: vm.currentDoc.docType
                }, function (quotationReferences) {
                    if (quotationReferences.length > 0) {
                        var invoiceDetailDTO = [];
                        var invoiceDetail;
                        var originTaxesIncluded;
                        quotationReferences.forEach(function (quotationReference) {
                            if (vm.currentDoc.docType === 'receipt') {
                                invoiceDetail = _.find(invoiceDetails, function (detail) {
                                    return detail.id === quotationReference.paymentReceipt.id;
                                });
                            } else {
                                invoiceDetail = _.find(invoiceDetails, function (detail) {
                                    return detail.id === quotationReference.invoicePurchaseDetail.id;
                                });
                            }
                            invoiceDetailDTO.push({
                                id: invoiceDetail.id,
                                quantity: invoiceDetail.quantity ? invoiceDetail.quantity : 1,
                                price: invoiceDetail.priceAfterTax ?
                                    (invoiceDetail.priceAfterTax * vm.currentDoc.docObj.exchangeRate) :
                                    invoiceDetail.amount,
                                subTotal: invoiceDetail.subTotalAfterTax ? invoiceDetail.subTotalAfterTax :
                                    invoiceDetail.amount,
                                discount: invoiceDetail.discountAfterTax ?
                                    (invoiceDetail.discountAfterTax * vm.currentDoc.docObj.exchangeRate) :
                                    0,
                                reference: quotationReference.noReference,
                                quotationDetailId: invoiceDetail.id,
                                reservedQuantity: invoiceDetail.quantity ? invoiceDetail.quantity : 1,
                                referenceHeaderId: vm.mainDoc.number
                            });
                        });
                        var sendToPresupuestos = new jinqJs()
                            .from(invoiceDetailDTO)
                            .groupBy('id', 'quantity', 'price', 'subTotal', 'discount', 'quotationDetailId', 'reservedQuantity', 'referenceHeaderId')
                            .sum('reference')
                            .select(function (data) {
                                data.reference = 0;
                                return data;
                            });
                        api.PresupuestosWS.BudgetDetail.updateExecutedAmounts.update(
                            {
                                idb: 0,
                                circleId: $rootScope.bsCircle.id,
                                origin: '30',
                                originInvoice: '31'
                            }, sendToPresupuestos, function (budgetDetailReferences) {
                                var invoiceDetailReferences = [];
                                budgetDetailReferences.forEach(function (budgetDetailReference) {
                                    invoiceDetailReferences.push({
                                        invoicePurchaseDetail: { id: budgetDetailReference.noReference },
                                        originType: { originTypeCode: '08' },
                                        noReference: budgetDetailReference.budgetDetail.id
                                    });
                                });
                                api.ComprasWS.InvoicePurchaseDetailReference.me.saveReferences(
                                    {
                                        id: 'createReferences',
                                        idCircle: $rootScope.bsCircle.id
                                    }, invoiceDetailReferences).$promise.then(function (invoiceDetailReferences) {
                                        changeValidateInvoice(ev, doc);
                                    }, function (errResponse) {
                                        $rootScope.loadingProgress = false;
                                        MessageService.showErrorMessage(errResponse.data.mensaje);
                                    });
                            }, function (errResponse) {
                                if (errResponse.status === 409) {
                                    var errorMessage = errResponse.data.split(";");
                                    MessageService.showErrorMessage(($filter('translate')(errorMessage[0])) + errorMessage[1]);
                                } else {
                                    MessageService.showErrorMessage(errResponse.data.mensaje);
                                }
                                $rootScope.loadingProgress = false;
                                $log.debug(errResponse);
                            });
                    } else {
                        changeValidateInvoice(ev, doc);
                    }

                }, function (errResponse) {
                    $rootScope.loadingProgress = false;
                    MessageService.showErrorMessage(errResponse.data.mensaje);
                    $log.debug(errResponse);
                });
        }


        //Rechazo
        vms.notAuthorizated = function (ev, docObj, detailId) {
            $mdDialog.show({
                controller: 'rejectionReasonController',
                controllerAs: 'vm',
                locals: {
                    Data: { id: detailId },
                    detailId: 0
                },
                templateUrl: 'app/main/apps/expenseSettlements/settlements/settlement/settlementEditor/rejectionReason/rejectionReason.html',
                parent: angular.element("#main"),
                targetEvent: ev,
                clickOutsideToClose: false
            }).then(function (answer) {

                $log.debug("answer:");
                $log.debug(answer);

                if (vm.currentDoc.docType === 'invoice') {
                    vm.currentDoc.docObj = answer.invoicePurchase;
                    vm.docArray[vm.currentIndex].docObj = answer.invoicePurchase;
                } else if (vm.currentDoc.docType === 'receipt') {
                    vm.currentDoc.docObj = answer.paymentReceipt;
                    vm.docArray[vm.currentIndex].docObj = answer.paymentReceipt;
                }
                vm.settlement = answer.settlement;

                $log.debug("vm.currentDoc.docObj:");
                $log.debug(vm.currentDoc.docObj);
                $log.debug("vm.docArray[vm.currentIndex]");
                $log.debug(vm.docArray[vm.currentIndex]);

                vm.changeNextDoc();

            }, function () {
            });
        };

        vms.changeCompany = function (companyBuyer, companyProvider, doc) {
            vm.fiscalNumberTitle = companyProvider.country.name === "Honduras" ? "RTN" : "NIT";
            $mdDialog.show({
                controller: 'createBasicCompanyController',
                controllerAs: 'vm',
                locals: {
                    data: '',
                    company: companyProvider,
                    settlementId: '',
                    companyBuyer: companyBuyer,
                    titleFiscal: vm.fiscalNumberTitle
                },
                templateUrl: 'app/main/apps/expenseSettlements/settlements/details/invoiceEditor/companyEditor/companyEditor.html',
                parent: angular.element("#main"),
                clickOutsideToClose: false
            }).then(function (answer) {
                vm.docArray.forEach(function (doc) {
                    if (doc.docType === 'invoice' && doc.docObj.companyProvider.id === answer.id) {
                        doc.docObj.companyProvider = answer;
                    }
                });
              vm.isWithholding = $rootScope.isWithholding;
                if (vm.isWithholding){
                  removeHoldingRetention(doc.docObj.id);
                }else{
                  restoreHoldingRetention(doc.docObj.id);
                }
                $rootScope.loadingProgress = false;
            }, function () {
                $rootScope.loadingProgress = false;
            });
        };

        function removeHoldingRetention (idInvoice) {
          for (let i = 0; i < vm.InvoiceWithholdingDetails.length; i++) {
            vm.dataDetail = vm.InvoiceWithholdingDetails[i];
            if(vm.dataDetail.withholding.name === 'IVA') {
              vm.idDetail = vm.dataDetail.id;
              vm.invoiceRetentionId = vm.dataDetail.invoicePurchaseWithholding.id;
            }
          }
          for (let i = 0; i < vm.InvoiceWithholdingsArr.length; i++) {
            const data = vm.InvoiceWithholdingsArr[i];
            if( data.invoicePurchase.id === idInvoice && data.withholding.id === vm.holding){
              api.ComprasWS.InvoicePurchaseWithholdingDetail.Details.delete({
                idCircle: $rootScope.bsCircle.id, id: vm.idDetail }).$promise.then(function (response) {
                const index = vm.InvoiceWithholdingsArr.findIndex(function(row) {
                  return row.id === vm.invoiceRetentionId;
                });
                vm.InvoiceWithholdingsArr.splice(index, 1);
                vm.refreshInvoice(response, true);
                $rootScope.loadingProgress = false;
              });
            }
          }
        }

        function restoreHoldingRetention (idInvoice) {
            api.ComprasWS.InvoicePurchaseWithholdingDetail.Retention.put({invoiceId: idInvoice }).$promise
              .then(function (response) {
                vm.refreshInvoice(response, true);
              });
        }

        function showMessage(message) {
            $rootScope.loadingProgress = false;
            $mdToast.show({
                template: '<md-toast layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
                hideDelay: 3000,
                position: 'top right'
            });
        }

        function showErrorMessage(message) {
            $rootScope.loadingProgress = false;
            $mdToast.show({
                template: '<md-toast layout="column" layout-align="center start"><div class="md-toast-content" style="background-color: red">'
                    + message + '</div></md-toast>',
                hideDelay: 5000,
                position: 'top right'
            });
        }

    }

    function InvoicePurchaseActionsController($mdDialog, api, $rootScope, $mdToast, $stateParams, $log, $filter, $timeout, $scope, $state, MessageService) {
        var vms = this;
        var vm = $scope.vm;
        vm.NUMBER_FOUR_HUNDRED = 1200;
        // variables
        vms.isRechzed = $stateParams.status === 'Rechazada';
        vms.addWithholding = addWithholding;
        vms.viewOrdenPago = viewOrdenPago;
        //funciones
        /**
         * Devuelve un objeto con el siguiente estado al que pasa una cotización
         * @returns statusTochange
         */
        function getStatusTochange() {
            var statusToChange = null;
            switch ($stateParams.status) {
                case 'Emitida':
                    statusToChange = {};
                    statusToChange.name = "Pendiente Recibir Original";
                    statusToChange.icon = "icon-thumb-up-outline";
                    statusToChange.buttonDescription = "QUOTATION.STATUS_CHANGE.Emitida";
                    break;
                case 'Pendiente Recibir Original':
                    statusToChange = {};
                    statusToChange.name = "Provisionada";
                    statusToChange.icon = "icon-thumb-up-outline";
                    statusToChange.buttonDescription = "QUOTATION.STATUS_CHANGE.PendienteProvisionar";
                    break;
                case 'Pendiente Provisionar':
                    statusToChange = {};
                    statusToChange.name = "Provisionada";
                    statusToChange.icon = "icon-thumb-up-outline";
                    statusToChange.buttonDescription = "QUOTATION.STATUS_CHANGE.Provisionada";
                    break;
            }

            return statusToChange;
        }

        function setStatusInvoice(status, reason, saveReason) {
            $rootScope.loadingProgress = true;

          var localInvoice = vm.currentDoc.docObj;
          if (localInvoice.invoiceSerie){
            localInvoice.invoiceSerie = { id: localInvoice.invoiceSerie.id };
          }
            api.ComprasWS.InvoicePurchase.setStatus(
                {
                    id: 'changeStatus', idCircle: $rootScope.bsCircle.id, status: status,
                    saveReason: saveReason, reason: reason
                }, localInvoice).$promise.then(function (response) {
                    $rootScope.loadingProgress = false;
                    $mdToast.show({
                        template: '<md-toast layout="column" layout-align="center start">'
                            + '<div class="md-toast-content" translate="INVOICE.MSG.STATUS_CHANGE_SUCCESS"></div></md-toast>',
                        hideDelay: 3000,
                        position: 'top right'
                    });
                    if (status === 'Provisionada') {

                        var urlRpt = $rootScope.getParameterValue('JASPER_URL_CONTRASENA_PAGO').replace('[ID]', vm.currentDoc.docObj.id);
                        $mdDialog.show({
                            controller: 'ReportShowPDFController',
                            controllerAs: 'vm',
                            templateUrl: 'app/main/apps/reports/dialogs/show-pdf/show-pdf.html',
                            parent: angular.element("#main"),
                            locals: {
                                Url: urlRpt
                            },
                            clickOutsideToClose: false,
                            fullscreen: true
                        }).then(function (answer) {
                            gotToInvoices();
                        }, function () {
                            gotToInvoices();
                        });
                    } else {
                        gotToInvoices();
                    }

                }, function (response) {
                    $rootScope.loadingProgress = false;
                    $log.error(response);
                });
        }


      /**
        /**
         * Cambia estado a una factura
         * @param {type} ev
         * @returns {undefined}
         */
        vms.changeStatusInvoice = function (ev) {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('INVOICE.MSG.' + $stateParams.status + '_INVOICE'))
                .textContent($filter('translate')('INVOICE.MSG.CONFIRMACION_' + $stateParams.status + '_INVOICE'))
                .ok($filter('translate')('INVOICE.MSG.SI'))
                .cancel($filter('translate')('INVOICE.MSG.NO'));
            $mdDialog.show(confirm).then(function () {

                if ($stateParams.status === 'Pendiente Provisionar') {
                    setStatusInvoice(getStatusTochange().name);
                }

                if ($stateParams.status === 'Emitida' || $stateParams.status === 'Pendiente Recibir Original') {
                    provisionInvioce(ev);
                }

            }, function () {
            });
        };
        /**
         * Abre compose para verificar fecha de contabilización
         * @param {type} ev
         * @returns {undefined}
         */
        function provisionInvioce(ev) {
            $mdDialog.show({
                controller: 'ProvisionInvoiceComposeController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/documentVerify/purchase/compose/compose-dialog.html',
                parent: angular.element("#main"),
                targetEvent: ev,
                locals: {
                    InvoiceWithholdingDetails: vm.InvoiceWithholdingDetails,
                    InvoiceWithholdingsArr: vm.InvoiceWithholdingsArr,
                    isSettlement: false,
                },
                invoice: vm.currentDoc.docObj,
                clickOutsideToClose: false
            }).then(function (answer) {

                if (answer && ($stateParams.status !== 'Emitida' ||
                    ((vm.currentDoc.docObj.invoiceSerie && vm.currentDoc.docObj.invoiceSerie.electronicInvoice) || vm.currentDoc.docObj.uuid !== null)
                )
                ) {

                    var urlRpt = $rootScope.getParameterValue('JASPER_URL_CONTRASENA_PAGO').replace('[ID]', vm.currentDoc.docObj.id);
                    $mdDialog.show({
                        controller: 'ReportShowPDFController',
                        controllerAs: 'vm',
                        templateUrl: 'app/main/apps/reports/dialogs/show-pdf/show-pdf.html',
                        parent: angular.element("#main"),
                        locals: {
                            Url: urlRpt
                        },
                        clickOutsideToClose: false,
                        fullscreen: true
                    }).then(function (answer) {
                        gotToInvoices();
                    }, function () {
                        gotToInvoices();
                    });
                    if (vm.hasBudgetApplication
                        && vm.currentDoc.docObj.details[0].merchandiseEntry.purchaseOrderDetail.contractPurchaseDetail
                        && vm.currentDoc.docObj.details[0].merchandiseEntry.purchaseOrderDetail.contractPurchaseDetail.contractPurchase
                    ) {
                        executeBudgetByContract(ev);
                    }
                } else {
                    gotToInvoices();
                }

            });
        }

        function gotToInvoices() {
            $state.go('app.invoice.' + $stateParams.status.replace("-", "").replace(/ /g, ""));
        }


        vms.goToInvoicePurchaseDetailEdit = function (data) {
            $mdDialog.show({
                controller: 'DetailEditorController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/invoice/saleInvoice/detailEditor/detailEditor.html',
                parent: angular.element("#main"),
                InvoicePurchase: vms.invoicePurchase,
                serie: vm.currentDoc.docObj.invoiceSerie,
                edited: data,
                id: data.id,
                Taxes: vms.taxes,
                canEdit: false,
                clickOutsideToClose: false
            }).then(function (answer) {
            });
        };

      function verifyIsContractFixed()
      {
        var isContractFixed = true;
        for (var i = 0; i < vm.currentDoc.docObj.details.length; i++) {
          if (vm.currentDoc.docObj.details[i].merchandiseEntry.purchaseOrderDetail.contractPurchaseDetail
            && vm.currentDoc.docObj.details[i].merchandiseEntry.purchaseOrderDetail.contractPurchaseDetail.contractPurchase
            && !vm.currentDoc.docObj.details[i].merchandiseEntry.purchaseOrderDetail.contractPurchaseDetail.contractPurchase.fixed) {
            isContractFixed = false;
            break;
          }
        }
        return isContractFixed;
      }

        vms.changeOtherStatusInvoice = function (status) {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('INVOICE.MSG.' + status + '_INVOICE'))
                .textContent($filter('translate')('INVOICE.MSG.CONFIRMACION_' + status + '_INVOICE'))
                .ok($filter('translate')('INVOICE.MSG.SI'))
                .cancel($filter('translate')('INVOICE.MSG.NO'));
            $mdDialog.show(confirm).then(function () {
                var isContractFixed = verifyIsContractFixed();

                if ((status === 'Rechazada' || status === 'Editando')) {
                    $mdDialog.show({
                        controller: 'RejectionReasonController',
                        controllerAs: 'vm',
                        templateUrl: 'app/main/apps/documentVerify/purchase/compose/rejection-reason-dialog.html',
                        parent: angular.element("#main"),
                        canEdit: false,
                        clickOutsideToClose: false
                    }).then(function (answer) {
                      verifyInvoiceChangeStatus(status, answer, true, isContractFixed);
                    });
                } else {
                        setStatusInvoice(status);
                }
            }, function () {
            });
        };

        function verifyInvoiceChangeStatus(status, answer, isSaveReason, isContractFixed){
          if (vm.hasBudgetApplication && isContractFixed) {
            revertBudgetedProductsExecute(status, answer, isSaveReason);
          } else if (vm.hasBudgetApplication && !isContractFixed) {
            var productsToValidate = new jinqJs()
              .from(vm.currentDoc.docObj.details)
              .select(function (r) {
                return {
                  id: r.merchandiseEntry.purchaseOrderDetail.contractPurchaseDetail.id,
                  product: r.product,
                  amount: r.subTotalAfterTax,
                  unitPrice: 0,
                  currency: r.currency,
                  exchangeRate: r.exchangeRate,
                  requestAmpliation: false,
                  references: null
                };
              });

            if (productsToValidate.length > 0) {
              $rootScope.loadingProgress = true;
              api.PresupuestosWS.Budget.revertBudgetedProducts
                .revertBudgeted(
                  {
                    'idc': $rootScope.bsCircle.id,
                    'originType': '28',
                    'noPaymentNotFixed': vm.currentDoc.docObj.details[0].merchandiseEntry.merchandiseHeader.noPayment
                  },
                  productsToValidate
                )
                .$promise.then(
                function (response) {
                  $rootScope.loadingProgress = false;
                  setStatusInvoice(status, answer, isSaveReason);
                },
                function (response) {
                  $rootScope.loadingProgress = false;
                  $log.error(response);
                }
              );
            } else {
              setStatusInvoice(status, answer, isSaveReason);
            }
          } else {
            setStatusInvoice(status, answer, isSaveReason);
          }
        }

        vms.changeStatusEmit = function () {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('INVOICE.MSG.Creando_INVOICE'))
                .textContent($filter('translate')('INVOICE.MSG.CONFIRMACION_Creando_INVOICE'))
                .ok($filter('translate')('INVOICE.MSG.SI'))
                .cancel($filter('translate')('INVOICE.MSG.NO'));
            $mdDialog.show(confirm).then(function () {

                $mdDialog.show({
                    controller: 'RejectionReasonController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/apps/documentVerify/purchase/compose/rejection-reason-dialog.html',
                    parent: angular.element("#main"),
                    canEdit: false,
                    clickOutsideToClose: false
                }).then(function (answer) {
                  var isContractFixed = verifyIsContractFixed();

                  verifyInvoiceChangeStatus('Ingresando', answer, true, isContractFixed);
                });
            }, function () {
            });
        };

      function revertBudgetedProductsExecute(status, reason, saveReason) {
        var invoiceDetails = new jinqJs()
          .from(vm.currentDoc.docObj.details)
          .where(function (detail) {
            return detail.merchandiseEntry.purchaseOrderDetail.quotationDetail;
          })
          .select();
        if (invoiceDetails.length > 0) {
          var quotationDetailsId = invoiceDetails.map(function (detail) {
            return detail.merchandiseEntry.purchaseOrderDetail.quotationDetail.id;
          });
          api.ComprasWS.QuotationDetailReference.QuotationDetailReference.getByQuotationDetails(
            {
              id: 'byQuatationDetails',
              circleId: $rootScope.bsCircle.id, quotationDetailsId: quotationDetailsId.toString()
            }, function (quotationReferences) {
              if (quotationReferences.length > 0) {
                var invoiceDetailDTO = [];
                var invoiceDetail;
                var originTaxesIncluded;
                quotationReferences.forEach(function (quotationReference) {
                  invoiceDetail = _.find(invoiceDetails, function (detail) {
                    return detail.merchandiseEntry.purchaseOrderDetail.quotationDetail.id === quotationReference.quotationDetail.id;
                  });
                  originTaxesIncluded = quotationReference.quotationDetail.taxesIncluded;
                  invoiceDetailDTO.push({
                    id: invoiceDetail.id,
                    quantity: (-invoiceDetail.quantity * vm.currentDoc.docObj.exchangeRate),
                    price: originTaxesIncluded === true ?
                      (-invoiceDetail.priceAfterTax * vm.currentDoc.docObj.exchangeRate) :
                      (-invoiceDetail.priceBeforeTax * vm.currentDoc.docObj.exchangeRate),
                    subTotal: originTaxesIncluded === true ?
                      (-invoiceDetail.subTotalAfterTax * vm.currentDoc.docObj.exchangeRate) :
                      (-invoiceDetail.subTotalBeforeTax * vm.currentDoc.docObj.exchangeRate),
                    discount: originTaxesIncluded === true ?
                      (-invoiceDetail.discountAfterTax * vm.currentDoc.docObj.exchangeRate) :
                      (-invoiceDetail.discountBeforeTax * vm.currentDoc.docObj.exchangeRate),
                    reference: quotationReference.noReference,
                    quotationDetailId: quotationReference.quotationDetail.id,
                    reservedQuantity: invoiceDetail.merchandiseEntry.purchaseOrderDetail.quantity,
                    referenceHeaderId: 0
                  });
                });
                api.PresupuestosWS.BudgetDetail.updateExecutedAmounts.reverse(
                  { idb: 0, circleId: $rootScope.bsCircle.id }, invoiceDetailDTO, function (budgetDetailReferences) {
                    var invoiceDetailReferences = [];
                    budgetDetailReferences.forEach(function (budgetDetailReference) {
                      invoiceDetailReferences.push({
                        invoicePurchaseDetail: { id: budgetDetailReference.noReference },
                        originType: { originTypeCode: '08' },
                        noReference: budgetDetailReference.budgetDetail.id
                      });
                    });
                    api.ComprasWS.InvoicePurchaseDetailReference.me.saveReferences(
                      {
                        id: 'createReferences',
                        idCircle: $rootScope.bsCircle.id
                      }, invoiceDetailReferences).$promise.then(function (invoiceDetailReferences) {
                      setStatusInvoice(status, reason, saveReason);
                    }, function (errResponse) {
                      $rootScope.loadingProgress = false;
                    });
                  }, function (errResponse) {
                    $rootScope.loadingProgress = false;
                    $log.debug(errResponse);
                  });
              } else {
                setStatusInvoice(status, reason, saveReason);
              }

            }, function (errResponse) {
              $rootScope.loadingProgress = false;
              $log.debug(errResponse);
            });
        } else {
          if (vm.hasBudgetApplication) {
            refuseBudgetByContract(status, reason, saveReason);
          } else {
            setStatusInvoice(status, reason, saveReason);
          }
        }
      }

      function validateHasBudgetApplication(id) {
            api.GeneralWS.CompanyApplication.byAppName.get({ 'company': id, 'app': 'Presupuestos' }).$promise.then(function (responseParameter) {
                if (responseParameter.$data && responseParameter.$data !== "") {
                    vm.hasBudgetApplication = responseParameter.$data.active;
                }
            }, function (response) {
                $log.error(response);
            });
        }

        validateHasBudgetApplication(vm.currentDoc.docObj.companyBuyer.id);

        function addWithholding() {

            $mdDialog.show({
                controller: 'WithholdingController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/documentVerify/purchase/compose/withholding-dialog.html',
                parent: angular.element("#main"),
                InvoicePurchase: vm.currentDoc,
                types: vm.withHoldingManually,
                clickOutsideToClose: false
            }).then(function (answer) {
                if (answer) {
                    vm.refreshInvoice(answer, true);
                }
            });
        }

        function viewOrdenPago() {
            var urlRpt = $rootScope.getParameterValue('JASPER_URL_DOC_ENTREGA').replace('[ID]', vm.currentDoc.docObj.id);
            $mdDialog.show({
                controller: 'ReportShowPDFController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/reports/dialogs/show-pdf/show-pdf.html',
                parent: angular.element("#main"),
                locals: {
                    Url: urlRpt
                },
                clickOutsideToClose: false,
                fullscreen: true
            }).then(function (answer) {
            }, function () {
            });
        }


        function refuseBudgetByContract(status, reason, saveReason) {
            var invoiceDetails = new jinqJs()
                .from(vm.currentDoc.docObj.details)
                .where(function (detail) {
                    return detail.merchandiseEntry.purchaseOrderDetail.contractPurchaseDetail;
                })
                .select();
            var contractDetailsId = invoiceDetails.map(function (detail) {
                return detail.merchandiseEntry.purchaseOrderDetail.contractPurchaseDetail.id;
            });
            api.ComprasWS.ContractDetailReference.byContractDetailsId.getByDetailsIdAndNoPayment(
                {
                    circleId: $rootScope.bsCircle.id,
                    noPayment: vm.currentDoc.docObj.details[0].merchandiseEntry.merchandiseHeader.noPayment
                }, contractDetailsId, function (contractReferences) {
                    if (contractReferences.length > 0) {
                        var invoiceDetailDTO = [];
                        var invoiceDetail;
                        var originTaxesIncluded;
                        contractReferences.forEach(function (reference) {
                            invoiceDetail = _.find(invoiceDetails, function (detail) {
                                return detail.merchandiseEntry.purchaseOrderDetail.contractPurchaseDetail.id === reference.contractPurchaseDetail.id;
                            });
                            originTaxesIncluded = reference.contractPurchaseDetail.taxesIncluded;
                            invoiceDetailDTO.push({
                                id: invoiceDetail.id,
                                quantity: (-invoiceDetail.quantity * vm.currentDoc.docObj.exchangeRate),
                                price: originTaxesIncluded === true ?
                                    (-invoiceDetail.priceAfterTax * vm.currentDoc.docObj.exchangeRate) :
                                    (-invoiceDetail.priceBeforeTax * vm.currentDoc.docObj.exchangeRate),
                                subTotal: originTaxesIncluded === true ?
                                    (-invoiceDetail.subTotalAfterTax * vm.currentDoc.docObj.exchangeRate) :
                                    (-invoiceDetail.subTotalBeforeTax * vm.currentDoc.docObj.exchangeRate),
                                discount: originTaxesIncluded === true ?
                                    (-invoiceDetail.discountAfterTax * vm.currentDoc.docObj.exchangeRate) :
                                    (-invoiceDetail.discountBeforeTax * vm.currentDoc.docObj.exchangeRate),
                                reference: reference.noReference,
                                quotationDetailId: reference.contractPurchaseDetail.id,
                                reservedQuantity: invoiceDetail.merchandiseEntry.purchaseOrderDetail.quantity,
                                referenceHeaderId: 0
                            });
                        });
                        api.PresupuestosWS.BudgetDetail.updateExecutedAmounts.reverse(
                            { idb: 0, circleId: $rootScope.bsCircle.id }, invoiceDetailDTO, function (budgetDetailReferences) {
                                var invoiceDetailReferences = [];
                                budgetDetailReferences.forEach(function (budgetDetailReference) {
                                    invoiceDetailReferences.push({
                                        invoicePurchaseDetail: { id: budgetDetailReference.noReference },
                                        originType: { originTypeCode: '08' },
                                        noReference: budgetDetailReference.budgetDetail.id
                                    });
                                });
                                api.ComprasWS.InvoicePurchaseDetailReference.me.saveReferences(
                                    {
                                        id: 'createReferences',
                                        idCircle: $rootScope.bsCircle.id
                                    }, invoiceDetailReferences).$promise.then(function (invoiceDetailReferences) {
                                        setStatusInvoice(status, reason, saveReason);
                                    }, function (errResponse) {
                                        $rootScope.loadingProgress = false;
                                    });
                            }, function (errResponse) {
                                $rootScope.loadingProgress = false;
                                $log.debug(errResponse);
                            });
                    } else {
                      setStatusInvoice(status, reason, saveReason);
                    }
                }, function (err) {

                });
        }

        function executeBudgetByContract(ev) {
            vm.details = vm.currentDoc.docObj.details;
            var invoiceDetails = new jinqJs()
                .from(vm.details)
                .where(function (detail) {
                    return detail.merchandiseEntry.purchaseOrderDetail.contractPurchaseDetail;
                })
                .select();
            var contractDetailsId = invoiceDetails.map(function (detail) {
                return detail.merchandiseEntry.purchaseOrderDetail.contractPurchaseDetail.id;
            });
            api.ComprasWS.ContractDetailReference.byContractDetailsId.getByDetailsIdAndNoPayment(
                {
                    circleId: $rootScope.bsCircle.id,
                    noPayment: vm.details[0].merchandiseEntry.merchandiseHeader.noPayment
                }, contractDetailsId, function (contractReferences) {
                    if (contractReferences.length > 0) {
                        var invoiceDetailDTO = [];
                        var invoiceDetail;
                        var originTaxesIncluded;
                        contractReferences.forEach(function (reference) {
                            invoiceDetail = _.find(invoiceDetails, function (detail) {
                                return detail.merchandiseEntry.purchaseOrderDetail.contractPurchaseDetail.id === reference.contractPurchaseDetail.id;
                            });
                            originTaxesIncluded = reference.contractPurchaseDetail.taxesIncluded;
                            invoiceDetailDTO.push({
                                id: invoiceDetail.id,
                                quantity: invoiceDetail.quantity,
                                price: originTaxesIncluded === true ?
                                    (invoiceDetail.priceAfterTax * vm.currentDoc.docObj.exchangeRate) :
                                    (invoiceDetail.priceBeforeTax * vm.currentDoc.docObj.exchangeRate),
                                subTotal: originTaxesIncluded === true ? invoiceDetail.subTotalAfterTax :
                                    invoiceDetail.subTotalBeforeTax,
                                discount: originTaxesIncluded === true ?
                                    (invoiceDetail.discountAfterTax * vm.currentDoc.docObj.exchangeRate) :
                                    (invoiceDetail.discountBeforeTax * vm.currentDoc.docObj.exchangeRate),
                                reference: reference.noReference,
                                quotationDetailId: reference.contractPurchaseDetail.id,
                                reservedQuantity: invoiceDetail.merchandiseEntry.quantity,
                                referenceHeaderId: vm.currentDoc.docObj.id,
                                noPayment: vm.details[0].merchandiseEntry.merchandiseHeader.noPayment
                            });
                        });
                        var sendToPresupuestos = new jinqJs()
                            .from(invoiceDetailDTO)
                            .groupBy('id', 'quantity', 'price', 'subTotal', 'discount', 'quotationDetailId', 'reservedQuantity', 'referenceHeaderId', 'noPayment')
                            .sum('reference')
                            .select(function (data) {
                                data.reference = 0;
                                return data;
                            });
                        vm.showButton = false;
                        api.PresupuestosWS.BudgetDetail.updateExecutedAmountsContract.update(
                            { idb: 0, circleId: $rootScope.bsCircle.id }, sendToPresupuestos, function (budgetDetailReferences) {
                                var invoiceDetailReferences = [];
                                budgetDetailReferences.forEach(function (budgetDetailReference) {
                                    invoiceDetailReferences.push({
                                        invoicePurchaseDetail: { id: budgetDetailReference.noReference },
                                        originType: { originTypeCode: '08' },
                                        noReference: budgetDetailReference.budgetDetail.id
                                    });
                                });
                                api.ComprasWS.InvoicePurchaseDetailReference.me.saveReferences(
                                    {
                                        id: 'createReferences',
                                        idCircle: $rootScope.bsCircle.id
                                    }, invoiceDetailReferences).$promise.then(function () {

                                    }, function (errResponse) {
                                        $rootScope.loadingProgress = false;
                                        MessageService.showErrorMessage(errResponse.data.mensaje);
                                    });
                            }, function (errResponse) {
                                if (errResponse.status === 409) {
                                    var errorMessage = errResponse.data.split(";");
                                    MessageService.showErrorMessage(($filter('translate')(errorMessage[0])) + errorMessage[1]);
                                } else {
                                  if (errResponse.data.mensaje === 'ReferenceFromQuotation Not Found') {
                                    MessageService.showErrorMessage($filter('translate')('INVOICE.REFERENCE_FROM_QUOTATION_NOT_FOUND'));
                                  } else {
                                    MessageService.showErrorMessage(errResponse.data.mensaje);
                                  }
                                }
                                $rootScope.loadingProgress = false;
                                $log.debug(errResponse);
                            });
                    } else {
                        $rootScope.loadingProgress = false;
                    }
                }, function (err) {

                });
        }


    }
}
)();

(function() {
  "use strict";

  angular
    .module("app.reports")
    .controller("AccountStatusController", AccountStatusController);

  /** @ngInject */
  function AccountStatusController(
    $mdSidenav,
    $stateParams,
    Report,
    api,
    $rootScope,
    $state,
    $timeout,
    $templateRequest,
    $sce,
    $log,
    $filter
  ) {
    var vm = this;

    var pageSize = Report.pageSize;
    vm.minDate = new Date();
    vm.filter = {
      startDate: new Date(vm.minDate.getTime()),
      endDate: new Date(vm.minDate.getTime()),
      isProvider: Report.isProvider,
      appName: Report.filter.appName,
      isGeneral: Report.filter.isGeneral
    };

    if ($stateParams.isTicket) {
      vm.filter.originTypeCode = "01";
    }

    vm.exportXLS = Report.exportXLS;
    vm.snFilter = Report.filter;
    vm.title = Report.title;
    vm.masterColumnDefs = Report.columns;
    vm.isShowFilter = true;

    //metodos
    vm.goToRef = goToRef;
    vm.statuses = [];
    vm.typeses = [];
    vm.exceptionLimitDateButton = false;

    rowsColumns();

    function rowsColumns() {
      vm.masterColumnDefs.forEach(function(d) {
        d.headerCellRenderer = function() {
          return "{{'" + d.headerName + "'|translate}}";
        };
        if (d.valueFormatter) {
          d.valueFormatter = getCellFormater(d.valueFormatter);
        }
        if (d.rendererButtons) {
          d.cellRenderer = getButtons(d.rendererButtons);
          delete d.rendererButtons;
        }
        if (d.rendererTranslateValue) {
          d.cellRenderer = getTranslateValue(
            d.rendererTranslateValue.prefixTranslate,
            d.rendererTranslateValue.keyValue
          );
          delete d.rendererTranslateValue;
        }
        if (d.dataTypes) {
          correctFilter(d);
        }
      });
    }
    vm.api = api;
    Report.api.forEach(function(d) {
      vm.api = vm.api[d];
    });

    function correctFilter(column) {
      switch (column.dataTypes) {
        case "Long":
        case "BigDecimal":
        case "Double":
        case "Integer":
          column.filter = "number";
          break;
        case "text":
          column.filter = "text";
          break;
        default:
          column.filter = "date";
          break;
      }
      correctFilterParams(column);
    }

    function correctFilterParams(column) {
      switch (column.filter) {
        case "number":
          column.filterParams = {
            filterOptions: ["equals"],
            newRowsAction: "keep"
          };
          break;
        case "text":
          column.filterParams = {
            filterOptions: ["contains"],
            newRowsAction: "keep"
          };
          break;
        case "date":
          column.suppressFilter = true;
          break;
      }
    }

    var gridOptions = Report.masterGridOptions;
    if (Report.detailGrid) {
      var templateDetail = null;
      vm.loadTemplate = function() {
        var otherTemplate = $sce.getTrustedResourceUrl(
          Report.detailGrid.templateUrl
        );
        $templateRequest(otherTemplate).then(
          function(template) {
            templateDetail = template;
          },
          function() {
            $log.error("Ocurrio un error al leer el template");
          }
        );
      };

      gridOptions.fullWidthCellRenderer = fullWidthCellRendererFn;
      gridOptions.isFullWidthCell = function(rowNode) {
        return rowNode.level === 1;
      };
      gridOptions.getRowHeight = function(params) {
        var rowIsDetailRow = params.node.level === 1;

        return rowIsDetailRow ? 450 : 45;
      };
    }
    gridOptions.doesDataFlower = function(dataItem) {
      return false;
    };
    gridOptions.onFilterChanged = function(c, d, e, f) {
      delete vm.filter.totalElements;
    };

    gridOptions.localeTextFunc = function(key, defaultValue) {
      return translateGrid(key, defaultValue, $filter);
    };

    gridOptions.getMainMenuItems = function(params) {
      return getHeaderMenu(params, $filter);
    };

    gridOptions.component = function(params) {
      return getHeaderMenu(params, $filter);
    };

    gridOptions.autoGroupColumnDef = {
      headerName: "ACCOUNT_STATUS.PURCHASE_ORDER_ID",
      field: "idPurchaseOrder",
      width: 185,
      cellRenderer: "group",
      pinned: "left",
      headerCellRenderer: getHeader,
      enableRowGroup: true,
      hide: true
    };

    gridOptions.columnDefs = vm.masterColumnDefs;
    vm.masterGridOptions = gridOptions;

    $timeout(function() {
      verifiAll();
    }, 10);

    function verifiAll() {
      if (vm.exportXLS) {
        vm.onExportXLS = function() {
          var params = {
            skipHeader: false,
            skipFooters: false,
            skipGroups: false,
            allColumns: true,
            onlySelected: false,
            fileName: Report.exportXLS.nameFile + new Date().getTime() + ".xls",
            columnSeparator: ",",
            sheetName: "data"
          };

          params.processCellCallback = function(params) {
            if (params.column.colId.indexOf("fecha") !== -1) {
              return $filter("date")(params.value, "dd/MM/yyyy");
            } else if (
              params.column.colId.indexOf("receptionDate") !== -1 &&
              params.value
            ) {
              return $filter("apiDate")(params.value, "dd/MM/yyyy HH:mm:ss");
            } else {
              return params.value;
            }
          };

          params.processHeaderCallback = function(params) {
            return $filter("translate")(params.column.colDef.headerName);
          };

          vm.masterGridOptions.api.exportDataAsExcel(params);
        };
      }
    }

    vm.search = search;
    vm.gotoDetail = gotoDetail;
    vm.toggleSidenav = toggleSidenav;

    //////////
    if (Report.verticalFilter) {
      $timeout(function() {
        toggleSidenav("main-sidenav");
      }, 300);
    }

    function getCellFormater(type) {
      switch (type) {
        case "date":
          return function(params) {
            if (params.value) {
              return $filter("date")(params.value, "dd/MM/yyyy");
            }
            return '';
          };
        case "currency":
          return function(params) {
            if (params.value) {
              return $filter("number")(params.value, "2");
            }
            return '';
          };
        case "localDateTime":
          return function(params) {
            if (params.value) {
              return $filter("apiDate")(params.value, "dd/MM/yyyy HH:mm:ss");
            }
            return '';
          };
        case "dateTime":
          return function(params) {
            if (params.value) {
              return $filter("date")(params.value, "dd/MM/yyyy HH:mm:ss");
            }
            return '';
          };
        case "boolean":
          return function(params) {
            if (params.value) {
              return '<md-icon md-font-icon="icon-checkbox-marked-circle green-500-fg"></md-icon>';
            }
              return '<md-icon md-font-icon="icon-cancel red-500-fg"></md-icon>';
          };

        default:
          return null;
          break;
      }
    }

    function fixDataTypesFilters(arr) {
      if (arr) {
        arr.forEach(function(r) {
          if (r.filterType === "number") {
            var clDef = vm.masterGridOptions.api.getColumnDef(r.field);
            r.filterType = clDef.dataTypes ? clDef.dataTypes : "number";
          }
        });
      }
    }

    function createNewDatasource() {
      vm.masterGridOptions.api.paginationSetPageSize(pageSize);

      var o = vm.masterGridOptions.api.getFilterModel();
      var parameters = {
        circle: $rootScope.bsCircle.id,
        idCircle: $rootScope.bsCircle.id,
        company: $rootScope.bsCircle.company.id,
        electronic: vm.electronic,
        page: vm.masterGridOptions.api.paginationGetCurrentPage(),
        pageSize: pageSize,
        startDate: vm.filter.startDate.toString(),
        endDate: vm.filter.endDate.toString()
      };
      var arr = $.map(o, function(k, ke, sd, ds) {
        var on = k;
        on.field = ke;
        on.filter = on.filter.toString();
        return on;
      });
      fixDataTypesFilters(arr);
      vm.parameters = parameters;
      vm.isShowProgressLinear = true;
      vm.filter.sorts = vm.masterGridOptions.api.getSortModel();
      vm.filter.filters = arr;
      vm.api(
        parameters,
        vm.filter,
        function(response) {
          vm.isShowProgressLinear = false;
          vm.showGrid = true;
          vm.filter.totalElements = response.totalElements;
          vm.filter.id = null;
          vm.masterGridOptions.api.setRowData(response.content);
          vm.hasData = response.content.length > 0;
        },
        function(response) {
          vm.isShowProgressLinear = false;
          $log.error(response);
        }
      );

      document.getElementsByClassName(
        "ag-column-drop-cell-text"
      )[0].innerHTML = $filter("translate")(
        document.getElementsByClassName("ag-column-drop-cell-text")[0].innerHTML
      );
    }

    function search() {
      if (vm.snFilter.isGeneral && !vm.snFilter.filterByDates) {
        delete vm.filter.startDate;
        delete vm.filter.endDate;
      } else {
        if (!vm.filter.startDate) {
          vm.filter.startDate = new Date();
        }
        if (!vm.filter.endDate) {
          vm.filter.endDate = new Date();
        }
        vm.filter.startDate.setHours(0);
        vm.filter.startDate.setMinutes(0);
        vm.filter.startDate.setSeconds(0);

        vm.filter.endDate.setHours(23);
        vm.filter.endDate.setMinutes(59);
        vm.filter.endDate.setSeconds(59);
      }

      if (!Report.filter.queryAll && !$stateParams.isTicket) {
        if (!vm.filter.departments || vm.filter.departments.length <= 0) {
          vm.filter.departments = [];

          if (vm.departments) {
            for (var i = 0; i < vm.departments.length; i++) {
              vm.filter.departments.push(vm.departments[i].id);
            }
          } else {
            vm.filter.departments.push(-1000);
          }
        }

        if (!vm.filter.costCenters || vm.filter.costCenters.length <= 0) {
          vm.filter.costCenters = [];

          if (vm.costCenters) {
            for (var j = 0; j < vm.costCenters.length; j++) {
              vm.filter.costCenters.push(vm.costCenters[j].id);
            }
          } else {
            vm.filter.costCenters.push(-1000);
          }
        }
      }

      if (!vm.filter.statuses || vm.filter.statuses.length <= 0) {
        vm.filter.statuses = [];

        if (vm.statuses) {
          for (var k = 0; k < vm.statuses.length; k++) {
            vm.filter.statuses.push(vm.statuses[k].id);
          }
        } else {
          vm.filter.statuses.push(-1000);
        }
      }

      if (!vm.filter.companies || vm.filter.companies.length <= 0) {
        vm.filter.companies = [];

        if (vm.companies) {
          for (var l = 0; l < vm.companies.length; l++) {
            vm.filter.companies.push(vm.companies[l].id);
          }
        }
      }

      if (vm.snFilter.isRejectedAutomatically) {
        vm.filter.isRejectedAutomatically = vm.snFilter.isRejectedAutomatically;
      }

      delete vm.filter.totalElements;
      vm.masterGridOptions.api.setColumnDefs(vm.masterColumnDefs);
      createNewDatasource();
      vm.isShowFilter = false;
    }

    /**
     * Toggle sidenav
     *
     * @param sidenavId
     */
    function toggleSidenav(sidenavId) {
      $mdSidenav(sidenavId).toggle();
    }

    function getTranslateValue(prefixTranslate, keyValue) {
      return function renderer(params) {
        var render = '<div style="width: 100%;">\n';
        render +=
          "{{'" + prefixTranslate + ".' + data." + keyValue + "| translate}} ";
        render += "</div>";
        return render;
      };
    }

    function goToRef(data) {
      window.open(data.originType.queryUrl + data.referenceId, "_blank");
    }

    /**
     * Go to product detail
     *
     * @param id
     */
    function gotoDetail(id) {
      $state.go(Report.stateDetail, {
        id: id,
        filter: vm.filter,
        backTo: $state.current.name,
        isClient: !Report.isProvider,
        isReport: true
      });
    }

    function fullWidthCellRendererFn(params) {
      params.$scope.id = params.data.id;
      if (Report.detailGrid) {
        params.$scope.detailGridOptions = Report.detailGrid.options;

        if (Report.detailGrid.exportXLS) {
          params.$scope.onExportDetailXLS = function() {
            var _params = {
              skipHeader: false,
              skipFooters: false,
              skipGroups: false,
              allColumns: true,
              onlySelected: false,
              fileName:
                Report.detailGrid.exportXLS.nameFile +
                params.$scope.id +
                "-" +
                new Date().getTime() +
                ".xls",
              columnSeparator: ",",
              sheetName: "data"
            };

            _params.processCellCallback = function(params) {
              if (params.column.colId.indexOf("fecha") !== -1) {
                return $filter("date")(params.value, "dd/MM/yyyy");
              } else if (params.column.colId.indexOf("createdAt") !== -1) {
                return $filter("apiDate")(params.value, "dd/MM/yyyy HH:mm:ss");
              } else {
                return params.value;
              }
            };

            _params.processHeaderCallback = function(para) {
              return $filter("translate")(para.column.colDef.headerName);
            };

            params.$scope.detailGridOptions.api.exportDataAsExcel(_params);
          };
        }

        var dataSource = {
          paginationPageSize: pageSize,
          getRows: function(p) {
            vm.isShowProgressLinear = true;
            api.PresupuestosWS.BudgetDetail.getDetailByBuget(
              { idb: params.data.budgetId },
              function(response) {
                vm.isShowProgressLinear = false;

                p.successCallback(response, response.length);

                var floatingRows = [];
                var totalQuantity = 0;
                var totalAmount = 0;

                response.forEach(function(row, index) {
                  totalQuantity += row.quantity;
                  totalAmount += row.amount;
                });

                floatingRows.push({
                  product: {
                    name: $filter("translate")("general.totales")
                  },
                  quantity: totalQuantity,
                  amount: totalAmount
                });

                params.$scope.detailGridOptions.api.setPinnedBottomRowData(
                  floatingRows
                );
              },
              function(response) {
                vm.isShowProgressLinear = false;
              }
            );
          }
        };
        var mouseWheelListener = function(event) {
          event.stopPropagation();
        };

        setTimeout(function() {
          var container = document.querySelector(
            "#containerDetail" + params.$scope.id
          );

          container.addEventListener("mousewheel", mouseWheelListener);
          container.addEventListener("DOMMouseScroll", mouseWheelListener);

          params.$scope.detailGridOptions.api.setEnterpriseDatasource(
            dataSource
          );
        }, 1000);

        $rootScope.$on("$translateChangeSuccess", function() {
          params.$scope.detailGridOptions.api.setColumnDefs(
            vm.detailColumnDefs
          );
        });

        return templateDetail;
      }
      return true;
    }

    if ($stateParams.filter !== null && $stateParams.filter !== undefined) {
      $timeout(function() {
        vm.filter = angular.copy($stateParams.filter);
        vm.search();
      }, 1000);
    }

    $timeout(function() {
      if (
        $state.current.name === "app.report.quotationC" &&
        $stateParams.id !== null &&
        $stateParams.id !== undefined
      ) {
        vm.filter.id = $stateParams.id;
        vm.search();
      }
    }, 1000);

    $timeout(function() {
      if (Report.filter.searchOnLoad) {
        search();
      }
    }, 1000);
  }
})();

(function () {
    'use strict';
    angular
        .module('app.contract')
        .controller('ContractsController', ContractsController);
    /** @ngInject */
    function ContractsController($state, api, $rootScope, $log, $mdDialog, $filter, MessageService, $timeout, $scope, $stateParams) {
        var vm = this;
        vm.statusNameByRole = "";
        vm.iconChangeStatusButton = "";
        vm.showChangeStatusButton = false;
        vm.isCreate = $stateParams.status === 'Creando';
        vm.statusToChange = $stateParams.status;
        vm.chageStatusButton = getDatasToChange($stateParams.status);
        vm.pageSize = 100;
        vm.hasBudgetApplication = false;
        vm.masterColumnDefs = [
            {
                headerName: '#',
                field: "id",
                width: 50,
                cellStyle: { 'text-align': 'center' },
                filter: 'number',
                sort: 'asc',
                pinned: "left"
            },
            {
                headerName: 'CONTRACT.COMPANY_PROVIDER',
                field: "companyProvider.name",
                headerCellRenderer: getHeader,
                width: 250,
                enableRowGroup: true,
                filter: 'text',
                enablePivot: true
            },
            {
                headerName: 'CONTRACT.DEPARTMENT',
                field: "department.description",
                headerCellRenderer: getHeader,
                width: 250,
                enableRowGroup: true,
                filter: 'text',
                enablePivot: true
            },
            {
                headerName: 'CONTRACT.COST_CENTER',
                field: "costCenter.description",
                headerCellRenderer: getHeader,
                width: 200,
                enableRowGroup: true,
                filter: 'text',
                enablePivot: true
            },
            {
                headerName: 'REQUISITION.PROJECT',
                field: "prjName",
                headerCellRenderer: getHeader,
                width: 150,
                enableRowGroup: true,
                filter: 'text',
                enablePivot: true
            },
            {
                headerName: 'CONTRACT.MAXDATEPURCHASE',
                field: "dateDelivery",
                headerCellRenderer: getHeader,
                valueFormatter: function (params) {
                    return $filter('date')(params.value, 'dd/MM/yyyy');
                },
                enableRowGroup: true,
                filter: 'date',
                enablePivot: true
            },
            {
                headerName: 'CONTRACT.ACTIONS',
                name: "actions",
                headerCellRenderer: getHeader,
                suppressSorting: true,
                suppressMenu: true,
                width: 250,
                cellRenderer: renderer,
                cellStyle: { 'padding': '0px' },
                pinned: "right"
            }
        ];
        if ($stateParams.status === 'Autorizado') {
            vm.masterColumnDefs.splice(5, 0, {
                headerName: 'CONTRACT.STATUS',
                field: "purchaseStatus.description",
                headerCellRenderer: getHeader,
                width: 200,
                enableRowGroup: true,
                filter: 'text',
                enablePivot: true
            });
        }

        if ($stateParams.status === 'Ingresado') {
            vm.masterColumnDefs.splice(1, 0, {
                headerName: 'REQUISITION.COMPANY_BUYER',
                field: "companyBuyer.name",
                headerCellRenderer: getHeader,
                width: 200,
                enableRowGroup: true,
                filter: 'text',
                enablePivot: true
            });
        }

        vm.masterGridOptions = {
            columnDefs: vm.masterColumnDefs,
            enableSorting: true,
            debug: false,
            enableFilter: true,
            enableColResize: true,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowData: null,
            groupHeaders: true,
            headerHeight: 50,
            rowHeight: 40,
            rowSelection: 'multiple',
            rowDeselection: true,
            rowModelType: "enterprise",
            cacheBlockSize: vm.pageSize,
            pagination: true,
            paginationPageSize: vm.pageSize,
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            },
            doesDataFlower: function (dataItem) {
                return true;
            },
            isExternalFilterPresent: isExternalFilterPresent,
            doesExternalFilterPass: doesExternalFilterPass
        };

        vm.masterColumnDefs.forEach(function (d) {
            correctFilterParams(d);
        });

        function correctFilterParams(column) {
            switch (column.filter) {
                case 'number':
                    column.filterParams = {
                        filterOptions: ['equals'],
                        newRowsAction: 'keep'
                    };
                    break;
                case 'text':
                    column.filterParams = {
                        filterOptions: ['contains'],
                        newRowsAction: 'keep'
                    };
                    break;
                case 'date':
                    column.suppressFilter = true;
                    break;
            }
        }

        // Data
        var filter = '';

        function isExternalFilterPresent() {
            return filter !== '';
        }

        function doesExternalFilterPass(node) {
            if (filter && filter !== 'everyone') {
                var arrdt = node.data.filter.split(filter);
                return arrdt.length > 1;
            }
            return true;
        }

        $scope.$watch('vm.search',
            function (newValue) {
                filter = newValue ? newValue.toLowerCase() : '';
                vm.masterGridOptions.api.onFilterChanged();
            }
        );

        vm.loading = true;
        $timeout(function (d) {
            if ($rootScope.bsCircle) {
                validateHasBudgetApplication($rootScope.bsCircle.company.id);
                $rootScope.loadingProgress = true;
                vm.loading = true;
                vm.status = $stateParams.status === 'Autorizado' ? 'Autorizado,Licitando' : $stateParams.status;
                vm.masterGridOptions.api.setColumnDefs(vm.masterColumnDefs);
                loadData();
                getDimensionCompany();
            } else {
                vm.loading = false;
                $state.go('app.dashboard_project');
            }
        }, 300);

        function loadData() {
            var projectIds = [];
            var dataSource = {
                paginationPageSize: vm.pageSize,
                getRows: function (params) {
                    var o = params.request.filterModel;
                    var arr = [];
                    if (params.request.filterModel) {
                        arr = $.map(o, function (k, ke, sd, ds) {
                            var on = k;
                            on.field = ke;
                            on.filter = on.filter.toString();
                            return on;
                        });
                    }
                    arr.forEach(function (row, index) {
                        filter = filter + "%" + row.filter;
                    });
                    api.ComprasWS.ContractFind.page(
                        {
                            idCircle: $rootScope.bsCircle.id,
                            status: vm.status,
                            page: vm.masterGridOptions.api.paginationGetCurrentPage(),
                            pageSize: vm.pageSize,
                            tickets: $stateParams.tickets, 'filter': filter
                        }, function (response) {// Success
                            vm.contracts = new jinqJs()
                                .from(response.content)
                                .orderBy([{ field: 'id', sort: 'asc' }])
                                .select(function (r) {
                                    var d = r;
                                    d.filter = (d.id + "," + d.department.description + "," + d.costCenter.description).toLowerCase();
                                    if (r.projectId !== undefined) {
                                        if (projectIds.length > 0) {
                                            if (projectIds.indexOf(r.projectId) < 0) {
                                                projectIds.push(r.projectId);
                                            }
                                        } else {
                                            projectIds.push(r.projectId);
                                        }
                                    }
                                    return r;
                                });
                            if (projectIds.length > 0) {
                                getAllProject(params, response, vm.contracts, projectIds);
                            } else {
                                vm.loading = false;
                                filter = '';
                                $rootScope.loadingProgress = false;
                                params.successCallback(vm.contracts, response.totalElements);
                                $log.debug(vm.contracts);
                            }
                        }, function (response) {// Error
                            $log.debug(response);
                            vm.loading = false;
                            $rootScope.loadingProgress = false;
                        });
                }
            };
            vm.masterGridOptions.api.setEnterpriseDatasource(dataSource);
        }

        function getAllProject(params, response, data, projectIds) {
            api.ProyectosWS.getAllProject.get({ 'ids': projectIds }, function (pjr) {
                data.forEach(function (row) {
                    pjr.forEach(function (res) {
                        if (row.projectId === res.id) {
                            row.prjName = res.name;
                        }
                    });
                });
                vm.loading = false;
                filter = '';
                $rootScope.loadingProgress = false;
                params.successCallback(data, response.totalElements);
            }, function () {
                params.successCallback(data, response.totalElements);
            });
        }

        function validateHasBudgetApplication(companyId) {
            api.GeneralWS.CompanyApplication.byAppName.get({
                'company': companyId,
                'app': 'Presupuestos'
            }).$promise.then(function (responseParameter) {
                if (responseParameter.$status === 200) {
                    if (responseParameter.$data && responseParameter.$data !== '') {
                        vm.hasBudgetApplication = responseParameter.$data.active;
                        api.GeneralWS.CompanyParameterByName.get(
                            {
                                id: $rootScope.bsCircle.company.id,
                                parameter: 'REQUEST_A_BUDGET_IN_CONTRACTS'
                            }, function (responseParameterRequestBudget) {
                                if (responseParameterRequestBudget) {
                                    vm.hasBudgetApplication = responseParameterRequestBudget.parameterValue === 'true' ? true : false;
                                }
                            }, function (errParameterRequestBudget) {
                                $log.error(errParameterRequestBudget);
                            });
                    }
                }
            }, function (response) {
                $log.error(response);
                vm.hasBudgetApplication = false;
            });
        }
        // Methods
        vm.convertDate = convertDate;
        vm.gotoContractDetail = gotoContractDetail;
        vm.newContract = newContract;
        vm.deleteContract = deleteContract;
        vm.presentContract = presentContract;
        //////////

        function convertDate(dateS) {
            return new Date(dateS + ' 00:00:00');
        }


        function presentContract(data, i, status) {

            var confirm = $mdDialog.confirm()
                .title($filter('translate')('CONTRACT.MSG.' + vm.statusToChange + '_CONTRACT'))
                .textContent($filter('translate')('CONTRACT.MSG.CONFIRMACION_' + vm.statusToChange + '_CONTRACT'))
                .ok($filter('translate')('CONTRACT.MSG.SI'))
                .cancel($filter('translate')('CONTRACT.MSG.NO'));
            $mdDialog.show(confirm).then(function () {

                if (status === 'Cancelado') {
                    var confirm2 = $mdDialog.confirm()
                        .title($filter('translate')('CONTRACT.CANCELAR'))
                        .textContent($filter('translate')('CONTRACT.MSG.CONFIRMACION_CANCELAll'))
                        .ok($filter('translate')('CONTRACT.MSG.SI_ALL'))
                        .cancel($filter('translate')('CONTRACT.MSG.NO_ALL'));
                    $mdDialog.show(confirm2).then(function () {
                        $rootScope.loadingProgress = true;
                        var promise = api.ComprasWS.ContractChangeStatus.update(
                            { 'id': data.id, 'idCircle': $rootScope.bsCircle.id, status: status, 'deleteAll': true }).$promise;
                        promise.then(function (response) {
                            if (response.circle) {
                                spliceContract(data.id);
                                vm.masterGridOptions.api.setRowData(vm.contracts);
                            } else {
                                $rootScope.loadingProgress = false;
                                spliceContract(data.id);
                                vm.masterGridOptions.api.setRowData(vm.contracts);
                            }
                            MessageService.show('CONTRACT.MSG.UPDATED');
                        }, function (response) {
                            $rootScope.loadingProgress = false;
                            var msg = 'ERROR';
                            if (response.data === 'No Detail') {
                                msg = 'DETAIL';
                            }
                            MessageService.showErrorMessage('CONTRACT.MSG.' + msg);
                        });
                    }, function () {
                        $rootScope.loadingProgress = true;
                        var promise = api.ComprasWS.ContractChangeStatus.update(
                            { 'id': data.id, 'idCircle': $rootScope.bsCircle.id, status: status, 'deleteAll': false }).$promise;
                        promise.then(function (responseUp) {
                            if (responseUp.circle) {
                                spliceContract(data.id);
                                vm.masterGridOptions.api.setRowData(vm.contracts);
                            } else {
                                $rootScope.loadingProgress = false;
                                spliceContract(data.id);
                                vm.masterGridOptions.api.setRowData(vm.contracts);
                            }
                            MessageService.show('CONTRACT.MSG.UPDATED');
                        }, function (responseErr) {
                            $rootScope.loadingProgress = false;
                            var msg = 'ERROR';
                            if (responseErr.data === 'No Detail') {
                                msg = 'DETAIL';
                            }
                            MessageService.showErrorMessage('CONTRACT.MSG.' + msg);
                        });
                    });
                } else {
                    $rootScope.loadingProgress = true;
                    var promise = api.ComprasWS.ContractChangeStatus.update(
                        { 'id': data.id, 'idCircle': $rootScope.bsCircle.id, status: status, 'deleteAll': false }).$promise;
                    promise.then(function (responseStatus) {
                        if (responseStatus.circle) {
                            spliceContract(data.id);
                            vm.masterGridOptions.api.setRowData(vm.contracts);
                        } else {
                            $rootScope.loadingProgress = false;
                            spliceContract(data.id);
                            vm.masterGridOptions.api.setRowData(vm.contracts);
                        }
                        MessageService.show('CONTRACT.MSG.UPDATED');
                    }, function (responseErrStatus) {
                        $rootScope.loadingProgress = false;
                        var msg = 'ERROR';
                        if (responseErrStatus.data === 'No Detail') {
                            msg = 'DETAIL';
                        }
                        MessageService.showErrorMessage('CONTRACT.MSG.' + msg);
                    });
                }
            }, function () {

            });
        }


        /**
         * Delete
         *
         * @param e
         * @param id
         * @param i
         * @returns {*}
         */
        function deleteContract(e, id, i) {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('CONTRACT.CANCELAR'))
                .textContent($filter('translate')('CONTRACT.MSG.CONFIRMACION_CANCEL'))
                .ok($filter('translate')('CONTRACT.MSG.SI'))
                .cancel($filter('translate')('CONTRACT.MSG.NO'));
            $mdDialog.show(confirm).then(function () {
                var confirm2 = $mdDialog.confirm()
                    .title($filter('translate')('CONTRACT.CANCELAR'))
                    .textContent($filter('translate')('CONTRACT.MSG.CONFIRMACION_CANCELAll'))
                    .ok($filter('translate')('CONTRACT.MSG.SI_ALL'))
                    .cancel($filter('translate')('CONTRACT.MSG.NO_ALL'));
                $mdDialog.show(confirm2).then(function () {
                    $rootScope.loadingProgress = true;
                    api.ComprasWS.Contract.delete({ idCircle: $rootScope.bsCircle.id, id: id, 'deleteAll': true }, function (response) {// Success
                        spliceContract(id);
                        $rootScope.loadingProgress = false;
                        vm.masterGridOptions.api.setRowData(vm.contracts);
                        MessageService.show('CONTRACT.MSG.DELETED');
                    }, function (response) {// Error
                        $log.debug(response);
                    });
                }, function () {
                    api.ComprasWS.Contract.delete({ idCircle: $rootScope.bsCircle.id, id: id }, function (responseDel) {// Success
                        spliceContract(id);
                        $rootScope.loadingProgress = false;
                        vm.masterGridOptions.api.setRowData(vm.contracts);
                        MessageService.show('CONTRACT.MSG.DELETED');
                    }, function (response) {// Error
                        $log.debug(response);
                    });
                });
            }, function () {
            });
        }

        /**
         * Go to product detail
         *
         * @param id
         */
        function gotoContractDetail(id) {
            $state.go('app.contract.' + $stateParams.status + '.detail', { id: id });
        }

        /**
         * Go to product detail
         *
         */
        function newContract() {
            $state.go('app.contract.Creando.detail');
        }

        function renderer(params) {
            var toRet = '<div style="width: 100%;">';
            if (vm.isCreate) {
                toRet = toRet + '<md-button class="edit-button md-icon-button" ng-click="vm.gotoContractDetail(data.id)" aria-label="Order details"'
                    + ' translate translate-attr-aria-label="CONTRACT.ORDER_DETAILS">'
                    + ' <md-tooltip md-direction="bottom">'
                    + ' {{"CONTRACT.DETAIL.EDIT"| translate}}'
                    + ' </md-tooltip>'
                    + '       <md-icon md-font-icon="icon-border-color" class="s16"></md-icon> '
                    + ' </md-button>';
            } else {
                toRet = toRet + '<md-button class="edit-button md-icon-button" ng-click="vm.gotoContractDetail(data.id)" aria-label="Order details"'
                    + ' translate translate-attr-aria-label="CONTRACT.ORDER_DETAILS">'
                    + ' <md-tooltip md-direction="bottom">'
                    + ' {{"CONTRACT.DETAIL.VIEW"| translate}}'
                    + ' </md-tooltip>'
                    + '       <md-icon md-font-icon="icon-eye" class="s16"></md-icon> '
                    + ' </md-button>';
            }

            if (params.data && params.data.purchaseStatus.description !== 'Cancelado') {
                toRet = toRet + '<md-button '
                    + 'ng-if="(data && !data.fixed && vm.hasBudgetApplication) || !vm.hasBudgetApplication" '
                    + 'class="edit-button md-icon-button" ng-click="vm.presentContract(data, '
                    + params.rowIndex + ',\'' + vm.chageStatusButton.statusNext + '\')" aria-label="present contract"'
                    + ' translate translate-attr-aria-label="CONTRACT.ORDER_DETAILS">'
                    + ' <md-tooltip md-direction="bottom">'
                    + ' {{vm.chageStatusButton.desc| translate}}'
                    + ' </md-tooltip>'
                    + '       <md-icon md-font-icon="{{vm.chageStatusButton.icon}}" class="s16"></md-icon>'
                    + ' </md-button>';
            }

            if (vm.isCreate || $stateParams.status === 'Ingresado') {
                toRet = toRet + '<md-button class="edit-button md-icon-button" ng-click="vm.deleteContract($event, data.id,'
                    + params.rowIndex + ')" aria-label="Compare"'
                    + ' translate translate-attr-aria-label="CONTRACT.COMPARE">'
                    + ' <md-tooltip md-direction="bottom">'
                    + ' {{"CONTRACT.DELETE"| translate}}'
                    + ' </md-tooltip>'
                    + '       <md-icon md-font-icon="icon-minus-circle" class="s16 md-warn"></md-icon> '
                    + ' </md-button>';
            }

            return toRet + '</div>';
        }

        function getDatasToChange(status) {
            var ret = { desc: 'CONTRACT.STATUSCHANGE.' + status };
            switch (status) {
                case 'Creando':
                    ret.icon = 'icon-content-paste';
                    ret.statusNext = 'Ingresado';
                    break;
                case 'Ingresado':
                    ret.icon = 'icon-key-variant';
                    ret.statusNext = 'Autorizado';
                    break;
                case 'Autorizado':
                    ret.icon = 'icon-cancel';
                    ret.statusNext = 'Cancelado';
                    break;
            }
            return ret;
        }


        function spliceContract(id) {
            var nro = 0;
            vm.contracts.forEach(function (row) {
                if (row.id === id) {
                    vm.contracts.splice(nro, 1);
                }

                nro += 1;
            });
            loadData();
        }

        function getDimensionCompany() {
            const NUMBER_DIMENSION_THREE = 3;
            const NUMBER_DIMENSION_FOUR = 4;
            const NUMBER_DIMENSION_FIVE = 5;
            api.GeneralWS.DimensionCompany.byCompany.getList(
                { 'company': $rootScope.bsCircle.company.id }
            ).$promise.then(function (responseDimension) {
                for (let i = 0; i < responseDimension.length; i++) {
                    if (responseDimension[i].dimensionNumber === NUMBER_DIMENSION_THREE) {
                        vm.dimensionCompanyDetail3 = responseDimension[i];
                        addMasterColumnDefs(responseDimension[i].description, 'dimensionCompanyDetail3.name', responseDimension[i].dimensionNumber);
                    } else if (responseDimension[i].dimensionNumber === NUMBER_DIMENSION_FOUR) {
                        vm.dimensionCompanyDetail4 = responseDimension[i];
                        addMasterColumnDefs(responseDimension[i].description, 'dimensionCompanyDetail4.name', responseDimension[i].dimensionNumber);
                    } else if (responseDimension[i].dimensionNumber === NUMBER_DIMENSION_FIVE) {
                        vm.dimensionCompanyDetail5 = responseDimension[i];
                        addMasterColumnDefs(responseDimension[i].description, 'dimensionCompanyDetail5.name', responseDimension[i].dimensionNumber);
                    } else {
                        vm.dimensionCompanyDetail1 = responseDimension[i];
                    }
                }
                vm.masterGridOptions.api.setColumnDefs(vm.masterColumnDefs);
            });
        }

        function addMasterColumnDefs(name, fieldName, number) {
            const NUMBER_SIX_COLUMN_ADD = 6;
            vm.masterColumnDefs.splice((number + NUMBER_SIX_COLUMN_ADD), 0, {
                headerName: name,
                field: fieldName,
                headerCellRenderer: getHeader,
                width: 200,
                enableRowGroup: true,
                filter: 'text',
                enablePivot: true
            });
        }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsThemeOptionsController', MsThemeOptionsController)
        .directive('msThemeOptions', msThemeOptions);

    /** @ngInject */
    function MsThemeOptionsController($cookies, fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;

        vm.layoutModes = [
            {
                label: 'Boxed',
                value: 'boxed'
            },
            {
                label: 'Wide',
                value: 'wide'
            }
        ];
        vm.layoutStyles = [
            {
                label : 'Vertical Navigation',
                value : 'verticalNavigation',
                figure: '/Compras/assets/images/theme-options/vertical-nav.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar',
                value : 'verticalNavigationFullwidthToolbar',
                figure: '/Compras/assets/images/theme-options/vertical-nav-with-full-toolbar.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar 2',
                value : 'verticalNavigationFullwidthToolbar2',
                figure: '/Compras/assets/images/theme-options/vertical-nav-with-full-toolbar-2.jpg'
            },
            {
                label : 'Horizontal Navigation',
                value : 'horizontalNavigation',
                figure: '/Compras/assets/images/theme-options/horizontal-nav.jpg'
            },
            {
                label : 'Content with Toolbar',
                value : 'contentWithToolbar',
                figure: '/Compras/assets/images/theme-options/content-with-toolbar.jpg'
            },
            {
                label : 'Content Only',
                value : 'contentOnly',
                figure: '/Compras/assets/images/theme-options/content-only.jpg'
            },
        ];

        vm.layoutMode = 'wide';
        vm.layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        // Methods
        vm.setActiveTheme = setActiveTheme;
        vm.getActiveTheme = getActiveTheme;
        vm.updateLayoutMode = updateLayoutMode;
        vm.updateLayoutStyle = updateLayoutStyle;

        //////////

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            fuseTheming.setActiveTheme(themeName);
        }

        /**
         * Get active theme
         *
         * @returns {service.themes.active|{name, theme}}
         */
        function getActiveTheme()
        {
            return fuseTheming.themes.active;
        }

        /**
         * Update layout mode
         */
        function updateLayoutMode()
        {
            var bodyEl = angular.element('body');

            // Update class on body element
            bodyEl.toggleClass('boxed', (vm.layoutMode === 'boxed'));
        }

        /**
         * Update layout style
         */
        function updateLayoutStyle()
        {
            // Update the cookie
            $cookies.put('layoutStyle', vm.layoutStyle);

            // Reload the page to apply the changes
            location.reload();
        }
    }

    /** @ngInject */
    function msThemeOptions($mdSidenav)
    {
        return {
            restrict   : 'E',
            scope      : {},
            controller : 'MsThemeOptionsController as vm',
            templateUrl: 'app/core/theme-options/theme-options.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-theme-options');

                return function postLink(scope)
                {
                    /**
                     * Toggle options sidenav
                     */
                    function toggleOptionsSidenav()
                    {
                        // Toggle the fuse theme options panel
                        $mdSidenav('fuse-theme-options').toggle();
                    }

                    // Expose the toggle function
                    scope.toggleOptionsSidenav = toggleOptionsSidenav;
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .service('fuseTheming', fuseThemingService);

    /** @ngInject */
    function fuseThemingService($cookies, $log, $mdTheming)
    {
        var service = {
            getRegisteredPalettes: getRegisteredPalettes,
            getRegisteredThemes  : getRegisteredThemes,
            setActiveTheme       : setActiveTheme,
            setThemesList        : setThemesList,
            themes               : {
                list  : {},
                active: {
                    'name' : '',
                    'theme': {}
                }
            }
        };

        return service;

        //////////

        /**
         * Get registered palettes
         *
         * @returns {*}
         */
        function getRegisteredPalettes()
        {
            return $mdTheming.PALETTES;
        }

        /**
         * Get registered themes
         *
         * @returns {*}
         */
        function getRegisteredThemes()
        {
            return $mdTheming.THEMES;
        }

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            // If theme does not exist, fallback to the default theme
            if ( angular.isUndefined(service.themes.list[themeName]) )
            {
                // If there is no theme called "default"...
                if ( angular.isUndefined(service.themes.list.default) )
                {
                    $log.error('You must have at least one theme named "default"');
                    return;
                }

                $log.warn('The theme "' + themeName + '" does not exist! Falling back to the "default" theme.');

                // Otherwise set theme to default theme
                service.themes.active.name = 'default';
                service.themes.active.theme = service.themes.list.default;
                $cookies.put('selectedTheme', service.themes.active.name);

                return;
            }

            service.themes.active.name = themeName;
            service.themes.active.theme = service.themes.list[themeName];
            $cookies.put('selectedTheme', themeName);
        }

        /**
         * Set available themes list
         *
         * @param themeList
         */
        function setThemesList(themeList)
        {
            service.themes.list = themeList;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($mdThemingProvider, fusePalettes, fuseThemes)
    {
        // Inject Cookies Service
        var $cookies;
        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Check if custom theme exist in cookies
        var customTheme = $cookies.getObject('customTheme');
        if ( customTheme )
        {
            fuseThemes['custom'] = customTheme;
        }

        $mdThemingProvider.alwaysWatchTheme(true);

        // Define custom palettes
        angular.forEach(fusePalettes, function (palette)
        {
            $mdThemingProvider.definePalette(palette.name, palette.options);
        });

        // Register custom themes
        angular.forEach(fuseThemes, function (theme, themeName)
        {
            $mdThemingProvider.theme(themeName)
                .primaryPalette(theme.primary.name, theme.primary.hues)
                .accentPalette(theme.accent.name, theme.accent.hues)
                .warnPalette(theme.warn.name, theme.warn.hues)
                .backgroundPalette(theme.background.name, theme.background.hues);
        });
    }

})();
(function ()
{
    'use strict';

    var fuseThemes = {
        default  : {
            primary   : {
                name: 'fuse-paleblue',
                hues: {
                    'default': '700',
                    'hue-1'  : '500',
                    'hue-2'  : '600',
                    'hue-3'  : '400'
                }
            },
            accent    : {
                name: 'light-blue',
                hues: {
                    'default': '600',
                    'hue-1'  : '400',
                    'hue-2'  : '700',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'red'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'pinkTheme': {
            primary   : {
                name: 'blue-grey',
                hues: {
                    'default': '800',
                    'hue-1'  : '600',
                    'hue-2'  : '400',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'pink',
                hues: {
                    'default': '400',
                    'hue-1'  : '300',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'blue'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'tealTheme': {
            primary   : {
                name: 'fuse-blue',
                hues: {
                    'default': '900',
                    'hue-1'  : '600',
                    'hue-2'  : '500',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'teal',
                hues: {
                    'default': '500',
                    'hue-1'  : '400',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'deep-orange'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        }
    };

    angular
        .module('app.core')
        .constant('fuseThemes', fuseThemes);
})();
(function () {
    'use strict';

    var fusePalettes = [
        {
            name: 'fuse-blue',
            options: {
                '50': '#ebf1fa',
                '100': '#c2d4ef',
                '200': '#9ab8e5',
                '300': '#78a0dc',
                '400': '#5688d3',
                '500': '#3470ca',
                '600': '#2e62b1',
                '700': '#275498',
                '800': '#21467e',
                '900': '#1a3865',
                'A100': '#c2d4ef',
                'A200': '#9ab8e5',
                'A400': '#5688d3',
                'A700': '#275498',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'fuse-paleblue',
            options: {
                '50': '#ececee',
                '100': '#c5c6cb',
                '200': '#9ea1a9',
                '300': '#7d818c',
                '400': '#5c616f',
                '500': '#3c4252',
                '600': '#353a48',
                '700': '#2d323e',
                '800': '#262933',
                '900': '#1e2129',
                'A100': '#c5c6cb',
                'A200': '#9ea1a9',
                'A400': '#5c616f',
                'A700': '#2d323e',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        }
    ];

    angular
        .module('app.core')
        .constant('fusePalettes', fusePalettes);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('fuseGenerator', fuseGeneratorService);

    /** @ngInject */
    function fuseGeneratorService($cookies, $log, fuseTheming)
    {
        // Storage for simplified themes object
        var themes = {};

        var service = {
            generate: generate,
            rgba    : rgba
        };

        return service;

        //////////

        /**
         * Generate less variables for each theme from theme's
         * palette by using material color naming conventions
         */
        function generate()
        {
            // Get registered themes and palettes and copy
            // them so we don't modify the original objects
            var registeredThemes = angular.copy(fuseTheming.getRegisteredThemes());
            var registeredPalettes = angular.copy(fuseTheming.getRegisteredPalettes());

            // First, create a simplified object that stores
            // all registered themes and their colors

            // Iterate through registered themes
            angular.forEach(registeredThemes, function (registeredTheme)
            {
                themes[registeredTheme.name] = {};

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(registeredTheme.colors, function (colorType, colorTypeName)
                {
                    themes[registeredTheme.name][colorTypeName] = {
                        'name'  : colorType.name,
                        'levels': {
                            'default': {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues.default].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 4)
                            },
                            'hue1'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 4)
                            },
                            'hue2'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 4)
                            },
                            'hue3'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 4)
                            }
                        }
                    };
                });
            });

            // Process themes one more time and then store them in the service for external use
            processAndStoreThemes(themes);

            // Iterate through simplified themes
            // object and create style variables
            var styleVars = {};

            // Iterate through registered themes
            angular.forEach(themes, function (theme, themeName)
            {
                styleVars = {};
                styleVars['@themeName'] = themeName;

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorTypes, colorTypeName)
                {
                    // Iterate through color levels (default, hue1, hue2 & hue3)
                    angular.forEach(colorTypes.levels, function (colors, colorLevelName)
                    {
                        // Iterate through color name (color, contrast1, contrast2, contrast3 & contrast4)
                        angular.forEach(colors, function (color, colorName)
                        {
                            styleVars['@' + colorTypeName + ucfirst(colorLevelName) + ucfirst(colorName)] = color;
                        });
                    });
                });

                // Render styles
                render(styleVars);
            });
        }

        // ---------------------------
        //  INTERNAL HELPER FUNCTIONS
        // ---------------------------

        /**
         * Process and store themes for global use
         *
         * @param _themes
         */
        function processAndStoreThemes(_themes)
        {
            // Here we will go through every registered theme one more time
            // and try to simplify their objects as much as possible for
            // easier access to their properties.
            var themes = angular.copy(_themes);

            // Iterate through themes
            angular.forEach(themes, function (theme)
            {
                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorType, colorTypeName)
                {
                    theme[colorTypeName] = colorType.levels;
                    theme[colorTypeName].color = colorType.levels.default.color;
                    theme[colorTypeName].contrast1 = colorType.levels.default.contrast1;
                    theme[colorTypeName].contrast2 = colorType.levels.default.contrast2;
                    theme[colorTypeName].contrast3 = colorType.levels.default.contrast3;
                    theme[colorTypeName].contrast4 = colorType.levels.default.contrast4;
                    delete theme[colorTypeName].default;
                });
            });

            // Store themes and set selected theme for the first time
            fuseTheming.setThemesList(themes);

            // Remember selected theme.
            var selectedTheme = $cookies.get('selectedTheme');

            if ( selectedTheme )
            {
                fuseTheming.setActiveTheme(selectedTheme);
            }
            else
            {
                fuseTheming.setActiveTheme('default');
            }
        }


        /**
         * Render css files
         *
         * @param styleVars
         */
        function render(styleVars)
        {
            var cssTemplate = '/* Content hack because they wont fix */\n/* https://github.com/angular/material/pull/8067 */\n[md-theme="@themeName"] md-content.md-hue-1,\nmd-content.md-@themeName-theme.md-hue-1 {\n    color: @backgroundHue1Contrast1;\n    background-color: @backgroundHue1Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-2,\nmd-content.md-@themeName-theme.md-hue-2 {\n    color: @backgroundHue2Contrast1;\n    background-color: @backgroundHue2Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-3,\n md-content.md-@themeName-theme.md-hue-3 {\n    color: @backgroundHue3Contrast1;\n    background-color: @backgroundHue3Color;\n}\n\n/* Text Colors */\n[md-theme="@themeName"] a {\n    color: @accentDefaultColor;\n}\n\n[md-theme="@themeName"] .secondary-text,\n[md-theme="@themeName"] .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .hint-text,\n[md-theme="@themeName"] .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .fade-text,\n[md-theme="@themeName"] .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Primary */\n[md-theme="@themeName"] .md-primary-bg {\n    background-color: @primaryDefaultColor;\n    color: @primaryDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg .secondary-text,\n[md-theme="@themeName"] .md-primary-bg .icon {\n    color: @primaryDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg .hint-text,\n[md-theme="@themeName"] .md-primary-bg .disabled-text {\n    color: @primaryDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg .fade-text,\n[md-theme="@themeName"] .md-primary-bg .divider {\n    color: @primaryDefaultContrast4;\n}\n\n/* Primary, Hue-1 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 {\n    background-color: @primaryHue1Color;\n    color: @primaryHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .icon {\n    color: @primaryHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .disabled-text {\n    color: @primaryHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .divider {\n    color: @primaryHue1Contrast4;\n}\n\n/* Primary, Hue-2 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 {\n    background-color: @primaryHue2Color;\n    color: @primaryHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .icon {\n    color: @primaryHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .disabled-text {\n    color: @primaryHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .divider {\n    color: @primaryHue2Contrast4;\n}\n\n/* Primary, Hue-3 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 {\n    background-color: @primaryHue3Color;\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .icon {\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .disabled-text {\n    color: @primaryHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .divider {\n    color: @primaryHue3Contrast4;\n}\n\n/* Primary foreground */\n[md-theme="@themeName"] .md-primary-fg {\n    color: @primaryDefaultColor !important;\n}\n\n/* Primary foreground, Hue-1 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-1 {\n    color: @primaryHue1Color !important;\n}\n\n/* Primary foreground, Hue-2 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-2 {\n    color: @primaryHue2Color !important;\n}\n\n/* Primary foreground, Hue-3 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-3 {\n    color: @primaryHue3Color !important;\n}\n\n/* Accent */\n[md-theme="@themeName"] .md-accent-bg {\n    background-color: @accentDefaultColor;\n    color: @accentDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg .secondary-text,\n[md-theme="@themeName"] .md-accent-bg .icon {\n    color: @accentDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg .hint-text,\n[md-theme="@themeName"] .md-accent-bg .disabled-text {\n    color: @accentDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg .fade-text,\n[md-theme="@themeName"] .md-accent-bg .divider {\n    color: @accentDefaultContrast4;\n}\n\n/* Accent, Hue-1 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 {\n    background-color: @accentHue1Color;\n    color: @accentHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .icon {\n    color: @accentHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .disabled-text {\n    color: @accentHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .divider {\n    color: @accentHue1Contrast4;\n}\n\n/* Accent, Hue-2 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 {\n    background-color: @accentHue2Color;\n    color: @accentHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .icon {\n    color: @accentHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .disabled-text {\n    color: @accentHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .divider {\n    color: @accentHue2Contrast4;\n}\n\n/* Accent, Hue-3 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 {\n    background-color: @accentHue3Color;\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .icon {\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .disabled-text {\n    color: @accentHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .divider {\n    color: @accentHue3Contrast4;\n}\n\n/* Accent foreground */\n[md-theme="@themeName"] .md-accent-fg {\n    color: @accentDefaultColor !important;\n}\n\n/* Accent foreground, Hue-1 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-1 {\n    color: @accentHue1Color !important;\n}\n\n/* Accent foreground, Hue-2 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-2 {\n    color: @accentHue2Color !important;\n}\n\n/* Accent foreground, Hue-3 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-3 {\n    color: @accentHue3Color !important;\n}\n\n/* Warn */\n[md-theme="@themeName"] .md-warn-bg {\n    background-color: @warnDefaultColor;\n    color: @warnDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg .secondary-text,\n[md-theme="@themeName"] .md-warn-bg .icon {\n    color: @warnDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg .hint-text,\n[md-theme="@themeName"] .md-warn-bg .disabled-text {\n    color: @warnDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg .fade-text,\n[md-theme="@themeName"] .md-warn-bg .divider {\n    color: @warnDefaultContrast4;\n}\n\n/* Warn, Hue-1 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 {\n    background-color: @warnHue1Color;\n    color: @warnHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .icon {\n    color: @warnHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .disabled-text {\n    color: @warnHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .divider {\n    color: @warnHue1Contrast4;\n}\n\n/* Warn, Hue-2 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 {\n    background-color: @warnHue2Color;\n    color: @warnHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .icon {\n    color: @warnHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .disabled-text {\n    color: @warnHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .divider {\n    color: @warnHue2Contrast4;\n}\n\n/* Warn, Hue-3 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 {\n    background-color: @warnHue3Color;\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .icon {\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .disabled-text {\n    color: @warnHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .divider {\n    color: @warnHue3Contrast4;\n}\n\n/* Warn foreground */\n[md-theme="@themeName"] .md-warn-fg {\n    color: @warnDefaultColor !important;\n}\n\n/* Warn foreground, Hue-1 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-1 {\n    color: @warnHue1Color !important;\n}\n\n/* Warn foreground, Hue-2 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-2 {\n    color: @warnHue2Color !important;\n}\n\n/* Warn foreground, Hue-3 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-3 {\n    color: @warnHue3Color !important;\n}\n\n/* Background */\n[md-theme="@themeName"] .md-background-bg {\n    background-color: @backgroundDefaultColor;\n    color: @backgroundDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg .secondary-text,\n[md-theme="@themeName"] .md-background-bg .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg .hint-text,\n[md-theme="@themeName"] .md-background-bg .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg .fade-text,\n[md-theme="@themeName"] .md-background-bg .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Background, Hue-1 */\n[md-theme="@themeName"] .md-background-bg.md-hue-1 {\n    background-color: @backgroundHue1Color;\n    color: @backgroundHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .icon {\n    color: @backgroundHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .disabled-text {\n    color: @backgroundHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .divider {\n    color: @backgroundHue1Contrast4;\n}\n\n/* Background, Hue-2 */\n[md-theme="@themeName"] .md-background-bg.md-hue-2 {\n    background-color: @backgroundHue2Color;\n    color: @backgroundHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .icon {\n    color: @backgroundHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .disabled-text {\n    color: @backgroundHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .divider {\n    color: @backgroundHue2Contrast4;\n}\n\n/* Background, Hue-3 */\n[md-theme="@themeName"] .md-background-bg.md-hue-3 {\n    background-color: @backgroundHue3Color;\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .icon {\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .disabled-text {\n    color: @backgroundHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .divider {\n    color: @backgroundHue3Contrast4;\n}\n\n/* Background foreground */\n[md-theme="@themeName"] .md-background-fg {\n    color: @backgroundDefaultColor !important;\n}\n\n/* Background foreground, Hue-1 */\n[md-theme="@themeName"] .md-background-fg.md-hue-1 {\n    color: @backgroundHue1Color !important;\n}\n\n/* Background foreground, Hue-2 */\n[md-theme="@themeName"] .md-background-fg.md-hue-2 {\n    color: @backgroundHue2Color !important;\n}\n\n/* Background foreground, Hue-3 */\n[md-theme="@themeName"] .md-background-fg.md-hue-3 {\n    color: @backgroundHue3Color !important;\n}';

            var regex = new RegExp(Object.keys(styleVars).join('|'), 'gi');
            var css = cssTemplate.replace(regex, function (matched)
            {
                return styleVars[matched];
            });

            var headEl = angular.element('head');
            var styleEl = angular.element('<style type="text/css"></style>');
            styleEl.html(css);
            headEl.append(styleEl);
        }

        /**
         * Convert color array to rgb/rgba
         * Also apply contrasts if needed
         *
         * @param color
         * @param _contrastLevel
         * @returns {string}
         */
        function rgba(color, _contrastLevel)
        {
            var contrastLevel = _contrastLevel || false;

            // Convert 255,255,255,0.XX to 255,255,255
            // According to Google's Material design specs, white primary
            // text must have opacity of 1 and we will fix that here
            // because Angular Material doesn't care about that spec
            if ( color.length === 4 && color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color.splice(3, 4);
            }

            // If contrast level provided, apply it to the current color
            if ( contrastLevel )
            {
                color = applyContrast(color, contrastLevel);
            }

            // Convert color array to color string (rgb/rgba)
            if ( color.length === 3 )
            {
                return 'rgb(' + color.join(',') + ')';
            }
            else if ( color.length === 4 )
            {
                return 'rgba(' + color.join(',') + ')';
            }
            else
            {
                $log.error('Invalid number of arguments supplied in the color array: ' + color.length + '\n' + 'The array must have 3 or 4 colors.');
            }
        }

        /**
         * Apply given contrast level to the given color
         *
         * @param color
         * @param contrastLevel
         */
        function applyContrast(color, contrastLevel)
        {
            var contrastLevels = {
                'white': {
                    '1': '1',
                    '2': '0.7',
                    '3': '0.3',
                    '4': '0.12'
                },
                'black': {
                    '1': '0.87',
                    '2': '0.54',
                    '3': '0.26',
                    '4': '0.12'
                }
            };

            // If white
            if ( color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color[3] = contrastLevels.white[contrastLevel];
            }
            // If black
            else if ( color[0] === 0 && color[1] === 0 && color[2] === 0 )
            {
                color[3] = contrastLevels.black[contrastLevel];
            }

            return color;
        }

        /**
         * Uppercase first
         */
        function ucfirst(string)
        {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msUtils', msUtils);

    /** @ngInject */
    function msUtils($window)
    {
        // Private variables
        var mobileDetect = new MobileDetect($window.navigator.userAgent),
            browserInfo = null;

        var service = {
            exists       : exists,
            detectBrowser: detectBrowser,
            guidGenerator: guidGenerator,
            isMobile     : isMobile,
            toggleInArray: toggleInArray
        };

        return service;

        //////////

        /**
         * Check if item exists in a list
         *
         * @param item
         * @param list
         * @returns {boolean}
         */
        function exists(item, list)
        {
            return list.indexOf(item) > -1;
        }

        /**
         * Returns browser information
         * from user agent data
         *
         * Found at http://www.quirksmode.org/js/detect.html
         * but modified and updated to fit for our needs
         */
        function detectBrowser()
        {
            // If we already tested, do not test again
            if ( browserInfo )
            {
                return browserInfo;
            }

            var browserData = [
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Edge',
                    versionSearch: 'Edge',
                    identity     : 'Edge'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Chrome',
                    identity : 'Chrome'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'OmniWeb',
                    versionSearch: 'OmniWeb/',
                    identity     : 'OmniWeb'
                },
                {
                    string       : $window.navigator.vendor,
                    subString    : 'Apple',
                    versionSearch: 'Version',
                    identity     : 'Safari'
                },
                {
                    prop    : $window.opera,
                    identity: 'Opera'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'iCab',
                    identity : 'iCab'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'KDE',
                    identity : 'Konqueror'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Firefox',
                    identity : 'Firefox'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'Camino',
                    identity : 'Camino'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Netscape',
                    identity : 'Netscape'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'MSIE',
                    identity     : 'Explorer',
                    versionSearch: 'MSIE'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Trident/7',
                    identity     : 'Explorer',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Gecko',
                    identity     : 'Mozilla',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Mozilla',
                    identity     : 'Netscape',
                    versionSearch: 'Mozilla'
                }
            ];

            var osData = [
                {
                    string   : $window.navigator.platform,
                    subString: 'Win',
                    identity : 'Windows'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Mac',
                    identity : 'Mac'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Linux',
                    identity : 'Linux'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPhone',
                    identity : 'iPhone'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPod',
                    identity : 'iPod'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPad',
                    identity : 'iPad'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Android',
                    identity : 'Android'
                }
            ];

            var versionSearchString = '';

            function searchString(data)
            {
                for ( var i = 0; i < data.length; i++ )
                {
                    var dataString = data[i].string;
                    var dataProp = data[i].prop;

                    versionSearchString = data[i].versionSearch || data[i].identity;

                    if ( dataString )
                    {
                        if ( dataString.indexOf(data[i].subString) !== -1 )
                        {
                            return data[i].identity;

                        }
                    }
                    else if ( dataProp )
                    {
                        return data[i].identity;
                    }
                }
            }

            function searchVersion(dataString)
            {
                var index = dataString.indexOf(versionSearchString);

                if ( index === -1 )
                {
                    return;
                }

                return parseInt(dataString.substring(index + versionSearchString.length + 1));
            }

            var browser = searchString(browserData) || 'unknown-browser';
            var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || 'unknown-version';
            var os = searchString(osData) || 'unknown-os';

            // Prepare and store the object
            browser = browser.toLowerCase();
            version = browser + '-' + version;
            os = os.toLowerCase();

            browserInfo = {
                browser: browser,
                version: version,
                os     : os
            };

            return browserInfo;
        }

        /**
         * Generates a globally unique id
         *
         * @returns {*}
         */
        function guidGenerator()
        {
            var S4 = function ()
            {
                return (((1 + Math.random()) * 0x10000) || 0).toString(16).substring(1);
            };
            return (S4() + S4() + S4() + S4() + S4() + S4());
        }

        /**
         * Return if current device is a
         * mobile device or not
         */
        function isMobile()
        {
            return mobileDetect.mobile();
        }

        /**
         * Toggle in array (push or splice)
         *
         * @param item
         * @param array
         */
        function toggleInArray(item, array)
        {
            if ( array.indexOf(item) === -1 )
            {
                array.push(item);
            }
            else
            {
                array.splice(array.indexOf(item), 1);
            }
        }
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msApi', msApiProvider);

    /** @ngInject **/
    function msApiProvider()
    {
        /* ----------------- */
        /* Provider          */
        /* ----------------- */
        var provider = this;

        // Inject the $log service
        var $log = angular.injector(['ng']).get('$log');

        // Data
        var baseUrl = '';
        var api = [];

        // Methods
        provider.setBaseUrl = setBaseUrl;
        provider.getBaseUrl = getBaseUrl;
        provider.getApiObject = getApiObject;
        provider.register = register;

        //////////

        /**
         * Set base url for API endpoints
         *
         * @param url {string}
         */
        function setBaseUrl(url)
        {
            baseUrl = url;
        }

        /**
         * Return the base url
         *
         * @returns {string}
         */
        function getBaseUrl()
        {
            return baseUrl;
        }

        /**
         * Return the api object
         *
         * @returns {object}
         */
        function getApiObject()
        {
            return api;
        }

        /**
         * Register API endpoint
         *
         * @param key
         * @param resource
         */
        function register(key, resource)
        {
            if ( !angular.isString(key) )
            {
                $log.error('"path" must be a string (eg. `dashboard.project`)');
                return;
            }

            if ( !angular.isArray(resource) )
            {
                $log.error('"resource" must be an array and it must follow $resource definition');
                return;
            }

            // Store the API object
            api[key] = {
                url          : baseUrl + (resource[0] || ''),
                paramDefaults: resource[1] || [],
                actions      : resource[2] || [],
                options      : resource[3] || {}
            };
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */
        this.$get = function ($log, $q, $resource, $rootScope)
        {
            // Data

            // Methods
            var service = {
                setBaseUrl: setBaseUrl,
                getBaseUrl: getBaseUrl,
                register  : register,
                resolve   : resolve,
                request   : request
            };

            return service;

            //////////

            /**
             * Resolve an API endpoint
             *
             * @param action {string}
             * @param parameters {object}
             * @returns {promise|boolean}
             */
            function resolve(action, parameters)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::resolveStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // Success
                        function (response)
                        {
                            deferred.resolve(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveSuccess');
                        },

                        // Error
                        function (response)
                        {
                            deferred.reject(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveError');
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }

            /**
             * Make a request to an API endpoint
             *
             * @param action {string}
             * @param [parameters] {object}
             * @param [success] {function}
             * @param [error] {function}
             *
             * @returns {promise|boolean}
             */
            function request(action, parameters, success, error)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::requestStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // SUCCESS
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestSuccess');
                            
                            // Resolve the promise
                            deferred.resolve(response);

                            // Call the success function if there is one
                            if ( angular.isDefined(success) && angular.isFunction(success) )
                            {
                                success(response);
                            }
                        },

                        // ERROR
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestError');
                            
                            // Reject the promise
                            deferred.reject(response);

                            // Call the error function if there is one
                            if ( angular.isDefined(error) && angular.isFunction(error) )
                            {
                                error(response);
                            }
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('apiResolver', apiResolverService);

    /** @ngInject */
    function apiResolverService($q, $log, api)
    {
        var service = {
            resolve: resolve
        };

        return service;

        //////////
        /**
         * Resolve api
         * @param action
         * @param parameters
         */
        function resolve(action, parameters)
        {
            var actionParts = action.split('@'),
                resource = actionParts[0],
                method = actionParts[1],
                params = parameters || {};

            if ( !resource || !method )
            {
                $log.error('apiResolver.resolve requires correct action parameter (ResourceName@methodName)');
                return false;
            }

            // Create a new deferred object
            var deferred = $q.defer();

            // Get the correct api object from api service
            var apiObject = getApiObject(resource);

            if ( !apiObject )
            {
                $log.error('Resource "' + resource + '" is not defined in the api service!');
                deferred.reject('Resource "' + resource + '" is not defined in the api service!');
            }
            else
            {
                apiObject[method](params,

                    // Success
                    function (response)
                    {
                        deferred.resolve(response);
                    },

                    // Error
                    function (response)
                    {
                        deferred.reject(response);
                    }
                );
            }

            // Return the promise
            return deferred.promise;
        }

        /**
         * Get correct api object
         *
         * @param resource
         * @returns {*}
         */
        function getApiObject(resource)
        {
            // Split the resource in case if we have a dot notated object
            var resourceParts = resource.split('.'),
                apiObject = api;

            // Loop through the resource parts and go all the way through
            // the api object and return the correct one
            for ( var l = 0; l < resourceParts.length; l++ )
            {
                if ( angular.isUndefined(apiObject[resourceParts[l]]) )
                {
                    $log.error('Resource part "' + resourceParts[l] + '" is not defined!');
                    apiObject = false;
                    break;
                }

                apiObject = apiObject[resourceParts[l]];
            }

            if ( !apiObject )
            {
                return false;
            }

            return apiObject;
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseConfig', fuseConfigProvider);

    /** @ngInject */
    function fuseConfigProvider()
    {
        // Default configuration
        var fuseConfiguration = {
            'disableCustomScrollbars'        : false,
            'disableMdInkRippleOnMobile'     : true,
            'disableCustomScrollbarsOnMobile': true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            fuseConfiguration = angular.extend({}, fuseConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig,
                setConfig: setConfig
            };

            return service;

            //////////

            /**
             * Returns a config value
             */
            function getConfig(configName)
            {
                if ( angular.isUndefined(fuseConfiguration[configName]) )
                {
                    return false;
                }

                return fuseConfiguration[configName];
            }

            /**
             * Creates or updates config object
             *
             * @param configName
             * @param configValue
             */
            function setConfig(configName, configValue)
            {
                fuseConfiguration[configName] = configValue;
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByTags', filterByTags)
        .filter('filterSingleByTags', filterSingleByTags);

    /** @ngInject */
    function filterByTags()
    {
        return function (items, tags)
        {
            if ( items.length === 0 || tags.length === 0 )
            {
                return items;
            }

            var filtered = [];

            items.forEach(function (item)
            {
                var match = tags.every(function (tag)
                {
                    var tagExists = false;

                    item.tags.forEach(function (itemTag)
                    {
                        if ( itemTag.name === tag.name )
                        {
                            tagExists = true;
                            return;
                        }
                    });

                    return tagExists;
                });

                if ( match )
                {
                    filtered.push(item);
                }
            });

            return filtered;
        };
    }

    /** @ngInject */
    function filterSingleByTags()
    {
        return function (itemTags, tags)
        {
            if ( itemTags.length === 0 || tags.length === 0 )
            {
                return;
            }

            if ( itemTags.length < tags.length )
            {
                return [];
            }

            var filtered = [];

            var match = tags.every(function (tag)
            {
                var tagExists = false;

                itemTags.forEach(function (itemTag)
                {
                    if ( itemTag.name === tag.name )
                    {
                        tagExists = true;
                        return;
                    }
                });

                return tagExists;
            });

            if ( match )
            {
                filtered.push(itemTags);
            }

            return filtered;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByPropIds', filterByPropIds);

    /** @ngInject */
    function filterByPropIds()
    {
        return function (items, parameter, ids)
        {
            if ( items.length === 0 || !ids || ids.length === 0 )
            {
                return items;
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item[parameter].indexOf(id) > -1 )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByIds', filterByIds);

    /** @ngInject */
    function filterByIds()
    {
        return function (items, ids)
        {

            if ( items.length === 0 || !ids )
            {
                return items;
            }

            if ( ids.length === 0 )
            {
                return [];
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item.id === id )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('toTrusted', toTrustedFilter)
        .filter('htmlToPlaintext', htmlToPlainTextFilter)
        .filter('nospace', nospaceFilter)
        .filter('humanizeDoc', humanizeDocFilter);

    /** @ngInject */
    function toTrustedFilter($sce)
    {
        return function (value)
        {
            return $sce.trustAsHtml(value);
        };
    }

    /** @ngInject */
    function htmlToPlainTextFilter()
    {
        return function (text)
        {
            return String(text).replace(/<[^>]+>/gm, '');
        };
    }

    /** @ngInject */
    function nospaceFilter()
    {
        return function (value)
        {
            return (!value) ? '' : value.replace(/ /g, '');
        };
    }

    /** @ngInject */
    function humanizeDocFilter()
    {
        return function (doc)
        {
            if ( !doc )
            {
                return;
            }
            if ( doc.type === 'directive' )
            {
                return doc.name.replace(/([A-Z])/g, function ($1)
                {
                    return '-' + $1.toLowerCase();
                });
            }
            return doc.label || doc.name;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('altDate', altDate);

    /** @ngInject */
    function altDate()
    {
        return function (value)
        {
            var diff = Date.now() - new Date(value);

            /**
             * If in a hour
             * e.g. "2 minutes ago"
             */
            if ( diff < (60 * 60 * 1000) )
            {
                return moment(value).fromNow();
            }
            /*
             * If in the day
             * e.g. "11:23"
             */
            else if ( diff < (60 * 60 * 24 * 1000) )
            {
                return moment(value).format('HH:mm');
            }
            /*
             * If in week
             * e.g "Tuesday"
             */
            else if ( diff < (60 * 60 * 24 * 7 * 1000) )
            {
                return moment(value).format('dddd');
            }
            /*
             * If more than a week
             * e.g. 03/29/2016
             */
            else
            {
                return moment(value).calendar();
            }

        };
    }

})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('hljs', hljsDirective);

    /** @ngInject */
    function hljsDirective($timeout, $q, $interpolate) {
        return {
            restrict: 'E',
            compile : function (element, attr) {
                var code;
                //No attribute? code is the content
                if (!attr.code) {
                    code = element.html();
                    element.empty();
                }

                return function (scope, element, attr) {

                    if (attr.code) {
                        // Attribute? code is the evaluation
                        code = scope.$eval(attr.code);
                    }
                    var shouldInterpolate = scope.$eval(attr.shouldInterpolate);

                    $q.when(code).then(function (code) {
                        if (code) {
                            if (shouldInterpolate) {
                                code = $interpolate(code)(scope);
                            }
                            var contentParent = angular.element(
                                '<pre><code class="highlight" ng-non-bindable></code></pre>'
                            );
                            element.append(contentParent);
                            // Defer highlighting 1-frame to prevent GA interference...
                            $timeout(function () {
                                render(code, contentParent);
                            }, 34, false);
                        }
                    });

                    function render(contents, parent) {

                        var codeElement = parent.find('code');
                        var lines = contents.split('\n');

                        // Remove empty lines
                        lines = lines.filter(function (line) {
                            return line.trim().length;
                        });

                        // Make it so each line starts at 0 whitespace
                        var firstLineWhitespace = lines[0].match(/^\s*/)[0];
                        var startingWhitespaceRegex = new RegExp('^' + firstLineWhitespace);
                        lines = lines.map(function (line) {
                            return line
                                .replace(startingWhitespaceRegex, '')
                                .replace(/\s+$/, '');
                        });

                        var highlightedCode = hljs.highlight(attr.language || attr.lang, lines.join('\n'), true);
                        highlightedCode.value = highlightedCode.value
                            .replace(/=<span class="hljs-value">""<\/span>/gi, '')
                            .replace('<head>', '')
                            .replace('<head/>', '');
                        codeElement.append(highlightedCode.value).addClass('highlight');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.toolbar', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        $translatePartialLoaderProvider.addPart('app/toolbar');
    }
})();

(function () {
    'use strict';

    angular
        .module('app.toolbar')
        .controller('ToolbarController', ToolbarController);

    /** @ngInject */
    function ToolbarController($rootScope, $q, api, $state,
        $timeout, $mdSidenav, $translate, $mdToast, msNavigationService, $mdMenu, $auth,
        localStorageService, APPNAME, APPINITIALS, envService, $filter, ICON_APP_NAME) {

        var vm = this;
        vm.urlIcons = envService.read('imagesApps');
        vm.urlIconsFull = envService.read('imagesApps') + ICON_APP_NAME;

        // Data
        $rootScope.global = {
            search: ''
        };

        vm.app = {
            initials: APPINITIALS,
            name: APPNAME
        };

        $rootScope.account = localStorageService.get('account');
        vm.bodyEl = angular.element('body');

        vm.userStatusOptions = [];
        vm.languages = {
            es: {
                'title': 'Spanish',
                'translation': 'TOOLBAR.SPANISH',
                'code': 'es',
                'flag': 'es'
            },
            esHN: {
                'title': 'Spanish(Honduras)',
                'translation': 'TOOLBAR.SPANISH_HN',
                'code': 'es-hn',
                'flag': 'hn'
            },
            en: {
                'title': 'English',
                'translation': 'TOOLBAR.ENGLISH',
                'code': 'en',
                'flag': 'us'
            }
        };

        // Methods
        vm.toggleSidenav = toggleSidenav;
        vm.logout = logout;
        vm.changeLanguage = changeLanguage;
        vm.setUserStatus = setUserStatus;
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;
        vm.search = search;
        vm.changeApp = changeApp;
        vm.getImageApp = getImageApp;
        vm.openRoles = openRoles;
        vm.openManual = openManual;
        vm.searchResultClick = searchResultClick;
        vm.changeCircle = changeCircle;


        //////////

        init();

        /**
         * Initialize
         */
        function init() {
            // Select the first status as a default
            vm.selectedLanguage = vm.languages[$translate.use()];
            $rootScope.currentTranslateLang = vm.selectedLanguage ? vm.selectedLanguage.code : 'es';
            loadApps();
        }


        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Sets User Status
         * @param status
         */
        function setUserStatus(status) {
            vm.userStatus = status;
        }

        function getImageApp(name) {
            return vm.urlIcons + name.split(' ').join('');
        }

        function changeApp(app) {
            if (app.url !== null && app.url) {
                window.open(app.url);
            }

        }

        function openRoles(e) {
            $state.go('app.role');
            $mdMenu.hide();
            $mdMenu.hide();
        }

        /**
         * Logout Function
         */
        function logout() {
            // Do logout here..
            logoutFinish($auth, $state, 'auth.login');
            localStorageService.remove('account');
            localStorageService.remove('accountc');
            localStorageService.remove('circles');
            localStorageService.remove('userParameters');

            delete $rootScope.bsCircle;
            delete $rootScope.circles;
            delete $rootScope.userParameters;

            if ($rootScope.userListenerEvent) {
                $rootScope.userListenerEvent.close();
            }
        }

        function loadApps() {
            api.GeneralWS.ApplicationByUser.query({}).$promise.then(
                function (response) {
                    response = $filter('orderBy')(response, 'sortOrderApp');
                    vm.apps = response;
                    $rootScope.myApps = response;
                },
                function (err) {

                }
            );
        }

        function changeCircle(c) {
            $rootScope.bsCircle = c;

            localStorageService.set('accountc', $rootScope.bsCircle);
            $rootScope.msNotificationArray = [];
            $rootScope.totalNumberOfNotifications = 0;

            if ($state.is('app.dashboards_project')) {
                $state.reload();
            } else {
                $state.go('app.dashboards_project', {}, { reload: true });
            }
        }

        function openManual(link) {
            window.open(link);
        }

        function changeLanguage(lang) {
            vm.selectedLanguage = lang;
            $translate.use(lang.code);
            $rootScope.currentTranslateLang = vm.selectedLanguage.code;
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu() {
            vm.bodyEl.toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }

        /**
         * Toggle msNavigation folded
         */
        function toggleMsNavigationFolded() {
            msNavigationService.toggleFolded();
        }

        /**
         * Search action
         *
         * @param query
         * @returns {Promise}
         */
        function search(query) {
            var navigation = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for (var x = 0; x < flatNavigation.length; x++) {
                if (flatNavigation[x].uisref) {
                    navigation.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the navigation;
            // otherwise we will return the entire navigation
            // list. Not exactly a good thing to do but it's
            // for demo purposes.
            if (query) {
                navigation = navigation.filter(function (item) {
                    if (angular.lowercase(item.title).search(angular.lowercase(query)) > -1) {
                        return true;
                    }
                });
            }

            // Fake service delay
            $timeout(function () {
                deferred.resolve(navigation);
            }, 1000);

            return deferred.promise;
        }

        /**
         * Search result click action
         *
         * @param item
         */
        function searchResultClick(item) {
            // If item has a link
            if (item.uisref) {
                // If there are state params,
                // use them...
                if (item.stateParams) {
                    $state.go(item.state, item.stateParams);
                } else {
                    $state.go(item.state);
                }
            }
        }


    }

})();

(function () {
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('QuickPanelController', QuickPanelController);

    /** @ngInject */
    function QuickPanelController($q, APPNAME, api, $rootScope, $timeout, $mdSidenav, $state, $mdDialog) {
        var vm = this;

        $rootScope.totalNumberOfNotifications = 0;
        vm.appNotificationArray = [];
        vm.userNotificationArray = [];

        //metodos
        vm.showAllMyNotifications = showAllMyNotifications;
        vm.showNotification = showNotification;
        vm.goToUserNotificationConfiguration = goToUserNotificationConfiguration;

        function getCurrentNotifications() {

            var defered = $q.defer();
            var promise = defered.promise;

            var numberOfRequest = 2;
            var numberOfRequestCompleted = 0;

            if ($rootScope.bsCircle) {
                api.NotificacionesWS.Notification.pageOfCurrentNotifications.page({
                    'circleId': $rootScope.bsCircle.id, 'pageNumber': 1, 'pageSize': 50
                })
                    .$promise.then(function (response) {

                        vm.appNotificationArray = response.content;
                        $rootScope.totalNumberOfNotifications += response.totalElements;

                        numberOfRequestCompleted += 1;

                        if (numberOfRequest === numberOfRequestCompleted) {
                            defered.resolve(true);
                        }

                    }, function (response) {
                        numberOfRequestCompleted += 1;

                        if (numberOfRequest === numberOfRequestCompleted) {
                            defered.resolve(true);
                        }

                    });

                api.NotificacionesWS.UserNotification.pageOfUnreadNotifications.page({
                    'circleId': $rootScope.bsCircle.id, 'pageNumber': 1, 'pageSize': 50
                })
                    .$promise.then(function (response) {

                        $rootScope.totalNumberOfNotifications += response.totalElements;

                        response.content.forEach(function (row) {
                            row.isUserNotification = true;

                            row.longTime = new Date(row.createdAt.year,
                                row.createdAt.monthValue,
                                row.createdAt.dayOfMonth,
                                row.createdAt.hour,
                                row.createdAt.minute,
                                row.createdAt.second).getTime();

                            if (row.applicationName === APPNAME) {
                                row.appPriorityNumber = 1;
                            } else {
                                row.appPriorityNumber = 2;
                            }

                            switch (row.notificationPriority) {
                                case 'HIGH':
                                    row.priorityNumber = 1;
                                    break;
                                case 'MEDIUM':
                                    row.priorityNumber = 2;
                                    break;
                                case 'LOW':
                                    row.priorityNumber = 3;
                                    break;
                                default:
                                    break;
                            }
                            vm.userNotificationArray.push(row);
                        });

                        numberOfRequestCompleted += 1;

                        if (numberOfRequest === numberOfRequestCompleted) {
                            defered.resolve(true);
                        }

                    }, function (response) {
                        numberOfRequestCompleted += 1;

                        if (numberOfRequest === numberOfRequestCompleted) {
                            defered.resolve(true);
                        }

                    });

            } else {
                defered.resolve(true);
            }

            return promise;

        }


        function processData() {

            getCurrentNotifications().then(function (response) {

                if ($rootScope.msNotificationArray === null || $rootScope.msNotificationArray === undefined) {
                    $rootScope.msNotificationArray = [];
                }

                $rootScope.msNotificationArray = $rootScope.msNotificationArray.concat(vm.appNotificationArray);

                var filterResult = new jinqJs()
                    .from(vm.userNotificationArray)
                    .orderBy([{ field: 'appPriorityNumber', sort: 'asc' }, { field: 'priorityNumber' }, { field: 'longTime' }])
                    .select();

                $rootScope.msNotificationArray = $rootScope.msNotificationArray.concat(filterResult);

            });

        }

        function goToUserNotificationConfiguration() {
            $state.go('app.notifications.Configuration');
            $mdSidenav('quick-panel').close();
        }

        function showAllMyNotifications() {
            $state.go('app.notifications.MyNotifications');
            $mdSidenav('quick-panel').close();
        }

        function markAsRead(notification, notificationIndex) {

            var _notificationIdArray = [notification.id];

            $rootScope.loadingProgress = true;
            api.NotificacionesWS.UserNotification.markAsRead.update({
                'circleId': $rootScope.bsCircle.id
            }, _notificationIdArray)
                .$promise.then(function (response) {
                    $rootScope.loadingProgress = false;

                    $rootScope.msNotificationArray.splice(notificationIndex, 1);
                    $rootScope.totalNumberOfNotifications -= 1;

                }, function (response) {
                    $rootScope.loadingProgress = false;
                });

        }

        function showNotification(event, notification, index) {

            $mdSidenav('quick-panel').close();

            if (notification.originType !== null
                && notification.originType !== undefined
                && notification.originType.queryUrl !== null
                && notification.originType.queryUrl !== undefined
                && notification.originType.queryUrl !== "") {

                markAsRead(notification, index);

                var url = notification.originType.queryUrl + notification.referenceNumber;

                window.open(url, "_blank");

                return;

            }

            $mdDialog.show({
                controller: 'ViewNotificationController',
                controllerAs: 'vm',
                locals: {
                    'notification': notification,
                    'notificationIndex': index
                },
                templateUrl: 'app/quick-panel/tabs/my-notifications/view-notification/view-notification.html',
                parent: angular.element("#main"),
                targetEvent: event,
                clickOutsideToClose: false
            }).then(function (response) {

            }, function () {
            });

        }

        function init() {
            processData();
        }

        $timeout(init, 1000);

    }

})();

(function () {
    'use strict';

    angular
        .module('app.navigation', [])
        .config(config);

    /** @ngInject */
    function config() {

    }

})();

(function () {
    'use strict';

    angular
        .module('app.navigation')
        .controller('NavigationController', NavigationController);

    /** @ngInject */
    function NavigationController($rootScope, $scope, localStorageService, APPNAME, APPINITIALS) {
        var vm = this;
        $rootScope.account = localStorageService.get('account');

        vm.app = {
            initials: APPINITIALS,
            name: APPNAME
        };

        // Data
        vm.bodyEl = angular.element('body');
        vm.folded = false;
        vm.msScrollOptions = {
            suppressScrollX: true
        };

        // Methods
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;

        //////////

        /**
         * Toggle folded status
         */
        function toggleMsNavigationFolded() {
            vm.folded = !vm.folded;
        }

        // Close the mobile menu on $stateChangeSuccess
        $scope.$on('$stateChangeSuccess', function () {
            vm.bodyEl.removeClass('ms-navigation-horizontal-mobile-menu-active');
        });
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .run(runBlock);

    /** @ngInject */
    function runBlock(msUtils, fuseGenerator, fuseConfig)
    {
        /**
         * Generate extra classes based on registered themes so we
         * can use same colors with non-angular-material elements
         */
        fuseGenerator.generate();

        /**
         * Disable md-ink-ripple effects on mobile
         * if 'disableMdInkRippleOnMobile' config enabled
         */
        if ( fuseConfig.getConfig('disableMdInkRippleOnMobile') && msUtils.isMobile() )
        {
            var bodyEl = angular.element('body');
            bodyEl.attr('md-no-ink', true);
        }

        /**
         * Put isMobile() to the html as a class
         */
        if ( msUtils.isMobile() )
        {
            angular.element('html').addClass('is-mobile');
        }

        /**
         * Put browser information to the html as a class
         */
        var browserInfo = msUtils.detectBrowser();
        if ( browserInfo )
        {
            var htmlClass = browserInfo.browser + ' ' + browserInfo.version + ' ' + browserInfo.os;
            angular.element('html').addClass(htmlClass);
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($ariaProvider, $logProvider, msScrollConfigProvider, fuseConfigProvider)
    {
        // Enable debug logging
        $logProvider.debugEnabled(false);

        /*eslint-disable */

        // ng-aria configuration
        $ariaProvider.config({
            tabindex: false
        });

        // Fuse theme configurations
        fuseConfigProvider.config({
            'disableCustomScrollbars'        : false,
            'disableCustomScrollbarsOnMobile': true,
            'disableMdInkRippleOnMobile'     : true
        });

        // msScroll configuration
        msScrollConfigProvider.config({
            wheelPropagation: true
        });

        /*eslint-enable */
    }
})();
function translateGrid(key, defaultValue, $filter) {

    // to avoid key clash with external keys, we add 'grid' to the start of each key.
    var gridKey = 'GRID.' + key;

    // look the value up. here we use the AngularJS 1.x $filter service, however you can use whatever
    // service you want, AngularJS 1.x or otherwise.
    var value = $filter('translate')(gridKey);
    return value === gridKey ? defaultValue : value;
}

function getHeader(name) {
    return '{{\'' + name.value + '\'|translate}}';
}

function getHeaderMenu(a, $filter) {
    a.columnApi.getAllColumns().forEach(function (r) {
        r.colDef.hN = r.colDef.hN ? r.colDef.hN : angular.copy(r.colDef.headerName);
        r.colDef.headerName = $filter('translate')(r.colDef.hN);
    });
    return a.defaultItems;
}

function agGridFormatToExport(params, $filter) {
    if (params.column.colId.indexOf("createdAt") !== -1) {
        return $filter('apiDate')(params.value, 'dd/MM/yyyy HH:mm:ss');
    }

    if (params.column.colId.indexOf("fecha") !== -1) {
        return $filter('date')(params.value, 'dd/MM/yyyy');
    } else {
        return params.value;
    }
}

function logoutFinish($auth, $state, redirect) {
    $auth.logout('OIDC').then(function () {
    }, function (out) {
        $state.go(redirect);
    });
}

function convertInvoicePurchaseDTOtoEntityStructure(data) {
    if (!data) {
        return data;
    }

    const invoicePurchaseEntity = {
        id: data.id,
        vatReceived: data.vatReceived,
        totalBeforeTax: data.totalBeforeTax,
        documentTotalAfterTax: data.documentTotalAfterTax,
        documentTotalBeforeTax: data.documentTotalBeforeTax,
        exchangeRate: data.exchangeRate,
        uuid: data.uuid,
        electronicSignature: data.electronicSignature,
        controlNumber: data.controlNumber,
        correlative: data.correlative,
        dateInvoicePurchase: data.dateInvoicePurchase,
        dateInvoiceAccounting: data.dateInvoiceAccounting,
        loadedPOS: data.loadedPOS,
        loadedPOSDate: data.loadedPOSDate,
        limitDateException: data.limitDateException,
        invoicePurchaseType: data.invoicePurchaseType,
        documentComposedCode: data.documentComposedCode,
        quotationFileId: data.quotationFileId,
        companyProvider: {
            id: data.companyProviderId,
            businessName: data.companyProviderBusinessName,
            address: data.companyProviderAddress,
            phone: data.companyProviderPhone,
            email: data.companyProviderEmail,
            webPage: data.companyProviderWebPage,
            isExternalProvider: data.companyProviderIsExternalProvider,
            companyCategoryId: data.companyProviderCompanyCategoryId,
        },
        companyBuyer: {
            id: data.companyBuyerId,
            name: data.companyBuyerName,
            country: {
                id: data.companyBuyerCountryId,
                name: data.companyBuyerCountryName,
            },
        },
        regime: {
            id: data.regimeId,
            code: data.regimeCode,
            name: data.regimeName,
        },
        purchaseStatus: {
            id: data.purchaseStatusId,
            description: data.purchaseStatusDescription,
        },
        invoiceSerie: {
            id: data.invoiceSerieId,
            invoiceSerieDocumentType: data.invoiceSerieDocumentType,
            serie: data.invoiceSerieSerie,
            electronicInvoice: data.invoiceSerieElectronicInvoice,
        },
        currency: {
            id: data.currencyId,
            description: data.currencyDescription,
            symbol: data.currencySymbol,
        }
    };

    if (data.documentRejectionId && data.documentRejectionId > 0) {
      invoicePurchaseEntity.documentRejection = {
        id: data. documentRejectionId,
        reason: data.documentRejectionReason
      }
    }

    if (!data.invoiceSerieId) {
      invoicePurchaseEntity.invoiceSerie =  null;
    }

    const detailEntities = [];
    if (!data.details) {
        data.details = [];
    }

    data.details.forEach(function (detail) {
        const detailEntity = {
            id: detail.id,
            productCodeErp1: detail.productCodeErp1,
            description: detail.description,
            subTotalBeforeTax: detail.subTotalBeforeTax,
            subTotalAfterTax: detail.subTotalAfterTax,
            priceBeforeTax: detail.priceBeforeTax,
            priceAfterTax: detail.priceAfterTax,
            documentSubTotalAfterTax: detail.documentSubTotalAfterTax,
            foreignSubTotalAfterTax: detail.foreignSubTotalAfterTax,
            discountBeforeTax: detail.discountBeforeTax,
            discountAfterTax: detail.discountAfterTax,
            quantity: detail.quantity,
            isExento: detail.isExento,
            taxIsNoDeductible: detail.taxIsNoDeductible,
            product: {
                id: detail.productId,
                name: detail.productName,
            },
            merchandiseEntry: {
                id: detail.merchandiseEntryId,
                merchandiseHeader: {
                    noPayment: detail.noPayment,
                },
                purchaseOrderDetail: {
                    id: detail.purchaseOrderDetailId,
                    quantity: detail.purchaseOrderDetailQuantity,
                    purchaseOrder: {
                        id: detail.purchaseOrderId,
                        company: {
                            id: detail.purchaseOrderCompanyId,
                        },
                        companyProvider: {
                            id: detail.purchaseOrderCompanyProviderId,
                        },
                        department: {
                            id: detail.departmentId,
                            description: detail.departmentDescription,
                        },
                        costCenter: {
                            id: detail.costCenterId,
                            description: detail.costCenterDescription,
                        },
                        dimensionCompanyDetail3: {
                            id: detail.dimensionCompanyDetail3Id,
                            name: detail.dimensionCompanyDetail3Name,
                        },
                        dimensionCompanyDetail4: {
                            id: detail.dimensionCompanyDetail4Id,
                            name: detail.dimensionCompanyDetail4Name,
                        },
                        dimensionCompanyDetail5: {
                            id: detail.dimensionCompanyDetail5Id,
                            name: detail.dimensionCompanyDetail5Name,
                        },
                    },
                    quotationDetail: {
                        id: detail.quotationDetailId,
                        isFixedAsset: detail.quotationDetailIsFixedAsset,
                      taxesIncluded: detail.quotationDetailTaxesIncluded
                    },
                    contractPurchaseDetail: {
                        id: detail.contractPurchaseDetailId,
                        total: detail.contractPurchaseDetailTotal,
                        exchangeRateCompanyBuyer: detail.contractPurchaseDetailExchangeRateCompanyBuyer,
                        currencyCompanyBuyer: {
                            id: detail.contractPurchaseDetailCurrencyCompanyBuyerId,
                        },
                        product: {
                            id: detail.contractPurchaseDetailProductId,
                        },
                        contractPurchase: {
                            id: detail.contractPurchaseId,
                            fixed: detail.contractPurchaseFixed,
                        },
                      taxesIncluded: detail.contractPurchaseDetailTaxesIncluded
                    },
                },
            },
            invoicePurchase: {
                companyCurrency: {
                    symbol: detail.companyCurrencySymbol,
                },
                foreignCurrency: {
                    symbol: detail.foreignCurrencySymbol,
                },
                currency: {
                    symbol: detail.invoicePurchaseCurrencySymbol,
                },
            },
          contractPurchaseDetailTaxesIncluded: detail.contractPurchaseDetailTaxesIncluded,
          quotationDetailTaxesIncluded: detail.quotationDetailTaxesIncluded
        };

        if (detail.contractPurchaseFixed !== undefined || detail.contractPurchaseFixed !== null) {
          detailEntity.contractPurchaseFixed = detail.contractPurchaseFixed;
        }

        if (detail.quotationDetailId === undefined) {
          detailEntity.merchandiseEntry.purchaseOrderDetail.quotationDetail = null;
        }
        if (!detail.contractPurchaseDetailId) {
          detailEntity.merchandiseEntry.purchaseOrderDetail.contractPurchaseDetail = null;
        }
        if (!detail.purchaseOrderDetailId) {
          detailEntity.merchandiseEntry.purchaseOrderDetail = null;
        }

        detailEntities.push({ invoicePurchaseDetail: detailEntity });
    });

    return {
        invoicePurchase: invoicePurchaseEntity,
        details: detailEntities,
        invoicePurchaseWithholdings: data.invoicePurchaseWithholdings,
    };
}

(function () {
  "use strict";

  /**
   * Main module of the Fuse
   */
  angular.module("fuse", [
    // Core
    "app.core",
    // Common
    "app.common",
    // Navigation
    "app.navigation",
    // Toolbar
    "app.toolbar",
    // Quick panel
    "app.quick-panel",
    // Apps
    "app.dashboards",
    //module for Purchase
    "app.requisition",
    "app.reports",
    "app.order",
    "app.expenseSettlement",
    "app.accountStatus",
    //Generales
    "app.general",
    "app.merchandiseEntry",
    "app.invoice",

    "app.quotation",
    //module for Sale
    //'app.sale',
    "app.expenseSettlement",
    "app.contract",
    "app.configuration",
    "app.generalReports",
    //files
    "app.files",
    //pagos
    "app.physicalDocumentDelivery",
    //ordenes de envío
    "app.shippingOrder",

    "app.returns",
  ]);
})();

(function () {
    'use strict';

    agGrid.initialiseAgGridWithAngular1(angular);
    agGrid.LicenseManager.setLicenseKey("CompanyName=MPRH, S.A.,LicensedApplication=Multi,LicenseType=SingleApplication,LicensedConcurrentDeveloperCount=1,LicensedProductionInstancesCount=0,AssetReference=AG-026056,ExpiryDate=7_April_2023_[v2]_MTY4MDgyMjAwMDAwMA==00d2d5b8ad66ae62b0774f46af5c430c");

    angular
        .module('fuse')
        .config(config);

    /** @ngInject */
    function config($mdIconProvider, $mdDateLocaleProvider, $httpProvider, APPNAME, IdleProvider, KeepaliveProvider, localStorageServiceProvider,
        $translateProvider, $provide, $translatePartialLoaderProvider) {
        // configure Idle settings
        IdleProvider.idle(15 * 60); // 1 minutes idle - tiempo inactividad
        IdleProvider.timeout(15); // after 30 seconds idle, time the user out - tiempo para vencer luego de inactividad aqui dispara los warning cada segundo
        KeepaliveProvider.interval(10 * 60); // 1 minute keep-alive ping - intervalo para accion para mantener vivo

        localStorageServiceProvider
            .setPrefix(APPNAME.split(' ').join(''))
            .setStorageType('sessionStorage')
            .setNotify(true, true);

        // angular-translate configuration
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: '{part}/i18n/{lang}.json'
        });
        $translateProvider.preferredLanguage('es');
        $translateProvider.useSanitizeValueStrategy('sanitize');

        // Text Angular options
        $provide.decorator('taOptions', [
            '$delegate', function (taOptions) {
                taOptions.toolbar = [
                    ['bold', 'italics', 'underline', 'ul', 'ol', 'quote', 'wordcount', 'charcount']
                ];

                taOptions.classes = {
                    focussed: 'focussed',
                    toolbar: 'ta-toolbar',
                    toolbarGroup: 'ta-group',
                    toolbarButton: 'md-button',
                    toolbarButtonActive: 'active',
                    disabled: '',
                    textEditor: 'form-control',
                    htmlEditor: 'form-control'
                };

                return taOptions;
            }
        ]);

        // Text Angular tools
        $provide.decorator('taTools', [
            '$delegate', function (taTools) {
                taTools.quote.iconclass = 'icon-format-quote';
                taTools.bold.iconclass = 'icon-format-bold';
                taTools.italics.iconclass = 'icon-format-italic';
                taTools.underline.iconclass = 'icon-format-underline';
                taTools.strikeThrough.iconclass = 'icon-format-strikethrough';
                taTools.ul.iconclass = 'icon-format-list-bulleted';
                taTools.ol.iconclass = 'icon-format-list-numbers';
                taTools.redo.iconclass = 'icon-redo';
                taTools.undo.iconclass = 'icon-undo';
                taTools.clear.iconclass = 'icon-close-circle-outline';
                taTools.justifyLeft.iconclass = 'icon-format-align-left';
                taTools.justifyCenter.iconclass = 'icon-format-align-center';
                taTools.justifyRight.iconclass = 'icon-format-align-right';
                taTools.justifyFull.iconclass = 'icon-format-align-justify';
                taTools.indent.iconclass = 'icon-format-indent-increase';
                taTools.outdent.iconclass = 'icon-format-indent-decrease';
                taTools.html.iconclass = 'icon-code-tags';
                taTools.insertImage.iconclass = 'icon-file-image-box';
                taTools.insertLink.iconclass = 'icon-link';
                taTools.insertVideo.iconclass = 'icon-filmstrip';

                return taTools;
            }
        ]);

        $mdDateLocaleProvider.formatDate = function (date) {
            return moment(date).format('DD-MM-YYYY');
        };

        $translatePartialLoaderProvider.addPart('app/common');

        $mdIconProvider
            .defaultIconSet('assets/angular-material-assets/img/icons/mdi.svg');

        $httpProvider.interceptors.push(function ($q, $cookies, $log, $rootScope) {
            return {
                'request': function (config) {
                    if (config.url.indexOf('http') !== -1) {
                        if (config.params) {
                            config.params.apprequest = APPNAME;
                        } else {
                            config.params = { apprequest: APPNAME };
                        }
                    }
                    return config;
                },
                'response': function (response) {
                    return response;
                },
                'responseError': function (response) {
                    if (response.status === 401) {
                        $rootScope.$broadcast('IdleTimeout');
                    }
                    return $q.reject(response);
                }
            };
        });

        document.addEventListener("mousewheel", function (event) {
            if (document.activeElement.type === "number") {
                document.activeElement.blur();
            }
        });

    }

})();

(function () {
    'use strict';

    angular
        .module('fuse')
        .controller('MainController', MainController);

    /** @ngInject */
    function MainController($scope, $rootScope, $state, Idle, $auth, api, $log, localStorageService, msNavigationService, APPNAME, $mdDialog) {
        $scope.events = [];

        $rootScope.hasCircle = hasCircle;
        $rootScope.dashboardScreens = dashboardScreens;
        $rootScope.getScreenByRole = getScreenByRole;
        $rootScope.changeCircleByNameAndCompanyId = changeCircleByNameAndCompanyId;
        $rootScope.getParameterValue = getParameterValue;
        $rootScope.getEspecialActionByName = getEspecialActionByName;
        $rootScope.getUserParameterValueByName = getUserParameterValueByName;
        $rootScope.createUserParameter = createUserParameter;
        $rootScope.updateUserParameterValue = updateUserParameterValue;
        $rootScope.showAuditLog = showAuditLog;

        $scope.$on('IdleStart', function () {
            // the user appears to have gone idle
            var now = new Date();
            $log.debug("****** IdleStart ******* " + now);
        });

        $scope.$on('IdleWarn', function (e, countdown) {
            // follows after the IdleStart event, but includes a countdown until the user is considered timed out
            // the countdown arg is the number of seconds remaining until then.
            // you can change the title or display a warning dialog from here.
            // you can let them resume their session by calling Idle.watch()
            var now = new Date();
            $log.debug("****** IdleWarn ******* " + now);
        });

        $scope.$on('IdleTimeout', function () {
            // the user has timed out (meaning idleDuration + timeout has passed without any activity)
            // this is where you'd log them
            var now = new Date();
            $log.debug("****** IDLE TIMEOUT ******* " + now);
            logoutFinish($auth, $state, 'auth.lock');
        });

        $scope.$on('IdleEnd', function () {
            // the user has come back from AFK and is doing stuff. if you are warning them, you can use this to hide the dialog
            var now = new Date();
            $log.debug("****** IdleEnd ******* " + now);
        });

        $scope.$on('Keepalive', function () {
            // do something to keep the user's session alive
            var now = new Date();
            $log.debug("****** Keepalive ******* " + now);
        });

        msNavigationService.clearNavigation();

        if (!$rootScope.circles || $rootScope.circles.length <= 0) {
            $state.go('app.errors.unauthorized');
        } else {
            hasCircle();
        }

        // Remove the splash screen
        $scope.$on('$viewContentAnimationEnded', function (event) {
            if (event.targetScope.$id === $scope.$id) {
                $rootScope.$broadcast('msSplashScreen::remove');
            }
        });

        Idle.watch();

        function hasCircle() {
            if ($rootScope.circles) {
                if ($rootScope.circles.length > 0) {
                    if ($rootScope.bsCircle.role.aplication.name !== APPNAME) {
                        $rootScope.bsCircle = $rootScope.circles[0];
                        localStorageService.set('accountc', $rootScope.bsCircle);
                        $state.go('app.dashboards_project');
                    }
                }

                if ($rootScope.bsCircle) {
                    getScreenByRole();
                } else {
                    dashboardScreens();
                }
            }
        }

        function dashboardScreens() {
            msNavigationService.saveItem('apps', {
                title: 'MAIN',
                group: true,
                weight: 1
            });

            msNavigationService.saveItem('apps.dashboards', {
                title: 'Dashboards',
                icon: 'icon-tile-four',
                state: 'app.dashboards_project',
                weight: 1
            });
        }

        function getScreenByRole() {

            msNavigationService.clearNavigation();
            $scope.items = [];

            $rootScope.statesAutorized = [
                'app.dashboards_project',
                'app.pages_errors_error-404',
                'app.errors.unauthorized',
                'app.errors.notFound',
                'auth.login',
                'auth.lock',
                'app.profile',
                'app.profile.edit',
                'app.role',
                'app.notifications.MyNotifications',
                'app.notifications.Configuration'
            ];

            api.GeneralWS.Menu.ByRole.query({ rol: $rootScope.bsCircle.role.id }).$promise.then(function (response) {
                $scope.items = response;
                $rootScope.items = response;

                msNavigationService.saveItem('apps.dashboards', {
                    title: 'Dashboards',
                    icon: 'icon-tile-four',
                    state: 'app.dashboards_project',
                    weight: 1
                });

                var hasApps = false;

                $scope.items.forEach(function (item) {
                    item.menuItem.group = item.menuItem.isGroup;
                    item.menuItem.state = item.menuItem.stateName;
                    msNavigationService.saveItem(item.menuItem.itemName, item.menuItem);

                    if (item.menuItem.state !== null && item.menuItem.state !== "") {
                        $rootScope.statesAutorized.push(item.menuItem.state);
                    }

                    if (item.menuItem.states) {
                        var states = item.menuItem.states.split(",");
                        $rootScope.statesAutorized = $rootScope.statesAutorized.concat(states);
                    }

                    if (item.menuItem.itemName === 'apps' && item.menuItem.isGroup) {
                        hasApps = true;
                    }
                });
                if ($rootScope.statesAutorized.indexOf($state.current.name) < 0) {
                    $state.go('app.pages_errors_error-404');
                }

                if (!hasApps) {
                    msNavigationService.saveItem('apps', {
                        title: 'MAIN',
                        group: true,
                        weight: 1
                    });
                }

            }, function (err) {
                $log.debug(err);
            });
        }

        function changeCircleByNameAndCompanyId(circleName, companyId, stateToReload) {
            companyId = parseInt(companyId);
            if ($rootScope.bsCircle.name === circleName && $rootScope.bsCircle.company.id === companyId) {
                return null;
            }

            if ($rootScope.circles) {
                for (var i = 0; i < $rootScope.circles.length; i++) {
                    if ($rootScope.circles[i].name === circleName && $rootScope.circles[i].company.id === companyId) {
                        $rootScope.bsCircle = $rootScope.circles[i];
                        localStorageService.set('accountc', $rootScope.bsCircle);

                        break;
                    }
                }
            }
        }

        function getParameterValue(parameter) {

            if ($rootScope.APPParameters) {

                for (var i = 0; i < $rootScope.APPParameters.length; i++) {
                    if ($rootScope.APPParameters[i].applicationParameter.parameterName === parameter) {
                        return $rootScope.APPParameters[i].appParameterValue;
                    }
                }

            }

            return '';

        }

        function getEspecialActionByName(actionName) {
            if (!$rootScope.bsCircle) {
                return false;
            }

            for (var i = 0; i < $rootScope.bsCircle.role.roleSpecialActions.length; i++) {
                if ($rootScope.bsCircle.role.roleSpecialActions[i].active &&
                    $rootScope.bsCircle.role.roleSpecialActions[i].specialAction.actionName === actionName) {
                    return true;
                }
            }

            return false;
        }

        function getUserParameterValueByName(name, returnJsonValue) {
            if ($rootScope.userParameters === null || $rootScope.userParameters === undefined) {
                return null;
            }
            for (var i = 0; i < $rootScope.userParameters.length; i++) {
                if ($rootScope.userParameters[i].applicationParameter.parameterName === name) {
                    if (returnJsonValue) {
                        return $rootScope.userParameters[i].userJsonParameterValue;
                    } else {
                        return $rootScope.userParameters[i].userParameterValue;
                    }
                }
            }

            return null;
        }

        function createUserParameter(parameterName, value, saveValueAsJson) {

            var parameter = {
                applicationParameter: {
                    parameterName: parameterName
                }
            };

            if (saveValueAsJson) {
                parameter.userJsonParameterValue = value;
            } else {
                parameter.userParameterValue = value;
            }

            api.GeneralWS.Usr.UserParameter.create({}, parameter).$promise.then(function (response) {
                if ($rootScope.userParameters === undefined || $rootScope.userParameters === null) {
                    $rootScope.userParameters = [];
                }

                $rootScope.userParameters.push(response);

                localStorageService.remove('userParameters');
                localStorageService.set('userParameters', $rootScope.userParameters);
            }, function (response) {
            });

        }

        function updateUserParameterValue(parameterName, value, saveValueAsJson) {

            var parameter = null;

            for (var i = 0; i < $rootScope.userParameters.length; i++) {
                if ($rootScope.userParameters[i].applicationParameter.parameterName === parameterName) {

                    if (saveValueAsJson) {
                        $rootScope.userParameters[i].userJsonParameterValue = value;
                    } else {
                        $rootScope.userParameters[i].userParameterValue = value;
                    }

                    parameter = $rootScope.userParameters[i];
                    break;
                }
            }

            api.GeneralWS.Usr.UserParameter.update({ 'userParameterId': parameter.id }, parameter).$promise.then(function (response) {
                localStorageService.remove('userParameters');
                localStorageService.set('userParameters', $rootScope.userParameters);
            }, function (response) {
            });

        }

        function showAuditLog(id, type) {

            $mdDialog.show({
                controller: 'AuditLogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/reports/dialogs/show-audit-log/show-audit-log.html',
                parent: angular.element("#main"),
                locals: {
                    id: id,
                    type: type
                },
                clickOutsideToClose: false,
                fullscreen: true
            }).then(function (answer) {
            }, function () {
            });
        }


    }
})();


(function () {
    'use strict';

    angular
        .module('fuse')
        .controller('AuthMainController', AuthMainController);

    /** @ngInject */
    function AuthMainController($scope, $rootScope) {

        // Remove the splash screen
        $scope.$on('$viewContentAnimationEnded', function (event) {
            if (event.targetScope.$id === $scope.$id) {
                $rootScope.$broadcast('msSplashScreen::remove');
            }
        });
    }
})();


(function () {
    'use strict';

    angular
        .module('fuse')
        .run(runBlock);

    /** @ngInject */
    function runBlock($rootScope, $timeout, $state) {
        // Activate loading indicator
        var stateChangeStartEvent = $rootScope.$on('$stateChangeStart', function () {
            $rootScope.loadingProgress = true;
        });

        // De-activate loading indicator
        var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function () {
            if (!$rootScope.bsCircle && !$state.current.abstract && $state.current.name.split('auth').length === 1) {
                $timeout(function () {
                    $state.go('app.errors.unauthorized');
                });
            }
            if ($rootScope.statesAutorized && $rootScope.statesAutorized.indexOf($state.current.name) < 0) {
                $state.go('app.pages_errors_error-404');
            }
            $timeout(function () {
                $rootScope.loadingProgress = false;
            });
        });

        // Store state in the root scope for easy access
        $rootScope.state = $state;

        // Cleanup
        $rootScope.$on('$destroy', function () {
            stateChangeStartEvent();
            stateChangeSuccessEvent();
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('fuse')
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider, APPNAME) {
        var stateProvider = $stateProvider;

        $urlRouterProvider.otherwise('/auth/login');

        var layoutStyle = 'verticalNavigationFullwidthToolbar2';
        var layouts = {
            verticalNavigation: {
                main: 'app/core/layouts/vertical-navigation.html',
                toolbar: 'app/toolbar/layouts/vertical-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
            },
            verticalNavigationFullwidthToolbar: {
                main: 'app/core/layouts/vertical-navigation-fullwidth-toolbar.html',
                toolbar: 'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
            },
            verticalNavigationFullwidthToolbar2: {
                main: 'app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html',
                toolbar: 'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html'
            },
            horizontalNavigation: {
                main: 'app/core/layouts/horizontal-navigation.html',
                toolbar: 'app/toolbar/layouts/horizontal-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/horizontal-navigation/navigation.html'
            },
            contentOnly: {
                main: 'app/core/layouts/content-only.html',
                toolbar: '',
                navigation: ''
            },
            contentWithToolbar: {
                main: 'app/core/layouts/content-with-toolbar.html',
                toolbar: 'app/toolbar/layouts/content-with-toolbar/toolbar.html',
                navigation: ''
            }
        };
        // END - Layout Style Switcher

        // State definitions
        stateProvider
            .state('app', {
                abstract: true,
                url: '',
                views: {
                    'main@': {
                        templateUrl: layouts[layoutStyle].main,
                        controller: 'MainController as vm'
                    },
                    'toolbar@app': {
                        templateUrl: layouts[layoutStyle].toolbar,
                        controller: 'ToolbarController as vm'
                    },
                    'navigation@app': {
                        templateUrl: layouts[layoutStyle].navigation,
                        controller: 'NavigationController as vm'
                    },
                    'quickPanel@app': {
                        templateUrl: 'app/quick-panel/quick-panel.html',
                        controller: 'QuickPanelController as vm'
                    }
                }, resolve: {
                    redirectIfNotAuthenticated: ['$q', '$state', '$auth', '$timeout', '$rootScope', 'api', 'localStorageService', 'envService', redirectIfNotAuthenticated]
                }
            });
        stateProvider
            .state('auth', {
                abstract: true,
                views: {
                    'main@': {
                        templateUrl: 'app/core/layouts/content-only.html',
                        controller: 'AuthMainController as vm'
                    }
                }, resolve: {
                    skipIfAuthenticated: ['$q', '$state', '$auth', '$timeout', '$rootScope', 'api', 'localStorageService', 'envService', skipIfAuthenticated]
                }
            });

        function skipIfAuthenticated($q, $state, $auth, $timeout, $rootScope, api, localStorageService, envService) {
            var defer = $q.defer();
            if ($auth.isAuthenticated()) {

                if (!$rootScope.account) {
                    api.UsuarioWS.Yo.get({},
                        function (response) {
                            $rootScope.account = response;
                            localStorageService.set('account', $rootScope.account);
                        },
                        function (response) {
                            console.error(response);
                        }
                    );
                }
                var ret;
                defer.resolve();
                ret = defer.promise;

                if ($state.current.name === "") {
                    $timeout(function () {
                        $state.go('app.dashboards_project');
                    });
                    return ret;
                } else {
                    $timeout(function () {
                        $state.go('app.dashboards_project');
                    });
                    defer.reject();
                }
            } else {
                defer.resolve();
            }
            return defer.promise;
        }

        function redirectIfNotAuthenticated($q, $state, $auth, $timeout, $rootScope, api, localStorageService, envService) {

            var defer = $q.defer();

            if ($auth.isAuthenticated()) {
                var prome = api.GeneralWS.Usr.User.basicUserInformation.get({}).$promise;

                if (!$rootScope.account) {
                    api.UsuarioWS.Yo.get({},
                        function (response) {
                            $rootScope.account = response;
                            localStorageService.set('account', $rootScope.account);
                        },
                        function (response) {
                            console.error(response);
                        }
                    );
                }
                return loadCirclesBasicInformation($rootScope, localStorageService, prome, $state, defer, envService, $timeout, $auth);
            } else {
                $timeout(function () {
                    $state.go('auth.login');
                });
                defer.reject();
            }
            return defer.promise;
        }

        function loadCirclesBasicInformation($rootScope, localStorageService, prome, $state, defer, envService, $timeout, $auth) {

            //valida los circulos y los parametros
            $rootScope.circles = localStorageService.get('circles');
            $rootScope.userParameters = localStorageService.get('userParameters');

            if (!$rootScope.circles || !$rootScope.userParameters) {
                prome.then(function (response) {

                    if (response.circles.length <= 0) {
                        $timeout(function () {
                            window.location.href = envService.read('msConfigUrl') + "company/my-company";
                        });
                    } else {
                      for (let j = 0; j<response.circles.length; j++) {
                        response.circles[j].role.roleSpecialActions = response.roleSpecialAction.filter(function (item) {
                          return item.roleAppId === response.circles[j].role.id;
                        });
                      }
                        $rootScope.bsCircle = response.circles[0];
                        localStorageService.set('accountc', $rootScope.bsCircle);

                        $rootScope.circles = response.circles;
                        localStorageService.set('circles', $rootScope.circles);

                        $rootScope.userParameters = response.parameters;
                        localStorageService.set('userParameters', $rootScope.userParameters);

                        $rootScope.userId = response.userId;
                        localStorageService.set(APPNAME + '_UID', $rootScope.userId);

                        $rootScope.userCompanies = getUserCompanies(response.circles);
                    }
                }, function (response) {

                    if (response.status === 401) {
                        logoutFinish($auth, $state, 'auth.login');
                    }

                    $timeout(function () {
                        $state.go('app.errors.unauthorized');
                    });
                });

                return prome;
            } else {
                $rootScope.bsCircle = localStorageService.get('accountc');
                $rootScope.userId = localStorageService.get(APPNAME + '_UID');
                $rootScope.userCompanies = getUserCompanies($rootScope.circles);

              if (!$rootScope.bsCircle || $rootScope.bsCircle.role.aplication.name !== APPNAME) {
                    $rootScope.bsCircle = $rootScope.circles[0];
                    localStorageService.set('accountc', $rootScope.bsCircle);
                    defer.resolve();
                } else {
                    defer.resolve();
                }
            }
            return defer.promise;
        }

        function getUserCompanies(circles) {
          var companies = [];

          for(var i = 0; i < circles.length; i++) {
            var companyId = circles[i].company.id;

            if(companies.indexOf(companyId) < 0) {
              companies.push(companyId);
            }
          }

          return companies;
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('fuse')
        .controller('IndexController', IndexController);

    /** @ngInject */
    function IndexController(fuseTheming, APPNAME, api, $rootScope, $log) {
        var vm = this;

        document.title = APPNAME;

        api.GeneralWS.Application.get({ app: APPNAME }, function (d) {
            $rootScope.APPQ = d;
            $log.debug($rootScope.APPQ);

            if (d) {
                api.GeneralWS.ApplicationParameter.get({ app: d.id }, function (response) {
                    $rootScope.APPParameters = response;
                });
            }

        });

        // Data
        vm.themes = fuseTheming.themes;

    }
})();

(function () {
    'use strict';
    var codes = {
        requisition: {
            Creando: "Creando",
            Ingresado: "Ingresado",
            Autorizado: "Autorizado",
            Cotizado: "Cotizado",
            Licitando: "Licitando",
            Rechazado: "Rechazado"
        },
        Quotation: {
            Ingresada: "Ingresada",
            Autorizado: "Autorizado",
            AprobadoProveedor: "Aprobado Proveedor",
            AprobadoProveedorSinCaracteristicas: "Aprobado sin caracteristicas",
            RechazadaProveedor: "Rechazada Proveedor",
            CambioProveedor: "Cambio Proveedor",
            CompraCancelada: "Cancelar Compra"
        },
        PurchaseOrder: {
            PendienteRecibir: "Pendiente Recibir",
            Recibida: "Recibido",
            CambioProveedor: "Cambio Proveedor",
            PrimeraRecepcion: "Primera Recepcion",
            Cancelar: "Cancelar"
        },
        InvoicePurchase: {
            Ingresando: "Ingresando",
            Editando: "Editando",
            Emitida: "Emitida",
            Verificada: "Verificada",
            PendienteRecibirOriginal: "Pendiente Recibir Original",
            Provisionada: 'Provisionada',
            Rechazada: "Rechazada",
            Pagada: "Pagada",
            Cancelada: "Cancelada"
        },
        Contract: {
            Creando: "Creando",
            Ingresado: "Ingresado",
            Autorizado: "Autorizado",
            Cancelado: "Cancelado",
            Finalizado: "Finalizado"
        },
        MerchandiseEntry: {
            Recibida: "Recibida",
            Cancelada: "Cancelada",
            NoRecibida: "No Recibida",
            PendienteVender: "Pendiente de Vender"
        },
        PhysicalDocumentDelivery: {
            Preparando: "Preparando",
            PendientesdeRevisar: "Pendientes de Revisar",
            LoteRevisado: "Lote Revisado",
            EntregadoaTesorero: "Entregado a Tesorero",
            Cancelarlaentregaactual: "Cancelar la entrega actual"
        }
    };

    var statusType = [
        { type: "REQUISITION", value: 1 },
        { type: "QUOTATION", value: 2 },
        { type: "PURCHASE_ORDER", value: 3 },
        { type: "INVOICE", value: 4 },
        { type: "CONTRACT", value: 5 },
        { type: "MERCHANDISE_ENTRY", value: 6 },
        { type: "PAYMENT_RECEIPT", value: 7 },
        { type: "PHYSICAL_DOCUMENT_DELIVERY", value: 8 },
    ];

    var REGEX_UUID = '[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}';

    const invoicePurchaseType = [
      { type: 'INV', name: 'INV', value: 0 },
      { type: 'TCK', name: 'TCK', value: 2 },
      { type: 'CFISCAL', name: 'C_FISCAL', value: 3 },
    ];

    angular
        .module('fuse')
        .constant('APPNAME', 'Compras')
        .constant('ICON_APP_NAME', 'Compras.png')
        .constant('APPINITIALS', 'CM')
        .constant('STATUS_CODES', codes)
        .constant('STATUS_TYPES', statusType)
        .constant('REGEX_UUID', REGEX_UUID)
        .constant('INVOICE_PURCHASE_TYPES', invoicePurchaseType)
        .constant('LINK_SETTLEMENT_REPORT', 'https://www.megapaca.gt/Compras/#!/expenseSettlement/expenseSettlement/view/');

})();

(function () {
    'use strict';

    angular
        .module('fuse')
        .config(config);

    /** @ngInject */
    function config($authProvider, $windowProvider, $mdDateLocaleProvider, envServiceProvider) {
        $mdDateLocaleProvider.formatDate = function (date) {
            return date ? moment(date).format('DD-MM-YYYY') : null;
        };

        $mdDateLocaleProvider.parseDate = function (dateString) {
            var m = moment(dateString, 'DD-MM-YYYY', true);
            return m.isValid() ? m.toDate() : new Date(NaN);
        };

        envServiceProvider.config({
            domains: {
                localhost: ['localhost'],
                development: ['desarrollo.megapaca'],
                test: ['pruebas.megapaca'],
                production: ['www.megapaca.com', 'www.megapaca.gt']
            },
            vars: {
                localhost: {
                    clientId: 'a355631f-de45-4fa9-9dd9-af6b90c1645f',
                    secret: 'XkbTgL894oG2zkS7nkk3-WAc1Qfq7YO5dLY22P0MwaksGHHUhPk9DiBcFLaTSURoBSQg60fdbAJ7lfBDK1JTRw',
                    imagesApps: 'https://desarrollo.megapaca.gt/Megasistemas/apps-images/',
                    hostOIC: 'https://desarrollo.megapaca.gt/',
                    appOIC: 'openid-connect-server-webapp',
                    msConfigUrl: 'https://desarrollo.megapaca.gt/Megasistemas/#!/',
                    baseUrl: 'https://desarrollo.megapaca.gt/ComprasWS/api/',
                    baseUrlGeneral: 'https://desarrollo.megapaca.gt/GeneralWS/api/',
                    baseUrlUsuarioWS: 'https://desarrollo.megapaca.gt/UsuarioWS/api/',
                    baseUrlTienda: 'https://desarrollo.megapaca.gt/TiendaWS/api/',
                    baseUrlTicketsWS: 'https://desarrollo.megapaca.gt/TicketsWS/api/',
                    baseUrlPresupuestosWS: 'https://desarrollo.megapaca.gt/PresupuestosWS/api/',
                    baseUrlLicitadorWS: 'https://desarrollo.megapaca.gt/LicitadorWS/api/',
                    baseUrlActivosFijosWS: 'https://desarrollo.megapaca.gt/ActivosFijosWS/api/',
                    baseUrlProyectosWS: 'https://desarrollo.megapaca.gt/ProyectosWS/api/',
                    baseUrlJReportsWSPdf: 'https://desarrollo.megapaca.gt/JReportsWS/api/Jasper/pdf',
                    baseUrlNotificacionesWS: 'https://desarrollo.megapaca.gt/NotificacionesWS/api/',
                    baseUrlInterfazWS: 'https://desarrollo.megapaca.gt/InterfazWS/api/',
                    baseUrlUserWS: 'https://desarrollo.megapaca.gt/user-ws/api/',
                    baseUrlPhotos: 'https://testing.megapaca.gt/ms/images'
                },
                development: {
                    clientId: 'a355631f-de45-4fa9-9dd9-af6b90c1645f',
                    secret: 'XkbTgL894oG2zkS7nkk3-WAc1Qfq7YO5dLY22P0MwaksGHHUhPk9DiBcFLaTSURoBSQg60fdbAJ7lfBDK1JTRw',
                    imagesApps: 'https://desarrollo.megapaca.gt/Megasistemas/apps-images/',
                    hostOIC: 'https://desarrollo.megapaca.gt/',
                    appOIC: 'openid-connect-server-webapp',
                    msConfigUrl: 'https://desarrollo.megapaca.gt/Megasistemas/#!/',
                    baseUrl: 'https://desarrollo.megapaca.gt/ComprasWS/api/',
                    baseUrlGeneral: 'https://desarrollo.megapaca.gt/GeneralWS/api/',
                    baseUrlUsuarioWS: 'https://desarrollo.megapaca.gt/UsuarioWS/api/',
                    baseUrlTienda: 'https://desarrollo.megapaca.gt/TiendaWS/api/',
                    baseUrlTicketsWS: 'https://desarrollo.megapaca.gt/TicketsWS/api/',
                    baseUrlPresupuestosWS: 'https://desarrollo.megapaca.gt/PresupuestosWS/api/',
                    baseUrlLicitadorWS: 'https://desarrollo.megapaca.gt/LicitadorWS/api/',
                    baseUrlActivosFijosWS: 'https://desarrollo.megapaca.gt/ActivosFijosWS/api/',
                    baseUrlProyectosWS: 'https://desarrollo.megapaca.gt/ProyectosWS/api/',
                    baseUrlJReportsWSPdf: 'https://desarrollo.megapaca.gt/JReportsWS/api/Jasper/pdf',
                    baseUrlNotificacionesWS: 'https://desarrollo.megapaca.gt/NotificacionesWS/api/',
                    baseUrlInterfazWS: 'https://desarrollo.megapaca.gt/InterfazWS/api/',
                    baseUrlUserWS: 'https://desarrollo.megapaca.gt/user-ws/api/',
                    baseUrlPhotos: 'https://testing.megapaca.gt/ms/images'
                },
                test: {
                    clientId: '5eb1b6a0-bd84-4be0-94f7-964616a5de2c',
                    secret: 'ANLTkyU5Ndk835M5J6t63suxINNcWDdAQsu9W_hdoPPAx1KUpG-AE14hC1Mcor5mx9NMAjIqYmCQakKOO7bRcOQ',
                    imagesApps: 'https://pruebas.megapaca.gt/Megasistemas/apps-images/',
                    hostOIC: 'https://pruebas.megapaca.gt/',
                    appOIC: 'openid-connect-server-webapp',
                    msConfigUrl: 'https://pruebas.megapaca.gt/Megasistemas/#!/',
                    baseUrl: 'https://pruebas.megapaca.gt/ComprasWS/api/',
                    baseUrlGeneral: 'https://pruebas.megapaca.gt/GeneralWS/api/',
                    baseUrlUsuarioWS: 'https://pruebas.megapaca.gt/UsuarioWS/api/',
                    baseUrlTienda: 'https://pruebas.megapaca.gt/TiendaWS/api/',
                    baseUrlTicketsWS: 'https://pruebas.megapaca.gt/TicketsWS/api/',
                    baseUrlPresupuestosWS: 'https://pruebas.megapaca.gt/PresupuestosWS/api/',
                    baseUrlLicitadorWS: 'https://pruebas.megapaca.gt/LicitadorWS/api/',
                    baseUrlActivosFijosWS: 'https://pruebas.megapaca.gt/ActivosFijosWS/api/',
                    baseUrlProyectosWS: 'https://pruebas.megapaca.gt/ProyectosWS/api/',
                    baseUrlJReportsWSPdf: 'https://pruebas.megapaca.gt/JReportsWS/api/Jasper/pdf',
                    baseUrlNotificacionesWS: 'https://pruebas.megapaca.gt/NotificacionesWS/api/',
                    baseUrlInterfazWS: 'https://pruebas.megapaca.gt/InterfazWS/api/',
                    baseUrlUserWS: 'https://pruebas.megapaca.gt/user-ws/api/',
                    baseUrlPhotos: 'https://testing.megapaca.gt/ms/images'
                },
                production: {
                    clientId: '3b60d6f8-1be6-48e2-8849-e205716510ef',
                    secret: 'AOjnOfYL2c-blgQQkCC0-Mt4ZTOJMq-JLFbUDBzftkcc5wc8Tk8zeZwbHthchbfzoqeDSl912mv5TTeMFQpntbY',
                    imagesApps: 'https://www.megapaca.gt/Megasistemas/apps-images/',
                    hostOIC: 'https://www.megapaca.gt/',
                    appOIC: 'openid-connect-server-webapp',
                    msConfigUrl: 'https://www.megapaca.gt/Megasistemas/#!/',
                    baseUrl: 'https://www.megapaca.gt/ComprasWS/api/',
                    baseUrlGeneral: 'https://www.megapaca.gt/GeneralWS/api/',
                    baseUrlUsuarioWS: 'https://www.megapaca.gt/UsuarioWS/api/',
                    baseUrlTienda: 'https://www.megapaca.gt/TiendaWS/api/',
                    baseUrlTicketsWS: 'https://www.megapaca.gt/TicketsWS/api/',
                    baseUrlPresupuestosWS: 'https://www.megapaca.gt/PresupuestosWS/api/',
                    baseUrlLicitadorWS: 'https://www.megapaca.gt/LicitadorWS/api/',
                    baseUrlActivosFijosWS: 'https://www.megapaca.gt/ActivosFijosWS/api/',
                    baseUrlProyectosWS: 'https://www.megapaca.gt/ProyectosWS/api/',
                    baseUrlJReportsWSPdf: 'https://www.megapaca.gt/JReportsWS/api/Jasper/pdf',
                    baseUrlNotificacionesWS: 'https://www.megapaca.gt/NotificacionesWS/api/',
                    baseUrlInterfazWS: 'https://www.megapaca.gt/InterfazWS/api/',
                    baseUrlUserWS: 'https://www.megapaca.gt/user-ws/api/',
                    baseUrlPhotos: 'https://www.megapaca.com/ms/images'
                }
            }
        });
        envServiceProvider.check();

        var win = $windowProvider.$get();
        $authProvider.oauth2({
            name: 'OIDC',
            url: envServiceProvider.read('hostOIC') + envServiceProvider.read('appOIC') + '/token',
            userInfo: envServiceProvider.read('hostOIC') + envServiceProvider.read('appOIC') + '/userinfo',
            clientId: envServiceProvider.read('clientId'),
            secret: envServiceProvider.read('secret'),
            tokenName: 'access_token',
            redirectUri: win.location.origin || win.location.protocol + '//' + win.location.host,
            authorizationEndpoint: envServiceProvider.read('hostOIC') + envServiceProvider.read('appOIC') + '/authorize',
            endSesionEndPoint: envServiceProvider.read('hostOIC') + envServiceProvider.read('appOIC') + '/endsession',
            revokeEndPoint: envServiceProvider.read('hostOIC') + envServiceProvider.read('appOIC') + '/revoke',
            scope: ['address', 'phone', 'openid', 'profile', 'email'],
            scopeDelimiter: '+'
        });

    }

})();

(function () {
  "use strict";
  angular.module("fuse").factory("api", apiService);
  /** @ngInject */
  function apiService($resource, envService, $http) {
    var interceptor = {
      response: function (response) {
        var result = response.resource;
        result.$status = response.status;
        result.$data = response.data;
        return result;
      }
    };
    var api = {};
    api.baseUrl = envService.read("baseUrl");
    api.baseUrlGeneral = envService.read("baseUrlGeneral");
    api.baseUrlLicitadorWS = envService.read("baseUrlLicitadorWS");
    api.baseUrlLocal = "app/data/";
    api.baseUrlOpenId = envService.read("hostOIC") + envService.read("appOIC");
    api.baseUrlUsuarioWS = envService.read("baseUrlUsuarioWS");
    api.baseUrlTienda = envService.read("baseUrlTienda");
    api.baseUrlTicketsWS = envService.read("baseUrlTicketsWS");
    api.baseUrlPresupuestosWS = envService.read("baseUrlPresupuestosWS");
    api.baseUrlActivosFijosWS = envService.read("baseUrlActivosFijosWS");
    api.baseUrlProyectosWS = envService.read("baseUrlProyectosWS");
    api.baseUrlNotificacionesWS = envService.read("baseUrlNotificacionesWS");
    api.baseUrlInterfazWS = envService.read("baseUrlInterfazWS");
    api.baseUrlUserWS = envService.read('baseUrlUserWS');
    api.baseUrlPhotos = envService.read('baseUrlPhotos');

    api.UsuarioWS = {
      UserInfo: $resource(
        api.baseUrlUsuarioWS + "UserInfo/:sub",
        { id: "@_sub" },
        {
          update: {
            method: "PUT"
          },
          patch: {
            method: "PATCH"
          },
          save: {
            method: "POST",
            params: {
              companyid: "@companyid"
            }
          }
        }
      ),
      UserPass: $resource(api.baseUrlUsuarioWS + 'UserInfo/changePassword/:sub', { id: '@_sub' }, {
        update: {
          method: 'PUT'
        }
      }),
      Me: $resource(
        envService.read("hostOIC") + envService.read("appOIC") + "/userinfo"
      ),
      Yo: $resource(api.baseUrlUsuarioWS + "me")
    };

    api.GeneralWS = {
      Usr: {
        User: {
          Company: {
            me: $resource(
              api.baseUrlGeneral + "User/company/:company",
              { company: "@company" },
              {
                page: {
                  method: "GET",
                  isArray: false
                }
              }
            ),
            CompanyRolUser: $resource(
              api.baseUrlGeneral + "Company/CompanyRolUser",
              {},
              {
                page: {
                  method: "GET",
                  isArray: true
                }
              }
            )
          },
          basicUserInformation: $resource(
            api.baseUrlGeneral + "User/Me/basicUserInformation",
            {},
            {
              get: {
                method: "GET"
              }
            }
          )
        },
        UserCostCenter: {
          me: $resource(
            api.baseUrlGeneral + "UserCostCenter/:idUsuario/:company",
            { idUsuario: "@idUsuario", company: "@company" },
            {
              page: {
                method: "GET",
                params: {
                  pageNumber: "@pageNumber",
                  pageSize: "@pageSize",
                  search: "@search"
                },
                isArray: false
              },
              create: {
                method: "POST",
                params: { associateAll: "@associateAll" },
                isArray: false
              },
              update: {
                method: "PUT",
                params: { deleteAll: "@deleteAll" },
                isArray: false
              }
            }
          )
        },
        UserDepartment: {
          me: $resource(
            api.baseUrlGeneral + "UserDepartment/:idUsuario/:company",
            { idUsuario: "@idUsuario", "@company": "@company" },
            {
              page: {
                method: "GET",
                params: {
                  pageNumber: "@pageNumber",
                  pageSize: "@pageSize",
                  search: "@search"
                },
                isArray: false
              },
              create: {
                method: "POST",
                params: { associateAll: "@associateAll", search: "@search" },
                isArray: false
              },
              update: {
                method: "PUT",
                params: { deleteAll: "@deleteAll", search: "@search" },
                isArray: false
              }
            }
          )
        },
        UserParameter: $resource(
          api.baseUrlGeneral + "UserParameter/:userParameterId",
          { userParameterId: "@userParameterId" },
          {
            create: {
              method: "POST"
            },
            update: {
              method: "PUT"
            }
          }
        )
      },
      UserSub: $resource(api.baseUrlGeneral + 'User/sub/:sub', { sub: '@_sub' }, {
        update: {
          method: 'PUT'
        },
        patch: {
          method: 'PATCH'
        }
      }),
      UserInvitation: $resource(
        api.baseUrlGeneral + "UserInvitation/inviteUser/:companyid/",
        { companyid: "@companyid" },
        {
          sendInvitation: {
            method: "POST"
          }
        }
      ),
      User: $resource(
        api.baseUrlGeneral + "User/:id",
        { id: "@_id" },
        {
          update: {
            method: "PUT"
          },
          patch: {
            method: "PATCH"
          },
          save: {
            method: "POST",
            params: {
              companyid: "@companyid"
            }
          }
        }
      ),
      UsersCompany: $resource(
        api.baseUrlGeneral + "User/company/:company/AndRole",
        { company: "@company" },
        {
          get: {
            method: "GET",
            params: {
              roleId: "@roleId",
              pageNumber: "@pageNumber",
              pageSize: "@pageSize",
              search: "@search"
            },
            isArray: false
          },
          getArray: {
            method: 'GET',
            params: {
              roleId: '@roleId',
              search: '@search'
            },
            isArray: true
          }
        }
      ),
      MyCircles: $resource(api.baseUrlGeneral + "BusinessCircle/me"),
      Company: {
        me: $resource(
          api.baseUrlGeneral + "Company/:id",
          { id: "@id" },
          {
            update: {
              method: "PUT"
            },
            create: {
              method: "POST"
            },
            getByMe: {
              method: "GET",
              isArray: true
            },
            addInvoiceSerie: {
              method: "PUT"
            },
            addRegime: {
              method: "PUT"
            }
          }
        ),
        updateExternalProvider: $resource(
          api.baseUrlGeneral + 'Company/:id/updateIsExternalProvider',
          { id: '@id' },
          {
            update: {
              method: 'PUT',
              params: {
                'isExternalProvider': '@isExternalProvider',
              },
            },
          }),
      },
      getAllCompaniesRolAdmin: $resource(
        api.baseUrlGeneral + "Company/companyAdmin"
      ),
      getAllCompaniesRol: $resource(api.baseUrlGeneral + "Company/CompanyRol"),
      getAllCompanies: $resource(
        api.baseUrlGeneral + "Company/isActive",
        {},
        {
          page: {
            method: "GET",
            isArray: false,
            params: {
              pageNumber: "@pageNumber",
              pageSize: "@pageSize",
              search: "@search",
              companyId: "@companyId",
              includeMe: "@includeMe"
            }
          }
        }
      ),
      getAllCompaniesProviders: $resource(
        api.baseUrlGeneral + "Company/:companyId/Provider",
        { companyId: "@companyId" },
        {
          page: {
            method: "GET",
            isArray: false,
            params: {
              pageNumber: "@pageNumber",
              pageSize: "@pageSize",
              search: "@search",
              includeMe: "@includeMe"
            }
          }
        }
      ),
      CompanyApplication: {
        me: $resource(
          api.baseUrlGeneral + "Company/:company/Application/:app",
          { company: "@company", app: "@app" },
          {
            create: {
              method: "POST",
              interceptor: interceptor
            },
            Delete: {
              method: "DELETE",
              interceptor: interceptor
            }
          }
        ),
        notAssociatedToCompany: $resource(
          api.baseUrlGeneral +
          "Company/:company/Application/notAssociatedToCompany",
          { company: "@company" },
          {}
        ),
        byAppName: $resource(
          api.baseUrlGeneral + "Company/:company/Application/:app",
          { company: "@company", app: "@app" },
          {
            get: {
              method: "GET",
              interceptor: interceptor
            }
          }
        )
      },
      Department: $resource(api.baseUrlGeneral + "Company/:idc/Department/me", {
        idc: "@idc"
      }),
      getAllDepartment: $resource(
        api.baseUrlGeneral + "Company/:idc/Department/Company",
        { idc: "@idc" }
      ),
      getAllDepartmentByCompanyIds: $resource(
        api.baseUrlGeneral + 'Company/:idc/Department/CompanyIds',
        { idc: '@idc' },
        {
          query: {
            method: 'POST',
            isArray: true
          }
        }
      ),
      getDepartmentsByMe: $resource(api.baseUrlGeneral + 'Department/:id', {
        idc: '@idc',
      }),
      CostCenter: $resource(api.baseUrlGeneral + "Company/:idc/CostCenter/me", {
        idc: "@idc"
      }),
      getAllCost: $resource(
        api.baseUrlGeneral + "Company/:idc/CostCenter/Company",
        { idc: "@idc" }
      ),
      getAllCostByCompanyIds: $resource(
        api.baseUrlGeneral + 'Company/:idc/CostCenter/CompanyIds',
        { idc: '@idc' },
        {
          query: {
            method: 'POST',
            isArray: true
          }
        }
      ),
      Currency: $resource(api.baseUrlGeneral + "Currency/isActive"),
      Product: $resource(
        api.baseUrlGeneral + "Product/:id",
        { id: "@id" },
        {
          create: {
            method: "POST"
          }
        }
      ),
      DepartmentProduct: $resource(
        api.baseUrlGeneral +
        "Circle/:circleId/Department/:departments/Product/:id",
        { circleId: "@_circleId", departments: "@_departments", id: "@_id" },
        {
          getAll: {
            method: "GET",
            params: {
              pageNumber: "@pageNumber",
              pageSize: "@pageSize"
            }
          }
        }
      ),
      MeasurementUnit: $resource(api.baseUrlGeneral + "MeasurementUnit"),
      BrandProduct: $resource(api.baseUrlGeneral + "Product/brand"),
      ProductAll: $resource(api.baseUrlGeneral + "Product/all/:circle", {
        circle: "@circle"
      }),
      ProductAllWithTaxes: $resource(
        api.baseUrlGeneral + "Product/all/withtaxes/:circleId",
        { circleId: "@circleId" }
      ),
      DocumentType: $resource(
        api.baseUrlGeneral + "DocumentType/Country/:id",
        { id: "@id" },
        {
          getAll: {
            method: "GET",
            isArray: true,
            params: {
              category: "@category"
            }
          }
        }
      ),
      CompanyDocumentActive: $resource(
        api.baseUrlGeneral + "Company/:id/Document/isActive",
        { id: "@id" },
        {
          getAll: {
            method: "GET",
            isArray: true
          }
        }
      ),
      CompanyDocument: $resource(
        api.baseUrlGeneral + "Company/:id/Documents",
        { id: "@id" },
        {
          addDocument: {
            method: "PUT"
          }
        }
      ),
      DocumentByType: $resource(
        api.baseUrlGeneral + "Document/findByNumberAndDocumentType",
        {},
        {
          getByDocumentType: {
            method: "GET",
            params: {
              number: "@number",
              companyId: "@companyId"
            }
          }
        }
      ),
      DocumentByCompany: $resource(
        api.baseUrlGeneral + "Document/findByCompany",
        {},
        {
          getByCompany: {
            method: "GET",
            params: {
              companyId: "@companyId"
            }
          }
        }
      ),
      CompanyDocumentByDocument: $resource(
        api.baseUrlGeneral + "Company/:id/Document/findByDocument",
        { id: "@id" },
        {
          get: {
            method: "GET",
            isArray: false,
            params: { number: "@number" }
          }
        }
      ),
      CompanyDocumentSettlementByDocument: $resource(
        api.baseUrlGeneral + "Company/:id/Document/findSettlementByDocument",
        { id: "@id" },
        {
          get: {
            method: "GET",
            isArray: false,
            params: { number: "@number" }
          }
        }
      ),
      CompanyByDocument: $resource(
        api.baseUrlGeneral + "Company/byDocument",
        {},
        {
          getByDocument: {
            method: "GET",
            params: {
              documentId: "@documentId"
            }
          }
        }
      ),
      Document: $resource(
        api.baseUrlGeneral + "Document/:id",
        { id: "@id" },
        {
          update: {
            method: "PUT",
            params: {
              businessCircleId: "@businessCircleId",
              companyId: "@companyId"
            }
          }
        }
      ),
      LoadAvatar: $resource(
        api.baseUrlGeneral + "User/:sub/photoUpload",
        { sub: "@_sub" },
        {
          save: {
            method: "POST",
            transformRequest: angular.identity,
            headers: { "Content-Type": undefined }
          }
        }
      ),
      LoadFiles: $resource(
        api.baseUrlGeneral + "FileStorage/:fileName/Files",
        { fileName: "@fileName" },
        {
          save: {
            method: "POST",
            isArray: true,
            transformRequest: angular.identity,
            headers: { "Content-Type": undefined }
          }
        }
      ),
      Regime: {
        Regime: $resource(
          api.baseUrlGeneral + "Regime/:id/",
          { id: "@_id" },
          {}
        ),
        getByCompany: $resource(
          api.baseUrlGeneral + "Regime/:id/:companyId",
          { id: "@id", companyId: "@companyId" },
          {
            get: {
              method: "GET",
              isArray: true
            }
          }
        ),
        getAllByCountry: $resource(
          api.baseUrlGeneral + "Regime/Country/:id",
          { id: "@id" },
          {
            get: {
              method: "GET",
              isArray: true
            }
          }
        ),
        getAllWithTaxByCountry: $resource(
          api.baseUrlGeneral + "Regime/WithTaxesByCountry/:id",
          { id: "@id" },
          {
            get: {
              method: "GET",
              isArray: true
            }
          }
        ),
        byCompanyIsInvoice: $resource(
          api.baseUrlGeneral + "Regime/byCompanyIsInvoice",
          {},
          {
            get: {
              method: "GET",
              isArray: true
            }
          }
        )
      },
      Withholding: {
        getByRegime: $resource(
          api.baseUrlGeneral + "Withholding/getByRegime/",
          {},
          {
            get: {
              method: "GET",
              isArray: true,
              params: {
                regimeId: "@regimeId",
                onlyManual: "@onlyManual"
              }
            }
          }
        )
      },
      WithholdingDocumentType: {
        InvoiceSerie: $resource(
          api.baseUrlGeneral + "WithholdingDocumentType/:invoiceserie/InvoiceSerie/",
          { invoiceserie: '@invoiceserie' },
          {
            filterExists: {
              method: "GET",
              isArray: true,
              params: {
                withholding: "@withholding"
              }
            }
          }
        )
      },
      Country: $resource(api.baseUrlGeneral + "Country"),
      InvoiceSerie: $resource(
        api.baseUrlGeneral + "InvoiceSerie/:id",
        { id: "@_id" },
        {
          update: {
            method: "PUT"
          },
          patch: {
            method: "PATCH"
          },
          save: {
            method: "POST"
          },
          delete: {
            method: "DELETE"
          },
          getByCompanySerieAndCorrelative: {
            method: "GET",
            params: {
              invoiceSerieId: "@_invoiceSerieId",
              companyId: "@_companyId",
              serie: "@_serie",
              initialNumber: "@_intialNumber",
              lastNumber: "@_lastNumber"
            }
          }
        }
      ),
      InvoiceSeries: $resource(
        api.baseUrlGeneral + "InvoiceSerie/ByCompanyProvider",
        {},
        {
          getByCompany: {
            method: "GET",
            isArray: true,
            params: {
              companyId: "@companyId"
            }
          }
        }
      ),
      InvoiceSeriesDocumentType: $resource(
        api.baseUrlGeneral + "InvoiceSeriesDocumentType",
        {},
        {
          query: {
            method: "GET",
            isArray: true,
            params: {
              companyId: "@companyId"
            }
          }
        }
      ),
      CreateBasicSerie: $resource(
        api.baseUrlGeneral + "InvoiceSerie/forCompanyProvider",
        {},
        {
          create: {
            method: "POST",
            params: {
              idCircle: "@idCircle"
            }
          }
        }
      ),
      CreateBasicSerieNotBlocked: $resource(
        api.baseUrlGeneral + "InvoiceSerie/serieNotBlocked",
        {},
        {
          create: {
            method: "POST"
          }
        }
      ),
      Common: {
        FileStorage: {
          filesUpload: {
            add: function (params, body) {
              var fd = addToFdFile(body, "files");
              return $http.post(
                api.baseUrlGeneral +
                "FileStorage/filesUpload/" +
                params.companyId,
                fd,
                {
                  transformRequest: angular.identity,
                  headers: { "Content-Type": undefined }
                }
              );
            }
          },
          deletePhoto: $resource(
            api.baseUrlGeneral + 'FileStorage/deletePhoto',
            {},
            {
              deletePhoto: {
                method: 'DELETE',
                isArray: false
              }
            }
          )
        }
      },
      Menu: {
        ByRole: $resource(api.baseUrlGeneral + "MenuItem/byRole/:rol", {
          rol: "@rol"
        })
      },
      UserDepartment: $resource(
        api.baseUrlGeneral + "User/departments",
        {},
        {
          get: {
            method: "GET",
            isArray: true,
            params: {
              companyId: "@companyId"
            }
          }
        }
      ),
      UserCostCenter: $resource(
        api.baseUrlGeneral + "User/costcenter",
        {},
        {
          get: {
            method: "GET",
            isArray: true,
            params: {
              companyId: "@companyId"
            }
          }
        }
      ),
      Application: $resource(
        api.baseUrlGeneral + "Application/:app",
        { id: "@_app" },
        {
          page: {
            method: "GET",
            params: { pageNumber: "@pageNumber", pageSize: "@pageSize" },
            isArray: false
          },
          get: {
            method: "GET",
            isArray: false
          }
        }
      ),
      ApplicationParameter: $resource(
        api.baseUrlGeneral + "Application/:app/Parameter",
        { id: "@_app" },
        {
          get: {
            method: "GET",
            isArray: true
          }
        }
      ),
      ApplicationByUser: $resource(api.baseUrlGeneral + "Application/byUser"),
      CountryTax: {
        CountryTax: $resource(
          api.baseUrlGeneral + "CountryTax/:id/",
          { id: "@_id" },
          {}
        ),
        getAllByCountry: $resource(
          api.baseUrlGeneral + "CountryTax/byCountry/:id",
          { id: "@id" },
          {
            get: {
              method: "GET",
              isArray: true
            }
          }
        ),
        getByCompany: $resource(
          api.baseUrlGeneral + "CountryTax/byCompany/:id/",
          { id: "@_id" },
          {
            get: {
              method: "GET",
              isArray: true
            }
          }
        ),
        getAllByRegime: $resource(
          api.baseUrlGeneral + "CountryTax/byRegime/:id/",
          { id: "@id" },
          {
            get: {
              method: "GET",
              isArray: true
            }
          }
        )
      },
      BasicCompany: {
        createBasicCompany: $resource(
          api.baseUrlGeneral + "Company/byInvoice",
          {},
          {
            create: {
              method: "POST",
              params: {
                document: "@document",
                documentNRC: "@documentNRC",
                settlementId: "@settlementId",
                companyBuyer: "@companyBuyer"
              }
            }
          }
        ),
        updateBasicCompany: $resource(
          api.baseUrlGeneral + "Company/:id/byInvoice",
          { id: "@id" },
          {
            update: {
              method: "PUT",
              params: {
                companyBuyer: '@companyBuyer',
                documentNRC: '@documentNRC',
              }
            }
          }
        )
      },
      ProductCompanyAddons: $resource(
        api.baseUrlGeneral + "ProductCompanyAddons/:id",
        { id: "@id" },
        {
          get: {
            method: "GET",
            isArray: true
          }
        }
      ),
      GetProductCompanyAddons: {
        getByProductsListAndCompany: $resource(
          api.baseUrlGeneral + 'ProductCompanyAddons/getByProductsListAndCompany',
          {},
          {
            getList: {
              method: 'GET',
              isArray: true
            }
          }
        )
      },
      ProductCompanyAddonsByProductsId: $resource(
        api.baseUrlGeneral + 'ProductCompanyAddons/getByProductsId',
        {},
        {
          getList: {
            method: 'GET',
            isArray: true
          }
        }
      ),
      ProductCompanyAddonsByCompanyAndProductsIsProvider: $resource(
        api.baseUrlGeneral + 'ProductCompanyAddons/getByCompanyAndProducts/isProvider',
        {},
        {
          getList: {
            method: 'GET',
            isArray: true
          }
        }
      ),
      CompanyParameter: $resource(
        api.baseUrlGeneral + "Company/:id/Parameter/app/:appId",
        { id: "@_id", appId: "@_appId" },
        {
          getParameters: {
            method: 'GET',
            isArray: false,
            params: {
              pageNumber: "@pageNumber",
              pageSize: "@pageSize"
            }
          }
        }
      ),
      CompanyParameterByName: $resource(
        api.baseUrlGeneral + "Company/:id/Parameter/:parameter",
        { id: "@_id", parameter: "@parameter" },
        {
          get: {
            method: "GET",
            isArray: false
          }
        }
      ),
      ExchangeRate: $resource(
        api.baseUrlGeneral + "ExchangeRate/dayExchangeRate",
        {},
        {
          getDayExchangeRate: {
            method: "POST",
            isArray: false,
            params: {
              idCircle: "@idCircle"
            }
          }
        }
      ),
      RoleApplication: $resource(
        api.baseUrlGeneral + "Application/:applicationId/Role/byNameLike",
        { applicationId: "@applicationId" },
        {
          getRoles: {
            method: "GET",
            isArray: true,
            params: {
              nameLike: "@nameLike"
            }
          }
        }
      ),
      CompanyRegime: $resource(
        api.baseUrlGeneral + "Company/:id/setRegime",
        { id: "@id" },
        {
          addRegime: {
            method: "PUT"
          }
        }
      ),
      CompanyUser: $resource(api.baseUrlGeneral + "Company/byUser"),
      DepartmentCompany: {
        DepartmentByCompany: $resource(
          api.baseUrlGeneral + "Company/:idc/Department/",
          { idc: "@idc" }
        )
      },
      CostCenterCompany: {
        CostCenterByCompany: $resource(
          api.baseUrlGeneral + "Company/:idc/CostCenter/",
          { idc: "@idc" }
        )
      },
      CompanyWithholding: {
        getAgentWithholding: $resource(
          api.baseUrlGeneral +
          "Company/:company/Withholding/getAgentWithholding",
          { company: "@company" }
        )
      },
      UserRoleTreasurer: {
        getbyCorporateAndRoleTreasure: $resource(
          api.baseUrlGeneral +
          "User/doGetByCorporateAndRoleTreasurer/:idCircle",
          { idCircle: "@idCircle" }
        )
      },
      GFace: {
        GFace: $resource(
          api.baseUrlGeneral + "GFace/",
          {},
          {
            getAll: {
              method: "GET",
              isArray: true
            }
          }
        )
      },
      DepartmentRelated: {
        byDeptos: $resource(api.baseUrlGeneral + "DepartmentRelated/byDeptos", {},
          {
            get: {
              method: 'POST',
              isArray: true
            }
          }
        )
      },
      ApplicationParameterCountryValue: {
        byParameterNameAndCountry: $resource(api.baseUrlGeneral + "ApplicationParameterCountryValue/byParameterNameAndCountry", {},
          {
            get: {
              method: 'GET',
              isArray: false
            }
          }
        )
      },
      DimensionCompany: {
        byCompanyNotActive: $resource(api.baseUrlGeneral + 'DimensionCompany/byCompany/:company', {}, {
          getList: {
            method: 'GET',
            params: {
              'company': '@company'
            },
            isArray: true
          }
        }),
        byCompany: $resource(api.baseUrlGeneral + 'DimensionCompany/byCompanyActive/:company', {}, {
          getList: {
            method: 'GET',
            params: {
              'company': '@company'
            },
            isArray: true
          }
        }),
        getByIdList: $resource(api.baseUrlGeneral + 'DimensionCompany/getByIdList', {}, {
          getList: {
            method: 'POST',
            isArray: true
          }
        })
      },
      DimensionCompanyDetail: {
        byDimensionCompany: $resource(api.baseUrlGeneral + 'DimensionCompanyDetail/all/byDimensionCompany', {}, {
          getList: {
            method: 'GET',
            params: {
              'dimensionCompanyId': '@dimensionCompanyId'
            },
            isArray: true
          }
        })
      },
      CompanyCategory: $resource(api.baseUrlGeneral + 'CompanyCategory/:id', {}, {
        get: {
          method: 'GET',
          params: {
            'id': '@id'
          },
          isArray: false
        }
      }),
      BusinessCircleMembers: {
        UsersByRoleAndCompanies: $resource(
          api.baseUrlGeneral + 'BusinessCircleMembers/User/byRoleAndCompanies',
          {},
          {
            query: {
              method: 'POST',
              isArray: true,
              params: {
                'applicationId': '@applicationId',
                'roleName': '@roleName',
              },
            },
          }
        ),
      },
    };

    api.UserWS = {
      UserDimension: {
        ByUser: $resource(
          api.baseUrlUserWS + 'UserDimension/ByUser/:userId',
          { userId: '@userId' },
          {
            get: {
              method: 'GET',
              isArray: true
            }
          }
        )
      }
    };

    api.TiendaWS = {
      Cart: $resource(
        api.baseUrlTienda + "Cart/:id/:options",
        { id: "@id", options: "@options" },
        {
          create: {
            method: "POST"
          },
          clear: {
            method: "PUT"
          }
        }
      ),
      CartCurrent: $resource(api.baseUrlTienda + "Cart/Current"),
      CartDetail: $resource(
        api.baseUrlTienda + "Cart/:idCart/Detail/:id/:qtt",
        { idCart: "@idCart", id: "@id", qtt: "@qtt" },
        {
          create: {
            method: "POST"
          },
          update: {
            method: "PUT"
          }
        }
      )
    };

    api.ComprasWS = {
      UserInvitation: $resource(
        api.baseUrl + "UserInvitation/inviteUser/:companyid/",
        { companyid: "@companyid" },
        {
          sendInvitation: {
            method: "POST"
          }
        }
      ),
      User: $resource(
        api.baseUrl + "User/:id",
        { id: "@_id" },
        {
          update: {
            method: "PUT"
          },
          patch: {
            method: "PATCH"
          },
          getApiContext: {
            method: "GET"
          }
        }
      ),
      Requisition: $resource(
        api.baseUrl + "Requisition/:id/:tipo",
        { id: "@id", tipo: "@tipo" },
        {
          update: {
            method: "PUT"
          },
          changeStatus: {
            method: "PATCH"
          },
          duplicateRequisition: {
            method: "POST"
          },
          create: {
            method: "POST"
          },
          updateBatch: {
            method: "POST",
            isArray: true
          },
          page: {
            method: "GET",
            isArray: false
          },
          getId: {
            method: "GET"
          }
        }
      ),
      asociateUserToQuote: $resource(
        api.baseUrl + 'Requisition/:requisitionId/asignUserToQuote/',
        { requisitionId: '@requisitionId' },
        {
          asociate: {
            method: 'PATCH',
            isArray: false,
            params: {
              userId: '@userId'
            }
          }
        }
      ),
      RequisitionPendingAuthorize: $resource(
        api.baseUrl + "Requisition/byNumberRequisition/",
        {},
        {
          getBy: {
            method: "GET",
            isArray: false
          }
        }
      ),
      Requisitions: {
        toCotize: $resource(
          api.baseUrl + "Requisition/ToCotize",
          {},
          {
            page: {
              method: "GET",
              isArray: false
            }
          }
        ),
        historyProduct: $resource(
          api.baseUrl + "Requisition/getRequisitionHistoryProduct",
          {},
          {
            query: {
              method: "GET",
              isArray: true,
              params: {
                productId: "@productId",
                departmentId: "@departmentId",
                costCenterId: "@costCenterId"
              }
            }
          }
        ),
        Audit: $resource(
          api.baseUrl + "Requisition/:id/Audit",
          { id: "@id" },
          {
            get: {
              method: "GET",
              isArray: true
            }
          }
        ),
        byReference: $resource(
          api.baseUrl + "Requisition/byReference",
          {},
          {
            get: {
              method: "GET",
              isArray: true
            }
          }
        ),
        filterToCompare: $resource(
          api.baseUrl + 'Requisition/:circleId/filter/:reqId/toCompare',
          { circleId: '@circleId', reqId: '@reqId' },
          {
            page: {
              method: "POST",
              isArray: false,
            }
          }
        ),
      },
      RequisitionDetails: {
        toCompare: $resource(
          api.baseUrl + 'Requisition/:reqId/Detail/:circleId/toCompare',
          { reqId: '@reqId', circleId: '@circleId' },
          {
            getList: {
              method: "GET",
              isArray: true
            }
          }
        ),
      },
      RequisitionRechaze: $resource(
        api.baseUrl + "Requisition/:id/noAutorize",
        { id: "@id" },
        {
          changeStatus: {
            method: "PATCH"
          }
        }
      ),
      RequisitionUpdateCompany: $resource(
        api.baseUrl + "Requisition/:id/updateData",
        { id: "@id" },
        {
          change: {
            method: "PATCH"
          }
        }
      ),
      RequisitionTemplate: $resource(
        api.baseUrl + "RequisitionTemplate/:company/:id",
        { id: "@id", company: "@company" },
        {
          create: {
            method: "POST"
          },
          update: {
            method: "PUT"
          },
          delete: {
            method: "DELETE"
          }
        }
      ),
      RequisitionTemplateShareMe: $resource(
        api.baseUrl + "RequisitionTemplate/:company/ShareMe",
        { company: "@company" },
        {
          update: {
            method: "PUT"
          },
          delete: {
            method: "DELETE"
          }
        }
      ),
      RequisitionTemplateDetail: $resource(
        api.baseUrl + "RequisitionTemplate/:company/:idTemplate/detail/:id",
        { id: "@id", company: "@company", idTemplate: "@idTemplate" },
        {
          create: {
            method: "POST"
          },
          update: {
            method: "PUT"
          },
          delete: {
            method: "DELETE"
          }
        }
      ),
      RequisitionTemplateUserShares: $resource(
        api.baseUrl + "RequisitionTemplateUser/:id",
        { id: "@id" },
        {
          create: {
            method: "POST"
          },
          update: {
            method: "PUT"
          },
          delete: {
            method: "DELETE"
          },
          get: {
            method: "GET",
            isArray: true
          }
        }
      ),
      RequisitionTemplateUser: {
        getDeptos: $resource(
          api.baseUrl + "RequisitionTemplateUser/getDeptos",
          {},
          {
            get: {
              method: "GET",
              isArray: true
            }
          }
        ),
        getcostCenters: $resource(
          api.baseUrl + "RequisitionTemplateUser/getCostCenters",
          {},
          {
            get: {
              method: "GET",
              isArray: true
            }
          }
        )
      },
      RequisitionTemplateBudget: $resource(
        api.baseUrl + "RequisitionTemplate/:company/requisition/:idRequisition",
        { idRequisition: "@idRequisition", company: "@company" }
      ),
      ProcessFlow: $resource(api.baseUrl + "Requisition/processFlow", {
        type: "@type",
        id: "@id"
      }),
      PurchaseStatus: $resource(api.baseUrl + "PurchaseStatus/:type/:id", {
        type: "@type",
        id: "@id"
      }),
      Report: {
        Invoice: $resource(
          api.baseUrl + "InvoicePurchase/:circle/filter",
          { circle: "@circle" },
          {
            page: {
              method: "POST",
              isArray: false
            }
          }
        ),
        PurchaseOrder: $resource(
          api.baseUrl + "PurchaseOrder/:circle/filter",
          { circle: "@circle" },
          {
            page: {
              method: "POST",
              isArray: false
            }
          }
        ),
        Requisition: $resource(
          api.baseUrl + "Requisition/:circle/filter",
          { circle: "@circle" },
          {
            page: {
              method: "POST",
              isArray: false
            }
          }
        ),
        RequisitionToReport: $resource(
          api.baseUrl + 'Requisition/:circle/filter/report',
          { circle: "@circle" },
          {
            page: {
              method: "POST",
              isArray: false
            }
          }
        ),
        DetailRequisitionAndPurchase: $resource(
          api.baseUrl + 'Requisition/:circle/filter/detailRequisitionAndPurchase',
          { circle: "@circle" },
          {
            page: {
              method: "POST",
              isArray: false
            }
          }
        ),
        RequisitionGeneral: $resource(
          api.baseUrl + "Requisition/:circle/generalFilter",
          { circle: "@circle" },
          {
            page: {
              method: "POST",
              isArray: false
            }
          }
        ),
        Quotation: $resource(
          api.baseUrl + "Company/0/Quotation/:circle/filter",
          { circle: "@circle" },
          {
            page: {
              method: "POST",
              isArray: false
            }
          }
        ),
        DetailQuotationPendingApprove: $resource(
          api.baseUrl + "Company/:companyId/Quotation/:quotationId/Detail/:circleId/getReportPendingApprove",
          { companyId: "@companyId", circleId: "@circleId", quotationId: "@quotationId" },
          {
            page: {
              method: "POST",
              isArray: false
            }
          }
        ),
        Contract: $resource(
          api.baseUrl + "ContractPurchase/:circle/filter",
          { circle: "@circle" },
          {
            page: {
              method: "POST",
              isArray: false
            }
          }
        ),
        Merchandise: $resource(
          api.baseUrl + "MerchandiseEntry/:circle/filter",
          { circle: "@circle" },
          {
            page: {
              method: "POST",
              isArray: false
            }
          }
        ),
        Settlement: $resource(
          api.baseUrl + "SettlementDetail/:circle/filter",
          { circle: "@circle" },
          {
            page: {
              method: "POST",
              isArray: false
            }
          }
        ),
        MerchandiseHeader: $resource(
          api.baseUrl + "MerchandiseEntry/:circle/filterHeader",
          { circle: "@circle" },
          {
            page: {
              method: "POST",
              isArray: false
            }
          }
        ),
        Erp: {
          PendingSend: $resource(
            api.baseUrl + "InvoicePurchase/:company/getNotSentToErp/report",
            { company: "@company" },
            {
              page: {
                method: "GET",
                isArray: false
              }
            }
          ),
          PendingConfirm: $resource(
            api.baseUrl +
            "InvoicePurchase/:company/getNotConfirmedToErp/report",
            { company: "@company" },
            {
              page: {
                method: "GET",
                isArray: false
              }
            }
          ),
          PendingCancel: $resource(
            api.baseUrl + "InvoicePurchase/:company/getNotCanceledToErp/report",
            { company: "@company" },
            {
              page: {
                method: "GET",
                isArray: false
              }
            }
          )
        },
        PettyCash: $resource(
          api.baseUrl + "PettyCash/filter",
          {},
          {
            page: {
              method: "POST",
              isArray: false
            }
          }
        ),
        SettlementHeader: $resource(
          api.baseUrl + "Settlement/:circle/filter",
          { circle: "@circle" },
          {
            page: {
              method: "POST",
              isArray: false
            }
          }
        ),
        providerByConsumed: $resource(
          api.baseUrl + "InvoicePurchase/:circle/providerByConsumed",
          { circle: "@circle" },
          {
            page: {
              method: "POST",
              isArray: true
            }
          }
        ),
        requisitionByUser: $resource(
          api.baseUrl + "Requisition/:circle/requisitionByUser",
          { circle: "@circle" },
          {
            page: {
              method: 'POST',
              isArray: false
            }
          }
        ),
        accountStatus: $resource(
          api.baseUrl + "MerchandiseEntry/accountStatus",
          { circle: '@circle' },
          {
            page: {
              method: "GET",
              isArray: false
            }
          }
        ),
        PhysicalDocumentDelivery: $resource(
          api.baseUrl + "PhysicalDocumentDelivery/:idCircle/filter",
          { idCircle: "@idCircle" },
          {
            page: {
              method: "POST",
              isArray: false
            }
          }
        ),
        InvoicePurchaseWithholding: $resource(
          api.baseUrl + "InvoicePurchaseWithholding/:idCircle/filter",
          { idCircle: "@idCircle" },
          {
            page: {
              method: "POST",
              isArray: false
            }
          }
        ),
        ShippingOrder: $resource(
          api.baseUrl + "ShippingOrder/:idCircle/filter",
          { idCircle: "@idCircle" },
          {
            page: {
              method: 'POST',
              isArray: false
            }
          }
        )
      },
      RequisitionDetail: $resource(
        api.baseUrl + "Requisition/:idRequisition/Detail/:id",
        { id: "@id", idRequisition: "@idRequisition" },
        {
          update: {
            method: "PUT"
          },
          create: {
            method: "POST"
          },
          page: {
            method: "GET",
            isArray: false
          },
          deleteList: {
            method: "DELETE",
            isArray: true,
            params: { id: "deleteList" }
          },
          createList: {
            method: "POST",
            isArray: true,
            params: { id: "createList" }
          }
        }
      ),
      Quotation: {
        me: $resource(
          api.baseUrl + "Company/:companyId/Quotation",
          { companyId: "@companyId" },
          {
            create: {
              method: "POST"
            },
            page: {
              method: "GET",
              isArray: true
            }
          }
        ),
        Quotation: $resource(
          api.baseUrl + "Company/:companyId/Quotation/:id/",
          { companyId: "@companyId", id: "@id" },
          {
            changeStatus: {
              method: "PUT"
            }
          }
        ),
        changeStatus: $resource(
          api.baseUrl +
          "Company/:companyId/Quotation/:quotationId/changeStatus",
          { quotationId: "@quotationId", companyId: "@companyId" },
          {
            update: {
              method: "PUT",
              params: { circleId: "@circleId", status: "@status" }
            }
          }
        ),
        changeStatusRefuse: $resource(
          api.baseUrl +
          "Company/:companyId/Quotation/:quotationId/refuseStatus",
          { quotationId: "@quotationId", companyId: "@companyId" },
          {
            update: {
              method: "PUT",
              params: { circleId: "@circleId", status: "@status" }
            }
          }
        ),
        findByStatus: $resource(
          api.baseUrl + "Company/:companyId/Quotation/findByStatus",
          { companyId: "@companyId" },
          {
            page: {
              method: "GET",
              isArray: false,
              params: {
                pageNumber: "@pageNumber",
                pageSize: "@pageSize",
                statusName: "@statusName"
              }
            },
            query: {
              method: "GET",
              isArray: true,
              params: { statusName: "@statusName" }
            }
          }
        ),
        authorize: $resource(
          api.baseUrl +
          "Company/:companyId/Quotation/:idCircle/:quotationId/authorize",
          {
            companyId: "@companyId",
            idCircle: "@idCircle",
            quotationId: "@quotationId"
          },
          {
            update: {
              method: "PUT",
              isArray: true
            }
          }
        ),
        cancelQuotations: $resource(
          api.baseUrl + "Company/:companyId/Quotation/cancelQuotations",
          { companyId: "@companyId" },
          {
            update: {
              method: "PUT",
              params: { circleId: "@circleId" }
            }
          }
        ),
        reCotizeQuotations: $resource(
          api.baseUrl + "Company/:companyId/Quotation/reCotizeQuotations",
          { companyId: "@companyId" },
          {
            update: {
              method: "PUT",
              params: { circleId: "@circleId" }
            }
          }
        ),
        byRequisition: $resource(
          api.baseUrl + "Company/:companyId/Quotation/byRequisition/:id",
          { companyId: "@companyId", idCircle: "@idCircle", id: "@id" },
          {
            getBy: {
              method: "GET",
              isArray: true
            }
          }
        ),
        Audit: $resource(
          api.baseUrl + "Company/:companyId/Quotation/:id/Audit",
          { companyId: "@companyId", id: "@id" },
          {
            get: {
              method: "GET",
              isArray: true
            }
          }
        ),
        findByStatusTicket: $resource(
          api.baseUrl + "Company/:companyId/Quotation/findByStatusTicket",
          { companyId: "@companyId" },
          {
            page: {
              method: "GET",
              isArray: false,
              params: {
                pageNumber: "@pageNumber",
                pageSize: "@pageSize",
                statusName: "@statusName"
              }
            },
            query: {
              method: "GET",
              isArray: true,
              params: { statusName: "@statusName" }
            }
          }
        )
      },
      QuotationDetail: {
        me: $resource(
          api.baseUrl + "Company/:companyId/Quotation/:quotationId/Detail/:id",
          { companyId: "@companyId", quotationId: "@quotationId", id: "@id" },
          {
            create: {
              method: "POST"
            },
            update: {
              method: "PUT"
            }
          }
        ),
        findDetailByQuotations: $resource(
          api.baseUrl +
          "Company/:companyId/Quotation/:quotationId/Detail/findDetailByQuotations",
          { companyId: "@companyId", quotationId: "@quotationId" },
          {
            query: {
              method: "GET",
              params: { circleId: "@circleId", quotations: "@quotations" },
              isArray: true
            }
          }
        ),
        updateQuantity: $resource(
          api.baseUrl +
          "Company/:companyId/Quotation/:quotationId/Detail/:quotationDetailId/updateQuantity",
          {
            companyId: "@companyId",
            quotationId: "@quotationId",
            quotationDetailId: "@quotationDetailId"
          },
          {
            update: {
              method: "PUT",
              params: { quantity: "@quantity" }
            }
          }
        ),
        deleteDetail: $resource(
          api.baseUrl +
          "Company/:companyId/Quotation/:quotationId/Detail/:circleId/deleteList",
          { companyId: "@companyId", quotationId: "@quotationId" },
          {
            cancel: {
              method: "DELETE",
              params: { circleId: "@circleId" }
            }
          }
        )
      },
      QuotationDetailReference: {
        QuotationDetailReference: $resource(
          api.baseUrl + "QuotationDetailReference/:id",
          { id: "@id" },
          {
            create: {
              method: "POST"
            },
            update: {
              method: "PUT"
            },
            getQuotationDetail: {
              method: "GET",
              isArray: true,
              params: {
                circleId: "@circleId",
                quotationDetailId: "@quotationDetailId"
              }
            },
            getByQuotationDetails: {
              method: "GET",
              isArray: true
            }
          }
        )
      },
      MerchandiseEntry: $resource(
        api.baseUrl + "MerchandiseEntry/:id/",
        { id: "@id" },
        {
          update: {
            method: "PUT",
            isArray: false
          },
          create: {
            method: "POST",
            isArray: true
          },
          page: {
            method: "GET",
            isArray: false
          },
          provider: {
            method: "GET",
            isArray: true
          },
          getAllByIds: {
            method: "GET",
            isArray: true
          },
          setStatusChange: {
            method: "PUT"
          },
          getHeader: {
            method: "GET",
            isArray: true
          },
          delete: {
            method: "DELETE"
          }
        }
      ),
      MerchandiseEntry2: {
        countByUserProvider: $resource(
          api.baseUrl + "MerchandiseEntry/countByUserProvider",
          {},
          {
            get: {
              method: "GET",
              isArray: false,
              interceptor: interceptor
            }
          }
        )
      },
      MerchandiseByPurchaseOrder: {
        byPurchaseOrder: $resource(
          api.baseUrl + "MerchandiseEntry/byPurchaseOrder",
          {},
          {
            get: {
              method: "GET",
              isArray: true
            }
          }
        )
      },
      MerchandiseHeader: $resource(
        api.baseUrl + "MerchandiseHeader/:id/",
        { id: "@id" },
        {
          page: {
            method: "GET",
            isArray: false
          },
          updateFiles: {
            method: "PUT"
          }
        }
      ),
      ByPurchaseOrderAndType: $resource(
        api.baseUrl + "MerchandiseHeader/ByPurchaseOrderAndType",
        { id: "@id" },
        {
          query: {
            method: "GET",
            isArray: true
          }
        }
      ),
      pettyCash: $resource(
        api.baseUrl + "PettyCash/:id",
        { id: "@id" },
        {
          update: {
            method: "PUT"
          },
          create: {
            method: "POST"
          },
          del: {
            method: "DELETE"
          }
        }
      ),
      pettyCashWithAmountToReturn: $resource(
        api.baseUrl + "PettyCash/withAmountToReturn"
      ),
      cancelPettyCash: $resource(
        api.baseUrl + "PettyCash/cancelPetty/:id",
        { id: "@id" },
        {
          cancel: {
            method: "PUT",
            params: {
              circle: "@circle"
            }
          }
        }
      ),
      finalizePettyCash: $resource(
        api.baseUrl + "PettyCash/finalize/:id",
        { id: "@id" },
        {
          finalize: {
            method: "PUT",
            params: {
              circle: "@circle",
              amountAvailable: "@amountAvailable"
            }
          }
        }
      ),
      pettyCashDepositReference: $resource(
        api.baseUrl + "PettyCash/setDepositReference/:id",
        { id: "@id" },
        {
          set: {
            method: "PUT",
            params: {
              circle: "@circle",
              reference: "@reference"
            }
          }
        }
      ),
      pettyCashType: $resource(api.baseUrl + "PettyCashType/:id", {
        id: "@id"
      }),
      allProducts: $resource(
        api.baseUrl +
        "SettlementProduct/pettyCashType/:pettyCashTypeId/product/:size/:page",
        {
          pettyCashTypeId: "@pettyCashTypeId",
          page: "@page",
          size: "@size",
          settlementProductTypeId: "@settlementProductTypeId"
        },
        {}
      ),
      allMembers: $resource(
        api.baseUrl +
        "SettlementProduct/pettyCashType/:pettyCashTypeId/settlementProduct/:size/:page",
        {
          pettyCashTypeId: "@pettyCashTypeId",
          page: "@page",
          size: "@size",
          settlementProductTypeId: "@settlementProductTypeId"
        },
        {}
      ),
      allSettlementProduct: $resource(
        api.baseUrl +
        "SettlementProduct/product/settlementId/:settlementId/:size/:page",
        {
          settlementId: "@settlementId",
          companyId: "@companyId",
          page: "@page",
          size: "@size",
          filter: "@filter",
          invoicePurchaseId: "@invoicePurchaseId"
        },
        {}
      ),
      settlementProductType: $resource(
        api.baseUrl + "SettlementProductType/:id",
        { id: "@id" }
      ),
      productRequired: $resource(
        api.baseUrl + "SettlementProduct/settlementId/:settlementId",
        { settlementId: "@settlementId" },
        {
          get: {
            method: "GET"
          }
        }
      ),
      settlementProduct: $resource(
        api.baseUrl + "SettlementProduct/productId/:productId",
        {
          productId: "@productId",
          pettyCashTypeId: "@pettyCashTypeId",
          companyId: "@companyId",
          idCircle: "@idCircle",
          settlementProductTypeId: "@settlementProductTypeId"
        },
        {
          create: {
            method: "POST"
          },
          remove: {
            method: "PUT",
            isArray: false
          },
          update: {
            method: "PUT",
            isArray: false
          }
        }
      ),
      settlementProductDeductible: $resource(
        api.baseUrl +
        "SettlementProduct/productPredetermined/productId/:id",
        {
          id: "@id"
        },
        {
          update: {
            method: "PUT",
            isArray: false
          }
        }
      ),
      settlementProductConfig: $resource(
        api.baseUrl + "SettlementProductConfig/:id",
        { id: "@id" }
      ),
      getSettlementProduct: $resource(
        api.baseUrl +
        "SettlementProduct/pettyCashType/:pettyCashTypeId/bySettlementProductType",
        { pettyCashTypeId: "@pettyCashTypeId" },
        {
          getAll: {
            method: "GET",
            isArray: true,
            params: {
              settlementProductTypeName: "@settlementProductTypeName",
              idCircle: "@idCircle",
              deductible: false
            }
          }
        }
      ),
      pettyCashGeneralSets: $resource(
        api.baseUrl + "PettyCashGeneralSets/:id/",
        { id: "@id" },
        {
          get: {
            method: "GET"
          },
          getAll: {
            method: "GET",
            isArray: true,
            params: {
              idCircle: "@idCircle"
            }
          },
          getByPettyCashType: {
            method: "GET",
            params: {
              pettyCashTypeId: "@pettyCashTypeId",
              idCircle: "@idCircle"
            }
          },
          create: {
            method: "POST"
          },
          update: {
            method: "PUT"
          },
          remove: {
            method: "DELETE"
          }
        }
      ),
      PettyCashTypeSettings: {
        getByUser: $resource(
          api.baseUrl + "PettyCashTypeSettings/byUser",
          {},
          {
            get: {
              method: "GET",
              isArray: true,
              params: {
                userId: "@userId",
                rolId: "@rolId",
                verification: "@verification"
              }
            }
          }
        ),
        getByUserProvision: $resource(
          api.baseUrl + "PettyCashTypeSettings/byUserPravition",
          {},
          {
            get: {
              method: "GET",
              isArray: true,
              params: {
                userId: "@userId",
                rolId: "@rolId",
                provition: "@provition"
              }
            }
          }
        ),
        PettyCashTypeSettings: $resource(
          api.baseUrl + "PettyCashTypeSettings/:id",
          { id: "@id" },
          {
            create: {
              method: "POST",
              params: { circle: "@circle" }
            },
            remove: {
              method: "DELETE",
              params: { circle: "@circle" }
            }
          }
        )
      },
      MerchandiseEntryOrderDetail: $resource(
        api.baseUrl + "MerchandiseEntry/purchaseOrderDetail/:id/",
        { id: "@id" }
      ),
      PurchaseOrder: $resource(
        api.baseUrl + "PurchaseOrder/:id/",
        { id: "@id" },
        {
          get: {
            method: 'GET',
            isArray: false
          },
          update: {
            method: "PUT"
          },
          changeStatus: {
            method: "PUT",
            pchangeStatusarams: { circleId: "@circleId", status: "@status" }
          },
          create: {
            method: "POST"
          }
        }
      ),
      PurchaseOrders: {
        Audit: $resource(
          api.baseUrl + "PurchaseOrder/:id/Audit",
          { id: "@id" },
          {
            get: {
              method: "GET",
              isArray: true
            }
          }
        ),
        changeStatus: $resource(
          api.baseUrl + "PurchaseOrder/changeStatus",
          { id: "@id" },
          {
            put: {
              method: "PUT",
              isArray: false
            }
          }
        ),
      },
      PurchaseByRequisition: $resource(
        api.baseUrl +
        "PurchaseOrder/:idPurchaseOrder/Detail/byRequisition/:id/",
        { idPurchaseOrder: "@idPurchaseOrder", id: "@id" },
        {
          getBy: {
            method: "GET",
            isArray: true
          }
        }
      ),
      PurchaseByContract: $resource(
        api.baseUrl + "PurchaseOrder/:idPurchaseOrder/Detail/byContract/:id/",
        { idPurchaseOrder: "@idPurchaseOrder", id: "@id" },
        {
          getBy: {
            method: "GET",
            isArray: true
          }
        }
      ),
      PurchaseOrderDetail: $resource(
        api.baseUrl + "PurchaseOrder/:idPurchaseOrder/Detail/:id",
        { idPurchaseOrder: "@idPurchaseOrder", id: "@id" },
        {
          create: {
            method: "POST",
            isArray: true
          },
          getId: {
            method: "GET"
          },
          update: {
            method: "PUT"
          }
        }
      ),
      PurchaseOrderDetailPendingDelivery: $resource(
        api.baseUrl + "PurchaseOrder/:idPurchaseOrder/Detail/detailsPendingDelivery",
        { idPurchaseOrder: "@idPurchaseOrder" },
        {
          getReportDetail: {
            method: "POST",
            isArray: false,
            params: {
              pageNumber: "@pageNumber",
              pageSize: "@pageSize",
              search: "@search"
            }
          }
        }
      ),
      InvoicePurchase: $resource(
        api.baseUrl + "InvoicePurchase/:id/",
        { id: "@id" },
        {
          query: {
            method: "GET",
            isArray: false
          },
          update: {
            method: "PUT"
          },
          updateDTO: {
            method: "PUT",
            params: {
              idInvoice: "@idInvoice",
              idCircle: "@idCircle"
            }
          },
          setFile: {
            method: "PUT"
          },
          save: {
            method: "POST"
          },
          saveInvoice: {
            method: "POST",
            isArray: false
          },
          page: {
            method: "GET",
            isArray: false
          },
          list: {
            method: "GET",
            isArray: true
          },
          setStatus: {
            method: "PUT",
            params: { idCircle: "idCircle", status: "@status" }
          }
        }
      ),
      CancelInvoicePurchase: $resource(
        api.baseUrl + "InvoicePurchase/:id/cancelPurchaseAndDetail",
        { id: "@id" },
        {
          cancel: {
            method: "PUT",
            params: { idCircle: "@idCircle" }
          }
        }
      ),
      InvoicePurchaseVatReceived: $resource(
        api.baseUrl + "InvoicePurchase/:id/removeVatReceived",
        { id: "@id" },
        {
          delete: {
            method: "PUT"
          }
        }
      ),
      setTotalInvoice: $resource(
        api.baseUrl + "InvoicePurchase/setTotal/:id/",
        { id: "@id" },
        {
          setTotal: {
            method: "PUT",
            params: { idCircle: "@idCircle" }
          }
        }
      ),
      InvoiceChangeStatus: $resource(
        api.baseUrl + "InvoicePurchase/:id/",
        { id: "@id" },
        {
          update: {
            method: "PUT",
            params: { circleId: "@circleId", status: "@status" }
          }
        }
      ),
      InvoicePurchaseFiles: $resource(
        api.baseUrl + "InvoicePurchase/getFilesInvoice/:id/",
        { id: "@id" },
        {
          get: {
            method: "GET",
            isArray: true
          }
        }
      ),
      Invoices: {
        limitDateException: $resource(
          api.baseUrl + "InvoicePurchase/:id/limitDateException",
          { id: "@id" },
          {
            update: {
              method: "PUT"
            }
          }
        ),
        deactivate: $resource(
          api.baseUrl + "InvoicePurchase/:id/deactivate",
          { id: "@id" },
          {
            update: {
              method: "PUT"
            }
          }
        ),
        cancelPayment: $resource(
          api.baseUrl + "InvoicePurchase/:id/cancelPayment",
          { id: "@id" },
          {
            update: {
              method: "PUT"
            }
          }
        ),
        relatedFiles: $resource(
          api.baseUrl + 'InvoicePurchase/:id/relatedFiles',
          { id: "@id" },
          {
            get: {
              method: "GET",
              isArray: false,
            },
          }
        ),
      },
      InvoicePurchaseChange: $resource(
        api.baseUrl + "InvoicePurchase/:id/updateDetailsAndTax",
        { id: "@id" },
        {
          changeDetails: {
            method: "PUT",
            params: { idCircle: "@idCircle" }
          }
        }
      ),
      InvoicePurchaseAudit: {
        Audit: $resource(
          api.baseUrl + "InvoicePurchase/:id/Audit",
          { id: "@id" },
          {
            get: {
              method: "GET",
              isArray: true
            }
          }
        )
      },
      InvoicePurchaseDetail: $resource(
        api.baseUrl + "InvoicePurchaseDetail/:id/",
        { id: "@id" },
        {
          save: {
            method: "POST"
          },
          saveDetails: {
            method: "POST",
            isArray: true
          },
          page: {
            method: "GET",
            isArray: false
          },
          byInvoice: {
            method: "GET",
            isArray: true,
            params: {
              invoiceId: "@invoiceId",
              idCircle: "@idCircle"
            }
          },
          update: {
            method: "PUT",
            isArray: false
          },
          updatePrice: {
            method: "PUT",
            isArray: false
          },
          updatePriceDetails: {
            method: "PUT",
            isArray: true,
            params: {
              idCircle: "@idCircle",
              invoicePurchaseId: "@invoicePurchaseId"
            }
          },
          delete: {
            method: "DELETE",
            isArray: true,
            params: {
              idCircle: "@idCircle"
            }
          },
          byId: {
            method: "GET"
          },
          getDtoByInvoice: {
            method: "GET",
            isArray: true,
            params: {
              invoiceId: "@invoiceId",
              idCircle: "@idCircle"
            }
          },
          saveDescription: {
            method: "PATCH",
            isArray: false
          }
        }
      ),
      InvoicePurchaseDetail2: {
        calculateTaxes: $resource(
          api.baseUrl +
          "InvoicePurchaseDetail/calculateTaxes/:invoicePurchaseId",
          { invoicePurchaseId: "@invoicePurchaseId" },
          {
            update: {
              method: "PUT",
              isArray: false,
              params: {
                idCircle: "@idCircle",
                ids: "@ids",
                isExento: "@isExento"
              }
            }
          }
        ),
        taxNoDeductible: $resource(
          api.baseUrl +
          "InvoicePurchaseDetail/invoicePurchase/:invoicePurchaseId/:id/setTaxNoDeductible",
          { invoicePurchaseId: "@invoicePurchaseId", id: "@id" },
          {
            update: {
              method: "PUT",
              isArray: false,
              params: {
                all: "@all",
                idCircle: "@idCircle",
                noDeductible: "@noDeductible",
                erpCode: "@erpCode"
              }
            }
          }
        ),
        adjust: $resource(
          api.baseUrl + "InvoicePurchaseDetail/:id/adjust",
          { id: "@id" },
          {
            update: {
              method: "PUT",
              isArray: false,
              params: {
                idCircle: "@idCircle",
                totalBeforeTax: "@totalBeforeTax",
                totalTax: "@totalTax"
              }
            }
          }
        ),
        changeErpCode: $resource(
          api.baseUrl + "InvoicePurchaseDetail/:id/changeErpCode",
          { id: "@id" },
          {
            update: {
              method: "PUT",
              isArray: false,
              params: {
                idCircle: "@idCircle",
                erpCode: "@erpCode"
              }
            }
          }
        )
      },
      InvoicesPurchasesDetails: {
        byRequisition: $resource(
          api.baseUrl + "InvoicePurchaseDetail/byRequisition/:id/",
          { id: "@id" },
          {
            getBy: {
              method: "GET",
              isArray: true
            }
          }
        ),
        byContract: $resource(
          api.baseUrl + "InvoicePurchaseDetail/byContract/:id/",
          { id: "@id" },
          {
            getBy: {
              method: "GET",
              isArray: true
            }
          }
        )
      },
      InvoicePurchaseDetailTax: {
        InvoicePurchaseDetailTax: $resource(
          api.baseUrl + "InvoicePurchaseDetailTax/:id/",
          { id: "@id" },
          {
            save: {
              method: "POST",
              isArray: true
            },
            saveDetailsTaxes: {
              method: "POST",
              isArray: true
            },
            byInvoicePurchaseDetail: {
              method: "GET",
              isArray: true,
              params: {
                invoicePurchaseDetailId: "@id"
              }
            },
            update: {
              method: "PUT"
            },
            updateOrCreate: {
              method: "PUT",
              isArray: true
            },
            byId: {
              method: "GET"
            }
          }
        ),
        deleteInvoicePurchaseDetailsTax: $resource(
          api.baseUrl + "InvoicePurchaseDetailTax/byInvocePurchaseDetail/:id/",
          { id: "@id" },
          {
            deleteAll: {
              method: "DELETE",
              isArray: true
            }
          }
        ),
        updateOrCreatePurchaseDetailsTax: $resource(
          api.baseUrl +
          "InvoicePurchaseDetailTax/byUpdateinvoicePurchaseDetail/:id/",
          { id: "@id" },
          {
            allDetails: {
              method: "PUT",
              isArray: true
            }
          }
        ),
        adjust: $resource(
          api.baseUrl + "InvoicePurchaseDetailTax/:id/adjust",
          { id: "@id" },
          {
            update: {
              method: "PUT",
              isArray: false,
              params: {
                idCircle: "@idCircle",
                totalTax: "@totalTax"
              }
            },
            create: {
              method: "POST",
              isArray: false,
              params: {
                idCircle: "@idCircle",
                totalTax: "@totalTax"
              }
            },
            delete: {
              method: 'DELETE',
              isArray: false,
              params: {
                idCircle: '@idCircle',
                idCountryTax: '@idCountryTax',
              }
            }
          }
        )
      },
      Settlement: {
        getAllSettlements: $resource(
          api.baseUrl + "Settlement/allSettlementsByPetty/:pettyCashId",
          { pettyCashId: "@pettyCashId" },
          {
            getAllByPettyCash: {
              method: "GET",
              isArray: true
            }
          }
        ),
        getSettlements: $resource(
          api.baseUrl + "Settlement/allSettlementByUser",
          {},
          {
            getAllByUser: {
              method: "GET",
              isArray: true,
              params: {
                circleId: "@circleId",
                status: "@status"
              }
            }
          }
        ),
        getAllSettlementProvisioned: $resource(
          api.baseUrl + "Settlement/provisioned",
          {},
          {
            allProvisioned: {
              method: "GET",
              isArray: true,
              params: { idCircle: "@idCircle" }
            }
          }
        ),
        Settlement: $resource(
          api.baseUrl + "Settlement/:id",
          { id: "@id" },
          {
            create: {
              method: "POST"
            },
            update: {
              method: "PUT"
            },
            delete: {
              method: "DELETE"
            },
            query: {
              method: "GET",
              isArray: true
            }
          }
        ),
        settlementDetailId: $resource(
          api.baseUrl + "Settlement/settlementDetailId",
          {},
          {
            get: {
              method: "GET",
              isArray: false
            }
          }
        ),
        limitDateException: $resource(
          api.baseUrl + "Settlement/limitDateException",
          { idCircle: "@idCircle", settlementId: "@settlementId" },
          {
            update: {
              method: "PUT"
            }
          }
        ),
        setTotalSettlement: $resource(
          api.baseUrl + "Settlement/setTotal/:id",
          { id: "@id" },
          {
            update: {
              method: "PUT"
            }
          }
        ),
        sendSettlement: $resource(
          api.baseUrl + "Settlement/Send/:settlementId",
          { settlementId: "@settlementId" },
          {
            send: {
              method: "PUT",
              params: { isFinal: "@isFinal", idCircle: "@idCircle" }
            }
          }
        ),
        authorizeSettlement: $resource(
          api.baseUrl + "Settlement/Authorize/:settlementId",
          { settlementId: "@settlementId" },
          {
            authorize: {
              method: "PUT",
              params: { idCircle: "@idCircle" }
            }
          }
        ),
        provisionSettlement: $resource(
          api.baseUrl + "Settlement/Provision/:settlementId",
          { settlementId: "@settlementId" },
          {
            Provision: {
              method: "PUT",
              params: {
                idCircle: "@idCircle",
                dateAccounting: "@dateAccounting"
              }
            }
          }
        ),
        cancelProvisionSettlement: $resource(
          api.baseUrl + "Settlement/cancelProvision/:settlementId",
          { settlementId: "@settlementId" },
          {
            cancel: {
              method: "PUT",
              params: { idCircle: "@idCircle" }
            }
          }
        ),
        paySettlement: $resource(
          api.baseUrl + "Settlement/Payment/:settlementId",
          { settlementId: "@settlementId" },
          {
            pay: {
              method: "PUT",
              params: {
                wireTransferReference: "@wireTransferReference",
                idCircle: "@idCircle"
              }
            }
          }
        ),
        cancelPaymentSettlement: $resource(
          api.baseUrl + "Settlement/cancelPayment/:settlementId",
          { settlementId: "@settlementId" },
          {
            cancel: {
              method: "PUT",
              params: { idCircle: "@idCircle" }
            }
          }
        ),
        getAmountAvailable: $resource(
          api.baseUrl + "Settlement/byPettyCash/:id",
          { id: "@id" },
          {
            getTotal: {
              method: "GET",
              interceptor: interceptor,
              isArray: false
            }
          }
        ),
        getByPettyAndStatus: $resource(
          api.baseUrl + "Settlement/byPettyCashAndStatus/:id",
          { id: "@id" },
          {
            getSettlements: {
              method: "GET",
              isArray: true,
              params: {
                idCircle: "@idCircle",
                status: "@status"
              }
            }
          }
        ),
        SettlementStatus: $resource(api.baseUrl + "SettlementStatus/:id", {
          id: "@id"
        }),
        getSettlementChangeStatus: $resource(
          api.baseUrl + "Settlement/getSettlementChangeStatus/:settlementId",
          { settlementId: "@settlementId" },
          {
            page: {
              method: "GET",
              isArray: false,
              params: { pageNumber: "@pageNumber", pageSize: "@pageSize" }
            }
          }
        ),
        getSettlementByNumber: $resource(api.baseUrl + "Settlement/settlementByNumber", {}, {
          get: {
            method: 'GET',
            isArray: false,
            params: { 'idCircle': '@idCircle', 'settlementId': '@settlementId' }
          }
        })
      },
      SettlementDetail: $resource(
        api.baseUrl + "SettlementDetail/:id",
        { id: "@id" },
        {
          create: {
            method: "POST"
          },
          update: {
            method: "PUT"
          },
          delete: {
            method: "DELETE"
          },
          query: {
            method: "GET"
          }
        }
      ),
      SettlementDetails: {
        getAllDetailsBySettlement: $resource(
          api.baseUrl + "SettlementDetail/allDetails/:settlementId",
          { settlementId: "@settlementId" },
          {
            getAll: {
              method: "GET",
              isArray: true,
              params: {
                circleId: "@circleId"
              }
            }
          }
        ),
        AllDetailsByStatus: $resource(
          api.baseUrl + "SettlementDetail/allDetailsByStatus",
          {},
          {
            getAll: {
              method: "GET",
              isArray: true,
              params: {
                status: "@status",
                circleId: "@circleId"
              }
            }
          }
        ),
        ForceDetail: $resource(
          api.baseUrl + "SettlementDetail/PettyCash/:id",
          { id: "@id" },
          {
            force: {
              method: "POST"
            }
          }
        ),
        AuthorizeDetail: $resource(
          api.baseUrl + "SettlementDetail/:id/authorize",
          { id: "@id" },
          {
            authorize: {
              method: "PUT",
              params: {
                circleId: "@circleId"
              }
            }
          }
        ),
        validateDetail: $resource(
          api.baseUrl + "SettlementDetail/:id/validateDetail",
          { id: "@id" },
          {
            validate: {
              method: "PUT",
              params: {
                circleId: "@circleId",
                dateAccounting: "@dateAccounting"
              }
            }
          }
        ),
        OverSpend: $resource(
          api.baseUrl + "SettlementDetail/:id/overSpend",
          { id: "@id" },
          {
            setIsOverSpend: {
              method: "PUT",
              params: {
                circleId: "@circleId"
              }
            }
          }
        ),
        Deductible: $resource(
          api.baseUrl + "SettlementDetail/getDeductible",
          {},
          {
            getDeductible: {
              method: "GET",
              params: {
                circleId: "@circleId",
                accountingDate: "@accountingDate"
              }
            }
          }
        ),
        DeleteDetailsSelected: $resource(
          api.baseUrl + "SettlementDetail/:id/deleteDetails",
          { id: "@id" },
          {
            deleteDetails: {
              method: "DELETE",
              isArray: true,
              params: {
                circleid: "@circleId"
              }
            }
          }
        ),
        getDetailsExtraAuthorization: $resource(
          api.baseUrl +
          "SettlementDetailExtraAuthorization/bySettlementDetail/:settlementDetailId",
          { settlementDetailId: "@settlementDetailId" },
          {
            getDetails: {
              method: "GET",
              isArray: true,
              params: {
                circleId: "@circleId"
              }
            }
          }
        ),
        deleteRejectedDetail: $resource(
          api.baseUrl + "SettlementDetail/:id/rejectedDetail",
          { id: "@id" },
          {
            deleteDetail: {
              method: "DELETE",
              params: {
                circleId: "@circleId"
              }
            }
          }
        )
      },
      PaymentReceipt: $resource(
        api.baseUrl + "PaymentReceipt/:id",
        { id: "@id" },
        {
          update: {
            method: "PUT",
            params: {
              idCircle: "@idCircle"
            }
          },
          setFile: {
            method: "PUT"
          },
          save: {
            method: "POST",
            params: {
              idCircle: "@idCircle"
            }
          }
        }
      ),
      PaymentReceiptFiles: $resource(
        api.baseUrl + "PaymentReceipt/getFilesReceipt/:id/",
        { id: "@id" },
        {
          get: {
            method: "GET",
            isArray: true
          }
        }
      ),
      RejectionReason: $resource(
        api.baseUrl + "RejectionReason/byCircle",
        {},
        {
          getAll: {
            method: "GET",
            isArray: true,
            params: {
              circleId: "@circleId"
            }
          }
        }
      ),
      allRejectionReason: $resource(
        api.baseUrl + "RejectionReason/:id",
        { id: "@id" },
        {
          query: {
            isArray: true
          },
          create: {
            method: "POST"
          },
          update: {
            method: "PUT"
          },
          delete: {
            method: "DELETE"
          }
        }
      ),
      rejectionReasonType: $resource(
        api.baseUrl + "RejectionReason/RejectionReasonType",
        {},
        {}
      ),
      setRejectionReason: $resource(
        api.baseUrl + "SettlementDetail/:id/rejectionReason",
        { id: "@id" },
        {
          setReason: {
            method: "PUT",
            params: {
              circleId: "@circleId"
            }
          }
        }
      ),
      Contract: $resource(
        api.baseUrl + "ContractPurchase/:id/",
        { id: "@id" },
        {
          update: {
            method: "PUT"
          },
          create: {
            method: "POST"
          },
          page: {
            method: "POST",
            isArray: false
          },
          getMerchandisesEntryes: {
            method: "GET",
            isArray: true
          }
        }
      ),
      ContractByNumber: $resource(
        api.baseUrl + "ContractPurchase/byNumber/",
        {},
        {
          getBy: {
            method: "GET"
          }
        }
      ),
      ContractFind: $resource(
        api.baseUrl + "ContractPurchase/find/:id/",
        { id: "@id" },
        {
          page: {
            method: "GET",
            isArray: false
          }
        }
      ),
      ContractMerchandiseEntryHeader: $resource(
        api.baseUrl + "ContractPurchase/getMerchandisesHeadersEntryes/:id/",
        { id: "@id" },
        {
          get: {
            method: "GET",
            isArray: true
          },
          create: {
            method: "POST"
          },
          page: {
            method: "GET",
            isArray: false
          }
        }
      ),
      ContractDetail: $resource(
        api.baseUrl + "ContractPurchaseDetail/:id/",
        { id: "@id" },
        {
          update: {
            method: "PUT"
          },
          create: {
            method: "POST"
          },
          page: {
            method: "GET",
            isArray: false
          },
          getContractPurchase: {
            method: "GET",
            isArray: true
          }
        }
      ),
      ContractDeleteNoPayment: $resource(
        api.baseUrl + "ContractPurchase/:id/deleteNoPayment",
        { id: "@id" }
      ),
      ContractChangeStatus: $resource(
        api.baseUrl + "ContractPurchase/:id/changeStatus",
        { id: "@id" },
        {
          update: {
            method: "PUT",
            params: {
              idCircle: "@idCircle",
              status: "@status",
              deleteAll: "@deleteAll"
            }
          }
        }
      ),
      ContractChangeStatusAuthorize: $resource(
        api.baseUrl + "ContractPurchase/:id/authorize",
        { id: "@id" },
        {
          update: {
            method: "POST",
            params: {
              idCircle: "@idCircle",
              status: "@status"
            }
          }
        }
      ),
      ContractType: $resource(
        api.baseUrl + "ContractType/:id",
        { id: "@id" },
        {
          getAll: {
            method: "GET",
            isArray: true
          }
        }
      ),
      InvoicePurchaseWithholding: $resource(
        api.baseUrl + "InvoicePurchaseWithholding/:id",
        { id: "@id" },
        {
          getByInvoice: {
            method: "GET",
            isArray: true
          },
          save: {
            method: "POST"
          },
          setTotal: {
            method: "PUT"
          },
          calculateWithholding: {
            method: "PATCH",
            isArray: true,
            params: {
              idCircle: "@idCircle",
              invoicePurchaseId: "@invoicePurchaseId"
            }
          },
          setFileWithholding: {
            method: "PUT",
            params: {
              idCircle: "@idCircle",
              invoicePurchaseId: "@invoicePurchaseId"
            }
          },
          addNew: {
            method: "POST",
            params: {
              idCircle: "@idCircle",
              invoicePurchaseId: "@invoicePurchaseId",
              typeId: "@typeId",
              rate: "@rate",
              amount: "@amount",
              baseAmount: "@baseAmount"
            }
          }
        }
      ),
      InvoicePurchaseWithholdingDetail: {
        Details: $resource(
          api.baseUrl + "InvoicePurchaseWithholdingDetail/:id",
          { id: "@id" },
          {
            getByInvoice: {
              method: "GET",
              isArray: true
            },
            save: {
              method: "POST"
            },
            delete: {
              method: "DELETE"
            }
          }
        ),
        Retention: $resource(
          api.baseUrl + 'InvoicePurchaseWithHoldingDetails/invoicePurchase/:invoiceId',
          { invoiceId: '@invoiceId' },
          {
            put: {
              method: 'PUT',
            }
          }
        ),
      },
      InvoicePurchaseDetailReference: {
        me: $resource(
          api.baseUrl + "InvoicePurchaseDetailReference/:id",
          { id: "@id" },
          {
            saveReferences: {
              method: "POST",
              isArray: true
            },
          }
        ),
        getReferences: $resource(
          api.baseUrl + "InvoicePurchaseDetailReference/getReferences",
          { id: "@id" },
          {
            get: {
              method: "GET",
              isArray: true
            },
          }
        )
      },
      SaleProduct: $resource(
        api.baseUrl + "Requisition/consignation/:productId",
        { productId: "@productId" },
        {
          sale: {
            method: "POST",
            isArray: false,
            params: {
              quantity: "@quantity",
              departmentId: "@departmentId",
              costCenterId: "@costCenterId",
              referenceId: "@referenceId"
            }
          }
        }
      ),
      BankAccount: $resource(
        api.baseUrlGeneral + "Company/:company/BankAccount/active",
        { company: "@company" }
      ),
      WireTransfer: $resource(api.baseUrl + "WireTransfer/:id", { id: "@id" }),
      PurchaseProductDelivery: {
        PurchaseProductDelivery: $resource(
          api.baseUrl + "PurchaseProductDelivery/Company/:company/:id",
          { company: "@company", id: "@id" },
          {
            query: {
              method: "GET",
              isArray: true
            },
            create: {
              method: "POST"
            },
            update: {
              method: "PUT"
            },
            delete: {
              method: "DELETE"
            }
          }
        )
      },
      InvoicePurchaseLimitDate: {
        LimitDate: $resource(
          api.baseUrl + "InvoicePurchase/LimitDate/Company/:companyId/:id",
          { companyId: "@companyId", id: "@id" },
          {
            query: {
              method: "GET",
              isArray: false
            },
            create: {
              method: "POST"
            },
            update: {
              method: "PUT"
            },
            delete: {
              method: "DELETE"
            }
          }
        )
      },
      InvoicePurchaseLimitDateType: {
        Active: $resource(
          api.baseUrl + "InvoicePurchase/LimitDate/Type/active",
          {},
          {}
        )
      },
      RequisitionType: {
        RequisitionTypeCompany: $resource(
          api.baseUrl + "RequisitionType/:company/:id",
          { company: "@company", id: "@id" },
          {
            query: {
              method: "GET",
              isArray: true
            },
            create: {
              method: "POST"
            },
            update: {
              method: "PUT"
            },
            delete: {
              method: "DELETE"
            },
            byId: {
              method: "GET"
            }
          }
        )
      },
      PhysicalDocumentDelivery: {
        PhysicalDocumentDelivery: $resource(
          api.baseUrl + "PhysicalDocumentDelivery/:id",
          { id: "@id" },
          {
            page: {
              method: "GET",
              isArray: false
            },
            getById: {
              method: "POST",
              isArray: false
            },
            update: {
              method: "PUT",
              isArray: false
            },
            create: {
              method: "POST",
              isArray: false
            }
          }
        ),
        changeStatus: $resource(
          api.baseUrl + "PhysicalDocumentDelivery/changeStatus",
          {
            physicalDocumentDeliveryId: "@physicalDocumentDeliveryId",
            status: "@status"
          },
          {
            update: {
              method: "PUT",
              isArray: false
            }
          }
        ),
        byId: $resource(
          api.baseUrl + "PhysicalDocumentDelivery/byId",
          { id: "@id" },
          {
            get: {
              method: "GET",
              isArray: false
            }
          }
        ),
        cancelProcess: $resource(
          api.baseUrl + "PhysicalDocumentDelivery/cancelProcess",
          { id: "@id" },
          {
            cancel: {
              method: "DELETE",
              isArray: false
            }
          }
        )
      },
      PhysicalDocumentDeliveryDetail: {
        PhysicalDocumentDeliveryDetail: $resource(
          api.baseUrl + "PhysicalDocumentDeliveryDetail/:id",
          { id: "@id" },
          {
            page: {
              method: "GET",
              isArray: false
            },
            getById: {
              method: "POST",
              isArray: false
            },
            update: {
              method: "PUT",
              isArray: false
            },
            create: {
              method: "POST",
              isArray: false
            },
            del: {
              method: "DELETE",
              isArray: false
            }
          }
        ),
        byPhysicalDocumentDelivery: $resource(
          api.baseUrl +
          "PhysicalDocumentDeliveryDetail/byPhysicalDocumentDelivery",
          { physicalDocumentDeliveryId: "@physicalDocumentDeliveryId" },
          {
            query: {
              method: "GET",
              isArray: true
            }
          }
        )
      },
      PurchaseStatusCompany: {
        PurchaseStatusCompany: $resource(
          api.baseUrl + "PurchaseStatusCompany/:company/:type",
          { company: "@company", type: "@type" },
          {
            get: {
              method: "GET",
              isArray: true
            }
          }
        ),
        PurchaseStatusCompanyObj: $resource(
          api.baseUrl + "PurchaseStatusCompany/:company/:id",
          { company: "@company", id: "@id" },
          {
            create: {
              method: "POST",
              isArray: false
            },
            update: {
              method: "PUT",
              isArray: false
            },
            del: {
              method: "DELETE",
              isArray: false
            }
          }
        )
      },
      ShippingOrder: $resource(
        api.baseUrl + "ShippingOrder/:id/",
        { id: "@id" },
        {
          update: {
            method: "PUT",
            isArray: false
          },
          create: {
            method: "POST",
            isArray: true
          },
          del: {
            method: "DELETE",
            isArray: false
          }
        }
      ),
      ShippingOrderDetail: $resource(
        api.baseUrl + "ShippingOrderDetail/:id/",
        { id: "@id" },
        {
          update: {
            method: "PUT",
            isArray: false
          },
          create: {
            method: "POST",
            isArray: true
          },
          del: {
            method: "DELETE",
            isArray: false
          }
        }
      ),
      ShippingOrderDetailByPurchaseorderDetail: $resource(
        api.baseUrl + "ShippingOrderDetail/byPurchaseorderDetail",
        {},
        {
          getAll: {
            method: "GET",
            isArray: true
          }
        }
      ),
      ShippingOrderDetailByShippingOrder: $resource(
        api.baseUrl + "ShippingOrderDetail/byShippingOrder",
        {},
        {
          getByShippingOrder: {
            method: "GET",
            isArray: true
          }
        }
      ),
      verifyCanInvoiceBeforeReceive: $resource(
        api.baseUrl + "PurchaseOrder/:idPurchaseOrder/Detail/verifyCanInvoiceBeforeReceive",
        { idPurchaseOrder: '@idPurchaseOrder' },
        {
          get: {
            method: "GET",
            isArray: false
          }
        }
      ),
      getQuantityInvoiced: $resource(
        api.baseUrl + "PurchaseOrder/:idPurchaseOrder/Detail/getQuantityInvoiced",
        { idPurchaseOrder: '@idPurchaseOrder' },
        {
          get: {
            method: "GET",
            isArray: false
          }
        }
      ),
      ContractDetailReference: {
        createReferences: $resource(
          api.baseUrl + "ContractPurchaseDetailReference/:id/createReferences",
          { id: '@id' },
          {
            create: {
              method: "POST",
              isArray: false
            }
          }
        ),
        byContractDetailsId: $resource(
          api.baseUrl + "ContractPurchaseDetailReference/byContractDetailsId",
          {},
          {
            getByDetailsIdAndNoPayment: {
              method: 'POST',
              isArray: true
            }
          }
        )
      },
      SettlementDetailReference: {
        createReferences: $resource(
          api.baseUrl + "SettlementDetailReference/:id/createReferences",
          { id: '@id' },
          {
            create: {
              method: "POST",
              isArray: false
            }
          }
        ),
        byInvoiceDetailsId: $resource(
          api.baseUrl + "SettlementDetailReference/getReferences",
          {},
          {
            get: {
              method: "GET",
              isArray: true
            }
          }
        )
      },
      RequisitionFiles: {
        getFilesByRequisition: $resource(
          api.baseUrl + 'RequisitionFiles/findByRequisition',
          {},
          {
            getList: {
              method: 'GET',
              isArray: true
            }
          }
        ),
        delFilesByRequisition: $resource(
          api.baseUrl + 'RequisitionFiles/deleteFiles',
          {},
          {
            deleteList: {
              method: 'POST',
              isArray: true
            }
          }
        ),
        saveRequisitionFiles: $resource(
          api.baseUrl + 'RequisitionFiles/',
          {},
          {
            create: {
              method: 'POST',
              isArray: true
            }
          }
        )
      }
    };

    api.LicitadorWS = {
      TenderPublish: $resource(
        api.baseUrlLicitadorWS + "Tender/Publish/:id",
        { id: "@id" },
        {
          publishTender: {
            method: "PUT",
            params: {
              businessCircleId: "@businessCircleId"
            }
          }
        }
      ),
      Tender: $resource(
        api.baseUrlLicitadorWS + "Tender/:id",
        { id: "@id" },
        {
          update: {
            method: "PUT"
          },
          create: {
            method: "POST"
          }
        }
      ),
      TenderPaymentType: $resource(
        api.baseUrlLicitadorWS + "TenderPaymentType/"
      ),
      TenderType: $resource(api.baseUrlLicitadorWS + "TenderType/"),
      TenderDetail: $resource(
        api.baseUrlLicitadorWS + "Tender/:idTender/Detail/:id",
        { id: "@id", idTender: "@idTender" },
        {
          getAll: {
            method: "GET",
            isArray: true
          },
          create: {
            method: "POST",
            isArray: true
          },
          update: {
            method: "PUT",
            isArray: true
          },
          delete: {
            method: "DELETE",
            isArray: true
          }
        }
      )
    };

    api.PresupuestosWS = {
      Budget: {
        findApprovedOfBeforeAndCurrentAndAfterMonth: $resource(
          api.baseUrlPresupuestosWS +
          "Company/:idc/Budget/findApprovedOfBeforeAndCurrentAndAfterMonth",
          { idc: "@idc" },
          {
            query: {
              isArray: true,
              params: {
                budgetTypeId: "@budgetTypeId",
                costCenterId: "@costCenterId",
                departmentId: "@departmentId"
              }
            }
          }
        ),
        findApprovedAndAuthorizeOfBeforeAndCurrentAndAfterMonth: $resource(
          api.baseUrlPresupuestosWS +
          "Company/:idc/Budget/findApprovedAndAuthorizeOfBeforeAndCurrentAndAfterMonth",
          { idc: "@idc" },
          {
            query: {
              isArray: true,
              params: {
                costCenterId: "@costCenterId",
                departmentId: "@departmentId"
              }
            }
          }
        ),
        validatesBudgetedProducts: $resource(
          api.baseUrlPresupuestosWS +
          "Company/:idc/Budget/validatesBudgetedProducts",
          { idc: "@idc" },
          {
            validate: {
              method: "POST",
              isArray: true,
              params: {
                budgetTypeId: "@budgetTypeId",
                costCenterId: "@costCenterId",
                departmentId: "@departmentId",
                budgetId: "@budgetId"
              }
            }
          }
        ),
        validatesBudgetedProductsContract: $resource(
          api.baseUrlPresupuestosWS +
          "Company/:idc/Budget/validatesBudgetedProductsContract",
          { idc: "@idc" },
          {
            validate: {
              method: "POST",
              isArray: true,
              params: {
                budgetTypeId: "@budgetTypeId",
                costCenterId: "@costCenterId",
                departmentId: "@departmentId",
                budgetId: "@budgetId"
              }
            }
          }
        ),
        revertBudgetedProducts: $resource(
          api.baseUrlPresupuestosWS +
          "Company/:idc/Budget/revertQuotaionProducts",
          { idc: "@idc" },
          {
            revertBudgeted: {
              method: "POST",
              isArray: true,
              params: {
                budgetTypeId: "@budgetTypeId",
                costCenterId: "@costCenterId",
                departmentId: "@departmentId",
                budgetId: "@budgetId"
              }
            }
          }
        ),
        executedByDateRange: $resource(
          api.baseUrlPresupuestosWS + "Company/:idc/Budget/executedByDateRange",
          { idc: "@idc" },
          {
            query: {
              method: "POST",
              isArray: true,
              params: { idc: "@idc" }
            }
          }
        )
      },
      BudgetType: {
        getAll: $resource(
          api.baseUrlPresupuestosWS + "BudgetType/:companyId",
          { companyId: "@companyId" },
          {
            query: {
              method: "GET",
              isArray: true
            }
          }
        )
      },
      BudgetDetail: {
        me: $resource(
          api.baseUrlPresupuestosWS + "Budget/:idb/BudgetDetail/:id",
          { idb: "@idb", id: "@id" },
          {
            query: {
              method: "GET",
              isArray: true
            },
            updateDetails: {
              method: "PUT",
              isArray: true
            }
          }
        ),
        updateExecutedAmounts: $resource(
          api.baseUrlPresupuestosWS +
          "Budget/:idb/BudgetDetail/updateExecutedAmountsFromInvoice",
          { idb: "@idb" },
          {
            update: {
              method: "POST",
              isArray: true
            },
            reverse: {
              method: "PUT",
              isArray: true
            }
          }
        ), updateExecutedAmountsContract: $resource(
          api.baseUrlPresupuestosWS +
          "Budget/:idb/BudgetDetail/updateExecutedAmountsFromInvoiceContract",
          { idb: "@idb" },
          {
            update: {
              method: "POST",
              isArray: true
            },
            reverse: {
              method: "PUT",
              isArray: true
            }
          }
        )
      }
    };

    api.ActivosFijosWS = {
      FixedAsset: {
        me: $resource(
          api.baseUrlActivosFijosWS +
          "Company/:companyId/FixedAsset/:fixedAssetId",
          { companyId: "@companyId", fixedAssetId: "@fixedAssetId" },
          {
            page: {
              method: "GET",
              params: {
                pageNumber: "@pageNumber",
                pageSize: "@pageSize",
                search: "@search"
              }
            },
            create: {
              method: 'POST',
              params: {},
              interceptor: interceptor
            },
            update: {
              method: "PUT",
              params: {},
              interceptor: interceptor
            }
          }
        )
      },
      FixedAssetGroup: {
        me: $resource(
          api.baseUrlActivosFijosWS +
          "Company/:companyId/FixedAssetGroup/:fixedAssetGroupId",
          { companyId: "@companyId", fixedAssetGroupId: "@fixedAssetGroupId" },
          {
            get: {
              method: "GET",
              isArray: false
            },
            query: {
              method: "GET",
              isArray: true,
              params: { search: "@search" }
            },
            create: {
              method: "POST",
              params: {},
              interceptor: interceptor
            },
            update: {
              method: "PUT",
              params: {},
              interceptor: interceptor
            }
          }
        )
      },
      FixedAssetGroupFeature: {
        countByCompany: $resource(api.baseUrlActivosFijosWS + 'Company/:companyId/FixedAssetGroup/:fixedAssetGroupId/Feature/countByCompanyAndProductsGroup',
          {}, {
          get: {
            method: 'GET',
            isArray: false,
          },
        }),
        me: $resource(
          api.baseUrlActivosFijosWS +
          "Company/:companyId/FixedAssetGroup/:fixedAssetGroupId/Feature/:fixedAssetGroupFeatureId",
          {
            companyId: "@companyId",
            fixedAssetGroupId: "@fixedAssetGroupId",
            fixedAssetGroupFeatureId: "@fixedAssetGroupFeatureId"
          },
          {
            get: {
              method: "GET",
              interceptor: interceptor
            },
            getProductAddons: {
              method: "GET",
              isArray: true,
              interceptor: interceptor
            },
            query: {
              method: "GET",
              isArray: true
            },
            create: {
              method: "POST",
              params: {},
              interceptor: interceptor
            },
            update: {
              method: "PUT",
              params: {},
              interceptor: interceptor
            }
          }
        ),
        active: $resource(
          api.baseUrlActivosFijosWS +
          "Company/:companyId/FixedAssetGroup/:fixedAssetGroupId/Feature/:fixedAssetGroupFeatureId/active",
          {
            companyId: "@companyId",
            fixedAssetGroupId: "@fixedAssetGroupId",
            fixedAssetGroupFeatureId: "@fixedAssetGroupFeatureId"
          },
          {
            query: {
              method: "GET",
              isArray: true
            }
          }
        ),
        getProductsToProvider: $resource(
          api.baseUrlActivosFijosWS +
          "Company/:companyId/FixedAssetGroup/Feature/getProductsToProvider",
          {
            companyId: "@companyId",
          },
          {
            get: {
              method: "GET",
              isArray: true,
              interceptor: interceptor
            }
          }
        )
      }
    };

    api.ProyectosWS = {
      getAll: $resource(
        api.baseUrlProyectosWS + "Company/:companyId/Project",
        { companyId: "@companyId" },
        {
          query: {
            method: "GET",
            isArray: true
          }
        }
      ),
      getAllActive: $resource(
        api.baseUrlProyectosWS + "Company/:companyId/Project/active",
        { companyId: "@companyId" },
        {
          query: {
            method: "GET",
            isArray: true
          }
        }
      ),
      getAllProject: $resource(
        api.baseUrlProyectosWS + "Project/byIds/:ids",
        { ids: "@ids" },
        {
          get: {
            method: "GET",
            isArray: true
          },
        }
      )
    };

    api.NotificacionesWS = {
      Notification: {
        currentNotifications: $resource(
          api.baseUrlNotificacionesWS +
          ":circleId/Notification/currentNotifications",
          { circleId: "@circleId" },
          {
            query: {
              method: "GET",
              isArray: true
            }
          }
        ),
        pageOfCurrentNotifications: $resource(
          api.baseUrlNotificacionesWS +
          ":circleId/Notification/pageOfCurrentNotifications",
          { circleId: "@circleId" },
          {
            page: {
              method: "GET",
              isArray: false,
              params: { pageSize: "@pageSize", pageNumber: "@pageNumber" }
            }
          }
        )
      },
      UserNotification: {
        unreadNotifications: $resource(
          api.baseUrlNotificacionesWS + ":circleId/UserNotification/Me/unread",
          { circleId: "@circleId" },
          {
            query: {
              method: "GET",
              isArray: true
            }
          }
        ),
        pageOfUnreadNotifications: $resource(
          api.baseUrlNotificacionesWS +
          ":circleId/UserNotification/Me/pageOfUnreadNotifications",
          { circleId: "@circleId" },
          {
            page: {
              method: "GET",
              isArray: false,
              params: { pageSize: "@pageSize", pageNumber: "@pageNumber" }
            }
          }
        ),
        myNotifications: $resource(
          api.baseUrlNotificacionesWS + ":circleId/UserNotification/Me",
          { circleId: "@circleId" },
          {
            page: {
              method: "POST",
              isArray: false,
              params: { pageSize: "@pageSize", pageNumber: "@pageNumber" }
            }
          }
        ),
        markAsRead: $resource(
          api.baseUrlNotificacionesWS + ":circleId/UserNotification/markAsRead",
          { circleId: "@circleId" },
          {
            update: {
              method: "PUT"
            }
          }
        ),
        markAllAsRead: $resource(
          api.baseUrlNotificacionesWS +
          ":circleId/UserNotification/markAllAsRead",
          { circleId: "@circleId" },
          {
            update: {
              method: "PUT"
            }
          }
        )
      },
      UserNotificationConfig: {
        me: $resource(
          api.baseUrlNotificacionesWS + "UserNotificationConfig",
          {},
          {
            query: {
              method: "GET",
              isArray: true,
              params: { companyId: "@companyId" }
            },
            update: {
              method: "PUT"
            }
          }
        )
      }
    };

    api.InterfazWS = {
      EntityCatalog: {
        me: $resource(
          api.baseUrlInterfazWS + "EntityCatalog",
          {},
          {
            query: {
              method: "GET",
              isArray: true
            }
          }
        )
      },
      InterfazTransaction: {
        findByFilter: $resource(
          api.baseUrlInterfazWS + "Transaction/:companyId",
          { companyId: "@companyId" },
          {
            page: {
              method: "POST",
              params: { pageNumber: "@pageNumber", pageSize: "@pageSize" }
            }
          }
        )
      }
    };

    return api;
  }
})();

function prepareFieldName(name) {
    name = name.split('%').join('');
    name = name.split('+').join('');
    name = name.split(' ').join('');
    name = name.split('(').join('');
    name = name.split(')').join('');
    name = name.split('-').join('');
    name = name.split('–').join('');
    name = name.split('_').join('');
    name = name.split('/').join('');
    name = name.split('.').join('');
    return name.split('&').join('');
}

function getHeader(name) {
    return '{{\'' + name.value + '\'|translate}}';
}

function getHeaderMenu(a, $filter) {
    a.columnApi.getAllColumns().forEach(function (r) {
        r.colDef.hN = r.colDef.hN ? r.colDef.hN : angular.copy(r.colDef.headerName);
        r.colDef.headerName = $filter('translate')(r.colDef.hN);
    });
    return a.defaultItems;
}

function getQSByM(m) {
    var arrM = [
        { q: 1, s: 1 },
        { q: 1, s: 1 },
        { q: 1, s: 1 },
        { q: 2, s: 1 },
        { q: 2, s: 1 },
        { q: 2, s: 1 },
        { q: 3, s: 2 },
        { q: 3, s: 2 },
        { q: 3, s: 2 },
        { q: 4, s: 2 },
        { q: 4, s: 2 },
        { q: 4, s: 2 }
    ];
    return arrM[m];
}


function createKeyFile(_keys_, currentKey) {
    var keys = angular.copy(_keys_);
    keys.push(currentKey);
    var formKey = keys.shift();

    if (keys.length) {
        formKey += "[" + keys.join("][") + "]";
    }
    return formKey;
}


function addToFdFile(object, keys) {
    var fd = new FormData();
    angular.forEach(object, function (value, key) {
        var formKey = keys;

        if (value instanceof File) {
            fd.append(formKey, value);
        } else if (value instanceof FileList) {
            if (value.length === 1) {
                fd.append(formKey, value[0]);
            } else {
                angular.forEach(value, function (file, index) {
                    fd.append(formKey + '[' + index + ']', file);
                });
            }
        } else if (value && (typeof value === 'object' || typeof value === 'array')) {
            var _keys = angular.copy(keys);
            _keys.push(key);
            addToFd(value, _keys);
        } else {
            fd.append(formKey, value);
        }
    });
    return fd;
}

function getImageFile(name) {
    if (name.match(/.(doc|docx|odt)$/i)) {
        return 'assets/images/logos/doc.ico';
    } else if (name.match(/.(xls|xlsx|ods)$/i)) {
        return 'assets/images/logos/xls.ico';
    } else if (name.match(/.(pdf)$/i)) {
        return 'assets/images/logos/pdf.jpg';
    }
    return 'assets/images/logos/gulp.png';
}


function getObjectTender(data) {
    var obj = {
        "requestedReference": data.requisition.id,
        "title": "Requerimiento de Compra " + data.requisition.id,
        "description": "Compra para el departamento " + data.requisition.department.description +
            " y centro de costo " + data.requisition.costCenter.description + " a travez de Requerimiento " + data.requisition.id,
        "company": {
            "id": data.requisition.department.company.id
        },
        "tenderDetails": [
        ],
        "startDateToReceiveOffer": new Date(),
        "dateToChooseOffer": new Date(data.requisition.maxDatePurchase)
    };
    data.details.forEach(function (d) {
        obj.tenderDetails.push({
            "product": {
                "id": d.product.id
            },
            "quantity": d.quantity,
            "description": d.observations
        });
    });
    return obj;
}

function replaceOriginTypedata(data, label) {
    var newlabel = !label ? '' : label;
    newlabel = newlabel.replace('{id}', data.id);
    newlabel = newlabel.replace('{referenceId}', data.referenceId);
    return newlabel;
}

function getMonths(m) {
    var months = [
        { id: 0, name: 'TEMPLATE.MONTH.ENERO' },
        { id: 1, name: 'TEMPLATE.MONTH.FEBRERO' },
        { id: 2, name: 'TEMPLATE.MONTH.MARZO' },
        { id: 3, name: 'TEMPLATE.MONTH.ABRIL' },
        { id: 4, name: 'TEMPLATE.MONTH.MAYO' },
        { id: 5, name: 'TEMPLATE.MONTH.JUNIO' },
        { id: 6, name: 'TEMPLATE.MONTH.JULIO' },
        { id: 7, name: 'TEMPLATE.MONTH.AGOSTO' },
        { id: 8, name: 'TEMPLATE.MONTH.SEPTIEMBRE' },
        { id: 9, name: 'TEMPLATE.MONTH.OCTUBRE' },
        { id: 10, name: 'TEMPLATE.MONTH.NOVIEMBRE' },
        { id: 11, name: 'TEMPLATE.MONTH.DICIEMBRE' }
    ];
    var mnts = angular.copy(months);
    for (var i = 0; i < mnts.length; i++) {
        if (mnts[i].id <= m) {
            months.splice(0, 1);
        }
    }
    return months;
}

(function () {
    'use strict';

    angular
        .module('app.auth', ['app.auth.login', 'app.auth.lock', 'app.auth.strengthPassword', 'app.auth.checkPassword'])
        .config(config);

    /** @ngInject */
    function config() {

    }
})();


(function () {
  "use strict";

  angular.module("app.returns", []).config(config);

  function config($stateProvider, $translatePartialLoaderProvider) {
    // State
    $stateProvider
      .state("app.returns", {
        url: "/returns",
        abstract: true,
      })
      .state("app.returns.issue", {
        url: "/issue",
        views: {
          "content@app": {
            templateUrl: "app/main/apps/returns/returns.html",
            controller: function() {},
          },
          params: {},
          resolve: {},
        },
      })
      .state("app.returns.pendingReturn", {
        url: "/pending-verification",
        views: {
          "content@app": {
            templateUrl: "app/main/apps/returns/pending-verification.html",
            controller: function() {},
          },
          params: {},
          resolve: {},
        },
      })
      .state("app.returns.queryReceived", {
        url: "/returns-received",
        views: {
          "content@app": {
            templateUrl: "app/main/apps/returns/returns-received.html",
            controller: function() {},
          },
          params: {},
          resolve: {},
        },
      })
      .state("app.returns.queryIssued", {
        url: "/issue-return-query",
        views: {
          "content@app": {
            templateUrl: "app/main/apps/returns/issue-return-query.html",
            controller: function() {},
          },
          params: {},
          resolve: {},
        },
      })
      .state("app.returns.pendingReceivedOriginal", {
        url: "/pending-received-original",
        views: {
          "content@app": {
            templateUrl: "app/main/apps/returns/pending-received-original.html",
            controller: function() {},
          },
          params: {},
          resolve: {},
        },
      })
      .state("app.returns.pendingIssuance", {
        url: "/pending-issue",
        views: {
          "content@app": {
            templateUrl: "app/main/apps/returns/pending-issue.html",
            controller: function() {},
          },
          params: {},
          resolve: {},
        },
      });

    // Translation
    $translatePartialLoaderProvider.addPart("app/main/apps/returns");
  }
})();

(function () {
    'use strict';

    angular
        .module('app.expenseSettlement', [
            'app.expenseSettlement.pettyCash',
            'app.expenseSettlement.settlement',
            'app.expenseSettlement.verificationSettlement',
            'app.expenseSettlement.requiredProduct',
            'app.expenseSettlement.pettyCashGeneralSets',
            'app.expenseSettlement.paymentSettlement',
            'app.expenseSettlement.provisioned',
            'app.expenseSettlement.paidSettlements',
            'app.expenseSettlement.consultSettlements'
        ]).config(config);


    /** @ngInject **/
    function config(msNavigationServiceProvider) {

    }

})();

(function () {
    'use strict';

    angular
        .module('app.dashboards', [
            'app.dashboards.project'
        ])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider) {

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/dashboards');
    }

})();

(function () {
    'use strict';

    angular
        .module('app.accountStatus', ['flow'])
        .config(config)
        .directive('expandGrid', expandGrid);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider) {

        $stateProvider
            .state('app.accountStatus', {
                url: '/accountStatus',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/accountStatus/horizontalFilter.html',
                        controller: 'AccountStatusController as vm'
                    }
                },
                resolve: {
                    Report: function (msApi) {
                        return msApi.resolve('report.accountStatus@get');
                    }
                },
                params: {
                    filter: null
                },
                bodyClass: 'file-manager'
            })
            ;

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/accountStatus');

        // Api
        msApiProvider.register('report.accountStatus', ['app/main/apps/accountStatus/data/accountStatus.json']);
    }

    function expandGrid() {
        var directive = {
            link: link, // The function attaching the behavior
            restrict: 'A' // Restrict directive to be used only as attribute
        };
        return directive;


        function link(scope, element, attrs) {

            var gridElement = $(element);
            var idGrid = attrs.id;
            var min = attrs.min ? parseInt(attrs.min) : 250;
            var other = attrs.other ? parseInt(attrs.other) : 0;
            resizeGridM("#" + idGrid, other, min);
            // Attach an eventHandler to the resize event of the
            // window to resize the data area of the grid accordingly
            scope.$watch(
                function () {
                    return gridElement.parent().height();
                },
                function (height) {
                    resizeGridM("#" + idGrid, other, min);
                });
        }
    }
    function resizeGridM(gridName, other, min) {
        //Define Elements Needed
        var grid = $(gridName);

        other = other ? other : 0;
        //Other variables
        var minimumAcceptableGridHeight = min ? min : 250; //This is roughly 5 rows

        //Get Window Height
        var windowHeight = $(window).innerHeight();

        //Padding you want to apply below your page
        var bottomPadding = 60;

        //Check if Calculated height is below threshold
        var calculatedHeight = windowHeight - bottomPadding - other - 150;
        var finalHeight = calculatedHeight < minimumAcceptableGridHeight ? minimumAcceptableGridHeight : calculatedHeight;

        //Apply the height for the content area
        grid.css('height', finalHeight + 'px');
    }

})();

(function () {
        'use strict';

        angular
                .module('app.common',
                        [
                                'angular-chartist',
                                'chart.js',
                                'datatables',
                                'gridshore.c3js.chart',
                                'nvd3',
                                'timer',
                                'uiGmapgoogle-maps',
                                'textAngular',
                                'ui.sortable',
                                'ngMdIcons',
                                'ng-sortable',
                                'xeditable',
                                'moment-picker',
                                // Library Optionals
                                'bw.paging',
                                'satellizer', 'LocalStorageModule', 'ngIdle', 'agGrid',
                                'environment',
                                'angularTrix',
                                //Querys to JSON
                                'angular-jinqjs',
                                //ng-flog attach file
                                'flow',
                                //notifications
                                'angular-web-notification',
                                'ngJsTree'
                        ]);
})();

angular.module("fuse").run(["$templateCache", function($templateCache) {$templateCache.put("app/quick-panel/quick-panel.html","<md-content><div class=\"my-notifications\" layout=\"column\" \nng-include=\"\'app/quick-panel/tabs/my-notifications/my-notifications.html\'\"></div></md-content>");
$templateCache.put("app/core/layouts/content-only.html","<div id=\"layout-content-only\" class=\"template-layout\" layout=\"column\" flex><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/core/layouts/content-with-toolbar.html","<div id=\"layout-content-with-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/layouts/horizontal-navigation.html","<div id=\"layout-horizontal-navigation\" class=\"template-layout\" layout=\"column\" flex><div \nid=\"toolbar-navigation-container\" class=\"md-whiteframe-1dp\" layout=\"column\" layout-align=\"space-between start\">\n<md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"horizontal-navigation\" ui-view=\"navigation\" layout=\"row\" layout-align=\"start end\" flex></div></div><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar-2\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation.html","<div id=\"layout-vertical-navigation\" class=\"template-layout\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" \nclass=\"md-primary-bg\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll \nui-view=\"navigation\"></md-sidenav><div id=\"content-container\" flex layout=\"column\"><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ms-scroll ui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/theme-options/theme-options.html","<md-sidenav md-component-id=\"fuse-theme-options\" class=\"md-sidenav-right\"><div class=\"ms-theme-options-list\" \nlayout=\"column\"><div class=\"theme-option layout-options\"><div class=\"option-title\">Layout Style:</div><md-radio-group \nlayout=\"row\" layout-align=\"start start\" layout-wrap ng-model=\"vm.layoutStyle\" ng-change=\"vm.updateLayoutStyle()\">\n<md-radio-button ng-repeat=\"layoutStyle in vm.layoutStyles\" ng-value=\"layoutStyle.value\"><div layout=\"column\" \nlayout-align=\"center center\"><img ng-src=\"{{layoutStyle.figure}}\"> <span class=\"text-center font-size-12 mt-8\">\n{{layoutStyle.label}}</span></div></md-radio-button></md-radio-group></div><md-divider></md-divider><div \nclass=\"theme-option\"><div class=\"option-title\">Layout Mode:</div><md-radio-group layout=\"row\" \nlayout-align=\"start center\" ng-model=\"vm.layoutMode\" ng-change=\"vm.updateLayoutMode()\"><md-radio-button \nng-repeat=\"layoutMode in vm.layoutModes\" ng-value=\"layoutMode.value\">{{layoutMode.label}}</md-radio-button>\n</md-radio-group></div><md-divider></md-divider><div class=\"theme-option color-palettes\"><div class=\"option-title\">\nColor Palette:</div><div layout=\"row\" layout-align=\"start start\" layout-wrap><md-button \nng-repeat=\"(themeName, theme) in vm.themes.list\" class=\"md-raised theme-button\" layout=\"row\" \nlayout-align=\"center center\" aria-label=\"{{themeName}}\" ng-click=\"vm.setActiveTheme(themeName)\" \nng-style=\"{\'background-color\': theme.primary.color,\'border-color\': theme.accent.color,\'color\': theme.primary.contrast1}\" \nng-class=\"{active: vm.getActiveTheme().name === themeName}\"><md-icon ng-style=\"{\'color\': theme.primary.contrast1}\" \nmd-font-icon=\"icon-palette\" class=\"icon s32\"></md-icon></md-button></div></div></div></md-sidenav>");
$templateCache.put("app/core/directives/ms-info-bar/ms-info-bar.html","<div id=\"ms-info-bar\" layout=\"row\" layout-align=\"start center\" flex><div id=\"ms-info-bar-message\" ng-transclude flex>\n</div><md-button id=\"ms-info-bar-close\" class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"removeInfoBar()\"><md-icon \nmd-font-icon=\"icon-close s24\"></md-icon></md-button></div>");
$templateCache.put("app/core/directives/ms-material-color-picker/ms-material-color-picker.html","<md-menu md-position-mode=\"target-right target\"><div ng-click=\"$mdOpenMenu($event)\"><ms-color-picker-button><md-button \naria-label=\"Row Color\" md-menu-origin ng-click=\"$mdOpenMenu($event)\" ng-class=\"vm.selectedColor.class\"><span \nng-show=\"vm.selectedColor.palette\">{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span \nng-show=\"!vm.selectedColor.palette\">Select Color</span></md-button></ms-color-picker-button></div><md-menu-content \nclass=\"ms-material-color-picker-menu-content\" layout-column><header \nng-class=\"vm.selectedColor.class || \'md-accent-bg\'\" class=\"md-whiteframe-4dp\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button md-prevent-menu-close ng-click=\"vm.activateHueSelection(false,false)\" \nclass=\"md-icon-button\" ng-class=\"{\'hidden\':!vm.selectedPalette}\" aria-label=\"Palette\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"s20\"></md-icon></md-button><span ng-if=\"vm.selectedColor.palette\">\n{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span ng-if=\"!vm.selectedColor.palette\">Select Color\n</span><md-button class=\"remove-color-button md-icon-button\" ng-click=\"vm.removeColor()\" aria-label=\"Remove Color\">\n<md-icon md-font-icon=\"icon-delete\" class=\"s20\"></md-icon></md-button></header><div class=\"colors\" ms-scroll><div \nng-show=\"!vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" ng-class=\"\'md-\'+palette+\'-500-bg\'\" \nng-repeat=\"(palette, hues) in vm.palettes\" ng-click=\"vm.activateHueSelection(palette,hues)\" layout=\"row\" \nlayout-align=\"start end\" md-prevent-menu-close md-ink-ripple><span class=\"label\">{{palette}}</span></div></div><div \nng-show=\"vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" \nng-class=\"\'md-\'+vm.selectedPalette+\'-\'+hue+\'-bg\'\" ng-repeat=\"(hue, values) in vm.selectedHues\" \nng-click=\"vm.selectColor(vm.selectedPalette,hue)\" layout=\"row\" layout-align=\"start end\" md-ink-ripple><span \nclass=\"label\">{{hue}} </span><i ng-if=\"vm.selectedPalette == vm.selectedColor.palette && hue == vm.selectedColor.hue\" \nclass=\"s16 icon-check\"></i></div></div></div></md-menu-content></md-menu>");
$templateCache.put("app/core/directives/ms-search-bar/ms-search-bar.html","<div flex layout=\"row\" layout-align=\"start center\"><label for=\"ms-search-bar-input\"><md-button \nclass=\"ms-search-bar-expander md-icon-button\" aria-label=\"Expand Search Bar\" ng-click=\"MsSearchBar.expand()\" \nng-if=\"!MsSearchBar.resultsLoading || MsSearchBar.collapsed\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\">\n</md-icon></md-button><div class=\"ms-search-bar-loader\" layout=\"row\" layout-align=\"center center\" \nng-if=\"MsSearchBar.resultsLoading && !MsSearchBar.collapsed\"><md-progress-circular class=\"md-accent\" md-diameter=\"32\" \nmd-mode=\"indeterminate\"></md-progress-circular></div></label><input id=\"ms-search-bar-input\" type=\"text\" \nplaceholder=\"Search\" flex ng-model=\"MsSearchBar.query\" ng-model-options=\"MsSearchBar.queryOptions\" \nng-blur=\"MsSearchBar.collapse()\" ng-keydown=\"MsSearchBar.handleKeydown($event)\"><md-button \nclass=\"ms-search-bar-collapser md-icon-button\" ng-click=\"MsSearchBar.collapse()\" aria-label=\"Collapse Search Bar\">\n<md-icon md-font-icon=\"icon-close\" class=\"icon s24\"></md-icon></md-button><div class=\"ms-search-bar-results\" \nng-if=\"MsSearchBar.results\" ms-scroll><div class=\"no-results\" ng-if=\"MsSearchBar.results.length === 0\">No Results!\n</div><div class=\"result\" ng-repeat=\"result in MsSearchBar.results\" ng-click=\"MsSearchBar.handleResultClick(result)\" \nng-mouseenter=\"MsSearchBar.handleMouseenter($index)\" ng-mousedown=\"MsSearchBar.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsSearchBar.selectedResultIndex}\" md-ink-ripple><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"icon-container\" layout=\"row\" layout-align=\"center center\"><i \nng-if=\"result.icon\" class=\"icon {{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div>\n<div><div class=\"title\">{{result.title}}</div><div class=\"description\" ng-if=\"result.description\">\n{{result.description}}</div></div></div></div></div></div>");
$templateCache.put("app/core/directives/ms-shortcuts/ms-shortcuts.html","<div class=\"shortcuts-container\" layout=\"row\" layout-align=\"space-between center\" flex \nng-class=\"{\'mobile-bar-active\': MsShortcuts.mobileBarActive}\"><div layout=\"row\" layout-align=\"start center\" flex><div \nclass=\"shortcuts hide show-gt-xs\" layout=\"row\" layout-align=\"start center\" ms-scroll \nng-if=\"MsShortcuts.shortcuts.length > 0\" ng-sortable=\"MsShortcuts.sortableOptions\"><div \nng-repeat=\"shortcut in MsShortcuts.shortcuts\" layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-icon-button shortcut\" aria-label=\"{{shortcut.translate ? shortcut.translate : shortcut.title| translate}}\" \nui-sref=\"{{shortcut.uisref}}\"><md-icon ng-if=\"shortcut.icon\" md-font-icon=\"{{shortcut.icon}}\" class=\"icon s24\">\n</md-icon><div ng-if=\"!shortcut.icon\" class=\"first-letter\">{{shortcut.title.charAt(0)}}</div><md-tooltip \nmd-direction=\"bottom\">{{shortcut.translate ? shortcut.translate : shortcut.title| translate}}</md-tooltip></md-button>\n</div></div><md-menu md-offset=\"8 56\" class=\"shortcut-menu hide show-gt-xs\"><md-button \nclass=\"md-icon-button add-shortcut-button\" aria-label=\"Add shortcut\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-menu-origin md-font-icon=\"icon-star\" class=\"icon amber-600-fg s24\"></md-icon><md-tooltip md-direction=\"bottom\">\n{{\'SHORTCUTS.CLICK_ADD_TO_REMOVE_SHORTCUT\' | translate}}</md-tooltip></md-button><md-menu-content><div \nid=\"ms-shortcut-add-menu\"><div class=\"shortcut-search\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"search-icon\" layout=\"row\" layout-align=\"center center\" ng-if=\"!MsShortcuts.resultsLoading\"><md-icon \nmd-menu-align-target md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon></div><div class=\"shortcut-loader\" \nlayout=\"row\" layout-align=\"center center\" ng-if=\"MsShortcuts.resultsLoading\"><md-progress-circular class=\"md-accent\" \nmd-diameter=\"20\" md-mode=\"indeterminate\"></md-progress-circular></div><input type=\"text\" \nplaceholder=\"{{\'SHORTCUTS.SEARCH\' | translate}}\" flex ng-model=\"MsShortcuts.query\" \nng-model-options=\"MsShortcuts.queryOptions\" ng-keydown=\"MsShortcuts.handleKeydown($event)\"></div><div class=\"results\" \nng-if=\"MsShortcuts.results\" ms-scroll><div class=\"no-results\" ng-if=\"MsShortcuts.results.length === 0\">No Results!\n</div><div class=\"result\" ng-repeat=\"result in MsShortcuts.results\" ng-click=\"MsShortcuts.handleResultClick(result)\" \nng-mouseenter=\"MsShortcuts.handleMouseenter($index)\" ng-mousedown=\"MsShortcuts.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsShortcuts.selectedResultIndex}\" md-prevent-menu-close=\"md-prevent-menu-close\" \nmd-ink-ripple><div layout=\"row\" layout-align=\"start space-between\"><div layout=\"row\" layout-align=\"start center\" flex>\n<div class=\"icon icon-container\" layout=\"row\" layout-align=\"center center\"><i ng-if=\"result.icon\" \nclass=\"{{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div><div><div class=\"title\">\n{{result.translate ? result.translate : result.title | translate}}</div></div></div><md-icon md-font-icon=\"icon-pin\" \nclass=\"icon s18\" ng-class=\"{\'fade-text\': !result.hasShortcut}\"></md-icon></div></div></div></div></md-menu-content>\n</md-menu></div><md-button class=\"md-icon-button toggle-mobile-menu hide-gt-xs\" aria-label=\"Add shortcut\" \nng-click=\"MsShortcuts.toggleMobileBar()\"><md-icon md-menu-origin md-font-icon=\"icon-star\" \nclass=\"icon amber-600-fg s24\" ng-hide=\"MsShortcuts.mobileBarActive\"></md-icon><md-icon md-menu-origin \nmd-font-icon=\"icon-close\" class=\"icon s24\" ng-hide=\"!MsShortcuts.mobileBarActive\"></md-icon></md-button></div>");
$templateCache.put("app/navigation/layouts/horizontal-navigation/navigation.html","<div layout=\"row\" layout-align=\"start center\"><ms-navigation-horizontal></ms-navigation-horizontal></div>");
$templateCache.put("app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html","<ms-navigation class=\"scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/navigation/layouts/vertical-navigation/navigation.html","<md-toolbar class=\"navigation-header md-whiteframe-1dp\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">{{vm.app.initials}}</span> <span \nclass=\"logo-text\">{{vm.app.name}}</span></div><md-icon class=\"fold-toggle s18\" md-font-icon=\"icon-backburger\" hide \nshow-gt-sm ng-click=\"vm.toggleMsNavigationFolded()\"></md-icon></md-toolbar><ms-navigation class=\"scrollable\" \nfolded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/main/apps/accountStatus/accountStatusTemplate.html","<div id=\"report\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" layout=\"column\" flex><div \nclass=\"header md-accent-bg\"><div class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div \nclass=\"toolbar\" layout=\"row\" layout-align=\"space-between\"><span class=\"h1\">{{\'REPORT.TITLE.\' + vm.title| translate}}\n</span><div class=\"right-side\" layout=\"row\"><md-button class=\"md-icon-button main-sidenav-toggle\" \nng-click=\"vm.toggleSidenav(\'main-sidenav\')\" aria-label=\"Toggle Main Sidenav\" translate \ntranslate-attr-aria-label=\"FILE.TOOGLE_MAIN_SIDENAV\"><md-icon md-font-icon=\"icon-filter\" class=\"icon\"></md-icon>\n</md-button></div></div><div class=\"breadcrumb text-truncate\" layout=\"row\" layout-align=\"start center\"><span \ndata-ng-repeat=\"path in vm.path\">{{path}}<md-icon md-font-icon=\"icon-chevron-right\" class=\"icon separator\"></md-icon>\n</span></div></div></div><md-content class=\"content\" flex><md-progress-linear md-mode=\"indeterminate\" \nng-if=\"vm.loading\" class=\"md-accent\"></md-progress-linear><div id=\"masterGridOptions\" ag-grid=\"vm.masterGridOptions\" \nclass=\"ag-fresh\" expand-grid min=\"260\" other=\"-10\"></div></md-content></div><md-sidenav \nclass=\"main-sidenav md-sidenav-right\" md-component-id=\"main-sidenav\" \nng-include=\"\'app/main/apps/reports/sidenavs/filter/filter.html\'\" ms-scroll ms-sidenav-helper></md-sidenav></div>");
$templateCache.put("app/main/apps/accountStatus/horizontalFilter.html","<md-progress-linear style=\"position: fixed; height: 5px; z-index: 10\" md-mode=\"query\" class=\"md-accent\" \nng-show=\"vm.isShowProgressLinear\"></md-progress-linear><div style=\"padding-top: 5px\"><div \nng-include=\"\'app/main/apps/reports/sidenavs/filter/h-filter.html\'\"></div><div layout=\"row\" \nlayout-align=\"center center\"><h2>{{\'REPORT.TITLE.\' + vm.title| translate}}</h2></div><div id=\"masterGridOptions\" \nag-grid=\"vm.masterGridOptions\" class=\"ag-fresh\" expand-grid min=\"260\" other=\"-10\" ng-show=\"vm.showGrid\"></div></div>\n<md-button class=\"md-fab\" ng-if=\"vm.exportXLS\" aria-label=\"Generar xls\" ng-show=\"vm.showGrid\" \nng-disabled=\"!vm.hasData\" ng-click=\"vm.onExportXLS()\" style=\"position: fixed; bottom: 10px; right: 20px\"><md-icon \nmd-font-icon=\"icon-file-excel\"></md-icon><md-tooltip md-direction=\"left\">{{\'REPORT.EXPORTXLS\'| translate}}</md-tooltip>\n</md-button>");
$templateCache.put("app/main/apps/contract/contracts.html","<div id=\"requisition\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-calendar-check-multiple\"></md-icon><span>\n{{\'CONTRACT.PENDING.\' + vm.statusToChange | translate}}</span></div><div class=\"order-count secondary-text\"><span \ntranslate=\"CONTRACT.TOTAL_CONTRACT\">Total Requerimientos:</span> <span>{{vm.requisitions.length}}</span></div></div>\n<div class=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"e-commerce-products-search\" ng-model=\"vm.search\" \nclass=\"search-input\" type=\"text\" placeholder=\"Search\" translate translate-attr-placeholder=\"CONTRACT.SEARCH\" \nng-model-options=\"{\'debounce\': 300}\" flex></div></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loading\" \nclass=\"md-accent\"></md-progress-linear><div id=\"masterGridOptions\" ag-grid=\"vm.masterGridOptions\" class=\"ag-fresh\" \nexpand-grid min=\"260\" other=\"-10\"></div></div></div><md-button class=\"md-fab md-fab-bottom-right\" \naria-label=\"addBudget\" style=\"position: fixed\" ng-click=\"vm.newContract()\" ng-if=\"vm.isCreate\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"left\">{{\"general.add\"| translate}}</md-tooltip>\n</md-button></div></div>");
$templateCache.put("app/main/apps/documentVerify/invoice.html","<div id=\"budgetO\" class=\"page-layout carded fullwidth\" layout=\"column\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" \nlayout=\"row\" layout-align=\"start center\" flex><md-button class=\"goto-orders-button md-icon-button\" \naria-label=\"Go to INVOICES\" ng-click=\"vm.gotToInvoices()\" translate translate-attr-aria-label=\"INVOICE.GO_TO_INVOICES\">\n<md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"h2\"><span>{{vm.mainDoc.type}}: </span><span>{{vm.mainDoc.number}}</span></div><div class=\"h4\"><span>\n{{vm.mainDoc.description}}</span></div><div class=\"subtitle secondary-text\"></div></div></div><span flex></span><div>\n<div ng-if=\"vm.mainDoc.typeCode === \'SETTLEMENT\'\" \nng-include=\"\'app/main/apps/documentVerify/settlement/invoiceActions.html\'\" \nng-controller=\"InvoiceSettlementActionsController as vms\"></div><div ng-if=\"vm.mainDoc.typeCode === \'PURCHASE\'\" \nng-include=\"\'app/main/apps/documentVerify/purchase/invoiceActions.html\'\" \nng-controller=\"InvoicePurchaseActionsController as vms\"></div></div></div><div class=\"content one\" md-background-bg \nlayout=\"row\" layout-align=\"start start\"><div ng-if=\"vm.docArray.length > 1\" ms-scroll expand-grid min=\"260\" other=\"30\" \nid=\"divDynamicHeigthSideNav\" ms-scroll layout=\"column\" flex=\"15\" flex-gt-md=\"15\" flex-gt-xs=\"15\"><md-sidenav \nclass=\"three sidenav main-sidenav md-white-bg\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" ng-if=\"vm.docArray.length > 0\" \nmd-component-id=\"sidenav\" ms-sidenav-helper><md-divider></md-divider><md-divider></md-divider><div class=\"content\">\n<md-list><md-list-item ng-repeat=\"doc in vm.docArray\" ng-click=\"vm.changeDoc(doc, $index)\" \nng-class=\"vm.selectedClass(doc)\"><div layout=\"row\" ng-if=\"doc.docType === \'invoice\'\" class=\"pl-1\"><div layout=\"column\" \nflex=\"20\" ng-class=\"vm.statusClass(doc.docObj.purchaseStatus.description)\"><p class=\"small\"><md-icon \nng-show=\"doc.docObj.invoicePurchaseType === \'INV\'\n                                              || doc.docObj.invoicePurchaseType === \'CFISCAL\'\n                                              || doc.docObj.invoicePurchaseType === \'TCK\' \" \nmd-font-icon=\"icon-file-outline\"></md-icon><md-icon ng-show=\"doc.docObj.invoicePurchaseType === \'REC\'\" \nmd-font-icon=\"icon-newspaper\"></md-icon><br><span style=\"font-size: 8px\">\n{{\'SETTLEMENT.TYPE_\' + doc.docObj.invoicePurchaseType| translate}}</span></p></div><div layout=\"column\"><p \nclass=\"small\"><span class=\"font-weight-500 font-size-9\">\n{{doc.docObj.companyProvider.businessName}} ({{doc.docObj.purchaseStatus.description}}) </span><span \nclass=\"font-weight-500 font-size-9\" ng-class=\"vm.statusClass(doc.docObj.purchaseStatus.description)\">\n({{doc.docObj.purchaseStatus.description}})</span><br><span class=\"font-weight-500 font-size-14\">\nNo: {{doc.docObj.invoiceSerie.serie ? (doc.docObj.invoiceSerie.serie + \'-\') : doc.docObj.uuid}} {{doc.docObj.serie ? (doc.docObj.serie + \'-\') : \'\'}} {{doc.docObj.correlative}} \n</span>, {{vm.dateFormatString(doc.docObj.dateInvoicePurchase)}}<br><span class=\"font-weight-500 font-size-14\">\n{{doc.docObj.currency.symbol}} {{doc.docObj.documentTotalAfterTax| number:2}}</span></p></div></div><div layout=\"row\" \nng-if=\"doc.docType === \'receipt\' && doc.docObj\" class=\"pl-1\"><div layout=\"column\" flex=\"20\" \nng-class=\"vm.statusClass(doc.docObj.purchaseStatus.description)\"><p class=\"small\"><md-icon md-font-icon=\"icon-receipt\">\n</md-icon><br><span style=\"font-size: 8px\">{{\'SETTLEMENT.RECEIPT.RECEIPT\'| translate}}</span></p></div><div \nlayout=\"column\"><p class=\"small\"><span class=\"font-weight-500 font-size-9\" \nng-class=\"vm.statusClass(doc.docObj.purchaseStatus.description)\">\n{{doc.docObj.recipientName}} ({{doc.docObj.purchaseStatus.description}}) </span><br><span \nclass=\"font-weight-500 font-size-14\">No: {{doc.docObj.correlative}}</span>\n , {{vm.dateFormatString(doc.docObj.receiptDate)}}<br><span class=\"font-weight-500 font-size-14\">\n{{doc.docObj.currency.symbol}} {{doc.docObj.documentAmount| number:2}}</span></p></div></div><md-divider></md-divider>\n</md-list-item></md-list></div></md-sidenav></div><div class=\"main two\" layout=\"column\" flex><div \nclass=\"one md-white-bg toolbar\" layout=\"row\"><md-tabs md-selected=\"vm.currentTab\" flex md-change=\"vm.changeTab()\">\n<md-tab id=\"tab1\" aria-controls=\"tab1-content\" md-on-select=\"vm.changeTab()\"><span translate=\"INVOICE.TAB.GENERAL\">\nRequisition Details</span></md-tab><md-tab id=\"tab2\" aria-controls=\"tab2-content\" md-on-select=\"vm.changeTab()\" \nng-if=\"vm.currentDoc.docType !== \'receipt\'\"><span translate=\"REQUISITION.REQUISITION_DETAILS\">Detail</span></md-tab>\n<md-tab id=\"tab3\" aria-controls=\"tab3-content\" md-on-select=\"vm.changeTab()\" \nng-if=\"vm.InvoiceWithholdingDetails.length > 0 && vm.currentDoc.docType !== \'receipt\'\"><span \nng-if=\"vm.InvoiceWithholdingDetails.length > 0\" translate=\"INVOICE.WITHHOLDING\">WITHHOLDING</span></md-tab><md-tab \nid=\"tab4\" aria-controls=\"tab4-content\" md-on-select=\"vm.changeTab()\" \nng-if=\"vm.vatReceived > 0 && vm.currentDoc.docType !== \'receipt\'\"><span ng-if=\"vm.vatReceived > 0\" \ntranslate=\"INVOICE.VATRECEIVED\">VATRECEIVED</span></md-tab></md-tabs></div><div class=\"two\" layout=\"row\"><md-content \nclass=\"content one\" flex><md-tabs md-dynamic-height md-selected=\"vm.currentTab\" class=\"tab-in-content two\"><md-tab \naria-controls=\"tab1-content\" class=\"three\"><md-tab-body><div layout=\"row\" layout-xs=\"column\" \nclass=\"invoice-image four\" layout-align=\"space-between stretch\"><div class=\"two\" layout=\"column\" flex=\"40\" flex-xs><div\n flex class=\"three\" ng-include=\"\'app/main/apps/documentVerify/invoicePreview.html\'\" ms-scroll></div></div><div \nclass=\"two\" layout=\"column\" flex=\"60\" flex-xs ng-if=\"!vm.showQuotationFile\"><iframe title=\"obj\" \nng-if=\"vm.filesData.invoice.fileOtherFormat\" width=\"100%\" height=\"100%\" name=\"plugin\" id=\"plugin\" \nsrc=\"{{vm.filesData.invoice.fileUrl}}\" ng-loaded-data=\"vm.isShowProgressLinear = false;\"></iframe><div layout=\"row\" \nng-if=\"!vm.filesData.invoice.fileOtherFormat\"><div layout=\"column\" layout-align=\"start start\" layout-wrap flex=\"5\" \nflex-gt-md=\"10\" flex-gt-xs=\"20\" class=\"three\"><div class=\"product-image three\" layout-align=\"center center\" \nng-repeat=\"image in vm.filesData.invoice.images\" ng-switch=\"image.type\"><img alt=\"img\" class=\"media\" \nng-class=\"image.default ? \'predeterminate\' : \'\'\" ng-src=\"{{image.url + image.extension}}\" \nng-fallback=\"assets/images/etc/thumbPhoto.jpg\" ng-click=\"vm.updateImageZoomOptions(image, vm.filesData)\"><md-divider>\n</md-divider></div></div><div layout=\"column\" ms-scroll expand-grid min=\"260\" other=\"30\" id=\"divDynamicHeigthFisic\" \nlayout-align=\"start center\" flex class=\"one\"><div class=\"image-zoom-area four\" \nng-class=\"\'rotate-\' + vm.filesData.invoice.valRotate + \'-class\'\"><md-button style=\"position: fixed; z-index: 50\" \nclass=\"md-icon-button\" \nng-click=\"vm.filesData.invoice.valRotate =\n                                                  vm.filesData.invoice.valRotate === 270 ? 0 : vm.filesData.invoice.valRotate + 90\">\n<md-icon md-font-icon=\"icon-rotate-right-variant\"></md-icon></md-button><img alt=\"img\" class=\"two\" \nwip-image-zoom=\"vm.filesData.invoice.imageZoomOptions\" ng-fallback=\"assets/images/etc/thumbPhoto.jpg\"></div></div>\n</div></div><div class=\"two\" layout=\"column\" flex=\"60\" flex-xs ng-if=\"vm.showQuotationFile\"><div \nng-include=\"\'app/main/apps/documentVerify/invoice-files/invoice-files.html\'\" flex></div></div></div></md-tab-body>\n</md-tab><md-tab aria-controls=\"tab2-content\"><md-tab-body><div \nclass=\"order-detail-form-container products md-background-bg md-whiteframe-1dp\"><div class=\"content-card\" \nlayout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex><md-progress-linear \nmd-mode=\"indeterminate\" ng-if=\"vm.loading\" class=\"md-accent\"></md-progress-linear><div id=\"masterGridOptionsE\" \nag-grid=\"vm.masterGridOptionsE\" class=\"ag-fresh\" expand-grid min=\"260\" other=\"150\"></div></div></div></div>\n</md-tab-body></md-tab><md-tab aria-controls=\"tab3-content\" ms-scroll \nng-if=\"vm.InvoiceWithholdingDetails.length > 0 && vm.currentDoc.docType !== \'receipt\'\"><md-tab-body ms-scroll><div \nclass=\"order-detail-form-container products md-background-bg md-whiteframe-1dp\"><div class=\"content-card\" \nlayout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex><md-progress-linear \nmd-mode=\"indeterminate\" ng-if=\"vm.loading\" class=\"md-accent\"></md-progress-linear><div id=\"masterGridOptionsRet\" \nag-grid=\"vm.masterGridOptionsRet\" class=\"ag-fresh\" expand-grid min=\"260\" other=\"-10\"></div></div></div></div>\n</md-tab-body></md-tab><md-tab aria-controls=\"tab4-content\" ms-scroll \nng-if=\"vm.vatReceived > 0 && vm.currentDoc.docType !== \'receipt\'\"><md-tab-body ms-scroll><div \nclass=\"order-detail-form-container products md-background-bg md-whiteframe-1dp\"><div class=\"content-card\" \nlayout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex><md-progress-linear \nmd-mode=\"indeterminate\" ng-if=\"vm.loading\" class=\"md-accent\"></md-progress-linear><div \nid=\"masterGridOptionsVatReceived\" ag-grid=\"vm.masterGridOptionsVatReceived\" class=\"ag-fresh\" expand-grid min=\"260\" \nother=\"-10\"></div></div></div></div></md-tab-body></md-tab></md-tabs></md-content></div></div></div></div></div>");
$templateCache.put("app/main/apps/documentVerify/invoicePreview.html","<div id=\"invoice\" class=\"page-layout blank\" layout=\"row\"><div flex class=\"invoice-container content\" ms-scroll \nexpand-grid min=\"260\" other=\"30\" id=\"divDynamicHeigth\"><div class=\"card md-whiteframe-8dp\"><div class=\"headeres\" \nlayout=\"column\"><div class=\"detail\" flex><div class=\"title font-weight-300 font-size-10\" ng-if=\"vm.companyDoc\"><span>\n{{vm.companyDoc.documentType.name}}</span>: {{ vm.companyDoc.number}}</div><div flex><a \nng-click=\"vm.showCompanyInfo()($event)\" flex class=\"p-16\"><div class=\"title font-weight-500 font-size-14\">\n{{vm.currentDoc.docObj.companyProvider.businessName}} {{vm.currentDoc.docObj.recipientName}} ({{vm.companyDoc.documentType.name}} : {{vm.companyDoc.number}})\n</div></a><div style=\"visibility: hidden\"><div class=\"md-dialog-container\" id=\"myStaticDialog\"><md-dialog><md-toolbar>\n<div class=\"md-toolbar-tools\"><h2>\n{{vm.currentDoc.docObj.companyProvider.businessName}} {{vm.currentDoc.docObj.recipientName}}</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.cancelDialog()\" aria-label=\"Cancel\"><ng-md-icon icon=\"close\">\n</ng-md-icon></md-button></div></md-toolbar><md-dialog-content scroll><div layout=\"column\" layout-align=\"start start\">\n<div class=\"title font-weight-300 font-size-12\" ng-if=\"vm.companyDoc\"><span class=\"font-weight-500 font-size-9\">\n{{vm.companyDoc.documentType.name}}</span>: {{vm.companyDoc.number}}</div><div \nng-if=\"vm.currentDoc.docObj.companyProvider.address\" class=\"address font-weight-300 font-size-12\">\n{{vm.currentDoc.docObj.companyProvider.address}}</div><div ng-if=\"vm.currentDoc.docObj.companyProvider.phone\" \nclass=\"phone font-weight-300 font-size-12\"><span class=\"font-weight-500 font-size-9\" translate=\"INVOICE.COMPANY.PHONE\">\nPhone</span> {{vm.currentDoc.docObj.companyProvider.phone}}</div><div class=\"font-weight-300 font-size-9\" \nng-if=\"vm.currentDoc.docObj.companyProvider.email\" class=\"email font-weight-300 font-size-12\"><span \nclass=\"font-weight-500 font-size-9\" translate=\"INVOICE.COMPANY.EMAIL\">Email</span>\n: {{vm.currentDoc.docObj.companyProvider.email}}</div><div ng-if=\"vm.currentDoc.docObj.companyProvider.webPage\" \nclass=\"website font-weight-300 font-size-12\"><span class=\"font-weight-500 font-size-9\" \ntranslate=\"INVOICE.COMPANY.WEBSITE\">Web</span>: {{vm.currentDoc.docObj.companyProvider.webPage}}</div></div>\n</md-dialog-content></md-dialog></div></div></div></div><div layout=\"row\" layout-align=\"start center\"><table \nclass=\"summary\"><tr ng-if=\"vm.currentDoc.docObj.invoiceSerie.invoiceSerieDocumentTypeOb\"><td class=\"label\" \ntranslate=\"INVOICE.INVOICE_PURCHASE.DOCUMENTTYPESERIE\">DOCUMENTTYPESERIE</td><td class=\"value\">\n{{vm.currentDoc.docObj.invoiceSerie.invoiceSerieDocumentTypeOb.description}}</td></tr><tr \nng-if=\"vm.currentDoc.docType === \'receipt\'\n                          && !vm.currentDoc.docObj.invoiceSerie.invoiceSerieDocumentTypeOb\">\n<td class=\"label\" translate=\"INVOICE.INVOICE_PURCHASE.DOCUMENT_TYPE\">DOCUMENTTYPE</td><td class=\"value\">\n{{\'INVOICE.INVOICE_PURCHASE.TYPE_REC\' | translate}}</td></tr><tr \nng-if=\"vm.currentDoc.docObj.invoiceSerie || vm.currentDoc.docObj.serie\"><td class=\"label\" \ntranslate=\"INVOICE.INVOICE_PURCHASE.SERIE\">SERIE</td><td class=\"value\">\n{{vm.currentDoc.docObj.invoiceSerie.serie}} {{vm.currentDoc.docObj.serie}} <span \nng-if=\"vm.currentDoc.docObj.invoiceSerie.electronicInvoice\" class=\"label-validated-product\">\n{{\'INVOICE.INVOICE_PURCHASE.ELECTRONIC\'| translate}}</span></td></tr><tr \nng-if=\"vm.currentDoc.docObj.regime.code === \'FEL\' || vm.currentDoc.docObj.uuid\"><td class=\"label\" \ntranslate=\"INVOICE.INVOICE_PURCHASE.DOCUMENT_TYPE\">DOCUMENTTYPE</td><td class=\"value\" \nng-if=\"vm.currentDoc.docObj.invoicePurchaseType !== \'CFISCAL\'\">\n{{\'INVOICE.INVOICE_PURCHASE.TYPE_\' + vm.currentDoc.docObj.invoicePurchaseType | translate}}</td><td class=\"value\" \nng-if=\"vm.currentDoc.docObj.invoicePurchaseType === \'CFISCAL\'\">{{\'INVOICE.INVOICE_PURCHASE.TYPE_C_FISCAL\' | translate}}\n</td></tr><tr ng-if=\"vm.currentDoc.docObj.regime.code===\'FEL\' || vm.currentDoc.docObj.uuid\"><td class=\"label\" \ntranslate=\"INVOICE.INVOICE_PURCHASE.UUID\">UUID</td><td class=\"value\">{{vm.currentDoc.docObj.uuid}}</td></tr><tr \nng-if=\"vm.currentDoc.docObj.electronicSignature\"><td class=\"label\" translate=\"INVOICE.INVOICE_PURCHASE.RECEIPT_STAMP\">\n</td><td class=\"value\">{{vm.currentDoc.docObj.electronicSignature}}</td></tr><tr class=\"code\" \nng-if=\"vm.currentDoc.docObj.correlative\"><td class=\"label\" translate=\"INVOICE.INVOICE_PURCHASE.CORRELATIVE\">CORRELATIVE\n</td><td class=\"value\">\n{{(vm.currentDoc.docObj.purchaseStatus.description === \'Emitida\' || vm.currentDoc.docObj.purchaseStatus.description === \'Pendiente Recibir Original\') ? vm.currentDoc.docObj.documentComposedCode : vm.currentDoc.docObj.correlative}}\n</td></tr><tr><td class=\"label\" translate=\"INVOICE.INVOICE_PURCHASE.DOCUMENT_DATE\">DOCUMENT DATE</td><td class=\"value\">\n<span ng-if=\"vm.currentDoc.docObj.dateInvoicePurchase\">\n{{vm.dateFormatString(vm.currentDoc.docObj.dateInvoicePurchase)}}</span> <span \nng-if=\"vm.currentDoc.docObj.receiptDate\">{{vm.dateFormatString(vm.currentDoc.docObj.receiptDate)}}</span></td></tr><tr \nng-if=\"vm.currentDoc.docObj.purchaseStatus.id === 86 ||\n                        vm.currentDoc.docObj.purchaseStatus.id === 61\n                        && vm.currentDoc.docObj.loadedPOS && vm.currentDoc.docObj.loadedPOSDate != null\">\n<td class=\"label\" translate=\"INVOICE.INVOICE_PURCHASE.LOADEDPOSDATE\" ng-show=\"vm.currentDoc.docObj.loadedPOS\">\nINVOICE LOADEDPOSDATE</td><td class=\"value\"><span \nng-if=\"vm.currentDoc.docObj.loadedPOS && vm.currentDoc.docObj.loadedPOSDate != null\">\n{{vm.currentDoc.docObj.loadedPOSDate | date : \'dd-MM-yyyy\'}}</span></td></tr><tr class=\"code\"><td class=\"label\" \ntranslate=\"INVOICE.INVOICE_PURCHASE.TOTAL_DUE\">TOTAL DUE</td><td class=\"value font-weight-500 font-size-20\">\n{{vm.currentDoc.docObj.currency.symbol}} {{vm.currentDoc.docObj.documentTotalAfterTax| number:2}} {{vm.currentDoc.docObj.documentAmount| number:2}}\n</td></tr></table></div><div layout=\"row\" layout-align=\"end start\" class=\"external-provider-text\" \nng-if=\"vm.mainDoc.typeCode === \'SETTLEMENT\'\n                    && vm.currentDoc.docObj.invoicePurchaseType === \'INV\'\n                    && vm.currentDoc.docObj.companyProvider.isExternalProvider\">\n{{\'INVOICE.COMPANY.EXTERNAL_PROVIDER\'| translate}}</div></div><div class=\"content\"><table \nng-show=\"vm.currentDoc.docType === \'invoice\'\" class=\"simple invoice-table\"><thead><th class=\"units\" \ntranslate=\"INVOICE.INVOICE_PURCHASE.DETAIL.QUANTITY\">QUANTITY</th><th class=\"title\" \ntranslate=\"INVOICE.INVOICE_PURCHASE.DETAIL.DESCRIPTION\">SERVICE</th><th class=\"totals text-right\" width=\"110%\"><div \nlayout=\"column\" layout-align=\"center end\"><span translate=\"INVOICE.INVOICE_PURCHASE.DETAIL.TOTAL_AFTER_TAX\"></span> \n<span>({{\'INVOICE.INVOICE_PURCHASE.DETAIL.UNIT_PRICE_AFTER_TAX\'| translate}})</span></div></th></thead><tbody><tr \nclass=\"three\" ng-repeat=\"detail in vm.currentDoc.docObj.details\"><td class=\"text-right one\"><div class=\"units\" \ntext-align=\"center\">{{detail.quantity}}</div></td><td class=\"two\"><div class=\"title\">\n{{detail.description!=null? detail.product.name + \"[\" + detail.description + \"]\": detail.product.name}}</div><div \nclass=\"detail\">{{detail.merchandiseEntry.purchaseOrderDetail.purchaseOrder.department.description}}</div><div \nclass=\"detail\">{{detail.merchandiseEntry.purchaseOrderDetail.purchaseOrder.costCenter.description}}</div><div \nclass=\"detail\"><span \nng-if=\"detail.merchandiseEntry\n                                        && detail.merchandiseEntry.purchaseOrderDetail\n                                        && detail.merchandiseEntry.purchaseOrderDetail.purchaseOrder\n                                        && detail.merchandiseEntry.purchaseOrderDetail.purchaseOrder.dimensionCompanyDetail3\">\n<strong>{{vm.dimensionCompanyDetail3.description}}</strong>\n {{detail.merchandiseEntry.purchaseOrderDetail.purchaseOrder.dimensionCompanyDetail3.name}} </span><span \nng-if=\"vm.settlement.pettyCash.dimensionCompanyDetail3\n                                        && vm.dimensionCompanyDetail3\">\n<strong>{{vm.dimensionCompanyDetail3.description}}</strong> {{vm.settlement.pettyCash.dimensionCompanyDetail3.name}}\n</span></div><div class=\"detail\"><span \nng-if=\"detail.merchandiseEntry\n                                            && detail.merchandiseEntry.purchaseOrderDetail\n                                            && detail.merchandiseEntry.purchaseOrderDetail.purchaseOrder\n                                            && detail.merchandiseEntry.purchaseOrderDetail.purchaseOrder.dimensionCompanyDetail4\">\n<strong>{{vm.dimensionCompanyDetail4.description}}</strong>\n {{detail.merchandiseEntry.purchaseOrderDetail.purchaseOrder.dimensionCompanyDetail4.name}} </span><span \nng-if=\"vm.settlement.pettyCash.dimensionCompanyDetail4\n                                        && vm.dimensionCompanyDetail4\">\n<strong>{{vm.dimensionCompanyDetail4.description}}</strong> {{vm.settlement.pettyCash.dimensionCompanyDetail4.name}}\n</span></div><div class=\"detail\"><span \nng-if=\"detail.merchandiseEntry\n                                            && detail.merchandiseEntry.purchaseOrderDetail\n                                            && detail.merchandiseEntry.purchaseOrderDetail.purchaseOrder\n                                            && detail.merchandiseEntry.purchaseOrderDetail.purchaseOrder.dimensionCompanyDetail5\">\n<strong>{{vm.dimensionCompanyDetail5.description}}</strong>\n {{detail.merchandiseEntry.purchaseOrderDetail.purchaseOrder.dimensionCompanyDetail5.name}} </span><span \nng-if=\"vm.settlement.pettyCash.dimensionCompanyDetail5\n                                        && vm.dimensionCompanyDetail5\">\n<strong>{{vm.dimensionCompanyDetail5.description}}</strong> {{vm.settlement.pettyCash.dimensionCompanyDetail5.name}}\n</span></div></td><td class=\"one\"><div layout=\"column\" layout-align=\"center end\"><span>\n{{vm.currentDoc.docObj.currency.symbol}}{{detail.documentSubTotalAfterTax| number:2}}</span> <span>\n({{vm.currentDoc.docObj.currency.symbol}}{{detail.priceAfterTax| number:2}})</span></div></td></tr></tbody></table>\n<span layout=\"column\" ng-show=\"vm.currentDoc.docType === \'receipt\'\" layout-align=\"center center\">\n{{vm.currentDoc.docObj.product.name}}<h1>{{vm.currentDoc.docObj.description}}</h1></span><table \nclass=\"simple invoice-table-footer\"><tbody><tr class=\"subtotal\" \nng-if=\"vm.currentDoc.docObj.companyBuyer.country.id !== 1\"><td translate=\"INVOICE.INVOICE_PURCHASE.TOTAL_BEFORE_TAX\">\nSUBTOTAL</td><td>\n{{vm.currentDoc.docObj.currency.symbol}} {{vm.currentDoc.docObj.documentTotalBeforeTax| number:2}} {{vm.currentDoc.docObj.documentAmount| number:2}}\n</td></tr><tr class=\"subtotal\" ng-if=\"vm.currentDoc.docObj.companyBuyer.country.id === 1\"><td \ntranslate=\"INVOICE.INVOICE_PURCHASE.SUBTOTAL\">SUBTOTAL</td><td>\n{{vm.currentDoc.docObj.currency.symbol}} {{vm.currentDoc.docObj.documentTotalAfterTax| number:2}} {{vm.currentDoc.docObj.documentAmount| number:2}}\n</td></tr><tr class=\"tax\" ng-if=\"vm.currentDoc.docObj.companyBuyer.country.id !== 1\"><td \ntranslate=\"INVOICE.INVOICE_PURCHASE.TAXES\">TAX</td><td>\n{{vm.currentDoc.docObj.currency.symbol}} {{(vm.currentDoc.docObj.documentTotalAfterTax - vm.currentDoc.docObj.documentTotalBeforeTax) | number:2}}\n</td></tr><tr class=\"tax\" ng-if=\"vm.currentDoc.docObj.vatReceived > 0\"><td \ntranslate=\"INVOICE.INVOICE_PURCHASE.VATRECEIVED\">VATRECEIVED</td><td>\n{{vm.currentDoc.docObj.currency.symbol}} {{vm.currentDoc.docObj.vatReceived| number:2}}</td></tr><tr class=\"tax\" \nng-if=\"vm.totalWithholding > 0\"><td translate=\"INVOICE.INVOICE_PURCHASE.WITHHOLDING\">RETENCIÓN</td><td>\n{{vm.currentDoc.docObj.currency.symbol}} -{{vm.totalWithholding| number:2}}</td></tr><tr class=\"total\"><td \ntranslate=\"INVOICE.INVOICE_PURCHASE.TOTAL\">TOTAL</td><td>{{vm.currentDoc.docObj.currency.symbol}} <span>\n{{vm.getTotalAmount()| number:2}}</span> {{vm.currentDoc.docObj.documentAmount| number:2}}</td></tr><tr class=\"tax\">\n<td>{{vm.currentDoc.docObj.regime.name}}</td></tr></tbody></table></div></div><div class=\"page-break\"></div></div>\n</div>");
$templateCache.put("app/main/apps/files/files.html","<md-content ng-controller=\"FilesController as fl\" class=\"p-16 mv-16\"><div \nng-class=\"{\'md-background-bg md-whiteframe-1dp\': !vm.fileContainerWithoutBorders}\"><div id=\"attach-uploader\" \nflow-init=\"fl.ngFlowOptions\" flow-name=\"fl.ngFlow.flow\" flow-files-submitted=\"fl.upload()\" \nflow-file-added=\"fl.fileAdded($file)\" flow-file-success=\"fl.fileSuccess($file, $message)\" \nflow-complete=\"fl.uploadComplete()\" flow-drop flow-drag-enter=\"fl.dropping=true\" flow-drag-leave=\"fl.dropping=false\" \nng-class=\"{\'dropping\':fl.dropping}\"><div class=\"drop-text hint-text\" layout=\"row\" layout-align=\"center center\"><span \ntranslate=\"{{fl.dropTranslateKey}}\">Drop to upload</span></div><div class=\"upload-button\" layout=\"column\" \nlayout-align=\"center center\" ng-show=\"!fl.loadingFiles\"><md-button \nng-disabled=\"vm[\'maxNumberFiles\' + fl.fileType]\n                && vm[\'filesToUpload\' + fl.fileType].length >= vm[\'maxNumberFiles\' + fl.fileType]\" \nclass=\"md-accent md-raised\" flow-btn aria-label=\"upload\" id=\"btnUpload\">{{\'files.UPLOAD\'| translate}}</md-button><span \nclass=\"secondary-text mt-8\" translate=\"{{fl.dropTranslateKey}}\"></span></div><div layout=\"row\" \nlayout-align=\"center start\" layout-wrap><div ng-repeat=\"file in vm[\'filesToUpload\' + fl.fileType]\" \nng-switch=\"file.type\"><div layout=\"row\" layout-align=\"center center\"><md-progress-circular \nng-if=\"file.type ==\'uploading\'\" class=\"md-accent\" md-diameter=\"40\"></md-progress-circular></div><md-content><div \nclass=\"product-image\" ng-class=\"fl.loadingFiles ? \'uploading\' : \'\'\" ng-switch-when=\"image\" layout=\"row\" \nlayout-align=\"center center\"><div class=\"overlay\" layout=\"column\" layout-align=\"center center\"><md-progress-linear \nmd-mode=\"indeterminate\"></md-progress-linear></div><div layout=\"column\"><img alt=\"image\" class=\"media\" \nng-src=\"{{file.image ? file.image : file.url}}\" ng-click=\"fl.updateZoomOptions(file.url)\"><p>{{file.file.name}}</p>\n</div><md-button class=\"md-fab-bottom-right md-fab md-mini\" ng-click=\"fl.fileRemove(file);\" ng-show=\"!fl.loadingFiles\" \naria-label=\"remove\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-content></div></div><div \nlayout=\"column\" layout-align=\"center center\" \nng-messages=\"vm[\'filesToUpload\' + fl.fileType].length > vm[\'maxNumberFiles\' + fl.fileType]\" \nng-if=\"vm[\'maxNumberFiles\' + fl.fileType] && vm[\'filesToUpload\' + fl.fileType].length > vm[\'maxNumberFiles\' + fl.fileType]\">\n{{\"files.EXCEEDS_FILE_LIMIT\" | translate}}: {{vm[\'maxNumberFiles\' + fl.fileType]}}</div></div></div></md-content>");
$templateCache.put("app/main/apps/generalReports/horizontalFilterReport.html","<md-progress-linear style=\"position: fixed; height: 5px; z-index: 10\" md-mode=\"query\" class=\"md-accent\" \nng-show=\"vm.isShowProgressLinear\"></md-progress-linear><div style=\"padding-top: 5px\"><div \nng-include=\"\'app/main/apps/generalReports/sidenavs/filter/h-filter.html\'\"></div><div layout=\"row\" \nlayout-align=\"center center\"><h2>{{\'REPORTS.\' + vm.title| translate}}</h2></div><div id=\"masterGridOptions\" \nag-grid=\"vm.masterGridOptions\" class=\"ag-fresh\" expand-grid min=\"260\" other=\"-10\" ng-show=\"vm.showGrid\"></div></div>\n<md-button class=\"md-fab\" ng-if=\"vm.exportXLS\" aria-label=\"Generar xls\" ng-show=\"vm.showGrid\" \nng-disabled=\"!vm.hasData\" ng-click=\"vm.onExportXLS()\" style=\"position: fixed; bottom: 10px; right: 20px\"><md-icon \nmd-font-icon=\"icon-file-excel\"></md-icon><md-tooltip md-direction=\"left\">{{\'REPORT.EXPORTXLS\'| translate}}</md-tooltip>\n</md-button>");
$templateCache.put("app/main/apps/generalReports/reportTemplate.html","<div id=\"report\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" layout=\"column\" flex><div \nclass=\"header md-accent-bg\"><div class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div \nclass=\"toolbar\" layout=\"row\" layout-align=\"space-between\"><span class=\"h1\">{{\'REPORTS.TITLE.\' + vm.title| translate}}\n</span><div class=\"right-side\" layout=\"row\"><md-button class=\"md-icon-button main-sidenav-toggle\" \nng-click=\"vm.toggleSidenav(\'main-sidenav\')\" aria-label=\"Toggle Main Sidenav\" translate \ntranslate-attr-aria-label=\"FILE.TOOGLE_MAIN_SIDENAV\"><md-icon md-font-icon=\"icon-filter\" class=\"icon\"></md-icon>\n</md-button></div></div><div class=\"breadcrumb text-truncate\" layout=\"row\" layout-align=\"start center\"><span \ndata-ng-repeat=\"path in vm.path\">{{path}}<md-icon md-font-icon=\"icon-chevron-right\" class=\"icon separator\"></md-icon>\n</span></div></div></div><md-content class=\"content\" flex><md-progress-linear md-mode=\"indeterminate\" \nng-if=\"vm.loading\" class=\"md-accent\"></md-progress-linear><div id=\"masterGridOptions\" ag-grid=\"vm.masterGridOptions\" \nclass=\"ag-fresh\" expand-grid min=\"260\" other=\"-10\"></div></md-content></div><md-sidenav \nclass=\"main-sidenav md-sidenav-right\" md-component-id=\"main-sidenav\" \nng-include=\"\'app/main/apps/generalReports/sidenavs/filter/filter.html\'\" ms-scroll ms-sidenav-helper></md-sidenav></div>");
$templateCache.put("app/main/apps/invoice/invoices.html","<div id=\"invoice\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-receipt\"></md-icon><span>{{\'INVOICE.INVOICES\' | translate}}</span></div><div \nclass=\"order-count secondary-text\"><span translate=\"INVOICE.TOTAL_INVOICES\">Total Facturas:</span> <span>\n{{vm.invoicePurchases.length}}</span></div></div><div ng-if=\"vm.statusName === \'Pendiente Recibir Original\'\" \nclass=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-barcode\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"inputBarCode\" ng-disabled=\"vm.inputBarCodeDisabled\" \nng-enter=\"vm.provisionInvioce($event)\" id=\"e-commerce-products-search\" ng-model=\"vm.barCode\" class=\"search-input\" \ntype=\"text\" placeholder=\"Search\" translate translate-attr-placeholder=\"INVOICE.BAR_CODE\" \nng-model-options=\"{\n                               \'debounce\'\n                               : 300}\" flex></div><div \nclass=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input ng-enter=\"vm.searchByInvoice()\" id=\"e-commerce-products-search\" \nng-model=\"vm.search\" class=\"search-input\" type=\"text\" placeholder=\"Search\" translate \ntranslate-attr-placeholder=\"REQUISITION.SEARCH\" ng-model-options=\"{\n                               \'debounce\': 300}\" \nflex></div></div><div class=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" \nlayout=\"column\" flex><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loading\" class=\"md-accent\">\n</md-progress-linear><div id=\"masterGridOptions\" ag-grid=\"vm.masterGridOptions\" class=\"ag-fresh\" expand-grid min=\"260\" \nother=\"-10\"></div></div></div></div></div>");
$templateCache.put("app/main/apps/order/orders.html","<div id=\"order\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-cart\"></md-icon><span>{{\'ORDER.PENDING.\' + vm.typeDisplay | translate}}</span></div><div \nclass=\"order-count secondary-text\"><span translate=\"ORDER.TOTAL_ORDER\">Total Requerimientos:</span> <span>\n{{vm.orders.length}}</span></div></div><div class=\"search\" layout=\"column\" flex><div class=\"search\" layout=\"row\" flex>\n<md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input \nid=\"e-commerce-products-search\" ng-model=\"vm.search\" class=\"search-input\" type=\"text\" placeholder=\"Search\" translate \ntranslate-attr-placeholder=\"ORDER.SEARCH\" ng-model-options=\"{\'debounce\': 300}\" flex></div><div layout=\"row\" flex \nclass=\"select-type\" ng-if=\"vm.typeDisplay === \'C\' \"><md-input-container flex class=\"search-input white-fg\"><label \nclass=\"label-style\">{{\'ORDER.FILTER_PRODUCTS\'| translate}}</label><md-select aria-label=\"filter type\" \nclass=\"select-style\" ng-model=\"vm.filterType\" name=\"filterType\" required ng-change=\"vm.getOrders()\"><md-option \nvalue=\"ALL\">{{\'ORDER.ALL\' | translate}}</md-option><md-option value=\"PRODUCT_SALE\">{{\'ORDER.PRODUCT_SALE\' | translate}}\n</md-option><md-option value=\"OTHER_PRODUCT\">{{\'ORDER.OTHER_PRODUCT\' | translate}}</md-option></md-select>\n</md-input-container></div></div></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loading\" \nclass=\"md-accent\"></md-progress-linear><div id=\"masterGridOptions\" ag-grid=\"vm.masterGridOptions\" class=\"ag-fresh\" \nexpand-grid min=\"260\" other=\"5\"></div></div></div></div></div>");
$templateCache.put("app/main/apps/quotation/quotations.html","<div id=\"quotations\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-button class=\"goto-orders-button md-icon-button\" aria-label=\"Go to orders\" ng-click=\"vm.goToBack()\" translate \nng-if=\"vm.productId\" translate-attr-aria-label=\"QUOTATION.GO_TO_ORDERS\"><md-icon md-font-icon=\"icon-arrow-left\">\n</md-icon></md-button><md-icon md-font-icon=\"icon-square-inc-cash\"></md-icon><span>\n{{\'QUOTATION.PENDING.\' + vm.status | translate}}</span></div><div class=\"order-count secondary-text\"><span \ntranslate=\"QUOTATION.TOTAL_QUOTATION\">Total Cotizaciones</span> <span>{{vm.gridData.length}}</span></div></div><div \nclass=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"e-commerce-products-search\" ng-model=\"vm.search\" \nclass=\"search-input\" type=\"text\" placeholder=\"Search\" translate translate-attr-placeholder=\"REQUISITION.SEARCH\" \nng-model-options=\"{\'debounce\': 300}\" flex></div></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loading\" \nclass=\"md-accent\"></md-progress-linear><div id=\"masterGridOptions\" ag-grid=\"vm.masterGridOptions\" class=\"ag-fresh\" \nexpand-grid min=\"260\" other=\"-10\"></div></div><md-button class=\"md-fab button-export\" ng-if=\"vm.status===\'Autorizado\'\" \naria-label=\"Generar xls\" ng-click=\"vm.onExportXLS()\" ng-disabled=\"vm.buttonExportDisable\"><md-icon \nmd-font-icon=\"icon-file-excel\"></md-icon><md-tooltip md-direction=\"left\">{{\'EXPORTXLS\'| translate}}</md-tooltip>\n</md-button></div></div></div>");
$templateCache.put("app/main/apps/reports/horizontalFilterReport.html","<md-progress-linear style=\"position: fixed; height: 5px; z-index: 10\" md-mode=\"query\" class=\"md-accent\" \nng-show=\"vm.isShowProgressLinear\"></md-progress-linear><div style=\"padding-top: 5px\"><div ng-if=\"!vm.filter.noFilter\" \nng-include=\"\'app/main/apps/reports/sidenavs/filter/h-filter.html\'\"></div><div layout=\"row\" \nlayout-align=\"center center\"><h2>{{\'REPORT.TITLE.\' + vm.title| translate}}</h2></div><div id=\"masterGridOptions\" \nag-grid=\"vm.masterGridOptions\" class=\"ag-fresh\" expand-grid min=\"260\" other=\"-10\" ng-show=\"vm.showGrid\"></div></div>\n<md-button class=\"md-fab\" ng-if=\"vm.exportXLS\" aria-label=\"Generar xls\" ng-show=\"vm.showGrid\" \nng-disabled=\"!vm.hasData || vm.exporting\" ng-click=\"vm.onExportXLS()\" \nstyle=\"position: fixed; bottom: 10px; right: 20px\"><md-icon md-font-icon=\"icon-file-excel\"></md-icon><md-tooltip \nmd-direction=\"left\">{{\'REPORT.EXPORTXLS\'| translate}}</md-tooltip></md-button>");
$templateCache.put("app/main/apps/reports/reportTemplate.html","<div id=\"report\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" layout=\"column\" flex><div \nclass=\"header md-accent-bg\"><div class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div \nclass=\"toolbar\" layout=\"row\" layout-align=\"space-between\"><span class=\"h1\">{{\'REPORT.TITLE.\' + vm.title| translate}}\n</span><div class=\"right-side\" layout=\"row\"><md-button class=\"md-icon-button main-sidenav-toggle\" \nng-click=\"vm.toggleSidenav(\'main-sidenav\')\" aria-label=\"Toggle Main Sidenav\" translate \ntranslate-attr-aria-label=\"FILE.TOOGLE_MAIN_SIDENAV\"><md-icon md-font-icon=\"icon-filter\" class=\"icon\"></md-icon>\n</md-button></div></div><div class=\"breadcrumb text-truncate\" layout=\"row\" layout-align=\"start center\"><span \ndata-ng-repeat=\"path in vm.path\">{{path}}<md-icon md-font-icon=\"icon-chevron-right\" class=\"icon separator\"></md-icon>\n</span></div></div></div><md-content class=\"content\" flex><md-progress-linear md-mode=\"indeterminate\" \nng-if=\"vm.loading\" class=\"md-accent\"></md-progress-linear><div id=\"masterGridOptions\" ag-grid=\"vm.masterGridOptions\" \nclass=\"ag-fresh\" expand-grid min=\"260\" other=\"-10\"></div></md-content></div><md-sidenav \nclass=\"main-sidenav md-sidenav-right\" md-component-id=\"main-sidenav\" \nng-include=\"\'app/main/apps/reports/sidenavs/filter/filter.html\'\" ms-scroll ms-sidenav-helper></md-sidenav></div>");
$templateCache.put("app/main/apps/returns/issue-return-query.html","<return-query-container-component translate-lang=\"{{$root.currentTranslateLang}}\" \nuser-companies=\"{{$root.userCompanies}}\"></return-query-container-component>");
$templateCache.put("app/main/apps/returns/pending-issue.html","<returns-pending-issuance translate-lang=\"{{$root.currentTranslateLang}}\" user-companies=\"{{$root.userCompanies}}\">\n</returns-pending-issuance>");
$templateCache.put("app/main/apps/returns/pending-received-original.html","<returns-pending-verification status-code=\"04\" translate-lang=\"{{$root.currentTranslateLang}}\" \nuser-companies=\"{{$root.userCompanies}}\" user-id=\"{{$root.userId}}\"></returns-pending-verification>");
$templateCache.put("app/main/apps/returns/pending-verification.html","<returns-pending-verification status-code=\"03\" translate-lang=\"{{$root.currentTranslateLang}}\" \nuser-companies=\"{{$root.userCompanies}}\" user-id=\"{{$root.userId}}\"></returns-pending-verification>");
$templateCache.put("app/main/apps/returns/returns-received.html","<returns-received-report-component translate-lang=\"{{$root.currentTranslateLang}}\" \nuser-companies=\"{{$root.userCompanies}}\"></returns-received-report-component>");
$templateCache.put("app/main/apps/returns/returns.html","<issue-return-element translate-lang=\"{{$root.currentTranslateLang}}\"></issue-return-element>");
$templateCache.put("app/main/apps/requisition/requisitions.html","<div id=\"requisition\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-backburger\"></md-icon><span>{{\'REQUISITION.PENDING.\' + vm.statusToChange | translate}}\n</span></div><div class=\"order-count secondary-text\"><span translate=\"REQUISITION.TOTAL_REQUISITION\">\nTotal Requerimientos:</span> <span>{{vm.requisitions.length}}</span></div></div><div class=\"search\" layout=\"row\" \nlayout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon>\n<input id=\"e-commerce-products-search\" ng-model=\"vm.search\" class=\"search-input\" type=\"text\" placeholder=\"Search\" \ntranslate translate-attr-placeholder=\"REQUISITION.SEARCH\" ng-model-options=\"{\'debounce\': 300}\" flex></div></div><div \nclass=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex>\n<md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loading\" class=\"md-accent\"></md-progress-linear><div \nid=\"masterGridOptions\" ag-grid=\"vm.masterGridOptions\" class=\"ag-fresh\" expand-grid min=\"260\" other=\"-10\"></div></div>\n</div><md-button class=\"md-fab md-fab-bottom-right\" ng-if=\"!vm.isTicket && vm.isCreate\" aria-label=\"addBudget\" \nstyle=\"position: fixed\" ng-click=\"vm.newRequisition()\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip \nmd-direction=\"left\">{{\"general.add\"| translate}}</md-tooltip></md-button></div></div>");
$templateCache.put("app/main/general/profile/profile.html","<div id=\"profile\" class=\"page-layout simple tabbed\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"space-between end\"><div class=\"user-info\" \nlayout=\"column\" layout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"start center\"><img \nclass=\"profile-image avatar huge\" \nng-src=\"{{vm.userInfo.picture ? vm.userInfo.picture : \'assets/images/avatars/profile.jpg\'}}\" alt=\"image\"><div \nclass=\"name\">{{vm.userInfo.name}} {{vm.userInfo.familyName}}</div></div><div class=\"actions\" layout=\"row\" \nlayout-align=\"end center\"><md-button class=\"md-raised md-warn\" aria-label=\"Save Change\" \nng-if=\"data.selectedIndex === 0\" ng-click=\"vm.editMode ? vm.sendForm() : (vm.editMode = true)\">\n{{(vm.editMode ? \'PROFILE.EDIT.SAVE\' : \'PROFILE.EDITBUTTON\')| translate}}<md-icon md-svg-icon=\"border-color\"></md-icon>\n</md-button><md-button class=\"md-raised md-warn\" aria-label=\"Save Change\" translate=\"PROFILE.EDIT.CANCEL\" \nng-if=\"vm.editMode\" ng-click=\"vm.cancelarEdit()\"><md-icon md-svg-icon=\"border-color\"></md-icon></md-button></div></div>\n<md-progress-linear md-mode=\"indeterminate\" ng-show=\"vm.loading\"></md-progress-linear><div class=\"content\" flex>\n<md-tabs md-dynamic-height md-selected=\"data.selectedIndex\"><md-tab id=\"tab0\"><md-tab-label><span \ntranslate=\"PROFILE.ABOUT\">About</span></md-tab-label><md-tab-body><md-content class=\"about-tab\" \nng-include=\"\'app/main/general/profile/tabs/about/about.html\'\"></md-content></md-tab-body></md-tab><md-tab id=\"tab1\">\n<md-tab-label><span translate=\"PROFILE.CHANGE_PASSWORD\">Password</span></md-tab-label><md-tab-body><md-content \nclass=\"password-tab\" ng-include=\"\'app/main/general/profile/tabs/password/password.html\'\"></md-content></md-tab-body>\n</md-tab></md-tabs></div></div>");
$templateCache.put("app/main/general/role/role.html","<div class=\"page-layout simple fullwidth\" id=\"rolePage\"><div class=\"header md-accent-bg\"><span class=\"h1\" \ntranslate=\"ROLE.MYROLES\">Mis Roles</span><br><div layout=\"row\" layout-align=\"end center\"><div flex=\"50\" \nclass=\"md-toolbar-tools\" style=\"padding: 0px\"><md-input-container><label translate=\"ROLE.FILTER_TYPE\">Tipo de Filtro\n</label><md-select ng-model=\"vm.tipoFiltro\"><md-option value=\"0\">{{\'ROLE.COMPANY\'|translate}}</md-option><md-option \nvalue=\"1\">{{\'ROLE.ROLE\'|translate}}</md-option></md-select></md-input-container></div></div><div layout=\"row\" \nlayout-align=\"end center\"><div flex=\"50\"><div class=\"custom-crud-search\" style=\"padding: 10px\"><md-icon flex=\"5\" \nmd-font-icon=\"icon-magnify\"></md-icon><input flex=\"90\" type=\"search\" placeholder=\"{{\'general.search\'| translate}}\" \nng-model=\"vm.inputSearch\"><md-icon flex=\"5\" md-font-icon=\"icon-close\" \nng-if=\"vm.inputSearch && vm.inputSearch.length > 0\" ng-click=\"vm.inputSearch=\'\'\"></md-icon></div></div></div></div><div\n class=\"content md-background-bg\"><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap \nng-if=\"vm.tipoFiltro === \'0\'\"><ms-widget layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\" \nng-repeat=\"c in vm.companies|filter: {name: vm.inputSearch}\"><ms-widget-front class=\"white-bg\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><div class=\"h4\">{{c.name}}</div></div></md-toolbar><md-content><md-list flex><md-list-item \nng-repeat=\"r in c.roles\" ng-click=\"vm.changeCircle(r.circle);\" \nng-class=\"r.circle.id === $root.bsCircle.id ? \'selected-item\' : \'\'\"><md-list-item-text>{{r.name}}</md-list-item-text>\n<md-button class=\"md-secondary md-icon-button\" ng-if=\"r.circle.id === $root.bsCircle.id\" aria-label=\"call\"><md-icon \nmd-font-icon=\"icon-check-circle\"></md-icon></md-button></md-list-item></md-list></md-content></ms-widget-front>\n</ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap ng-if=\"vm.tipoFiltro === \'1\'\">\n<ms-widget layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\" \nng-repeat=\"r in vm.roles|filter: {name: vm.inputSearch}\"><ms-widget-front class=\"white-bg\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><div class=\"h4\">{{r.name}}</div></div></md-toolbar><md-content><md-list flex><md-list-item \nng-repeat=\"c in r.companies\" ng-click=\"vm.changeCircle(c.circle);\" \nng-class=\"c.circle.id === $root.bsCircle.id ? \'selected-item\' : \'\'\"><md-list-item-text>{{c.name}}</md-list-item-text>\n<md-button class=\"md-secondary md-icon-button\" ng-if=\"c.circle.id === $root.bsCircle.id\" aria-label=\"call\"><md-icon \nmd-font-icon=\"icon-check-circle\"></md-icon></md-button></md-list-item></md-list></md-content></ms-widget-front>\n</ms-widget></div></div></div>");
$templateCache.put("app/quick-panel/tabs/activity/activity-tab.html","<md-list class=\"friends\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.FRIENDS\">Friends</span>\n</md-subheader><md-list-item class=\"friend md-3-line\" ng-repeat=\"friend in vm.activities.friends\"><img \nng-src=\"{{friend.avatar}}\" class=\"md-avatar\" alt=\"{{friend.name}}\"><div class=\"status {{friend.status}}\"></div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div \nclass=\"md-list-item-text\"><h3 class=\"message\">{{friend.message}}</h3><p class=\"time\">{{friend.time}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"servers\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.APP_SERVERS\">Application Servers</span></md-subheader><md-list-item class=\"server md-3-line\" \nng-repeat=\"server in vm.activities.servers\"><md-icon md-font-icon=\"icon-checkbox-blank-circle\" class=\"s16 status\" \nng-class=\"server.status\"></md-icon><div class=\"md-list-item-text\"><h3>{{server.location}}</h3><p>{{server.detail}}</p>\n</div></md-list-item></md-list><md-divider></md-divider><md-list class=\"stats\"><md-subheader class=\"md-no-sticky\"><span\n translate=\"QUICKPANEL.USER_STATS\">User Stats</span></md-subheader><md-list-item class=\"stat md-2-line\" \nng-repeat=\"stat in vm.activities.stats\"><div class=\"md-list-item-text\"><span>\n{{stat.title}} ({{stat.current}} / {{stat.total}})</span><md-progress-linear ng-class=\"stat.status\" \nmd-mode=\"determinate\" value=\"{{stat.percent}}\"></md-progress-linear></div></md-list-item></md-list>");
$templateCache.put("app/quick-panel/tabs/chat/chat-tab.html","<div class=\"main animate-slide-left\" ng-hide=\"vm.chatActive\"><md-list class=\"recent\"><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.RECENT\">Recent</span></md-subheader><md-list-item \nclass=\"contact md-3-line\" ng-repeat=\"contact in vm.contacts.recent\" ng-click=\"vm.toggleChat(contact)\"><img \nng-src=\"{{contact.avatar}}\" class=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div \nclass=\"md-list-item-text\"><h3>{{contact.name}}</h3><p class=\"last-message\">{{contact.lastMessage}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"all\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.START_NEW_CHAT\">Start New Chat</span></md-subheader><md-list-item class=\"contact\" \nng-repeat=\"contact in vm.contacts.all\" ng-click=\"vm.toggleChat(contact)\"><img ng-src=\"{{contact.avatar}}\" \nclass=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div class=\"md-list-item-text\">\n<h3>{{contact.name}}</h3></div></md-list-item></md-list><md-divider></md-divider></div><div \nclass=\"chat animate-slide-right\" ng-show=\"vm.chatActive\" layout=\"column\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button\" ng-click=\"vm.toggleChat()\" aria-label=\"Back\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.BACK\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><h4>\n<span>{{vm.chat.contact.name}}</span></h4></div><div layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-icon-button\" aria-label=\"Call\" translate translate-attr-aria-label=\"QUICKPANEL.CALL\"><md-icon \nmd-font-icon=\"icon-phone\"></md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"More\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button></div>\n</div></md-toolbar><md-content flex layout-paddings ms-scroll id=\"chat-dialog\"><div layout=\"row\" \nng-repeat=\"dialog in vm.chat.contact.dialog\" class=\"md-padding message-row\" ng-class=\"dialog.who\"><img \nng-if=\"dialog.who ===\'contact\'\" ng-src=\"{{vm.chat.contact.avatar}}\" class=\"avatar\" alt=\"{{vm.chat.contact.name}}\"> <img\n ng-if=\"dialog.who ===\'user\'\" class=\"avatar\" src=\"assets/images/avatars/profile.jpg\" alt=\"image\"><div class=\"bubble\" \nflex><div class=\"message\">{{dialog.message}}</div><div class=\"time secondary-text\">{{dialog.time}}</div></div></div>\n</md-content><form ng-submit=\"vm.reply()\" layout=\"row\" class=\"reply\" layout-align=\"start center\"><textarea \nng-keyup=\"$event.keyCode == 13 ? vm.reply() : null\" flex ng-model=\"vm.replyMessage\" \nplaceholder=\"Type and hit enter to send message\" translate translate-attr-placeholder=\"QUICKPANEL.REPLY_PLACEHOLDER\">\n</textarea><md-button class=\"md-fab md-mini\" type=\"submit\" aria-label=\"Send message\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.SEND_MESSAGE\"><md-icon md-font-icon=\"icon-send\" class=\"s16\"></md-icon>\n</md-button></form></div>");
$templateCache.put("app/quick-panel/tabs/my-notifications/my-notifications.html","<div class=\"notifications-header\" layout=\"row\" layout-align=\"center center\"><md-button class=\"md-icon-button\" \ntitle=\"{{\'notifications.notification_configuration\'| translate}}\" ng-click=\"vm.goToUserNotificationConfiguration()\">\n<md-icon md-font-icon=\"icon-cog\"></md-icon></md-button><span>{{\'QUICKPANEL.NOTIFICATIONS\'| translate}}</span></div><div\n class=\"notifications-list scrollable\" ms-scroll flex><div class=\"notification\" \nng-class=\"{\'warning-type\': notification.alertType === \'WARNING\',\n        \'error-type\': notification.alertType === \'ERROR\',\n        \'success-type\': notification.alertType === \'SUCCESS\',\n        \'message-type\': notification.alertType === \'MESSAGE\'}\" \nng-repeat=\"notification in vm.userNotificationArray\" ng-click=\"vm.showNotification($event, notification)\" \nlayout=\"column\"><div layout=\"row\"><div class=\"icon-alert-type\" flex=\"30\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-pin\" class=\"s20\" ng-if=\"!notification.isUserNotification\"></md-icon><md-icon \nmd-font-icon=\"icon-message-text\" class=\"s20\" \nng-if=\"notification.alertType === \'MESSAGE\' && notification.isUserNotification\"></md-icon><md-icon \nmd-font-icon=\"icon-check\" class=\"s20\" ng-if=\"notification.alertType === \'SUCCESS\' && notification.isUserNotification\">\n</md-icon><md-icon md-font-icon=\"icon-alert\" class=\"s20\" \nng-if=\"notification.alertType === \'WARNING\' && notification.isUserNotification\"></md-icon><md-icon \nmd-font-icon=\"icon-cancel\" class=\"s20\" ng-if=\"notification.alertType === \'ERROR\' && notification.isUserNotification\">\n</md-icon></div><div flex=\"70\" layout=\"row\" layout-align=\"end center\"><span>\n{{notification.createdAt| apiDate:\'dd-MM-yyyy HH:mm\'}}</span></div></div><div layout=\"row\"><span>\n{{notification.message| topCharactersHtml: 100}}...</span></div></div></div><div layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-primary\" ng-click=\"vm.showAllMyNotifications()\">\n{{\'notifications.show_all_my_notifications\'| translate}}</md-button></div>");
$templateCache.put("app/quick-panel/tabs/today/today-tab.html","<md-list class=\"date\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.TODAY\">Today</span></md-subheader>\n<md-list-item class=\"md-display-1 md-2-line\" layout=\"column\" layout-align=\"start start\"><div class=\"secondary-text\">\n<div>{{vm.date | date:\'EEEE\'}}</div><div layout=\"row\" layout-align=\"start start\"><span>{{vm.date | date:\'d\'}}</span> \n<span class=\"md-subhead\">th</span> <span>{{vm.date | date:\'MMMM\'}}</span></div></div></md-list-item></md-list>");
$templateCache.put("app/quick-panel/tabs/notifications/notifications.html","<div class=\"notification\" ng-repeat=\"notification in $root.msNotificationArray\"><span>\n{{notification.createdAt | apiDate:\'dd-MM-yyyy HH:mm\'}}</span><br><span>{{notification.message}}</span></div>");
$templateCache.put("app/toolbar/layouts/content-with-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">{{vm.app.initials}}</span> <span class=\"logo-text\">\n{{vm.app.name}}</span></div><div class=\"toolbar-separator\"></div><ms-shortcuts></ms-shortcuts><div \nclass=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\"><md-progress-circular \nid=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\">\n</md-progress-circular><div class=\"toolbar-separator\"></div><md-menu-bar id=\"user-menu\"><md-menu \nmd-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" \ntranslate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\" alt=\"image\">\n<md-icon md-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" \nclass=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><div class=\"toolbar-separator\"></div><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div class=\"toolbar-separator\"></div>\n<md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button class=\"language-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" \nlayout-align=\"center center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\" \nalt=\"image\"> <span class=\"iso\">{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" \nid=\"language-menu-content\"><md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button \nng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\">\n<span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\" \nalt=\"image\"> <span translate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item>\n</md-menu-content></md-menu><div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" \nclass=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/horizontal-navigation/toolbar.html","<div layout=\"column\" layout-align=\"space-between stretch\" class=\"h-128\"><div class=\"top-row\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"navigation-toggle\" \nhide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">{{vm.app.initials}}</span> <span class=\"logo-text\">\n{{vm.app.name}}</span></div></div><div layout=\"row\" layout-align=\"start center\"><md-progress-circular \nid=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\">\n</md-progress-circular><ms-shortcuts></ms-shortcuts><md-menu-bar id=\"user-menu\"><md-menu \nmd-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" \ntranslate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\" alt=\"image\">\n<md-icon md-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" \nclass=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><ms-search-bar on-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\">\n</ms-search-bar><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button \nclass=\"language-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target><div \nlayout=\"row\" layout-align=\"center center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\" alt=\"image\"> <span class=\"iso\">\n{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\" alt=\"image\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'quick-panel\')\" \naria-label=\"Toggle quick panel\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon \nmd-font-icon=\"icon-format-list-bulleted\" class=\"icon\"></md-icon></md-button></div></div><div class=\"bottom-row\"><div \nid=\"horizontal-navigation\" ui-view=\"navigation\"></div></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><ms-shortcuts></ms-shortcuts><div \nclass=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\"><md-progress-circular \nid=\"toolbar-progress\" ng-disabled=\"!$root.loadingProgress\" class=\"md-accent\" md-diameter=\"32\"></md-progress-circular>\n<md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nsrc=\"assets/images/avatars/profile.jpg\" alt=\"image\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide \nshow-gt-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs></md-icon></div>\n</md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"app.pages_profile\"><md-icon \nmd-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile</md-button></md-menu-item><md-menu-item \nclass=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon><md-button>Inbox\n</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu id=\"user-status-menu\"><md-button \nng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">{{vm.userStatus.title}}</md-button>\n<md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" ng-class=\"{\'selected\': status === vm.userStatus}\" \nng-repeat=\"status in vm.userStatusOptions\"><md-icon md-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><ms-search-bar \non-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div \nclass=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\">\n<md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target>\n<div layout=\"row\" layout-align=\"center center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\" alt=\"image\"> <span class=\"iso\">\n{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\" alt=\"image\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div class=\"toolbar-separator\"></div>\n<ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\">\n<md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"32\"></md-progress-circular><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\" alt=\"image\">\n<md-icon md-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-sm>Visitante</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" \nclass=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><div class=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" \nmd-position-mode=\"target-right target\"><md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" layout-align=\"center center\"><img \nclass=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\" alt=\"image\"> <span class=\"iso\">\n{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\" alt=\"image\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\" style=\"cursor: pointer\" ui-sref=\"app.dashboards_project\"><span \nclass=\"logo-image\"><img ng-src=\"{{vm.urlIconsFull}}\" alt=\"image\"> </span><span class=\"logo-text\" hide-sm hide-xs>\n{{vm.app.name}}</span></div><div class=\"toolbar-separator\"></div><md-button id=\"navigation-toggle\" \nclass=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><md-button class=\"md-icon-button navigation-fold-toggle\" hide show-gt-sm \naria-label=\"Toggle navigation fold\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION_FOLD\" \nng-click=\"vm.toggleMsNavigationFolded()\"><md-icon class=\"s18\" md-font-icon=\"icon-backburger\"></md-icon></md-button>\n<ms-shortcuts hide-sm hide-xs></ms-shortcuts><div class=\"toolbar-separator\"></div><div layout=\"column\" \nclass=\"bussinesCircle\" layout-align=\"center center\" hide-xs><span class=\"role\"><strong>{{bsCircle.role.description}}\n</strong> </span><span class=\"company\">{{bsCircle.company.name}}</span></div></div><div layout=\"row\" \nlayout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular><md-menu-bar id=\"user-menu\"><md-menu \nmd-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdMenu.open($event)\" \naria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nng-src=\"{{account.picture ? account.picture : \'assets/images/avatars/profile.jpg\'}}\" alt=\"picture\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" aria-label=\"icon\" ng-style=\"{\'color\': vm.userStatus.color }\" \nclass=\"icon status s16\"></md-icon></div><span class=\"username\" hide-xs>\n{{account.name + \' \' + (account.familyName ? account.familyName : \'\')}}</span><md-icon \nmd-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs></md-icon></div><md-tooltip>{{bsCircle.role.description}}\n</md-tooltip></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ng-show=\"account.sub\"><md-icon \nmd-font-icon class=\"icon-account-multiple\"></md-icon><md-menu class=\"roles-bs\"><md-button \nng-click=\"vm.openRoles($event);\" translate translate-attr-aria-label=\"TOOLBAR.ROLES\"><span transalte=\"TOOLBAR.ROLES\">\nMis Roles</span></md-button><md-menu-content width=\"4\" style=\"max-height: 90vh\" ms-scroll><md-list flex><md-list-item \nclass=\"md-2-line item-menu-bs\" ng-class=\"bsCircle.id === r.id ? \'md-light-green-300-bg\' : \'\'\" ng-repeat=\"r in circles\" \nng-click=\"vm.changeCircle(r);\"><md-icon ng-if=\"r.icon\" md-font-icon=\"{{r.icon}}\" class=\"icon\"></md-icon><div \nclass=\"md-list-item-text\" layout=\"column\"><h3>{{r.role.description}}</h3><h4>{{r.company.name}}</h4></div>\n</md-list-item></md-list></md-menu-content></md-menu></md-menu-item><md-menu-item class=\"md-indent\" \nui-sref=\"auth.register\" ng-hide=\"account.sub\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>\n<span transalte=\"TOOLBAR.NEW_ACCOUNT\">Crear Cuenta</span></md-button></md-menu-item><md-menu-item class=\"md-indent\" \nui-sref=\"app.profile\" ng-show=\"account.sub\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>\n<span translate=\"TOOLBAR.PROFILE\">Mi Perfil</span></md-button></md-menu-item><md-menu-divider ng-show=\"account.sub\">\n</md-menu-divider><md-menu-item class=\"md-indent\" ng-click=\"vm.openManual($root.APPQ.urlManual)\" \nng-show=\"$root.APPQ.urlManual\"><md-icon md-font-icon=\"icon-file-pdf\" class=\"icon\"></md-icon><md-button><span \ntranslate=\"TOOLBAR.USER_MANUAL\">Manual de Usuario</span></md-button></md-menu-item><md-menu-divider \nng-show=\"account.sub\"></md-menu-divider><md-menu-item class=\"md-indent\" ng-show=\"account.sub\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\"><span translate=\"TOOLBAR.EXIT\">\nSalir</span></md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div>\n<ms-search-bar on-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\" hide-sm \nhide-xs></ms-search-bar><div class=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" \nmd-position-mode=\"target-right target\"><md-button class=\"language-button\" ng-click=\"$mdMenu.open()\" \naria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" layout-align=\"center center\"><img \nclass=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\" alt=\"image\"> <span class=\"iso\">\n{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\" alt=\"image\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class=\"toolbar-separator\" hide-sm hide-xs></div><md-menu id=\"apps-menu\" md-offset=\"0 72\" \nmd-position-mode=\"target-right target\"><md-button class=\"apps-button\" ng-click=\"$mdMenu.open()\" aria-label=\"Apps\" \nmd-menu-origin md-menu-align-target><md-icon md-font-icon=\"icon-apps\" class=\"icon\"></md-icon></md-button>\n<md-menu-content width=\"5\" id=\"apps-menu-content\" class=\"apps-menu-content\"><div class=\"widget-group\" layout=\"row\" \nflex=\"100\" layout-wrap style=\"max-width: 400px\" ms-scroll><ms-widget layout=\"column\" flex=\"50\" flex-gt-xs=\"33\" \nflex-gt-md=\"33\" ng-repeat=\"app in vm.apps\" ng-click=\"vm.changeApp(app)\" layout-align=\"end center\"><div layout=\"column\" \nlayout-align=\"center center\"><img ng-src=\"{{vm.getImageApp(app.name)}}.png\" width=\"50\" height=\"50\" alt=\"image\"> <span \nclass=\"h3\">{{app.name}}</span></div></ms-widget></div></md-menu-content></md-menu><div class=\"toolbar-separator\"></div>\n<md-button title=\"{{$root.totalNumberOfNotifications | number:0}} {{\'notifications.notifications\' | translate}}\" \nid=\"quick-panel-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'quick-panel\')\" \naria-label=\"Toggle quick panel\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><span \nclass=\"notifications-number\" ng-if=\"$root.totalNumberOfNotifications > 0\">\n{{$root.totalNumberOfNotifications | number:0}}</span><md-icon md-font-icon=\"icon-bell\" class=\"icon\"></md-icon>\n</md-button></div></div>");
$templateCache.put("app/core/directives/ms-navigation/templates/horizontal.html","<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><ul \nclass=\"horizontal\"><li ng-repeat=\"node in vm.navigation\" ms-navigation-horizontal-node=\"node\" \nng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li></ul><script \ntype=\"text/ng-template\" id=\"navigation-horizontal-nested.html\">\n<div ms-navigation-horizontal-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-horizontal-button\" ng-if=\"!node.uisref && node.title\"\n             ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-horizontal-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-horizontal-node=\"node\"\n            ng-class=\"{\'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-horizontal-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/core/directives/ms-navigation/templates/vertical.html","<ul><li ng-repeat=\"node in vm.navigation\" ms-navigation-node=\"node\" \nng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li></ul>\n<script type=\"text/ng-template\" id=\"navigation-nested.html\">\n<div ms-navigation-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-button\" ng-if=\"!node.uisref && node.title\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-node=\"node\"\n            ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/main/apps/accountStatus/process-flow/process-flow.html","<md-content class=\"content\" flex ms-scroll><div id=\"flow-chart\" class=\"flow-chart\"><div class=\"tree\"><ul><li><a \nng-if=\"vm.infoProcessFlow.originId\"><span ng-if=\"vm.infoProcessFlow.originId\">\n{{vm.infoProcessFlow.originType.originTypeName}} # {{vm.infoProcessFlow.originId}}</span></a><ul><li><a><span \nng-if=\"vm.infoProcessFlow.requisitionId\"><span translate=\"REPORT.PROCESS_FLOW.REQUISTION\"></span>\n# {{vm.infoProcessFlow.requisitionId}}</span> <span ng-if=\"vm.infoProcessFlow.contractId\"><span \ntranslate=\"REPORT.PROCESS_FLOW.CONTRACT\"></span># {{vm.infoProcessFlow.contractId}}</span><br><span>\n{{vm.infoProcessFlow.status}}</span><md-button class=\"edit-button md-icon-button\" \nng-click=\"showAuditLog(vm.infoProcessFlow.requisitionId, 1)\" aria-label=\"logs\" translate \ntranslate-attr-aria-label=\"logs\"><md-tooltip md-direction=\"bottom\">Log</md-tooltip><md-icon \nmd-font-icon=\"icon-history\" class=\"s16\"></md-icon></md-button></a><ul \nng-if=\"vm.infoProcessFlow.requisitionId && vm.infoProcessFlow.quotations.length > 0\"><li \nng-repeat=\"quotation in vm.infoProcessFlow.quotations| orderBy:\'childId\'\"><a><span \ntranslate=\"REPORT.PROCESS_FLOW.QUOTATION\"></span> #{{quotation.childId}}<br>{{quotation.childDescription}}<br>\n({{quotation.childStatus}})<md-button class=\"edit-button md-icon-button\" ng-click=\"showAuditLog(quotation.childId, 2)\" \naria-label=\"logs\" translate translate-attr-aria-label=\"logs\"><md-tooltip md-direction=\"bottom\">Log</md-tooltip><md-icon\n md-font-icon=\"icon-history\" class=\"s16\"></md-icon></md-button></a><ul \nng-if=\"vm.infoProcessFlow.purchaseOrders.length > 0\"><li \nng-repeat=\"purchaseOrder in vm.infoProcessFlow.purchaseOrders| filter:{fatherId:quotation.childId} | orderBy:\'childId\'\">\n<a><span translate=\"REPORT.PROCESS_FLOW.PURCHASE_ORDER\"></span> # {{purchaseOrder.childId}}<br>\n({{purchaseOrder.childStatus}})<md-button class=\"edit-button md-icon-button\" \nng-click=\"showAuditLog(purchaseOrder.childId, 3)\" aria-label=\"logs\" translate translate-attr-aria-label=\"logs\">\n<md-tooltip md-direction=\"bottom\">Log</md-tooltip><md-icon md-font-icon=\"icon-history\" class=\"s16\"></md-icon>\n</md-button></a><ul ng-if=\"vm.infoProcessFlow.entryMerchandise1.length > 0\"><li \nng-repeat=\"entryMerchandise1 in vm.infoProcessFlow.entryMerchandise1| filter:{fatherId:purchaseOrder.childId}| orderBy:\'childId\'\">\n<a><span translate=\"REPORT.PROCESS_FLOW.ENTRY\"></span> # {{entryMerchandise1.childId}}</a><ul><li \nng-repeat=\"invoice in vm.infoProcessFlow.invoice| filter:{fatherId:entryMerchandise1.childId}| orderBy:\'childId\'\"><a>\n<span translate=\"REPORT.PROCESS_FLOW.INVOICE\"></span> # {{invoice.childId}}<br>({{invoice.childStatus}})<md-button \nclass=\"edit-button md-icon-button\" ng-click=\"showAuditLog(invoice.childId, 4)\" aria-label=\"logs\" translate \ntranslate-attr-aria-label=\"logs\"><md-tooltip md-direction=\"bottom\">Log</md-tooltip><md-icon \nmd-font-icon=\"icon-history\" class=\"s16\"></md-icon></md-button></a></li></ul></li></ul></li></ul></li></ul><ul \nng-if=\"vm.infoProcessFlow.contractId && vm.infoProcessFlow.purchaseOrders.length > 0\"><li \nng-repeat=\"purchaseOrder in vm.infoProcessFlow.purchaseOrders| orderBy:\'childId\'\"><a><span \ntranslate=\"REPORT.PROCESS_FLOW.PURCHASE_ORDER\"></span> # {{purchaseOrder.childId}}<br>({{purchaseOrder.childStatus}})\n<md-button class=\"edit-button md-icon-button\" ng-click=\"showAuditLog(purchaseOrder.childId, 3)\" aria-label=\"logs\" \ntranslate translate-attr-aria-label=\"logs\"><md-tooltip md-direction=\"bottom\">Log</md-tooltip><md-icon \nmd-font-icon=\"icon-history\" class=\"s16\"></md-icon></md-button></a><ul \nng-if=\"vm.infoProcessFlow.entryMerchandise1.length > 0\"><li \nng-repeat=\"entryMerchandise1 in vm.infoProcessFlow.entryMerchandise1| filter:{fatherId:purchaseOrder.childId}| orderBy:\'childId\'\">\n<a><span translate=\"REPORT.PROCESS_FLOW.ENTRY\"></span> # {{entryMerchandise1.childId}}<br><span \ntranslate=\"REPORT.PROCESS_FLOW.CUOTA\"></span>#{{entryMerchandise1.paymentNro}}</a><ul \nng-if=\"vm.infoProcessFlow.invoice.length > 0\"><li \nng-repeat=\"invoice in vm.infoProcessFlow.invoice| filter:{fatherId:entryMerchandise1.childId}| orderBy:\'childId\'\"><a>\n<span translate=\"REPORT.PROCESS_FLOW.INVOICE\"></span> # {{invoice.childId}}<br>({{invoice.childStatus}})<md-button \nclass=\"edit-button md-icon-button\" ng-click=\"showAuditLog(invoice.childId, 4)\" aria-label=\"logs\" translate \ntranslate-attr-aria-label=\"logs\"><md-tooltip md-direction=\"bottom\">Log</md-tooltip><md-icon \nmd-font-icon=\"icon-history\" class=\"s16\"></md-icon></md-button></a></li></ul></li></ul></li></ul></li></ul></li></ul>\n</div></div></md-content>");
$templateCache.put("app/main/apps/contract/contract/budgetsTemplate.html","<div layout=\"row\" layout-align=\"start center\" style=\"height: 100%\"><div flex=\"70\"><md-menu-bar \nstyle=\"width: 100%; margin: 0px\"><md-menu md-position-mode=\"left bottom\"><div layout=\"row\" \nng-click=\"$mdOpenMenu($event);\"><div style=\"cursor: pointer\"><span \nng-if=\"data.references.length === undefined || data.references.length === null || data.references.length === 0\">\n{{\'authorize_quotations.select_budgets\'| translate}}... </span><span ng-if=\"data.references.length > 1\">\n{{data.references.length}} {{\'authorize_quotations.selected_budgets\'| translate}}...</span></div><div \nng-if=\"data.references.length === 1\" style=\"min-height: 32px; min-width: 100px; width: 100%; display: block\"><div \nlayout=\"row\" layout-align=\"start center\" ng-repeat=\"reference in data.references\" style=\"height: 38px; float: left\">\n<div flex=\"40\" layout=\"column\"><span>{{\'authorize_quotations.amount\'| translate}}</span> <span>\n{{reference.currencyCode}}. {{reference.amountToUse| number:2}}</span></div><div flex=\"60\" layout=\"column\"><span>\n{{reference.budgetStartDate| date: \'dd/MM/yyyy\'}} - {{reference.budgetEndDate| date: \'dd/MM/yyyy\'}} </span><span>\n{{\'authorize_quotations.type\'| translate}}: {{reference.budgetType}}</span></div></div></div></div><md-menu-content \nwidth=\"3\" style=\"max-height:600px\"><md-menu-item \nstyle=\"height: 54px; line-height: normal; min-width: 325px; min-height: 50px\" \nng-if=\"vm.productBudget[data.product.id].length === 0\"><span>\n{{\'authorize_quotations.no_budgets_for_this_product\'| translate}}...</span></md-menu-item><md-menu-item \nstyle=\"height: 54px; line-height: normal; min-width: 325px; min-height: 50px\" \nng-if=\"vm.productBudget[data.product.id].length > 0\" ng-repeat=\"budgetDetail in vm.productBudget[data.product.id]\"><div\n style=\"cursor: pointer; position: relative; margin: 0px\" md-prevent-menu-close \nng-click=\"toggleSelectBudget(budgetDetail, $event)\" md-ink-ripple layout=\"row\" layout-align=\"start center\"><div \nflex=\"10\" layout=\"column\" layout-align=\"center center\"><md-checkbox ng-checked=\"isSelected(budgetDetail)\" \naria-label=\"{{isSelected(budgetDetail) ? \'Deselect\' : \'Select\'}}\" style=\"margin: 0px\"></md-checkbox></div><div \nflex=\"30\" layout=\"column\"><span>{{\'authorize_quotations.available\'| translate}}</span> <span>\n{{budgetDetail.currencyOfficial.code}}. {{budgetDetail.available| number:2}}</span></div><div flex=\"60\" \nlayout=\"column\"><span>\n{{budgetDetail.budget.startDate| date: \'dd/MM/yyyy\'}} - {{budgetDetail.budget.endDate| date: \'dd/MM/yyyy\'}}</span> \n<span>{{\'authorize_quotations.type\'| translate}}: {{budgetDetail.budget.budgetType.description}}</span></div></div>\n</md-menu-item></md-menu-content></md-menu></md-menu-bar></div><div flex=\"30\"><md-checkbox aria-label=\"need extension\" \nng-change=\"validateRequestAmpliation($event, this)\" ng-model=\"data.requestAmpliation\" \nng-if=\"data.totalCovered < (data.total) && data.references && data.references.length > 0\">\n{{\'authorize_quotations.request_ampliation\'| translate}}</md-checkbox></div></div>");
$templateCache.put("app/main/apps/contract/contract/contract.html","<div id=\"budgetO\" class=\"page-layout carded fullwidth\" layout=\"column\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" \nlayout=\"row\" layout-align=\"start center\" flex><md-button class=\"goto-orders-button md-icon-button\" \naria-label=\"Go to orders\" ng-click=\"vm.gotoContracts()\" translate translate-attr-aria-label=\"CONTRACT.GO_TO_ORDERS\">\n<md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"h2\"><span translate=\"CONTRACT.NEW\" ng-if=\"!vm.contractPurchase.id\">Nuevo</span> <span \ntranslate=\"CONTRACT.CONTRACT\">Contract</span> <span>{{vm.contractPurchase.id}}</span></div><div><span>\n{{vm.contractPurchase.companyProvider.name}}</span></div><div class=\"subtitle secondary-text\"></div></div></div></div>\n<div class=\"content-card\" layout=\"column\" flex><div class=\"toolbar\"><div layout=\"row\"><md-tabs \nmd-selected=\"vm.currentTab\" flex><md-tab id=\"tab1\" aria-controls=\"tab1-content\"><span translate=\"CONTRACT.COMPANY\">\nRequisition Details</span></md-tab><md-tab ng-disabled=\"!vm.contractPurchase.companyProvider\" id=\"tab2\" \naria-controls=\"tab2-content\"><span translate=\"CONTRACT.ENCABEZADO\">Requisition Details</span></md-tab><md-tab \nng-disabled=\"!vm.contractPurchase.id\" id=\"tab3\" aria-controls=\"tab2-content\"><span \ntranslate=\"CONTRACT.CONTRACT_DETAILS\">Details</span></md-tab></md-tabs><div \nng-if=\"vm.contractPurchase.id > 0 && vm.detailsContract.length>0\"><md-button ng-show=\"vm.statusToChange\" \nng-disabled=\"$rootScope.loadingProgress\" class=\"md-raised md-primary\" ng-click=\"vm.presentContract()\" \naria-label=\"present budget\" translate translate-attr-aria-label=\"CONTRACT.ORDER_DETAILS\"><span>\n{{\'CONTRACT.STATUSCHANGE.\' + vm.statusToChange| translate}}</span></md-button></div></div></div><md-content \nclass=\"content\" flex ms-scroll><md-tabs md-dynamic-height md-selected=\"vm.currentTab\" class=\"tab-in-content\"><md-tab \naria-controls=\"tab1-content\"><md-tab-body><div ng-show=\"false\"><md-input-container><input type=\"text\" \nng-model=\"vm.contractPurchase.companyProvider.name\" name=\"providerName\" required></md-input-container></div><div \nid=\"companyList\" class=\"custom-list\" ms-scroll expand-grid min=\"200\" other=\"235\"><div class=\"search-list\" layout=\"row\" \nlayout-align=\"start center\"><input flex type=\"search\" ng-model=\"vm.searchCompanyInput\" \nplaceholder=\"{{\'QUOTATION.CREATE.SEARCH_COMPANY\'| translate}}\" ng-enter=\"vm.getAllCompanies()\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.getAllCompanies()\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button>\n</div><div ng-if=\"vm.companyArray.length > 0 && !vm.isShowLoaderCompanies\"><div class=\"item\" \nng-repeat=\"company in vm.companyArray\" ng-click=\"vm.toggleCompany($event, company)\"><div layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-radiobox-marked\" \nng-if=\"company.id === vm.contractPurchase.companyProvider.id\"></md-icon><md-icon md-font-icon=\"icon-radiobox-blank\" \nng-if=\"company.id !== vm.contractPurchase.companyProvider.id\"></md-icon><div flex class=\"company-name\">\n{{company.name}} / {{company.businessName}}({{company.email}})</div></div></div></div><div \nng-if=\"vm.companyArray.length === 0 && !vm.isShowLoaderCompanies\" layout=\"column\" layout-align=\"center center\" \nclass=\"message-empty-list\"><div>{{\'QUOTATION.CREATE.COMPANY_LIST_EMPTY\'| translate}}</div></div><div layout=\"column\" \nlayout-align=\"center center\" class=\"loader-content-list\" ng-if=\"vm.isShowLoaderCompanies\"><md-progress-circular \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular><div>\n{{\'QUOTATION.CREATE.LOADING_COMPANIES\'| translate}}...</div></div></div><div layout=\"row\"><div paging \nclass=\"pageable-div center\" page=\"vm.paginationCompanies.pageNumber\" ul-class=\"pagination\" \npage-size=\"vm.paginationCompanies.pageSize\" hide-if-empty=\"true\" paging-action=\"vm.paginationCompanies.getPage(page)\" \ntotal=\"vm.paginationCompanies.totalElements\"></div></div></md-tab-body></md-tab><md-tab aria-controls=\"tab2-content\">\n<md-tab-body><form name=\"vm.contractPurchaseForm\"><div \nclass=\"order-detail-form-container status md-background-bg md-whiteframe-1dp\"><div class=\"pb-16\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-clipboard-text\" class=\"m-0 mr-16\"></md-icon><div \nclass=\"h2 secondary-text\" translate=\"CONTRACT.CONTRACT_DATA\">Requisition Data</div></div><div class=\"customer\"><div \nlayout-gt-xs=\"row\" layout-align=\"start center\" layout-align=\"start center\"><md-input-container flex-gt-xs><label \ntranslate=\"CONTRACT.DEPARTMENT\">Department</label><md-select ng-model=\"vm.contractPurchase.department.id\" \nname=\"department\" required ng-disabled=\"vm.loadingDepartments\" md-on-close=\"vm.clearSearchDepartment()\">\n<md-select-header><input id=\"searchDepartment\" ng-model=\"vm.searchDepartment\" type=\"search\" \nplaceholder=\"Buscar departamento\"></md-select-header><md-optgroup label=\"Departamentos\"><md-option ng-value=\"depto.id\" \nng-repeat=\"depto in vm.departments| filter:vm.searchDepartment\">{{depto.description}}</md-option></md-optgroup>\n</md-select><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loadingDepartments\"></md-progress-linear><div \nng-messages=\"vm.contractPurchaseForm.department.$error\"><div ng-message=\"required\" \ntranslate=\"CONTRACT.ERROR.FIELD_REQUIRED\">This is required!</div></div></md-input-container><md-input-container \nflex-gt-xs><label translate=\"CONTRACT.COST_CENTER\">Cost Center</label><md-select \nng-model=\"vm.contractPurchase.costCenter.id\" name=\"costcenter\" md-on-close=\"vm.clearSearchCostCenter()\" required \nng-disabled=\"vm.loadingCostCenter\"><md-select-header><input id=\"searchCostCenter\" ng-model=\"vm.searchCostCenter\" \ntype=\"search\" placeholder=\"Buscar centro de costo\"></md-select-header><md-optgroup><md-option ng-value=\"cc.id\" \nng-repeat=\"cc in vm.costCenters| filter:vm.searchCostCenter\">{{cc.description}}</md-option></md-optgroup></md-select>\n<md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loadingCostCenter\"></md-progress-linear><div \nng-messages=\"vm.contractPurchaseForm.costcenter.$error\"><div ng-message=\"required\" \ntranslate=\"CONTRACT.ERROR.FIELD_REQUIRED\">This is required!</div></div></md-input-container></div><div \nlayout-gt-xs=\"row\" layout-align=\"start center\" layout-align=\"start center\"><md-input-container flex-gt-xs><label \ntranslate=\"REQUISITION.PROJECT\">Proyecto</label><md-select ng-model=\"vm.contractPurchase.projectId\" name=\"project\" \nng-disabled=\"vm.loadingProjects\" md-on-close=\"vm.clearSearchProject()\"><md-select-header><input id=\"searchProject\" \nng-model=\"vm.searchProject\" type=\"search\" placeholder=\"Buscar Proyectos\"></md-select-header><md-optgroup \nlabel=\"Proyectos\"><md-option value=\"{{depto.id}}\" ng-repeat=\"depto in vm.projects| filter:vm.searchProject\">\n{{depto.code}} - {{depto.name}}</md-option></md-optgroup></md-select><md-progress-linear md-mode=\"indeterminate\" \nng-if=\"vm.loadingProjects\"></md-progress-linear></md-input-container><md-input-container flex-gt-xs><label \ntranslate=\"CONTRACT.TYPE\">ContractType</label><md-select ng-model=\"vm.contractPurchase.contractType.id\" \nname=\"contractType\" md-on-close=\"vm.clearSearchContractType()\" required ng-disabled=\"vm.loadingContractType\">\n<md-select-header><input id=\"searchContractType\" ng-model=\"vm.searchContractType\" type=\"search\" \nplaceholder=\"Buscar Tipo de Contrato\"></md-select-header><md-optgroup><md-option ng-value=\"ct.id\" \nng-repeat=\"ct in vm.contractTypes| filter:vm.searchContractType\">{{ct.name}}</md-option></md-optgroup></md-select>\n<md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loadingContractType\"></md-progress-linear><div \nng-messages=\"vm.contractPurchaseForm.contractType.$error\"><div ng-message=\"required\" \ntranslate=\"CONTRACT.ERROR.FIELD_REQUIRED\">This is required!</div></div></md-input-container></div><div \nlayout-gt-xs=\"row\" layout-align=\"start center\" layout-align=\"start center\"><md-input-container flex-gt-xs><label \ntranslate=\"CONTRACT.CURRENCY\">currency</label><md-select ng-model=\"vm.contractPurchase.currency.id\" name=\"currency\" \nmd-on-close=\"vm.clearSearchCurrency()\" required ng-disabled=\"vm.loadingCurrency\"><md-select-header><input \nid=\"searchCurrency\" ng-model=\"vm.searchCurrency\" type=\"search\" placeholder=\"Buscar Moneda\"></md-select-header>\n<md-optgroup><md-option ng-value=\"cr.id\" ng-repeat=\"cr in vm.currencyArray| filter:vm.searchCurrency\">\n{{cr.description}} <span>{{cr.symbol}}</span></md-option></md-optgroup></md-select><md-progress-linear \nmd-mode=\"indeterminate\" ng-if=\"vm.loadingCurrency\"></md-progress-linear><div \nng-messages=\"vm.contractPurchaseForm.currency.$error\"><div ng-message=\"required\" \ntranslate=\"CONTRACT.ERROR.FIELD_REQUIRED\">This is required!</div></div></md-input-container><md-input-container \nflex-gt-xs><label translate=\"CONTRACT.EXCHANGERATE\">exchangeRate</label><input type=\"number\" \nng-model=\"vm.contractPurchase.exchangeRate\" ng-disabled=\"vm.details.length > 0\" name=\"exchangeRate\" md-open-on-focus \nrequired><div ng-messages=\"vm.contractPurchaseForm.exchangeRate.$error\"><div ng-message=\"required\" \ntranslate=\"CONTRACT.ERROR.FIELD_REQUIRED\">This is required!</div></div></md-input-container></div><div \nlayout-gt-xs=\"row\" layout-align=\"start center\" layout-align=\"start center\"><md-input-container flex-gt-xs><label \ntranslate=\"CONTRACT.MAXDATEPURCHASE\">End Date</label><md-datepicker type=\"date\" \nng-model=\"vm.contractPurchase.dateDelivery\" name=\"dateDelivery\" md-min-date=\"vm.minDate\" md-open-on-focus>\n</md-datepicker><div ng-messages=\"vm.contractPurchaseForm.dateDelivery.$error\"><div ng-message=\"valid\" \ntranslate=\"CONTRACT.ERROR.INVALID_DATE\">The entered value is not a date!</div><div ng-message=\"required\" \ntranslate=\"CONTRACT.ERROR.FIELD_REQUIRED\">This is required!</div><div ng-message=\"mindate\" \ntranslate=\"CONTRACT.ERROR.INVALID_DATE\">Date is too early!</div></div></md-input-container><md-input-container \nflex-gt-xs><label translate=\"CONTRACT.PAYMENTS\">payments</label><input type=\"number\" \nng-model=\"vm.contractPurchase.payments\" ng-disabled=\"vm.details.length > 0\" min=\"1.0\" name=\"payments\" md-open-on-focus \nrequired><div ng-messages=\"vm.contractPurchaseForm.payments.$error\"><div ng-message=\"required\" \ntranslate=\"CONTRACT.ERROR.FIELD_REQUIRED\">This is required!</div></div></md-input-container><md-input-container \nflex-gt-xs><md-checkbox ng-model=\"vm.contractPurchase.fixed\">{{\"CONTRACT.FIXED\"| translate}}</md-checkbox><div \nng-messages=\"vm.contractPurchaseForm.fixed.$error\"><div ng-message=\"required\" \ntranslate=\"CONTRACT.ERROR.FIELD_REQUIRED\">This is required!</div></div></md-input-container></div><div \nlayout-gt-xs=\"row\" layout-align=\"start center\" layout-align=\"start center\"><md-input-container flex-gt-xs \nng-if=\"vm.dimensionCompanyDetail3\"><label>{{vm.dimensionCompanyDetail3.description}}</label><md-select \nng-model=\"vm.contractPurchase.dimensionCompanyDetail3.id\" name=\"dimensionCompanyDetail3\" \nmd-on-close=\"vm.searchDimensionCompanyDetail3=\'\'\" ng-required=\"vm.dimensionCompanyDetail3.required\"><md-select-header>\n<input id=\"searchDimensionCompanyDetail3\" ng-model=\"vm.searchDimensionCompanyDetail3\" type=\"search\" translate \ntranslate-attr-placeholder=\"general.search\" aria-label=\"search-dimension-company\" \nng-keydown=\"$event.stopPropagation()\"></md-select-header><md-optgroup label=\"dimensionCompanyDetail3\"><md-option \nvalue=\"{{data.id}}\" \nng-repeat=\"data in vm.dimensionCompanyDetail3List| \n                                                                filter:vm.searchDimensionCompanyDetail3\">\n{{data.code}} - {{data.name}}</md-option></md-optgroup></md-select><md-progress-linear md-mode=\"indeterminate\" \nng-if=\"vm.loadingdimensionCompanyDetail3List\"></md-progress-linear></md-input-container><md-input-container flex-gt-xs \nng-if=\"vm.dimensionCompanyDetail4\"><label>{{vm.dimensionCompanyDetail4.description}}</label><md-select \nng-model=\"vm.contractPurchase.dimensionCompanyDetail4.id\" name=\"dimensionCompanyDetail4\" \nmd-on-close=\"vm.searchDimensionCompanyDetail4=\'\'\" ng-required=\"vm.dimensionCompanyDetail4.required\"><md-select-header>\n<input id=\"searchDimensionCompanyDetail4\" ng-model=\"vm.searchDimensionCompanyDetail4\" type=\"search\" translate \ntranslate-attr-placeholder=\"general.search\" aria-label=\"search-dimension-company\" \nng-keydown=\"$event.stopPropagation()\"></md-select-header><md-optgroup label=\"dimensionCompanyDetail4\"><md-option \nvalue=\"{{data.id}}\" \nng-repeat=\"data in vm.dimensionCompanyDetail4List| \n                                                                filter:vm.searchDimensionCompanyDetail4\">\n{{data.code}} - {{data.name}}</md-option></md-optgroup></md-select><md-progress-linear md-mode=\"indeterminate\" \nng-if=\"vm.loadingdimensionCompanyDetail4List\"></md-progress-linear></md-input-container><md-input-container flex-gt-xs \nng-if=\"vm.dimensionCompanyDetail5\"><label>{{vm.dimensionCompanyDetail5.description}}</label><md-select \nng-model=\"vm.contractPurchase.dimensionCompanyDetail5.id\" name=\"dimensionCompanyDetail5\" \nmd-on-close=\"vm.searchDimensionCompanyDetail5=\'\'\" ng-required=\"vm.dimensionCompanyDetail5.required\"><md-select-header>\n<input id=\"searchDimensionCompanyDetail5\" ng-model=\"vm.searchDimensionCompanyDetail5\" type=\"search\" translate \ntranslate-attr-placeholder=\"general.search\" aria-label=\"search-dimension-company\" \nng-keydown=\"$event.stopPropagation()\"></md-select-header><md-optgroup label=\"dimensionCompanyDetail5\"><md-option \nvalue=\"{{data.id}}\" \nng-repeat=\"data in vm.dimensionCompanyDetail5List| \n                                                                filter:vm.searchDimensionCompanyDetail5\">\n{{data.code}} - {{data.name}}</md-option></md-optgroup></md-select><md-progress-linear md-mode=\"indeterminate\" \nng-if=\"vm.loadingdimensionCompanyDetail5List\"></md-progress-linear></md-input-container></div></div></div></form>\n</md-tab-body></md-tab><md-tab aria-controls=\"tab3-content\"><md-tab-body><div \nclass=\"order-detail-form-container products md-background-bg md-whiteframe-1dp\"><div class=\"black-text\" \nlayout=\"column\" layout-align=\"start start\" style=\"width: 100%\"><div class=\"search\" layout=\"row\" layout-align=\"none\" \nstyle=\"width: 100%\"><md-icon md-font-icon=\"icon-magnify\" class=\"black-text icon search-icon\"></md-icon><input \nid=\"e-commerce\" ng-model=\"vm.search\" class=\"\" type=\"text\" placeholder=\"Search\" \nstyle=\"width: 90%; box-shadow: 10px 10px 5px #888888\" translate translate-attr-placeholder=\"REQUISITION.SEARCH\" \nng-model-options=\"{\'debounce\': 300}\"></div></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loading\" \nclass=\"md-accent\"></md-progress-linear><div id=\"masterGridOptionsE\" ag-grid=\"vm.masterGridOptions\" class=\"ag-fresh\" \nexpand-grid min=\"260\" other=\"200\"></div></div></div></div></md-tab-body></md-tab></md-tabs></md-content></div></div>\n</div><md-button ng-if=\"vm.currentTab >= 1 && vm.currentTab !== 2\" class=\"md-fab md-fab-bottom-right\" \naria-label=\"addDetail\" ng-disabled=\"vm.contractPurchaseForm.$invalid && vm.currentTab === 1\" \nng-click=\"vm.openAddDialog($event)\"><md-icon md-font-icon=\"icon-content-save\" \nng-if=\"vm.currentTab === 1 && !vm.contractPurchase.product\"></md-icon><md-icon md-font-icon=\"icon-pencil\" \nng-if=\"vm.currentTab === 1 && vm.contractPurchase.product\"></md-icon><md-tooltip md-direction=\"top\" \nng-if=\"vm.currentTab === 1 && vm.contractPurchase.product\" md-visible=\"tooltipVisible\">{{\'general.edit\'| translate}}\n</md-tooltip></md-button><md-button ng-if=\"vm.currentTab === 2\" class=\"md-fab md-fab-bottom-right\" \naria-label=\"addDetail\" ng-disabled=\"vm.contractPurchaseForm.$invalid && vm.currentTab === 1\" \nng-click=\"vm.composeDialog($event)\"><md-icon md-font-icon=\"icon-plus\" ng-if=\"vm.currentTab === 2\"></md-icon><md-tooltip\n md-direction=\"top\" ng-if=\"vm.currentTab === 2\" md-visible=\"tooltipVisible\">{{\'general.edit\'| translate}}</md-tooltip>\n</md-button><md-button ng-if=\"vm.currentTab >= 1\" class=\"md-fab md-fab-bottom-left\" aria-label=\"addDetail\" \nng-click=\"vm.currentTab = (vm.currentTab - 1)\"><md-icon md-font-icon=\"icon-arrow-left\" ng-if=\"vm.currentTab >= 1\">\n</md-icon><md-tooltip md-direction=\"top\" md-visible=\"tooltipVisible\">{{\'general.return\'| translate}}</md-tooltip>\n</md-button>");
$templateCache.put("app/main/apps/contract/contract/contract_Autorize.html","<div id=\"budgetO\" class=\"page-layout carded fullwidth\" layout=\"column\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" \nlayout=\"row\" layout-align=\"start center\" flex><md-button class=\"goto-orders-button md-icon-button\" \naria-label=\"Go to orders\" ng-click=\"vm.gotoContracts()\" translate translate-attr-aria-label=\"CONTRACT.GO_TO_ORDERS\">\n<md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"h2\"><span translate=\"CONTRACT.CONTRACT\">Order</span> <span>{{vm.contractPurchase.id}}</span></div><div \nclass=\"subtitle secondary-text\"></div></div></div></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"toolbar\"><div layout=\"row\"><span flex></span><md-button ng-show=\"vm.statusToChange\" \nng-disabled=\"$rootScope.loadingProgress || !vm.showButton\" class=\"md-raised md-primary\" \nng-click=\"vm.presentContract()\" aria-label=\"present budget\" translate \ntranslate-attr-aria-label=\"CONTRACT.ORDER_DETAILS\"><span ng-if=\"!vm.requestAmpliationButton\">\n{{\'CONTRACT.STATUSCHANGE.\' + vm.statusToChange| translate}}</span> <span ng-if=\"vm.requestAmpliationButton\">\n{{\'CONTRACT.STATUSCHANGE.request_ampliation\' | translate}}</span></md-button></div></div><md-content class=\"content\" \nflex ms-scroll><fieldset class=\"standard\"><legend>{{\'CONTRACT.ENCABEZADO\'| translate}}</legend><div layout=\"row\"><div \nflex layout-wrap layout-gt-sm=\"row\" id=\"generalData\" ng-class=\"vm.dinamicSize > 900 ? \'\' : \'customer-toolbar\'\"><div \nflex=\"100\" layout=\"row\" layout-xs=\"column\" class=\"p-6 grey-50-bg\" style=\"padding-left: 8px; padding-top: 5px\"><div \nflex=\"30\"><span class=\"title grey-50-bg\"><strong>{{\"CONTRACT.COMPANY_PROVIDER\"| translate}}</strong></span></div><div \nflex=\"70\"><span>{{vm.contractPurchase.companyProvider.name}}</span></div></div><div flex=\"100\" layout=\"row\" \nlayout-xs=\"column\" class=\"p-6 grey-50-bg\" style=\"padding-left: 8px; padding-top: 5px\"><div flex=\"30\"><span \nclass=\"title grey-50-bg\"><strong>{{\"CONTRACT.DEPARTMENT\"| translate}}</strong></span></div><div flex=\"70\"><span>\n{{vm.contractPurchase.department.description}}</span></div></div><div flex=\"100\" layout=\"row\" layout-xs=\"column\" \nclass=\"p-6 grey-50-bg\" style=\"padding-left: 8px; padding-top: 5px\"><div flex=\"30\"><span class=\"title grey-50-bg\">\n<strong>{{\"CONTRACT.COST_CENTER\"| translate}}</strong></span></div><div flex=\"70\"><span>\n{{vm.contractPurchase.costCenter.description}}</span></div></div><div flex=\"100\" layout=\"row\" layout-xs=\"column\" \nclass=\"p-6 grey-50-bg\" style=\"padding-left: 8px; padding-top: 5px\"><div flex=\"30\"><span class=\"title grey-50-bg\">\n<strong>{{\"REQUISITION.PROJECT\"| translate}}</strong></span></div><div flex=\"70\"><span>{{vm.contractPurchase.prjName}}\n</span></div></div><div flex=\"100\" layout=\"row\" layout-xs=\"column\" class=\"p-6 grey-50-bg\" \nstyle=\"padding-left: 8px; padding-top: 5px\"><div flex=\"30\"><span class=\"title grey-50-bg\"><strong>\n{{\"CONTRACT.TYPE\"| translate}}</strong></span></div><div flex=\"70\"><span>{{vm.contractPurchase.contractType.name}}\n</span></div></div><div flex=\"100\" layout=\"row\" layout-xs=\"column\" class=\"p-6 grey-50-bg\" \nstyle=\"padding-left: 8px; padding-top: 5px\"><div flex=\"30\"><span class=\"title grey-50-bg\"><strong>\n{{\"CONTRACT.MAXDATEPURCHASE\"| translate}}</strong></span></div><div flex=\"70\"><span>\n{{vm.contractPurchase.dateDelivery| date: \'dd-MM-yyyy\'}}</span></div></div><div flex=\"100\" layout=\"row\" \nlayout-xs=\"column\" class=\"p-6 grey-50-bg\" style=\"padding-left: 8px; padding-top: 5px\"><div flex=\"30\"><span \nclass=\"title grey-50-bg\"><strong>{{\"CONTRACT.PAYMENTS\"| translate}}</strong></span></div><div flex=\"70\"><span>\n{{vm.contractPurchase.payments| number : 0}}</span></div></div></div><span flex=\"5\"></span><div flex layout-wrap \nlayout-gt-sm=\"row\" id=\"generalData\" ng-class=\"vm.dinamicSize > 900 ? \'\' : \'customer-toolbar\'\"><div flex=\"100\" \nlayout=\"row\" layout-xs=\"column\" ng-if=\"vm.dimensionCompanyDetail3\" class=\"p-6 grey-50-bg line\"><div flex=\"20\"><span \nclass=\"title grey-50-bg\"><strong>{{vm.dimensionCompanyDetail3.description}}</strong></span></div><div flex=\"80\"><span>\n{{vm.contractPurchase.dimensionCompanyDetail3.name}}</span></div></div><div flex=\"100\" layout=\"row\" layout-xs=\"column\" \nng-if=\"vm.dimensionCompanyDetail4\" class=\"p-6 grey-50-bg line\"><div flex=\"20\"><span class=\"title grey-50-bg\"><strong>\n{{vm.dimensionCompanyDetail4.description}}</strong></span></div><div flex=\"80\"><span>\n{{vm.contractPurchase.dimensionCompanyDetail4.name}}</span></div></div><div flex=\"100\" layout=\"row\" layout-xs=\"column\" \nng-if=\"vm.dimensionCompanyDetail5\" class=\"p-6 grey-50-bg line\"><div flex=\"20\"><span class=\"title grey-50-bg\"><strong>\n{{vm.dimensionCompanyDetail5.description}}</strong></span></div><div flex=\"80\"><span>\n{{vm.contractPurchase.dimensionCompanyDetail5.name}}</span></div></div></div></div></fieldset><md-progress-linear \nmd-mode=\"indeterminate\" ng-if=\"vm.loading\" class=\"md-accent\"></md-progress-linear><div id=\"masterGridOptionsE\" \nag-grid=\"vm.masterGridOptions\" class=\"ag-fresh\" expand-grid min=\"250\" other=\"300\"></div></md-content></div></div></div>");
$templateCache.put("app/main/apps/contract/contract/contract_Report.html","<div id=\"budgetO\" class=\"page-layout carded fullwidth\" layout=\"column\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex ng-show=\"vm.contractPurchase.purchaseStatus.orderColumn <= 2\"><div class=\"header\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><md-button\n class=\"goto-orders-button md-icon-button\" aria-label=\"Go to orders\" ng-click=\"vm.gotoContracts()\" translate \ntranslate-attr-aria-label=\"CONTRACT.GO_TO_ORDERS\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div \nlayout=\"column\" layout-align=\"start start\"><div class=\"h2\"><span translate=\"CONTRACT.CONTRACT\">Order</span> <span>\n{{vm.contractPurchase.id}}</span></div><div class=\"subtitle secondary-text\"></div></div></div></div><div \nclass=\"content-card\" layout=\"column\" flex><md-content class=\"content\" flex ms-scroll><fieldset class=\"standard\">\n<legend>{{\'CONTRACT.ENCABEZADO\'| translate}}</legend><div layout-wrap layout-gt-sm=\"row\" id=\"generalData\"><div \nflex=\"100\" layout=\"row\" layout-xs=\"column\" class=\"p-6 grey-50-bg\" style=\"padding-left: 8px; padding-top: 5px\"><div \nflex=\"30\"><span class=\"title grey-50-bg\"><strong>{{\"CONTRACT.COMPANY_PROVIDER\"| translate}}</strong></span></div><div \nflex=\"70\"><span>{{vm.contractPurchase.companyProvider.name}}</span></div></div><div flex=\"100\" layout=\"row\" \nlayout-xs=\"column\" class=\"p-6 grey-50-bg\" style=\"padding-left: 8px; padding-top: 5px\"><div flex=\"30\"><span \nclass=\"title grey-50-bg\"><strong>{{\"CONTRACT.DEPARTMENT\"| translate}}</strong></span></div><div flex=\"70\"><span>\n{{vm.contractPurchase.department.description}}</span></div></div><div flex=\"100\" layout=\"row\" layout-xs=\"column\" \nclass=\"p-6 grey-50-bg\" style=\"padding-left: 8px; padding-top: 5px\"><div flex=\"30\"><span class=\"title grey-50-bg\">\n<strong>{{\"CONTRACT.COST_CENTER\"| translate}}</strong></span></div><div flex=\"70\"><span>\n{{vm.contractPurchase.costCenter.description}}</span></div></div><div flex=\"100\" layout=\"row\" layout-xs=\"column\" \nclass=\"p-6 grey-50-bg\" style=\"padding-left: 8px; padding-top: 5px\"><div flex=\"30\"><span class=\"title grey-50-bg\">\n<strong>{{\"REQUISITION.PROJECT\"| translate}}</strong></span></div><div flex=\"70\"><span>\n{{vm.contractPurchase.project.prjName}}</span></div></div><div flex=\"100\" layout=\"row\" layout-xs=\"column\" \nclass=\"p-6 grey-50-bg\" style=\"padding-left: 8px; padding-top: 5px\"><div flex=\"30\"><span class=\"title grey-50-bg\">\n<strong>{{\"CONTRACT.TYPE\"| translate}}</strong></span></div><div flex=\"70\"><span>\n{{vm.contractPurchase.contractType.name}}</span></div></div></div></fieldset><fieldset class=\"standard\"><legend>\n{{\'CONTRACT.PRODUCTS\'| translate}}</legend><div layout-wrap layout-gt-sm=\"row\" id=\"productData\"><div flex=\"100\" \nlayout=\"row\" layout-xs=\"column\" class=\"p-6 grey-50-bg\" style=\"padding-left: 8px; padding-top: 5px\"><div flex=\"30\"><span\n class=\"title grey-50-bg\"><strong>{{\"CONTRACT.PRODUCT\"| translate}}</strong></span></div><div flex=\"70\"><span>\n{{vm.contractPurchase.product.name}}</span></div></div><div flex=\"100\" layout=\"row\" layout-xs=\"column\" \nclass=\"p-6 grey-50-bg\" style=\"padding-left: 8px; padding-top: 5px\"><div flex=\"30\"><span class=\"title grey-50-bg\">\n<strong>{{\"CONTRACT.PAYMENTS\"| translate}}</strong></span></div><div flex=\"70\"><span>\n{{vm.contractPurchase.payments| number : 0}}</span></div></div><div flex=\"100\" layout=\"row\" layout-xs=\"column\" \nclass=\"p-6 grey-50-bg\" style=\"padding-left: 8px; padding-top: 5px\"><div flex=\"30\"><span class=\"title grey-50-bg\">\n<strong>{{\"CONTRACT.TOTAL\"| translate}}</strong></span></div><div flex=\"70\"><span>\n{{vm.contractPurchase.total| number : 2}}</span></div></div><div flex=\"100\" layout=\"row\" layout-xs=\"column\" \nclass=\"p-6 grey-50-bg\" style=\"padding-left: 8px; padding-top: 5px\"><div flex=\"30\"><span class=\"title grey-50-bg\">\n<strong>{{\"CONTRACT.MAXDATEPURCHASE\"| translate}}</strong></span></div><div flex=\"70\"><span>\n{{vm.contractPurchase.dateDelivery| date: \'dd-MM-yyyy\'}}</span></div></div></div></fieldset></md-content></div></div>\n<div class=\"center\" layout=\"column\" flex ng-show=\"vm.contractPurchase.purchaseStatus.orderColumn > 2\"><div \nclass=\"header\" layout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" \nflex><md-button class=\"goto-orders-button md-icon-button\" aria-label=\"Go to orders\" ng-click=\"vm.gotoContracts()\" \ntranslate translate-attr-aria-label=\"CONTRACT.GO_TO_ORDERS\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon>\n</md-button><div layout=\"column\" layout-align=\"start start\"><div class=\"h2\"><span translate=\"CONTRACT.CONTRACT\">Order\n</span> <span>{{vm.contractPurchase.id}}</span></div><div class=\"subtitle secondary-text\"></div></div></div></div>\n<md-tabs md-selected=\"vm.currentTab\" ng-if=\"vm.showProcessFlow\"><md-tab id=\"tab1\" aria-controls=\"tab1-content\">\n<md-tab-label><md-icon md-font-icon=\"icon-indent\"></md-icon><span translate=\"REQUISITION.ENCABEZADO\">Detalles</span>\n</md-tab-label></md-tab><md-tab id=\"tab2\" aria-controls=\"tab2-content\"><md-icon md-font-icon=\"icon-cube-unfolded\">\n</md-icon><span translate=\"REPORT.PROCESS_FLOW.FLOW\">Diagrama</span></md-tab></md-tabs><md-content class=\"content\" \nflex ms-scroll><md-tabs md-dynamic-height md-selected=\"vm.currentTab\" class=\"tab-in-content\"><md-tab \naria-controls=\"tab1-content\"><md-tab-body><div class=\"content-card\" layout=\"column\" flex><div \nng-class=\"vm.dinamicSize > 900 ? \'toolbar\' : \'customer-toolbar\'\"><div layout=\"row\"><div class=\"customer\" \nlayout=\"column\"><span><strong translate=\"CONTRACT.DEPARTMENT\"></strong> {{vm.contractPurchase.department.description}}\n</span></div><div class=\"customer\" layout=\"column\" style=\"margin-left: 50px\"><span><strong translate=\"CONTRACT.TYPE\">\n</strong> {{vm.contractPurchase.contractType.name}}</span> <span><strong translate=\"CONTRACT.PRODUCT\"></strong>\n {{vm.contractPurchase.product.name}}</span> <span><strong translate=\"CONTRACT.MAXDATEPURCHASE\"></strong>\n {{vm.contractPurchase.dateDelivery| date: \'dd-MM-yyyy\'}}</span></div><div class=\"customer\" layout=\"column\" \nstyle=\"margin-left: 50px\"><span><strong translate=\"CONTRACT.PAYMENTS\"></strong> {{vm.contractPurchase.payments}}</span>\n <span><strong translate=\"CONTRACT.TOTAL\"></strong>\n {{vm.contractPurchase.currency.symbol}}{{vm.contractPurchase.total| number:2}}</span></div><div class=\"customer line\" \nlayout=\"column\"><span class=\"title grey-50-bg\" ng-if=\"vm.dimensionCompanyDetail3\"><strong>\n{{vm.dimensionCompanyDetail3.description}}</strong> {{vm.contractPurchase.dimensionCompanyDetail3.name}} </span><span \nclass=\"title grey-50-bg\" ng-if=\"vm.dimensionCompanyDetail4\"><strong>{{vm.dimensionCompanyDetail4.description}}</strong>\n {{vm.contractPurchase.dimensionCompanyDetail4.name}} </span><span class=\"title grey-50-bg\" \nng-if=\"vm.dimensionCompanyDetail5\"><strong>{{vm.dimensionCompanyDetail5.description}}</strong>\n {{vm.contractPurchase.dimensionCompanyDetail5.name}}</span></div><span flex></span><md-button \nng-show=\"vm.statusToChange\" ng-disabled=\"$rootScope.loadingProgress\" class=\"md-raised md-primary\" \nng-click=\"vm.presentContract()\" aria-label=\"present budget\" translate \ntranslate-attr-aria-label=\"CONTRACT.ORDER_DETAILS\"><span>{{\'CONTRACT.STATUSCHANGE.\' + vm.statusToChange| translate}}\n</span></md-button></div></div><md-content class=\"content\" flex ms-scroll><div \nclass=\"order-detail-form-container products md-background-bg md-whiteframe-1dp\"><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" style=\"width: 100%\" dt-options=\"vm.dtOptions2\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"CONTRACT.NO\">NO</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"CONTRACT.DETAIL.QUANTITY\">Cantidad</span></div></th><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\" translate=\"CONTRACT.MAXDATEPURCHASE\">Date</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"CONTRACT.DETAIL.OBSERVATIONS\">Observaciones</span></div>\n</th></tr></thead><tbody><tr ng-repeat=\"detail in vm.details| orderBy:\'id\'\"><td>{{$index + 1}}</td><td>\n{{detail.quantity| number:0}}</td><td>{{detail.purchaseOrderDetail.purchaseOrder.dateDelivery| date : \'dd/MM/yyyy\'}}\n</td><td>\n{{\'INVOICE_MERCHANDISE_ENTRY.PAYMENTS\'| translate}} {{detail.noPayment}} - {{detail.invoiced==true?\'Facturado\':\'Pendiente de Facturar\'}}\n</td></tr></tbody></table></div></md-content></div></md-tab-body></md-tab><md-tab aria-controls=\"tab2-content\">\n<md-tab-body><div ng-include=\"\'app/main/apps/reports/process-flow/process-flow.html\'\"></div></md-tab-body></md-tab>\n</md-tabs></md-content></div></div>");
$templateCache.put("app/main/apps/contract/contract/contract_view.html","<div id=\"budgetO\" class=\"page-layout carded fullwidth\" layout=\"column\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" \nlayout=\"row\" layout-align=\"start center\" flex><md-button class=\"goto-orders-button md-icon-button\" \naria-label=\"Go to orders\" ng-click=\"vm.gotoContracts()\" translate translate-attr-aria-label=\"CONTRACT.GO_TO_ORDERS\">\n<md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"h2\"><span translate=\"CONTRACT.CONTRACT\">Order</span> <span>{{vm.contractPurchase.id}}</span></div><div \nclass=\"subtitle secondary-text\"></div></div></div></div><md-tabs md-selected=\"vm.currentTab\" \nng-if=\"vm.showProcessFlow\"><md-tab id=\"tab1\" aria-controls=\"tab1-content\"><md-tab-label><md-icon \nmd-font-icon=\"icon-indent\"></md-icon><span translate=\"REQUISITION.ENCABEZADO\">Detalles</span></md-tab-label></md-tab>\n<md-tab id=\"tab2\" aria-controls=\"tab2-content\"><md-icon md-font-icon=\"icon-cube-unfolded\"></md-icon><span \ntranslate=\"REPORT.PROCESS_FLOW.FLOW\">Diagrama</span></md-tab></md-tabs><md-content class=\"content\" flex ms-scroll>\n<md-tabs md-dynamic-height md-selected=\"vm.currentTab\" class=\"tab-in-content\"><md-tab aria-controls=\"tab1-content\">\n<md-tab-body><div class=\"content-card\" layout=\"column\" flex><div \nng-class=\"vm.dinamicSize > 900 ? \'toolbar\' : \'customer-toolbar\'\"><div layout=\"row\"><div class=\"customer\" \nlayout=\"column\"><span><strong translate=\"CONTRACT.COMPANY_PROVIDER\"></strong>\n {{vm.contractPurchase.companyProvider.name}}</span> <span><strong translate=\"CONTRACT.DEPARTMENT\"></strong>\n {{vm.contractPurchase.department.description}}</span> <span><strong translate=\"CONTRACT.COST_CENTER\"></strong>\n {{vm.contractPurchase.costCenter.description}}</span></div><div class=\"customer\" layout=\"column\" \nstyle=\"margin-left: 50px\"><span><strong translate=\"CONTRACT.TYPE\"></strong> {{vm.contractPurchase.contractType.name}}\n</span> <span><strong translate=\"CONTRACT.MAXDATEPURCHASE\"></strong>\n {{vm.contractPurchase.dateDelivery| date: \'dd-MM-yyyy\'}}</span> <span><strong translate=\"CONTRACT.PAYMENTS\"></strong>\n {{vm.contractPurchase.payments}}</span></div><div class=\"customer line\" layout=\"column\"><span \nclass=\"title grey-50-bg\" ng-if=\"vm.dimensionCompanyDetail3\"><strong>{{vm.dimensionCompanyDetail3.description}}</strong>\n {{vm.contractPurchase.dimensionCompanyDetail3.name}} </span><span class=\"title grey-50-bg\" \nng-if=\"vm.dimensionCompanyDetail4\"><strong>{{vm.dimensionCompanyDetail4.description}}</strong>\n {{vm.contractPurchase.dimensionCompanyDetail4.name}} </span><span class=\"title grey-50-bg\" \nng-if=\"vm.dimensionCompanyDetail5\"><strong>{{vm.dimensionCompanyDetail5.description}}</strong>\n {{vm.contractPurchase.dimensionCompanyDetail5.name}}</span></div><span flex></span><md-button \nng-show=\"vm.statusToChange\" ng-disabled=\"$rootScope.loadingProgress\" class=\"md-raised md-primary\" \nng-click=\"vm.presentContract()\" aria-label=\"present budget\" translate \ntranslate-attr-aria-label=\"CONTRACT.ORDER_DETAILS\"><span>{{\'CONTRACT.STATUSCHANGE.\' + vm.statusToChange| translate}}\n</span></md-button></div></div><md-content class=\"content\" flex ms-scroll><div \nclass=\"order-detail-form-container products md-background-bg md-whiteframe-1dp\"><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" style=\"width: 100%\" dt-options=\"vm.dtOptions2\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"CONTRACT.NO\">NO</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"CONTRACT.DETAIL.QUANTITY\">Cantidad</span></div></th><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\" translate=\"CONTRACT.MAXDATEPURCHASE\">Date</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"CONTRACT.DETAIL.OBSERVATIONS\">Observaciones</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"CONTRACT.ACTIONS\">\nActions</span></div></th></tr></thead><tbody><tr ng-repeat=\"detail in vm.details | orderBy:\'id\'\"><td>{{$index + 1}}\n</td><td>{{detail.quantityReceived| number:0}}</td><td>{{detail.purchaseOrder.dateDelivery| date : \'dd/MM/yyyy\'}}</td>\n<td>\n{{\'INVOICE_MERCHANDISE_ENTRY.PAYMENTS\'| translate}} {{detail.noPayment}} - {{detail.invoiced==true?\'Facturado\':\'Pendiente de Facturar\'}}\n</td><td><md-button class=\"edit-button md-icon-button\" ng-click=\"vm.viewDetail(detail)\" aria-label=\"Order details\" \ntranslate translate-attr-aria-label=\"CONTRACT.ORDER_DETAILS\"><md-tooltip md-direction=\"bottom\">\n{{\"CONTRACT.DETAIL.VIEW\"| translate}}</md-tooltip><md-icon md-font-icon=\"icon-eye\" class=\"s16\"></md-icon></md-button>\n</td></tr></tbody></table></div></md-content></div></md-tab-body></md-tab><md-tab aria-controls=\"tab2-content\">\n<md-tab-body><div ng-include=\"\'app/main/apps/reports/process-flow/process-flow.html\'\"></div></md-tab-body></md-tab>\n</md-tabs></md-content></div></div>");
$templateCache.put("app/main/apps/contract/contract-report/contract-Report.html","<div id=\"budgetO\" class=\"page-layout carded fullwidth\" layout=\"column\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" \nlayout=\"row\" layout-align=\"start center\" flex ng-hide=\"!vm.hiddenSearch\"><md-button \nclass=\"goto-orders-button md-icon-button\" aria-label=\"Go to orders\" ng-click=\"vm.gotoContracts()\" translate \ntranslate-attr-aria-label=\"CONTRACT.GO_TO_ORDERS\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button></div>\n<div class=\"search-wrapper md-whiteframe-4dp\" layout=\"row\" layout-align=\"start center\" flex ng-hide=\"vm.hiddenSearch\">\n<div class=\"search\" flex layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"icon s24\"></md-icon><input ng-enter=\"vm.searchContract(vm.search)\" flex ng-model=\"vm.search\" type=\"number\" \nplaceholder=\"Search for an e-mail or contact\" translate \ntranslate-attr-placeholder=\"CONTRACT.SEARCH_PLACEHOLDER_CONTRACT\"><md-button class=\"md-icon-button\" \nng-click=\"vm.searchContract(vm.search)\" aria-label=\"Back\" translate translate-attr-aria-label=\"MAIL.BACK\"><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon></md-button></div></div></div><div class=\"data\" layout=\"column\" flex \nng-show=\"vm.contractPurchase.id\"><md-tabs md-selected=\"vm.currentTab\" ng-if=\"vm.showProcessFlow\"><md-tab id=\"tab1\" \naria-controls=\"tab1-content\"><md-tab-label><md-icon md-font-icon=\"icon-indent\"></md-icon><span \ntranslate=\"REQUISITION.ENCABEZADO\">Detalles</span></md-tab-label></md-tab><md-tab id=\"tab2\" \naria-controls=\"tab2-content\"><md-tab-label><md-icon md-font-icon=\"icon-indent\"></md-icon><span \ntranslate=\"CONTRACT.NOPAYMENTS\">Cuotas</span></md-tab-label></md-tab><md-tab id=\"tab3\" aria-controls=\"tab3-content\">\n<md-icon md-font-icon=\"icon-cube-unfolded\"></md-icon><span translate=\"REPORT.PROCESS_FLOW.FLOW\">Diagrama</span>\n</md-tab><md-tab id=\"tab4\" aria-controls=\"tab4-content\" ng-if=\"vm.detailsPurchaseOrder.length > 0\"><md-icon \nmd-font-icon=\"icon-cart\"></md-icon><span translate=\"ORDER.ORDER\">PurchaseOrder</span></md-tab><md-tab id=\"tab5\" \naria-controls=\"tab5-content\" ng-if=\"vm.detailsInvoice.length > 0\"><md-icon md-font-icon=\"icon-receipt\"></md-icon><span \ntranslate=\"INVOICE.INVOICE\" ng-show=\"vm.detailsInvoice.length > 0\">Invoice</span></md-tab></md-tabs><md-content \nclass=\"content\" flex ms-scroll><md-tabs md-dynamic-height class=\"customer-tabs\" md-selected=\"vm.currentTab\" \nclass=\"tab-in-content\"><md-tab class=\"customer-tab\" aria-controls=\"tab1-content\" ng-show=\"vm.details.length > 0\">\n<md-tab-body class=\"customer-tab-body\"><div class=\"content-card\" layout=\"column\" flex><div \nng-class=\"vm.dinamicSize > 900 ? \'toolbar\' : \'customer-toolbar\'\"><div layout=\"row\"><div class=\"customer\" \nlayout=\"column\"><span><strong translate=\"CONTRACT.DEPARTMENT\"></strong> {{vm.contractPurchase.department.description}}\n</span> <span><strong translate=\"CONTRACT.COST_CENTER\"></strong> {{vm.contractPurchase.costCenter.description}}</span> \n<span><strong translate=\"CONTRACT.TYPE\"></strong> {{vm.contractPurchase.contractType.name}}</span></div><div \nclass=\"customer\" layout=\"column\" style=\"margin-left: 50px\"><span><strong translate=\"CONTRACT.PAYMENTS\"></strong>\n {{vm.contractPurchase.payments}}</span> <span><strong translate=\"CONTRACT.TOTAL\"></strong>\n {{vm.contractPurchase.currency.symbol}}{{vm.contractPurchase.total| number:2}}</span></div><div class=\"customer\" \nlayout=\"column\" style=\"margin-left: 50px\"><span><strong translate=\"CONTRACT.DATE_CREATED\"></strong>\n {{vm.contractPurchase.createdAt.dayOfMonth}} / {{vm.contractPurchase.createdAt.monthValue}} / {{vm.contractPurchase.createdAt.year}}\n</span> <span><strong translate=\"CONTRACT.BY_CREATED\"></strong> {{vm.contractPurchase.createdBy}}</span></div><div \nclass=\"customer line\" layout=\"column\"><span class=\"title grey-50-bg\" ng-if=\"vm.dimensionCompanyDetail3\"><strong>\n{{vm.dimensionCompanyDetail3.description}}</strong> {{vm.contractPurchase.dimensionCompanyDetail3.name}} </span><span \nclass=\"title grey-50-bg\" ng-if=\"vm.dimensionCompanyDetail4\"><strong>{{vm.dimensionCompanyDetail4.description}}</strong>\n {{vm.contractPurchase.dimensionCompanyDetail4.name}} </span><span class=\"title grey-50-bg\" \nng-if=\"vm.dimensionCompanyDetail5\"><strong>{{vm.dimensionCompanyDetail5.description}}</strong>\n {{vm.contractPurchase.dimensionCompanyDetail5.name}}</span></div></div></div><div class=\"content-card\" \nlayout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex><md-progress-linear \nmd-mode=\"indeterminate\" ng-if=\"vm.loading\" class=\"md-accent\"></md-progress-linear><div id=\"masterGridOptionsE\" \nag-grid=\"vm.masterGridOptionsE\" class=\"ag-fresh\" expand-grid min=\"260\" other=\"200\"></div></div></div></div>\n</md-tab-body></md-tab><md-tab aria-controls=\"tab2-content\" ng-show=\"vm.details.length > 0\"><md-tab-body><div \nclass=\"content-card\" layout=\"column\" flex><div \nclass=\"order-detail-form-container products md-background-bg md-whiteframe-1dp\"><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loading\" \nclass=\"md-accent\"></md-progress-linear><div id=\"masterGridOptionsPurchaseOrder\" ag-grid=\"vm.masterGridOptions\" \nclass=\"ag-fresh\" expand-grid min=\"260\" other=\"300\"></div></div></div></div></md-tab-body></md-tab><md-tab \naria-controls=\"tab3-content\" ng-show=\"vm.details.length > 0\"><md-tab-body><div \nng-include=\"\'app/main/apps/reports/process-flow/process-flow.html\'\"></div></md-tab-body></md-tab><md-tab \naria-controls=\"tab4-content\" ng-show=\"vm.detailsPurchaseOrder.length > 0\"><md-tab-body><md-tab-body><div \nclass=\"order-detail-form-container products md-background-bg md-whiteframe-1dp\"><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loading\" \nclass=\"md-accent\"></md-progress-linear><div id=\"masterGridOptionsPurchaseOrder2\" \nag-grid=\"vm.masterGridOptionsPurchaseOrder\" class=\"ag-fresh\" expand-grid min=\"260\" other=\"100\"></div></div></div>\n</md-tab-body></md-tab-body></md-tab><md-tab aria-controls=\"tab5-content\" ng-show=\"vm.detailsInvoice.length > 0\">\n<md-tab-body><div class=\"order-detail-form-container products md-background-bg md-whiteframe-1dp\"><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loading\" \nclass=\"md-accent\"></md-progress-linear><div id=\"masterGridOptionsInvoice\" ag-grid=\"vm.masterGridOptionsInvoice\" \nclass=\"ag-fresh\" expand-grid min=\"260\" other=\"100\"></div></div></div></md-tab-body></md-tab></md-tabs></md-content>\n</div></div></div>");
$templateCache.put("app/main/apps/configuration/messageStatus/messageStatus.html","<div id=\"productDelivery\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div\n class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-email\"></md-icon><span translate=\"MESSAGE_STATUS.MESSAGES\">message</span></div></div><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><md-input-container flexclass=\"search-input white-fg\">\n<label translate=\"MESSAGE_STATUS.TYPE\"></label><md-select style=\"background: white; color: black\" \nng-model=\"vm.statusType\" name=\"statusType\" required md-on-close=\"vm.clearSearchType()\" ng-change=\"vm.getData()\">\n<md-select-header><input id=\"searchType\" ng-model=\"vm.searchType\" type=\"search\" placeholder=\"Buscar Tipo\">\n</md-select-header><md-optgroup label=\"Departamentos\"><md-option value=\"{{data.value}}\" \nng-repeat=\"data in vm.statusTypes| filter:vm.searchType\">{{\"MESSAGE_STATUS.\"+data.type | translate}}</md-option>\n</md-optgroup></md-select></md-input-container></div></div><md-progress-linear md-mode=\"indeterminate\" \nng-show=\"vm.loading\"></md-progress-linear><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loading\" \nclass=\"md-accent\"></md-progress-linear><div id=\"masterGridOptions\" ag-grid=\"vm.masterGridOptions\" class=\"ag-fresh\" \nexpand-grid min=\"260\" other=\"60\"></div></div><div class=\"content fullpage-datatable\" layout=\"column\" flex><div \nclass=\"loading-threads\" layout=\"column\" layout-align=\"center center\" ng-if=\"vm.allBlockedSeries.length === 0\"></div>\n</div></div><md-button class=\"md-fab md-fab-bottom-right\" aria-label=\"add\" style=\"position: fixed\" \nng-click=\"vm.editData()\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"left\">\n{{\"general.add\"| translate}}</md-tooltip></md-button></div></div>");
$templateCache.put("app/main/apps/configuration/purchaseProductDelivery/purchaseProductDelivery.html","<div id=\"productDelivery\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div\n class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-cog-box\"></md-icon><span translate=\"PURCHASEPRODUCTDELIVERY.CONFIGUREPRODUCTDELIVERY\">\nConfigurar</span></div></div></div><md-progress-linear md-mode=\"indeterminate\" ng-show=\"vm.loading\">\n</md-progress-linear><div class=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" \nlayout=\"column\" flex><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loading\" class=\"md-accent\">\n</md-progress-linear><div id=\"masterGridOptions\" ag-grid=\"vm.masterGridOptions\" class=\"ag-fresh\" expand-grid min=\"260\" \nother=\"60\"></div></div><div class=\"content fullpage-datatable\" layout=\"column\" flex><div class=\"loading-threads\" \nlayout=\"column\" layout-align=\"center center\" ng-if=\"vm.allBlockedSeries.length === 0\"></div></div></div><md-button \nclass=\"md-fab md-fab-bottom-right\" aria-label=\"add\" style=\"position: fixed\" \nng-click=\"vm.createPurchaseProductDelivery()\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip \nmd-direction=\"left\">{{\"general.add\"| translate}}</md-tooltip></md-button></div></div>");
$templateCache.put("app/main/apps/configuration/rejectionReason/rejectionReason.html","<div id=\"providers\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-account-multiple\"></md-icon><span translate=\"REJECTIONREASON.REJECTIONREASON\">\nSeries Bloqueadas</span></div></div></div><md-progress-linear md-mode=\"indeterminate\" ng-show=\"vm.loading\">\n</md-progress-linear><div class=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" \nlayout=\"column\" flex><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loading\" class=\"md-accent\">\n</md-progress-linear><div id=\"masterGridOptions\" ag-grid=\"vm.masterGridOptions\" class=\"ag-fresh\" expand-grid min=\"260\" \nother=\"-10\"></div></div><div class=\"content fullpage-datatable\" layout=\"column\" flex><div class=\"loading-threads\" \nlayout=\"column\" layout-align=\"center center\" ng-if=\"vm.allBlockedSeries.length === 0\"></div></div></div><md-button \nclass=\"md-fab md-fab-bottom-right\" aria-label=\"add\" style=\"position: fixed\" ng-click=\"vm.createRejectionReason()\">\n<md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"left\">{{\"general.add\"| translate}}</md-tooltip>\n</md-button></div></div>");
$templateCache.put("app/main/apps/dashboards/project/dashboard-project.html","<div id=\"dashboard-project\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" flex ms-scroll>\n<div class=\"header md-accent-bg\" layout=\"column\" layout-align=\"space-between\"><div layout=\"row\" \nlayout-align=\"space-between\"><div><span class=\"md-display-1 font-weight-300\">Bienvenido, {{account.name}}!</span></div>\n<div class=\"toolbar\"></div></div></div><div class=\"content\"><md-grid-list md-cols=\"12\" md-cols-xs=\"1\" \nmd-row-height=\"16:9\" ng-cloak style=\"margin-top: 15px\"><md-grid-tile md-colspan-xs=\"1\" \nng-if=\"vm.requisitionsPendingInsert > 0\" md-rowspan-xs=\"1\" md-colspan=\"2\" md-rowspan=\"4\"><md-card \nstyle=\"width: 99%; height: 99%; padding: 15px; background: white\" class=\"custom-hover-card\" \nng-click=\"vm.viewGoto(\'app.requisition.Creando\', {status: \'Creando\'})\"><div layout=\"row\" layout-align=\"center center\">\n<span style=\"color: #9E9E9E; font-size: 20px\">Tiene</span></div><div layout=\"row\" layout-align=\"center center\"><span \nstyle=\"color: #03A9F4; font-size: 90px\">{{vm.requisitionsPendingInsert}}</span></div><div layout=\"row\" \nlayout-align=\"center center\"><span style=\"color: #9E9E9E; font-size: 20px; text-align: center\">\n{{\'REQUISITION.PENDING.Creando\'| translate}}!</span></div></md-card></md-grid-tile><md-grid-tile md-colspan-xs=\"1\" \nng-if=\"vm.requisitionsPendingAutorize > 0\" md-rowspan-xs=\"1\" md-colspan=\"2\" md-rowspan=\"4\"><md-card \nstyle=\"width: 99%; height: 99%; padding: 15px; background: white\" class=\"custom-hover-card\" \nng-click=\"vm.viewGoto(\'app.requisition.Ingresado\', {status: \'Ingresado\'})\"><div layout=\"row\" \nlayout-align=\"center center\"><span style=\"color: #9E9E9E; font-size: 20px\">Tiene</span></div><div layout=\"row\" \nlayout-align=\"center center\"><span style=\"color: #03A9F4; font-size: 90px\" \nng-show=\"!vm.loadingRequisitionsPendingAutorize\">{{vm.requisitionsPendingAutorize}}</span></div><div layout=\"row\" \nlayout-align=\"center center\"><span style=\"color: #9E9E9E; font-size: 20px; text-align: center\">\n{{\'REQUISITION.PENDING.Ingresado\'| translate}}!</span></div></md-card></md-grid-tile><md-grid-tile md-colspan-xs=\"1\" \nng-if=\"vm.requisitionsPendingCotize > 0\" md-rowspan-xs=\"1\" md-colspan=\"2\" md-rowspan=\"4\"><md-card \nstyle=\"width: 99%; height: 99%; padding: 15px; background: white\" class=\"custom-hover-card\" \nng-click=\"vm.viewGoto(\'app.requisition.Autorizado\', {status: \'Autorizado\'})\"><div layout=\"row\" \nlayout-align=\"center center\"><span style=\"color: #9E9E9E; font-size: 20px\">Tiene</span></div><div layout=\"row\" \nlayout-align=\"center center\"><span style=\"color: #03A9F4; font-size: 90px\" \nng-show=\"!vm.loadingRequisitionsPendingCotize\">{{vm.requisitionsPendingCotize}}</span></div><div layout=\"row\" \nlayout-align=\"center center\"><span style=\"color: #9E9E9E; font-size: 20px; text-align: center\">\n{{\'REQUISITION.PENDING.Autorizado\'| translate}}!</span></div></md-card></md-grid-tile><md-grid-tile md-colspan-xs=\"1\" \nng-if=\"vm.quotationsPendingAuthorize.length > 0\" md-rowspan-xs=\"1\" md-colspan=\"2\" md-rowspan=\"4\"><md-card \nstyle=\"width: 99%; height: 99%; padding: 15px; background: white\" class=\"custom-hover-card\" \nng-click=\"vm.viewGoto(\'app.quotation.Ingresada\', {status: \'Ingresada\', isClient: true})\"><div layout=\"row\" \nlayout-align=\"center center\"><span style=\"color: #9E9E9E; font-size: 20px\">Tiene</span></div><div layout=\"row\" \nlayout-align=\"center center\"><span style=\"color: #03A9F4; font-size: 90px\" \nng-show=\"!vm.loadingQuotationsPendingAuthorize\">{{vm.quotationsPendingAuthorize.length}}</span></div><div layout=\"row\" \nlayout-align=\"center center\"><span style=\"color: #9E9E9E; font-size: 20px; text-align: center\">\n{{\'QUOTATION.PENDING.Ingresada\'| translate}}!</span></div></md-card></md-grid-tile><md-grid-tile md-colspan-xs=\"1\" \nng-if=\"vm.quotationsReportPendingAuthorize.length > 0\" md-rowspan-xs=\"1\" md-colspan=\"2\" md-rowspan=\"4\"><md-card \nstyle=\"width: 99%; height: 99%; padding: 15px; background: white\" class=\"custom-hover-card\" \nng-click=\"vm.viewGoto(\'app.quotation.reportPendingAuthorize\', {status: \'Ingresada\', isClient: true})\"><div \nlayout=\"row\" layout-align=\"center center\"><span style=\"color: #9E9E9E; font-size: 20px\">Tiene</span></div><div \nlayout=\"row\" layout-align=\"center center\"><span style=\"color: #03A9F4; font-size: 90px\" \nng-show=\"!vm.loadingQuotationsReportPendingAuthorize\">{{vm.quotationsReportPendingAuthorize.length}}</span></div><div \nlayout=\"row\" layout-align=\"center center\"><span style=\"color: #9E9E9E; font-size: 20px; text-align: center\">\n{{\'QUOTATION.PENDING.Ingresada\'| translate}}!</span></div></md-card></md-grid-tile><md-grid-tile md-colspan-xs=\"1\" \nng-if=\"vm.quotationsPendingApproval.length > 0\" md-rowspan-xs=\"1\" md-colspan=\"2\" md-rowspan=\"4\"><md-card \nstyle=\"width: 99%; height: 99%; padding: 15px; background: white\" class=\"custom-hover-card\" \nng-click=\"vm.viewGoto(\'app.quotation.Autorizado\', {status: \'Autorizado\', isClient: false})\"><div layout=\"row\" \nlayout-align=\"center center\"><span style=\"color: #9E9E9E; font-size: 20px\">Tiene</span></div><div layout=\"row\" \nlayout-align=\"center center\"><span style=\"color: #03A9F4; font-size: 90px\" \nng-show=\"!vm.loadingQuotationsPendingApproval\">{{vm.quotationsPendingApproval.length}}</span></div><div layout=\"row\" \nlayout-align=\"center center\"><span style=\"color: #9E9E9E; font-size: 20px; text-align: center\">\n{{\'QUOTATION.PENDING.Autorizado\'| translate}}!</span></div></md-card></md-grid-tile><md-grid-tile md-colspan-xs=\"1\" \nng-if=\"vm.quotationsReportPendingApproval.length > 0\" md-rowspan-xs=\"1\" md-colspan=\"2\" md-rowspan=\"4\"><md-card \nstyle=\"width: 99%; height: 99%; padding: 15px; background: white\" class=\"custom-hover-card\" \nng-click=\"vm.viewGoto(\'app.quotation.reportPendingApprove\', {status: \'Autorizado\', isClient: false})\"><div \nlayout=\"row\" layout-align=\"center center\"><span style=\"color: #9E9E9E; font-size: 20px\">Tiene</span></div><div \nlayout=\"row\" layout-align=\"center center\"><span style=\"color: #03A9F4; font-size: 90px\" \nng-show=\"!vm.loadingQuotationsReportPendingApproval\">{{vm.quotationsReportPendingApproval.length}}</span></div><div \nlayout=\"row\" layout-align=\"center center\"><span style=\"color: #9E9E9E; font-size: 20px; text-align: center\">\n{{\'QUOTATION.PENDING.Autorizado\'| translate}}!</span></div></md-card></md-grid-tile><md-grid-tile md-colspan-xs=\"1\" \nng-if=\"vm.quotationsPendingFeatures.length > 0\" md-rowspan-xs=\"1\" md-colspan=\"2\" md-rowspan=\"4\"><md-card \nstyle=\"width: 99%; height: 99%; padding: 15px; background: white\" class=\"custom-hover-card\" \nng-click=\"vm.viewGoto(\'app.quotation.Aprobado_sin_caracteristicas\', {status: \'Aprobado sin caracteristicas\', isClient: false})\">\n<div layout=\"row\" layout-align=\"center center\"><span style=\"color: #9E9E9E; font-size: 20px\">Tiene</span></div><div \nlayout=\"row\" layout-align=\"center center\"><span style=\"color: #03A9F4; font-size: 90px\" \nng-show=\"!vm.loadingQuotationsPendingFeatures\">{{vm.quotationsPendingFeatures.length}}</span></div><div layout=\"row\" \nlayout-align=\"center center\"><span style=\"color: #9E9E9E; font-size: 20px; text-align: center\">\n{{\'QUOTATION.PENDING.Aprobadosincaracteristicas\'| translate}}!</span></div></md-card></md-grid-tile><md-grid-tile \nmd-colspan-xs=\"1\" ng-if=\"vm.ordersProvider.length > 0\" md-rowspan-xs=\"1\" md-colspan=\"2\" md-rowspan=\"4\"><md-card \nstyle=\"width: 99%; height: 99%; padding: 15px; background: white\" class=\"custom-hover-card\" \nng-click=\"vm.viewGoto(\'app.order.P\', {type: \'P\'})\"><div layout=\"row\" layout-align=\"center center\"><span \nstyle=\"color: #9E9E9E; font-size: 20px\">Tiene</span></div><div layout=\"row\" layout-align=\"center center\"><span \nstyle=\"color: #03A9F4; font-size: 90px\" ng-show=\"!vm.loadingOrdersProvider\">{{vm.ordersProvider.length}}</span></div>\n<div layout=\"row\" layout-align=\"center center\"><span style=\"color: #9E9E9E; font-size: 20px; text-align: center\">\n{{\'ORDER.PENDING.P\'| translate}}!</span></div></md-card></md-grid-tile><md-grid-tile md-colspan-xs=\"1\" \nng-if=\"vm.ordersClient.length > 0\" md-rowspan-xs=\"1\" md-colspan=\"2\" md-rowspan=\"4\"><md-card \nstyle=\"width: 99%; height: 99%; padding: 15px; background: white\" class=\"custom-hover-card\" \nng-click=\"vm.viewGoto(\'app.order.C\', {type: \'C\'})\"><div layout=\"row\" layout-align=\"center center\"><span \nstyle=\"color: #9E9E9E; font-size: 20px\">Tiene</span></div><div layout=\"row\" layout-align=\"center center\"><span \nstyle=\"color: #03A9F4; font-size: 90px\" ng-show=\"!vm.loadingOrdersClient\">{{vm.ordersClient.length}}</span></div><div \nlayout=\"row\" layout-align=\"center center\"><span style=\"color: #9E9E9E; font-size: 20px; text-align: center\">\n{{\'ORDER.PENDING.C\'| translate}}!</span></div></md-card></md-grid-tile><md-grid-tile md-colspan-xs=\"1\" \nng-if=\"vm.ordersFirsRecept.length > 0\" md-rowspan-xs=\"1\" md-colspan=\"2\" md-rowspan=\"4\"><md-card \nstyle=\"width: 99%; height: 99%; padding: 15px; background: white\" class=\"custom-hover-card\" \nng-click=\"vm.viewGoto(\'app.order.PR\', {type: \'PR\'})\"><div layout=\"row\" layout-align=\"center center\"><span \nstyle=\"color: #9E9E9E; font-size: 20px\">Tiene</span></div><div layout=\"row\" layout-align=\"center center\"><span \nstyle=\"color: #03A9F4; font-size: 90px\" ng-show=\"!vm.loadingOrdersFirsRecept\">{{vm.ordersFirsRecept.length}}</span>\n</div><div layout=\"row\" layout-align=\"center center\"><span style=\"color: #9E9E9E; font-size: 20px; text-align: center\">\n{{\'ORDER.PENDING.PR\'| translate}}!</span></div></md-card></md-grid-tile><md-grid-tile md-colspan-xs=\"1\" \nng-if=\"vm.ordersReportClient.length > 0\" md-rowspan-xs=\"1\" md-colspan=\"2\" md-rowspan=\"4\"><md-card \nstyle=\"width: 99%; height: 99%; padding: 15px; background: white\" class=\"custom-hover-card\" \nng-click=\"vm.viewGoto(\'app.order.reportPendingDelivery\', {type: \'C\'})\"><div layout=\"row\" layout-align=\"center center\">\n<span style=\"color: #9E9E9E; font-size: 20px\">Tiene</span></div><div layout=\"row\" layout-align=\"center center\"><span \nstyle=\"color: #03A9F4; font-size: 90px\" ng-show=\"!vm.loadingOrdersReportClient\">{{vm.ordersReportClient.length}}</span>\n</div><div layout=\"row\" layout-align=\"center center\"><span style=\"color: #9E9E9E; font-size: 20px; text-align: center\">\n{{\'ORDER.PENDING.C\'| translate}}!</span></div></md-card></md-grid-tile><md-grid-tile md-colspan-xs=\"1\" \nng-if=\"vm.merchandiseEntries > 0\" md-rowspan-xs=\"1\" md-colspan=\"2\" md-rowspan=\"4\"><md-card \nstyle=\"width: 99%; height: 99%; padding: 15px; background: white\" class=\"custom-hover-card\" \nng-click=\"vm.viewGoto(\'app.merchandiseEntry.invoiceMerchandiseEntry\', {})\"><div layout=\"row\" \nlayout-align=\"center center\"><span style=\"color: #9E9E9E; font-size: 20px\">Tiene</span></div><div layout=\"row\" \nlayout-align=\"center center\"><span style=\"color: #03A9F4; font-size: 90px\" ng-show=\"!vm.loadingMerchandiseEntries\">\n{{vm.merchandiseEntries}}</span></div><div layout=\"row\" layout-align=\"center center\"><span \nstyle=\"color: #9E9E9E; font-size: 20px; text-align: center\">\n{{\'INVOICE_MERCHANDISE_ENTRY.MERCHANDISE_ENTRIES\'| translate}}!</span></div></md-card></md-grid-tile><md-grid-tile \nmd-colspan-xs=\"1\" ng-if=\"vm.invoicesPendingEmit.length > 0\" md-rowspan-xs=\"1\" md-colspan=\"2\" md-rowspan=\"4\"><md-card \nstyle=\"width: 99%; height: 99%; padding: 15px; background: white\" class=\"custom-hover-card\" \nng-click=\"vm.viewGoto(\'app.invoice.Ingresando\', {status: \'Ingresando\'})\"><div layout=\"row\" \nlayout-align=\"center center\"><span style=\"color: #9E9E9E; font-size: 20px\">Tiene</span></div><div layout=\"row\" \nlayout-align=\"center center\"><span style=\"color: #03A9F4; font-size: 90px\" ng-show=\"!vm.loadingInvoicesPendingEmit\">\n{{vm.invoicesPendingEmit.length}}</span></div><div layout=\"row\" layout-align=\"center center\"><span \nstyle=\"color: #9E9E9E; font-size: 20px; text-align: center\">{{\'INVOICE.PENDING_EMIT\'| translate}}!</span></div>\n</md-card></md-grid-tile><md-grid-tile md-colspan-xs=\"1\" ng-if=\"vm.invoicesPendingEdit.length > 0\" md-rowspan-xs=\"1\" \nmd-colspan=\"2\" md-rowspan=\"4\"><md-card style=\"width: 99%; height: 99%; padding: 15px; background: white\" \nclass=\"custom-hover-card\" ng-click=\"vm.viewGoto(\'app.invoice.Editando\', {status: \'Editando\'})\"><div layout=\"row\" \nlayout-align=\"center center\"><span style=\"color: #9E9E9E; font-size: 20px\">Tiene</span></div><div layout=\"row\" \nlayout-align=\"center center\"><span style=\"color: #03A9F4; font-size: 90px\" ng-show=\"!vm.loadingInvoicesPendingEdit\">\n{{vm.invoicesPendingEdit.length}}</span></div><div layout=\"row\" layout-align=\"center center\"><span \nstyle=\"color: #9E9E9E; font-size: 20px; text-align: center\">{{\'INVOICE.PENDING_EDIT\'| translate}}!</span></div>\n</md-card></md-grid-tile><md-grid-tile md-colspan-xs=\"1\" ng-if=\"vm.invoicesPendingPreCheck.length > 0\" \nmd-rowspan-xs=\"1\" md-colspan=\"2\" md-rowspan=\"4\"><md-card \nstyle=\"width: 99%; height: 99%; padding: 15px; background: white\" class=\"custom-hover-card\" \nng-click=\"vm.viewGoto(\'app.invoice.Emitida\', {status: \'Emitida\'})\"><div layout=\"row\" layout-align=\"center center\"><span\n style=\"color: #9E9E9E; font-size: 20px\">Tiene</span></div><div layout=\"row\" layout-align=\"center center\"><span \nstyle=\"color: #03A9F4; font-size: 90px\" ng-show=\"!vm.loadingInvoicesPendingPreCheck\">\n{{vm.invoicesPendingPreCheck.length}}</span></div><div layout=\"row\" layout-align=\"center center\"><span \nstyle=\"color: #9E9E9E; font-size: 20px; text-align: center\">{{\'INVOICE.PENDING_PRECHECK\'| translate}}!</span></div>\n</md-card></md-grid-tile><md-grid-tile md-colspan-xs=\"1\" ng-if=\"vm.invoicesPendingCheck.length > 0\" md-rowspan-xs=\"1\" \nmd-colspan=\"2\" md-rowspan=\"4\"><md-card style=\"width: 99%; height: 99%; padding: 15px; background: white\" \nclass=\"custom-hover-card\" ng-click=\"vm.viewGoto(\'app.invoice.PreVerificada\', {status: \'Pre-Verificada\'})\"><div \nlayout=\"row\" layout-align=\"center center\"><span style=\"color: #9E9E9E; font-size: 20px\">Tiene</span></div><div \nlayout=\"row\" layout-align=\"center center\"><span style=\"color: #03A9F4; font-size: 90px\" \nng-show=\"!vm.loadingInvoicesPendingCheck\">{{vm.invoicesPendingCheck.length}}</span></div><div layout=\"row\" \nlayout-align=\"center center\"><span style=\"color: #9E9E9E; font-size: 20px; text-align: center\">\n{{\'INVOICE.PENDING_CHECK\'| translate}}!</span></div></md-card></md-grid-tile><md-grid-tile md-colspan-xs=\"1\" \nng-if=\"vm.contractsPendingInsert > 0\" md-rowspan-xs=\"1\" md-colspan=\"2\" md-rowspan=\"4\"><md-card \nstyle=\"width: 99%; height: 99%; padding: 15px; background: white\" class=\"custom-hover-card\" \nng-click=\"vm.viewGoto(\'app.contract.Creando\', {status: \'Creando\'})\"><div layout=\"row\" layout-align=\"center center\">\n<span style=\"color: #9E9E9E; font-size: 20px\">Tiene</span></div><div layout=\"row\" layout-align=\"center center\"><span \nstyle=\"color: #03A9F4; font-size: 90px\" ng-show=\"!vm.loadingContractsPendingInsert\">{{vm.contractsPendingInsert}}\n</span></div><div layout=\"row\" layout-align=\"center center\"><span \nstyle=\"color: #9E9E9E; font-size: 20px; text-align: center\">{{\'CONTRACT.PENDING.Creando\'| translate}}!</span></div>\n</md-card></md-grid-tile><md-grid-tile md-colspan-xs=\"1\" ng-if=\"vm.contractsPendingAutorize > 0\" md-rowspan-xs=\"1\" \nmd-colspan=\"2\" md-rowspan=\"4\"><md-card style=\"width: 99%; height: 99%; padding: 15px; background: white\" \nclass=\"custom-hover-card\" ng-click=\"vm.viewGoto(\'app.contract.Ingresado\', {status: \'Ingresado\'})\"><div layout=\"row\" \nlayout-align=\"center center\"><span style=\"color: #9E9E9E; font-size: 20px\">Tiene</span></div><div layout=\"row\" \nlayout-align=\"center center\"><span style=\"color: #03A9F4; font-size: 90px\" \nng-show=\"!vm.loadingContractsPendingAutorize\">{{vm.contractsPendingAutorize}}</span></div><div layout=\"row\" \nlayout-align=\"center center\"><span style=\"color: #9E9E9E; font-size: 20px; text-align: center\">\n{{\'CONTRACT.PENDING.Ingresado\'| translate}}!</span></div></md-card></md-grid-tile><md-grid-tile md-colspan-xs=\"1\" \nng-if=\"vm.contractsPendingCancel > 0\" md-rowspan-xs=\"1\" md-colspan=\"2\" md-rowspan=\"4\"><md-card \nstyle=\"width: 99%; height: 99%; padding: 15px; background: white\" class=\"custom-hover-card\" \nng-click=\"vm.viewGoto(\'app.contract.Autorizado\', {status: \'Autorizado\'})\"><div layout=\"row\" \nlayout-align=\"center center\"><span style=\"color: #9E9E9E; font-size: 20px\">Tiene</span></div><div layout=\"row\" \nlayout-align=\"center center\"><span style=\"color: #03A9F4; font-size: 90px\" ng-show=\"!vm.loadingContractsPendingCancel\">\n{{vm.contractsPendingCancel}}</span></div><div layout=\"row\" layout-align=\"center center\"><span \nstyle=\"color: #9E9E9E; font-size: 20px; text-align: center\">{{\'CONTRACT.PENDING.Autorizado\'| translate}}!</span></div>\n</md-card></md-grid-tile><md-grid-tile md-colspan-xs=\"1\" ng-if=\"vm.settlementsPendingAuthorization.length > 0\" \nmd-rowspan-xs=\"1\" md-colspan=\"2\" md-rowspan=\"4\"><md-card \nstyle=\"width: 99%; height: 99%; padding: 15px; background: white\" class=\"custom-hover-card\" \nng-click=\"vm.viewGoto(\'app.expenseSettlement.settlement.pendingAuthorize\', {status: \'Pendiente de Autorizar\'})\"><div \nlayout=\"row\" layout-align=\"center center\"><span style=\"color: #9E9E9E; font-size: 20px\">\n{{\'EXPENSE_SETTLEMENTS.DASHBOARD.HAVE\' | translate}}</span></div><div layout=\"row\" layout-align=\"center center\"><span \nstyle=\"color: #03A9F4; font-size: 90px\" ng-show=\"!vm.loadingSettlementPendingAuthorization\">\n{{vm.settlementsPendingAuthorization.length}}</span></div><div layout=\"row\" layout-align=\"center center\"><span \nstyle=\"color: #9E9E9E; font-size: 20px; text-align: center\">\n{{vm.settlementsPendingAuthorization.length === 1 ? \'EXPENSE_SETTLEMENTS.DASHBOARD.SETTLEMENT_PENDING_AUTHORIZATION\' : \'EXPENSE_SETTLEMENTS.DASHBOARD.SETTLEMENTS_PENDING_AUTHORIZATION\'| translate}}!\n</span></div></md-card></md-grid-tile><md-grid-tile md-colspan-xs=\"1\" \nng-if=\"vm.settlementPendingVerification.length > 0\" md-rowspan-xs=\"1\" md-colspan=\"2\" md-rowspan=\"4\"><md-card \nstyle=\"width: 99%; height: 99%; padding: 15px; background: white\" class=\"custom-hover-card\" \nng-click=\"vm.viewGoto(\'app.expenseSettlement.verificationSettlements\')\"><div layout=\"row\" layout-align=\"center center\">\n<span style=\"color: #9E9E9E; font-size: 20px\">{{\'EXPENSE_SETTLEMENTS.DASHBOARD.HAVE\' | translate}}</span></div><div \nlayout=\"row\" layout-align=\"center center\"><span style=\"color: #03A9F4; font-size: 90px\" \nng-show=\"!vm.loadingSettlementPendingVerification\">{{vm.settlementPendingVerification.length}}</span></div><div \nlayout=\"row\" layout-align=\"center center\"><span style=\"color: #9E9E9E; font-size: 20px; text-align: center\">\n{{vm.settlementPendingVerification.length === 1 ? \'EXPENSE_SETTLEMENTS.DASHBOARD.SETTLEMENT_PENDING_VERIFICATION\' : \'EXPENSE_SETTLEMENTS.DASHBOARD.SETTLEMENTS_PENDING_VERIFICATION\'| translate}}!\n</span></div></md-card></md-grid-tile><md-grid-tile md-colspan-xs=\"1\" \nng-if=\"vm.settlementPendingProvisioning.length > 0\" md-rowspan-xs=\"1\" md-colspan=\"2\" md-rowspan=\"4\"><md-card \nstyle=\"width: 99%; height: 99%; padding: 15px; background: white\" class=\"custom-hover-card\" \nng-click=\"vm.viewGoto(\'app.expenseSettlement.settlement.preProvisioned\', {status: \'Pre-Provisionada\'})\"><div \nlayout=\"row\" layout-align=\"center center\"><span style=\"color: #9E9E9E; font-size: 20px\">\n{{\'EXPENSE_SETTLEMENTS.DASHBOARD.HAVE\' | translate}}</span></div><div layout=\"row\" layout-align=\"center center\"><span \nstyle=\"color: #03A9F4; font-size: 90px\" ng-show=\"!vm.loadingSettlementPendingProsivioning\">\n{{vm.settlementPendingProvisioning.length}}</span></div><div layout=\"row\" layout-align=\"center center\"><span \nstyle=\"color: #9E9E9E; font-size: 20px; text-align: center\">\n{{vm.settlementPendingProvisioning.length === 1 ? \'EXPENSE_SETTLEMENTS.DASHBOARD.SETTLEMENT_PENDING_PROVISION\' : \'EXPENSE_SETTLEMENTS.DASHBOARD.SETTLEMENTS_PENDING_PROVISION\'| translate}}!\n</span></div></md-card></md-grid-tile><md-grid-tile md-colspan-xs=\"1\" ng-if=\"vm.detailsNotValidated.length > 0\" \nmd-rowspan-xs=\"1\" md-colspan=\"2\" md-rowspan=\"4\"><md-card \nstyle=\"width: 99%; height: 99%; padding: 15px; background: white\" class=\"custom-hover-card\" \nng-click=\"vm.viewGoto(\'app.expenseSettlement.settlement.details\')\"><div layout=\"row\" layout-align=\"center center\"><span\n style=\"color: #9E9E9E; font-size: 20px\">{{\'EXPENSE_SETTLEMENTS.DASHBOARD.HAVE\' | translate}}</span></div><div \nlayout=\"row\" layout-align=\"center center\"><span style=\"color: #03A9F4; font-size: 90px\" \nng-show=\"!vm.loadingDetailsNotValidated\">{{vm.detailsNotValidated.length}}</span></div><div layout=\"row\" \nlayout-align=\"center center\"><span style=\"color: #9E9E9E; font-size: 20px; text-align: center\">\n{{vm.detailsNotValidated.length === 1 ? \'EXPENSE_SETTLEMENTS.DASHBOARD.DETAIL_NOT_VALIDATED\' : \'EXPENSE_SETTLEMENTS.DASHBOARD.DETAILS_NOT_VALIDATED\'| translate}}!\n</span></div></md-card></md-grid-tile><md-grid-tile md-colspan-xs=\"1\" ng-if=\"vm.detailsExtraAuthorization.length > 0\" \nmd-rowspan-xs=\"1\" md-colspan=\"2\" md-rowspan=\"4\"><md-card \nstyle=\"width: 99%; height: 99%; padding: 15px; background: white\" class=\"custom-hover-card\" \nng-click=\"vm.viewGoto(\'app.expenseSettlement.settlement.details\')\"><div layout=\"row\" layout-align=\"center center\"><span\n style=\"color: #9E9E9E; font-size: 20px\">Tiene</span></div><div layout=\"row\" layout-align=\"center center\"><span \nstyle=\"color: #03A9F4; font-size: 90px\" ng-show=\"!vm.loadingDetailsExtraAuthorization\">\n{{vm.detailsExtraAuthorization.length}}</span></div><div layout=\"row\" layout-align=\"center center\"><span \nstyle=\"color: #9E9E9E; font-size: 20px; text-align: center\">\n{{vm.detailsExtraAuthorization.length === 1 ? \'EXPENSE_SETTLEMENTS.DASHBOARD.DETAIL_PENDING_AUTHORIZATION\' : \'EXPENSE_SETTLEMENTS.DASHBOARD.DETAILS_PENDING_AUTHORIZATION\'| translate}}!\n</span></div></md-card></md-grid-tile><md-grid-tile md-colspan-xs=\"1\" ng-if=\"vm.settlementPendingPayment.length > 0\" \nmd-rowspan-xs=\"1\" md-colspan=\"2\" md-rowspan=\"4\"><md-card \nstyle=\"width: 99%; height: 99%; padding: 15px; background: white\" class=\"custom-hover-card\" \nng-click=\"vm.viewGoto(\'app.expenseSettlement.paymentSettlements\')\"><div layout=\"row\" layout-align=\"center center\"><span\n style=\"color: #9E9E9E; font-size: 20px\">{{\'EXPENSE_SETTLEMENTS.DASHBOARD.HAVE\' | translate}}</span></div><div \nlayout=\"row\" layout-align=\"center center\"><span style=\"color: #03A9F4; font-size: 90px\" \nng-show=\"!vm.loadingSettlementPendingPayment\">{{vm.settlementPendingPayment.length}}</span></div><div layout=\"row\" \nlayout-align=\"center center\"><span style=\"color: #9E9E9E; font-size: 20px; text-align: center\">\n{{vm.settlementPendingPayment.length === 1 ? \'EXPENSE_SETTLEMENTS.DASHBOARD.SETTLEMENT_PENDING_PAYMENT\' : \'EXPENSE_SETTLEMENTS.DASHBOARD.SETTLEMENTS_PENDING_PAYMENT\'| translate}}!\n</span></div></md-card></md-grid-tile><md-grid-tile md-colspan-xs=\"1\" ng-if=\"vm.pettiesWithAmountToReturn.length > 0\" \nmd-rowspan-xs=\"1\" md-colspan=\"2\" md-rowspan=\"4\"><md-card \nstyle=\"width: 99%; height: 99%; padding: 15px; background: white\" class=\"custom-hover-card\" \nng-click=\"vm.viewGoto(\'app.expenseSettlement.pettyCash.withAmountToReturn\')\"><div layout=\"row\" \nlayout-align=\"center center\"><span style=\"color: #9E9E9E; font-size: 20px\">Tiene</span></div><div layout=\"row\" \nlayout-align=\"center center\"><span style=\"color: #03A9F4; font-size: 90px\" \nng-show=\"!vm.loadingPettiesWithAmountToReturn\">{{vm.pettiesWithAmountToReturn.length}}</span></div><div layout=\"row\" \nlayout-align=\"center center\"><span style=\"color: #9E9E9E; font-size: 20px; text-align: center\">\n{{vm.pettiesWithAmountToReturn.length === 1 ? \'EXPENSE_SETTLEMENTS.DASHBOARD.SETTLEMENT_RETURNING_PENDING\' : \'EXPENSE_SETTLEMENTS.DASHBOARD.SETTLEMENTS_RETURNING_PENDING\'| translate}}!\n</span></div></md-card></md-grid-tile></md-grid-list></div></div></div>");
$templateCache.put("app/main/apps/documentVerify/invoice-files/invoice-file-loader.html","<iframe title=\"obj\" ng-if=\"fl.fileData.fileOtherFormat\" width=\"100%\" height=\"100%\" name=\"plugin\" id=\"plugin\" \nsrc=\"{{fl.fileData.fileUrl}}\"></iframe><div layout=\"row\" ng-if=\"!fl.fileData.fileOtherFormat\" style=\"height: 100%\" \nms-scroll><div layout=\"column\" layout-align=\"start start\" layout-wrap flex=\"5\" flex-gt-md=\"10\" flex-gt-xs=\"20\" \nclass=\"three\"><div class=\"product-image three\" layout-align=\"center center\" ng-repeat=\"image in fl.fileData.images\" \nng-switch=\"image.type\"><img alt=\"img\" class=\"media\" ng-class=\"image.default ? \'predeterminate\' : \'\'\" \nng-src=\"{{image.url + image.extension}}\" ng-fallback=\"assets/images/etc/thumbPhoto.jpg\" \nng-click=\"fl.onUpdateZoom({ image: image, fileData: fl.fileData })\"><md-divider></md-divider></div></div><div \nstyle=\"max-height: 100px; height: 100px\"><div layout=\"column\" min=\"260\" other=\"30\" id=\"divDynamicHeigthFisic\" \nlayout-align=\"start center\" flex class=\"one\"><div class=\"image-zoom-area four\" \nng-class=\"\'rotate-\' + fl.fileData.valRotate + \'-class\'\"><md-button style=\"position: fixed; z-index: 50\" \nclass=\"md-icon-button\" \nng-click=\"fl.fileData.valRotate = fl.fileData.valRotate === 270 ? 0 : fl.fileData.valRotate + 90\"><md-icon \nmd-font-icon=\"icon-rotate-right-variant\"></md-icon></md-button><img alt=\"img\" class=\"two\" \nwip-image-zoom=\"fl.fileData.imageZoomOptions\" ng-fallback=\"assets/images/etc/thumbPhoto.jpg\"></div></div></div></div>");
$templateCache.put("app/main/apps/documentVerify/invoice-files/invoice-files.html","<div class=\"invoice-files\" layout=\"column\" flex><div layout=\"row\" layout-align=\"start center\"><md-button \nng-click=\"vm.currentFileTab = 0\" ng-class=\"{\'md-raised\': vm.currentFileTab === 0}\">\n{{\'INVOICE.TAB_FILES.INVOICE\'|translate}}</md-button><md-button ng-click=\"vm.currentFileTab = 1\" \nng-class=\"{\'md-raised\': vm.currentFileTab === 1}\">{{\'INVOICE.TAB_FILES.QUOTATION\'|translate}}</md-button><md-button \nclass=\"md-raised md-primary\" ng-click=\"vm.compareDocuments()\">{{\'INVOICE.TAB_FILES.COMPARE\'|translate}}</md-button>\n</div><md-tabs class=\"file-tabs\" md-dynamic-height md-no-barv md-selected=\"vm.currentFileTab\" layout=\"column\" flex>\n<md-tab><md-tab-body><invoice-file-loader file-data=\"vm.filesData.invoice\" \non-update-zoom=\"vm.updateImageZoomOptions(image, fileData)\" class=\"full-height\"></invoice-file-loader></md-tab-body>\n</md-tab><md-tab><md-tab-body><invoice-file-loader file-data=\"vm.filesData.quotation\" \non-update-zoom=\"vm.updateImageZoomOptions(image, fileData)\" class=\"full-height\"></invoice-file-loader></md-tab-body>\n</md-tab></md-tabs></div>");
$templateCache.put("app/main/apps/documentVerify/invoice-files-comparator/invoice-files-comparator.html","<md-dialog class=\"invoice-files-comparator\" aria-label=\"invoiceFilesCompare\"><div layout=\"row\" \nlayout-align=\"end center\"><md-button aria-label=\"button close\" class=\"md-icon-button\" ng-click=\"vm.closeDialog()\">\n<md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><md-dialog-content layout=\"row\" \nclass=\"full-height\"><div flex=\"50\" class=\"file-container\" layout=\"column\"><div class=\"file-title\" layout=\"row\" \nlayout-align=\"center center\">{{ vm.fileDataLeft.titleKey | translate }}</div><invoice-file-loader \nfile-data=\"vm.fileDataLeft\" on-update-zoom=\"vm.updateImageZoomOptions(image, fileData)\" class=\"full-height\">\n</invoice-file-loader></div><div flex=\"50\" class=\"file-container\" layout=\"column\"><div class=\"file-title\" layout=\"row\" \nlayout-align=\"center center\">{{ vm.fileDataRight.titleKey | translate }}</div><invoice-file-loader \nfile-data=\"vm.fileDataRight\" on-update-zoom=\"vm.updateImageZoomOptions(image, fileData)\" class=\"full-height\">\n</invoice-file-loader></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/apps/documentVerify/purchase/invoiceActions.html","<md-button \nng-show=\"(vm.currentDoc.docObj.purchaseStatus.description === \'Emitida\' || vm.currentDoc.docObj.purchaseStatus.description === \'Pendiente Recibir Original\' || vm.currentDoc.docObj.purchaseStatus.description === \'Pendiente Provisionar\')\" \nng-disabled=\"!vm.showButton\" class=\"md-raised md-primary\" ng-click=\"vms.changeStatusInvoice()\" \naria-label=\"change Staus\" translate translate-attr-aria-label=\"INVOICE.CHANGE_STATUS\"><span>\n{{\'INVOICE.STATUS_CHANGE.\' + vm.currentDoc.docObj.purchaseStatus.description| translate}}</span><md-tooltip \nmd-direction=\"top\" md-visible=\"tooltipVisible\">\n{{\'INVOICE.STATUS_CHANGE.\' + vm.currentDoc.docObj.purchaseStatus.description| translate}}</md-tooltip></md-button>\n<md-button \nng-show=\"(vm.currentDoc.docObj.purchaseStatus.description === \'Emitida\' || vm.currentDoc.docObj.purchaseStatus.description === \'Pendiente Provisionar\')\" \nclass=\"md-raised md-primary\" ng-click=\"vms.changeOtherStatusInvoice(\'Editando\')\" aria-label=\"change Staus\" translate \ntranslate-attr-aria-label=\"INVOICE.CHANGE_STATUS\"><span>{{\'INVOICE.STATUS_CHANGE.Editando\'| translate}}</span>\n<md-tooltip md-direction=\"top\" md-visible=\"tooltipVisible\">{{\'INVOICE.STATUS_CHANGE.Editando\'| translate}}</md-tooltip>\n</md-button><md-button ng-show=\"(vm.currentDoc.docObj.purchaseStatus.description === \'Emitida\')\" \nclass=\"md-raised md-primary\" ng-click=\"vms.changeStatusEmit()\" aria-label=\"change Staus\" translate \ntranslate-attr-aria-label=\"INVOICE.CHANGE_STATUS\"><span>{{\'INVOICE.STATUS_CHANGE.Creando\'| translate}}</span>\n<md-tooltip md-direction=\"top\" md-visible=\"tooltipVisible\">{{\'INVOICE.STATUS_CHANGE.Creando\'| translate}}</md-tooltip>\n</md-button><md-button \nng-show=\"(\n    vm.currentDoc.docObj.purchaseStatus.description === \'Emitida\'\n    || vm.currentDoc.docObj.purchaseStatus.description === \'Pendiente Recibir Original\'\n    || vm.currentDoc.docObj.purchaseStatus.description === \'Pendiente Provisionar\'\n    ) && !vm.currentDoc.docObj.loadedPOS\" \nclass=\"md-raised md-warn\" ng-click=\"vms.changeOtherStatusInvoice(\'Rechazada\')\" aria-label=\"change Staus\" translate \ntranslate-attr-aria-label=\"INVOICE.CHANGE_STATUS\"><span>{{\'INVOICE.STATUS_CHANGE.Rechazada\'| translate}}</span>\n<md-tooltip md-direction=\"top\" md-visible=\"tooltipVisible\">{{\'INVOICE.STATUS_CHANGE.Rechazada\'| translate}}\n</md-tooltip></md-button><div layout=\"row\"><md-button class=\"md-raised md-primary\" ng-click=\"vms.viewOrdenPago()\" \naria-label=\"order\" translate translate-attr-aria-label=\"Add\"><md-icon md-font-icon=\"icon-eye\"></md-icon><span \ntranslate=\"INVOICE.ORDEN_PAGO\">Orden de Entrega</span><md-tooltip md-direction=\"top\" md-visible=\"tooltipVisible\">\n{{\'INVOICE.ORDEN_PAGO\'| translate}}</md-tooltip></md-button><span flex></span><md-button \nng-if=\"vm.withHoldingManually.length > 0 && vm.canEdit\" class=\"md-raised md-primary\" ng-click=\"vms.addWithholding()\" \naria-label=\"addWithholding\" translate translate-attr-aria-label=\"Add\"><md-icon md-font-icon=\"icon-plus\"></md-icon><span\n translate=\"INVOICE.INVOICE_PURCHASE.WITHHOLDING\">Retención</span><md-tooltip md-direction=\"top\" \nmd-visible=\"tooltipVisible\">{{\'INVOICE.INVOICE_PURCHASE.WITHHOLDING\'| translate}}</md-tooltip></md-button></div>");
$templateCache.put("app/main/apps/documentVerify/settlement/invoiceActions.html","<md-button \nng-show=\"vm.mainDoc.typeCode === \'SETTLEMENT\' && vm.currentDoc.docType === \'invoice\' && vm.currentDoc.docObj.companyProvider.privated === true && vm.currentDoc.docObj.purchaseStatus.description === \'Emitida\' \" \nng-disabled=\"loadingProgress\" class=\"md-raised md-primary\" \nng-click=\"vms.changeCompany(vm.currentDoc.docObj.companyBuyer, vm.currentDoc.docObj.companyProvider, vm.currentDoc)\" \naria-label=\"change company\"><span>{{\'EXPENSE_SETTLEMENTS.CHANGE_NAME_COMPANY\'| translate}}</span></md-button><md-button\n \nng-show=\"vm.mainDoc.typeCode === \'SETTLEMENT\'\n                    && (vm.currentDoc.docObj.purchaseStatus.description === \'Emitida\' || vm.currentDoc.docObj.purchaseStatus.description === \'Emitido\')\" \nng-disabled=\"loadingProgress\" class=\"md-raised md-warn\" \nng-click=\"vms.notAuthorizated($event, vm.currentDoc.docObj, vm.currentDoc.detailId)\" aria-label=\"change Status\"><span>\n{{\'INVOICE.REJECT\'| translate}}</span></md-button><md-button \nng-show=\"vm.mainDoc.typeCode === \'SETTLEMENT\'\n                    && (vm.currentDoc.docObj.purchaseStatus.description === \'Emitida\' || vm.currentDoc.docObj.purchaseStatus.description === \'Emitido\')\" \nng-disabled=\"loadingProgress\" class=\"md-raised md-default-theme\" \nng-click=\"vms.setValidatedInvoice($event, vm.currentDoc)\" aria-label=\"change Staus\" translate \ntranslate-attr-aria-label=\"INVOICE.CHANGE_STATUS\"><span>\n{{\'INVOICE.STATUS_CHANGE.\' + vm.currentDoc.docObj.purchaseStatus.description | translate}}</span></md-button>");
$templateCache.put("app/main/apps/expenseSettlements/consultSettlement/consultSettlement.html","<div id=\"mail\" class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"start center\" \nstyle=\"min-height:10px; height: 13px; margin-top: 30px; padding: 2px 0\"><div class=\"search-wrapper\" layout=\"row\" \nlayout-align=\"end center\" flex><div class=\"white-fg\"><h1 ng-if=\"vm.settlement.id\">\n{{\'CONSULT_SETTLEMENT.SETTLEMENT\' | translate}} # {{vm.settlement.id}}</h1></div></div></div><div class=\"header\" \nlayout=\"row\" flex layout-align=\"start center\" style=\"height: 13px; margin-top: -25px; padding: 10px 0\"><div \nclass=\"search-wrapper md-whiteframe-4dp\" layout=\"row\" layout-align=\"start center\" flex><div class=\"search\" flex \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><input \nid=\"settlementInput\" ng-enter=\"vm.getSettlement(vm.search)\" flex ng-model=\"vm.search\" type=\"number\" translate \ntranslate-attr-placeholder=\"CONSULT_SETTLEMENT.SEARCH_BY_NUM\"><md-button class=\"md-icon-button\" \nng-click=\"vm.getSettlement(vm.search)\" aria-label=\"Back\" translate translate-attr-aria-label=\"MAIL.BACK\"><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon></md-button></div></div></div><div class=\"content thread-detail\" ms-scroll flex>\n<div class=\"thread-content\"><div layout=\"row\"><ms-form-wizard flex><div class=\"toolbar\" ng-if=\"vm.settlement.id\"><div \nclass=\"navigation\" flex layout=\"row\" layout-align=\"center center\"><div class=\"customer\" layout=\"column\"><span></span> \n<span><strong>{{vm.settlement.settlementHeader.pettyType}}</strong>: {{vm.settlement.settlementHeader.pettyId}} </span>\n<span><strong translate=\"CONSULT_SETTLEMENT.PETTY_CASH.NAME\">:</strong>: {{vm.settlement.settlementHeader.name}} \n</span><span><strong translate=\"CONSULT_SETTLEMENT.PETTY_CASH.COST_CENTER\"></strong>\n: {{vm.settlement.settlementHeader.costCenter}} </span><span><strong \ntranslate=\"CONSULT_SETTLEMENT.PETTY_CASH.DEPARTMENT\"></strong>: {{vm.settlement.settlementHeader.department}}</span>\n</div><div flex></div><div class=\"customer\" layout=\"column\"><span></span> <span><strong \ntranslate=\"CONSULT_SETTLEMENT.PETTY_CASH.HOLDER\"></strong>: {{vm.settlement.settlementHeader.holder}} </span><span>\n<strong translate=\"Estado\"></strong>: {{vm.settlement.settlementHeader.settlementStatus}} </span><span \nng-if=\"vm.settlement.policy\"><strong translate=\"CONSULT_SETTLEMENT.PETTY_CASH.POLICY\"></strong>\n: {{vm.settlement.settlementHeader.policy}} </span><span ng-if=\"vm.settlement.container\"><strong \ntranslate=\"CONSULT_SETTLEMENT.PETTY_CASH.CONTAINER\"></strong>: {{vm.settlement.settlementHeader.container}}</span>\n</div><div flex></div><div class=\"customer\" layout=\"column\"><span></span> <span \nng-if=\"vm.settlement.settlementHeader.amount > 0\"><strong translate=\"CONSULT_SETTLEMENT.PETTY_CASH.AMOUNT\"></strong>\n: {{vm.settlement.settlementHeader.amount| number: 2}} </span><span ng-if=\"vm.settlement.settlementHeader.amount > 0\">\n<strong translate=\"SETTLEMENT.PENDING_AMOUNT\"></strong>\n: {{vm.settlement.settlementHeader.amount - vm.amountAvailable| number: 2}} </span><span \nng-if=\"vm.amountAvailable > 0\" ng-class=\"vm.amountAvailable < 0 ? \'over-spend\' : \'\'\"><strong \ntranslate=\"SETTLEMENT.INITIAL_AMOUNT\"></strong>: {{vm.amountAvailable| number: 2}} </span><span \nng-if=\"vm.settlement.settlementHeader.settledAmount > 0\"><strong translate=\"SETTLEMENT.SETTLED_AMOUNT\"></strong>\n: {{vm.settlement.settlementHeader.settledAmount| number: 2}}</span></div><span flex></span></div></div><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex ng-show=\"vm.settlement.id && vm.settlement.details.length > 0\">\n<div id=\"masterGridOptions\" ag-grid=\"vm.masterGridOptions\" class=\"ag-fresh\" expand-grid min=\"280\" other=\"200\"></div>\n</div></ms-form-wizard></div></div></div></div></div>");
$templateCache.put("app/main/apps/expenseSettlements/paidSettlements/paidSettlement.html","<div id=\"verificationSettlement\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-clipboard-text\"></md-icon><span \ntranslate=\"EXPENSE_SETTLEMENTS.VIEW_SETTLEMENTS\">Liquidaciones de gasto</span></div><div \nclass=\"product-count secondary-text\"><span translate=\"EXPENSE_SETTLEMENTS.TOTAL_SETTLEMENTS\">\nTotal liquidaciones de gasto</span>: <span>{{vm.settlements.length}}</span></div></div><div class=\"search\" \nlayout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\">\n</md-icon><input id=\"e-commerce-products-search\" ng-model=\"vm.search\" class=\"search-input\" type=\"text\" \nplaceholder=\"Search\" translate translate-attr-placeholder=\"EXPENSE_SETTLEMENTS.SEARCH\" \nng-model-options=\"{\'debounce\': 300}\" flex></div></div><md-progress-linear md-mode=\"indeterminate\" ng-show=\"vm.loading\">\n</md-progress-linear><div class=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" \nlayout=\"column\" flex><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loading\" class=\"md-accent\">\n</md-progress-linear><div id=\"masterGridOptions\" ag-grid=\"vm.masterGridOptions\" class=\"ag-fresh\" expand-grid min=\"260\" \nother=\"-10\"></div></div></div></div></div>");
$templateCache.put("app/main/apps/expenseSettlements/paymentSettlement/paymentSettlement.html","<div id=\"verificationSettlement\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-clipboard-text\"></md-icon><span \ntranslate=\"EXPENSE_SETTLEMENTS.VIEW_SETTLEMENTS\">Liquidaciones de gasto</span></div><div \nclass=\"product-count secondary-text\"><span translate=\"EXPENSE_SETTLEMENTS.TOTAL_SETTLEMENTS\">\nTotal liquidaciones de gasto</span>: <span>{{vm.settlements.length}}</span></div></div><div class=\"search\" \nlayout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\">\n</md-icon><input id=\"e-commerce-products-search\" ng-model=\"vm.search\" class=\"search-input\" type=\"text\" \nplaceholder=\"Search\" translate translate-attr-placeholder=\"EXPENSE_SETTLEMENTS.SEARCH\" \nng-model-options=\"{\'debounce\': 300}\" flex></div></div><md-progress-linear md-mode=\"indeterminate\" ng-show=\"vm.loading\">\n</md-progress-linear><div class=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" \nlayout=\"column\" flex><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loading\" class=\"md-accent\">\n</md-progress-linear><div id=\"masterGridOptions\" ag-grid=\"vm.masterGridOptions\" class=\"ag-fresh\" expand-grid min=\"260\" \nother=\"-10\"></div></div></div></div></div>");
$templateCache.put("app/main/apps/expenseSettlements/pettyCash/pettyCash.html","<div id=\"pettyCash\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-clipboard-text\"></md-icon><span translate=\"EXPENSE_SETTLEMENTS.PETTY_CASH.PETTY_CASH\">\nFondo de Caja</span></div><div class=\"product-count secondary-text\"><span \ntranslate=\"EXPENSE_SETTLEMENTS.PETTY_CASH.TOTAL_PETTY_CASH\">Total cajas:</span>: <span>{{vm.pettyCashes.length}}</span>\n</div></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"e-commerce-products-search\" ng-model=\"vm.search\" \nclass=\"search-input\" type=\"text\" placeholder=\"Search\" translate \ntranslate-attr-placeholder=\"EXPENSE_SETTLEMENTS.SEARCH\" ng-model-options=\"{\'debounce\': 300}\" flex></div></div>\n<md-progress-linear md-mode=\"indeterminate\" ng-show=\"vm.loading\"></md-progress-linear><div class=\"content-card\" \nlayout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex><md-progress-linear \nmd-mode=\"indeterminate\" ng-if=\"vm.loading\" class=\"md-accent\"></md-progress-linear><div id=\"masterGridOptions\" \nag-grid=\"vm.masterGridOptions\" class=\"ag-fresh\" expand-grid min=\"260\" other=\"-10\"></div><div class=\"loading-threads\" \nlayout=\"column\" layout-align=\"center center\" ng-if=\"vm.allPettyCash.length === 0\"><h2>\n{{\'EXPENSE_SETTLEMENTS.PETTY_CASH.NO_PETTY_CASH\'| translate}}</h2></div></div></div><md-button \nclass=\"md-fab md-warn md-fab-bottom-right button-static\" ng-if=\"!vm.snThread\" ng-click=\"vm.newPettyCash(null)\">\n<ng-md-icon icon=\"add\"></ng-md-icon><md-tooltip><span translate=\"EXPENSE_SETTLEMENTS.PETTY_CASH.CREATE\">COMPOSE</span>\n</md-tooltip></md-button></div></div>");
$templateCache.put("app/main/apps/expenseSettlements/pettyCashGeneralSets/pettyCashGeneralSets.html","<div id=\"contacts\" class=\"page-layout simple left-sidenav inner-sidenav\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button sidenav-toggle\" hide-gt-md ng-click=\"vm.toggleSidenav(\'sidenav\')\" aria-label=\"Toggle sidenav\" \ntranslate translate-attr-aria-label=\"PROVIDER.TOGGLE_SIDENAV\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon \nmd-font-icon=\"icon-square-inc-cash\" class=\"s24\"></md-icon></span><span class=\"logo-text\" \ntranslate=\"PETTY_CASH_SETS.CONFIGURATION_PETTY_CASH_SETS\">Providers</span></div></div></div><div class=\"content\" \nmd-background-bg layout=\"row\" layout-align=\"start start\"><md-sidenav class=\"sidenav main-sidenav md-white-bg\" \nms-scroll md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-sidenav-helper><div \nclass=\"header md-padding\" layout=\"column\" layout-align=\"start center\"><img ng-if=\"vm.company.logo\" \nng-src=\"{{vm.URLPHOTOS + vm.company.logo.parentPath + vm.company.logo.name + \'t\' + vm.company.logo.extension}}\" \nclass=\"md-avatar avatar mr-16\" alt=\"{{vm.company.name}}\"> <span class=\"font-weight-500 font-size-14\">\n{{vm.company.name}}</span></div><md-divider></md-divider><div ms-scroll class=\"content\"><md-list><md-list-item \nng-click=\"vm.filterChange(\'all\')\" ng-class=\"{\'selected\':vm.listType === \'all\'}\"><p \ntranslate=\"PETTY_CASH_SETS.ALL_TYPES\">All petty cash type</p></md-list-item><md-divider></md-divider><md-subheader \nclass=\"md-no-sticky\">{{\'PETTY_CASH_SETS.PETTY_CASH_TYPE\'| translate}}</md-subheader><div class=\"loading-threads\" \nlayout=\"column\" layout-align=\"center center\" ng-if=\"vm.pettyCashTypes.length === 0\"><h2>\n{{\'PETTY_CASH_SETS.NO_PETTY_CASH_TYPES\'| translate}}</h2></div><md-list-item ng-repeat=\"type in vm.pettyCashTypes\" \nng-click=\"vm.filterChange(type)\" ng-class=\"{\'selected\':vm.listType.description === type.description}\"><p class=\"pl-8\">\n{{type.description}}</p></md-list-item></md-list></div></md-sidenav><div class=\"main\" ms-scroll><md-list \nclass=\"contacts-list\"><md-subheader class=\"md-no-sticky md-white-bg\"><div layout=\"row\" layout-align=\"start center\"><div\n class=\"list-title\" layout=\"row\" layout-align=\"start center\" ng-hide=\"editGroupForm.$visible\"><span \nng-if=\"vm.listType === \'all\'\" translate=\"PETTY_CASH_SETS.ALL_TYPES\">All offers</span> <span \nng-if=\"vm.listType.description\">{{vm.listType.description}}</span> <span ng-if=\"vm.pettyCashGeneralSetsFilter.length\" \nclass=\"secondary-text contacts-count\">({{vm.pettyCashGeneralSetsFilter.length}})</span></div></div></md-subheader><div \nclass=\"loading-threads\" layout=\"column\" layout-align=\"center center\" ng-if=\"vm.pettyCashGeneralSets.length === 0\"><h2>\n{{\'PETTY_CASH_SETS.NO_PETTY_MAX_AMOUNTS\'| translate}}</h2></div><table class=\"dataTable row-border hover\" \ndatatable=\"ng\" dt-options=\"vm.dtOptions\" ng-if=\"vm.pettyCashGeneralSets && vm.pettyCashGeneralSets.length > 0\"><thead>\n<tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\n{{\'PETTY_CASH_SETS.PETTY_CASH_TYPE\'| translate}}</span></div></th><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\">{{\'PETTY_CASH_SETS.MAX_AMOUNT_PETTYCASH\'| translate}}</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\n{{\'PETTY_CASH_SETS.MAX_AMOUNT_INVOICE\'| translate}}</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">{{\'PETTY_CASH_SETS.MAX_INVOICES_PROVIDER\'| translate}}</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\n{{\'PETTY_CASH_SETS.MORE_DETAILS\'| translate}}</span></div></th><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\">{{\'PETTY_CASH_SETS.ASK_FOR_BUDGET\'| translate}}</span></div></th><th class=\"secondary-text\">\n<div class=\"table-header\"><span class=\"column-title\">{{\'PETTY_CASH_SETS.USE_EXTERNAL_PROVIDERS\'| translate}}</span>\n</div></th><th id=\"petty-cash-sets-options\" class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">{{\'PETTY_CASH_SETS.OPTIONS\'| translate}}</span></div></th></tr></thead><tbody><tr \nng-repeat=\"generalSets in vm.pettyCashGeneralSetsFilter track by generalSets.pettyCashType.id\" md-ink-ripple><td>\n<strong>{{generalSets.pettyCashType.description}}</strong></td><td><span ng-if=\"generalSets.maxAmountByPettyCash > 0\">\n{{generalSets.maxAmountByPettyCash| number: 2}} </span><span ng-if=\"!(generalSets.maxAmountByPettyCash > 0)\">\n{{\'PETTY_CASH_SETS.NO_LIMITS\'| translate}}</span></td><td><span ng-if=\"generalSets.maxAmountByDocument > 0\">\n{{generalSets.maxAmountByDocument| number: 2}} </span><span ng-if=\"!(generalSets.maxAmountByDocument > 0)\">\n{{\'PETTY_CASH_SETS.NO_LIMITS\'| translate}}</span></td><td><span ng-if=\"generalSets.maxInvoiceByProvider > 0\">\n{{generalSets.maxInvoiceByProvider| number: 0}} </span><span ng-if=\"!(generalSets.maxInvoiceByProvider > 0)\">\n{{\'PETTY_CASH_SETS.NO_LIMITS\'| translate}}</span></td><td><md-icon \nmd-font-icon=\"{{generalSets.moreDetails === true ? \'icon-checkbox-marked-circle green-500-fg\' : \'\'}}\" class=\"icon\">\n</md-icon></td><td><md-icon \nmd-font-icon=\"{{generalSets.askForBudget === true ? \'icon-checkbox-marked-circle green-500-fg\' : \'\'}}\" class=\"icon\">\n</md-icon></td><td><md-icon \nmd-font-icon=\"{{generalSets.useExternalProviders === true\n                              ? \'icon-checkbox-marked-circle green-500-fg\' : \'\'}}\" \nclass=\"icon\"></md-icon></td><td><div><md-button class=\"edit-button md-icon-button\" \nng-click=\"vm.editPettyCashGeneralSets($index, generalSets, generalSets.pettyCashType)\" aria-label=\"Edit max amount\" \ntranslate translate-attr-aria-label=\"EC.PRODUCT_DETAILS\"><md-tooltip md-direction=\"top\" md-visible=\"tooltipVisible\">\n{{\'PETTY_CASH_SETS.EDIT\'| translate}}</md-tooltip><md-icon md-font-icon=\"icon-pencil\" class=\"md-accent-bgn s16\">\n</md-icon></md-button><md-button class=\"edit-button md-icon-button\" \nng-click=\"vm.deletePettyCashGeneralSets($index, event, generalSets)\" aria-label=\"Delete max amount\"><md-tooltip \nmd-direction=\"top\" md-visible=\"tooltipVisible\">{{\'PETTY_CASH_SETS.DELETE\'| translate}}</md-tooltip><md-icon \nmd-font-icon=\"icon-delete\" class=\"s16 md-warn\"></md-icon></md-button></div></td></tr></tbody></table></md-list></div>\n</div></div>");
$templateCache.put("app/main/apps/expenseSettlements/settlementRequiredProduct/requiredProduct.html","<div id=\"requiredProduct\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div\n class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h2\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-clipboard-text\"></md-icon><span \ntranslate=\"EXPENSE_SETTLEMENTS.SETTLEMENTPRODUCT.SETTLEMENTPRODUCT\"></span></div></div><div layout=\"column\" \nlayout-gt-sm=\"row\" flex=\"50\" flex-xs=\"100\"><md-input-container layout=\"column\" flex><md-select \nng-model=\"vm.requiredProduct.settlementProductType.id\" name=\"pettyCashType\" required><md-optgroup label=\"\"><md-option \nng-value=\"{{productType.id}}\" ng-repeat=\"productType in vm.settlementProductsType\">{{productType.description}}\n</md-option></md-optgroup></md-select><div ng-messages=\"vm.basicForm.settlementProductType.$error\"><div \nng-message=\"required\"><span translate=\"EXPENSE_SETTLEMENTS.SETTLEMENTPRODUCT.PRODUCTREQUIRED\"></span></div></div>\n</md-input-container><md-input-container flex><label class=\"h1\" \ntranslate=\"EXPENSE_SETTLEMENTS.PETTY_CASH.PETTYCASHTYPE\"></label><md-select \nng-model=\"vm.requiredProduct.pettyCashType.id\" name=\"pettyCashType\" required \nmd-on-close=\"vm.clearSearchPettyCashType()\"><md-select-header><input id=\"pettyCashType\" \nng-model=\"vm.searchPettyCashType\" type=\"search\" placeholder=\"Buscar\"></md-select-header><md-optgroup \nlabel=\"PettyCashType\"><md-option ng-value=\"{{pettyCashType.id}}\" \nng-repeat=\"pettyCashType in vm.pettyCashType| filter:vm.searchPettyCashType\">{{pettyCashType.description}}</md-option>\n</md-optgroup></md-select><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loadingPettyCashType\">\n</md-progress-linear><div ng-messages=\"vm.basicForm.pettyCashType.$error\"><div ng-message=\"required\"><span \ntranslate=\"EXPENSE_SETTLEMENTS.SETTLEMENTPRODUCT.PRODUCTREQUIRED\"></span></div></div></md-input-container></div></div>\n<div class=\"content-card\" layout=\"column\" flex><div class=\"loading-threads\" layout=\"column\" \nlayout-align=\"center center\" ng-show=\"!vm.requiredProduct.pettyCashType\"><h2>\n{{\'EXPENSE_SETTLEMENTS.SETTLEMENTPRODUCT.SELECTCAJA\'| translate}}</h2></div><div class=\"loading-threads\" \nlayout=\"column\" layout-align=\"center center\" ng-show=\"!vm.requiredProduct.settlementProductType\"><h2>\n{{\'EXPENSE_SETTLEMENTS.SETTLEMENTPRODUCT.SELECTPRODUCTTYPE\'| translate}}</h2></div><div id=\"asignatedItem\" \nng-show=\"vm.requiredProduct.pettyCashType && vm.requiredProduct.settlementProductType\" class=\"content\" layout-sm=\"row\" \nlayout-gt-lg=\"row\" layout-gt-md=\"row\" layout-xl=\"row\" layout-lg=\"row\" layout-md=\"row\" \nlayout-align-xl=\"space-around center\" layout-align-lg=\"space-around center\" layout-align-md=\"space-around center\"><div \nlayout=\"column\" flex-xl=\"45\" flex-lg=\"45\" flex-md=\"40\" flex><div class=\"md-inline-form\"><div \nng-style=\"vm.dinamicHeight\" class=\"custom-list\" ms-scroll><div class=\"search\" layout=\"row\" layout-align=\"start center\">\n<input flex type=\"text\" translate translate-attr-placeholder=\"EXPENSE_SETTLEMENTS.SETTLEMENTPRODUCT.PRODUCTSAVALIBLE\" \nng-enter=\"\" ng-model=\"vm.searchAllItem\" name=\"searchFieldAll\" id=\"searchField\" \nng-keydown=\"vm.loadProductAvailable(vm.requiredProduct.pettyCashType.id, 1, vm.requiredProduct.settlementProductType.id, vm.searchAllItem)\">\n<md-button type=\"submit\" aria-label=\"Search\" \nng-click=\"vm.loadProductAvailable(vm.requiredProduct.pettyCashType.id, 1, vm.requiredProduct.settlementProductType.id, vm.searchAllItem)\">\n<md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button></div><div ng-click=\"vm.toggle(item, $event)\" class=\"item\" \nng-class=\"{\'selected\': vm.isSelected(item)}\" ng-repeat=\"item in vm.allProducts.content\"><div layout=\"row\" \nlayout-align=\"start center\"><md-icon ng-if=\"vm.isSelected(item)\" md-font-icon=\"icon-checkbox-marked\"></md-icon><md-icon\n ng-if=\"!vm.isSelected(item)\" md-font-icon=\"icon-checkbox-blank-outline\"></md-icon><div flex class=\"product-name\">\n<strong>{{ item.name}} [<span>({{ item.measurementUnit.name}})</span>]</strong></div></div></div></div><div \nlayout=\"row\"><div paging class=\"pageable-div\" page=\"vm.page\" ul-class=\"pagination\" page-size=\"vm.pageSize\" \nhide-if-empty=\"true\" \npaging-action=\"vm.loadProductAvailable(vm.requiredProduct.pettyCashType.id, page, vm.requiredProduct.settlementProductType.id)\" \ntotal=\"vm.allProducts.totalElements\"></div></div></div></div><div layout=\"column\"><md-button \naria-label=\"Button disassociate\" class=\"md-primary md-raised\" ng-click=\"vm.disassociate()\" \nng-disabled=\"vm.selectedAssociatedArray === undefined || vm.selectedAssociatedArray === null || vm.selectedAssociatedArray.length === 0\">\n<md-icon md-font-icon=\"icon-arrow-left\"></md-icon><md-tooltip md-direction=\"left\">{{\"general.delete\"| translate}}\n</md-tooltip></md-button><md-button aria-label=\"Button associate\" class=\"md-primary md-raised\" \nng-click=\"vm.associate()\" \nng-disabled=\"vm.selectedArray === undefiled || vm.selectedArray === null || vm.selectedArray.length === 0\"><md-icon \nmd-font-icon=\"icon-arrow-right\"></md-icon><md-tooltip md-direction=\"left\">{{\"general.add\"| translate}}</md-tooltip>\n</md-button></div><div layout=\"column\" flex-xl=\"45\" flex-lg=\"45\" flex-md=\"40\" flex><div class=\"md-inline-form\"><div \nng-style=\"vm.dinamicHeight\" class=\"custom-list\" ms-scroll><div class=\"search\" layout=\"row\" layout-align=\"start center\">\n<input flex type=\"search\" translate translate-attr-placeholder=\"EXPENSE_SETTLEMENTS.SETTLEMENTPRODUCT.PRDODUTSBYBOX\" \nng-keydown=\"vm.loadMembersList(vm.requiredProduct.pettyCashType.id, vm.requiredProduct.settlementProductType.id, vm.searchMemItem)\" \ntype=\"text\" ng-model=\"vm.searchMemItem\" name=\"searchFieldMem\" id=\"searchField\"><md-button class=\"md-icon-button\" \ntype=\"submit\" aria-label=\"Search\" \nng-click=\"vm.loadMembersList(vm.requiredProduct.pettyCashType.id, vm.requiredProduct.settlementProductType.id, vm.searchMemItem)\">\n<md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button></div><div ng-click=\"vm.toggleAssociated(item, $event)\" \nclass=\"item\" ng-class=\"{\'selected\': vm.isSelectedAssociated(item)}\" ng-repeat=\"item in vm.membersList.content\" \nng-click=\"vm.toggleAssociated($event, item)\"><div layout=\"row\" layout-align=\"start center\"><md-icon \nng-if=\"vm.isSelectedAssociated(item)\" md-font-icon=\"icon-checkbox-marked\"></md-icon><md-icon \nng-if=\"!vm.isSelectedAssociated(item)\" md-font-icon=\"icon-checkbox-blank-outline\"></md-icon><div flex \nclass=\"product-name\">{{item.producto.name}} ({{item.producto.measurementUnit.name}})</div><md-checkbox \nng-model=\"item.deductible\" ng-change=\"vm.updateMember(item)\">Deducible</md-checkbox></div></div></div><div \nlayout=\"row\"><div paging class=\"pageable-div\" page=\"vm.pageM\" ul-class=\"pagination\" page-size=\"vm.pageSizeM\" \nhide-if-empty=\"true\" paging-action=\"vm.loadMembersList(vm.requiredProduct.pettyCashType.id, page)\" \ntotal=\"vm.membersList.totalElements\"></div></div></div></div></div></div></div></div>");
$templateCache.put("app/main/apps/expenseSettlements/settlementsProvisioned/settlementProvisioned.html","<div id=\"verificationSettlement\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-clipboard-text\"></md-icon><span \ntranslate=\"EXPENSE_SETTLEMENTS.VIEW_SETTLEMENTS\">Liquidaciones de gasto</span></div><div \nclass=\"product-count secondary-text\"><span translate=\"EXPENSE_SETTLEMENTS.TOTAL_SETTLEMENTS\">\nTotal liquidaciones de gasto</span>: <span>{{vm.settlements.length}}</span></div></div><div class=\"search\" \nlayout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\">\n</md-icon><input id=\"e-commerce-products-search\" ng-model=\"vm.search\" class=\"search-input\" type=\"text\" \nplaceholder=\"Search\" translate translate-attr-placeholder=\"EXPENSE_SETTLEMENTS.SEARCH\" \nng-model-options=\"{\'debounce\': 300}\" flex></div></div><md-progress-linear md-mode=\"indeterminate\" ng-show=\"vm.loading\">\n</md-progress-linear><div class=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" \nlayout=\"column\" flex><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loading\" class=\"md-accent\">\n</md-progress-linear><div id=\"masterGridOptions\" ag-grid=\"vm.masterGridOptions\" class=\"ag-fresh\" expand-grid min=\"260\" \nother=\"-10\"></div></div></div></div></div>");
$templateCache.put("app/main/apps/expenseSettlements/verificationSettlement/verificationSettlement.html","<div id=\"verificationSettlement\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-clipboard-text\"></md-icon><span \ntranslate=\"EXPENSE_SETTLEMENTS.VIEW_SETTLEMENTS\">Liquidaciones de gasto</span></div><div \nclass=\"product-count secondary-text\"><span translate=\"EXPENSE_SETTLEMENTS.TOTAL_SETTLEMENTS\">\nTotal liquidaciones de gasto</span>: <span>{{vm.settlements.length}}</span></div></div><div class=\"search\" \nlayout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\">\n</md-icon><input id=\"e-commerce-products-search\" ng-model=\"vm.search\" class=\"search-input\" type=\"text\" \nplaceholder=\"Search\" translate translate-attr-placeholder=\"EXPENSE_SETTLEMENTS.SEARCH\" \nng-model-options=\"{\'debounce\': 300}\" flex></div></div><md-progress-linear md-mode=\"indeterminate\" ng-show=\"vm.loading\">\n</md-progress-linear><div class=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" \nlayout=\"column\" flex><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loading\" class=\"md-accent\">\n</md-progress-linear><div id=\"masterGridOptions\" ag-grid=\"vm.masterGridOptions\" class=\"ag-fresh\" expand-grid min=\"260\" \nother=\"-10\"></div></div></div></div></div>");
$templateCache.put("app/main/apps/files/dialogPhoto/dialogPhoto.html","<md-dialog id=\"dialogPhoto\" aria-label=\"dialogPhoto\"><div layout=\"row\" layout-align=\"end center\" \nclass=\"tools-dialog-photo\"><md-button aria-label=\"button close\" class=\"md-icon-button\" \nng-click=\"vm.printElement(\'prevImage\')\"><md-icon md-font-icon=\"icon-printer\" class=\"s16\"></md-icon></md-button>\n<md-button ng-href=\"{{vm.url}}\" class=\"md-icon-button\" download><md-icon md-font-icon=\"icon-download\"></md-icon>\n</md-button><md-button aria-label=\"button close\" class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon \nmd-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><md-dialog-content><div id=\"prevImage\"><img \nalt=\"img\" ng-if=\"vm.isIMG\" ng-src=\"{{vm.url}}\"><iframe title=\"pdf\" ng-if=\"vm.isPDF\" ng-src=\"{{vm.trustSrc(vm.url)}}\" \nstyle=\"min-height: 500px; min-width: 900px\" width=\"100%\" height=\"100%\" name=\"plugin\" id=\"plugin\"></iframe></div>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/main/apps/generalReports/process-flow/process-flow.html","<md-content class=\"content\" flex ms-scroll><div id=\"flow-chart\" class=\"flow-chart\"><div class=\"tree\"><ul><li><a><span \nng-if=\"vm.infoProcessFlow.requisitionId\"><span translate=\"REPORT.PROCESS_FLOW.REQUISTION\"></span>\n# {{vm.infoProcessFlow.requisitionId}} </span><span ng-if=\"vm.infoProcessFlow.contractId\"><span \ntranslate=\"REPORT.PROCESS_FLOW.CONTRACT\"></span># {{vm.infoProcessFlow.contractId}}</span><br><span>\n{{vm.infoProcessFlow.status}}</span><md-button class=\"edit-button md-icon-button\" \nng-click=\"showAuditLog(vm.infoProcessFlow.requisitionId, 1)\" aria-label=\"logs\" translate \ntranslate-attr-aria-label=\"logs\"><md-tooltip md-direction=\"bottom\">Log</md-tooltip><md-icon \nmd-font-icon=\"icon-history\" class=\"s16\"></md-icon></md-button></a><ul \nng-if=\"vm.infoProcessFlow.requisitionId && vm.infoProcessFlow.quotations.length > 0\"><li \nng-repeat=\"quotation in vm.infoProcessFlow.quotations| orderBy:\'childId\'\"><a><span \ntranslate=\"REPORT.PROCESS_FLOW.QUOTATION\"></span> #{{quotation.childId}}<br>{{quotation.childDescription}}<br>\n({{quotation.childStatus}})<md-button class=\"edit-button md-icon-button\" ng-click=\"showAuditLog(quotation.childId, 2)\" \naria-label=\"logs\" translate translate-attr-aria-label=\"logs\"><md-tooltip md-direction=\"bottom\">Log</md-tooltip><md-icon\n md-font-icon=\"icon-history\" class=\"s16\"></md-icon></md-button></a><ul \nng-if=\"vm.infoProcessFlow.purchaseOrders.length > 0\"><li \nng-repeat=\"purchaseOrder in vm.infoProcessFlow.purchaseOrders| filter:{fatherId:quotation.childId} | orderBy:\'childId\'\">\n<a><span translate=\"REPORT.PROCESS_FLOW.PURCHASE_ORDER\"></span> # {{purchaseOrder.childId}}<br>\n({{purchaseOrder.childStatus}})<md-button class=\"edit-button md-icon-button\" \nng-click=\"showAuditLog(purchaseOrder.childId, 3)\" aria-label=\"logs\" translate translate-attr-aria-label=\"logs\">\n<md-tooltip md-direction=\"bottom\">Log</md-tooltip><md-icon md-font-icon=\"icon-history\" class=\"s16\"></md-icon>\n</md-button></a><ul ng-if=\"vm.infoProcessFlow.entryMerchandise1.length > 0\"><li \nng-repeat=\"entryMerchandise1 in vm.infoProcessFlow.entryMerchandise1| filter:{fatherId:purchaseOrder.childId}| orderBy:\'childId\'\">\n<a><span translate=\"REPORT.PROCESS_FLOW.ENTRY\"></span> # {{entryMerchandise1.childId}}</a><ul><li \nng-repeat=\"invoice in vm.infoProcessFlow.invoice| filter:{fatherId:entryMerchandise1.childId}| orderBy:\'childId\'\"><a>\n<span translate=\"REPORT.PROCESS_FLOW.INVOICE\"></span> # {{invoice.childId}}<br>({{invoice.childStatus}})<md-button \nclass=\"edit-button md-icon-button\" ng-click=\"showAuditLog(invoice.childId, 4)\" aria-label=\"logs\" translate \ntranslate-attr-aria-label=\"logs\"><md-tooltip md-direction=\"bottom\">Log</md-tooltip><md-icon \nmd-font-icon=\"icon-history\" class=\"s16\"></md-icon></md-button></a></li></ul></li></ul></li></ul></li></ul><ul \nng-if=\"vm.infoProcessFlow.contractId && vm.infoProcessFlow.purchaseOrders.length > 0\"><li \nng-repeat=\"purchaseOrder in vm.infoProcessFlow.purchaseOrders| orderBy:\'childId\'\"><a><span \ntranslate=\"REPORT.PROCESS_FLOW.PURCHASE_ORDER\"></span> # {{purchaseOrder.childId}}<br>({{purchaseOrder.childStatus}})\n<md-button class=\"edit-button md-icon-button\" ng-click=\"showAuditLog(purchaseOrder.childId, 3)\" aria-label=\"logs\" \ntranslate translate-attr-aria-label=\"logs\"><md-tooltip md-direction=\"bottom\">Log</md-tooltip><md-icon \nmd-font-icon=\"icon-history\" class=\"s16\"></md-icon></md-button></a><ul \nng-if=\"vm.infoProcessFlow.entryMerchandise1.length > 0\"><li \nng-repeat=\"entryMerchandise1 in vm.infoProcessFlow.entryMerchandise1| filter:{fatherId:purchaseOrder.childId}| orderBy:\'childId\'\">\n<a><span translate=\"REPORT.PROCESS_FLOW.ENTRY\"></span> # {{entryMerchandise1.childId}}<br><span \ntranslate=\"REPORT.PROCESS_FLOW.CUOTA\"></span>#{{entryMerchandise1.paymentNro}}</a><ul \nng-if=\"vm.infoProcessFlow.invoice.length > 0\"><li \nng-repeat=\"invoice in vm.infoProcessFlow.invoice| filter:{fatherId:entryMerchandise1.childId}| orderBy:\'childId\'\"><a>\n<span translate=\"REPORT.PROCESS_FLOW.INVOICE\"></span> # {{invoice.childId}}<br>({{invoice.childStatus}})<md-button \nclass=\"edit-button md-icon-button\" ng-click=\"showAuditLog(invoice.childId, 4)\" aria-label=\"logs\" translate \ntranslate-attr-aria-label=\"logs\"><md-tooltip md-direction=\"bottom\">Log</md-tooltip><md-icon \nmd-font-icon=\"icon-history\" class=\"s16\"></md-icon></md-button></a></li></ul></li></ul></li></ul></li></ul></div></div>\n</md-content>");
$templateCache.put("app/main/apps/invoice/configureLimitDate/limitDate.html","<div id=\"invoice\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-calendar-check\"></md-icon><span>{{\'INVOICE.CONFIGURE_LIMIT_DATE\' | translate}}</span></div>\n</div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"e-commerce-products-search\" ng-model=\"vm.search\" \nclass=\"search-input\" type=\"text\" placeholder=\"Search\" translate translate-attr-placeholder=\"REQUISITION.SEARCH\" \nng-model-options=\"{\'debounce\': 300}\" flex></div></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loading\" \nclass=\"md-accent\"></md-progress-linear><div id=\"masterGridOptions\" ag-grid=\"vm.masterGridOptions\" class=\"ag-fresh\" \nexpand-grid min=\"260\" other=\"-5\"></div></div></div><md-button class=\"md-fab md-fab-bottom-right\" aria-label=\"add\" \nstyle=\"position: fixed\" ng-click=\"vm.createInvoiceLimitDate()\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip \nmd-direction=\"left\">{{\"general.add\"| translate}}</md-tooltip></md-button></div></div>");
$templateCache.put("app/main/apps/invoice/purchases/invoice.html","<div id=\"budgetO\" class=\"page-layout carded fullwidth\" layout=\"column\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" \nlayout=\"row\" layout-align=\"start center\" flex><md-button class=\"goto-orders-button md-icon-button\" \naria-label=\"Go to INVOICES\" ng-click=\"vm.gotToInvoices()\" translate translate-attr-aria-label=\"INVOICE.GO_TO_INVOICES\">\n<md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"h2\"><span translate=\"INVOICE.INVOICE\">Invoice</span> <span>{{vm.invoice.id}}</span></div><div \nclass=\"subtitle secondary-text\"></div></div></div></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"toolbar\" style=\"max-height: {{vm.maxHeight}}; height: {{vm.maxHeight}}\"><div layout=\"row\"><md-tabs \nmd-selected=\"vm.currentTab\" flex md-change=\"vm.changeTab()\"><md-tab id=\"tab1\" aria-controls=\"tab1-content\" \nmd-on-select=\"vm.changeTab()\"><span translate=\"INVOICE.TAB.GENERAL\">Requisition Details</span></md-tab><md-tab \nng-disabled=\"vm.invoicePurchaseForm.$invalid || vm.details.length < 1\" id=\"tab2\" aria-controls=\"tab2-content\" \nmd-on-select=\"vm.changeTab()\"><span translate=\"REQUISITION.REQUISITION_DETAILS\">Detail</span></md-tab><md-tab \nid=\"tab3\" aria-controls=\"tab3-content\" md-on-select=\"vm.changeTab()\"><span translate=\"ORDER.ORDER\">PurchaseOrder</span>\n</md-tab><md-tab id=\"tab4\" aria-controls=\"tab4-content\" md-on-select=\"vm.changeTab()\" \nng-if=\"vm.statusToChange === \'Provisionada\'\"><span translate=\"REPORT.PDF_CONTRASENA_PAGO\">WITHHOLDING</span></md-tab>\n<md-tab id=\"tab5\" aria-controls=\"tab5-content\" md-on-select=\"vm.changeTab()\" \nng-if=\"vm.InvoiceWithholdingDetails.length > 0\"><span ng-if=\"vm.InvoiceWithholdingDetails.length > 0\" \ntranslate=\"INVOICE.WITHHOLDING\">WITHHOLDING</span></md-tab></md-tabs></div><div layout=\"row\" \nng-if=\"vm.currentTab === 0\"><div class=\"customer\" layout=\"column\"><span><strong \ntranslate=\"INVOICE.COMPANY.COMPANY_PROVIDER\"></strong> {{vm.invoice.companyProvider.name}}</span> <span><strong \ntranslate=\"INVOICE.COMPANY.ID\"></strong> <span class=\"number\">\n{{vm.invoice.companyProvider.documents[0].document.number}}</span></span></div><div flex></div><div class=\"customer\" \nlayout=\"column\"><span ng-if=\"vm.invoice.invoiceSerie\"><strong translate=\"INVOICE.INVOICE_PURCHASE.SERIE\"></strong>\n {{vm.invoice.invoiceSerie.serie}}</span> <span ng-if=\"vm.invoice.correlative\"><strong \ntranslate=\"INVOICE.INVOICE_PURCHASE.CORRELATIVE\"></strong><span class=\"number\"> {{vm.invoice.correlative}}</span>\n</span> <span ng-if=\"vm.invoice.uuid\"><strong translate=\"INVOICE.INVOICE_PURCHASE.UUID\"></strong><span class=\"number\">\n {{vm.invoice.uuid}}</span></span> <span ng-if=\"vm.invoice.electronicSignature\"><strong \ntranslate=\"INVOICE.INVOICE_PURCHASE.RECEIPT_STAMP\"></strong><span class=\"number\">{{vm.invoice.electronicSignature}}\n</span> </span><span><strong translate=\"INVOICE.INVOICE_PURCHASE.DATE\"></strong>\n {{vm.invoice.dateInvoicePurchase| date: \'dd-MM-yyyy\'}}</span></div><div flex></div><div class=\"customer\" \nlayout=\"column\"><span><strong translate=\"INVOICE.CURRENCY\"></strong> {{vm.invoice.currency.description}}</span> <span>\n<strong translate=\"INVOICE.INVOICE_PURCHASE.TOTAL_BEFORE_TAX\"></strong> <span class=\"number\">\n{{vm.invoice.currency.symbol + \' \' + vm.invoice.totalBeforeTax}}</span></span> <span><strong \ntranslate=\"INVOICE.INVOICE_PURCHASE.TOTAL_AFTER_TAX\"></strong> <span class=\"number\">\n{{vm.invoice.currency.symbol + \' \' + vm.invoice.totalAfterTax}}</span></span></div><span flex></span><div \nclass=\"customer\" layout=\"column\"><md-button class=\"md-raised md-warn\" ng-if=\"vm.permissionCancelInvoice\" \nng-click=\"vm.changeCancelStatusInvoice()\" aria-label=\"change Staus\" translate \ntranslate-attr-aria-label=\"INVOICE.STATUS_CHANGE.Cancelar\"><span>\n{{\'INVOICE.STATUS_CHANGE.eliminar_orden_entrega\'| translate}}</span><md-tooltip md-direction=\"top\" \nmd-visible=\"tooltipVisible\">{{\'INVOICE.STATUS_CHANGE.eliminar_orden_entrega\'| translate}}</md-tooltip></md-button>\n</div></div></div><md-content class=\"content\" flex ms-scroll><form name=\"vm.invoicePurchaseForm\"><md-tabs \nmd-dynamic-height md-selected=\"vm.currentTab\" class=\"tab-in-content\"><md-tab aria-controls=\"tab1-content\"><md-tab-body>\n<iframe title=\"report\" ng-if=\"vm.fileOtherFormat\" style=\"min-height: 500px\" width=\"100%\" height=\"100%\" name=\"plugin\" \nid=\"plugin\" src=\"{{vm.fileUrl}}\" ng-loaded-data=\"vm.isShowProgressLinear = false;\"></iframe><div class=\"invoice-image\" \nng-if=\"!vm.fileOtherFormat\"><div layout=\"row\" layout-align=\"center center\"><div class=\"image-zoom-area\" \nng-class=\"\'rotate-\' + vm.valRotate + \'-class\'\"><md-button style=\"position: fixed; z-index: 50\" class=\"md-icon-button\" \nng-click=\"vm.valRotate = vm.valRotate === 270 ? 0 : vm.valRotate + 90\"><md-icon \nmd-font-icon=\"icon-rotate-right-variant\"></md-icon></md-button><img alt=\"image\" wip-image-zoom=\"vm.imageZoomOptions\" \nng-fallback=\"assets/images/etc/thumbPhoto.jpg\" ng-class=\"\"></div></div><div layout=\"row\" layout-align=\"start start\" \nlayout-wrap flex=\"100\"><div ng-repeat=\"image in vm.images\" ng-switch=\"image.type\" flex=\"33\" flex-gt-xs=\"25\" \nflex-gt-md=\"20\"><div class=\"product-image\" layout-align=\"center center\"><img alt=\"image\" class=\"media\" \nng-class=\"image.default ? \'predeterminate\' : \'\'\" ng-src=\"{{image.url + image.extension}}\" \nng-fallback=\"assets/images/etc/thumbPhoto.jpg\" ng-click=\"vm.updateImageZoomOptions(image)\"></div></div></div></div>\n</md-tab-body></md-tab><md-tab aria-controls=\"tab2-content\"><md-tab-body><div \nclass=\"order-detail-form-container products md-background-bg md-whiteframe-1dp\" ng-show=\"vm.details.length > 0\"><div \nclass=\"black-text\" layout=\"column\" layout-align=\"start start\"><div class=\"search\" layout=\"row\" \nlayout-align=\"start start\" flex><md-icon md-font-icon=\"icon-magnify\" class=\"black-text icon search-icon\"></md-icon>\n<input id=\"e-commerce-products-search\" ng-model=\"vm.search\" class=\"search-input\" type=\"text\" placeholder=\"Search\" \ntranslate translate-attr-placeholder=\"REQUISITION.SEARCH\" \nng-model-options=\"{\n                                                               \'debounce\': 300}\" flex></div></div>\n<div class=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex>\n<md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loading\" class=\"md-accent\"></md-progress-linear><div \nid=\"masterGridOptionsE\" ag-grid=\"vm.masterGridOptionsE\" class=\"ag-fresh\" expand-grid min=\"260\" other=\"200\"></div></div>\n</div></div></md-tab-body></md-tab><md-tab aria-controls=\"tab3-content\"><md-tab-body><div \nclass=\"order-detail-form-container products md-background-bg md-whiteframe-1dp\"><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loading\" \nclass=\"md-accent\"></md-progress-linear><div id=\"masterGridOptionsPurchaseOrder\" \nag-grid=\"vm.masterGridOptionsPurchaseOrder\" class=\"ag-fresh\" expand-grid min=\"260\" other=\"100\"></div></div></div>\n</md-tab-body></md-tab><md-tab aria-controls=\"tab4-content\" ng-if=\"vm.statusToChange === \'Provisionada\'\"><md-tab-body>\n<div id=\"reportContrsenas\" expand-grid min=\"260\" other=\"110\"><iframe title=\"report\" width=\"100%\" height=\"100%\" \nname=\"plugin\" id=\"plugin\" src=\"{{vm.reportContrasena}}\"></iframe></div></md-tab-body></md-tab><md-tab \naria-controls=\"tab5-content\"><md-tab-body><div \nclass=\"order-detail-form-container products md-background-bg md-whiteframe-1dp\"><div class=\"content-card\" \nlayout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex><md-progress-linear \nmd-mode=\"indeterminate\" ng-if=\"vm.loading\" class=\"md-accent\"></md-progress-linear><div id=\"masterGridOptionsRet\" \nag-grid=\"vm.masterGridOptionsRet\" class=\"ag-fresh\" expand-grid min=\"260\" other=\"200\"></div></div></div></div>\n</md-tab-body></md-tab></md-tabs></form></md-content></div></div></div>");
$templateCache.put("app/main/apps/invoice/saleInvoice/budgetsTemplate.html","<div layout=\"row\" layout-align=\"start center\" style=\"height: 100%\"><div flex=\"70\"><md-menu-bar \nstyle=\"width: 100%; margin: 0px\"><md-menu md-position-mode=\"left bottom\"><div layout=\"row\" \nng-click=\"$mdOpenMenu($event);\"><div style=\"cursor: pointer\"><span \nng-if=\"data.invoicePurchaseDetail.merchandiseEntry.purchaseOrderDetail.contractPurchaseDetail.references.length === undefined\n                        || data.invoicePurchaseDetail.merchandiseEntry.purchaseOrderDetail.contractPurchaseDetail.references.length === null\n                        || data.invoicePurchaseDetail.merchandiseEntry.purchaseOrderDetail.contractPurchaseDetail.references.length === 0\">\n{{\'authorize_quotations.select_budgets\'| translate}}... </span><span \nng-if=\"data.invoicePurchaseDetail.merchandiseEntry.purchaseOrderDetail.contractPurchaseDetail.references.length > 1\">\n{{data.invoicePurchaseDetail.merchandiseEntry.purchaseOrderDetail.contractPurchaseDetail.references.length}} {{\'authorize_quotations.selected_budgets\'| translate}}...\n</span></div><div \nng-if=\"data.invoicePurchaseDetail.merchandiseEntry.purchaseOrderDetail.contractPurchaseDetail.references.length === 1\" \nstyle=\"min-height: 32px; min-width: 100px; width: 100%; display: block\"><div layout=\"row\" layout-align=\"start center\" \nng-repeat=\"reference in data.invoicePurchaseDetail.merchandiseEntry.purchaseOrderDetail.contractPurchaseDetail.references\" \nstyle=\"height: 38px; float: left\"><div flex=\"40\" layout=\"column\" ng-if=\"reference.amountToUse>0\"><span>\n{{\'authorize_quotations.amount\'| translate}}</span> <span>\n{{reference.currencyCode}}. {{reference.amountToUse| number:2}}</span></div><div flex=\"60\" layout=\"column\" \nng-if=\"reference.amountToUse>0\"><span>\n{{reference.budgetStartDate| date: \'dd/MM/yyyy\'}} - {{reference.budgetEndDate| date: \'dd/MM/yyyy\'}} </span><span>\n{{\'authorize_quotations.type\'| translate}}: {{reference.budgetType}}</span></div></div></div></div><md-menu-content \nwidth=\"3\" style=\"max-height:600px\"><md-menu-item \nstyle=\"height: 54px; line-height: normal; min-width: 325px; min-height: 50px\" \nng-if=\"vm.productBudget[data.invoicePurchaseDetail.merchandiseEntry.purchaseOrderDetail.contractPurchaseDetail.product.id].length === 0\">\n<span>{{\'authorize_quotations.no_budgets_for_this_product\'| translate}}...</span></md-menu-item><md-menu-item \nstyle=\"height: 54px; line-height: normal; min-width: 325px; min-height: 50px\" \nng-if=\"vm.productBudget[data.invoicePurchaseDetail.merchandiseEntry.purchaseOrderDetail.contractPurchaseDetail.product.id].length > 0\" \nng-repeat=\"budgetDetail in vm.productBudget[data.invoicePurchaseDetail.merchandiseEntry.purchaseOrderDetail.contractPurchaseDetail.product.id]\">\n<div style=\"cursor: pointer; position: relative; margin: 0px\" md-prevent-menu-close \nng-click=\"toggleSelectBudget(budgetDetail, $event)\" md-ink-ripple layout=\"row\" layout-align=\"start center\"><div \nflex=\"10\" layout=\"column\" layout-align=\"center center\"><md-checkbox ng-checked=\"isSelected(budgetDetail)\" \naria-label=\"{{isSelected(budgetDetail) ? \'Deselect\' : \'Select\'}}\" style=\"margin: 0px\"></md-checkbox></div><div \nflex=\"30\" layout=\"column\"><span>{{\'authorize_quotations.available\'| translate}}</span> <span>\n{{budgetDetail.currencyOfficial.code}}. {{budgetDetail.available| number:2}}</span></div><div flex=\"60\" \nlayout=\"column\"><span>\n{{budgetDetail.budget.startDate| date: \'dd/MM/yyyy\'}} - {{budgetDetail.budget.endDate| date: \'dd/MM/yyyy\'}}</span> \n<span>{{\'authorize_quotations.type\'| translate}}: {{budgetDetail.budget.budgetType.description}}</span></div></div>\n</md-menu-item></md-menu-content></md-menu></md-menu-bar></div><div flex=\"30\"><md-checkbox aria-label=\"need extension\" \nng-change=\"validateRequestAmpliation($event, this)\" \nng-model=\"data.invoicePurchaseDetail.merchandiseEntry.purchaseOrderDetail.contractPurchaseDetail.requestAmpliation\" \nng-if=\"data.invoicePurchaseDetail.merchandiseEntry.purchaseOrderDetail.contractPurchaseDetail.totalCovered <\n            (data.invoicePurchaseDetail.subTotalAfterTax)\n            && data.invoicePurchaseDetail.merchandiseEntry.purchaseOrderDetail.contractPurchaseDetail.references\n            && data.invoicePurchaseDetail.merchandiseEntry.purchaseOrderDetail.contractPurchaseDetail.references.length > 0\">\n{{\'authorize_quotations.request_ampliation\'| translate}}</md-checkbox></div></div>");
$templateCache.put("app/main/apps/invoice/saleInvoice/saleInvoiceEditor.html","<div id=\"invoiceEditor\" class=\"page-layout carded fullwidth\" layout=\"column\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><md-button class=\"goto-orders-button md-icon-button\" \naria-label=\"Go to orders\" ng-click=\"vm.goToInvoicePurchases()\" translate translate-attr-aria-label=\"INVOICE.INVOICES\">\n<md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"h2\"><span translate=\"INVOICE.INVOICE\">Order</span> <span>{{vm.invoicePurchase.id}}</span></div><div \nclass=\"subtitle secondary-text\"></div></div></div></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"toolbar\"><div layout=\"row\"><md-tabs md-selected=\"vm.currentTab\" flex><md-tab id=\"tab1\" \naria-controls=\"tab1-content\"><span translate=\"INVOICE.TAB.GENERAL\">Requisition Details</span></md-tab><md-tab \nng-disabled=\"vm.details.length < 1\" id=\"tab2\" aria-controls=\"tab2-content\"><span \ntranslate=\"REQUISITION.REQUISITION_DETAILS\">Detail</span></md-tab><md-tab \nng-if=\"vm.InvoiceWithholdingDetails.length > 0\" ng-show=\"vm.InvoiceWithholdingDetails.length > 0\" id=\"tab3\" \naria-controls=\"tab3-content\"><span ng-show=\"vm.InvoiceWithholdingDetails.length > 0\" translate=\"INVOICE.WITHHOLDING\">\nWithholding</span></md-tab></md-tabs><span flex></span><div ng-if=\"vm.currentTab >= 1\"><md-button \nng-show=\"vm.currentTab >= 1 && vm.details.length > 0 && vm.viewButton\" ng-disabled=\"!vm.showButton\" \nclass=\"md-raised md-primary\" ng-click=\"vm.generateDesciptions()\" translate \ntranslate-attr-aria-label=\"INVOICE.SALE_INVOICE.DETAIL.GENERATE_DESCRIPTION\"><span>\n{{\'INVOICE.SALE_INVOICE.DETAIL.GENERATE_DESCRIPTION\'| translate}}</span></md-button><md-button \nng-show=\"vm.currentTab >= 1 && vm.details.length > 0 && !vm.viewButton\" ng-disabled=\"!vm.showButton\" \nclass=\"md-raised md-primary\" ng-click=\"vm.addFeaturesInvoice()\" aria-label=\"present budget\" translate \ntranslate-attr-aria-label=\"INVOICE.STATUS_CHANGE.Ingresando\"><span>{{\'INVOICE.STATUS_CHANGE.Ingresando\'| translate}}\n</span></md-button><md-button ng-show=\"vm.currentTab >= 1 && vm.details.length > 0 && vm.viewButton\" \nng-disabled=\"!vm.showButton\" class=\"md-raised md-primary\" ng-click=\"vm.setStatusInvoices()\" \naria-label=\"present budget\" translate translate-attr-aria-label=\"INVOICE.STATUS_CHANGE.Ingresando\"><span \nng-if=\"!vm.requestAmpliationButton\">{{\'INVOICE.STATUS_CHANGE.Ingresando\'| translate}}</span> <span \nng-if=\"vm.requestAmpliationButton\">{{\'INVOICE.STATUS_CHANGE.request_ampliation\'| translate}}</span></md-button>\n<md-button ng-show=\"vm.currentTab >= 1 && vm.details.length > 0\" class=\"md-raised md-warn\" \nng-disabled=\"!vm.showButton\" ng-click=\"vm.changeCancelStatusInvoice()\" aria-label=\"change Staus\" translate \ntranslate-attr-aria-label=\"INVOICE.STATUS_CHANGE.Cancelar\"><span>{{\'INVOICE.STATUS_CHANGE.Cancelar\'| translate}}</span>\n<md-tooltip md-direction=\"top\" md-visible=\"tooltipVisible\">{{\'INVOICE.STATUS_CHANGE.Cancelar\'| translate}}</md-tooltip>\n</md-button></div></div></div><md-content class=\"content\" flex ms-scroll><md-tabs md-dynamic-height \nmd-selected=\"vm.currentTab\" class=\"tab-in-content\"><md-tab aria-controls=\"tab1-content\"><md-tab-body><div layout=\"row\" \nng-if=\"vm.invoicePurchase.documentRejection\" layout-align=\"center center\" \nstyle=\"border-radius: 3px;padding: 3px;background-color:#FE2E2E;color: white\"><span \ntranslate=\"INVOICE.INVOICE_PURCHASE.REJECTION_REASON\">Motivo de Rechazo</span> : <span>\n{{ vm.invoicePurchase.documentRejection.reason}}</span></div><form name=\"vm.invoicePurchaseForm\"><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex-gt-xs><label translate=\"INVOICE.COMPANY.COMPANY_CLIENT\">Company Client\n</label><md-select ng-model=\"vm.invoicePurchase.companyBuyer.id\" name=\"companyBuyer\" \nmd-on-close=\"vm.clearSearchCompanyBuyer()\" required ng-disabled=\"true\"><md-select-header><input \nid=\"searchCompanyBuyer\" ng-model=\"vm.searchCompanyBuyer\" type=\"search\" placeholder=\"Buscar Empresa Cliente\">\n</md-select-header><md-optgroup><md-option ng-value=\"cc.id\" \nng-repeat=\"cc in vm.companies| filter:vm.searchCompanyBuyer\">{{cc.name}}</md-option></md-optgroup></md-select>\n<md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loadingCompanyBuyer\"></md-progress-linear><div \nng-messages=\"vm.invoicePurchaseForm.companyBuyer.$error\"><div ng-message=\"required\" \ntranslate=\"INVOICE.ERROR.FIELD_REQUIRED\">This date is required!</div></div></md-input-container><md-input-container \nflex><label translate=\"INVOICE.INVOICE_PURCHASE.DATE\"></label><md-datepicker required flex=\"100\" flex-gt-xs=\"50\" \nng-model=\"vm.invoicePurchase.dateInvoicePurchase\" name=\"dateDeliver\" md-placeholder=\"dd-MM-yyyy\" \nmd-max-date=\"vm.dueDate\"></md-datepicker></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" \nng-if=\"vm.showFelSV\"><md-input-container flex-gt-xs><label translate=\"INVOICE.INVOICE_PURCHASE.DOCUMENT_TYPE\">\nDocumentType</label><md-select ng-model=\"vm.invoicePurchase.invoicePurchaseType\" name=\"invoicePurchaseType\" required>\n<md-optgroup><md-option ng-value=\"t.type\" ng-repeat=\"t in vm.invoicePurchaseTypes\">\n{{\'INVOICE.INVOICE_PURCHASE.TYPE_\' + t.name | translate}}</md-option></md-optgroup></md-select><md-progress-linear \nmd-mode=\"indeterminate\" ng-if=\"vm.loadingRegime\"></md-progress-linear><div \nng-messages=\"vm.invoicePurchaseForm.regime.$error\"><div ng-message=\"required\" translate=\"INVOICE.ERROR.FIELD_REQUIRED\">\nThis date is required!</div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex-gt-xs ng-if=\"!vm.viewUuid\"><label translate=\"INVOICE.INVOICE_PURCHASE.SERIE\">Serie</label>\n<md-select ng-model=\"vm.invoicePurchase.invoiceSerie\" name=\"serie\" md-on-close=\"vm.clearSearchSerie()\" \nng-required=\"!vm.viewUuid\" ng-change=\"vm.validateDateInvoicePurchace()\"><md-select-header><input id=\"searchSerie\" \nng-model=\"vm.searchSerie\" type=\"search\" placeholder=\"Buscar Serie\"></md-select-header><md-optgroup><md-option \nng-value=\"cc\" ng-repeat=\"cc in vm.series| filter:vm.searchSerie\"><span ng-if=\"cc.invoiceSerieDocumentTypeOb\">\n({{cc.invoiceSerieDocumentTypeOb.description}}) </span>{{cc.serie}}</md-option></md-optgroup></md-select>\n<md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loadingSerie\"></md-progress-linear><div \nng-messages=\"vm.invoicePurchaseForm.serie.$error\"><div ng-message=\"required\" translate=\"INVOICE.ERROR.FIELD_REQUIRED\">\nThis date is required!</div></div><div ng-if=\"vm.almostEnd\" class=\"almostEnd\"><div>{{vm.almostEnd}}</div></div>\n</md-input-container><md-input-container flex-gt-xs ng-if=\"!vm.viewUuid\"><label \ntranslate=\"INVOICE.INVOICE_PURCHASE.CORRELATIVE\"></label><input ng-required=\"!vm.viewUuid\" name=\"correlative\" \nng-model=\"vm.invoicePurchase.correlative\" type=\"number\" style=\"text-align: right\" \nmin=\"{{vm.invoicePurchase.invoiceSerie.initialNumber}}\" max=\"{{vm.invoicePurchase.invoiceSerie.lastNumber}}\"><div \nng-messages=\"vm.invoicePurchaseForm.correlative.$error\"><div ng-message=\"required\" \ntranslate=\"INVOICE.ERROR.FIELD_REQUIRED\">This date is required!</div></div></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\" \nng-if=\"vm.invoicePurchase.invoiceSerie.electronicInvoice\n                                    || vm.showFelSV\">\n<md-input-container flex-gt-xs><label translate=\"{{vm.electronicInvoiceTitle}}\"></label><input \nng-required=\"vm.showFelSV\" name=\"electronicSignature\" ng-model=\"vm.invoicePurchase.electronicSignature\" type=\"text\">\n<div ng-messages=\"vm.invoicePurchaseForm.electronicSignature.$error\"><div ng-message=\"required\" \ntranslate=\"INVOICE.ERROR.FIELD_REQUIRED\">This date is required!</div></div></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container flex-gt-xs><label translate=\"INVOICE.COMPANY.REGIME\">Regime\n</label><md-select ng-model=\"vm.invoicePurchase.regime\" name=\"regime\" md-on-close=\"vm.clearSearchRegime()\" \nng-blur=\"vm.getTaxes()\" ; ng-change=\"vm.validateRegime()\" required><md-select-header><input id=\"searchSerie\" \nng-model=\"vm.searchRegime\" type=\"search\" placeholder=\"Buscar Regime\"></md-select-header><md-optgroup><md-option \nng-value=\"cc\" ng-repeat=\"cc in vm.regimes| filter:vm.searchRegime\">{{cc.name}}</md-option></md-optgroup></md-select>\n<md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loadingRegime\"></md-progress-linear><div \nng-messages=\"vm.invoicePurchaseForm.regime.$error\"><div ng-message=\"required\" translate=\"INVOICE.ERROR.FIELD_REQUIRED\">\nThis date is required!</div></div></md-input-container><md-input-container flex-gt-xs><label \ntranslate=\"INVOICE.CURRENCY\">Currency</label><md-select ng-model=\"vm.invoicePurchase.currency.id\" name=\"currency\" \nmd-on-close=\"vm.clearSearchCurrency()\" required ng-disabled=\"true\"><md-select-header><input id=\"searchCurrency\" \nng-model=\"vm.searchCurrency\" type=\"search\" placeholder=\"Buscar Moneda\"></md-select-header><md-optgroup><md-option \nng-value=\"cc.id\" ng-repeat=\"cc in vm.currencies| filter:vm.searchCurrency\">{{cc.description}}</md-option></md-optgroup>\n</md-select><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loadingCurrency\"></md-progress-linear><div \nng-messages=\"vm.invoicePurchaseForm.currency.$error\"><div ng-message=\"required\" \ntranslate=\"INVOICE.ERROR.FIELD_REQUIRED\">This date is required!</div></div></md-input-container><md-input-container \nflex-gt-xs ng-if=\"vm.invoicePurchase.currency.id !== vm.invoicePurchase.companyProvider.currency.id\"><label \ntranslate=\"INVOICE.INVOICE_PURCHASE.EXCHANGE_RATE\">exchangeRate</label><input required name=\"exchangeRate\" \nng-model=\"vm.invoicePurchase.exchangeRate\" type=\"number\" style=\"text-align: right\"></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container flex-gt-xs ng-if=\"vm.viewUuid\"><label \ntranslate=\"{{vm.uuidTitle}}\"></label><input ng-required=\"vm.viewUuid\" name=\"uuid\" id=\"uuid\" \nng-model=\"vm.invoicePurchase.uuid\" ng-blur=\"vm.validateUUID()\" type=\"text\" ng-pattern=\"vm.regexUUID\" \nstyle=\"text-align: right\"><div ng-messages=\"vm.invoicePurchaseForm.uuid.$error\"><div ng-message=\"required\" \ntranslate=\"INVOICE.ERROR.FIELD_REQUIRED\">This date is required!</div><div ng-message=\"pattern\" \ntranslate=\"{{vm.uuidErrorTitle}}\">This date is pattern!</div></div></md-input-container><md-input-container flex \nng-if=\"vm.showFelSV\"><label id=\"lbControlNumber\" translate=\"INVOICE.INVOICE_PURCHASE.CONTROL_NUMBER\"></label><input \nid=\"inControlNumber\" ng-required=\"vm.showFelSV\" type=\"text\" name=\"controlNumber\" \nng-model=\"vm.invoicePurchase.controlNumber\" style=\"text-align: right\" maxlength=\"31\" minlength=\"31\"><div \nng-messages=\"vm.invoicePurchaseForm.controlNumber.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\" \ntranslate=\"INVOICE.ERROR.FIELD_REQUIRED\">This field is required!</div><div ng-message=\"maxlength\" \ntranslate=\"INVOICE.ERROR.CONTROL_NUMBER_LENGTH\">Must be 31 characteres!</div><div ng-message=\"minlength\" \ntranslate=\"INVOICE.ERROR.CONTROL_NUMBER_LENGTH\">Must be 31 characteres!</div></div></md-input-container></div><div \nclass=\"p-16\" ng-show=\"false\"><div class=\"md-background-bg md-whiteframe-1dp\"><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><label translate=\"INVOICE.UPLOAD_QUOTATION\"></label><files-uploader file-type=\"Quotation\" \nvm=\"vm\"></files-uploader></md-input-container></div><div layout=\"row\" layout-align=\"center start\" layout-wrap \nng-show=\"vm.invoicePurchase.id && vm.invoicePurchase.filesQuotation.length > 0\"><div \nng-repeat=\"file in vm.invoicePurchase.filesQuotation\" ng-switch=\"file.extension\"><md-content><div layout=\"column\" \nng-click=\"vm.viewIMG(file)\" \nng-if=\"file.extension == \'.jpg\' || file.extension == \'.png\' || file.extension == \'.JPG\' || file.extension == \'.PNG\'\"><a\n href=\"\"><img alt=\"img\" height=\"100px\" width=\"100px\" class=\"media\" \nng-src=\"{{vm.URLPHOTOS + file.parentPath + file.name + file.extension}}\"><p>{{file.originalName + file.extension}}</p>\n</a></div><div layout=\"column\" \nng-if=\"file.extension != \'.jpg\' && file.extension != \'.png\' && file.extension != \'.JPG\' && file.extension != \'.PNG\'\"><a\n target=\"_blank\" href=\"{{vm.URLPHOTOS + file.parentPath + file.name + file.extension}}\"><md-icon \nmd-font-icon=\"icon-file-document\"></md-icon><p>{{file.originalName + file.extension}}</p></a></div></md-content></div>\n</div></div></div><div class=\"p-16\"><div class=\"md-background-bg md-whiteframe-1dp\"><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex><label translate=\"INVOICE.UPLOAD_INVOICE\"></label><files-uploader vm=\"vm\">\n</files-uploader></md-input-container></div><div layout=\"row\" layout-align=\"center start\" layout-wrap \nng-show=\"vm.invoicePurchase.id && vm.invoicePurchase.files.length > 0\"><div \nng-repeat=\"file in vm.invoicePurchase.files\" ng-switch=\"file.extension\"><md-content><div layout=\"column\" \nng-click=\"vm.viewIMG(file)\" \nng-if=\"file.extension == \'.jpg\' || file.extension == \'.png\' || file.extension == \'.JPG\' || file.extension == \'.PNG\'\"><a\n href=\"\"><img alt=\"img\" height=\"100px\" width=\"100px\" class=\"media\" \nng-src=\"{{vm.URLPHOTOS + file.parentPath + file.name + file.extension}}\"><p>{{file.originalName + file.extension}}</p>\n</a></div><div layout=\"column\" \nng-if=\"file.extension != \'.jpg\' && file.extension != \'.png\' && file.extension != \'.JPG\' && file.extension != \'.PNG\'\"><a\n target=\"_blank\" href=\"{{vm.URLPHOTOS + file.parentPath + file.name + file.extension}}\"><md-icon \nmd-font-icon=\"icon-file-document\"></md-icon><p>{{file.originalName + file.extension}}</p></a></div></md-content></div>\n</div></div></div></form></md-tab-body></md-tab><md-tab aria-controls=\"tab2-content\"><md-tab-body><div \nclass=\"order-detail-form-container products md-background-bg md-whiteframe-1dp\" ng-show=\"vm.details.length > 0\"><div \nclass=\"black-text\" layout=\"column\" layout-align=\"start start\" style=\"width: 100%\"><div class=\"search\" layout=\"row\" \nlayout-align=\"none\" style=\"width: 100%\"><md-icon md-font-icon=\"icon-magnify\" class=\"black-text icon search-icon\">\n</md-icon><input id=\"e-commerce\" ng-model=\"vm.search\" class=\"\" type=\"text\" placeholder=\"Search\" \nstyle=\"width: 90%; box-shadow: 10px 10px 5px #888888\" translate translate-attr-placeholder=\"REQUISITION.SEARCH\" \nng-model-options=\"{\'debounce\': 300}\"></div></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loading\" \nclass=\"md-accent\"></md-progress-linear><div id=\"masterGridOptionsE\" ag-grid=\"vm.masterGridOptionsE\" class=\"ag-fresh\" \nexpand-grid min=\"260\" other=\"200\"></div></div></div></div></md-tab-body></md-tab><md-tab aria-controls=\"tab3-content\" \nng-show=\"vm.InvoiceWithholdingDetails.length > 0\"><md-tab-body><div \nclass=\"order-detail-form-container products md-background-bg md-whiteframe-1dp\" \nng-show=\"vm.InvoiceWithholdingDetails.length > 0\"><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loading\" \nclass=\"md-accent\"></md-progress-linear><div id=\"masterGridOptionsRet\" ag-grid=\"vm.masterGridOptionsRet\" \nclass=\"ag-fresh\" expand-grid min=\"260\" other=\"200\"></div></div></div></div></md-tab-body></md-tab></md-tabs>\n</md-content></div><md-button class=\"md-fab md-fab-bottom-right\" aria-label=\"addDetail\" \nng-disabled=\"vm.invoicePurchaseForm.$invalid || (vm.filesPurchase.length < 1 && vm.filesToUpload.length < 1)\n                         || (vm.filesToUploadQuotation.length > vm.maxNumberFilesQuotation)\" \nng-click=\"vm.nextInvoicePurchase();\" ng-show=\"vm.currentTab === 0\"><md-icon md-font-icon=\"icon-content-save\" \nng-if=\"vm.currentTab === 0\"></md-icon></md-button></div></div>");
$templateCache.put("app/main/apps/invoice/saleInvoice/saleInvoiceEditorFile.html","<div id=\"invoiceEditor\" class=\"page-layout carded fullwidth\" layout=\"column\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><md-button class=\"goto-orders-button md-icon-button\" \naria-label=\"Go to orders\" ng-click=\"vm.goToInvoicePurchases()\" translate translate-attr-aria-label=\"INVOICE.INVOICES\">\n<md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"h2\"><span translate=\"INVOICE.INVOICE\">Order</span> <span>{{vm.invoicePurchase.id}}</span></div><div \nclass=\"subtitle secondary-text\"></div></div></div></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"toolbar\"><div layout=\"row\"><md-tabs md-selected=\"vm.currentTab\" flex><md-tab id=\"tab1\" \naria-controls=\"tab1-content\"><span translate=\"INVOICE.TAB.GENERAL\">Requisition Details </span></md-tab><md-tab \nng-if=\"vm.viewDetail\" ng-disabled=\"vm.details.length < 1\" id=\"tab2\" aria-controls=\"tab2-content\"><span \nng-if=\"vm.viewDetail\" translate=\"REQUISITION.REQUISITION_DETAILS\">Detail</span></md-tab><md-tab \nng-if=\"vm.InvoiceWithholdingDetails.length>0 && vm.viewDetail\" id=\"tab3\" aria-controls=\"tab3-content\"><span \nng-if=\"vm.InvoiceWithholdingDetails.length>0 && vm.viewDetail\" translate=\"INVOICE.WITHHOLDING\">Withholding</span>\n</md-tab></md-tabs><span flex></span><div ng-show=\"vm.currentTab >= 1\"><md-button \nng-show=\"vm.details.length > 0 && vm.viewDetail\" class=\"md-raised md-primary\" ng-click=\"vm.setStatusInvoices()\" \naria-label=\"present budget\" translate translate-attr-aria-label=\"INVOICE.STATUS_CHANGE.Editando\"><span>\n{{\'INVOICE.STATUS_CHANGE.Ingresando\'| translate}}</span></md-button></div></div></div><md-content class=\"content\" flex \nms-scroll><form name=\"vm.invoicePurchaseForm\"><md-tabs md-dynamic-height md-selected=\"vm.currentTab\" \nclass=\"tab-in-content\"><md-tab aria-controls=\"tab1-content\"><md-tab-body><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex-gt-xs><label translate=\"INVOICE.COMPANY.COMPANY_CLIENT\">Company Client</label><md-select \nng-disabled=\"true\" ng-model=\"vm.invoicePurchase.companyBuyer.id\" name=\"companyBuyer\" \nmd-on-close=\"vm.clearSearchCompanyBuyer()\" required ng-disabled=\"true\"><md-select-header><input \nid=\"searchCompanyBuyer\" ng-model=\"vm.searchCompanyBuyer\" type=\"search\" placeholder=\"Buscar Empresa Cliente\">\n</md-select-header><md-optgroup><md-option ng-value=\"cc.id\" \nng-repeat=\"cc in vm.companies| filter:vm.searchCompanyBuyer\">{{cc.name}}</md-option></md-optgroup></md-select>\n<md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loadingCompanyBuyer\"></md-progress-linear><div \nng-messages=\"vm.invoicePurchaseForm.companyBuyer.$error\"><div ng-message=\"required\" \ntranslate=\"INVOICE.ERROR.FIELD_REQUIRED\">This date is required!</div></div></md-input-container><md-input-container \nflex><label translate=\"INVOICE.INVOICE_PURCHASE.DATE\"></label><md-datepicker ng-disabled=\"true\" required flex=\"100\" \nflex-gt-xs=\"50\" ng-model=\"vm.invoicePurchase.dateInvoicePurchase\" name=\"dateDeliver\" md-placeholder=\"dd-MM-yyyy\">\n</md-datepicker></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex-gt-xs>\n<label translate=\"INVOICE.INVOICE_PURCHASE.SERIE\">Serie</label><md-select ng-disabled=\"true\" \nng-model=\"vm.invoicePurchase.invoiceSerie.id\" name=\"serie\" md-on-close=\"vm.clearSearchSerie()\" required>\n<md-select-header><input id=\"searchSerie\" ng-model=\"vm.searchSerie\" type=\"search\" placeholder=\"Buscar Serie\">\n</md-select-header><md-optgroup><md-option ng-value=\"cc.id\" ng-repeat=\"cc in vm.series| filter:vm.searchSerie\">\n{{cc.serie}}</md-option></md-optgroup></md-select><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loadingSerie\">\n</md-progress-linear><div ng-messages=\"vm.invoicePurchaseForm.serie.$error\"><div ng-message=\"required\" \ntranslate=\"INVOICE.ERROR.FIELD_REQUIRED\">This date is required!</div></div></md-input-container><md-input-container \nflex-gt-xs><label translate=\"INVOICE.INVOICE_PURCHASE.CORRELATIVE\"></label><input ng-disabled=\"true\" required \nname=\"correlative\" ng-model=\"vm.invoicePurchase.correlative\" type=\"number\" style=\"text-align: right\" \nmin=\"{{vm.invoicePurchase.invoiceSerie.initialNumber}}\" max=\"{{vm.invoicePurchase.invoiceSerie.lastNumber}}\">\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex-gt-xs><label \ntranslate=\"INVOICE.COMPANY.REGIME\">Regime</label><md-select ng-disabled=\"true\" ng-model=\"vm.invoicePurchase.regime.id\" \nname=\"regime\" md-on-close=\"vm.clearSearchRegime()\" required><md-select-header><input id=\"searchSerie\" \nng-model=\"vm.searchRegime\" type=\"search\" placeholder=\"Buscar Regime\"></md-select-header><md-optgroup><md-option \nng-value=\"cc.id\" ng-repeat=\"cc in vm.regimes| filter:vm.searchRegime\">{{cc.name}}</md-option></md-optgroup></md-select>\n<md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loadingRegime\"></md-progress-linear><div \nng-messages=\"vm.invoicePurchaseForm.regime.$error\"><div ng-message=\"required\" translate=\"INVOICE.ERROR.FIELD_REQUIRED\">\nThis date is required!</div></div></md-input-container><md-input-container flex-gt-xs><label \ntranslate=\"INVOICE.CURRENCY\">Currency</label><md-select ng-disabled=\"true\" ng-model=\"vm.invoicePurchase.currency.id\" \nname=\"currency\" md-on-close=\"vm.clearSearchCurrency()\" required ng-disabled=\"true\"><md-select-header><input \nid=\"searchCurrency\" ng-model=\"vm.searchCurrency\" type=\"search\" placeholder=\"Buscar Moneda\"></md-select-header>\n<md-optgroup><md-option ng-value=\"cc.id\" ng-repeat=\"cc in vm.currencies| filter:vm.searchCurrency\">{{cc.description}}\n</md-option></md-optgroup></md-select><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loadingCurrency\">\n</md-progress-linear><div ng-messages=\"vm.invoicePurchaseForm.currency.$error\"><div ng-message=\"required\" \ntranslate=\"INVOICE.ERROR.FIELD_REQUIRED\">This date is required!</div></div></md-input-container></div><div \nclass=\"p-16\"><div class=\"md-background-bg md-whiteframe-1dp\"><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><label translate=\"INVOICE.UPLOAD_QUOTATION\"></label><files-uploader file-type=\"Quotation\" \nvm=\"vm\"></files-uploader></md-input-container></div><div layout=\"row\" layout-align=\"center start\" layout-wrap \nng-show=\"vm.invoicePurchase.id && vm.invoicePurchase.filesQuotation.length > 0\"><div \nng-repeat=\"file in vm.invoicePurchase.filesQuotation\" ng-switch=\"file.extension\"><md-content><div layout=\"column\" \nng-click=\"vm.viewIMG(file)\" \nng-if=\"file.extension == \'.jpg\' || file.extension == \'.png\' || file.extension == \'.JPG\' || file.extension == \'.PNG\'\"><a\n href=\"\"><img alt=\"image\" height=\"100px\" width=\"100px\" class=\"media\" \nng-src=\"{{vm.URLPHOTOS + file.parentPath + file.name + file.extension}}\"><p>{{file.originalName + file.extension}}</p>\n</a></div><div layout=\"column\" \nng-if=\"file.extension != \'.jpg\' && file.extension != \'.png\' && file.extension != \'.JPG\' && file.extension != \'.PNG\'\"><a\n target=\"_blank\" href=\"{{vm.URLPHOTOS + file.parentPath + file.name + file.extension}}\"><md-icon \nmd-font-icon=\"icon-file-document\"></md-icon><p>{{file.originalName + file.extension}}</p></a></div></md-content></div>\n</div></div></div><div class=\"p-16\"><div class=\"md-background-bg md-whiteframe-1dp\"><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex><label translate=\"INVOICE.UPLOAD_INVOICE\"></label><files-uploader vm=\"vm\">\n</files-uploader></md-input-container></div><div layout=\"row\" layout-align=\"center start\" layout-wrap \nng-show=\"vm.invoicePurchase.id && vm.invoicePurchase.files.length > 0\"><div \nng-repeat=\"file in vm.invoicePurchase.files\" ng-switch=\"file.extension\"><md-content><div layout=\"column\" \nng-click=\"vm.viewIMG(file)\" \nng-if=\"file.extension == \'.jpg\' || file.extension == \'.png\' || file.extension == \'.JPG\' || file.extension == \'.PNG\'\"><a\n href=\"\"><img alt=\"image\" height=\"100px\" width=\"100px\" class=\"media\" \nng-src=\"{{vm.URLPHOTOS + file.parentPath + file.name + file.extension}}\"><p>{{file.originalName + file.extension}}</p>\n</a></div><div layout=\"column\" \nng-if=\"file.extension != \'.jpg\' && file.extension != \'.png\' && file.extension != \'.JPG\' && file.extension != \'.PNG\'\"><a\n target=\"_blank\" href=\"{{vm.URLPHOTOS + file.parentPath + file.name + file.extension}}\"><md-icon \nmd-font-icon=\"icon-file-document\"></md-icon><p>{{file.originalName + file.extension}}</p></a></div></md-content></div>\n</div></div></div></md-tab-body></md-tab><md-tab aria-controls=\"tab2-content\" \nng-hide=\"vm.filesPurchase.length < 1 || vm.filesToUpload.length < 1 && !vm.viewDetail\"><md-tab-body><div \nclass=\"order-detail-form-container products md-background-bg md-whiteframe-1dp\" ng-show=\"vm.details.length > 0\"><div \nclass=\"black-text\" layout=\"column\" layout-align=\"start start\"><div class=\"search\" layout=\"row\" \nlayout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" class=\"black-text icon search-icon\"></md-icon>\n<input id=\"e-commerce-products-search\" ng-model=\"vm.search\" class=\"search-input\" type=\"text\" placeholder=\"Search\" \ntranslate translate-attr-placeholder=\"REQUISITION.SEARCH\" ng-model-options=\"{\'debounce\': 300}\" flex></div></div><div \nclass=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex>\n<md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loading\" class=\"md-accent\"></md-progress-linear><div \nid=\"masterGridOptionsE\" ag-grid=\"vm.masterGridOptionsE\" class=\"ag-fresh\" expand-grid min=\"260\" other=\"-10\"></div></div>\n</div></div></md-tab-body></md-tab><md-tab aria-controls=\"tab3-content\" \nng-show=\"vm.InvoiceWithholdingDetails.length>0 && vm.viewDetail\"><md-tab-body><div \nclass=\"order-detail-form-container products md-background-bg md-whiteframe-1dp\" \nng-show=\"vm.InvoiceWithholdingDetails.length>0\"><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loading\" \nclass=\"md-accent\"></md-progress-linear><div id=\"masterGridOptionsRet\" ag-grid=\"vm.masterGridOptionsRet\" \nclass=\"ag-fresh\" expand-grid min=\"260\" other=\"-10\"></div></div></div></div></md-tab-body></md-tab></md-tabs></form>\n</md-content></div><md-button class=\"md-fab md-fab-bottom-right\" aria-label=\"addDetail\" \nng-disabled=\"(vm.filesPurchase.length < 1 || (vm.filesToUpload.length < 1 && vm.filesToUploadQuotation.length < 1))\n                          || (vm.filesToUploadQuotation.length > vm.maxNumberFilesQuotation)\" \nng-click=\"vm.updateFileInvoicePurchase(); vm.viewDetail=true\" ng-show=\"vm.currentTab === 0\"><md-icon \nmd-font-icon=\"icon-content-save\" ng-if=\"vm.currentTab === 0\"></md-icon></md-button></div></div>");
$templateCache.put("app/main/apps/merchandiseEntry/invoiceMerchandiseEntry/invoiceMerchandiseEntry.html","<div id=\"invoiceMerchandiseEntry\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-cart-outline\"></md-icon><span \ntranslate=\"INVOICE_MERCHANDISE_ENTRY.MERCHANDISE_ENTRIES\">Entradas de Mercancía</span></div><div \nclass=\"order-count secondary-text\"><span translate=\"INVOICE_MERCHANDISE_ENTRY.TOTAL_MERCHANDISE_ENTRY\">Total Entradas\n</span> <span>{{vm.merchandiseEntries.length}}</span></div></div><div class=\"search\" layout=\"row\" \nlayout-align=\"start center\" flex><input id=\"e-commerce-products-search\" ng-model=\"vm.search\" class=\"search-input\" \ntype=\"text\" placeholder=\"Search\" translate translate-attr-placeholder=\"INVOICE_MERCHANDISE_ENTRY.SEARCH\" \nng-model-options=\"{\'debounce\': 300}\" flex></div></div><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"></div><div class=\"order-count secondary-text\"></div></div><div class=\"search\" \nlayout=\"row\" layout-align=\"start center\" flex style=\"top: -35px\"><md-input-container flex \nclass=\"search-input white-fg\"><label translate=\"INVOICE_MERCHANDISE_ENTRY.COMPANY\"></label><md-select \nstyle=\"background: white; color: black\" ng-model=\"vm.companyInvoice.id\" name=\"companyInvoice\" required \nng-disabled=\"!vm.companyInvoice || vm.loadingCompanies\" md-on-close=\"vm.clearSearchCompany()\" \nng-change=\"vm.getMerchandiseEntry()\"><md-select-header><input id=\"searchCompany\" ng-model=\"vm.searchCompany\" \ntype=\"search\" placeholder=\"Buscar Cliente\"></md-select-header><md-optgroup label=\"Departamentos\"><md-option \nvalue=\"{{company.id}}\" ng-repeat=\"company in vm.companies| filter:vm.searchCompany\">{{company.name}}</md-option>\n</md-optgroup></md-select></md-input-container></div></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loading\" \nclass=\"md-accent\"></md-progress-linear><div layout=\"row\"><div style=\"padding-left: 10px; padding-top: 10px\">\n<md-checkbox ng-if=\"vm.merchandiseEntries && vm.merchandiseEntries.length > 0\" ng-model=\"vm.selectAll\" \nng-click=\"vm.selectAllMerchandise()\">Seleccionar Todo para Facturar</md-checkbox></div><span flex></span><div>\n<md-button ng-disabled=\"!vm.merchandiseEntrysSend.length > 0\" class=\"md-raised md-primary\" \nng-click=\"vm.invoiceMerchandiseEntrys()\" aria-label=\"facturar\" translate \ntranslate-attr-aria-label=\"INVOICE_MERCHANDISE_ENTRY.INVOICE\"><span>{{\'INVOICE_MERCHANDISE_ENTRY.INVOICE\'| translate}}\n</span><md-tooltip md-direction=\"top\" md-visible=\"tooltipVisible\">{{\'INVOICE_MERCHANDISE_ENTRY.INVOICE\'| translate}}\n</md-tooltip></md-button></div></div><div layout=\"column\" flex=\"90\"><div layout-gt-xs=\"row\" id=\"masterGridOptions\" \nag-grid=\"vm.masterGridOptions\" class=\"ag-fresh\" expand-grid min=\"260\" other=\"100\"></div></div></div></div></div></div>");
$templateCache.put("app/main/apps/merchandiseEntry/merchandiseEntry/merchandiseEntry.html","<div id=\"merchandiseEntry\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-cart-outline\"></md-icon><span translate=\"MERCHANDISE_ENTRY.MERCHANDISE_ENTRIES\">\nEntradas de Mercancía</span></div><div class=\"order-count secondary-text\"><span \ntranslate=\"MERCHANDISE_ENTRY.TOTAL_MERCHANDISE_ENTRY\">Total Entradas</span> <span>{{vm.merchandiseEntries.length}}\n</span></div></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input id=\"e-commerce-products-search\" \nng-model=\"vm.search\" class=\"search-input\" type=\"text\" placeholder=\"Search\" translate \ntranslate-attr-placeholder=\"MERCHANDISE_ENTRY.SEARCH\" ng-model-options=\"{\'debounce\': 300}\" flex></div></div><div \nclass=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex>\n<md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loading\" class=\"md-accent\"></md-progress-linear><div \nid=\"masterGridOptions\" ag-grid=\"vm.masterGridOptions\" class=\"ag-fresh\" expand-grid min=\"260\" other=\"-10\"></div></div>\n</div><md-button class=\"md-fab md-fab-bottom-right\" aria-label=\"addBudget\" style=\"position: fixed\" \nng-click=\"vm.newRequisition()\" ng-if=\"vm.isCreate\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div></div>");
$templateCache.put("app/main/apps/order/details-pending-delivery/details-pending-delivery.html","<md-progress-linear style=\"position: fixed; height: 5px; z-index: 10\" md-mode=\"query\" class=\"md-accent\" \nng-show=\"vm.isShowProgressLinear\"></md-progress-linear><div style=\"padding-top: 5px\"><div layout=\"row\" \nlayout-align=\"center center\"><h2>{{\'ORDER.DETAILS_PENDING_DELIVERY\'| translate}}</h2></div><div id=\"masterGridOptions\" \nag-grid=\"vm.masterGridOptions\" class=\"ag-fresh\" expand-grid min=\"260\" other=\"10\"></div></div><md-button class=\"md-fab\" \naria-label=\"Generar xls\" ng-disabled=\"!vm.hasData\" ng-click=\"vm.onExportXLS()\" \nstyle=\"position: fixed; bottom: 10px; right: 20px\"><md-icon md-font-icon=\"icon-file-excel\"></md-icon><md-tooltip \nmd-direction=\"left\">{{\'REPORT.EXPORTXLS\'| translate}}</md-tooltip></md-button>");
$templateCache.put("app/main/apps/order/order/order.html","<div id=\"budgetO\" class=\"page-layout carded fullwidth\" layout=\"column\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" \nlayout=\"row\" layout-align=\"start center\" flex><md-button class=\"goto-orders-button md-icon-button\" \naria-label=\"Go to orders\" ng-click=\"vm.gotoOrders()\" translate translate-attr-aria-label=\"ORDER.GO_TO_ORDERS\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"column\" layout-align=\"start start\"><div class=\"h2\">\n<span translate=\"ORDER.ORDER\">Order</span> <span>{{vm.order.id}}</span></div><div class=\"subtitle secondary-text\">\n</div></div></div></div><div class=\"content-card\" layout=\"column\" flex><div \nng-class=\"vm.dinamicSize > 900 ? \'toolbar\' : \'customer-toolbar\'\"><div layout=\"row\"><div class=\"customer\" \nlayout=\"column\" flex><span><strong translate=\"ORDER.DEPARTMENT\"></strong> {{vm.order.department.description}}</span> \n<span><strong translate=\"ORDER.COST_CENTER\"></strong> {{vm.order.costCenter.description}}</span> <span><strong \ntranslate=\"ORDER.PURCHASESTATUS\"></strong> {{vm.order.purchaseStatus.description}}</span></div><div class=\"customer\" \nlayout=\"column\" flex><span><strong translate=\"ORDER.PROVIDER\"></strong> {{vm.order.companyProvider.name}}</span> <span>\n<strong translate=\"ORDER.BUYER\"></strong> {{vm.order.company.name}}</span> <span><strong translate=\"ORDER.TOTAL\">\n</strong> {{vm.order.total| number:2}}</span></div><div class=\"customer\" layout=\"column\" flex><span \nng-if=\"vm.order.dimensionCompanyDetail3\"><strong>{{vm.dimensionCompanyDetail3.description}}</strong>\n {{vm.order.dimensionCompanyDetail3.name}} </span><span ng-if=\"vm.order.dimensionCompanyDetail4\"><strong>\n{{vm.dimensionCompanyDetail4.description}}</strong> {{vm.order.dimensionCompanyDetail4.name}} </span><span \nng-if=\"vm.order.dimensionCompanyDetail5\"><strong>{{vm.dimensionCompanyDetail5.description}}</strong>\n {{vm.order.dimensionCompanyDetail5.name}}</span></div><div class=\"customer\" layout=\"column\" flex><md-button \nng-show=\"vm.reasignProvider && vm.details.length > 0\" ng-disabled=\"$rootScope.loadingProgress\" \nclass=\"md-raised md-primary\" aria-label=\"change Staus\" ng-click=\"vm.updateProvider()\" translate \ntranslate-attr-aria-label=\"QUOTATION.ORDER_DETAILS\"><span>{{\'ORDER.UPDATE_PROVIDER\'| translate}}</span><md-tooltip \nmd-direction=\"top\" md-visible=\"tooltipVisible\">{{\'ORDER.UPDATE_PROVIDER\'| translate}}</md-tooltip></md-button></div>\n<div class=\"customer\" layout=\"column\" flex><md-button ng-show=\"vm.canCancelPurchase && vm.quantityDays>0\" \nng-disabled=\"$rootScope.loadingProgress\" class=\"md-raised md-warn\" aria-label=\"change Staus\" \nng-click=\"vm.cancelPurchase()\" translate translate-attr-aria-label=\"QUOTATION.ORDER_DETAILS\"><div>\n{{\'ORDER.CANCEL_PURCHASE\'| translate}}<br>[{{vm.quantityDays}} {{\"ORDER.DAYS\" | translate}}]</div><md-tooltip \nmd-direction=\"top\" md-visible=\"tooltipVisible\">{{\'ORDER.CANCEL_PURCHASE\'| translate}}</md-tooltip></md-button></div>\n</div></div><md-content class=\"content\" flex ms-scroll><div class=\"content fullpage-datatable\" layout=\"column\" flex>\n<md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loading\" class=\"md-accent\"></md-progress-linear><div \nid=\"masterGridOptionsOC\" ag-grid=\"vm.masterGridOptions\" class=\"ag-fresh\" expand-grid min=\"260\" other=\"-10\"></div></div>\n</md-content></div></div></div><md-button class=\"md-fab md-fab-bottom-right\" aria-label=\"addDetail\" \nng-disabled=\"vm.petition <= 0\" ng-click=\"vm.saveEntries($event)\"><md-icon md-font-icon=\"icon-content-save\"></md-icon>\n</md-button>");
$templateCache.put("app/main/apps/order/order/order_view.html","<div id=\"budgetO\" class=\"page-layout carded fullwidth\" layout=\"column\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" \nlayout=\"row\" layout-align=\"start center\" flex><md-button class=\"goto-orders-button md-icon-button\" \naria-label=\"Go to orders\" ng-click=\"vm.gotoOrders()\" translate translate-attr-aria-label=\"ORDER.GO_TO_ORDERS\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"column\" layout-align=\"start start\"><div class=\"h2\">\n<span translate=\"ORDER.ORDER\">Order</span> <span>{{vm.order.id}}</span></div><div class=\"subtitle secondary-text\">\n</div></div></div></div><md-tabs md-selected=\"vm.currentTab\" ng-if=\"vm.showProcessFlow\"><md-tab id=\"tab1\" \naria-controls=\"tab1-content\"><md-tab-label><md-icon md-font-icon=\"icon-indent\"></md-icon><span \ntranslate=\"REQUISITION.ENCABEZADO\">Detalles</span></md-tab-label></md-tab><md-tab id=\"tab2\" \naria-controls=\"tab2-content\"><md-icon md-font-icon=\"icon-cube-unfolded\"></md-icon><span \ntranslate=\"REPORT.PROCESS_FLOW.FLOW\">Diagrama</span></md-tab></md-tabs><md-content class=\"content\" flex ms-scroll>\n<md-tabs md-dynamic-height md-selected=\"vm.currentTab\" class=\"tab-in-content\"><md-tab aria-controls=\"tab1-content\">\n<md-tab-body><div class=\"content-card\" layout=\"column\" flex><div \nng-class=\"vm.dinamicSize > 900 ? \'toolbar\' : \'customer-toolbar\'\"><div layout=\"row\"><div class=\"customer\" \nlayout=\"column\" flex><span><strong translate=\"ORDER.DEPARTMENT\"></strong> {{vm.order.department.description}}</span> \n<span><strong translate=\"ORDER.COST_CENTER\"></strong> {{vm.order.costCenter.description}}</span> <span><strong \ntranslate=\"ORDER.PURCHASESTATUS\"></strong> {{vm.order.purchaseStatus.description}}</span></div><div \nclass=\"customer line\" layout=\"column\" flex><span><strong translate=\"ORDER.PROVIDER\"></strong>\n {{vm.order.companyProvider.name}}</span> <span><strong translate=\"ORDER.BUYER\"></strong> {{vm.order.company.name}}\n</span> <span><strong translate=\"ORDER.TOTAL\"></strong> {{vm.order.total| number:2}}</span></div><div \nclass=\"customer line\" layout=\"column\" flex><span ng-if=\"vm.order.dimensionCompanyDetail3\"><strong>\n{{vm.dimensionCompanyDetail3.description}}</strong> {{vm.order.dimensionCompanyDetail3.name}} </span><span \nng-if=\"vm.order.dimensionCompanyDetail4\"><strong>{{vm.dimensionCompanyDetail4.description}}</strong>\n {{vm.order.dimensionCompanyDetail4.name}} </span><span ng-if=\"vm.order.dimensionCompanyDetail5\"><strong>\n{{vm.dimensionCompanyDetail5.description}}</strong> {{vm.order.dimensionCompanyDetail5.name}}</span></div><div \nclass=\"customer\" layout=\"column\" flex><md-button ng-show=\"vm.reasignProvider && vm.details.length > 0\" \nng-disabled=\"$rootScope.loadingProgress\" class=\"md-raised md-primary\" aria-label=\"change Staus\" \nng-click=\"vm.updateProvider()\" translate translate-attr-aria-label=\"QUOTATION.ORDER_DETAILS\"><span>\n{{\'ORDER.UPDATE_PROVIDER\'| translate}}</span><md-tooltip md-direction=\"top\" md-visible=\"tooltipVisible\">\n{{\'ORDER.UPDATE_PROVIDER\'| translate}}</md-tooltip></md-button></div><div class=\"customer\" layout=\"column\" flex>\n<md-button ng-show=\"vm.PIC\" ng-disabled=\"$rootScope.loadingProgress\" class=\"md-raised md-primary\" \naria-label=\"change Staus\" ng-click=\"vm.approvePurchase()\" translate \ntranslate-attr-aria-label=\"QUOTATION.ORDER_DETAILS\"><span>{{\'ORDER.APPROVE_PURCHASE\'| translate}}</span><md-tooltip \nmd-direction=\"top\" md-visible=\"tooltipVisible\">{{\'ORDER.APPROVE_PURCHASE\'| translate}}</md-tooltip></md-button>\n<md-button ng-show=\"vm.canCancelPurchase && vm.quantityDays>0\" ng-disabled=\"$rootScope.loadingProgress\" \nclass=\"md-raised md-warn\" aria-label=\"change Staus\" ng-click=\"vm.cancelPurchase()\" translate \ntranslate-attr-aria-label=\"QUOTATION.ORDER_DETAILS\"><div>{{\'ORDER.CANCEL_PURCHASE\'| translate}}<br>\n[{{vm.quantityDays}} {{\"ORDER.DAYS\" | translate}}]</div><md-tooltip md-direction=\"top\" md-visible=\"tooltipVisible\">\n{{\'ORDER.CANCEL_PURCHASE\'| translate}}</md-tooltip></md-button><md-button ng-show=\"vm.details.length > 0\" \nng-disabled=\"(!vm.purchaseOrderDetailToInvoice || vm.purchaseOrderDetailToInvoice.length<=0) || $rootScope.loadingProgress || vm.petitionInvoice<=0\" \nclass=\"md-raised md-primary\" aria-label=\"change Staus\" ng-click=\"vm.invoicePurchaseOrderDetail($event)\" translate \ntranslate-attr-aria-label=\"QUOTATION.ORDER_DETAILS\"><span>{{\'ORDER.INVOICE_PURCHASE\'| translate}}</span><md-tooltip \nmd-direction=\"top\" md-visible=\"tooltipVisible\">{{\'ORDER.INVOICE_PURCHASE\'| translate}}</md-tooltip></md-button></div>\n</div></div><md-content class=\"content\" flex ms-scroll><div class=\"content fullpage-datatable\" layout=\"column\" flex>\n<md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loading\" class=\"md-accent\"></md-progress-linear><div \nid=\"masterGridOptionsOC\" ag-grid=\"vm.masterGridOptions\" class=\"ag-fresh\" expand-grid min=\"260\" other=\"100\"></div></div>\n</md-content></div></md-tab-body></md-tab><md-tab aria-controls=\"tab2-content\"><md-tab-body><div \nng-include=\"\'app/main/apps/reports/process-flow/process-flow.html\'\"></div></md-tab-body></md-tab></md-tabs>\n</md-content></div></div><md-button class=\"md-fab md-fab-bottom-right\" aria-label=\"addDetail\" ng-if=\"vm.type === \'P\'\" \nng-disabled=\"vm.petition <= 0\" ng-click=\"vm.saveShippingOrder($event)\"><md-icon md-font-icon=\"icon-send\"></md-icon>\n<md-tooltip md-direction=\"left\">{{\'ORDER.SHIPPING_ORDER\'| translate}}</md-tooltip></md-button>");
$templateCache.put("app/main/apps/order/order-provider/order-provider.html","<div id=\"budgetO\" class=\"page-layout carded fullwidth\" layout=\"column\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" \nlayout=\"row\" layout-align=\"start center\" flex><md-button class=\"goto-orders-button md-icon-button\" \naria-label=\"Go to orders\" ng-click=\"vm.gotoOrders()\" translate translate-attr-aria-label=\"ORDER.GO_TO_ORDERS\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"column\" layout-align=\"start start\"><div class=\"h2\">\n<span translate=\"ORDER.ORDER\">Order</span> <span>{{vm.order.id}}</span></div><div class=\"subtitle secondary-text\">\n</div></div></div></div><md-tabs md-selected=\"vm.currentTab\"><md-tab id=\"tab1\" aria-controls=\"tab1-content\">\n<md-tab-label><md-icon md-font-icon=\"icon-indent\"></md-icon><span translate=\"REQUISITION.ENCABEZADO\">Detalles</span>\n</md-tab-label></md-tab><md-tab id=\"tab2\" aria-controls=\"tab2-content\" ng-if=\"vm.detailsInvoice.length > 0\"><md-icon \nmd-font-icon=\"icon-cube-unfolded\"></md-icon><span translate=\"INVOICE.INVOICE\">Invoice</span></md-tab></md-tabs>\n<md-content class=\"content\" flex ms-scroll><md-tabs md-dynamic-height md-selected=\"vm.currentTab\" \nclass=\"tab-in-content\"><md-tab aria-controls=\"tab1-content\"><md-tab-body><div class=\"content-card\" layout=\"column\" \nflex><div ng-class=\"vm.dinamicSize > 900 ? \'toolbar\' : \'customer-toolbar\'\"><div layout=\"row\"><div class=\"customer\" \nlayout=\"column\" flex><span><strong translate=\"ORDER.DEPARTMENT\"></strong> {{vm.order.department.description}}</span> \n<span><strong translate=\"ORDER.COST_CENTER\"></strong> {{vm.order.costCenter.description}}</span> <span><strong \ntranslate=\"ORDER.PURCHASESTATUS\"></strong> {{vm.order.purchaseStatus.description}}</span></div><div \nclass=\"customer line\" layout=\"column\" flex><span><strong translate=\"ORDER.PROVIDER\"></strong>\n {{vm.order.companyProvider.name}}</span> <span><strong translate=\"ORDER.BUYER\"></strong> {{vm.order.company.name}}\n</span> <span><strong translate=\"ORDER.TOTAL\"></strong> {{vm.order.total| number:2}}</span></div><div \nclass=\"customer line\" layout=\"column\" flex><span ng-if=\"vm.order.dimensionCompanyDetail3\"><strong>\n{{vm.dimensionCompanyDetail3.description}}</strong> {{vm.order.dimensionCompanyDetail3.name}} </span><span \nng-if=\"vm.order.dimensionCompanyDetail4\"><strong>{{vm.dimensionCompanyDetail4.description}}</strong>\n {{vm.order.dimensionCompanyDetail4.name}} </span><span ng-if=\"vm.order.dimensionCompanyDetail5\"><strong>\n{{vm.dimensionCompanyDetail5.description}}</strong> {{vm.order.dimensionCompanyDetail5.name}}</span></div><div \nclass=\"customer\" layout=\"column\" flex><md-button ng-show=\"vm.completedAllFeatures\" \nng-disabled=\"$rootScope.loadingProgress\" class=\"md-raised md-primary\" aria-label=\"change Staus\" \nng-click=\"vm.approvePurchase()\" translate translate-attr-aria-label=\"QUOTATION.ORDER_DETAILS\"><span>\n{{\'ORDER.APPROVE_PURCHASE\'| translate}}</span><md-tooltip md-direction=\"top\" md-visible=\"tooltipVisible\">\n{{\'ORDER.CANCEL_PURCHASE\'| translate}}</md-tooltip></md-button></div></div></div><md-content class=\"content\" flex \nms-scroll><div class=\"content fullpage-datatable\" layout=\"column\" flex><md-progress-linear md-mode=\"indeterminate\" \nng-if=\"vm.loading\" class=\"md-accent\"></md-progress-linear><div id=\"masterGridOptionsOC\" ag-grid=\"vm.masterGridOptions\" \nclass=\"ag-fresh\" expand-grid min=\"260\" other=\"-10\"></div></div></md-content></div></md-tab-body></md-tab><md-tab \naria-controls=\"tab2-content\" ng-show=\"vm.detailsInvoice.length > 0\"><md-tab-body><div \nclass=\"order-detail-form-container products md-background-bg md-whiteframe-1dp\"><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loading\" \nclass=\"md-accent\"></md-progress-linear><div id=\"masterGridOptionsInvoice\" ag-grid=\"vm.masterGridOptionsInvoice\" \nclass=\"ag-fresh\" expand-grid min=\"260\" other=\"100\"></div></div></div></md-tab-body></md-tab></md-tabs></md-content>\n</div></div>");
$templateCache.put("app/main/apps/order/order-report/order-report.html","<div id=\"mail\" class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"search-wrapper md-whiteframe-4dp\" layout=\"row\" layout-align=\"start center\" flex><div class=\"search\" flex \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><input \nng-enter=\"vm.getRequisition(vm.search)\" flex ng-model=\"vm.search\" type=\"number\" \nplaceholder=\"Search for an e-mail or contact\" translate translate-attr-placeholder=\"ORDER.SEARCH_PLACEHOLDER_ORDER\">\n<md-button class=\"md-icon-button\" ng-click=\"vm.getRequisition(vm.search)\" aria-label=\"Back\" translate \ntranslate-attr-aria-label=\"MAIL.BACK\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button></div></div></div><div\n class=\"content-card\" layout=\"column\" flex><div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\" \nng-if=\"vm.activeMailPaneIndex === 0\"><div layout=\"row\" layout-align=\"start center\"></div></div><div class=\"data\" \nlayout=\"column\" flex ng-if=\"vm.requisition.id\"><md-tabs md-selected=\"vm.currentTab\"><md-tab id=\"tab1\" \naria-controls=\"tab1-content\"><md-tab-label><md-icon md-font-icon=\"icon-indent\"></md-icon><span \ntranslate=\"REQUISITION.ENCABEZADO\">Requisition Details</span></md-tab-label></md-tab><md-tab id=\"tab2\" \naria-controls=\"tab2-content\"><md-tab-label><md-icon md-font-icon=\"icon-cube-unfolded\"></md-icon><span \ntranslate=\"REPORT.PROCESS_FLOW.FLOW\">Diagrama</span></md-tab-label></md-tab><md-tab id=\"tab3\" \naria-controls=\"tab3-content\" ng-if=\"vm.quotationsDetails.length > 0\"><md-tab-label><md-icon \nmd-font-icon=\"icon-cash-100\"></md-icon><span translate=\"QUOTATION.QUOTATION\">Quotation</span></md-tab-label></md-tab>\n<md-tab id=\"tab4\" aria-controls=\"tab4-content\" ng-if=\"vm.detailsPurchaseOrder.length > 0\"><md-tab-label><md-icon \nmd-font-icon=\"icon-cart\"></md-icon><span translate=\"ORDER.ORDER\">PurchaseOrder</span></md-tab-label></md-tab><md-tab \nid=\"tab5\" aria-controls=\"tab5-content\" ng-if=\"vm.detailsInvoice.length > 0\"><md-tab-label><md-icon \nmd-font-icon=\"icon-receipt\"></md-icon><span translate=\"INVOICE.INVOICE\">Invoice</span></md-tab-label></md-tab>\n</md-tabs><md-content class=\"content\" flex ms-scroll><md-tabs md-dynamic-height md-selected=\"vm.currentTab\" \nclass=\"tab-in-content\"><md-tab aria-controls=\"tab1-content\"><md-tab-body><div class=\"content-card\" layout=\"column\" \nflex><div ng-class=\"vm.dinamicSize > 900 ? \'toolbar\' : \'customer-toolbar\'\"><div layout=\"row\"><div class=\"customer\" \nlayout=\"column\"><span><strong translate=\"REQUISITION.DEPARTMENT\"></strong> {{vm.requisition.department.description}}\n</span> <span><strong translate=\"REQUISITION.COST_CENTER\"></strong> {{vm.requisition.costCenter.description}}</span> \n<span><strong translate=\"REQUISITION.MAXDATEPURCHASE\"></strong> {{vm.requisition.maxDatePurchase| date: \'dd-MM-yyyy\'}}\n</span> <span ng-if=\"vm.requisition.referenceId\"><strong translate=\"REQUISITION.ORIGIN\"></strong> <a target=\"_blank\" \nhref=\"{{vm.requisition.originType.queryUrl}}{{vm.requisition.referenceId}}\">\n{{vm.replaceOriginTypedata(vm.requisition, vm.requisition.originType.originTypeUrlDescription)}}</a></span></div><div \nclass=\"customer line\" layout=\"column\"><span><strong translate=\"REQUISITION.STATUS\"></strong>\n {{vm.requisition.purchaseStatus.description}}</span> <span><strong translate=\"REQUISITION.REQUISITION_TYPE\"></strong>\n {{vm.requisition.requisitionType.description}}</span> <span><strong translate=\"REQUISITION.DESCRIPTION\"></strong>\n {{vm.requisition.description}}</span> <span><strong translate=\"CONTRACT.DATE_CREATED\"></strong>\n {{vm.requisition.createdAt.dayOfMonth}}/{{vm.requisition.createdAt.monthValue}}/{{vm.requisition.createdAt.year}} \n</span><span><strong translate=\"CONTRACT.BY_CREATED\"></strong> {{vm.requisition.createdBy}}</span></div><div \nclass=\"customer line\" layout=\"column\" flex \nng-if=\"\n                                             (vm.dimensionCompanyDetail3 && vm.order.dimensionCompanyDetail3.name)\n                                             || (vm.dimensionCompanyDetail4 && vm.order.dimensionCompanyDetail4.name)\n                                             || (vm.dimensionCompanyDetail5 && vm.order.dimensionCompanyDetail5.name)\">\n<span ng-if=\"vm.order.dimensionCompanyDetail3\"><strong>{{vm.dimensionCompanyDetail3.description}}</strong>\n {{vm.order.dimensionCompanyDetail3.name}} </span><span ng-if=\"vm.order.dimensionCompanyDetail4\"><strong>\n{{vm.dimensionCompanyDetail4.description}}</strong> {{vm.order.dimensionCompanyDetail4.name}} </span><span \nng-if=\"vm.order.dimensionCompanyDetail5\"><strong>{{vm.dimensionCompanyDetail5.description}}</strong>\n {{vm.order.dimensionCompanyDetail5.name}}</span></div><div class=\"customer line\" layout=\"column\"><span \nng-if=\"vm.requisition.originType && vm.requisition.originType.originTypeCode === \'01\' && vm.requisition.urgentPurchase\">\n<strong translate=\"REQUISITION.PURCHASE_TYPE\"></strong>{{\"REQUISITION.MSG.URGENT_PURCHASE\"| translate}} </span><span \nng-if=\"vm.requisition.originType && vm.requisition.originType.originTypeCode === \'01\' && vm.requisition.departmentFirsRecept\">\n<strong translate=\"REQUISITION.DEPARTMENT_FIRST_RECEPT\"></strong> {{vm.requisition.departmentFirsRecept.description}}\n</span></div><div class=\"customer\" layout=\"column\" flex ng-if=\"vm.cancelPurchaseOrder\"><md-button \nng-show=\"vm.reasignProvider && vm.details.length > 0\" ng-disabled=\"$rootScope.loadingProgress\" \nclass=\"md-raised md-primary\" aria-label=\"change Staus\" ng-click=\"vm.updateProvider()\" translate \ntranslate-attr-aria-label=\"QUOTATION.ORDER_DETAILS\"><span>{{\'ORDER.UPDATE_PROVIDER\'| translate}}</span><md-tooltip \nmd-direction=\"top\" md-visible=\"tooltipVisible\">{{\'ORDER.UPDATE_PROVIDER\'| translate}}</md-tooltip></md-button>\n<md-button ng-show=\"vm.canCancelPurchase && vm.quantityDays>0\" ng-disabled=\"$rootScope.loadingProgress\" \nclass=\"md-raised md-warn\" aria-label=\"change Staus\" ng-click=\"vm.cancelPurchase()\" translate \ntranslate-attr-aria-label=\"QUOTATION.ORDER_DETAILS\"><div>{{\'ORDER.CANCEL_PURCHASE\'| translate}}<br>\n[{{vm.quantityDays}} {{\"ORDER.DAYS\" | translate}}]</div><md-tooltip md-direction=\"top\" md-visible=\"tooltipVisible\">\n{{\'ORDER.CANCEL_PURCHASE\'| translate}}</md-tooltip></md-button></div></div></div><div \nclass=\"md-background-bg md-whiteframe-1dp\"><div class=\"content fullpage-datatable\" layout=\"column\" flex>\n<md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loading\" class=\"md-accent\"></md-progress-linear><div \nid=\"masterGridOptions\" ag-grid=\"vm.masterGridOptions\" class=\"ag-fresh\" expand-grid min=\"260\" other=\"200\"></div></div>\n</div></div></md-tab-body></md-tab><md-tab aria-controls=\"tab2-content\"><md-tab-body><div \nng-include=\"\'app/main/apps/reports/process-flow/process-flow.html\'\"></div></md-tab-body></md-tab><md-tab \naria-controls=\"tab3-content\" ng-show=\"vm.quotationsDetails.length > 0\"><md-tab-body><div \nclass=\"order-detail-form-container products md-background-bg md-whiteframe-1dp\" ng-show=\"vm.details.length > 0\"><div \nclass=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex>\n<md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loading\" class=\"md-accent\"></md-progress-linear><div \nid=\"masterGridOptionsQuotation\" ag-grid=\"vm.masterGridOptionsQuotation\" class=\"ag-fresh\" expand-grid min=\"260\" \nother=\"100\"></div></div></div></div></md-tab-body></md-tab><md-tab aria-controls=\"tab4-content\" \nng-show=\"vm.detailsPurchaseOrder.length > 0\"><md-tab-body><div \nclass=\"order-detail-form-container products md-background-bg md-whiteframe-1dp\"><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loading\" \nclass=\"md-accent\"></md-progress-linear><div id=\"masterGridOptionsPurchaseOrder\" \nag-grid=\"vm.masterGridOptionsPurchaseOrder\" class=\"ag-fresh\" expand-grid min=\"260\" other=\"100\"></div></div></div>\n</md-tab-body></md-tab><md-tab aria-controls=\"tab5-content\" ng-show=\"vm.detailsInvoice.length > 0\"><md-tab-body><div \nclass=\"order-detail-form-container products md-background-bg md-whiteframe-1dp\"><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loading\" \nclass=\"md-accent\"></md-progress-linear><div id=\"masterGridOptionsInvoice\" ag-grid=\"vm.masterGridOptionsInvoice\" \nclass=\"ag-fresh\" expand-grid min=\"260\" other=\"100\"></div></div></div></md-tab-body></md-tab></md-tabs></md-content>\n</div><div ng-show=\"false\" id=\"masterGridOptionsQuotation\" ag-grid=\"vm.masterGridOptionsQuotation\" class=\"ag-fresh\" \nexpand-grid min=\"260\" other=\"100\"></div><div class=\"data\" layout=\"column\" flex ng-if=\"vm.contractPurchase.id\"><md-tabs \nmd-selected=\"vm.currentTab\" ng-if=\"vm.showProcessFlow\"><md-tab id=\"tab1\" aria-controls=\"tab1-content\"><md-tab-label>\n<md-icon md-font-icon=\"icon-indent\"></md-icon><span translate=\"REQUISITION.ENCABEZADO\">Detalles</span></md-tab-label>\n</md-tab><md-tab id=\"tab2\" aria-controls=\"tab2-content\"><md-tab-label><md-icon md-font-icon=\"icon-indent\"></md-icon>\n<span translate=\"CONTRACT.NOPAYMENTS\">Cuotas</span></md-tab-label></md-tab><md-tab id=\"tab3\" \naria-controls=\"tab3-content\"><md-icon md-font-icon=\"icon-cube-unfolded\"></md-icon><span \ntranslate=\"REPORT.PROCESS_FLOW.FLOW\">Diagrama</span></md-tab><md-tab id=\"tab4\" aria-controls=\"tab4-content\" \nng-if=\"vm.detailsPurchaseOrder.length > 0\"><md-icon md-font-icon=\"icon-cart\"></md-icon><span translate=\"ORDER.ORDER\">\nPurchaseOrder</span></md-tab><md-tab id=\"tab5\" aria-controls=\"tab5-content\" ng-if=\"vm.detailsInvoice.length > 0\">\n<md-icon md-font-icon=\"icon-receipt\"></md-icon><span translate=\"INVOICE.INVOICE\" \nng-show=\"vm.detailsInvoice.length > 0\">Invoice</span></md-tab></md-tabs><md-content class=\"content\" flex ms-scroll>\n<md-tabs md-dynamic-height md-selected=\"vm.currentTab\" class=\"tab-in-content\"><md-tab aria-controls=\"tab1-content\" \nng-show=\"vm.details.length > 0\"><md-tab-body><div class=\"content-card\" layout=\"column\" flex><div \nng-class=\"vm.dinamicSize > 900 ? \'toolbar\' : \'customer-toolbar\'\"><div layout=\"row\"><div class=\"customer\" \nlayout=\"column\"><span><strong translate=\"CONTRACT.DEPARTMENT\"></strong> {{vm.contractPurchase.department.description}}\n</span> <span><strong translate=\"CONTRACT.COST_CENTER\"></strong> {{vm.contractPurchase.costCenter.description}}</span> \n<span><strong translate=\"CONTRACT.TYPE\"></strong> {{vm.contractPurchase.contractType.name}}</span></div><div \nclass=\"customer\" layout=\"column\" style=\"margin-left: 50px\"><span><strong translate=\"CONTRACT.PAYMENTS\"></strong>\n {{vm.contractPurchase.payments}}</span> <span><strong translate=\"CONTRACT.TOTAL\"></strong>\n {{vm.contractPurchase.currency.symbol}}{{vm.contractPurchase.total| number:2}}</span></div><div class=\"customer\" \nlayout=\"column\" style=\"margin-left: 50px\"><span><strong translate=\"CONTRACT.DATE_CREATED\"></strong>\n {{vm.contractPurchase.createdAt.dayOfMonth}} / {{vm.contractPurchase.createdAt.monthValue}} / {{vm.contractPurchase.createdAt.year}}\n</span> <span><strong translate=\"CONTRACT.BY_CREATED\"></strong> {{vm.contractPurchase.createdBy}}</span></div><div \nclass=\"customer line\" layout=\"column\" flex><span ng-if=\"vm.order.dimensionCompanyDetail3\"><strong>\n{{vm.dimensionCompanyDetail3.description}}</strong> {{vm.order.dimensionCompanyDetail3.name}} </span><span \nng-if=\"vm.order.dimensionCompanyDetail4\"><strong>{{vm.dimensionCompanyDetail4.description}}</strong>\n {{vm.order.dimensionCompanyDetail4.name}} </span><span ng-if=\"vm.order.dimensionCompanyDetail5\"><strong>\n{{vm.dimensionCompanyDetail5.description}}</strong> {{vm.order.dimensionCompanyDetail5.name}}</span></div></div></div>\n<div class=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex>\n<md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loading\" class=\"md-accent\"></md-progress-linear><div \nid=\"masterGridOptionsE\" ag-grid=\"vm.masterGridOptionsE\" class=\"ag-fresh\" expand-grid min=\"260\" other=\"200\"></div></div>\n</div></div></md-tab-body></md-tab><md-tab aria-controls=\"tab2-content\" ng-show=\"vm.details.length > 0\"><md-tab-body>\n<div class=\"content-card\" layout=\"column\" flex><div \nclass=\"order-detail-form-container products md-background-bg md-whiteframe-1dp\"><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loading\" \nclass=\"md-accent\"></md-progress-linear><div id=\"masterGridOptionsPurchaseOrderCuot\" ag-grid=\"vm.masterGridOptionsCuot\" \nclass=\"ag-fresh\" expand-grid min=\"260\" other=\"300\"></div></div></div></div></md-tab-body></md-tab><md-tab \naria-controls=\"tab3-content\" ng-show=\"vm.details.length > 0\"><md-tab-body><div \nng-include=\"\'app/main/apps/reports/process-flow/process-flow.html\'\"></div></md-tab-body></md-tab><md-tab \naria-controls=\"tab4-content\" ng-show=\"vm.detailsPurchaseOrder.length > 0\"><md-tab-body><md-tab-body><div \nclass=\"order-detail-form-container products md-background-bg md-whiteframe-1dp\"><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loading\" \nclass=\"md-accent\"></md-progress-linear><div id=\"masterGridOptionsPurchaseOrder2\" \nag-grid=\"vm.masterGridOptionsPurchaseOrder\" class=\"ag-fresh\" expand-grid min=\"260\" other=\"100\"></div></div></div>\n</md-tab-body></md-tab-body></md-tab><md-tab aria-controls=\"tab5-content\" ng-show=\"vm.detailsInvoice.length > 0\">\n<md-tab-body><div class=\"order-detail-form-container products md-background-bg md-whiteframe-1dp\"><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loading\" \nclass=\"md-accent\"></md-progress-linear><div id=\"masterGridOptionsInvoice2\" ag-grid=\"vm.masterGridOptionsInvoice\" \nclass=\"ag-fresh\" expand-grid min=\"260\" other=\"100\"></div></div></div></md-tab-body></md-tab></md-tabs></md-content>\n</div></div></div></div>");
$templateCache.put("app/main/apps/physicalDocumentDelivery/pendingDelivery/pendingDelivery.html","<div id=\"requisition\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-truck\"></md-icon><span>{{\'physicalDocumentDelivery.pendingDelivery\' | translate}}</span>\n</div><div class=\"order-count secondary-text\"><span>{{vm.requisitions.length}}</span></div></div><div class=\"search\" \nlayout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\">\n</md-icon><input id=\"e-commerce-products-search\" ng-model=\"vm.search\" class=\"search-input\" type=\"text\" \nplaceholder=\"Search\" translate translate-attr-placeholder=\"REQUISITION.SEARCH\" ng-model-options=\"{\'debounce\': 300}\" \nflex></div></div><div class=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" \nlayout=\"column\" flex><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loading\" class=\"md-accent\">\n</md-progress-linear><div id=\"masterGridOptions\" ag-grid=\"vm.masterGridOptions\" class=\"ag-fresh\" expand-grid min=\"260\" \nother=\"-10\"></div></div></div></div></div>");
$templateCache.put("app/main/apps/physicalDocumentDelivery/prepareDelivery/prepareDelivery.html","<div id=\"budgetO\" class=\"page-layout carded fullwidth\" layout=\"column\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" \nlayout=\"row\" layout-align=\"start center\" flex><div layout=\"column\" layout-align=\"start start\"><div class=\"h2\"><md-icon \nmd-font-icon=\"icon-clock\"></md-icon><span translate=\"physicalDocumentDelivery.prepareDelivery\">prepareDelivery</span> \n<span>{{vm.physicalDocument.id}}</span></div><div class=\"subtitle secondary-text\" layout-align=\"start center\"></div>\n</div></div></div><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div class=\"white-fg\" \nlayout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"></div><div \nclass=\"order-count secondary-text\"></div></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex \nstyle=\"margin-top: -35px\"><md-input-container flex-gt-xs style=\"margin-top:-10px\"><label \ntranslate=\"physicalDocumentDelivery.Treasures\">Treasures</label><md-select \nng-model=\"vm.physicalDocument.userTreasurer.id\" name=\"userTreasurer\" required ng-disabled=\"vm.loadingTreasures\" \nmd-on-close=\"vm.clearSearchUserTreasurer()\" ng-change=\"vm.focusBarcode()\"><md-select-header><input \nid=\"searchUserTreasurer\" ng-model=\"vm.searchUserTreasurer\" type=\"search\" placeholder=\"Buscar\"></md-select-header>\n<md-optgroup label=\"treasures\"><md-option value=\"{{row.id}}\" \nng-repeat=\"row in vm.treasures| filter:vm.searchUserTreasurer\">{{row.name}} - {{row.account}}</md-option></md-optgroup>\n</md-select><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loadingTreasures\"></md-progress-linear><div \nng-messages=\"vm.physicalDocumentForm.treasure.$error\"><div ng-message=\"required\" \ntranslate=\"physicalDocument.ERROR.FIELD_REQUIRED\">This is required!</div></div></md-input-container></div></div><div \nclass=\"content-card\" layout=\"column\" flex><div class=\"toolbar\"><div layout=\"row\" layout-align=\"end center\">\n<md-input-container flex></md-input-container><md-input-container flex><label \ntranslate=\"physicalDocumentDelivery.barCode\">barCode</label><input id=\"barCode\" name=\"barCode\" \nng-model=\"vm.physicalDocument.barCode\" type=\"text\" ng-enter=\"vm.validatePhysicalDocument()\"><div \nng-messages=\"vm.physicalDocumentForm.barCode.$error\"><div ng-message=\"required\" \ntranslate=\"physicalDocument.ERROR.FIELD_REQUIRED\">This is required!</div></div></md-input-container><md-input-container\n flex><div layout=\"row\" layout-align=\"end center\"><md-button style=\"margin-top: -50px\" ng-show=\"vm.detail.length > 0\" \nng-disabled=\"$rootScope.loadingProgress\" class=\"md-raised md-primary\" ng-click=\"vm.presentPhysicalDocumentDelivery()\" \naria-label=\"present budget\" translate translate-attr-aria-label=\"REQUISITION.ORDER_DETAILS\"><span>\n{{\"physicalDocumentDelivery.STATUSCHANGE.\" + vm.statusToChange| translate}}</span><md-tooltip md-direction=\"top\" \nmd-visible=\"tooltipVisible\">{{\'physicalDocumentDelivery.STATUSCHANGE.\' + vm.statusToChange| translate}}</md-tooltip>\n</md-button><md-button style=\"margin-top: -50px\" ng-show=\"vm.detail.length > 0\" \nng-disabled=\"$rootScope.loadingProgress\" class=\"md-raised md-warn\" ng-click=\"vm.cancelPhysicalDocumentDelivery()\" \naria-label=\"present budget\" translate translate-attr-aria-label=\"REQUISITION.ORDER_DETAILS\"><span>\n{{\"physicalDocumentDelivery.STATUSCHANGE.cancelPhysicalDocumentDelivery\" | translate}}</span><md-tooltip \nmd-direction=\"top\" md-visible=\"tooltipVisible\">\n{{\'physicalDocumentDelivery.STATUSCHANGE.cancelPhysicalDocumentDelivery\' | translate}}</md-tooltip></md-button></div>\n</md-input-container></div></div><md-content class=\"content\" flex ms-scroll><md-progress-linear \nmd-mode=\"indeterminate\" ng-if=\"vm.loading\" class=\"md-accent\"></md-progress-linear><div ng-show=\"vm.detail.length>0\" \nid=\"masterGridOptionsR\" ag-grid=\"vm.masterGridOptions\" class=\"ag-fresh\" expand-grid min=\"260\" other=\"205\"></div>\n</md-content></div></div></div>");
$templateCache.put("app/main/apps/physicalDocumentDelivery/view/view.html","<div id=\"budgetO\" class=\"page-layout carded fullwidth\" layout=\"column\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" \nlayout=\"row\" layout-align=\"start center\" flex><md-button class=\"goto-orders-button md-icon-button\" \naria-label=\"Go to orders\" ng-click=\"vm.goToPhysicalDocumentDelivery()\" translate \ntranslate-attr-aria-label=\"physicalDocumentDelivery.physicalDocumentDelivery\"><md-icon md-font-icon=\"icon-arrow-left\">\n</md-icon></md-button><div layout=\"column\" layout-align=\"start start\"><div class=\"h2\"><md-icon \nmd-font-icon=\"icon-clock\"></md-icon><span>{{vm.title | translate}}</span> <span>{{vm.physicalDocument.id}}</span></div>\n<div class=\"subtitle secondary-text\" layout-align=\"start center\"></div></div></div></div><div class=\"header\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div \nclass=\"h1\" layout=\"row\" layout-align=\"start center\"></div><div class=\"order-count secondary-text\"></div></div><div \nclass=\"search\" layout=\"row\" layout-align=\"start center\" flex style=\"margin-top: -35px\"><md-input-container flex-gt-xs \nstyle=\"margin-top:-10px\"><label translate=\"physicalDocumentDelivery.Treasures\">Treasures</label><md-select \nreadonly=\"true\" ng-model=\"vm.physicalDocument.userTreasurer.id\" name=\"userTreasurer\" required ng-disabled=\"true\" \nmd-on-close=\"vm.clearSearchUserTreasurer()\" ng-change=\"vm.focusBarcode()\"><md-select-header><input \nid=\"searchUserTreasurer\" ng-model=\"vm.searchUserTreasurer\" type=\"search\" placeholder=\"Buscar\"></md-select-header>\n<md-optgroup label=\"treasures\"><md-option value=\"{{row.id}}\" \nng-repeat=\"row in vm.treasures| filter:vm.searchUserTreasurer\">{{row.name}} - {{row.account}}</md-option></md-optgroup>\n</md-select><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loadingTreasures\"></md-progress-linear><div \nng-messages=\"vm.physicalDocumentForm.treasure.$error\"><div ng-message=\"required\" \ntranslate=\"physicalDocument.ERROR.FIELD_REQUIRED\">This is required!</div></div></md-input-container></div></div><div \nclass=\"content-card\" layout=\"column\" flex><div class=\"toolbar\"><div layout=\"row\" layout-align=\"end center\">\n<md-input-container flex></md-input-container><md-input-container flex></md-input-container><md-input-container flex>\n<div layout=\"row\" layout-align=\"end center\"><md-button style=\"margin-top: -10px\" \nng-show=\"vm.detail.length > 0 && vm.statusToChange\" ng-disabled=\"$rootScope.loadingProgress\" \nclass=\"md-raised md-primary\" ng-click=\"vm.presentPhysicalDocumentDelivery()\" aria-label=\"present budget\" translate \ntranslate-attr-aria-label=\"REQUISITION.ORDER_DETAILS\"><span>\n{{\"physicalDocumentDelivery.STATUSCHANGE.\" + vm.statusToChange| translate}}</span><md-tooltip md-direction=\"top\" \nmd-visible=\"tooltipVisible\">{{\'physicalDocumentDelivery.STATUSCHANGE.\' + vm.statusToChange| translate}}</md-tooltip>\n</md-button></div></md-input-container></div></div><md-content class=\"content\" flex ms-scroll><md-progress-linear \nmd-mode=\"indeterminate\" ng-if=\"vm.loading\" class=\"md-accent\"></md-progress-linear><div ng-show=\"vm.detail.length>0\" \nid=\"masterGridOptionsR\" ag-grid=\"vm.masterGridOptions\" class=\"ag-fresh\" expand-grid min=\"260\" other=\"205\"></div>\n</md-content></div></div></div>");
$templateCache.put("app/main/apps/quotation/pending-authorize/content.html","<div id=\"quotation-grid\" ag-grid=\"vm.gridOptions\" class=\"ag-fresh\" ng-show=\"vm.showGrid\" \nstyle=\"width: 100%; height: 100%\"></div>");
$templateCache.put("app/main/apps/quotation/pending-authorize/pending-authorize.html","<div id=\"quotation-pending-authorize\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div class=\"center\" \nlayout=\"column\" flex><div class=\"header\" layout-xl=\"row\" layout-align-xl=\"space-between center\" layout-lg=\"row\" \nlayout-align-lg=\"space-between center\" layout-xs=\"column\" layout-align-xs=\"none center\"><div class=\"white-fg\" \nlayout=\"column\" layout-align=\"space-between center\"><div class=\"title\" flex><span>\n{{\'authorize_quotations.quotations_to_be_authorized\'| translate}}</span></div><div class=\"order-count secondary-text\">\n<span translate=\"QUOTATION.TOTAL_QUOTATION\">Total Cotizaciones</span> <span>{{vm.totalPending}}</span></div></div><div \nclass=\"search\" layout=\"row\" layout-align=\"start center\" flex><input id=\"e-commerce-products-search\" \nng-model=\"vm.search\" class=\"search-input\" type=\"text\" placeholder=\"Search\" translate \ntranslate-attr-placeholder=\"INVOICE_MERCHANDISE_ENTRY.SEARCH\" ng-model-options=\"{\'debounce\': 300}\" flex></div>\n<md-button class=\"md-raised md-primary\" ng-disabled=\"vm.quotationsToAuthorize.length === 0\" \nng-click=\"vm.goToDetail($event)\">Ver detalles</md-button></div><md-card class=\"content-card\" ms-scroll flex \nlayout=\"column\" ng-include=\"\'app/main/apps/quotation/pending-authorize/content.html\'\"></md-card></div></div>");
$templateCache.put("app/main/apps/quotation/quotation/quotation_view.html","<div id=\"budgetO\" class=\"page-layout carded fullwidth\" layout=\"column\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" \nlayout=\"row\" layout-align=\"start center\" flex><md-button class=\"goto-orders-button md-icon-button\" \naria-label=\"Go to orders\" ng-click=\"vm.goToQuotations()\" translate translate-attr-aria-label=\"QUOTATION.GO_TO_ORDERS\">\n<md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"h2\"><span translate=\"QUOTATION.QUOTATION\">Order</span> <span>{{vm.quotation.id}}</span></div><div \nclass=\"subtitle secondary-text\"><span translate=\"REQUISITION.REQUISITION\">Requerimiento</span>\n #{{vm.quotation.requisition.id}}</div></div></div></div><md-tabs md-selected=\"vm.currentTab\" ng-if=\"vm.isClient\">\n<md-tab id=\"tab1\" aria-controls=\"tab1-content\"><md-tab-label><md-icon md-font-icon=\"icon-indent\"></md-icon><span \ntranslate=\"REQUISITION.ENCABEZADO\">Detalles</span></md-tab-label></md-tab><md-tab id=\"tab2\" \naria-controls=\"tab2-content\"><md-icon md-font-icon=\"icon-cube-unfolded\"></md-icon><span \ntranslate=\"REPORT.PROCESS_FLOW.FLOW\">Diagrama</span></md-tab></md-tabs><md-content class=\"content\" flex ms-scroll>\n<md-tabs md-dynamic-height md-selected=\"vm.currentTab\" class=\"tab-in-content\"><md-tab aria-controls=\"tab1-content\">\n<md-tab-body><div class=\"content-card\" layout=\"column\" flex><div class=\"toolbar\"><div layout=\"row\"><span flex></span>\n<md-button \nng-show=\"(vm.statusToChange.actual !== \'Autorizado\' && \n                                        vm.details.length > 0 && \n                                        !vm.isReport && vm.optionsTrue) || \n                                        (vm.statusToChange.actual === \'Autorizado\' && \n                                        vm.arrayAproveRefuse.length > 0 && \n                                        !vm.isReport && vm.optionsTrue)\" \nng-if=\"!vm.isCreatedQuotation\" \nng-disabled=\"$rootScope.loadingProgress || \n                                        (vm.isEnterFeatures === true && \n                                        vm.completedAllFeatures === false)\" \nclass=\"md-raised md-primary\" ng-click=\"vm.changeStatus()\" aria-label=\"change Staus\" translate \ntranslate-attr-aria-label=\"QUOTATION.ORDER_DETAILS\"><span>{{vm.statusToChange.buttonDescription| translate}}</span>\n<md-tooltip md-direction=\"top\" md-visible=\"tooltipVisible\">{{vm.statusToChange.buttonDescription| translate}}\n</md-tooltip></md-button><md-button ng-show=\"vm.statusToChange && vm.details.length > 0 && vm.actionmake\" \nng-if=\"vm.isCreatedQuotation\" ng-disabled=\"$rootScope.loadingProgress\" class=\"md-raised md-primary\" \nng-click=\"vm.changeStatus()\" aria-label=\"change Staus\" translate translate-attr-aria-label=\"QUOTATION.ORDER_DETAILS\">\n<span>{{\'QUOTATION.\' + vm.actionmake| translate}}</span><md-tooltip md-direction=\"top\" md-visible=\"tooltipVisible\">\n{{\'QUOTATION.\' + vm.actionmake| translate}}</md-tooltip></md-button><md-button \nng-show=\"!vm.statusToChange && vm.reasignProvider && vm.isClient\" ng-disabled=\"$rootScope.loadingProgress\" \nclass=\"md-raised md-primary\" aria-label=\"change Staus\" ng-click=\"vm.updateProvider()\" translate \ntranslate-attr-aria-label=\"QUOTATION.ORDER_DETAILS\"><span>{{\'QUOTATION.UPDATE_PROVIDER\'| translate}}</span><md-tooltip \nmd-direction=\"top\" md-visible=\"tooltipVisible\">{{\'QUOTATION.UPDATE_PROVIDER\'| translate}}</md-tooltip></md-button>\n<md-button \nng-show=\"vm.statusToChange && \n                                        vm.details.length > 0 && !vm.isClient && \n                                        !vm.isReport && vm.arrayAproveRefuse.length > 0 && \n                                        !vm.isReport\" \nng-if=\"!vm.isCreatedQuotation\" ng-disabled=\"$rootScope.loadingProgress\" class=\"md-raised md-warn\" \nng-click=\"vm.refuseQuotationStatus()\" aria-label=\"change Staus\" translate \ntranslate-attr-aria-label=\"QUOTATION.ORDER_DETAILS\"><span>{{\'QUOTATION.REFUSE_QUOTATION\'| translate}}</span><md-tooltip\n md-direction=\"top\" md-visible=\"tooltipVisible\">{{\'QUOTATION.REFUSE_QUOTATION\'| translate}}</md-tooltip></md-button>\n<md-button \nng-show=\"\n                                    vm.statusToChange.buttonDescription === \'QUOTATION.AUTHORIZE\' && \n                                        vm.details.length > 0 && \n                                        !vm.isReport\" \nng-disabled=\"$rootScope.loadingProgress\" class=\"md-raised md-warn\" ng-click=\"vm.changeCancelStatus()\" \naria-label=\"change Staus\" translate translate-attr-aria-label=\"QUOTATION.ORDER_DETAILS\"><span>\n{{\'QUOTATION.CANCEL_PURCHASE\'| translate}}</span><md-tooltip md-direction=\"top\" md-visible=\"tooltipVisible\">\n{{\'QUOTATION.CANCEL_PURCHASE\'| translate}}</md-tooltip></md-button></div></div><md-content class=\"content\" flex \nms-scroll><fieldset class=\"standard\"><legend>{{\'CONTRACT.ENCABEZADO\'| translate}}</legend><div layout=\"row\"><div \nclass=\"customer\" layout=\"column\"><span><strong \ntranslate=\"{{vm.isClient === true ? \n                                                        \'QUOTATION.PROVIDER\': \n                                                        \'QUOTATION.CLIENT\'}}\">\n</strong> {{vm.isClient === true ? vm.quotation.provider.name: vm.quotation.requisition.department.company.name}}\n</span> <span><strong translate=\"QUOTATION.DEPARTMENT\"></strong> {{vm.quotation.requisition.department.description}}\n</span> <span><strong translate=\"QUOTATION.COST_CENTER\"></strong> {{vm.quotation.requisition.costCenter.description}}\n</span> <span><strong translate=\"QUOTATION.CURRENCY\"></strong>\n {{vm.quotation.currency.description| date: \'dd-MM-yyyy\'}}</span> <span><strong translate=\"QUOTATION.TOTAL\"></strong>\n {{vm.quotation.currency.symbol + \' \'}} {{ vm.quotation.total | number : 2}}</span></div><span flex></span><div \nclass=\"customer\" layout=\"column\" hide-sm hide-xs><span><strong translate=\"QUOTATION.MAX_DATE_DELIVERY\"></strong>\n {{vm.quotation.requisition.maxDatePurchase| date: \'dd-MM-yyyy\'}}</span> <span><strong \ntranslate=\"QUOTATION.EXPIRE_DATE\"></strong> {{vm.quotation.expireDate| date: \'dd-MM-yyyy\'}}</span> <span \nng-if=\"vm.quotation.requisition.referenceId && \n                                                vm.quotation.requisition.originType\">\n<strong translate=\"QUOTATION.ORIGIN_TICKET\"></strong> <a target=\"_blank\" \nhref=\"{{vm.quotation.requisition.originType.queryUrl}}\n                                                    {{vm.quotation.requisition.referenceId}}\">\n{{vm.replaceOriginTypedata(vm.quotation.requisition, vm.quotation.requisition.originType.originTypeUrlDescription)}}\n</a></span></div><span flex></span><div class=\"customer\" layout=\"column\"><span \nng-if=\"vm.quotation.requisition.dimensionCompanyDetail3\"><strong>{{vm.dimensionCompanyDetail3.description}}</strong>\n {{vm.quotation.requisition.dimensionCompanyDetail3.name}} </span><span \nng-if=\"vm.quotation.requisition.dimensionCompanyDetail4\"><strong>{{vm.dimensionCompanyDetail4.description}}</strong>\n {{vm.quotation.requisition.dimensionCompanyDetail4.name}} </span><span \nng-if=\"vm.quotation.requisition.dimensionCompanyDetail5\"><strong>{{vm.dimensionCompanyDetail5.description}}</strong>\n {{vm.quotation.requisition.dimensionCompanyDetail5.name}}</span></div></div></fieldset><div layout=\"row\" \nng-if=\"vm.quotation.files && vm.quotation.files.length > 0\"><div class=\"customer\" layout=\"column\" \nng-repeat=\"files in vm.quotation.files\"><a target=\"_blank\" \nhref=\"{{vm.URLPHOTOS + files.parentPath + files.name + files.extension}}\"><md-icon md-font-icon=\"icon-file-document\">\n</md-icon><span translate=\"INVOICE.WITHHOLDING_DETAIL.FILE\"></span># {{files.id}}</a></div></div><div ms-scroll \nclass=\"order-detail-form-container products md-background-bg md-whiteframe-1dp\"><table \nclass=\"dataTable row-border hover custom-table\" datatable=\"ng\" dt-options=\"vm.dtOptions\" aria-label=\"dataTable\"><thead>\n<tr><th class=\"secondary-text\" ng-show=\"vm.status === \'Autorizado\'\"><div class=\"table-header\"><md-checkbox \nng-model=\"vm.selectAll\" ng-change=\"vm.selectAllDetailQuotationAproveRefuse()\">Seleccionar Todo</md-checkbox></div></th>\n<th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"QUOTATION.NO\">NO</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"QUOTATION.DETAIL.PRODUCT\">producto</span></div></th><th class=\"secondary-text customer-th\"><div \nclass=\"table-header\"><span class=\"column-title right\" translate=\"QUOTATION.DETAIL.QUANTITY\">Cantidad</span></div></th>\n<th class=\"secondary-text customer-th\"><div class=\"table-header\"><span class=\"column-title right\" \ntranslate=\"QUOTATION.DETAIL.PRICE\">Precio</span></div></th><th class=\"secondary-text customer-th\"><div \nclass=\"table-header\"><span class=\"column-title right\" translate=\"QUOTATION.TOTAL\">SubTotal</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"QUOTATION.DETAIL.OBSERVATIONS\">\nObservaciones</span></div></th><th scope=\"col\" class=\"secondary-text\" \nng-show=\"vm.isCreatedQuotation && \n                                                    vm.hasBudgetApplication\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"QUOTATION.SELECT_BUDGET\">Presupuestos</span></div></th><th \nclass=\"secondary-text\" ng-if=\"vm.isEnterFeatures\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"QUOTATION.COMPLETED\">Completado</span></div></th><th scope=\"col\" class=\"secondary-text\" \nng-if=\"(!vm.isCreatedQuotation && \n                                                    (vm.isClient || vm.isEnterFeatures) || \n                                                    vm.isReport)\">\n<div class=\"table-header\"><span class=\"column-title\" translate=\"QUOTATION.DETAIL.OPTIONS\">Opciones</span></div></th>\n</tr></thead><tbody><tr ng-repeat=\"detail in vm.details\" ng-controller=\"QuotationDetailRowController as row\"><td \nng-show=\"vm.status === \'Autorizado\'\"><md-checkbox aria-label=\"selected\" ng-model=\"detail.selected\" \nng-change=\"vm.detailQuotationAproveRefuse(detail)\"></md-checkbox></td><td>{{$index + 1}}</td><td>\n{{detail.requisitionDetail.product.name}}</td><td class=\"customer-td\">{{detail.requisitionDetail.quantity| number: 2}}\n</td><td class=\"customer-td\">{{detail.price| number: 6}}</td><td class=\"customer-td\">{{detail.subTotal| number: 2}}\n</td><td>{{detail.requisitionDetail.observations}}</td><td ng-show=\"vm.isCreatedQuotation && vm.hasBudgetApplication\" \nclass=\"min-width\"><div layout=\"row\"><div flex><md-progress-circular type=\"indeterminate\" \nng-show=\"vm.isShowLoaderBudgets\"></md-progress-circular><md-input-container \nng-if=\"!vm.isShowLoaderBudgets && \n                                                                    row.budgets.length > 0\" \nclass=\"md-block\"><label></label><md-select class=\"select-budget\" ng-model=\"detail.sreferences\" multiple=\"true\" \naria-label=\"references\"><md-option class=\"option-budget\" ng-repeat=\"opt in row.budgets\" ng-value=\"opt\" flex><div \nlayout=\"row\" flex><div layout=\"column\" class=\"h3 ocult-first\"><span>Disponible</span> <span>\n{{opt.currencyOfficial.code}}. {{opt.disponible| number:2}}</span></div><span flex></span><div layout=\"column\" \nlayout-align=\"right\"><span>{{opt.budget.startDate| date: \'dd-MM-yyyy\'}} - {{opt.budget.endDate| date: \'dd-MM-yyyy\'}}\n</span> <span>Tipo: {{opt.budget .budgetType.description}}</span></div></div></md-option></md-select>\n</md-input-container></div><div flex class=\"min-padding\" ng-show=\"detail.needAmpliataion\"><md-checkbox \nng-show=\"!vm.isShowLoaderBudgets && \n                                                                row.budgets.length > 0\" \nng-model=\"detail.requestAmpliation\">{{\'QUOTATION.REQ_AMPLIATION\'| translate}}</md-checkbox></div></div></td><td \nng-if=\"vm.isEnterFeatures\">{{detail.completedFeatures}}</td><td \nng-if=\"(!vm.isCreatedQuotation && \n                                                    (vm.isClient || vm.isEnterFeatures) || \n                                                    vm.isReport)\">\n<div layout=\"row\"><div flex><md-button ng-if=\"vm.isEnterFeatures\" class=\"md-icon-button\" \nng-click=\"vm.addFeatures(detail, $index)\"><md-icon md-font-icon=\"icon-border-color\" class=\"s16\"></md-icon><md-tooltip \nmd-direction=\"left\">{{\"QUOTATION.DETAIL.FEATURES.EDIT\"| translate}}</md-tooltip></md-button><md-button \nng-if=\"vm.isClient && vm.viewDetailPermision\" class=\"md-icon-button\" ng-click=\"vm.viewDetail(detail, $index)\"><md-icon \nmd-font-icon=\"icon-eye\" class=\"s16\"></md-icon><md-tooltip md-direction=\"left\">{{\"QUOTATION.DETAIL.VIEW\"| translate}}\n</md-tooltip></md-button><md-button ng-if=\"vm.isReport && detail.isFixedAsset\" class=\"md-icon-button\" \nng-click=\"vm.viewDetailFeatures(detail, $index)\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"s16\">\n</md-icon><md-tooltip md-direction=\"left\">{{\"QUOTATION.DETAIL.VIEW_FIXEDASSET\"| translate}}</md-tooltip></md-button>\n</div></div></td></tr></tbody><tfoot><tr><td ng-show=\"vm.status === \'Autorizado\'\" class=\"align-right\"></td><td \ncolspan=\"2\" class=\"align-right\">TOTAL</td><td class=\"align-right\">\n{{vm.details| sumOfValue: \'requisitionDetail.quantity\': 0}}</td><td></td><td class=\"align-right\">\n{{vm.details| sumOfValue: \'subTotal\': 2}}</td><td \nng-if=\"!vm.isCreatedQuotation && \n                                                    (vm.isClient || vm.isEnterFeatures)\">\n</td><td ng-show=\"vm.isCreatedQuotation && vm.hasBudgetApplication\"></td><td ng-if=\"vm.isEnterFeatures\"></td><td \nng-if=\"vm.isReport && !vm.isClient\"></td><td></td></tr></tfoot></table></div></md-content></div></md-tab-body></md-tab>\n<md-tab aria-controls=\"tab2-content\"><md-tab-body><div \nng-include=\"\'app/main/apps/reports/process-flow/process-flow.html\'\"></div></md-tab-body></md-tab></md-tabs>\n</md-content></div></div>");
$templateCache.put("app/main/apps/quotation/pending-authorize-ticket/content.html","<div id=\"quotation-grid\" ag-grid=\"vm.gridOptions\" class=\"ag-fresh\" ng-show=\"vm.showGrid\" \nstyle=\"width: 100%; height: 100%\"></div>");
$templateCache.put("app/main/apps/quotation/pending-authorize-ticket/pending-authorize-ticket.html","<div id=\"quotation-pending-authorize\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div class=\"center\" \nlayout=\"column\" flex><div class=\"header\" layout-xl=\"row\" layout-align-xl=\"space-between center\" layout-lg=\"row\" \nlayout-align-lg=\"space-between center\" layout-xs=\"column\" layout-align-xs=\"none center\"><md-icon \nmd-font-icon=\"icon-square-inc-cash\"></md-icon><div class=\"title\" flex><span>\n{{\'authorize_quotations.quotations_to_be_authorized\' | translate}}</span></div><div class=\"search\" layout=\"row\" \nlayout-align=\"start center\" flex><input id=\"e-commerce-products-search\" ng-model=\"vm.search\" class=\"search-input\" \ntype=\"text\" placeholder=\"Search\" translate translate-attr-placeholder=\"INVOICE_MERCHANDISE_ENTRY.SEARCH\" \nng-model-options=\"{\'debounce\': 300}\" flex></div><md-button class=\"md-raised md-primary\" \nng-disabled=\"vm.quotationsToAuthorize.length === 0\" ng-click=\"vm.goToDetail($event)\">Ver detalles</md-button></div>\n<md-card class=\"content-card\" ms-scroll flex layout=\"column\" \nng-include=\"\'app/main/apps/quotation/pending-authorize/content.html\'\"></md-card></div></div>");
$templateCache.put("app/main/apps/quotation/quotation-report/quotation-report.html","<div id=\"mail\" class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"search-wrapper md-whiteframe-4dp\" layout=\"row\" layout-align=\"start center\" flex><div class=\"search\" flex \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><input \nng-enter=\"vm.getRequisition(vm.search)\" flex ng-model=\"vm.search\" type=\"number\" \nplaceholder=\"Search for an e-mail or contact\" translate \ntranslate-attr-placeholder=\"QUOTATION.SEARCH_PLACEHOLDER_QUOTATION\"><md-button class=\"md-icon-button\" \nng-click=\"vm.getRequisition(vm.search)\" aria-label=\"Back\" translate translate-attr-aria-label=\"MAIL.BACK\"><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon></md-button></div></div></div><div class=\"content-card\" layout=\"column\" flex><div\n class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\" ng-if=\"vm.activeMailPaneIndex === 0\"><div \nlayout=\"row\" layout-align=\"start center\"></div></div><div class=\"data\" layout=\"column\" flex \nng-show=\"vm.requisition.id\"><md-tabs md-selected=\"vm.currentTab\"><md-tab id=\"tab1\" aria-controls=\"tab1-content\">\n<md-tab-label><md-icon md-font-icon=\"icon-indent\"></md-icon><span translate=\"REQUISITION.ENCABEZADO\">\nRequisition Details</span></md-tab-label></md-tab><md-tab id=\"tab2\" aria-controls=\"tab2-content\"><md-tab-label><md-icon\n md-font-icon=\"icon-cube-unfolded\"></md-icon><span translate=\"REPORT.PROCESS_FLOW.FLOW\">Diagrama</span></md-tab-label>\n</md-tab><md-tab id=\"tab3\" aria-controls=\"tab3-content\" ng-if=\"vm.quotationsDetails.length > 0\"><md-tab-label><md-icon \nmd-font-icon=\"icon-cash-100\"></md-icon><span translate=\"QUOTATION.QUOTATION\">Quotation</span></md-tab-label></md-tab>\n<md-tab id=\"tab4\" aria-controls=\"tab4-content\" ng-if=\"vm.detailsPurchaseOrder.length > 0\"><md-tab-label><md-icon \nmd-font-icon=\"icon-cart\"></md-icon><span translate=\"ORDER.ORDER\">PurchaseOrder</span></md-tab-label></md-tab><md-tab \nid=\"tab5\" aria-controls=\"tab5-content\" ng-if=\"vm.detailsInvoice.length > 0\"><md-tab-label><md-icon \nmd-font-icon=\"icon-receipt\"></md-icon><span translate=\"INVOICE.INVOICE\">Invoice</span></md-tab-label></md-tab>\n</md-tabs><md-content class=\"content\" flex ms-scroll><md-tabs md-dynamic-height md-selected=\"vm.currentTab\" \nclass=\"tab-in-content\"><md-tab aria-controls=\"tab1-content\"><md-tab-body><div class=\"content-card\" layout=\"column\" \nflex><div class=\"md-background-bg md-whiteframe-1dp\"><div class=\"content fullpage-datatable\" layout=\"column\" flex>\n<fieldset class=\"standard\"><legend>{{\'CONTRACT.ENCABEZADO\'| translate}}</legend><div layout=\"row\"><div \nclass=\"customer\" layout=\"column\"><span><strong translate=\"REQUISITION.DEPARTMENT\"></strong>\n {{vm.requisition.department.description}}</span> <span><strong translate=\"REQUISITION.COST_CENTER\"></strong>\n {{vm.requisition.costCenter.description}}</span> <span><strong translate=\"REQUISITION.MAXDATEPURCHASE\"></strong>\n {{vm.requisition.maxDatePurchase| date: \'dd-MM-yyyy\'}}</span> <span ng-if=\"vm.requisition.referenceId\"><strong \ntranslate=\"REQUISITION.ORIGIN\"></strong> <a target=\"_blank\" \nhref=\"{{vm.requisition.originType.queryUrl}}\n                                                                {{vm.requisition.referenceId}}\">\n{{vm.replaceOriginTypedata(vm.requisition, vm.requisition.originType.originTypeUrlDescription)}} </a></span><span>\n<strong translate=\"REQUISITION.STATUS\"></strong> {{vm.requisition.purchaseStatus.description}}</span></div><span flex>\n</span><div class=\"customer\" layout=\"column\"><span><strong translate=\"REQUISITION.REQUISITION_TYPE\"></strong>\n {{vm.requisition.requisitionType.description}}</span> <span><strong translate=\"REQUISITION.DESCRIPTION\"></strong>\n {{vm.requisition.description}}</span> <span><strong translate=\"CONTRACT.DATE_CREATED\"></strong>\n {{vm.requisition.createdAt.dayOfMonth}}/ {{vm.requisition.createdAt.monthValue}}/ {{vm.requisition.createdAt.year}} \n</span><span><strong translate=\"CONTRACT.BY_CREATED\"></strong> {{vm.requisition.createdBy}}</span></div><span flex>\n</span><div class=\"customer\" layout=\"column\"><span \nng-if=\"vm.requisition.originType && \n                                                            vm.requisition.originType.originTypeCode === \'01\' && \n                                                            vm.requisition.urgentPurchase\">\n<strong translate=\"REQUISITION.PURCHASE_TYPE\"></strong>{{\"REQUISITION.MSG.URGENT_PURCHASE\"| translate}} </span><span \nng-if=\"vm.requisition.originType && \n                                                            vm.requisition.originType.originTypeCode === \'01\' && \n                                                            vm.requisition.departmentFirsRecept\">\n<strong translate=\"REQUISITION.DEPARTMENT_FIRST_RECEPT\"></strong> {{vm.requisition.departmentFirsRecept.description}}\n</span></div><span flex></span><div class=\"customer\" layout=\"column\"><span \nng-if=\"vm.requisition.dimensionCompanyDetail3\"><strong>{{vm.dimensionCompanyDetail3.description}}</strong>\n {{vm.requisition.dimensionCompanyDetail3.name}} </span><span ng-if=\"vm.requisition.dimensionCompanyDetail4\"><strong>\n{{vm.dimensionCompanyDetail4.description}}</strong> {{vm.requisition.dimensionCompanyDetail4.name}} </span><span \nng-if=\"vm.requisition.dimensionCompanyDetail5\"><strong>{{vm.dimensionCompanyDetail5.description}}</strong>\n {{vm.requisition.dimensionCompanyDetail5.name}}</span></div><span flex></span></div></fieldset><md-progress-linear \nmd-mode=\"indeterminate\" ng-if=\"vm.loading\" class=\"md-accent\"></md-progress-linear><div id=\"masterGridOptions\" \nag-grid=\"vm.masterGridOptions\" class=\"ag-fresh\" expand-grid min=\"260\" other=\"200\"></div></div></div></div>\n</md-tab-body></md-tab><md-tab aria-controls=\"tab2-content\"><md-tab-body><div \nng-include=\"\'app/main/apps/reports/process-flow/process-flow.html\'\"></div></md-tab-body></md-tab><md-tab \naria-controls=\"tab3-content\" ng-show=\"vm.quotationsDetails.length > 0\"><md-tab-body><div \nclass=\"order-detail-form-container products md-background-bg md-whiteframe-1dp\" ng-show=\"vm.details.length > 0\"><div \nclass=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex>\n<md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loading\" class=\"md-accent\"></md-progress-linear><div \nid=\"masterGridOptionsQuotation\" ag-grid=\"vm.masterGridOptionsQuotation\" class=\"ag-fresh\" expand-grid min=\"260\" \nother=\"100\"></div></div></div></div></md-tab-body></md-tab><md-tab aria-controls=\"tab4-content\" \nng-show=\"vm.detailsPurchaseOrder.length > 0\"><md-tab-body><div \nclass=\"order-detail-form-container products md-background-bg md-whiteframe-1dp\"><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loading\" \nclass=\"md-accent\"></md-progress-linear><div id=\"masterGridOptionsPurchaseOrder\" \nag-grid=\"vm.masterGridOptionsPurchaseOrder\" class=\"ag-fresh\" expand-grid min=\"260\" other=\"100\"></div></div></div>\n</md-tab-body></md-tab><md-tab aria-controls=\"tab5-content\" ng-show=\"vm.detailsInvoice.length > 0\"><md-tab-body><div \nclass=\"order-detail-form-container products md-background-bg md-whiteframe-1dp\"><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loading\" \nclass=\"md-accent\"></md-progress-linear><div id=\"masterGridOptionsInvoice\" ag-grid=\"vm.masterGridOptionsInvoice\" \nclass=\"ag-fresh\" expand-grid min=\"260\" other=\"100\"></div></div></div></md-tab-body></md-tab></md-tabs></md-content>\n</div></div></div></div>");
$templateCache.put("app/main/apps/reports/process-flow/process-flow.html","<md-content class=\"content\" flex ms-scroll><div id=\"flow-chart\" class=\"flow-chart\"><div class=\"tree\"><ul><li><a \nng-if=\"vm.infoProcessFlow.originId\"><span ng-if=\"vm.infoProcessFlow.originId\">\n{{vm.infoProcessFlow.originType.originTypeName}} # {{vm.infoProcessFlow.originId}}</span></a><ul \nng-if=\"!vm.infoProcessFlow.contractId && vm.infoProcessFlow.requisitions.length > 0\"><li \nng-repeat=\"requisition in vm.infoProcessFlow.requisitions| orderBy:\'childId\'\"><a><span \ntranslate=\"REPORT.PROCESS_FLOW.REQUISITION\"></span> #{{requisition.childId}}<br>{{requisition.childDescription}}<br>\n({{requisition.childStatus}})<md-button class=\"edit-button md-icon-button\" \nng-click=\"showAuditLog(requisition.childId, 1)\" aria-label=\"logs\" translate translate-attr-aria-label=\"logs\">\n<md-tooltip md-direction=\"bottom\">Log</md-tooltip><md-icon md-font-icon=\"icon-history\" class=\"s16\"></md-icon>\n</md-button></a><ul ng-if=\"vm.infoProcessFlow.quotations.length > 0\"><li \nng-repeat=\"quotation in vm.infoProcessFlow.quotations | filter:{fatherId:requisition.childId} | orderBy:\'childId\'\"><a>\n<span translate=\"REPORT.PROCESS_FLOW.QUOTATION\"></span> #{{quotation.childId}}<br>{{quotation.childDescription}}<br>\n({{quotation.childStatus}})<md-button class=\"edit-button md-icon-button\" ng-click=\"showAuditLog(quotation.childId, 2)\" \naria-label=\"logs\" translate translate-attr-aria-label=\"logs\"><md-tooltip md-direction=\"bottom\">Log</md-tooltip><md-icon\n md-font-icon=\"icon-history\" class=\"s16\"></md-icon></md-button></a><ul \nng-if=\"vm.infoProcessFlow.purchaseOrders.length > 0\"><li \nng-repeat=\"purchaseOrder in vm.infoProcessFlow.purchaseOrders| filter:{fatherId:quotation.childId} | orderBy:\'childId\'\">\n<a><span translate=\"REPORT.PROCESS_FLOW.PURCHASE_ORDER\"></span> # {{purchaseOrder.childId}}<br>\n({{purchaseOrder.childStatus}})<md-button class=\"edit-button md-icon-button\" \nng-click=\"showAuditLog(purchaseOrder.childId, 3)\" aria-label=\"logs\" translate translate-attr-aria-label=\"logs\">\n<md-tooltip md-direction=\"bottom\">Log</md-tooltip><md-icon md-font-icon=\"icon-history\" class=\"s16\"></md-icon>\n</md-button></a><ul ng-if=\"vm.infoProcessFlow.entryMerchandise1.length > 0\"><li \nng-repeat=\"entryMerchandise1 in vm.infoProcessFlow.entryMerchandise1| filter:{fatherId:purchaseOrder.childId}| orderBy:\'childId\'\">\n<a><span translate=\"REPORT.PROCESS_FLOW.ENTRY\"></span> # {{entryMerchandise1.childId}}</a><ul><li \nng-repeat=\"invoice in vm.infoProcessFlow.invoice| filter:{fatherId:entryMerchandise1.childId}| orderBy:\'childId\'\"><a>\n<span translate=\"REPORT.PROCESS_FLOW.INVOICE\"></span> # {{invoice.childId}}<br>({{invoice.childStatus}})<md-button \nclass=\"edit-button md-icon-button\" ng-click=\"showAuditLog(invoice.childId, 4)\" aria-label=\"logs\" translate \ntranslate-attr-aria-label=\"logs\"><md-tooltip md-direction=\"bottom\">Log</md-tooltip><md-icon \nmd-font-icon=\"icon-history\" class=\"s16\"></md-icon></md-button></a></li></ul></li></ul></li></ul></li></ul></li></ul>\n</li></ul><ul ng-if=\"vm.infoProcessFlow.contractId\"><li ng-if=\"vm.infoProcessFlow.contractId\"><a \nng-if=\"vm.infoProcessFlow.contractId\"><span ng-if=\"vm.infoProcessFlow.contractId\"><span \ntranslate=\"REPORT.PROCESS_FLOW.CONTRACT\"></span># {{vm.infoProcessFlow.contractId}}</span><br><span>\n{{vm.infoProcessFlow.status}}</span></a><ul \nng-if=\"vm.infoProcessFlow.contractId && vm.infoProcessFlow.purchaseOrders.length > 0\"><li \nng-repeat=\"purchaseOrder in vm.infoProcessFlow.purchaseOrders| orderBy:\'childId\'\"><a><span \ntranslate=\"REPORT.PROCESS_FLOW.PURCHASE_ORDER\"></span> # {{purchaseOrder.childId}}<br>({{purchaseOrder.childStatus}})\n<md-button class=\"edit-button md-icon-button\" ng-click=\"showAuditLog(purchaseOrder.childId, 3)\" aria-label=\"logs\" \ntranslate translate-attr-aria-label=\"logs\"><md-tooltip md-direction=\"bottom\">Log</md-tooltip><md-icon \nmd-font-icon=\"icon-history\" class=\"s16\"></md-icon></md-button></a><ul \nng-if=\"vm.infoProcessFlow.entryMerchandise1.length > 0\"><li \nng-repeat=\"entryMerchandise1 in vm.infoProcessFlow.entryMerchandise1| filter:{fatherId:purchaseOrder.childId}| orderBy:\'childId\'\">\n<a><span translate=\"REPORT.PROCESS_FLOW.ENTRY\"></span> # {{entryMerchandise1.childId}}<br><span \ntranslate=\"REPORT.PROCESS_FLOW.CUOTA\"></span>#{{entryMerchandise1.paymentNro}}</a><ul \nng-if=\"vm.infoProcessFlow.invoice.length > 0\"><li \nng-repeat=\"invoice in vm.infoProcessFlow.invoice| filter:{fatherId:entryMerchandise1.childId}| orderBy:\'childId\'\"><a>\n<span translate=\"REPORT.PROCESS_FLOW.INVOICE\"></span> # {{invoice.childId}}<br>({{invoice.childStatus}})<md-button \nclass=\"edit-button md-icon-button\" ng-click=\"showAuditLog(invoice.childId, 4)\" aria-label=\"logs\" translate \ntranslate-attr-aria-label=\"logs\"><md-tooltip md-direction=\"bottom\">Log</md-tooltip><md-icon \nmd-font-icon=\"icon-history\" class=\"s16\"></md-icon></md-button></a></li></ul></li></ul></li></ul></li></ul></div></div>\n</md-content>");
$templateCache.put("app/main/apps/requisition/requisition/requisition.html","<div id=\"budgetO\" class=\"page-layout carded fullwidth\" layout=\"column\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" \nlayout=\"row\" layout-align=\"start center\" flex><md-button class=\"goto-orders-button md-icon-button\" \naria-label=\"Go to orders\" ng-click=\"vm.gotoRequisitions()\" translate \ntranslate-attr-aria-label=\"REQUISITION.GO_TO_ORDERS\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div\n layout=\"column\" layout-align=\"start start\"><div class=\"h2\"><span translate=\"REQUISITION.REQUISITION\">Order</span> \n<span>{{vm.requisition.id}}</span></div><div class=\"subtitle secondary-text\"></div></div></div></div><div \nclass=\"content-card\" layout=\"column\" flex><div ng-class=\"vm.dinamicSize > 900 ? \'toolbar\' : \'customer-toolbar\'\"><div \nlayout=\"row\"><md-tabs md-selected=\"vm.currentTab\" flex><md-tab id=\"tab1\" aria-controls=\"tab1-content\"><span \ntranslate=\"REQUISITION.ENCABEZADO\">Requisition Details </span></md-tab><md-tab \nng-disabled=\"vm.requisitionForm.$invalid\n                                                || vm.requisitionForm.$dirty\n                                                || vm.fileAddedOrRemoved\" \nid=\"tab2\" aria-controls=\"tab2-content\"><span translate=\"REQUISITION.REQUISITION_DETAILS\">Rubros</span></md-tab><md-tab \nid=\"tab3\" aria-controls=\"tab3-content\" \nng-disabled=\"!(vm.requisitionFiles.length>0\n                            && vm.filesToUpload.length>0)\n                            || vm.loadingFiles\n                            || vm.fileAddedOrRemoved\">\n<md-progress-circular ng-if=\"vm.loadingFiles\" class=\"md-hue-2\" md-diameter=\"20px\"></md-progress-circular><md-icon \nng-if=\"!vm.loadingFiles\" md-font-icon=\"icon-file-image\"></md-icon><span translate=\"REQUISITION.FILES\">Archivos</span>\n</md-tab></md-tabs><span flex></span><div ng-if=\"vm.currentTab === 1\"><md-button \nng-show=\"vm.statusToChange != \'Ingresado\' && !vm.requisition.urgentPurchase && vm.details.length > 0\" \nng-disabled=\"$rootScope.loadingProgress\" class=\"md-raised md-primary\" ng-click=\"vm.presentRequisition()\" \naria-label=\"present budget\" translate translate-attr-aria-label=\"REQUISITION.ORDER_DETAILS\"><span>\n{{\'REQUISITION.STATUSCHANGE.\' + vm.statusToChange| translate}}</span></md-button><md-button \nng-show=\"vm.statusToChange === \'Creando\' && vm.requisition.urgentPurchase && vm.details.length > 0\" \nng-disabled=\"$rootScope.loadingProgress\" class=\"md-raised md-primary\" ng-click=\"vm.autorizeRequisition()\" \naria-label=\"present budget\" translate translate-attr-aria-label=\"REQUISITION.ORDER_DETAILS\"><span>\n{{\'REQUISITION.STATUSCHANGE.Ingresado\'| translate}}</span></md-button><md-button \nng-show=\"vm.statusToChange === \'Creando\' && !vm.requisition.urgentPurchase && vm.hasBudgetApplication && !vm.requisition.originType\" \nng-disabled=\"$rootScope.loadingProgress\" class=\"md-raised md-primary\" ng-click=\"vm.productsByBudget()\" \naria-label=\"present budget\" translate translate-attr-aria-label=\"REQUISITION.ORDER_DETAILS\"><span>\n{{\'REQUISITION.PRODUCTS_BY_BUDGET\'| translate}}</span></md-button><md-button \nng-show=\"vm.statusToChange === \'Creando\' && !vm.requisition.urgentPurchase && vm.viewChangeTemplates\" \nng-disabled=\"$rootScope.loadingProgress\" class=\"md-raised md-primary\" ng-click=\"vm.getTemplates(vm.requisition.id)\" \naria-label=\"present budget\" translate translate-attr-aria-label=\"REQUISITION.ORDER_DETAILS\"><span>\n{{\'REQUISITION.ADD_TEMPLATE\'| translate}}</span></md-button><md-button \nng-show=\"vm.statusToChange === \'Ingresado\' && vm.details.length > 0\" ng-disabled=\"$rootScope.loadingProgress\" \nclass=\"md-raised md-primary\" ng-click=\"vm.presentRequisition(false)\" aria-label=\"present budget\" translate \ntranslate-attr-aria-label=\"REQUISITION.ORDER_DETAILS\"><span>\n{{\'REQUISITION.STATUSCHANGE.\' + vm.statusToChange| translate}}</span><md-tooltip md-direction=\"top\" \nmd-visible=\"tooltipVisible\">{{\'REQUISITION.STATUSCHANGE.TOOLTIP_AUTHORIZE\'| translate}}</md-tooltip></md-button>\n<md-button ng-show=\"vm.statusToChange === \'Ingresado\' && vm.details.length > 0 && vm.hasTenderApplication\" \nng-disabled=\"$rootScope.loadingProgress\" class=\"md-raised md-primary\" ng-click=\"vm.presentRequisition(true)\" \naria-label=\"present budget\" translate translate-attr-aria-label=\"REQUISITION.ORDER_DETAILS\"><span>\n{{\'REQUISITION.STATUSCHANGE.AUTHORIZE_LICITE\'| translate}}</span><md-tooltip md-direction=\"top\" \nmd-visible=\"tooltipVisible\">{{\'REQUISITION.STATUSCHANGE.TOOLTIP_AUTHORIZE_LICITE\'| translate}}</md-tooltip></md-button>\n<md-button ng-show=\"vm.statusToChange === \'Ingresado\' && vm.details.length > 0\" \nng-disabled=\"$rootScope.loadingProgress\" class=\"md-raised md-warn\" ng-click=\"vm.noAutorize()\" aria-label=\"rechaze\" \ntranslate translate-attr-aria-label=\"rechaze\"><span>{{\'REQUISITION.STATUSCHANGE.NoAutorizado\'| translate}}</span>\n<md-tooltip md-direction=\"top\" md-visible=\"tooltipVisible\">{{\'REQUISITION.STATUSCHANGE.NoAutorizado\'| translate}}\n</md-tooltip></md-button><md-button ng-show=\"vm.cartExist && !vm.requisition.originType\" \nng-disabled=\"$rootScope.loadingProgress\" class=\"md-raised md-primary\" ng-click=\"vm.changeCart()\" \naria-label=\"chargue Cart\" translate translate-attr-aria-label=\"REQUISITION.CHARGECART\"><md-icon \nmd-font-icon=\"icon-cart\"></md-icon>{{\'REQUISITION.CHARGE_CART\'| translate}}</md-button></div></div></div><md-content \nclass=\"content\" flex ms-scroll><md-tabs md-dynamic-height md-selected=\"vm.currentTab\" class=\"tab-in-content\"><md-tab \naria-controls=\"tab1-content\"><md-tab-body><form name=\"vm.requisitionForm\"><div \nclass=\"order-detail-form-container status md-background-bg md-whiteframe-1dp\"><div class=\"pb-16\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-clipboard-text\" class=\"m-0 mr-16\"></md-icon><div \nclass=\"h2 secondary-text\" translate=\"REQUISITION.REQUISITION_DATA\">Requisition Data</div></div><div class=\"customer\">\n<div class=\"customer\"><div layout-gt-xs=\"row\" layout-align=\"start center\" layout-align=\"start center\">\n<md-input-container flex-gt-xs><label translate=\"REQUISITION.DEPARTMENT\">Department</label><md-select \nng-model=\"vm.requisition.department.id\" name=\"department\" required \nng-disabled=\"vm.loadingDepartments || vm.requisitionFromOtherOrigin\" md-on-close=\"vm.clearSearchDepartment()\">\n<md-select-header><input id=\"searchDepartment\" ng-model=\"vm.searchDepartment\" type=\"search\" \nplaceholder=\"Buscar departamento\"></md-select-header><md-optgroup label=\"Departamentos\"><md-option \nvalue=\"{{depto.id}}\" ng-repeat=\"depto in vm.departments| filter:vm.searchDepartment\">{{depto.description}}</md-option>\n</md-optgroup></md-select><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loadingDepartments\">\n</md-progress-linear><div ng-messages=\"vm.requisitionForm.department.$error\"><div ng-message=\"required\" \ntranslate=\"REQUISITION.ERROR.FIELD_REQUIRED\">This date is required!</div></div></md-input-container><md-input-container\n flex-gt-xs><label translate=\"REQUISITION.COST_CENTER\">Cost Center</label><md-select \nng-model=\"vm.requisition.costCenter.id\" name=\"costcenter\" md-on-close=\"vm.clearSearchCostCenter()\" required \nng-disabled=\"vm.loadingCostCenter || vm.requisitionFromOtherOrigin\"><md-select-header><input id=\"searchCostCenter\" \nng-model=\"vm.searchCostCenter\" type=\"search\" placeholder=\"Buscar centro de costo\"></md-select-header><md-optgroup>\n<md-option value=\"{{cc.id}}\" ng-repeat=\"cc in vm.costCenters| filter:vm.searchCostCenter\">{{cc.description}}\n</md-option></md-optgroup></md-select><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loadingCostCenter\">\n</md-progress-linear><div ng-messages=\"vm.requisitionForm.costcenter.$error\"><div ng-message=\"required\" \ntranslate=\"REQUISITION.ERROR.FIELD_REQUIRED\">This date is required!</div></div></md-input-container></div><div \nlayout-gt-xs=\"row\" layout-align=\"start center\" layout-align=\"start center\"><md-input-container flex-gt-xs><label \ntranslate=\"REQUISITION.PROJECT\">Proyecto</label><md-select ng-model=\"vm.requisition.projectId\" name=\"project\" \nng-disabled=\"vm.loadingProjects\" md-on-close=\"vm.clearSearchProject()\"><md-select-header><input id=\"searchProject\" \nng-model=\"vm.searchProject\" type=\"search\" placeholder=\"Buscar Proyectos\"></md-select-header><md-optgroup \nlabel=\"Proyectos\"><md-option value=\"{{depto.id}}\" ng-repeat=\"depto in vm.projects| filter:vm.searchProject\">\n{{depto.code}} - {{depto.name}}</md-option></md-optgroup></md-select><md-progress-linear md-mode=\"indeterminate\" \nng-if=\"vm.loadingProjects\"></md-progress-linear></md-input-container></div><div layout-gt-xs=\"row\" \nlayout-align=\"start center\" layout-align=\"start center\"><md-input-container flex-gt-xs><label \ntranslate=\"REQUISITION.MAXDATEPURCHASE\">End Date</label><md-datepicker type=\"date\" \nng-model=\"vm.requisition.maxDatePurchase\" name=\"endDate\" md-min-date=\"vm.minDate\" md-open-on-focus></md-datepicker><div\n ng-messages=\"vm.requisitionForm.endDate.$error\"><div ng-message=\"valid\" translate=\"REQUISITION.ERROR.INVALID_DATE\">\nThe entered value is not a date!</div><div ng-message=\"required\" translate=\"REQUISITION.ERROR.FIELD_REQUIRED\">\nThis date is required!</div><div ng-message=\"mindate\" translate=\"REQUISITION.ERROR.INVALID_DATE\">Date is too early!\n</div></div></md-input-container></div><div \nng-show=\"vm.requisition.originType && vm.requisition.originType.originTypeCode === \'01\'\" layout-gt-xs=\"row\" \nlayout-align=\"start center\" layout-align=\"start center\"><md-input-container class=\"md-block\"><md-switch \nclass=\"md-primary\" ng-model=\"vm.requisition.receivedDouble\" ng-change=\"vm.loadDeptosUser()\">\n{{\"REQUISITION.MSG.SURE_RECEIPTED\"| translate}}</md-switch></md-input-container><md-input-container flex-gt-xs \nng-show=\"vm.requisition.receivedDouble\"><label translate=\"REQUISITION.DEPARTMENT\">Department</label><md-select \nng-model=\"vm.requisition.departmentFirsRecept.id\" ng-required=\"vm.requisition.receivedDouble\" \nname=\"departmentFirsRecept\" ng-disabled=\"vm.loadingDepartments\" md-on-close=\"vm.clearSearchDepartmentFirsRecept()\">\n<md-select-header><input id=\"searchDepartmentFirsRecept\" name=\"searchDepartmentFirsRecept\" \nng-model=\"vm.searchDepartmentFirsRecept\" type=\"search\" placeholder=\"Buscar departamento\"></md-select-header>\n<md-optgroup label=\"Departamentos\"><md-option ng-value=\"{{deptoF.id}}\" \nng-repeat=\"deptoF in vm.departmentsF| filter:vm.searchDepartmentFirsRecept\">\n{{deptoF.description}} ({{deptoF.companyName}})</md-option></md-optgroup></md-select><md-progress-linear \nmd-mode=\"indeterminate\" ng-if=\"vm.loadingDepartments\"></md-progress-linear><div \nng-messages=\"vm.requisitionForm.departmentFirsRecept.$error\"><div ng-message=\"required\" \ntranslate=\"REQUISITION.ERROR.FIELD_REQUIRED\">This date is required!</div></div></md-input-container></div><div \nlayout-gt-xs=\"row\" layout-align=\"start center\" layout-align=\"start center\"><md-input-container flex-gt-xs><label \ntranslate=\"REQUISITION.REQUISITION_TYPE\">requisitionType</label><md-select \nng-model=\"vm.requisition.requisitionType.id\" ng-required=\"true\" name=\"requisitionType\" ng-disabled=\"vm.loading\" \nmd-on-close=\"vm.clearSearchRequisitionType()\"><md-select-header><input id=\"searchRequisitionType\" \nname=\"searchRequisitionType\" ng-model=\"vm.searchRequisitionType\" type=\"search\" \nplaceholder=\"Buscar tipo de requerimiento\"></md-select-header><md-optgroup label=\"requisitionTypes\"><md-option \nng-value=\"{{data.id}}\" ng-repeat=\"data in vm.requisitionTypes| filter:vm.searchRequisitionType\">{{data.description}}\n</md-option></md-optgroup></md-select><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loading\">\n</md-progress-linear><div ng-messages=\"vm.requisitionForm.requisitionType.$error\"><div ng-message=\"required\" \ntranslate=\"REQUISITION.ERROR.FIELD_REQUIRED\">This is required!</div></div></md-input-container><md-input-container \nflex-gt-xs><label translate=\"REQUISITION.DESCRIPTION\">requisitionType</label><input id=\"description\" \nng-model=\"vm.requisition.description\" type=\"text\" placeholder=\"Descripcion del Requerimiento\"></md-input-container>\n</div><div layout-gt-xs=\"row\" layout-align=\"start center\" layout-align=\"start center\"><md-input-container flex-gt-xs \nng-if=\"vm.dimensionCompanyDetail3\"><label>{{vm.dimensionCompanyDetail3.description}}</label><md-select \nng-model=\"vm.requisition.dimensionCompanyDetail3.id\" name=\"dimensionCompanyDetail3\" \nmd-on-close=\"vm.searchDimensionCompanyDetail3=\'\'\" ng-required=\"vm.dimensionCompanyDetail3.required\" \nng-disabled=\"vm.requisitionFromOtherOrigin\"><md-select-header><input id=\"searchDimensionCompanyDetail3\" \nng-model=\"vm.searchDimensionCompanyDetail3\" type=\"search\" translate translate-attr-placeholder=\"general.search\" \naria-label=\"search-dimension-company\" ng-keydown=\"$event.stopPropagation()\"></md-select-header><md-optgroup \nlabel=\"dimensionCompanyDetail3\"><md-option value=\"{{data.id}}\" \nng-repeat=\"data in vm.dimensionCompanyDetail3List|\n                                                                filter:vm.searchDimensionCompanyDetail3\">\n{{data.code}} - {{data.name}}</md-option></md-optgroup></md-select><md-progress-linear md-mode=\"indeterminate\" \nng-if=\"vm.loadingdimensionCompanyDetail3List\"></md-progress-linear></md-input-container><md-input-container flex-gt-xs \nng-if=\"vm.dimensionCompanyDetail4\"><label>{{vm.dimensionCompanyDetail4.description}}</label><md-select \nng-model=\"vm.requisition.dimensionCompanyDetail4.id\" name=\"dimensionCompanyDetail4\" \nmd-on-close=\"vm.searchDimensionCompanyDetail4=\'\'\" ng-required=\"vm.dimensionCompanyDetail4.required\" \nng-disabled=\"vm.requisitionFromOtherOrigin\"><md-select-header><input id=\"searchDimensionCompanyDetail4\" \nng-model=\"vm.searchDimensionCompanyDetail4\" type=\"search\" translate translate-attr-placeholder=\"general.search\" \naria-label=\"search-dimension-company\" ng-keydown=\"$event.stopPropagation()\"></md-select-header><md-optgroup \nlabel=\"dimensionCompanyDetail4\"><md-option value=\"{{data.id}}\" \nng-repeat=\"data in vm.dimensionCompanyDetail4List|\n                                                                filter:vm.searchDimensionCompanyDetail4\">\n{{data.code}} - {{data.name}}</md-option></md-optgroup></md-select><md-progress-linear md-mode=\"indeterminate\" \nng-if=\"vm.loadingdimensionCompanyDetail4List\"></md-progress-linear></md-input-container><md-input-container flex-gt-xs \nng-if=\"vm.dimensionCompanyDetail5\"><label>{{vm.dimensionCompanyDetail5.description}}</label><md-select \nng-model=\"vm.requisition.dimensionCompanyDetail5.id\" name=\"dimensionCompanyDetail5\" \nmd-on-close=\"vm.searchDimensionCompanyDetail5=\'\'\" ng-required=\"vm.dimensionCompanyDetail5.required\" \nng-disabled=\"vm.requisitionFromOtherOrigin\"><md-select-header><input id=\"searchDimensionCompanyDetail5\" \nng-model=\"vm.searchDimensionCompanyDetail5\" type=\"search\" translate translate-attr-placeholder=\"general.search\" \naria-label=\"search-dimension-company\" ng-keydown=\"$event.stopPropagation()\"></md-select-header><md-optgroup \nlabel=\"dimensionCompanyDetail5\"><md-option value=\"{{data.id}}\" \nng-repeat=\"data in vm.dimensionCompanyDetail5List|\n                                                                filter:vm.searchDimensionCompanyDetail5\">\n{{data.code}} - {{data.name}}</md-option></md-optgroup></md-select><md-progress-linear md-mode=\"indeterminate\" \nng-if=\"vm.loadingdimensionCompanyDetail5List\"></md-progress-linear></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\" ng-if=\"vm.statusToChange===\'Creando\'\"><md-input-container flex><label translate=\"INVOICE.UPLOAD\">\n</label><div ng-include=\"\'app/main/apps/files/files.html\'\"></div></md-input-container></div></div></div></div></form>\n</md-tab-body></md-tab><md-tab aria-controls=\"tab2-content\"><md-tab-body><div class=\"toolbar\"><div layout=\"row\"><div \nclass=\"customer\" layout=\"column\"><span><strong translate=\"REQUISITION.DEPARTMENT\"></strong>\n {{vm.requisition.department.description}}</span> <span><strong translate=\"REQUISITION.COST_CENTER\"></strong>\n {{vm.requisition.costCenter.description}}</span> <span><strong translate=\"REQUISITION.MAXDATEPURCHASE\"></strong>\n {{vm.requisition.maxDatePurchase| date: \'dd-MM-yyyy\'}}</span></div><span flex></span><div class=\"customer\" \nlayout=\"column\"><span ng-if=\"vm.requisition.referenceId\"><strong translate=\"REQUISITION.ORIGIN\"></strong> <a \ntarget=\"_blank\" href=\"{{vm.requisition.originType.queryUrl}}{{vm.requisition.referenceId}}\">\n{{vm.replaceOriginTypedata(vm.requisition, vm.requisition.originType.originTypeUrlDescription)}} </a></span><span>\n<strong translate=\"REQUISITION.STATUS\"></strong> {{vm.requisition.purchaseStatus.description}}</span> <span><strong \ntranslate=\"REQUISITION.REQUISITION_TYPE\"></strong> {{vm.requisition.requisitionType.description}}</span> <span><strong \ntranslate=\"REQUISITION.DESCRIPTION\"></strong> {{vm.requisition.description}}</span></div><span flex></span><div \nclass=\"customer\" layout=\"column\"><span \nng-if=\"vm.requisition.originType && vm.requisition.originType.originTypeCode === \'01\' && vm.requisition.urgentPurchase\">\n<strong translate=\"REQUISITION.PURCHASE_TYPE\"></strong>{{\"REQUISITION.MSG.URGENT_PURCHASE\"| translate}} </span><span \nng-if=\"vm.requisition.originType && vm.requisition.originType.originTypeCode === \'01\' && vm.requisition.departmentFirsRecept.id\">\n<strong translate=\"REQUISITION.DEPARTMENT_FIRST_RECEPT\"></strong> {{vm.requisition.departmentFirsRecept.description}}\n</span></div><span flex></span><div class=\"customer\" layout=\"column\"><span ng-if=\"vm.dimensionCompanyDetail3\"><strong>\n{{vm.dimensionCompanyDetail3.description}}</strong> {{vm.requisition.dimensionCompanyDetail3.name}} </span><span \nng-if=\"vm.dimensionCompanyDetail4\"><strong>{{vm.dimensionCompanyDetail4.description}}</strong>\n {{vm.requisition.dimensionCompanyDetail4.name}} </span><span ng-if=\"vm.dimensionCompanyDetail5\"><strong>\n{{vm.dimensionCompanyDetail5.description}}</strong> {{vm.requisition.dimensionCompanyDetail5.name}}</span></div></div>\n</div><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loading\" class=\"md-accent\"></md-progress-linear><div \nid=\"masterGridOptionsR\" ag-grid=\"vm.masterGridOptions\" class=\"ag-fresh\" expand-grid min=\"260\" other=\"150\"></div>\n</md-tab-body></md-tab><md-tab aria-controls=\"tab3-content\"><md-tab-body><div id=\"masterGridOptionsFiles\" \nag-grid=\"vm.masterGridOptionsFiles\" class=\"ag-fresh\" expand-grid min=\"260\" other=\"150\"></div></md-tab-body></md-tab>\n</md-tabs></md-content></div></div></div><md-button class=\"md-fab md-fab-bottom-right\" aria-label=\"addDetail\" \nng-if=\"vm.currentTab != 2\" ng-disabled=\"vm.requisitionForm.$invalid || vm.filesToUpload.length > vm.maxNumberFiles\" \nng-click=\"vm.openAddDialog($event)\"><md-icon md-font-icon=\"icon-plus\" ng-if=\"vm.currentTab === 1\"><md-tooltip \nmd-direction=\"top\">{{\"general.add\"| translate}}</md-tooltip></md-icon><md-icon md-font-icon=\"icon-arrow-right\" \nng-if=\"vm.currentTab === 0\"><md-tooltip md-direction=\"top\">{{\"general.next\"| translate}}</md-tooltip></md-icon>\n</md-button>");
$templateCache.put("app/main/apps/requisition/requisition/requisition_view.html","<div id=\"budgetO\" class=\"page-layout carded fullwidth\" layout=\"column\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" \nlayout=\"row\" layout-align=\"start center\" flex><md-button class=\"goto-orders-button md-icon-button\" \naria-label=\"Go to orders\" ng-click=\"vm.gotoRequisitions()\" translate \ntranslate-attr-aria-label=\"REQUISITION.GO_TO_ORDERS\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div\n layout=\"column\" layout-align=\"start start\"><div class=\"h2\"><span translate=\"REQUISITION.REQUISITION\">Order</span> \n<span>{{vm.requisition.id}}</span></div><div class=\"subtitle secondary-text\"></div></div></div></div><md-tabs \nmd-selected=\"vm.currentTab\"><md-tab id=\"tab1\" aria-controls=\"tab1-content\"><md-tab-label><md-icon \nmd-font-icon=\"icon-indent\"></md-icon><span translate=\"REQUISITION.ENCABEZADO\">Requisition Details</span></md-tab-label>\n</md-tab><md-tab id=\"tab2\" aria-controls=\"tab2-content\"><md-icon md-font-icon=\"icon-cube-unfolded\"></md-icon><span \ntranslate=\"REPORT.PROCESS_FLOW.FLOW\">Diagrama</span></md-tab><md-tab id=\"tab3\" aria-controls=\"tab3-content\" \nng-disabled=\"!(vm.requisitionFiles.length>0 && vm.filesToUpload.length>0) || vm.loadingFiles\"><md-icon \nmd-font-icon=\"icon-file-image\"></md-icon><span translate=\"REQUISITION.FILES\">Archivos</span></md-tab></md-tabs>\n<md-content class=\"content\" flex ms-scroll><md-tabs md-dynamic-height md-selected=\"vm.currentTab\" \nclass=\"tab-in-content\"><md-tab aria-controls=\"tab1-content\"><md-tab-body><div class=\"content-card\" layout=\"column\" \nflex><div ng-class=\"vm.dinamicSize > 900 ? \'toolbar\' : \'customer-toolbar\'\"><div layout=\"row\"><span flex></span>\n<md-button ng-show=\"vm.statusToChange && vm.details.length > 0 && vm.isBuyer !== false && vm.isBuyer !== true\" \nng-disabled=\"$rootScope.loadingProgress\" class=\"md-raised md-primary\" ng-click=\"vm.presentRequisition()\" \naria-label=\"present budget\" translate translate-attr-aria-label=\"REQUISITION.ORDER_DETAILS\"><span>\n{{\'REQUISITION.STATUSCHANGE.\' + vm.statusToChange| translate}}</span><md-tooltip md-direction=\"top\" \nmd-visible=\"tooltipVisible\">{{\'REQUISITION.STATUSCHANGE.\' + vm.statusToChange| translate}}</md-tooltip></md-button>\n<md-button ng-show=\"(vm.statusToChange && vm.details.length > 0 && vm.refuseRequisition) || vm.isBuyer\" \nng-disabled=\"$rootScope.loadingProgress\" class=\"md-raised md-warn\" ng-click=\"vm.noAutorizeDetail()\" \naria-label=\"rechaze\" translate translate-attr-aria-label=\"rechaze\"><span>\n{{\'REQUISITION.STATUSCHANGE.NoAutorizado\'| translate}}</span><md-tooltip md-direction=\"top\" \nmd-visible=\"tooltipVisible\">{{\'REQUISITION.STATUSCHANGE.NoAutorizado\'| translate}}</md-tooltip></md-button><md-button \nng-show=\"!vm.statusToChange && vm.canDuplicate && vm.details.length > 0 && !vm.isBuyer\" \nng-disabled=\"$rootScope.loadingProgress\" class=\"md-raised md-primary\" ng-click=\"vm.duplicateRequisition()\" \naria-label=\"present budget\" translate translate-attr-aria-label=\"REQUISITION.ORDER_DETAILS\"><span>\n{{\'REQUISITION.DUPLICATE_REQUISITION\'| translate}}</span><md-tooltip md-direction=\"top\" md-visible=\"tooltipVisible\">\n{{\'REQUISITION.DUPLICATE_REQUISITION\'| translate}}</md-tooltip></md-button></div></div><md-content class=\"content\" \nflex ms-scroll><fieldset class=\"standard\"><legend>{{\'REQUISITION.REQUISITION_DATA\'| translate}}</legend><div \nlayout=\"row\"><div flex layout-wrap layout-gt-sm=\"row\" id=\"generalData\" \nng-class=\"vm.dinamicSize > 900 ? \'\' : \'customer-toolbar\'\"><div flex=\"100\" layout=\"row\" layout-xs=\"column\" class=\"p-6\">\n<div flex=\"30\"><span class=\"title\"><strong translate=\"REQUISITION.DEPARTMENT\"></strong></span></div><div flex=\"70\">\n<span>{{vm.requisition.department.description}}</span></div></div><div flex=\"100\" layout=\"row\" layout-xs=\"column\" \nclass=\"p-6\"><div flex=\"30\"><span class=\"title\"><strong translate=\"REQUISITION.COST_CENTER\"></strong></span></div><div \nflex=\"70\"><span>{{vm.requisition.costCenter.description}}</span></div></div><div flex=\"100\" layout=\"row\" \nlayout-xs=\"column\" class=\"p-6\"><div flex=\"30\"><span class=\"title\"><strong translate=\"REQUISITION.MAXDATEPURCHASE\">\n</strong></span></div><div flex=\"70\"><span>{{vm.requisition.maxDatePurchase | date: \'dd-MM-yyyy\'}}</span></div></div>\n<div flex=\"100\" layout=\"row\" layout-xs=\"column\" class=\"p-6\"><div flex=\"30\"><span ng-if=\"vm.requisition.referenceId\">\n<strong translate=\"REQUISITION.ORIGIN\"></strong></span></div><div flex=\"70\"><span><a target=\"_blank\" \nhref=\"{{vm.requisition.originType.queryUrl}}\n                                                    {{vm.requisition.referenceId}}\">\n{{vm.replaceOriginTypedata(vm.requisition, vm.requisition.originType.originTypeUrlDescription)}}</a></span></div></div>\n<div flex=\"100\" layout=\"row\" layout-xs=\"column\" class=\"p-6\"><div flex=\"30\"><span class=\"title\"><strong \ntranslate=\"REQUISITION.STATUS\"></strong></span></div><div flex=\"70\"><span>{{vm.requisition.purchaseStatus.description}}\n</span></div></div><div flex=\"100\" layout=\"row\" layout-xs=\"column\" class=\"p-6\"><div flex=\"30\"><span class=\"title\">\n<strong translate=\"REQUISITION.REQUISITION_TYPE\"></strong></span></div><div flex=\"70\"><span>\n{{vm.requisition.requisitionType.description}}</span></div></div></div><span flex=\"1\"></span><div flex layout-wrap \nlayout-gt-sm=\"row\" id=\"generalData\" ng-class=\"vm.dinamicSize > 900 ? \'\' : \'customer-toolbar\'\"><div flex=\"100\" \nlayout=\"row\" layout-xs=\"column\"><div flex=\"40\"><span><strong translate=\"REQUISITION.DESCRIPTION\"></strong></span></div>\n<div flex=\"60\"><span>{{vm.requisition.description}}</span></div></div><div flex=\"100\" layout=\"row\" layout-xs=\"column\" \nng-if=\"vm.requisition.originType &&\n                                        vm.requisition.originType.originTypeCode === \'01\' &&\n                                        vm.requisition.urgentPurchase\">\n<div flex=\"40\"><span><strong translate=\"REQUISITION.PURCHASE_TYPE\"></strong></span></div><div flex=\"60\"><span>\n{{\"REQUISITION.MSG.URGENT_PURCHASE\"| translate}}</span></div></div><div flex=\"100\" layout=\"row\" layout-xs=\"column\"><div\n flex=\"40\"><span \nng-if=\"vm.requisition.originType\n                                                && vm.requisition.originType.originTypeCode === \'01\'\n                                                && vm.requisition.departmentFirsRecept.id\">\n<strong translate=\"REQUISITION.DEPARTMENT_FIRST_RECEPT\"></strong></span></div><div flex=\"60\"><span>\n{{vm.requisition.departmentFirsRecept.description}}</span></div></div><div flex=\"100\" layout=\"row\" layout-xs=\"column\" \nng-if=\"vm.dimensionCompanyDetail3\"><div flex=\"40\"><span ng-if=\"vm.dimensionCompanyDetail3\"><strong>\n{{vm.dimensionCompanyDetail3.description}}</strong></span></div><div flex=\"60\"><span>\n{{vm.requisition.dimensionCompanyDetail3.name}}</span></div></div><div flex=\"100\" layout=\"row\" layout-xs=\"column\" \nng-if=\"vm.dimensionCompanyDetail4\"><div flex=\"40\"><span ng-if=\"vm.dimensionCompanyDetail4\"><strong>\n{{vm.dimensionCompanyDetail4.description}}</strong></span></div><div flex=\"60\"><span>\n{{vm.requisition.dimensionCompanyDetail4.name}}</span></div></div><div flex=\"100\" layout=\"row\" layout-xs=\"column\" \nng-if=\"vm.dimensionCompanyDetail5\"><div flex=\"40\"><span ng-if=\"vm.dimensionCompanyDetail5\"><strong>\n{{vm.dimensionCompanyDetail5.description}}</strong></span></div><div flex=\"60\"><span>\n{{vm.requisition.dimensionCompanyDetail5.name}}</span></div></div></div></div></fieldset><md-progress-linear \nmd-mode=\"indeterminate\" ng-if=\"vm.loading\" class=\"md-accent\"></md-progress-linear><div id=\"masterGridOptions\" \nag-grid=\"vm.masterGridOptions\" class=\"ag-fresh\" expand-grid min=\"260\" other=\"150\"></div></md-content></div>\n</md-tab-body></md-tab><md-tab aria-controls=\"tab2-content\"><md-tab-body><div \nng-include=\"\'app/main/apps/reports/process-flow/process-flow.html\'\"></div></md-tab-body></md-tab><md-tab \naria-controls=\"tab3-content\"><md-tab-body><div id=\"masterGridOptionsFiles\" ag-grid=\"vm.masterGridOptionsFiles\" \nclass=\"ag-fresh\" expand-grid min=\"260\" other=\"150\"></div></md-tab-body></md-tab></md-tabs></md-content></div></div>");
$templateCache.put("app/main/apps/requisition/requisition-autorize/requisitions-autorize.html","<div id=\"requisition-autorize\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-backburger\"></md-icon><span>\n{{\'REQUISITION.PENDING.\' + vm.statusToChange | translate}}</span></div><div class=\"order-count secondary-text\"><span \ntranslate=\"REQUISITION.TOTAL_REQUISITION\">Total Requerimientos:</span> <span>{{vm.requisitions.length}}</span></div>\n</div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"e-commerce-products-search\" ng-model=\"vm.search\" \nclass=\"search-input\" type=\"text\" placeholder=\"Search\" translate translate-attr-placeholder=\"REQUISITION.SEARCH\" \nng-model-options=\"{\'debounce\': 300}\" flex></div><md-button class=\"md-raised md-primary\" \nng-disabled=\"vm.requisitionToAuthorize.length === 0\" ng-click=\"vm.authorizeRequisitions()\">\n{{\"REQUISITION.STATUSCHANGE.Ingresado\" | translate}}</md-button><md-button class=\"md-raised md-warn\" \nng-disabled=\"vm.requisitionToAuthorize.length === 0\" ng-click=\"vm.cancelRequisitions()\">\n{{\"REQUISITION.CANCELAR\" | translate}}</md-button></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loading\" \nclass=\"md-accent\"></md-progress-linear><div id=\"masterGridOptions\" ag-grid=\"vm.masterGridOptions\" class=\"ag-fresh\" \nexpand-grid min=\"260\" other=\"-10\"></div></div></div><md-button class=\"md-fab md-fab-bottom-right\" \nng-if=\"!vm.isTicket && vm.isCreate\" aria-label=\"addBudget\" style=\"position: fixed\" ng-click=\"vm.newRequisition()\">\n<md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"left\">{{\"general.add\"| translate}}</md-tooltip>\n</md-button></div></div>");
$templateCache.put("app/main/apps/requisition/requisition-compare/requisition-compare.html","<div id=\"requisitionCompare\" class=\"page-layout carded fullwidth\" layout=\"column\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"white-fg\" layout=\"column\" layout-align=\"start start\" flex><div layout=\"row\"><md-button \nclass=\"go-to-requisitions-button md-icon-button\" aria-label=\"Go to requisitions\" ng-click=\"vm.gotoRequisitions()\" \ntranslate translate-attr-aria-label=\"REQUISITION.GO_TO_REQUISITIONS\" title=\'{{\"REQUISITION.GO_TO_REPORT\"| translate}}\'>\n<md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"h2\"><span translate=\"REQUISITION.REQUISITION\">Title</span> <span>{{vm.requisition.id}}</span></div></div></div>\n<div layout=\"row\"><md-input-container flex><label translate=\"REQUISITION.CURRENCY\">Currency</label><md-select \nng-model=\"vm.currency\" name=\"currencies\" ng-change=\"vm.changeCurrency()\"><md-option ng-value=\"currency\" \nng-repeat=\"currency in vm.currencies\">{{currency.description}} ({{currency.symbol}})</md-option></md-select>\n<md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loadingDepartments\"></md-progress-linear></md-input-container>\n<md-input-container ng-if=\"vm.showExangeRate\" flex><label translate=\"REQUISITION.EXCHANGE_RATE\"></label><input \nid=\"currencyExchangeRate\" class=\"input-exchange-rate\" type=\"number\" min=\"0.00\" ng-model=\"vm.currencyExchangeRate\" \nng-enter=\"vm.convertAmounts()\"></md-input-container><md-button class=\"md-primary md-raised button-exchange-rate\" \nng-if=\"vm.showExangeRate\" ng-disabled=\"!vm.currencyExchangeRate > 0\" ng-click=\"vm.convertAmounts()\">\n{{\"REQUISITION.CONVERT\"| translate}}</md-button></div></div><div class=\"white-fg\" layout=\"row\" \nlayout-align=\"start center\"><md-button \nng-class=\"{\'md-fab md-mini md-warn\': !vm.isHorizontalPer, \n                           \'md-fab md-mini md-primary\': vm.isHorizontalPer}\" \naria-label=\"Horizontal\" ng-click=\"vm.isVerticalPer = false; vm.showPercentageByOrientation(\'isHorizontalPer\', \'H\')\" \ntitle=\'{{\"REQUISITION.SEE_HORIZONTAL_PERCENTAGES\"| translate}}\'><md-icon md-font-icon=\"icon-swap-horizontal\"></md-icon>\n</md-button><md-button \nng-class=\"{\'md-fab md-mini md-warn\': !vm.isVerticalPer, \n                           \'md-fab md-mini md-primary\': vm.isVerticalPer}\" \naria-label=\"Vertical\" ng-click=\"vm.isHorizontalPer = false; vm.showPercentageByOrientation(\'isVerticalPer\', \'V\')\" \ntitle=\'{{\"REQUISITION.SEE_VERTICAL_PERCENTAGES\"| translate}}\'><md-icon md-font-icon=\"icon-swap-vertical\"></md-icon>\n</md-button></div></div><md-content class=\"content\" flex ms-scroll><md-progress-linear md-mode=\"indeterminate\" \nng-if=\"vm.loading\" class=\"md-accent\"></md-progress-linear><div id=\"masterGridOptions\" ag-grid=\"vm.masterGridOptions\" \nclass=\"ag-fresh\" expand-grid min=\"260\" other=\"-10\"></div></md-content></div></div>");
$templateCache.put("app/main/apps/requisition/requisition-report/requisition-report.html","<div id=\"mail\" class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"start center\" \nstyle=\"min-height:10px; height: 13px; margin-top: 30px; padding: 2px 0\"><div class=\"search-wrapper\" layout=\"row\" \nlayout-align=\"space-between center\" flex ng-hide=\"vm.hiddenSearch\"><div><md-checkbox ng-model=\"vm.searchTicket\" \naria-label=\"Finished?\"><strong><span translate=\"REQUISITION.SEARCH_PLACEHOLDER_TICKET\">BUSCAR POR TICKET</span>\n</strong></md-checkbox></div><div class=\"white-fg\"><h1 ng-if=\"vm.requisition.id\">\n{{\'REQUISITION.REQUISITION\' | translate}} # {{vm.requisition.id}}</h1></div></div></div><div class=\"header\" \nlayout=\"row\" flex layout-align=\"start center\" style=\"height: 13px; margin-top: -25px; padding: 10px 0\"><div \nclass=\"search-wrapper md-whiteframe-4dp\" layout=\"row\" layout-align=\"start center\" flex ng-hide=\"vm.hiddenSearch\"><div \nclass=\"search\" flex layout=\"row\" layout-align=\"start center\"><input ng-if=\"!vm.searchTicket\" \nng-enter=\"vm.getRequisition(vm.search)\" flex ng-model=\"vm.search\" type=\"number\" translate \ntranslate-attr-placeholder=\"REQUISITION.SEARCH_PLACEHOLDER_REQUISITION\"> <input ng-if=\"vm.searchTicket\" \nng-enter=\"vm.getRequisition(vm.search)\" flex ng-model=\"vm.search\" type=\"number\" translate \ntranslate-attr-placeholder=\"REQUISITION.SEARCH_PLACEHOLDER_TICKET\"><md-button class=\"md-icon-button\" \nng-click=\"vm.getRequisition(vm.search)\" aria-label=\"Back\" translate translate-attr-aria-label=\"MAIL.BACK\"><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon></md-button></div></div></div><div class=\"content-card\" layout=\"column\" flex><div\n class=\"data\" layout=\"column\" flex><md-tabs md-selected=\"vm.currentTab\"><md-tab id=\"tab0\" aria-controls=\"tab0-content\" \nng-if=\"vm.requisitionList.length>0\"><md-tab-label><md-icon md-font-icon=\"icon-format-list-numbers\"></md-icon><span \ntranslate=\"REQUISITION.LIST\">List Requisitions</span></md-tab-label></md-tab><md-tab id=\"tab1\" \naria-controls=\"tab1-content\" ng-if=\"vm.requisition.id\"><md-tab-label ng-if=\"vm.requisition.id\"><md-icon \nmd-font-icon=\"icon-indent\"></md-icon><span translate=\"REQUISITION.ENCABEZADO\">Requisition Details</span></md-tab-label>\n</md-tab><md-tab id=\"tab2\" aria-controls=\"tab2-content\" ng-if=\"vm.requisition.id\"><md-tab-label \nng-if=\"vm.requisition.id\"><md-icon md-font-icon=\"icon-cube-unfolded\"></md-icon><span \ntranslate=\"REPORT.PROCESS_FLOW.FLOW\">Diagrama</span></md-tab-label></md-tab><md-tab id=\"tab6\" \naria-controls=\"tab6-content\" ng-if=\"vm.requisition.id\"><md-tab-label ng-if=\"vm.requisition.id\"><md-icon \nmd-font-icon=\"icon-file-image\"></md-icon><span translate=\"REQUISITION.FILES\">Requisition Files</span></md-tab-label>\n</md-tab><md-tab id=\"tab3\" aria-controls=\"tab3-content\" ng-if=\"vm.quotationsDetails.length > 0\"><md-tab-label \nng-if=\"vm.quotationsDetails.length > 0\"><md-icon md-font-icon=\"icon-cash-100\"></md-icon><span \ntranslate=\"QUOTATION.QUOTATION\">Quotation</span></md-tab-label></md-tab><md-tab id=\"tab4\" aria-controls=\"tab4-content\" \nng-if=\"vm.detailsPurchaseOrder.length > 0\"><md-tab-label><md-icon md-font-icon=\"icon-cart\"></md-icon><span \ntranslate=\"ORDER.ORDER\">PurchaseOrder</span></md-tab-label></md-tab><md-tab id=\"tab5\" aria-controls=\"tab5-content\" \nng-if=\"vm.detailsInvoice.length > 0\"><md-tab-label><md-icon md-font-icon=\"icon-receipt\"></md-icon><span \ntranslate=\"INVOICE.INVOICE\">Invoice</span></md-tab-label></md-tab></md-tabs><md-content class=\"content\" flex ms-scroll>\n<md-tabs md-dynamic-height md-selected=\"vm.currentTab\" class=\"tab-in-content\"><md-tab aria-controls=\"tab0-content\" \nng-if=\"vm.requisitionList.length > 0\"><md-tab-body ng-if=\"vm.requisitionList.length > 0\"><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loading\" \nclass=\"md-accent\"></md-progress-linear><div id=\"masterGridOptionsRequisitions\" \nag-grid=\"vm.masterGridOptionsRequisitions\" class=\"ag-fresh\" expand-grid min=\"260\" other=\"100\"></div></div>\n</md-tab-body></md-tab><md-tab aria-controls=\"tab1-content\" ng-show=\"vm.requisition.id\"><md-tab-body \nng-show=\"vm.requisition.id\"><div class=\"content-card\" layout=\"column\" flex ng-show=\"vm.requisition.id\"><div \nng-class=\"vm.dinamicSize > 900 ? \'toolbar\' : \'customer-toolbar\'\"><div layout=\"row\"><div class=\"customer\" \nlayout=\"column\"><span><strong translate=\"REQUISITION.DEPARTMENT\"></strong> {{vm.requisition.department.description}}\n</span> <span><strong translate=\"REQUISITION.COST_CENTER\"></strong> {{vm.requisition.costCenter.description}}</span> \n<span><strong translate=\"REQUISITION.MAXDATEPURCHASE\"></strong> {{vm.requisition.maxDatePurchase| date: \'dd-MM-yyyy\'}}\n</span></div><span flex></span><div class=\"customer\" layout=\"column\"><span ng-if=\"vm.requisition.referenceId\"><strong \ntranslate=\"REQUISITION.ORIGIN\"></strong> <a target=\"_blank\" \nhref=\"{{vm.requisition.originType.queryUrl}}{{vm.requisition.referenceId}}\">\n{{vm.replaceOriginTypedata(vm.requisition, vm.requisition.originType.originTypeUrlDescription)}} </a></span><span>\n<strong translate=\"REQUISITION.STATUS\"></strong> {{vm.requisition.purchaseStatus.description}}</span> <span><strong \ntranslate=\"REQUISITION.REQUISITION_TYPE\"></strong> {{vm.requisition.requisitionType.description}}</span> <span><strong \ntranslate=\"REQUISITION.DESCRIPTION\"></strong> {{vm.requisition.description}}</span></div><span flex></span><div \nclass=\"customer\" layout=\"column\"><span><strong translate=\"CONTRACT.DATE_CREATED\"></strong>\n {{vm.requisition.createdAt.dayOfMonth}}/{{vm.requisition.createdAt.monthValue}}/{{vm.requisition.createdAt.year}} \n</span><span><strong translate=\"CONTRACT.BY_CREATED\"></strong> {{vm.requisition.createdBy}}</span></div><span flex>\n</span><div class=\"customer\" layout=\"column\"><span \nng-if=\"vm.requisition.originType && vm.requisition.originType.originTypeCode === \'01\' && vm.requisition.urgentPurchase\">\n<strong translate=\"REQUISITION.PURCHASE_TYPE\"></strong>{{\"REQUISITION.MSG.URGENT_PURCHASE\"| translate}} </span><span \nng-if=\"vm.requisition.originType && vm.requisition.originType.originTypeCode === \'01\' && vm.requisition.departmentFirsRecept\">\n<strong translate=\"REQUISITION.DEPARTMENT_FIRST_RECEPT\"></strong> {{vm.requisition.departmentFirsRecept.description}}\n</span> <span ng-if=\"vm.dimensionCompanyDetail3\"><strong>{{vm.dimensionCompanyDetail3.description}}</strong>\n {{vm.requisition.dimensionCompanyDetail3.name}} </span><span ng-if=\"vm.dimensionCompanyDetail4\"><strong>\n{{vm.dimensionCompanyDetail4.description}}</strong> {{vm.requisition.dimensionCompanyDetail4.name}} </span><span \nng-if=\"vm.dimensionCompanyDetail5\"><strong>{{vm.dimensionCompanyDetail5.description}}</strong>\n {{vm.requisition.dimensionCompanyDetail5.name}}</span></div><span flex></span><div class=\"customer\" layout=\"column\" \nng-if=\"vm.editBussinesData\"><span><strong>{{\"REQUISITION.MSG.EDITBUSSINESDATA\"| translate}}</strong></span><md-button \naria-label=\"Add shortcut\" ng-click=\"vm.editBussines($event)\"><md-icon md-menu-origin \nmd-font-icon=\"icon-pencil-box-outline\" class=\"icon amber-600-fg s24\"></md-icon><md-tooltip \nng-if=\"vm.purchaseOrderStatus === \'Recibido\'\"><span translate=\"SETTLEMENT.NO_AUTHORIZE\">\n{{\"REQUISITION.MSG.EDITBUSSINESDATA\"| translate}}</span></md-tooltip></md-button></div></div></div><div \nclass=\"md-background-bg md-whiteframe-1dp\"><div class=\"content fullpage-datatable\" layout=\"column\" flex>\n<md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loading\" class=\"md-accent\"></md-progress-linear><div \nid=\"masterGridOptions\" ag-grid=\"vm.masterGridOptions\" class=\"ag-fresh\" expand-grid min=\"260\" other=\"200\"></div></div>\n</div></div></md-tab-body></md-tab><md-tab aria-controls=\"tab1-content\" ng-show=\"vm.requisition.id\"><md-tab-body><div \nng-include=\"\'app/main/apps/reports/process-flow/process-flow.html\'\"></div></md-tab-body></md-tab><md-tab \naria-controls=\"tab6-content\" ng-show=\"vm.requisition.id\n                            && vm.requisitionFiles.length>0\">\n<md-tab-body ng-show=\"vm.requisition.id && vm.requisitionFiles.length>0\"><div id=\"masterGridOptionsFiles\" \nag-grid=\"vm.masterGridOptionsFiles\" class=\"ag-fresh\" expand-grid min=\"260\" other=\"150\"></div></md-tab-body></md-tab>\n<md-tab aria-controls=\"tab3-content\" ng-show=\"vm.quotationsDetails.length > 0\"><md-tab-body><div \nclass=\"order-detail-form-container products md-background-bg md-whiteframe-1dp\"><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loading\" \nclass=\"md-accent\"></md-progress-linear><div id=\"masterGridOptionsQuotation\" ag-grid=\"vm.masterGridOptionsQuotation\" \nclass=\"ag-fresh\" expand-grid min=\"260\" other=\"100\"></div></div></div></md-tab-body></md-tab><md-tab \naria-controls=\"tab4-content\" ng-show=\"vm.detailsPurchaseOrder.length > 0\"><md-tab-body><div \nclass=\"order-detail-form-container products md-background-bg md-whiteframe-1dp\"><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loading\" \nclass=\"md-accent\"></md-progress-linear><div id=\"masterGridOptionsPurchaseOrder\" \nag-grid=\"vm.masterGridOptionsPurchaseOrder\" class=\"ag-fresh\" expand-grid min=\"260\" other=\"100\"></div></div></div>\n</md-tab-body></md-tab><md-tab aria-controls=\"tab5-content\" ng-show=\"vm.detailsInvoice.length > 0\"><md-tab-body><div \nclass=\"order-detail-form-container products md-background-bg md-whiteframe-1dp\"><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loading\" \nclass=\"md-accent\"></md-progress-linear><div id=\"masterGridOptionsInvoice\" ag-grid=\"vm.masterGridOptionsInvoice\" \nclass=\"ag-fresh\" expand-grid min=\"260\" other=\"100\"></div></div></div></md-tab-body></md-tab></md-tabs></md-content>\n</div></div></div></div>");
$templateCache.put("app/main/apps/requisition/requisition-cotize/requisitions-cotize.html","<div id=\"requisition-autorize\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-backburger\"></md-icon><span>\n{{\'REQUISITION.PENDING.\' + vm.statusToChange | translate}}</span></div><div class=\"order-count secondary-text\"><span \ntranslate=\"REQUISITION.TOTAL_REQUISITION\">Total Requerimientos:</span> <span>{{vm.requisitions.length}}</span></div>\n</div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"e-commerce-products-search\" ng-model=\"vm.search\" \nclass=\"search-input\" type=\"text\" placeholder=\"Search\" translate translate-attr-placeholder=\"REQUISITION.SEARCH\" \nng-model-options=\"{\'debounce\': 300}\" flex></div></div><div class=\"white-fg\" layout=\"column\" layout-align=\"start end\" \nng-if=\"vm.filterPendingQuote\"><md-checkbox ng-model=\"vm.pendingAssignment\" ng-click=\"vm.loadDataToCotize()\">\n{{\'REQUISITION.FILTER_PENDING_ASSIGNMENT\'| translate}}</md-checkbox></div><div class=\"content-card\" layout=\"column\" \nflex><div class=\"content fullpage-datatable\" layout=\"column\" flex><md-progress-linear md-mode=\"indeterminate\" \nng-if=\"vm.loading\" class=\"md-accent\"></md-progress-linear><div id=\"masterGridOptions\" ag-grid=\"vm.masterGridOptions\" \nclass=\"ag-fresh\" expand-grid min=\"260\" other=\"-10\"></div></div></div><md-button class=\"md-fab md-fab-bottom-right\" \nng-if=\"!vm.isTicket && vm.isCreate\" aria-label=\"addBudget\" style=\"position: fixed\" ng-click=\"vm.newRequisition()\">\n<md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"left\">{{\"general.add\"| translate}}</md-tooltip>\n</md-button></div></div>");
$templateCache.put("app/main/apps/requisition/requisition-template/requisition-templates.html","<div id=\"productTemplate\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div\n class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-cart-outline\"></md-icon><span translate=\"TEMPLATE.PRODUCT_TEMPLATE\">Plantillas</span></div>\n<div class=\"order-count secondary-text\"><span translate=\"TEMPLATE.TOTAL_PRODUCT_TEMPLATE\">Total Plantillas</span> \n<span>{{vm.productTemplates.length}}</span></div></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" \nflex><md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input \nid=\"e-commerce-products-search\" ng-model=\"vm.search\" class=\"search-input\" type=\"text\" placeholder=\"Search\" translate \ntranslate-attr-placeholder=\"general.search\" ng-model-options=\"{\'debounce\': 300}\" flex></div></div><div \nclass=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex>\n<md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loading\" class=\"md-accent\"></md-progress-linear><div \nid=\"masterGridOptions\" ag-grid=\"vm.masterGridOptions\" class=\"ag-fresh\" expand-grid min=\"260\" other=\"-10\"></div></div>\n</div><md-button class=\"md-fab md-fab-bottom-right\" aria-label=\"addBudget\" style=\"position: fixed\" \nng-click=\"vm.newTemplateDetail()\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"left\">\n{{\"general.add\"| translate}}</md-tooltip></md-button></div></div>");
$templateCache.put("app/main/apps/requisition/requisitionType/requisitionType.html","<div id=\"requisitionType\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div\n class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-cog-box\"></md-icon><span translate=\"CONFIGURATION.REQUISITION_TYPE\">Configurar</span></div>\n</div></div><md-progress-linear md-mode=\"indeterminate\" ng-show=\"vm.loading\"></md-progress-linear><div \nclass=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex>\n<md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loading\" class=\"md-accent\"></md-progress-linear><div \nid=\"masterGridOptions\" ag-grid=\"vm.masterGridOptions\" class=\"ag-fresh\" expand-grid min=\"260\" other=\"60\"></div></div>\n<div class=\"content fullpage-datatable\" layout=\"column\" flex><div class=\"loading-threads\" layout=\"column\" \nlayout-align=\"center center\" ng-if=\"vm.allBlockedSeries.length === 0\"></div></div></div><md-button \nclass=\"md-fab md-fab-bottom-right\" aria-label=\"add\" style=\"position: fixed\" ng-click=\"vm.createRequisitionType()\">\n<md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"left\">{{\"general.add\"| translate}}</md-tooltip>\n</md-button></div></div>");
$templateCache.put("app/main/apps/shippingOrder/detail_shipping_order/shippingOrder.html","<div id=\"budgetO\" class=\"page-layout carded fullwidth\" layout=\"column\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" \nlayout=\"row\" layout-align=\"start center\" flex><md-button class=\"goto-orders-button md-icon-button\" \naria-label=\"Go to orders\" ng-click=\"vm.gotoBack()\" translate translate-attr-aria-label=\"ORDER.GO_TO_ORDERS\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"column\" layout-align=\"start start\"><div class=\"h2\">\n<span translate=\"SHIPPING_ORDER.SHIPPING_ORDER\">shipping</span> <span>{{vm.shippingOrder.id}}</span></div><div \nclass=\"subtitle secondary-text\"></div></div></div></div><md-tabs md-selected=\"vm.currentTab\" \nng-if=\"vm.showProcessFlow\"><md-tab id=\"tab1\" aria-controls=\"tab1-content\"><md-tab-label><md-icon \nmd-font-icon=\"icon-indent\"></md-icon><span translate=\"REQUISITION.ENCABEZADO\">Detalles</span></md-tab-label></md-tab>\n</md-tabs><md-content class=\"content\" flex ms-scroll><md-tabs md-dynamic-height md-selected=\"vm.currentTab\" \nclass=\"tab-in-content\"><md-tab aria-controls=\"tab1-content\"><md-tab-body><div class=\"content-card\" layout=\"column\" \nflex><div class=\"toolbar\"><div layout=\"row\"><div class=\"customer\" layout=\"column\" flex><span><strong \ntranslate=\"ORDER.DEPARTMENT\"></strong> {{vm.shippingOrder.purchaseOrder.department.description}}</span> <span><strong \ntranslate=\"ORDER.COST_CENTER\"></strong> {{vm.shippingOrder.purchaseOrder.costCenter.description}}</span> <span><strong \ntranslate=\"ORDER.PURCHASESTATUS\"></strong> {{vm.shippingOrder.shippingStatus.description}}</span></div><div \nclass=\"customer\" layout=\"column\" flex><span><strong translate=\"ORDER.PROVIDER\"></strong>\n {{vm.shippingOrder.purchaseOrder.companyProvider.name}}</span> <span><strong translate=\"ORDER.BUYER\"></strong>\n {{vm.shippingOrder.purchaseOrder.company.name}}</span> <span><strong translate=\"ORDER.TOTAL\"></strong>\n {{vm.shippingOrder.purchaseOrder.total| number:2}}</span></div><div class=\"customer\" layout=\"column\" flex><span>\n<strong translate=\"ORDER.SHIPPING_ORDER.USER\"></strong> {{vm.shippingOrder.user.name}}</span> <span><strong \ntranslate=\"SHIPPING_ORDER.PURCHASE_ORDER\"></strong> {{vm.shippingOrder.purchaseOrder.id}}</span></div></div></div>\n<md-content class=\"content\" flex ms-scroll><div class=\"content fullpage-datatable\" layout=\"column\" flex>\n<md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loading\" class=\"md-accent\"></md-progress-linear><div \nid=\"masterGridOptionsOC\" ag-grid=\"vm.masterGridOptions\" class=\"ag-fresh\" expand-grid min=\"260\" other=\"200\"></div></div>\n</md-content></div></md-tab-body></md-tab></md-tabs></md-content></div></div>");
$templateCache.put("app/main/general/auth/login/login.html","<div id=\"login-v2\" layout=\"row\" layout-align=\"start\"><div id=\"login-v2-intro\" flex hide show-gt-sm><div \nclass=\"description\" translate=\"LOGIN_V2.INTRO_DESCRIPTION\"></div></div><div id=\"login-v2-form-wrapper\" \nclass=\"flex-scrollable md-whiteframe-8dp\" ms-scroll><div id=\"login-v2-form\"><div class=\"logo\" hide-gt-sm><span><img \nng-src=\"{{vm.urlIcons}}\" alt=\"image\"></span></div><div layout=\"column\" layout-align=\"start center\"><div class=\"title\" \ntranslate=\"LOGIN_V2.TITLE\"></div></div><br><div layout=\"column\" layout-align=\"start center\"><md-button \naria-label=\"Login\" class=\"md-raised google\" ng-click=\"vm.authenticate(\'OIDC\')\" translate=\"LOGIN_V2.WITH_OIDC\">\n</md-button><a class=\"link\" ng-click=\"vm.forgetPassword();\">Olvide mi contraseña</a></div><div class=\"register\" \nlayout=\"row\" layout-sm=\"column\" layout-align=\"center center\"><span class=\"text\" translate=\"LOGIN_V2.DONT_HAVE_ACCOUNT\">\n</span> <a class=\"link\" ng-click=\"vm.register();\" translate=\"LOGIN_V2.CREATE_ACCOUNT\"></a></div></div></div></div>");
$templateCache.put("app/main/general/auth/lock/lock.html","<div id=\"lock\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"lock-form-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div id=\"lock-form\" class=\"md-whiteframe-8dp\"><div layout=\"row\" \nlayout-align=\"start center\" layout-sm=\"column\" layout-align-sm=\"center center\"><div class=\"avatar-container\"><img \nclass=\"avatar big\" src=\"{{userAccount.person.image}}\" alt=\"image\"><md-icon md-font-icon=\"icon-lock\" \nclass=\"md-warn-fg s36 md-hue-2\"></md-icon></div><div flex layout=\"column\" layout-align=\"start\" \nlayout-align-sm=\"center center\"><div class=\"title\" translate=\"LOCK.TITLE\"></div><div class=\"subtitle\" \ntranslate=\"LOCK.SUBTITLE\"></div></div></div><form name=\"lockForm\" novalidate><md-button \nclass=\"md-raised md-accent submit-button\" aria-label=\"UNLOCK\" ng-click=\"vm.authenticate(\'OIDC\')\" \ntranslate=\"LOCK.UNLOCK\" translate-attr-aria-label=\"LOCK.UNLOCK\"></md-button></form><div class=\"message\"><a \nui-sref=\"auth.login\" class=\"md-accent-color\"><span translate=\"LOCK.ARE_YOU_NOT\"></span><span> {{account.name}}?</span>\n</a></div></div></div></div>");
$templateCache.put("app/main/general/errors/unauthorized/unauthorized.html","<div id=\"maintenance\" class=\"flex-scrollable\" layout=\"column\" ms-scroll ng-cloak><div id=\"maintenance-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"maintenance-form\" class=\"md-whiteframe-8dp\"><h1>\n{{\'ERRORS.noAutorizado.no_acceso_app\'| translate}}</h1><div class=\"logo\"><img ng-src=\"{{vm.iconApp}}\" alt=\"image\">\n</div><div class=\"subtitle\">{{\'ERRORS.noAutorizado.comuniquese_con_admin\'| translate}}</div><div><md-button \nclass=\"md-primary\" ng-click=\"vm.goToConfigureCompany()\">{{\'ERRORS.noAutorizado.configurarEmpresa\'| translate}}\n</md-button></div></div></div></div>");
$templateCache.put("app/main/general/profile/profileEditor/profileEditor.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"space-between\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" ui-sref=\"app.profile\" \nstyle=\"cursor: pointer\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\">\n</md-icon><span class=\"parent\" style=\"cursor: pointer\" ui-sref=\"app.profile\">\n{{vm.userInfo.name}} {{vm.userInfo.familyName}}</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\">\n</md-icon><span class=\"parent\" translate=\"PROFILE.EDIT.TITLE\">Edit</span></div><div class=\"title\"><span \ntranslate=\"PROFILE.EDIT.TITLE\">Edit</span> {{vm.userInfo.name}} {{vm.userInfo.familyName}}</div></div><div \nclass=\"actions\" layout=\"row\" layout-align=\"end center\"><md-button class=\"md-fab md-warn\" style=\"height: 56px\" \naria-label=\"Edit\" ui-sref=\"app.profile\"><md-icon md-svg-icon=\"close\"></md-icon></md-button></div></div>\n<md-progress-linear md-mode=\"indeterminate\" ng-show=\"vm.loading\"></md-progress-linear><div class=\"content\" \nlayout=\"column\"><div layout=\"row\"><ms-form-wizard flex><md-tabs md-dynamic-height md-selected=\"msWizard.selectedIndex\" \nmd-center-tabs=\"true\"><md-tab><md-tab-label><span class=\"ms-form-wizard-step-label\"><span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$invalid\">1</span> <span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$valid\"><em class=\"icon-check s16\"></em> </span>\n<span class=\"ms-form-wizard-step-text\" translate=\"PROFILE.GENERAL_INFORMATION\">Personal Information</span></span>\n</md-tab-label><md-tab-body><form name=\"wizardStep1\" class=\"md-inline-form\" ms-form-wizard-form novalidate><div \nlayout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex=\"100\" flex-gt-xs=\"25\" flex-gt-md=\"50\">CHANFLE <input \ntype=\"text\" name=\"firstname\" ng-model=\"vm.userInfo.name\" placeholder=\"{{\'PROFILE.EDIT.NAME\'| translate}}\" required><div\n ng-messages=\"wizardStep1.firstname.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\'PROFILE.EDIT.NAME\'| translate}} {{\'PROFILE.EDIT.REQUIRED\'| translate}}.</span></div></div></md-input-container>\n<md-input-container flex=\"100\" flex-gt-xs=\"25\" flex-gt-md=\"50\"><input type=\"text\" name=\"middlename\" \nng-model=\"vm.userInfo.middleName\" placeholder=\"{{\'PROFILE.EDIT.SNAME\'| translate}}\"></md-input-container>\n<md-input-container flex=\"100\" flex-gt-xs=\"30\" flex-gt-md=\"50\"><input type=\"text\" name=\"familyName\" \nng-model=\"vm.userInfo.familyName\" placeholder=\"{{\'PROFILE.EDIT.LASTNAME\'| translate}}\"></md-input-container>\n<md-input-container flex=\"100\" flex-gt-xs=\"20\" flex-gt-md=\"50\"><input type=\"text\" name=\"givenName\" \nng-model=\"vm.userInfo.givenName\" placeholder=\"{{\'PROFILE.EDIT.TNAME\'| translate}}\"></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex=\"100\" flex-gt-xs=\"20\"><input type=\"text\" \nname=\"nickname\" ng-model=\"vm.userInfo.nickname\" placeholder=\"{{\'PROFILE.EDIT.NICKNAME\'| translate}}\">\n</md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"80\"><input type=\"email\" name=\"email\" \nng-model=\"vm.userInfo.email\" placeholder=\"{{\'PROFILE.EDIT.EMAIL\'| translate}}\" ng-pattern=\"/^.+@.+\\..+$/\" required><div\n ng-messages=\"wizardStep1.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\n{{\'PROFILE.EDIT.EMAIL\'| translate}} {{\'PROFILE.EDIT.REQUIRED\'| translate}}.</span></div><div ng-message=\"pattern\">\n<span>{{\'PROFILE.EDIT.EMAIL\'| translate}} {{\'PROFILE.EDIT.EINVALID\'| translate}}</span></div></div>\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex=\"100\" flex-gt-xs=\"50\">\n<label>{{\'PROFILE.EDIT.GENDER\'| translate}}</label><md-select ng-model=\"vm.userInfo.gender\"><md-option \nng-repeat=\"gender in vm.genders\" value=\"{{gender}}\">{{\'SEXO.\' + gender| translate}}</md-option></md-select>\n</md-input-container><div flex=\"100\" flex-gt-xs=\"50\"><md-datepicker class=\"md-block\" ng-model=\"vm.userInfo.birthdate\" \nmd-placeholder=\"Enter date\"></md-datepicker></div></div><div layout=\"column\" layout-gt-sm=\"row\" flex>\n<md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"password\" name=\"password\" \nng-model=\"vm.userInfo.preferredUsername.password\" placeholder=\"{{\'PROFILE.EDIT.PASSWORD\'| translate}}\">\n</md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"password\" name=\"passwordConfirm\" \nplaceholder=\"{{\'PROFILE.EDIT.PASSWORD\'| translate}} ({{\'PROFILE.EDIT.CONFIRM\'| translate}})\" \nng-model=\"vm.userInfo.validatePassword\" ng-pattern=\"{{vm.userInfo.preferredUsername.password}}\" \nng-required=\"vm.userInfo.preferredUsername.password\"><div ng-messages=\"wizardStep1.passwordConfirm.$error\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\n{{\'PROFILE.EDIT.PASSWORD\'| translate}} ({{\'PROFILE.EDIT.CONFIRM\'| translate}}) {{\'PROFILE.EDIT.REQUIRED\'| translate}}.\n</span></div><div ng-message=\"pattern\"><span>\n{{\'PROFILE.EDIT.PASSWORD\'| translate}} ({{\'PROFILE.EDIT.CONFIRM\'| translate}}) {{\'PROFILE.EDIT.MATCH\'| translate}}.\n</span></div></div></md-input-container></div></form></md-tab-body></md-tab><md-tab ng-disabled=\"wizardStep1.$invalid\">\n<md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" \nng-if=\"wizardStep2.$invalid\">2</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep2.$valid\">\n<em class=\"icon-check s16\"></em> </span><span class=\"ms-form-wizard-step-text\" translate=\"PROFILE.PROFILE\">Profile\n</span></span></md-tab-label><md-tab-body><form name=\"wizardStep2\" ms-form-wizard-form novalidate><md-input-container \nclass=\"md-block\"><label>{{\'PROFILE.ABOUT_ME\'| translate}}</label><textarea rows=\"3\" name=\"profile\" md-maxlength=\"150\" \nmax-rows=\"5\" ng-model=\"vm.userInfo.profile\"></textarea></md-input-container><md-input-container class=\"md-block\">\n<label>{{\'PROFILE.PICTURE\'| translate}}</label><input type=\"file\" name=\"picture\" ng-model=\"vm.userInfo.picture\" \nplaceholder=\"Picture\"> <button ng-click=\"uploadFileGenerico(person.id)\" class=\"btn btn-sm\">Cargar</button>\n</md-input-container></form></md-tab-body></md-tab><md-tab ng-disabled=\"wizardStep1.$invalid || wizardStep2.$invalid\">\n<md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" \nng-if=\"wizardStep3.$invalid\">3</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$valid\">\n<em class=\"icon-check s16\"></em> </span><span class=\"ms-form-wizard-step-text\" translate=\"PROFILE.CONTACT\">Contact\n</span></span></md-tab-label><md-tab-body><form name=\"wizardStep3\" ms-form-wizard-form novalidate><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex=\"100\" flex-gt-xs=\"80\"><label>{{\'PROFILE.EDIT.ADDRESS\'| translate}}</label>\n<textarea rows=\"1\" name=\"address\" md-maxlength=\"150\" max-rows=\"3\" ng-model=\"vm.userInfo.locale\"></textarea>\n</md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"20\"><label>{{\'PROFILE.EDIT.POSTAL\'| translate}}</label>\n<input name=\"postalcode\" ng-model=\"vm.userInfo.zoneinfo\" placeholder=\"12345\" ng-pattern=\"/^[0-9]{5}$/\" \nmd-maxlength=\"5\"><div ng-messages=\"wizardStep3.postalcode.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"pattern\"><span>That doesn\'t look like a valid postal code.</span></div><div ng-message=\"md-maxlength\">\n<span>Postal code can\'t be longer than 5 characters.</span></div></div></md-input-container></div><md-input-container \nclass=\"md-block\"><input type=\"tel\" name=\"phone\" ng-model=\"vm.userInfo.phoneNumber\" \nplaceholder=\"{{\'PROFILE.EDIT.PHONE\'| translate}}\"></md-input-container><md-input-container class=\"md-block\"><input \ntype=\"url\" name=\"website\" ng-model=\"vm.userInfo.website\" placeholder=\"{{\'PROFILE.EDIT.WEBSITE\'| translate}}\">\n</md-input-container></form></md-tab-body></md-tab></md-tabs><div class=\"navigation\" flex layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-raised md-accent\" ng-click=\"msWizard.previousStep()\" \nng-disabled=\"msWizard.isFirstStep()\"><span translate=\"PROFILE.EDIT.PREVIOUS\">Previous</span></md-button><div \nclass=\"steps\"><span ng-repeat=\"form in msWizard.forms\" \nng-class=\"{\n                                          \'selected md-accent-bg\':msWizard.selectedIndex === $index}\">\n</span></div><md-button class=\"md-raised md-accent\" ng-click=\"msWizard.nextStep()\" ng-hide=\"msWizard.isLastStep()\" \nng-disabled=\"msWizard.currentStepInvalid()\"><span translate=\"PROFILE.EDIT.NEXT\">Next</span></md-button><md-button \nclass=\"md-raised md-warn\" ng-click=\"vm.sendForm(); msWizard.resetForm();\" ng-show=\"msWizard.isLastStep()\" \nng-disabled=\"msWizard.formsIncomplete()\"><span translate=\"PROFILE.EDIT.SAVE\">Send</span></md-button></div>\n</ms-form-wizard></div></div></div>");
$templateCache.put("app/main/general/notifications/configuration/configuration.html","<div id=\"notification-configuration-view\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div class=\"center\" \nlayout=\"column\" flex><div class=\"header\" layout-xl=\"row\" layout-align-xl=\"space-between center\" layout-lg=\"row\" \nlayout-align-lg=\"space-between center\" layout-xs=\"column\" layout-align-xs=\"none center\"><div class=\"title\" flex=\"20\" \nflex-xs=\"100\"><span>{{\'notifications.setup_notifications\'| translate}}</span></div><div flex=\"20\" \nclass=\"applications-select\" layout=\"column\"><span>{{\'notifications.filter_by_application\' | translate}}:</span>\n<md-select aria-label=\"filter by application\" ng-model=\"vm.applicationsSelected\" \nng-change=\"vm.filterConfigByAppName()\"><md-option ng-value=\"application.id\" \nng-repeat=\"application in vm.applicationsArray\">{{application.name}}</md-option></md-select></div></div><div \nclass=\"content-card\" ms-scroll flex layout=\"column\" \nng-include=\"\'app/main/general/notifications/configuration/content/content.html\'\"></div></div></div>");
$templateCache.put("app/main/general/notifications/my-notifications/my-notifications.html","<div id=\"my-notifications-view\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div class=\"center\" \nlayout=\"column\" flex><div class=\"header\" layout-xl=\"row\" layout-align-xl=\"space-between center\" layout-lg=\"row\" \nlayout-align-lg=\"space-between center\" layout-xs=\"column\" layout-align-xs=\"none center\"><div class=\"title\" flex=\"20\" \nflex-xs=\"100\"><span>{{\'notifications.my_notifications\' | translate}}</span></div><div layout=\"column\" flex=\"80\" \nclass=\"search-container\"><div class=\"search\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><input flex ng-enter=\"vm.search()\" \nng-click=\"vm.showAdvancedFilter = false;\" ng-model=\"vm.searchInput\" type=\"search\" \nplaceholder=\"{{\'general.search\'| translate}}\"><md-button title=\"{{\'notifications.show_search_options\' | translate}}\" \nng-click=\"vm.showAdvancedFilter = !vm.showAdvancedFilter;\" class=\"md-icon-button\"><md-icon \nmd-font-icon=\"icon-chevron-down\" class=\"s18\"></md-icon></md-button></div><div ng-if=\"vm.showAdvancedFilter\" \nid=\"advanced-filter\" layout=\"column\" ng-include=\"\'app/main/general/notifications/my-notifications/filter/filter.html\'\" \nng-controller=\"MyNotificationsFilterController as filterCtrl\"></div></div></div><md-card class=\"content-card\" flex \nlayout=\"column\" ng-include=\"\'app/main/general/notifications/my-notifications/content/content.html\'\"></md-card></div>\n</div>");
$templateCache.put("app/quick-panel/tabs/my-notifications/view-notification/view-notification.html","<md-dialog aria-label=\"view notification\" id=\"view-my-notification\"><div class=\"notification-toolbar\" layout=\"row\"><div\n flex layout=\"row\" layout-align=\"end center\"><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon \nmd-font-icon=\"icon-close\" class=\"s18\"></md-icon></md-button></div></div><div layout=\"row\" layout-align=\"start center\" \nclass=\"notification\"><div layout=\"column\" flex><div class=\"notification-info\" layout=\"column\"><div layout=\"row\"><div \nclass=\"applicationFrom\" flex>{{\'notifications.application\'| translate}}: {{vm.notification.applicationName}}</div><div \nlayout=\"row\" layout-align=\"end center\" class=\"notification-date\"><span>\n{{vm.notification.createdAt| apiDate: \'dd-MM-yyyy HH:mm\'}}</span></div></div><div layout=\"row\"><div flex layout=\"row\" \nlayout-align=\"start center\"><div class=\"userFrom\" ng-if=\"vm.notification.userFromId\">\n{{\'notifications.from\'| translate}}: {{vm.notification.userFromName}} ({{vm.notification.userFromAccount}})</div></div>\n<div layout=\"row\" layout-align=\"end center\" class=\"icon-alert-type\" \nng-class=\"{\'warning-type\': vm.notification.alertType === \'WARNING\',\n                         \'error-type\': vm.notification.alertType === \'ERROR\',\n                         \'success-type\': vm.notification.alertType === \'SUCCESS\',\n                         \'message-type\': vm.notification.alertType === \'MESSAGE\'}\">\n<md-icon md-font-icon=\"icon-pin\" class=\"s20\" ng-if=\"!vm.notification.isUserNotification\"></md-icon><md-icon \nmd-font-icon=\"icon-message-text\" class=\"s20\" \nng-if=\"vm.notification.alertType === \'MESSAGE\' && vm.notification.isUserNotification\"></md-icon><md-icon \nmd-font-icon=\"icon-check\" class=\"s20\" \nng-if=\"vm.notification.alertType === \'SUCCESS\' && vm.notification.isUserNotification\"></md-icon><md-icon \nmd-font-icon=\"icon-alert\" class=\"s20\" \nng-if=\"vm.notification.alertType === \'WARNING\' && vm.notification.isUserNotification\"></md-icon><md-icon \nmd-font-icon=\"icon-cancel\" class=\"s20\" \nng-if=\"vm.notification.alertType === \'ERROR\' && vm.notification.isUserNotification\"></md-icon></div></div><div \nclass=\"origin-type-info\" layout=\"row\" layout-align=\"estart center\" \nng-if=\"vm.notification.originTypeId !== null && vm.notification.originTypeId !== undefined\">\n{{vm.notification.originTypeName}}: {{vm.notification.referenceNumber}}</div></div><div class=\"notification-message\" \nng-bind-html=\"vm.notification.message\"></div></div></div><div layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-primary\" ng-click=\"vm.closeDialog()\">{{\'general.close\'| translate}}</md-button></div></md-dialog>");
$templateCache.put("app/main/general/errors/404/error-404.html","<div id=\"maintenance\" class=\"flex-scrollable\" layout=\"column\" ms-scroll ng-cloak><div id=\"maintenance-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"maintenance-form\" class=\"md-whiteframe-8dp\"><h1>\n{{\'ERRORS.405.MESSAGE\'| translate}}</h1><div class=\"logo\"><img ng-src=\"{{vm.iconApp}}\" alt=\"image\"></div><div \nclass=\"subtitle\">{{\'ERRORS.405.CODE\'| translate}}</div><div><a class=\"back-link md-accent-color\" href=\"/\" \nui-sref=\"app.dashboards_project\" translate=\"ERRORS.405.GO_BACK\">Go back to dashboard</a></div></div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-1/template-1.html","<div class=\"template-1\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-10/template-10.html","<div class=\"template-10 p-16\"><div class=\"pb-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"info\">\n<div class=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h2\" \nng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"media ml-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div><div \nclass=\"text\">{{card.text}}</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-3/template-3.html","<div class=\"template-3 p-16 teal-bg white-fg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" \nlayout-align=\"space-between\"><div class=\"info\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div \nclass=\"subtitle h3 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"cta\"><md-button \nclass=\"m-0\">{{card.cta}}</md-button></div></div><div class=\"media pl-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-4/template-4.html","<div class=\"template-4\"><div class=\"info white-fg ph-16 pv-24\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"text\" ng-if=\"card.text\">{{card.text}}</div></div><div class=\"media\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-2/template-2.html","<div class=\"template-2\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"text p-16\" ng-if=\"card.text\">{{card.text}}\n</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-6/template-6.html","<div class=\"template-6\"><div class=\"content pv-24 ph-16\"><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div><div class=\"title h2\" ng-if=\"card.title\">{{card.title}}</div><div class=\"text pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-5/template-5.html","<div class=\"template-5 p-16\" layout=\"row\" layout-align=\"space-between start\"><div class=\"info\"><div \nclass=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"event h2\" ng-if=\"card.event\">\n{{card.event}}</div></div><div class=\"media ml-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-7/template-7.html","<div class=\"template-7\" layout=\"row\" layout-align=\"space-between\"><div class=\"info\" layout=\"column\" \nlayout-align=\"space-between\" layout-fill flex><div class=\"p-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"subtitle h4 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"text h4 pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div><div><md-divider></md-divider><div class=\"p-8\" layout=\"row\"><md-icon \nmd-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\">\n</md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" \nclass=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon></div></div></div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-8/template-8.html","<div class=\"template-8\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"buttons pt-16\"><md-button class=\"m-0\">{{card.button1}}</md-button><md-button class=\"m-0 md-accent\">\n{{card.button2}}</md-button></div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-9/template-9.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"text ph-16 pb-16\" ng-if=\"card.text\">{{card.text}}</div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div><div class=\"buttons m-8\"><md-button class=\"md-icon-button mr-16\" \naria-label=\"Favorite\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-share\" class=\"s24\"></md-icon></md-button></div>\n</div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/vertical.html","<div class=\"ms-stepper-vertical\"><div class=\"ms-stepper-vertical-line\"></div><div class=\"ms-stepper-steps\" \nng-transclude></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/horizontal/horizontal.html","<div class=\"ms-stepper-horizontal\"><div class=\"ms-stepper-navigation-wrapper\"><div class=\"ms-stepper-navigation\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(step.stepNumber), \'valid\': MsStepper.isStepValid(step.stepNumber), \'disabled\': MsStepper.isStepDisabled(step.stepNumber), \'optional\': MsStepper.isStepOptional(step.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(step.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(step.stepNumber)\" \nng-repeat=\"step in MsStepper.steps | filter:MsStepper.filterHiddenStep\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"step md-accent-bg\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(step.stepNumber) || MsStepper.isStepOptional(step.stepNumber)\">{{$index + 1}} </span>\n<span ng-if=\"MsStepper.isStepValid(step.stepNumber) && !MsStepper.isStepOptional(step.stepNumber)\"><i \nclass=\"icon icon-check s18\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div class=\"title\" \ntranslate=\"{{step.stepTitleTranslate}}\">{{step.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(step.stepNumber)\">Optional</div></div></md-button></div></div><div \nclass=\"ms-stepper-steps\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" \nng-click=\"MsStepper.gotoPreviousStep()\">{{MsStepper.backDescriptionButton}}</md-button><div class=\"ms-stepper-dots\">\n<span ng-repeat=\"step in MsStepper.steps\" ng-hide=\"MsStepper.isStepHidden(step.stepNumber)\" \nng-class=\"{\'selected md-accent-bg\':MsStepper.currentStepNumber === $index + 1}\"></span></div><md-button \nclass=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">\n{{MsStepper.nextDescriptionButton}}</md-button><md-button type=\"submit\" class=\"md-accent md-raised\" \nng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" ng-disabled=\"!MsStepper.isFormValid()\">\n{{MsStepper.submitDescriptionButton}}</md-button></div></div>");
$templateCache.put("app/main/apps/accountStatus/sidenavs/filter/filter.html","<div class=\"header\" layout=\"column\" layout-align=\"space-between start\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-filter\" class=\"icon s24\"></md-icon>\n</span><span class=\"logo-text\" translate=\"REPORT.FILTER\">Filter</span></div></div><div class=\"content\"><form \nname=\"filterForm\"><div layout=\"column\" class=\"filter\"><md-input-container flex class=\"inputfilter\"><label \ntranslate=\"REPORT.STARTDATE\">Start Date</label><md-datepicker type=\"date\" ng-model=\"vm.filter.startDate\" \nng-change=\"vm.changeStartDate()\" name=\"startDate\" md-min-date=\"vm.minDate\" md-open-on-focus></md-datepicker><div \nng-messages=\"vm.filterForm.startDate.$error\"><div ng-message=\"valid\" translate=\"REPORT.ERROR.INVALID_DATE\">\nThe entered value is not a date!</div><div ng-message=\"required\" translate=\"REPORT.ERROR.FIELD_REQUIRED\">\nThis date is required!</div><div ng-message=\"mindate\" translate=\"REPORT.ERROR.INVALID_DATE\">Date is too early!</div>\n</div></md-input-container><md-input-container flex class=\"inputfilter\"><label translate=\"REPORT.ENDDATE\">End Date\n</label><md-datepicker type=\"date\" ng-model=\"vm.filter.endDate\" name=\"endDate\" md-min-date=\"vm.filter.startDate\" \nmd-open-on-focus></md-datepicker><div ng-messages=\"vm.filterForm.endDate.$error\"><div ng-message=\"valid\" \ntranslate=\"REPORT.ERROR.INVALID_DATE\">The entered value is not a date!</div><div ng-message=\"required\" \ntranslate=\"REPORT.ERROR.FIELD_REQUIRED\">This date is required!</div><div ng-message=\"mindate\" \ntranslate=\"REPORT.ERROR.INVALID_DATE\">Date is too early!</div></div></md-input-container><md-input-container \nclass=\"inputfilter\" ng-if=\"vm.snFilter.department\"><label>{{\'REPORT.DEPARTMENT\'| translate}}</label><md-select \nng-model=\"vm.filter.departments\" md-on-close=\"vm.clearSearchDepartment()\" multiple=\"multiple\" \nng-disabled=\"vm.loadingDepartments\"><md-select-header><input id=\"searchDepartment\" ng-model=\"vm.searchDepartment\" \ntype=\"search\" placeholder=\"Buscar departamento\"></md-select-header><md-optgroup label=\"Departamentos\"><md-option \nvalue=\"{{department.id}}\" ng-repeat=\"department in vm.departments| filter:vm.searchDepartment\">\n{{department.code}} - {{department.description}}</md-option></md-optgroup></md-select><md-progress-linear \nmd-mode=\"indeterminate\" ng-if=\"vm.loadingDepartments\"></md-progress-linear></md-input-container><md-input-container \nclass=\"inputfilter\" ng-if=\"vm.snFilter.costCenter\"><label>{{\'REPORT.COSTCENTER\'| translate}}</label><md-select \nng-model=\"vm.filter.costCenters\" md-on-close=\"vm.clearSearchCostCenter()\" multiple=\"multiple\" \nng-disabled=\"vm.loadingCostCenter\"><md-select-header><input id=\"searchCostCenter\" ng-model=\"vm.searchCostCenter\" \ntype=\"search\" placeholder=\"Buscar Centro de Costo\"></md-select-header><md-optgroup label=\"Departamentos\"><md-option \nvalue=\"{{costCenter.id}}\" ng-repeat=\"costCenter in vm.costCenters| filter:vm.searchCostCenter\">\n{{costCenter.code}} - {{costCenter.description}}</md-option></md-optgroup></md-select><md-progress-linear \nmd-mode=\"indeterminate\" ng-if=\"vm.loadingCostCenter\"></md-progress-linear></md-input-container><md-input-container \nclass=\"inputfilter\" ng-if=\"vm.snFilter.status\"><label>{{\'REPORT.STATUS\'| translate}}</label><md-select \nng-model=\"vm.filter.statuses\" md-on-close=\"vm.clearSearchStatus()\" multiple=\"multiple\" ng-disabled=\"vm.loadingStatus\">\n<md-select-header><input id=\"searchStatus\" ng-model=\"vm.searchStatus\" type=\"search\" placeholder=\"Buscar Status\">\n</md-select-header><md-optgroup label=\"Departamentos\"><md-option value=\"{{status.id}}\" \nng-repeat=\"status in vm.statuses| filter:vm.searchStatus\">{{status.description}}</md-option></md-optgroup></md-select>\n<md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loadingStatus\"></md-progress-linear></md-input-container>\n<md-button class=\"md-primary\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><span translate=\"REPORT.SEARCH\">Search\n</span></md-button></div></form></div>");
$templateCache.put("app/main/apps/accountStatus/sidenavs/filter/h-filter.html","<md-progress-linear style=\"position: fixed; height: 5px; z-index: 10\" md-mode=\"query\" class=\"md-accent\" \nng-show=\"vm.isShowProgressLinear\"></md-progress-linear><div style=\"padding-top: 5px\"><md-content ng-cloak><md-card>\n<md-button class=\"md-primary button-filter\" target=\"_blank\" ng-click=\"vm.isShowFilter = !vm.isShowFilter\">\n{{\'REPORT.CLICK_FILTRO\'| translate}}<md-icon ng-if=\"vm.isShowFilter\" md-font-icon=\"icon-chevron-down\"></md-icon>\n<md-icon ng-if=\"!vm.isShowFilter\" md-font-icon=\"icon-chevron-right\"></md-icon></md-button><div \nng-show=\"vm.isShowFilter\" class=\"animate-show\"><div layout=\"row\" layout-xs=\"row\" layout-align=\"space-around center\" \nng-if=\"vm.snFilter.checkFilterDate\"><md-checkbox ng-model=\"vm.snFilter.filterByDates\">\n{{\'REPORT.FILTER_DATES\'| translate}}</md-checkbox></div><div layout=\"row\" layout-xs=\"row\" \nlayout-align=\"space-around center\" ng-if=\"vm.snFilter.filterByDates\"><md-datepicker type=\"date\" \nng-model=\"vm.filter.startDate\" md-placeholder=\"Enter start date\" ng-change=\"vm.changeStartDate(true)\" name=\"startDate\" \nmd-open-on-focus></md-datepicker><md-datepicker type=\"date\" ng-model=\"vm.filter.endDate\" \nmd-placeholder=\"Enter end date\" ng-change=\"vm.changeStartDate(false)\" name=\"endDate\" md-min-date=\"vm.filter.startDate\" \nmd-open-on-focus></md-datepicker></div><div layout=\"row\" layout-xs=\"row\" layout-align=\"space-around center\" \nng-if=\"vm.snFilter.checkElectronic\"><md-checkbox ng-model=\"vm.electronic\">\n{{\'REPORT.FILTER_CHECK_ELECTRONIC\'| translate}}</md-checkbox></div><div layout=\"row\" layout-xs=\"row\" \nlayout-align=\"space-around center\" ng-if=\"vm.snFilter.companies\"><md-input-container class=\"inputfilter\" flex \nng-if=\"vm.snFilter.companies\"><label>{{\'REPORT.SELECT_COMPANY\'| translate}}</label><md-select \nng-model=\"vm.filter.companies\" md-on-close=\"vm.clearSearchCompany()\" multiple=\"multiple\" \nng-disabled=\"vm.loadingCompanies\"><md-select-header><input id=\"searchCompany\" ng-model=\"vm.searchCompany\" \ntype=\"search\" placeholder=\"Buscar Empresa\"></md-select-header><md-optgroup label=\"Empresas\"><md-option \nvalue=\"{{data.id}}\" ng-repeat=\"data in vm.companies| filter:vm.searchCompany\">{{data.id}} - {{data.name}}</md-option>\n</md-optgroup></md-select><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loadingCompanies\"></md-progress-linear>\n</md-input-container></div><div layout=\"row\" layout-xs=\"column\"><md-input-container class=\"inputfilter\" flex \nng-if=\"vm.snFilter.department\"><label>{{\'REPORT.DEPARTMENT\'| translate}}</label><md-select \nng-model=\"vm.filter.departments\" md-on-close=\"vm.clearSearchDepartment()\" multiple=\"multiple\" \nng-disabled=\"vm.loadingDepartments\"><md-select-header><input id=\"searchDepartment\" ng-model=\"vm.searchDepartment\" \ntype=\"search\" placeholder=\"Buscar departamento\"></md-select-header><md-optgroup label=\"Departamentos\"><md-option \nvalue=\"{{department.id}}\" ng-repeat=\"department in vm.departments| filter:vm.searchDepartment\">\n{{department.code}} - {{department.description}}</md-option></md-optgroup></md-select><md-progress-linear \nmd-mode=\"indeterminate\" ng-if=\"vm.loadingDepartments\"></md-progress-linear></md-input-container><md-input-container \nclass=\"inputfilter\" flex ng-if=\"vm.snFilter.costCenter\"><label>{{\'REPORT.COSTCENTER\'| translate}}</label><md-select \nng-model=\"vm.filter.costCenters\" md-on-close=\"vm.clearSearchCostCenter()\" multiple=\"multiple\" \nng-disabled=\"vm.loadingCostCenter\"><md-select-header><input id=\"searchCostCenter\" ng-model=\"vm.searchCostCenter\" \ntype=\"search\" placeholder=\"Buscar Centro de Costo\"></md-select-header><md-optgroup label=\"Departamentos\"><md-option \nvalue=\"{{costCenter.id}}\" ng-repeat=\"costCenter in vm.costCenters| filter:vm.searchCostCenter\">\n{{costCenter.description}}</md-option></md-optgroup></md-select><md-progress-linear md-mode=\"indeterminate\" \nng-if=\"vm.loadingCostCenter\"></md-progress-linear></md-input-container><md-input-container class=\"inputfilter\" flex \nng-if=\"vm.snFilter.project\"><label>{{\'REPORT.PROJECT\'| translate}}</label><md-select ng-model=\"vm.filter.projects\" \nmd-on-close=\"vm.clearSearchProject()\" multiple=\"multiple\" ng-disabled=\"vm.loadingProject\"><md-select-header><input \nid=\"searchProject\" ng-model=\"vm.searchProject\" type=\"search\" placeholder=\"Buscar proyecto\"></md-select-header>\n<md-optgroup label=\"Proyectos\"><md-option value=\"{{department.id}}\" \nng-repeat=\"department in vm.projects| filter:vm.searchProject\">{{department.code}} - {{department.name}}</md-option>\n</md-optgroup></md-select><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loadingProject\"></md-progress-linear>\n</md-input-container></div><div layout=\"row\" layout-xs=\"column\"><md-input-container class=\"inputfilter\" flex \nng-if=\"vm.snFilter.idField\"><label>{{\'REPORT.DOC_ENTREGA\'| translate}}</label><input ng-model=\"vm.filter.id\" \ntype=\"number\"></md-input-container><md-input-container class=\"inputfilter\" flex ng-if=\"vm.snFilter.correlativo\"><label>\n{{\'REPORT.NO_FACTURA\'| translate}}</label><input ng-model=\"vm.filter.correlative\" type=\"number\"></md-input-container>\n<md-input-container class=\"inputfilter\" flex ng-if=\"vm.snFilter.status\"><label>{{\'REPORT.STATUS\'| translate}}</label>\n<md-select ng-model=\"vm.filter.statuses\" md-on-close=\"vm.clearSearchStatus()\" multiple=\"multiple\" \nng-disabled=\"vm.loadingStatus\"><md-select-header><input id=\"searchStatus\" ng-model=\"vm.searchStatus\" type=\"search\" \nplaceholder=\"Buscar Status\"></md-select-header><md-optgroup label=\"Departamentos\"><md-option value=\"{{status.id}}\" \nng-repeat=\"status in vm.statuses| filter:vm.searchStatus\">{{status.description}}</md-option></md-optgroup></md-select>\n<md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loadingStatus\"></md-progress-linear></md-input-container>\n<md-input-container class=\"inputfilter\" flex ng-if=\"vm.snFilter.contractValid\"><md-checkbox \nng-if=\"vm.snFilter.contractValid\" ng-model=\"vm.selectContractVAlid\" ng-click=\"vm.selectContractsValid()\">\nBuscar Solo Contratos Vigentes</md-checkbox><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loadingStatus\">\n</md-progress-linear></md-input-container></div><div layout=\"row\" layout-xs=\"column\"><md-input-container \nclass=\"inputfilter\" flex ng-if=\"vm.snFilter.settlementid\"><label>{{\'REPORT.SETTLEMENTID\'| translate}}</label><input \nng-model=\"vm.filter.id\" type=\"number\"></md-input-container><md-input-container class=\"inputfilter\" flex \nng-if=\"vm.snFilter.pettyCashId\"><label>{{\'REPORT.PETTYCASHID\'| translate}}</label><input \nng-model=\"vm.filter.pettyCashId\" type=\"number\"></md-input-container><md-input-container class=\"inputfilter\" flex \nng-if=\"vm.snFilter.invoicePurchaseCorrelative\"><label>{{\'REPORT.INVOICEPURCHASECORRELATIVE\'| translate}}</label><input \nng-model=\"vm.filter.correlative\" type=\"number\"></md-input-container><md-input-container class=\"inputfilter\" flex \nng-if=\"vm.snFilter.SettlementStatus\"><label>{{\'REPORT.SETTLEMENTSTATUS\'| translate}}</label><md-select \nng-model=\"vm.filter.settlementStatus\" md-on-close=\"vm.clearSearchSettlementStatus()\" multiple=\"multiple\" \nng-disabled=\"vm.loadingDepartments\"><md-select-header><input id=\"searchDepartment\" \nng-model=\"vm.searchSettlementStatus\" type=\"search\" placeholder=\"Buscar settlementStatus\"></md-select-header>\n<md-optgroup label=\"settlementStatus\"><md-option value=\"{{settlementStatus.id}}\" \nng-repeat=\"settlementStatus in vm.settlementStatus| filter:vm.searchSettlementStatus\">{{settlementStatus.name}}\n</md-option></md-optgroup></md-select><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loadingSettlementStatus\">\n</md-progress-linear></md-input-container><md-input-container class=\"inputfilter\" flex \nng-if=\"vm.snFilter.pettyCashStatus\"><label>{{\'REPORT.PETTYCASHSTATUS\'| translate}}</label><md-select \nng-model=\"vm.filter.pettyCashStatus\" md-on-close=\"vm.clearSearchPettyCashStatus()\" multiple=\"multiple\" \nng-disabled=\"vm.loading\"><md-select-header><input id=\"searchPettyCashStatus\" ng-model=\"vm.searchPettyCashStatus\" \ntype=\"search\" placeholder=\"Buscar Estado\"></md-select-header><md-optgroup label=\"pettyCashStatus\"><md-option \nvalue=\"{{pettyCashStatus.id}}\" ng-repeat=\"pettyCashStatus in vm.pettyCashStatus| filter:vm.searchPettyCashStatus\">\n{{pettyCashStatus.name}}</md-option></md-optgroup></md-select><md-progress-linear md-mode=\"indeterminate\" \nng-if=\"vm.loadingPettyCashStatus\"></md-progress-linear></md-input-container></div><div layout=\"row\" layout-xs=\"column\">\n<md-input-container class=\"inputfilter\" flex ng-if=\"vm.snFilter.type\"><label>{{\'REPORT.TYPE\'| translate}}</label>\n<md-select ng-model=\"vm.filter.types\" md-on-close=\"vm.clearSearchStatus()\" multiple=\"multiple\" \nng-disabled=\"vm.loadingTypes\"><md-select-header><input id=\"searchType\" ng-model=\"vm.searchType\" type=\"search\" \nplaceholder=\"Buscar Type\"></md-select-header><md-optgroup label=\"Types\"><md-option value=\"{{dat.id}}\" \nng-repeat=\"dat in vm.typeses | filter:vm.searchType\">{{dat.description}}</md-option></md-optgroup></md-select>\n<md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loadingType\"></md-progress-linear></md-input-container></div><div\n layout=\"row\" layout-xs=\"row\" layout-align=\"center center\"><md-button class=\"md-accent md-raised md-hue-1\" \nng-click=\"vm.search()\">{{\'REPORT.SEARCH\'| translate}}</md-button></div></div></md-card></md-content></div>");
$templateCache.put("app/main/apps/contract/contract/compose/compose-dialog.html","<md-dialog class=\"compose-dialog\" aria-label=\"New Message\" ms-scroll><md-toolbar class=\"md-accent md-hue-2\" \nlayout=\"row\" ng-if=\"!vm.searchMode\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div\n style=\"min-width: 400px\"><md-tabs md-selected=\"vm.selectedTab\" class=\"title\"><md-tab id=\"tab12\" \naria-controls=\"tab12-content\" label=\"{{\'CONTRACT.DETAIL.PRODUCT\'| translate}}\"></md-tab><md-tab \nng-disabled=\"!vm.contractPurchaseDetail.product\" id=\"tab22\" aria-controls=\"tab22-content\" \nlabel=\"{{\'CONTRACT.DETAIL.DETAILS\'| translate}}\"></md-tab></md-tabs></div><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.activeSearch()\" aria-label=\"Close dialog\" tranlate ng-if=\"vm.selectedTab === 0\" \ntranslate-aria-label=\"MAIL.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" tranlate \ntranslate-aria-label=\"MAIL.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-toolbar class=\"md-accent md-hue-2\" ng-show=\"vm.searchMode\"><form ng-submit=\"vm.getProducts(1)\" \nname=\"vm.searchForm\"><div class=\"md-toolbar-tools\"><md-button type=\"button\" class=\"md-icon-button\" \nng-click=\"vm.searchMode = !vm.searchMode\" aria-label=\"Back\"><ng-md-icon icon=\"arrow_back\"></ng-md-icon></md-button>\n<md-input-container flex style=\"margin-top: 60px\"><label translate=\"CONTRACT.DETAIL.FILTER\">Filtro</label><input \ntype=\"text\" ng-model=\"vm.filterProduct\" name=\"searchText\" required id=\"searchField\" \nng-model-options=\"{\'debounce\': 500}\"><div ng-messages=\"vm.searchForm.searchText.$error\"><div ng-message=\"required\" \ntranslate=\"CONTRACT.ERROR.FIELD_REQUIRED\">This date is required!</div></div></md-input-container><md-button \ntype=\"submit\" aria-label=\"Search\"><span translate=\"CONTRACT.DETAIL.SEARCH\">Search</span></md-button></div></form>\n</md-toolbar><md-dialog-content ms-scroll flex layout-fill \nng-class=\"vm.selectedTab === 0 ? \'md-dialog-list-content\' : \'\'\"><div ng-if=\"vm.selectedTab === 0\"><div \nclass=\"content thread-list\"><div class=\"thread\" md-ink-ripple ng-if=\"!vm.loading\" \nng-repeat=\"product in vm.productos.content\" ng-click=\"vm.selectProduct(product)\" \nng-class=\"{\n                                 \'current-thread\': vm.selectedProduct(product)}\"><div layout=\"row\" \nng-class=\"vm.isDefaultClass(product);\" layout-align=\"start center\"><div class=\"info\" flex layout=\"row\"><div><div \nclass=\"title h3\"><strong>{{product.productCode ? product.productCode + \' - \' : \'\'}}{{product.name}}</strong></div><div \nclass=\"notes\" layout=\"column\"><span ng-if=\"product.brand\"><strong>Marca: </strong>{{product.brand}}</span> <span \nng-if=\"product.company\"><strong>Empresa: </strong>{{product.company}}</span> <span ng-if=\"product.measurementUnit\">\n<strong>Unidad de Medida: </strong>{{product.measurementUnit.name}}</span></div></div><span flex></span><div \nng-if=\"product.salePrice || product.buyPrice\"><label ng-if=\"product.defaultCC\"><md-tooltip md-direction=\"bottom\">\n{{\"REQUISITION.DETAIL.DEFAULTCC\"| translate}}</md-tooltip><ng-md-icon icon=\"playlist_add_check\"></ng-md-icon></label>\n<label ng-if=\"product.default && !product.defaultCC\"><md-tooltip md-direction=\"bottom\">\n{{\"REQUISITION.DETAIL.DEFAULTGN\"| translate}}</md-tooltip><ng-md-icon icon=\"spellcheck\"></ng-md-icon></label><h1 \nng-if=\"product.buyPrice && product.buyPrice > 0\">{{product.currencyBuy.symbol}} {{product.buyPrice| number: 2}}</h1><h1\n ng-if=\"!product.buyPrice && product.salePrice && product.salePrice > 0\">\n{{product.currencySale.symbol}} {{product.salePrice| number: 2}}</h1></div></div></div><div layout=\"column\" \nlayout-align=\"space-between end\"><div class=\"actions\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"label ng-binding ng-scope md-green-300-bg\" role=\"button\" ng-if=\"vm.selectedProduct(product)\"><md-icon \nmd-font-icon=\"icon-check-all\"></md-icon></div></div></div></div></div><div class=\"div-loader\" ng-show=\"vm.loading\">\n<md-progress-circular class=\"ajax-loader md-accent md-hue-2\" md-mode=\"indeterminate\"></md-progress-circular></div>\n</div><div ng-if=\"vm.selectedTab === 1\"><form name=\"vm.detailForm\" ng-submit=\"vm.sendDetail()\"><div layout=\"column\" \nflex><div class=\"profile-box info-box general md-whiteframe-1dp\" layout=\"column\"><div class=\"content\"><div \nclass=\"info-line\"><div class=\"title\" translate=\"CONTRACT.DETAIL.PRODUCT\">Product</div><div class=\"info\">\n{{vm.contractPurchaseDetail.product.productCode}} {{vm.contractPurchaseDetail.product.name}}</div></div></div></div>\n</div><div layout=\"row\" layout-xs=\"column\"><md-input-container flex-gt-xs><label translate=\"CONTRACT.QUANTITY\">quantity\n</label><input type=\"number\" ng-model=\"vm.contractPurchaseDetail.quantity\" name=\"quantity\" step=\"any\" md-open-on-focus \nrequired><div ng-messages=\"vm.contractPurchaseDetailForm.quantity.$error\"><div ng-message=\"required\" \ntranslate=\"CONTRACT.ERROR.FIELD_REQUIRED\">This is required!</div></div></md-input-container><md-input-container \nflex-gt-xs><label translate=\"CONTRACT.UNIT_PRICE\">total</label><input type=\"number\" \nng-model=\"vm.contractPurchaseDetail.total\" name=\"total\" md-open-on-focus required><div \nng-messages=\"vm.contractPurchaseDetailForm.total.$error\"><div ng-message=\"required\" \ntranslate=\"CONTRACT.ERROR.FIELD_REQUIRED\">This is required!</div></div></md-input-container><md-input-container \nflex-gt-xs><md-checkbox ng-model=\"vm.contractPurchaseDetail.taxesIncluded\">{{\"CONTRACT.TAXESINCLUDED\" | translate}}\n</md-checkbox><div ng-messages=\"vm.contractPurchaseDetailForm.taxesIncluded.$error\"><div ng-message=\"required\" \ntranslate=\"CONTRACT.ERROR.FIELD_REQUIRED\">This is required!</div></div></md-input-container></div></form><md-button \nng-click=\"vm.sendDetail()\" class=\"send-button md-accent md-fab md-fab-bottom-right\" aria-label=\"Send\" \nng-if=\"vm.detailForm.$valid\" ng-disabled=\"vm.loading\" translate-attr-aria-label=\"CONTRACT.DETAIL.SEND\"><md-icon \nmd-font-icon=\"icon-content-save\"></md-icon></md-button></div></md-dialog-content><md-dialog-actions \nstyle=\"justify-content: center\" class=\"actionsSpace\" ng-if=\"vm.selectedTab === 0\"><div paging class=\"pageable-div\" \npage=\"vm.page\" ul-class=\"pagination\" page-size=\"vm.pageSize\" hide-if-empty=\"true\" paging-action=\"vm.getProducts(page)\" \ntotal=\"vm.productos.totalElements\"></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/contract/contract/detail/detail.html","<md-dialog class=\"compose-dialog\" aria-label=\"New Message\" ms-scroll><md-toolbar class=\"md-accent md-hue-2\" \nlayout=\"row\" ng-if=\"!vm.searchMode\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\">\n<span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" tranlate \ntranslate-aria-label=\"MAIL.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll flex layout-fill ng-class=\"vm.selectedTab === 0 ? \'md-dialog-list-content\' : \'\'\"><div \nclass=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex>\n<md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loading\" class=\"md-accent\"></md-progress-linear><div \nid=\"masterGridOptionsE\" ag-grid=\"vm.masterGridOptions\" class=\"ag-fresh\" expand-grid min=\"260\" other=\"200\"></div></div>\n</div></md-dialog-content><md-dialog-actions style=\"justify-content: center\" class=\"actionsSpace\" \nng-if=\"vm.selectedTab === 0\"><div paging class=\"pageable-div\" page=\"vm.page\" ul-class=\"pagination\" \npage-size=\"vm.pageSize\" hide-if-empty=\"true\" paging-action=\"vm.getProducts(page)\" total=\"vm.productos.totalElements\">\n</div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/configuration/messageStatus/messageDialog/messageDialog.html","<md-dialog class=\"compose-dialog\" aria-label=\"New Message\" ms-scroll \nstyle=\"width: 60%; height: 70%; max-width:60%; max-height: 70%\"><md-toolbar class=\"md-accent md-hue-2\" layout=\"row\">\n<div layout=\"row\" layout-align=\"start center\"><span flex translate=\"MESSAGE_STATUS.MESSAGE\"></span></div><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" tranlate \ntranslate-aria-label=\"MAIL.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll flex layout-fill style=\"min-height: 250px\"><form name=\"vm.detailForm\" \nng-submit=\"vm.sendDetail()\"><div layout=\"row\" layout-xs=\"column\"><md-input-container flex-gt-xs><label \ntranslate=\"MESSAGE_STATUS.STATUS\">Status</label><md-select ng-model=\"vm.purchaseStatusCompany.purchaseStatus.id\" \nname=\"status\" required ng-disabled=\"vm.loadingStatus\" md-on-close=\"vm.clearSearchStatus()\"><md-select-header><input \nid=\"searchStatus\" ng-model=\"vm.searchStatus\" type=\"search\" placeholder=\"Buscar estado\"></md-select-header><md-optgroup \nlabel=\"Estados\"><md-option ng-value=\"data.id\" ng-repeat=\"data in vm.statuses | filter:vm.searchStatus\">\n{{data.description}}</md-option></md-optgroup></md-select><md-progress-linear md-mode=\"indeterminate\" \nng-if=\"vm.loadingStatus\"></md-progress-linear><div ng-messages=\"vm.detailForm.status.$error\"><div \nng-message=\"required\" translate=\"REQUISITION.ERROR.FIELD_REQUIRED\">This date is required!</div></div>\n</md-input-container></div><md-input-container class=\"md-block\"><label translate=\"MESSAGE_STATUS.TICKETS_MESSAGE\">\ncommentsForDelivery</label><textarea rows=\"3\" maxlength=\"512\" ng-model=\"vm.purchaseStatusCompany.ticketsMessage\" \nname=\"ticketsMessage\" required></textarea><div ng-messages=\"vm.detailForm.ticketsMessage.$error\"><div \nng-message=\"maxlength\" translate=\"REQUISITION.ERROR.MEX_LENGTH\">This required!</div></div></md-input-container></form>\n</md-dialog-content><md-dialog-actions><md-button ng-click=\"vm.closeDialog()\" \nclass=\"send-button md-fab-bottom-right md-primary\" aria-label=\"Send\" ng-disabled=\"!vm.detailForm.$valid\" \ntranslate-attr-aria-label=\"REQUISITION.DETAIL.SEND\"><span>Cerrar</span><md-tooltip md-direction=\"left\">\n{{\"general.cancel\"| translate}}</md-tooltip></md-button><md-button ng-click=\"vm.sendDetail()\" \nclass=\"send-button md-fab-bottom-right md-primary\" aria-label=\"Send\" ng-disabled=\"!vm.detailForm.$valid\" \ntranslate-attr-aria-label=\"REQUISITION.DETAIL.SEND\"><span>Guardar</span><md-tooltip md-direction=\"left\">\n{{\"general.save\"| translate}}</md-tooltip></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/configuration/purchaseProductDelivery/purchaseProductDeliveryEdit/purchaseProductDeliveryEdit.html","<md-dialog class=\"compose-dialog\" aria-label=\"New Message\" ms-scroll \nstyle=\"width: 95%; height: 95%; max-width:95%; max-height: 95%\"><md-toolbar class=\"md-accent md-hue-2\" layout=\"row\" \nng-if=\"!vm.searchMode\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div \nstyle=\"min-width: 400px\"><md-tabs md-selected=\"vm.selectedTab\" class=\"title\"><md-tab id=\"tab12\" \naria-controls=\"tab12-content\" label=\"{{\'REQUISITION.DETAIL.PRODUCT\'| translate}}\"></md-tab><md-tab id=\"tab22\" \naria-controls=\"tab22-content\" label=\"{{\'REQUISITION.DETAIL.DETAILS\'| translate}}\"></md-tab></md-tabs></div><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.activeSearch()\" aria-label=\"Close dialog\" tranlate \nng-if=\"vm.selectedTab === 0\" translate-aria-label=\"MAIL.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-magnify\"></md-icon>\n</md-button><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" tranlate \ntranslate-aria-label=\"MAIL.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-toolbar class=\"md-accent md-hue-2\" ng-show=\"vm.searchMode\"><form ng-submit=\"vm.getProducts(1)\" \nname=\"vm.searchForm\"><div class=\"md-toolbar-tools\"><md-button type=\"button\" class=\"md-icon-button\" \nng-click=\"vm.searchMode = !vm.searchMode; vm.getProducts(1)\" aria-label=\"Back\"><ng-md-icon icon=\"arrow_back\">\n</ng-md-icon></md-button><md-input-container flex style=\"margin-top: 60px\"><label \ntranslate=\"REQUISITION.DETAIL.FILTER\">Filtro</label><input type=\"text\" ng-model=\"vm.filterProduct\" name=\"searchText\" \nid=\"searchField\" ng-model-options=\"{\'debounce\': 500}\"><div ng-messages=\"vm.searchForm.searchText.$error\"><div \nng-message=\"required\" translate=\"REQUISITION.ERROR.FIELD_REQUIRED\">This date is required!</div></div>\n</md-input-container><md-button type=\"submit\" aria-label=\"Search\"><span translate=\"REQUISITION.DETAIL.SEARCH\">Search\n</span></md-button></div></form></md-toolbar><md-dialog-content ms-scroll flex layout-fill \nng-class=\"vm.selectedTab === 0 ? \'md-dialog-list-content\' : \'\'\"><div ng-if=\"vm.selectedTab === 0\"><div \nclass=\"content thread-list\"><div class=\"thread\" md-ink-ripple ng-click=\"vm.selectProduct({id:-100})\" \nng-class=\"{\n                                 \'current-thread\': vm.detail.product.id === product.id}\"><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"info\" flex layout=\"row\"><div><div class=\"title h3\"><strong \ntranslate=\"PURCHASEPRODUCTDELIVERY.ALL_PRODUCTS\">TODOS LOS PRODUCTOS</strong></div></div><span flex></span></div></div>\n<div layout=\"column\" layout-align=\"space-between end\"><div class=\"actions\" layout=\"row\" layout-align=\"start center\">\n<div class=\"label ng-binding ng-scope md-green-300-bg\" role=\"button\" ng-if=\"!vm.detail.product\"><md-icon \nmd-font-icon=\"icon-check-all\"></md-icon></div></div></div></div><div class=\"thread\" md-ink-ripple ng-if=\"!vm.loading\" \nng-repeat=\"product in vm.productos.content\" ng-click=\"vm.selectProduct(product)\" \nng-class=\"{\n                                 \'current-thread\': vm.detail.product.id === product.id}\"><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"info\" flex layout=\"row\"><div><div class=\"title h3\"><strong>\n{{product.productCode ? product.productCode + \' - \' : \'\'}}{{product.name}}</strong></div><div class=\"notes\" \nlayout=\"column\"><span ng-if=\"product.brand\"><strong>Marca: </strong>{{product.brand}}</span> <span \nng-if=\"product.company\"><strong>Empresa: </strong>{{product.company}}</span> <span ng-if=\"product.measurementUnit\">\n<strong>Unidad de Medida: </strong>{{product.measurementUnit.name}}</span></div></div><span flex></span><div \nng-if=\"product.salePrice\"><h1>\n{{product.salePrice ? (product.buyPrice ? product.currencyBuy.symbol : product.currencySale.symbol) : \'\' }} {{(product.salePrice ? (product.buyPrice ? product.buyPrice : product.salePrice) : \'\') | number: 2}}\n</h1></div></div></div><div layout=\"column\" layout-align=\"space-between end\"><div class=\"actions\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"label ng-binding ng-scope md-green-300-bg\" role=\"button\" \nng-if=\"vm.detail.product.id === product.id\"><md-icon md-font-icon=\"icon-check-all\"></md-icon></div></div></div></div>\n</div><div class=\"div-loader\" ng-show=\"vm.loading\"><md-progress-circular class=\"ajax-loader md-accent md-hue-2\" \nmd-mode=\"indeterminate\"></md-progress-circular></div></div><div ng-show=\"vm.selectedTab === 1\"><form \nname=\"vm.detailForm\" ng-submit=\"vm.sendDetail()\"><div layout=\"column\" flex><div \nclass=\"profile-box info-box general md-whiteframe-1dp\" layout=\"column\"><div class=\"content\"><div class=\"info-line\"><div\n class=\"title\" translate=\"REQUISITION.DETAIL.PRODUCT\">Product</div><div ng-if=\"vm.detail.product.id==-100\" \nclass=\"info\" translate=\"PURCHASEPRODUCTDELIVERY.ALL_PRODUCTS\"></div><div class=\"info\">\n{{vm.detail.product.productCode}} {{vm.detail.product.name}}</div><div class=\"notes\"><span \nng-if=\"vm.detail.product.brand\"><strong>Marca: </strong>{{vm.detail.product.brand.name}}</span><br><span \nng-if=\"vm.detail.product.measurementUnit\"><strong>Unidad de Medida: </strong>{{vm.detail.product.measurementUnit.name}}\n</span></div></div></div></div></div><div layout=\"row\" layout-xs=\"column\"><md-input-container flex-gt-xs><label \ntranslate=\"REQUISITION.DEPARTMENT\">Department</label><md-select ng-model=\"vm.detail.department.id\" name=\"department\" \nrequired ng-disabled=\"vm.loadingDepartments\" md-on-close=\"vm.clearSearchDepartment()\"><md-select-header><input \nid=\"searchDepartment\" ng-model=\"vm.searchDepartment\" type=\"search\" placeholder=\"Buscar departamento\">\n</md-select-header><md-optgroup label=\"Departamentos\"><md-option ng-value=\"depto.id\" \nng-repeat=\"depto in vm.departments | filter:vm.searchDepartment\">{{depto.description}}</md-option></md-optgroup>\n</md-select><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loadingDepartments\"></md-progress-linear><div \nng-messages=\"vm.requisitionForm.department.$error\"><div ng-message=\"required\" \ntranslate=\"REQUISITION.ERROR.FIELD_REQUIRED\">This date is required!</div></div></md-input-container><md-input-container\n flex-gt-xs><label translate=\"REQUISITION.COST_CENTER\">Cost Center</label><md-select \nng-model=\"vm.detail.costCenter.id\" name=\"costcenter\" md-on-close=\"vm.clearSearchCostCenter()\" required \nng-disabled=\"vm.loadingCostCenter\"><md-select-header><input id=\"searchCostCenter\" ng-model=\"vm.searchCostCenter\" \ntype=\"search\" placeholder=\"Buscar centro de costo\"></md-select-header><md-optgroup><md-option ng-value=\"cc.id\" \nng-repeat=\"cc in vm.costCenters| filter:vm.searchCostCenter\">{{cc.description}}</md-option></md-optgroup></md-select>\n<md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loadingCostCenter\"></md-progress-linear><div \nng-messages=\"vm.requisitionForm.costcenter.$error\"><div ng-message=\"required\" \ntranslate=\"REQUISITION.ERROR.FIELD_REQUIRED\">This date is required!</div></div></md-input-container></div><div \nlayout=\"row\" layout-xs=\"column\"><md-input-container flex-gt-xs><label translate=\"PURCHASEPRODUCTDELIVERY.COMPANY\">\nCompany Delivery</label><md-select ng-model=\"vm.companyDelivery.id\" name=\"companyDelivery\" required \nng-disabled=\"vm.loadingCompanyDelivery\" md-on-close=\"vm.clearSearchCompanyDelivery()\" \nng-change=\"vm.loadDeptosDelivery()\"><md-select-header><input id=\"searchCompanyDelivery\" \nng-model=\"vm.searchCompanyDelivery\" type=\"search\" placeholder=\"Buscar Empresa de entrega\"></md-select-header>\n<md-optgroup label=\"Companies\"><md-option ng-value=\"cc.id\" \nng-repeat=\"cc in vm.companies | filter:vm.searchCompanyDelivery\">{{cc.name}}</md-option></md-optgroup></md-select>\n<md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loadingDepartments\"></md-progress-linear><div \nng-messages=\"vm.requisitionForm.companyDelivery.$error\"><div ng-message=\"required\" \ntranslate=\"REQUISITION.ERROR.FIELD_REQUIRED\">This date is required!</div></div></md-input-container><md-input-container\n flex-gt-xs><label translate=\"PURCHASEPRODUCTDELIVERY.DEPARTMENTDELIVERY\">DepartmentsDelivery</label><md-select \nng-model=\"vm.detail.departmentToDelivery.id\" name=\"DepartmentsDelivery\" required \nng-disabled=\"vm.loadingDepartmentsDelivery || !vm.companyDelivery\" md-on-close=\"vm.clearSearchDepartmentDelivery()\">\n<md-select-header><input id=\"searchDepartmentDelivery\" ng-model=\"vm.searchDepartmentDelivery\" type=\"search\" \nplaceholder=\"Buscar departamento Entrega\"></md-select-header><md-optgroup label=\"Departamentos Entrega\"><md-option \nng-value=\"depto.id\" ng-repeat=\"depto in vm.departmentsDeliverys | filter:vm.searchDepartmentDelivery\">\n{{depto.description}}</md-option></md-optgroup></md-select><md-progress-linear md-mode=\"indeterminate\" \nng-if=\"vm.loadingDepartmentsDelivery\"></md-progress-linear><div \nng-messages=\"vm.requisitionForm.departmentToDelivery.$error\"><div ng-message=\"required\" \ntranslate=\"REQUISITION.ERROR.FIELD_REQUIRED\">This date is required!</div></div></md-input-container></div><div \nlayout=\"row\" layout-xs=\"column\"><md-input-container flex-gt-xs><label \ntranslate=\"PURCHASEPRODUCTDELIVERY.PERSONWHORECIEVES\">PERSONWHORECIEVES</label><input rows=\"3\" maxlength=\"512\" \nng-model=\"vm.detail.personWhoRecieves\" name=\"notes\"><div ng-messages=\"vm.detailForm.notes.$error\"><div \nng-message=\"maxlength\" translate=\"REQUISITION.ERROR.MEX_LENGTH\">This required!</div></div><div \nng-messages=\"vm.requisitionForm.personWhoRecieves.$error\"><div ng-message=\"required\" \ntranslate=\"REQUISITION.ERROR.FIELD_REQUIRED\">This required!</div></div></md-input-container><md-input-container \nflex-gt-xs><label translate=\"PURCHASEPRODUCTDELIVERY.ADDRESSTODELIVERY\">ADDRESSTODELIVERY</label><input rows=\"3\" \nmaxlength=\"512\" ng-model=\"vm.detail.addressToDelivery\" name=\"notes\"><div ng-messages=\"vm.detailForm.notes.$error\"><div \nng-message=\"maxlength\" translate=\"REQUISITION.ERROR.MEX_LENGTH\">This required!</div></div><div \nng-messages=\"vm.requisitionForm.addressToDelivery.$error\"><div ng-message=\"required\" \ntranslate=\"REQUISITION.ERROR.FIELD_REQUIRED\">This required!</div></div></md-input-container></div><md-input-container \nclass=\"md-block\"><label translate=\"PURCHASEPRODUCTDELIVERY.COMMENTSFORDELIVERY\">commentsForDelivery</label><textarea \nrows=\"3\" maxlength=\"512\" ng-model=\"vm.detail.commentsForDelivery\" name=\"notes\"></textarea><div \nng-messages=\"vm.detailForm.commentsForDelivery.$error\"><div ng-message=\"maxlength\" \ntranslate=\"REQUISITION.ERROR.MEX_LENGTH\">This required!</div></div></md-input-container></form><md-button \nng-click=\"vm.sendDetail()\" class=\"send-button md-accent md-fab md-fab-bottom-right\" aria-label=\"Send\" \nng-if=\"vm.detailForm.$valid\" ng-disabled=\"vm.loading\" translate-attr-aria-label=\"REQUISITION.DETAIL.SEND\"><md-icon \nmd-font-icon=\"icon-content-save\"></md-icon><md-tooltip md-direction=\"left\">{{\"general.save\"| translate}}</md-tooltip>\n</md-button></div></md-dialog-content><md-dialog-actions style=\"justify-content: center\" class=\"actionsSpace\" \nng-if=\"vm.selectedTab === 0 && !vm.creatingProduct\"><div paging class=\"pageable-div\" page=\"vm.page\" \nul-class=\"pagination\" page-size=\"vm.pageSize\" hide-if-empty=\"true\" paging-action=\"vm.getProducts(page)\" \ntotal=\"vm.productos.totalElements\"></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/configuration/rejectionReason/rejectionReasonEdit/rejectionReasonEdit.html","<md-dialog aria-label=\"New Company\"><form name=\"rejectionReason\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\" translate=\"Limite de documentos\">New Message</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" tranlate translate-aria-label=\"REJECTIONREASON.CLOSE_DIALOG\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-progress-linear \nmd-mode=\"indeterminate\" class=\"md-primary\" ng-if=\"vm.loading\"></md-progress-linear><md-dialog-content><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label translate=\"REJECTIONREASON.MESSAGENEW\"></label>\n<input required ng-model=\"vm.rejectionReason.name\" style=\"\" ng-disabled=\"\"></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label translate=\"REJECTIONREASON.DEFINITIVE\"></label>\n<md-input-container flex><md-checkbox ng-disabled=\"\" ng-model=\"vm.rejectionReason.isDefinitive\" aria-label=\"Disabled\">\n</md-checkbox></md-input-container></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex-gt-xs ng-if=\"vm.rol === \'ADMIN\'\"><label translate=\"REJECTIONREASON.REJECTIONREASONTYPE\">\nRejectionReasonType</label><md-select ng-model=\"vm.rejectionReason.rejectionReasonType\" name=\"transactiontype\" \nrequired><md-option value=\"0\"><span translate=\"REJECTIONREASON.ADMINISTRATION\"></span></md-option><md-option value=\"1\">\n<span translate=\"REJECTIONREASON.VERIFICATION\"></span></md-option></md-select></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"end center\"><md-button ng-click=\"vm.sendForm()\" ng-disabled=\"\" \nclass=\"md-fab md-warn md-fab-bottom-right\" aria-label=\"Send\"><ng-md-icon icon=\"save\"></ng-md-icon><md-tooltip><span \ntranslate=\"SETTLEMENT.SAVE\">Guardar</span></md-tooltip></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/documentVerify/settlement/compose/compose-dialog.html","<md-dialog class=\"compose-dialog\" aria-label=\"New Message\" felx><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" \ntranslate=\"INVOICE.INVOICE_PURCHASE.ACCOUNTING_DATE\">New Message</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" tranlate translate-aria-label=\"INVOICE.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-progress-linear md-mode=\"indeterminate\" \nclass=\"md-primary\" ng-if=\"vm.loading\"></md-progress-linear><md-dialog-content ms-scroll><div layout=\"row\" \nlayout-align=\"center center\"><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label \ntranslate=\"INVOICE.INVOICE_PURCHASE.ACCOUNTING_DATE\">Fecha de Contabilidad</label><md-datepicker type=\"date\" \nng-model=\"vm.invoice.dateInvoiceAccounting\" name=\"dateDelivery\" md-min-date=\"vm.minDate\" md-max-date=\"vm.maxDate\" \nmd-open-on-focus ng-disabled=\"\"></md-datepicker><div ng-messages=\"vm.invoice.dateDelivery.$error\"><div \nng-message=\"valid\" translate=\"INVOICE.ERROR.INVALID_DATE\">The entered value is not a date!</div><div \nng-message=\"required\" translate=\"INVOICE.ERROR.FIELD_REQUIRED\">This date is required!</div><div ng-message=\"mindate\" \ntranslate=\"INVOICE.ERROR.INVALID_DATE\">Date is too early!</div></div></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\" ng-if=\"vm.InvoiceWithholdingDetails.length > 0\"><md-input-container class=\"flex\"><label \ntranslate=\"INVOICE.INVOICE_PURCHASE.CODE_WITHHOLDING\">Fecha de Contabilidad</label><input \nng-model=\"vm.codeWithholding\" name=\"codeWithholding\" required></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\" ng-if=\"vm.InvoiceWithholdingDetails.length > 0\"><md-input-container flex><label \ntranslate=\"INVOICE.WITHHOLDING\">Withholding</label><div ng-include=\"\'app/main/apps/files/files.html\'\"></div>\n</md-input-container></div></div></md-dialog-content><md-dialog-actions><md-button class=\"md-fab md-fab-bottom-right\" \naria-label=\"save\" \nng-disabled=\"($rootScope.loadingProgress || !vm.invoice.dateInvoiceAccounting) || (vm.InvoiceWithholdingDetails.length > 0 && vm.codeWithholding === \'\') || (vm.InvoiceWithholdingDetails.length > 0 && (!vm.filesToUpload || vm.filesToUpload.length <= 0))\" \nng-click=\"vm.provisionSettlement()\"><md-icon md-font-icon=\"icon-content-save\"></md-icon><md-tooltip>\n{{\'INVOICE.STATUS_CHANGE.\' + vm.invoice.purchaseStatus.description| translate}}</md-tooltip></md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/documentVerify/purchase/compose/compose-dialog.html","<md-dialog class=\"compose-dialog\" aria-label=\"New Message\" \nstyle=\"width: 65%; height: {{vm.height}}; max-width:65%; max-height: {{vm.height}}\"><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\" translate=\"INVOICE.INVOICE_PURCHASE.ACCOUNTING_DATE\">New Message</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" tranlate translate-aria-label=\"INVOICE.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-progress-linear md-mode=\"indeterminate\" \nclass=\"md-primary\" ng-if=\"vm.loading\"></md-progress-linear><md-dialog-content ms-scroll><div layout=\"row\" \nlayout-align=\"center center\"><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container class=\"flex\"><label \ntranslate=\"INVOICE.INVOICE_PURCHASE.ACCOUNTING_DATE\">Fecha de Contabilidad</label><md-datepicker type=\"date\" \nng-model=\"vm.invoice.dateInvoiceAccounting\" name=\"dateDelivery\" md-min-date=\"vm.minDate\" md-max-date=\"vm.maxDate\" \nmd-open-on-focus></md-datepicker><div ng-messages=\"vm.invoice.dateDelivery.$error\"><div ng-message=\"valid\" \ntranslate=\"INVOICE.ERROR.INVALID_DATE\">The entered value is not a date!</div><div ng-message=\"required\" \ntranslate=\"INVOICE.ERROR.FIELD_REQUIRED\">This date is required!</div><div ng-message=\"mindate\" \ntranslate=\"INVOICE.ERROR.INVALID_DATE\">Date is too early!</div></div></md-input-container></div><div \nclass=\"order-detail-form-container products md-background-bg md-whiteframe-1dp\" ms-scroll \nng-if=\"vm.InvoiceWithholdingsArr.length>0\"><div class=\"page-layout simple left-sidenav\" layout=\"row\"><md-sidenav \nclass=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-sidenav-helper><md-list>\n<md-list-item ng-class=\"(data === vm.invoicePurchaseWithholding) ? \'selected\' : \'\'\" ng-click=\"vm.getData(data)\" \nng-repeat=\"data in vm.InvoiceWithholdingsArr\" style=\"border-bottom: 1px solid #D8D8D8\"><p>\n{{data.totalWithholding| number: 2}} - {{data.withholding.withholdingCode}}</p><md-icon ng-show=\"data.fileWithholding\" \nmd-font-icon=\"icon-attachment\"></md-icon></md-list-item></md-list></md-sidenav><div class=\"center\" flex \nstyle=\"height: 400px; overflow: auto\"><md-card><md-progress-linear style=\"position: fixed; height: 5px; z-index: 10\" \nmd-mode=\"query\" class=\"md-accent\" ng-show=\"vm.isShowProgressLinear\"></md-progress-linear><div ng-show=\"vm.showGrid\" \nms-scroll><div layout=\"column\" layout-gt-xs=\"row\" ng-if=\"vm.InvoiceWithholdingDetails.length > 0\"><md-input-container \nclass=\"flex\"><label translate=\"INVOICE.INVOICE_PURCHASE.CODE_WITHHOLDING\">Codigo de Retencion</label><input \nng-model=\"vm.invoicePurchaseWithholding.codeWithholding\" name=\"codeWithholding\" required></md-input-container></div>\n<div layout=\"column\" layout-gt-xs=\"row\" ng-if=\"vm.InvoiceWithholdingDetails.length > 0\"><md-input-container flex><label\n translate=\"INVOICE.WITHHOLDING\">Withholding</label><div ng-include=\"\'app/main/apps/files/files.html\'\"></div>\n</md-input-container></div><div layout=\"row\" layout-align=\"center start\" layout-wrap \nng-show=\"vm.invoicePurchaseWithholding.id && vm.invoicePurchaseWithholding.fileWithholding\"><div \nng-switch=\"vm.invoicePurchaseWithholding.fileWithholding.extension\"><md-content><div layout=\"column\" \nng-click=\"vm.viewIMG(vm.invoicePurchaseWithholding.fileWithholding)\" \nng-if=\"vm.invoicePurchaseWithholding.fileWithholding.extension == \'.jpg\' || vm.invoicePurchaseWithholding.fileWithholding.extension == \'.png\' || vm.invoicePurchaseWithholding.fileWithholding.extension == \'.JPG\' || vm.invoicePurchaseWithholding.fileWithholding.extension == \'.PNG\'\">\n<a href=\"\"><img alt=\"img\" height=\"100px\" width=\"100px\" class=\"media\" \nng-src=\"{{vm.URLPHOTOS + vm.invoicePurchaseWithholding.fileWithholding.parentPath + vm.invoicePurchaseWithholding.fileWithholding.name + vm.invoicePurchaseWithholding.fileWithholding.extension}}\">\n<p>\n{{vm.invoicePurchaseWithholding.fileWithholding.originalName + vm.invoicePurchaseWithholding.fileWithholding.extension}}\n</p></a></div><div layout=\"column\" \nng-if=\"vm.invoicePurchaseWithholding.fileWithholding.extension != \'.jpg\' && vm.invoicePurchaseWithholding.fileWithholding.extension != \'.png\' && vm.invoicePurchaseWithholding.fileWithholding.extension != \'.JPG\' && vm.invoicePurchaseWithholding.fileWithholding.extension != \'.PNG\'\">\n<a target=\"_blank\" \nhref=\"{{vm.URLPHOTOS + vm.invoicePurchaseWithholding.fileWithholding.parentPath + vm.invoicePurchaseWithholding.fileWithholding.name + vm.invoicePurchaseWithholding.fileWithholding.extension}}\">\n<md-icon md-font-icon=\"icon-file-document\"></md-icon><p>\n{{vm.invoicePurchaseWithholding.fileWithholding.originalName + vm.invoicePurchaseWithholding.fileWithholding.extension}}\n</p></a></div></md-content></div></div></div></md-card></div></div></div></div><md-button \nclass=\"md-fab md-fab-bottom-right\" \nng-disabled=\"((!vm.invoicePurchaseWithholding.codeWithholding || (vm.filesToUpload.length < 1 && !vm.contentFile)) && vm.InvoiceWithholdingsArr.length>0) || !vm.invoice.dateInvoiceAccounting \" \naria-label=\"addBudget\" style=\"position: fixed\" ng-click=\"vm.saveWithholding()\"><md-icon \nmd-font-icon=\"icon-content-save\"></md-icon><md-tooltip md-direction=\"left\">{{\"general.save\"| translate}}</md-tooltip>\n</md-button></md-dialog-content></md-dialog>");
$templateCache.put("app/main/apps/documentVerify/purchase/compose/rejection-reason-dialog.html","<md-dialog aria-label=\"Discount\" style=\"max-width: 325px; width: 325px\"><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><strong><span class=\"title\" \ntranslate=\"INVOICE.INVOICE_PURCHASE.REJECTION_REASON\">Reason</span></strong><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" tranlate translate-aria-label=\"QUOTATION.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-progress-linear md-mode=\"indeterminate\" \nclass=\"md-primary\" ng-if=\"vm.loading\"></md-progress-linear><md-dialog-content><form name=\"vm.formDescript\">\n<md-input-container class=\"md-block\"><label translate=\"INVOICE.INVOICE_PURCHASE.REJECTION_REASON\">Motivo de Rechazo\n</label><textarea ng-model=\"vm.reason\" md-maxlength=\"500\" rows=\"5\" md-select-on-focus name=\"reason\"></textarea>\n</md-input-container></form></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\">\n<div flex layout=\"row\" layout-align=\"end center\"><md-button type=\"submit\" ng-click=\"vm.save()\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"!vm.reason || vm.reason === \'\' || vm.formDescript.$invalid\" \naria-label=\"SAVE\" translate=\"INVOICE.SALE_INVOICE.DETAIL.SAVE\" translate-attr-aria-label=\"CONTACTS.SAVE\">Guardar\n</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/documentVerify/purchase/compose/withholding-dialog.html","<md-dialog class=\"compose-dialog withholding-dialog\" aria-label=\"New Message\"><md-toolbar class=\"md-accent md-hue-2\">\n<div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" \ntranslate=\"INVOICE.INVOICE_PURCHASE.WITHHOLDING\">Retención</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" tranlate translate-aria-label=\"INVOICE.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-progress-linear md-mode=\"indeterminate\" \nclass=\"md-primary\" ng-if=\"vm.loading\"></md-progress-linear><md-dialog-content ms-scroll><div layout=\"row\" \nlayout-align=\"center center\"><div layout-gt-xs=\"row\" layout-align=\"start center\" layout-align=\"start center\">\n<md-input-container flex-gt-xs><label translate=\"INVOICE.INVOICE_PURCHASE.WITHHOLDING_TYPE\">Tipo</label><md-select \nng-model=\"vm.withholdingType.id\" name=\"withholdingType\" required md-on-close=\"vm.clearSearchType()\"><md-select-header>\n<input id=\"searchType\" ng-model=\"vm.searchType\" type=\"search\" placeholder=\"Buscar\"></md-select-header><md-optgroup \nlabel=\"Types\"><md-option value=\"{{row.id}}\" ng-repeat=\"row in vm.withholdingTypes| filter:vm.searchType\">{{row.name}}\n</md-option></md-optgroup></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" \nng-if=\"vm.canAddBaseAmount\"><md-input-container flex><label \ntranslate=\"INVOICE.INVOICE_PURCHASE.WITHHOLDING_BASEAMOUNT\">Monto Base</label><input \nng-model=\"vm.withholdingBaseAmount\" type=\"number\" name=\"withholdingBase\" id=\"withholdingBase\" required min=\"0.1\" \nmax=\"{{vm.invoice.docObj.totalBeforeTax}}\"><div ng-messages=\"vm.detailForm.quantity.$error\"><div ng-message=\"required\" \ntranslate=\"REQUISITION.ERROR.FIELD_REQUIRED\">This date is required!</div></div></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label \ntranslate=\"INVOICE.INVOICE_PURCHASE.WITHHOLDING_TASA\">Tasa de Retención</label><input \nng-disabled=\"vm.withholdingType.rate > 0\" ng-model=\"vm.withholdingRate\" type=\"number\" name=\"withholdingRate\" \nid=\"withholdingRate\" required min=\"0.1\"><div ng-messages=\"vm.detailForm.quantity.$error\"><div ng-message=\"required\" \ntranslate=\"REQUISITION.ERROR.FIELD_REQUIRED\">This date is required!</div></div></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container class=\"flex\"><label \ntranslate=\"INVOICE.INVOICE_PURCHASE.WITHHOLDING_AMOUNT\">Monto</label><input ng-disabled=\"vm.canAddBaseAmount\" \ntype=\"number\" ng-model=\"vm.withholdingAmount\" name=\"codeWithholding\"></md-input-container></div></div><div \nlayout=\"row\" layout-align=\"center center\" ng-if=\"vm.withholdingTypeVatTax.typeId\"><div layout=\"column\" \nlayout-gt-xs=\"row\" class=\"apply-vat-withholding\"><md-checkbox aria-label=\"chkbxIVA\" ng-model=\"vm.applyVatWithholding\" \nng-change=\"vm.calculateVatWithholdingAmount()\" flex><label translate=\"INVOICE.INVOICE_PURCHASE.APPLY_VAT_WITHHOLDING\">\n</label></md-checkbox></div><div ng-if=\"vm.applyVatWithholding\"><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><label translate=\"INVOICE.INVOICE_PURCHASE.WITHHOLDING_TASA\">Tasa de Retención</label><input \nng-disabled=\"true\" type=\"number\" ng-model=\"vm.withholdingTypeVatTax.rate\" required min=\"0.1\"></md-input-container>\n</div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container class=\"flex\"><label \ntranslate=\"INVOICE.INVOICE_PURCHASE.VAT_WITHHELD\">IVA Retenido</label><input ng-disabled=\"true\" type=\"number\" \nng-model=\"vm.withholdingTypeVatTax.amount\" required></md-input-container></div></div></div></md-dialog-content>\n<md-button class=\"md-fab md-fab-bottom-right\" aria-label=\"save\" \nng-disabled=\"vm.loading || (!vm.applyVatWithholding && !vm.withholdingType) \n                || (vm.withholdingType && !vm.withholdingAmount > 0)\" \nng-click=\"vm.save()\"><md-icon md-font-icon=\"icon-content-save\"></md-icon><md-tooltip>{{\'general.save\'| translate}}\n</md-tooltip></md-button></md-dialog>");
$templateCache.put("app/main/apps/expenseSettlements/pettyCash/pettyCashEditor/pettyCashEditor.html","<div id=\"e-commerce-orders\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><md-button class=\"goto-orders-button md-icon-button\" \naria-label=\"Go to orders\" ng-click=\"vm.closeThread()\" translate translate-attr-aria-label=\"PURCHASE.BACK\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"column\" layout-align=\"start start\"><div class=\"h2\">\n<span translate=\"EXPENSE_SETTLEMENTS.PETTY_CASH.PETTY_CASH\">Fondo de Caja</span> <span>{{vm.pettyCash.id}}</span> \n<span><h2>{{vm.pettyCashTypeSelected.description}}</h2></span></div></div></div></div><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><md-content ms-scroll><form name=\"vm.basicForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveModel()\" ng-disabled=\"vm.isReport\"><div layout=\"column\" \nlayout-gt-sm=\"row\"><div flex><md-input-container flex><label translate=\"EXPENSE_SETTLEMENTS.PETTY_CASH.PETTYCASHTYPE\">\n</label><md-select ng-model=\"vm.pettyCash.pettyCashType.id\" name=\"pettyCashType\" ng-disabled=\"vm.pettyCash.id\" \nrequired md-on-close=\"vm.clearSearchPettyCashType()\"><md-select-header><input id=\"pettyCashType\" \nng-model=\"vm.searchPettyCashType\" type=\"search\" placeholder=\"Buscar\"></md-select-header><md-optgroup \nlabel=\"PettyCashType\"><md-option ng-value=\"{{pettyCashType.id}}\" \nng-repeat=\"pettyCashType in vm.pettyCashType| filter:vm.searchPettyCashType\">{{pettyCashType.description}}</md-option>\n</md-optgroup></md-select><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loadingPettyCashType\">\n</md-progress-linear><div ng-messages=\"vm.basicForm.pettyCashType.$error\"><div ng-message=\"required\"><span \ntranslate=\"EXPENSE_SETTLEMENTS.PETTY_CASH.PETTYCASHTYPE_IS_REQUIRED\"></span></div></div></md-input-container></div>\n</div><div layout=\"column\" layout-gt-sm=\"row\" ng-if=\"vm.pettyCashTypeSelected.name===\'TRAVEL\'\"><md-input-container \nflex><label class=\"title\" translate=\"EXPENSE_SETTLEMENTS.PETTY_CASH.TRAVEL_DESTINATION \">destination</label><input \ntype=\"text\" name=\"travelDestination\" required ng-model=\"vm.pettyCash.travelDestination\"><div \nng-messages=\"vm.basicForm.travelDestination.$error\" role=\"alert\"><div ng-message=\"required\"><div \ntranslate=\"EXPENSE_SETTLEMENTS.PETTY_CASH.TRAVEL_DESTINATION_IS_REQUIRED\">This date is required!</div></div></div>\n</md-input-container><md-input-container flex><label class=\"title\" \ntranslate=\"EXPENSE_SETTLEMENTS.PETTY_CASH.TRAVEL_TIME\">travelTime</label><input type=\"text\" name=\"travelTime\" \nng-model=\"vm.pettyCash.travelTime\" required><div ng-messages=\"vm.basicForm.travelTime.$error\" role=\"alert\"><div \nng-message=\"required\"><div translate=\"EXPENSE_SETTLEMENTS.PETTY_CASH.TRAVEL_TIME_IS_REQUIRED\">This date is required!\n</div></div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" \nng-if=\"vm.pettyCashTypeSelected.name===\'TRAVEL\'\"><md-input-container flex><label class=\"title\" \ntranslate=\"EXPENSE_SETTLEMENTS.PETTY_CASH.TRAVEL_REASON\">travelReason</label><input type=\"text\" name=\"travelReason\" \nng-model=\"vm.pettyCash.travelReason\" required><div ng-messages=\"vm.basicForm.travelReason.$error\" role=\"alert\"><div \nng-message=\"required\"><div translate=\"EXPENSE_SETTLEMENTS.PETTY_CASH.TRAVEL_REASON_IS_REQUIRED\">This date is required!\n</div></div></div></md-input-container><md-input-container flex><label class=\"title\" \ntranslate=\"EXPENSE_SETTLEMENTS.PETTY_CASH.TRAVEL_REQUEST\">travelRequest</label><input type=\"text\" name=\"travelRequest\" \nng-model=\"vm.pettyCash.travelRequest\" required><div ng-messages=\"vm.basicForm.travelRequest.$error\" role=\"alert\"><div \nng-message=\"required\"><div translate=\"EXPENSE_SETTLEMENTS.PETTY_CASH.TRAVEL_REQUEST_IS_REQUIRED\">This date is required!\n</div></div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container><label \nclass=\"title\" translate=\"EXPENSE_SETTLEMENTS.PETTY_CASH.AMOUNT \">amount</label><input type=\"number\" name=\"amount\" \nstyle=\"text-align: right\" ng-required=\"vm.amountRequired\" ng-model=\"vm.pettyCash.amount\" min=\"0.01\"><div \nng-messages=\"vm.basicForm.amount.$error\" role=\"alert\"><div ng-message=\"required\"><div \ntranslate=\"EXPENSE_SETTLEMENTS.PETTY_CASH.AMOUNT_IS_REQUIRED\">This date is required!</div></div></div>\n</md-input-container><md-input-container flex><label class=\"title\" translate=\"EXPENSE_SETTLEMENTS.PETTY_CASH.NAME\">name\n</label><input type=\"text\" name=\"name\" ng-model=\"vm.pettyCash.name\" required><div \nng-messages=\"vm.basicForm.name.$error\" role=\"alert\"><div ng-message=\"required\"><div \ntranslate=\"EXPENSE_SETTLEMENTS.PETTY_CASH.NAME_IS_REQUIRED\">This date is required!</div></div></div>\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label \ntranslate=\"EXPENSE_SETTLEMENTS.PETTY_CASH.STARTDATE\">Enter date</label><md-datepicker type=\"date\" flex=\"100\" \nflex-gt-xs=\"50\" ng-required=\"true\" ng-model=\"vm.pettyCash.startDate\" name=\"startDate\" ng-disabled=\"vm.pettyCash.id\" \nng-change=\"vm.changeStartDate()\" md-min-date=\"vm.minDate\"></md-datepicker></md-input-container><md-input-container \nflex><label translate=\"EXPENSE_SETTLEMENTS.PETTY_CASH.DUEDATE\">Enter date</label><md-datepicker type=\"date\" flex=\"100\" \nflex-gt-xs=\"50\" ng-model=\"vm.pettyCash.dueDate\" name=\"dueDate\" md-placeholder=\"dd-MM-yyyy\" \nmd-min-date=\"vm.pettyCash.startDate\"></md-datepicker><div ng-messages=\"vm.basicForm.dueDate.$error\"><div \nng-message=\"required\" translate=\"EXPENSE_SETTLEMENTS.PETTY_CASH.DUEDATE_IS_REQUIRED\">This date is required!</div><div \nng-message=\"mindate\">Date is too early!</div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><label translate=\"EXPENSE_SETTLEMENTS.PETTY_CASH.COMPANY\">Company</label><md-select \nng-disabled=\"vm.isReport\" ng-model=\"vm.pettyCash.company.id\" name=\"companyId\" required \nmd-on-close=\"vm.clearSearchCompany()\"><md-select-header><input id=\"company\" ng-model=\"vm.searchCompany\" type=\"search\" \nplaceholder=\"Buscar\"></md-select-header><md-optgroup label=\"company\"><md-option ng-value=\"{{company.id}}\" \nng-repeat=\"company in vm.companies| filter:vm.searchCompany\">{{company.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex><label translate=\"EXPENSE_SETTLEMENTS.PETTY_CASH.COSTCENTER\">\nCentro de costo</label><md-select ng-disabled=\"vm.isReport\" ng-model=\"vm.pettyCash.costCenter.id\" name=\"costCenterId\" \nrequired md-on-close=\"vm.clearSearchCostCenter()\"><md-select-header><input id=\"costCenter\" \nng-model=\"vm.searchCostCenter\" type=\"search\" placeholder=\"Buscar\"></md-select-header><md-optgroup label=\"costCenter\">\n<md-option ng-value=\"{{costCenter.id}}\" ng-repeat=\"costCenter in vm.costCenters| filter:vm.searchCostCenter\">\n{{costCenter.description}}</md-option></md-optgroup></md-select></md-input-container><md-input-container flex><label \ntranslate=\"EXPENSE_SETTLEMENTS.PETTY_CASH.DEPARTMENT\">Departamento</label><md-select ng-disabled=\"vm.isReport\" \nng-model=\"vm.pettyCash.department.id\" name=\"departmentId\" required md-on-close=\"vm.clearSearchDepartment()\">\n<md-select-header><input id=\"department\" ng-model=\"vm.searchDepartment\" type=\"search\" placeholder=\"Buscar\">\n</md-select-header><md-optgroup label=\"department\"><md-option ng-value=\"{{department.id}}\" \nng-repeat=\"department in vm.departments| filter:vm.searchDepartment\">{{department.description}}</md-option>\n</md-optgroup></md-select></md-input-container><md-input-container flex><label \ntranslate=\"EXPENSE_SETTLEMENTS.PETTY_CASH.PROJECT\">Projecto</label><md-select ng-disabled=\"vm.isReport\" \nng-model=\"vm.pettyCash.projectId\" name=\"projectId\" md-on-close=\"vm.clearSearchProject()\"><md-select-header><input \nid=\"project\" ng-model=\"vm.searchProject\" type=\"search\" placeholder=\"Buscar\"></md-select-header><md-optgroup \nlabel=\"project\"><md-option ng-value=\"{{project.id}}\" ng-repeat=\"project in vm.projects| filter:vm.searchProject\">\n{{project.name}}</md-option></md-optgroup></md-select></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex-gt-xs ng-if=\"vm.dimensionCompanyDetail3\"><label>\n{{vm.dimensionCompanyDetail3.description}}</label><md-select ng-model=\"vm.pettyCash.dimensionCompanyDetail3.id\" \nname=\"dimensionCompanyDetail3\" md-on-close=\"vm.searchDimensionCompanyDetail3=\'\'\" \nng-required=\"vm.dimensionCompanyDetail3.required\"><md-select-header><input id=\"searchDimensionCompanyDetail3\" \nng-model=\"vm.searchDimensionCompanyDetail3\" type=\"search\" translate translate-attr-placeholder=\"general.search\" \naria-label=\"search-dimension-company\" ng-keydown=\"$event.stopPropagation()\"></md-select-header><md-optgroup \nlabel=\"dimensionCompanyDetail3\"><md-option value=\"{{data.id}}\" \nng-repeat=\"data in vm.dimensionCompanyDetail3List| \n                                                            filter:vm.searchDimensionCompanyDetail3\">\n{{data.code}} - {{data.name}}</md-option></md-optgroup></md-select><md-progress-linear md-mode=\"indeterminate\" \nng-if=\"vm.loadingdimensionCompanyDetail3List\"></md-progress-linear></md-input-container><md-input-container flex-gt-xs \nng-if=\"vm.dimensionCompanyDetail4\"><label>{{vm.dimensionCompanyDetail4.description}}</label><md-select \nng-model=\"vm.pettyCash.dimensionCompanyDetail4.id\" name=\"dimensionCompanyDetail4\" \nmd-on-close=\"vm.searchDimensionCompanyDetail4=\'\'\" ng-required=\"vm.dimensionCompanyDetail4.required\"><md-select-header>\n<input id=\"searchDimensionCompanyDetail4\" ng-model=\"vm.searchDimensionCompanyDetail4\" type=\"search\" translate \ntranslate-attr-placeholder=\"general.search\" aria-label=\"search-dimension-company\" \nng-keydown=\"$event.stopPropagation()\"></md-select-header><md-optgroup label=\"dimensionCompanyDetail4\"><md-option \nvalue=\"{{data.id}}\" \nng-repeat=\"data in vm.dimensionCompanyDetail4List| \n                                                            filter:vm.searchDimensionCompanyDetail4\">\n{{data.code}} - {{data.name}}</md-option></md-optgroup></md-select><md-progress-linear md-mode=\"indeterminate\" \nng-if=\"vm.loadingdimensionCompanyDetail4List\"></md-progress-linear></md-input-container><md-input-container flex-gt-xs \nng-if=\"vm.dimensionCompanyDetail5\"><label>{{vm.dimensionCompanyDetail5.description}}</label><md-select \nng-model=\"vm.pettyCash.dimensionCompanyDetail5.id\" name=\"dimensionCompanyDetail5\" \nmd-on-close=\"vm.searchDimensionCompanyDetail5=\'\'\" ng-required=\"vm.dimensionCompanyDetail5.required\"><md-select-header>\n<input id=\"searchDimensionCompanyDetail5\" ng-model=\"vm.searchDimensionCompanyDetail5\" type=\"search\" translate \ntranslate-attr-placeholder=\"general.search\" aria-label=\"search-dimension-company\" \nng-keydown=\"$event.stopPropagation()\"></md-select-header><md-optgroup label=\"dimensionCompanyDetail5\"><md-option \nvalue=\"{{data.id}}\" \nng-repeat=\"data in vm.dimensionCompanyDetail5List| \n                                                            filter:vm.searchDimensionCompanyDetail5\">\n{{data.code}} - {{data.name}}</md-option></md-optgroup></md-select><md-progress-linear md-mode=\"indeterminate\" \nng-if=\"vm.loadingdimensionCompanyDetail5List\"></md-progress-linear></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex><label class=\"title\" \ntranslate=\"EXPENSE_SETTLEMENTS.PETTY_CASH.DESCRIPTION\">descripcion</label><input ng-disabled=\"vm.isReport\" type=\"text\" \nname=\"description\" ng-model=\"vm.pettyCash.description\"></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\" ng-show=\"vm.requirePolicyAndContainer\"><md-input-container><label \ntranslate=\"SETTLEMENT.IMPORT_DOCUMENT\"></label><input ng-disabled=\"vm.isReport\" ng-model=\"vm.pettyCash.importDocument\" \ntype=\"text\" style=\"text-align: right\"></md-input-container><md-input-container><label translate=\"SETTLEMENT.CONTAINER\">\n</label><input ng-disabled=\"vm.isReport\" ng-model=\"vm.pettyCash.container\" type=\"text\" style=\"text-align: right\">\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label \ntranslate=\"EXPENSE_SETTLEMENTS.PETTY_CASH.ASSIGN_PETTYCASH\">ASIGNAR CAJA</label><md-select ng-disabled=\"vm.isReport\" \nng-model=\"vm.pettyCash.holder.id\" name=\"holderId\" required md-on-close=\"vm.clearSearchHolder()\"><md-select-header>\n<input id=\"holder\" ng-model=\"vm.pettyCash.searchHolder\" type=\"search\" placeholder=\"Buscar\"></md-select-header>\n<md-optgroup label=\"holder\"><md-option ng-value=\"{{user.user.id}}\" \nng-repeat=\"user in vm.users| filter:vm.pettyCash.searchHolder\">{{user.user.account}}</md-option></md-optgroup>\n</md-select></md-input-container></div></form><md-button ng-click=\"vm.saveModel()\" ng-disabled=\"vm.basicForm.$invalid\" \nclass=\"md-fab md-fab-bottom-right\" aria-label=\"Send\"><ng-md-icon icon=\"save\"></ng-md-icon><md-tooltip><span \ntranslate=\"SETTLEMENT.SAVE\">Guardar</span></md-tooltip></md-button></md-content></div></div></div>");
$templateCache.put("app/main/apps/expenseSettlements/pettyCash/settings/settings.html","<div id=\"settings\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div \nclass=\"header\" layout-xl=\"row\" layout-align-xl=\"space-between-center\" layout-lg=\"row\" \nlayout-align-lg=\"space-between center\" layout-xs=\"column\" layourt-align-xs=\"none center\"><div class=\"title\" flex=\"20\" \nflex-xs=\"100\"><md-icon class=\"white-fg\" md-font-icon=\"icon-clipboard-text\"></md-icon><span \ntranslate=\"EXPENSE_SETTLEMENTS.PETTY_CASH.SETTINGS.CONFIGURATION_TYPES\"></span></div><div layout=\"row\" flex=\"80\" \nlayout-align=\"start center\"><div class=\"search\" flex layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><input id=\"searchField\" flex ng-keyup=\"vm.changeFilter()\" \nng-enter=\"vm.loadUsers(vm.settings.roleApplication.id, 1)\" ng-model=\"vm.filterUser\" type=\"search\" \nplaceholder=\"{{\'EXPENSE_SETTLEMENTS.SEARCH\'| translate}}\"><md-button \nng-click=\"vm.loadUsers(vm.settings.roleApplication.id, 1)\">{{\'EXPENSE_SETTLEMENTS.SEARCH\'| translate}}</md-button>\n</div></div></div><md-card class=\"content-card\" layout=\"column\" flex \nng-include=\"\'app/main/apps/expenseSettlements/pettyCash/settings/content/content.html\'\"></md-card></div></div>");
$templateCache.put("app/main/apps/expenseSettlements/pettyCash/withAmountToReturn/pettyCashRefund.html","<div id=\"pettyCashRefund\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div\n class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-clipboard-text\"></md-icon><span \ntranslate=\"EXPENSE_SETTLEMENTS.PETTY_CASH.PETTY_CASH_REFUND\">Devolucion Fondo de Caja</span></div><div \nclass=\"product-count secondary-text\"><span translate=\"EXPENSE_SETTLEMENTS.PETTY_CASH.TOTAL_PETTY_CASH\">Total cajas:\n</span>: <span>{{vm.pettyCashes.length}}</span></div></div><div class=\"search\" layout=\"row\" \nlayout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon>\n<input id=\"e-commerce-products-search\" ng-model=\"vm.search\" class=\"search-input\" type=\"text\" placeholder=\"Search\" \ntranslate translate-attr-placeholder=\"EXPENSE_SETTLEMENTS.SEARCH\" ng-model-options=\"{\'debounce\': 300}\" flex></div>\n</div><md-progress-linear md-mode=\"indeterminate\" ng-show=\"vm.loading\"></md-progress-linear><div class=\"content-card\" \nlayout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex><md-progress-linear \nmd-mode=\"indeterminate\" ng-if=\"vm.loading\" class=\"md-accent\"></md-progress-linear><div id=\"masterGridOptions\" \nag-grid=\"vm.masterGridOptions\" class=\"ag-fresh\" expand-grid min=\"260\" other=\"-10\"></div><div class=\"loading-threads\" \nlayout=\"column\" layout-align=\"center center\" ng-if=\"vm.allPettyCash.length === 0\"><h2>\n{{\'EXPENSE_SETTLEMENTS.PETTY_CASH.NO_PETTY_CASH\'| translate}}</h2></div></div></div></div></div>");
$templateCache.put("app/main/apps/expenseSettlements/pettyCashGeneralSets/pettyCashGeneralSetsEditor/pettyCashGeneralSetsEditor.html","<md-dialog class=\"compose-dialog\" aria-label=\"New Company\"><form name=\"pettyMaxAmountForm\" class=\"md-inline-form\" \nnovalidate><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\" translate=\"PETTY_CASH_SETS.CONFIGURATION_PETTY_CASH_SETS\">\nNew Message</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" tranlate \ntranslate-aria-label=\"SETTLEMENT.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-progress-linear md-mode=\"indeterminate\" class=\"md-primary\" ng-if=\"vm.loading\"></md-progress-linear>\n<md-dialog-content><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label \ntranslate=\"PETTY_CASH_SETS.PETTY_CASH_TYPE\"></label><input required \nng-model=\"vm.pettyCashGeneralSets.pettyCashType.description\" style=\"text-align: center\" ng-disabled=\"true\">\n</md-input-container><md-input-container flex><label translate=\"PETTY_CASH_SETS.MAX_AMOUNT_PETTYCASH\"></label><input \ntype=\"number\" min=\"0.00\" ng-model=\"vm.pettyCashGeneralSets.maxAmountByPettyCash\" style=\"text-align: center\">\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label \ntranslate=\"PETTY_CASH_SETS.MAX_AMOUNT_INVOICE\"></label><input type=\"number\" min=\"0.00\" \nng-model=\"vm.pettyCashGeneralSets.maxAmountByDocument\" style=\"text-align: center\" ng-disabled=\"\"></md-input-container>\n<md-input-container flex><label translate=\"PETTY_CASH_SETS.MAX_INVOICES_PROVIDER\"></label><input type=\"number\" min=\"0\" \nng-model=\"vm.pettyCashGeneralSets.maxInvoiceByProvider\" style=\"text-align: center\" ng-disabled=\"\"></md-input-container>\n</div><div layout=\"column\" layout-gt-xs=\"column\"><md-input-container class=\"m-0 pb-10\"><md-checkbox class=\"m-0\" \nname=\"moreDetails\" ng-model=\"vm.pettyCashGeneralSets.moreDetails\" aria-label=\"moreDetails\"></md-checkbox><span \ntranslate=\"Agregar más de un detalle a factura\"></span></md-input-container><md-input-container class=\"m-0 pb-10\">\n<md-checkbox class=\"m-0\" name=\"moreDetails\" ng-model=\"vm.pettyCashGeneralSets.askForBudget\" aria-label=\"moreDetails\">\n</md-checkbox><span translate=\"PETTY_CASH_SETS.ASK_FOR_BUDGET\"></span></md-input-container><md-input-container \nclass=\"m-0 pb-10\"><md-checkbox class=\"m-0\" name=\"useAllProducts\" ng-model=\"vm.pettyCashGeneralSets.useAllProducts\" \naria-label=\"useAllProducts\"></md-checkbox><span translate=\"PETTY_CASH_SETS.USE_ALL_PRODUCTOS\"></span>\n</md-input-container><md-input-container class=\"m-0 pb-10\"><md-checkbox class=\"m-0\" name=\"useExternalProviders\" \nng-model=\"vm.pettyCashGeneralSets.useExternalProviders\" aria-label=\"useExternalProviders\"></md-checkbox><span \ntranslate=\"PETTY_CASH_SETS.USE_EXTERNAL_PROVIDERS\"></span></md-input-container></div></md-dialog-content></form>\n<md-button ng-click=\"vm.sendForm()\" ng-disabled=\"pettyMaxAmountForm.$invalid\" \nclass=\"md-fab md-warn md-fab-bottom-right\" aria-label=\"Send\"><ng-md-icon icon=\"save\"></ng-md-icon><md-tooltip><span \ntranslate=\"SETTLEMENT.SAVE\">Guardar</span></md-tooltip></md-button></md-dialog>");
$templateCache.put("app/main/apps/expenseSettlements/settlements/details/details.html","<div id=\"invoices\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-clipboard-text\"></md-icon><span translate=\"SETTLEMENT.DETAILS\">Detalles</span></div><div \nclass=\"product-count secondary-text\"><span translate=\"SETTLEMENT.TOTAL_DETAILS\">Total detalles</span>: <span>\n{{vm.settlementDetails.length}}</span></div></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex>\n<md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input \nid=\"e-commerce-products-search\" class=\"search-input\" type=\"text\" placeholder=\"Search\" translate \ntranslate-attr-placeholder=\"SETTLEMENT.SEARCH\" flex></div></div><md-progress-linear md-mode=\"indeterminate\" \nng-show=\"vm.loading\"></md-progress-linear><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><div class=\"loading-threads\" layout=\"column\" \nlayout-align=\"center center\" ng-if=\"vm.settlementDetails.length === 0\"><h2>{{\'SETTLEMENT.NO_DETAILS\'| translate}}</h2>\n</div><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loading\" class=\"md-accent\"></md-progress-linear><div \nid=\"settlement-grid\" ag-grid=\"vm.gridOptions\" class=\"ag-fresh\" style=\"width: 100%; height: 100%\"></div></div></div>\n</div></div>");
$templateCache.put("app/main/apps/expenseSettlements/settlements/settlement/settlement.html","<div id=\"settlement\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-clipboard-text\"></md-icon><span translate=\"SETTLEMENT.VIEW_SETTLEMENTS\">\nLiquiciones de gasto</span></div><div class=\"product-count secondary-text\"><span \ntranslate=\"SETTLEMENT.TOTAL_SETTLEMENTS\">Total liquidaciones:</span>: <span>{{vm.settlements.length}}</span></div>\n</div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"e-commerce-products-search\" ng-model=\"vm.search\" \nclass=\"search-input\" type=\"text\" placeholder=\"Search\" translate translate-attr-placeholder=\"SETTLEMENT.SEARCH\" \nng-model-options=\"{\'debounce\': 300}\" flex></div></div><md-progress-linear md-mode=\"indeterminate\" ng-show=\"vm.loading\">\n</md-progress-linear><div class=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" \nlayout=\"column\" flex><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loading\" class=\"md-accent\">\n</md-progress-linear><div id=\"masterGridOptions\" ag-grid=\"vm.masterGridOptions\" class=\"ag-fresh\" expand-grid min=\"260\" \nother=\"-10\"></div></div><div class=\"content fullpage-datatable\" layout=\"column\" flex \nng-if=\"vm.settlements.length === 0 && !vm.loading\"><div class=\"loading-threads\" layout=\"column\" \nlayout-align=\"center center\" ng-if=\"vm.settlements.length === 0\"><h2>{{\'SETTLEMENT.NO_SETTLEMENTS\'| translate}}</h2>\n</div></div></div></div></div>");
$templateCache.put("app/main/apps/generalReports/dialogs/show-audit-log/show-audit-log.html","<md-dialog class=\"transaction-detail\" aria-label=\"detail of transaction\"><div layout=\"row\" class=\"tools-dialog\"><div \nflex=\"50\" layout=\"row\" layout-align=\"start center\"><h2 translate=\"REPORT.LOGS.TITLE\">Bitácora</h2></div><div flex=\"50\" \nlayout=\"row\" layout-align=\"end center\"><md-button aria-label=\"button close\" class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div></div>\n<md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loading\" class=\"md-accent\"></md-progress-linear><div \nid=\"transactionDetailMasterGridOptions\" ag-grid=\"vm.masterGridOptions\" class=\"ag-fresh\"></div></md-dialog>");
$templateCache.put("app/main/apps/generalReports/dialogs/show-interfaz-detail/show-interfaz-detail.html","<md-dialog class=\"transaction-detail\" aria-label=\"detail of transaction\"><div layout=\"row\" class=\"tools-dialog\"><div \nflex=\"50\" layout=\"row\" layout-align=\"start center\"><h2 translate=\"REPORT.transaction_detail\">Detalle de transacción\n</h2></div><div flex=\"50\" layout=\"row\" layout-align=\"end center\"><md-button aria-label=\"button close\" \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon>\n</md-button></div></div><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loading\" class=\"md-accent\">\n</md-progress-linear><div id=\"transactionDetailMasterGridOptions\" ag-grid=\"vm.masterGridOptions\" class=\"ag-fresh\">\n</div></md-dialog>");
$templateCache.put("app/main/apps/generalReports/dialogs/show-invoiceView-detail/show-invoiceView-detail.html","<md-dialog class=\"transaction-detail\" aria-label=\"detail of transaction\"><div layout=\"row\" class=\"tools-dialog\"><div \nflex=\"50\" layout=\"row\" layout-align=\"start center\"><h2>\n{{vm.detailsSettlement.invoicePurchaseType !== \'RECEIPT\' ? \'SETTLEMENT.INVOICE_DETAIL\' : \'SETTLEMENT.RECEIPT_DETAIL\' | translate}}\n</h2></div><div flex=\"50\" layout=\"row\" layout-align=\"end center\"><md-button aria-label=\"button close\" \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon>\n</md-button></div></div><div class=\"content thread-detail\" ms-scroll flex><div class=\"thread-content\"><div \nlayout=\"row\"><ms-form-wizard flex><div class=\"toolbar\"><div class=\"navigation\" flex layout=\"row\" \nlayout-align=\"center center\"><div class=\"customer h3\" layout=\"column\"><span></span> <span><strong \ntranslate=\"SETTLEMENT.COMPANY.NIT\" ng-if=\"vm.detailsSettlement.invoicePurchaseType !== \'RECEIPT\'\"></strong>\n {{vm.detailsSettlement.companyDocumentNumber}} </span><span><strong translate=\"SETTLEMENT.COMPANY.COMPANY\"></strong>\n: {{vm.detailsSettlement.companyProviderName}} </span><span><strong translate=\"SETTLEMENT.INVOICE.DATE\"></strong>\n: {{vm.detailsSettlement.dateInvoicePurchase| date: \'dd-MM-yyyy\'}}</span></div><div flex></div><div \nclass=\"customer h3\" layout=\"column\"><span></span> <span><strong translate=\"SETTLEMENT.INVOICE.SERIE\"></strong>\n: {{vm.detailsSettlement.invoiceSerie}} </span><span><strong translate=\"SETTLEMENT.INVOICE.CORRELATIVE\"></strong>\n: {{vm.detailsSettlement.invoicePurchaseCorrelative}}</span></div><div flex></div><div class=\"customer h3\" \nlayout=\"column\"><span></span> <span><strong translate=\"SETTLEMENT.INVOICE.DETAIL.TOTAL_PRICE\"></strong>\n: {{vm.detailsSettlement.currencyExchangeDescription}}.{{vm.detailsSettlement.documentTotalAfterTax| number : 2}}\n</span></div><div flex></div></div><div layout=\"row\"><div layout=\"column\" flex layout-align=\"start center\"><div \nlayout=\"row\" layout-align=\"center center\"><h4><strong>{{\'SETTLEMENT.FILES\'|translate}}</strong></h4></div><div \nng-repeat=\"file in vm.filesPurchase\" ng-switch=\"file.extension\" \nng-if=\"vm.detailsSettlement.invoicePurchaseType !== \'RECEIPT\'\"><md-content><div layout=\"column\" \nng-click=\"vm.viewIMG(file)\" \nng-if=\"file.extension === \'.jpg\' || file.extension === \'.png\' || file.extension === \'.JPG\' || file.extension === \'.PNG\'\">\n<a href=\"\"><img alt=\"image\" height=\"100px\" width=\"100px\" class=\"media\" \nng-src=\"{{vm.URLPHOTOS + file.parentPath + file.name + file.extension}}\"><p>{{file.originalName + file.extension}}</p>\n</a></div></md-content></div><div layout=\"row\" layout-align=\"center start\" layout-wrap \nng-show=\"vm.receipt.files.length > 0\" ng-if=\"vm.detailsSettlement.invoicePurchaseType === \'RECEIPT\'\"><div \nng-repeat=\"file in vm.receipt.files\" ng-switch=\"file.extension\"><md-content><div layout=\"column\" \nng-click=\"vm.viewIMG(file)\" \nng-if=\"file.extension === \'.jpg\' || file.extension === \'.png\' || file.extension === \'.JPG\' || file.extension === \'.PNG\'\">\n<a href=\"\"><img alt=\"image\" height=\"100px\" width=\"100px\" class=\"media\" \nng-src=\"{{vm.URLPHOTOS + file.parentPath + file.name + file.extension}}\"><p>{{file.originalName + file.extension}}</p>\n</a></div></md-content></div></div></div></div></div></ms-form-wizard></div></div><md-content class=\"content\" flex \nms-scroll><div class=\"simple-table-container md-whiteframe-4dp\"><div class=\"table-title\"><md-tab-body><header \nclass=\"md-accent-bg\"><div layout=\"row\" layout-align=\"center center\"><strong><h2><div class=\"title\" \ntranslate=\"SETTLEMENT.INVOICE.DETAIL.DETAIL\">Invoice Detail</div></h2></strong></div></header></md-tab-body></div>\n<table class=\"simple\" ms-responsive-table><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"SETTLEMENT.INVOICE.PRODUCT\">Producto</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"SETTLEMENT.INVOICE.DETAIL.QUANTITY\">Cantidad</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"SETTLEMENT.INVOICE.DETAIL.UNIT_PRICE\">PrecioDespuésImpuesto</span></div></th><th class=\"secondary-text\"><div\n class=\"table-header\"><span class=\"column-title\" translate=\"SETTLEMENT.INVOICE.DETAIL.TOTAL_PRICE\">TotalDespuésImpuesto\n</span></div></th></tr></thead><tbody><tr ng-repeat=\"detail in vm.details\" \nng-if=\"vm.detailsSettlement.invoicePurchaseType !== \'RECEIPT\'\"><td>{{detail.product.name}}</td><td>{{detail.quantity}}\n</td><td>{{detail.invoicePurchase.currency.symbol}}.{{detail.priceAfterTax| number:2}}</td><td>\n{{detail.invoicePurchase.currency.symbol}}.{{detail.documentSubTotalAfterTax| number:2}}</td></tr><tr \nng-if=\"vm.detailsSettlement.invoicePurchaseType === \'RECEIPT\'\"><td>{{vm.receipt.product.name}}</td><td>{{ }}</td><td>\n{{ }}</td><td>{{vm.receipt.currency.symbol}}.{{vm.receipt.documentAmount| number:2}}</td></tr></tbody></table></div>\n</md-content></div></md-dialog>");
$templateCache.put("app/main/apps/generalReports/dialogs/show-pdf/show-pdf.html","<md-dialog aria-label=\"qr\" style=\"width: 100%;height: 100%;max-height: 92%\"><md-toolbar><div class=\"md-toolbar-tools\">\n<h2></h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon \nmd-font-icon=\"icon-window-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><iframe \ntitle=\"report\" width=\"100%\" height=\"100%\" name=\"plugin\" id=\"plugin\" src=\"{{vm.report}}\"></iframe></md-dialog>");
$templateCache.put("app/main/apps/generalReports/sidenavs/filter/filter.html","<div class=\"header\" layout=\"column\" layout-align=\"space-between start\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-filter\" class=\"icon s24\"></md-icon>\n</span><span class=\"logo-text\" translate=\"REPORT.FILTER\">Filter</span></div></div><div class=\"content\"><form \nname=\"filterForm\"><div layout=\"column\" class=\"filter\"><md-input-container flex class=\"inputfilter\"><label \ntranslate=\"REPORT.STARTDATE\">Start Date</label><md-datepicker type=\"date\" ng-model=\"vm.filter.startDate\" \nng-change=\"vm.changeStartDate()\" name=\"startDate\" md-min-date=\"vm.minDate\" md-open-on-focus></md-datepicker><div \nng-messages=\"vm.filterForm.startDate.$error\"><div ng-message=\"valid\" translate=\"REPORT.ERROR.INVALID_DATE\">\nThe entered value is not a date!</div><div ng-message=\"required\" translate=\"REPORT.ERROR.FIELD_REQUIRED\">\nThis date is required!</div><div ng-message=\"mindate\" translate=\"REPORT.ERROR.INVALID_DATE\">Date is too early!</div>\n</div></md-input-container><md-input-container flex class=\"inputfilter\"><label translate=\"REPORT.ENDDATE\">End Date\n</label><md-datepicker type=\"date\" ng-model=\"vm.filter.endDate\" name=\"endDate\" md-min-date=\"vm.filter.startDate\" \nmd-open-on-focus></md-datepicker><div ng-messages=\"vm.filterForm.endDate.$error\"><div ng-message=\"valid\" \ntranslate=\"REPORT.ERROR.INVALID_DATE\">The entered value is not a date!</div><div ng-message=\"required\" \ntranslate=\"REPORT.ERROR.FIELD_REQUIRED\">This date is required!</div><div ng-message=\"mindate\" \ntranslate=\"REPORT.ERROR.INVALID_DATE\">Date is too early!</div></div></md-input-container><md-input-container \nclass=\"inputfilter\" ng-if=\"vm.snFilter.department\"><label>{{\'REPORT.DEPARTMENT\'| translate}}</label><md-select \nng-model=\"vm.filter.departments\" md-on-close=\"vm.clearSearchDepartment()\" multiple=\"multiple\" \nng-disabled=\"vm.loadingDepartments\"><md-select-header><input id=\"searchDepartment\" ng-model=\"vm.searchDepartment\" \ntype=\"search\" placeholder=\"Buscar departamento\"></md-select-header><md-optgroup label=\"Departamentos\"><md-option \nvalue=\"{{department.id}}\" ng-repeat=\"department in vm.departments| filter:vm.searchDepartment\">\n{{department.code}} - {{department.description}}</md-option></md-optgroup></md-select><md-progress-linear \nmd-mode=\"indeterminate\" ng-if=\"vm.loadingDepartments\"></md-progress-linear></md-input-container><md-input-container \nclass=\"inputfilter\" ng-if=\"vm.snFilter.costCenter\"><label>{{\'REPORT.COSTCENTER\'| translate}}</label><md-select \nng-model=\"vm.filter.costCenters\" md-on-close=\"vm.clearSearchCostCenter()\" multiple=\"multiple\" \nng-disabled=\"vm.loadingCostCenter\"><md-select-header><input id=\"searchCostCenter\" ng-model=\"vm.searchCostCenter\" \ntype=\"search\" placeholder=\"Buscar Centro de Costo\"></md-select-header><md-optgroup label=\"Departamentos\"><md-option \nvalue=\"{{costCenter.id}}\" ng-repeat=\"costCenter in vm.costCenters| filter:vm.searchCostCenter\">\n{{costCenter.code}} - {{costCenter.description}}</md-option></md-optgroup></md-select><md-progress-linear \nmd-mode=\"indeterminate\" ng-if=\"vm.loadingCostCenter\"></md-progress-linear></md-input-container><md-input-container \nclass=\"inputfilter\" ng-if=\"vm.snFilter.status\"><label>{{\'REPORT.STATUS\'| translate}}</label><md-select \nng-model=\"vm.filter.statuses\" md-on-close=\"vm.clearSearchStatus()\" multiple=\"multiple\" ng-disabled=\"vm.loadingStatus\">\n<md-select-header><input id=\"searchStatus\" ng-model=\"vm.searchStatus\" type=\"search\" placeholder=\"Buscar Status\">\n</md-select-header><md-optgroup label=\"Departamentos\"><md-option value=\"{{status.id}}\" \nng-repeat=\"status in vm.statuses| filter:vm.searchStatus\">{{status.description}}</md-option></md-optgroup></md-select>\n<md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loadingStatus\"></md-progress-linear></md-input-container>\n<md-button class=\"md-primary\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><span translate=\"REPORT.SEARCH\">Search\n</span></md-button></div></form></div>");
$templateCache.put("app/main/apps/generalReports/sidenavs/filter/h-filter.html","<md-progress-linear style=\"position: fixed; height: 5px; z-index: 10\" md-mode=\"query\" class=\"md-accent\" \nng-show=\"vm.isShowProgressLinear\"></md-progress-linear><div style=\"padding-top: 5px\"><md-content ng-cloak><md-card>\n<md-button class=\"md-primary button-filter\" target=\"_blank\" ng-click=\"vm.isShowFilter = !vm.isShowFilter\">\n{{\'REPORT.CLICK_FILTRO\'| translate}}<md-icon ng-if=\"vm.isShowFilter\" md-font-icon=\"icon-chevron-down\"></md-icon>\n<md-icon ng-if=\"!vm.isShowFilter\" md-font-icon=\"icon-chevron-right\"></md-icon></md-button><div \nng-show=\"vm.isShowFilter\" class=\"animate-show\"><form name=\"vm.filterForm\"><div layout=\"row\" layout-xs=\"row\" \nlayout-align=\"space-around center\" ng-if=\"vm.snFilter.checkFilterDate\"><md-checkbox \nng-model=\"vm.snFilter.filterByDates\">{{\'REPORT.FILTER_DATES\'| translate}}</md-checkbox></div><div layout=\"row\" \nlayout-xs=\"row\" layout-align=\"space-around center\" ng-if=\"vm.snFilter.filterByDates\"><md-datepicker type=\"date\" \nng-model=\"vm.filter.startDate\" md-placeholder=\"Enter start date\" ng-change=\"vm.changeStartDate(true)\" name=\"startDate\" \nmd-open-on-focus></md-datepicker><md-datepicker type=\"date\" ng-model=\"vm.filter.endDate\" \nmd-placeholder=\"Enter end date\" ng-change=\"vm.changeStartDate(false)\" name=\"endDate\" md-min-date=\"vm.filter.startDate\" \nmd-open-on-focus></md-datepicker></div><div layout=\"row\" layout-xs=\"row\" layout-align=\"space-around center\" \nng-if=\"vm.snFilter.checkElectronic\"><md-checkbox ng-model=\"vm.electronic\">\n{{\'REPORT.FILTER_CHECK_ELECTRONIC\'| translate}}</md-checkbox></div><div layout=\"row\" layout-xs=\"row\" \nlayout-align=\"space-around center\" ng-if=\"vm.snFilter.companies || vm.snFilter.companiesDialog\"><md-input-container \nclass=\"inputfilter\" flex ng-if=\"vm.snFilter.companies\"><label>{{\'REPORT.SELECT_COMPANY\'| translate}}</label><md-select \nng-model=\"vm.filter.companies\" md-on-close=\"vm.clearSearchCompany()\" multiple=\"multiple\" \nng-disabled=\"vm.loadingCompanies\"><md-select-header><input id=\"searchCompany\" ng-model=\"vm.searchCompany\" \ntype=\"search\" placeholder=\"Buscar Empresa\"></md-select-header><md-optgroup label=\"Empresas\"><md-option value=\"-1\" \nng-click=\"vm.selectAllItemsCompanies(\'-1\')\">{{\'REPORTS.SELECT_ALL\' | translate}}</md-option><md-option \nvalue=\"{{data.id}}\" ng-repeat=\"data in vm.companies| filter:vm.searchCompany\" \nng-click=\"vm.changeDeptoAndCCByCompany(data.id)\">{{data.id}} - {{data.name}}</md-option></md-optgroup></md-select>\n<md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loadingCompanies\"></md-progress-linear></md-input-container>\n<md-input-container class=\"inputfilter\" flex ng-if=\"vm.snFilter.companiesDialog\"><label>\n{{\'REPORT.companiesDialog\'| translate}}</label><input readonly=\"true\" ng-model=\"vm.namesCompaniesDialog\" required>\n<md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loadingCompaniesDialog\"></md-progress-linear>\n</md-input-container><md-button class=\"md-mini md-fab md-primary md-raised\" aria-label=\"addDetail\" \nng-click=\"vm.selectCompanies(\'companies\')\" ng-if=\"vm.snFilter.companiesDialog\"><md-icon md-font-icon=\"icon-plus\" \nng-if=\"!vm.namesCompaniesDialog\"><md-tooltip md-direction=\"top\">{{\"general.add\"| translate}}</md-tooltip></md-icon>\n<md-icon md-font-icon=\"icon-pencil\" ng-if=\"vm.namesCompaniesDialog\"><md-tooltip md-direction=\"top\">\n{{\"general.edit\"| translate}}</md-tooltip></md-icon></md-button></div><div layout=\"row\" layout-xs=\"column\">\n<md-input-container class=\"inputfilter\" flex ng-if=\"vm.snFilter.department\"><label>{{\'REPORT.DEPARTMENT\'| translate}}\n</label><md-select ng-model=\"vm.filter.departments\" md-on-close=\"vm.clearSearchDepartment()\" multiple=\"multiple\" \nng-disabled=\"vm.loadingDepartments\"><md-select-header><input id=\"searchDepartment\" ng-model=\"vm.searchDepartment\" \ntype=\"search\" placeholder=\"Buscar departamento\"></md-select-header><md-optgroup label=\"Departamentos\"><md-option \nvalue=\"-1\" ng-click=\"vm.selectAllItemsDepartments(\'-1\')\" ng-if=\"vm.departments.length>0\"><span \nng-if=\"!vm.filter.departments || vm.filter.departments.length===0\">{{\'REPORTS.SELECT_ALL\'| translate}} </span><span \nng-if=\"vm.filter.departments.length>0\">{{\'REPORTS.DE_SELECT_ALL\'| translate}}</span></md-option><md-option \nvalue=\"{{department.id}}\" ng-repeat=\"department in vm.departments| filter:vm.searchDepartment\">\n{{department.code}} - {{department.description}}</md-option></md-optgroup></md-select><md-progress-linear \nmd-mode=\"indeterminate\" ng-if=\"vm.loadingDepartments\"></md-progress-linear></md-input-container><md-input-container \nclass=\"inputfilter\" flex ng-if=\"vm.snFilter.costCenter\"><label>{{\'REPORT.COSTCENTER\'| translate}}</label><md-select \nng-model=\"vm.filter.costCenters\" md-on-close=\"vm.clearSearchCostCenter()\" multiple=\"multiple\" \nng-disabled=\"vm.loadingCostCenter\"><md-select-header><input id=\"searchCostCenter\" ng-model=\"vm.searchCostCenter\" \ntype=\"search\" placeholder=\"Buscar Centro de Costo\"></md-select-header><md-optgroup label=\"CentrosDeCosto\"><md-option \nvalue=\"-1\" ng-click=\"vm.selectAllItemsCostCenters(\'-1\')\" ng-if=\"vm.costCenters.length>0\"><span \nng-if=\"!vm.filter.costCenters || vm.filter.costCenters.length===0\">{{\'REPORTS.SELECT_ALL\'| translate}} </span><span \nng-if=\"vm.filter.costCenters.length>0\">{{\'REPORTS.DE_SELECT_ALL\'| translate}}</span></md-option><md-option \nvalue=\"{{costCenter.id}}\" ng-repeat=\"costCenter in vm.costCenters| filter:vm.searchCostCenter\">\n{{costCenter.description}}</md-option></md-optgroup></md-select><md-progress-linear md-mode=\"indeterminate\" \nng-if=\"vm.loadingCostCenters\"></md-progress-linear></md-input-container><md-input-container class=\"inputfilter\" flex \nng-if=\"vm.snFilter.project\"><label>{{\'REPORT.PROJECT\'| translate}}</label><md-select ng-model=\"vm.filter.projects\" \nmd-on-close=\"vm.clearSearchProject()\" multiple=\"multiple\" ng-disabled=\"vm.loadingProject\"><md-select-header><input \nid=\"searchProject\" ng-model=\"vm.searchProject\" type=\"search\" placeholder=\"Buscar proyecto\"></md-select-header>\n<md-optgroup label=\"Proyectos\"><md-option value=\"{{department.id}}\" \nng-repeat=\"department in vm.projects| filter:vm.searchProject\">{{department.code}} - {{department.name}}</md-option>\n</md-optgroup></md-select><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loadingProject\"></md-progress-linear>\n</md-input-container></div><div layout=\"row\" layout-xs=\"column\"><md-input-container class=\"inputfilter\" flex \nng-if=\"vm.snFilter.idField\"><label>{{\'REPORT.DOC_ENTREGA\'| translate}}</label><input ng-model=\"vm.filter.id\" \ntype=\"number\"></md-input-container><md-input-container class=\"inputfilter\" flex ng-if=\"vm.snFilter.correlativo\"><label>\n{{\'REPORT.NO_FACTURA\'| translate}}</label><input ng-model=\"vm.filter.correlative\" type=\"number\"></md-input-container>\n<md-input-container class=\"inputfilter\" flex ng-if=\"vm.snFilter.status\"><label>{{\'REPORT.STATUS\'| translate}}</label>\n<md-select ng-model=\"vm.filter.statuses\" md-on-close=\"vm.clearSearchStatus()\" multiple=\"multiple\" \nng-disabled=\"vm.loadingStatus\"><md-select-header><input id=\"searchStatus\" ng-model=\"vm.searchStatus\" type=\"search\" \nplaceholder=\"Buscar Status\"></md-select-header><md-optgroup label=\"Departamentos\"><md-option value=\"{{status.id}}\" \nng-repeat=\"status in vm.statuses| filter:vm.searchStatus\">{{status.description}}</md-option></md-optgroup></md-select>\n<md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loadingStatus\"></md-progress-linear></md-input-container>\n<md-input-container class=\"inputfilter\" flex ng-if=\"vm.snFilter.statusInvoice\"><label>\n{{\'REPORTS.STATUS_INVOICE\'| translate}}</label><md-select ng-model=\"vm.filter.statusesInvoice\" \nmd-on-close=\"vm.clearSearchStatus()\" multiple=\"multiple\" ng-disabled=\"vm.loadingStatus\"><md-select-header><input \nid=\"searchStatus\" ng-model=\"vm.searchStatus\" type=\"search\" placeholder=\"Buscar Status\" \nng-keydown=\"$event.stopPropagation()\"></md-select-header><md-optgroup label=\"Estados\"><md-option value=\"-1\" \nng-click=\"vm.selectAllItemsStatus(\'-1\')\"><span \nng-if=\"!vm.filter.statusesInvoice || vm.filter.statusesInvoice.length===0\">{{\'REPORTS.SELECT_ALL\'| translate}} </span>\n<span ng-if=\"vm.filter.statusesInvoice.length>0\">{{\'REPORTS.DE_SELECT_ALL\'| translate}}</span></md-option><md-option \nvalue=\"{{status.id}}\" ng-repeat=\"status in vm.statusesInvoice| filter:vm.searchStatus\">{{status.description}}\n</md-option></md-optgroup></md-select><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loadingStatus\">\n</md-progress-linear></md-input-container><md-input-container class=\"inputfilter\" flex \nng-if=\"vm.snFilter.contractValid\"><md-checkbox ng-if=\"vm.snFilter.contractValid\" ng-model=\"vm.selectContractVAlid\" \nng-click=\"vm.selectContractsValid()\">Buscar Solo Contratos Vigentes</md-checkbox><md-progress-linear \nmd-mode=\"indeterminate\" ng-if=\"vm.loadingStatus\"></md-progress-linear></md-input-container></div><div layout=\"row\" \nlayout-xs=\"column\"><md-input-container class=\"inputfilter\" flex ng-if=\"vm.snFilter.settlementid\"><label>\n{{\'REPORT.SETTLEMENTID\'| translate}}</label><input ng-model=\"vm.filter.id\" type=\"number\"></md-input-container>\n<md-input-container class=\"inputfilter\" flex ng-if=\"vm.snFilter.pettyCashId\"><label>{{\'REPORT.PETTYCASHID\'| translate}}\n</label><input ng-model=\"vm.filter.pettyCashId\" type=\"number\"></md-input-container><md-input-container \nclass=\"inputfilter\" flex ng-if=\"vm.snFilter.invoicePurchaseCorrelative\"><label>\n{{\'REPORT.INVOICEPURCHASECORRELATIVE\'| translate}}</label><input ng-model=\"vm.filter.correlative\" type=\"number\">\n</md-input-container><md-input-container class=\"inputfilter\" flex ng-if=\"vm.snFilter.SettlementStatus\"><label>\n{{\'REPORT.SETTLEMENTSTATUS\'| translate}}</label><md-select ng-model=\"vm.filter.settlementStatus\" \nmd-on-close=\"vm.clearSearchSettlementStatus()\" multiple=\"multiple\" ng-disabled=\"vm.loadingDepartments\">\n<md-select-header><input id=\"searchDepartment\" ng-model=\"vm.searchSettlementStatus\" type=\"search\" \nplaceholder=\"Buscar settlementStatus\"></md-select-header><md-optgroup label=\"settlementStatus\"><md-option \nvalue=\"{{settlementStatus.id}}\" ng-repeat=\"settlementStatus in vm.settlementStatus| filter:vm.searchSettlementStatus\">\n{{settlementStatus.name}}</md-option></md-optgroup></md-select><md-progress-linear md-mode=\"indeterminate\" \nng-if=\"vm.loadingSettlementStatus\"></md-progress-linear></md-input-container><md-input-container class=\"inputfilter\" \nflex ng-if=\"vm.snFilter.pettyCashStatus\"><label>{{\'REPORT.PETTYCASHSTATUS\'| translate}}</label><md-select \nng-model=\"vm.filter.pettyCashStatus\" md-on-close=\"vm.clearSearchPettyCashStatus()\" multiple=\"multiple\" \nng-disabled=\"vm.loading\"><md-select-header><input id=\"searchPettyCashStatus\" ng-model=\"vm.searchPettyCashStatus\" \ntype=\"search\" placeholder=\"Buscar Estado\"></md-select-header><md-optgroup label=\"pettyCashStatus\"><md-option \nvalue=\"{{pettyCashStatus.id}}\" ng-repeat=\"pettyCashStatus in vm.pettyCashStatus| filter:vm.searchPettyCashStatus\">\n{{pettyCashStatus.name}}</md-option></md-optgroup></md-select><md-progress-linear md-mode=\"indeterminate\" \nng-if=\"vm.loadingPettyCashStatus\"></md-progress-linear></md-input-container></div><div layout=\"row\" layout-xs=\"column\">\n<md-input-container class=\"inputfilter\" flex ng-if=\"vm.snFilter.type\"><label>{{\'REPORT.TYPE\'| translate}}</label>\n<md-select ng-model=\"vm.filter.types\" md-on-close=\"vm.clearSearchStatus()\" multiple=\"multiple\" \nng-disabled=\"vm.loadingTypes\"><md-select-header><input id=\"searchType\" ng-model=\"vm.searchType\" type=\"search\" \nplaceholder=\"Buscar Type\"></md-select-header><md-optgroup label=\"Types\"><md-option value=\"{{dat.id}}\" \nng-repeat=\"dat in vm.typeses | filter:vm.searchType\">{{dat.description}}</md-option></md-optgroup></md-select>\n<md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loadingType\"></md-progress-linear></md-input-container></div><div\n layout=\"row\" layout-xs=\"column\"><md-input-container class=\"inputfilter\" flex ng-if=\"vm.snFilter.providers\"><label>\n{{\'REPORT.providers\'| translate}}</label><input readonly=\"true\" ng-model=\"vm.namesProviders\"><md-progress-linear \nmd-mode=\"indeterminate\" ng-if=\"vm.loadingProviders\"></md-progress-linear></md-input-container><md-button \nclass=\"md-mini md-fab md-primary md-raised\" aria-label=\"addDetail\" ng-click=\"vm.selectCompanies(\'providers\')\" \nng-if=\"vm.snFilter.providers\"><md-icon md-font-icon=\"icon-plus\" ng-if=\"!vm.namesProviders\"><md-tooltip \nmd-direction=\"top\">{{\"general.add\"| translate}}</md-tooltip></md-icon><md-icon md-font-icon=\"icon-pencil\" \nng-if=\"vm.namesProviders\"><md-tooltip md-direction=\"top\">{{\"general.edit\"| translate}}</md-tooltip></md-icon>\n</md-button></div></form><div layout=\"row\" layout-xs=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-accent md-raised md-hue-1\" ng-click=\"vm.search()\" ng-disabled=\"vm.filterForm.$invalid\">\n{{\'REPORT.SEARCH\'| translate}}</md-button></div></div></md-card></md-content></div>");
$templateCache.put("app/main/apps/invoice/configureLimitDate/editLimitDate/editLimitDate.html","<md-dialog class=\"compose-dialog\" aria-label=\"New Message\" ms-scroll \nstyle=\"width: 45%; height: 75%; max-width:45%; max-height: 75%\"><md-toolbar class=\"md-accent md-hue-2\" layout=\"row\" \nng-if=\"!vm.searchMode\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \ntranslate=\"INVOICE.CONFIGURE_LIMIT_DATE\"></span> <span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" tranlate translate-aria-label=\"MAIL.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll flex layout-fill><div>\n<form name=\"vm.detailForm\" ng-submit=\"vm.sendDetail()\"><div \nclass=\"order-detail-form-container status md-background-bg md-whiteframe-1dp\"><div><div layout=\"row\" \nlayout-align=\"center center\"><md-input-container flex-gt-xs><label translate=\"INVOICE.LIMIT_DATE.TYPE\">Tipo</label>\n<md-select ng-model=\"vm.detail.invoicePurchaseLimitDateType.id\" name=\"type\" md-on-close=\"vm.clearSearchType()\" \nrequired><md-select-header><input id=\"searchType\" ng-model=\"vm.searchType\" type=\"search\" placeholder=\"Buscar\">\n</md-select-header><md-optgroup><md-option ng-value=\"cc.id\" \nng-repeat=\"cc in vm.invoicePurchaseType| filter:vm.searchType\">{{cc.limitDateTypeName}}</md-option></md-optgroup>\n</md-select><div ng-messages=\"vm.detailForm.invoicePurchaseLimitDateType.$error\"><div ng-message=\"required\" \ntranslate=\"INVOICE.ERROR.FIELD_REQUIRED\">This field is required!</div></div></md-input-container></div><div \nlayout=\"row\" layout-align=\"center center\"><md-input-container><label translate=\"INVOICE.INVOICE_PURCHASE.DATE_MIN\">\nEnd Date</label><md-datepicker required type=\"date\" ng-model=\"vm.detail.minDate\" name=\"endDate\" \nmd-min-date=\"vm.minDate\" md-open-on-focus></md-datepicker><div ng-messages=\"vm.detailForm.minDate.$error\"><div \nng-message=\"valid\" translate=\"REQUISITION.ERROR.INVALID_DATE\">The entered value is not a date!</div><div \nng-message=\"required\" translate=\"REQUISITION.ERROR.FIELD_REQUIRED\">This date is required!</div><div \nng-message=\"mindate\" translate=\"REQUISITION.ERROR.INVALID_DATE\">Date is too early!</div></div></md-input-container>\n</div><div layout=\"row\" layout-align=\"center center\"><md-input-container><label \ntranslate=\"INVOICE.INVOICE_PURCHASE.DATE_MAX\">End Date</label><md-datepicker required type=\"date\" \nng-model=\"vm.detail.maxDate\" name=\"endDate\" md-min-date=\"vm.detail.minDate\" md-open-on-focus></md-datepicker><div \nng-messages=\"vm.detailForm.maxDate.$error\"><div ng-message=\"valid\" translate=\"REQUISITION.ERROR.INVALID_DATE\">\nThe entered value is not a date!</div><div ng-message=\"required\" translate=\"REQUISITION.ERROR.FIELD_REQUIRED\">\nThis date is required!</div><div ng-message=\"mindate\" translate=\"REQUISITION.ERROR.INVALID_DATE\">Date is too early!\n</div></div></md-input-container></div><div layout=\"row\" layout-align=\"center center\"><md-input-container><label \ntranslate=\"INVOICE.INVOICE_PURCHASE.DATE_REFERENCE\">End Date</label><md-datepicker required type=\"date\" \nng-model=\"vm.detail.referenceDate\" name=\"endDate\" md-open-on-focus></md-datepicker><div \nng-messages=\"vm.detailForm.referenceDate.$error\"><div ng-message=\"valid\" translate=\"REQUISITION.ERROR.INVALID_DATE\">\nThe entered value is not a date!</div><div ng-message=\"required\" translate=\"REQUISITION.ERROR.FIELD_REQUIRED\">\nThis date is required!</div><div ng-message=\"mindate\" translate=\"REQUISITION.ERROR.INVALID_DATE\">Date is too early!\n</div></div></md-input-container></div></div></div></form><md-button ng-click=\"vm.sendDetail()\" \nclass=\"send-button md-accent md-fab md-fab-bottom-right\" aria-label=\"Send\" ng-if=\"vm.detailForm.$valid\" \nng-disabled=\"vm.disableButton\" translate-attr-aria-label=\"REQUISITION.DETAIL.SEND\"><md-icon \nmd-font-icon=\"icon-content-save\"></md-icon><md-tooltip md-direction=\"left\">{{\"general.save\"| translate}}</md-tooltip>\n</md-button></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/apps/invoice/saleInvoice/detailEditor/detailEditor.html","<md-dialog class=\"compose-dialog\" aria-label=\"New Message\"><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\n{{vm.invoicePurchaseDetail.product.name}}</span> <span class=\"title\" \nng-if=\"vm.invoicePurchaseDetail.product.measurementUnit\">[{{vm.invoicePurchaseDetail.product.measurementUnit.name}}]\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" tranlate \ntranslate-aria-label=\"INVOICE.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-progress-linear md-mode=\"indeterminate\" class=\"md-primary\" ng-if=\"vm.loading\"></md-progress-linear>\n<md-dialog-content ms-scroll><div layout=\"row\"><div class=\"customer\" layout=\"column\"><span><strong \ntranslate=\"INVOICE.INVOICE_PURCHASE.DETAIL.QUANTITY\"></strong></span></div><div class=\"customer\" layout=\"column\" \nstyle=\"width: 5px\"></div><div class=\"customer\" layout=\"column\"><span class=\"number\">\n{{vm.invoicePurchaseDetail.quantity}}</span></div></div><div layout=\"row\"><div class=\"customer\" layout=\"column\" \nflex=\"50\"><div layout=\"row\"><div class=\"customer\" layout=\"column\"><span><strong \ntranslate=\"INVOICE.INVOICE_PURCHASE.DETAIL.UNIT_PRICE_BEFORE_TAX\"></strong> </span><span><strong \ntranslate=\"INVOICE.INVOICE_PURCHASE.DETAIL.UNIT_PRICE_AFTER_TAX\"></strong></span></div><div class=\"customer\" \nlayout=\"column\" style=\"width: 20px\"><span class=\"number\">\n{{vm.invoicePurchaseDetail.invoicePurchase.currency.symbol + \". \"}}</span> <span class=\"number\">\n{{vm.invoicePurchaseDetail.invoicePurchase.currency.symbol + \". \"}}</span></div><div class=\"customer\" layout=\"column\" \nstyle=\"width: 5px\"></div><div class=\"customer\" layout=\"column\"><span class=\"number\">\n{{vm.invoicePurchaseDetail.priceBeforeTaxCurrency| number: 6}}</span> <span class=\"number\">\n{{vm.invoicePurchaseDetail.priceAfterTaxCurrency| number: 6}}</span></div></div></div><div class=\"customer\" \nlayout=\"column\" flex=\"50\"><div layout=\"row\"><div class=\"customer\" layout=\"column\"><span><strong \ntranslate=\"INVOICE.INVOICE_PURCHASE.DETAIL.TOTAL_BEFORE_TAX\"></strong> </span><span><strong \ntranslate=\"INVOICE.INVOICE_PURCHASE.DETAIL.TOTAL_AFTER_TAX\"></strong></span></div><div class=\"customer\" \nlayout=\"column\" style=\"width: 20px\"><span class=\"number\">\n{{vm.invoicePurchaseDetail.invoicePurchase.currency.symbol + \". \"}}</span> <span class=\"number\">\n{{vm.invoicePurchaseDetail.invoicePurchase.currency.symbol + \". \"}}</span></div><div class=\"customer\" layout=\"column\" \nstyle=\"width: 5px\"></div><div class=\"customer\" layout=\"column\"><span class=\"number\">\n{{vm.invoicePurchaseDetail.documentSubTotalBeforeTaxCurrency| number: 2}}</span> <span class=\"number\">\n{{vm.invoicePurchaseDetail.documentSubTotalAfterTaxCurrency| number: 2}}</span></div></div></div></div><br><div \nlayout=\"row\" flex></div><div layout=\"row\" layout-align=\"center center\"><strong><h2><div class=\"title\" \ntranslate=\"INVOICE.INVOICE_PURCHASE.DETAIL.DETAIL_TAXES\">Documents</div></h2></strong></div><form name=\"vm.basicForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"vm.saveCountryTax()\"><div layout=\"column\" layout-gt-sm=\"row\" \nng-if=\"vm.CountryTaxs\"><md-input-container flex><label class=\"h1\" translate=\"INVOICE.INVOICE_PURCHASE.TAXES\"></label>\n<md-select ng-model=\" vm.invoicePurchaseDetailTax.countryTax.id\" name=\"countryTax\" required \nmd-on-close=\"vm.clearvSearchCountryTax()\"><md-select-header><input id=\"CountryTaxs\" ng-model=\"vm.searchCountryTax\" \ntype=\"search\" placeholder=\"Buscar\"></md-select-header><md-optgroup label=\"CountryTaxs\"><md-option \nng-value=\"{{countryTax.id}}\" ng-repeat=\"countryTax in vm.CountryTaxs| filter:vm.searchCountryTax\">\n{{countryTax.description}}</md-option></md-optgroup></md-select></md-input-container><md-input-container><label \nclass=\"title\" translate=\"INVOICE.INVOICE_PURCHASE.DETAIL.VALUE \">amount</label><input type=\"number\" name=\"value\" \nstyle=\"text-align: right\" required ng-model=\"vm.invoicePurchaseDetailTax.documentPrice\" min=\"0.01\"><div \nng-messages=\"vm.basicForm.value.$error\" role=\"alert\"><div ng-message=\"required\"><div \ntranslate=\"INVOICE.INVOICE_PURCHASE.DETAIL.VALUE\">This date is required!</div></div></div></md-input-container>\n<md-button type=\"submit\" class=\"md-fab\" aria-label=\"save\" ng-disabled=\"vm.basicForm.$invalid\" aria-label=\"save\">\n<ng-md-icon icon=\"save\"></ng-md-icon><md-tooltip md-direction=\"left\">{{\"general.save\"| translate}}</md-tooltip>\n</md-button></div></form><md-button class=\"md-fab right-bottom-arrow md-fab-bottom-right\" aria-label=\"add\" \nng-if=\"!vm.CountryTaxs && vm.rol && !vm.isValidPurchaseStatus\" ng-click=\"vm.addCountrytax()\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"left\">{{\"general.add\"| translate}}</md-tooltip>\n</md-button><div class=\"content fullpage-datatable\" layout=\"column\" flex><md-progress-linear md-mode=\"indeterminate\" \nng-if=\"vm.loading\" class=\"md-accent\"></md-progress-linear><div id=\"masterGridOptionsTax\" \nag-grid=\"vm.masterGridOptionsTax\" class=\"ag-fresh\" expand-grid min=\"150\" other=\"-5\" style=\"max-height: 250px\"></div>\n</div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/apps/invoice/saleInvoice/detailEditor/discount-dialog.html","<md-dialog aria-label=\"Discount\" style=\"max-width: 325px; width: 325px\"><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><strong><span class=\"title\" \ntranslate=\"INVOICE.SALE_INVOICE.DETAIL.DISCOUNT.DISCOUNT\">New Message</span></strong><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" tranlate translate-aria-label=\"QUOTATION.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-progress-linear md-mode=\"indeterminate\" \nclass=\"md-primary\" ng-if=\"vm.loading\"></md-progress-linear><md-dialog-content><div layout=\"row\" \nng-if=\"(vm.invoicePurchaseDetail.discountBeforeTax || vm.invoicePurchaseDetail.discountAfterTax) && !vm.loading\"><span>\n<strong translate=\"INVOICE.SALE_INVOICE.DETAIL.DISCOUNT.EXISTING_DISCOUNT\"></strong></span></div><div layout=\"row\" \nng-if=\"(vm.invoicePurchaseDetail.discountBeforeTax || vm.invoicePurchaseDetail.discountAfterTax) && !vm.loading\" \nstyle=\"padding: 15px\"><div class=\"customer\" layout=\"column\"><span><strong \ntranslate=\"INVOICE.SALE_INVOICE.DETAIL.DISCOUNT.BEFORE_TAX\"></strong> </span><span><strong \ntranslate=\"INVOICE.SALE_INVOICE.DETAIL.DISCOUNT.AFTER_TAX\"></strong></span></div><div class=\"customer\" layout=\"column\" \nstyle=\"width: 25px\"><span style=\"text-align: right\">{{vm.invoicePurchaseDetail.invoicePurchase.currency.symbol + \". \"}}\n</span> <span style=\"text-align: right\">{{vm.invoicePurchaseDetail.invoicePurchase.currency.symbol + \". \"}}</span>\n</div><div class=\"customer\" layout=\"column\" style=\"width: 5px\"></div><div class=\"customer\" layout=\"column\"><span \nstyle=\"text-align: right\">{{vm.discountBeforeTax}}</span> <span style=\"text-align: right\">{{vm.discountAfterTax}}\n</span></div></div><br><div layout=\"row\" style=\"text-align: left\"><span><strong \ntranslate=\"INVOICE.SALE_INVOICE.DETAIL.DISCOUNT.APPLY_TO_PRICE\"></strong></span></div><div layout=\"row\" \nstyle=\"padding: 15px\"><md-radio-group ng-model=\"vm.applyToPrice\" style=\"text-align: left\" flex=\"100\"><div layout=\"row\">\n<md-radio-button value=\"0\"><span class=\"title\" translate=\"INVOICE.SALE_INVOICE.DETAIL.DISCOUNT.BEFORE_TAX\"></span>\n</md-radio-button><span flex=\"10\"></span><md-radio-button value=\"1\"><span class=\"title\" \ntranslate=\"INVOICE.SALE_INVOICE.DETAIL.DISCOUNT.AFTER_TAX\"></span></md-radio-button></div></md-radio-group></div><div \nlayout=\"row\"><md-input-container flex=\"100\" style=\"text-align: right\"><label \ntranslate=\"INVOICE.SALE_INVOICE.DETAIL.DISCOUNT.DISCOUNT\">Price</label><input ng-model=\"vm.discount\" type=\"number\" \nname=\"price\" required min=\"0\" \nmax=\"{{vm.applyToPrice === \'0\' ? \n                (vm.invoicePurchaseDetail.priceBeforeTax - 0.01) : \n                (vm.invoicePurchaseDetail.priceAfterTax - 0.01)}}\" \nstyle=\"text-align: right\" ng-disabled=\"!vm.applyToPrice\" ng-change=\"vm.validateDecimalDiscount()\"></md-input-container>\n</div><div layout=\"row\"><md-button flex=\"50\" \nng-if=\"(\n                (vm.invoicePurchaseDetail.discountBeforeTax &&\n                    vm.invoicePurchaseDetail.discountBeforeTax>0 && \n                    vm.applyToPrice ===\'0\') || \n                (vm.invoicePurchaseDetail.discountAfterTax && \n                vm.invoicePurchaseDetail.discountAfterTax>0 && \n                vm.applyToPrice ===\'1\') && !vm.loading)\" \nclass=\"md-raised md-primary\" ng-click=\"vm.save(0)\" aria-label=\"add_discount\" translate \ntranslate-attr-aria-label=\"save\"><span>{{ \'INVOICE.DELETE\'| translate}}</span></md-button><md-button flex=\"100\" \nng-disabled=\"(!vm.discount && !(vm.discount === 0)) || \n            !vm.applyToPrice || vm.loading\" \nclass=\"md-raised md-primary\" ng-click=\"vm.save(null)\" aria-label=\"add_discount\" translate \ntranslate-attr-aria-label=\"save\"><span>\n{{((vm.invoicePurchaseDetail.discountBeforeTax && vm.invoicePurchaseDetail.discountAfterTax) && !vm.loading ? \'INVOICE.SALE_INVOICE.DETAIL.DISCOUNT.REPLACE\' : \'INVOICE.SALE_INVOICE.DETAIL.DISCOUNT.APPLY\')| translate}}\n</span></md-button></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/apps/invoice/saleInvoice/editDescription/description-dialog.html","<md-dialog aria-label=\"Discount\" style=\"max-width: 325px; width: 325px\"><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><strong><span class=\"title\" \ntranslate=\"INVOICE.SALE_INVOICE.DETAIL.ADDDESCRIPTION\">New Message</span></strong><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" tranlate translate-aria-label=\"QUOTATION.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-progress-linear md-mode=\"indeterminate\" \nclass=\"md-primary\" ng-if=\"vm.loading\"></md-progress-linear><md-dialog-content><form name=\"vm.formDescript\">\n<md-input-container class=\"md-block\"><label translate=\"INVOICE.SALE_INVOICE.DETAIL.DESCRIPTION\">Price</label><textarea \nng-model=\"vm.description\" md-maxlength=\"240\" rows=\"5\" md-select-on-focus name=\"description\"></textarea>\n</md-input-container></form></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\">\n<div layout=\"row\" layout-align=\"end center\"><md-button type=\"submit\" ng-click=\"vm.save()\" \nclass=\"send-button md-accent md-raised\" \nng-disabled=\"!vm.description || vm.description === \'\' || vm.formDescript.$invalid\" aria-label=\"SAVE\" \ntranslate=\"INVOICE.SALE_INVOICE.DETAIL.SAVE\" translate-attr-aria-label=\"CONTACTS.SAVE\">SAVE</md-button></div>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/merchandiseEntry/invoiceMerchandiseEntry/view/view.html","<div id=\"budgetO\" class=\"page-layout carded fullwidth\" layout=\"column\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" \nlayout=\"row\" layout-align=\"start center\" flex><md-button class=\"goto-orders-button md-icon-button\" \naria-label=\"Go to orders\" ng-click=\"vm.gotoMerchandises()\" translate \ntranslate-attr-aria-label=\"MERCHANDISE_ENTRY.GO_TO_MERCHANDISES\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon>\n</md-button><div layout=\"column\" layout-align=\"start start\"><div class=\"h2\"><span \ntranslate=\"MERCHANDISE_ENTRY.MERCHANDISE_ENTRY_ADD\">MERCHANDISE_ENTRY</span> <span>#{{vm.merchandiseHeader.id}}</span>\n</div><div class=\"subtitle secondary-text\"></div></div></div></div><md-tabs md-selected=\"vm.currentTab\"><md-tab \nid=\"tab1\" aria-controls=\"tab1-content\"><md-tab-label><md-icon md-font-icon=\"icon-indent\"></md-icon><span \ntranslate=\"REQUISITION.ENCABEZADO\">Requisition Details</span></md-tab-label></md-tab><md-tab id=\"tab2\" \naria-controls=\"tab2-content\"><md-icon md-font-icon=\"icon-cube-unfolded\"></md-icon><span \ntranslate=\"REPORT.PROCESS_FLOW.FLOW\">Diagrama</span></md-tab></md-tabs><md-content class=\"content\" flex ms-scroll>\n<md-tabs md-dynamic-height md-selected=\"vm.currentTab\" class=\"tab-in-content\"><md-tab aria-controls=\"tab1-content\">\n<md-tab-body><div class=\"content-card\" layout=\"column\" flex><div class=\"toolbar\"><div layout=\"row\"><div \nclass=\"customer\" layout=\"column\" flex><span><strong translate=\"MERCHANDISE_ENTRY.DEPARTMENT\"></strong>\n {{vm.merchandiseHeader.purchaseOrder.department.description}}</span> <span><strong \ntranslate=\"MERCHANDISE_ENTRY.COST_CENTER\"></strong> {{vm.merchandiseHeader.purchaseOrder.costCenter.description}}\n</span> <span><strong translate=\"MERCHANDISE_ENTRY.DETAIL.QUANTITY\"></strong>\n {{vm.merchandiseHeader.quantityReceived| number:0}}</span></div><div class=\"customer\" layout=\"column\" flex><span>\n<strong translate=\"MERCHANDISE_ENTRY.PROVIDER\"></strong> {{vm.merchandiseHeader.purchaseOrder.companyProvider.name}}\n</span> <span><strong translate=\"MERCHANDISE_ENTRY.BUYER\"></strong> {{vm.merchandiseHeader.purchaseOrder.company.name}}\n</span> <span><strong translate=\"MERCHANDISE_ENTRY.TOTAL\"></strong> {{vm.merchandiseHeader.totalReceived| number:2}}\n</span></div><div ng-if=\"vm.details.length > 0\"><md-button \nng-show=\"vm.statusToChange === \'Creando\' && vm.details.length > 0\" ng-disabled=\"$rootScope.loadingProgress\" \nclass=\"md-raised md-primary\" ng-click=\"vm.presentRequisition()\" aria-label=\"present requisition\" translate \ntranslate-attr-aria-label=\"REQUISITION.STATUSCHANGE.Creando\"><span>\n{{\'REQUISITION.STATUSCHANGE.\' + vm.statusToChange| translate}}</span></md-button></div><div \nng-if=\"vm.merchandises.length > 0\"><md-button ng-show=\"vm.merchandises.length > 0\" \nng-disabled=\"$rootScope.loadingProgress\" class=\"md-raised md-primary\" ng-click=\"vm.viewMerchandisesDetail()\" \naria-label=\"present merchandise\" translate translate-attr-aria-label=\"REQUISITION.ORDER_DETAILS\"><span>\n{{\'MERCHANDISE_ENTRY.DETAIL.DETAILS\'| translate}}</span></md-button></div></div></div><md-content class=\"content\" flex \nms-scroll><div layout=\"column\" flex ng-show=\"vm.addProducts\"><md-progress-linear md-mode=\"indeterminate\" \nng-if=\"vm.loading\" class=\"md-accent\"></md-progress-linear><div id=\"masterGridOptions\" ag-grid=\"vm.masterGridOptions\" \nclass=\"ag-fresh\" expand-grid min=\"260\" other=\"-10\"></div></div><div layout=\"column\" flex \nng-show=\"vm.details.length <= 0 && !vm.addProducts\"><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loading\" \nclass=\"md-accent\"></md-progress-linear><div id=\"masterGridOptionsME\" ag-grid=\"vm.masterGridOptionsME\" class=\"ag-fresh\" \nexpand-grid min=\"260\" other=\"-10\"></div></div></md-content></div></md-tab-body></md-tab><md-tab \naria-controls=\"tab2-content\"><md-tab-body><div ng-include=\"\'app/main/apps/reports/process-flow/process-flow.html\'\">\n</div></md-tab-body></md-tab></md-tabs></md-content></div></div><md-button class=\"md-fab md-fab-bottom-right\" \nng-show=\"vm.statusToChange === \'Creando\' && vm.addProducts\" aria-label=\"addDetail\" ng-click=\"vm.composeDialog($event)\">\n<md-icon ng-show=\"vm.addProducts\" md-font-icon=\"icon-plus\"></md-icon></md-button>");
$templateCache.put("app/main/apps/order/order/compose/features-dialog.html","<md-dialog aria-label=\"Crear-Editar\" style=\"width: 60%; height: 90%\"><ms-widget flippable=\"true\" layout=\"row\" \nstyle=\"padding: 0; height: 100%\"><ms-widget-front class=\"white-bg\" ms-scroll><md-toolbar \nclass=\"md-accent md-tall md-toolbar-more\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\n{{\'QUOTATION.DETAIL.FEATURES.AGGREGATED_TO\'| translate }} <strong>\n{{vm.detail.quotationDetail.requisitionDetail.product.name}}</strong></span><md-button class=\"md-icon-button\" \nng-click=\"vm.newContact ? (vm.completedFeatures === true ? vm.cancel() : vm.flip()) : vm.cancel()\" aria-label=\"Close\" \ntranslate translate-attr-aria-label=\"general.close\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div><div\n class=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"column\" layout-align=\"center center\"><div \nlayout=\"column\" layout-align=\"center center\"><div><form ng-submit=\"vm.searchFeature()\" name=\"vm.searchForm\"><div \nclass=\"md-toolbar-tools\"><md-input-container flex style=\"margin-top: 60px\"><label translate=\"QUOTATION.FILTER\">Filtro\n</label><input type=\"text\" ng-model=\"vm.filter\" name=\"search\" id=\"searchFilter\" ng-keyup=\"vm.searchFeature()\">\n</md-input-container><md-button type=\"submit\" aria-label=\"Search\"><span translate=\"QUOTATION.SEARCH\">Search</span>\n</md-button></div></form></div></div></div></md-toolbar><md-progress-linear type=\"indeterminate\" \nng-show=\"vm.isShowProgressLinear\"></md-progress-linear><md-dialog-content ms-scroll style=\"padding: 0px\"><div \nlayout=\"column\" class=\"p-16\" style=\"padding: 0px\"><div id=\"e-commerce-product\" \nclass=\"md-dialog-list-content center p-16\" flex-gt-sm=\"50\" flex=\"100\"><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\" ng-show=\"!vm.loading\"><div \nclass=\"content thread-list\" ms-scroll><form name=\"vm.featuresUpdateForm\" id=\"featuresUpdateForm\" \nng-submit=\"vm.save(false)\" ng-if=\"vm.fixedAssetsToUpdate.length > 0\"><br><div \nng-repeat=\"feature in vm.fixedAssetToUpdate.features\"><md-input-container style=\"margin: 5px 0\" class=\"md-block\" \nng-if=\"feature.fixedAssetGroupFeature.dataType === \'TEXT\'\"><input type=\"text\" \nplaceholder=\"{{feature.fixedAssetGroupFeature.fixedAssetFeatureName}}\" \nname=\"input{{feature.fixedAssetGroupFeature.id}}\" required md-no-asterisk \nmd-maxlength=\"{{feature.fixedAssetGroupFeature.valueLength}}\" ng-model=\"feature.featureValue\"><div \nng-messages=\"vm.step4[\'input\' + feature.fixedAssetGroupFeature.id].$error\"><div ng-message=\"required\">\n{{\'general.field_required\'| translate}}.</div><div ng-message=\"md-maxlength\">\n{{\'general.can_not_be_more_than\'| translate}} {{feature.fixedAssetGroupFeature.valueLength}} {{\'general.characters\'| translate}}.\n</div></div></md-input-container><md-input-container style=\"margin: 5px 0\" class=\"md-block\" \nng-if=\"feature.fixedAssetGroupFeature.dataType === \'NUMBER\'\"><input type=\"text\" \nplaceholder=\"{{feature.fixedAssetGroupFeature.fixedAssetFeatureName}}\" \nname=\"input{{feature.fixedAssetGroupFeature.id}}\" required md-no-asterisk ng-model=\"feature.featureValue\" numbers-only>\n<div ng-messages=\"vm.step4[\'input\' + feature.fixedAssetGroupFeature.id].$error\"><div ng-message=\"required\">\n{{\'general.field_required\'| translate}}.</div><div ng-message=\"md-maxlength\">\n{{\'general.can_not_be_more_than\'| translate}} {{feature.fixedAssetGroupFeature.valueLength}} {{\'general.characters\'| translate}}.\n</div></div></md-input-container><md-input-container style=\"margin: 5px 0\" class=\"md-block\" \nng-if=\"feature.fixedAssetGroupFeature.dataType === \'DECIMAL\'\"><input type=\"text\" \nplaceholder=\"{{feature.fixedAssetGroupFeature.fixedAssetFeatureName}}\" \nname=\"input{{feature.fixedAssetGroupFeature.id}}\" required md-no-asterisk ng-model=\"feature.featureValue\" \ndecimals-only><div ng-messages=\"vm.step4[\'input\' + feature.fixedAssetGroupFeature.id].$error\"><div \nng-message=\"required\">{{\'general.field_required\'| translate}}.</div><div ng-message=\"md-maxlength\">\n{{\'general.can_not_be_more_than\'| translate}} {{feature.fixedAssetGroupFeature.valueLength}} {{\'general.characters\'| translate}}.\n</div></div></md-input-container><md-checkbox style=\"margin-top: 0px; margin-bottom: 18px\" \nng-if=\"feature.fixedAssetGroupFeature.dataType === \'BOOLEAN\'\" ng-click=\"vm.toggleBooleanFeatureValue($event, feature)\" \nng-checked=\"vm.isCheckedBooleanFeatureValue(feature)\">{{feature.fixedAssetGroupFeature.fixedAssetFeatureName}}\n</md-checkbox></div><div layout=\"row\"><span flex></span><md-button type=\"submit\">{{\'QUOTATION.UPDATE\'| translate}}\n</md-button><md-button ng-if=\"vm.page===1\" ng-click=\"vm.updateAll()\">{{\'QUOTATION.UPDATE_ALL\'| translate}}</md-button>\n</div></form><div ayout=\"row\" layout-align=\"center center\" ng-if=\"!(vm.fixedAssetsToUpdate.length > 0)\"><span flex>\n</span> <span class=\"title\">{{\'QUOTATION.DETAIL.FEATURES.NOT_FOUND_SEARCH\'| translate}} \"{{vm.filter}}\"</span></div>\n</div><div layout=\"row\" layout-align=\"center center\"><div paging class=\"pageable-div center\" page=\"vm.page\" \nul-class=\"pagination\" page-size=\"vm.pageSize\" hide-if-empty=\"true\" \npaging-action=\"vm.fixedAssetToUpdate = vm.fixedAssetsToUpdate[page-1];\" total=\"vm.fixedAssetsToUpdate.length\"></div>\n</div></div><md-button class=\"md-fab md-fab-bottom-left md-fa\" aria-label=\"add\" style=\"position: fixed\" \nng-click=\"vm.onEdit()\" ng-if=\"!vm.completedFeatures\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon><md-tooltip \nmd-direction=\"top\">{{\'QUOTATION.RETURN\'| translate}}</md-tooltip></md-button></div></div></md-dialog-content>\n</ms-widget-front><ms-widget-back id=\"perms\" class=\"white-bg\" ms-scroll><div ng-init=\"vm.flipping(flipWidget);\"></div>\n<div class=\"page-layout carded fullwidth\" layout=\"column\"><md-toolbar class=\"md-accent md-tall md-toolbar-more\" \nlayout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">{{\'QUOTATION.DETAIL.FEATURES.ADD_TO\'| translate}} <strong>\n{{vm.detail.quotationDetail.requisitionDetail.product.name}}</strong></span><md-button class=\"md-icon-button\" \nng-click=\"vm.cancel()\" aria-label=\"Close\" translate translate-attr-aria-label=\"general.close\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div><div class=\"md-toolbar-tools md-toolbar-tools-middle\" \nlayout=\"row\" layout-align=\"space-between center\"><span flex class=\"title\" style=\"font-size: 12pt; text-align: center\">\n<strong>{{(\'QUOTATION.DETAIL.FEATURES.QUANTITY_PRODUCT\'| translate) + \": \"}}</strong>\n {{vm.detail.quotationDetail.requisitionDetail.quantity}}</span> <span flex class=\"title\" \nstyle=\"font-size: 12pt; text-align: center\"><strong>{{(\'QUOTATION.DETAIL.FEATURES.QUANTITY_ADDED\'| translate) + \": \"}}\n</strong> {{vm.fixedAssets.length}}</span> <span flex class=\"title\" style=\"font-size: 12pt; text-align: center\">\n<strong>{{(\'QUOTATION.DETAIL.FEATURES.PENDINGS\'| translate)+ \": \" }}</strong>\n{{(vm.detail.quotationDetail.requisitionDetail.quantity - vm.fixedAssets.length)}}</span></div></md-toolbar><div \nclass=\"center\" layout=\"column\" flex><div class=\"md-dialog-content\" ms-scroll><form name=\"vm.featuresForm\" \nid=\"featuresForm\" ng-submit=\"vm.save(true)\" ng-if=\"!vm.completedFeatures\"><div \nng-repeat=\"feature in vm.fixedAsset.features\"><md-input-container style=\"margin: 5px 0\" class=\"md-block\" \nng-if=\"feature.fixedAssetGroupFeature.dataType === \'TEXT\'\"><input type=\"text\" \nplaceholder=\"{{feature.fixedAssetGroupFeature.fixedAssetFeatureName}}\" \nname=\"input{{feature.fixedAssetGroupFeature.id}}\" required md-no-asterisk \nmd-maxlength=\"{{feature.fixedAssetGroupFeature.valueLength}}\" ng-model=\"feature.featureValue\"><div \nng-messages=\"vm.step4[\'input\' + feature.fixedAssetGroupFeature.id].$error\"><div ng-message=\"required\">\n{{\'general.field_required\'| translate}}.</div><div ng-message=\"md-maxlength\">\n{{\'general.can_not_be_more_than\'| translate}} {{feature.fixedAssetGroupFeature.valueLength}} {{\'general.characters\'| translate}}.\n</div></div></md-input-container><md-input-container style=\"margin: 5px 0\" class=\"md-block\" \nng-if=\"feature.fixedAssetGroupFeature.dataType === \'NUMBER\'\"><input type=\"text\" \nplaceholder=\"{{feature.fixedAssetGroupFeature.fixedAssetFeatureName}}\" \nname=\"input{{feature.fixedAssetGroupFeature.id}}\" required md-no-asterisk ng-model=\"feature.featureValue\" numbers-only>\n<div ng-messages=\"vm.step4[\'input\' + feature.fixedAssetGroupFeature.id].$error\"><div ng-message=\"required\">\n{{\'general.field_required\'| translate}}.</div><div ng-message=\"md-maxlength\">\n{{\'general.can_not_be_more_than\'| translate}} {{feature.fixedAssetGroupFeature.valueLength}} {{\'general.characters\'| translate}}.\n</div></div></md-input-container><md-input-container style=\"margin: 5px 0\" class=\"md-block\" \nng-if=\"feature.fixedAssetGroupFeature.dataType === \'DECIMAL\'\"><input type=\"text\" \nplaceholder=\"{{feature.fixedAssetGroupFeature.fixedAssetFeatureName}}\" \nname=\"input{{feature.fixedAssetGroupFeature.id}}\" required md-no-asterisk ng-model=\"feature.featureValue\" \ndecimals-only><div ng-messages=\"vm.step4[\'input\' + feature.fixedAssetGroupFeature.id].$error\"><div \nng-message=\"required\">{{\'general.field_required\'| translate}}.</div><div ng-message=\"md-maxlength\">\n{{\'general.can_not_be_more_than\'| translate}} {{feature.fixedAssetGroupFeature.valueLength}} {{\'general.characters\'| translate}}.\n</div></div></md-input-container><md-checkbox style=\"margin-top: 0px; margin-bottom: 18px\" \nng-if=\"feature.fixedAssetGroupFeature.dataType === \'BOOLEAN\'\" ng-click=\"vm.toggleBooleanFeatureValue($event, feature)\" \nng-checked=\"vm.isCheckedBooleanFeatureValue(feature)\">{{feature.fixedAssetGroupFeature.fixedAssetFeatureName}}\n</md-checkbox></div><div layout=\"row\"><span flex></span><md-button ng-click=\"vm.cancel()\">\n{{\'QUOTATION.CANCEL\'| translate}}</md-button><md-button type=\"submit\">{{\'QUOTATION.SAVE\'| translate}}</md-button>\n<md-button ng-click=\"vm.saveAll()\">{{\'QUOTATION.SAVE_ALL\'| translate}}</md-button></div></form><md-button \nclass=\"md-fab md-fab-bottom-right md-fa\" aria-label=\"add\" style=\"position: fixed\" ng-click=\"vm.onEdit()\" \nng-if=\"vm.fixedAssets.length > 0\"><md-icon md-font-icon=\"icon-eye\"></md-icon><md-tooltip md-direction=\"top\">\n{{\'QUOTATION.DETAIL.FEATURES.VIEW_AGGREGATED\'| translate}}</md-tooltip></md-button></div></div></div></ms-widget-back>\n</ms-widget></md-dialog>");
$templateCache.put("app/main/apps/order/order/compose/features-dialogView.html","<md-dialog aria-label=\"Crear-Editar\" style=\"width: 60%; height: 90%\"><ms-widget flippable=\"true\" layout=\"row\" \nstyle=\"padding: 0; height: 100%\"><ms-widget-front class=\"white-bg\" ms-scroll><md-toolbar \nclass=\"md-accent md-tall md-toolbar-more\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\n{{\'QUOTATION.DETAIL.FEATURES.AGGREGATED_TO\'| translate }} <strong>{{vm.quotationDetail.requisitionDetail.product.name}}\n</strong></span><md-button class=\"md-icon-button\" \nng-click=\"vm.newContact ? (vm.completedFeatures === true ? vm.cancel() : vm.flip()) : vm.cancel()\" aria-label=\"Close\" \ntranslate translate-attr-aria-label=\"general.close\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div><div\n class=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"column\" layout-align=\"center center\"><div \nlayout=\"column\" layout-align=\"center center\"><div><form ng-submit=\"vm.searchFeature()\" name=\"vm.searchForm\"><div \nclass=\"md-toolbar-tools\"><md-input-container flex style=\"margin-top: 60px\"><label translate=\"QUOTATION.FILTER\">Filtro\n</label><input type=\"text\" ng-model=\"vm.filter\" name=\"search\" id=\"searchFilter\" ng-keyup=\"vm.searchFeature()\">\n</md-input-container><md-button type=\"submit\" aria-label=\"Search\"><span translate=\"QUOTATION.SEARCH\">Search</span>\n</md-button></div></form></div></div></div></md-toolbar><md-progress-linear type=\"indeterminate\" \nng-show=\"vm.isShowProgressLinear\"></md-progress-linear><md-dialog-content ms-scroll style=\"padding: 0px\"><div \nlayout=\"column\" class=\"p-16\" style=\"padding: 0px\"><div id=\"e-commerce-product\" \nclass=\"md-dialog-list-content center p-16\" flex-gt-sm=\"50\" flex=\"100\"><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\" ng-show=\"!vm.loading\"><div \nclass=\"content thread-list\" ms-scroll><form name=\"vm.featuresUpdateForm\" id=\"featuresUpdateForm\" \nng-submit=\"vm.save(false)\" ng-if=\"vm.fixedAssetsToUpdate.length > 0\"><br><div \nng-repeat=\"feature in vm.fixedAssetToUpdate.features\"><md-input-container style=\"margin: 5px 0\" class=\"md-block\" \nng-if=\"feature.fixedAssetGroupFeature.dataType === \'TEXT\'\"><input ng-disabled=\"true\" type=\"text\" \nplaceholder=\"{{feature.fixedAssetGroupFeature.fixedAssetFeatureName}}\" \nname=\"input{{feature.fixedAssetGroupFeature.id}}\" required md-no-asterisk \nmd-maxlength=\"{{feature.fixedAssetGroupFeature.valueLength}}\" ng-model=\"feature.featureValue\"><div \nng-messages=\"vm.step4[\'input\' + feature.fixedAssetGroupFeature.id].$error\"><div ng-message=\"required\">\n{{\'general.field_required\'| translate}}.</div><div ng-message=\"md-maxlength\">\n{{\'general.can_not_be_more_than\'| translate}} {{feature.fixedAssetGroupFeature.valueLength}} {{\'general.characters\'| translate}}.\n</div></div></md-input-container><md-input-container style=\"margin: 5px 0\" class=\"md-block\" \nng-if=\"feature.fixedAssetGroupFeature.dataType === \'NUMBER\'\"><input ng-disabled=\"true\" type=\"text\" \nplaceholder=\"{{feature.fixedAssetGroupFeature.fixedAssetFeatureName}}\" \nname=\"input{{feature.fixedAssetGroupFeature.id}}\" required md-no-asterisk ng-model=\"feature.featureValue\" numbers-only>\n<div ng-messages=\"vm.step4[\'input\' + feature.fixedAssetGroupFeature.id].$error\"><div ng-message=\"required\">\n{{\'general.field_required\'| translate}}.</div><div ng-message=\"md-maxlength\">\n{{\'general.can_not_be_more_than\'| translate}} {{feature.fixedAssetGroupFeature.valueLength}} {{\'general.characters\'| translate}}.\n</div></div></md-input-container><md-input-container style=\"margin: 5px 0\" class=\"md-block\" \nng-if=\"feature.fixedAssetGroupFeature.dataType === \'DECIMAL\'\"><input ng-disabled=\"true\" type=\"text\" \nplaceholder=\"{{feature.fixedAssetGroupFeature.fixedAssetFeatureName}}\" \nname=\"input{{feature.fixedAssetGroupFeature.id}}\" required md-no-asterisk ng-model=\"feature.featureValue\" \ndecimals-only><div ng-messages=\"vm.step4[\'input\' + feature.fixedAssetGroupFeature.id].$error\"><div \nng-message=\"required\">{{\'general.field_required\'| translate}}.</div><div ng-message=\"md-maxlength\">\n{{\'general.can_not_be_more_than\'| translate}} {{feature.fixedAssetGroupFeature.valueLength}} {{\'general.characters\'| translate}}.\n</div></div></md-input-container><md-checkbox ng-disabled=\"true\" style=\"margin-top: 0px; margin-bottom: 18px\" \nng-if=\"feature.fixedAssetGroupFeature.dataType === \'BOOLEAN\'\" ng-click=\"vm.toggleBooleanFeatureValue($event, feature)\" \nng-checked=\"vm.isCheckedBooleanFeatureValue(feature)\">{{feature.fixedAssetGroupFeature.fixedAssetFeatureName}}\n</md-checkbox></div><div layout=\"row\"><span flex></span></div></form><div ayout=\"row\" layout-align=\"center center\" \nng-if=\"!(vm.fixedAssetsToUpdate.length > 0)\"><span flex></span> <span class=\"title\">\n{{\'QUOTATION.DETAIL.FEATURES.NOT_FOUND_SEARCH\'| translate}} \"{{vm.filter}}\"</span></div></div><div layout=\"row\" \nlayout-align=\"center center\"><div paging class=\"pageable-div center\" page=\"vm.page\" ul-class=\"pagination\" \npage-size=\"vm.pageSize\" hide-if-empty=\"true\" paging-action=\"vm.fixedAssetToUpdate = vm.fixedAssetsToUpdate[page-1];\" \ntotal=\"vm.fixedAssetsToUpdate.length\"></div></div></div><md-button class=\"md-fab md-fab-bottom-left md-fa\" \naria-label=\"add\" style=\"position: fixed\" ng-click=\"vm.onEdit()\" ng-if=\"!vm.completedFeatures\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon><md-tooltip md-direction=\"top\">{{\'QUOTATION.RETURN\'| translate}}</md-tooltip>\n</md-button></div></div></md-dialog-content></ms-widget-front></ms-widget></md-dialog>");
$templateCache.put("app/main/apps/order/order/merchandiseEntry/merchandiseEntry.html","<md-dialog aria-label=\"Mango (Fruit)\" class=\"row-border hover\" style=\"width: 40%\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>Entradas de Mercancía</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-progress-linear type=\"indeterminate\" ng-show=\"vm.loading\"></md-progress-linear><md-content ms-scroll>\n<div class=\"content fullpage-datatable\" layout=\"column\"><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loading\" \nclass=\"md-accent\"></md-progress-linear><div id=\"masterGridOptionsME\" ag-grid=\"vm.masterGridOptionsME\" class=\"ag-fresh\" \nexpand-grid min=\"260\" other=\"-10\"></div></div></md-content></md-dialog>");
$templateCache.put("app/main/apps/order/order/receiveMerchandiseEntry/receiveMerchandiseEntry.html","<md-dialog class=\"compose-dialog\" aria-label=\"New Message\" ms-scroll><md-toolbar class=\"md-accent md-hue-2\" \nlayout=\"row\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div \nstyle=\"min-width: 400px\"><span translate=\"ORDER.MSG.SURE_SEND\">Entradas de Mercancía A RECIBIR</span></div><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" tranlate \ntranslate-aria-label=\"MAIL.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll flex layout-fill ng-class=\"vm.selectedTab === 0 ? \'md-dialog-list-content\' : \'\'\"><div><div\n layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label translate=\"ORDER.UPLOAD_MERCHANDISE\"></label><div \nng-include=\"\'app/main/apps/files/files.html\'\"></div></md-input-container></div><md-button \nng-disabled=\"vm.filesToUpload.length <= 0 && vm.uploadFiles\" ng-click=\"vm.saveMerchandiseHeader()\" \nclass=\"send-button md-accent md-fab md-fab-bottom-right\" aria-label=\"Send\" ng-disabled=\"vm.loading\" \ntranslate-attr-aria-label=\"CONTRACT.DETAIL.SEND\"><md-icon md-font-icon=\"icon-content-save\"></md-icon></md-button></div>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/main/apps/order/order/shippingOrderView/shippingOrderView.html","<md-dialog aria-label=\"Mango (Fruit)\" class=\"row-border hover\" style=\"width: 40%\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>{{\'ORDER.SHIPPING_ORDER.SHIPPING_ORDERS\' | translate}}</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-progress-linear type=\"indeterminate\" ng-show=\"vm.loading\"></md-progress-linear>\n<md-content ms-scroll><div class=\"content fullpage-datatable\" layout=\"column\"><md-progress-linear \nmd-mode=\"indeterminate\" ng-if=\"vm.loading\" class=\"md-accent\"></md-progress-linear><div id=\"masterGridOptionsSO\" \nag-grid=\"vm.masterGridOptionsSO\" class=\"ag-fresh\" expand-grid min=\"260\" other=\"150\"></div></div></md-content>\n</md-dialog>");
$templateCache.put("app/main/apps/quotation/dialog/quotationDetail-budget/quotationDetail-budget-dialog.html","<md-dialog aria-label=\"Crear-Editar\" style=\"width: 60%; height: 90%\"><ms-widget flippable=\"true\" layout=\"row\" \nstyle=\"padding: 0; height: 100%\"><ms-widget-front class=\"white-bg\" ms-scroll><md-toolbar \nclass=\"md-accent md-tall md-toolbar-more\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{\'QUOTATION.BUDGETS\'| translate }}<strong>\n</strong></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\" aria-label=\"Close\" translate \ntranslate-attr-aria-label=\"general.close\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-progress-linear type=\"indeterminate\" ng-show=\"vm.isShowProgressLinear\"></md-progress-linear><md-dialog-content \nms-scroll style=\"padding: 0px\"><div layout=\"column\" class=\"p-16\" style=\"padding: 0px\"><div id=\"e-commerce-product\" \nclass=\"md-dialog-list-content center p-16\" flex-gt-sm=\"50\" flex=\"100\"><div class=\"content fullpage-datatable\" \nlayout=\"column\" flex><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loading\" class=\"md-accent\">\n</md-progress-linear><div id=\"masterGridOptions\" ag-grid=\"vm.masterGridOptions\" class=\"ag-fresh\" expand-grid min=\"260\" \nother=\"-10\"></div></div></div></div></md-dialog-content></ms-widget-front></ms-widget></md-dialog>");
$templateCache.put("app/main/apps/quotation/create/views/content.html","<form name=\"vm.stepper\" flex ms-horizontal-stepper next-button-description=\"Siguiente\" back-button-description=\"Atras\" \nsubmit-button-description=\"Crear\" ng-submit=\"vm.create()\" ng-model=\"vm.stepper\" ms-scroll novalidate>\n<ms-horizontal-stepper-step ng-form=\"vm.step1\" step=\"1\" step-title=\"\'Proveedor\'\"><div ng-show=\"false\">\n<md-input-container><input type=\"text\" ng-model=\"vm.quotation.provider.name\" name=\"providerName\" required \naria-label=\"quotationProvider\"><div ng-messages=\"vm.step2.providerName.$error\"><div ng-message=\"required\">\n{{\'QUOTATION.CREATE.FIELD_REQUIRED\'| translate}}</div></div></md-input-container></div><div id=\"companyList\" \nclass=\"custom-list\" ms-scroll expand-grid min=\"200\" other=\"235\"><div class=\"search-list\" layout=\"row\" \nlayout-align=\"start center\"><input flex type=\"search\" ng-model=\"vm.searchCompanyInput\" \nplaceholder=\"{{\'QUOTATION.CREATE.SEARCH_COMPANY\'| translate}}\" ng-enter=\"vm.getAllCompanies()\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.getAllCompanies()\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button>\n</div><div ng-if=\"vm.companyArray.length > 0 && !vm.isShowLoaderCompanies\"><div class=\"item\" \nng-repeat=\"company in vm.companyArray\" ng-click=\"vm.toggleCompany($event, company)\"><div layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-radiobox-marked\" \nng-if=\"company.id === vm.quotation.provider.id\"></md-icon><md-icon md-font-icon=\"icon-radiobox-blank\" \nng-if=\"company.id !== vm.quotation.provider.id\"></md-icon><div flex class=\"company-name\">\n{{company.name}} / {{company.businessName}}({{company.email}})</div></div></div></div><div \nng-if=\"vm.companyArray.length === 0 && !vm.isShowLoaderCompanies\" layout=\"column\" layout-align=\"center center\" \nclass=\"message-empty-list\"><div>{{\'QUOTATION.CREATE.COMPANY_LIST_EMPTY\'| translate}}</div></div><div layout=\"column\" \nlayout-align=\"center center\" class=\"loader-content-list\" ng-if=\"vm.isShowLoaderCompanies\"><md-progress-circular \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular><div>\n{{\'QUOTATION.CREATE.LOADING_COMPANIES\'| translate}}...</div></div></div><div layout=\"row\"><div paging \nclass=\"pageable-div center\" page=\"vm.paginationCompanies.pageNumber\" ul-class=\"pagination\" \npage-size=\"vm.paginationCompanies.pageSize\" hide-if-empty=\"true\" paging-action=\"vm.paginationCompanies.getPage(page)\" \ntotal=\"vm.paginationCompanies.totalElements\"></div></div></ms-horizontal-stepper-step><ms-horizontal-stepper-step \nng-form=\"vm.step2\" step=\"2\" step-title=\"\'Moneda y fecha de vigencia\'\"><div layout=\"row\" layout-align=\"center center\">\n<div flex=\"60\"><md-input-container class=\"md-block\"><label>{{\'QUOTATION.CREATE.CURRENCY\'| translate}}</label><md-select\n ng-model=\"vm.quotation.currency\" name=\"currency\" ng-change=\"vm.quotation.exchangeRate = 1\" required><md-option \nng-value=\"currency\" ng-repeat=\"currency in vm.currencyArray\">{{currency.code}} - {{currency.description}}</md-option>\n</md-select><div ng-messages=\"vm.step2.currency.$error\"><div ng-message=\"required\">\n{{\'QUOTATION.CREATE.FIELD_REQUIRED\'| translate}}</div></div></md-input-container></div></div><div layout=\"row\" \nlayout-align=\"center center\"><md-input-container flex=\"60\"><label>{{\'QUOTATION.EXCHANGERATE_INPUT\'| translate}}</label>\n<input ng-disabled=\"vm.quotation.requisition.department.company.currency.id === vm.quotation.currency.id\" \ntype=\"number\" ng-model=\"vm.quotation.exchangeRate\" name=\"exchangeRateInput\"><div \nng-messages=\"vm.step2.exchangeRateInput.$error\"><div ng-message=\"required\">\n{{\'QUOTATION.CREATE.FIELD_REQUIRED\'| translate}}</div></div></md-input-container></div><div layout=\"row\" \nlayout-align=\"center center\"><div><md-input-container flex=\"100\"><label>{{\'QUOTATION.CREATE.EXPIRE_DATE\'| translate}}\n</label><md-datepicker ng-model=\"vm.quotation.expireDate\" name=\"expireDate\" md-min-date=\"vm.minExpireDate\">\n</md-datepicker><div ng-messages=\"step2.expireDate.$error\"><div ng-message=\"required\">\n{{\'QUOTATION.CREATE.FIELD_REQUIRED\'| translate}}</div></div></md-input-container></div></div>\n</ms-horizontal-stepper-step><ms-horizontal-stepper-step ng-form=\"vm.step3\" step=\"3\" step-title=\"\'Detalle\'\"><div \nclass=\"simple-table-container\" id=\"quotationDetail\" min=\"200\" other=\"100\" ms-scroll><table class=\"simple\"><thead><tr>\n<th><md-checkbox step=\"any\" ng-model=\"vm.selectAll\" ng-change=\"vm.selectAllDetailQuotation()\" aria-label=\"rowSelected\">\nSeleccionar Todo</md-checkbox></th><th>{{\'QUOTATION.CREATE.PRODUCT\'| translate}}</th><th>\n{{\'QUOTATION.CREATE.QUANTITY\'| translate}}</th><th>{{\'QUOTATION.CREATE.PRICE\'| translate}}</th><th \nstyle=\"width: 100px; max-width: 100px\"><div>{{\'QUOTATION.CREATE.TAX.TAXES\'| translate}}<md-switch \nng-model=\"vm.taxesIncludedAll\" name=\"taxesIncludedAll\" style=\"margin-top: 0px; margin-bottom: 0px\" \nng-change=\"vm.changeAllTaxesIncluded()\" aria-label=\"quotationtaxesInludedAll\"></md-switch><md-tooltip \nmd-direction=\"bottom\">\n{{(vm.taxesIncludedAll ? \'QUOTATION.CREATE.TAX.INCLUDED\' : \'QUOTATION.CREATE.TAX.NOT_INCLUDED\')| translate}}\n</md-tooltip></div></th><th>{{\'QUOTATION.CREATE.SUBTOTAL\'| translate}}</th><th>\n{{\'QUOTATION.CREATE.HISTORY\'| translate}}</th></tr></thead><tbody><tr \nng-repeat=\"row in vm.quotationDetailArray| filter:vm.localSearch\"><td><md-checkbox ng-model=\"row.selected\" \nng-change=\"vm.detailQuotation(row)\" aria-label=\"rowSelected\"></md-checkbox></td><td><span>\n{{row.requisitionDetail.product.name}}</span></td><td><span>{{row.requisitionDetail.quantity}}</span></td><td \nstyle=\"background-color: rgba(134, 244, 54, 0.37)\"><md-input-container><label>Ingrese precio</label><input \nng-if=\"row.selected\" type=\"number\" required name=\"priceInput{{$index}}\" ng-model=\"row.price\" \nng-keyup=\"vm.calculateSubtotal($event, row)\" min=\"0.0001\" max=\"priceInput{{$index}}+1\" aria-label=\"quotationPrice\">\n</md-input-container></td><td style=\"background-color: rgba(134, 244, 54, 0.37);width: 100px; max-width: 100px\"><div>\n<md-switch ng-if=\"row.selected\" ng-model=\"row.taxesIncluded\" name=\"taxesIncludedSelect{{$index}}\" \nng-change=\"vm.viewTaxeRow(row)\" style=\"margin-top: 0px; margin-bottom: 0px\" aria-label=\"rowTaxesIncluded\"></md-switch>\n<md-tooltip md-direction=\"bottom\">\n{{(row.taxesIncluded ? \'QUOTATION.CREATE.TAX.INCLUDED\' : \'QUOTATION.CREATE.TAX.NOT_INCLUDED\')| translate}}</md-tooltip>\n</div></td><td><span>{{row.subTotal| number:2}}</span></td><td><md-button ng-click=\"vm.showHistory(row)\" \nclass=\"md-icon-button\" title=\"Ver historial de este producto\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button>\n</td></tr><tr><td colspan=\"5\"><span style=\"font-weight: bold\">{{\'QUOTATION.CREATE.TOTAL\'| translate}}</span></td><td>\n<span style=\"font-weight: bold\">{{vm.quotation.total| number:2}}</span><md-input-container style=\"display: none\"><input\n step=\"any\" ng-model=\"vm.totalQuotation\" name=\"quotationTotal\" type=\"number\" required min=\"0.1\" \naria-label=\"totalquotation\"></md-input-container></td><td>-</td></tr></tbody></table></div>\n</ms-horizontal-stepper-step><ms-horizontal-stepper-step ng-form=\"vm.step4\" step=\"4\" step-title=\"\'Adjuntar archivo\'\">\n<div ng-include=\"\'app/main/apps/files/files.html\'\"></div></ms-horizontal-stepper-step></form><div ng-if=\"vm.loading\" \nstyle=\"position: fixed; \nz-index: 1; \npadding-top: 100px; \nleft: 0;\ntop: 0;\nwidth: 100%; \nheight: 100%; \noverflow: auto; \nbackground-color: rgb(0,0,0); \nbackground-color: rgba(0,0,0,0.4)\">\nloading</div>");
$templateCache.put("app/main/apps/quotation/create/views/create.html","<div id=\"create-quotation\" class=\"page-layout carded fullwidth\" layout=\"column\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><md-button class=\"goto-orders-button md-icon-button\" \naria-label=\"Go to orders\" ui-sref=\"app.requisition.Autorizado\" translate \ntranslate-attr-aria-label=\"ORDER.GO_TO_ORDERS\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div \nlayout=\"column\" layout-align=\"start start\"><div class=\"h2\"><span translate=\"QUOTATION.CREATE.CREATE\">Order</span></div>\n</div><span flex></span><div class=\"customer\" layout=\"column\"><span><strong translate=\"QUOTATION.DEPARTMENT\"></strong>\n {{vm.quotation.requisition.department.description}}</span> <span><strong translate=\"QUOTATION.COST_CENTER\"></strong>\n {{vm.quotation.requisition.costCenter.description}}</span> <span><strong translate=\"QUOTATION.CURRENCY\"></strong>\n {{vm.quotation.currency.description| date: \'dd-MM-yyyy\'}}</span></div><span flex></span><div class=\"customer\" \nlayout=\"column\"><span><strong translate=\"QUOTATION.MAX_DATE_DELIVERY\"></strong>\n {{vm.quotation.requisition.maxDatePurchase| date: \'dd-MM-yyyy\'}}</span> <span><strong \ntranslate=\"QUOTATION.EXPIRE_DATE\"></strong> {{vm.quotation.expireDate| date: \'dd-MM-yyyy\'}}</span></div></div></div>\n<div class=\"content-card\" layout=\"column\" flex ng-include=\"\'app/main/apps/quotation/create/views/content.html\'\"></div>\n</div></div>");
$templateCache.put("app/main/apps/quotation/pending-authorize/detail/budgetsTemplate.html","<div layout=\"row\" layout-align=\"start center\" style=\"height: 100%\"><div flex=\"70\"><md-menu-bar \nstyle=\"width: 100%; margin: 0px\"><md-menu md-position-mode=\"left bottom\"><div layout=\"row\" \nng-click=\"$mdOpenMenu($event);\"><div style=\"cursor: pointer\"><span \nng-if=\"data.references.length === undefined || data.references.length === null || data.references.length === 0\">\n{{\'authorize_quotations.select_budgets\'| translate}}... </span><span ng-if=\"data.references.length > 1\">\n{{data.references.length}} {{\'authorize_quotations.selected_budgets\'| translate}}...</span></div><div \nng-if=\"data.references.length === 1\" style=\"min-height: 32px; min-width: 100px; width: 100%; display: block\"><div \nlayout=\"row\" layout-align=\"start center\" ng-repeat=\"reference in data.references\" style=\"height: 38px; float: left\">\n<div flex=\"40\" layout=\"column\"><span>{{\'authorize_quotations.amount\'| translate}}</span> <span>\n{{reference.currencyCode}}. {{reference.amountToUse| number:2}}</span></div><div flex=\"60\" layout=\"column\"><span>\n{{reference.budgetStartDate| date: \'dd/MM/yyyy\'}} - {{reference.budgetEndDate| date: \'dd/MM/yyyy\'}} </span><span>\n{{\'authorize_quotations.type\'| translate}}: {{reference.budgetType}}</span></div></div></div></div><md-menu-content \nwidth=\"3\" style=\"max-height:600px\"><md-menu-item \nstyle=\"height: 54px; line-height: normal; min-width: 325px; min-height: 50px\" \nng-if=\"vm.productBudget[data.requisitionDetail.product.id].length === 0\"><span>\n{{\'authorize_quotations.no_budgets_for_this_product\'| translate}}...</span></md-menu-item><md-menu-item \nstyle=\"height: 54px; line-height: normal; min-width: 325px; min-height: 50px\" \nng-if=\"vm.productBudget[data.requisitionDetail.product.id].length > 0\" \nng-repeat=\"budgetDetail in vm.productBudget[data.requisitionDetail.product.id]\"><div \nstyle=\"cursor: pointer; position: relative; margin: 0px\" md-prevent-menu-close \nng-click=\"toggleSelectBudget(budgetDetail, $event)\" md-ink-ripple layout=\"row\" layout-align=\"start center\"><div \nflex=\"10\" layout=\"column\" layout-align=\"center center\"><md-checkbox ng-checked=\"isSelected(budgetDetail)\" \naria-label=\"{{isSelected(budgetDetail) ? \'Deselect\' : \'Select\'}}\" style=\"margin: 0px\"></md-checkbox></div><div \nflex=\"30\" layout=\"column\"><span>{{\'authorize_quotations.available\'| translate}}</span> <span>\n{{budgetDetail.currencyOfficial.code}}. {{budgetDetail.available| number:2}}</span></div><div flex=\"60\" \nlayout=\"column\"><span>\n{{budgetDetail.budget.startDate| date: \'dd/MM/yyyy\'}} - {{budgetDetail.budget.endDate| date: \'dd/MM/yyyy\'}}</span> \n<span>{{\'authorize_quotations.type\'| translate}}: {{budgetDetail.budget.budgetType.description}}</span></div></div>\n</md-menu-item></md-menu-content></md-menu></md-menu-bar></div><div flex=\"30\"><md-checkbox aria-label=\"need extension\" \nng-change=\"validateRequestAmpliation($event, this)\" ng-model=\"data.requestAmpliation\" \nng-if=\"data.totalCovered < data.subTotal && data.references && data.references.length > 0\">\n{{\'authorize_quotations.request_ampliation\'| translate}}</md-checkbox></div></div>");
$templateCache.put("app/main/apps/quotation/pending-authorize/detail/content.html","");
$templateCache.put("app/main/apps/quotation/pending-authorize/detail/detail.html","<div id=\"quotation-pending-authorize-detail\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div class=\"center\" \nlayout=\"column\" flex><div class=\"header\" layout-xl=\"row\" layout-align-xl=\"space-between center\" layout-lg=\"row\" \nlayout-align-lg=\"space-between center\" layout-xs=\"column\" layout-align-xs=\"none center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button\" title=\"Regresar a la lista de cotizaciones\" \nng-click=\"vm.backToQuotations()\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><div \nlayout=\"column\"><div class=\"title\"><span>\n{{\'authorize_quotations.requisition\'| translate}} {{vm.currentRequisition.requisitionId}}</span></div><div \nlayout=\"row\" class=\"button-tabs\"><md-button ng-click=\"vm.indexView = 0\"><md-icon md-font-icon=\"icon-indent\"></md-icon>\n<span translate=\"REQUISITION.ENCABEZADO\">Detalles</span></md-button><md-button ng-click=\"vm.indexView = 1\"><md-icon \nmd-font-icon=\"icon-cube-unfolded\"></md-icon><span translate=\"REPORT.PROCESS_FLOW.FLOW\">Diagrama</span></md-button>\n</div></div></div><div layout=\"row\" layout-align=\"end center\"><md-button class=\"md-raised md-primary\" \nng-click=\"vm.authorizeQuotation($event)\">{{vm.buttonDescription| translate}}</md-button><md-button \nclass=\"md-raised md-warn\" ng-click=\"vm.cancelRequisition($event)\">Cancelar Compra</md-button><md-button \nclass=\"md-raised md-warn\" ng-click=\"vm.reCotizeQuotation($event)\">Re-cotizar</md-button></div></div><md-card \nng-show=\"vm.indexView === 0\" class=\"content-card\" ms-scroll flex layout=\"column\"><div layout=\"row\" \nclass=\"requisition-info\" layout-align=\"start center\"><div layout=\"column\" class=\"info\"><span><strong \ntranslate=\"QUOTATION.COMPANY\"></strong> {{vm.currentRequisition.companyName}}</span> <span><strong \ntranslate=\"QUOTATION.DEPARTMENT\"></strong> {{vm.currentRequisition.departmentName}}</span></div><div layout=\"column\" \nclass=\"info\"><span><strong translate=\"QUOTATION.COST_CENTER\"></strong> {{vm.currentRequisition.costCenterDescription}}\n</span> <span><strong translate=\"QUOTATION.MAX_DATE_DELIVERY\"></strong>\n {{vm.currentRequisition.maxDatePurchase| date: \'dd-MM-yyyy\'}}</span></div><div layout=\"column\" class=\"info\"><span \nng-if=\"vm.currentRequisition.referenceId && vm.currentRequisition.originType\"><strong \ntranslate=\"QUOTATION.ORIGIN_TICKET\"></strong> <a target=\"_blank\" \nhref=\"{{vm.currentRequisition.originType.queryUrl}}{{vm.currentRequisition.referenceId}}\">\n{{vm.replaceOriginTypedata({id: vm.currentRequisition.requisitionId, referenceId: vm.currentRequisition.referenceId}, vm.currentRequisition.originType.originTypeUrlDescription)}}\n</a></span></div><div layout=\"column\" class=\"info\"><span ng-if=\"vm.currentRequisition.dimensionCompanyDetail3Id>0\">\n<strong>{{vm.dimensionCompanyDetail3.description}}</strong> {{vm.currentRequisition.dimensionCompanyDetail3Name}} \n</span><span ng-if=\"vm.currentRequisition.dimensionCompanyDetail4Id>0\"><strong>\n{{vm.dimensionCompanyDetail4.description}}</strong> {{vm.currentRequisition.dimensionCompanyDetail4Name}} </span><span \nng-if=\"vm.currentRequisition.dimensionCompanyDetail5Id>0\"><strong>{{vm.dimensionCompanyDetail5.description}}</strong>\n {{vm.currentRequisition.dimensionCompanyDetail5Name}}</span></div></div><div flex layout=\"row\"><div \nng-if=\"vm.requisitionArray.length > 1\" flex=\"10\" layout=\"column\" class=\"requisition-list\"><div class=\"title\"><span>\nRequerimiento #</span></div><div ng-click=\"vm.selectRequisition($event, requisition)\" class=\"requisition-number\" \nng-class=\"{\'selected\': vm.currentRequisition.requisitionId === requisition.requisitionId}\" md-ink-ripple \nng-repeat=\"requisition in vm.requisitionArray\">{{requisition.requisitionId}}</div></div><div \nflex=\"{{vm.requisitionArray.length > 1 ? 90 : 100}}\"><div id=\"quotation-grid\" ag-grid=\"vm.gridOptions\" \nclass=\"ag-fresh\" style=\"width: 100%; height: 100%\"></div></div></div></md-card><md-card ng-show=\"vm.indexView === 1\" \nclass=\"content-card flow-requisition\" ms-scroll flex layout=\"column\"><div \nng-include=\"\'app/main/apps/reports/process-flow/process-flow.html\'\"></div></md-card></div></div>");
$templateCache.put("app/main/apps/quotation/pending-authorize/detail/editQuantityTemplate.html","<div layout=\"row\" layout-align=\"end center\"><span ng-if=\"!data.editMode\">{{data.requisitionDetail.quantity}}</span> \n<input id=\"input{{data.id}}\" ng-if=\"data.editMode\" ng-model=\"data.requisitionDetail.quantity\" type=\"number\" flex><div \nstyle=\"width: 16px; height: 16px; margin-left: 5px; cursor: pointer\" ng-if=\"data.editMode\" \nng-click=\"vm.updateQuantity(data, rowNode)\"><md-icon title=\"Guardar\" class=\"s16\" md-font-icon=\"icon-content-save\">\n</md-icon></div><div style=\"width: 16px; height: 16px; margin-left: 5px; cursor: pointer\" \nng-click=\"vm.onEditQuantity(this, data, rowNode)\"><md-icon title=\"Cancelar\" class=\"s16\" md-font-icon=\"icon-close\" \nng-if=\"data.editMode\"></md-icon><md-icon title=\"Editar\" class=\"s16\" md-font-icon=\"icon-border-color\" \nng-if=\"!data.editMode\"></md-icon></div></div>");
$templateCache.put("app/main/apps/quotation/quotation/compose/compose-dialog.html","<md-dialog class=\"compose-dialog\" aria-label=\"New Message\"><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" \ntranslate=\"QUOTATION.DATE_DELIVERY\">New Message</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" tranlate translate-aria-label=\"QUOTATION.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div></md-toolbar><md-progress-linear md-mode=\"indeterminate\" class=\"md-primary\" \nng-if=\"vm.loading\"></md-progress-linear><md-dialog-content ms-scroll><div layout=\"row\" layout-align=\"center center\">\n<div layout=\"column\" layout-gt-xs=\"row\"><md-input-container class=\"flex\"><label translate=\"QUOTATION.DATE_DELIVERY\">\nFecha de Entrega</label><md-datepicker type=\"date\" ng-model=\"vm.dateDelivery\" name=\"dateDelivery\" \nmd-min-date=\"vm.minDate\" md-open-on-focus></md-datepicker><div ng-messages=\"vm.dateDelivery.$error\"><div \nng-message=\"valid\" translate=\"QUOTATION.ERROR.INVALID_DATE\">The entered value is not a date!</div><div \nng-message=\"required\" translate=\"QUOTATION.ERROR.FIELD_REQUIRED\">This date is required!</div><div ng-message=\"mindate\" \ntranslate=\"QUOTATION.ERROR.INVALID_DATE\">Date is too early!</div></div></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container class=\"flex\" ng-if=\"!vm.disabledButton\"><md-button ng-show=\"vm.statusToChange\" \nng-disabled=\"$rootScope.loadingProgress || !vm.dateDelivery || vm.disabledButton\" class=\"md-raised md-primary\" \nng-click=\"vm.createPurchaseOrder(); vm.disabledButton=true\" aria-label=\"change Staus\" translate \ntranslate-attr-aria-label=\"QUOTATION.ORDER_DETAILS\"><span>{{\'QUOTATION.STATUSCHANGE.\' + vm.statusToChange| translate}}\n</span></md-button></md-input-container></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/apps/quotation/quotation/compose/features-dialog.html","<md-dialog aria-label=\"Crear-Editar\" style=\"width: 60%; height: 90%\"><ms-widget flippable=\"true\" layout=\"row\" \nstyle=\"padding: 0; height: 100%\"><ms-widget-front class=\"white-bg\" ms-scroll><md-toolbar \nclass=\"md-accent md-tall md-toolbar-more\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\n{{\'QUOTATION.DETAIL.FEATURES.AGGREGATED_TO\'| translate }} <strong>{{vm.quotationDetail.requisitionDetail.product.name}}\n</strong></span><md-button class=\"md-icon-button\" \nng-click=\"vm.newContact ? (vm.completedFeatures === true ? vm.cancel() : vm.flip()) : vm.cancel()\" aria-label=\"Close\" \ntranslate translate-attr-aria-label=\"general.close\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div><div\n class=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"column\" layout-align=\"center center\"><div \nlayout=\"column\" layout-align=\"center center\"><div><form ng-submit=\"vm.searchFeature()\" name=\"vm.searchForm\"><div \nclass=\"md-toolbar-tools\"><md-input-container flex style=\"margin-top: 60px\"><label translate=\"QUOTATION.FILTER\">Filtro\n</label><input type=\"text\" ng-model=\"vm.filter\" name=\"search\" id=\"searchFilter\" ng-keyup=\"vm.searchFeature()\">\n</md-input-container><md-button type=\"submit\" aria-label=\"Search\"><span translate=\"QUOTATION.SEARCH\">Search</span>\n</md-button></div></form></div></div></div></md-toolbar><md-progress-linear type=\"indeterminate\" \nng-show=\"vm.isShowProgressLinear\"></md-progress-linear><md-dialog-content ms-scroll style=\"padding: 0px\"><div \nlayout=\"column\" class=\"p-16\" style=\"padding: 0px\"><div id=\"e-commerce-product\" \nclass=\"md-dialog-list-content center p-16\" flex-gt-sm=\"50\" flex=\"100\"><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\" ng-show=\"!vm.loading\"><div \nclass=\"content thread-list\" ms-scroll><form name=\"vm.featuresUpdateForm\" id=\"featuresUpdateForm\" \nng-submit=\"vm.save(false)\" ng-if=\"vm.fixedAssetsToUpdate.length > 0\"><br><div \nng-repeat=\"feature in vm.fixedAssetToUpdate.features\"><md-input-container style=\"margin: 5px 0\" class=\"md-block\" \nng-if=\"feature.fixedAssetGroupFeature.dataType === \'TEXT\'\"><input type=\"text\" \nplaceholder=\"{{feature.fixedAssetGroupFeature.fixedAssetFeatureName}}\" \nname=\"input{{feature.fixedAssetGroupFeature.id}}\" required md-no-asterisk \nmd-maxlength=\"{{feature.fixedAssetGroupFeature.valueLength}}\" ng-model=\"feature.featureValue\"><div \nng-messages=\"vm.step4[\'input\' + feature.fixedAssetGroupFeature.id].$error\"><div ng-message=\"required\">\n{{\'general.field_required\'| translate}}.</div><div ng-message=\"md-maxlength\">\n{{\'general.can_not_be_more_than\'| translate}} {{feature.fixedAssetGroupFeature.valueLength}} {{\'general.characters\'| translate}}.\n</div></div></md-input-container><md-input-container style=\"margin: 5px 0\" class=\"md-block\" \nng-if=\"feature.fixedAssetGroupFeature.dataType === \'NUMBER\'\"><input type=\"text\" \nplaceholder=\"{{feature.fixedAssetGroupFeature.fixedAssetFeatureName}}\" \nname=\"input{{feature.fixedAssetGroupFeature.id}}\" required md-no-asterisk ng-model=\"feature.featureValue\" numbers-only>\n<div ng-messages=\"vm.step4[\'input\' + feature.fixedAssetGroupFeature.id].$error\"><div ng-message=\"required\">\n{{\'general.field_required\'| translate}}.</div><div ng-message=\"md-maxlength\">\n{{\'general.can_not_be_more_than\'| translate}} {{feature.fixedAssetGroupFeature.valueLength}} {{\'general.characters\'| translate}}.\n</div></div></md-input-container><md-input-container style=\"margin: 5px 0\" class=\"md-block\" \nng-if=\"feature.fixedAssetGroupFeature.dataType === \'DECIMAL\'\"><input type=\"text\" \nplaceholder=\"{{feature.fixedAssetGroupFeature.fixedAssetFeatureName}}\" \nname=\"input{{feature.fixedAssetGroupFeature.id}}\" required md-no-asterisk ng-model=\"feature.featureValue\" \ndecimals-only><div ng-messages=\"vm.step4[\'input\' + feature.fixedAssetGroupFeature.id].$error\"><div \nng-message=\"required\">{{\'general.field_required\'| translate}}.</div><div ng-message=\"md-maxlength\">\n{{\'general.can_not_be_more_than\'| translate}} {{feature.fixedAssetGroupFeature.valueLength}} {{\'general.characters\'| translate}}.\n</div></div></md-input-container><md-checkbox style=\"margin-top: 0px; margin-bottom: 18px\" \nng-if=\"feature.fixedAssetGroupFeature.dataType === \'BOOLEAN\'\" ng-click=\"vm.toggleBooleanFeatureValue($event, feature)\" \nng-checked=\"vm.isCheckedBooleanFeatureValue(feature)\">{{feature.fixedAssetGroupFeature.fixedAssetFeatureName}}\n</md-checkbox></div><div layout=\"row\"><span flex></span><md-button type=\"submit\">{{\'QUOTATION.UPDATE\'| translate}}\n</md-button></div></form><center ng-if=\"!(vm.fixedAssetsToUpdate.length > 0)\"><span flex></span> <span class=\"title\">\n{{\'QUOTATION.DETAIL.FEATURES.NOT_FOUND_SEARCH\'| translate}} \"{{vm.filter}}\"</span></center></div><div layout=\"row\" \nlayout-align=\"center center\"><div paging class=\"pageable-div center\" page=\"vm.page\" ul-class=\"pagination\" \npage-size=\"vm.pageSize\" hide-if-empty=\"true\" paging-action=\"vm.fixedAssetToUpdate = vm.fixedAssetsToUpdate[page-1];\" \ntotal=\"vm.fixedAssetsToUpdate.length\"></div></div></div><md-button class=\"md-fab md-fab-bottom-left md-fa\" \naria-label=\"add\" style=\"position: fixed\" ng-click=\"vm.onEdit()\" ng-if=\"!vm.completedFeatures\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon><md-tooltip md-direction=\"top\">{{\'QUOTATION.RETURN\'| translate}}</md-tooltip>\n</md-button></div></div></md-dialog-content></ms-widget-front><ms-widget-back id=\"perms\" class=\"white-bg\" ms-scroll>\n<div ng-init=\"vm.flipping(flipWidget);\"></div><div class=\"page-layout carded fullwidth\" layout=\"column\"><md-toolbar \nclass=\"md-accent md-tall md-toolbar-more\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{\'QUOTATION.DETAIL.FEATURES.ADD_TO\'| translate}} \n<strong>{{vm.quotationDetail.requisitionDetail.product.name}}</strong></span><md-button class=\"md-icon-button\" \nng-click=\"vm.cancel()\" aria-label=\"Close\" translate translate-attr-aria-label=\"general.close\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div><div class=\"md-toolbar-tools md-toolbar-tools-middle\" \nlayout=\"row\" layout-align=\"space-between center\"><span flex class=\"title\" style=\"font-size: 12pt; text-align: center\">\n<strong>{{(\'QUOTATION.DETAIL.FEATURES.QUANTITY_PRODUCT\'| translate) + \": \"}}</strong>\n {{vm.quotationDetail.requisitionDetail.quantity}}</span> <span flex class=\"title\" \nstyle=\"font-size: 12pt; text-align: center\"><strong>{{(\'QUOTATION.DETAIL.FEATURES.QUANTITY_ADDED\'| translate) + \": \"}}\n</strong> {{vm.fixedAssets.length}}</span> <span flex class=\"title\" style=\"font-size: 12pt; text-align: center\">\n<strong>{{(\'QUOTATION.DETAIL.FEATURES.PENDINGS\'| translate)+ \": \" }}</strong>\n{{(vm.quotationDetail.requisitionDetail.quantity - vm.fixedAssets.length)}}</span></div></md-toolbar><div \nclass=\"center\" layout=\"column\" flex><div class=\"md-dialog-content\" ms-scroll><form name=\"vm.featuresForm\" \nid=\"featuresForm\" ng-submit=\"vm.save(true)\" ng-if=\"!vm.completedFeatures\"><div \nng-repeat=\"feature in vm.fixedAsset.features\"><md-input-container style=\"margin: 5px 0\" class=\"md-block\" \nng-if=\"feature.fixedAssetGroupFeature.dataType === \'TEXT\'\"><input type=\"text\" \nplaceholder=\"{{feature.fixedAssetGroupFeature.fixedAssetFeatureName}}\" \nname=\"input{{feature.fixedAssetGroupFeature.id}}\" required md-no-asterisk \nmd-maxlength=\"{{feature.fixedAssetGroupFeature.valueLength}}\" ng-model=\"feature.featureValue\"><div \nng-messages=\"vm.step4[\'input\' + feature.fixedAssetGroupFeature.id].$error\"><div ng-message=\"required\">\n{{\'general.field_required\'| translate}}.</div><div ng-message=\"md-maxlength\">\n{{\'general.can_not_be_more_than\'| translate}} {{feature.fixedAssetGroupFeature.valueLength}} {{\'general.characters\'| translate}}.\n</div></div></md-input-container><md-input-container style=\"margin: 5px 0\" class=\"md-block\" \nng-if=\"feature.fixedAssetGroupFeature.dataType === \'NUMBER\'\"><input type=\"text\" \nplaceholder=\"{{feature.fixedAssetGroupFeature.fixedAssetFeatureName}}\" \nname=\"input{{feature.fixedAssetGroupFeature.id}}\" required md-no-asterisk ng-model=\"feature.featureValue\" numbers-only>\n<div ng-messages=\"vm.step4[\'input\' + feature.fixedAssetGroupFeature.id].$error\"><div ng-message=\"required\">\n{{\'general.field_required\'| translate}}.</div><div ng-message=\"md-maxlength\">\n{{\'general.can_not_be_more_than\'| translate}} {{feature.fixedAssetGroupFeature.valueLength}} {{\'general.characters\'| translate}}.\n</div></div></md-input-container><md-input-container style=\"margin: 5px 0\" class=\"md-block\" \nng-if=\"feature.fixedAssetGroupFeature.dataType === \'DECIMAL\'\"><input type=\"text\" \nplaceholder=\"{{feature.fixedAssetGroupFeature.fixedAssetFeatureName}}\" \nname=\"input{{feature.fixedAssetGroupFeature.id}}\" required md-no-asterisk ng-model=\"feature.featureValue\" \ndecimals-only><div ng-messages=\"vm.step4[\'input\' + feature.fixedAssetGroupFeature.id].$error\"><div \nng-message=\"required\">{{\'general.field_required\'| translate}}.</div><div ng-message=\"md-maxlength\">\n{{\'general.can_not_be_more_than\'| translate}} {{feature.fixedAssetGroupFeature.valueLength}} {{\'general.characters\'| translate}}.\n</div></div></md-input-container><md-checkbox style=\"margin-top: 0px; margin-bottom: 18px\" \nng-if=\"feature.fixedAssetGroupFeature.dataType === \'BOOLEAN\'\" ng-click=\"vm.toggleBooleanFeatureValue($event, feature)\" \nng-checked=\"vm.isCheckedBooleanFeatureValue(feature)\">{{feature.fixedAssetGroupFeature.fixedAssetFeatureName}}\n</md-checkbox></div><div layout=\"row\"><span flex></span><md-button ng-click=\"vm.cancel()\">\n{{\'QUOTATION.CANCEL\'| translate}}</md-button><md-button type=\"submit\">{{\'QUOTATION.SAVE\'| translate}}</md-button></div>\n</form><md-button class=\"md-fab md-fab-bottom-right md-fa\" aria-label=\"add\" style=\"position: fixed\" \nng-click=\"vm.onEdit()\" ng-if=\"vm.fixedAssets.length > 0\"><md-icon md-font-icon=\"icon-eye\"></md-icon><md-tooltip \nmd-direction=\"top\">{{\'QUOTATION.DETAIL.FEATURES.VIEW_AGGREGATED\'| translate}}</md-tooltip></md-button></div></div>\n</div></ms-widget-back></ms-widget></md-dialog>");
$templateCache.put("app/main/apps/quotation/quotation/compose/features-dialogView.html","<md-dialog aria-label=\"Crear-Editar\" style=\"width: 60%; height: 90%\"><ms-widget flippable=\"true\" layout=\"row\" \nstyle=\"padding: 0; height: 100%\"><ms-widget-front class=\"white-bg\" ms-scroll><md-toolbar \nclass=\"md-accent md-tall md-toolbar-more\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\n{{\'QUOTATION.DETAIL.FEATURES.AGGREGATED_TO\'| translate }} <strong>{{vm.quotationDetail.requisitionDetail.product.name}}\n</strong></span><md-button class=\"md-icon-button\" \nng-click=\"vm.newContact ? (vm.completedFeatures === true ? vm.cancel() : vm.flip()) : vm.cancel()\" aria-label=\"Close\" \ntranslate translate-attr-aria-label=\"general.close\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div><div\n class=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"column\" layout-align=\"center center\"><div \nlayout=\"column\" layout-align=\"center center\"><div><form ng-submit=\"vm.searchFeature()\" name=\"vm.searchForm\"><div \nclass=\"md-toolbar-tools\"><md-input-container flex style=\"margin-top: 60px\"><label translate=\"QUOTATION.FILTER\">Filtro\n</label><input type=\"text\" ng-model=\"vm.filter\" name=\"search\" id=\"searchFilter\" ng-keyup=\"vm.searchFeature()\">\n</md-input-container><md-button type=\"submit\" aria-label=\"Search\"><span translate=\"QUOTATION.SEARCH\">Search</span>\n</md-button></div></form></div></div></div></md-toolbar><md-progress-linear type=\"indeterminate\" \nng-show=\"vm.isShowProgressLinear\"></md-progress-linear><md-dialog-content ms-scroll style=\"padding: 0px\"><div \nlayout=\"column\" class=\"p-16\" style=\"padding: 0px\"><div id=\"e-commerce-product\" \nclass=\"md-dialog-list-content center p-16\" flex-gt-sm=\"50\" flex=\"100\"><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\" ng-show=\"!vm.loading\"><div \nclass=\"content thread-list\" ms-scroll><form name=\"vm.featuresUpdateForm\" id=\"featuresUpdateForm\" \nng-submit=\"vm.save(false)\" ng-if=\"vm.fixedAssetsToUpdate.length > 0\"><br><div \nng-repeat=\"feature in vm.fixedAssetToUpdate.features\"><md-input-container style=\"margin: 5px 0\" class=\"md-block\" \nng-if=\"feature.fixedAssetGroupFeature.dataType === \'TEXT\'\"><input ng-disabled=\"true\" type=\"text\" \nplaceholder=\"{{feature.fixedAssetGroupFeature.fixedAssetFeatureName}}\" \nname=\"input{{feature.fixedAssetGroupFeature.id}}\" required md-no-asterisk \nmd-maxlength=\"{{feature.fixedAssetGroupFeature.valueLength}}\" ng-model=\"feature.featureValue\"><div \nng-messages=\"vm.step4[\'input\' + feature.fixedAssetGroupFeature.id].$error\"><div ng-message=\"required\">\n{{\'general.field_required\'| translate}}.</div><div ng-message=\"md-maxlength\">\n{{\'general.can_not_be_more_than\'| translate}} {{feature.fixedAssetGroupFeature.valueLength}} {{\'general.characters\'| translate}}.\n</div></div></md-input-container><md-input-container style=\"margin: 5px 0\" class=\"md-block\" \nng-if=\"feature.fixedAssetGroupFeature.dataType === \'NUMBER\'\"><input ng-disabled=\"true\" type=\"text\" \nplaceholder=\"{{feature.fixedAssetGroupFeature.fixedAssetFeatureName}}\" \nname=\"input{{feature.fixedAssetGroupFeature.id}}\" required md-no-asterisk ng-model=\"feature.featureValue\" numbers-only>\n<div ng-messages=\"vm.step4[\'input\' + feature.fixedAssetGroupFeature.id].$error\"><div ng-message=\"required\">\n{{\'general.field_required\'| translate}}.</div><div ng-message=\"md-maxlength\">\n{{\'general.can_not_be_more_than\'| translate}} {{feature.fixedAssetGroupFeature.valueLength}} {{\'general.characters\'| translate}}.\n</div></div></md-input-container><md-input-container style=\"margin: 5px 0\" class=\"md-block\" \nng-if=\"feature.fixedAssetGroupFeature.dataType === \'DECIMAL\'\"><input ng-disabled=\"true\" type=\"text\" \nplaceholder=\"{{feature.fixedAssetGroupFeature.fixedAssetFeatureName}}\" \nname=\"input{{feature.fixedAssetGroupFeature.id}}\" required md-no-asterisk ng-model=\"feature.featureValue\" \ndecimals-only><div ng-messages=\"vm.step4[\'input\' + feature.fixedAssetGroupFeature.id].$error\"><div \nng-message=\"required\">{{\'general.field_required\'| translate}}.</div><div ng-message=\"md-maxlength\">\n{{\'general.can_not_be_more_than\'| translate}} {{feature.fixedAssetGroupFeature.valueLength}} {{\'general.characters\'| translate}}.\n</div></div></md-input-container><md-checkbox ng-disabled=\"true\" style=\"margin-top: 0px; margin-bottom: 18px\" \nng-if=\"feature.fixedAssetGroupFeature.dataType === \'BOOLEAN\'\" ng-click=\"vm.toggleBooleanFeatureValue($event, feature)\" \nng-checked=\"vm.isCheckedBooleanFeatureValue(feature)\">{{feature.fixedAssetGroupFeature.fixedAssetFeatureName}}\n</md-checkbox></div><div layout=\"row\"><span flex></span></div></form><div layout=\"row\" layout-align=\"center center\" \nng-if=\"!(vm.fixedAssetsToUpdate.length > 0)\"><span flex></span> <span class=\"title\">\n{{\'QUOTATION.DETAIL.FEATURES.NOT_FOUND_SEARCH\'| translate}} \"{{vm.filter}}\"</span></div></div><div layout=\"row\" \nlayout-align=\"center center\"><div paging class=\"pageable-div center\" page=\"vm.page\" ul-class=\"pagination\" \npage-size=\"vm.pageSize\" hide-if-empty=\"true\" paging-action=\"vm.fixedAssetToUpdate = vm.fixedAssetsToUpdate[page-1];\" \ntotal=\"vm.fixedAssetsToUpdate.length\"></div></div></div><md-button class=\"md-fab md-fab-bottom-left md-fa\" \naria-label=\"add\" style=\"position: fixed\" ng-click=\"vm.onEdit()\" ng-if=\"!vm.completedFeatures\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon><md-tooltip md-direction=\"top\">{{\'QUOTATION.RETURN\'| translate}}</md-tooltip>\n</md-button></div></div></md-dialog-content></ms-widget-front></ms-widget></md-dialog>");
$templateCache.put("app/main/apps/quotation/pending-authorize-ticket/detail/budgetsTemplate.html","<div layout=\"row\" layout-align=\"start center\" style=\"height: 100%\"><div flex=\"70\"><md-menu-bar \nstyle=\"width: 100%; margin: 0px\"><md-menu md-position-mode=\"left bottom\"><div layout=\"row\" \nng-click=\"$mdOpenMenu($event);\"><div style=\"cursor: pointer\"><span \nng-if=\"data.references.length === undefined || data.references.length === null || data.references.length === 0\">\n{{\'authorize_quotations.select_budgets\'| translate}}... </span><span ng-if=\"data.references.length > 1\">\n{{data.references.length}} {{\'authorize_quotations.selected_budgets\'| translate}}...</span></div><div \nng-if=\"data.references.length === 1\" style=\"min-height: 32px; min-width: 100px; width: 100%; display: block\"><div \nlayout=\"row\" layout-align=\"start center\" ng-repeat=\"reference in data.references\" style=\"height: 38px; float: left\">\n<div flex=\"40\" layout=\"column\"><span>{{\'authorize_quotations.amount\'| translate}}</span> <span>\n{{reference.currencyCode}}. {{reference.amountToUse| number:2}}</span></div><div flex=\"60\" layout=\"column\"><span>\n{{reference.budgetStartDate| date: \'dd/MM/yyyy\'}} - {{reference.budgetEndDate| date: \'dd/MM/yyyy\'}} </span><span>\n{{\'authorize_quotations.type\'| translate}}: {{reference.budgetType}}</span></div></div></div></div><md-menu-content \nwidth=\"3\" style=\"max-height:600px\"><md-menu-item \nstyle=\"height: 54px; line-height: normal; min-width: 325px; min-height: 50px\" \nng-if=\"vm.productBudget[data.requisitionDetail.product.id].length === 0\"><span>\n{{\'authorize_quotations.no_budgets_for_this_product\'| translate}}...</span></md-menu-item><md-menu-item \nstyle=\"height: 54px; line-height: normal; min-width: 325px; min-height: 50px\" \nng-if=\"vm.productBudget[data.requisitionDetail.product.id].length > 0\" \nng-repeat=\"budgetDetail in vm.productBudget[data.requisitionDetail.product.id]\"><div \nstyle=\"cursor: pointer; position: relative; margin: 0px\" md-prevent-menu-close \nng-click=\"toggleSelectBudget(budgetDetail, $event)\" md-ink-ripple layout=\"row\" layout-align=\"start center\"><div \nflex=\"10\" layout=\"column\" layout-align=\"center center\"><md-checkbox ng-checked=\"isSelected(budgetDetail)\" \naria-label=\"{{isSelected(budgetDetail) ? \'Deselect\' : \'Select\'}}\" style=\"margin: 0px\"></md-checkbox></div><div \nflex=\"30\" layout=\"column\"><span>{{\'authorize_quotations.available\'| translate}}</span> <span>\n{{budgetDetail.currencyOfficial.code}}. {{budgetDetail.available| number:2}}</span></div><div flex=\"60\" \nlayout=\"column\"><span>\n{{budgetDetail.budget.startDate| date: \'dd/MM/yyyy\'}} - {{budgetDetail.budget.endDate| date: \'dd/MM/yyyy\'}}</span> \n<span>{{\'authorize_quotations.type\'| translate}}: {{budgetDetail.budget.budgetType.description}}</span></div></div>\n</md-menu-item></md-menu-content></md-menu></md-menu-bar></div><div flex=\"30\"><md-checkbox aria-label=\"need extension\" \nng-change=\"validateRequestAmpliation($event, this)\" ng-model=\"data.requestAmpliation\" \nng-if=\"data.totalCovered < data.subTotal && data.references && data.references.length > 0\">\n{{\'authorize_quotations.request_ampliation\'| translate}}</md-checkbox></div></div>");
$templateCache.put("app/main/apps/quotation/pending-authorize-ticket/detail/content.html","");
$templateCache.put("app/main/apps/quotation/pending-authorize-ticket/detail/detail.html","<div id=\"quotation-pending-authorize-detail\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div class=\"center\" \nlayout=\"column\" flex><div class=\"header\" layout-xl=\"row\" layout-align-xl=\"space-between center\" layout-lg=\"row\" \nlayout-align-lg=\"space-between center\" layout-xs=\"column\" layout-align-xs=\"none center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button\" title=\"Regresar a la lista de cotizaciones\" \nng-click=\"vm.backToQuotations()\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><div \nlayout=\"column\"><div class=\"title\"><span>\n{{\'authorize_quotations.requisition\'| translate}} {{vm.currentRequisition.requisitionId}}</span></div><div \nlayout=\"row\" class=\"button-tabs\"><md-button ng-click=\"vm.indexView = 0\"><md-icon md-font-icon=\"icon-indent\"></md-icon>\n<span translate=\"REQUISITION.ENCABEZADO\">Detalles</span></md-button><md-button ng-click=\"vm.indexView = 1\"><md-icon \nmd-font-icon=\"icon-cube-unfolded\"></md-icon><span translate=\"REPORT.PROCESS_FLOW.FLOW\">Diagrama</span></md-button>\n</div></div></div><div layout=\"row\" layout-align=\"end center\"><md-button class=\"md-raised md-primary\" \nng-click=\"vm.authorizeQuotation($event)\">{{vm.buttonDescription| translate}}</md-button><md-button \nclass=\"md-raised md-warn\" ng-click=\"vm.cancelRequisition($event)\">Cancelar Compra</md-button><md-button \nclass=\"md-raised md-warn\" ng-click=\"vm.reCotizeQuotation($event)\">Re-cotizar</md-button></div></div><md-card \nng-show=\"vm.indexView === 0\" class=\"content-card\" ms-scroll flex layout=\"column\"><div layout=\"row\" \nclass=\"requisition-info\" layout-align=\"start center\"><div layout=\"column\" class=\"info\"><span><strong \ntranslate=\"QUOTATION.COMPANY\"></strong> {{vm.currentRequisition.companyName}}</span> <span><strong \ntranslate=\"QUOTATION.DEPARTMENT\"></strong> {{vm.currentRequisition.departmentName}}</span></div><div layout=\"column\" \nclass=\"info\"><span><strong translate=\"QUOTATION.COST_CENTER\"></strong> {{vm.currentRequisition.costCenterDescription}}\n</span> <span><strong translate=\"QUOTATION.MAX_DATE_DELIVERY\"></strong>\n {{vm.currentRequisition.maxDatePurchase| date: \'dd-MM-yyyy\'}}</span></div><div layout=\"column\" class=\"info\"><span \nng-if=\"vm.currentRequisition.referenceId && vm.currentRequisition.originType\"><strong \ntranslate=\"QUOTATION.ORIGIN_TICKET\"></strong> <a target=\"_blank\" \nhref=\"{{vm.currentRequisition.originType.queryUrl}}{{vm.currentRequisition.referenceId}}\">\n{{vm.replaceOriginTypedata({id: vm.currentRequisition.requisitionId, referenceId: vm.currentRequisition.referenceId}, vm.currentRequisition.originType.originTypeUrlDescription)}}\n</a></span></div><div layout=\"column\" class=\"info\"><span ng-if=\"vm.currentRequisition.dimensionCompanyDetail3Id>0\">\n<strong>{{vm.dimensionCompanyDetail3.description}}</strong> {{vm.currentRequisition.dimensionCompanyDetail3Name}} \n</span><span ng-if=\"vm.currentRequisition.dimensionCompanyDetail4Id>0\"><strong>\n{{vm.dimensionCompanyDetail4.description}}</strong> {{vm.currentRequisition.dimensionCompanyDetail4Name}} </span><span \nng-if=\"vm.currentRequisition.dimensionCompanyDetail5Id>0\"><strong>{{vm.dimensionCompanyDetail5.description}}</strong>\n {{vm.currentRequisition.dimensionCompanyDetail5Name}}</span></div></div><div flex layout=\"row\"><div \nng-if=\"vm.requisitionArray.length > 1\" flex=\"10\" layout=\"column\" class=\"requisition-list\"><div class=\"title\"><span>\nRequerimiento #</span></div><div ng-click=\"vm.selectRequisition($event, requisition)\" class=\"requisition-number\" \nng-class=\"{\'selected\': vm.currentRequisition.requisitionId === requisition.requisitionId}\" md-ink-ripple \nng-repeat=\"requisition in vm.requisitionArray\">{{requisition.requisitionId}}</div></div><div \nflex=\"{{vm.requisitionArray.length > 1 ? 90 : 100}}\"><div id=\"quotation-grid\" ag-grid=\"vm.gridOptions\" \nclass=\"ag-fresh\" style=\"width: 100%; height: 100%\"></div></div></div></md-card><md-card ng-show=\"vm.indexView === 1\" \nclass=\"content-card flow-requisition\" ms-scroll flex layout=\"column\"><div \nng-include=\"\'app/main/apps/reports/process-flow/process-flow.html\'\"></div></md-card></div></div>");
$templateCache.put("app/main/apps/quotation/pending-authorize-ticket/detail/editQuantityTemplate.html","<div layout=\"row\" layout-align=\"end center\"><span ng-if=\"!data.editMode\">{{data.requisitionDetail.quantity}}</span> \n<input id=\"input{{data.id}}\" ng-if=\"data.editMode\" ng-model=\"data.requisitionDetail.quantity\" type=\"number\" flex><div \nstyle=\"width: 16px; height: 16px; margin-left: 5px; cursor: pointer\" ng-if=\"data.editMode\" \nng-click=\"vm.updateQuantity(data, rowNode)\"><md-icon title=\"Guardar\" class=\"s16\" md-font-icon=\"icon-content-save\">\n</md-icon></div><div style=\"width: 16px; height: 16px; margin-left: 5px; cursor: pointer\" \nng-click=\"vm.onEditQuantity(this, data, rowNode)\"><md-icon title=\"Cancelar\" class=\"s16\" md-font-icon=\"icon-close\" \nng-if=\"data.editMode\"></md-icon><md-icon title=\"Editar\" class=\"s16\" md-font-icon=\"icon-border-color\" \nng-if=\"!data.editMode\"></md-icon></div></div>");
$templateCache.put("app/main/apps/reports/dialogs/dialog-companies/dialog-companies.html","<md-dialog class=\"dialog-companies\" aria-label=\"detail of transaction\"><div layout=\"row\" class=\"tools-dialog\"><div \nflex=\"50\" layout=\"row\" layout-align=\"start center\"><h2>{{\'REPORT.SEARCH_\'+vm.type | translate}}</h2></div><div \nflex=\"50\" layout=\"row\" layout-align=\"end center\"><md-button aria-label=\"button close\" class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div></div>\n<md-content class=\"content-company\" flex><div id=\"companyList\" class=\"custom-list-company\" ms-scroll expand-grid \nmin=\"200\" other=\"139\"><div class=\"search-list\" layout=\"row\" layout-align=\"start center\"><input flex type=\"search\" \nng-model=\"vm.searchCompanyInput\" placeholder=\"{{\'QUOTATION.CREATE.SEARCH_COMPANY\'| translate}}\" \nng-keydown=\"vm.getAllCompanies($event)\"><md-button class=\"md-icon-button\" ng-click=\"vm.getAllCompanies()\"><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon></md-button></div><div \nng-if=\"vm.companyArray.length > 0 && !vm.isShowLoaderCompanies\"><div class=\"item-company\" \nng-repeat=\"company in vm.companyArray | filter: vm.searchCompanyInput\"><div layout=\"row\" layout-align=\"start center\" \nng-click=\"vm.selectCompany(company)\"><div flex class=\"company-name\">\n{{company.name}} / {{company.businessName}}({{company.email}})</div><md-icon ng-if=\"company.selected\" \nmd-font-icon=\"icon-check-all\"></md-icon></div></div></div><div \nng-if=\"vm.companyArray.length === 0 && !vm.isShowLoaderCompanies\" layout=\"column\" layout-align=\"center center\" \nclass=\"message-empty-list\"><div>{{\'REPORT.LIST_EMPTY_\'+vm.type| translate}}</div></div><div layout=\"column\" \nlayout-align=\"center center\" class=\"loader-content-list\" ng-if=\"vm.isShowLoaderCompanies\"><md-progress-circular \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular><div>\n{{\'REPORT.LOADING_\'+vm.type| translate}}...</div></div></div><div layout=\"row\" layout-align=\"center center\"><div \npaging class=\"pageable-div center\" page=\"vm.paginationCompanies.pageNumber\" ul-class=\"pagination\" \npage-size=\"vm.paginationCompanies.pageSize\" hide-if-empty=\"true\" paging-action=\"vm.paginationCompanies.getPage(page)\" \ntotal=\"vm.paginationCompanies.totalElements\"></div></div></md-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><md-button ng-click=\"vm.closeDialog()\" \nclass=\"send-button md-fab-bottom-right md-primary\" aria-label=\"Send\" \ntranslate-attr-aria-label=\"REQUISITION.DETAIL.SEND\"><span>Cerrar</span><md-tooltip md-direction=\"left\">\n{{\"general.cancel\"| translate}}</md-tooltip></md-button><md-button ng-click=\"vm.save()\" \nclass=\"send-button md-fab-bottom-right md-primary\" aria-label=\"Send\" \ntranslate-attr-aria-label=\"REQUISITION.DETAIL.SEND\"><span>Guardar</span><md-tooltip md-direction=\"left\">\n{{\"general.save\"| translate}}</md-tooltip></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/reports/dialogs/dialog-products/dialog-products.html","<md-dialog class=\"productt-dialog\" aria-label=\"detail of transaction\"><div layout=\"row\" class=\"tools-dialog\"><div \nflex=\"50\" layout=\"row\" layout-align=\"start center\"><h2>{{\'REPORT.SEARCH_PRODUCTS\' | translate}}</h2></div><div \nflex=\"50\" layout=\"row\" layout-align=\"end center\"><md-button aria-label=\"button close\" class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div></div>\n<md-content class=\"content\" flex ms-scroll><div id=\"productList\" class=\"custom-list-product\" ms-scroll expand-grid \nmin=\"200\" other=\"235\"><div class=\"search-list\" layout=\"row\" layout-align=\"start center\"><input flex type=\"search\" \nng-model=\"vm.searchProductInput\" ng-disabled=\"vm.disableFilter\" placeholder=\"{{\'REPORT.SEARCH_PRODUCTS\'| translate}}\" \nng-enter=\"vm.getAllProducts()\"><md-button class=\"md-icon-button\" ng-click=\"vm.getAllProducts()\"><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon></md-button></div><div \nng-if=\"vm.products.length > 0 && !vm.isShowLoaderProducts\"><div class=\"item-product\" \nng-repeat=\"product in vm.products\"><div layout=\"row\" layout-align=\"start center\" ng-click=\"vm.selectProduct(product)\">\n<div flex class=\"product-name\">{{product.name}} / {{product.productCode}}({{product.measurementUnit.name}})</div>\n<md-icon ng-if=\"product.selected\" md-font-icon=\"icon-check-all\"></md-icon></div></div></div><div \nng-if=\"vm.products.length === 0 && !vm.isShowLoaderProducts\" layout=\"column\" layout-align=\"center center\" \nclass=\"message-empty-list\"><div>{{\'REPORT.PRODUCTS_LIST_EMPTY\'| translate}}</div></div><div layout=\"column\" \nlayout-align=\"center center\" class=\"loader-content-list\" ng-if=\"vm.isShowLoaderProducts\"><md-progress-circular \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular><div>\n{{\'REPORT.LOADING_PRODUCTS\'| translate}}...</div></div></div><div layout=\"row\" layout-align=\"center center\"><div \npaging class=\"pageable-div center\" page=\"vm.paginationProducts.pageNumber\" ul-class=\"pagination\" \npage-size=\"vm.paginationProducts.pageSize\" hide-if-empty=\"true\" paging-action=\"vm.paginationProducts.getPage(page)\" \ntotal=\"vm.paginationProducts.totalElements\"></div></div></md-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><md-button ng-click=\"vm.closeDialog()\" \nclass=\"send-button md-fab-bottom-right md-primary\" aria-label=\"Send\" ng-disabled=\"vm.arraySelected.length===0\" \ntranslate-attr-aria-label=\"REQUISITION.DETAIL.SEND\"><span>Cerrar</span><md-tooltip md-direction=\"left\">\n{{\"general.cancel\"| translate}}</md-tooltip></md-button><md-button ng-click=\"vm.save()\" \nclass=\"send-button md-fab-bottom-right md-primary\" aria-label=\"Send\" ng-disabled=\"vm.arraySelected.length===0\" \ntranslate-attr-aria-label=\"REQUISITION.DETAIL.SEND\"><span>Guardar</span><md-tooltip md-direction=\"left\">\n{{\"general.save\"| translate}}</md-tooltip></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/reports/dialogs/show-audit-log/show-audit-log.html","<md-dialog class=\"transaction-detail\" aria-label=\"detail of transaction\"><div layout=\"row\" class=\"tools-dialog\"><div \nflex=\"50\" layout=\"row\" layout-align=\"start center\"><h2 translate=\"REPORT.LOGS.TITLE\">Bitácora</h2></div><div flex=\"50\" \nlayout=\"row\" layout-align=\"end center\"><md-button aria-label=\"button close\" class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div></div>\n<md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loading\" class=\"md-accent\"></md-progress-linear><div \nid=\"transactionDetailMasterGridOptions\" ag-grid=\"vm.masterGridOptions\" class=\"ag-fresh\"></div></md-dialog>");
$templateCache.put("app/main/apps/reports/dialogs/show-interfaz-detail/show-interfaz-detail.html","<md-dialog class=\"transaction-detail\" aria-label=\"detail of transaction\"><div layout=\"row\" class=\"tools-dialog\"><div \nflex=\"50\" layout=\"row\" layout-align=\"start center\"><h2 translate=\"REPORT.transaction_detail\">Detalle de transacción\n</h2></div><div flex=\"50\" layout=\"row\" layout-align=\"end center\"><md-button aria-label=\"button close\" \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon>\n</md-button></div></div><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loading\" class=\"md-accent\">\n</md-progress-linear><div id=\"transactionDetailMasterGridOptions\" ag-grid=\"vm.masterGridOptions\" class=\"ag-fresh\">\n</div></md-dialog>");
$templateCache.put("app/main/apps/reports/dialogs/show-pdf/show-pdf.html","<md-dialog aria-label=\"qr\" style=\"width: 100%;height: 100%;max-height: 92%\"><md-toolbar><div class=\"md-toolbar-tools\">\n<h2></h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon \nmd-font-icon=\"icon-window-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><iframe \ntitle=\"report\" width=\"100%\" height=\"100%\" name=\"plugin\" id=\"plugin\" src=\"{{vm.report}}\"></iframe></md-dialog>");
$templateCache.put("app/main/apps/reports/dialogs/show-invoiceView-detail/show-invoiceView-detail.html","<md-dialog class=\"transaction-detail\" aria-label=\"detail of transaction\"><div layout=\"row\" class=\"tools-dialog\"><div \nflex=\"50\" layout=\"row\" layout-align=\"start center\"><h2>\n{{vm.detailsSettlement.invoicePurchaseType !== \'RECEIPT\' ? \'SETTLEMENT.INVOICE_DETAIL\' : \'SETTLEMENT.RECEIPT_DETAIL\' | translate}}\n</h2></div><div flex=\"50\" layout=\"row\" layout-align=\"end center\"><md-button aria-label=\"button close\" \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon>\n</md-button></div></div><div class=\"content thread-detail\" ms-scroll flex><div class=\"thread-content\"><div \nlayout=\"row\"><ms-form-wizard flex><div class=\"toolbar\"><div class=\"navigation\" flex layout=\"row\" \nlayout-align=\"space-between\"><div class=\"customer h3\" layout=\"column\" flex=\"33\" layout-align=\"center start\"><span>\n</span> <span><strong translate=\"SETTLEMENT.COMPANY.NIT\" \nng-if=\"vm.detailsSettlement.invoicePurchaseType !== \'RECEIPT\'\"></strong>\n {{vm.detailsSettlement.companyDocumentNumber}} </span><span><strong translate=\"SETTLEMENT.COMPANY.COMPANY\"></strong>\n: {{vm.detailsSettlement.companyProviderName}} </span><span><strong translate=\"SETTLEMENT.INVOICE.DATE\"></strong>\n: {{vm.detailsSettlement.dateInvoicePurchase | date: \'dd-MM-yyyy\'}}</span></div><div class=\"customer h3\" \nlayout=\"column\" flex=\"34\" layout-align=\"center start\"><span></span> <span \nng-if=\"vm.detailsSettlement.electronicSignature\"><strong translate=\"SETTLEMENT.INVOICE.RECEIPT_STAMP\"></strong>\n: {{vm.detailsSettlement.electronicSignature}} </span><span ng-if=\"vm.detailsSettlement.uuid\"><strong \ntranslate=\"SETTLEMENT.INVOICE.UUID\"></strong>: {{vm.detailsSettlement.uuid}} </span><span \nng-if=\"vm.detailsSettlement.invoiceSerie\"><strong translate=\"SETTLEMENT.INVOICE.SERIE\"></strong>\n: {{vm.detailsSettlement.invoiceSerie}} </span><span ng-if=\"vm.detailsSettlement.invoicePurchaseCorrelative\"><strong \ntranslate=\"SETTLEMENT.INVOICE.CORRELATIVE\"></strong>: {{vm.detailsSettlement.invoicePurchaseCorrelative}} </span><span>\n<strong translate=\"SETTLEMENT.INVOICE.DETAIL.TOTAL_PRICE\"></strong>\n: {{vm.detailsSettlement.currencyExchangeDescription}}. {{vm.detailsSettlement.documentTotalAfterTax | number : 2}}\n</span></div><div class=\"customer h3\" layout=\"column\" flex=\"33\" layout-align=\"center center\"><span></span> <span \nng-if=\"vm.dimensionCompanyDetail3\"><strong>{{vm.dimensionCompanyDetail3.description}}</strong>\n: {{vm.detailsSettlement.dimensionCompanyDetail3Name}} </span><span ng-if=\"vm.dimensionCompanyDetail4\"><strong>\n{{vm.dimensionCompanyDetail4.description}}</strong>: {{vm.detailsSettlement.dimensionCompanyDetail4Name}} </span><span \nng-if=\"vm.dimensionCompanyDetail5\"><strong>{{vm.dimensionCompanyDetail5.description}}</strong>\n: {{vm.detailsSettlement.dimensionCompanyDetail5Name}}</span></div></div><div layout=\"row\"><div layout=\"column\" flex \nlayout-align=\"start center\"><div layout=\"row\" layout-align=\"center center\"><h4><strong>{{\'SETTLEMENT.FILES\'|translate}}\n</strong></h4></div><div ng-repeat=\"file in vm.filesPurchase\" ng-switch=\"file.extension\" \nng-if=\"vm.detailsSettlement.invoicePurchaseType !== \'RECEIPT\'\"><md-content><div layout=\"column\" \nng-click=\"vm.viewIMG(file)\" \nng-if=\"file.extension === \'.jpg\' || file.extension === \'.png\' || file.extension === \'.JPG\' || file.extension === \'.PNG\'\">\n<a href=\"\"><img alt=\"image\" height=\"100px\" width=\"100px\" class=\"media\" \nng-src=\"{{vm.URLPHOTOS + file.parentPath + file.name + file.extension}}\"><p>{{file.originalName + file.extension}}</p>\n</a></div></md-content></div><div layout=\"row\" layout-align=\"center start\" layout-wrap \nng-show=\"vm.receipt.files.length > 0\" ng-if=\"vm.detailsSettlement.invoicePurchaseType === \'RECEIPT\'\"><div \nng-repeat=\"file in vm.receipt.files\" ng-switch=\"file.extension\"><md-content><div layout=\"column\" \nng-click=\"vm.viewIMG(file)\" \nng-if=\"file.extension === \'.jpg\' || file.extension === \'.png\' || file.extension === \'.JPG\' || file.extension === \'.PNG\'\">\n<a href=\"\"><img alt=\"image\" height=\"100px\" width=\"100px\" class=\"media\" \nng-src=\"{{vm.URLPHOTOS + file.parentPath + file.name + file.extension}}\"><p>{{file.originalName + file.extension}}</p>\n</a></div></md-content></div></div></div></div></div></ms-form-wizard></div></div><md-content class=\"content\" flex \nms-scroll><div class=\"simple-table-container md-whiteframe-4dp\"><div class=\"table-title\"><md-tab-body><header \nclass=\"md-accent-bg\"><div layout=\"row\" layout-align=\"center center\"><strong><h2><div class=\"title\" \ntranslate=\"SETTLEMENT.INVOICE.DETAIL.DETAIL\">Invoice Detail</div></h2></strong></div></header></md-tab-body></div>\n<table class=\"simple\" ms-responsive-table><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"SETTLEMENT.INVOICE.PRODUCT\">Producto</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"SETTLEMENT.INVOICE.DETAIL.QUANTITY\">Cantidad</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"SETTLEMENT.INVOICE.DETAIL.UNIT_PRICE\">PrecioDespuésImpuesto</span></div></th><th class=\"secondary-text\"><div\n class=\"table-header\"><span class=\"column-title\" translate=\"SETTLEMENT.INVOICE.DETAIL.TOTAL_PRICE\">TotalDespuésImpuesto\n</span></div></th></tr></thead><tbody><tr ng-repeat=\"detail in vm.details\" \nng-if=\"vm.detailsSettlement.invoicePurchaseType !== \'RECEIPT\'\"><td>{{detail.product.name}}</td><td>{{detail.quantity}}\n</td><td>{{detail.invoicePurchase.currency.symbol}}.{{detail.priceAfterTax| number:2}}</td><td>\n{{detail.invoicePurchase.currency.symbol}}.{{detail.documentSubTotalAfterTax| number:2}}</td></tr><tr \nng-if=\"vm.detailsSettlement.invoicePurchaseType === \'RECEIPT\'\"><td>{{vm.receipt.product.name}}</td><td>{{ }}</td><td>\n{{ }}</td><td>{{vm.receipt.currency.symbol}}.{{vm.receipt.documentAmount| number:2}}</td></tr></tbody></table></div>\n</md-content></div></md-dialog>");
$templateCache.put("app/main/apps/reports/sidenavs/filter/filter.html","<div class=\"header\" layout=\"column\" layout-align=\"space-between start\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-filter\" class=\"icon s24\"></md-icon>\n</span><span class=\"logo-text\" translate=\"REPORT.FILTER\">Filter</span></div></div><div class=\"content\"><form \nname=\"filterForm\"><div layout=\"column\" class=\"filter\"><md-input-container flex class=\"inputfilter\"><label \ntranslate=\"REPORT.STARTDATE\">Start Date</label><md-datepicker type=\"date\" ng-model=\"vm.filter.startDate\" \nng-change=\"vm.changeStartDate()\" name=\"startDate\" md-min-date=\"vm.minDate\" md-open-on-focus></md-datepicker><div \nng-messages=\"vm.filterForm.startDate.$error\"><div ng-message=\"valid\" translate=\"REPORT.ERROR.INVALID_DATE\">\nThe entered value is not a date!</div><div ng-message=\"required\" translate=\"REPORT.ERROR.FIELD_REQUIRED\">\nThis date is required!</div><div ng-message=\"mindate\" translate=\"REPORT.ERROR.INVALID_DATE\">Date is too early!</div>\n</div></md-input-container><md-input-container flex class=\"inputfilter\"><label translate=\"REPORT.ENDDATE\">End Date\n</label><md-datepicker type=\"date\" ng-model=\"vm.filter.endDate\" name=\"endDate\" md-min-date=\"vm.filter.startDate\" \nmd-open-on-focus></md-datepicker><div ng-messages=\"vm.filterForm.endDate.$error\"><div ng-message=\"valid\" \ntranslate=\"REPORT.ERROR.INVALID_DATE\">The entered value is not a date!</div><div ng-message=\"required\" \ntranslate=\"REPORT.ERROR.FIELD_REQUIRED\">This date is required!</div><div ng-message=\"mindate\" \ntranslate=\"REPORT.ERROR.INVALID_DATE\">Date is too early!</div></div></md-input-container><md-input-container \nclass=\"inputfilter\" ng-if=\"vm.snFilter.department\"><label>{{\'REPORT.DEPARTMENT\'| translate}}</label><md-select \nng-model=\"vm.filter.departments\" md-on-close=\"vm.clearSearchDepartment()\" multiple=\"multiple\" \nng-disabled=\"vm.loadingDepartments\"><md-select-header><input id=\"searchDepartment\" ng-model=\"vm.searchDepartment\" \ntype=\"search\" placeholder=\"Buscar departamento\"></md-select-header><md-optgroup label=\"Departamentos\"><md-option \nvalue=\"{{department.id}}\" ng-repeat=\"department in vm.departments| filter:vm.searchDepartment\">\n{{department.code}} - {{department.description}}</md-option></md-optgroup></md-select><md-progress-linear \nmd-mode=\"indeterminate\" ng-if=\"vm.loadingDepartments\"></md-progress-linear></md-input-container><md-input-container \nclass=\"inputfilter\" ng-if=\"vm.snFilter.costCenter\"><label>{{\'REPORT.COSTCENTER\'| translate}}</label><md-select \nng-model=\"vm.filter.costCenters\" md-on-close=\"vm.clearSearchCostCenter()\" multiple=\"multiple\" \nng-disabled=\"vm.loadingCostCenter\"><md-select-header><input id=\"searchCostCenter\" ng-model=\"vm.searchCostCenter\" \ntype=\"search\" placeholder=\"Buscar Centro de Costo\"></md-select-header><md-optgroup label=\"Departamentos\"><md-option \nvalue=\"{{costCenter.id}}\" ng-repeat=\"costCenter in vm.costCenters| filter:vm.searchCostCenter\">\n{{costCenter.code}} - {{costCenter.description}}</md-option></md-optgroup></md-select><md-progress-linear \nmd-mode=\"indeterminate\" ng-if=\"vm.loadingCostCenter\"></md-progress-linear></md-input-container><md-input-container \nclass=\"inputfilter\" ng-if=\"vm.snFilter.status\"><label>{{\'REPORT.STATUS\'| translate}}</label><md-select \nng-model=\"vm.filter.statuses\" md-on-close=\"vm.clearSearchStatus()\" multiple=\"multiple\" ng-disabled=\"vm.loadingStatus\">\n<md-select-header><input id=\"searchStatus\" ng-model=\"vm.searchStatus\" type=\"search\" placeholder=\"Buscar Status\">\n</md-select-header><md-optgroup label=\"Departamentos\"><md-option value=\"{{status.id}}\" \nng-repeat=\"status in vm.statuses| filter:vm.searchStatus\">{{status.description}}</md-option></md-optgroup></md-select>\n<md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loadingStatus\"></md-progress-linear></md-input-container>\n<md-button class=\"md-primary\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><span translate=\"REPORT.SEARCH\">Search\n</span></md-button></div></form></div>");
$templateCache.put("app/main/apps/reports/sidenavs/filter/h-filter.html","<md-progress-linear style=\"position: fixed; height: 5px; z-index: 10\" md-mode=\"query\" class=\"md-accent\" \nng-show=\"vm.isShowProgressLinear\"></md-progress-linear><div style=\"padding-top: 5px\"><md-content ng-cloak><md-card>\n<md-button class=\"md-primary button-filter\" target=\"_blank\" ng-click=\"vm.isShowFilter = !vm.isShowFilter\">\n{{\'REPORT.CLICK_FILTRO\'| translate}}<md-icon ng-if=\"vm.isShowFilter\" md-font-icon=\"icon-chevron-down\"></md-icon>\n<md-icon ng-if=\"!vm.isShowFilter\" md-font-icon=\"icon-chevron-right\"></md-icon></md-button><div \nng-show=\"vm.isShowFilter\" class=\"animate-show\"><div layout=\"row\" layout-xs=\"row\" layout-align=\"space-around center\" \nng-if=\"vm.snFilter.checkFilterDate\"><md-checkbox ng-model=\"vm.snFilter.filterByDates\">\n{{\'REPORT.FILTER_DATES\'| translate}}</md-checkbox></div><div layout=\"row\" layout-xs=\"row\" \nlayout-align=\"space-around center\" ng-if=\"vm.snFilter.filterByDates\"><md-datepicker type=\"date\" \nng-model=\"vm.filter.startDate\" md-placeholder=\"Enter start date\" ng-change=\"vm.changeStartDate(true)\" name=\"startDate\" \nmd-open-on-focus></md-datepicker><md-datepicker type=\"date\" ng-model=\"vm.filter.endDate\" \nmd-placeholder=\"Enter end date\" ng-change=\"vm.changeStartDate(false)\" name=\"endDate\" md-min-date=\"vm.filter.startDate\" \nmd-max-date=\"vm.maxDate\" md-open-on-focus></md-datepicker></div><div layout=\"row\" layout-xs=\"row\" \nlayout-align=\"space-around center\" ng-if=\"vm.snFilter.checkElectronic\"><md-checkbox ng-model=\"vm.electronic\">\n{{\'REPORT.FILTER_CHECK_ELECTRONIC\'| translate}}</md-checkbox></div><div layout=\"row\" layout-xs=\"row\" \nlayout-align=\"space-around center\" ng-if=\"vm.snFilter.userRoleComprasOperator\"><md-input-container class=\"inputfilter\" \nflex ng-if=\"vm.snFilter.userRoleComprasOperator\"><label>{{\'REPORT.SELECT_USER\'| translate}}</label><md-select \nng-model=\"vm.filter.usersToQuote\" md-on-close=\"vm.searchUserToQuote==\'\'\" multiple=\"multiple\" \nng-disabled=\"vm.isShowLoaderUsers\" ng-if=\"vm.snFilter.userRoleComprasOperator\"><md-select-header><input \nid=\"searchUserToQuote\" ng-model=\"vm.searchUserToQuote\" type=\"search\" ng-keydown=\"$event.stopPropagation()\" \nplaceholder=\"Buscar Usuario\"></md-select-header><md-optgroup label=\"Empresas\"><md-option value=\"{{data.id}}\" \nng-repeat=\"data in vm.userArray| filter:vm.searchUserToQuote\">{{data.name}}</md-option></md-optgroup></md-select>\n<md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.isShowLoaderUsers\"></md-progress-linear></md-input-container>\n</div><div layout=\"row\" layout-xs=\"row\" layout-align=\"space-around center\" \nng-if=\"vm.snFilter.companies || vm.snFilter.companiesDialog || vm.snFilter.companiesLoadDeptoAndCC || vm.snFilter.companiesLoadDeptoAndCCUser\">\n<md-input-container class=\"inputfilter\" flex ng-if=\"vm.snFilter.companiesDialog\"><label>\n{{\'REPORT.companiesDialog\'| translate}}</label><input readonly=\"true\" ng-model=\"vm.namesCompaniesDialog\">\n<md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loadingCompaniesDialog\"></md-progress-linear>\n</md-input-container><md-button class=\"md-mini md-fab md-primary md-raised\" aria-label=\"addDetail\" \nng-click=\"vm.selectCompanies(\'companies\')\" ng-if=\"vm.snFilter.companiesDialog\"><md-icon md-font-icon=\"icon-plus\" \nng-if=\"!vm.namesCompaniesDialog\"><md-tooltip md-direction=\"top\">{{\"general.add\"| translate}}</md-tooltip></md-icon>\n<md-icon md-font-icon=\"icon-pencil\" ng-if=\"vm.namesCompaniesDialog\"><md-tooltip md-direction=\"top\">\n{{\"general.edit\"| translate}}</md-tooltip></md-icon></md-button><md-input-container class=\"inputfilter\" flex \nng-if=\"vm.snFilter.companies\"><label>{{\'REPORT.SELECT_COMPANY\'| translate}}</label><md-select \nng-model=\"vm.filter.companies\" md-on-close=\"vm.clearSearchCompany()\" multiple=\"multiple\" \nng-disabled=\"vm.loadingCompanies\" ng-if=\"!vm.snFilter.isNotCompaniesMultiple\"><md-select-header><input \nid=\"searchCompany\" ng-model=\"vm.searchCompany\" type=\"search\" placeholder=\"Buscar Empresa\"></md-select-header>\n<md-optgroup label=\"Empresas\"><md-option value=\"{{data.id}}\" ng-repeat=\"data in vm.companies| filter:vm.searchCompany\">\n{{data.id}} - {{data.name}}</md-option></md-optgroup></md-select><md-select ng-model=\"vm.filter.companies\" \nmd-on-close=\"vm.clearSearchCompany()\" ng-disabled=\"vm.loadingCompanies\" ng-if=\"vm.snFilter.isNotCompaniesMultiple\">\n<md-select-header><input id=\"searchCompany\" ng-model=\"vm.searchCompany\" type=\"search\" placeholder=\"Buscar Empresa\">\n</md-select-header><md-optgroup label=\"Empresas\"><md-option value=\"{{data.id}}\" \nng-repeat=\"data in vm.companies| filter:vm.searchCompany\">{{data.id}} - {{data.name}}</md-option></md-optgroup>\n</md-select><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loadingCompanies\"></md-progress-linear>\n</md-input-container><md-input-container class=\"inputfilter\" flex ng-if=\"vm.snFilter.companiesLoadDeptoAndCC\"><label>\n{{\'REPORT.SELECT_COMPANY\'| translate}}</label><md-select ng-model=\"vm.filter.companies\" \nmd-on-close=\"vm.clearSearchCompany()\" multiple=\"multiple\" ng-disabled=\"vm.loadingCompanies\" \nng-change=\"vm.changeDeptosAndCc()\" ng-if=\"!vm.snFilter.isNotCompaniesMultiple\"><md-select-header><input \nid=\"searchCompany\" ng-model=\"vm.searchCompany\" ng-keydown=\"$event.stopPropagation()\" type=\"search\" \nplaceholder=\"Buscar Empresa\"></md-select-header><md-optgroup label=\"Empresas\"><md-option value=\"{{data.id}}\" \nng-repeat=\"data in vm.companies| filter:vm.searchCompany\">{{data.id}} - {{data.name}}</md-option></md-optgroup>\n</md-select></md-input-container><md-input-container class=\"inputfilter\" flex \nng-if=\"vm.snFilter.companiesLoadDeptoAndCCUser\"><label>{{\'REPORT.SELECT_COMPANY\'| translate}}</label><md-select \nng-model=\"vm.filter.companies\" md-on-close=\"vm.clearSearchCompany()\" ng-disabled=\"vm.loadingCompanies\" \nng-change=\"vm.changeDeptosAndCcUser()\" ng-if=\"!vm.snFilter.isNotCompaniesMultiple\"><md-select-header><input \nid=\"searchCompany\" ng-model=\"vm.searchCompany\" ng-keydown=\"$event.stopPropagation()\" type=\"search\" \nplaceholder=\"Buscar Empresa\"></md-select-header><md-optgroup label=\"Empresas\"><md-option value=\"{{data.id}}\" \nng-repeat=\"data in vm.companies| filter:vm.searchCompany\">{{data.id}} - {{data.name}}</md-option></md-optgroup>\n</md-select></md-input-container></div><div layout=\"row\" layout-xs=\"column\"><md-input-container class=\"inputfilter\" \nflex ng-if=\"vm.snFilter.department\"><label>{{\'REPORT.DEPARTMENT\'| translate}}</label><md-select \nng-model=\"vm.filter.departments\" md-on-close=\"vm.clearSearchDepartment()\" multiple=\"multiple\" \nng-disabled=\"vm.loadingDepartments\"><md-select-header><input id=\"searchDepartment\" ng-model=\"vm.searchDepartment\" \ntype=\"search\" placeholder=\"Buscar departamento\" ng-keydown=\"$event.stopPropagation()\"></md-select-header><md-optgroup \nlabel=\"Departamentos\"><md-option value=\"{{department.id}}\" \nng-repeat=\"department in vm.departments| filter:vm.searchDepartment\">{{department.code}} - {{department.description}}\n</md-option></md-optgroup></md-select><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loadingDepartments\">\n</md-progress-linear></md-input-container><md-input-container class=\"inputfilter\" flex ng-if=\"vm.snFilter.costCenter\">\n<label>{{\'REPORT.COSTCENTER\'| translate}}</label><md-select ng-model=\"vm.filter.costCenters\" \nmd-on-close=\"vm.clearSearchCostCenter()\" multiple=\"multiple\" ng-disabled=\"vm.loadingCostCenter\"><md-select-header>\n<input id=\"searchCostCenter\" ng-model=\"vm.searchCostCenter\" type=\"search\" placeholder=\"Buscar Centro de Costo\" \nng-keydown=\"$event.stopPropagation()\"></md-select-header><md-optgroup label=\"Departamentos\"><md-option \nvalue=\"{{costCenter.id}}\" ng-repeat=\"costCenter in vm.costCenters| filter:vm.searchCostCenter\">\n{{costCenter.description}}</md-option></md-optgroup></md-select><md-progress-linear md-mode=\"indeterminate\" \nng-if=\"vm.loadingCostCenter\"></md-progress-linear></md-input-container><md-input-container class=\"inputfilter\" flex \nng-if=\"vm.snFilter.project\"><label>{{\'REPORT.PROJECT\'| translate}}</label><md-select ng-model=\"vm.filter.projects\" \nmd-on-close=\"vm.clearSearchProject()\" multiple=\"multiple\" ng-disabled=\"vm.loadingProject\"><md-select-header><input \nid=\"searchProject\" ng-model=\"vm.searchProject\" type=\"search\" placeholder=\"Buscar proyecto\"></md-select-header>\n<md-optgroup label=\"Proyectos\"><md-option value=\"{{department.id}}\" \nng-repeat=\"department in vm.projects| filter:vm.searchProject\">{{department.code}} - {{department.name}}</md-option>\n</md-optgroup></md-select><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loadingProject\"></md-progress-linear>\n</md-input-container></div><div layout=\"row\" layout-xs=\"column\"><md-input-container class=\"inputfilter\" flex \nng-if=\"vm.snFilter.providers\"><label>{{\'REPORT.providers\'| translate}}</label><input readonly=\"true\" \nng-model=\"vm.namesProviders\"><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loadingProviders\">\n</md-progress-linear></md-input-container><md-button class=\"md-mini md-fab md-primary md-raised\" \naria-label=\"addDetail\" ng-click=\"vm.selectCompanies(\'providers\')\" ng-if=\"vm.snFilter.providers\"><md-icon \nmd-font-icon=\"icon-plus\" ng-if=\"!vm.namesProviders\"><md-tooltip md-direction=\"top\">{{\"general.add\"| translate}}\n</md-tooltip></md-icon><md-icon md-font-icon=\"icon-pencil\" ng-if=\"vm.namesProviders\"><md-tooltip md-direction=\"top\">\n{{\"general.edit\"| translate}}</md-tooltip></md-icon></md-button><md-input-container class=\"inputfilter\" flex \nng-if=\"vm.snFilter.providersSelect\"><label>{{\'REPORT.providers\'| translate}}</label><md-select \nng-model=\"vm.filter.providers\" md-on-close=\"vm.clearSearchProviderSelect()\" multiple=\"multiple\" \nng-change=\"vm.selectAllItemsProviders()\" ng-disabled=\"vm.loadingProviderSelect\"><md-select-header><input \nid=\"searchProviderSelect\" ng-model=\"vm.searchProviderSelect\" type=\"search\" placeholder=\"Buscar Proveedor\" \nng-keydown=\"$event.stopPropagation(); vm.loadProviders()\"></md-select-header><md-optgroup label=\"Proveedores\">\n<md-option value=\"{{provider.id}}\" ng-repeat=\"provider in vm.providersSelect\">{{provider.name}}</md-option>\n</md-optgroup></md-select><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loadingProviderSelect\">\n</md-progress-linear></md-input-container></div><div layout=\"row\" layout-xs=\"column\"><md-input-container \nclass=\"inputfilter\" flex ng-if=\"vm.snFilter.products\"><label>{{\'REPORT.products\'| translate}}</label><input \nreadonly=\"true\" ng-model=\"vm.namesProducts\"><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loadingProducts\">\n</md-progress-linear></md-input-container><md-button class=\"md-mini md-fab md-primary md-raised\" \naria-label=\"addDetail\" ng-click=\"vm.selectProducts()\" ng-if=\"vm.snFilter.products\"><md-icon md-font-icon=\"icon-plus\" \nng-if=\"!vm.namesProducts\"><md-tooltip md-direction=\"top\">{{\"general.add\"| translate}}</md-tooltip></md-icon><md-icon \nmd-font-icon=\"icon-pencil\" ng-if=\"vm.namesProducts\"><md-tooltip md-direction=\"top\">{{\"general.edit\"| translate}}\n</md-tooltip></md-icon></md-button><md-input-container class=\"inputfilter\" flex ng-if=\"vm.snFilter.productsSelect\">\n<label>{{\'REPORT.products\'| translate}}</label><md-select ng-model=\"vm.filter.products\" \nmd-on-close=\"vm.clearSearchCompany()\" multiple=\"multiple\" ng-disabled=\"vm.loadingProducts\" \nng-if=\"!vm.snFilter.isNotCompaniesMultiple\"><md-select-header><input id=\"searchProducts\" \nng-model=\"vm.searchProductInput\" ng-keydown=\"$event.stopPropagation(); vm.loadProducts()\" type=\"search\" \nplaceholder=\"Buscar Producto\"></md-select-header><md-optgroup label=\"Productos\"><md-option value=\"{{data.id}}\" \nng-repeat=\"data in vm.products.content| filter:vm.searchProductInput\">{{data.id}}- {{data.name}}</md-option>\n</md-optgroup></md-select><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loadingProducts\"></md-progress-linear>\n</md-input-container></div><div layout=\"row\" layout-xs=\"column\"><md-input-container class=\"inputfilter\" flex \nng-if=\"vm.snFilter.idShipping\"><label>{{\'REPORT.SHIPPING_ID\'| translate}}</label><input ng-model=\"vm.filter.id\" \ntype=\"number\"></md-input-container><md-input-container class=\"inputfilter\" flex ng-if=\"vm.snFilter.idField\"><label>\n{{\'REPORT.DOC_ENTREGA\'| translate}}</label><input ng-model=\"vm.filter.id\" type=\"number\"></md-input-container>\n<md-input-container class=\"inputfilter\" flex ng-if=\"vm.snFilter.correlativo\"><label>{{\'REPORT.NO_FACTURA\'| translate}}\n</label><input ng-model=\"vm.filter.correlative\" type=\"number\"></md-input-container><md-input-container \nclass=\"inputfilter\" flex ng-if=\"vm.snFilter.status\"><label>{{\'REPORT.STATUS\'| translate}}</label><md-select \nng-model=\"vm.filter.statuses\" md-on-close=\"vm.clearSearchStatus()\" multiple=\"multiple\" ng-disabled=\"vm.loadingStatus\">\n<md-select-header><input id=\"searchStatus\" ng-model=\"vm.searchStatus\" type=\"search\" placeholder=\"Buscar Estado\">\n</md-select-header><md-optgroup label=\"Estados\"><md-option value=\"{{status.id}}\" \nng-repeat=\"status in vm.statuses| filter:vm.searchStatus\">{{status.description}}</md-option></md-optgroup></md-select>\n<md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loadingStatus\"></md-progress-linear></md-input-container>\n<md-input-container class=\"inputfilter\" flex ng-if=\"vm.snFilter.statusRequisition\"><label>\n{{\'REPORT.STATUS_REQUISITION\'| translate}}</label><md-select ng-model=\"vm.filter.statusesRequisition\" \nmd-on-close=\"vm.clearSearchStatus()\" multiple=\"multiple\" ng-disabled=\"vm.loadingStatus\"><md-select-header><input \nid=\"searchStatusRequisition\" ng-model=\"vm.searchStatusRequisition\" type=\"search\" \nplaceholder=\"Buscar Estado Requerimiento\"></md-select-header><md-optgroup label=\"Estados\"><md-option \nvalue=\"{{status.id}}\" ng-repeat=\"status in vm.statusesRequisition| filter:vm.searchStatusRequisition\">\n{{status.description}}</md-option></md-optgroup></md-select><md-progress-linear md-mode=\"indeterminate\" \nng-if=\"vm.loadingStatusRequisition\"></md-progress-linear></md-input-container><md-input-container class=\"inputfilter\" \nflex ng-if=\"vm.snFilter.statusPurchaseOrder\"><label>{{\'REPORT.STATUS_PURCHASE_ORDER\'| translate}}</label><md-select \nng-model=\"vm.filter.statusesPurchaseOrder\" md-on-close=\"vm.clearSearchStatus()\" multiple=\"multiple\" \nng-disabled=\"vm.loadingStatus\"><md-select-header><input id=\"searchStatusPurchaseOrder\" \nng-model=\"vm.searchStatusPurchaseOrder\" type=\"search\" placeholder=\"Buscar Estado Orden de Compra\"></md-select-header>\n<md-optgroup label=\"Estados\"><md-option value=\"{{status.id}}\" \nng-repeat=\"status in vm.statusesPurchaseOrder| filter:vm.searchStatusPurchaseOrder\">{{status.description}}</md-option>\n</md-optgroup></md-select><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loadingStatusPurchaseOrder\">\n</md-progress-linear></md-input-container><md-input-container class=\"inputfilter\" flex \nng-if=\"vm.snFilter.requisitionTypes\"><label>{{\'REPORT.REQUISITION_TYPE\'| translate}}</label><md-select \nng-model=\"vm.filter.requisitionTypes\" md-on-close=\"vm.clearRequisitionType()\" multiple=\"multiple\" \nng-disabled=\"vm.loadingRequisitionTypes\"><md-select-header><input id=\"searchRequisitionType\" \nng-model=\"vm.searchRequisitionType\" type=\"search\" \nplaceholder=\"{{\'REPORT.SEARCH2\'| translate}} {{\'REPORT.REQUISITION_TYPE\'\n                                        | translate}}\">\n</md-select-header><md-optgroup label=\"Types\"><md-option \nng-repeat=\"status in vm.requisitionTypes| filter:vm.searchRequisitionType\" value=\"{{status.id}}\">{{status.description}}\n</md-option></md-optgroup></md-select><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loadingRequisitionTypes\">\n</md-progress-linear></md-input-container><md-input-container class=\"inputfilter\" flex \nng-if=\"vm.snFilter.requisitionNo\"><label>{{\'REPORT.NO_REQUISITION\'| translate}}</label><input ng-model=\"vm.filter.id\" \ntype=\"number\"></md-input-container><md-input-container class=\"inputfilter\" flex ng-if=\"vm.snFilter.contractValid\">\n<md-checkbox ng-if=\"vm.snFilter.contractValid\" ng-model=\"vm.selectContractVAlid\" ng-click=\"vm.selectContractsValid()\">\nBuscar Solo Contratos Vigentes</md-checkbox><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loadingStatus\">\n</md-progress-linear></md-input-container></div><div layout=\"row\" layout-xs=\"column\"><md-input-container \nclass=\"inputfilter\" flex ng-if=\"vm.snFilter.settlementid\"><label>{{\'REPORT.SETTLEMENTID\'| translate}}</label><input \nng-model=\"vm.filter.id\" type=\"number\"></md-input-container><md-input-container class=\"inputfilter\" flex \nng-if=\"vm.snFilter.pettyCashId\"><label>{{\'REPORT.PETTYCASHID\'| translate}}</label><input \nng-model=\"vm.filter.pettyCashId\" type=\"number\"></md-input-container><md-input-container class=\"inputfilter\" flex \nng-if=\"vm.snFilter.invoicePurchaseCorrelative\"><label>{{\'REPORT.INVOICEPURCHASECORRELATIVE\'| translate}}</label><input \nng-model=\"vm.filter.correlative\" type=\"number\"></md-input-container><md-input-container class=\"inputfilter\" flex \nng-if=\"vm.snFilter.SettlementStatus\"><label>{{\'REPORT.SETTLEMENTSTATUS\'| translate}}</label><md-select \nng-model=\"vm.filter.settlementStatus\" md-on-close=\"vm.clearSearchSettlementStatus()\" multiple=\"multiple\" \nng-disabled=\"vm.loadingDepartments\"><md-select-header><input id=\"searchDepartment\" \nng-model=\"vm.searchSettlementStatus\" type=\"search\" placeholder=\"Buscar Estado\"></md-select-header><md-optgroup \nlabel=\"settlementStatus\"><md-option value=\"{{settlementStatus.id}}\" \nng-repeat=\"settlementStatus in vm.settlementStatus| filter:vm.searchSettlementStatus\">{{settlementStatus.name}}\n</md-option></md-optgroup></md-select><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loadingSettlementStatus\">\n</md-progress-linear></md-input-container><md-input-container class=\"inputfilter\" flex \nng-if=\"vm.snFilter.pettyCashStatus\"><label>{{\'REPORT.PETTYCASHSTATUS\'| translate}}</label><md-select \nng-model=\"vm.filter.pettyCashStatus\" md-on-close=\"vm.clearSearchPettyCashStatus()\" multiple=\"multiple\" \nng-disabled=\"vm.loading\"><md-select-header><input id=\"searchPettyCashStatus\" ng-model=\"vm.searchPettyCashStatus\" \ntype=\"search\" placeholder=\"Buscar Estado\"></md-select-header><md-optgroup label=\"pettyCashStatus\"><md-option \nvalue=\"{{pettyCashStatus.id}}\" ng-repeat=\"pettyCashStatus in vm.pettyCashStatus| filter:vm.searchPettyCashStatus\">\n{{pettyCashStatus.name}}</md-option></md-optgroup></md-select><md-progress-linear md-mode=\"indeterminate\" \nng-if=\"vm.loadingPettyCashStatus\"></md-progress-linear></md-input-container></div><div layout=\"row\" layout-xs=\"column\">\n<md-input-container class=\"inputfilter\" flex ng-if=\"vm.snFilter.type\"><label>{{\'REPORT.TYPE\'| translate}}</label>\n<md-select ng-model=\"vm.filter.types\" md-on-close=\"vm.clearSearchStatus()\" multiple=\"multiple\" \nng-disabled=\"vm.loadingTypes\"><md-select-header><input id=\"searchType\" ng-model=\"vm.searchType\" type=\"search\" \nplaceholder=\"Buscar Type\"></md-select-header><md-optgroup label=\"Types\"><md-option value=\"{{dat.id}}\" \nng-repeat=\"dat in vm.typeses | filter:vm.searchType\">{{dat.description}}</md-option></md-optgroup></md-select>\n<md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loadingType\"></md-progress-linear></md-input-container></div><div\n layout-gt-xs=\"row\" layout-align=\"start center\" layout-align=\"start center\" \nng-if=\"vm.snFilter.loadDimensionCompanyDetail\"><md-input-container flex-gt-xs ng-if=\"vm.dimensionCompanyDetail3\">\n<label>{{vm.dimensionCompanyDetail3.description}}</label><md-select ng-model=\"vm.filter.dimensionCompanyDetail3Id\" \nname=\"dimensionCompanyDetail3\" multiple=\"multiple\" md-on-close=\"vm.searchDimensionCompanyDetail3=\'\'\"><md-select-header>\n<input id=\"searchDimensionCompanyDetail3\" ng-model=\"vm.searchDimensionCompanyDetail3\" type=\"search\" translate \ntranslate-attr-placeholder=\"general.search\" aria-label=\"search-dimension-company\" \nng-keydown=\"$event.stopPropagation()\"></md-select-header><md-optgroup label=\"dimensionCompanyDetail3\"><md-option \nvalue=\"{{data.id}}\" \nng-repeat=\"data in vm.dimensionCompanyDetail3List|\n                                    filter:vm.searchDimensionCompanyDetail3\">\n{{data.code}} - {{data.name}}</md-option></md-optgroup></md-select><md-progress-linear md-mode=\"indeterminate\" \nng-if=\"vm.loadingdimensionCompanyDetail3List\"></md-progress-linear></md-input-container><md-input-container flex-gt-xs \nng-if=\"vm.dimensionCompanyDetail4\"><label>{{vm.dimensionCompanyDetail4.description}}</label><md-select \nng-model=\"vm.filter.dimensionCompanyDetail4Id\" name=\"dimensionCompanyDetail4\" multiple=\"multiple\" \nmd-on-close=\"vm.searchDimensionCompanyDetail4=\'\'\"><md-select-header><input id=\"searchDimensionCompanyDetail4\" \nng-model=\"vm.searchDimensionCompanyDetail4\" type=\"search\" translate translate-attr-placeholder=\"general.search\" \naria-label=\"search-dimension-company\" ng-keydown=\"$event.stopPropagation()\"></md-select-header><md-optgroup \nlabel=\"dimensionCompanyDetail4\"><md-option value=\"{{data.id}}\" \nng-repeat=\"data in vm.dimensionCompanyDetail4List|\n                                    filter:vm.searchDimensionCompanyDetail4\">\n{{data.code}} - {{data.name}}</md-option></md-optgroup></md-select><md-progress-linear md-mode=\"indeterminate\" \nng-if=\"vm.loadingdimensionCompanyDetail4List\"></md-progress-linear></md-input-container><md-input-container flex-gt-xs \nng-if=\"vm.dimensionCompanyDetail5\"><label>{{vm.dimensionCompanyDetail5.description}}</label><md-select \nng-model=\"vm.filter.dimensionCompanyDetail5Id\" name=\"dimensionCompanyDetail5\" multiple=\"multiple\" \nmd-on-close=\"vm.searchDimensionCompanyDetail5=\'\'\"><md-select-header><input id=\"searchDimensionCompanyDetail5\" \nng-model=\"vm.searchDimensionCompanyDetail5\" type=\"search\" translate translate-attr-placeholder=\"general.search\" \naria-label=\"search-dimension-company\" ng-keydown=\"$event.stopPropagation()\"></md-select-header><md-optgroup \nlabel=\"dimensionCompanyDetail5\"><md-option value=\"{{data.id}}\" \nng-repeat=\"data in vm.dimensionCompanyDetail5List|\n                                    filter:vm.searchDimensionCompanyDetail5\">\n{{data.code}} - {{data.name}}</md-option></md-optgroup></md-select><md-progress-linear md-mode=\"indeterminate\" \nng-if=\"vm.loadingdimensionCompanyDetail5List\"></md-progress-linear></md-input-container></div><div layout=\"row\">\n<md-input-container class=\"inputfilter\" flex ng-if=\"vm.snFilter.receivingPOUsers\"><label>\n{{\'REPORT.RECEIVING_PURCHASE_ORDER_USER\'| translate}}</label><md-select ng-model=\"vm.filter.userAccounts\" \nmd-on-close=\"vm.clearSearchReceivingPOUser()\" multiple=\"multiple\"><md-select-header><input id=\"searchReceivingPOUser\" \nng-model=\"vm.searchReceivingPOUser\" ng-keydown=\"$event.stopPropagation()\" type=\"search\" \nplaceholder=\"{{\'REPORT.SEARCH2\'| translate}} {{\'REPORT.USER\'| translate}}\"></md-select-header><md-optgroup \nlabel=\"Users\"><md-option value=\"{{user.account}}\" \nng-repeat=\"user in vm.usersByRoleAndUserCompanies| filter:vm.searchReceivingPOUser\">{{user.name}}</md-option>\n</md-optgroup></md-select><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loadingUsersByRoleAndUserCompanies\">\n</md-progress-linear></md-input-container></div><div layout=\"row\" layout-xs=\"column\"><md-input-container \nclass=\"inputfilter\" flex ng-if=\"vm.snFilter.filterType\"><label>{{\'REPORT.FILTER_PRODUCTS\'| translate}}</label>\n<md-select aria-label=\"filter type\" ng-model=\"vm.filter.filterType\" name=\"filterType\"><md-option value=\"ALL\">\n{{\'ORDER.ALL\' | translate}}</md-option><md-option value=\"PRODUCT_SALE\">{{\'ORDER.PRODUCT_SALE\' | translate}}</md-option>\n<md-option value=\"OTHER_PRODUCT\">{{\'ORDER.OTHER_PRODUCT\' | translate}}</md-option></md-select></md-input-container>\n</div><div layout=\"row\" layout-xs=\"row\" layout-align=\"center center\"><md-button class=\"md-accent md-raised md-hue-1\" \nng-click=\"vm.search()\">{{\'REPORT.SEARCH\'| translate}}</md-button></div></div></md-card></md-content></div>");
$templateCache.put("app/main/apps/requisition/requisition/compose/compose-dialog.html","<md-dialog class=\"compose-dialog\" aria-label=\"New Message\" ms-scroll><md-toolbar class=\"md-accent md-hue-2\" \nlayout=\"row\" ng-if=\"!vm.searchMode\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div\n style=\"min-width: 400px\"><md-tabs md-selected=\"vm.selectedTab\" class=\"title\"><md-tab id=\"tab12\" \naria-controls=\"tab12-content\" label=\"{{\'REQUISITION.DETAIL.PRODUCT\'| translate}}\"></md-tab><md-tab \nng-disabled=\"!vm.detail.product\" id=\"tab22\" aria-controls=\"tab22-content\" \nlabel=\"{{\'REQUISITION.DETAIL.DETAILS\'| translate}}\"></md-tab></md-tabs></div><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.activeSearch()\" aria-label=\"Close dialog\" tranlate ng-if=\"vm.selectedTab === 0\" \ntranslate-aria-label=\"MAIL.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" tranlate \ntranslate-aria-label=\"MAIL.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-toolbar class=\"md-accent md-hue-2\" ng-show=\"vm.searchMode\"><form ng-submit=\"vm.getProducts(1)\" \nname=\"vm.searchForm\"><div class=\"md-toolbar-tools\"><md-button type=\"button\" class=\"md-icon-button\" \nng-click=\"vm.searchMode = !vm.searchMode; vm.getProducts(1)\" aria-label=\"Back\"><ng-md-icon icon=\"arrow_back\">\n</ng-md-icon></md-button><md-input-container flex style=\"margin-top: 60px\"><label \ntranslate=\"REQUISITION.DETAIL.FILTER\">Filtro</label><input type=\"text\" ng-model=\"vm.filterProduct\" name=\"searchText\" \nid=\"searchField\" ng-model-options=\"{\'debounce\': 500}\"><div ng-messages=\"vm.searchForm.searchText.$error\"><div \nng-message=\"required\" translate=\"REQUISITION.ERROR.FIELD_REQUIRED\">This date is required!</div></div>\n</md-input-container><md-button type=\"submit\" aria-label=\"Search\"><span translate=\"REQUISITION.DETAIL.SEARCH\">Search\n</span></md-button></div></form></md-toolbar><md-dialog-content ms-scroll flex layout-fill \nng-class=\"vm.selectedTab === 0 ? \'md-dialog-list-content\' : \'\'\"><div ng-if=\"vm.selectedTab === 0\"><div \nclass=\"content thread-list\" ng-show=\"!vm.creatingProduct\"><div class=\"thread\" md-ink-ripple ng-if=\"!vm.loading\" \nng-repeat=\"product in vm.productos.content\" ng-click=\"vm.selectProduct(product)\" \nng-class=\"{\n                                 \'current-thread\': vm.selectedProduct(product)}\"><div layout=\"row\" \nng-class=\"vm.isDefaultClass(product);\" layout-align=\"start center\"><div class=\"info\" flex layout=\"row\"><div><div \nclass=\"title h3\"><strong>{{product.productCode ? product.productCode + \' - \' : \'\'}}{{product.name}}</strong></div><div \nclass=\"notes\" layout=\"column\"><span ng-if=\"product.brand\"><strong>Marca: </strong>{{product.brand}}</span> <span \nng-if=\"product.company\"><strong>Empresa: </strong>{{product.company}}</span> <span ng-if=\"product.measurementUnit\">\n<strong>Unidad de Medida: </strong>{{product.measurementUnit.name}}</span></div></div><span flex></span><div \nng-if=\"product.salePrice || product.buyPrice\"><label ng-if=\"product.defaultCC\"><md-tooltip md-direction=\"bottom\">\n{{\"REQUISITION.DETAIL.DEFAULTCC\"| translate}}</md-tooltip><ng-md-icon icon=\"playlist_add_check\"></ng-md-icon></label>\n<label ng-if=\"product.default && !product.defaultCC\"><md-tooltip md-direction=\"bottom\">\n{{\"REQUISITION.DETAIL.DEFAULTGN\"| translate}}</md-tooltip><ng-md-icon icon=\"spellcheck\"></ng-md-icon></label><h1 \nng-if=\"product.buyPrice && product.buyPrice > 0\">{{product.currencyBuy.symbol}} {{product.buyPrice| number: 2}}</h1><h1\n ng-if=\"!product.buyPrice && product.salePrice && product.salePrice > 0\">\n{{product.currencySale.symbol}} {{product.salePrice| number: 2}}</h1></div></div></div><div layout=\"column\" \nlayout-align=\"space-between end\"><div class=\"actions\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"label ng-binding ng-scope md-green-300-bg\" role=\"button\" ng-if=\"vm.selectedProduct(product)\"><md-icon \nmd-font-icon=\"icon-check-all\"></md-icon></div></div></div></div></div><div class=\"div-loader\" ng-show=\"vm.loading\">\n<md-progress-circular class=\"ajax-loader md-accent md-hue-2\" md-mode=\"indeterminate\"></md-progress-circular></div>\n</div><div ng-if=\"vm.selectedTab === 1\"><form name=\"vm.detailForm\" ng-submit=\"vm.sendDetail()\"><div layout=\"column\" \nflex><div class=\"profile-box info-box general md-whiteframe-1dp\" layout=\"column\"><div class=\"content\"><div \nclass=\"info-line\"><div class=\"title\" translate=\"REQUISITION.DETAIL.PRODUCT\">Product</div><div class=\"info\">\n{{vm.detail.product.productCode}} {{vm.detail.product.name}}</div><div class=\"notes\"><span \nng-if=\"vm.detail.product.brand\"><strong>Marca: </strong>{{vm.detail.product.brand.name}}</span><br><span \nng-if=\"vm.detail.product.measurementUnit\"><strong>Unidad de Medida: </strong>{{vm.detail.product.measurementUnit.name}}\n</span></div></div></div></div></div><div layout=\"row\" layout-xs=\"column\"><md-input-container flex><label \ntranslate=\"REQUISITION.DETAIL.QUANTITY\">Quantity</label><input ng-model=\"vm.detail.quantity\" type=\"number\" \nname=\"quantity\" id=\"quantity\" required min=\"0.1\"><div ng-messages=\"vm.detailForm.quantity.$error\"><div \nng-message=\"required\" translate=\"REQUISITION.ERROR.FIELD_REQUIRED\">This date is required!</div></div>\n</md-input-container><md-input-container class=\"md-block\" readonly=\"readonly\"><md-switch class=\"md-primary\" \nng-model=\"vm.detail.consignment\" ng-disabled=\"true\">Es Consignación</md-switch></md-input-container></div>\n<md-input-container class=\"md-block\"><label translate=\"REQUISITION.DETAIL.OBSERVATIONS\">Observaciones</label><textarea \nrows=\"3\" maxlength=\"512\" ng-model=\"vm.detail.observations\" name=\"notes\"></textarea><div \nng-messages=\"vm.detailForm.notes.$error\"><div ng-message=\"maxlength\" translate=\"REQUISITION.ERROR.MEX_LENGTH\">\nThis date is required!</div></div></md-input-container></form><md-button ng-click=\"vm.sendDetail()\" \nclass=\"send-button md-accent md-fab md-fab-bottom-right\" aria-label=\"Send\" ng-if=\"vm.detailForm.$valid\" \nng-disabled=\"vm.loading\" translate-attr-aria-label=\"REQUISITION.DETAIL.SEND\"><md-icon md-font-icon=\"icon-content-save\">\n</md-icon></md-button></div></md-dialog-content><md-dialog-actions style=\"justify-content: center\" \nclass=\"actionsSpace\" ng-if=\"vm.selectedTab === 0 && !vm.creatingProduct\"><div paging class=\"pageable-div\" \npage=\"vm.page\" ul-class=\"pagination\" page-size=\"vm.pageSize\" hide-if-empty=\"true\" paging-action=\"vm.getProducts(page)\" \ntotal=\"vm.productos.totalElements\"></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/requisition/requisition/compose/createProduct.html","<form name=\"pro.createProduct\"><div layout=\"column\" class=\"p-16\"><md-input-container flex><label \ntranslate=\"REQUISITION.CREATEPRODUCT.NAME\"></label><input type=\"text\" name=\"name\" ng-model=\"pro.product.name\" required>\n<div ng-messages=\"pro.createProduct.name.$error\" ng-show=\"pro.createProduct.name.$touched\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"REQUISITION.CREATEPRODUCT.REQUIRED\"></span></div></div></md-input-container>\n<md-input-container flex><label translate=\"REQUISITION.CREATEPRODUCT.MEASURE\"></label><md-select \nng-model=\"pro.product.measurementUnit.name\" name=\"measure\" required md-on-close=\"pro.clearSearchMeasure()\">\n<md-select-header><input id=\"searchMeasureses\" ng-model=\"pro.searchMeasures\" type=\"search\" \nplaceholder=\"Buscar Unidad Medida\"></md-select-header><md-optgroup label=\"Measures\"><md-option \nvalue=\"{{measure.name}}\" ng-repeat=\"measure in pro.measures| filter: pro.searchMeasures\">{{measure.name}}</md-option>\n</md-optgroup></md-select><md-progress-linear md-mode=\"indeterminate\" ng-if=\"pro.loadingCurrency\"></md-progress-linear>\n<div ng-messages=\"pro.createProduct.measure.$error\" ng-show=\"pro.createProduct.measure.$touched\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"REQUISITION.CREATEPRODUCT.REQUIRED\"></span></div></div></md-input-container><div\n layout=\"row\" flex layout-align=\"center center\"><md-input-container flex ng-if=\"!pro.noExistBrand\"><label \ntranslate=\"REQUISITION.CREATEPRODUCT.BRAND\"></label><md-select ng-model=\"pro.product.brand.name\" name=\"brand\" required \nmd-on-close=\"pro.clearSearchBrand()\"><md-select-header><input id=\"searchBrand\" ng-model=\"pro.searchBrand\" \ntype=\"search\" placeholder=\"Buscar marca\"></md-select-header><md-optgroup label=\"Brands\"><md-option \nvalue=\"{{brand.name}}\" ng-repeat=\"brand in pro.brands| filter:pro.searchBrand\">{{brand.name}}</md-option></md-optgroup>\n</md-select><md-progress-linear md-mode=\"indeterminate\" ng-if=\"pro.loadingBrands\"></md-progress-linear><div \nng-messages=\"pro.createProduct.brand.$error\"><div ng-message=\"required\"><span \ntranslate=\"REQUISITION.CREATEPRODUCT.REQUIRED\"></span></div></div></md-input-container><md-input-container flex \nng-if=\"pro.noExistBrand\"><label translate=\"REQUISITION.CREATEPRODUCT.BRANDNEW\"></label><input type=\"text\" id=\"ipBrand\" \nname=\"brand\" ng-model=\"pro.product.brand.name\" required autofocus><div ng-messages=\"pro.createProduct.brand.$error\" \nng-show=\"pro.createProduct.brand.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"REQUISITION.CREATEPRODUCT.REQUIRED\"></span></div></div></md-input-container><md-button \nclass=\"md-icon-button\" ng-click=\"pro.changeBrand()\" aria-label=\"brand\"><div ng-if=\"!pro.noExistBrand\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon><md-tooltip>{{\'REQUISITION.CREATEPRODUCT.BRANDADD\'| translate}}</md-tooltip></div>\n<div ng-if=\"pro.noExistBrand\"><md-tooltip>{{\'REQUISITION.CREATEPRODUCT.BRANDSEARCH\'| translate}}</md-tooltip><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon></div></md-button></div><md-input-container flex><label \ntranslate=\"REQUISITION.CREATEPRODUCT.TYPE\"></label><md-select ng-model=\"pro.product.type\" name=\"type\" required>\n<md-option value=\"P\">{{\'REQUISITION.CREATEPRODUCT.TYPES.P\'|translate}}</md-option><md-option value=\"S\">\n{{\'REQUISITION.CREATEPRODUCT.TYPES.S\'|translate}}</md-option></md-select></md-input-container></div><md-button \nclass=\"md-fab md-fab-bottom-right\" ng-click=\"pro.saveContain();\" ng-disabled=\"pro.createProduct.$invalid\"><md-icon \nmd-font-icon=\"icon-content-save\"></md-icon><md-tooltip>{{\'REQUISITION.CREATEPRODUCT.SAVE\'| translate}}</md-tooltip>\n</md-button></form>");
$templateCache.put("app/main/apps/requisition/requisition/dialogDetailZero/dialogDetailZero.html","<md-dialog class=\"\" style=\"width:40%; height:40%\"><md-toolbar class=\"md-warn md-hue-2\"><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><h2>{{\"REQUISITION.MSG.ALERT\" |translate}}</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" tranlate \ntranslate-aria-label=\"MAIL.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content flex ng-class=\"\'md-dialog-list-content\'\"><h3>{{\"REQUISITION.MSG.HAVEDETAILZERO\" | translate}}</h3>\n<md-checkbox ng-model=\"vm.ignoreDetailZero\">{{\"REQUISITION.MSG.IGNREDETAILZERO\" | translate}}</md-checkbox>\n</md-dialog-content><md-dialog-actions style=\"justify-content: center\" class=\"actionsSpace\"><md-button \nng-disabled=\"!vm.ignoreDetailZero\" class=\"md-raised md-primary\" ng-click=\"vm.okDetail()\" aria-label=\"present budget\" \ntranslate translate-attr-aria-label=\"REQUISITION.MSG.SI\"><span>{{\'REQUISITION.MSG.SI\' | translate}}</span></md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/requisition/requisition/productsByBudget/productsByBudget-dialog.html","<md-dialog aria-label=\"New Message\" ms-scroll id=\"productsByBudget\" style=\"\"><md-toolbar class=\"md-accent md-hue-2\">\n<div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><h2>\n{{\'TEMPLATE.SELECT_PRODUCTS\'|translate}}</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" tranlate translate-aria-label=\"MAIL.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><div layout=\"row\" layout-align=\"center center\"><div \nlayout-gt-xs=\"row\" layout-align=\"start center\" layout-align=\"start center\"><div layout=\"row\" layout-xs=\"row\" \nlayout-align=\"space-around center\"><md-datepicker type=\"date\" ng-model=\"vm.filter.startDate\" \nmd-placeholder=\"{{\'REQUISITION.START_DATE\' | translate}}\" name=\"startDate\" md-open-on-focus></md-datepicker>\n<md-datepicker type=\"date\" ng-model=\"vm.filter.endDate\" md-placeholder=\"{{\'REQUISITION.END_DATE\' | translate}}\" \nname=\"endDate\" md-min-date=\"vm.filter.startDate\" md-open-on-focus></md-datepicker></div><md-button \nclass=\"md-icon-button\" ng-click=\"vm.getTemplate()\" aria-label=\"Close dialog\" tranlate \ntranslate-aria-label=\"MAIL.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button></div></div>\n<md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loading\" class=\"md-accent\"></md-progress-linear><md-checkbox \nng-if=\"vm.templates && vm.templates.length > 0\" ng-model=\"vm.selectAll\" ng-click=\"vm.selectAllItems()\">\n{{\'TEMPLATE.SELECT_ALL\'|translate}}</md-checkbox><div layout=\"row\" style=\"height: 200px\"><div id=\"masterGridOptions\" \nag-grid=\"vm.masterGridOptions\" class=\"ag-fresh\" expand-grid min=\"300\" other=\"40\"></div></div><md-button \naria-label=\"sendTemplates\" class=\"md-fab md-fab-bottom-right md-mini\" ng-click=\"vm.sendData()\" \nng-disabled=\"vm.loading || !(vm.itemSelected.length > 0)\"><md-icon md-font-icon=\"icon-content-save\"></md-icon>\n</md-button></md-dialog>");
$templateCache.put("app/main/apps/requisition/requisition/selectCompany/selectcompany-dialog.html","<md-dialog aria-label=\"New Message\" ms-scroll style=\"min-width: 450px\"><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><h2>Seleccione Rol</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" tranlate \ntranslate-aria-label=\"MAIL.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll flex layout-fill><form name=\"vm.companyValid\"><md-input-container flex class=\"md-block\">\n<label translate=\"REQUISITION.ROLE\">Empresa</label><md-select ng-model=\"vm.company\" name=\"currency\" required \nmd-on-close=\"vm.clearSearchRole()\"><md-select-header><input id=\"searchRole\" ng-model=\"vm.searchRole\" type=\"search\" \nplaceholder=\"Buscar Role\"></md-select-header><md-optgroup label=\"Departamentos\"><md-option \nng-repeat=\"comp in vm.companies| filter:vm.searchRole\" ng-value=\"{{comp}}\">\n{{comp.role.description}} ({{comp.company.name}})</md-option></md-optgroup></md-select></md-input-container></form>\n</md-dialog-content><md-dialog-actions style=\"justify-content: center\" class=\"actionsSpace\"><md-button \nclass=\"md-raised\" ng-click=\"vm.selectCompany()\" ng-disabled=\"vm.companyValid.$invalid\"><span \ntranslate=\"REQUISITION.MSG.ACCEPT\"></span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/requisition/requisition/selectTemplates/selecttemplates-dialog.html","<md-dialog aria-label=\"New Message\" ms-scroll id=\"selectTemplates\" style=\"\"><md-toolbar class=\"md-accent md-hue-2\"><div\n class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><h2>{{\'TEMPLATE.SELECT_PRODUCTS\'|translate}}\n</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" \ntranlate translate-aria-label=\"MAIL.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loading\" class=\"md-accent\"></md-progress-linear><div\n layout=\"row\"><md-input-container flex-gt-xs><md-checkbox ng-if=\"vm.templates && vm.templates.length > 0\" \nng-model=\"vm.selectAll\" ng-click=\"vm.selectAllTemplates()\">{{\'TEMPLATE.SELECT_ALL\'|translate}}</md-checkbox>\n</md-input-container><md-input-container flex-gt-xs><label translate=\"REQUISITION.REQUISITION_TYPE\">requisitionType\n</label><md-select ng-model=\"vm.requisitionType.id\" ng-required=\"true\" name=\"requisitionType\" ng-disabled=\"vm.loading\" \nmd-on-close=\"vm.clearSearchRequisitionType()\" ng-change=\"vm.getDataTemplate()\"><md-select-header><input \nid=\"searchRequisitionType\" name=\"searchRequisitionType\" ng-model=\"vm.searchRequisitionType\" type=\"search\" \nplaceholder=\"Buscar tipo de requerimiento\"></md-select-header><md-optgroup label=\"requisitionTypes\"><md-option \nng-value=\"{{data.id}}\" ng-repeat=\"data in vm.requisitionTypes| filter:vm.searchRequisitionType\">{{data.description}}\n</md-option></md-optgroup></md-select><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loading\">\n</md-progress-linear><div ng-messages=\"vm.requisitionForm.requisitionType.$error\"><div ng-message=\"required\" \ntranslate=\"REQUISITION.ERROR.FIELD_REQUIRED\">This is required!</div></div></md-input-container></div><div layout=\"row\" \nstyle=\"height: 200px\"><div id=\"masterGridOptions\" ag-grid=\"vm.masterGridOptions\" class=\"ag-fresh\" expand-grid \nmin=\"200\" other=\"40\"></div></div><md-button aria-label=\"sendTemplates\" class=\"md-fab md-fab-bottom-right md-mini\" \nng-click=\"vm.sendTemplates()\" ng-disabled=\"!(vm.templatessSend.length > 0)\"><md-icon md-font-icon=\"icon-content-save\">\n</md-icon></md-button></md-dialog>");
$templateCache.put("app/main/apps/requisition/requisition-autorize/detailRow/requisitionDetail.html","<div class=\"contariner-detail-template md-background-bg md-whiteframe-1dp content-custom\" id=\"containerDetail{{id}}\">\n<table class=\"dataTable row-border hover\" datatable=\"ng\" style=\"width: 100%\" dt-options=\"dtOptions\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"REQUISITION.DETAIL.QUANTITY\">\nCantidad</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"REQUISITION.DETAIL.PRODUCT\">Producto</span></div></th><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\" translate=\"REQUISITION.DETAIL.CURRENT_PRICE\">Precio Actual</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"REQUISITION.DETAIL.CONSIGNACION\">Consignacion</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"REQUISITION.DETAIL.OBSERVATIONS\">Observaciones</span></div>\n</th></tr></thead><tbody><tr ng-repeat=\"detail in details| orderBy:\'id\'\"><td>{{detail.quantity| number:0}}</td><td>\n{{detail.product.name}}</td><td>{{detail.currentPrice| number:2}}</td><td><md-icon \nmd-font-icon=\"{{detail.consignment ? \'icon-check\' : \'icon-close\'}}\"></md-icon></td><td>{{detail.observations}}</td>\n</tr></tbody></table></div>");
$templateCache.put("app/main/apps/requisition/requisition-compare/requisition-compare-dialog/requisition-compare-dialog.html","<md-dialog class=\"requisition-compare-dialog\" aria-label=\"requisition-compare-dialog\"><md-toolbar id=\"dialog-toolbar\" \nclass=\"md-accent md-hue-2\" layout=\"row\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\">\n<span>{{\'REQUISITION.SEARCH\'| translate}} {{\'REQUISITION.REQUISITION\'| translate}}</span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" tranlate \ntranslate-aria-label=\"MAIL.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<div ng-include=\"\'app/main/apps/reports/sidenavs/filter/h-filter.html\'\"></div><md-dialog-content class=\"content\"><div \nlayout=\"row\" layout-align=\"start center\" class=\"select-all\" ng-if=\"!vm.load\"><md-checkbox \nng-if=\"vm.requisitions.length > 0\" ng-model=\"vm.isCheckAllRequisition\" ng-change=\"vm.selectAllRequisition()\">\n{{\'REQUISITION.SELECT_ALL\'| translate}}</md-checkbox></div><div ng-style=\"vm.dinamicHeight\" class=\"custom-list\" \nms-scroll ng-if=\"!vm.load\"><div ng-click=\"vm.toggle(row, $event)\" class=\"item\" \nng-class=\"{\'selected\': vm.isSelected(row)}\" ng-repeat=\"row in vm.requisitions\"><div layout=\"row\" \nlayout-align=\"start center\"><md-icon ng-if=\"vm.isSelected(row)\" md-font-icon=\"icon-checkbox-marked\"></md-icon><md-icon \nng-if=\"!vm.isSelected(row)\" md-font-icon=\"icon-checkbox-blank-outline\"></md-icon><div flex class=\"description\" \nlayout=\"column\"><span><b>{{\'REQUISITION.DEPARTMENT\'| translate}}: </b>{{row.departmentDescription}}</span> <span><b>\n{{\'REQUISITION.COST_CENTER\'| translate}}: </b>{{row.costCenterDescription}}</span> <span><b>\n{{\'REQUISITION.CREATED_AT\'| translate}}: </b>{{row.createdAt| apiDate: \'dd-MM-yyyy HH:mm\'}}</span> <span><b>\n{{\'REQUISITION.REQUISITION_TYPE\'| translate}}: </b>{{row.requisitionTypeDescription}}</span></div></div></div></div>\n<div ng-style=\"vm.dinamicHeight\" ng-if=\"vm.load\" layout=\"column\" layout-align=\"center center\"><md-progress-circular \nmd-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular><span>{{\'REQUISITION.MSG.LOADING\'| translate}}...\n</span></div><div layout=\"row\" ng-if=\"!vm.load && vm.requisitions.length > 0\"><div flex layout=\"row\" \nlayout-align=\"space-between center\"><div paging class=\"pageable-div center\" page=\"vm.pagination.pageNumber\" \nul-class=\"pagination\" page-size=\"vm.pagination.pageSize\" hide-if-empty=\"false\" \npaging-action=\"vm.pagination.getPage(page)\" total=\"vm.pagination.totalElements\"></div><md-button type=\"submit\" \nng-click=\"vm.compare()\" class=\"send-button md-accent md-raised\" ng-disabled=\"vm.selectedArray.length === 0\" \naria-label=\"SAVE\" translate=\"REQUISITION.COMPARE\" translate-attr-aria-label=\"CONTACTS.SAVE\">\n{{\'REQUISITION.COMPARE\'| translate}}</md-button></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/apps/requisition/requisition-report/requisitionEditDataBussines/requisitionEditDataBussines.html","<md-dialog id=\"quotation-history-products\"><md-toolbar layout=\"row\" class=\"tools-dialog-photo\"><div class=\"title\" flex \nlayout=\"row\" layout-align=\"start center\"><h3>{{\'REQUISITION.MSG.EDITBUSSINESDATA\' | translate}}</h3></div><div flex \nlayout=\"row\" layout-align=\"end center\"><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-progress-linear md-mode=\"indeterminate\" \nng-if=\"vm.loading\"></md-progress-linear><form name=\"vm.requisitionForm\"><div \nclass=\"order-detail-form-container status md-background-bg md-whiteframe-1dp\" style=\"min-height: 250px\"><div \nlayout-gt-xs=\"row\" layout-align=\"start center\" layout-align=\"start center\"><md-input-container flex-gt-xs><label \ntranslate=\"CONTRACT.DEPARTMENT\">Department</label><md-select ng-model=\"vm.requisition.department.id\" name=\"department\" \nrequired ng-disabled=\"vm.loadingDepartments\" md-on-close=\"vm.clearSearchDepartment()\"><md-select-header><input \nid=\"searchDepartment\" ng-model=\"vm.searchDepartment\" type=\"search\" placeholder=\"Buscar departamento\">\n</md-select-header><md-optgroup label=\"Departamentos\"><md-option ng-value=\"depto.id\" \nng-repeat=\"depto in vm.departments| filter:vm.searchDepartment\">{{depto.description}}</md-option></md-optgroup>\n</md-select><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loadingDepartments\"></md-progress-linear><div \nng-messages=\"vm.requisitionForm.department.$error\"><div ng-message=\"required\" \ntranslate=\"CONTRACT.ERROR.FIELD_REQUIRED\">This is required!</div></div></md-input-container></div><div \nlayout-gt-xs=\"row\" layout-align=\"start center\" layout-align=\"start center\"><md-input-container flex-gt-xs><label \ntranslate=\"CONTRACT.COST_CENTER\">Cost Center</label><md-select ng-model=\"vm.requisition.costCenter.id\" \nname=\"costcenter\" md-on-close=\"vm.clearSearchCostCenter()\" required ng-disabled=\"vm.loadingCostCenter\">\n<md-select-header><input id=\"searchCostCenter\" ng-model=\"vm.searchCostCenter\" type=\"search\" \nplaceholder=\"Buscar centro de costo\"></md-select-header><md-optgroup><md-option ng-value=\"cc.id\" \nng-repeat=\"cc in vm.costCenters| filter:vm.searchCostCenter\">{{cc.description}}</md-option></md-optgroup></md-select>\n<md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loadingCostCenter\"></md-progress-linear><div \nng-messages=\"vm.requisitionForm.costcenter.$error\"><div ng-message=\"required\" \ntranslate=\"CONTRACT.ERROR.FIELD_REQUIRED\">This is required!</div></div></md-input-container></div><md-button \nclass=\"md-fab md-fab-bottom-right\" ng-disabled=\"vm.requisitionForm.$invalid || vm.requisitionForm.$pristine\" \nng-click=\"vm.sendDataCompany()\"><md-icon md-font-icon=\"icon-content-save\"></md-icon></md-button></div></form>\n</md-dialog>");
$templateCache.put("app/main/apps/requisition/requisition-cotize/addRequisitionToQuote/addRequisitionToQuote.html","<md-dialog class=\"compose-dialog\" aria-label=\"New Message\" ms-scroll><md-toolbar class=\"md-accent md-hue-2\" \nlayout=\"row\" ng-if=\"!vm.searchMode\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\">\n<div><span translate=\"USER_ASIGNMENT.ASSIGNMET_USER_TO_REQUISITION_TO_QUOTE\"></span></div><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" tranlate \ntranslate-aria-label=\"MAIL.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon><md-tooltip md-direction=\"left\">\n{{\'general.cancel\'| translate}}</md-tooltip></md-button></div></md-toolbar><md-dialog-content ms-scroll flex \nlayout-fill class=\"md-dialog-list-content\"><div ng-show=\"false\"><md-input-container><input type=\"text\" \nng-model=\"vm.user.account\" name=\"userName\" required aria-label=\"requisitionUser\"></md-input-container></div><div \nid=\"userList\" class=\"custom-list\" ms-scroll expand-grid min=\"200\" other=\"235\"><div class=\"search-list\" layout=\"row\" \nlayout-align=\"start center\"><input flex type=\"search\" ng-model=\"vm.searchUserInput\" \nplaceholder=\"{{\'USER_ASIGNMENT.SEARCH_USER\'| translate}}\" ng-enter=\"vm.paginationUsers.getPage(1)\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.paginationUsers.getPage(1)\"><md-icon md-font-icon=\"icon-magnify\"></md-icon>\n<md-tooltip md-direction=\"left\">{{\'USER_ASIGNMENT.SEARCH_USER\'| translate}}</md-tooltip></md-button></div><div \nng-if=\"vm.userArray.length > 0 && !vm.isShowLoaderUsers\"><div class=\"item\" ng-repeat=\"user in vm.userArray\" \nng-click=\"vm.toggleUser(user)\"><div layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-radiobox-marked\" ng-if=\"user.id === vm.requisition.userToQuote.id\"></md-icon><md-icon \nmd-font-icon=\"icon-radiobox-blank\" ng-if=\"user.id !== vm.requisition.userToQuote.id\"></md-icon><div flex \nclass=\"user-name\">{{user.account}} / {{user.name}}</div></div></div></div><div \nng-if=\"vm.userArray.length === 0 && !vm.isShowLoaderUsers\" layout=\"column\" layout-align=\"center center\" \nclass=\"message-empty-list\"><div>{{\"USER_ASIGNMENT.USER_LIST_EMPTY\" | translate}}</div></div><div layout=\"column\" \nlayout-align=\"center center\" class=\"loader-content-list\" ng-if=\"vm.isShowLoaderUsers\"><md-progress-circular \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular><div>\n{{\'USER_ASIGNMENT.LOADING_USER_LIST\'| translate}}...</div></div></div><div layout=\"row\" layout-align=\"center center\">\n<div paging class=\"pageable-div\" page=\"vm.paginationUsers.pageNumber\" ul-class=\"pagination\" \npage-size=\"vm.paginationUsers.pageSize\" paging-action=\"vm.paginationUsers.getPage(page)\" \ntotal=\"vm.paginationUsers.totalElements\"></div></div></md-dialog-content><md-dialog-actions \nlayout-align=\"space-between center\" class=\"actionsSpace\"><md-button ng-click=\"vm.closeDialog()\" \nclass=\"send-button md-fab-bottom-right md-primary\" aria-label=\"Send\" translate-attr-aria-label=\"DETAIL.CANCEL\"><span>\n{{\"general.cancel\" | translate}}</span><md-tooltip md-direction=\"left\">{{\"general.cancel\"| translate}}</md-tooltip>\n</md-button><md-button ng-click=\"vm.asociateUser()\" class=\"send-button md-fab-bottom-right md-primary\" \naria-label=\"Send\" ng-disabled=\"!vm.requisition.userToQuote \n            || vm.loadingAssociation\" \ntranslate-attr-aria-label=\"DETAIL.USER_TO_QUOTE\"><span>{{\"USER_ASIGNMENT.ASOCIATE_USER_TO_QUOTE\" | translate}}</span>\n<md-tooltip md-direction=\"left\">{{\"USER_ASIGNMENT.ASOCIATE_USER_TO_QUOTE\"| translate}}</md-tooltip></md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/requisition/requisition-cotize/detailRow/requisitionDetail.html","<div class=\"contariner-detail-template md-background-bg md-whiteframe-1dp content-custom\" id=\"containerDetail{{id}}\">\n<table class=\"dataTable row-border hover\" datatable=\"ng\" style=\"width: 100%\" dt-options=\"dtOptions\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"REQUISITION.DETAIL.QUANTITY\">\nCantidad</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"REQUISITION.DETAIL.PRODUCT\">Producto</span></div></th><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\" translate=\"REQUISITION.DETAIL.CURRENT_PRICE\">Precio Actual</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"REQUISITION.DETAIL.COTIZED\">\nCotizado</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"REQUISITION.DETAIL.CONSIGNACION\">Consignacion</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"REQUISITION.DETAIL.OBSERVATIONS\">Observaciones</span></div>\n</th></tr></thead><tbody><tr ng-repeat=\"detail in details| orderBy:\'id\'\"><td>{{detail.quantity| number:0}}</td><td>\n{{detail.product.name}}</td><td>{{detail.currentPrice| number:2}}</td><td><md-icon \nmd-font-icon=\"{{detail.cotizated ? \'icon-check\' : \'icon-close\'}}\"></md-icon></td><td><md-icon \nmd-font-icon=\"{{detail.consignment ? \'icon-check\' : \'icon-close\'}}\"></md-icon></td><td>{{detail.observations}}</td>\n</tr></tbody></table></div>");
$templateCache.put("app/main/apps/requisition/requisition-template/detail/template-detail-dialog.html","<md-dialog class=\"compose-dialog\" aria-label=\"New Message\" ms-scroll><md-toolbar class=\"md-accent md-hue-2\" \nlayout=\"row\" ng-if=\"!vm.searchMode\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div\n style=\"min-width: 400px\"><md-tabs md-selected=\"vm.selectedTab\" class=\"title\"><md-tab id=\"tab12\" \naria-controls=\"tab12-content\" label=\"{{\'REQUISITION.DETAIL.PRODUCT\'| translate}}\"></md-tab><md-tab \nng-disabled=\"!vm.detail.product\" id=\"tab22\" aria-controls=\"tab22-content\" \nlabel=\"{{\'REQUISITION.DETAIL.DETAILS\'| translate}}\"></md-tab></md-tabs></div><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.activeSearch()\" aria-label=\"Close dialog\" tranlate ng-if=\"vm.selectedTab === 0\" \ntranslate-aria-label=\"MAIL.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" tranlate \ntranslate-aria-label=\"MAIL.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-toolbar class=\"md-accent md-hue-2\" ng-show=\"vm.searchMode\"><form ng-submit=\"vm.getProducts(1)\" \nname=\"vm.searchForm\"><div class=\"md-toolbar-tools\"><md-button type=\"button\" class=\"md-icon-button\" \nng-click=\"vm.searchMode = !vm.searchMode\" aria-label=\"Back\"><ng-md-icon icon=\"arrow_back\"></ng-md-icon></md-button>\n<md-input-container flex style=\"margin-top: 60px\"><label translate=\"REQUISITION.DETAIL.FILTER\">Filtro</label><input \ntype=\"text\" ng-model=\"vm.filterProduct\" name=\"searchText\" required id=\"searchField\" \nng-model-options=\"{\'debounce\': 500}\"><div ng-messages=\"vm.searchForm.searchText.$error\"><div ng-message=\"required\" \ntranslate=\"REQUISITION.ERROR.FIELD_REQUIRED\">This date is required!</div></div></md-input-container><md-button \ntype=\"submit\" aria-label=\"Search\"><span translate=\"REQUISITION.DETAIL.SEARCH\">Search</span></md-button></div></form>\n</md-toolbar><md-dialog-content ms-scroll flex layout-fill \nng-class=\"vm.selectedTab === 0 ? \'md-dialog-list-content\' : \'\'\"><div ng-if=\"vm.selectedTab === 0\"><div \nclass=\"content thread-list\"><div class=\"thread\" md-ink-ripple ng-if=\"!vm.loading\" \nng-repeat=\"product in vm.productos.content\" ng-click=\"vm.selectProduct(product)\" \nng-class=\"{\n                                 \'current-thread\': vm.detail.product.id === product.id}\"><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"info\" flex layout=\"row\"><div><div class=\"title h3\"><strong>\n{{product.productCode ? product.productCode + \' - \' : \'\'}}{{product.name}}</strong></div><div class=\"notes\" \nlayout=\"column\"><span ng-if=\"product.brand\"><strong>Marca: </strong>{{product.brand}}</span> <span \nng-if=\"product.company\"><strong>Empresa: </strong>{{product.company}}</span> <span ng-if=\"product.measurementUnit\">\n<strong>Unidad de Medida: </strong>{{product.measurementUnit.name}}</span></div></div><span flex></span><div \nng-if=\"product.salePrice\"><h1>\n{{product.salePrice ? (product.buyPrice ? product.currencyBuy.symbol : product.currencySale.symbol) : \'\' }} {{(product.salePrice ? (product.buyPrice ? product.buyPrice : product.salePrice) : \'\') | number: 2}}\n</h1></div></div></div><div layout=\"column\" layout-align=\"space-between end\"><div class=\"actions\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"label ng-binding ng-scope md-green-300-bg\" role=\"button\" \nng-if=\"vm.detail.product.id === product.id\"><md-icon md-font-icon=\"icon-check-all\"></md-icon></div></div></div></div>\n</div><div class=\"div-loader\" ng-show=\"vm.loading\"><md-progress-circular class=\"ajax-loader md-accent md-hue-2\" \nmd-mode=\"indeterminate\"></md-progress-circular></div></div><div ng-if=\"vm.selectedTab === 1\"><form \nname=\"vm.detailForm\" ng-submit=\"vm.sendDetail()\"><div layout=\"column\" flex><div \nclass=\"profile-box info-box general md-whiteframe-1dp\" layout=\"column\"><div class=\"content\"><div class=\"info-line\"><div\n class=\"title\" translate=\"REQUISITION.DETAIL.PRODUCT\">Product</div><div class=\"info\">\n{{vm.detail.product.productCode}} {{vm.detail.product.name}}</div></div></div></div></div><div layout=\"row\" \nlayout-xs=\"column\"><md-input-container flex><label translate=\"REQUISITION.DETAIL.QUANTITY\">Quantity</label><input \nng-model=\"vm.detail.quantity\" type=\"number\" name=\"quantity\" required min=\"0.0\"><div \nng-messages=\"vm.detailForm.quantity.$error\"><div ng-message=\"required\" translate=\"REQUISITION.ERROR.FIELD_REQUIRED\">\nThis date is required!</div></div></md-input-container></div></form><md-button ng-click=\"vm.sendDetail()\" \nclass=\"send-button md-accent md-fab md-fab-bottom-right\" aria-label=\"Send\" ng-if=\"vm.detailForm.$valid\" \nng-disabled=\"vm.loading\" translate-attr-aria-label=\"REQUISITION.DETAIL.SEND\"><md-icon md-font-icon=\"icon-content-save\">\n</md-icon></md-button></div></md-dialog-content><md-dialog-actions style=\"justify-content: center\" \nclass=\"actionsSpace\" ng-if=\"vm.selectedTab === 0\"><div paging class=\"pageable-div\" page=\"vm.page\" \nul-class=\"pagination\" page-size=\"vm.pageSize\" hide-if-empty=\"true\" paging-action=\"vm.getProducts(page)\" \ntotal=\"vm.productos.totalElements\"></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/requisition/requisition-template/editor/requisition-template-shares.html","<div id=\"productTemplateO\" class=\"page-layout carded fullwidth\" layout=\"column\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><md-button class=\"goto-orders-button md-icon-button\" \naria-label=\"Back\" ng-click=\"vm.gotoTemplates()\" translate translate-attr-aria-label=\"TEMPLATE.PT.GO_TO_ORDERS\"><md-icon\n md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"column\" layout-align=\"start start\"><div class=\"h2\">\n<span translate=\"TEMPLATE.PT.PRODUCTTEMPLATE_USER_SHARES\">Order</span> <span>{{vm.productTemplate.id}}</span></div><div\n class=\"subtitle secondary-text\"></div></div></div></div><md-content class=\"content\" flex><div class=\"content-card\" \nlayout=\"column\" flex><div class=\"toolbar\"><div layout=\"row\"><div class=\"customer\" layout=\"column\"><span><strong \ntranslate=\"REQUISITION.DEPARTMENT\"></strong> {{vm.productTemplate.department.description}}</span> <span><strong \ntranslate=\"REQUISITION.COST_CENTER\"></strong> {{vm.productTemplate.costCenter.description}}</span></div><span flex>\n</span><div class=\"customer\" layout=\"column\"><span><strong translate=\"REQUISITION.DESCRIPTION\"></strong>\n {{vm.productTemplate.description}}</span></div><span flex></span></div></div><md-content class=\"content\" flex \nms-scroll><div class=\"content fullpage-datatable\" layout=\"column\" flex><form name=\"vm.detailForm\" \nng-submit=\"vm.addUser()\"><div layout=\"row\" layout-xs=\"column\"><md-input-container flex><label \ntranslate=\"TEMPLATE.PT.EMAIL\">email</label><input ng-model=\"vm.requisitionTemplateUser.user.account\" type=\"email\" \nname=\"email\" required><div ng-messages=\"vm.detailForm.email.$error\"><div ng-message=\"required\" \ntranslate=\"REQUISITION.ERROR.FIELD_REQUIRED\">This is required!</div></div></md-input-container><md-button \nng-click=\"vm.addUser()\" class=\"md-fab md-mini md-accent\" aria-label=\"Send\" ng-disabled=\"!vm.detailForm.$valid\" \ntranslate-attr-aria-label=\"REQUISITION.DETAIL.SEND\"><md-icon md-font-icon=\"icon-content-save\"></md-icon><md-tooltip \nmd-direction=\"left\">{{\"general.save\"| translate}}</md-tooltip></md-button></div></form><md-progress-linear \nmd-mode=\"indeterminate\" ng-if=\"vm.loading\" class=\"md-accent\"></md-progress-linear><div id=\"masterGridOptionsU\" \nag-grid=\"vm.masterGridOptionsU\" class=\"ag-fresh\" expand-grid min=\"260\" other=\"250\"></div></div></md-content></div>\n</md-content></div></div>");
$templateCache.put("app/main/apps/requisition/requisition-template/editor/requisition-template.html","<div id=\"productTemplateO\" class=\"page-layout carded fullwidth\" layout=\"column\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><md-button class=\"goto-orders-button md-icon-button\" \naria-label=\"Back\" ng-click=\"vm.gotoTemplates()\" translate translate-attr-aria-label=\"TEMPLATE.PT.GO_TO_ORDERS\"><md-icon\n md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"column\" layout-align=\"start start\"><div class=\"h2\">\n<span translate=\"TEMPLATE.PT.PRODUCTTEMPLATE\">Order</span> <span>{{vm.productTemplate.id}}</span></div><div \nclass=\"subtitle secondary-text\"></div></div></div></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"toolbar\"><div layout=\"row\"><md-tabs md-selected=\"vm.currentTab\" flex><md-tab id=\"tab1\" \naria-controls=\"tab1-content\"><span translate=\"TEMPLATE.PT.ENCABEZADO\">Configuración General </span></md-tab><md-tab \nng-disabled=\"vm.productTemplateForm.$invalid\" id=\"tab2\" aria-controls=\"tab2-content\"><span \ntranslate=\"TEMPLATE.PT.PRODUCTTEMPLATE_DETAILS\">Detalle</span></md-tab><md-tab ng-disabled=\"!vm.productTemplate.id\" \nid=\"tab3\" aria-controls=\"tab2-content\"><span translate=\"TEMPLATE.PT.REPITITIONS\">Repeticiones</span></md-tab></md-tabs>\n</div></div><md-content class=\"content\" flex ms-scroll><md-tabs md-dynamic-height md-selected=\"vm.currentTab\" \nclass=\"tab-in-content\"><md-tab aria-controls=\"tab1-content\"><md-tab-body><form name=\"vm.productTemplateForm\"><div \nlayout=\"column\" flex><div class=\"order-detail-form-container status md-background-bg md-whiteframe-1dp\" flex><div \nclass=\"customer\"><md-input-container flex-gt-xs class=\"md-block\"><label translate=\"TEMPLATE.DESCRIPTION\">DESCRIPTION\n</label><input ng-model=\"vm.productTemplate.description\" type=\"text\" name=\"description\" required><div \nng-messages=\"vm.productTemplateForm.description.$error\"><div ng-message=\"required\" \ntranslate=\"TEMPLATE.ERROR.FIELD_REQUIRED\">This date is required!</div></div></md-input-container><div \nlayout-gt-xs=\"row\" layout-align=\"start center\"><md-input-container flex-gt-xs><label translate=\"TEMPLATE.DEPARTMENT\">\nDepartment</label><md-select ng-model=\"vm.productTemplate.department.id\" name=\"department\" required \nng-disabled=\"vm.loadingDepartments\" md-on-close=\"vm.clearSearchDepartment()\"><md-select-header><input \nid=\"searchDepartment\" ng-model=\"vm.searchDepartment\" type=\"search\" placeholder=\"{{\'general.search\'| translate}}\">\n</md-select-header><md-optgroup label=\"Departamentos\"><md-option ng-value=\"{{depto.id}}\" \nng-repeat=\"depto in vm.departments| filter:vm.searchDepartment\">{{depto.description}}</md-option></md-optgroup>\n</md-select><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loadingDepartments\"></md-progress-linear><div \nng-messages=\"vm.productTemplateForm.department.$error\"><div ng-message=\"required\" \ntranslate=\"TEMPLATE.ERROR.FIELD_REQUIRED\">This date is required!</div></div></md-input-container><md-input-container \nflex-gt-xs><label translate=\"TEMPLATE.COSTCENTER\">Cost Center</label><md-select \nng-model=\"vm.productTemplate.costCenter.id\" name=\"costcenter\" md-on-close=\"vm.clearSearchCostCenter()\" required \nng-disabled=\"vm.loadingCostCenter\"><md-select-header><input id=\"searchCostCenter\" ng-model=\"vm.searchCostCenter\" \ntype=\"search\" placeholder=\"{{\'general.search\'| translate}}\"></md-select-header><md-optgroup><md-option \nng-value=\"{{cc.id}}\" ng-repeat=\"cc in vm.costCenters| filter:vm.searchCostCenter\">{{cc.description}}</md-option>\n</md-optgroup></md-select><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loadingCostCenter\">\n</md-progress-linear><div ng-messages=\"vm.productTemplateForm.costcenter.$error\"><div ng-message=\"required\" \ntranslate=\"TEMPLATE.ERROR.FIELD_REQUIRED\">This date is required!</div></div></md-input-container></div><div \nlayout-gt-xs=\"row\" layout-align=\"start center\"><md-input-container flex-gt-xs><label \ntranslate=\"REQUISITION.REQUISITION_TYPE\">RequisitionType</label><md-select readonly=\"readonly\" \nng-model=\"vm.productTemplate.requisitionType.id\" name=\"requisitionType\" ng-disabled=\"vm.loadingRequisitionType\" \nmd-on-close=\"vm.clearSearchDepartment()\"><md-select-header><input id=\"searchRequisitionType\" \nng-model=\"vm.searchRequisitionType\" type=\"search\" placeholder=\"{{\'general.search\'| translate}}\"></md-select-header>\n<md-optgroup label=\"requisitionTypes\"><md-option ng-value=\"{{requisitionType.id}}\" \nng-repeat=\"requisitionType in vm.requisitionTypes| filter:vm.searchRequisitionType\">{{requisitionType.description}}\n</md-option></md-optgroup></md-select><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loadingRequisitionType\">\n</md-progress-linear><div ng-messages=\"vm.productTemplateForm.requisitionType.$error\"><div ng-message=\"required\" \ntranslate=\"TEMPLATE.ERROR.FIELD_REQUIRED\">This data is required!</div></div></md-input-container></div><div \nlayout-gt-xs=\"row\" layout-align=\"start center\"><md-input-container flex-gt-xs ng-if=\"vm.dimensionCompanyDetail3\">\n<label>{{vm.dimensionCompanyDetail3.description}}</label><md-select \nng-model=\"vm.productTemplate.dimensionCompanyDetail3.id\" name=\"dimensionCompanyDetail3\" \nmd-on-close=\"vm.searchDimensionCompanyDetail3=\'\'\" ng-required=\"vm.dimensionCompanyDetail3.required\"><md-select-header>\n<input id=\"searchDimensionCompanyDetail3\" ng-model=\"vm.searchDimensionCompanyDetail3\" type=\"search\" translate \ntranslate-attr-placeholder=\"general.search\" aria-label=\"search-dimension-company\" \nng-keydown=\"$event.stopPropagation()\"></md-select-header><md-optgroup label=\"dimensionCompanyDetail3\"><md-option \nvalue=\"{{data.id}}\" \nng-repeat=\"data in vm.dimensionCompanyDetail3List|\n                                                                  filter:vm.searchDimensionCompanyDetail3\">\n{{data.code}} - {{data.name}}</md-option></md-optgroup></md-select><md-progress-linear md-mode=\"indeterminate\" \nng-if=\"vm.loadingdimensionCompanyDetail3List\"></md-progress-linear></md-input-container><md-input-container flex-gt-xs \nng-if=\"vm.dimensionCompanyDetail4\"><label>{{vm.dimensionCompanyDetail4.description}}</label><md-select \nng-model=\"vm.productTemplate.dimensionCompanyDetail4.id\" name=\"dimensionCompanyDetail4\" \nmd-on-close=\"vm.searchDimensionCompanyDetail4=\'\'\" ng-required=\"vm.dimensionCompanyDetail4.required\"><md-select-header>\n<input id=\"searchDimensionCompanyDetail4\" ng-model=\"vm.searchDimensionCompanyDetail4\" type=\"search\" translate \ntranslate-attr-placeholder=\"general.search\" aria-label=\"search-dimension-company\" \nng-keydown=\"$event.stopPropagation()\"></md-select-header><md-optgroup label=\"dimensionCompanyDetail4\"><md-option \nvalue=\"{{data.id}}\" \nng-repeat=\"data in vm.dimensionCompanyDetail4List|\n                                                                  filter:vm.searchDimensionCompanyDetail4\">\n{{data.code}} - {{data.name}}</md-option></md-optgroup></md-select><md-progress-linear md-mode=\"indeterminate\" \nng-if=\"vm.loadingdimensionCompanyDetail4List\"></md-progress-linear></md-input-container><md-input-container flex-gt-xs \nng-if=\"vm.dimensionCompanyDetail5\"><label>{{vm.dimensionCompanyDetail5.description}}</label><md-select \nng-model=\"vm.productTemplate.dimensionCompanyDetail5.id\" name=\"dimensionCompanyDetail5\" \nmd-on-close=\"vm.searchDimensionCompanyDetail5=\'\'\" ng-required=\"vm.dimensionCompanyDetail5.required\"><md-select-header>\n<input id=\"searchDimensionCompanyDetail5\" ng-model=\"vm.searchDimensionCompanyDetail5\" type=\"search\" translate \ntranslate-attr-placeholder=\"general.search\" aria-label=\"search-dimension-company\" \nng-keydown=\"$event.stopPropagation()\"></md-select-header><md-optgroup label=\"dimensionCompanyDetail5\"><md-option \nvalue=\"{{data.id}}\" \nng-repeat=\"data in vm.dimensionCompanyDetail5List|\n                                                                  filter:vm.searchDimensionCompanyDetail5\">\n{{data.code}} - {{data.name}}</md-option></md-optgroup></md-select><md-progress-linear md-mode=\"indeterminate\" \nng-if=\"vm.loadingdimensionCompanyDetail5List\"></md-progress-linear></md-input-container></div></div></div><div \nclass=\"inputs-forms-config\"><div layout-gt-xs=\"row\" layout-align=\"start center\"><md-input-container flex-gt-xs><label \ntranslate=\"TEMPLATE.PT.MONTHSTART\">Tipo de Fecha</label><md-select ng-model=\"vm.productTemplate.monthStart\" \nname=\"dateType\"><md-option value=\"{{dt.id + 1}}\" ng-repeat=\"dt in vm.months\">{{dt.name| translate}}</md-option>\n</md-select><div ng-messages=\"vm.productTemplateForm.dateType.$error\"><div ng-message=\"required\" \ntranslate=\"TEMPLATE.ERROR.FIELD_REQUIRED\">This date is required!</div></div></md-input-container><md-input-container \nflex-gt-xs><label translate=\"TEMPLATE.PT.YEARSTART\">Year</label><input ng-model=\"vm.productTemplate.yearStart\" \ntype=\"number\" min=\"{{vm.minYear}}\"></md-input-container></div><div layout-gt-xs=\"row\" layout-align=\"start center\">\n<md-input-container flex-gt-xs flex=\"50\"><label>{{(\'TEMPLATE.PT.FRECUENCY\' + vm.dateSearch.type) | translate}}</label>\n<md-select ng-model=\"vm.productTemplate.frecuency\" name=\"valType\"><md-option value=\"{{dt.id}}\" \nng-repeat=\"dt in vm.typesDates\">{{dt.name| translate}}</md-option></md-select></md-input-container><fieldset \nclass=\"standard input-repititions\" flex=\"50\"><legend translate=\"TEMPLATE.PT.REPITITIONS\"></legend><div \nlayout-gt-sm=\"row\"><md-input-container flex-gt-xs ng-if=\"vm.productTemplate.repititions > 0\"><input \nng-model=\"vm.productTemplate.repititions\" type=\"number\" min=\"0\" aria-label=\"repititions\"></md-input-container>\n<md-checkbox ng-model=\"vm.isIndefinide\" aria-label=\"isIndefinide\"><label translate=\"TEMPLATE.PT.INDEFINIDE\"></label>\n</md-checkbox></div></fieldset></div></div></div></form></md-tab-body></md-tab><md-tab aria-controls=\"tab2-content\">\n<md-tab-body><div id=\"masterGridOptionsDetail\" ag-grid=\"vm.masterGridOptionsDetail\" class=\"ag-fresh\" expand-grid \nmin=\"200\" other=\"90\"></div></md-tab-body></md-tab><md-tab aria-controls=\"tab3-content\"><md-tab-body><div \nid=\"masterGridOptionsFrecuency\" ag-grid=\"vm.masterGridOptionsFrecuency\" class=\"ag-fresh\" expand-grid min=\"200\" \nother=\"90\"></div></md-tab-body></md-tab></md-tabs></md-content></div></div></div><md-button \nclass=\"md-fab md-fab-bottom-right\" aria-label=\"addDetail\" ng-click=\"vm.openDialog($event)\" \nng-show=\"vm.currentTab === 1 && !vm.shareMe\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip \nmd-direction=\"left\">{{\"general.add\"| translate}}</md-tooltip></md-button><md-button class=\"md-fab md-fab-bottom-right\" \naria-label=\"addDetail\" ng-click=\"vm.currentTab = 1\" ng-show=\"vm.currentTab === 0 && !vm.shareMe\" \nng-disabled=\"vm.productTemplateForm.$invalid\"><md-icon md-font-icon=\"icon-arrow-right\"></md-icon><md-tooltip \nmd-direction=\"left\">{{\"general.next\"| translate}}</md-tooltip></md-button>");
$templateCache.put("app/main/apps/requisition/requisitionType/requisitionTypeEdit/requisitionTypeEdit.html","<md-dialog class=\"compose-dialog\" aria-label=\"New Message\" ms-scroll \nstyle=\"width: 35%; height: 60%; max-width:35%; max-height: 60%\"><md-toolbar class=\"md-accent md-hue-2\" layout=\"row\" \nng-if=\"!vm.searchMode\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div \nstyle=\"min-width: 400px\"><span>{{\'CONFIGURATION.REQUISITION_TYPE\'| translate}}\"</span></div><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" tranlate \ntranslate-aria-label=\"MAIL.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll flex layout-fill ng-class=\"vm.selectedTab === 0 ? \'md-dialog-list-content\' : \'\'\"><div>\n<form name=\"vm.detailForm\" ng-submit=\"vm.sendDetail()\"><div layout=\"row\" layout-xs=\"column\"><md-input-container \nflex-gt-xs><label translate=\"REQUISITION_TYPE.DESCRIPTION\">DESCRIPTION</label><textarea rows=\"3\" maxlength=\"512\" \nng-model=\"vm.requisitionType.description\" name=\"notes\" required></textarea><div \nng-messages=\"vm.detailForm.description.$error\"><div ng-message=\"maxlength\" translate=\"REQUISITION.ERROR.MEX_LENGTH\">\nThis required!</div></div></md-input-container></div></form><md-button ng-click=\"vm.sendDetail()\" \nclass=\"send-button md-accent md-fab md-fab-bottom-right\" aria-label=\"Send\" ng-if=\"vm.detailForm.$valid\" \nng-disabled=\"vm.loading\" translate-attr-aria-label=\"REQUISITION.DETAIL.SEND\"><md-icon md-font-icon=\"icon-content-save\">\n</md-icon><md-tooltip md-direction=\"left\">{{\"general.save\"| translate}}</md-tooltip></md-button></div>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/main/general/auth/directives/strengthPassword/strengthPassword.tpl.html","<div class=\"password-strength\"><div class=\"password-strength-label\">\n{{strengthLabel || \'js.passwordStrength\' | translate}}</div><div class=\"bar-container\"><div \nclass=\"bar {{strengthLevel}}\" style=\"width: {{lengthLevel}}%\"></div></div></div>");
$templateCache.put("app/main/general/profile/tabs/about/about.html","<div layout=\"row\" layout-wrap><div flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><form name=\"wizardStep1\" \nclass=\"md-inline-form\" novalidate><div class=\"about\" layout=\"column\" flex=\"200\" flex-gt-sm=\"100\" flex-gt-md=\"130\"><div \nclass=\"profile-box info-box general md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\"><div class=\"title\" \ntranslate=\"PROFILE.GENERAL_INFORMATION\">General Information</div></header><div class=\"content\"><div \nng-class=\"vm.editMode ? \'\' : \'info-line\'\"><div class=\"info-line\"><div class=\"title\" translate=\"PROFILE.FULLNAME\">\nFullname</div><div class=\"info\">\n{{vm.userInfo.name}} {{vm.userInfo.middleName}} {{vm.userInfo.familyName}} {{vm.userInfo.givenName}}</div></div><div \nlayout=\"row\" layout-sm=\"column\"><md-input-container flex=\"100\" flex-gt-xs=\"25\" flex-gt-md=\"50\"><input type=\"text\" \nname=\"firstname\" ng-model=\"vm.userInfo.name\" placeholder=\"{{\'PROFILE.EDIT.NAME\'| translate}}\" \nng-disabled=\"!vm.editMode\" required><div ng-messages=\"wizardStep1.firstname.$error\" role=\"alert\"><div \nng-message=\"required\"><span>{{\'PROFILE.EDIT.NAME\'| translate}} {{\'PROFILE.EDIT.REQUIRED\'| translate}}.</span></div>\n</div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"25\" flex-gt-md=\"50\"><input type=\"text\" \nname=\"middlename\" ng-model=\"vm.userInfo.middleName\" ng-disabled=\"!vm.editMode\" \nplaceholder=\"{{\'PROFILE.EDIT.SNAME\'| translate}}\"></md-input-container></div><div layout=\"row\" layout-sm=\"column\">\n<md-input-container flex=\"100\" flex-gt-xs=\"30\" flex-gt-md=\"50\"><input type=\"text\" name=\"familyName\" \nng-model=\"vm.userInfo.familyName\" ng-disabled=\"!vm.editMode\" placeholder=\"{{\'PROFILE.EDIT.LASTNAME\'| translate}}\">\n</md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"20\" flex-gt-md=\"50\"><input type=\"text\" \nname=\"givenName\" ng-model=\"vm.userInfo.givenName\" ng-disabled=\"!vm.editMode\" \nplaceholder=\"{{\'PROFILE.EDIT.TNAME\'| translate}}\"></md-input-container></div><div layout=\"row\" layout-sm=\"column\">\n<md-input-container flex=\"100\" flex-gt-xs=\"20\" flex-gt-md=\"50\"><input type=\"text\" name=\"nickname\" \nng-model=\"vm.userInfo.nickname\" ng-disabled=\"!vm.editMode\" placeholder=\"{{\'PROFILE.EDIT.NICKNAME\'| translate}}\">\n</md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>{{\'PROFILE.EDIT.GENDER\'| translate}}</label>\n<md-select ng-model=\"vm.userInfo.gender\" ng-disabled=\"!vm.editMode\"><md-option ng-repeat=\"gender in vm.genders\" \nvalue=\"{{gender}}\">{{\'SEXO.\' + gender| translate}}</md-option></md-select></md-input-container></div>\n<md-input-container class=\"md-block\"><label translate=\"PROFILE.BIRTHDAY\">birthdate</label><md-datepicker \nng-model=\"vm.userInfo.birthdate\" name=\"birthday\" md-open-on-focus ng-disabled=\"!vm.editMode\"></md-datepicker><div \nng-messages=\"vm.wizardStep1.birthday.$error\"><div ng-message=\"valid\" translate=\"PROFILE.INVALID_DATE\">\nThe entered value is not a date!</div><div ng-message=\"required\">\n{{\'PROFILE.BIRTHDAY\'| translate}} {{\'PROFILE.EDIT.REQUIRED\'| translate}}</div></div></md-input-container>\n<md-input-container class=\"md-block\"><label>{{\'PROFILE.ABOUT_ME\'| translate}}</label><textarea rows=\"3\" name=\"profile\" \nmd-maxlength=\"150\" max-rows=\"5\" ng-disabled=\"!vm.editMode\" ng-model=\"vm.userInfo.profile\">\n                                </textarea></md-input-container><md-input-container class=\"md-block\" ng-if=\"true\">\n<input id=\"fileInput\" type=\"file\" class=\"ng-hide\" name=\"photo\" aria-label=\"fileInput\" ng-disabled=\"!vm.editMode\" \nfile-model=\"vm.filesToUpload\" accept=\"image/jpeg, image/jpg\"><md-button class=\"md-raised md-button\" \nng-click=\"uploadf3()\" ng-disabled=\"!vm.editMode\" ng-show=\"vm.editMode\" translate=\"PROFILE.SELECT_PICTURE\"><md-icon \nmd-svg-icon=\"border-color\"></md-icon><label>AwesomeButtonName</label></md-button></md-input-container></div></div>\n</div><div class=\"profile-box company md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"title\" translate=\"PROFILE.EMPRESAS\">Empresas</div></header><div \nclass=\"content-wrapper\" layout=\"column\" flex><div class=\"content thread-list\" ms-scroll flex><div class=\"thread\" \nmd-ink-ripple style=\"cursor: pointer\"><div layout=\"row\" layout-align=\"start center\"><div class=\"info\" flex><ul><li \nng-repeat=\"c in vm.company\"><strong><span>{{c.name}}</span></strong>({{c.email}})</li></ul></div></div></div></div>\n</div></div></div></form></div><div flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><form name=\"wizardStep2\" \nclass=\"md-inline-form\" novalidate><div class=\"about\" layout=\"column\" flex=\"200\" flex-gt-sm=\"100\" flex-gt-md=\"130\"><div \nclass=\"profile-box info-box general md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\"><div layout=\"row\">\n<div class=\"title\" translate=\"PROFILE.CONTACT\">Contact</div></div></header><div class=\"content\"><div class=\"info-line\">\n<div class=\"title\" translate=\"PROFILE.EMAILS\">Emails</div><div class=\"info\">{{vm.userInfo.email}}</div></div><div \nlayout=\"column\" layout-gt-sm=\"row\" flex><md-input-container flex=\"100\" flex-gt-xs=\"70\" flex-gt-md=\"70\"><label>\n{{\'PROFILE.EDIT.ADDRESS\'| translate}}</label><textarea rows=\"1\" name=\"address\" md-maxlength=\"150\" max-rows=\"3\" \nng-disabled=\"!vm.editMode\" ng-model=\"vm.userInfo.locale\">\n                                </textarea>\n</md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"30\" flex-gt-md=\"30\"><label>\n{{\'PROFILE.EDIT.POSTAL\'| translate}}</label><input name=\"postalcode\" ng-model=\"vm.userInfo.zoneinfo\" \nplaceholder=\"12345\" ng-disabled=\"!vm.editMode\" ng-pattern=\"/^[0-9]{5}$/\" md-maxlength=\"5\"><div \nng-messages=\"wizardStep1.postalcode.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"pattern\"><span>\nThat doesn\'t look like a valid postal code.</span></div><div ng-message=\"md-maxlength\"><span>\nPostal code can\'t be longer than 5 characters.</span></div></div></md-input-container></div><md-input-container \nclass=\"md-block\"><input type=\"tel\" name=\"phone\" ng-model=\"vm.userInfo.phoneNumber\" ng-disabled=\"!vm.editMode\" \nplaceholder=\"{{\'PROFILE.EDIT.PHONE\'| translate}}\"></md-input-container><md-input-container class=\"md-block\"><input \ntype=\"url\" name=\"website\" ng-model=\"vm.userInfo.website\" ng-disabled=\"!vm.editMode\" \nplaceholder=\"{{\'PROFILE.EDIT.WEBSITE\'| translate}}\"></md-input-container></div></div></div></form></div></div>");
$templateCache.put("app/main/general/profile/tabs/password/password.html","<div layout=\"row\" layout-wrap layout-align=\"center center\"><div flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><form \nname=\"changePasswordForm\" class=\"md-inline-form\" novalidate><div class=\"about\" layout=\"column\" flex=\"200\" \nflex-gt-sm=\"100\" flex-gt-md=\"130\"><div class=\"profile-box info-box general md-whiteframe-1dp\" layout=\"column\"><header \nclass=\"md-accent-bg\"><div layout=\"row\"><div class=\"title\" translate=\"PROFILE.CHANGE_PASSWORD\">Change Password</div>\n<span flex></span><md-button type=\"submit\" class=\"md-raised md-warn\" \nng-disabled=\"changePasswordForm.$invalid || changePasswordForm.$pristine\" ng-click=\"vm.sendFormChangePassword();\"><span\n translate=\"PROFILE.EDIT.CHANGE\">Change</span></md-button></div></header><div class=\"content\" layout=\"column\">\n<md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"password\" name=\"password\" id=\"password\" \nng-model=\"vm.pass.newPassword\" placeholder=\"{{\'PROFILE.EDIT.NEW_PASSWORD\'| translate}}\" ng-required=\"true\">\n</md-input-container><div my-password-strength password=\"vm.pass.newPassword\"></div><md-input-container flex=\"100\" \nflex-gt-xs=\"50\"><input type=\"password\" name=\"passwordConfirm\" \nplaceholder=\"{{\'PROFILE.EDIT.PASSWORD\'| translate}} ({{\'PROFILE.EDIT.CONFIRM\'| translate}})\" \nng-model=\"vm.pass.validatePassword\" pw-check=\"password\" ng-required=\"true\"><div \nng-messages=\"wizardStep12.passwordConfirm.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\n{{\'PROFILE.EDIT.PASSWORD\'| translate}} ({{\'PROFILE.EDIT.CONFIRM\'| translate}}) {{\'PROFILE.EDIT.REQUIRED\'| translate}}.\n</span></div><div ng-message=\"pattern\"><span>\n{{\'PROFILE.EDIT.PASSWORD\'| translate}} ({{\'PROFILE.EDIT.CONFIRM\'| translate}}) {{\'PROFILE.EDIT.MATCH\'| translate}}.\n</span></div></div></md-input-container></div></div></div></form></div></div>");
$templateCache.put("app/main/general/profile/tabs/photos-videos/photos-videos.html","<div class=\"photos-videos\"><div class=\"period\" data-ng-repeat=\"period in vm.photosVideos\"><div class=\"period-title\">\n<span class=\"name\">{{period.name}}</span> <span class=\"info\">{{period.info}}</span></div><div class=\"period-media\" \nlayout=\"row\" layout-wrap><div class=\"media\" ng-repeat=\"media in period.media\"><img class=\"preview\" \nng-src=\"{{media.preview}}\" title=\"{{media.title}}\" alt=\"image\"><div class=\"title\">{{media.title}}</div></div></div>\n</div></div>");
$templateCache.put("app/main/general/profile/tabs/timeline/timeline.html","<div layout=\"row\" layout-wrap><div class=\"timeline\" layout=\"column\" flex=\"100\" flex-gt-sm=\"55\" flex-gt-md=\"65\" \nflex-order=\"2\" flex-order-gt-sm=\"1\"><div class=\"profile-box add-post md-whiteframe-1dp\"><div class=\"form\" flex>\n<textarea placeholder=\"Write something..\" translate translate-attr-placeholder=\"PROFILE.WRITE_SOMETHING\"></textarea>\n<footer layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button\" aria-label=\"insert photo\" translate translate-attr-aria-label=\"PROFILE.INSERT_PHOTO\"><md-icon \nmd-font-icon=\"icon-file-image-box\"></md-icon><md-tooltip><span translate=\"PROFILE.INSERT_PHOTO\">insert photo</span>\n</md-tooltip></md-button><md-button class=\"md-icon-button\" aria-label=\"add person\" translate \ntranslate-attr-aria-label=\"PROFILE.ADD_PERSON\"><md-icon md-font-icon=\"icon-person-plus\"></md-icon><md-tooltip><span \ntranslate=\"PROFILE.ADD_PERSON\">add person</span></md-tooltip></md-button><md-button class=\"md-icon-button\" \naria-label=\"add location\" translate translate-attr-aria-label=\"PROFILE.LOCATION\"><md-icon \nmd-font-icon=\"icon-map-marker\"></md-icon><md-tooltip><span translate=\"PROFILE.LOCATION\">add location</span>\n</md-tooltip></md-button></div><md-button ng-click=\"\" class=\"post-button md-accent md-raised\" aria-label=\"POST\" \ntranslate=\"PROFILE.POST\" translate-attr-aria-label=\"PROFILE.POST\">POST</md-button></footer></div></div><md-divider>\n</md-divider><div class=\"timeline-item md-whiteframe-1dp\" ng-repeat=\"post in vm.posts\"><header layout=\"row\" \nlayout-align=\"space-between start\"><div class=\"user\" layout=\"row\" layout-align=\"start center\"><img class=\"avatar\" \nng-src=\"{{post.user.avatar}}\" alt=\"image\"><div layout=\"column\"><div class=\"title\"><span \nclass=\"username md-accent-color\">{{post.user.name}}</span> <span ng-if=\"post.type == \'post\'\" \ntranslate=\"PROFILE.TYPE_POST\">posted on your timeline</span> <span ng-if=\"post.type == \'something\'\" \ntranslate=\"PROFILE.TYPE_SOMETHING\">shared something with you</span> <span ng-if=\"post.type == \'video\'\" \ntranslate=\"PROFILE.TYPE_VIDEO\">shared a video with you</span> <span ng-if=\"post.type == \'article\'\" \ntranslate=\"PROFILE.TYPE_ARTICLE\">shared an article with you</span></div><div class=\"time\">{{post.time}}</div></div>\n</div><md-button class=\"md-icon-button\" aria-label=\"more\" translate translate-attr-aria-label=\"PROFILE.MORE\"><md-icon \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button></header><div class=\"content\"><div ng-if=\"post.message\" \nclass=\"message\">{{post.message}}</div><div ng-if=\"post.media\" class=\"media\"><img ng-if=\"post.media.type === \'image\'\" \nng-src=\"{{post.media.preview}}\" alt=\"image\"><div ng-if=\"post.media.type === \'video\'\" \nng-bind-html=\"post.media.embed | toTrusted\"></div></div><div ng-if=\"post.article\" layout=\"column\" class=\"article\"><div \nclass=\"media\"><img ng-src=\"{{post.article.media.preview}}\" alt=\"image\"></div><div class=\"title\">{{post.article.title}}\n</div><div class=\"subtitle\">{{post.article.subtitle}}</div><div class=\"excerpt\">{{post.article.excerpt}}</div></div>\n<div layout=\"row\" layout-align=\"start center\"><md-button class=\"like-button\"><div layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s16\"></md-icon><span \ntranslate=\"PROFILE.LIKE\">Like</span>&nbsp;<span>({{post.like}})</span></div></md-button><md-button \nclass=\"share-button\"><div layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-share\" class=\"s16\">\n</md-icon><span translate=\"PROFILE.SHARE\">Share</span>&nbsp;<span>({{post.share}})</span></div></md-button></div></div>\n<footer class=\"\" layout=\"column\" layout-align=\"start start\"><div ng-if=\"post.comments\" class=\"comment-count\">\n{{post.comments.length}} comments<md-icon md-font-icon=\"icon-keyboard_arrow_down\"></md-icon></div><div class=\"comment\" \nlayout=\"row\" layout-fill ng-repeat=\"comment in post.comments\"><img ng-src=\"{{comment.user.avatar}}\" class=\"avatar\" \nalt=\"image\"><div flex layout=\"column\"><div layout=\"row\" layout-align=\"start center\"><span class=\"username\">\n{{comment.user.name}}</span> <span class=\"time\">{{comment.time}}</span></div><div class=\"message\">{{comment.message}}\n</div><div class=\"actions\" layout=\"row\" layout-align=\"space-between center\"><a href=\"#\" \nclass=\"reply-button md-accent-color\" translate=\"PROFILE.REPLY\">Reply</a><md-icon flex md-font-icon=\"icon-flag\" \nclass=\"report-button s16\"></md-icon></div></div></div><div class=\"reply\" layout=\"row\" layout-fill><img \nsrc=\"assets/images/avatars/profile.jpg\" class=\"avatar\" alt=\"image\"><form flex><textarea placeholder=\"Add a comment...\" \ntranslate translate-attr-placeholder=\"PROFILE.ADD_COMMENT\"></textarea><md-button ng-click=\"\" \nclass=\"post-comment-button md-accent md-raised\" aria-label=\"Post Comment\" translate=\"PROFILE.POST_COMMENT\" \ntranslate-aria-label=\"PROFILE.POST_COMMENT\">Post Comment</md-button></form></div></footer></div></div><div \nclass=\"timeline-sidebar\" layout=\"column\" flex=\"100\" flex-gt-sm=\"45\" flex-gt-md=\"35\" flex-order=\"1\" \nflex-order-gt-sm=\"2\"><div class=\"profile-box latest-activity md-whiteframe-1dp\" layout=\"column\"><header \nclass=\"md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div class=\"title\" \ntranslate=\"PROFILE.LATEST_ACTIVITY\">Latest Activity</div><div class=\"more secondary-text\" translate=\"PROFILE.SEE_ALL\">\nSee All</div></header><div class=\"content\" layout=\"row\" layout-wrap><div class=\"activities\"><div class=\"activity\" \nlayout=\"row\" layout-align=\"start start\" ng-repeat=\"activity in vm.activities\"><img ng-src=\"{{activity.user.avatar}}\" \nclass=\"avatar\" alt=\"{{activity.user.name}}\" alt=\"image\"><div layout=\"column\"><div><span \nclass=\"username md-accent-color\">{{activity.user.name}}</span> <span class=\"message\">{{activity.message}}</span></div>\n<span class=\"time secondary-text\">{{activity.time}}</span></div></div></div></div></div></div></div>");
$templateCache.put("app/main/general/notifications/configuration/content/content.html","<div id=\"notification-configuration-grid\" ag-grid=\"vm.gridOptions\" class=\"ag-fresh\" ng-show=\"vm.showGrid\" \nstyle=\"width: 100%; height: 100%\"></div>");
$templateCache.put("app/main/general/notifications/my-notifications/content/content.html","<div class=\"notifications-header\" layout=\"row\"><div flex layout=\"row\" layout-align=\"start center\"><md-checkbox \naria-label=\"select all notifications\" ng-model=\"vm.selectAllNotifications\" \nng-checked=\"vm.selectedNotifications.length > 0\" ng-click=\"vm.toggleSelectNotifications()\" \ntitle=\"{{\'notifications.select_all_notifications\'| translate}}\"></md-checkbox><md-button title=\"Marcar como leído\" \nclass=\"md-icon-button\" ng-if=\"vm.selectedNotifications.length > 0\" aria-label=\"mark as read\" \nng-click=\"vm.markAsRead(vm.selectedNotifications)\"><md-icon style=\"color: green\" md-font-icon=\"icon-check\"></md-icon>\n</md-button><md-button title=\"Marcar todas las notificaciones como leídas\" class=\"md-icon-button\" \nng-if=\"vm.myNotificationsArray.length > 0 && $root.totalNumberOfNotifications > 0\" aria-label=\"mark all as read\" \nng-click=\"vm.markAllAsRead()\"><md-icon style=\"color: green\" md-font-icon=\"icon-check-all\"></md-icon></md-button></div>\n<div flex layout=\"row\" layout-align=\"end center\"><md-switch md-invert ng-model=\"vm.filter.onlyUnread\" \nng-change=\"vm.getMyNotifications()\" aria-label=\"show only unread notifications\" \ntitle=\"{{\'notifications.filter_by_unread\'| translate}}\">{{\'notifications.filter_by_unread\'| translate}}</md-switch>\n<span class=\"page-info\" hide-sm>\n{{ (vm.pagination.pageNumber * vm.pagination.pageSize) - (vm.pagination.pageSize - 1)}} - {{ (vm.pagination.totalElements > vm.pagination.pageSize) ? (vm.pagination.pageSize * vm.pagination.pageNumber) : vm.pagination.numberOfElements}} {{\'general.of\' | translate}} {{vm.pagination.totalElements}}\n</span><md-button title=\"{{\'notifications.before_page\'| translate}}\" class=\"md-icon-button arrow\" \naria-label=\"Previous\" ng-click=\"vm.pagination.beforePage()\" ng-disabled=\"vm.pagination.pageNumber === 1\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon></md-button><md-button title=\"{{\'notifications.next_page\'| translate}}\" \nclass=\"md-icon-button arrow\" aria-label=\"Next\" ng-click=\"vm.pagination.nextPage()\" \nng-disabled=\"vm.pagination.pageNumber === vm.pagination.totalPages || vm.pagination.totalPages === 0\"><md-icon \nmd-font-icon=\"icon-chevron-right\"></md-icon></md-button></div></div><div class=\"notifications-list\" ms-scroll flex><div\n class=\"notifications-content\"><div class=\"notification\" ng-class=\"{\'unread\': !notification.markedAsRead}\" \nng-repeat=\"notification in vm.myNotificationsArray| filter:vm.searchInput\" layout=\"row\" layout-align=\"start center\" \nng-click=\"vm.showNotification($event, notification)\"><div layout=\"column\" flex><div class=\"notification-info\" \nlayout=\"row\" layout-align=\"start center\"><md-checkbox ng-checked=\"vm.isSelectedNotification(notification)\" \nng-click=\"vm.toggleSelectNotification(notification, $event)\" \naria-label=\"{{vm.isSelectedNotification(notification) ? \'Deselect\' : \'Select\'}}\"></md-checkbox><div flex \nlayout=\"column\"><div class=\"applicationFrom\">\n{{\'notifications.application\'| translate}}: {{notification.application.name}}</div><div class=\"userFrom\" \nng-if=\"notification.userFrom\">\n{{\'notifications.from\'| translate}}: {{notification.userFrom.name}}({{notification.userFrom.account}})</div><div \nng-if=\"notification.originType !== null && notification.originType !== undefined\">\n{{notification.originType.originTypeName}}: {{notification.referenceNumber}}</div></div><div flex layout=\"column\"><div \nlayout=\"row\" layout-align=\"end center\"><div class=\"notification-date\">\n{{notification.createdAt| apiDate: \'dd-MM-yyyy HH:mm\'}}</div></div><div class=\"icon-alert-type\" \nng-class=\"{\'warning-type\': notification.notificationType.alertType === \'WARNING\', \'error-type\': notification.notificationType.alertType === \'ERROR\', \'success-type\': notification.notificationType.alertType === \'SUCCESS\', \'message-type\': notification.notificationType.alertType === \'MESSAGE\'}\" \nlayout=\"row\" layout-align=\"end center\"><md-icon md-font-icon=\"icon-message-text\" class=\"s20\" \nng-if=\"notification.notificationType.alertType === \'MESSAGE\'\"></md-icon><md-icon md-font-icon=\"icon-check\" class=\"s20\" \nng-if=\"notification.notificationType.alertType === \'SUCCESS\'\"></md-icon><md-icon md-font-icon=\"icon-alert\" class=\"s20\" \nng-if=\"notification.notificationType.alertType === \'WARNING\'\"></md-icon><md-icon md-font-icon=\"icon-cancel\" \nclass=\"s20\" ng-if=\"notification.notificationType.alertType === \'ERROR\'\"></md-icon></div></div></div><div \nclass=\"notification-message-preview\" ng-if=\"vm.currentNotification.id !== notification.id\">\n{{notification.message| topCharactersHtml: 100}}...</div><div class=\"notification-message\" \nng-if=\"vm.currentNotification.id === notification.id\" ng-bind-html=\"notification.message\"></div></div></div></div>\n</div>");
$templateCache.put("app/main/general/notifications/my-notifications/filter/filter.html","<div layout=\"row\" layout-align=\"end center\" class=\"toolbar-advanced-search\"><md-button class=\"md-icon-button\" \ntitle=\"{{\'notifications.clear_filters\' | translate}}\" ng-click=\"filterCtrl.clearFilters()\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"s18 md-warn\"></md-icon></md-button><md-button class=\"md-icon-button\" \ntitle=\"{{\'general.close\' | translate}}\" ng-click=\"vm.showAdvancedFilter = false\"><md-icon md-font-icon=\"icon-close\" \nclass=\"s18\"></md-icon></md-button></div><div layout=\"row\"><md-input-container flex><label>\n{{\'notifications.company\' | translate}}</label><md-select ng-model=\"vm.filter.companies\" multiple=\"multiple\" \nmd-on-close=\"filterCtrl.clearSearchCompany()\"><md-select-header><input id=\"searchCompanyInput\" \nng-model=\"filterCtrl.searchCompany\" type=\"search\" translate translate-attr-placeholder=\"general.search\">\n</md-select-header><md-optgroup label=\"Companies\"><md-option ng-value=\"company.id\" \nng-repeat=\"company in filterCtrl.companyArray | filter : filterCtrl.searchCompany\">{{company.name}}</md-option>\n</md-optgroup></md-select><md-progress-linear md-mode=\"indeterminate\" ng-if=\"filterCtrl.loadingCompanies\">\n</md-progress-linear></md-input-container></div><div layout=\"row\"><md-input-container flex><label>\n{{\'notifications.application\' | translate}}</label><md-select ng-model=\"vm.filter.applications\" multiple=\"multiple\" \nmd-on-close=\"filterCtrl.clearSearchApplication()\"><md-select-header><input id=\"searchApplicationInput\" \nng-model=\"filterCtrl.searchApplication\" type=\"search\" translate translate-attr-placeholder=\"general.search\">\n</md-select-header><md-optgroup label=\"Applications\"><md-option ng-value=\"application.id\" \nng-repeat=\"application in $root.myApps | filter : filterCtrl.searchApplication\">{{application.name}}</md-option>\n</md-optgroup></md-select></md-input-container></div><div layout=\"row\"><md-switch ng-model=\"vm.filter.filterByDates\" \naria-label=\"filter by dates\">{{\'notifications.filter_by_dates\' | translate}}</md-switch></div><fieldset \nng-if=\"vm.filter.filterByDates\"><legend>{{\'notifications.dates_range\' | translate}}</legend><div layout=\"row\"><div \nflex layout=\"row\" layout-align=\"center center\"><md-datepicker ng-model=\"vm.filter.startDate\" \nng-change=\"filterCtrl.changeStartDate(true)\" md-placeholder=\"{{\'notifications.start_date\' | translate}}\">\n</md-datepicker></div><div flex layout=\"row\" layout-align=\"center center\"><md-datepicker ng-model=\"vm.filter.endDate\" \nng-change=\"filterCtrl.changeStartDate(true)\" md-placeholder=\"{{\'notifications.end_date\' | translate}}\"></md-datepicker>\n</div></div></fieldset><div layout=\"row\" layout-align=\"center center\"><md-button class=\"md-primary md-raised\" \nng-click=\"filterCtrl.search($event)\">{{\'general.search\' | translate}}</md-button></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html","<md-button class=\"ms-stepper-navigation-item {{\'stepButton\' + stepInfo.stepNumber}}\" aria-label=\"clic\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(stepInfo.stepNumber), \'valid\': MsStepper.isStepValid(stepInfo.stepNumber), \'disabled\': MsStepper.isStepDisabled(stepInfo.stepNumber), \'optional\': MsStepper.isStepOptional(stepInfo.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(stepInfo.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(stepInfo.stepNumber)\" \nng-hide=\"MsStepper.isStepHidden(stepInfo.stepNumber)\" aria-label=\"Stepper navigation button\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"step\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(stepInfo.stepNumber) || MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-checkbox-blank-circle-outline s18 md-accent-fg\"></i> </span><span \nng-if=\"MsStepper.isStepValid(stepInfo.stepNumber) && !MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-check-circle s18 md-accent-fg\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"title\" ng-if=\"stepInfo.stepTitleTranslate\">{{stepInfo.stepTitleTranslate | translate }}</div><div class=\"title\" \nng-if=\"!stepInfo.stepTitleTranslate\">{{stepInfo.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(stepInfo.stepNumber)\">Optional</div></div></md-button><div \nclass=\"ms-stepper-step-content\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"start center\" ng-show=\"MsStepper.isStepCurrent(stepInfo.stepNumber)\"><md-button \nclass=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" ng-click=\"MsStepper.gotoPreviousStep()\">\n{{MsStepper.backDescriptionButton}}</md-button><md-button class=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">\n{{MsStepper.nextDescriptionButton}}</md-button><md-button type=\"submit\" class=\"md-accent md-raised\" \nng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" ng-disabled=\"!MsStepper.isFormValid()\">\n{{MsStepper.submitDescriptionButton}}</md-button></div>");
$templateCache.put("app/main/apps/expenseSettlements/pettyCash/settings/content/content.html","<div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label \ntranslate=\"EXPENSE_SETTLEMENTS.PETTY_CASH.SETTINGS.ROLE\"></label><md-select ng-model=\"vm.settings.roleApplication\" \nng-model-options=\"{trackBy: \'$value.id\'}\" name=\"roleApplication\" required ng-disabled=\"true\" \nng-change=\"vm.changeRoleApplication()\" md-on-close=\"vm.clearSearchRoleApplication()\"><md-select-header><input \nid=\"roleApplication\" ng-model=\"vm.searchRoleApplication\" type=\"search\" placeholder=\"Seleccione rol\"></md-select-header>\n<md-optgroup label=\"roleApplication\"><md-option ng-value=\"{{role}}\" \nng-repeat=\"role in vm.roles| filter:vm.searchRoleApplication\">{{role.description}}</md-option></md-optgroup>\n</md-select></md-input-container></div><div class=\"loading-threads\" layout=\"column\" layout-align=\"center center\" \nng-show=\"!vm.settings.roleApplication.id\"><h2>{{\'EXPENSE_SETTLEMENTS.PETTY_CASH.SETTINGS.SELECT_ROLE\'| translate}}</h2>\n</div><div class=\"content-wrapper\" layout=\"row\" flex><div id=\"usersList\" class=\"content\" ms-scroll flex=\"50\" \nng-if=\"vm.settings.roleApplication.id\" \nng-include=\"\'app/main/apps/expenseSettlements/pettyCash/settings/content/userList.html\'\"></div><div class=\"content\" \nms-scroll flex=\"50\" ng-if=\"vm.settings.roleApplication.id\" \nng-include=\"\'app/main/apps/expenseSettlements/pettyCash/settings/content/typeSettings.html\'\"></div></div>");
$templateCache.put("app/main/apps/expenseSettlements/pettyCash/settings/content/typeSettings.html","<div ng-style=\"vm.dinamicHeight\" ng-if=\"vm.loadingSettings\" layout=\"column\" layout-align=\"center center\">\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular><span class=\"loading-data\">\n{{\'EXPENSE_SETTLEMENTS.PETTY_CASH.SETTINGS.LOADING_CONFIGURATIONS\'|translate}}...</span></div><md-card \nstyle=\"margin-top: 0px\" ng-style=\"vm.dinamicHeight\" ng-if=\"!vm.loadingSettings && vm.selectedUser\" \nid=\"productParameter\" class=\"card-content productParameterDetail\" layout=\"column\" ng-if=\"vm.selectedUser\"><div \nclass=\"parameters-header\" layout=\"row\" layout-align=\"center center\"><div flex=\"80\" layout=\"row\" \nlayout-align=\"center center\"><h4><strong>\n{{\'EXPENSE_SETTLEMENTS.PETTY_CASH.SETTINGS.VERIFICATION\'|translate}} {{vm.selectedUser.account}}</strong></h4></div>\n</div><div ng-style=\"vm.dinamicHeight\" class=\"custom-list\" ms-scroll ng-disabled=\"vm.loading\"><div layout=\"row\" \nlayout-align=\"start center\" ng-click=\"null\" class=\"item\" ng-repeat=\"type in vm.pettyCashTypes track by type.id\"><div \nflex layout=\"row\" layout-align=\"start center\"><md-checkbox ng-disabled=\"vm.loading\" ng-checked=\"type.isChecked\" \nng-click=\"vm.toggleSelectType(type, $event, true)\" aria-label=\"{{type.isChecked ? \'Deselect\' : \'Select\'}}\">\n</md-checkbox><div flex class=\"product-name\">{{type.description}}</div></div></div></div></md-card><md-card \nstyle=\"margin-top: 0px\" ng-style=\"vm.dinamicHeight\" ng-if=\"!vm.loadingSettings && vm.selectedUser\" \nid=\"productParameter\" class=\"card-content productParameterDetail\" layout=\"column\" ng-if=\"vm.selectedUser\"><div \nclass=\"parameters-header\" layout=\"row\" layout-align=\"center center\"><div flex=\"80\" layout=\"row\" \nlayout-align=\"center center\"><h4><strong>\n{{\'EXPENSE_SETTLEMENTS.PETTY_CASH.SETTINGS.PROVISION\'|translate}} {{vm.selectedUser.account}}</strong></h4></div></div>\n<div ng-style=\"vm.dinamicHeight\" class=\"custom-list\" ms-scroll ng-disabled=\"vm.loadingP\"><div layout=\"row\" \nlayout-align=\"start center\" ng-click=\"null\" class=\"item\" \nng-repeat=\"type in vm.pettyCashTypesProvision track by type.id\"><div flex layout=\"row\" layout-align=\"start center\">\n<md-checkbox ng-disabled=\"vm.loadingP\" ng-checked=\"type.isCheckedValidate\" ng-model=\"tyoe.selected\" \nng-click=\"vm.toggleSelectTypeProvision(type, $event, false)\" \naria-label=\"{{type.isCheckedValidate ? \'Deselect\' : \'Select\'}}\"></md-checkbox><div flex class=\"product-name\">\n{{type.description}}</div></div></div></div></md-card>");
$templateCache.put("app/main/apps/expenseSettlements/pettyCash/settings/content/userList.html","<div ng-style=\"vm.dinamicHeight\" class=\"custom-list\" ms-scroll ng-if=\"!vm.loading\"><div class=\"parameters-header\" \nlayout=\"row\" layout-align=\"center center\"><div flex=\"80\" layout=\"row\" layout-align=\"center center\"><h4><strong>\n{{\'EXPENSE_SETTLEMENTS.PETTY_CASH.SETTINGS.USERS_WITH_ROLE\'| translate}} {{vm.settings.roleApplication.description}}\n</strong></h4></div></div><div layout=\"row\" layout-align=\"start center\" ng-click=\"vm.selectUser(user)\" class=\"item\" \nng-class=\"{\'selected\': vm.selectedUser.id === user.id}\" ng-repeat=\"user in vm.users.content\"><div flex layout=\"row\" \nlayout-align=\"start center\"><div flex class=\"product-name\">{{user.account}}</div></div><div \nng-if=\"vm.selectedUser.id === user.id\" class=\"label md-green-300-bg\"><md-icon md-font-icon=\"icon-check-all\"></md-icon>\n</div></div></div><div ng-style=\"vm.dinamicHeight\" ng-if=\"vm.loading\" layout=\"column\" layout-align=\"center center\">\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular><span class=\"loading-data\">\n{{\'EXPENSE_SETTLEMENTS.PETTY_CASH.SETTINGS.LOADING_USERS\'| translate}}...</span></div><div layout=\"row\" \nlayout-align=\"center center\"><div paging class=\"pageable-div center\" page=\"vm.page\" ul-class=\"pagination\" \npage-size=\"vm.pageSize\" hide-if-empty=\"true\" paging-action=\"vm.loadUsers(vm.settings.roleApplication.id, page)\" \ntotal=\"vm.users.totalElements\"></div></div>");
$templateCache.put("app/main/apps/expenseSettlements/pettyCash/withAmountToReturn/depositEditor/depositEditor.html","<md-dialog aria-label=\"New Company\"><form name=\"companyForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\" translate=\"EXPENSE_SETTLEMENTS.REFUND.BANK_DEPOSIT\">New Message</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" tranlate translate-aria-label=\"SETTLEMENT.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-progress-linear md-mode=\"indeterminate\" \nclass=\"md-primary\" ng-if=\"vm.loading\"></md-progress-linear><md-dialog-content><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex>{{vm.wireTransfer.holder.name}}</md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex><label translate=\"EXPENSE_SETTLEMENTS.REFUND.BANK_ACCOUNT\"></label>\n<md-select ng-model=\"vm.wireTransfer.bankAccount.id\" name=\"bankAccount\" required \nmd-on-close=\"vm.clearSearchBankAccount()\"><md-select-header><input id=\"bankAccount\" \nng-model=\"vm.searchBankAccountType\" type=\"search\" placeholder=\"Buscar\"></md-select-header><md-optgroup \nlabel=\"EXPENSE_SETTLEMENTS.REFUND.BANK_ACCOUNT\"><md-option ng-value=\"{{bankAccount.id}}\" \nng-repeat=\"bankAccount in vm.bankAccounts| filter:vm.searchBankAccountType\">\n{{bankAccount.accountNumber}} ({{bankAccount.bank.name}})</md-option></md-optgroup></md-select><md-progress-linear \nmd-mode=\"indeterminate\" ng-if=\"vm.loadingBankAccount\"></md-progress-linear></md-input-container><md-input-container \nflex><label translate=\"EXPENSE_SETTLEMENTS.REFUND.SLIP_NUMBER\"></label><input required \nng-model=\"vm.wireTransfer.number\" style=\"text-align: right\"></md-input-container><md-input-container flex><label \ntranslate=\"Fecha de transacción\">Enter date</label><md-datepicker type=\"date\" ng-required=\"true\" flex=\"100\" \nflex-gt-xs=\"50\" ng-model=\"vm.wireTransfer.documentDate\" name=\"documentDate\" ng-disabled=\"vm.wireTransfer.id\" \nng-change=\"vm.changeDocumentDate()\"></md-datepicker></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><label translate=\"EXPENSE_SETTLEMENTS.REFUND.AMOUNT\"></label><input required \nng-model=\"vm.wireTransfer.amount\" style=\"text-align: right\" ng-disabled=\"true\"></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"end center\"><md-button ng-click=\"vm.sendForm()\" ng-disabled=\"companyForm.$invalid\" \nclass=\"md-fab md-warn md-fab-bottom-right\" aria-label=\"Send\"><ng-md-icon icon=\"save\"></ng-md-icon><md-tooltip><span \ntranslate=\"SETTLEMENT.SAVE\">Guardar</span></md-tooltip></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/expenseSettlements/settlements/details/receiptEditor/receiptEditor.html","<div id=\"e-commerce-order\" class=\"page-layout carded fullwidth\" layout=\"column\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><md-button class=\"goto-orders-button md-icon-button\" \naria-label=\"Go to orders\" ng-click=\"vm.closeThread()\" translate translate-attr-aria-label=\"SETTLEMENT.BACK\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"column\" layout-align=\"start start\"><div class=\"h2\">\n<span translate=\"SETTLEMENT.RECEIPT.RECEIPT\">Invoice</span> <span>{{vm.receipt.id}}</span> <span>\n{{vm.settlement.settlementStatus.name}}</span></div></div></div></div><div class=\"content-card\" layout=\"column\" flex>\n<md-content class=\"content\" flex ms-scroll><ms-form-wizard flex><md-tabs md-dynamic-height \nmd-selected=\"msWizard.selectedIndex\" class=\"tab-in-content\"><md-tab><md-tab-body><form name=\"wizardStep1\" \nclass=\"md-inline-form\" ms-form-wizard-form novalidate><md-button ng-if=\"vm.receipt.id\" \nclass=\"md-fab md-fab-bottom-right md-mini\" aria-label=\"upload photo\" ng-click=\"vm.updateReceipt()\" \nng-disabled=\"wizardStep1.$invalid\"><ng-md-icon icon=\"save\"></ng-md-icon><md-tooltip><span \ntranslate=\"SETTLEMENT.INVOICE.UPDATE\">UPDATE</span></md-tooltip></md-button><md-button \nclass=\"md-fab md-warn md-fab-bottom-right md-mini\" ng-click=\"vm.saveReceipt()\" \nng-disabled=\"wizardStep1.$invalid || vm.filesToUpload.length === 0\" ng-if=\"!vm.receipt.id\"><ng-md-icon icon=\"save\">\n</ng-md-icon><md-tooltip><span translate=\"SETTLEMENT.INVOICE.CREATE\">CREATE</span></md-tooltip></md-button><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container flex-gt-xs><label translate=\"SETTLEMENT.RECEIPT.RECIPIENT_NAME\">\n</label><input required ng-model=\"vm.receipt.recipientName\" style=\"text-align: left\"></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container flex-gt-xs><label translate=\"SETTLEMENT.INVOICE.SERIE\"></label>\n<input ng-model=\"vm.receipt.serie\" style=\"text-align: left\"></md-input-container><md-input-container flex-gt-xs><label \ntranslate=\"SETTLEMENT.INVOICE.CORRELATIVE\"></label><input required ng-model=\"vm.receipt.correlative\" \nstyle=\"text-align: right\"></md-input-container><md-input-container flex-gt-xs><label \ntranslate=\"SETTLEMENT.RECEIPT.DATE_RECEIPT\"></label><md-datepicker type=\"date\" ng-required=\"true\" flex=\"100\" \nflex-gt-xs=\"50\" md-min-date=\"vm.lastYear\" md-max-date=\"vm.today\" \nng-change=\"vm.changeCurrencyOrDate(vm.receipt.currency.id, vm.receipt.receiptDate)\" ng-model=\"vm.receipt.receiptDate\" \nname=\"dateReceipt\" md-placeholder=\"dd-MM-yyyy\"></md-datepicker><div ng-messages=\"wizardStep1.startDate.$error\"><div \nng-message=\"valid\">The entered value is not a date!</div><div ng-message=\"required\" \ntranslate=\"EXPENSE_SETTLEMENTS.PETTY_CASH.STARTDATE_IS_REQUIRED\">This date is required!</div></div>\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex-gt-xs><label class=\"title\" \ntranslate=\"SETTLEMENT.RECEIPT.CURRENCY\">Currency</label><md-select ng-model=\"vm.receipt.currency.id\" \nmd-on-close=\"vm.clearSearchCurrency()\" name=\"currency\" required \nng-change=\"vm.changeCurrencyOrDate(vm.receipt.currency.id, vm.receipt.receiptDate)\"><md-select-header><input \nid=\"currency\" ng-model=\"vm.searchCurrency\" type=\"search\" placeholder=\"Seleccione moneda\"></md-select-header>\n<md-optgroup label=\"currency\"><md-option ng-value=\"{{currency.id}}\" \nng-repeat=\"currency in vm.currencies| filter :vm.searchCurrency\">{{currency.description}} ({{currency.code}})\n</md-option></md-optgroup></md-select></md-input-container><md-input-container flex-gt-xs><label \nng-if=\"vm.receipt.currency.id && vm.receipt.receiptDate && vm.canEditExchangeRate\" \ntranslate=\"SETTLEMENT.RECEIPT.EXCHANGE_RATE\"></label><input ng-model=\"vm.receipt.exchangeRate\" type=\"number\" min=\"0.1\" \nng-if=\"vm.receipt.currency && vm.receipt.receiptDate && vm.canEditExchangeRate\" style=\"text-align: right\" required \nng-change=\"vm.calculateAmounts()\"></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex-gt-xs><label translate=\"SETTLEMENT.RECEIPT.TOTAL_DOCUMENT\"></label><input \nng-model=\"vm.receipt.documentAmount\" type=\"number\" min=\"0\" style=\"text-align: right\" required \nng-change=\"vm.calculateAmounts()\"></md-input-container><md-input-container flex-gt-xs><label \nng-if=\"vm.receipt.currency.id && vm.receipt.receiptDate && vm.canEditExchangeRate\" \ntranslate=\"SETTLEMENT.RECEIPT.TOTAL_LOCAL_DOCUMENT\"></label><input ng-model=\"vm.receipt.amount\" type=\"number\" min=\"0\" \nstyle=\"text-align: right\" required ng-if=\"vm.receipt.currency.id && vm.receipt.receiptDate && vm.canEditExchangeRate\" \nng-disabled=\"true\"></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex-gt-xs>\n<label translate=\"SETTLEMENT.RECEIPT.PRODUCT\"></label><md-select ng-model=\"vm.receipt.product.id\" \nmd-on-close=\"vm.clearSearchProduct()\" name=\"product\" required><md-select-header><input id=\"product\" \nng-model=\"vm.searchProduct\" type=\"search\" placeholder=\"Seleccione producto\"></md-select-header><md-optgroup \nlabel=\"product\"><md-option ng-value=\"{{product.id}}\" \nng-repeat=\"product in vm.defaultProducts| filter :vm.searchProduct\">{{product.name}}</md-option></md-optgroup>\n</md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex-gt-xs><label \ntranslate=\"SETTLEMENT.RECEIPT.DESCRIPTION\"></label><textarea ng-required=\"true\" type=\"text\" name=\"descripcion\" \nng-model=\"vm.receipt.description\">\n                                            </textarea></md-input-container></div>\n<div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex-gt-xs><label translate=\"INVOICE.UPLOAD\"></label><div \nng-include=\"\'app/main/apps/files/files.html\'\"></div></md-input-container></div><div layout=\"row\" \nlayout-align=\"center start\" layout-wrap ng-show=\"vm.receipt.id && vm.receipt.files.length > 0\"><div \nng-repeat=\"file in vm.receipt.files\" ng-switch=\"file.extension\"><md-content><div layout=\"column\" \nng-click=\"vm.viewIMG(file)\" \nng-if=\"file.extension === \'.jpg\' || file.extension === \'.png\' || file.extension === \'.JPG\' || file.extension === \'.PNG\'\">\n<a href=\"\"><img alt=\"img\" height=\"100px\" width=\"100px\" class=\"media\" \nng-src=\"{{vm.URLPHOTOS + file.parentPath + file.name + file.extension}}\"><p>{{file.originalName + file.extension}}</p>\n</a></div><div layout=\"column\" \nng-if=\"file.extension !== \'.jpg\' && file.extension !== \'.png\' && file.extension !== \'.JPG\' && file.extension !== \'.PNG\'\">\n<a target=\"_blank\" href=\"{{vm.URLPHOTOS + file.parentPath + file.name + file.extension}}\"><md-icon \nmd-font-icon=\"icon-file-document\"></md-icon><p>{{file.originalName + file.extension}}</p></a></div></md-content></div>\n</div></form></md-tab-body></md-tab></md-tabs></ms-form-wizard></md-content></div></div></div>");
$templateCache.put("app/main/apps/expenseSettlements/settlements/details/receiptEditor/receipt_view.html","<div id=\"e-commerce-order\" class=\"page-layout carded fullwidth\" layout=\"column\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><md-button class=\"goto-orders-button md-icon-button\" \naria-label=\"Go to orders\" ng-click=\"vm.closeThread()\" translate translate-attr-aria-label=\"SETTLEMENT.BACK\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"column\" layout-align=\"start start\"><div class=\"h2\">\n<span translate=\"SETTLEMENT.RECEIPT.RECEIPT\">Invoice</span> <span>{{vm.receipt.id}}</span></div></div></div></div><div \nclass=\"content-card\" layout=\"column\" flex><div class=\"toolbar\" style=\"max-height: 160px; height: 160px\"><div \nlayout=\"row\"><md-tabs md-selected=\"vm.currentTab\" flex><md-tab id=\"tab1\" aria-controls=\"tab1-content\"><md-tab-label><i \nclass=\"icon-check s16\"></i> <span translate=\"SETTLEMENT.RECEIPT.GENERAL_INFORMATION\">Payment receipt</span>\n</md-tab-label></md-tab></md-tabs><span flex></span> <span flex></span><md-button ng-if=\"vm.isExtraAuthorizer\" \nclass=\"md-raised md-primary\" ng-click=\"vm.notAuthorizated($event, vm.receipt)\" aria-label=\"change Staus\"><span>\n{{\'SETTLEMENT.NO_AUTHORIZE\'| translate}}</span></md-button><md-button ng-if=\"vm.isExtraAuthorizer\" \nclass=\"md-raised md-primary\" ng-click=\"vm.authorizeDetail($event, vm.receipt)\" aria-label=\"change Staus\"><span>\n{{\'SETTLEMENT.AUTHORIZE\'| translate}}</span></md-button></div><div class=\"navigation\" flex layout=\"row\" \nlayout-align=\"center center\"><div class=\"customer h3\" layout=\"column\"><span></span> <span><strong \ntranslate=\"SETTLEMENT.RECEIPT.RECIPIENT_NAME\"></strong>: {{vm.receipt.recipientName}} </span><span><strong \ntranslate=\"SETTLEMENT.CURRENCY\"></strong>: {{vm.receipt.currency.description}} ({{vm.receipt.currency.code}})</span> \n<span><strong translate=\"SETTLEMENT.RECEIPT.DATE_RECEIPT\"></strong>: {{vm.receipt.receiptDate| date: \'dd-MM-yyyy\'}} \n</span><span><strong translate=\"SETTLEMENT.INVOICE.ACCOUNTING_DATE\"></strong>\n: {{vm.receipt.dateReceiptAccounting| date: \'dd-MM-yyyy\'}}</span></div><div flex></div><div class=\"customer h3\" \nlayout=\"column\"><span></span> <span><strong translate=\"SETTLEMENT.RECEIPT.TOTAL_DOCUMENT\"></strong>\n: {{vm.receipt.currency.symbol}}{{vm.receipt.documentAmount| number: 2}} </span><span ng-if=\"vm.canEditExchangeRate\">\n<strong ng-if=\"vm.canEditExchangeRate\" translate=\"SETTLEMENT.RECEIPT.TOTAL_LOCAL_DOCUMENT\"></strong>\n: {{vm.settlement.pettyCash.currency.symbol}}{{vm.receipt.amount| number: 2}} </span><span><strong \ntranslate=\"SETTLEMENT.INVOICE.SERIE\"></strong>: {{vm.receipt.serie}} </span><span><strong \ntranslate=\"SETTLEMENT.INVOICE.CORRELATIVE\"></strong>: {{vm.receipt.correlative}} </span><span><strong \ntranslate=\"SETTLEMENT.RECEIPT.PRODUCT\"></strong>: {{vm.receipt.product.name}}</span> <span><strong \ntranslate=\"SETTLEMENT.RECEIPT.DESCRIPTION\"></strong>: {{vm.receipt.description}}</span></div><div flex></div></div>\n</div><md-content class=\"content\" flex ms-scroll><form name=\"vm.paymentReceiptForm\"><md-tabs md-dynamic-height \nmd-selected=\"vm.currentTab\" class=\"tab-in-content\"><md-tab aria-controls=\"tab1-content\"><md-tab-body><div layout=\"row\">\n<div layout=\"column\" ng-show=\"vm.detailsExtraAuthorization.length > 0\" flex layout-align=\"start center\"><div \nlayout=\"row\" layout-align=\"center center\"><h4><strong>\n{{\'SETTLEMENT.EXTRA_AUTHORIZATION_REASONS.EXTRA_AUTHORIZATION_REASONS\'|translate}}</strong></h4></div><ul type=\"d\" isk>\n<li ng-repeat=\"detail in vm.detailsExtraAuthorization\" ng-value=\"true\">\n{{\'SETTLEMENT.EXTRA_AUTHORIZATION_REASONS.\' + detail.extraAuthorizationReason.name| translate}}</li></ul></div><div \nlayout=\"column\" ng-show=\"vm.receipt.id && vm.receipt.files.length > 0\" flex layout-align=\"start center\"><div \nlayout=\"row\" layout-align=\"center center\"><h4><strong>{{\'SETTLEMENT.FILES\'|translate}}</strong></h4></div><div \nng-repeat=\"file in vm.receipt.files\" ng-switch=\"file.extension\"><md-content><div layout=\"column\" \nng-click=\"vm.viewIMG(file)\" \nng-if=\"file.extension === \'.jpg\' || file.extension === \'.png\' || file.extension === \'.JPG\' || file.extension === \'.PNG\'\">\n<a href=\"\"><img alt=\"image\" height=\"100px\" width=\"100px\" class=\"media\" \nng-src=\"{{vm.URLPHOTOS + file.parentPath + file.name + file.extension}}\"><p>{{file.originalName + file.extension}}</p>\n</a></div><div layout=\"column\" \nng-if=\"file.extension !== \'.jpg\' && file.extension !== \'.png\' && file.extension !== \'.JPG\' && file.extension !== \'.PNG\'\">\n<a target=\"_blank\" href=\"{{vm.URLPHOTOS + file.parentPath + file.name + file.extension}}\"><md-icon \nmd-font-icon=\"icon-file-document\"></md-icon><p>{{file.originalName + file.extension}}</p></a></div></md-content></div>\n</div></div></md-tab-body></md-tab></md-tabs></form></md-content></div></div></div>");
$templateCache.put("app/main/apps/expenseSettlements/settlements/details/invoiceEditor/budgetsTemplate.html","<div layout=\"row\" layout-align=\"start center\" style=\"height: 100%\"><div flex=\"70\"><md-menu-bar \nstyle=\"width: 100%; margin: 0px\"><md-menu md-position-mode=\"left bottom\"><div layout=\"row\" \nng-click=\"$mdOpenMenu($event);\"><div style=\"cursor: pointer\"><span \nng-if=\"data.references.length === undefined || data.references.length === null || data.references.length === 0\">\n{{\'authorize_quotations.select_budgets\'| translate}}... </span><span ng-if=\"data.references.length > 1\">\n{{data.references.length}} {{\'authorize_quotations.selected_budgets\'| translate}}...</span></div><div \nng-if=\"data.references.length === 1\" style=\"min-height: 32px; min-width: 100px; width: 100%; display: block\"><div \nlayout=\"row\" layout-align=\"start center\" ng-repeat=\"reference in data.references\" style=\"height: 38px; float: left\">\n<div flex=\"40\" layout=\"column\"><span>{{\'authorize_quotations.amount\'| translate}}</span> <span>\n{{reference.currencyCode}}. {{reference.amountToUse| number:2}}</span></div><div flex=\"60\" layout=\"column\"><span>\n{{reference.budgetStartDate| date: \'dd/MM/yyyy\'}} - {{reference.budgetEndDate| date: \'dd/MM/yyyy\'}} </span><span>\n{{\'authorize_quotations.type\'| translate}}: {{reference.budgetType}}</span></div></div></div></div><md-menu-content \nwidth=\"3\" style=\"max-height:600px\"><md-menu-item \nstyle=\"height: 54px; line-height: normal; min-width: 325px; min-height: 50px\" \nng-if=\"vm.productBudget[data.product.id].length === 0\"><span>\n{{\'authorize_quotations.no_budgets_for_this_product\'| translate}}...</span></md-menu-item><md-menu-item \nstyle=\"height: 54px; line-height: normal; min-width: 325px; min-height: 50px\" \nng-if=\"vm.productBudget[data.product.id].length > 0\" ng-repeat=\"budgetDetail in vm.productBudget[data.product.id]\"><div\n style=\"cursor: pointer; position: relative; margin: 0px\" md-prevent-menu-close \nng-click=\"toggleSelectBudget(budgetDetail, $event)\" md-ink-ripple layout=\"row\" layout-align=\"start center\"><div \nflex=\"10\" layout=\"column\" layout-align=\"center center\"><md-checkbox ng-checked=\"isSelected(budgetDetail)\" \naria-label=\"{{isSelected(budgetDetail) ? \'Deselect\' : \'Select\'}}\" style=\"margin: 0px\"></md-checkbox></div><div \nflex=\"30\" layout=\"column\"><span>{{\'authorize_quotations.available\'| translate}}</span> <span>\n{{budgetDetail.currencyOfficial.code}}. {{budgetDetail.available| number:2}}</span></div><div flex=\"60\" \nlayout=\"column\"><span>\n{{budgetDetail.budget.startDate| date: \'dd/MM/yyyy\'}} - {{budgetDetail.budget.endDate| date: \'dd/MM/yyyy\'}}</span> \n<span>{{\'authorize_quotations.type\'| translate}}: {{budgetDetail.budget.budgetType.description}}</span></div></div>\n</md-menu-item></md-menu-content></md-menu></md-menu-bar></div><div flex=\"30\"><md-checkbox aria-label=\"need extension\" \nng-change=\"validateRequestAmpliation($event, this)\" ng-model=\"data.requestAmpliation\" \nng-if=\"data.totalCovered < data.subTotalAfterTax && data.references && data.references.length > 0\">\n{{\'authorize_quotations.request_ampliation\'| translate}}</md-checkbox></div></div>");
$templateCache.put("app/main/apps/expenseSettlements/settlements/details/invoiceEditor/invoiceEditor.html","<div id=\"e-commerce-order\" class=\"page-layout carded fullwidth\" layout=\"column\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><md-button class=\"goto-orders-button md-icon-button\" \naria-label=\"Go to orders\" ng-click=\"vm.closeThread()\" translate translate-attr-aria-label=\"SETTLEMENT.BACK\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"column\" layout-align=\"start start\"><div class=\"h2\">\n<span>{{\'SETTLEMENT.TYPE_\' + vm.invoicePurchaseType| translate}}</span> <span>{{vm.invoicePurchase.id}}</span> <span>\n{{vm.settlement.settlementStatus.name}}</span></div></div></div></div><div class=\"content-card\" layout=\"column\" flex>\n<md-content class=\"content\" flex ms-scroll><ms-form-wizard flex><md-tabs md-dynamic-height \nmd-selected=\"msWizard.selectedIndex\" class=\"tab-in-content\"><md-tab><md-tab-body><form name=\"wizardStep1\" \nclass=\"md-inline-form\" ms-form-wizard-form novalidate><md-button ng-if=\"vm.invoicePurchase.id\" \nclass=\"md-fab md-fab-bottom-right md-mini\" aria-label=\"upload photo\" ng-click=\"vm.updateInvoicePurchase()\" \nng-disabled=\"wizardStep1.$invalid\"><ng-md-icon icon=\"save\"></ng-md-icon><md-tooltip><span \ntranslate=\"SETTLEMENT.INVOICE.UPDATE\">UPDATE</span></md-tooltip></md-button><md-button \nclass=\"md-fab md-warn md-fab-bottom-right md-mini\" ng-click=\"vm.saveInvoicePurchase()\" \nng-show=\"vm.invoicePurchase.companyProvider\" ng-disabled=\"wizardStep1.$invalid || vm.filesToUpload.length === 0\" \nng-if=\"!vm.invoicePurchase.id\"><ng-md-icon icon=\"save\"></ng-md-icon><md-tooltip><span \ntranslate=\"SETTLEMENT.INVOICE.CREATE\">CREATE</span></md-tooltip></md-button><div \nng-if=\"vm.useExternalProviders && vm.invoicePurchase.companyProvider.id\" flex=\"100\" layout=\"row\" \nlayout-align=\"end center\"><md-checkbox ng-model=\"vm.invoicePurchase.companyProvider.isExternalProvider\" \nng-change=\"vm.updateCompanyIsExternalProvider()\">{{\"INVOICE.COMPANY.IS_EXTERNAL_PROVIDER\"| translate}}</md-checkbox>\n</div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label>\n{{vm.countryProvider.fiscalNumberTitle || vm.fiscalNumberTitle}}</label><input ng-model=\"vm.document.number\" \ntype=\"text\" name=\"documentType\" ng-enter=\"vm.findDocument(vm.document.number)\" style=\"text-align: right\" \nng-change=\"vm.changeInvoice()\"></md-input-container><md-input-container ng-if=\"vm.document.number\"><md-button \nclass=\"md-fab md-primary md-mini\" aria-label=\"Find document\" ng-click=\"vm.findDocument(vm.document.number)\"><md-icon \nmd-font-icon=\"icon-check\" class=\"s16\"></md-icon><md-tooltip><span translate=\"SETTLEMENT.INVOICE.VALIDATE_DOCUMENT\">\nFIND DOCUMENT</span></md-tooltip></md-button></md-input-container><md-input-container flex><label \ntranslate=\"SETTLEMENT.COMPANY.COMPANY\"></label><input ng-model=\"vm.invoicePurchase.companyProvider.businessName\" \ntype=\"text\" style=\"text-align: right\" ng-disabled=\"true\"></md-input-container><md-input-container flex-gt-xs \nng-show=\"vm.showMore\"><label translate=\"SETTLEMENT.REGIME\">Regime</label><md-select \nng-model=\"vm.invoicePurchase.regime.id\" md-on-close=\"vm.clearSearchRegime()\" name=\"regime\" required \nng-change=\"vm.validateRegime()\" \nng-disabled=\"vm.useExternalProviders\n                                              && vm.invoicePurchase.companyProvider.isExternalProvider\">\n<md-select-header><input id=\"searchRegime\" ng-model=\"vm.searchRegime\" type=\"search\" placeholder=\"Seleccione régimen\">\n</md-select-header><md-optgroup label=\"regime\"><md-option ng-value=\"{{regime.id}}\" \nng-repeat=\"regime in vm.regimes| filter :vm.searchRegime\">{{regime.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container ng-if=\"!vm.regime.id && vm.invoicePurchase.regime.id\"><md-button \nclass=\"md-fab md-primary md-mini\" aria-label=\"Associate regime\" \nng-click=\"vm.addRegimeToCompany($event, vm.invoicePurchase.regime.id,\n                                           vm.invoicePurchase.companyProvider)\">\n<md-icon md-font-icon=\"icon-plus\" class=\"s16\"></md-icon><md-tooltip><span translate=\"SETTLEMENT.ASSOCIATE_NOW\">\nASSOCIATE REGIME</span></md-tooltip></md-button></md-input-container></div><md-input-container flex \nng-if=\"vm.showNrcInput\"><label translate=\"SETTLEMENT.COMPANY.NRC\"></label><input ng-model=\"vm.documentNRC.number\" \ntype=\"text\" style=\"text-align: right\" ng-disabled=\"true\"></md-input-container><div layout=\"column\" layout-gt-xs=\"row\" \nng-if=\"vm.showMore\"><md-input-container flex><label translate=\"SETTLEMENT.INVOICE.DATE\"></label><md-datepicker \ntype=\"date\" ng-required=\"true\" flex=\"100\" flex-gt-xs=\"50\" \nng-change=\"vm.changeCurrencyOrDate(vm.invoicePurchase.currency,\n                                                vm.invoicePurchase.dateInvoicePurchase)\" \nmd-min-date=\"vm.lastYear\" md-max-date=\"vm.today\" ng-model=\"vm.invoicePurchase.dateInvoicePurchase\" name=\"startDate\" \nmd-placeholder=\"dd-MM-yyyy\"></md-datepicker></md-input-container><md-input-container flex-gt-xs><label \ntranslate=\"INVOICE.CURRENCY\"></label><md-autocomplete ng-required=\"true\" md-no-cache=\"true\" md-require-match \nmd-min-length=\"0\" placeholder=\"Seleccione moneda\" md-selected-item=\"vm.invoicePurchase.currency\" \nmd-search-text=\"vm.searchTextCurrency\" \nmd-selected-item-change=\"vm.changeCurrencyOrDate(vm.invoicePurchase.currency,\n                                                                vm.invoicePurchase.dateInvoicePurchase)\" \nmd-items=\"item in vm.querySearch(1,vm.searchTextCurrency)\" md-item-text=\"item.description\"><md-item-template><span \nmd-highlight-text=\"vm.searchTextCurrency\" md-highlight-flags=\"^i\">{{item.description}} ({{item.code}})</span>\n</md-item-template><md-not-found>{{\'SETTLEMENT.NO_MATCHES_FOUND\'| translate}} \"{{vm.searchTextCurrency}}\".\n</md-not-found></md-autocomplete></md-input-container><md-input-container flex-gt-xs><label \nng-if=\"vm.invoicePurchase.currency && vm.invoicePurchase.dateInvoicePurchase && vm.canEditExchangeRate\" \ntranslate=\"SETTLEMENT.INVOICE.EXCHANGE_RATE\"></label><input ng-model=\"vm.invoicePurchase.exchangeRate\" type=\"number\" \nmin=\"0.1\" style=\"text-align: right\" \nng-if=\"vm.invoicePurchase.currency && vm.invoicePurchase.dateInvoicePurchase && vm.canEditExchangeRate\" required \nng-disabled=\"!vm.canEditExchangeRate\" ng-change=\"vm.changeExchangeRate(vm.invoicePurchase.exchangeRate)\">\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" ng-show=\"vm.invoicePurchase.companyProvider\">\n<md-input-container flex-gt-xs ng-if=\"!vm.viewUuid\"><label translate=\"INVOICE.INVOICE_PURCHASE.SERIE\"></label>\n<md-autocomplete ng-required=\"true\" md-no-cache=\"true\" md-require-match md-min-length=\"0\" \nplaceholder=\"Seleccione serie\" md-selected-item=\"vm.invoicePurchase.invoiceSerie\" md-search-text=\"vm.searchTextSerie\" \nmd-items=\"item in vm.querySearch(3,vm.searchTextSerie)\" md-item-text=\"item.serie\" \nmd-selected-item-change=\"vm.exist = true\" \nng-disabled=\"vm.useExternalProviders\n                                              && vm.invoicePurchase.companyProvider.isExternalProvider\">\n<md-item-template><span md-highlight-text=\"vm.searchTextSerie\" md-highlight-flags=\"^i\">{{item.serie}}</span>\n</md-item-template><md-not-found>{{\'SETTLEMENT.NO_MATCHES_FOUND\'| translate}} \"{{vm.searchTextSerie}}\". <a \nng-if=\"vm.searchTextSerie\" \nng-click=\"vm.addSerieToCompany($event, vm.searchTextSerie,\n                                       vm.invoicePurchase.companyProvider)\">\n{{\'SETTLEMENT.ASSOCIATE_NOW\'| translate}}</a></md-not-found></md-autocomplete></md-input-container><md-input-container \nng-if=\"!vm.viewUuid\"><md-button class=\"md-fab md-primary md-mini\" aria-label=\"Associate serie\" \nng-click=\"vm.addSerieToCompany($event, vm.searchTextSerie,\n                                           vm.invoicePurchase.companyProvider)\" \nng-disabled=\"(vm.exist === true && vm.invoicePurchase.invoiceSerie) || !vm.searchTextSerie\"><md-icon \nmd-font-icon=\"icon-plus\" class=\"s16\"></md-icon><md-tooltip><span translate=\"SETTLEMENT.ASSOCIATE_NOW\">ASSOCIATE SERIE\n</span></md-tooltip></md-button></md-input-container><md-input-container flex ng-if=\"!vm.viewUuid\"><label \ntranslate=\"SETTLEMENT.INVOICE.CORRELATIVE\"></label><input ng-required=\"true\" ng-model=\"vm.invoicePurchase.correlative\" \ntype=\"number\" style=\"text-align: right\" min=\"{{vm.invoicePurchase.invoiceSerie.initialNumber}}\" \nmax=\"{{vm.invoicePurchase.invoiceSerie.lastNumber}}\"></md-input-container></div><div id=\"dvElectronicSignature\" \nlayout=\"column\" layout-gt-xs=\"row\" ng-if=\"vm.showFelSV\"><md-input-container flex><label id=\"lbElectronicSignature\" \ntranslate=\"{{vm.electronicSignatureTitle}}\"></label><input id=\"inElectronicSignature\" ng-required=\"vm.showFelSV\" \ntype=\"text\" name=\"electronicSignature\" ng-model=\"vm.invoicePurchase.electronicSignature\"><div \nng-messages=\"vm.wizardStep1.electronicSignature.$error\"><div ng-message=\"required\" \ntranslate=\"INVOICE.ERROR.FIELD_REQUIRED\">This field is required!</div></div></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container flex ng-if=\"vm.viewUuid\"><label translate=\"{{vm.uuidTitle}}\">\n</label><input ng-required=\"vm.viewUuid\" name=\"uuid\" ng-model=\"vm.invoicePurchase.uuid\" ng-blur=\"vm.validateUUID()\" \ntype=\"text\" ng-pattern=\"vm.regexUUID\" style=\"text-align: right\"><div ng-messages=\"wizardStep1.uuid.$error\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"required\" translate=\"INVOICE.ERROR.FIELD_REQUIRED\">\nThis field is required!</div><div ng-message=\"pattern\" translate=\"{{vm.uuidErrorTitle}}\">This date is pattern!</div>\n</div></md-input-container><md-input-container flex ng-if=\"vm.showFelSV\"><label id=\"lbControlNumber\" \ntranslate=\"INVOICE.INVOICE_PURCHASE.CONTROL_NUMBER\"></label><input id=\"inControlNumber\" ng-required=\"vm.showFelSV\" \ntype=\"text\" name=\"controlNumber\" ng-model=\"vm.invoicePurchase.controlNumber\" style=\"text-align: right\" maxlength=\"31\" \nminlength=\"31\"><div ng-messages=\"wizardStep1.controlNumber.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\" translate=\"INVOICE.ERROR.FIELD_REQUIRED\">This field is required!</div><div \nng-message=\"maxlength\" translate=\"INVOICE.ERROR.CONTROL_NUMBER_LENGTH\">Must be 31 characteres!</div><div \nng-message=\"minlength\" translate=\"INVOICE.ERROR.CONTROL_NUMBER_LENGTH\">Must be 31 characteres!</div></div>\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" \nng-if=\"vm.invoicePurchase.companyProvider && vm.invoicePurchase.documentTotalAfterTax > 0\"><md-input-container flex \nng-if=\"vm.details.length > 0\"><label>\n{{\"SETTLEMENT.INVOICE.DETAIL.TOTAL_PRICE\"|translate}} ({{vm.invoicePurchase.currency.symbol}})</label><input \nng-disabled=\"true\" ng-model=\"vm.invoicePurchase.documentTotalAfterTax\" type=\"number\" min=\"0\" style=\"text-align: right\">\n</md-input-container><md-input-container flex \nng-if=\"vm.details.length > 0 && vm.invoicePurchase.currency.id !== vm.pettyCash.currency.id && vm.invoicePurchase.totalAfterTax > 0\">\n<label>{{\"SETTLEMENT.INVOICE.DETAIL.TOTAL_PRICE\"|translate}} ({{vm.pettyCash.currency.symbol}} )</label><input \nng-disabled=\"true\" ng-model=\"vm.invoicePurchase.totalAfterTax\" type=\"number\" min=\"0\" style=\"text-align: right\">\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" ng-if=\"vm.invoicePurchase.companyProvider\">\n<md-input-container flex><label translate=\"INVOICE.UPLOAD\"></label><div ng-include=\"\'app/main/apps/files/files.html\'\">\n</div></md-input-container></div><div layout=\"row\" layout-align=\"center start\" layout-wrap \nng-show=\"vm.invoicePurchase.id && vm.invoicePurchase.files.length > 0 && vm.showMore\"><div \nng-repeat=\"file in vm.invoicePurchase.files\" ng-switch=\"file.extension\"><md-content><div layout=\"column\" \nng-click=\"vm.viewIMG(file)\" \nng-if=\"file.extension === \'.jpg\' || file.extension === \'.png\' || file.extension === \'.JPG\' || file.extension === \'.PNG\'\">\n<a href=\"\"><img alt=\"img\" height=\"100px\" width=\"100px\" class=\"media\" \nng-src=\"{{vm.URLPHOTOS + file.parentPath + file.name + file.extension}}\"><p>{{file.originalName + file.extension}}</p>\n</a></div><div layout=\"column\" \nng-if=\"file.extension !== \'.jpg\' && file.extension !== \'.png\' && file.extension !== \'.JPG\' && file.extension !== \'.PNG\'\">\n<a target=\"_blank\" href=\"{{vm.URLPHOTOS + file.parentPath + file.name + file.extension}}\"><md-icon \nmd-font-icon=\"icon-file-document\"></md-icon><p>{{file.originalName + file.extension}}</p></a></div></md-content></div>\n</div></form></md-tab-body></md-tab></md-tabs><md-tabs md-dynamic-height md-selected=\"msWizard2.selectedIndex\" \nmd-center-tabs=\"true\" ms-scroll ng-if=\"vm.invoicePurchase.id\"><md-tab><md-tab-body><header class=\"md-accent-bg\"><div \nlayout=\"row\" layout-align=\"center center\"><strong><h2><div class=\"title\" translate=\"Detalle\">Details</div></h2>\n</strong></div></header><div class=\"navigation\" flex layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-raised md-primary\" ng-if=\"vm.showButton\" ng-click=\"vm.reserveBudgetBySettlement()\"><span \ntranslate=\"SETTLEMENT.BUDGET_RESERVE\"></span></md-button><md-button class=\"md-fab md-accent md-mini md-fab md-hue-2\" \nng-click=\"vm.editDetail($event)\" \nng-if=\"(!vm.details || vm.details.length === 0 || vm.pettyCashGeneralSets.moreDetails === true)\" \nng-disabled=\"vm.hasBudgetApplication && vm.settlementDetail.budgeted\"><ng-md-icon icon=\"add\"></ng-md-icon><md-tooltip>\n<span translate=\"SETTLEMENT.ADD\">COMPOSE</span></md-tooltip></md-button></div></md-tab-body></md-tab></md-tabs><div \nclass=\"order-detail-form-container products md-background-bg md-whiteframe-1dp\" ng-show=\"vm.details.length > 0\"><div \nid=\"settlement-detail-grid\" ag-grid=\"vm.gridOptions\" class=\"ag-fresh\" style=\"width: 100%; height: 400px\"></div></div>\n</ms-form-wizard></md-content></div></div></div>");
$templateCache.put("app/main/apps/expenseSettlements/settlements/details/invoiceEditor/invoice_view.html","<div id=\"e-commerce-order\" class=\"page-layout carded fullwidth\" layout=\"column\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><md-button class=\"goto-orders-button md-icon-button\" \naria-label=\"Go to orders\" ng-click=\"vm.closeThread()\" translate translate-attr-aria-label=\"SETTLEMENT.BACK\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"column\" layout-align=\"start start\"><div class=\"h2\">\n<span>{{\'SETTLEMENT.TYPE_\' + vm.invoicePurchase.invoicePurchaseType| translate}}</span> <span>{{vm.invoicePurchase.id}}\n</span> <span>{{vm.settlement.settlementStatus.name}}</span></div></div></div></div><div class=\"content thread-detail\" \nms-scroll flex><div class=\"thread-content\"><div layout=\"row\"><ms-form-wizard flex><div class=\"toolbar\"><div \nclass=\"navigation\" flex layout=\"row\" layout-align=\"center center\"><div class=\"customer h3\" layout=\"column\"><span>\n</span> <span><strong translate=\"SETTLEMENT.COMPANY.NIT\"></strong>: {{vm.document.number}} </span><span><strong \ntranslate=\"SETTLEMENT.COMPANY.COMPANY\"></strong>: {{vm.invoicePurchase.companyProvider.businessName}} </span><span>\n<strong translate=\"SETTLEMENT.COMPANY.NRC\"></strong>: {{vm.documentNRC.number}} </span><span><strong \ntranslate=\"SETTLEMENT.INVOICE.DATE\"></strong>: {{vm.invoicePurchase.dateInvoicePurchase| date: \'dd-MM-yyyy\'}} </span>\n<span><strong translate=\"SETTLEMENT.INVOICE.SERIE\"></strong>\n: {{vm.invoicePurchase.invoiceSerie?vm.invoicePurchase.invoiceSerie.serie: vm.invoicePurchase.uuid.substring(0,8)}} \n</span><span><strong translate=\"SETTLEMENT.INVOICE.CORRELATIVE\"></strong>: {{vm.invoicePurchase.correlative}}</span>\n</div><div flex></div><div class=\"customer h3\" layout=\"column\"><span></span> <span><strong \ntranslate=\"SETTLEMENT.CURRENCY\"></strong>\n: {{vm.invoicePurchase.currency.description}} ({{vm.invoicePurchase.currency.code}}) </span><span><strong \ntranslate=\"SETTLEMENT.REGIME\"></strong>: {{vm.invoicePurchase.regime.name}} </span><span><strong \ntranslate=\"SETTLEMENT.INVOICE.DETAIL.TOTAL_PRICE\"></strong>\n: {{vm.invoicePurchase.currency.symbol}}.{{vm.invoicePurchase.documentTotalAfterTax| number : 2}} </span><span \nng-if=\"vm.invoicePurchase.electronicSignature\"><strong translate=\"SETTLEMENT.INVOICE.RECEIPT_STAMP\"></strong>\n : {{vm.invoicePurchase.electronicSignature}} </span><span ng-if=\"vm.invoicePurchase.uuid\"><strong \ntranslate=\"SETTLEMENT.INVOICE.UUID\"></strong>: {{vm.invoicePurchase.uuid}}</span></div><div flex></div><div \nclass=\"customer h3\" layout=\"column\"><span></span> <span ng-if=\"vm.dimensionCompanyDetail3\"><strong>\n{{vm.dimensionCompanyDetail3.description}}</strong>: {{vm.settlement.pettyCash.dimensionCompanyDetail3.name}} </span>\n<span ng-if=\"vm.dimensionCompanyDetail4\"><strong>{{vm.dimensionCompanyDetail4.description}}</strong>\n: {{vm.settlement.pettyCash.dimensionCompanyDetail4.name}} </span><span ng-if=\"vm.dimensionCompanyDetail5\"><strong>\n{{vm.dimensionCompanyDetail5.description}}</strong>: {{vm.settlement.pettyCash.dimensionCompanyDetail5.name}}</span>\n</div><div flex></div></div><div layout=\"row\"><div layout=\"column\" ng-show=\"vm.detailsExtraAuthorization.length > 0\" \nflex layout-align=\"start center\"><div layout=\"row\" layout-align=\"center center\"><h4><strong>\n{{\'SETTLEMENT.EXTRA_AUTHORIZATION_REASONS.EXTRA_AUTHORIZATION_REASONS\'|translate}}</strong></h4></div><ul type=\"d\" isk>\n<li ng-repeat=\"detail in vm.detailsExtraAuthorization\" ng-value=\"true\">\n{{\'SETTLEMENT.EXTRA_AUTHORIZATION_REASONS.\' + detail.extraAuthorizationReason.name | translate}}</li></ul></div><div \nlayout=\"column\" ng-show=\"vm.invoicePurchase.id && vm.invoicePurchase.files.length > 0\" flex \nlayout-align=\"start center\"><div layout=\"row\" layout-align=\"center center\"><h4><strong>{{\'SETTLEMENT.FILES\'|translate}}\n</strong></h4></div><div ng-repeat=\"file in vm.invoicePurchase.files\" ng-switch=\"file.extension\"><md-content><div \nlayout=\"column\" ng-click=\"vm.viewIMG(file)\" \nng-if=\"file.extension === \'.jpg\' || file.extension === \'.png\' || file.extension === \'.JPG\' || file.extension === \'.PNG\'\">\n<a href=\"\"><img alt=\"img\" height=\"100px\" width=\"100px\" class=\"media\" \nng-src=\"{{vm.URLPHOTOS + file.parentPath + file.name + file.extension}}\"><p>{{file.originalName + file.extension}}</p>\n</a></div><div layout=\"column\" \nng-if=\"file.extension !== \'.jpg\' && file.extension !== \'.png\' && file.extension !== \'.JPG\' && file.extension !== \'.PNG\'\">\n<a target=\"_blank\" href=\"{{vm.URLPHOTOS + file.parentPath + file.name + file.extension}}\"><md-icon \nmd-font-icon=\"icon-file-document\"></md-icon><p>{{file.originalName + file.extension}}</p></a></div></md-content></div>\n</div></div></div></ms-form-wizard></div></div><md-content class=\"content\" flex ms-scroll><ms-form-wizard flex><md-tabs\n md-dynamic-height md-selected=\"msWizard2.selectedIndex\" md-center-tabs=\"true\" ms-scroll ng-if=\"vm.invoicePurchase.id\">\n<md-tab><md-tab-body><header class=\"md-accent-bg\"><div layout=\"row\" layout-align=\"center center\"><strong><h2><div \nclass=\"title\" translate=\"Detalle\">Details</div></h2></strong></div></header></md-tab-body></md-tab></md-tabs><div \nclass=\"order-detail-form-container products md-background-bg md-whiteframe-1dp\" ng-show=\"vm.details.length > 0\"><div \nid=\"invoice-detail-grid\" ag-grid=\"vm.gridOptions\" class=\"ag-fresh\" style=\"width: 100%; height: 400px\"></div></div>\n</ms-form-wizard></md-content></div></div></div>");
$templateCache.put("app/main/apps/expenseSettlements/settlements/settlement/settlementEditor/budgetsTemplate.html","<div layout=\"row\" layout-align=\"start center\" style=\"height: 100%\"><div flex=\"70\"><md-menu-bar \nstyle=\"width: 100%; margin: 0px\"><md-menu md-position-mode=\"left bottom\"><div layout=\"row\" \nng-click=\"$mdOpenMenu($event);\"><div style=\"cursor: pointer\"><span \nng-if=\"data.references.length === undefined || data.references.length === null || data.references.length === 0\">\n{{\'authorize_quotations.select_budgets\'| translate}}... </span><span ng-if=\"data.references.length > 1\">\n{{data.references.length}} {{\'authorize_quotations.selected_budgets\'| translate}}...</span></div><div \nng-if=\"data.references.length === 1\" style=\"min-height: 32px; min-width: 100px; width: 100%; display: block\"><div \nlayout=\"row\" layout-align=\"start center\" ng-repeat=\"reference in data.references\" style=\"height: 38px; float: left\">\n<div flex=\"40\" layout=\"column\"><span>{{\'authorize_quotations.amount\'| translate}}</span> <span>\n{{reference.currencyCode}}. {{reference.amountToUse| number:2}}</span></div><div flex=\"60\" layout=\"column\"><span>\n{{reference.budgetStartDate| date: \'dd/MM/yyyy\'}} - {{reference.budgetEndDate| date: \'dd/MM/yyyy\'}} </span><span>\n{{\'authorize_quotations.type\'| translate}}: {{reference.budgetType}}</span></div></div></div></div><md-menu-content \nwidth=\"3\" style=\"max-height:600px\"><md-menu-item \nstyle=\"height: 54px; line-height: normal; min-width: 325px; min-height: 50px\" \nng-if=\"vm.productBudget[data.paymentReceipt.product.id].length === 0\"><span>\n{{\'authorize_quotations.no_budgets_for_this_product\'| translate}}...</span></md-menu-item><md-menu-item \nstyle=\"height: 54px; line-height: normal; min-width: 325px; min-height: 50px\" \nng-if=\"vm.productBudget[data.paymentReceipt.product.id].length > 0\" \nng-repeat=\"budgetDetail in vm.productBudget[data.paymentReceipt.product.id]\"><div \nstyle=\"cursor: pointer; position: relative; margin: 0px\" md-prevent-menu-close \nng-click=\"toggleSelectBudget(budgetDetail, $event)\" md-ink-ripple layout=\"row\" layout-align=\"start center\"><div \nflex=\"10\" layout=\"column\" layout-align=\"center center\"><md-checkbox ng-checked=\"isSelected(budgetDetail)\" \naria-label=\"{{isSelected(budgetDetail) ? \'Deselect\' : \'Select\'}}\" style=\"margin: 0px\"></md-checkbox></div><div \nflex=\"30\" layout=\"column\"><span>{{\'authorize_quotations.available\'| translate}}</span> <span>\n{{budgetDetail.currencyOfficial.code}}. {{budgetDetail.available| number:2}}</span></div><div flex=\"60\" \nlayout=\"column\"><span>\n{{budgetDetail.budget.startDate| date: \'dd/MM/yyyy\'}} - {{budgetDetail.budget.endDate| date: \'dd/MM/yyyy\'}}</span> \n<span>{{\'authorize_quotations.type\'| translate}}: {{budgetDetail.budget.budgetType.description}}</span></div></div>\n</md-menu-item></md-menu-content></md-menu></md-menu-bar></div><div flex=\"30\"><md-checkbox aria-label=\"need extension\" \nng-change=\"validateRequestAmpliation($event, this)\" ng-model=\"data.requestAmpliation\" \nng-if=\"data.totalCovered < data.paymentReceipt.amount && data.references && data.references.length > 0\">\n{{\'authorize_quotations.request_ampliation\'| translate}}</md-checkbox></div></div>");
$templateCache.put("app/main/apps/expenseSettlements/settlements/settlement/settlementEditor/settlementEditor.html","<div id=\"settlementEditor\" class=\"page-layout carded fullwidth\" layout=\"column\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><md-button class=\"goto-orders-button md-icon-button\" \naria-label=\"Go to orders\" ng-click=\"vm.closeThread()\" translate translate-attr-aria-label=\"PURCHASE.BACK\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"column\" layout-align=\"start start\"><div class=\"h2\">\n<span translate=\"SETTLEMENT.EXPENSE_SETTLEMENT\">Settlement</span> <span>{{vm.settlement.id}}</span> <span>\n- {{vm.settlement.settlementStatus.name}}</span></div></div></div></div><div class=\"content thread-detail\" ms-scroll \nflex><div class=\"thread-content\"><div layout=\"row\"><ms-form-wizard flex><div class=\"toolbar\"><div layout=\"row\" \nlayout-align=\"end center\"><div><md-button \nng-disabled=\"!vm.details || vm.details.length === 0 || !vm.canAddDetail || !vm.showButton\" \nclass=\"md-raised md-primary\" ng-click=\"vm.sendSettlement($event)\" aria-label=\"change Staus\"><span>\n{{\'SETTLEMENT.SEND\'| translate}}</span></md-button></div></div><div class=\"navigation header-settlement\" flex \nlayout=\"row\" layout-align=\"center center\"><div class=\"customer h3\" layout=\"column\"><span></span> <span><strong>\n{{vm.settlement.pettyCash.pettyCashType.description}}</strong>: {{vm.settlement.pettyCash.id}} </span><span><strong \ntranslate=\"EXPENSE_SETTLEMENTS.PETTY_CASH.NAME\"></strong>: {{vm.settlement.pettyCash.name}} </span><span><strong \ntranslate=\"EXPENSE_SETTLEMENTS.PETTY_CASH.COST_CENTER\"></strong>: {{vm.settlement.pettyCash.costCenter.description}} \n</span><span><strong translate=\"EXPENSE_SETTLEMENTS.PETTY_CASH.DEPARTMENT\"></strong>\n: {{vm.settlement.pettyCash.department.description}} </span><span><strong \ntranslate=\"EXPENSE_SETTLEMENTS.PETTY_CASH.HOLDER\"></strong>: {{vm.settlement.pettyCash.holder.account}} </span><span>\n</span> <span ng-show=\"vm.settlement.pettyCash.pettyCashType.name === \'IMPORT\'\"><strong \ntranslate=\"SETTLEMENT.CONTAINER\"></strong>: {{vm.settlement.pettyCash.container}} </span><span \nng-show=\"vm.settlement.pettyCash.pettyCashType.name === \'IMPORT\'\"><strong translate=\"SETTLEMENT.IMPORT_DOCUMENT\">\n</strong>: {{vm.settlement.pettyCash.importDocument}}</span></div><div flex></div><div class=\"customer h3\" \nlayout=\"column\"><span></span> <span ng-if=\"vm.settlement.pettyCash.amount > 0\"><strong \ntranslate=\"EXPENSE_SETTLEMENTS.PETTY_CASH.AMOUNT\"></strong>\n: {{vm.settlement.pettyCash.currency.symbol}} {{vm.settlement.pettyCash.amount| number: 2}} </span><span \nng-if=\"vm.settlement.pettyCash.amount > 0\"><strong translate=\"SETTLEMENT.PENDING_AMOUNT\"></strong>\n: {{vm.settlement.pettyCash.currency.symbol}} {{vm.settlement.pettyCash.amount - vm.amountAvailable| number: 2}} \n</span><span ng-if=\"vm.settlement.isExtra === true\"><strong translate=\"SETTLEMENT.EXTRAORDINARY_SETTLEMENT\"></strong>:\n<md-icon md-font-icon=\"{{vm.settlement.isExtra === true ? \'icon-checkbox-marked-circle green-500-fg\' : \'\'}}\" \nclass=\"icon\"></md-icon><md-tooltip><span translate=\"SETTLEMENT.NO_MORE_DETAILS\"></span></md-tooltip></span><span \nng-show=\"vm.amountAvailable\" ng-class=\"vm.amountAvailable < 0 ? \'over-spend\' : \'\'\"><strong \ntranslate=\"SETTLEMENT.INITIAL_AMOUNT\"></strong>\n: {{vm.settlement.pettyCash.currency.symbol}} {{vm.amountAvailable| number: 2}} </span><span><strong \ntranslate=\"SETTLEMENT.SETTLEMENT\"></strong>: {{vm.settlement.id ? vm.settlement.id : \'\'}} </span><span \nng-if=\"vm.settlement.settledAmount > 0\"><strong translate=\"SETTLEMENT.SETTLED_AMOUNT\"></strong>\n: {{vm.settlement.pettyCash.currency.symbol}} {{vm.settlement.settledAmount| number: 2}}</span></div><div flex></div>\n<div class=\"customer h3\" layout=\"column\"><span></span> <span ng-if=\"vm.dimensionCompanyDetail3\"><strong>\n{{vm.dimensionCompanyDetail3.description}}</strong>: {{vm.settlement.pettyCash.dimensionCompanyDetail3.name}} </span>\n<span ng-if=\"vm.dimensionCompanyDetail4\"><strong>{{vm.dimensionCompanyDetail4.description}}</strong>\n: {{vm.settlement.pettyCash.dimensionCompanyDetail4.name}} </span><span ng-if=\"vm.dimensionCompanyDetail5\"><strong>\n{{vm.dimensionCompanyDetail5.description}}</strong>: {{vm.settlement.pettyCash.dimensionCompanyDetail5.name}}</span>\n</div><div flex></div></div></div><md-tabs md-dynamic-height md-selected=\"msWizard2.selectedIndex\" \nmd-center-tabs=\"true\" ms-scroll ng-if=\"vm.canAddDetail\"><md-tab><md-tab-body><header class=\"md-accent-bg\"><div \nlayout=\"row\" layout-align=\"center center\"><strong><h2><div class=\"title\" translate=\"Detalle\">Details</div></h2>\n</strong></div></header><div layout=\"row\" layout-align=\"end center\"><md-button class=\"md-raised md-primary\" \nng-if=\"vm.showButtonSV\" ng-click=\"vm.addDetail(vm.settlement.id, \'CFISCAL\')\" aria-label=\"Add detail\" \nng-disabled=\"vm.settlement.isExtra === true\"><md-icon md-font-icon=\"icon-plus\" class=\"s22\"></md-icon><md-tooltip \nmd-direction=\"top\" md-visible=\"tooltipVisible\">{{\'SETTLEMENT.ADD_FISCAL_CREDIT\'| translate}}</md-tooltip><span>\n{{\'SETTLEMENT.RECEIPT.FISCAL_CREDIT\'| translate}}</span></md-button><md-button class=\"md-accent md-raised md-hue-1\" \nng-click=\"vm.addDetail(vm.settlement.id, \'INV\')\" aria-label=\"Add detail\" ng-disabled=\"vm.settlement.isExtra === true\">\n<md-icon md-font-icon=\"icon-plus\" class=\"s22\"></md-icon><md-tooltip md-direction=\"top\" md-visible=\"tooltipVisible\">\n{{\'SETTLEMENT.ADD_INVOICE\'| translate}}</md-tooltip><span>{{\'SETTLEMENT.INVOICE.INVOICE\'| translate}}</span>\n</md-button><md-button class=\"md-accent md-raised md-hue-2\" ng-if=\"vm.showButtonSV\" \nng-click=\"vm.addDetail(vm.settlement.id, \'TCK\')\" aria-label=\"Add detail\" ng-disabled=\"vm.settlement.isExtra === true\">\n<md-icon md-font-icon=\"icon-plus\" class=\"s22\"></md-icon><md-tooltip md-direction=\"top\" md-visible=\"tooltipVisible\">\n{{\'SETTLEMENT.ADD_TICKET\'| translate}}</md-tooltip><span>{{\'SETTLEMENT.RECEIPT.TICKET\'| translate}}</span></md-button>\n<md-button class=\"md-raised md-primary\" ng-if=\"!vm.showButtonSV\" ng-click=\"vm.addDetail(vm.settlement.id, \'REC\')\" \naria-label=\"Add detail\" ng-disabled=\"vm.settlement.isExtra === true\"><md-icon md-font-icon=\"icon-plus\" class=\"s22\">\n</md-icon><md-tooltip md-direction=\"top\" md-visible=\"tooltipVisible\">{{\'SETTLEMENT.ADD_ACCOUNTING_RECEIPT\'| translate}}\n</md-tooltip><span>{{\'SETTLEMENT.RECEIPT.ACCOUNTING_RECEIPT\'| translate}}</span></md-button><md-button \nclass=\"md-warn md-raised md-hue-2\" ng-click=\"vm.addDetail(vm.settlement.id)\" aria-label=\"Add detail\" \nng-disabled=\"vm.settlement.isExtra === true\"><md-icon md-font-icon=\"icon-plus\" class=\"s22\"></md-icon><md-tooltip \nmd-direction=\"top\" md-visible=\"tooltipVisible\">{{\'SETTLEMENT.ADD_RECEIPT\'| translate}}</md-tooltip><span>\n{{\'SETTLEMENT.RECEIPT.RECEIPT\'| translate}}</span></md-button></div><div ng-show=\"vm.selectedDetails.length > 0\" \nclass=\"selected-bar header animate-slide-down md-accent-bg\" layout=\"row\" layout-align=\"start center\"><div flex \nlayout=\"row\" layout-align=\"space-between center\"><div><span class=\"selected-contacts-count\"><span>\n{{vm.selectedDetails.length}}</span> <span>\n{{vm.selectedDetails.length === 1 ? \'SETTLEMENT.SELECTED\' : \'SETTLEMENT.SELECTED2\'| translate}}</span></span><md-menu \nclass=\"select-menu\" ng-if=\"!vm.currentThread\"><md-button class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\" \naria-label=\"multi select toggle\" translate translate-attr-aria-label=\"SETTLEMENT.MULTI_SELECT_TOGGLE\"><md-icon \nmd-font-icon=\"icon-menu-down\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-click=\"vm.selectAllDetails()\" translate=\"SETTLEMENT.SELECT_ALL\">Select all</md-button></md-menu-item><md-menu-item>\n<md-button ng-click=\"vm.deselectDetails()\" translate=\"SETTLEMENT.SELECT_NONE\">Select none</md-button></md-menu-item>\n</md-menu-content></md-menu></div><div class=\"multi-select-actions\"><md-button class=\"md-icon-button\" \nng-if=\"vm.settlement.settlementStatus.name === \'Ingresando\'\" ng-click=\"vm.deleteSelectedDetails($event)\" \naria-label=\"delete selected\" translate><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span \ntranslate=\"SETTLEMENT.DELETE\">DELETE</span></md-tooltip></md-button></div></div></div></md-tab-body></md-tab></md-tabs>\n<div class=\"order-detail-form-container products md-background-bg md-whiteframe-1dp\" ng-show=\"vm.details.length > 0\">\n<div id=\"settlement-grid\" ag-grid=\"vm.gridOptions\" class=\"ag-fresh\" style=\"width: 100%; height: 400px\"></div></div>\n</ms-form-wizard></div></div></div></div></div>");
$templateCache.put("app/main/apps/expenseSettlements/settlements/settlement/settlementEditor/settlement_view.html","<div id=\"settlementEditor\" class=\"page-layout carded fullwidth\" layout=\"column\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><md-button class=\"goto-orders-button md-icon-button\" \naria-label=\"Go to orders\" ng-click=\"vm.closeThread()\" translate translate-attr-aria-label=\"PURCHASE.BACK\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"column\" layout-align=\"start start\"><div class=\"h2\">\n<span translate=\"SETTLEMENT.EXPENSE_SETTLEMENT\">Settlement</span> <span>{{vm.settlement.id}}</span> <span>\n- {{vm.settlement.settlementStatus.name}}</span></div></div></div></div><div class=\"content thread-detail\" ms-scroll \nflex><div class=\"thread-content\"><div layout=\"row\"><ms-form-wizard flex><div class=\"toolbar\"><div layout=\"row\" \nlayout-align=\"end center\"><md-button class=\"md-accent md-raised md-hue-1\" \nng-click=\"vm.viewChangeStatus(vm.settlement.id, $event)\" aria-label=\"change Staus\"><span>\n{{\'SETTLEMENT.CHANGE_STATUS.VIEW_CHANGE_STATUS\'| translate}}</span></md-button><md-button \nng-disabled=\"!vm.details || vm.details.length === 0 || !vm.canAuthorizeSettlement\n                                            || !vm.settlement.settlementStatus.name === \'Pendiente de Autorizar\'\" \nng-show=\"vm.isAuthorizer && vm.settlement.settlementStatus.name === \'Pendiente de Autorizar\'\" \nclass=\"md-raised md-primary\" ng-click=\"vm.authorizeSettlement()\" aria-label=\"change Staus\"><span>\n{{\'SETTLEMENT.AUTHORIZE\'| translate}}</span></md-button><md-button \nng-disabled=\"!vm.canValidateSettlement || vm.isValidated || !vm.settlement.settlementStatus.name === \'No Validada\'\" \nng-show=\"vm.isVerifier && vm.settlement.settlementStatus.name !== \'Provisionada\'\" class=\"md-raised md-primary\" \nng-click=\"vm.provisionSettlement()\" aria-label=\"change Staus\"><span>{{\'SETTLEMENT.PROVISION\'| translate}}</span>\n</md-button><md-button ng-disabled=\"vm.settlement.pettyCash.pettyCashType.name === \'TRAVEL\'\" \nng-show=\"vm.isPayment && vm.settlement.settlementStatus.name === \'Provisionada\'\" class=\"md-raised md-primary\" \nng-click=\"vm.paySettlement($event, vm.settlement)\" aria-label=\"change Staus\"><span>\n{{\'SETTLEMENT.LIQUIDATE\'| translate}}</span></md-button></div><div class=\"navigation header-settlement\" flex \nlayout=\"row\" layout-align=\"center center\"><div class=\"customer h3\" layout=\"column\"><span></span> <span><strong>\n{{vm.settlement.pettyCash.pettyCashType.description}}</strong>: {{vm.settlement.pettyCash.id}} </span><span><strong \ntranslate=\"EXPENSE_SETTLEMENTS.PETTY_CASH.NAME\">:</strong> {{vm.settlement.pettyCash.name}} </span><span><strong \ntranslate=\"EXPENSE_SETTLEMENTS.PETTY_CASH.COST_CENTER\"></strong>: {{vm.settlement.pettyCash.costCenter.description}} \n</span><span><strong translate=\"EXPENSE_SETTLEMENTS.PETTY_CASH.DEPARTMENT\"></strong>\n: {{vm.settlement.pettyCash.department.description}} </span><span><strong \ntranslate=\"EXPENSE_SETTLEMENTS.PETTY_CASH.HOLDER\"></strong>: {{vm.settlement.pettyCash.holder.account}}</span></div>\n<div flex></div><div class=\"customer h3\" layout=\"column\"><span></span> <span \nng-if=\"vm.settlement.pettyCash.amount > 0\"><strong translate=\"EXPENSE_SETTLEMENTS.PETTY_CASH.AMOUNT\">:</strong>\n {{vm.settlement.pettyCash.amount| number: 2}} </span><span \nng-if=\"vm.settlement.pettyCash.amount > 0 && !vm.isPayment\"><strong translate=\"SETTLEMENT.PENDING_AMOUNT\">:</strong>\n {{vm.settlement.pettyCash.amount - vm.amountAvailable| number: 2}} </span><span \nng-if=\"vm.settlement.isExtra === true\"><strong translate=\"SETTLEMENT.EXTRAORDINARY_SETTLEMENT\">:</strong><md-icon \nmd-font-icon=\"{{vm.settlement.isExtra === true ? \'icon-checkbox-marked-circle green-500-fg\' : \'\'}}\" class=\"icon\">\n</md-icon></span><span ng-if=\"vm.amountAvailable > 0 && !vm.isPayment\" \nng-class=\"vm.amountAvailable < 0 ? \'over-spend\' : \'\'\"><strong translate=\"SETTLEMENT.INITIAL_AMOUNT\">:</strong>\n {{vm.amountAvailable| number: 2}} </span><span><strong translate=\"SETTLEMENT.SETTLEMENT\">:</strong>\n {{vm.settlement.id ? vm.settlement.id : \'\'}} </span><span ng-if=\"vm.settlement.settledAmount > 0\"><strong \ntranslate=\"SETTLEMENT.SETTLED_AMOUNT\">:</strong> {{vm.settlement.settledAmount| number: 2}} </span><span \nng-if=\"vm.settlement.policy\"><strong translate=\"SETTLEMENT.POLICY\"></strong>: {{vm.settlement.policy}} </span><span \nng-if=\"vm.settlement.container\"><strong translate=\"SETTLEMENT.CONTAINER\"></strong>: {{vm.settlement.container}}</span>\n</div><div flex></div><div class=\"customer h3\" layout=\"column\"><span></span> <span ng-if=\"vm.dimensionCompanyDetail3\">\n<strong>{{vm.dimensionCompanyDetail3.description}}</strong>: {{vm.settlement.pettyCash.dimensionCompanyDetail3.name}} \n</span><span ng-if=\"vm.dimensionCompanyDetail4\"><strong>{{vm.dimensionCompanyDetail4.description}}</strong>\n: {{vm.settlement.pettyCash.dimensionCompanyDetail4.name}} </span><span ng-if=\"vm.dimensionCompanyDetail5\"><strong>\n{{vm.dimensionCompanyDetail5.description}}</strong>: {{vm.settlement.pettyCash.dimensionCompanyDetail5.name}}</span>\n</div><div flex></div></div></div><md-tabs md-dynamic-height md-selected=\"msWizard2.selectedIndex\" \nmd-center-tabs=\"true\" ms-scroll ng-if=\"vm.canAddDetail\"><md-tab><md-tab-body><header class=\"md-accent-bg\"><div \nlayout=\"row\" layout-align=\"center center\"><strong><h2><div class=\"title\" translate=\"Detalle\">Details</div></h2>\n</strong></div></header><div ng-show=\"vm.selectedDetails.length > 0\" \nclass=\"selected-bar header animate-slide-down md-accent-bg\" layout=\"row\" layout-align=\"start center\"><div flex \nlayout=\"row\" layout-align=\"space-between center\"><div><span class=\"selected-contacts-count\"><span>\n{{vm.selectedDetails.length}}</span> <span>\n{{vm.selectedDetails.length === 1 ? \'SETTLEMENT.SELECTED\' : \'SETTLEMENT.SELECTED2\'| translate}}</span></span><md-menu \nclass=\"select-menu\" ng-if=\"!vm.currentThread\"><md-button class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\" \naria-label=\"multi select toggle\" translate translate-attr-aria-label=\"SETTLEMENT.MULTI_SELECT_TOGGLE\"><md-icon \nmd-font-icon=\"icon-menu-down\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-click=\"vm.selectAllDetails()\" translate=\"SETTLEMENT.SELECT_ALL\">Select all</md-button></md-menu-item><md-menu-item>\n<md-button ng-click=\"vm.deselectDetails()\" translate=\"SETTLEMENT.SELECT_NONE\">Select none</md-button></md-menu-item>\n</md-menu-content></md-menu></div><div class=\"multi-select-actions\"><md-button class=\"md-icon-button\" \nng-if=\"vm.settlement.settlementStatus.name === \'Pendiente de Autorizar\'\" aria-label=\"authorized selected\" translate>\n<md-icon md-font-icon=\"icon-thumb-down\"></md-icon><md-tooltip><span translate=\"SETTLEMENT.NO_AUTHORIZE\">NO_AUTHORIZE\n</span></md-tooltip></md-button></div></div></div></md-tab-body></md-tab></md-tabs></ms-form-wizard></div></div><div \nclass=\"order-detail-form-container products md-background-bg md-whiteframe-1dp\" ng-show=\"vm.details.length > 0\" \nstyle=\"height: 80%\"><div id=\"settlement-grid\" ag-grid=\"vm.gridOptions\" class=\"ag-fresh\" \nstyle=\"width: 100%; height: 100%\"></div></div></div></div></div>");
$templateCache.put("app/main/apps/merchandiseEntry/invoiceMerchandiseEntry/view/dialog/details.html","<md-dialog class=\"compose-dialog\" aria-label=\"New Message\" ms-scroll><md-toolbar class=\"md-accent md-hue-2\" \nlayout=\"row\"><div style=\"min-width: 400px\"><md-tabs md-selected=\"vm.selectedTab\" class=\"title\"><md-tab id=\"tab12\" \naria-controls=\"tab12-content\" label=\"{{\'MERCHANDISE_ENTRY.PRODUCTS\'| translate}}\"></md-tab><md-tab id=\"tab22\" \naria-controls=\"tab22-content\" label=\"{{\'MERCHANDISE_ENTRY.FILES\'| translate}}\"></md-tab></md-tabs></div><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"end center\"><md-button class=\"md-icon-button\" \nng-click=\"vm.close()\" aria-label=\"Close dialog\" tranlate translate-aria-label=\"MAIL.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll flex layout-fill \nng-class=\"vm.selectedTab === 0 ? \'md-dialog-list-content\' : \'\'\"><div ng-hide=\"vm.selectedTab === 1\"><md-progress-linear\n md-mode=\"indeterminate\" ng-if=\"vm.loading\" class=\"md-accent\"></md-progress-linear><div id=\"masterGridOptionsD\" \nag-grid=\"vm.masterGridOptionsD\" class=\"ag-fresh\" expand-grid min=\"260\" other=\"-10\"></div></div><div layout-gt-xs=\"row\" \nlayout=\"row\" layout-align=\"center start\" layout-wrap ng-show=\"vm.selectedTab === 1\"><div \nng-repeat=\"file in vm.merchandiseHeader.filesMerchandiseEntry\" ng-switch=\"file.extension\"><md-content><div \nlayout=\"column\" ng-click=\"vm.viewIMG(file)\" \nng-if=\"file.extension == \'.jpg\' || file.extension == \'.png\' || file.extension == \'.JPG\' || file.extension == \'.PNG\'\"><a\n href=\"\"><img alt=\"img\" height=\"100px\" width=\"100px\" class=\"media\" \nng-src=\"{{vm.URLPHOTOS + file.parentPath + file.name + file.extension}}\"><p>{{file.originalName + file.extension}}</p>\n</a></div><div layout=\"column\" \nng-if=\"file.extension != \'.jpg\' && file.extension != \'.png\' && file.extension != \'.JPG\' && file.extension != \'.PNG\'\"><a\n target=\"_blank\" href=\"{{vm.URLPHOTOS + file.parentPath + file.name + file.extension}}\"><md-icon \nmd-font-icon=\"icon-file-document\"></md-icon><p>{{file.originalName + file.extension}}</p></a></div></md-content></div>\n</div><div layout-gt-xs=\"row\" layout=\"row\" layout-align=\"center start\" layout-wrap ng-show=\"vm.selectedTab === 1\"><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label translate=\"ORDER.UPLOAD_MERCHANDISE\"></label><div \nng-include=\"\'app/main/apps/files/files.html\'\"></div></md-input-container></div><md-button \nng-disabled=\"vm.filesToUpload.length <= 0 && vm.uploadFiles\" ng-click=\"vm.updateMerchandiseHeader()\" \nclass=\"send-button md-accent md-fab md-fab-bottom-right\" aria-label=\"Send\" ng-disabled=\"vm.loading\" \ntranslate-attr-aria-label=\"CONTRACT.DETAIL.SEND\"><md-icon md-font-icon=\"icon-content-save\"></md-icon></md-button></div>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/main/apps/quotation/pending-authorize/detail/show-history-product/history-product.html","<md-dialog id=\"quotation-history-products\"><md-toolbar layout=\"row\" class=\"tools-dialog-photo\"><div class=\"title\" flex \nlayout=\"row\" layout-align=\"start center\"><h3>{{\'authorize_quotations.history_of\' | translate}} {{vm.product.name}}</h3>\n</div><div flex layout=\"row\" layout-align=\"end center\"><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><div layout=\"row\" \nlayout-align=\"end center\"><md-switch ng-model=\"vm.byCorporate\" ng-change=\"vm.init()\" \nng-model-options=\"{\'debounce\': 300}\" aria-label=\"Switch 1\">{{\'authorize_quotations.historial_corporativo\' | translate}}\n</md-switch></div><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loading\"></md-progress-linear><div \nid=\"history-grid\" ag-grid=\"vm.gridOptions\" class=\"ag-fresh\" style=\"width: 100%; height: 460px\"></div></md-dialog>");
$templateCache.put("app/main/apps/expenseSettlements/settlements/details/invoiceEditor/detailEditor/detailEditor.html","<md-dialog class=\"compose-dialog\" aria-label=\"New Detail\"><md-toolbar class=\"md-accent md-hue-2\" layout=\"row\" \nng-if=\"!vm.searchMode\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"spate-between center\"><div \nstyle=\"min-width: 400px\"><md-tabs md-selected=\"vm.selectedTab\" class=\"title\"><md-tab id=\"tab12\" \nlabel=\"{{\'SETTLEMENT.INVOICE.PRODUCT\'| translate}}\"></md-tab><md-tab ng-disabled=\"!vm.invoicePurchaseDetail.product\" \nid=\"tab22\" label=\"{{\'SETTLEMENT.INVOICE.DETAIL.DETAIL\'| translate}}\"></md-tab></md-tabs></div><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.activeSearch()\" aria-label=\"Close dialog\" tranlate \nng-if=\"vm.selectedTab === 0\" translate-aria-label=\"SETTLEMENT.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-magnify\">\n</md-icon></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" tranlate \ntranslate-aria-label=\"SETTLEMENT.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-toolbar class=\"md-accent md-hue-2\" ng-show=\"vm.searchMode\"><form ng-submit=\"vm.getProducts(1)\" \nname=\"vm.searchForm\"><div class=\"md-toolbar-tools\"><md-button type=\"button\" class=\"md-icon-button\" \nng-click=\"vm.backSearch()\" aria-label=\"Back\"><ng-md-icon icon=\"arrow_back\"></ng-md-icon></md-button><md-input-container\n flex style=\"margin-top: 60px\"><label translate=\"SETTLEMENT.INVOICE.DETAIL.FILTER\">Filtro</label><input type=\"text\" \nng-model=\"vm.filterProduct\" name=\"searchText\" required id=\"searchField\" ng-model-options=\"{\'debounce\': 500}\"><div \nng-messages=\"vm.searchForm.searchText.$error\"><div ng-message=\"required\" \ntranslate=\"SETTLEMENT.INVOICE.DETAIL.FIELD_REQUIRED\">This date is required!</div></div></md-input-container><md-button \ntype=\"submit\" aria-label=\"Search\"><span translate=\"SETTLEMENT.INVOICE.DETAIL.SEARCH\">Search</span></md-button></div>\n</form></md-toolbar><md-progress-linear md-mode=\"indeterminate\" class=\"md-primary\" ng-if=\"vm.loading\">\n</md-progress-linear><md-dialog-content ms-scroll flex layout-fill \nng-class=\"vm.selectedTab === 0 ? \'md-dialog-list-content\' : \'\'\"><div ng-if=\"vm.selectedTab === 0\"><div \nclass=\"content thread-list\" ng-show=\"!vm.creatingProduct\"><div class=\"thread\" md-ink-ripple ng-if=\"!vm.loading\" \nng-repeat=\"product in vm.productos.content\" ng-click=\"vm.selectProduct(product)\" \nng-class=\"{\'current-thread\': vm.invoicePurchaseDetail.product.id === product.id}\"><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"info\" flex><div class=\"title\">\n{{product.productCode ? product.productCode + \' - \' : \'\'}}{{product.name}}</div><div class=\"notes\">\n{{product.brand.name}}<br>{{product.productType.name}}</div></div></div><div layout=\"column\" \nlayout-align=\"space-between end\"><div class=\"actions\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"label ng-binding ng-scope md-green-300-bg\" role=\"button\" \nng-if=\"vm.invoicePurchaseDetail.product.id === product.id\"><md-icon md-font-icon=\"icon-check-all\"></md-icon></div>\n</div></div></div></div><div ng-if=\"vm.creatingProduct && !vm.loadingProgress\" \nng-include=\"\'app/main/apps/requisition/requisition/compose/createProduct.html\'\" \nng-controller=\"ProductCreateController as pro\"></div></div><div ng-if=\"vm.selectedTab === 1\"><form \nname=\"vm.detailForm\"><div layout=\"column\" flex><div class=\"profile-box info-box general md-whiteframe-1dp\" \nlayout=\"column\"><div class=\"content\"><div class=\"info-line\"><div class=\"title\" translate=\"SETTLEMENT.INVOICE.PRODUCT\">\nProduct</div><div class=\"info\">{{vm.invoicePurchaseDetail.product.name}}</div></div></div></div></div><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label translate=\"SETTLEMENT.INVOICE.DETAIL.DESCRIPTION\">\ndescription</label><textarea ng-required=\"true\" type=\"text\" name=\"description\" \nng-model=\"vm.invoicePurchaseDetail.description\">\n                        </textarea></md-input-container></div><div \nlayout=\"column\" layout-align=\"center center\"><md-input-container class=\"md-block\"><label \ntranslate=\"SETTLEMENT.INVOICE.DETAIL.QUANTITY\"></label><input ng-required=\"true\" \nng-model=\"vm.invoicePurchaseDetail.quantity\" name=\"quantity\" ng-change=\"vm.changeInputQuantityDetail()\" type=\"number\" \nmin=\"0.01\" pattern=\"^\\d+(?:\\.\\d{1,2})?$\" style=\"text-align: right\"></md-input-container></div><div layout=\"column\" \nlayout-align=\"center center\"><label>\n{{\'SETTLEMENT.SETTLEMENT_DETAIL.DOCUMENT_CURRENCY\'| translate}} ({{vm.invoicePurchase.currency.symbol}})</label></div>\n<div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label \ntranslate=\"SETTLEMENT.INVOICE.DETAIL.UNIT_PRICE\"></label><input ng-required=\"true\" \nng-model=\"vm.invoicePurchaseDetail.priceAfterTax\" type=\"number\" min=\"0.01\" \nng-disabled=\"!vm.useInputPriceAfterTax || !vm.invoicePurchaseDetail.id && vm.invoicePurchaseDetail.isExento\" \nng-change=\"vm.calculateSubTotalAfterTax()\" style=\"text-align: right\"></md-input-container><md-input-container flex>\n<label translate=\"SETTLEMENT.INVOICE.DETAIL.TOTAL_PRICE\"></label><input ng-required=\"true\" \nng-model=\"vm.invoicePurchaseDetail.documentSubTotalAfterTax\" type=\"number\" min=\"0.01\" \nng-disabled=\"!vm.useInputSubTotalAfterTax || !vm.invoicePurchaseDetail.id && vm.invoicePurchaseDetail.isExento\" \nng-change=\"vm.calculatePriceAfterTax()\" style=\"text-align: right\"></md-input-container></div><div layout=\"column\" \nlayout-align=\"center center\" ng-if=\"vm.differentCurrency\"><label>\n{{\'SETTLEMENT.SETTLEMENT_DETAIL.SOURCE_CURRENCY\'| translate}} ({{vm.pettyCash.currency.symbol}})</label></div><div \nlayout=\"column\" layout-gt-xs=\"row\" ng-if=\"vm.differentCurrency\"><md-input-container flex><label \ntranslate=\"SETTLEMENT.INVOICE.DETAIL.TOTAL_AFTER_TAX\"></label><input ng-required=\"true\" \nng-model=\"vm.invoicePurchaseDetail.subTotalAfterTax\" type=\"number\" min=\"0.01\" ng-disabled=\"true\" \nstyle=\"text-align: right\"></md-input-container></div><div ng-if=\"vm.detailsTax.length > 0\"><div layout=\"row\" \nlayout-align=\"center center\"><strong><h2><div class=\"title\" translate=\"INVOICE.INVOICE_PURCHASE.DETAIL.DETAIL_TAXES\">\nDocuments</div></h2></strong></div><table class=\"dataTable row-border hover\" datatable=\"ng\" style=\"max-width:260px\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"INVOICE.TAX.TAX\">Producto</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"INVOICE.TAX.DETAIL.PERCENTAGE\">Producto</span></div></th><th class=\"secondary-text\">\n<div class=\"table-header\"><span class=\"column-title\" translate=\"INVOICE.TAX.DETAIL.VALUE\">Producto</span></div></th>\n</tr></thead><tbody><tr ng-repeat=\"detail in vm.detailsTax\"><td>{{detail.countryTax.tax.name}}</td><td>{{detail.rate}}\n</td><td>{{detail.invoicePurchaseDetail.invoicePurchase.currency.symbol}} {{detail.price}}</td></tr></tbody></table>\n</div></form></div></md-dialog-content><md-dialog-actions style=\"justify-content: center\" class=\"actionsSpace\"><div \npaging class=\"pageable-div\" page=\"vm.page\" ul-class=\"pagination\" page-size=\"vm.pageSize\" hide-if-empty=\"true\" \npaging-action=\"vm.getProducts(page)\" total=\"vm.productos.totalElements\" ng-if=\"vm.selectedTab === 0\"></div><md-button \nng-click=\"vm.validateMaxAmount()\" ng-disabled=\"vm.detailForm.$invalid\" ng-if=\"vm.selectedTab === 1\" \nclass=\"send-button md-accent md-fab md-fab-bottom-right\" aria-label=\"Send\"><ng-md-icon icon=\"save\"></ng-md-icon>\n<md-tooltip><span translate=\"SETTLEMENT.SAVE\">Guardar</span></md-tooltip></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/expenseSettlements/settlements/details/invoiceEditor/companyEditor/companyEditor.html","<md-dialog aria-label=\"New Company\" flex=\"60\" flex-gt-md=\"30\" flex-gt-xs=\"60\"><form name=\"companyForm\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\" translate=\"SETTLEMENT.COMPANY.COMPANY\">New Message</span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" tranlate \ntranslate-aria-label=\"SETTLEMENT.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-progress-linear md-mode=\"indeterminate\" class=\"md-primary\" ng-if=\"vm.loading\"></md-progress-linear>\n<md-dialog-content ng-disabled=\"vm.loading\"><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label \ntranslate=\"SETTLEMENT.COMPANY.BUSINESS_NAME\"></label><input required ng-model=\"vm.companyProvider.businessName\" \nstyle=\"text-align: right\" ng-disabled=\"\"></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><label>{{vm.titleFiscal| translate}}</label><input required ng-model=\"vm.document.number\" \nstyle=\"text-align: right\" ng-disabled=\"true\"></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex ng-if=\"vm.showNrc\"><label translate=\"SETTLEMENT.COMPANY.NRC\"></label><input required \nng-model=\"vm.documentNRC.number\" style=\"text-align: right\" ng-disabled=\"false\"></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><md-checkbox ng-disabled=\"vm.loading\" \nng-model=\"vm.isWithholding\" aria-label=\"CheckboxWithholding\" class=\"md-align-top-left\" flex>\n{{\"SETTLEMENT.COMPANY.isWithholding\"| translate}}</md-checkbox></md-input-container></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"end center\">\n<md-button ng-click=\"vm.sendForm()\" ng-disabled=\"companyForm.$invalid || vm.loading\" \nclass=\"md-fab md-warn md-fab-bottom-right\" aria-label=\"Send\"><ng-md-icon icon=\"save\"></ng-md-icon><md-tooltip><span \ntranslate=\"SETTLEMENT.SAVE\">Guardar</span></md-tooltip></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/expenseSettlements/settlements/details/invoiceEditor/productsRequired/productsRequired.html","<md-dialog class=\"compose-dialog\" aria-label=\"New Message\"><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" \ntranslate=\"SETTLEMENT.PRODUCTREQUIREDS\">New Message</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\" ng-if=\"vm.showButtons\"><h3>\n<span class=\"title\" translate=\"SETTLEMENT.MSJPRODUCTREQUIREDS\">New Message</span></h3></div><md-dialog-content \nms-scroll><md-list flex><md-list-item class=\"md-3-line\" ng-repeat=\"item in vm.products\" ng-click=\"null\"><div \nclass=\"md-list-item-text\" layout=\"column\"><h2>{{ item.name}}</h2></div></md-list-item></md-list><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\" ng-if=\"vm.showButtons\"><h3><span \nclass=\"title\" translate=\"SETTLEMENT.PRODUCTREQUIREDSAUTORICED\">New Message</span></h3></div><md-dialog-actions \nlayout=\"row\" ng-if=\"vm.showButtons\"><span flex></span><md-button ng-click=\"vm.closeDialog()\"><span \ntranslate=\"SETTLEMENT.CANCEL\"></span></md-button><md-button ng-click=\"vm.ok()\"><span translate=\"SETTLEMENT.OK\"></span>\n</md-button></md-dialog-actions></md-dialog-content></md-dialog>");
$templateCache.put("app/main/apps/expenseSettlements/settlements/settlement/settlementEditor/changeStatus/changeStatus.html","<md-dialog class=\"change-status-detail\" aria-label=\"details of change status\"><div layout=\"row\" class=\"tools-dialog\">\n<div flex=\"50\" layout=\"row\" layout-align=\"start center\"><h2 translate=\"SETTLEMENT.CHANGE_STATUS.CHANGE_STATUS\">\nDetalle de cambios de estado</h2></div><div flex=\"50\" layout=\"row\" layout-align=\"end center\"><md-button \naria-label=\"button close\" class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" \nclass=\"s16\"></md-icon></md-button></div></div><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loading\" \nclass=\"md-accent\"></md-progress-linear><div id=\"changeStatusDetailMasterGridOptions\" ag-grid=\"vm.masterGridOptions\" \nclass=\"ag-fresh\"></div></md-dialog>");
$templateCache.put("app/main/apps/expenseSettlements/settlements/settlement/settlementEditor/paySettlement/paySettlement.html","<md-dialog class=\"compose-dialog\" aria-label=\"Payment settlement\"><form name=\"payForm\" class=\"md-inline-form\" \nnovalidate flex><md-toolbar><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\" translate=\"SETTLEMENT.SETTLEMENT_PAYMENT.SETTLEMENT_PAYMENT\">New Message</span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" tranlate \ntranslate-aria-label=\"SETTLEMENT.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-progress-linear md-mode=\"indeterminate\" class=\"md-primary\" ng-if=\"vm.loading\"></md-progress-linear>\n<md-dialog-content><div layout=\"column\" layout-align=\"center center\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"120\"><p>\n{{\'SETTLEMENT.SETTLEMENT_PAYMENT.SELECT_TYPE_TRANSACTION\'| translate}}</p></div><div layout=\"column\" \nlayout-align=\"center center\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"120\"><md-radio-group \nng-model=\"vm.wireTransfer.wireTransferType\" layout-align=\"center center\" required><md-radio-button value=\"DEPOSIT\" \nclass=\"md-primary\">{{\'SETTLEMENT.SETTLEMENT_PAYMENT.DEPOSIT\' | translate}}</md-radio-button><md-radio-button \nvalue=\"TRANSFER\">{{\'SETTLEMENT.SETTLEMENT_PAYMENT.TRANSFER\' | translate}}</md-radio-button><md-radio-button \nvalue=\"CHECK\">{{\'SETTLEMENT.SETTLEMENT_PAYMENT.CHECK\' | translate}}</md-radio-button></md-radio-group></div><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label \ntranslate=\"SETTLEMENT.SETTLEMENT_PAYMENT.BANK_ACCOUNT\"></label><md-select ng-model=\"vm.wireTransfer.bankAccount.id\" \nname=\"bankAccount\" required md-on-close=\"vm.clearSearchBankAccount()\"><md-select-header><input id=\"bankAccount\" \nng-model=\"vm.searchBankAccountType\" type=\"search\" placeholder=\"Buscar\"></md-select-header><md-optgroup \nlabel=\"BankAccount\"><md-option ng-value=\"{{bankAccount.id}}\" \nng-repeat=\"bankAccount in vm.bankAccounts| filter:vm.searchBankAccountType\">\n{{bankAccount.accountNumber}} ({{bankAccount.bank.name}})</md-option></md-optgroup></md-select><md-progress-linear \nmd-mode=\"indeterminate\" ng-if=\"vm.loadingBankAccount\"></md-progress-linear></md-input-container><md-input-container \nflex><label class=\"title\" translate=\"SETTLEMENT.SETTLEMENT_PAYMENT.AMOUNT\">amount</label><input type=\"number\" \nname=\"amount\" style=\"text-align: right\" required ng-disabled=\"true\" ng-model=\"vm.wireTransfer.amount\" min=\"0.01\">\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label class=\"title\" \ntranslate=\"SETTLEMENT.SETTLEMENT_PAYMENT.NUMBER\">number</label><input type=\"number\" name=\"number\" \nstyle=\"text-align: right\" required ng-model=\"vm.wireTransfer.number\" min=\"1\"></md-input-container><md-input-container \nflex><label translate=\"SETTLEMENT.SETTLEMENT_PAYMENT.TRANSACTION_DATE\">Enter date</label><md-datepicker type=\"date\" \nng-required=\"true\" flex=\"100\" flex-gt-xs=\"50\" ng-model=\"vm.wireTransfer.documentDate\" name=\"documentDate\" \nng-disabled=\"vm.wireTransfer.id\" ng-change=\"vm.changeDocumentDate()\"></md-datepicker></md-input-container></div>\n</md-dialog-content></form><div layout=\"row\" layout-align=\"end center\" style=\"padding: 8px\"><md-button \nclass=\"md-raised md-primary\" ng-click=\"vm.paySetlement()\" ng-disabled=\"payForm.$invalid\" aria-label=\"Paid settlement\">\n<span>{{\'SETTLEMENT.LIQUIDATE\'| translate}}</span></md-button></div></md-dialog>");
$templateCache.put("app/main/apps/expenseSettlements/settlements/settlement/settlementEditor/rejectionReason/rejectionReason.html","<md-dialog aria-label=\"Rejection reason\"><form name=\"vm.rejectionForm\" class=\"md-inline-form\" novalidate flex>\n<md-toolbar><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" \ntranslate=\"SETTLEMENT.REJECTION_REASON\">New Message</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" tranlate translate-aria-label=\"SETTLEMENT.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-progress-linear md-mode=\"indeterminate\" \nclass=\"md-primary\" ng-if=\"vm.loading\"></md-progress-linear><md-dialog-content><div><p>\n{{\'SETTLEMENT.MSG_REJECTION_REASON\'| translate}}</p></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container \nflex><label translate=\"SETTLEMENT.SELECT_REJECTION_REASON\"></label><md-select ng-required=\"true\" \nng-model=\"vm.detail.rejectionReason\" ng-model-options=\"{trackBy: \'$value.id\'}\" aria-label=\"rejection reason\" \nname=\"rejectionReason\" md-autofocus ng-change=\"vm.changeReason()\"><md-option ng-repeat=\"reason in vm.reasons\" \nng-value=\"reason\">{{reason.name}} ({{\'SETTLEMENT.IS_DEFINITIVE_\' + reason.isDefinitive| translate}})</md-option>\n</md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label \ntranslate=\"SETTLEMENT.COMMENT_REJECTION_REASON\"></label><textarea ng-required=\"true\" type=\"text\" name=\"descripcion\" \nmd-maxlength=\"240\" rows=\"2\" md-select-on-focus ng-model=\"vm.detail.rejectionReasonDescription\">\n                    \n</textarea></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" \nng-show=\"vm.detail.rejectionReason.isDefinitive\"><md-input-container><md-checkbox name=\"isDefinitive\" \nng-model=\"vm.confirmIsDefinitive\" aria-label=\"is Definitive\" ng-required=\"vm.checkRequired\"></md-checkbox><span \ntranslate=\"SETTLEMENT.IS_DEFINITIVE_CONFIRM\"></span><div ng-messages=\"vm.rejectionForm.isDefinitive.$error\" \nrole=\"alert\"><div ng-message=\"required\"><div translate=\"SETTLEMENT.IS_DEFINITIVE_MSG\">This date is required!</div>\n</div></div></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"end center\"><md-button ng-click=\"vm.sendForm()\" \nng-disabled=\"vm.rejectionForm.$invalid && !vm.canSaveRejection\" class=\"md-fab md-warn md-fab-bottom-right\" \naria-label=\"Send\"><ng-md-icon icon=\"save\"></ng-md-icon><md-tooltip><span translate=\"SETTLEMENT.OK\">Aceptar</span>\n</md-tooltip></md-button></div></md-dialog-actions></form></md-dialog>");}]);